// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%2378829D%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23808290%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 13 11%27 width=%2713%27 height=%2711%27 fill=%27none%27%3e%3cpath d=%27M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2317C653%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23F8285A%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23F8285A%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%287, 20, 55, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23071437%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%231B84FF%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23F5F5F5%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23006AE6%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-700%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-700%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-focus-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-focus-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-hover-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-hover-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-active-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-active-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-disabled-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-pagination-disabled-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-muted%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-muted%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-white%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-white%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-white%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-white%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-primary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-primary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-primary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-primary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-secondary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-secondary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-secondary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-secondary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-light%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-light%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-light%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-light%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-success%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-success%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-success%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-success%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-info%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-info%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-info%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-info%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-warning%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-warning%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-warning%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-warning%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-danger%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-danger%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-danger%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-danger%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-dark%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-dark%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-dark%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-dark%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-muted%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-muted%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-100%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-100%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-100%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-100%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-200%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-200%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-200%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-200%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-300%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-300%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-300%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-300%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-400%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-400%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-400%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-400%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-500%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-500%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-500%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-500%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-600%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-600%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-600%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-600%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-700%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-700%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-800%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-800%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-800%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-800%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-900%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-gray-900%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-900%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_102___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-gray-900%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_103___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-hover%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_104___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-hover%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_105___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-here%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_106___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-here%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_107___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-show%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_108___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-show%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_109___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-active%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_110___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-menu-link-color-active%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_111___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-primary-inverse%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_112___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-primary-inverse%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_113___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-muted%29%27%3e%3cpath d=%27M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_114___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--bs-text-muted%29%27%3e%3cpath d=%27M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_115___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--bs-gray-500%29%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
var ___CSS_LOADER_URL_REPLACEMENT_102___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_102___);
var ___CSS_LOADER_URL_REPLACEMENT_103___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_103___);
var ___CSS_LOADER_URL_REPLACEMENT_104___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_104___);
var ___CSS_LOADER_URL_REPLACEMENT_105___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_105___);
var ___CSS_LOADER_URL_REPLACEMENT_106___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_106___);
var ___CSS_LOADER_URL_REPLACEMENT_107___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_107___);
var ___CSS_LOADER_URL_REPLACEMENT_108___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_108___);
var ___CSS_LOADER_URL_REPLACEMENT_109___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_109___);
var ___CSS_LOADER_URL_REPLACEMENT_110___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_110___);
var ___CSS_LOADER_URL_REPLACEMENT_111___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_111___);
var ___CSS_LOADER_URL_REPLACEMENT_112___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_112___);
var ___CSS_LOADER_URL_REPLACEMENT_113___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_113___);
var ___CSS_LOADER_URL_REPLACEMENT_114___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_114___);
var ___CSS_LOADER_URL_REPLACEMENT_115___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_115___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000000;
  --bs-white: #ffffff;
  --bs-gray: #78829D;
  --bs-gray-dark: #252F4A;
  --bs-gray-100: #F9F9F9;
  --bs-gray-200: #F1F1F4;
  --bs-gray-300: #DBDFE9;
  --bs-gray-400: #C4CADA;
  --bs-gray-500: #99A1B7;
  --bs-gray-600: #78829D;
  --bs-gray-700: #4B5675;
  --bs-gray-800: #252F4A;
  --bs-gray-900: #071437;
  --bs-light: #F9F9F9;
  --bs-primary: #1B84FF;
  --bs-secondary: #F9F9F9;
  --bs-success: #17C653;
  --bs-info: #7239EA;
  --bs-warning: #F6C000;
  --bs-danger: #F8285A;
  --bs-dark: #1E2129;
  --bs-light-rgb: 249, 249, 249;
  --bs-primary-rgb: 27, 132, 255;
  --bs-secondary-rgb: 249, 249, 249;
  --bs-success-rgb: 23, 198, 83;
  --bs-info-rgb: 114, 57, 234;
  --bs-warning-rgb: 246, 192, 0;
  --bs-danger-rgb: 248, 40, 90;
  --bs-dark-rgb: 30, 33, 41;
  --bs-primary-text-emphasis: #0b3566;
  --bs-secondary-text-emphasis: #646464;
  --bs-success-text-emphasis: #094f21;
  --bs-info-text-emphasis: #2e175e;
  --bs-warning-text-emphasis: #624d00;
  --bs-danger-text-emphasis: #631024;
  --bs-light-text-emphasis: #4B5675;
  --bs-dark-text-emphasis: #4B5675;
  --bs-primary-bg-subtle: #d1e6ff;
  --bs-secondary-bg-subtle: #fefefe;
  --bs-success-bg-subtle: #d1f4dd;
  --bs-info-bg-subtle: #e3d7fb;
  --bs-warning-bg-subtle: #fdf2cc;
  --bs-danger-bg-subtle: #fed4de;
  --bs-light-bg-subtle: #fcfcfc;
  --bs-dark-bg-subtle: #C4CADA;
  --bs-primary-border-subtle: #a4ceff;
  --bs-secondary-border-subtle: #fdfdfd;
  --bs-success-border-subtle: #a2e8ba;
  --bs-info-border-subtle: #c7b0f7;
  --bs-warning-border-subtle: #fbe699;
  --bs-danger-border-subtle: #fca9bd;
  --bs-light-border-subtle: #F1F1F4;
  --bs-dark-border-subtle: #99A1B7;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: Inter, Helvetica, "sans-serif";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #071437;
  --bs-body-color-rgb: 7, 20, 55;
  --bs-body-bg: #ffffff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(7, 20, 55, 0.75);
  --bs-secondary-color-rgb: 7, 20, 55;
  --bs-secondary-bg: #F1F1F4;
  --bs-secondary-bg-rgb: 241, 241, 244;
  --bs-tertiary-color: rgba(7, 20, 55, 0.5);
  --bs-tertiary-color-rgb: 7, 20, 55;
  --bs-tertiary-bg: #F9F9F9;
  --bs-tertiary-bg-rgb: 249, 249, 249;
  --bs-heading-color: #071437;
  --bs-link-color: #1B84FF;
  --bs-link-color-rgb: 27, 132, 255;
  --bs-link-decoration: none;
  --bs-link-hover-color: #056EE9;
  --bs-link-hover-color-rgb: 5, 110, 233;
  --bs-link-hover-decoration: none;
  --bs-code-color: #b93993;
  --bs-highlight-color: #071437;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #F1F1F4;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.65rem;
  --bs-border-radius-sm: 0.3rem;
  --bs-border-radius-lg: 0.85rem;
  --bs-border-radius-xl: 1.25rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(27, 132, 255, 0.25);
  --bs-form-valid-color: #17C653;
  --bs-form-valid-border-color: #17C653;
  --bs-form-invalid-color: #F8285A;
  --bs-form-invalid-border-color: #F8285A;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #F5F5F5;
  --bs-body-color-rgb: 245, 245, 245;
  --bs-body-bg: #15171C;
  --bs-body-bg-rgb: 21, 23, 28;
  --bs-emphasis-color: #ffffff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(245, 245, 245, 0.75);
  --bs-secondary-color-rgb: 245, 245, 245;
  --bs-secondary-bg: #252F4A;
  --bs-secondary-bg-rgb: 37, 47, 74;
  --bs-tertiary-color: rgba(245, 245, 245, 0.5);
  --bs-tertiary-color-rgb: 245, 245, 245;
  --bs-tertiary-bg: #162241;
  --bs-tertiary-bg-rgb: 22, 34, 65;
  --bs-primary-text-emphasis: #76b5ff;
  --bs-secondary-text-emphasis: #fbfbfb;
  --bs-success-text-emphasis: #74dd98;
  --bs-info-text-emphasis: #aa88f2;
  --bs-warning-text-emphasis: #fad966;
  --bs-danger-text-emphasis: #fb7e9c;
  --bs-light-text-emphasis: #F9F9F9;
  --bs-dark-text-emphasis: #DBDFE9;
  --bs-primary-bg-subtle: #051a33;
  --bs-secondary-bg-subtle: #323232;
  --bs-success-bg-subtle: #052811;
  --bs-info-bg-subtle: #170b2f;
  --bs-warning-bg-subtle: #312600;
  --bs-danger-bg-subtle: #320812;
  --bs-light-bg-subtle: #252F4A;
  --bs-dark-bg-subtle: #131825;
  --bs-primary-border-subtle: #104f99;
  --bs-secondary-border-subtle: #959595;
  --bs-success-border-subtle: #0e7732;
  --bs-info-border-subtle: #44228c;
  --bs-warning-border-subtle: #947300;
  --bs-danger-border-subtle: #951836;
  --bs-light-border-subtle: #4B5675;
  --bs-dark-border-subtle: #252F4A;
  --bs-heading-color: #F5F5F5;
  --bs-link-color: #006AE6;
  --bs-link-hover-color: #3388eb;
  --bs-link-color-rgb: 0, 106, 230;
  --bs-link-hover-color-rgb: 51, 136, 235;
  --bs-code-color: #b93993;
  --bs-highlight-color: #F5F5F5;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #26272F;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 1.75rem;
  }
}

h2, .h2 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.5rem;
  }
}

h3, .h3 {
  font-size: calc(1.26rem + 0.12vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.35rem;
  }
}

h4, .h4 {
  font-size: 1.25rem;
}

h5, .h5 {
  font-size: 1.15rem;
}

h6, .h6 {
  font-size: 1.075rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: 700;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: none;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
  text-decoration: none;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 1rem;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 1rem;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 1rem;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.3rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #99A1B7;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #78829D;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  box-shadow: var(--bs-box-shadow-sm);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-gray-600);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0rem;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0rem;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 0.75rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 0.75rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 1.25rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 1.25rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 1.5rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 1.5rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 1.75rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 1.75rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 2rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 2rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 2.25rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 2.25rem;
}

.g-10,
.gx-10 {
  --bs-gutter-x: 2.5rem;
}

.g-10,
.gy-10 {
  --bs-gutter-y: 2.5rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0rem;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0rem;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-sm-6,
  .gx-sm-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-6,
  .gy-sm-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-7,
  .gx-sm-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-sm-7,
  .gy-sm-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-sm-8,
  .gx-sm-8 {
    --bs-gutter-x: 2rem;
  }
  .g-sm-8,
  .gy-sm-8 {
    --bs-gutter-y: 2rem;
  }
  .g-sm-9,
  .gx-sm-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-sm-9,
  .gy-sm-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-sm-10,
  .gx-sm-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-sm-10,
  .gy-sm-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0rem;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0rem;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-md-6,
  .gx-md-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-6,
  .gy-md-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-7,
  .gx-md-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-md-7,
  .gy-md-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-md-8,
  .gx-md-8 {
    --bs-gutter-x: 2rem;
  }
  .g-md-8,
  .gy-md-8 {
    --bs-gutter-y: 2rem;
  }
  .g-md-9,
  .gx-md-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-md-9,
  .gy-md-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-md-10,
  .gx-md-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-md-10,
  .gy-md-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0rem;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0rem;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-lg-6,
  .gx-lg-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-6,
  .gy-lg-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-7,
  .gx-lg-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-lg-7,
  .gy-lg-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-lg-8,
  .gx-lg-8 {
    --bs-gutter-x: 2rem;
  }
  .g-lg-8,
  .gy-lg-8 {
    --bs-gutter-y: 2rem;
  }
  .g-lg-9,
  .gx-lg-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-lg-9,
  .gy-lg-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-lg-10,
  .gx-lg-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-lg-10,
  .gy-lg-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0rem;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0rem;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-xl-6,
  .gx-xl-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-6,
  .gy-xl-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-7,
  .gx-xl-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-xl-7,
  .gy-xl-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-xl-8,
  .gx-xl-8 {
    --bs-gutter-x: 2rem;
  }
  .g-xl-8,
  .gy-xl-8 {
    --bs-gutter-y: 2rem;
  }
  .g-xl-9,
  .gx-xl-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-xl-9,
  .gy-xl-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-xl-10,
  .gx-xl-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-xl-10,
  .gy-xl-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0rem;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0rem;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 0.75rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 0.75rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 1.25rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 1.25rem;
  }
  .g-xxl-6,
  .gx-xxl-6 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-6,
  .gy-xxl-6 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-7,
  .gx-xxl-7 {
    --bs-gutter-x: 1.75rem;
  }
  .g-xxl-7,
  .gy-xxl-7 {
    --bs-gutter-y: 1.75rem;
  }
  .g-xxl-8,
  .gx-xxl-8 {
    --bs-gutter-x: 2rem;
  }
  .g-xxl-8,
  .gy-xxl-8 {
    --bs-gutter-y: 2rem;
  }
  .g-xxl-9,
  .gx-xxl-9 {
    --bs-gutter-x: 2.25rem;
  }
  .g-xxl-9,
  .gy-xxl-9 {
    --bs-gutter-y: 2.25rem;
  }
  .g-xxl-10,
  .gx-xxl-10 {
    --bs-gutter-x: 2.5rem;
  }
  .g-xxl-10,
  .gy-xxl-10 {
    --bs-gutter-y: 2.5rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: transparent;
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: var(--bs-gray-100);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: var(--bs-gray-100);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(1px * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000000;
  --bs-table-bg: #d1e6ff;
  --bs-table-border-color: #bccfe6;
  --bs-table-striped-bg: #c7dbf2;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #bccfe6;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #c1d5ec;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000000;
  --bs-table-bg: #fefefe;
  --bs-table-border-color: #e5e5e5;
  --bs-table-striped-bg: #f1f1f1;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e5e5e5;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #ebebeb;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000000;
  --bs-table-bg: #d1f4dd;
  --bs-table-border-color: #bcdcc7;
  --bs-table-striped-bg: #c7e8d2;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #bcdcc7;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #c1e2cc;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000000;
  --bs-table-bg: #e3d7fb;
  --bs-table-border-color: #ccc2e2;
  --bs-table-striped-bg: #d8ccee;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #ccc2e2;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #d2c7e8;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000000;
  --bs-table-bg: #fdf2cc;
  --bs-table-border-color: #e4dab8;
  --bs-table-striped-bg: #f0e6c2;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e4dab8;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #eae0bd;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000000;
  --bs-table-bg: #fed4de;
  --bs-table-border-color: #e5bfc8;
  --bs-table-striped-bg: #f1c9d3;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e5bfc8;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #ebc4cd;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000000;
  --bs-table-bg: #F9F9F9;
  --bs-table-border-color: #e0e0e0;
  --bs-table-striped-bg: #ededed;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e0e0e0;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e6e6e6;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #ffffff;
  --bs-table-bg: #1E2129;
  --bs-table-border-color: #35373e;
  --bs-table-striped-bg: #292c34;
  --bs-table-striped-color: #ffffff;
  --bs-table-active-bg: #35373e;
  --bs-table-active-color: #ffffff;
  --bs-table-hover-bg: #2f3239;
  --bs-table-hover-color: #ffffff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
  font-weight: 500;
  color: var(--bs-gray-800);
}

.col-form-label {
  padding-top: calc(0.775rem + 1px);
  padding-bottom: calc(0.775rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-gray-800);
}

.col-form-label-lg {
  padding-top: calc(0.825rem + 1px);
  padding-bottom: calc(0.825rem + 1px);
  font-size: 1.15rem;
}

.col-form-label-sm {
  padding-top: calc(0.55rem + 1px);
  padding-bottom: calc(0.55rem + 1px);
  font-size: 0.95rem;
}

.form-text {
  margin-top: 0.5rem;
  font-size: 0.95rem;
  color: var(--bs-text-muted);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.775rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-gray-700);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: 1px solid var(--bs-gray-300);
  border-radius: 0.65rem;
  box-shadow: false;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-gray-700);
  background-color: var(--bs-body-bg);
  border-color: var(--bs-gray-400);
  outline: 0;
  box-shadow: false, 0 0 0 0.25rem rgba(27, 132, 255, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-gray-500);
  opacity: 1;
}
.form-control:disabled {
  color: var(--bs-gray-500);
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-300);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.775rem 1rem;
  margin: -0.775rem -1rem;
  margin-inline-end: 1rem;
  color: var(--bs-gray-700);
  background-color: var(--bs-gray-100);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: shade-color(var(--bs-gray-100), 5%);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.775rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-gray-700);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.95rem;
  border-radius: 0.3rem;
}
.form-control-sm::file-selector-button {
  padding: 0.55rem 0.75rem;
  margin: -0.55rem -0.75rem;
  margin-inline-end: 0.75rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.65rem + 2px);
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.85rem;
}
.form-control-lg::file-selector-button {
  padding: 0.825rem 1.5rem;
  margin: -0.825rem -1.5rem;
  margin-inline-end: 1.5rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1.55rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 1.1rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1.65rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1.55rem + 2px);
  padding: 0.775rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.65rem;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 0.65rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 1.1rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1.65rem + 2px);
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.775rem 3rem 0.775rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-gray-700);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  border: 1px solid var(--bs-gray-300);
  border-radius: 0.65rem;
  box-shadow: false;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: var(--bs-gray-400);
  outline: 0;
  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 1rem;
  background-image: none;
}
.form-select:disabled {
  color: var(--bs-gray-500);
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-300);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-gray-700);
}

.form-select-sm {
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  padding-left: 0.75rem;
  font-size: 0.95rem;
  border-radius: 0.3rem;
}

.form-select-lg {
  padding-top: 0.825rem;
  padding-bottom: 0.825rem;
  padding-left: 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.85rem;
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 2.25rem;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -2.25rem;
}

.form-check-reverse {
  padding-right: 2.25rem;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -2.25rem;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: transparent;
  flex-shrink: 0;
  width: 1.75rem;
  height: 1.75rem;
  margin-top: -0.125rem;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--bs-gray-300);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.45em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: var(--bs-gray-400);
  outline: 0;
  box-shadow: none;
}
.form-check-input:checked {
  background-color: #1B84FF;
  border-color: #1B84FF;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #1B84FF;
  border-color: #1B84FF;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: var(--bs-gray-500);
}

.form-switch {
  padding-left: 3.75rem;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 3.25rem;
  margin-left: -3.75rem;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 3.25rem;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch.form-check-reverse {
  padding-right: 3.75rem;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -3.75rem;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(27, 132, 255, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(27, 132, 255, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #1B84FF;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #bbdaff;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-gray-300);
  border-color: transparent;
  border-radius: 0.65rem;
  box-shadow: var(--bs-box-shadow-inset);
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #1B84FF;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #bbdaff;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-gray-300);
  border-color: transparent;
  border-radius: 0.65rem;
  box-shadow: var(--bs-box-shadow-inset);
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-gray-500);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-gray-500);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.75rem + 2px);
  min-height: calc(3.75rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 1rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 1rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.85rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.85rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.85rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.5rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: 0.65rem;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #78829D;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-gray-200);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.775rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-gray-700);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-gray-100);
  border: 1px solid var(--bs-gray-300);
  border-radius: 0.65rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.85rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.55rem 0.75rem;
  font-size: 0.95rem;
  border-radius: 0.3rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 4rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(1px * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.95rem;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0.1rem;
  font-size: 1rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: 0.65rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 1.55rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.3875rem) center;
  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1.55rem);
  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1.55rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.95rem;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0.1rem;
  font-size: 1rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: 0.65rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 1.55rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.3875rem) center;
  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1.55rem);
  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 5.5rem;
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1.55rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 1.5rem;
  --bs-btn-padding-y: 0.775rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1.1rem;
  --bs-btn-font-weight: 500;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.65rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: none;
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  box-shadow: var(--bs-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
  box-shadow: var(--bs-btn-active-shadow);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
  box-shadow: none;
}

.btn-light {
  --bs-btn-color: #000000;
  --bs-btn-bg: #F9F9F9;
  --bs-btn-border-color: #F9F9F9;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #d4d4d4;
  --bs-btn-hover-border-color: #c7c7c7;
  --bs-btn-focus-shadow-rgb: 212, 212, 212;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #c7c7c7;
  --bs-btn-active-border-color: #bbbbbb;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #F9F9F9;
  --bs-btn-disabled-border-color: #F9F9F9;
}

.btn-primary {
  --bs-btn-color: #000000;
  --bs-btn-bg: #1B84FF;
  --bs-btn-border-color: #1B84FF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #3d96ff;
  --bs-btn-hover-border-color: #3290ff;
  --bs-btn-focus-shadow-rgb: 23, 112, 217;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #499dff;
  --bs-btn-active-border-color: #3290ff;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #1B84FF;
  --bs-btn-disabled-border-color: #1B84FF;
}

.btn-secondary {
  --bs-btn-color: #000000;
  --bs-btn-bg: #F9F9F9;
  --bs-btn-border-color: #F9F9F9;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #fafafa;
  --bs-btn-hover-border-color: #fafafa;
  --bs-btn-focus-shadow-rgb: 212, 212, 212;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #fafafa;
  --bs-btn-active-border-color: #fafafa;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #F9F9F9;
  --bs-btn-disabled-border-color: #F9F9F9;
}

.btn-success {
  --bs-btn-color: #000000;
  --bs-btn-bg: #17C653;
  --bs-btn-border-color: #17C653;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #3acf6d;
  --bs-btn-hover-border-color: #2ecc64;
  --bs-btn-focus-shadow-rgb: 20, 168, 71;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #45d175;
  --bs-btn-active-border-color: #2ecc64;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #17C653;
  --bs-btn-disabled-border-color: #17C653;
}

.btn-info {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #7239EA;
  --bs-btn-border-color: #7239EA;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #6130c7;
  --bs-btn-hover-border-color: #5b2ebb;
  --bs-btn-focus-shadow-rgb: 135, 87, 237;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #5b2ebb;
  --bs-btn-active-border-color: #562bb0;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #7239EA;
  --bs-btn-disabled-border-color: #7239EA;
}

.btn-warning {
  --bs-btn-color: #000000;
  --bs-btn-bg: #F6C000;
  --bs-btn-border-color: #F6C000;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f7c926;
  --bs-btn-hover-border-color: #f7c61a;
  --bs-btn-focus-shadow-rgb: 209, 163, 0;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f8cd33;
  --bs-btn-active-border-color: #f7c61a;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #F6C000;
  --bs-btn-disabled-border-color: #F6C000;
}

.btn-danger {
  --bs-btn-color: #000000;
  --bs-btn-bg: #F8285A;
  --bs-btn-border-color: #F8285A;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f94873;
  --bs-btn-hover-border-color: #f93e6b;
  --bs-btn-focus-shadow-rgb: 211, 34, 77;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f9537b;
  --bs-btn-active-border-color: #f93e6b;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #F8285A;
  --bs-btn-disabled-border-color: #F8285A;
}

.btn-dark {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #1E2129;
  --bs-btn-border-color: #1E2129;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #404249;
  --bs-btn-hover-border-color: #35373e;
  --bs-btn-focus-shadow-rgb: 64, 66, 73;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #4b4d54;
  --bs-btn-active-border-color: #35373e;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #1E2129;
  --bs-btn-disabled-border-color: #1E2129;
}

.btn-outline-light {
  --bs-btn-color: #F9F9F9;
  --bs-btn-border-color: #F9F9F9;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #F9F9F9;
  --bs-btn-hover-border-color: #F9F9F9;
  --bs-btn-focus-shadow-rgb: 249, 249, 249;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #F9F9F9;
  --bs-btn-active-border-color: #F9F9F9;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #F9F9F9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F9F9F9;
  --bs-gradient: none;
}

.btn-outline-primary {
  --bs-btn-color: #1B84FF;
  --bs-btn-border-color: #1B84FF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #1B84FF;
  --bs-btn-hover-border-color: #1B84FF;
  --bs-btn-focus-shadow-rgb: 27, 132, 255;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #1B84FF;
  --bs-btn-active-border-color: #1B84FF;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #1B84FF;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #1B84FF;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #F9F9F9;
  --bs-btn-border-color: #F9F9F9;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #F9F9F9;
  --bs-btn-hover-border-color: #F9F9F9;
  --bs-btn-focus-shadow-rgb: 249, 249, 249;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #F9F9F9;
  --bs-btn-active-border-color: #F9F9F9;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #F9F9F9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F9F9F9;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #17C653;
  --bs-btn-border-color: #17C653;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #17C653;
  --bs-btn-hover-border-color: #17C653;
  --bs-btn-focus-shadow-rgb: 23, 198, 83;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #17C653;
  --bs-btn-active-border-color: #17C653;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #17C653;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #17C653;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #7239EA;
  --bs-btn-border-color: #7239EA;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #7239EA;
  --bs-btn-hover-border-color: #7239EA;
  --bs-btn-focus-shadow-rgb: 114, 57, 234;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #7239EA;
  --bs-btn-active-border-color: #7239EA;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #7239EA;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7239EA;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #F6C000;
  --bs-btn-border-color: #F6C000;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #F6C000;
  --bs-btn-hover-border-color: #F6C000;
  --bs-btn-focus-shadow-rgb: 246, 192, 0;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #F6C000;
  --bs-btn-active-border-color: #F6C000;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #F6C000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F6C000;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #F8285A;
  --bs-btn-border-color: #F8285A;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #F8285A;
  --bs-btn-hover-border-color: #F8285A;
  --bs-btn-focus-shadow-rgb: 248, 40, 90;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #F8285A;
  --bs-btn-active-border-color: #F8285A;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #F8285A;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #F8285A;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #1E2129;
  --bs-btn-border-color: #1E2129;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #1E2129;
  --bs-btn-hover-border-color: #1E2129;
  --bs-btn-focus-shadow-rgb: 30, 33, 41;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #1E2129;
  --bs-btn-active-border-color: #1E2129;
  --bs-btn-active-shadow: none;
  --bs-btn-disabled-color: #1E2129;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #1E2129;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: var(--bs-gray-600);
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 23, 112, 217;
  text-decoration: none;
}
.btn-link:hover, .btn-link:focus-visible {
  text-decoration: none;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.825rem;
  --bs-btn-padding-x: 1.75rem;
  --bs-btn-font-size: 1.15rem;
  --bs-btn-border-radius: 0.85rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.55rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 0.95rem;
  --bs-btn-border-radius: 0.3rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0.65rem;
  --bs-dropdown-border-width: 0rem;
  --bs-dropdown-inner-border-radius: calc(0.65rem - 0rem);
  --bs-dropdown-divider-bg: var(--bs-gray-100);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-dropdown-link-color: var(--bs-gray-900);
  --bs-dropdown-link-hover-color: var(--bs-gray-900);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: var(--bs-component-hover-color);
  --bs-dropdown-link-active-bg: var(--bs-component-hover-bg);
  --bs-dropdown-link-disabled-color: var(--bs-gray-500);
  --bs-dropdown-item-padding-x: 0.85rem;
  --bs-dropdown-item-padding-y: 0.65rem;
  --bs-dropdown-header-color: var(--bs-gray-600);
  --bs-dropdown-header-padding-x: 0.85rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
  box-shadow: var(--bs-dropdown-box-shadow);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.95rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #DBDFE9;
  --bs-dropdown-bg: #252F4A;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #DBDFE9;
  --bs-dropdown-link-hover-color: #ffffff;
  --bs-dropdown-divider-bg: var(--bs-gray-100);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: var(--bs-component-hover-color);
  --bs-dropdown-link-active-bg: var(--bs-component-hover-bg);
  --bs-dropdown-link-disabled-color: #99A1B7;
  --bs-dropdown-header-color: #99A1B7;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.65rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(1px * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 1.125rem;
  padding-left: 1.125rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.3125rem;
  padding-left: 1.3125rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: none;
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(1px * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(27, 132, 255, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #ffffff;
  --bs-nav-pills-link-active-bg: #1B84FF;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 600;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.44375rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.075rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.075rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: 0.65rem;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  box-shadow: none;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #ffffff;
  --bs-navbar-brand-color: #ffffff;
  --bs-navbar-brand-hover-color: #ffffff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: var(--bs-gray-900);
  --bs-card-subtitle-color: ;
  --bs-card-border-width: 1px;
  --bs-card-border-color: #F1F1F4;
  --bs-card-border-radius: 0.85rem;
  --bs-card-box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);
  --bs-card-inner-border-radius: calc(0.85rem - 1px);
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: transparent;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
  box-shadow: var(--bs-card-box-shadow);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: 0.65rem;
  --bs-accordion-inner-border-radius: calc(0.65rem - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.5rem;
  --bs-accordion-btn-padding-y: 1.5rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-body-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --bs-accordion-btn-icon-width: 1.15rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.5rem;
  --bs-accordion-body-padding-y: 1.5rem;
  --bs-accordion-active-color: var(--bs-primary);
  --bs-accordion-active-bg: var(--bs-gray-100);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-gray-600);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-primary);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1.075rem;
  --bs-pagination-color: var(--bs-gray-700);
  --bs-pagination-bg: transparent;
  --bs-pagination-border-width: 0;
  --bs-pagination-border-color: transparent;
  --bs-pagination-border-radius: 0.65rem;
  --bs-pagination-hover-color: var(--bs-component-hover-color);
  --bs-pagination-hover-bg: var(--bs-component-hover-bg);
  --bs-pagination-hover-border-color: transparent;
  --bs-pagination-focus-color: var(--bs-component-hover-color);
  --bs-pagination-focus-bg: var(--bs-component-hover-bg);
  --bs-pagination-focus-box-shadow: none;
  --bs-pagination-active-color: var(--bs-component-active-color);
  --bs-pagination-active-bg: var(--bs-component-active-bg);
  --bs-pagination-active-border-color: transparent;
  --bs-pagination-disabled-color: var(--bs-gray-400);
  --bs-pagination-disabled-bg: transparent;
  --bs-pagination-disabled-border-color: transparent;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(0 * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.075rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.95rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.5rem;
  --bs-badge-padding-y: 0.325rem;
  --bs-badge-font-size: 0.85rem;
  --bs-badge-font-weight: 600;
  --bs-badge-color: var(--bs-body-color);
  --bs-badge-border-radius: 0.3rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-gray-100);
  --bs-progress-border-radius: 6px;
  --bs-progress-box-shadow: none;
  --bs-progress-bar-color: #ffffff;
  --bs-progress-bar-bg: #1B84FF;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
  box-shadow: var(--bs-progress-box-shadow);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-gray-900);
  --bs-list-group-bg: #ffffff;
  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-gray-700);
  --bs-list-group-action-hover-color: var(--bs-gray-700);
  --bs-list-group-action-hover-bg: var(--bs-gray-100);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-gray-200);
  --bs-list-group-disabled-color: var(--bs-gray-600);
  --bs-list-group-disabled-bg: #ffffff;
  --bs-list-group-active-color: var(--bs-component-active-color);
  --bs-list-group-active-bg: var(--bs-component-active-bg);
  --bs-list-group-active-border-color: var(--bs-component-active-bg);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: none;
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 0.75rem;
  height: 0.75rem;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/0.75rem auto no-repeat;
  border: 0;
  border-radius: 0.65rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: var(--bs-gray-700);
  --bs-toast-bg: var(--bs-body-bg);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: transparent;
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-gray-700);
  --bs-toast-header-bg: var(--bs-body-bg);
  --bs-toast-header-border-color: var(--bs-border-color);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1.75rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: 0;
  --bs-modal-border-radius: 0.65rem;
  --bs-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  --bs-modal-inner-border-radius: 0.65rem;
  --bs-modal-header-padding-x: 1.75rem;
  --bs-modal-header-padding-y: 1.75rem;
  --bs-modal-header-padding: 1.75rem 1.75rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  box-shadow: var(--bs-modal-box-shadow);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000000;
  --bs-backdrop-opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 1rem;
  --bs-tooltip-padding-y: 0.75rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 1rem;
  --bs-tooltip-color: var(--bs-gray-800);
  --bs-tooltip-bg: var(--bs-body-bg);
  --bs-tooltip-border-radius: 0.65rem;
  --bs-tooltip-opacity: 1;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 1rem;
  --bs-popover-bg: #ffffff;
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: #ffffff;
  --bs-popover-border-radius: 0.65rem;
  --bs-popover-inner-border-radius: 0.65rem;
  --bs-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-popover-header-padding-x: 1.25rem;
  --bs-popover-header-padding-y: 1rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: var(--bs-gray-800);
  --bs-popover-header-bg: #ffffff;
  --bs-popover-body-padding-x: 1.25rem;
  --bs-popover-body-padding-y: 1.25rem;
  --bs-popover-body-color: var(--bs-gray-800);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
  box-shadow: var(--bs-popover-box-shadow);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #ffffff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #ffffff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000000;
}
.carousel-dark .carousel-caption {
  color: #000000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.185rem;
  --bs-spinner-animation-speed: 0.65s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.145em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.65s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.3s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1.75rem;
  --bs-offcanvas-padding-y: 1.75rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: 0;
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  box-shadow: var(--bs-offcanvas-box-shadow);
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.4;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);
          mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-light {
  color: #000000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary {
  color: #000000 !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000000 !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000000 !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000000 !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #ffffff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(250, 250, 250, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(250, 250, 250, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(73, 157, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(73, 157, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(250, 250, 250, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(250, 250, 250, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(69, 209, 117, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(69, 209, 117, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(91, 46, 187, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(91, 46, 187, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(248, 205, 51, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(248, 205, 51, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(249, 83, 123, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 83, 123, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(24, 26, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(24, 26, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-5 {
  opacity: 0.05 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-25 {
  top: 25% !important;
}

.top-50 {
  top: 50% !important;
}

.top-75 {
  top: 75% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-25 {
  bottom: 25% !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-75 {
  bottom: 75% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-25 {
  left: 25% !important;
}

.start-50 {
  left: 50% !important;
}

.start-75 {
  left: 75% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-25 {
  right: 25% !important;
}

.end-50 {
  right: 50% !important;
}

.end-75 {
  right: 75% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-0 {
  border-width: 0 !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-unset {
  width: unset !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.w-1px {
  width: 1px !important;
}

.w-2px {
  width: 2px !important;
}

.w-3px {
  width: 3px !important;
}

.w-4px {
  width: 4px !important;
}

.w-5px {
  width: 5px !important;
}

.w-6px {
  width: 6px !important;
}

.w-7px {
  width: 7px !important;
}

.w-8px {
  width: 8px !important;
}

.w-9px {
  width: 9px !important;
}

.w-10px {
  width: 10px !important;
}

.w-15px {
  width: 15px !important;
}

.w-20px {
  width: 20px !important;
}

.w-25px {
  width: 25px !important;
}

.w-30px {
  width: 30px !important;
}

.w-35px {
  width: 35px !important;
}

.w-40px {
  width: 40px !important;
}

.w-45px {
  width: 45px !important;
}

.w-50px {
  width: 50px !important;
}

.w-55px {
  width: 55px !important;
}

.w-60px {
  width: 60px !important;
}

.w-65px {
  width: 65px !important;
}

.w-70px {
  width: 70px !important;
}

.w-75px {
  width: 75px !important;
}

.w-80px {
  width: 80px !important;
}

.w-85px {
  width: 85px !important;
}

.w-90px {
  width: 90px !important;
}

.w-95px {
  width: 95px !important;
}

.w-100px {
  width: 100px !important;
}

.w-125px {
  width: 125px !important;
}

.w-150px {
  width: 150px !important;
}

.w-175px {
  width: 175px !important;
}

.w-200px {
  width: 200px !important;
}

.w-225px {
  width: 225px !important;
}

.w-250px {
  width: 250px !important;
}

.w-275px {
  width: 275px !important;
}

.w-300px {
  width: 300px !important;
}

.w-325px {
  width: 325px !important;
}

.w-350px {
  width: 350px !important;
}

.w-375px {
  width: 375px !important;
}

.w-400px {
  width: 400px !important;
}

.w-425px {
  width: 425px !important;
}

.w-450px {
  width: 450px !important;
}

.w-475px {
  width: 475px !important;
}

.w-500px {
  width: 500px !important;
}

.w-550px {
  width: 550px !important;
}

.w-600px {
  width: 600px !important;
}

.w-650px {
  width: 650px !important;
}

.w-700px {
  width: 700px !important;
}

.w-750px {
  width: 750px !important;
}

.w-800px {
  width: 800px !important;
}

.w-850px {
  width: 850px !important;
}

.w-900px {
  width: 900px !important;
}

.w-950px {
  width: 950px !important;
}

.w-1000px {
  width: 1000px !important;
}

.mw-unset {
  max-width: unset !important;
}

.mw-25 {
  max-width: 25% !important;
}

.mw-50 {
  max-width: 50% !important;
}

.mw-75 {
  max-width: 75% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mw-auto {
  max-width: auto !important;
}

.mw-1px {
  max-width: 1px !important;
}

.mw-2px {
  max-width: 2px !important;
}

.mw-3px {
  max-width: 3px !important;
}

.mw-4px {
  max-width: 4px !important;
}

.mw-5px {
  max-width: 5px !important;
}

.mw-6px {
  max-width: 6px !important;
}

.mw-7px {
  max-width: 7px !important;
}

.mw-8px {
  max-width: 8px !important;
}

.mw-9px {
  max-width: 9px !important;
}

.mw-10px {
  max-width: 10px !important;
}

.mw-15px {
  max-width: 15px !important;
}

.mw-20px {
  max-width: 20px !important;
}

.mw-25px {
  max-width: 25px !important;
}

.mw-30px {
  max-width: 30px !important;
}

.mw-35px {
  max-width: 35px !important;
}

.mw-40px {
  max-width: 40px !important;
}

.mw-45px {
  max-width: 45px !important;
}

.mw-50px {
  max-width: 50px !important;
}

.mw-55px {
  max-width: 55px !important;
}

.mw-60px {
  max-width: 60px !important;
}

.mw-65px {
  max-width: 65px !important;
}

.mw-70px {
  max-width: 70px !important;
}

.mw-75px {
  max-width: 75px !important;
}

.mw-80px {
  max-width: 80px !important;
}

.mw-85px {
  max-width: 85px !important;
}

.mw-90px {
  max-width: 90px !important;
}

.mw-95px {
  max-width: 95px !important;
}

.mw-100px {
  max-width: 100px !important;
}

.mw-125px {
  max-width: 125px !important;
}

.mw-150px {
  max-width: 150px !important;
}

.mw-175px {
  max-width: 175px !important;
}

.mw-200px {
  max-width: 200px !important;
}

.mw-225px {
  max-width: 225px !important;
}

.mw-250px {
  max-width: 250px !important;
}

.mw-275px {
  max-width: 275px !important;
}

.mw-300px {
  max-width: 300px !important;
}

.mw-325px {
  max-width: 325px !important;
}

.mw-350px {
  max-width: 350px !important;
}

.mw-375px {
  max-width: 375px !important;
}

.mw-400px {
  max-width: 400px !important;
}

.mw-425px {
  max-width: 425px !important;
}

.mw-450px {
  max-width: 450px !important;
}

.mw-475px {
  max-width: 475px !important;
}

.mw-500px {
  max-width: 500px !important;
}

.mw-550px {
  max-width: 550px !important;
}

.mw-600px {
  max-width: 600px !important;
}

.mw-650px {
  max-width: 650px !important;
}

.mw-700px {
  max-width: 700px !important;
}

.mw-750px {
  max-width: 750px !important;
}

.mw-800px {
  max-width: 800px !important;
}

.mw-850px {
  max-width: 850px !important;
}

.mw-900px {
  max-width: 900px !important;
}

.mw-950px {
  max-width: 950px !important;
}

.mw-1000px {
  max-width: 1000px !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-unset {
  height: unset !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.h-1px {
  height: 1px !important;
}

.h-2px {
  height: 2px !important;
}

.h-3px {
  height: 3px !important;
}

.h-4px {
  height: 4px !important;
}

.h-5px {
  height: 5px !important;
}

.h-6px {
  height: 6px !important;
}

.h-7px {
  height: 7px !important;
}

.h-8px {
  height: 8px !important;
}

.h-9px {
  height: 9px !important;
}

.h-10px {
  height: 10px !important;
}

.h-15px {
  height: 15px !important;
}

.h-20px {
  height: 20px !important;
}

.h-25px {
  height: 25px !important;
}

.h-30px {
  height: 30px !important;
}

.h-35px {
  height: 35px !important;
}

.h-40px {
  height: 40px !important;
}

.h-45px {
  height: 45px !important;
}

.h-50px {
  height: 50px !important;
}

.h-55px {
  height: 55px !important;
}

.h-60px {
  height: 60px !important;
}

.h-65px {
  height: 65px !important;
}

.h-70px {
  height: 70px !important;
}

.h-75px {
  height: 75px !important;
}

.h-80px {
  height: 80px !important;
}

.h-85px {
  height: 85px !important;
}

.h-90px {
  height: 90px !important;
}

.h-95px {
  height: 95px !important;
}

.h-100px {
  height: 100px !important;
}

.h-125px {
  height: 125px !important;
}

.h-150px {
  height: 150px !important;
}

.h-175px {
  height: 175px !important;
}

.h-200px {
  height: 200px !important;
}

.h-225px {
  height: 225px !important;
}

.h-250px {
  height: 250px !important;
}

.h-275px {
  height: 275px !important;
}

.h-300px {
  height: 300px !important;
}

.h-325px {
  height: 325px !important;
}

.h-350px {
  height: 350px !important;
}

.h-375px {
  height: 375px !important;
}

.h-400px {
  height: 400px !important;
}

.h-425px {
  height: 425px !important;
}

.h-450px {
  height: 450px !important;
}

.h-475px {
  height: 475px !important;
}

.h-500px {
  height: 500px !important;
}

.h-550px {
  height: 550px !important;
}

.h-600px {
  height: 600px !important;
}

.h-650px {
  height: 650px !important;
}

.h-700px {
  height: 700px !important;
}

.h-750px {
  height: 750px !important;
}

.h-800px {
  height: 800px !important;
}

.h-850px {
  height: 850px !important;
}

.h-900px {
  height: 900px !important;
}

.h-950px {
  height: 950px !important;
}

.h-1000px {
  height: 1000px !important;
}

.mh-unset {
  max-height: unset !important;
}

.mh-25 {
  max-height: 25% !important;
}

.mh-50 {
  max-height: 50% !important;
}

.mh-75 {
  max-height: 75% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.mh-auto {
  max-height: auto !important;
}

.mh-1px {
  max-height: 1px !important;
}

.mh-2px {
  max-height: 2px !important;
}

.mh-3px {
  max-height: 3px !important;
}

.mh-4px {
  max-height: 4px !important;
}

.mh-5px {
  max-height: 5px !important;
}

.mh-6px {
  max-height: 6px !important;
}

.mh-7px {
  max-height: 7px !important;
}

.mh-8px {
  max-height: 8px !important;
}

.mh-9px {
  max-height: 9px !important;
}

.mh-10px {
  max-height: 10px !important;
}

.mh-15px {
  max-height: 15px !important;
}

.mh-20px {
  max-height: 20px !important;
}

.mh-25px {
  max-height: 25px !important;
}

.mh-30px {
  max-height: 30px !important;
}

.mh-35px {
  max-height: 35px !important;
}

.mh-40px {
  max-height: 40px !important;
}

.mh-45px {
  max-height: 45px !important;
}

.mh-50px {
  max-height: 50px !important;
}

.mh-55px {
  max-height: 55px !important;
}

.mh-60px {
  max-height: 60px !important;
}

.mh-65px {
  max-height: 65px !important;
}

.mh-70px {
  max-height: 70px !important;
}

.mh-75px {
  max-height: 75px !important;
}

.mh-80px {
  max-height: 80px !important;
}

.mh-85px {
  max-height: 85px !important;
}

.mh-90px {
  max-height: 90px !important;
}

.mh-95px {
  max-height: 95px !important;
}

.mh-100px {
  max-height: 100px !important;
}

.mh-125px {
  max-height: 125px !important;
}

.mh-150px {
  max-height: 150px !important;
}

.mh-175px {
  max-height: 175px !important;
}

.mh-200px {
  max-height: 200px !important;
}

.mh-225px {
  max-height: 225px !important;
}

.mh-250px {
  max-height: 250px !important;
}

.mh-275px {
  max-height: 275px !important;
}

.mh-300px {
  max-height: 300px !important;
}

.mh-325px {
  max-height: 325px !important;
}

.mh-350px {
  max-height: 350px !important;
}

.mh-375px {
  max-height: 375px !important;
}

.mh-400px {
  max-height: 400px !important;
}

.mh-425px {
  max-height: 425px !important;
}

.mh-450px {
  max-height: 450px !important;
}

.mh-475px {
  max-height: 475px !important;
}

.mh-500px {
  max-height: 500px !important;
}

.mh-550px {
  max-height: 550px !important;
}

.mh-600px {
  max-height: 600px !important;
}

.mh-650px {
  max-height: 650px !important;
}

.mh-700px {
  max-height: 700px !important;
}

.mh-750px {
  max-height: 750px !important;
}

.mh-800px {
  max-height: 800px !important;
}

.mh-850px {
  max-height: 850px !important;
}

.mh-900px {
  max-height: 900px !important;
}

.mh-950px {
  max-height: 950px !important;
}

.mh-1000px {
  max-height: 1000px !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 0.75rem !important;
}

.m-4 {
  margin: 1rem !important;
}

.m-5 {
  margin: 1.25rem !important;
}

.m-6 {
  margin: 1.5rem !important;
}

.m-7 {
  margin: 1.75rem !important;
}

.m-8 {
  margin: 2rem !important;
}

.m-9 {
  margin: 2.25rem !important;
}

.m-10 {
  margin: 2.5rem !important;
}

.m-11 {
  margin: 2.75rem !important;
}

.m-12 {
  margin: 3rem !important;
}

.m-13 {
  margin: 3.25rem !important;
}

.m-14 {
  margin: 3.5rem !important;
}

.m-15 {
  margin: 3.75rem !important;
}

.m-16 {
  margin: 4rem !important;
}

.m-17 {
  margin: 4.25rem !important;
}

.m-18 {
  margin: 4.5rem !important;
}

.m-19 {
  margin: 4.75rem !important;
}

.m-20 {
  margin: 5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-4 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-5 {
  margin-right: 1.25rem !important;
  margin-left: 1.25rem !important;
}

.mx-6 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-7 {
  margin-right: 1.75rem !important;
  margin-left: 1.75rem !important;
}

.mx-8 {
  margin-right: 2rem !important;
  margin-left: 2rem !important;
}

.mx-9 {
  margin-right: 2.25rem !important;
  margin-left: 2.25rem !important;
}

.mx-10 {
  margin-right: 2.5rem !important;
  margin-left: 2.5rem !important;
}

.mx-11 {
  margin-right: 2.75rem !important;
  margin-left: 2.75rem !important;
}

.mx-12 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-13 {
  margin-right: 3.25rem !important;
  margin-left: 3.25rem !important;
}

.mx-14 {
  margin-right: 3.5rem !important;
  margin-left: 3.5rem !important;
}

.mx-15 {
  margin-right: 3.75rem !important;
  margin-left: 3.75rem !important;
}

.mx-16 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-17 {
  margin-right: 4.25rem !important;
  margin-left: 4.25rem !important;
}

.mx-18 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-19 {
  margin-right: 4.75rem !important;
  margin-left: 4.75rem !important;
}

.mx-20 {
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-5 {
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}

.my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-7 {
  margin-top: 1.75rem !important;
  margin-bottom: 1.75rem !important;
}

.my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

.my-9 {
  margin-top: 2.25rem !important;
  margin-bottom: 2.25rem !important;
}

.my-10 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}

.my-11 {
  margin-top: 2.75rem !important;
  margin-bottom: 2.75rem !important;
}

.my-12 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-13 {
  margin-top: 3.25rem !important;
  margin-bottom: 3.25rem !important;
}

.my-14 {
  margin-top: 3.5rem !important;
  margin-bottom: 3.5rem !important;
}

.my-15 {
  margin-top: 3.75rem !important;
  margin-bottom: 3.75rem !important;
}

.my-16 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-17 {
  margin-top: 4.25rem !important;
  margin-bottom: 4.25rem !important;
}

.my-18 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-19 {
  margin-top: 4.75rem !important;
  margin-bottom: 4.75rem !important;
}

.my-20 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 1.75rem !important;
}

.mt-8 {
  margin-top: 2rem !important;
}

.mt-9 {
  margin-top: 2.25rem !important;
}

.mt-10 {
  margin-top: 2.5rem !important;
}

.mt-11 {
  margin-top: 2.75rem !important;
}

.mt-12 {
  margin-top: 3rem !important;
}

.mt-13 {
  margin-top: 3.25rem !important;
}

.mt-14 {
  margin-top: 3.5rem !important;
}

.mt-15 {
  margin-top: 3.75rem !important;
}

.mt-16 {
  margin-top: 4rem !important;
}

.mt-17 {
  margin-top: 4.25rem !important;
}

.mt-18 {
  margin-top: 4.5rem !important;
}

.mt-19 {
  margin-top: 4.75rem !important;
}

.mt-20 {
  margin-top: 5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 0.75rem !important;
}

.me-4 {
  margin-right: 1rem !important;
}

.me-5 {
  margin-right: 1.25rem !important;
}

.me-6 {
  margin-right: 1.5rem !important;
}

.me-7 {
  margin-right: 1.75rem !important;
}

.me-8 {
  margin-right: 2rem !important;
}

.me-9 {
  margin-right: 2.25rem !important;
}

.me-10 {
  margin-right: 2.5rem !important;
}

.me-11 {
  margin-right: 2.75rem !important;
}

.me-12 {
  margin-right: 3rem !important;
}

.me-13 {
  margin-right: 3.25rem !important;
}

.me-14 {
  margin-right: 3.5rem !important;
}

.me-15 {
  margin-right: 3.75rem !important;
}

.me-16 {
  margin-right: 4rem !important;
}

.me-17 {
  margin-right: 4.25rem !important;
}

.me-18 {
  margin-right: 4.5rem !important;
}

.me-19 {
  margin-right: 4.75rem !important;
}

.me-20 {
  margin-right: 5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 1.75rem !important;
}

.mb-8 {
  margin-bottom: 2rem !important;
}

.mb-9 {
  margin-bottom: 2.25rem !important;
}

.mb-10 {
  margin-bottom: 2.5rem !important;
}

.mb-11 {
  margin-bottom: 2.75rem !important;
}

.mb-12 {
  margin-bottom: 3rem !important;
}

.mb-13 {
  margin-bottom: 3.25rem !important;
}

.mb-14 {
  margin-bottom: 3.5rem !important;
}

.mb-15 {
  margin-bottom: 3.75rem !important;
}

.mb-16 {
  margin-bottom: 4rem !important;
}

.mb-17 {
  margin-bottom: 4.25rem !important;
}

.mb-18 {
  margin-bottom: 4.5rem !important;
}

.mb-19 {
  margin-bottom: 4.75rem !important;
}

.mb-20 {
  margin-bottom: 5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 0.75rem !important;
}

.ms-4 {
  margin-left: 1rem !important;
}

.ms-5 {
  margin-left: 1.25rem !important;
}

.ms-6 {
  margin-left: 1.5rem !important;
}

.ms-7 {
  margin-left: 1.75rem !important;
}

.ms-8 {
  margin-left: 2rem !important;
}

.ms-9 {
  margin-left: 2.25rem !important;
}

.ms-10 {
  margin-left: 2.5rem !important;
}

.ms-11 {
  margin-left: 2.75rem !important;
}

.ms-12 {
  margin-left: 3rem !important;
}

.ms-13 {
  margin-left: 3.25rem !important;
}

.ms-14 {
  margin-left: 3.5rem !important;
}

.ms-15 {
  margin-left: 3.75rem !important;
}

.ms-16 {
  margin-left: 4rem !important;
}

.ms-17 {
  margin-left: 4.25rem !important;
}

.ms-18 {
  margin-left: 4.5rem !important;
}

.ms-19 {
  margin-left: 4.75rem !important;
}

.ms-20 {
  margin-left: 5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -0.75rem !important;
}

.m-n4 {
  margin: -1rem !important;
}

.m-n5 {
  margin: -1.25rem !important;
}

.m-n6 {
  margin: -1.5rem !important;
}

.m-n7 {
  margin: -1.75rem !important;
}

.m-n8 {
  margin: -2rem !important;
}

.m-n9 {
  margin: -2.25rem !important;
}

.m-n10 {
  margin: -2.5rem !important;
}

.m-n11 {
  margin: -2.75rem !important;
}

.m-n12 {
  margin: -3rem !important;
}

.m-n13 {
  margin: -3.25rem !important;
}

.m-n14 {
  margin: -3.5rem !important;
}

.m-n15 {
  margin: -3.75rem !important;
}

.m-n16 {
  margin: -4rem !important;
}

.m-n17 {
  margin: -4.25rem !important;
}

.m-n18 {
  margin: -4.5rem !important;
}

.m-n19 {
  margin: -4.75rem !important;
}

.m-n20 {
  margin: -5rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -0.75rem !important;
  margin-left: -0.75rem !important;
}

.mx-n4 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n5 {
  margin-right: -1.25rem !important;
  margin-left: -1.25rem !important;
}

.mx-n6 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n7 {
  margin-right: -1.75rem !important;
  margin-left: -1.75rem !important;
}

.mx-n8 {
  margin-right: -2rem !important;
  margin-left: -2rem !important;
}

.mx-n9 {
  margin-right: -2.25rem !important;
  margin-left: -2.25rem !important;
}

.mx-n10 {
  margin-right: -2.5rem !important;
  margin-left: -2.5rem !important;
}

.mx-n11 {
  margin-right: -2.75rem !important;
  margin-left: -2.75rem !important;
}

.mx-n12 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n13 {
  margin-right: -3.25rem !important;
  margin-left: -3.25rem !important;
}

.mx-n14 {
  margin-right: -3.5rem !important;
  margin-left: -3.5rem !important;
}

.mx-n15 {
  margin-right: -3.75rem !important;
  margin-left: -3.75rem !important;
}

.mx-n16 {
  margin-right: -4rem !important;
  margin-left: -4rem !important;
}

.mx-n17 {
  margin-right: -4.25rem !important;
  margin-left: -4.25rem !important;
}

.mx-n18 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.mx-n19 {
  margin-right: -4.75rem !important;
  margin-left: -4.75rem !important;
}

.mx-n20 {
  margin-right: -5rem !important;
  margin-left: -5rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}

.my-n4 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n5 {
  margin-top: -1.25rem !important;
  margin-bottom: -1.25rem !important;
}

.my-n6 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n7 {
  margin-top: -1.75rem !important;
  margin-bottom: -1.75rem !important;
}

.my-n8 {
  margin-top: -2rem !important;
  margin-bottom: -2rem !important;
}

.my-n9 {
  margin-top: -2.25rem !important;
  margin-bottom: -2.25rem !important;
}

.my-n10 {
  margin-top: -2.5rem !important;
  margin-bottom: -2.5rem !important;
}

.my-n11 {
  margin-top: -2.75rem !important;
  margin-bottom: -2.75rem !important;
}

.my-n12 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n13 {
  margin-top: -3.25rem !important;
  margin-bottom: -3.25rem !important;
}

.my-n14 {
  margin-top: -3.5rem !important;
  margin-bottom: -3.5rem !important;
}

.my-n15 {
  margin-top: -3.75rem !important;
  margin-bottom: -3.75rem !important;
}

.my-n16 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}

.my-n17 {
  margin-top: -4.25rem !important;
  margin-bottom: -4.25rem !important;
}

.my-n18 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.my-n19 {
  margin-top: -4.75rem !important;
  margin-bottom: -4.75rem !important;
}

.my-n20 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -0.75rem !important;
}

.mt-n4 {
  margin-top: -1rem !important;
}

.mt-n5 {
  margin-top: -1.25rem !important;
}

.mt-n6 {
  margin-top: -1.5rem !important;
}

.mt-n7 {
  margin-top: -1.75rem !important;
}

.mt-n8 {
  margin-top: -2rem !important;
}

.mt-n9 {
  margin-top: -2.25rem !important;
}

.mt-n10 {
  margin-top: -2.5rem !important;
}

.mt-n11 {
  margin-top: -2.75rem !important;
}

.mt-n12 {
  margin-top: -3rem !important;
}

.mt-n13 {
  margin-top: -3.25rem !important;
}

.mt-n14 {
  margin-top: -3.5rem !important;
}

.mt-n15 {
  margin-top: -3.75rem !important;
}

.mt-n16 {
  margin-top: -4rem !important;
}

.mt-n17 {
  margin-top: -4.25rem !important;
}

.mt-n18 {
  margin-top: -4.5rem !important;
}

.mt-n19 {
  margin-top: -4.75rem !important;
}

.mt-n20 {
  margin-top: -5rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -0.75rem !important;
}

.me-n4 {
  margin-right: -1rem !important;
}

.me-n5 {
  margin-right: -1.25rem !important;
}

.me-n6 {
  margin-right: -1.5rem !important;
}

.me-n7 {
  margin-right: -1.75rem !important;
}

.me-n8 {
  margin-right: -2rem !important;
}

.me-n9 {
  margin-right: -2.25rem !important;
}

.me-n10 {
  margin-right: -2.5rem !important;
}

.me-n11 {
  margin-right: -2.75rem !important;
}

.me-n12 {
  margin-right: -3rem !important;
}

.me-n13 {
  margin-right: -3.25rem !important;
}

.me-n14 {
  margin-right: -3.5rem !important;
}

.me-n15 {
  margin-right: -3.75rem !important;
}

.me-n16 {
  margin-right: -4rem !important;
}

.me-n17 {
  margin-right: -4.25rem !important;
}

.me-n18 {
  margin-right: -4.5rem !important;
}

.me-n19 {
  margin-right: -4.75rem !important;
}

.me-n20 {
  margin-right: -5rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -0.75rem !important;
}

.mb-n4 {
  margin-bottom: -1rem !important;
}

.mb-n5 {
  margin-bottom: -1.25rem !important;
}

.mb-n6 {
  margin-bottom: -1.5rem !important;
}

.mb-n7 {
  margin-bottom: -1.75rem !important;
}

.mb-n8 {
  margin-bottom: -2rem !important;
}

.mb-n9 {
  margin-bottom: -2.25rem !important;
}

.mb-n10 {
  margin-bottom: -2.5rem !important;
}

.mb-n11 {
  margin-bottom: -2.75rem !important;
}

.mb-n12 {
  margin-bottom: -3rem !important;
}

.mb-n13 {
  margin-bottom: -3.25rem !important;
}

.mb-n14 {
  margin-bottom: -3.5rem !important;
}

.mb-n15 {
  margin-bottom: -3.75rem !important;
}

.mb-n16 {
  margin-bottom: -4rem !important;
}

.mb-n17 {
  margin-bottom: -4.25rem !important;
}

.mb-n18 {
  margin-bottom: -4.5rem !important;
}

.mb-n19 {
  margin-bottom: -4.75rem !important;
}

.mb-n20 {
  margin-bottom: -5rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -0.75rem !important;
}

.ms-n4 {
  margin-left: -1rem !important;
}

.ms-n5 {
  margin-left: -1.25rem !important;
}

.ms-n6 {
  margin-left: -1.5rem !important;
}

.ms-n7 {
  margin-left: -1.75rem !important;
}

.ms-n8 {
  margin-left: -2rem !important;
}

.ms-n9 {
  margin-left: -2.25rem !important;
}

.ms-n10 {
  margin-left: -2.5rem !important;
}

.ms-n11 {
  margin-left: -2.75rem !important;
}

.ms-n12 {
  margin-left: -3rem !important;
}

.ms-n13 {
  margin-left: -3.25rem !important;
}

.ms-n14 {
  margin-left: -3.5rem !important;
}

.ms-n15 {
  margin-left: -3.75rem !important;
}

.ms-n16 {
  margin-left: -4rem !important;
}

.ms-n17 {
  margin-left: -4.25rem !important;
}

.ms-n18 {
  margin-left: -4.5rem !important;
}

.ms-n19 {
  margin-left: -4.75rem !important;
}

.ms-n20 {
  margin-left: -5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 0.75rem !important;
}

.p-4 {
  padding: 1rem !important;
}

.p-5 {
  padding: 1.25rem !important;
}

.p-6 {
  padding: 1.5rem !important;
}

.p-7 {
  padding: 1.75rem !important;
}

.p-8 {
  padding: 2rem !important;
}

.p-9 {
  padding: 2.25rem !important;
}

.p-10 {
  padding: 2.5rem !important;
}

.p-11 {
  padding: 2.75rem !important;
}

.p-12 {
  padding: 3rem !important;
}

.p-13 {
  padding: 3.25rem !important;
}

.p-14 {
  padding: 3.5rem !important;
}

.p-15 {
  padding: 3.75rem !important;
}

.p-16 {
  padding: 4rem !important;
}

.p-17 {
  padding: 4.25rem !important;
}

.p-18 {
  padding: 4.5rem !important;
}

.p-19 {
  padding: 4.75rem !important;
}

.p-20 {
  padding: 5rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-4 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-5 {
  padding-right: 1.25rem !important;
  padding-left: 1.25rem !important;
}

.px-6 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-7 {
  padding-right: 1.75rem !important;
  padding-left: 1.75rem !important;
}

.px-8 {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}

.px-9 {
  padding-right: 2.25rem !important;
  padding-left: 2.25rem !important;
}

.px-10 {
  padding-right: 2.5rem !important;
  padding-left: 2.5rem !important;
}

.px-11 {
  padding-right: 2.75rem !important;
  padding-left: 2.75rem !important;
}

.px-12 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-13 {
  padding-right: 3.25rem !important;
  padding-left: 3.25rem !important;
}

.px-14 {
  padding-right: 3.5rem !important;
  padding-left: 3.5rem !important;
}

.px-15 {
  padding-right: 3.75rem !important;
  padding-left: 3.75rem !important;
}

.px-16 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-17 {
  padding-right: 4.25rem !important;
  padding-left: 4.25rem !important;
}

.px-18 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.px-19 {
  padding-right: 4.75rem !important;
  padding-left: 4.75rem !important;
}

.px-20 {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}

.py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-7 {
  padding-top: 1.75rem !important;
  padding-bottom: 1.75rem !important;
}

.py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.py-9 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}

.py-10 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}

.py-11 {
  padding-top: 2.75rem !important;
  padding-bottom: 2.75rem !important;
}

.py-12 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-13 {
  padding-top: 3.25rem !important;
  padding-bottom: 3.25rem !important;
}

.py-14 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

.py-15 {
  padding-top: 3.75rem !important;
  padding-bottom: 3.75rem !important;
}

.py-16 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-17 {
  padding-top: 4.25rem !important;
  padding-bottom: 4.25rem !important;
}

.py-18 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.py-19 {
  padding-top: 4.75rem !important;
  padding-bottom: 4.75rem !important;
}

.py-20 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 0.75rem !important;
}

.pt-4 {
  padding-top: 1rem !important;
}

.pt-5 {
  padding-top: 1.25rem !important;
}

.pt-6 {
  padding-top: 1.5rem !important;
}

.pt-7 {
  padding-top: 1.75rem !important;
}

.pt-8 {
  padding-top: 2rem !important;
}

.pt-9 {
  padding-top: 2.25rem !important;
}

.pt-10 {
  padding-top: 2.5rem !important;
}

.pt-11 {
  padding-top: 2.75rem !important;
}

.pt-12 {
  padding-top: 3rem !important;
}

.pt-13 {
  padding-top: 3.25rem !important;
}

.pt-14 {
  padding-top: 3.5rem !important;
}

.pt-15 {
  padding-top: 3.75rem !important;
}

.pt-16 {
  padding-top: 4rem !important;
}

.pt-17 {
  padding-top: 4.25rem !important;
}

.pt-18 {
  padding-top: 4.5rem !important;
}

.pt-19 {
  padding-top: 4.75rem !important;
}

.pt-20 {
  padding-top: 5rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 0.75rem !important;
}

.pe-4 {
  padding-right: 1rem !important;
}

.pe-5 {
  padding-right: 1.25rem !important;
}

.pe-6 {
  padding-right: 1.5rem !important;
}

.pe-7 {
  padding-right: 1.75rem !important;
}

.pe-8 {
  padding-right: 2rem !important;
}

.pe-9 {
  padding-right: 2.25rem !important;
}

.pe-10 {
  padding-right: 2.5rem !important;
}

.pe-11 {
  padding-right: 2.75rem !important;
}

.pe-12 {
  padding-right: 3rem !important;
}

.pe-13 {
  padding-right: 3.25rem !important;
}

.pe-14 {
  padding-right: 3.5rem !important;
}

.pe-15 {
  padding-right: 3.75rem !important;
}

.pe-16 {
  padding-right: 4rem !important;
}

.pe-17 {
  padding-right: 4.25rem !important;
}

.pe-18 {
  padding-right: 4.5rem !important;
}

.pe-19 {
  padding-right: 4.75rem !important;
}

.pe-20 {
  padding-right: 5rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 0.75rem !important;
}

.pb-4 {
  padding-bottom: 1rem !important;
}

.pb-5 {
  padding-bottom: 1.25rem !important;
}

.pb-6 {
  padding-bottom: 1.5rem !important;
}

.pb-7 {
  padding-bottom: 1.75rem !important;
}

.pb-8 {
  padding-bottom: 2rem !important;
}

.pb-9 {
  padding-bottom: 2.25rem !important;
}

.pb-10 {
  padding-bottom: 2.5rem !important;
}

.pb-11 {
  padding-bottom: 2.75rem !important;
}

.pb-12 {
  padding-bottom: 3rem !important;
}

.pb-13 {
  padding-bottom: 3.25rem !important;
}

.pb-14 {
  padding-bottom: 3.5rem !important;
}

.pb-15 {
  padding-bottom: 3.75rem !important;
}

.pb-16 {
  padding-bottom: 4rem !important;
}

.pb-17 {
  padding-bottom: 4.25rem !important;
}

.pb-18 {
  padding-bottom: 4.5rem !important;
}

.pb-19 {
  padding-bottom: 4.75rem !important;
}

.pb-20 {
  padding-bottom: 5rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 0.75rem !important;
}

.ps-4 {
  padding-left: 1rem !important;
}

.ps-5 {
  padding-left: 1.25rem !important;
}

.ps-6 {
  padding-left: 1.5rem !important;
}

.ps-7 {
  padding-left: 1.75rem !important;
}

.ps-8 {
  padding-left: 2rem !important;
}

.ps-9 {
  padding-left: 2.25rem !important;
}

.ps-10 {
  padding-left: 2.5rem !important;
}

.ps-11 {
  padding-left: 2.75rem !important;
}

.ps-12 {
  padding-left: 3rem !important;
}

.ps-13 {
  padding-left: 3.25rem !important;
}

.ps-14 {
  padding-left: 3.5rem !important;
}

.ps-15 {
  padding-left: 3.75rem !important;
}

.ps-16 {
  padding-left: 4rem !important;
}

.ps-17 {
  padding-left: 4.25rem !important;
}

.ps-18 {
  padding-left: 4.5rem !important;
}

.ps-19 {
  padding-left: 4.75rem !important;
}

.ps-20 {
  padding-left: 5rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 1.75rem !important;
}

.gap-8 {
  gap: 2rem !important;
}

.gap-9 {
  gap: 2.25rem !important;
}

.gap-10 {
  gap: 2.5rem !important;
}

.gap-11 {
  gap: 2.75rem !important;
}

.gap-12 {
  gap: 3rem !important;
}

.gap-13 {
  gap: 3.25rem !important;
}

.gap-14 {
  gap: 3.5rem !important;
}

.gap-15 {
  gap: 3.75rem !important;
}

.gap-16 {
  gap: 4rem !important;
}

.gap-17 {
  gap: 4.25rem !important;
}

.gap-18 {
  gap: 4.5rem !important;
}

.gap-19 {
  gap: 4.75rem !important;
}

.gap-20 {
  gap: 5rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 0.75rem !important;
}

.row-gap-4 {
  row-gap: 1rem !important;
}

.row-gap-5 {
  row-gap: 1.25rem !important;
}

.row-gap-6 {
  row-gap: 1.5rem !important;
}

.row-gap-7 {
  row-gap: 1.75rem !important;
}

.row-gap-8 {
  row-gap: 2rem !important;
}

.row-gap-9 {
  row-gap: 2.25rem !important;
}

.row-gap-10 {
  row-gap: 2.5rem !important;
}

.row-gap-11 {
  row-gap: 2.75rem !important;
}

.row-gap-12 {
  row-gap: 3rem !important;
}

.row-gap-13 {
  row-gap: 3.25rem !important;
}

.row-gap-14 {
  row-gap: 3.5rem !important;
}

.row-gap-15 {
  row-gap: 3.75rem !important;
}

.row-gap-16 {
  row-gap: 4rem !important;
}

.row-gap-17 {
  row-gap: 4.25rem !important;
}

.row-gap-18 {
  row-gap: 4.5rem !important;
}

.row-gap-19 {
  row-gap: 4.75rem !important;
}

.row-gap-20 {
  row-gap: 5rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 0.75rem !important;
}

.column-gap-4 {
  column-gap: 1rem !important;
}

.column-gap-5 {
  column-gap: 1.25rem !important;
}

.column-gap-6 {
  column-gap: 1.5rem !important;
}

.column-gap-7 {
  column-gap: 1.75rem !important;
}

.column-gap-8 {
  column-gap: 2rem !important;
}

.column-gap-9 {
  column-gap: 2.25rem !important;
}

.column-gap-10 {
  column-gap: 2.5rem !important;
}

.column-gap-11 {
  column-gap: 2.75rem !important;
}

.column-gap-12 {
  column-gap: 3rem !important;
}

.column-gap-13 {
  column-gap: 3.25rem !important;
}

.column-gap-14 {
  column-gap: 3.5rem !important;
}

.column-gap-15 {
  column-gap: 3.75rem !important;
}

.column-gap-16 {
  column-gap: 4rem !important;
}

.column-gap-17 {
  column-gap: 4.25rem !important;
}

.column-gap-18 {
  column-gap: 4.5rem !important;
}

.column-gap-19 {
  column-gap: 4.75rem !important;
}

.column-gap-20 {
  column-gap: 5rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-2 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-3 {
  font-size: calc(1.26rem + 0.12vw) !important;
}

.fs-4 {
  font-size: 1.25rem !important;
}

.fs-5 {
  font-size: 1.15rem !important;
}

.fs-6 {
  font-size: 1.075rem !important;
}

.fs-7 {
  font-size: 0.95rem !important;
}

.fs-8 {
  font-size: 0.85rem !important;
}

.fs-9 {
  font-size: 0.75rem !important;
}

.fs-10 {
  font-size: 0.5rem !important;
}

.fs-sm {
  font-size: 0.95rem !important;
}

.fs-base {
  font-size: 1rem !important;
}

.fs-lg {
  font-size: 1.075rem !important;
}

.fs-xl {
  font-size: 1.21rem !important;
}

.fs-fluid {
  font-size: 100% !important;
}

.fs-2x {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-2qx {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2hx {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2tx {
  font-size: calc(1.4rem + 1.8vw) !important;
}

.fs-3x {
  font-size: calc(1.425rem + 2.1vw) !important;
}

.fs-3qx {
  font-size: calc(1.45rem + 2.4vw) !important;
}

.fs-3hx {
  font-size: calc(1.475rem + 2.7vw) !important;
}

.fs-3tx {
  font-size: calc(1.5rem + 3vw) !important;
}

.fs-4x {
  font-size: calc(1.525rem + 3.3vw) !important;
}

.fs-4qx {
  font-size: calc(1.55rem + 3.6vw) !important;
}

.fs-4hx {
  font-size: calc(1.575rem + 3.9vw) !important;
}

.fs-4tx {
  font-size: calc(1.6rem + 4.2vw) !important;
}

.fs-5x {
  font-size: calc(1.625rem + 4.5vw) !important;
}

.fs-5qx {
  font-size: calc(1.65rem + 4.8vw) !important;
}

.fs-5hx {
  font-size: calc(1.675rem + 5.1vw) !important;
}

.fs-5tx {
  font-size: calc(1.7rem + 5.4vw) !important;
}

.fs-6x {
  font-size: calc(1.725rem + 5.7vw) !important;
}

.fs-6qx {
  font-size: calc(1.75rem + 6vw) !important;
}

.fs-6hx {
  font-size: calc(1.775rem + 6.3vw) !important;
}

.fs-6tx {
  font-size: calc(1.8rem + 6.6vw) !important;
}

.fs-7x {
  font-size: calc(1.825rem + 6.9vw) !important;
}

.fs-7qx {
  font-size: calc(1.85rem + 7.2vw) !important;
}

.fs-7hx {
  font-size: calc(1.875rem + 7.5vw) !important;
}

.fs-7tx {
  font-size: calc(1.9rem + 7.8vw) !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 500 !important;
}

.fw-bold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: 700 !important;
}

.lh-0 {
  line-height: 0 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 1.75 !important;
}

.lh-xl {
  line-height: 2 !important;
}

.lh-xxl {
  line-height: 2.25 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.65rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.3rem !important;
}

.rounded-2 {
  border-radius: 0.65rem !important;
}

.rounded-3 {
  border-radius: 0.85rem !important;
}

.rounded-4 {
  border-radius: 1.25rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-index-n1 {
  z-index: -1 !important;
}

.z-index-n2 {
  z-index: -2 !important;
}

.z-index-0 {
  z-index: 0 !important;
}

.z-index-1 {
  z-index: 1 !important;
}

.z-index-2 {
  z-index: 2 !important;
}

.z-index-3 {
  z-index: 3 !important;
}

.cursor-help {
  cursor: help !important;
}

.cursor-wait {
  cursor: wait !important;
}

.cursor-crosshair {
  cursor: crosshair !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.cursor-zoom-in {
  cursor: zoom-in !important;
}

.cursor-grab {
  cursor: grab !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-0-hover:hover {
  opacity: 0 !important;
}

.opacity-5 {
  opacity: 0.05 !important;
}

.opacity-5-hover:hover {
  opacity: 0.05 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-10-hover:hover {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-15-hover:hover {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-20-hover:hover {
  opacity: 0.2 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-25-hover:hover {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-50-hover:hover {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-75-hover:hover {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.opacity-100-hover:hover {
  opacity: 1 !important;
}

.min-w-unset {
  min-width: unset !important;
}

.min-w-25 {
  min-width: 25% !important;
}

.min-w-50 {
  min-width: 50% !important;
}

.min-w-75 {
  min-width: 75% !important;
}

.min-w-100 {
  min-width: 100% !important;
}

.min-w-auto {
  min-width: auto !important;
}

.min-w-1px {
  min-width: 1px !important;
}

.min-w-2px {
  min-width: 2px !important;
}

.min-w-3px {
  min-width: 3px !important;
}

.min-w-4px {
  min-width: 4px !important;
}

.min-w-5px {
  min-width: 5px !important;
}

.min-w-6px {
  min-width: 6px !important;
}

.min-w-7px {
  min-width: 7px !important;
}

.min-w-8px {
  min-width: 8px !important;
}

.min-w-9px {
  min-width: 9px !important;
}

.min-w-10px {
  min-width: 10px !important;
}

.min-w-15px {
  min-width: 15px !important;
}

.min-w-20px {
  min-width: 20px !important;
}

.min-w-25px {
  min-width: 25px !important;
}

.min-w-30px {
  min-width: 30px !important;
}

.min-w-35px {
  min-width: 35px !important;
}

.min-w-40px {
  min-width: 40px !important;
}

.min-w-45px {
  min-width: 45px !important;
}

.min-w-50px {
  min-width: 50px !important;
}

.min-w-55px {
  min-width: 55px !important;
}

.min-w-60px {
  min-width: 60px !important;
}

.min-w-65px {
  min-width: 65px !important;
}

.min-w-70px {
  min-width: 70px !important;
}

.min-w-75px {
  min-width: 75px !important;
}

.min-w-80px {
  min-width: 80px !important;
}

.min-w-85px {
  min-width: 85px !important;
}

.min-w-90px {
  min-width: 90px !important;
}

.min-w-95px {
  min-width: 95px !important;
}

.min-w-100px {
  min-width: 100px !important;
}

.min-w-125px {
  min-width: 125px !important;
}

.min-w-150px {
  min-width: 150px !important;
}

.min-w-175px {
  min-width: 175px !important;
}

.min-w-200px {
  min-width: 200px !important;
}

.min-w-225px {
  min-width: 225px !important;
}

.min-w-250px {
  min-width: 250px !important;
}

.min-w-275px {
  min-width: 275px !important;
}

.min-w-300px {
  min-width: 300px !important;
}

.min-w-325px {
  min-width: 325px !important;
}

.min-w-350px {
  min-width: 350px !important;
}

.min-w-375px {
  min-width: 375px !important;
}

.min-w-400px {
  min-width: 400px !important;
}

.min-w-425px {
  min-width: 425px !important;
}

.min-w-450px {
  min-width: 450px !important;
}

.min-w-475px {
  min-width: 475px !important;
}

.min-w-500px {
  min-width: 500px !important;
}

.min-w-550px {
  min-width: 550px !important;
}

.min-w-600px {
  min-width: 600px !important;
}

.min-w-650px {
  min-width: 650px !important;
}

.min-w-700px {
  min-width: 700px !important;
}

.min-w-750px {
  min-width: 750px !important;
}

.min-w-800px {
  min-width: 800px !important;
}

.min-w-850px {
  min-width: 850px !important;
}

.min-w-900px {
  min-width: 900px !important;
}

.min-w-950px {
  min-width: 950px !important;
}

.min-w-1000px {
  min-width: 1000px !important;
}

.min-h-unset {
  min-height: unset !important;
}

.min-h-25 {
  min-height: 25% !important;
}

.min-h-50 {
  min-height: 50% !important;
}

.min-h-75 {
  min-height: 75% !important;
}

.min-h-100 {
  min-height: 100% !important;
}

.min-h-auto {
  min-height: auto !important;
}

.min-h-1px {
  min-height: 1px !important;
}

.min-h-2px {
  min-height: 2px !important;
}

.min-h-3px {
  min-height: 3px !important;
}

.min-h-4px {
  min-height: 4px !important;
}

.min-h-5px {
  min-height: 5px !important;
}

.min-h-6px {
  min-height: 6px !important;
}

.min-h-7px {
  min-height: 7px !important;
}

.min-h-8px {
  min-height: 8px !important;
}

.min-h-9px {
  min-height: 9px !important;
}

.min-h-10px {
  min-height: 10px !important;
}

.min-h-15px {
  min-height: 15px !important;
}

.min-h-20px {
  min-height: 20px !important;
}

.min-h-25px {
  min-height: 25px !important;
}

.min-h-30px {
  min-height: 30px !important;
}

.min-h-35px {
  min-height: 35px !important;
}

.min-h-40px {
  min-height: 40px !important;
}

.min-h-45px {
  min-height: 45px !important;
}

.min-h-50px {
  min-height: 50px !important;
}

.min-h-55px {
  min-height: 55px !important;
}

.min-h-60px {
  min-height: 60px !important;
}

.min-h-65px {
  min-height: 65px !important;
}

.min-h-70px {
  min-height: 70px !important;
}

.min-h-75px {
  min-height: 75px !important;
}

.min-h-80px {
  min-height: 80px !important;
}

.min-h-85px {
  min-height: 85px !important;
}

.min-h-90px {
  min-height: 90px !important;
}

.min-h-95px {
  min-height: 95px !important;
}

.min-h-100px {
  min-height: 100px !important;
}

.min-h-125px {
  min-height: 125px !important;
}

.min-h-150px {
  min-height: 150px !important;
}

.min-h-175px {
  min-height: 175px !important;
}

.min-h-200px {
  min-height: 200px !important;
}

.min-h-225px {
  min-height: 225px !important;
}

.min-h-250px {
  min-height: 250px !important;
}

.min-h-275px {
  min-height: 275px !important;
}

.min-h-300px {
  min-height: 300px !important;
}

.min-h-325px {
  min-height: 325px !important;
}

.min-h-350px {
  min-height: 350px !important;
}

.min-h-375px {
  min-height: 375px !important;
}

.min-h-400px {
  min-height: 400px !important;
}

.min-h-425px {
  min-height: 425px !important;
}

.min-h-450px {
  min-height: 450px !important;
}

.min-h-475px {
  min-height: 475px !important;
}

.min-h-500px {
  min-height: 500px !important;
}

.min-h-550px {
  min-height: 550px !important;
}

.min-h-600px {
  min-height: 600px !important;
}

.min-h-650px {
  min-height: 650px !important;
}

.min-h-700px {
  min-height: 700px !important;
}

.min-h-750px {
  min-height: 750px !important;
}

.min-h-800px {
  min-height: 800px !important;
}

.min-h-850px {
  min-height: 850px !important;
}

.min-h-900px {
  min-height: 900px !important;
}

.min-h-950px {
  min-height: 950px !important;
}

.min-h-1000px {
  min-height: 1000px !important;
}

.border-top-0 {
  border-top-width: 0 !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

.border-bottom-0 {
  border-bottom-width: 0 !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

.border-right-0 {
  border-right-width: 0 !important;
}

.border-right-1 {
  border-right-width: 1px !important;
}

.border-right-2 {
  border-right-width: 2px !important;
}

.border-right-3 {
  border-right-width: 3px !important;
}

.border-right-4 {
  border-right-width: 4px !important;
}

.border-right-5 {
  border-right-width: 5px !important;
}

.border-left-0 {
  border-left-width: 0 !important;
}

.border-left-1 {
  border-left-width: 1px !important;
}

.border-left-2 {
  border-left-width: 2px !important;
}

.border-left-3 {
  border-left-width: 3px !important;
}

.border-left-4 {
  border-left-width: 4px !important;
}

.border-left-5 {
  border-left-width: 5px !important;
}

.ls-1 {
  letter-spacing: 0.1rem !important;
}

.ls-2 {
  letter-spacing: 0.115rem !important;
}

.ls-3 {
  letter-spacing: 0.125rem !important;
}

.ls-4 {
  letter-spacing: 0.25rem !important;
}

.ls-5 {
  letter-spacing: 0.5rem !important;
}

.ls-n1 {
  letter-spacing: -0.1rem !important;
}

.ls-n2 {
  letter-spacing: -0.115rem !important;
}

.ls-n3 {
  letter-spacing: -0.125rem !important;
}

.ls-n4 {
  letter-spacing: -0.25rem !important;
}

.ls-n5 {
  letter-spacing: -0.5rem !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .overflow-sm-auto {
    overflow: auto !important;
  }
  .overflow-sm-hidden {
    overflow: hidden !important;
  }
  .overflow-sm-visible {
    overflow: visible !important;
  }
  .overflow-sm-scroll {
    overflow: scroll !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .position-sm-static {
    position: static !important;
  }
  .position-sm-relative {
    position: relative !important;
  }
  .position-sm-absolute {
    position: absolute !important;
  }
  .position-sm-fixed {
    position: fixed !important;
  }
  .position-sm-sticky {
    position: sticky !important;
  }
  .w-sm-unset {
    width: unset !important;
  }
  .w-sm-25 {
    width: 25% !important;
  }
  .w-sm-50 {
    width: 50% !important;
  }
  .w-sm-75 {
    width: 75% !important;
  }
  .w-sm-100 {
    width: 100% !important;
  }
  .w-sm-auto {
    width: auto !important;
  }
  .w-sm-1px {
    width: 1px !important;
  }
  .w-sm-2px {
    width: 2px !important;
  }
  .w-sm-3px {
    width: 3px !important;
  }
  .w-sm-4px {
    width: 4px !important;
  }
  .w-sm-5px {
    width: 5px !important;
  }
  .w-sm-6px {
    width: 6px !important;
  }
  .w-sm-7px {
    width: 7px !important;
  }
  .w-sm-8px {
    width: 8px !important;
  }
  .w-sm-9px {
    width: 9px !important;
  }
  .w-sm-10px {
    width: 10px !important;
  }
  .w-sm-15px {
    width: 15px !important;
  }
  .w-sm-20px {
    width: 20px !important;
  }
  .w-sm-25px {
    width: 25px !important;
  }
  .w-sm-30px {
    width: 30px !important;
  }
  .w-sm-35px {
    width: 35px !important;
  }
  .w-sm-40px {
    width: 40px !important;
  }
  .w-sm-45px {
    width: 45px !important;
  }
  .w-sm-50px {
    width: 50px !important;
  }
  .w-sm-55px {
    width: 55px !important;
  }
  .w-sm-60px {
    width: 60px !important;
  }
  .w-sm-65px {
    width: 65px !important;
  }
  .w-sm-70px {
    width: 70px !important;
  }
  .w-sm-75px {
    width: 75px !important;
  }
  .w-sm-80px {
    width: 80px !important;
  }
  .w-sm-85px {
    width: 85px !important;
  }
  .w-sm-90px {
    width: 90px !important;
  }
  .w-sm-95px {
    width: 95px !important;
  }
  .w-sm-100px {
    width: 100px !important;
  }
  .w-sm-125px {
    width: 125px !important;
  }
  .w-sm-150px {
    width: 150px !important;
  }
  .w-sm-175px {
    width: 175px !important;
  }
  .w-sm-200px {
    width: 200px !important;
  }
  .w-sm-225px {
    width: 225px !important;
  }
  .w-sm-250px {
    width: 250px !important;
  }
  .w-sm-275px {
    width: 275px !important;
  }
  .w-sm-300px {
    width: 300px !important;
  }
  .w-sm-325px {
    width: 325px !important;
  }
  .w-sm-350px {
    width: 350px !important;
  }
  .w-sm-375px {
    width: 375px !important;
  }
  .w-sm-400px {
    width: 400px !important;
  }
  .w-sm-425px {
    width: 425px !important;
  }
  .w-sm-450px {
    width: 450px !important;
  }
  .w-sm-475px {
    width: 475px !important;
  }
  .w-sm-500px {
    width: 500px !important;
  }
  .w-sm-550px {
    width: 550px !important;
  }
  .w-sm-600px {
    width: 600px !important;
  }
  .w-sm-650px {
    width: 650px !important;
  }
  .w-sm-700px {
    width: 700px !important;
  }
  .w-sm-750px {
    width: 750px !important;
  }
  .w-sm-800px {
    width: 800px !important;
  }
  .w-sm-850px {
    width: 850px !important;
  }
  .w-sm-900px {
    width: 900px !important;
  }
  .w-sm-950px {
    width: 950px !important;
  }
  .w-sm-1000px {
    width: 1000px !important;
  }
  .mw-sm-unset {
    max-width: unset !important;
  }
  .mw-sm-25 {
    max-width: 25% !important;
  }
  .mw-sm-50 {
    max-width: 50% !important;
  }
  .mw-sm-75 {
    max-width: 75% !important;
  }
  .mw-sm-100 {
    max-width: 100% !important;
  }
  .mw-sm-auto {
    max-width: auto !important;
  }
  .mw-sm-1px {
    max-width: 1px !important;
  }
  .mw-sm-2px {
    max-width: 2px !important;
  }
  .mw-sm-3px {
    max-width: 3px !important;
  }
  .mw-sm-4px {
    max-width: 4px !important;
  }
  .mw-sm-5px {
    max-width: 5px !important;
  }
  .mw-sm-6px {
    max-width: 6px !important;
  }
  .mw-sm-7px {
    max-width: 7px !important;
  }
  .mw-sm-8px {
    max-width: 8px !important;
  }
  .mw-sm-9px {
    max-width: 9px !important;
  }
  .mw-sm-10px {
    max-width: 10px !important;
  }
  .mw-sm-15px {
    max-width: 15px !important;
  }
  .mw-sm-20px {
    max-width: 20px !important;
  }
  .mw-sm-25px {
    max-width: 25px !important;
  }
  .mw-sm-30px {
    max-width: 30px !important;
  }
  .mw-sm-35px {
    max-width: 35px !important;
  }
  .mw-sm-40px {
    max-width: 40px !important;
  }
  .mw-sm-45px {
    max-width: 45px !important;
  }
  .mw-sm-50px {
    max-width: 50px !important;
  }
  .mw-sm-55px {
    max-width: 55px !important;
  }
  .mw-sm-60px {
    max-width: 60px !important;
  }
  .mw-sm-65px {
    max-width: 65px !important;
  }
  .mw-sm-70px {
    max-width: 70px !important;
  }
  .mw-sm-75px {
    max-width: 75px !important;
  }
  .mw-sm-80px {
    max-width: 80px !important;
  }
  .mw-sm-85px {
    max-width: 85px !important;
  }
  .mw-sm-90px {
    max-width: 90px !important;
  }
  .mw-sm-95px {
    max-width: 95px !important;
  }
  .mw-sm-100px {
    max-width: 100px !important;
  }
  .mw-sm-125px {
    max-width: 125px !important;
  }
  .mw-sm-150px {
    max-width: 150px !important;
  }
  .mw-sm-175px {
    max-width: 175px !important;
  }
  .mw-sm-200px {
    max-width: 200px !important;
  }
  .mw-sm-225px {
    max-width: 225px !important;
  }
  .mw-sm-250px {
    max-width: 250px !important;
  }
  .mw-sm-275px {
    max-width: 275px !important;
  }
  .mw-sm-300px {
    max-width: 300px !important;
  }
  .mw-sm-325px {
    max-width: 325px !important;
  }
  .mw-sm-350px {
    max-width: 350px !important;
  }
  .mw-sm-375px {
    max-width: 375px !important;
  }
  .mw-sm-400px {
    max-width: 400px !important;
  }
  .mw-sm-425px {
    max-width: 425px !important;
  }
  .mw-sm-450px {
    max-width: 450px !important;
  }
  .mw-sm-475px {
    max-width: 475px !important;
  }
  .mw-sm-500px {
    max-width: 500px !important;
  }
  .mw-sm-550px {
    max-width: 550px !important;
  }
  .mw-sm-600px {
    max-width: 600px !important;
  }
  .mw-sm-650px {
    max-width: 650px !important;
  }
  .mw-sm-700px {
    max-width: 700px !important;
  }
  .mw-sm-750px {
    max-width: 750px !important;
  }
  .mw-sm-800px {
    max-width: 800px !important;
  }
  .mw-sm-850px {
    max-width: 850px !important;
  }
  .mw-sm-900px {
    max-width: 900px !important;
  }
  .mw-sm-950px {
    max-width: 950px !important;
  }
  .mw-sm-1000px {
    max-width: 1000px !important;
  }
  .h-sm-unset {
    height: unset !important;
  }
  .h-sm-25 {
    height: 25% !important;
  }
  .h-sm-50 {
    height: 50% !important;
  }
  .h-sm-75 {
    height: 75% !important;
  }
  .h-sm-100 {
    height: 100% !important;
  }
  .h-sm-auto {
    height: auto !important;
  }
  .h-sm-1px {
    height: 1px !important;
  }
  .h-sm-2px {
    height: 2px !important;
  }
  .h-sm-3px {
    height: 3px !important;
  }
  .h-sm-4px {
    height: 4px !important;
  }
  .h-sm-5px {
    height: 5px !important;
  }
  .h-sm-6px {
    height: 6px !important;
  }
  .h-sm-7px {
    height: 7px !important;
  }
  .h-sm-8px {
    height: 8px !important;
  }
  .h-sm-9px {
    height: 9px !important;
  }
  .h-sm-10px {
    height: 10px !important;
  }
  .h-sm-15px {
    height: 15px !important;
  }
  .h-sm-20px {
    height: 20px !important;
  }
  .h-sm-25px {
    height: 25px !important;
  }
  .h-sm-30px {
    height: 30px !important;
  }
  .h-sm-35px {
    height: 35px !important;
  }
  .h-sm-40px {
    height: 40px !important;
  }
  .h-sm-45px {
    height: 45px !important;
  }
  .h-sm-50px {
    height: 50px !important;
  }
  .h-sm-55px {
    height: 55px !important;
  }
  .h-sm-60px {
    height: 60px !important;
  }
  .h-sm-65px {
    height: 65px !important;
  }
  .h-sm-70px {
    height: 70px !important;
  }
  .h-sm-75px {
    height: 75px !important;
  }
  .h-sm-80px {
    height: 80px !important;
  }
  .h-sm-85px {
    height: 85px !important;
  }
  .h-sm-90px {
    height: 90px !important;
  }
  .h-sm-95px {
    height: 95px !important;
  }
  .h-sm-100px {
    height: 100px !important;
  }
  .h-sm-125px {
    height: 125px !important;
  }
  .h-sm-150px {
    height: 150px !important;
  }
  .h-sm-175px {
    height: 175px !important;
  }
  .h-sm-200px {
    height: 200px !important;
  }
  .h-sm-225px {
    height: 225px !important;
  }
  .h-sm-250px {
    height: 250px !important;
  }
  .h-sm-275px {
    height: 275px !important;
  }
  .h-sm-300px {
    height: 300px !important;
  }
  .h-sm-325px {
    height: 325px !important;
  }
  .h-sm-350px {
    height: 350px !important;
  }
  .h-sm-375px {
    height: 375px !important;
  }
  .h-sm-400px {
    height: 400px !important;
  }
  .h-sm-425px {
    height: 425px !important;
  }
  .h-sm-450px {
    height: 450px !important;
  }
  .h-sm-475px {
    height: 475px !important;
  }
  .h-sm-500px {
    height: 500px !important;
  }
  .h-sm-550px {
    height: 550px !important;
  }
  .h-sm-600px {
    height: 600px !important;
  }
  .h-sm-650px {
    height: 650px !important;
  }
  .h-sm-700px {
    height: 700px !important;
  }
  .h-sm-750px {
    height: 750px !important;
  }
  .h-sm-800px {
    height: 800px !important;
  }
  .h-sm-850px {
    height: 850px !important;
  }
  .h-sm-900px {
    height: 900px !important;
  }
  .h-sm-950px {
    height: 950px !important;
  }
  .h-sm-1000px {
    height: 1000px !important;
  }
  .mh-sm-unset {
    max-height: unset !important;
  }
  .mh-sm-25 {
    max-height: 25% !important;
  }
  .mh-sm-50 {
    max-height: 50% !important;
  }
  .mh-sm-75 {
    max-height: 75% !important;
  }
  .mh-sm-100 {
    max-height: 100% !important;
  }
  .mh-sm-auto {
    max-height: auto !important;
  }
  .mh-sm-1px {
    max-height: 1px !important;
  }
  .mh-sm-2px {
    max-height: 2px !important;
  }
  .mh-sm-3px {
    max-height: 3px !important;
  }
  .mh-sm-4px {
    max-height: 4px !important;
  }
  .mh-sm-5px {
    max-height: 5px !important;
  }
  .mh-sm-6px {
    max-height: 6px !important;
  }
  .mh-sm-7px {
    max-height: 7px !important;
  }
  .mh-sm-8px {
    max-height: 8px !important;
  }
  .mh-sm-9px {
    max-height: 9px !important;
  }
  .mh-sm-10px {
    max-height: 10px !important;
  }
  .mh-sm-15px {
    max-height: 15px !important;
  }
  .mh-sm-20px {
    max-height: 20px !important;
  }
  .mh-sm-25px {
    max-height: 25px !important;
  }
  .mh-sm-30px {
    max-height: 30px !important;
  }
  .mh-sm-35px {
    max-height: 35px !important;
  }
  .mh-sm-40px {
    max-height: 40px !important;
  }
  .mh-sm-45px {
    max-height: 45px !important;
  }
  .mh-sm-50px {
    max-height: 50px !important;
  }
  .mh-sm-55px {
    max-height: 55px !important;
  }
  .mh-sm-60px {
    max-height: 60px !important;
  }
  .mh-sm-65px {
    max-height: 65px !important;
  }
  .mh-sm-70px {
    max-height: 70px !important;
  }
  .mh-sm-75px {
    max-height: 75px !important;
  }
  .mh-sm-80px {
    max-height: 80px !important;
  }
  .mh-sm-85px {
    max-height: 85px !important;
  }
  .mh-sm-90px {
    max-height: 90px !important;
  }
  .mh-sm-95px {
    max-height: 95px !important;
  }
  .mh-sm-100px {
    max-height: 100px !important;
  }
  .mh-sm-125px {
    max-height: 125px !important;
  }
  .mh-sm-150px {
    max-height: 150px !important;
  }
  .mh-sm-175px {
    max-height: 175px !important;
  }
  .mh-sm-200px {
    max-height: 200px !important;
  }
  .mh-sm-225px {
    max-height: 225px !important;
  }
  .mh-sm-250px {
    max-height: 250px !important;
  }
  .mh-sm-275px {
    max-height: 275px !important;
  }
  .mh-sm-300px {
    max-height: 300px !important;
  }
  .mh-sm-325px {
    max-height: 325px !important;
  }
  .mh-sm-350px {
    max-height: 350px !important;
  }
  .mh-sm-375px {
    max-height: 375px !important;
  }
  .mh-sm-400px {
    max-height: 400px !important;
  }
  .mh-sm-425px {
    max-height: 425px !important;
  }
  .mh-sm-450px {
    max-height: 450px !important;
  }
  .mh-sm-475px {
    max-height: 475px !important;
  }
  .mh-sm-500px {
    max-height: 500px !important;
  }
  .mh-sm-550px {
    max-height: 550px !important;
  }
  .mh-sm-600px {
    max-height: 600px !important;
  }
  .mh-sm-650px {
    max-height: 650px !important;
  }
  .mh-sm-700px {
    max-height: 700px !important;
  }
  .mh-sm-750px {
    max-height: 750px !important;
  }
  .mh-sm-800px {
    max-height: 800px !important;
  }
  .mh-sm-850px {
    max-height: 850px !important;
  }
  .mh-sm-900px {
    max-height: 900px !important;
  }
  .mh-sm-950px {
    max-height: 950px !important;
  }
  .mh-sm-1000px {
    max-height: 1000px !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 0.75rem !important;
  }
  .m-sm-4 {
    margin: 1rem !important;
  }
  .m-sm-5 {
    margin: 1.25rem !important;
  }
  .m-sm-6 {
    margin: 1.5rem !important;
  }
  .m-sm-7 {
    margin: 1.75rem !important;
  }
  .m-sm-8 {
    margin: 2rem !important;
  }
  .m-sm-9 {
    margin: 2.25rem !important;
  }
  .m-sm-10 {
    margin: 2.5rem !important;
  }
  .m-sm-11 {
    margin: 2.75rem !important;
  }
  .m-sm-12 {
    margin: 3rem !important;
  }
  .m-sm-13 {
    margin: 3.25rem !important;
  }
  .m-sm-14 {
    margin: 3.5rem !important;
  }
  .m-sm-15 {
    margin: 3.75rem !important;
  }
  .m-sm-16 {
    margin: 4rem !important;
  }
  .m-sm-17 {
    margin: 4.25rem !important;
  }
  .m-sm-18 {
    margin: 4.5rem !important;
  }
  .m-sm-19 {
    margin: 4.75rem !important;
  }
  .m-sm-20 {
    margin: 5rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-sm-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-sm-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-sm-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-sm-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-sm-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-sm-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-sm-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-sm-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-sm-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-sm-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-sm-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-sm-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-sm-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-sm-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-sm-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-sm-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-sm-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-sm-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-sm-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-sm-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-sm-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-sm-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-sm-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-sm-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-sm-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-sm-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-sm-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-sm-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 0.75rem !important;
  }
  .mt-sm-4 {
    margin-top: 1rem !important;
  }
  .mt-sm-5 {
    margin-top: 1.25rem !important;
  }
  .mt-sm-6 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-7 {
    margin-top: 1.75rem !important;
  }
  .mt-sm-8 {
    margin-top: 2rem !important;
  }
  .mt-sm-9 {
    margin-top: 2.25rem !important;
  }
  .mt-sm-10 {
    margin-top: 2.5rem !important;
  }
  .mt-sm-11 {
    margin-top: 2.75rem !important;
  }
  .mt-sm-12 {
    margin-top: 3rem !important;
  }
  .mt-sm-13 {
    margin-top: 3.25rem !important;
  }
  .mt-sm-14 {
    margin-top: 3.5rem !important;
  }
  .mt-sm-15 {
    margin-top: 3.75rem !important;
  }
  .mt-sm-16 {
    margin-top: 4rem !important;
  }
  .mt-sm-17 {
    margin-top: 4.25rem !important;
  }
  .mt-sm-18 {
    margin-top: 4.5rem !important;
  }
  .mt-sm-19 {
    margin-top: 4.75rem !important;
  }
  .mt-sm-20 {
    margin-top: 5rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 0.75rem !important;
  }
  .me-sm-4 {
    margin-right: 1rem !important;
  }
  .me-sm-5 {
    margin-right: 1.25rem !important;
  }
  .me-sm-6 {
    margin-right: 1.5rem !important;
  }
  .me-sm-7 {
    margin-right: 1.75rem !important;
  }
  .me-sm-8 {
    margin-right: 2rem !important;
  }
  .me-sm-9 {
    margin-right: 2.25rem !important;
  }
  .me-sm-10 {
    margin-right: 2.5rem !important;
  }
  .me-sm-11 {
    margin-right: 2.75rem !important;
  }
  .me-sm-12 {
    margin-right: 3rem !important;
  }
  .me-sm-13 {
    margin-right: 3.25rem !important;
  }
  .me-sm-14 {
    margin-right: 3.5rem !important;
  }
  .me-sm-15 {
    margin-right: 3.75rem !important;
  }
  .me-sm-16 {
    margin-right: 4rem !important;
  }
  .me-sm-17 {
    margin-right: 4.25rem !important;
  }
  .me-sm-18 {
    margin-right: 4.5rem !important;
  }
  .me-sm-19 {
    margin-right: 4.75rem !important;
  }
  .me-sm-20 {
    margin-right: 5rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-sm-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-sm-8 {
    margin-bottom: 2rem !important;
  }
  .mb-sm-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-sm-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-sm-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-sm-12 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-sm-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-sm-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-sm-16 {
    margin-bottom: 4rem !important;
  }
  .mb-sm-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-sm-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-sm-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-sm-20 {
    margin-bottom: 5rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 0.75rem !important;
  }
  .ms-sm-4 {
    margin-left: 1rem !important;
  }
  .ms-sm-5 {
    margin-left: 1.25rem !important;
  }
  .ms-sm-6 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-7 {
    margin-left: 1.75rem !important;
  }
  .ms-sm-8 {
    margin-left: 2rem !important;
  }
  .ms-sm-9 {
    margin-left: 2.25rem !important;
  }
  .ms-sm-10 {
    margin-left: 2.5rem !important;
  }
  .ms-sm-11 {
    margin-left: 2.75rem !important;
  }
  .ms-sm-12 {
    margin-left: 3rem !important;
  }
  .ms-sm-13 {
    margin-left: 3.25rem !important;
  }
  .ms-sm-14 {
    margin-left: 3.5rem !important;
  }
  .ms-sm-15 {
    margin-left: 3.75rem !important;
  }
  .ms-sm-16 {
    margin-left: 4rem !important;
  }
  .ms-sm-17 {
    margin-left: 4.25rem !important;
  }
  .ms-sm-18 {
    margin-left: 4.5rem !important;
  }
  .ms-sm-19 {
    margin-left: 4.75rem !important;
  }
  .ms-sm-20 {
    margin-left: 5rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -0.75rem !important;
  }
  .m-sm-n4 {
    margin: -1rem !important;
  }
  .m-sm-n5 {
    margin: -1.25rem !important;
  }
  .m-sm-n6 {
    margin: -1.5rem !important;
  }
  .m-sm-n7 {
    margin: -1.75rem !important;
  }
  .m-sm-n8 {
    margin: -2rem !important;
  }
  .m-sm-n9 {
    margin: -2.25rem !important;
  }
  .m-sm-n10 {
    margin: -2.5rem !important;
  }
  .m-sm-n11 {
    margin: -2.75rem !important;
  }
  .m-sm-n12 {
    margin: -3rem !important;
  }
  .m-sm-n13 {
    margin: -3.25rem !important;
  }
  .m-sm-n14 {
    margin: -3.5rem !important;
  }
  .m-sm-n15 {
    margin: -3.75rem !important;
  }
  .m-sm-n16 {
    margin: -4rem !important;
  }
  .m-sm-n17 {
    margin: -4.25rem !important;
  }
  .m-sm-n18 {
    margin: -4.5rem !important;
  }
  .m-sm-n19 {
    margin: -4.75rem !important;
  }
  .m-sm-n20 {
    margin: -5rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-sm-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-sm-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-sm-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-sm-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-sm-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-sm-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-sm-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-sm-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-sm-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-sm-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-sm-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-sm-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-sm-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-sm-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-sm-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-sm-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-sm-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-sm-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-sm-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-sm-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-sm-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-sm-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-sm-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-sm-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-sm-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-sm-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-sm-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-sm-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-sm-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1rem !important;
  }
  .mt-sm-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-sm-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-sm-n8 {
    margin-top: -2rem !important;
  }
  .mt-sm-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-sm-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-sm-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-sm-n12 {
    margin-top: -3rem !important;
  }
  .mt-sm-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-sm-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-sm-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-sm-n16 {
    margin-top: -4rem !important;
  }
  .mt-sm-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-sm-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-sm-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-sm-n20 {
    margin-top: -5rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -0.75rem !important;
  }
  .me-sm-n4 {
    margin-right: -1rem !important;
  }
  .me-sm-n5 {
    margin-right: -1.25rem !important;
  }
  .me-sm-n6 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n7 {
    margin-right: -1.75rem !important;
  }
  .me-sm-n8 {
    margin-right: -2rem !important;
  }
  .me-sm-n9 {
    margin-right: -2.25rem !important;
  }
  .me-sm-n10 {
    margin-right: -2.5rem !important;
  }
  .me-sm-n11 {
    margin-right: -2.75rem !important;
  }
  .me-sm-n12 {
    margin-right: -3rem !important;
  }
  .me-sm-n13 {
    margin-right: -3.25rem !important;
  }
  .me-sm-n14 {
    margin-right: -3.5rem !important;
  }
  .me-sm-n15 {
    margin-right: -3.75rem !important;
  }
  .me-sm-n16 {
    margin-right: -4rem !important;
  }
  .me-sm-n17 {
    margin-right: -4.25rem !important;
  }
  .me-sm-n18 {
    margin-right: -4.5rem !important;
  }
  .me-sm-n19 {
    margin-right: -4.75rem !important;
  }
  .me-sm-n20 {
    margin-right: -5rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-sm-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-sm-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-sm-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-sm-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-sm-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-sm-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-sm-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-sm-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-sm-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-sm-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-sm-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-sm-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-sm-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-sm-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1rem !important;
  }
  .ms-sm-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-sm-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-sm-n8 {
    margin-left: -2rem !important;
  }
  .ms-sm-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-sm-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-sm-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-sm-n12 {
    margin-left: -3rem !important;
  }
  .ms-sm-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-sm-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-sm-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-sm-n16 {
    margin-left: -4rem !important;
  }
  .ms-sm-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-sm-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-sm-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-sm-n20 {
    margin-left: -5rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 0.75rem !important;
  }
  .p-sm-4 {
    padding: 1rem !important;
  }
  .p-sm-5 {
    padding: 1.25rem !important;
  }
  .p-sm-6 {
    padding: 1.5rem !important;
  }
  .p-sm-7 {
    padding: 1.75rem !important;
  }
  .p-sm-8 {
    padding: 2rem !important;
  }
  .p-sm-9 {
    padding: 2.25rem !important;
  }
  .p-sm-10 {
    padding: 2.5rem !important;
  }
  .p-sm-11 {
    padding: 2.75rem !important;
  }
  .p-sm-12 {
    padding: 3rem !important;
  }
  .p-sm-13 {
    padding: 3.25rem !important;
  }
  .p-sm-14 {
    padding: 3.5rem !important;
  }
  .p-sm-15 {
    padding: 3.75rem !important;
  }
  .p-sm-16 {
    padding: 4rem !important;
  }
  .p-sm-17 {
    padding: 4.25rem !important;
  }
  .p-sm-18 {
    padding: 4.5rem !important;
  }
  .p-sm-19 {
    padding: 4.75rem !important;
  }
  .p-sm-20 {
    padding: 5rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-sm-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-sm-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-sm-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-sm-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-sm-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-sm-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-sm-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-sm-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-sm-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-sm-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-sm-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-sm-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-sm-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-sm-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-sm-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-sm-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-sm-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-sm-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-sm-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-sm-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-sm-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-sm-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-sm-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-sm-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-sm-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-sm-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-sm-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-sm-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-sm-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-sm-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 0.75rem !important;
  }
  .pt-sm-4 {
    padding-top: 1rem !important;
  }
  .pt-sm-5 {
    padding-top: 1.25rem !important;
  }
  .pt-sm-6 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-7 {
    padding-top: 1.75rem !important;
  }
  .pt-sm-8 {
    padding-top: 2rem !important;
  }
  .pt-sm-9 {
    padding-top: 2.25rem !important;
  }
  .pt-sm-10 {
    padding-top: 2.5rem !important;
  }
  .pt-sm-11 {
    padding-top: 2.75rem !important;
  }
  .pt-sm-12 {
    padding-top: 3rem !important;
  }
  .pt-sm-13 {
    padding-top: 3.25rem !important;
  }
  .pt-sm-14 {
    padding-top: 3.5rem !important;
  }
  .pt-sm-15 {
    padding-top: 3.75rem !important;
  }
  .pt-sm-16 {
    padding-top: 4rem !important;
  }
  .pt-sm-17 {
    padding-top: 4.25rem !important;
  }
  .pt-sm-18 {
    padding-top: 4.5rem !important;
  }
  .pt-sm-19 {
    padding-top: 4.75rem !important;
  }
  .pt-sm-20 {
    padding-top: 5rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 0.75rem !important;
  }
  .pe-sm-4 {
    padding-right: 1rem !important;
  }
  .pe-sm-5 {
    padding-right: 1.25rem !important;
  }
  .pe-sm-6 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-7 {
    padding-right: 1.75rem !important;
  }
  .pe-sm-8 {
    padding-right: 2rem !important;
  }
  .pe-sm-9 {
    padding-right: 2.25rem !important;
  }
  .pe-sm-10 {
    padding-right: 2.5rem !important;
  }
  .pe-sm-11 {
    padding-right: 2.75rem !important;
  }
  .pe-sm-12 {
    padding-right: 3rem !important;
  }
  .pe-sm-13 {
    padding-right: 3.25rem !important;
  }
  .pe-sm-14 {
    padding-right: 3.5rem !important;
  }
  .pe-sm-15 {
    padding-right: 3.75rem !important;
  }
  .pe-sm-16 {
    padding-right: 4rem !important;
  }
  .pe-sm-17 {
    padding-right: 4.25rem !important;
  }
  .pe-sm-18 {
    padding-right: 4.5rem !important;
  }
  .pe-sm-19 {
    padding-right: 4.75rem !important;
  }
  .pe-sm-20 {
    padding-right: 5rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-sm-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-sm-8 {
    padding-bottom: 2rem !important;
  }
  .pb-sm-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-sm-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-sm-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-sm-12 {
    padding-bottom: 3rem !important;
  }
  .pb-sm-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-sm-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-sm-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-sm-16 {
    padding-bottom: 4rem !important;
  }
  .pb-sm-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-sm-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-sm-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-sm-20 {
    padding-bottom: 5rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 0.75rem !important;
  }
  .ps-sm-4 {
    padding-left: 1rem !important;
  }
  .ps-sm-5 {
    padding-left: 1.25rem !important;
  }
  .ps-sm-6 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-7 {
    padding-left: 1.75rem !important;
  }
  .ps-sm-8 {
    padding-left: 2rem !important;
  }
  .ps-sm-9 {
    padding-left: 2.25rem !important;
  }
  .ps-sm-10 {
    padding-left: 2.5rem !important;
  }
  .ps-sm-11 {
    padding-left: 2.75rem !important;
  }
  .ps-sm-12 {
    padding-left: 3rem !important;
  }
  .ps-sm-13 {
    padding-left: 3.25rem !important;
  }
  .ps-sm-14 {
    padding-left: 3.5rem !important;
  }
  .ps-sm-15 {
    padding-left: 3.75rem !important;
  }
  .ps-sm-16 {
    padding-left: 4rem !important;
  }
  .ps-sm-17 {
    padding-left: 4.25rem !important;
  }
  .ps-sm-18 {
    padding-left: 4.5rem !important;
  }
  .ps-sm-19 {
    padding-left: 4.75rem !important;
  }
  .ps-sm-20 {
    padding-left: 5rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 0.75rem !important;
  }
  .gap-sm-4 {
    gap: 1rem !important;
  }
  .gap-sm-5 {
    gap: 1.25rem !important;
  }
  .gap-sm-6 {
    gap: 1.5rem !important;
  }
  .gap-sm-7 {
    gap: 1.75rem !important;
  }
  .gap-sm-8 {
    gap: 2rem !important;
  }
  .gap-sm-9 {
    gap: 2.25rem !important;
  }
  .gap-sm-10 {
    gap: 2.5rem !important;
  }
  .gap-sm-11 {
    gap: 2.75rem !important;
  }
  .gap-sm-12 {
    gap: 3rem !important;
  }
  .gap-sm-13 {
    gap: 3.25rem !important;
  }
  .gap-sm-14 {
    gap: 3.5rem !important;
  }
  .gap-sm-15 {
    gap: 3.75rem !important;
  }
  .gap-sm-16 {
    gap: 4rem !important;
  }
  .gap-sm-17 {
    gap: 4.25rem !important;
  }
  .gap-sm-18 {
    gap: 4.5rem !important;
  }
  .gap-sm-19 {
    gap: 4.75rem !important;
  }
  .gap-sm-20 {
    gap: 5rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-sm-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-sm-8 {
    row-gap: 2rem !important;
  }
  .row-gap-sm-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-sm-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-sm-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-sm-12 {
    row-gap: 3rem !important;
  }
  .row-gap-sm-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-sm-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-sm-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-sm-16 {
    row-gap: 4rem !important;
  }
  .row-gap-sm-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-sm-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-sm-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-sm-20 {
    row-gap: 5rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-sm-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-sm-8 {
    column-gap: 2rem !important;
  }
  .column-gap-sm-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-sm-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-sm-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-sm-12 {
    column-gap: 3rem !important;
  }
  .column-gap-sm-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-sm-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-sm-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-sm-16 {
    column-gap: 4rem !important;
  }
  .column-gap-sm-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-sm-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-sm-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-sm-20 {
    column-gap: 5rem !important;
  }
  .fs-sm-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-sm-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-sm-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-sm-4 {
    font-size: 1.25rem !important;
  }
  .fs-sm-5 {
    font-size: 1.15rem !important;
  }
  .fs-sm-6 {
    font-size: 1.075rem !important;
  }
  .fs-sm-7 {
    font-size: 0.95rem !important;
  }
  .fs-sm-8 {
    font-size: 0.85rem !important;
  }
  .fs-sm-9 {
    font-size: 0.75rem !important;
  }
  .fs-sm-10 {
    font-size: 0.5rem !important;
  }
  .fs-sm-sm {
    font-size: 0.95rem !important;
  }
  .fs-sm-base {
    font-size: 1rem !important;
  }
  .fs-sm-lg {
    font-size: 1.075rem !important;
  }
  .fs-sm-xl {
    font-size: 1.21rem !important;
  }
  .fs-sm-fluid {
    font-size: 100% !important;
  }
  .fs-sm-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-sm-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-sm-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-sm-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-sm-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-sm-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-sm-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-sm-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-sm-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-sm-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-sm-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-sm-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-sm-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-sm-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-sm-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-sm-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-sm-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-sm-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-sm-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-sm-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-sm-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-sm-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-sm-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-sm-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
  .min-w-sm-unset {
    min-width: unset !important;
  }
  .min-w-sm-25 {
    min-width: 25% !important;
  }
  .min-w-sm-50 {
    min-width: 50% !important;
  }
  .min-w-sm-75 {
    min-width: 75% !important;
  }
  .min-w-sm-100 {
    min-width: 100% !important;
  }
  .min-w-sm-auto {
    min-width: auto !important;
  }
  .min-w-sm-1px {
    min-width: 1px !important;
  }
  .min-w-sm-2px {
    min-width: 2px !important;
  }
  .min-w-sm-3px {
    min-width: 3px !important;
  }
  .min-w-sm-4px {
    min-width: 4px !important;
  }
  .min-w-sm-5px {
    min-width: 5px !important;
  }
  .min-w-sm-6px {
    min-width: 6px !important;
  }
  .min-w-sm-7px {
    min-width: 7px !important;
  }
  .min-w-sm-8px {
    min-width: 8px !important;
  }
  .min-w-sm-9px {
    min-width: 9px !important;
  }
  .min-w-sm-10px {
    min-width: 10px !important;
  }
  .min-w-sm-15px {
    min-width: 15px !important;
  }
  .min-w-sm-20px {
    min-width: 20px !important;
  }
  .min-w-sm-25px {
    min-width: 25px !important;
  }
  .min-w-sm-30px {
    min-width: 30px !important;
  }
  .min-w-sm-35px {
    min-width: 35px !important;
  }
  .min-w-sm-40px {
    min-width: 40px !important;
  }
  .min-w-sm-45px {
    min-width: 45px !important;
  }
  .min-w-sm-50px {
    min-width: 50px !important;
  }
  .min-w-sm-55px {
    min-width: 55px !important;
  }
  .min-w-sm-60px {
    min-width: 60px !important;
  }
  .min-w-sm-65px {
    min-width: 65px !important;
  }
  .min-w-sm-70px {
    min-width: 70px !important;
  }
  .min-w-sm-75px {
    min-width: 75px !important;
  }
  .min-w-sm-80px {
    min-width: 80px !important;
  }
  .min-w-sm-85px {
    min-width: 85px !important;
  }
  .min-w-sm-90px {
    min-width: 90px !important;
  }
  .min-w-sm-95px {
    min-width: 95px !important;
  }
  .min-w-sm-100px {
    min-width: 100px !important;
  }
  .min-w-sm-125px {
    min-width: 125px !important;
  }
  .min-w-sm-150px {
    min-width: 150px !important;
  }
  .min-w-sm-175px {
    min-width: 175px !important;
  }
  .min-w-sm-200px {
    min-width: 200px !important;
  }
  .min-w-sm-225px {
    min-width: 225px !important;
  }
  .min-w-sm-250px {
    min-width: 250px !important;
  }
  .min-w-sm-275px {
    min-width: 275px !important;
  }
  .min-w-sm-300px {
    min-width: 300px !important;
  }
  .min-w-sm-325px {
    min-width: 325px !important;
  }
  .min-w-sm-350px {
    min-width: 350px !important;
  }
  .min-w-sm-375px {
    min-width: 375px !important;
  }
  .min-w-sm-400px {
    min-width: 400px !important;
  }
  .min-w-sm-425px {
    min-width: 425px !important;
  }
  .min-w-sm-450px {
    min-width: 450px !important;
  }
  .min-w-sm-475px {
    min-width: 475px !important;
  }
  .min-w-sm-500px {
    min-width: 500px !important;
  }
  .min-w-sm-550px {
    min-width: 550px !important;
  }
  .min-w-sm-600px {
    min-width: 600px !important;
  }
  .min-w-sm-650px {
    min-width: 650px !important;
  }
  .min-w-sm-700px {
    min-width: 700px !important;
  }
  .min-w-sm-750px {
    min-width: 750px !important;
  }
  .min-w-sm-800px {
    min-width: 800px !important;
  }
  .min-w-sm-850px {
    min-width: 850px !important;
  }
  .min-w-sm-900px {
    min-width: 900px !important;
  }
  .min-w-sm-950px {
    min-width: 950px !important;
  }
  .min-w-sm-1000px {
    min-width: 1000px !important;
  }
  .min-h-sm-unset {
    min-height: unset !important;
  }
  .min-h-sm-25 {
    min-height: 25% !important;
  }
  .min-h-sm-50 {
    min-height: 50% !important;
  }
  .min-h-sm-75 {
    min-height: 75% !important;
  }
  .min-h-sm-100 {
    min-height: 100% !important;
  }
  .min-h-sm-auto {
    min-height: auto !important;
  }
  .min-h-sm-1px {
    min-height: 1px !important;
  }
  .min-h-sm-2px {
    min-height: 2px !important;
  }
  .min-h-sm-3px {
    min-height: 3px !important;
  }
  .min-h-sm-4px {
    min-height: 4px !important;
  }
  .min-h-sm-5px {
    min-height: 5px !important;
  }
  .min-h-sm-6px {
    min-height: 6px !important;
  }
  .min-h-sm-7px {
    min-height: 7px !important;
  }
  .min-h-sm-8px {
    min-height: 8px !important;
  }
  .min-h-sm-9px {
    min-height: 9px !important;
  }
  .min-h-sm-10px {
    min-height: 10px !important;
  }
  .min-h-sm-15px {
    min-height: 15px !important;
  }
  .min-h-sm-20px {
    min-height: 20px !important;
  }
  .min-h-sm-25px {
    min-height: 25px !important;
  }
  .min-h-sm-30px {
    min-height: 30px !important;
  }
  .min-h-sm-35px {
    min-height: 35px !important;
  }
  .min-h-sm-40px {
    min-height: 40px !important;
  }
  .min-h-sm-45px {
    min-height: 45px !important;
  }
  .min-h-sm-50px {
    min-height: 50px !important;
  }
  .min-h-sm-55px {
    min-height: 55px !important;
  }
  .min-h-sm-60px {
    min-height: 60px !important;
  }
  .min-h-sm-65px {
    min-height: 65px !important;
  }
  .min-h-sm-70px {
    min-height: 70px !important;
  }
  .min-h-sm-75px {
    min-height: 75px !important;
  }
  .min-h-sm-80px {
    min-height: 80px !important;
  }
  .min-h-sm-85px {
    min-height: 85px !important;
  }
  .min-h-sm-90px {
    min-height: 90px !important;
  }
  .min-h-sm-95px {
    min-height: 95px !important;
  }
  .min-h-sm-100px {
    min-height: 100px !important;
  }
  .min-h-sm-125px {
    min-height: 125px !important;
  }
  .min-h-sm-150px {
    min-height: 150px !important;
  }
  .min-h-sm-175px {
    min-height: 175px !important;
  }
  .min-h-sm-200px {
    min-height: 200px !important;
  }
  .min-h-sm-225px {
    min-height: 225px !important;
  }
  .min-h-sm-250px {
    min-height: 250px !important;
  }
  .min-h-sm-275px {
    min-height: 275px !important;
  }
  .min-h-sm-300px {
    min-height: 300px !important;
  }
  .min-h-sm-325px {
    min-height: 325px !important;
  }
  .min-h-sm-350px {
    min-height: 350px !important;
  }
  .min-h-sm-375px {
    min-height: 375px !important;
  }
  .min-h-sm-400px {
    min-height: 400px !important;
  }
  .min-h-sm-425px {
    min-height: 425px !important;
  }
  .min-h-sm-450px {
    min-height: 450px !important;
  }
  .min-h-sm-475px {
    min-height: 475px !important;
  }
  .min-h-sm-500px {
    min-height: 500px !important;
  }
  .min-h-sm-550px {
    min-height: 550px !important;
  }
  .min-h-sm-600px {
    min-height: 600px !important;
  }
  .min-h-sm-650px {
    min-height: 650px !important;
  }
  .min-h-sm-700px {
    min-height: 700px !important;
  }
  .min-h-sm-750px {
    min-height: 750px !important;
  }
  .min-h-sm-800px {
    min-height: 800px !important;
  }
  .min-h-sm-850px {
    min-height: 850px !important;
  }
  .min-h-sm-900px {
    min-height: 900px !important;
  }
  .min-h-sm-950px {
    min-height: 950px !important;
  }
  .min-h-sm-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .overflow-md-auto {
    overflow: auto !important;
  }
  .overflow-md-hidden {
    overflow: hidden !important;
  }
  .overflow-md-visible {
    overflow: visible !important;
  }
  .overflow-md-scroll {
    overflow: scroll !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .position-md-static {
    position: static !important;
  }
  .position-md-relative {
    position: relative !important;
  }
  .position-md-absolute {
    position: absolute !important;
  }
  .position-md-fixed {
    position: fixed !important;
  }
  .position-md-sticky {
    position: sticky !important;
  }
  .w-md-unset {
    width: unset !important;
  }
  .w-md-25 {
    width: 25% !important;
  }
  .w-md-50 {
    width: 50% !important;
  }
  .w-md-75 {
    width: 75% !important;
  }
  .w-md-100 {
    width: 100% !important;
  }
  .w-md-auto {
    width: auto !important;
  }
  .w-md-1px {
    width: 1px !important;
  }
  .w-md-2px {
    width: 2px !important;
  }
  .w-md-3px {
    width: 3px !important;
  }
  .w-md-4px {
    width: 4px !important;
  }
  .w-md-5px {
    width: 5px !important;
  }
  .w-md-6px {
    width: 6px !important;
  }
  .w-md-7px {
    width: 7px !important;
  }
  .w-md-8px {
    width: 8px !important;
  }
  .w-md-9px {
    width: 9px !important;
  }
  .w-md-10px {
    width: 10px !important;
  }
  .w-md-15px {
    width: 15px !important;
  }
  .w-md-20px {
    width: 20px !important;
  }
  .w-md-25px {
    width: 25px !important;
  }
  .w-md-30px {
    width: 30px !important;
  }
  .w-md-35px {
    width: 35px !important;
  }
  .w-md-40px {
    width: 40px !important;
  }
  .w-md-45px {
    width: 45px !important;
  }
  .w-md-50px {
    width: 50px !important;
  }
  .w-md-55px {
    width: 55px !important;
  }
  .w-md-60px {
    width: 60px !important;
  }
  .w-md-65px {
    width: 65px !important;
  }
  .w-md-70px {
    width: 70px !important;
  }
  .w-md-75px {
    width: 75px !important;
  }
  .w-md-80px {
    width: 80px !important;
  }
  .w-md-85px {
    width: 85px !important;
  }
  .w-md-90px {
    width: 90px !important;
  }
  .w-md-95px {
    width: 95px !important;
  }
  .w-md-100px {
    width: 100px !important;
  }
  .w-md-125px {
    width: 125px !important;
  }
  .w-md-150px {
    width: 150px !important;
  }
  .w-md-175px {
    width: 175px !important;
  }
  .w-md-200px {
    width: 200px !important;
  }
  .w-md-225px {
    width: 225px !important;
  }
  .w-md-250px {
    width: 250px !important;
  }
  .w-md-275px {
    width: 275px !important;
  }
  .w-md-300px {
    width: 300px !important;
  }
  .w-md-325px {
    width: 325px !important;
  }
  .w-md-350px {
    width: 350px !important;
  }
  .w-md-375px {
    width: 375px !important;
  }
  .w-md-400px {
    width: 400px !important;
  }
  .w-md-425px {
    width: 425px !important;
  }
  .w-md-450px {
    width: 450px !important;
  }
  .w-md-475px {
    width: 475px !important;
  }
  .w-md-500px {
    width: 500px !important;
  }
  .w-md-550px {
    width: 550px !important;
  }
  .w-md-600px {
    width: 600px !important;
  }
  .w-md-650px {
    width: 650px !important;
  }
  .w-md-700px {
    width: 700px !important;
  }
  .w-md-750px {
    width: 750px !important;
  }
  .w-md-800px {
    width: 800px !important;
  }
  .w-md-850px {
    width: 850px !important;
  }
  .w-md-900px {
    width: 900px !important;
  }
  .w-md-950px {
    width: 950px !important;
  }
  .w-md-1000px {
    width: 1000px !important;
  }
  .mw-md-unset {
    max-width: unset !important;
  }
  .mw-md-25 {
    max-width: 25% !important;
  }
  .mw-md-50 {
    max-width: 50% !important;
  }
  .mw-md-75 {
    max-width: 75% !important;
  }
  .mw-md-100 {
    max-width: 100% !important;
  }
  .mw-md-auto {
    max-width: auto !important;
  }
  .mw-md-1px {
    max-width: 1px !important;
  }
  .mw-md-2px {
    max-width: 2px !important;
  }
  .mw-md-3px {
    max-width: 3px !important;
  }
  .mw-md-4px {
    max-width: 4px !important;
  }
  .mw-md-5px {
    max-width: 5px !important;
  }
  .mw-md-6px {
    max-width: 6px !important;
  }
  .mw-md-7px {
    max-width: 7px !important;
  }
  .mw-md-8px {
    max-width: 8px !important;
  }
  .mw-md-9px {
    max-width: 9px !important;
  }
  .mw-md-10px {
    max-width: 10px !important;
  }
  .mw-md-15px {
    max-width: 15px !important;
  }
  .mw-md-20px {
    max-width: 20px !important;
  }
  .mw-md-25px {
    max-width: 25px !important;
  }
  .mw-md-30px {
    max-width: 30px !important;
  }
  .mw-md-35px {
    max-width: 35px !important;
  }
  .mw-md-40px {
    max-width: 40px !important;
  }
  .mw-md-45px {
    max-width: 45px !important;
  }
  .mw-md-50px {
    max-width: 50px !important;
  }
  .mw-md-55px {
    max-width: 55px !important;
  }
  .mw-md-60px {
    max-width: 60px !important;
  }
  .mw-md-65px {
    max-width: 65px !important;
  }
  .mw-md-70px {
    max-width: 70px !important;
  }
  .mw-md-75px {
    max-width: 75px !important;
  }
  .mw-md-80px {
    max-width: 80px !important;
  }
  .mw-md-85px {
    max-width: 85px !important;
  }
  .mw-md-90px {
    max-width: 90px !important;
  }
  .mw-md-95px {
    max-width: 95px !important;
  }
  .mw-md-100px {
    max-width: 100px !important;
  }
  .mw-md-125px {
    max-width: 125px !important;
  }
  .mw-md-150px {
    max-width: 150px !important;
  }
  .mw-md-175px {
    max-width: 175px !important;
  }
  .mw-md-200px {
    max-width: 200px !important;
  }
  .mw-md-225px {
    max-width: 225px !important;
  }
  .mw-md-250px {
    max-width: 250px !important;
  }
  .mw-md-275px {
    max-width: 275px !important;
  }
  .mw-md-300px {
    max-width: 300px !important;
  }
  .mw-md-325px {
    max-width: 325px !important;
  }
  .mw-md-350px {
    max-width: 350px !important;
  }
  .mw-md-375px {
    max-width: 375px !important;
  }
  .mw-md-400px {
    max-width: 400px !important;
  }
  .mw-md-425px {
    max-width: 425px !important;
  }
  .mw-md-450px {
    max-width: 450px !important;
  }
  .mw-md-475px {
    max-width: 475px !important;
  }
  .mw-md-500px {
    max-width: 500px !important;
  }
  .mw-md-550px {
    max-width: 550px !important;
  }
  .mw-md-600px {
    max-width: 600px !important;
  }
  .mw-md-650px {
    max-width: 650px !important;
  }
  .mw-md-700px {
    max-width: 700px !important;
  }
  .mw-md-750px {
    max-width: 750px !important;
  }
  .mw-md-800px {
    max-width: 800px !important;
  }
  .mw-md-850px {
    max-width: 850px !important;
  }
  .mw-md-900px {
    max-width: 900px !important;
  }
  .mw-md-950px {
    max-width: 950px !important;
  }
  .mw-md-1000px {
    max-width: 1000px !important;
  }
  .h-md-unset {
    height: unset !important;
  }
  .h-md-25 {
    height: 25% !important;
  }
  .h-md-50 {
    height: 50% !important;
  }
  .h-md-75 {
    height: 75% !important;
  }
  .h-md-100 {
    height: 100% !important;
  }
  .h-md-auto {
    height: auto !important;
  }
  .h-md-1px {
    height: 1px !important;
  }
  .h-md-2px {
    height: 2px !important;
  }
  .h-md-3px {
    height: 3px !important;
  }
  .h-md-4px {
    height: 4px !important;
  }
  .h-md-5px {
    height: 5px !important;
  }
  .h-md-6px {
    height: 6px !important;
  }
  .h-md-7px {
    height: 7px !important;
  }
  .h-md-8px {
    height: 8px !important;
  }
  .h-md-9px {
    height: 9px !important;
  }
  .h-md-10px {
    height: 10px !important;
  }
  .h-md-15px {
    height: 15px !important;
  }
  .h-md-20px {
    height: 20px !important;
  }
  .h-md-25px {
    height: 25px !important;
  }
  .h-md-30px {
    height: 30px !important;
  }
  .h-md-35px {
    height: 35px !important;
  }
  .h-md-40px {
    height: 40px !important;
  }
  .h-md-45px {
    height: 45px !important;
  }
  .h-md-50px {
    height: 50px !important;
  }
  .h-md-55px {
    height: 55px !important;
  }
  .h-md-60px {
    height: 60px !important;
  }
  .h-md-65px {
    height: 65px !important;
  }
  .h-md-70px {
    height: 70px !important;
  }
  .h-md-75px {
    height: 75px !important;
  }
  .h-md-80px {
    height: 80px !important;
  }
  .h-md-85px {
    height: 85px !important;
  }
  .h-md-90px {
    height: 90px !important;
  }
  .h-md-95px {
    height: 95px !important;
  }
  .h-md-100px {
    height: 100px !important;
  }
  .h-md-125px {
    height: 125px !important;
  }
  .h-md-150px {
    height: 150px !important;
  }
  .h-md-175px {
    height: 175px !important;
  }
  .h-md-200px {
    height: 200px !important;
  }
  .h-md-225px {
    height: 225px !important;
  }
  .h-md-250px {
    height: 250px !important;
  }
  .h-md-275px {
    height: 275px !important;
  }
  .h-md-300px {
    height: 300px !important;
  }
  .h-md-325px {
    height: 325px !important;
  }
  .h-md-350px {
    height: 350px !important;
  }
  .h-md-375px {
    height: 375px !important;
  }
  .h-md-400px {
    height: 400px !important;
  }
  .h-md-425px {
    height: 425px !important;
  }
  .h-md-450px {
    height: 450px !important;
  }
  .h-md-475px {
    height: 475px !important;
  }
  .h-md-500px {
    height: 500px !important;
  }
  .h-md-550px {
    height: 550px !important;
  }
  .h-md-600px {
    height: 600px !important;
  }
  .h-md-650px {
    height: 650px !important;
  }
  .h-md-700px {
    height: 700px !important;
  }
  .h-md-750px {
    height: 750px !important;
  }
  .h-md-800px {
    height: 800px !important;
  }
  .h-md-850px {
    height: 850px !important;
  }
  .h-md-900px {
    height: 900px !important;
  }
  .h-md-950px {
    height: 950px !important;
  }
  .h-md-1000px {
    height: 1000px !important;
  }
  .mh-md-unset {
    max-height: unset !important;
  }
  .mh-md-25 {
    max-height: 25% !important;
  }
  .mh-md-50 {
    max-height: 50% !important;
  }
  .mh-md-75 {
    max-height: 75% !important;
  }
  .mh-md-100 {
    max-height: 100% !important;
  }
  .mh-md-auto {
    max-height: auto !important;
  }
  .mh-md-1px {
    max-height: 1px !important;
  }
  .mh-md-2px {
    max-height: 2px !important;
  }
  .mh-md-3px {
    max-height: 3px !important;
  }
  .mh-md-4px {
    max-height: 4px !important;
  }
  .mh-md-5px {
    max-height: 5px !important;
  }
  .mh-md-6px {
    max-height: 6px !important;
  }
  .mh-md-7px {
    max-height: 7px !important;
  }
  .mh-md-8px {
    max-height: 8px !important;
  }
  .mh-md-9px {
    max-height: 9px !important;
  }
  .mh-md-10px {
    max-height: 10px !important;
  }
  .mh-md-15px {
    max-height: 15px !important;
  }
  .mh-md-20px {
    max-height: 20px !important;
  }
  .mh-md-25px {
    max-height: 25px !important;
  }
  .mh-md-30px {
    max-height: 30px !important;
  }
  .mh-md-35px {
    max-height: 35px !important;
  }
  .mh-md-40px {
    max-height: 40px !important;
  }
  .mh-md-45px {
    max-height: 45px !important;
  }
  .mh-md-50px {
    max-height: 50px !important;
  }
  .mh-md-55px {
    max-height: 55px !important;
  }
  .mh-md-60px {
    max-height: 60px !important;
  }
  .mh-md-65px {
    max-height: 65px !important;
  }
  .mh-md-70px {
    max-height: 70px !important;
  }
  .mh-md-75px {
    max-height: 75px !important;
  }
  .mh-md-80px {
    max-height: 80px !important;
  }
  .mh-md-85px {
    max-height: 85px !important;
  }
  .mh-md-90px {
    max-height: 90px !important;
  }
  .mh-md-95px {
    max-height: 95px !important;
  }
  .mh-md-100px {
    max-height: 100px !important;
  }
  .mh-md-125px {
    max-height: 125px !important;
  }
  .mh-md-150px {
    max-height: 150px !important;
  }
  .mh-md-175px {
    max-height: 175px !important;
  }
  .mh-md-200px {
    max-height: 200px !important;
  }
  .mh-md-225px {
    max-height: 225px !important;
  }
  .mh-md-250px {
    max-height: 250px !important;
  }
  .mh-md-275px {
    max-height: 275px !important;
  }
  .mh-md-300px {
    max-height: 300px !important;
  }
  .mh-md-325px {
    max-height: 325px !important;
  }
  .mh-md-350px {
    max-height: 350px !important;
  }
  .mh-md-375px {
    max-height: 375px !important;
  }
  .mh-md-400px {
    max-height: 400px !important;
  }
  .mh-md-425px {
    max-height: 425px !important;
  }
  .mh-md-450px {
    max-height: 450px !important;
  }
  .mh-md-475px {
    max-height: 475px !important;
  }
  .mh-md-500px {
    max-height: 500px !important;
  }
  .mh-md-550px {
    max-height: 550px !important;
  }
  .mh-md-600px {
    max-height: 600px !important;
  }
  .mh-md-650px {
    max-height: 650px !important;
  }
  .mh-md-700px {
    max-height: 700px !important;
  }
  .mh-md-750px {
    max-height: 750px !important;
  }
  .mh-md-800px {
    max-height: 800px !important;
  }
  .mh-md-850px {
    max-height: 850px !important;
  }
  .mh-md-900px {
    max-height: 900px !important;
  }
  .mh-md-950px {
    max-height: 950px !important;
  }
  .mh-md-1000px {
    max-height: 1000px !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 0.75rem !important;
  }
  .m-md-4 {
    margin: 1rem !important;
  }
  .m-md-5 {
    margin: 1.25rem !important;
  }
  .m-md-6 {
    margin: 1.5rem !important;
  }
  .m-md-7 {
    margin: 1.75rem !important;
  }
  .m-md-8 {
    margin: 2rem !important;
  }
  .m-md-9 {
    margin: 2.25rem !important;
  }
  .m-md-10 {
    margin: 2.5rem !important;
  }
  .m-md-11 {
    margin: 2.75rem !important;
  }
  .m-md-12 {
    margin: 3rem !important;
  }
  .m-md-13 {
    margin: 3.25rem !important;
  }
  .m-md-14 {
    margin: 3.5rem !important;
  }
  .m-md-15 {
    margin: 3.75rem !important;
  }
  .m-md-16 {
    margin: 4rem !important;
  }
  .m-md-17 {
    margin: 4.25rem !important;
  }
  .m-md-18 {
    margin: 4.5rem !important;
  }
  .m-md-19 {
    margin: 4.75rem !important;
  }
  .m-md-20 {
    margin: 5rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-md-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-md-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-md-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-md-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-md-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-md-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-md-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-md-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-md-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-md-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-md-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-md-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-md-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-md-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-md-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-md-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-md-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-md-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-md-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-md-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-md-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-md-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-md-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-md-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-md-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-md-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-md-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-md-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 0.75rem !important;
  }
  .mt-md-4 {
    margin-top: 1rem !important;
  }
  .mt-md-5 {
    margin-top: 1.25rem !important;
  }
  .mt-md-6 {
    margin-top: 1.5rem !important;
  }
  .mt-md-7 {
    margin-top: 1.75rem !important;
  }
  .mt-md-8 {
    margin-top: 2rem !important;
  }
  .mt-md-9 {
    margin-top: 2.25rem !important;
  }
  .mt-md-10 {
    margin-top: 2.5rem !important;
  }
  .mt-md-11 {
    margin-top: 2.75rem !important;
  }
  .mt-md-12 {
    margin-top: 3rem !important;
  }
  .mt-md-13 {
    margin-top: 3.25rem !important;
  }
  .mt-md-14 {
    margin-top: 3.5rem !important;
  }
  .mt-md-15 {
    margin-top: 3.75rem !important;
  }
  .mt-md-16 {
    margin-top: 4rem !important;
  }
  .mt-md-17 {
    margin-top: 4.25rem !important;
  }
  .mt-md-18 {
    margin-top: 4.5rem !important;
  }
  .mt-md-19 {
    margin-top: 4.75rem !important;
  }
  .mt-md-20 {
    margin-top: 5rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 0.75rem !important;
  }
  .me-md-4 {
    margin-right: 1rem !important;
  }
  .me-md-5 {
    margin-right: 1.25rem !important;
  }
  .me-md-6 {
    margin-right: 1.5rem !important;
  }
  .me-md-7 {
    margin-right: 1.75rem !important;
  }
  .me-md-8 {
    margin-right: 2rem !important;
  }
  .me-md-9 {
    margin-right: 2.25rem !important;
  }
  .me-md-10 {
    margin-right: 2.5rem !important;
  }
  .me-md-11 {
    margin-right: 2.75rem !important;
  }
  .me-md-12 {
    margin-right: 3rem !important;
  }
  .me-md-13 {
    margin-right: 3.25rem !important;
  }
  .me-md-14 {
    margin-right: 3.5rem !important;
  }
  .me-md-15 {
    margin-right: 3.75rem !important;
  }
  .me-md-16 {
    margin-right: 4rem !important;
  }
  .me-md-17 {
    margin-right: 4.25rem !important;
  }
  .me-md-18 {
    margin-right: 4.5rem !important;
  }
  .me-md-19 {
    margin-right: 4.75rem !important;
  }
  .me-md-20 {
    margin-right: 5rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1rem !important;
  }
  .mb-md-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-md-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-md-8 {
    margin-bottom: 2rem !important;
  }
  .mb-md-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-md-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-md-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-md-12 {
    margin-bottom: 3rem !important;
  }
  .mb-md-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-md-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-md-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-md-16 {
    margin-bottom: 4rem !important;
  }
  .mb-md-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-md-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-md-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-md-20 {
    margin-bottom: 5rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 0.75rem !important;
  }
  .ms-md-4 {
    margin-left: 1rem !important;
  }
  .ms-md-5 {
    margin-left: 1.25rem !important;
  }
  .ms-md-6 {
    margin-left: 1.5rem !important;
  }
  .ms-md-7 {
    margin-left: 1.75rem !important;
  }
  .ms-md-8 {
    margin-left: 2rem !important;
  }
  .ms-md-9 {
    margin-left: 2.25rem !important;
  }
  .ms-md-10 {
    margin-left: 2.5rem !important;
  }
  .ms-md-11 {
    margin-left: 2.75rem !important;
  }
  .ms-md-12 {
    margin-left: 3rem !important;
  }
  .ms-md-13 {
    margin-left: 3.25rem !important;
  }
  .ms-md-14 {
    margin-left: 3.5rem !important;
  }
  .ms-md-15 {
    margin-left: 3.75rem !important;
  }
  .ms-md-16 {
    margin-left: 4rem !important;
  }
  .ms-md-17 {
    margin-left: 4.25rem !important;
  }
  .ms-md-18 {
    margin-left: 4.5rem !important;
  }
  .ms-md-19 {
    margin-left: 4.75rem !important;
  }
  .ms-md-20 {
    margin-left: 5rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -0.75rem !important;
  }
  .m-md-n4 {
    margin: -1rem !important;
  }
  .m-md-n5 {
    margin: -1.25rem !important;
  }
  .m-md-n6 {
    margin: -1.5rem !important;
  }
  .m-md-n7 {
    margin: -1.75rem !important;
  }
  .m-md-n8 {
    margin: -2rem !important;
  }
  .m-md-n9 {
    margin: -2.25rem !important;
  }
  .m-md-n10 {
    margin: -2.5rem !important;
  }
  .m-md-n11 {
    margin: -2.75rem !important;
  }
  .m-md-n12 {
    margin: -3rem !important;
  }
  .m-md-n13 {
    margin: -3.25rem !important;
  }
  .m-md-n14 {
    margin: -3.5rem !important;
  }
  .m-md-n15 {
    margin: -3.75rem !important;
  }
  .m-md-n16 {
    margin: -4rem !important;
  }
  .m-md-n17 {
    margin: -4.25rem !important;
  }
  .m-md-n18 {
    margin: -4.5rem !important;
  }
  .m-md-n19 {
    margin: -4.75rem !important;
  }
  .m-md-n20 {
    margin: -5rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-md-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-md-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-md-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-md-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-md-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-md-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-md-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-md-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-md-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-md-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-md-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-md-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-md-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-md-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-md-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-md-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-md-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-md-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-md-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-md-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-md-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-md-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-md-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-md-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-md-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-md-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-md-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-md-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-md-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-md-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-md-n4 {
    margin-top: -1rem !important;
  }
  .mt-md-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-md-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-md-n8 {
    margin-top: -2rem !important;
  }
  .mt-md-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-md-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-md-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-md-n12 {
    margin-top: -3rem !important;
  }
  .mt-md-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-md-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-md-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-md-n16 {
    margin-top: -4rem !important;
  }
  .mt-md-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-md-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-md-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-md-n20 {
    margin-top: -5rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -0.75rem !important;
  }
  .me-md-n4 {
    margin-right: -1rem !important;
  }
  .me-md-n5 {
    margin-right: -1.25rem !important;
  }
  .me-md-n6 {
    margin-right: -1.5rem !important;
  }
  .me-md-n7 {
    margin-right: -1.75rem !important;
  }
  .me-md-n8 {
    margin-right: -2rem !important;
  }
  .me-md-n9 {
    margin-right: -2.25rem !important;
  }
  .me-md-n10 {
    margin-right: -2.5rem !important;
  }
  .me-md-n11 {
    margin-right: -2.75rem !important;
  }
  .me-md-n12 {
    margin-right: -3rem !important;
  }
  .me-md-n13 {
    margin-right: -3.25rem !important;
  }
  .me-md-n14 {
    margin-right: -3.5rem !important;
  }
  .me-md-n15 {
    margin-right: -3.75rem !important;
  }
  .me-md-n16 {
    margin-right: -4rem !important;
  }
  .me-md-n17 {
    margin-right: -4.25rem !important;
  }
  .me-md-n18 {
    margin-right: -4.5rem !important;
  }
  .me-md-n19 {
    margin-right: -4.75rem !important;
  }
  .me-md-n20 {
    margin-right: -5rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-md-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-md-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-md-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-md-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-md-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-md-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-md-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-md-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-md-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-md-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-md-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-md-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-md-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-md-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-md-n4 {
    margin-left: -1rem !important;
  }
  .ms-md-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-md-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-md-n8 {
    margin-left: -2rem !important;
  }
  .ms-md-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-md-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-md-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-md-n12 {
    margin-left: -3rem !important;
  }
  .ms-md-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-md-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-md-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-md-n16 {
    margin-left: -4rem !important;
  }
  .ms-md-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-md-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-md-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-md-n20 {
    margin-left: -5rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 0.75rem !important;
  }
  .p-md-4 {
    padding: 1rem !important;
  }
  .p-md-5 {
    padding: 1.25rem !important;
  }
  .p-md-6 {
    padding: 1.5rem !important;
  }
  .p-md-7 {
    padding: 1.75rem !important;
  }
  .p-md-8 {
    padding: 2rem !important;
  }
  .p-md-9 {
    padding: 2.25rem !important;
  }
  .p-md-10 {
    padding: 2.5rem !important;
  }
  .p-md-11 {
    padding: 2.75rem !important;
  }
  .p-md-12 {
    padding: 3rem !important;
  }
  .p-md-13 {
    padding: 3.25rem !important;
  }
  .p-md-14 {
    padding: 3.5rem !important;
  }
  .p-md-15 {
    padding: 3.75rem !important;
  }
  .p-md-16 {
    padding: 4rem !important;
  }
  .p-md-17 {
    padding: 4.25rem !important;
  }
  .p-md-18 {
    padding: 4.5rem !important;
  }
  .p-md-19 {
    padding: 4.75rem !important;
  }
  .p-md-20 {
    padding: 5rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-md-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-md-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-md-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-md-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-md-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-md-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-md-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-md-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-md-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-md-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-md-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-md-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-md-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-md-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-md-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-md-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-md-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-md-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-md-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-md-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-md-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-md-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-md-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-md-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-md-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-md-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-md-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-md-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-md-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-md-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 0.75rem !important;
  }
  .pt-md-4 {
    padding-top: 1rem !important;
  }
  .pt-md-5 {
    padding-top: 1.25rem !important;
  }
  .pt-md-6 {
    padding-top: 1.5rem !important;
  }
  .pt-md-7 {
    padding-top: 1.75rem !important;
  }
  .pt-md-8 {
    padding-top: 2rem !important;
  }
  .pt-md-9 {
    padding-top: 2.25rem !important;
  }
  .pt-md-10 {
    padding-top: 2.5rem !important;
  }
  .pt-md-11 {
    padding-top: 2.75rem !important;
  }
  .pt-md-12 {
    padding-top: 3rem !important;
  }
  .pt-md-13 {
    padding-top: 3.25rem !important;
  }
  .pt-md-14 {
    padding-top: 3.5rem !important;
  }
  .pt-md-15 {
    padding-top: 3.75rem !important;
  }
  .pt-md-16 {
    padding-top: 4rem !important;
  }
  .pt-md-17 {
    padding-top: 4.25rem !important;
  }
  .pt-md-18 {
    padding-top: 4.5rem !important;
  }
  .pt-md-19 {
    padding-top: 4.75rem !important;
  }
  .pt-md-20 {
    padding-top: 5rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 0.75rem !important;
  }
  .pe-md-4 {
    padding-right: 1rem !important;
  }
  .pe-md-5 {
    padding-right: 1.25rem !important;
  }
  .pe-md-6 {
    padding-right: 1.5rem !important;
  }
  .pe-md-7 {
    padding-right: 1.75rem !important;
  }
  .pe-md-8 {
    padding-right: 2rem !important;
  }
  .pe-md-9 {
    padding-right: 2.25rem !important;
  }
  .pe-md-10 {
    padding-right: 2.5rem !important;
  }
  .pe-md-11 {
    padding-right: 2.75rem !important;
  }
  .pe-md-12 {
    padding-right: 3rem !important;
  }
  .pe-md-13 {
    padding-right: 3.25rem !important;
  }
  .pe-md-14 {
    padding-right: 3.5rem !important;
  }
  .pe-md-15 {
    padding-right: 3.75rem !important;
  }
  .pe-md-16 {
    padding-right: 4rem !important;
  }
  .pe-md-17 {
    padding-right: 4.25rem !important;
  }
  .pe-md-18 {
    padding-right: 4.5rem !important;
  }
  .pe-md-19 {
    padding-right: 4.75rem !important;
  }
  .pe-md-20 {
    padding-right: 5rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1rem !important;
  }
  .pb-md-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-md-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-md-8 {
    padding-bottom: 2rem !important;
  }
  .pb-md-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-md-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-md-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-md-12 {
    padding-bottom: 3rem !important;
  }
  .pb-md-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-md-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-md-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-md-16 {
    padding-bottom: 4rem !important;
  }
  .pb-md-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-md-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-md-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-md-20 {
    padding-bottom: 5rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 0.75rem !important;
  }
  .ps-md-4 {
    padding-left: 1rem !important;
  }
  .ps-md-5 {
    padding-left: 1.25rem !important;
  }
  .ps-md-6 {
    padding-left: 1.5rem !important;
  }
  .ps-md-7 {
    padding-left: 1.75rem !important;
  }
  .ps-md-8 {
    padding-left: 2rem !important;
  }
  .ps-md-9 {
    padding-left: 2.25rem !important;
  }
  .ps-md-10 {
    padding-left: 2.5rem !important;
  }
  .ps-md-11 {
    padding-left: 2.75rem !important;
  }
  .ps-md-12 {
    padding-left: 3rem !important;
  }
  .ps-md-13 {
    padding-left: 3.25rem !important;
  }
  .ps-md-14 {
    padding-left: 3.5rem !important;
  }
  .ps-md-15 {
    padding-left: 3.75rem !important;
  }
  .ps-md-16 {
    padding-left: 4rem !important;
  }
  .ps-md-17 {
    padding-left: 4.25rem !important;
  }
  .ps-md-18 {
    padding-left: 4.5rem !important;
  }
  .ps-md-19 {
    padding-left: 4.75rem !important;
  }
  .ps-md-20 {
    padding-left: 5rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 0.75rem !important;
  }
  .gap-md-4 {
    gap: 1rem !important;
  }
  .gap-md-5 {
    gap: 1.25rem !important;
  }
  .gap-md-6 {
    gap: 1.5rem !important;
  }
  .gap-md-7 {
    gap: 1.75rem !important;
  }
  .gap-md-8 {
    gap: 2rem !important;
  }
  .gap-md-9 {
    gap: 2.25rem !important;
  }
  .gap-md-10 {
    gap: 2.5rem !important;
  }
  .gap-md-11 {
    gap: 2.75rem !important;
  }
  .gap-md-12 {
    gap: 3rem !important;
  }
  .gap-md-13 {
    gap: 3.25rem !important;
  }
  .gap-md-14 {
    gap: 3.5rem !important;
  }
  .gap-md-15 {
    gap: 3.75rem !important;
  }
  .gap-md-16 {
    gap: 4rem !important;
  }
  .gap-md-17 {
    gap: 4.25rem !important;
  }
  .gap-md-18 {
    gap: 4.5rem !important;
  }
  .gap-md-19 {
    gap: 4.75rem !important;
  }
  .gap-md-20 {
    gap: 5rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1rem !important;
  }
  .row-gap-md-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-md-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-md-8 {
    row-gap: 2rem !important;
  }
  .row-gap-md-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-md-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-md-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-md-12 {
    row-gap: 3rem !important;
  }
  .row-gap-md-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-md-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-md-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-md-16 {
    row-gap: 4rem !important;
  }
  .row-gap-md-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-md-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-md-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-md-20 {
    row-gap: 5rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1rem !important;
  }
  .column-gap-md-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-md-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-md-8 {
    column-gap: 2rem !important;
  }
  .column-gap-md-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-md-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-md-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-md-12 {
    column-gap: 3rem !important;
  }
  .column-gap-md-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-md-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-md-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-md-16 {
    column-gap: 4rem !important;
  }
  .column-gap-md-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-md-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-md-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-md-20 {
    column-gap: 5rem !important;
  }
  .fs-md-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-md-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-md-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-md-4 {
    font-size: 1.25rem !important;
  }
  .fs-md-5 {
    font-size: 1.15rem !important;
  }
  .fs-md-6 {
    font-size: 1.075rem !important;
  }
  .fs-md-7 {
    font-size: 0.95rem !important;
  }
  .fs-md-8 {
    font-size: 0.85rem !important;
  }
  .fs-md-9 {
    font-size: 0.75rem !important;
  }
  .fs-md-10 {
    font-size: 0.5rem !important;
  }
  .fs-md-sm {
    font-size: 0.95rem !important;
  }
  .fs-md-base {
    font-size: 1rem !important;
  }
  .fs-md-lg {
    font-size: 1.075rem !important;
  }
  .fs-md-xl {
    font-size: 1.21rem !important;
  }
  .fs-md-fluid {
    font-size: 100% !important;
  }
  .fs-md-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-md-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-md-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-md-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-md-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-md-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-md-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-md-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-md-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-md-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-md-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-md-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-md-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-md-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-md-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-md-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-md-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-md-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-md-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-md-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-md-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-md-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-md-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-md-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
  .min-w-md-unset {
    min-width: unset !important;
  }
  .min-w-md-25 {
    min-width: 25% !important;
  }
  .min-w-md-50 {
    min-width: 50% !important;
  }
  .min-w-md-75 {
    min-width: 75% !important;
  }
  .min-w-md-100 {
    min-width: 100% !important;
  }
  .min-w-md-auto {
    min-width: auto !important;
  }
  .min-w-md-1px {
    min-width: 1px !important;
  }
  .min-w-md-2px {
    min-width: 2px !important;
  }
  .min-w-md-3px {
    min-width: 3px !important;
  }
  .min-w-md-4px {
    min-width: 4px !important;
  }
  .min-w-md-5px {
    min-width: 5px !important;
  }
  .min-w-md-6px {
    min-width: 6px !important;
  }
  .min-w-md-7px {
    min-width: 7px !important;
  }
  .min-w-md-8px {
    min-width: 8px !important;
  }
  .min-w-md-9px {
    min-width: 9px !important;
  }
  .min-w-md-10px {
    min-width: 10px !important;
  }
  .min-w-md-15px {
    min-width: 15px !important;
  }
  .min-w-md-20px {
    min-width: 20px !important;
  }
  .min-w-md-25px {
    min-width: 25px !important;
  }
  .min-w-md-30px {
    min-width: 30px !important;
  }
  .min-w-md-35px {
    min-width: 35px !important;
  }
  .min-w-md-40px {
    min-width: 40px !important;
  }
  .min-w-md-45px {
    min-width: 45px !important;
  }
  .min-w-md-50px {
    min-width: 50px !important;
  }
  .min-w-md-55px {
    min-width: 55px !important;
  }
  .min-w-md-60px {
    min-width: 60px !important;
  }
  .min-w-md-65px {
    min-width: 65px !important;
  }
  .min-w-md-70px {
    min-width: 70px !important;
  }
  .min-w-md-75px {
    min-width: 75px !important;
  }
  .min-w-md-80px {
    min-width: 80px !important;
  }
  .min-w-md-85px {
    min-width: 85px !important;
  }
  .min-w-md-90px {
    min-width: 90px !important;
  }
  .min-w-md-95px {
    min-width: 95px !important;
  }
  .min-w-md-100px {
    min-width: 100px !important;
  }
  .min-w-md-125px {
    min-width: 125px !important;
  }
  .min-w-md-150px {
    min-width: 150px !important;
  }
  .min-w-md-175px {
    min-width: 175px !important;
  }
  .min-w-md-200px {
    min-width: 200px !important;
  }
  .min-w-md-225px {
    min-width: 225px !important;
  }
  .min-w-md-250px {
    min-width: 250px !important;
  }
  .min-w-md-275px {
    min-width: 275px !important;
  }
  .min-w-md-300px {
    min-width: 300px !important;
  }
  .min-w-md-325px {
    min-width: 325px !important;
  }
  .min-w-md-350px {
    min-width: 350px !important;
  }
  .min-w-md-375px {
    min-width: 375px !important;
  }
  .min-w-md-400px {
    min-width: 400px !important;
  }
  .min-w-md-425px {
    min-width: 425px !important;
  }
  .min-w-md-450px {
    min-width: 450px !important;
  }
  .min-w-md-475px {
    min-width: 475px !important;
  }
  .min-w-md-500px {
    min-width: 500px !important;
  }
  .min-w-md-550px {
    min-width: 550px !important;
  }
  .min-w-md-600px {
    min-width: 600px !important;
  }
  .min-w-md-650px {
    min-width: 650px !important;
  }
  .min-w-md-700px {
    min-width: 700px !important;
  }
  .min-w-md-750px {
    min-width: 750px !important;
  }
  .min-w-md-800px {
    min-width: 800px !important;
  }
  .min-w-md-850px {
    min-width: 850px !important;
  }
  .min-w-md-900px {
    min-width: 900px !important;
  }
  .min-w-md-950px {
    min-width: 950px !important;
  }
  .min-w-md-1000px {
    min-width: 1000px !important;
  }
  .min-h-md-unset {
    min-height: unset !important;
  }
  .min-h-md-25 {
    min-height: 25% !important;
  }
  .min-h-md-50 {
    min-height: 50% !important;
  }
  .min-h-md-75 {
    min-height: 75% !important;
  }
  .min-h-md-100 {
    min-height: 100% !important;
  }
  .min-h-md-auto {
    min-height: auto !important;
  }
  .min-h-md-1px {
    min-height: 1px !important;
  }
  .min-h-md-2px {
    min-height: 2px !important;
  }
  .min-h-md-3px {
    min-height: 3px !important;
  }
  .min-h-md-4px {
    min-height: 4px !important;
  }
  .min-h-md-5px {
    min-height: 5px !important;
  }
  .min-h-md-6px {
    min-height: 6px !important;
  }
  .min-h-md-7px {
    min-height: 7px !important;
  }
  .min-h-md-8px {
    min-height: 8px !important;
  }
  .min-h-md-9px {
    min-height: 9px !important;
  }
  .min-h-md-10px {
    min-height: 10px !important;
  }
  .min-h-md-15px {
    min-height: 15px !important;
  }
  .min-h-md-20px {
    min-height: 20px !important;
  }
  .min-h-md-25px {
    min-height: 25px !important;
  }
  .min-h-md-30px {
    min-height: 30px !important;
  }
  .min-h-md-35px {
    min-height: 35px !important;
  }
  .min-h-md-40px {
    min-height: 40px !important;
  }
  .min-h-md-45px {
    min-height: 45px !important;
  }
  .min-h-md-50px {
    min-height: 50px !important;
  }
  .min-h-md-55px {
    min-height: 55px !important;
  }
  .min-h-md-60px {
    min-height: 60px !important;
  }
  .min-h-md-65px {
    min-height: 65px !important;
  }
  .min-h-md-70px {
    min-height: 70px !important;
  }
  .min-h-md-75px {
    min-height: 75px !important;
  }
  .min-h-md-80px {
    min-height: 80px !important;
  }
  .min-h-md-85px {
    min-height: 85px !important;
  }
  .min-h-md-90px {
    min-height: 90px !important;
  }
  .min-h-md-95px {
    min-height: 95px !important;
  }
  .min-h-md-100px {
    min-height: 100px !important;
  }
  .min-h-md-125px {
    min-height: 125px !important;
  }
  .min-h-md-150px {
    min-height: 150px !important;
  }
  .min-h-md-175px {
    min-height: 175px !important;
  }
  .min-h-md-200px {
    min-height: 200px !important;
  }
  .min-h-md-225px {
    min-height: 225px !important;
  }
  .min-h-md-250px {
    min-height: 250px !important;
  }
  .min-h-md-275px {
    min-height: 275px !important;
  }
  .min-h-md-300px {
    min-height: 300px !important;
  }
  .min-h-md-325px {
    min-height: 325px !important;
  }
  .min-h-md-350px {
    min-height: 350px !important;
  }
  .min-h-md-375px {
    min-height: 375px !important;
  }
  .min-h-md-400px {
    min-height: 400px !important;
  }
  .min-h-md-425px {
    min-height: 425px !important;
  }
  .min-h-md-450px {
    min-height: 450px !important;
  }
  .min-h-md-475px {
    min-height: 475px !important;
  }
  .min-h-md-500px {
    min-height: 500px !important;
  }
  .min-h-md-550px {
    min-height: 550px !important;
  }
  .min-h-md-600px {
    min-height: 600px !important;
  }
  .min-h-md-650px {
    min-height: 650px !important;
  }
  .min-h-md-700px {
    min-height: 700px !important;
  }
  .min-h-md-750px {
    min-height: 750px !important;
  }
  .min-h-md-800px {
    min-height: 800px !important;
  }
  .min-h-md-850px {
    min-height: 850px !important;
  }
  .min-h-md-900px {
    min-height: 900px !important;
  }
  .min-h-md-950px {
    min-height: 950px !important;
  }
  .min-h-md-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .overflow-lg-auto {
    overflow: auto !important;
  }
  .overflow-lg-hidden {
    overflow: hidden !important;
  }
  .overflow-lg-visible {
    overflow: visible !important;
  }
  .overflow-lg-scroll {
    overflow: scroll !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .position-lg-static {
    position: static !important;
  }
  .position-lg-relative {
    position: relative !important;
  }
  .position-lg-absolute {
    position: absolute !important;
  }
  .position-lg-fixed {
    position: fixed !important;
  }
  .position-lg-sticky {
    position: sticky !important;
  }
  .w-lg-unset {
    width: unset !important;
  }
  .w-lg-25 {
    width: 25% !important;
  }
  .w-lg-50 {
    width: 50% !important;
  }
  .w-lg-75 {
    width: 75% !important;
  }
  .w-lg-100 {
    width: 100% !important;
  }
  .w-lg-auto {
    width: auto !important;
  }
  .w-lg-1px {
    width: 1px !important;
  }
  .w-lg-2px {
    width: 2px !important;
  }
  .w-lg-3px {
    width: 3px !important;
  }
  .w-lg-4px {
    width: 4px !important;
  }
  .w-lg-5px {
    width: 5px !important;
  }
  .w-lg-6px {
    width: 6px !important;
  }
  .w-lg-7px {
    width: 7px !important;
  }
  .w-lg-8px {
    width: 8px !important;
  }
  .w-lg-9px {
    width: 9px !important;
  }
  .w-lg-10px {
    width: 10px !important;
  }
  .w-lg-15px {
    width: 15px !important;
  }
  .w-lg-20px {
    width: 20px !important;
  }
  .w-lg-25px {
    width: 25px !important;
  }
  .w-lg-30px {
    width: 30px !important;
  }
  .w-lg-35px {
    width: 35px !important;
  }
  .w-lg-40px {
    width: 40px !important;
  }
  .w-lg-45px {
    width: 45px !important;
  }
  .w-lg-50px {
    width: 50px !important;
  }
  .w-lg-55px {
    width: 55px !important;
  }
  .w-lg-60px {
    width: 60px !important;
  }
  .w-lg-65px {
    width: 65px !important;
  }
  .w-lg-70px {
    width: 70px !important;
  }
  .w-lg-75px {
    width: 75px !important;
  }
  .w-lg-80px {
    width: 80px !important;
  }
  .w-lg-85px {
    width: 85px !important;
  }
  .w-lg-90px {
    width: 90px !important;
  }
  .w-lg-95px {
    width: 95px !important;
  }
  .w-lg-100px {
    width: 100px !important;
  }
  .w-lg-125px {
    width: 125px !important;
  }
  .w-lg-150px {
    width: 150px !important;
  }
  .w-lg-175px {
    width: 175px !important;
  }
  .w-lg-200px {
    width: 200px !important;
  }
  .w-lg-225px {
    width: 225px !important;
  }
  .w-lg-250px {
    width: 250px !important;
  }
  .w-lg-275px {
    width: 275px !important;
  }
  .w-lg-300px {
    width: 300px !important;
  }
  .w-lg-325px {
    width: 325px !important;
  }
  .w-lg-350px {
    width: 350px !important;
  }
  .w-lg-375px {
    width: 375px !important;
  }
  .w-lg-400px {
    width: 400px !important;
  }
  .w-lg-425px {
    width: 425px !important;
  }
  .w-lg-450px {
    width: 450px !important;
  }
  .w-lg-475px {
    width: 475px !important;
  }
  .w-lg-500px {
    width: 500px !important;
  }
  .w-lg-550px {
    width: 550px !important;
  }
  .w-lg-600px {
    width: 600px !important;
  }
  .w-lg-650px {
    width: 650px !important;
  }
  .w-lg-700px {
    width: 700px !important;
  }
  .w-lg-750px {
    width: 750px !important;
  }
  .w-lg-800px {
    width: 800px !important;
  }
  .w-lg-850px {
    width: 850px !important;
  }
  .w-lg-900px {
    width: 900px !important;
  }
  .w-lg-950px {
    width: 950px !important;
  }
  .w-lg-1000px {
    width: 1000px !important;
  }
  .mw-lg-unset {
    max-width: unset !important;
  }
  .mw-lg-25 {
    max-width: 25% !important;
  }
  .mw-lg-50 {
    max-width: 50% !important;
  }
  .mw-lg-75 {
    max-width: 75% !important;
  }
  .mw-lg-100 {
    max-width: 100% !important;
  }
  .mw-lg-auto {
    max-width: auto !important;
  }
  .mw-lg-1px {
    max-width: 1px !important;
  }
  .mw-lg-2px {
    max-width: 2px !important;
  }
  .mw-lg-3px {
    max-width: 3px !important;
  }
  .mw-lg-4px {
    max-width: 4px !important;
  }
  .mw-lg-5px {
    max-width: 5px !important;
  }
  .mw-lg-6px {
    max-width: 6px !important;
  }
  .mw-lg-7px {
    max-width: 7px !important;
  }
  .mw-lg-8px {
    max-width: 8px !important;
  }
  .mw-lg-9px {
    max-width: 9px !important;
  }
  .mw-lg-10px {
    max-width: 10px !important;
  }
  .mw-lg-15px {
    max-width: 15px !important;
  }
  .mw-lg-20px {
    max-width: 20px !important;
  }
  .mw-lg-25px {
    max-width: 25px !important;
  }
  .mw-lg-30px {
    max-width: 30px !important;
  }
  .mw-lg-35px {
    max-width: 35px !important;
  }
  .mw-lg-40px {
    max-width: 40px !important;
  }
  .mw-lg-45px {
    max-width: 45px !important;
  }
  .mw-lg-50px {
    max-width: 50px !important;
  }
  .mw-lg-55px {
    max-width: 55px !important;
  }
  .mw-lg-60px {
    max-width: 60px !important;
  }
  .mw-lg-65px {
    max-width: 65px !important;
  }
  .mw-lg-70px {
    max-width: 70px !important;
  }
  .mw-lg-75px {
    max-width: 75px !important;
  }
  .mw-lg-80px {
    max-width: 80px !important;
  }
  .mw-lg-85px {
    max-width: 85px !important;
  }
  .mw-lg-90px {
    max-width: 90px !important;
  }
  .mw-lg-95px {
    max-width: 95px !important;
  }
  .mw-lg-100px {
    max-width: 100px !important;
  }
  .mw-lg-125px {
    max-width: 125px !important;
  }
  .mw-lg-150px {
    max-width: 150px !important;
  }
  .mw-lg-175px {
    max-width: 175px !important;
  }
  .mw-lg-200px {
    max-width: 200px !important;
  }
  .mw-lg-225px {
    max-width: 225px !important;
  }
  .mw-lg-250px {
    max-width: 250px !important;
  }
  .mw-lg-275px {
    max-width: 275px !important;
  }
  .mw-lg-300px {
    max-width: 300px !important;
  }
  .mw-lg-325px {
    max-width: 325px !important;
  }
  .mw-lg-350px {
    max-width: 350px !important;
  }
  .mw-lg-375px {
    max-width: 375px !important;
  }
  .mw-lg-400px {
    max-width: 400px !important;
  }
  .mw-lg-425px {
    max-width: 425px !important;
  }
  .mw-lg-450px {
    max-width: 450px !important;
  }
  .mw-lg-475px {
    max-width: 475px !important;
  }
  .mw-lg-500px {
    max-width: 500px !important;
  }
  .mw-lg-550px {
    max-width: 550px !important;
  }
  .mw-lg-600px {
    max-width: 600px !important;
  }
  .mw-lg-650px {
    max-width: 650px !important;
  }
  .mw-lg-700px {
    max-width: 700px !important;
  }
  .mw-lg-750px {
    max-width: 750px !important;
  }
  .mw-lg-800px {
    max-width: 800px !important;
  }
  .mw-lg-850px {
    max-width: 850px !important;
  }
  .mw-lg-900px {
    max-width: 900px !important;
  }
  .mw-lg-950px {
    max-width: 950px !important;
  }
  .mw-lg-1000px {
    max-width: 1000px !important;
  }
  .h-lg-unset {
    height: unset !important;
  }
  .h-lg-25 {
    height: 25% !important;
  }
  .h-lg-50 {
    height: 50% !important;
  }
  .h-lg-75 {
    height: 75% !important;
  }
  .h-lg-100 {
    height: 100% !important;
  }
  .h-lg-auto {
    height: auto !important;
  }
  .h-lg-1px {
    height: 1px !important;
  }
  .h-lg-2px {
    height: 2px !important;
  }
  .h-lg-3px {
    height: 3px !important;
  }
  .h-lg-4px {
    height: 4px !important;
  }
  .h-lg-5px {
    height: 5px !important;
  }
  .h-lg-6px {
    height: 6px !important;
  }
  .h-lg-7px {
    height: 7px !important;
  }
  .h-lg-8px {
    height: 8px !important;
  }
  .h-lg-9px {
    height: 9px !important;
  }
  .h-lg-10px {
    height: 10px !important;
  }
  .h-lg-15px {
    height: 15px !important;
  }
  .h-lg-20px {
    height: 20px !important;
  }
  .h-lg-25px {
    height: 25px !important;
  }
  .h-lg-30px {
    height: 30px !important;
  }
  .h-lg-35px {
    height: 35px !important;
  }
  .h-lg-40px {
    height: 40px !important;
  }
  .h-lg-45px {
    height: 45px !important;
  }
  .h-lg-50px {
    height: 50px !important;
  }
  .h-lg-55px {
    height: 55px !important;
  }
  .h-lg-60px {
    height: 60px !important;
  }
  .h-lg-65px {
    height: 65px !important;
  }
  .h-lg-70px {
    height: 70px !important;
  }
  .h-lg-75px {
    height: 75px !important;
  }
  .h-lg-80px {
    height: 80px !important;
  }
  .h-lg-85px {
    height: 85px !important;
  }
  .h-lg-90px {
    height: 90px !important;
  }
  .h-lg-95px {
    height: 95px !important;
  }
  .h-lg-100px {
    height: 100px !important;
  }
  .h-lg-125px {
    height: 125px !important;
  }
  .h-lg-150px {
    height: 150px !important;
  }
  .h-lg-175px {
    height: 175px !important;
  }
  .h-lg-200px {
    height: 200px !important;
  }
  .h-lg-225px {
    height: 225px !important;
  }
  .h-lg-250px {
    height: 250px !important;
  }
  .h-lg-275px {
    height: 275px !important;
  }
  .h-lg-300px {
    height: 300px !important;
  }
  .h-lg-325px {
    height: 325px !important;
  }
  .h-lg-350px {
    height: 350px !important;
  }
  .h-lg-375px {
    height: 375px !important;
  }
  .h-lg-400px {
    height: 400px !important;
  }
  .h-lg-425px {
    height: 425px !important;
  }
  .h-lg-450px {
    height: 450px !important;
  }
  .h-lg-475px {
    height: 475px !important;
  }
  .h-lg-500px {
    height: 500px !important;
  }
  .h-lg-550px {
    height: 550px !important;
  }
  .h-lg-600px {
    height: 600px !important;
  }
  .h-lg-650px {
    height: 650px !important;
  }
  .h-lg-700px {
    height: 700px !important;
  }
  .h-lg-750px {
    height: 750px !important;
  }
  .h-lg-800px {
    height: 800px !important;
  }
  .h-lg-850px {
    height: 850px !important;
  }
  .h-lg-900px {
    height: 900px !important;
  }
  .h-lg-950px {
    height: 950px !important;
  }
  .h-lg-1000px {
    height: 1000px !important;
  }
  .mh-lg-unset {
    max-height: unset !important;
  }
  .mh-lg-25 {
    max-height: 25% !important;
  }
  .mh-lg-50 {
    max-height: 50% !important;
  }
  .mh-lg-75 {
    max-height: 75% !important;
  }
  .mh-lg-100 {
    max-height: 100% !important;
  }
  .mh-lg-auto {
    max-height: auto !important;
  }
  .mh-lg-1px {
    max-height: 1px !important;
  }
  .mh-lg-2px {
    max-height: 2px !important;
  }
  .mh-lg-3px {
    max-height: 3px !important;
  }
  .mh-lg-4px {
    max-height: 4px !important;
  }
  .mh-lg-5px {
    max-height: 5px !important;
  }
  .mh-lg-6px {
    max-height: 6px !important;
  }
  .mh-lg-7px {
    max-height: 7px !important;
  }
  .mh-lg-8px {
    max-height: 8px !important;
  }
  .mh-lg-9px {
    max-height: 9px !important;
  }
  .mh-lg-10px {
    max-height: 10px !important;
  }
  .mh-lg-15px {
    max-height: 15px !important;
  }
  .mh-lg-20px {
    max-height: 20px !important;
  }
  .mh-lg-25px {
    max-height: 25px !important;
  }
  .mh-lg-30px {
    max-height: 30px !important;
  }
  .mh-lg-35px {
    max-height: 35px !important;
  }
  .mh-lg-40px {
    max-height: 40px !important;
  }
  .mh-lg-45px {
    max-height: 45px !important;
  }
  .mh-lg-50px {
    max-height: 50px !important;
  }
  .mh-lg-55px {
    max-height: 55px !important;
  }
  .mh-lg-60px {
    max-height: 60px !important;
  }
  .mh-lg-65px {
    max-height: 65px !important;
  }
  .mh-lg-70px {
    max-height: 70px !important;
  }
  .mh-lg-75px {
    max-height: 75px !important;
  }
  .mh-lg-80px {
    max-height: 80px !important;
  }
  .mh-lg-85px {
    max-height: 85px !important;
  }
  .mh-lg-90px {
    max-height: 90px !important;
  }
  .mh-lg-95px {
    max-height: 95px !important;
  }
  .mh-lg-100px {
    max-height: 100px !important;
  }
  .mh-lg-125px {
    max-height: 125px !important;
  }
  .mh-lg-150px {
    max-height: 150px !important;
  }
  .mh-lg-175px {
    max-height: 175px !important;
  }
  .mh-lg-200px {
    max-height: 200px !important;
  }
  .mh-lg-225px {
    max-height: 225px !important;
  }
  .mh-lg-250px {
    max-height: 250px !important;
  }
  .mh-lg-275px {
    max-height: 275px !important;
  }
  .mh-lg-300px {
    max-height: 300px !important;
  }
  .mh-lg-325px {
    max-height: 325px !important;
  }
  .mh-lg-350px {
    max-height: 350px !important;
  }
  .mh-lg-375px {
    max-height: 375px !important;
  }
  .mh-lg-400px {
    max-height: 400px !important;
  }
  .mh-lg-425px {
    max-height: 425px !important;
  }
  .mh-lg-450px {
    max-height: 450px !important;
  }
  .mh-lg-475px {
    max-height: 475px !important;
  }
  .mh-lg-500px {
    max-height: 500px !important;
  }
  .mh-lg-550px {
    max-height: 550px !important;
  }
  .mh-lg-600px {
    max-height: 600px !important;
  }
  .mh-lg-650px {
    max-height: 650px !important;
  }
  .mh-lg-700px {
    max-height: 700px !important;
  }
  .mh-lg-750px {
    max-height: 750px !important;
  }
  .mh-lg-800px {
    max-height: 800px !important;
  }
  .mh-lg-850px {
    max-height: 850px !important;
  }
  .mh-lg-900px {
    max-height: 900px !important;
  }
  .mh-lg-950px {
    max-height: 950px !important;
  }
  .mh-lg-1000px {
    max-height: 1000px !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 0.75rem !important;
  }
  .m-lg-4 {
    margin: 1rem !important;
  }
  .m-lg-5 {
    margin: 1.25rem !important;
  }
  .m-lg-6 {
    margin: 1.5rem !important;
  }
  .m-lg-7 {
    margin: 1.75rem !important;
  }
  .m-lg-8 {
    margin: 2rem !important;
  }
  .m-lg-9 {
    margin: 2.25rem !important;
  }
  .m-lg-10 {
    margin: 2.5rem !important;
  }
  .m-lg-11 {
    margin: 2.75rem !important;
  }
  .m-lg-12 {
    margin: 3rem !important;
  }
  .m-lg-13 {
    margin: 3.25rem !important;
  }
  .m-lg-14 {
    margin: 3.5rem !important;
  }
  .m-lg-15 {
    margin: 3.75rem !important;
  }
  .m-lg-16 {
    margin: 4rem !important;
  }
  .m-lg-17 {
    margin: 4.25rem !important;
  }
  .m-lg-18 {
    margin: 4.5rem !important;
  }
  .m-lg-19 {
    margin: 4.75rem !important;
  }
  .m-lg-20 {
    margin: 5rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-lg-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-lg-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-lg-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-lg-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-lg-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-lg-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-lg-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-lg-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-lg-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-lg-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-lg-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-lg-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-lg-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-lg-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-lg-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-lg-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-lg-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-lg-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-lg-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-lg-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-lg-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-lg-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-lg-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-lg-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-lg-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-lg-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-lg-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-lg-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 0.75rem !important;
  }
  .mt-lg-4 {
    margin-top: 1rem !important;
  }
  .mt-lg-5 {
    margin-top: 1.25rem !important;
  }
  .mt-lg-6 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-7 {
    margin-top: 1.75rem !important;
  }
  .mt-lg-8 {
    margin-top: 2rem !important;
  }
  .mt-lg-9 {
    margin-top: 2.25rem !important;
  }
  .mt-lg-10 {
    margin-top: 2.5rem !important;
  }
  .mt-lg-11 {
    margin-top: 2.75rem !important;
  }
  .mt-lg-12 {
    margin-top: 3rem !important;
  }
  .mt-lg-13 {
    margin-top: 3.25rem !important;
  }
  .mt-lg-14 {
    margin-top: 3.5rem !important;
  }
  .mt-lg-15 {
    margin-top: 3.75rem !important;
  }
  .mt-lg-16 {
    margin-top: 4rem !important;
  }
  .mt-lg-17 {
    margin-top: 4.25rem !important;
  }
  .mt-lg-18 {
    margin-top: 4.5rem !important;
  }
  .mt-lg-19 {
    margin-top: 4.75rem !important;
  }
  .mt-lg-20 {
    margin-top: 5rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 0.75rem !important;
  }
  .me-lg-4 {
    margin-right: 1rem !important;
  }
  .me-lg-5 {
    margin-right: 1.25rem !important;
  }
  .me-lg-6 {
    margin-right: 1.5rem !important;
  }
  .me-lg-7 {
    margin-right: 1.75rem !important;
  }
  .me-lg-8 {
    margin-right: 2rem !important;
  }
  .me-lg-9 {
    margin-right: 2.25rem !important;
  }
  .me-lg-10 {
    margin-right: 2.5rem !important;
  }
  .me-lg-11 {
    margin-right: 2.75rem !important;
  }
  .me-lg-12 {
    margin-right: 3rem !important;
  }
  .me-lg-13 {
    margin-right: 3.25rem !important;
  }
  .me-lg-14 {
    margin-right: 3.5rem !important;
  }
  .me-lg-15 {
    margin-right: 3.75rem !important;
  }
  .me-lg-16 {
    margin-right: 4rem !important;
  }
  .me-lg-17 {
    margin-right: 4.25rem !important;
  }
  .me-lg-18 {
    margin-right: 4.5rem !important;
  }
  .me-lg-19 {
    margin-right: 4.75rem !important;
  }
  .me-lg-20 {
    margin-right: 5rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-lg-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-lg-8 {
    margin-bottom: 2rem !important;
  }
  .mb-lg-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-lg-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-lg-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-lg-12 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-lg-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-lg-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-lg-16 {
    margin-bottom: 4rem !important;
  }
  .mb-lg-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-lg-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-lg-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-lg-20 {
    margin-bottom: 5rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 0.75rem !important;
  }
  .ms-lg-4 {
    margin-left: 1rem !important;
  }
  .ms-lg-5 {
    margin-left: 1.25rem !important;
  }
  .ms-lg-6 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-7 {
    margin-left: 1.75rem !important;
  }
  .ms-lg-8 {
    margin-left: 2rem !important;
  }
  .ms-lg-9 {
    margin-left: 2.25rem !important;
  }
  .ms-lg-10 {
    margin-left: 2.5rem !important;
  }
  .ms-lg-11 {
    margin-left: 2.75rem !important;
  }
  .ms-lg-12 {
    margin-left: 3rem !important;
  }
  .ms-lg-13 {
    margin-left: 3.25rem !important;
  }
  .ms-lg-14 {
    margin-left: 3.5rem !important;
  }
  .ms-lg-15 {
    margin-left: 3.75rem !important;
  }
  .ms-lg-16 {
    margin-left: 4rem !important;
  }
  .ms-lg-17 {
    margin-left: 4.25rem !important;
  }
  .ms-lg-18 {
    margin-left: 4.5rem !important;
  }
  .ms-lg-19 {
    margin-left: 4.75rem !important;
  }
  .ms-lg-20 {
    margin-left: 5rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -0.75rem !important;
  }
  .m-lg-n4 {
    margin: -1rem !important;
  }
  .m-lg-n5 {
    margin: -1.25rem !important;
  }
  .m-lg-n6 {
    margin: -1.5rem !important;
  }
  .m-lg-n7 {
    margin: -1.75rem !important;
  }
  .m-lg-n8 {
    margin: -2rem !important;
  }
  .m-lg-n9 {
    margin: -2.25rem !important;
  }
  .m-lg-n10 {
    margin: -2.5rem !important;
  }
  .m-lg-n11 {
    margin: -2.75rem !important;
  }
  .m-lg-n12 {
    margin: -3rem !important;
  }
  .m-lg-n13 {
    margin: -3.25rem !important;
  }
  .m-lg-n14 {
    margin: -3.5rem !important;
  }
  .m-lg-n15 {
    margin: -3.75rem !important;
  }
  .m-lg-n16 {
    margin: -4rem !important;
  }
  .m-lg-n17 {
    margin: -4.25rem !important;
  }
  .m-lg-n18 {
    margin: -4.5rem !important;
  }
  .m-lg-n19 {
    margin: -4.75rem !important;
  }
  .m-lg-n20 {
    margin: -5rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-lg-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-lg-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-lg-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-lg-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-lg-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-lg-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-lg-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-lg-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-lg-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-lg-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-lg-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-lg-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-lg-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-lg-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-lg-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-lg-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-lg-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-lg-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-lg-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-lg-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-lg-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-lg-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-lg-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-lg-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-lg-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-lg-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-lg-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-lg-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-lg-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1rem !important;
  }
  .mt-lg-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-lg-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-lg-n8 {
    margin-top: -2rem !important;
  }
  .mt-lg-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-lg-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-lg-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-lg-n12 {
    margin-top: -3rem !important;
  }
  .mt-lg-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-lg-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-lg-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-lg-n16 {
    margin-top: -4rem !important;
  }
  .mt-lg-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-lg-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-lg-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-lg-n20 {
    margin-top: -5rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -0.75rem !important;
  }
  .me-lg-n4 {
    margin-right: -1rem !important;
  }
  .me-lg-n5 {
    margin-right: -1.25rem !important;
  }
  .me-lg-n6 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n7 {
    margin-right: -1.75rem !important;
  }
  .me-lg-n8 {
    margin-right: -2rem !important;
  }
  .me-lg-n9 {
    margin-right: -2.25rem !important;
  }
  .me-lg-n10 {
    margin-right: -2.5rem !important;
  }
  .me-lg-n11 {
    margin-right: -2.75rem !important;
  }
  .me-lg-n12 {
    margin-right: -3rem !important;
  }
  .me-lg-n13 {
    margin-right: -3.25rem !important;
  }
  .me-lg-n14 {
    margin-right: -3.5rem !important;
  }
  .me-lg-n15 {
    margin-right: -3.75rem !important;
  }
  .me-lg-n16 {
    margin-right: -4rem !important;
  }
  .me-lg-n17 {
    margin-right: -4.25rem !important;
  }
  .me-lg-n18 {
    margin-right: -4.5rem !important;
  }
  .me-lg-n19 {
    margin-right: -4.75rem !important;
  }
  .me-lg-n20 {
    margin-right: -5rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-lg-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-lg-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-lg-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-lg-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-lg-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-lg-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-lg-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-lg-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-lg-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-lg-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-lg-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-lg-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-lg-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-lg-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1rem !important;
  }
  .ms-lg-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-lg-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-lg-n8 {
    margin-left: -2rem !important;
  }
  .ms-lg-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-lg-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-lg-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-lg-n12 {
    margin-left: -3rem !important;
  }
  .ms-lg-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-lg-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-lg-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-lg-n16 {
    margin-left: -4rem !important;
  }
  .ms-lg-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-lg-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-lg-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-lg-n20 {
    margin-left: -5rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 0.75rem !important;
  }
  .p-lg-4 {
    padding: 1rem !important;
  }
  .p-lg-5 {
    padding: 1.25rem !important;
  }
  .p-lg-6 {
    padding: 1.5rem !important;
  }
  .p-lg-7 {
    padding: 1.75rem !important;
  }
  .p-lg-8 {
    padding: 2rem !important;
  }
  .p-lg-9 {
    padding: 2.25rem !important;
  }
  .p-lg-10 {
    padding: 2.5rem !important;
  }
  .p-lg-11 {
    padding: 2.75rem !important;
  }
  .p-lg-12 {
    padding: 3rem !important;
  }
  .p-lg-13 {
    padding: 3.25rem !important;
  }
  .p-lg-14 {
    padding: 3.5rem !important;
  }
  .p-lg-15 {
    padding: 3.75rem !important;
  }
  .p-lg-16 {
    padding: 4rem !important;
  }
  .p-lg-17 {
    padding: 4.25rem !important;
  }
  .p-lg-18 {
    padding: 4.5rem !important;
  }
  .p-lg-19 {
    padding: 4.75rem !important;
  }
  .p-lg-20 {
    padding: 5rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-lg-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-lg-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-lg-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-lg-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-lg-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-lg-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-lg-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-lg-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-lg-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-lg-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-lg-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-lg-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-lg-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-lg-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-lg-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-lg-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-lg-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-lg-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-lg-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-lg-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-lg-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-lg-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-lg-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-lg-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-lg-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-lg-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-lg-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-lg-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-lg-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-lg-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 0.75rem !important;
  }
  .pt-lg-4 {
    padding-top: 1rem !important;
  }
  .pt-lg-5 {
    padding-top: 1.25rem !important;
  }
  .pt-lg-6 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-7 {
    padding-top: 1.75rem !important;
  }
  .pt-lg-8 {
    padding-top: 2rem !important;
  }
  .pt-lg-9 {
    padding-top: 2.25rem !important;
  }
  .pt-lg-10 {
    padding-top: 2.5rem !important;
  }
  .pt-lg-11 {
    padding-top: 2.75rem !important;
  }
  .pt-lg-12 {
    padding-top: 3rem !important;
  }
  .pt-lg-13 {
    padding-top: 3.25rem !important;
  }
  .pt-lg-14 {
    padding-top: 3.5rem !important;
  }
  .pt-lg-15 {
    padding-top: 3.75rem !important;
  }
  .pt-lg-16 {
    padding-top: 4rem !important;
  }
  .pt-lg-17 {
    padding-top: 4.25rem !important;
  }
  .pt-lg-18 {
    padding-top: 4.5rem !important;
  }
  .pt-lg-19 {
    padding-top: 4.75rem !important;
  }
  .pt-lg-20 {
    padding-top: 5rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 0.75rem !important;
  }
  .pe-lg-4 {
    padding-right: 1rem !important;
  }
  .pe-lg-5 {
    padding-right: 1.25rem !important;
  }
  .pe-lg-6 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-7 {
    padding-right: 1.75rem !important;
  }
  .pe-lg-8 {
    padding-right: 2rem !important;
  }
  .pe-lg-9 {
    padding-right: 2.25rem !important;
  }
  .pe-lg-10 {
    padding-right: 2.5rem !important;
  }
  .pe-lg-11 {
    padding-right: 2.75rem !important;
  }
  .pe-lg-12 {
    padding-right: 3rem !important;
  }
  .pe-lg-13 {
    padding-right: 3.25rem !important;
  }
  .pe-lg-14 {
    padding-right: 3.5rem !important;
  }
  .pe-lg-15 {
    padding-right: 3.75rem !important;
  }
  .pe-lg-16 {
    padding-right: 4rem !important;
  }
  .pe-lg-17 {
    padding-right: 4.25rem !important;
  }
  .pe-lg-18 {
    padding-right: 4.5rem !important;
  }
  .pe-lg-19 {
    padding-right: 4.75rem !important;
  }
  .pe-lg-20 {
    padding-right: 5rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-lg-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-lg-8 {
    padding-bottom: 2rem !important;
  }
  .pb-lg-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-lg-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-lg-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-lg-12 {
    padding-bottom: 3rem !important;
  }
  .pb-lg-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-lg-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-lg-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-lg-16 {
    padding-bottom: 4rem !important;
  }
  .pb-lg-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-lg-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-lg-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-lg-20 {
    padding-bottom: 5rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 0.75rem !important;
  }
  .ps-lg-4 {
    padding-left: 1rem !important;
  }
  .ps-lg-5 {
    padding-left: 1.25rem !important;
  }
  .ps-lg-6 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-7 {
    padding-left: 1.75rem !important;
  }
  .ps-lg-8 {
    padding-left: 2rem !important;
  }
  .ps-lg-9 {
    padding-left: 2.25rem !important;
  }
  .ps-lg-10 {
    padding-left: 2.5rem !important;
  }
  .ps-lg-11 {
    padding-left: 2.75rem !important;
  }
  .ps-lg-12 {
    padding-left: 3rem !important;
  }
  .ps-lg-13 {
    padding-left: 3.25rem !important;
  }
  .ps-lg-14 {
    padding-left: 3.5rem !important;
  }
  .ps-lg-15 {
    padding-left: 3.75rem !important;
  }
  .ps-lg-16 {
    padding-left: 4rem !important;
  }
  .ps-lg-17 {
    padding-left: 4.25rem !important;
  }
  .ps-lg-18 {
    padding-left: 4.5rem !important;
  }
  .ps-lg-19 {
    padding-left: 4.75rem !important;
  }
  .ps-lg-20 {
    padding-left: 5rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 0.75rem !important;
  }
  .gap-lg-4 {
    gap: 1rem !important;
  }
  .gap-lg-5 {
    gap: 1.25rem !important;
  }
  .gap-lg-6 {
    gap: 1.5rem !important;
  }
  .gap-lg-7 {
    gap: 1.75rem !important;
  }
  .gap-lg-8 {
    gap: 2rem !important;
  }
  .gap-lg-9 {
    gap: 2.25rem !important;
  }
  .gap-lg-10 {
    gap: 2.5rem !important;
  }
  .gap-lg-11 {
    gap: 2.75rem !important;
  }
  .gap-lg-12 {
    gap: 3rem !important;
  }
  .gap-lg-13 {
    gap: 3.25rem !important;
  }
  .gap-lg-14 {
    gap: 3.5rem !important;
  }
  .gap-lg-15 {
    gap: 3.75rem !important;
  }
  .gap-lg-16 {
    gap: 4rem !important;
  }
  .gap-lg-17 {
    gap: 4.25rem !important;
  }
  .gap-lg-18 {
    gap: 4.5rem !important;
  }
  .gap-lg-19 {
    gap: 4.75rem !important;
  }
  .gap-lg-20 {
    gap: 5rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-lg-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-lg-8 {
    row-gap: 2rem !important;
  }
  .row-gap-lg-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-lg-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-lg-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-lg-12 {
    row-gap: 3rem !important;
  }
  .row-gap-lg-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-lg-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-lg-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-lg-16 {
    row-gap: 4rem !important;
  }
  .row-gap-lg-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-lg-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-lg-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-lg-20 {
    row-gap: 5rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-lg-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-lg-8 {
    column-gap: 2rem !important;
  }
  .column-gap-lg-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-lg-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-lg-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-lg-12 {
    column-gap: 3rem !important;
  }
  .column-gap-lg-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-lg-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-lg-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-lg-16 {
    column-gap: 4rem !important;
  }
  .column-gap-lg-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-lg-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-lg-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-lg-20 {
    column-gap: 5rem !important;
  }
  .fs-lg-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-lg-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-lg-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-lg-4 {
    font-size: 1.25rem !important;
  }
  .fs-lg-5 {
    font-size: 1.15rem !important;
  }
  .fs-lg-6 {
    font-size: 1.075rem !important;
  }
  .fs-lg-7 {
    font-size: 0.95rem !important;
  }
  .fs-lg-8 {
    font-size: 0.85rem !important;
  }
  .fs-lg-9 {
    font-size: 0.75rem !important;
  }
  .fs-lg-10 {
    font-size: 0.5rem !important;
  }
  .fs-lg-sm {
    font-size: 0.95rem !important;
  }
  .fs-lg-base {
    font-size: 1rem !important;
  }
  .fs-lg-lg {
    font-size: 1.075rem !important;
  }
  .fs-lg-xl {
    font-size: 1.21rem !important;
  }
  .fs-lg-fluid {
    font-size: 100% !important;
  }
  .fs-lg-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-lg-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-lg-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-lg-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-lg-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-lg-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-lg-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-lg-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-lg-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-lg-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-lg-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-lg-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-lg-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-lg-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-lg-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-lg-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-lg-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-lg-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-lg-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-lg-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-lg-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-lg-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-lg-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-lg-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
  .min-w-lg-unset {
    min-width: unset !important;
  }
  .min-w-lg-25 {
    min-width: 25% !important;
  }
  .min-w-lg-50 {
    min-width: 50% !important;
  }
  .min-w-lg-75 {
    min-width: 75% !important;
  }
  .min-w-lg-100 {
    min-width: 100% !important;
  }
  .min-w-lg-auto {
    min-width: auto !important;
  }
  .min-w-lg-1px {
    min-width: 1px !important;
  }
  .min-w-lg-2px {
    min-width: 2px !important;
  }
  .min-w-lg-3px {
    min-width: 3px !important;
  }
  .min-w-lg-4px {
    min-width: 4px !important;
  }
  .min-w-lg-5px {
    min-width: 5px !important;
  }
  .min-w-lg-6px {
    min-width: 6px !important;
  }
  .min-w-lg-7px {
    min-width: 7px !important;
  }
  .min-w-lg-8px {
    min-width: 8px !important;
  }
  .min-w-lg-9px {
    min-width: 9px !important;
  }
  .min-w-lg-10px {
    min-width: 10px !important;
  }
  .min-w-lg-15px {
    min-width: 15px !important;
  }
  .min-w-lg-20px {
    min-width: 20px !important;
  }
  .min-w-lg-25px {
    min-width: 25px !important;
  }
  .min-w-lg-30px {
    min-width: 30px !important;
  }
  .min-w-lg-35px {
    min-width: 35px !important;
  }
  .min-w-lg-40px {
    min-width: 40px !important;
  }
  .min-w-lg-45px {
    min-width: 45px !important;
  }
  .min-w-lg-50px {
    min-width: 50px !important;
  }
  .min-w-lg-55px {
    min-width: 55px !important;
  }
  .min-w-lg-60px {
    min-width: 60px !important;
  }
  .min-w-lg-65px {
    min-width: 65px !important;
  }
  .min-w-lg-70px {
    min-width: 70px !important;
  }
  .min-w-lg-75px {
    min-width: 75px !important;
  }
  .min-w-lg-80px {
    min-width: 80px !important;
  }
  .min-w-lg-85px {
    min-width: 85px !important;
  }
  .min-w-lg-90px {
    min-width: 90px !important;
  }
  .min-w-lg-95px {
    min-width: 95px !important;
  }
  .min-w-lg-100px {
    min-width: 100px !important;
  }
  .min-w-lg-125px {
    min-width: 125px !important;
  }
  .min-w-lg-150px {
    min-width: 150px !important;
  }
  .min-w-lg-175px {
    min-width: 175px !important;
  }
  .min-w-lg-200px {
    min-width: 200px !important;
  }
  .min-w-lg-225px {
    min-width: 225px !important;
  }
  .min-w-lg-250px {
    min-width: 250px !important;
  }
  .min-w-lg-275px {
    min-width: 275px !important;
  }
  .min-w-lg-300px {
    min-width: 300px !important;
  }
  .min-w-lg-325px {
    min-width: 325px !important;
  }
  .min-w-lg-350px {
    min-width: 350px !important;
  }
  .min-w-lg-375px {
    min-width: 375px !important;
  }
  .min-w-lg-400px {
    min-width: 400px !important;
  }
  .min-w-lg-425px {
    min-width: 425px !important;
  }
  .min-w-lg-450px {
    min-width: 450px !important;
  }
  .min-w-lg-475px {
    min-width: 475px !important;
  }
  .min-w-lg-500px {
    min-width: 500px !important;
  }
  .min-w-lg-550px {
    min-width: 550px !important;
  }
  .min-w-lg-600px {
    min-width: 600px !important;
  }
  .min-w-lg-650px {
    min-width: 650px !important;
  }
  .min-w-lg-700px {
    min-width: 700px !important;
  }
  .min-w-lg-750px {
    min-width: 750px !important;
  }
  .min-w-lg-800px {
    min-width: 800px !important;
  }
  .min-w-lg-850px {
    min-width: 850px !important;
  }
  .min-w-lg-900px {
    min-width: 900px !important;
  }
  .min-w-lg-950px {
    min-width: 950px !important;
  }
  .min-w-lg-1000px {
    min-width: 1000px !important;
  }
  .min-h-lg-unset {
    min-height: unset !important;
  }
  .min-h-lg-25 {
    min-height: 25% !important;
  }
  .min-h-lg-50 {
    min-height: 50% !important;
  }
  .min-h-lg-75 {
    min-height: 75% !important;
  }
  .min-h-lg-100 {
    min-height: 100% !important;
  }
  .min-h-lg-auto {
    min-height: auto !important;
  }
  .min-h-lg-1px {
    min-height: 1px !important;
  }
  .min-h-lg-2px {
    min-height: 2px !important;
  }
  .min-h-lg-3px {
    min-height: 3px !important;
  }
  .min-h-lg-4px {
    min-height: 4px !important;
  }
  .min-h-lg-5px {
    min-height: 5px !important;
  }
  .min-h-lg-6px {
    min-height: 6px !important;
  }
  .min-h-lg-7px {
    min-height: 7px !important;
  }
  .min-h-lg-8px {
    min-height: 8px !important;
  }
  .min-h-lg-9px {
    min-height: 9px !important;
  }
  .min-h-lg-10px {
    min-height: 10px !important;
  }
  .min-h-lg-15px {
    min-height: 15px !important;
  }
  .min-h-lg-20px {
    min-height: 20px !important;
  }
  .min-h-lg-25px {
    min-height: 25px !important;
  }
  .min-h-lg-30px {
    min-height: 30px !important;
  }
  .min-h-lg-35px {
    min-height: 35px !important;
  }
  .min-h-lg-40px {
    min-height: 40px !important;
  }
  .min-h-lg-45px {
    min-height: 45px !important;
  }
  .min-h-lg-50px {
    min-height: 50px !important;
  }
  .min-h-lg-55px {
    min-height: 55px !important;
  }
  .min-h-lg-60px {
    min-height: 60px !important;
  }
  .min-h-lg-65px {
    min-height: 65px !important;
  }
  .min-h-lg-70px {
    min-height: 70px !important;
  }
  .min-h-lg-75px {
    min-height: 75px !important;
  }
  .min-h-lg-80px {
    min-height: 80px !important;
  }
  .min-h-lg-85px {
    min-height: 85px !important;
  }
  .min-h-lg-90px {
    min-height: 90px !important;
  }
  .min-h-lg-95px {
    min-height: 95px !important;
  }
  .min-h-lg-100px {
    min-height: 100px !important;
  }
  .min-h-lg-125px {
    min-height: 125px !important;
  }
  .min-h-lg-150px {
    min-height: 150px !important;
  }
  .min-h-lg-175px {
    min-height: 175px !important;
  }
  .min-h-lg-200px {
    min-height: 200px !important;
  }
  .min-h-lg-225px {
    min-height: 225px !important;
  }
  .min-h-lg-250px {
    min-height: 250px !important;
  }
  .min-h-lg-275px {
    min-height: 275px !important;
  }
  .min-h-lg-300px {
    min-height: 300px !important;
  }
  .min-h-lg-325px {
    min-height: 325px !important;
  }
  .min-h-lg-350px {
    min-height: 350px !important;
  }
  .min-h-lg-375px {
    min-height: 375px !important;
  }
  .min-h-lg-400px {
    min-height: 400px !important;
  }
  .min-h-lg-425px {
    min-height: 425px !important;
  }
  .min-h-lg-450px {
    min-height: 450px !important;
  }
  .min-h-lg-475px {
    min-height: 475px !important;
  }
  .min-h-lg-500px {
    min-height: 500px !important;
  }
  .min-h-lg-550px {
    min-height: 550px !important;
  }
  .min-h-lg-600px {
    min-height: 600px !important;
  }
  .min-h-lg-650px {
    min-height: 650px !important;
  }
  .min-h-lg-700px {
    min-height: 700px !important;
  }
  .min-h-lg-750px {
    min-height: 750px !important;
  }
  .min-h-lg-800px {
    min-height: 800px !important;
  }
  .min-h-lg-850px {
    min-height: 850px !important;
  }
  .min-h-lg-900px {
    min-height: 900px !important;
  }
  .min-h-lg-950px {
    min-height: 950px !important;
  }
  .min-h-lg-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .overflow-xl-auto {
    overflow: auto !important;
  }
  .overflow-xl-hidden {
    overflow: hidden !important;
  }
  .overflow-xl-visible {
    overflow: visible !important;
  }
  .overflow-xl-scroll {
    overflow: scroll !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .position-xl-static {
    position: static !important;
  }
  .position-xl-relative {
    position: relative !important;
  }
  .position-xl-absolute {
    position: absolute !important;
  }
  .position-xl-fixed {
    position: fixed !important;
  }
  .position-xl-sticky {
    position: sticky !important;
  }
  .w-xl-unset {
    width: unset !important;
  }
  .w-xl-25 {
    width: 25% !important;
  }
  .w-xl-50 {
    width: 50% !important;
  }
  .w-xl-75 {
    width: 75% !important;
  }
  .w-xl-100 {
    width: 100% !important;
  }
  .w-xl-auto {
    width: auto !important;
  }
  .w-xl-1px {
    width: 1px !important;
  }
  .w-xl-2px {
    width: 2px !important;
  }
  .w-xl-3px {
    width: 3px !important;
  }
  .w-xl-4px {
    width: 4px !important;
  }
  .w-xl-5px {
    width: 5px !important;
  }
  .w-xl-6px {
    width: 6px !important;
  }
  .w-xl-7px {
    width: 7px !important;
  }
  .w-xl-8px {
    width: 8px !important;
  }
  .w-xl-9px {
    width: 9px !important;
  }
  .w-xl-10px {
    width: 10px !important;
  }
  .w-xl-15px {
    width: 15px !important;
  }
  .w-xl-20px {
    width: 20px !important;
  }
  .w-xl-25px {
    width: 25px !important;
  }
  .w-xl-30px {
    width: 30px !important;
  }
  .w-xl-35px {
    width: 35px !important;
  }
  .w-xl-40px {
    width: 40px !important;
  }
  .w-xl-45px {
    width: 45px !important;
  }
  .w-xl-50px {
    width: 50px !important;
  }
  .w-xl-55px {
    width: 55px !important;
  }
  .w-xl-60px {
    width: 60px !important;
  }
  .w-xl-65px {
    width: 65px !important;
  }
  .w-xl-70px {
    width: 70px !important;
  }
  .w-xl-75px {
    width: 75px !important;
  }
  .w-xl-80px {
    width: 80px !important;
  }
  .w-xl-85px {
    width: 85px !important;
  }
  .w-xl-90px {
    width: 90px !important;
  }
  .w-xl-95px {
    width: 95px !important;
  }
  .w-xl-100px {
    width: 100px !important;
  }
  .w-xl-125px {
    width: 125px !important;
  }
  .w-xl-150px {
    width: 150px !important;
  }
  .w-xl-175px {
    width: 175px !important;
  }
  .w-xl-200px {
    width: 200px !important;
  }
  .w-xl-225px {
    width: 225px !important;
  }
  .w-xl-250px {
    width: 250px !important;
  }
  .w-xl-275px {
    width: 275px !important;
  }
  .w-xl-300px {
    width: 300px !important;
  }
  .w-xl-325px {
    width: 325px !important;
  }
  .w-xl-350px {
    width: 350px !important;
  }
  .w-xl-375px {
    width: 375px !important;
  }
  .w-xl-400px {
    width: 400px !important;
  }
  .w-xl-425px {
    width: 425px !important;
  }
  .w-xl-450px {
    width: 450px !important;
  }
  .w-xl-475px {
    width: 475px !important;
  }
  .w-xl-500px {
    width: 500px !important;
  }
  .w-xl-550px {
    width: 550px !important;
  }
  .w-xl-600px {
    width: 600px !important;
  }
  .w-xl-650px {
    width: 650px !important;
  }
  .w-xl-700px {
    width: 700px !important;
  }
  .w-xl-750px {
    width: 750px !important;
  }
  .w-xl-800px {
    width: 800px !important;
  }
  .w-xl-850px {
    width: 850px !important;
  }
  .w-xl-900px {
    width: 900px !important;
  }
  .w-xl-950px {
    width: 950px !important;
  }
  .w-xl-1000px {
    width: 1000px !important;
  }
  .mw-xl-unset {
    max-width: unset !important;
  }
  .mw-xl-25 {
    max-width: 25% !important;
  }
  .mw-xl-50 {
    max-width: 50% !important;
  }
  .mw-xl-75 {
    max-width: 75% !important;
  }
  .mw-xl-100 {
    max-width: 100% !important;
  }
  .mw-xl-auto {
    max-width: auto !important;
  }
  .mw-xl-1px {
    max-width: 1px !important;
  }
  .mw-xl-2px {
    max-width: 2px !important;
  }
  .mw-xl-3px {
    max-width: 3px !important;
  }
  .mw-xl-4px {
    max-width: 4px !important;
  }
  .mw-xl-5px {
    max-width: 5px !important;
  }
  .mw-xl-6px {
    max-width: 6px !important;
  }
  .mw-xl-7px {
    max-width: 7px !important;
  }
  .mw-xl-8px {
    max-width: 8px !important;
  }
  .mw-xl-9px {
    max-width: 9px !important;
  }
  .mw-xl-10px {
    max-width: 10px !important;
  }
  .mw-xl-15px {
    max-width: 15px !important;
  }
  .mw-xl-20px {
    max-width: 20px !important;
  }
  .mw-xl-25px {
    max-width: 25px !important;
  }
  .mw-xl-30px {
    max-width: 30px !important;
  }
  .mw-xl-35px {
    max-width: 35px !important;
  }
  .mw-xl-40px {
    max-width: 40px !important;
  }
  .mw-xl-45px {
    max-width: 45px !important;
  }
  .mw-xl-50px {
    max-width: 50px !important;
  }
  .mw-xl-55px {
    max-width: 55px !important;
  }
  .mw-xl-60px {
    max-width: 60px !important;
  }
  .mw-xl-65px {
    max-width: 65px !important;
  }
  .mw-xl-70px {
    max-width: 70px !important;
  }
  .mw-xl-75px {
    max-width: 75px !important;
  }
  .mw-xl-80px {
    max-width: 80px !important;
  }
  .mw-xl-85px {
    max-width: 85px !important;
  }
  .mw-xl-90px {
    max-width: 90px !important;
  }
  .mw-xl-95px {
    max-width: 95px !important;
  }
  .mw-xl-100px {
    max-width: 100px !important;
  }
  .mw-xl-125px {
    max-width: 125px !important;
  }
  .mw-xl-150px {
    max-width: 150px !important;
  }
  .mw-xl-175px {
    max-width: 175px !important;
  }
  .mw-xl-200px {
    max-width: 200px !important;
  }
  .mw-xl-225px {
    max-width: 225px !important;
  }
  .mw-xl-250px {
    max-width: 250px !important;
  }
  .mw-xl-275px {
    max-width: 275px !important;
  }
  .mw-xl-300px {
    max-width: 300px !important;
  }
  .mw-xl-325px {
    max-width: 325px !important;
  }
  .mw-xl-350px {
    max-width: 350px !important;
  }
  .mw-xl-375px {
    max-width: 375px !important;
  }
  .mw-xl-400px {
    max-width: 400px !important;
  }
  .mw-xl-425px {
    max-width: 425px !important;
  }
  .mw-xl-450px {
    max-width: 450px !important;
  }
  .mw-xl-475px {
    max-width: 475px !important;
  }
  .mw-xl-500px {
    max-width: 500px !important;
  }
  .mw-xl-550px {
    max-width: 550px !important;
  }
  .mw-xl-600px {
    max-width: 600px !important;
  }
  .mw-xl-650px {
    max-width: 650px !important;
  }
  .mw-xl-700px {
    max-width: 700px !important;
  }
  .mw-xl-750px {
    max-width: 750px !important;
  }
  .mw-xl-800px {
    max-width: 800px !important;
  }
  .mw-xl-850px {
    max-width: 850px !important;
  }
  .mw-xl-900px {
    max-width: 900px !important;
  }
  .mw-xl-950px {
    max-width: 950px !important;
  }
  .mw-xl-1000px {
    max-width: 1000px !important;
  }
  .h-xl-unset {
    height: unset !important;
  }
  .h-xl-25 {
    height: 25% !important;
  }
  .h-xl-50 {
    height: 50% !important;
  }
  .h-xl-75 {
    height: 75% !important;
  }
  .h-xl-100 {
    height: 100% !important;
  }
  .h-xl-auto {
    height: auto !important;
  }
  .h-xl-1px {
    height: 1px !important;
  }
  .h-xl-2px {
    height: 2px !important;
  }
  .h-xl-3px {
    height: 3px !important;
  }
  .h-xl-4px {
    height: 4px !important;
  }
  .h-xl-5px {
    height: 5px !important;
  }
  .h-xl-6px {
    height: 6px !important;
  }
  .h-xl-7px {
    height: 7px !important;
  }
  .h-xl-8px {
    height: 8px !important;
  }
  .h-xl-9px {
    height: 9px !important;
  }
  .h-xl-10px {
    height: 10px !important;
  }
  .h-xl-15px {
    height: 15px !important;
  }
  .h-xl-20px {
    height: 20px !important;
  }
  .h-xl-25px {
    height: 25px !important;
  }
  .h-xl-30px {
    height: 30px !important;
  }
  .h-xl-35px {
    height: 35px !important;
  }
  .h-xl-40px {
    height: 40px !important;
  }
  .h-xl-45px {
    height: 45px !important;
  }
  .h-xl-50px {
    height: 50px !important;
  }
  .h-xl-55px {
    height: 55px !important;
  }
  .h-xl-60px {
    height: 60px !important;
  }
  .h-xl-65px {
    height: 65px !important;
  }
  .h-xl-70px {
    height: 70px !important;
  }
  .h-xl-75px {
    height: 75px !important;
  }
  .h-xl-80px {
    height: 80px !important;
  }
  .h-xl-85px {
    height: 85px !important;
  }
  .h-xl-90px {
    height: 90px !important;
  }
  .h-xl-95px {
    height: 95px !important;
  }
  .h-xl-100px {
    height: 100px !important;
  }
  .h-xl-125px {
    height: 125px !important;
  }
  .h-xl-150px {
    height: 150px !important;
  }
  .h-xl-175px {
    height: 175px !important;
  }
  .h-xl-200px {
    height: 200px !important;
  }
  .h-xl-225px {
    height: 225px !important;
  }
  .h-xl-250px {
    height: 250px !important;
  }
  .h-xl-275px {
    height: 275px !important;
  }
  .h-xl-300px {
    height: 300px !important;
  }
  .h-xl-325px {
    height: 325px !important;
  }
  .h-xl-350px {
    height: 350px !important;
  }
  .h-xl-375px {
    height: 375px !important;
  }
  .h-xl-400px {
    height: 400px !important;
  }
  .h-xl-425px {
    height: 425px !important;
  }
  .h-xl-450px {
    height: 450px !important;
  }
  .h-xl-475px {
    height: 475px !important;
  }
  .h-xl-500px {
    height: 500px !important;
  }
  .h-xl-550px {
    height: 550px !important;
  }
  .h-xl-600px {
    height: 600px !important;
  }
  .h-xl-650px {
    height: 650px !important;
  }
  .h-xl-700px {
    height: 700px !important;
  }
  .h-xl-750px {
    height: 750px !important;
  }
  .h-xl-800px {
    height: 800px !important;
  }
  .h-xl-850px {
    height: 850px !important;
  }
  .h-xl-900px {
    height: 900px !important;
  }
  .h-xl-950px {
    height: 950px !important;
  }
  .h-xl-1000px {
    height: 1000px !important;
  }
  .mh-xl-unset {
    max-height: unset !important;
  }
  .mh-xl-25 {
    max-height: 25% !important;
  }
  .mh-xl-50 {
    max-height: 50% !important;
  }
  .mh-xl-75 {
    max-height: 75% !important;
  }
  .mh-xl-100 {
    max-height: 100% !important;
  }
  .mh-xl-auto {
    max-height: auto !important;
  }
  .mh-xl-1px {
    max-height: 1px !important;
  }
  .mh-xl-2px {
    max-height: 2px !important;
  }
  .mh-xl-3px {
    max-height: 3px !important;
  }
  .mh-xl-4px {
    max-height: 4px !important;
  }
  .mh-xl-5px {
    max-height: 5px !important;
  }
  .mh-xl-6px {
    max-height: 6px !important;
  }
  .mh-xl-7px {
    max-height: 7px !important;
  }
  .mh-xl-8px {
    max-height: 8px !important;
  }
  .mh-xl-9px {
    max-height: 9px !important;
  }
  .mh-xl-10px {
    max-height: 10px !important;
  }
  .mh-xl-15px {
    max-height: 15px !important;
  }
  .mh-xl-20px {
    max-height: 20px !important;
  }
  .mh-xl-25px {
    max-height: 25px !important;
  }
  .mh-xl-30px {
    max-height: 30px !important;
  }
  .mh-xl-35px {
    max-height: 35px !important;
  }
  .mh-xl-40px {
    max-height: 40px !important;
  }
  .mh-xl-45px {
    max-height: 45px !important;
  }
  .mh-xl-50px {
    max-height: 50px !important;
  }
  .mh-xl-55px {
    max-height: 55px !important;
  }
  .mh-xl-60px {
    max-height: 60px !important;
  }
  .mh-xl-65px {
    max-height: 65px !important;
  }
  .mh-xl-70px {
    max-height: 70px !important;
  }
  .mh-xl-75px {
    max-height: 75px !important;
  }
  .mh-xl-80px {
    max-height: 80px !important;
  }
  .mh-xl-85px {
    max-height: 85px !important;
  }
  .mh-xl-90px {
    max-height: 90px !important;
  }
  .mh-xl-95px {
    max-height: 95px !important;
  }
  .mh-xl-100px {
    max-height: 100px !important;
  }
  .mh-xl-125px {
    max-height: 125px !important;
  }
  .mh-xl-150px {
    max-height: 150px !important;
  }
  .mh-xl-175px {
    max-height: 175px !important;
  }
  .mh-xl-200px {
    max-height: 200px !important;
  }
  .mh-xl-225px {
    max-height: 225px !important;
  }
  .mh-xl-250px {
    max-height: 250px !important;
  }
  .mh-xl-275px {
    max-height: 275px !important;
  }
  .mh-xl-300px {
    max-height: 300px !important;
  }
  .mh-xl-325px {
    max-height: 325px !important;
  }
  .mh-xl-350px {
    max-height: 350px !important;
  }
  .mh-xl-375px {
    max-height: 375px !important;
  }
  .mh-xl-400px {
    max-height: 400px !important;
  }
  .mh-xl-425px {
    max-height: 425px !important;
  }
  .mh-xl-450px {
    max-height: 450px !important;
  }
  .mh-xl-475px {
    max-height: 475px !important;
  }
  .mh-xl-500px {
    max-height: 500px !important;
  }
  .mh-xl-550px {
    max-height: 550px !important;
  }
  .mh-xl-600px {
    max-height: 600px !important;
  }
  .mh-xl-650px {
    max-height: 650px !important;
  }
  .mh-xl-700px {
    max-height: 700px !important;
  }
  .mh-xl-750px {
    max-height: 750px !important;
  }
  .mh-xl-800px {
    max-height: 800px !important;
  }
  .mh-xl-850px {
    max-height: 850px !important;
  }
  .mh-xl-900px {
    max-height: 900px !important;
  }
  .mh-xl-950px {
    max-height: 950px !important;
  }
  .mh-xl-1000px {
    max-height: 1000px !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 0.75rem !important;
  }
  .m-xl-4 {
    margin: 1rem !important;
  }
  .m-xl-5 {
    margin: 1.25rem !important;
  }
  .m-xl-6 {
    margin: 1.5rem !important;
  }
  .m-xl-7 {
    margin: 1.75rem !important;
  }
  .m-xl-8 {
    margin: 2rem !important;
  }
  .m-xl-9 {
    margin: 2.25rem !important;
  }
  .m-xl-10 {
    margin: 2.5rem !important;
  }
  .m-xl-11 {
    margin: 2.75rem !important;
  }
  .m-xl-12 {
    margin: 3rem !important;
  }
  .m-xl-13 {
    margin: 3.25rem !important;
  }
  .m-xl-14 {
    margin: 3.5rem !important;
  }
  .m-xl-15 {
    margin: 3.75rem !important;
  }
  .m-xl-16 {
    margin: 4rem !important;
  }
  .m-xl-17 {
    margin: 4.25rem !important;
  }
  .m-xl-18 {
    margin: 4.5rem !important;
  }
  .m-xl-19 {
    margin: 4.75rem !important;
  }
  .m-xl-20 {
    margin: 5rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-xl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-xl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-xl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-xl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-xl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-xl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-xl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-xl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-xl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-xl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-xl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-xl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-xl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-xl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-xl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-xl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-xl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-xl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-xl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-xl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-xl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-xl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 0.75rem !important;
  }
  .mt-xl-4 {
    margin-top: 1rem !important;
  }
  .mt-xl-5 {
    margin-top: 1.25rem !important;
  }
  .mt-xl-6 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-7 {
    margin-top: 1.75rem !important;
  }
  .mt-xl-8 {
    margin-top: 2rem !important;
  }
  .mt-xl-9 {
    margin-top: 2.25rem !important;
  }
  .mt-xl-10 {
    margin-top: 2.5rem !important;
  }
  .mt-xl-11 {
    margin-top: 2.75rem !important;
  }
  .mt-xl-12 {
    margin-top: 3rem !important;
  }
  .mt-xl-13 {
    margin-top: 3.25rem !important;
  }
  .mt-xl-14 {
    margin-top: 3.5rem !important;
  }
  .mt-xl-15 {
    margin-top: 3.75rem !important;
  }
  .mt-xl-16 {
    margin-top: 4rem !important;
  }
  .mt-xl-17 {
    margin-top: 4.25rem !important;
  }
  .mt-xl-18 {
    margin-top: 4.5rem !important;
  }
  .mt-xl-19 {
    margin-top: 4.75rem !important;
  }
  .mt-xl-20 {
    margin-top: 5rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 0.75rem !important;
  }
  .me-xl-4 {
    margin-right: 1rem !important;
  }
  .me-xl-5 {
    margin-right: 1.25rem !important;
  }
  .me-xl-6 {
    margin-right: 1.5rem !important;
  }
  .me-xl-7 {
    margin-right: 1.75rem !important;
  }
  .me-xl-8 {
    margin-right: 2rem !important;
  }
  .me-xl-9 {
    margin-right: 2.25rem !important;
  }
  .me-xl-10 {
    margin-right: 2.5rem !important;
  }
  .me-xl-11 {
    margin-right: 2.75rem !important;
  }
  .me-xl-12 {
    margin-right: 3rem !important;
  }
  .me-xl-13 {
    margin-right: 3.25rem !important;
  }
  .me-xl-14 {
    margin-right: 3.5rem !important;
  }
  .me-xl-15 {
    margin-right: 3.75rem !important;
  }
  .me-xl-16 {
    margin-right: 4rem !important;
  }
  .me-xl-17 {
    margin-right: 4.25rem !important;
  }
  .me-xl-18 {
    margin-right: 4.5rem !important;
  }
  .me-xl-19 {
    margin-right: 4.75rem !important;
  }
  .me-xl-20 {
    margin-right: 5rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-xl-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-xl-8 {
    margin-bottom: 2rem !important;
  }
  .mb-xl-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xl-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-xl-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-xl-12 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-xl-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-xl-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-xl-16 {
    margin-bottom: 4rem !important;
  }
  .mb-xl-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-xl-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xl-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-xl-20 {
    margin-bottom: 5rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 0.75rem !important;
  }
  .ms-xl-4 {
    margin-left: 1rem !important;
  }
  .ms-xl-5 {
    margin-left: 1.25rem !important;
  }
  .ms-xl-6 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-7 {
    margin-left: 1.75rem !important;
  }
  .ms-xl-8 {
    margin-left: 2rem !important;
  }
  .ms-xl-9 {
    margin-left: 2.25rem !important;
  }
  .ms-xl-10 {
    margin-left: 2.5rem !important;
  }
  .ms-xl-11 {
    margin-left: 2.75rem !important;
  }
  .ms-xl-12 {
    margin-left: 3rem !important;
  }
  .ms-xl-13 {
    margin-left: 3.25rem !important;
  }
  .ms-xl-14 {
    margin-left: 3.5rem !important;
  }
  .ms-xl-15 {
    margin-left: 3.75rem !important;
  }
  .ms-xl-16 {
    margin-left: 4rem !important;
  }
  .ms-xl-17 {
    margin-left: 4.25rem !important;
  }
  .ms-xl-18 {
    margin-left: 4.5rem !important;
  }
  .ms-xl-19 {
    margin-left: 4.75rem !important;
  }
  .ms-xl-20 {
    margin-left: 5rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -0.75rem !important;
  }
  .m-xl-n4 {
    margin: -1rem !important;
  }
  .m-xl-n5 {
    margin: -1.25rem !important;
  }
  .m-xl-n6 {
    margin: -1.5rem !important;
  }
  .m-xl-n7 {
    margin: -1.75rem !important;
  }
  .m-xl-n8 {
    margin: -2rem !important;
  }
  .m-xl-n9 {
    margin: -2.25rem !important;
  }
  .m-xl-n10 {
    margin: -2.5rem !important;
  }
  .m-xl-n11 {
    margin: -2.75rem !important;
  }
  .m-xl-n12 {
    margin: -3rem !important;
  }
  .m-xl-n13 {
    margin: -3.25rem !important;
  }
  .m-xl-n14 {
    margin: -3.5rem !important;
  }
  .m-xl-n15 {
    margin: -3.75rem !important;
  }
  .m-xl-n16 {
    margin: -4rem !important;
  }
  .m-xl-n17 {
    margin: -4.25rem !important;
  }
  .m-xl-n18 {
    margin: -4.5rem !important;
  }
  .m-xl-n19 {
    margin: -4.75rem !important;
  }
  .m-xl-n20 {
    margin: -5rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-xl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-xl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-xl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-xl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-xl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-xl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-xl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-xl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-xl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-xl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-xl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-xl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-xl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-xl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-xl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-xl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-xl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-xl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-xl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-xl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-xl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-xl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-xl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-xl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1rem !important;
  }
  .mt-xl-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-xl-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-xl-n8 {
    margin-top: -2rem !important;
  }
  .mt-xl-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-xl-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-xl-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-xl-n12 {
    margin-top: -3rem !important;
  }
  .mt-xl-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-xl-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-xl-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-xl-n16 {
    margin-top: -4rem !important;
  }
  .mt-xl-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-xl-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-xl-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-xl-n20 {
    margin-top: -5rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -0.75rem !important;
  }
  .me-xl-n4 {
    margin-right: -1rem !important;
  }
  .me-xl-n5 {
    margin-right: -1.25rem !important;
  }
  .me-xl-n6 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n7 {
    margin-right: -1.75rem !important;
  }
  .me-xl-n8 {
    margin-right: -2rem !important;
  }
  .me-xl-n9 {
    margin-right: -2.25rem !important;
  }
  .me-xl-n10 {
    margin-right: -2.5rem !important;
  }
  .me-xl-n11 {
    margin-right: -2.75rem !important;
  }
  .me-xl-n12 {
    margin-right: -3rem !important;
  }
  .me-xl-n13 {
    margin-right: -3.25rem !important;
  }
  .me-xl-n14 {
    margin-right: -3.5rem !important;
  }
  .me-xl-n15 {
    margin-right: -3.75rem !important;
  }
  .me-xl-n16 {
    margin-right: -4rem !important;
  }
  .me-xl-n17 {
    margin-right: -4.25rem !important;
  }
  .me-xl-n18 {
    margin-right: -4.5rem !important;
  }
  .me-xl-n19 {
    margin-right: -4.75rem !important;
  }
  .me-xl-n20 {
    margin-right: -5rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-xl-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-xl-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-xl-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xl-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-xl-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-xl-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-xl-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-xl-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-xl-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-xl-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-xl-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-xl-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-xl-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-xl-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1rem !important;
  }
  .ms-xl-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-xl-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-xl-n8 {
    margin-left: -2rem !important;
  }
  .ms-xl-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-xl-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-xl-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-xl-n12 {
    margin-left: -3rem !important;
  }
  .ms-xl-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-xl-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-xl-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-xl-n16 {
    margin-left: -4rem !important;
  }
  .ms-xl-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-xl-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-xl-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-xl-n20 {
    margin-left: -5rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 0.75rem !important;
  }
  .p-xl-4 {
    padding: 1rem !important;
  }
  .p-xl-5 {
    padding: 1.25rem !important;
  }
  .p-xl-6 {
    padding: 1.5rem !important;
  }
  .p-xl-7 {
    padding: 1.75rem !important;
  }
  .p-xl-8 {
    padding: 2rem !important;
  }
  .p-xl-9 {
    padding: 2.25rem !important;
  }
  .p-xl-10 {
    padding: 2.5rem !important;
  }
  .p-xl-11 {
    padding: 2.75rem !important;
  }
  .p-xl-12 {
    padding: 3rem !important;
  }
  .p-xl-13 {
    padding: 3.25rem !important;
  }
  .p-xl-14 {
    padding: 3.5rem !important;
  }
  .p-xl-15 {
    padding: 3.75rem !important;
  }
  .p-xl-16 {
    padding: 4rem !important;
  }
  .p-xl-17 {
    padding: 4.25rem !important;
  }
  .p-xl-18 {
    padding: 4.5rem !important;
  }
  .p-xl-19 {
    padding: 4.75rem !important;
  }
  .p-xl-20 {
    padding: 5rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-xl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-xl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-xl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-xl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-xl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-xl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-xl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-xl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-xl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-xl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-xl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-xl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-xl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-xl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-xl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-xl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-xl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-xl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-xl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-xl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-xl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-xl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-xl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-xl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 0.75rem !important;
  }
  .pt-xl-4 {
    padding-top: 1rem !important;
  }
  .pt-xl-5 {
    padding-top: 1.25rem !important;
  }
  .pt-xl-6 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-7 {
    padding-top: 1.75rem !important;
  }
  .pt-xl-8 {
    padding-top: 2rem !important;
  }
  .pt-xl-9 {
    padding-top: 2.25rem !important;
  }
  .pt-xl-10 {
    padding-top: 2.5rem !important;
  }
  .pt-xl-11 {
    padding-top: 2.75rem !important;
  }
  .pt-xl-12 {
    padding-top: 3rem !important;
  }
  .pt-xl-13 {
    padding-top: 3.25rem !important;
  }
  .pt-xl-14 {
    padding-top: 3.5rem !important;
  }
  .pt-xl-15 {
    padding-top: 3.75rem !important;
  }
  .pt-xl-16 {
    padding-top: 4rem !important;
  }
  .pt-xl-17 {
    padding-top: 4.25rem !important;
  }
  .pt-xl-18 {
    padding-top: 4.5rem !important;
  }
  .pt-xl-19 {
    padding-top: 4.75rem !important;
  }
  .pt-xl-20 {
    padding-top: 5rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 0.75rem !important;
  }
  .pe-xl-4 {
    padding-right: 1rem !important;
  }
  .pe-xl-5 {
    padding-right: 1.25rem !important;
  }
  .pe-xl-6 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-7 {
    padding-right: 1.75rem !important;
  }
  .pe-xl-8 {
    padding-right: 2rem !important;
  }
  .pe-xl-9 {
    padding-right: 2.25rem !important;
  }
  .pe-xl-10 {
    padding-right: 2.5rem !important;
  }
  .pe-xl-11 {
    padding-right: 2.75rem !important;
  }
  .pe-xl-12 {
    padding-right: 3rem !important;
  }
  .pe-xl-13 {
    padding-right: 3.25rem !important;
  }
  .pe-xl-14 {
    padding-right: 3.5rem !important;
  }
  .pe-xl-15 {
    padding-right: 3.75rem !important;
  }
  .pe-xl-16 {
    padding-right: 4rem !important;
  }
  .pe-xl-17 {
    padding-right: 4.25rem !important;
  }
  .pe-xl-18 {
    padding-right: 4.5rem !important;
  }
  .pe-xl-19 {
    padding-right: 4.75rem !important;
  }
  .pe-xl-20 {
    padding-right: 5rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-xl-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-xl-8 {
    padding-bottom: 2rem !important;
  }
  .pb-xl-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xl-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-xl-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-xl-12 {
    padding-bottom: 3rem !important;
  }
  .pb-xl-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-xl-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-xl-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-xl-16 {
    padding-bottom: 4rem !important;
  }
  .pb-xl-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-xl-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-xl-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-xl-20 {
    padding-bottom: 5rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 0.75rem !important;
  }
  .ps-xl-4 {
    padding-left: 1rem !important;
  }
  .ps-xl-5 {
    padding-left: 1.25rem !important;
  }
  .ps-xl-6 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-7 {
    padding-left: 1.75rem !important;
  }
  .ps-xl-8 {
    padding-left: 2rem !important;
  }
  .ps-xl-9 {
    padding-left: 2.25rem !important;
  }
  .ps-xl-10 {
    padding-left: 2.5rem !important;
  }
  .ps-xl-11 {
    padding-left: 2.75rem !important;
  }
  .ps-xl-12 {
    padding-left: 3rem !important;
  }
  .ps-xl-13 {
    padding-left: 3.25rem !important;
  }
  .ps-xl-14 {
    padding-left: 3.5rem !important;
  }
  .ps-xl-15 {
    padding-left: 3.75rem !important;
  }
  .ps-xl-16 {
    padding-left: 4rem !important;
  }
  .ps-xl-17 {
    padding-left: 4.25rem !important;
  }
  .ps-xl-18 {
    padding-left: 4.5rem !important;
  }
  .ps-xl-19 {
    padding-left: 4.75rem !important;
  }
  .ps-xl-20 {
    padding-left: 5rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 0.75rem !important;
  }
  .gap-xl-4 {
    gap: 1rem !important;
  }
  .gap-xl-5 {
    gap: 1.25rem !important;
  }
  .gap-xl-6 {
    gap: 1.5rem !important;
  }
  .gap-xl-7 {
    gap: 1.75rem !important;
  }
  .gap-xl-8 {
    gap: 2rem !important;
  }
  .gap-xl-9 {
    gap: 2.25rem !important;
  }
  .gap-xl-10 {
    gap: 2.5rem !important;
  }
  .gap-xl-11 {
    gap: 2.75rem !important;
  }
  .gap-xl-12 {
    gap: 3rem !important;
  }
  .gap-xl-13 {
    gap: 3.25rem !important;
  }
  .gap-xl-14 {
    gap: 3.5rem !important;
  }
  .gap-xl-15 {
    gap: 3.75rem !important;
  }
  .gap-xl-16 {
    gap: 4rem !important;
  }
  .gap-xl-17 {
    gap: 4.25rem !important;
  }
  .gap-xl-18 {
    gap: 4.5rem !important;
  }
  .gap-xl-19 {
    gap: 4.75rem !important;
  }
  .gap-xl-20 {
    gap: 5rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-xl-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-xl-8 {
    row-gap: 2rem !important;
  }
  .row-gap-xl-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-xl-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-xl-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-xl-12 {
    row-gap: 3rem !important;
  }
  .row-gap-xl-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-xl-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-xl-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-xl-16 {
    row-gap: 4rem !important;
  }
  .row-gap-xl-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-xl-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-xl-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-xl-20 {
    row-gap: 5rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-xl-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-xl-8 {
    column-gap: 2rem !important;
  }
  .column-gap-xl-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-xl-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-xl-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-xl-12 {
    column-gap: 3rem !important;
  }
  .column-gap-xl-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-xl-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-xl-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-xl-16 {
    column-gap: 4rem !important;
  }
  .column-gap-xl-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-xl-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-xl-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-xl-20 {
    column-gap: 5rem !important;
  }
  .fs-xl-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-xl-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-xl-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-xl-4 {
    font-size: 1.25rem !important;
  }
  .fs-xl-5 {
    font-size: 1.15rem !important;
  }
  .fs-xl-6 {
    font-size: 1.075rem !important;
  }
  .fs-xl-7 {
    font-size: 0.95rem !important;
  }
  .fs-xl-8 {
    font-size: 0.85rem !important;
  }
  .fs-xl-9 {
    font-size: 0.75rem !important;
  }
  .fs-xl-10 {
    font-size: 0.5rem !important;
  }
  .fs-xl-sm {
    font-size: 0.95rem !important;
  }
  .fs-xl-base {
    font-size: 1rem !important;
  }
  .fs-xl-lg {
    font-size: 1.075rem !important;
  }
  .fs-xl-xl {
    font-size: 1.21rem !important;
  }
  .fs-xl-fluid {
    font-size: 100% !important;
  }
  .fs-xl-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-xl-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-xl-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-xl-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-xl-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-xl-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-xl-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-xl-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-xl-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-xl-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-xl-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-xl-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-xl-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-xl-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-xl-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-xl-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-xl-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-xl-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-xl-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-xl-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-xl-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-xl-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-xl-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-xl-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
  .min-w-xl-unset {
    min-width: unset !important;
  }
  .min-w-xl-25 {
    min-width: 25% !important;
  }
  .min-w-xl-50 {
    min-width: 50% !important;
  }
  .min-w-xl-75 {
    min-width: 75% !important;
  }
  .min-w-xl-100 {
    min-width: 100% !important;
  }
  .min-w-xl-auto {
    min-width: auto !important;
  }
  .min-w-xl-1px {
    min-width: 1px !important;
  }
  .min-w-xl-2px {
    min-width: 2px !important;
  }
  .min-w-xl-3px {
    min-width: 3px !important;
  }
  .min-w-xl-4px {
    min-width: 4px !important;
  }
  .min-w-xl-5px {
    min-width: 5px !important;
  }
  .min-w-xl-6px {
    min-width: 6px !important;
  }
  .min-w-xl-7px {
    min-width: 7px !important;
  }
  .min-w-xl-8px {
    min-width: 8px !important;
  }
  .min-w-xl-9px {
    min-width: 9px !important;
  }
  .min-w-xl-10px {
    min-width: 10px !important;
  }
  .min-w-xl-15px {
    min-width: 15px !important;
  }
  .min-w-xl-20px {
    min-width: 20px !important;
  }
  .min-w-xl-25px {
    min-width: 25px !important;
  }
  .min-w-xl-30px {
    min-width: 30px !important;
  }
  .min-w-xl-35px {
    min-width: 35px !important;
  }
  .min-w-xl-40px {
    min-width: 40px !important;
  }
  .min-w-xl-45px {
    min-width: 45px !important;
  }
  .min-w-xl-50px {
    min-width: 50px !important;
  }
  .min-w-xl-55px {
    min-width: 55px !important;
  }
  .min-w-xl-60px {
    min-width: 60px !important;
  }
  .min-w-xl-65px {
    min-width: 65px !important;
  }
  .min-w-xl-70px {
    min-width: 70px !important;
  }
  .min-w-xl-75px {
    min-width: 75px !important;
  }
  .min-w-xl-80px {
    min-width: 80px !important;
  }
  .min-w-xl-85px {
    min-width: 85px !important;
  }
  .min-w-xl-90px {
    min-width: 90px !important;
  }
  .min-w-xl-95px {
    min-width: 95px !important;
  }
  .min-w-xl-100px {
    min-width: 100px !important;
  }
  .min-w-xl-125px {
    min-width: 125px !important;
  }
  .min-w-xl-150px {
    min-width: 150px !important;
  }
  .min-w-xl-175px {
    min-width: 175px !important;
  }
  .min-w-xl-200px {
    min-width: 200px !important;
  }
  .min-w-xl-225px {
    min-width: 225px !important;
  }
  .min-w-xl-250px {
    min-width: 250px !important;
  }
  .min-w-xl-275px {
    min-width: 275px !important;
  }
  .min-w-xl-300px {
    min-width: 300px !important;
  }
  .min-w-xl-325px {
    min-width: 325px !important;
  }
  .min-w-xl-350px {
    min-width: 350px !important;
  }
  .min-w-xl-375px {
    min-width: 375px !important;
  }
  .min-w-xl-400px {
    min-width: 400px !important;
  }
  .min-w-xl-425px {
    min-width: 425px !important;
  }
  .min-w-xl-450px {
    min-width: 450px !important;
  }
  .min-w-xl-475px {
    min-width: 475px !important;
  }
  .min-w-xl-500px {
    min-width: 500px !important;
  }
  .min-w-xl-550px {
    min-width: 550px !important;
  }
  .min-w-xl-600px {
    min-width: 600px !important;
  }
  .min-w-xl-650px {
    min-width: 650px !important;
  }
  .min-w-xl-700px {
    min-width: 700px !important;
  }
  .min-w-xl-750px {
    min-width: 750px !important;
  }
  .min-w-xl-800px {
    min-width: 800px !important;
  }
  .min-w-xl-850px {
    min-width: 850px !important;
  }
  .min-w-xl-900px {
    min-width: 900px !important;
  }
  .min-w-xl-950px {
    min-width: 950px !important;
  }
  .min-w-xl-1000px {
    min-width: 1000px !important;
  }
  .min-h-xl-unset {
    min-height: unset !important;
  }
  .min-h-xl-25 {
    min-height: 25% !important;
  }
  .min-h-xl-50 {
    min-height: 50% !important;
  }
  .min-h-xl-75 {
    min-height: 75% !important;
  }
  .min-h-xl-100 {
    min-height: 100% !important;
  }
  .min-h-xl-auto {
    min-height: auto !important;
  }
  .min-h-xl-1px {
    min-height: 1px !important;
  }
  .min-h-xl-2px {
    min-height: 2px !important;
  }
  .min-h-xl-3px {
    min-height: 3px !important;
  }
  .min-h-xl-4px {
    min-height: 4px !important;
  }
  .min-h-xl-5px {
    min-height: 5px !important;
  }
  .min-h-xl-6px {
    min-height: 6px !important;
  }
  .min-h-xl-7px {
    min-height: 7px !important;
  }
  .min-h-xl-8px {
    min-height: 8px !important;
  }
  .min-h-xl-9px {
    min-height: 9px !important;
  }
  .min-h-xl-10px {
    min-height: 10px !important;
  }
  .min-h-xl-15px {
    min-height: 15px !important;
  }
  .min-h-xl-20px {
    min-height: 20px !important;
  }
  .min-h-xl-25px {
    min-height: 25px !important;
  }
  .min-h-xl-30px {
    min-height: 30px !important;
  }
  .min-h-xl-35px {
    min-height: 35px !important;
  }
  .min-h-xl-40px {
    min-height: 40px !important;
  }
  .min-h-xl-45px {
    min-height: 45px !important;
  }
  .min-h-xl-50px {
    min-height: 50px !important;
  }
  .min-h-xl-55px {
    min-height: 55px !important;
  }
  .min-h-xl-60px {
    min-height: 60px !important;
  }
  .min-h-xl-65px {
    min-height: 65px !important;
  }
  .min-h-xl-70px {
    min-height: 70px !important;
  }
  .min-h-xl-75px {
    min-height: 75px !important;
  }
  .min-h-xl-80px {
    min-height: 80px !important;
  }
  .min-h-xl-85px {
    min-height: 85px !important;
  }
  .min-h-xl-90px {
    min-height: 90px !important;
  }
  .min-h-xl-95px {
    min-height: 95px !important;
  }
  .min-h-xl-100px {
    min-height: 100px !important;
  }
  .min-h-xl-125px {
    min-height: 125px !important;
  }
  .min-h-xl-150px {
    min-height: 150px !important;
  }
  .min-h-xl-175px {
    min-height: 175px !important;
  }
  .min-h-xl-200px {
    min-height: 200px !important;
  }
  .min-h-xl-225px {
    min-height: 225px !important;
  }
  .min-h-xl-250px {
    min-height: 250px !important;
  }
  .min-h-xl-275px {
    min-height: 275px !important;
  }
  .min-h-xl-300px {
    min-height: 300px !important;
  }
  .min-h-xl-325px {
    min-height: 325px !important;
  }
  .min-h-xl-350px {
    min-height: 350px !important;
  }
  .min-h-xl-375px {
    min-height: 375px !important;
  }
  .min-h-xl-400px {
    min-height: 400px !important;
  }
  .min-h-xl-425px {
    min-height: 425px !important;
  }
  .min-h-xl-450px {
    min-height: 450px !important;
  }
  .min-h-xl-475px {
    min-height: 475px !important;
  }
  .min-h-xl-500px {
    min-height: 500px !important;
  }
  .min-h-xl-550px {
    min-height: 550px !important;
  }
  .min-h-xl-600px {
    min-height: 600px !important;
  }
  .min-h-xl-650px {
    min-height: 650px !important;
  }
  .min-h-xl-700px {
    min-height: 700px !important;
  }
  .min-h-xl-750px {
    min-height: 750px !important;
  }
  .min-h-xl-800px {
    min-height: 800px !important;
  }
  .min-h-xl-850px {
    min-height: 850px !important;
  }
  .min-h-xl-900px {
    min-height: 900px !important;
  }
  .min-h-xl-950px {
    min-height: 950px !important;
  }
  .min-h-xl-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .overflow-xxl-auto {
    overflow: auto !important;
  }
  .overflow-xxl-hidden {
    overflow: hidden !important;
  }
  .overflow-xxl-visible {
    overflow: visible !important;
  }
  .overflow-xxl-scroll {
    overflow: scroll !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .position-xxl-static {
    position: static !important;
  }
  .position-xxl-relative {
    position: relative !important;
  }
  .position-xxl-absolute {
    position: absolute !important;
  }
  .position-xxl-fixed {
    position: fixed !important;
  }
  .position-xxl-sticky {
    position: sticky !important;
  }
  .w-xxl-unset {
    width: unset !important;
  }
  .w-xxl-25 {
    width: 25% !important;
  }
  .w-xxl-50 {
    width: 50% !important;
  }
  .w-xxl-75 {
    width: 75% !important;
  }
  .w-xxl-100 {
    width: 100% !important;
  }
  .w-xxl-auto {
    width: auto !important;
  }
  .w-xxl-1px {
    width: 1px !important;
  }
  .w-xxl-2px {
    width: 2px !important;
  }
  .w-xxl-3px {
    width: 3px !important;
  }
  .w-xxl-4px {
    width: 4px !important;
  }
  .w-xxl-5px {
    width: 5px !important;
  }
  .w-xxl-6px {
    width: 6px !important;
  }
  .w-xxl-7px {
    width: 7px !important;
  }
  .w-xxl-8px {
    width: 8px !important;
  }
  .w-xxl-9px {
    width: 9px !important;
  }
  .w-xxl-10px {
    width: 10px !important;
  }
  .w-xxl-15px {
    width: 15px !important;
  }
  .w-xxl-20px {
    width: 20px !important;
  }
  .w-xxl-25px {
    width: 25px !important;
  }
  .w-xxl-30px {
    width: 30px !important;
  }
  .w-xxl-35px {
    width: 35px !important;
  }
  .w-xxl-40px {
    width: 40px !important;
  }
  .w-xxl-45px {
    width: 45px !important;
  }
  .w-xxl-50px {
    width: 50px !important;
  }
  .w-xxl-55px {
    width: 55px !important;
  }
  .w-xxl-60px {
    width: 60px !important;
  }
  .w-xxl-65px {
    width: 65px !important;
  }
  .w-xxl-70px {
    width: 70px !important;
  }
  .w-xxl-75px {
    width: 75px !important;
  }
  .w-xxl-80px {
    width: 80px !important;
  }
  .w-xxl-85px {
    width: 85px !important;
  }
  .w-xxl-90px {
    width: 90px !important;
  }
  .w-xxl-95px {
    width: 95px !important;
  }
  .w-xxl-100px {
    width: 100px !important;
  }
  .w-xxl-125px {
    width: 125px !important;
  }
  .w-xxl-150px {
    width: 150px !important;
  }
  .w-xxl-175px {
    width: 175px !important;
  }
  .w-xxl-200px {
    width: 200px !important;
  }
  .w-xxl-225px {
    width: 225px !important;
  }
  .w-xxl-250px {
    width: 250px !important;
  }
  .w-xxl-275px {
    width: 275px !important;
  }
  .w-xxl-300px {
    width: 300px !important;
  }
  .w-xxl-325px {
    width: 325px !important;
  }
  .w-xxl-350px {
    width: 350px !important;
  }
  .w-xxl-375px {
    width: 375px !important;
  }
  .w-xxl-400px {
    width: 400px !important;
  }
  .w-xxl-425px {
    width: 425px !important;
  }
  .w-xxl-450px {
    width: 450px !important;
  }
  .w-xxl-475px {
    width: 475px !important;
  }
  .w-xxl-500px {
    width: 500px !important;
  }
  .w-xxl-550px {
    width: 550px !important;
  }
  .w-xxl-600px {
    width: 600px !important;
  }
  .w-xxl-650px {
    width: 650px !important;
  }
  .w-xxl-700px {
    width: 700px !important;
  }
  .w-xxl-750px {
    width: 750px !important;
  }
  .w-xxl-800px {
    width: 800px !important;
  }
  .w-xxl-850px {
    width: 850px !important;
  }
  .w-xxl-900px {
    width: 900px !important;
  }
  .w-xxl-950px {
    width: 950px !important;
  }
  .w-xxl-1000px {
    width: 1000px !important;
  }
  .mw-xxl-unset {
    max-width: unset !important;
  }
  .mw-xxl-25 {
    max-width: 25% !important;
  }
  .mw-xxl-50 {
    max-width: 50% !important;
  }
  .mw-xxl-75 {
    max-width: 75% !important;
  }
  .mw-xxl-100 {
    max-width: 100% !important;
  }
  .mw-xxl-auto {
    max-width: auto !important;
  }
  .mw-xxl-1px {
    max-width: 1px !important;
  }
  .mw-xxl-2px {
    max-width: 2px !important;
  }
  .mw-xxl-3px {
    max-width: 3px !important;
  }
  .mw-xxl-4px {
    max-width: 4px !important;
  }
  .mw-xxl-5px {
    max-width: 5px !important;
  }
  .mw-xxl-6px {
    max-width: 6px !important;
  }
  .mw-xxl-7px {
    max-width: 7px !important;
  }
  .mw-xxl-8px {
    max-width: 8px !important;
  }
  .mw-xxl-9px {
    max-width: 9px !important;
  }
  .mw-xxl-10px {
    max-width: 10px !important;
  }
  .mw-xxl-15px {
    max-width: 15px !important;
  }
  .mw-xxl-20px {
    max-width: 20px !important;
  }
  .mw-xxl-25px {
    max-width: 25px !important;
  }
  .mw-xxl-30px {
    max-width: 30px !important;
  }
  .mw-xxl-35px {
    max-width: 35px !important;
  }
  .mw-xxl-40px {
    max-width: 40px !important;
  }
  .mw-xxl-45px {
    max-width: 45px !important;
  }
  .mw-xxl-50px {
    max-width: 50px !important;
  }
  .mw-xxl-55px {
    max-width: 55px !important;
  }
  .mw-xxl-60px {
    max-width: 60px !important;
  }
  .mw-xxl-65px {
    max-width: 65px !important;
  }
  .mw-xxl-70px {
    max-width: 70px !important;
  }
  .mw-xxl-75px {
    max-width: 75px !important;
  }
  .mw-xxl-80px {
    max-width: 80px !important;
  }
  .mw-xxl-85px {
    max-width: 85px !important;
  }
  .mw-xxl-90px {
    max-width: 90px !important;
  }
  .mw-xxl-95px {
    max-width: 95px !important;
  }
  .mw-xxl-100px {
    max-width: 100px !important;
  }
  .mw-xxl-125px {
    max-width: 125px !important;
  }
  .mw-xxl-150px {
    max-width: 150px !important;
  }
  .mw-xxl-175px {
    max-width: 175px !important;
  }
  .mw-xxl-200px {
    max-width: 200px !important;
  }
  .mw-xxl-225px {
    max-width: 225px !important;
  }
  .mw-xxl-250px {
    max-width: 250px !important;
  }
  .mw-xxl-275px {
    max-width: 275px !important;
  }
  .mw-xxl-300px {
    max-width: 300px !important;
  }
  .mw-xxl-325px {
    max-width: 325px !important;
  }
  .mw-xxl-350px {
    max-width: 350px !important;
  }
  .mw-xxl-375px {
    max-width: 375px !important;
  }
  .mw-xxl-400px {
    max-width: 400px !important;
  }
  .mw-xxl-425px {
    max-width: 425px !important;
  }
  .mw-xxl-450px {
    max-width: 450px !important;
  }
  .mw-xxl-475px {
    max-width: 475px !important;
  }
  .mw-xxl-500px {
    max-width: 500px !important;
  }
  .mw-xxl-550px {
    max-width: 550px !important;
  }
  .mw-xxl-600px {
    max-width: 600px !important;
  }
  .mw-xxl-650px {
    max-width: 650px !important;
  }
  .mw-xxl-700px {
    max-width: 700px !important;
  }
  .mw-xxl-750px {
    max-width: 750px !important;
  }
  .mw-xxl-800px {
    max-width: 800px !important;
  }
  .mw-xxl-850px {
    max-width: 850px !important;
  }
  .mw-xxl-900px {
    max-width: 900px !important;
  }
  .mw-xxl-950px {
    max-width: 950px !important;
  }
  .mw-xxl-1000px {
    max-width: 1000px !important;
  }
  .h-xxl-unset {
    height: unset !important;
  }
  .h-xxl-25 {
    height: 25% !important;
  }
  .h-xxl-50 {
    height: 50% !important;
  }
  .h-xxl-75 {
    height: 75% !important;
  }
  .h-xxl-100 {
    height: 100% !important;
  }
  .h-xxl-auto {
    height: auto !important;
  }
  .h-xxl-1px {
    height: 1px !important;
  }
  .h-xxl-2px {
    height: 2px !important;
  }
  .h-xxl-3px {
    height: 3px !important;
  }
  .h-xxl-4px {
    height: 4px !important;
  }
  .h-xxl-5px {
    height: 5px !important;
  }
  .h-xxl-6px {
    height: 6px !important;
  }
  .h-xxl-7px {
    height: 7px !important;
  }
  .h-xxl-8px {
    height: 8px !important;
  }
  .h-xxl-9px {
    height: 9px !important;
  }
  .h-xxl-10px {
    height: 10px !important;
  }
  .h-xxl-15px {
    height: 15px !important;
  }
  .h-xxl-20px {
    height: 20px !important;
  }
  .h-xxl-25px {
    height: 25px !important;
  }
  .h-xxl-30px {
    height: 30px !important;
  }
  .h-xxl-35px {
    height: 35px !important;
  }
  .h-xxl-40px {
    height: 40px !important;
  }
  .h-xxl-45px {
    height: 45px !important;
  }
  .h-xxl-50px {
    height: 50px !important;
  }
  .h-xxl-55px {
    height: 55px !important;
  }
  .h-xxl-60px {
    height: 60px !important;
  }
  .h-xxl-65px {
    height: 65px !important;
  }
  .h-xxl-70px {
    height: 70px !important;
  }
  .h-xxl-75px {
    height: 75px !important;
  }
  .h-xxl-80px {
    height: 80px !important;
  }
  .h-xxl-85px {
    height: 85px !important;
  }
  .h-xxl-90px {
    height: 90px !important;
  }
  .h-xxl-95px {
    height: 95px !important;
  }
  .h-xxl-100px {
    height: 100px !important;
  }
  .h-xxl-125px {
    height: 125px !important;
  }
  .h-xxl-150px {
    height: 150px !important;
  }
  .h-xxl-175px {
    height: 175px !important;
  }
  .h-xxl-200px {
    height: 200px !important;
  }
  .h-xxl-225px {
    height: 225px !important;
  }
  .h-xxl-250px {
    height: 250px !important;
  }
  .h-xxl-275px {
    height: 275px !important;
  }
  .h-xxl-300px {
    height: 300px !important;
  }
  .h-xxl-325px {
    height: 325px !important;
  }
  .h-xxl-350px {
    height: 350px !important;
  }
  .h-xxl-375px {
    height: 375px !important;
  }
  .h-xxl-400px {
    height: 400px !important;
  }
  .h-xxl-425px {
    height: 425px !important;
  }
  .h-xxl-450px {
    height: 450px !important;
  }
  .h-xxl-475px {
    height: 475px !important;
  }
  .h-xxl-500px {
    height: 500px !important;
  }
  .h-xxl-550px {
    height: 550px !important;
  }
  .h-xxl-600px {
    height: 600px !important;
  }
  .h-xxl-650px {
    height: 650px !important;
  }
  .h-xxl-700px {
    height: 700px !important;
  }
  .h-xxl-750px {
    height: 750px !important;
  }
  .h-xxl-800px {
    height: 800px !important;
  }
  .h-xxl-850px {
    height: 850px !important;
  }
  .h-xxl-900px {
    height: 900px !important;
  }
  .h-xxl-950px {
    height: 950px !important;
  }
  .h-xxl-1000px {
    height: 1000px !important;
  }
  .mh-xxl-unset {
    max-height: unset !important;
  }
  .mh-xxl-25 {
    max-height: 25% !important;
  }
  .mh-xxl-50 {
    max-height: 50% !important;
  }
  .mh-xxl-75 {
    max-height: 75% !important;
  }
  .mh-xxl-100 {
    max-height: 100% !important;
  }
  .mh-xxl-auto {
    max-height: auto !important;
  }
  .mh-xxl-1px {
    max-height: 1px !important;
  }
  .mh-xxl-2px {
    max-height: 2px !important;
  }
  .mh-xxl-3px {
    max-height: 3px !important;
  }
  .mh-xxl-4px {
    max-height: 4px !important;
  }
  .mh-xxl-5px {
    max-height: 5px !important;
  }
  .mh-xxl-6px {
    max-height: 6px !important;
  }
  .mh-xxl-7px {
    max-height: 7px !important;
  }
  .mh-xxl-8px {
    max-height: 8px !important;
  }
  .mh-xxl-9px {
    max-height: 9px !important;
  }
  .mh-xxl-10px {
    max-height: 10px !important;
  }
  .mh-xxl-15px {
    max-height: 15px !important;
  }
  .mh-xxl-20px {
    max-height: 20px !important;
  }
  .mh-xxl-25px {
    max-height: 25px !important;
  }
  .mh-xxl-30px {
    max-height: 30px !important;
  }
  .mh-xxl-35px {
    max-height: 35px !important;
  }
  .mh-xxl-40px {
    max-height: 40px !important;
  }
  .mh-xxl-45px {
    max-height: 45px !important;
  }
  .mh-xxl-50px {
    max-height: 50px !important;
  }
  .mh-xxl-55px {
    max-height: 55px !important;
  }
  .mh-xxl-60px {
    max-height: 60px !important;
  }
  .mh-xxl-65px {
    max-height: 65px !important;
  }
  .mh-xxl-70px {
    max-height: 70px !important;
  }
  .mh-xxl-75px {
    max-height: 75px !important;
  }
  .mh-xxl-80px {
    max-height: 80px !important;
  }
  .mh-xxl-85px {
    max-height: 85px !important;
  }
  .mh-xxl-90px {
    max-height: 90px !important;
  }
  .mh-xxl-95px {
    max-height: 95px !important;
  }
  .mh-xxl-100px {
    max-height: 100px !important;
  }
  .mh-xxl-125px {
    max-height: 125px !important;
  }
  .mh-xxl-150px {
    max-height: 150px !important;
  }
  .mh-xxl-175px {
    max-height: 175px !important;
  }
  .mh-xxl-200px {
    max-height: 200px !important;
  }
  .mh-xxl-225px {
    max-height: 225px !important;
  }
  .mh-xxl-250px {
    max-height: 250px !important;
  }
  .mh-xxl-275px {
    max-height: 275px !important;
  }
  .mh-xxl-300px {
    max-height: 300px !important;
  }
  .mh-xxl-325px {
    max-height: 325px !important;
  }
  .mh-xxl-350px {
    max-height: 350px !important;
  }
  .mh-xxl-375px {
    max-height: 375px !important;
  }
  .mh-xxl-400px {
    max-height: 400px !important;
  }
  .mh-xxl-425px {
    max-height: 425px !important;
  }
  .mh-xxl-450px {
    max-height: 450px !important;
  }
  .mh-xxl-475px {
    max-height: 475px !important;
  }
  .mh-xxl-500px {
    max-height: 500px !important;
  }
  .mh-xxl-550px {
    max-height: 550px !important;
  }
  .mh-xxl-600px {
    max-height: 600px !important;
  }
  .mh-xxl-650px {
    max-height: 650px !important;
  }
  .mh-xxl-700px {
    max-height: 700px !important;
  }
  .mh-xxl-750px {
    max-height: 750px !important;
  }
  .mh-xxl-800px {
    max-height: 800px !important;
  }
  .mh-xxl-850px {
    max-height: 850px !important;
  }
  .mh-xxl-900px {
    max-height: 900px !important;
  }
  .mh-xxl-950px {
    max-height: 950px !important;
  }
  .mh-xxl-1000px {
    max-height: 1000px !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 0.75rem !important;
  }
  .m-xxl-4 {
    margin: 1rem !important;
  }
  .m-xxl-5 {
    margin: 1.25rem !important;
  }
  .m-xxl-6 {
    margin: 1.5rem !important;
  }
  .m-xxl-7 {
    margin: 1.75rem !important;
  }
  .m-xxl-8 {
    margin: 2rem !important;
  }
  .m-xxl-9 {
    margin: 2.25rem !important;
  }
  .m-xxl-10 {
    margin: 2.5rem !important;
  }
  .m-xxl-11 {
    margin: 2.75rem !important;
  }
  .m-xxl-12 {
    margin: 3rem !important;
  }
  .m-xxl-13 {
    margin: 3.25rem !important;
  }
  .m-xxl-14 {
    margin: 3.5rem !important;
  }
  .m-xxl-15 {
    margin: 3.75rem !important;
  }
  .m-xxl-16 {
    margin: 4rem !important;
  }
  .m-xxl-17 {
    margin: 4.25rem !important;
  }
  .m-xxl-18 {
    margin: 4.5rem !important;
  }
  .m-xxl-19 {
    margin: 4.75rem !important;
  }
  .m-xxl-20 {
    margin: 5rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }
  .mx-xxl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }
  .mx-xxl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }
  .mx-xxl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }
  .mx-xxl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }
  .mx-xxl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }
  .mx-xxl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }
  .mx-xxl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }
  .mx-xxl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }
  .mx-xxl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }
  .mx-xxl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }
  .mx-xxl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }
  .mx-xxl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }
  .mx-xxl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }
  .my-xxl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }
  .my-xxl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }
  .my-xxl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }
  .my-xxl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }
  .my-xxl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }
  .my-xxl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }
  .my-xxl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }
  .my-xxl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }
  .my-xxl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }
  .my-xxl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }
  .my-xxl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }
  .my-xxl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }
  .my-xxl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }
  .my-xxl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 0.75rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1rem !important;
  }
  .mt-xxl-5 {
    margin-top: 1.25rem !important;
  }
  .mt-xxl-6 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-7 {
    margin-top: 1.75rem !important;
  }
  .mt-xxl-8 {
    margin-top: 2rem !important;
  }
  .mt-xxl-9 {
    margin-top: 2.25rem !important;
  }
  .mt-xxl-10 {
    margin-top: 2.5rem !important;
  }
  .mt-xxl-11 {
    margin-top: 2.75rem !important;
  }
  .mt-xxl-12 {
    margin-top: 3rem !important;
  }
  .mt-xxl-13 {
    margin-top: 3.25rem !important;
  }
  .mt-xxl-14 {
    margin-top: 3.5rem !important;
  }
  .mt-xxl-15 {
    margin-top: 3.75rem !important;
  }
  .mt-xxl-16 {
    margin-top: 4rem !important;
  }
  .mt-xxl-17 {
    margin-top: 4.25rem !important;
  }
  .mt-xxl-18 {
    margin-top: 4.5rem !important;
  }
  .mt-xxl-19 {
    margin-top: 4.75rem !important;
  }
  .mt-xxl-20 {
    margin-top: 5rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 0.75rem !important;
  }
  .me-xxl-4 {
    margin-right: 1rem !important;
  }
  .me-xxl-5 {
    margin-right: 1.25rem !important;
  }
  .me-xxl-6 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-7 {
    margin-right: 1.75rem !important;
  }
  .me-xxl-8 {
    margin-right: 2rem !important;
  }
  .me-xxl-9 {
    margin-right: 2.25rem !important;
  }
  .me-xxl-10 {
    margin-right: 2.5rem !important;
  }
  .me-xxl-11 {
    margin-right: 2.75rem !important;
  }
  .me-xxl-12 {
    margin-right: 3rem !important;
  }
  .me-xxl-13 {
    margin-right: 3.25rem !important;
  }
  .me-xxl-14 {
    margin-right: 3.5rem !important;
  }
  .me-xxl-15 {
    margin-right: 3.75rem !important;
  }
  .me-xxl-16 {
    margin-right: 4rem !important;
  }
  .me-xxl-17 {
    margin-right: 4.25rem !important;
  }
  .me-xxl-18 {
    margin-right: 4.5rem !important;
  }
  .me-xxl-19 {
    margin-right: 4.75rem !important;
  }
  .me-xxl-20 {
    margin-right: 5rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 0.75rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 1.25rem !important;
  }
  .mb-xxl-6 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-7 {
    margin-bottom: 1.75rem !important;
  }
  .mb-xxl-8 {
    margin-bottom: 2rem !important;
  }
  .mb-xxl-9 {
    margin-bottom: 2.25rem !important;
  }
  .mb-xxl-10 {
    margin-bottom: 2.5rem !important;
  }
  .mb-xxl-11 {
    margin-bottom: 2.75rem !important;
  }
  .mb-xxl-12 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-13 {
    margin-bottom: 3.25rem !important;
  }
  .mb-xxl-14 {
    margin-bottom: 3.5rem !important;
  }
  .mb-xxl-15 {
    margin-bottom: 3.75rem !important;
  }
  .mb-xxl-16 {
    margin-bottom: 4rem !important;
  }
  .mb-xxl-17 {
    margin-bottom: 4.25rem !important;
  }
  .mb-xxl-18 {
    margin-bottom: 4.5rem !important;
  }
  .mb-xxl-19 {
    margin-bottom: 4.75rem !important;
  }
  .mb-xxl-20 {
    margin-bottom: 5rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 0.75rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1rem !important;
  }
  .ms-xxl-5 {
    margin-left: 1.25rem !important;
  }
  .ms-xxl-6 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-7 {
    margin-left: 1.75rem !important;
  }
  .ms-xxl-8 {
    margin-left: 2rem !important;
  }
  .ms-xxl-9 {
    margin-left: 2.25rem !important;
  }
  .ms-xxl-10 {
    margin-left: 2.5rem !important;
  }
  .ms-xxl-11 {
    margin-left: 2.75rem !important;
  }
  .ms-xxl-12 {
    margin-left: 3rem !important;
  }
  .ms-xxl-13 {
    margin-left: 3.25rem !important;
  }
  .ms-xxl-14 {
    margin-left: 3.5rem !important;
  }
  .ms-xxl-15 {
    margin-left: 3.75rem !important;
  }
  .ms-xxl-16 {
    margin-left: 4rem !important;
  }
  .ms-xxl-17 {
    margin-left: 4.25rem !important;
  }
  .ms-xxl-18 {
    margin-left: 4.5rem !important;
  }
  .ms-xxl-19 {
    margin-left: 4.75rem !important;
  }
  .ms-xxl-20 {
    margin-left: 5rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -0.75rem !important;
  }
  .m-xxl-n4 {
    margin: -1rem !important;
  }
  .m-xxl-n5 {
    margin: -1.25rem !important;
  }
  .m-xxl-n6 {
    margin: -1.5rem !important;
  }
  .m-xxl-n7 {
    margin: -1.75rem !important;
  }
  .m-xxl-n8 {
    margin: -2rem !important;
  }
  .m-xxl-n9 {
    margin: -2.25rem !important;
  }
  .m-xxl-n10 {
    margin: -2.5rem !important;
  }
  .m-xxl-n11 {
    margin: -2.75rem !important;
  }
  .m-xxl-n12 {
    margin: -3rem !important;
  }
  .m-xxl-n13 {
    margin: -3.25rem !important;
  }
  .m-xxl-n14 {
    margin: -3.5rem !important;
  }
  .m-xxl-n15 {
    margin: -3.75rem !important;
  }
  .m-xxl-n16 {
    margin: -4rem !important;
  }
  .m-xxl-n17 {
    margin: -4.25rem !important;
  }
  .m-xxl-n18 {
    margin: -4.5rem !important;
  }
  .m-xxl-n19 {
    margin: -4.75rem !important;
  }
  .m-xxl-n20 {
    margin: -5rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }
  .mx-xxl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }
  .mx-xxl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }
  .mx-xxl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }
  .mx-xxl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }
  .mx-xxl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }
  .mx-xxl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xxl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }
  .mx-xxl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }
  .mx-xxl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }
  .mx-xxl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }
  .mx-xxl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }
  .mx-xxl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }
  .mx-xxl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }
  .mx-xxl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }
  .my-xxl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }
  .my-xxl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }
  .my-xxl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }
  .my-xxl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }
  .my-xxl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }
  .my-xxl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xxl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }
  .my-xxl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }
  .my-xxl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }
  .my-xxl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }
  .my-xxl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }
  .my-xxl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }
  .my-xxl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }
  .my-xxl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -0.75rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -1.25rem !important;
  }
  .mt-xxl-n6 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n7 {
    margin-top: -1.75rem !important;
  }
  .mt-xxl-n8 {
    margin-top: -2rem !important;
  }
  .mt-xxl-n9 {
    margin-top: -2.25rem !important;
  }
  .mt-xxl-n10 {
    margin-top: -2.5rem !important;
  }
  .mt-xxl-n11 {
    margin-top: -2.75rem !important;
  }
  .mt-xxl-n12 {
    margin-top: -3rem !important;
  }
  .mt-xxl-n13 {
    margin-top: -3.25rem !important;
  }
  .mt-xxl-n14 {
    margin-top: -3.5rem !important;
  }
  .mt-xxl-n15 {
    margin-top: -3.75rem !important;
  }
  .mt-xxl-n16 {
    margin-top: -4rem !important;
  }
  .mt-xxl-n17 {
    margin-top: -4.25rem !important;
  }
  .mt-xxl-n18 {
    margin-top: -4.5rem !important;
  }
  .mt-xxl-n19 {
    margin-top: -4.75rem !important;
  }
  .mt-xxl-n20 {
    margin-top: -5rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -0.75rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1rem !important;
  }
  .me-xxl-n5 {
    margin-right: -1.25rem !important;
  }
  .me-xxl-n6 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n7 {
    margin-right: -1.75rem !important;
  }
  .me-xxl-n8 {
    margin-right: -2rem !important;
  }
  .me-xxl-n9 {
    margin-right: -2.25rem !important;
  }
  .me-xxl-n10 {
    margin-right: -2.5rem !important;
  }
  .me-xxl-n11 {
    margin-right: -2.75rem !important;
  }
  .me-xxl-n12 {
    margin-right: -3rem !important;
  }
  .me-xxl-n13 {
    margin-right: -3.25rem !important;
  }
  .me-xxl-n14 {
    margin-right: -3.5rem !important;
  }
  .me-xxl-n15 {
    margin-right: -3.75rem !important;
  }
  .me-xxl-n16 {
    margin-right: -4rem !important;
  }
  .me-xxl-n17 {
    margin-right: -4.25rem !important;
  }
  .me-xxl-n18 {
    margin-right: -4.5rem !important;
  }
  .me-xxl-n19 {
    margin-right: -4.75rem !important;
  }
  .me-xxl-n20 {
    margin-right: -5rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -0.75rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -1.25rem !important;
  }
  .mb-xxl-n6 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n7 {
    margin-bottom: -1.75rem !important;
  }
  .mb-xxl-n8 {
    margin-bottom: -2rem !important;
  }
  .mb-xxl-n9 {
    margin-bottom: -2.25rem !important;
  }
  .mb-xxl-n10 {
    margin-bottom: -2.5rem !important;
  }
  .mb-xxl-n11 {
    margin-bottom: -2.75rem !important;
  }
  .mb-xxl-n12 {
    margin-bottom: -3rem !important;
  }
  .mb-xxl-n13 {
    margin-bottom: -3.25rem !important;
  }
  .mb-xxl-n14 {
    margin-bottom: -3.5rem !important;
  }
  .mb-xxl-n15 {
    margin-bottom: -3.75rem !important;
  }
  .mb-xxl-n16 {
    margin-bottom: -4rem !important;
  }
  .mb-xxl-n17 {
    margin-bottom: -4.25rem !important;
  }
  .mb-xxl-n18 {
    margin-bottom: -4.5rem !important;
  }
  .mb-xxl-n19 {
    margin-bottom: -4.75rem !important;
  }
  .mb-xxl-n20 {
    margin-bottom: -5rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -0.75rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -1.25rem !important;
  }
  .ms-xxl-n6 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n7 {
    margin-left: -1.75rem !important;
  }
  .ms-xxl-n8 {
    margin-left: -2rem !important;
  }
  .ms-xxl-n9 {
    margin-left: -2.25rem !important;
  }
  .ms-xxl-n10 {
    margin-left: -2.5rem !important;
  }
  .ms-xxl-n11 {
    margin-left: -2.75rem !important;
  }
  .ms-xxl-n12 {
    margin-left: -3rem !important;
  }
  .ms-xxl-n13 {
    margin-left: -3.25rem !important;
  }
  .ms-xxl-n14 {
    margin-left: -3.5rem !important;
  }
  .ms-xxl-n15 {
    margin-left: -3.75rem !important;
  }
  .ms-xxl-n16 {
    margin-left: -4rem !important;
  }
  .ms-xxl-n17 {
    margin-left: -4.25rem !important;
  }
  .ms-xxl-n18 {
    margin-left: -4.5rem !important;
  }
  .ms-xxl-n19 {
    margin-left: -4.75rem !important;
  }
  .ms-xxl-n20 {
    margin-left: -5rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 0.75rem !important;
  }
  .p-xxl-4 {
    padding: 1rem !important;
  }
  .p-xxl-5 {
    padding: 1.25rem !important;
  }
  .p-xxl-6 {
    padding: 1.5rem !important;
  }
  .p-xxl-7 {
    padding: 1.75rem !important;
  }
  .p-xxl-8 {
    padding: 2rem !important;
  }
  .p-xxl-9 {
    padding: 2.25rem !important;
  }
  .p-xxl-10 {
    padding: 2.5rem !important;
  }
  .p-xxl-11 {
    padding: 2.75rem !important;
  }
  .p-xxl-12 {
    padding: 3rem !important;
  }
  .p-xxl-13 {
    padding: 3.25rem !important;
  }
  .p-xxl-14 {
    padding: 3.5rem !important;
  }
  .p-xxl-15 {
    padding: 3.75rem !important;
  }
  .p-xxl-16 {
    padding: 4rem !important;
  }
  .p-xxl-17 {
    padding: 4.25rem !important;
  }
  .p-xxl-18 {
    padding: 4.5rem !important;
  }
  .p-xxl-19 {
    padding: 4.75rem !important;
  }
  .p-xxl-20 {
    padding: 5rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }
  .px-xxl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }
  .px-xxl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }
  .px-xxl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .px-xxl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }
  .px-xxl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }
  .px-xxl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }
  .px-xxl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xxl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }
  .px-xxl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }
  .px-xxl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }
  .px-xxl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }
  .px-xxl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }
  .px-xxl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }
  .px-xxl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }
  .px-xxl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  .py-xxl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }
  .py-xxl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }
  .py-xxl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }
  .py-xxl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }
  .py-xxl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }
  .py-xxl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }
  .py-xxl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xxl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }
  .py-xxl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }
  .py-xxl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }
  .py-xxl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }
  .py-xxl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }
  .py-xxl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }
  .py-xxl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }
  .py-xxl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 0.75rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1rem !important;
  }
  .pt-xxl-5 {
    padding-top: 1.25rem !important;
  }
  .pt-xxl-6 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-7 {
    padding-top: 1.75rem !important;
  }
  .pt-xxl-8 {
    padding-top: 2rem !important;
  }
  .pt-xxl-9 {
    padding-top: 2.25rem !important;
  }
  .pt-xxl-10 {
    padding-top: 2.5rem !important;
  }
  .pt-xxl-11 {
    padding-top: 2.75rem !important;
  }
  .pt-xxl-12 {
    padding-top: 3rem !important;
  }
  .pt-xxl-13 {
    padding-top: 3.25rem !important;
  }
  .pt-xxl-14 {
    padding-top: 3.5rem !important;
  }
  .pt-xxl-15 {
    padding-top: 3.75rem !important;
  }
  .pt-xxl-16 {
    padding-top: 4rem !important;
  }
  .pt-xxl-17 {
    padding-top: 4.25rem !important;
  }
  .pt-xxl-18 {
    padding-top: 4.5rem !important;
  }
  .pt-xxl-19 {
    padding-top: 4.75rem !important;
  }
  .pt-xxl-20 {
    padding-top: 5rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 0.75rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1rem !important;
  }
  .pe-xxl-5 {
    padding-right: 1.25rem !important;
  }
  .pe-xxl-6 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-7 {
    padding-right: 1.75rem !important;
  }
  .pe-xxl-8 {
    padding-right: 2rem !important;
  }
  .pe-xxl-9 {
    padding-right: 2.25rem !important;
  }
  .pe-xxl-10 {
    padding-right: 2.5rem !important;
  }
  .pe-xxl-11 {
    padding-right: 2.75rem !important;
  }
  .pe-xxl-12 {
    padding-right: 3rem !important;
  }
  .pe-xxl-13 {
    padding-right: 3.25rem !important;
  }
  .pe-xxl-14 {
    padding-right: 3.5rem !important;
  }
  .pe-xxl-15 {
    padding-right: 3.75rem !important;
  }
  .pe-xxl-16 {
    padding-right: 4rem !important;
  }
  .pe-xxl-17 {
    padding-right: 4.25rem !important;
  }
  .pe-xxl-18 {
    padding-right: 4.5rem !important;
  }
  .pe-xxl-19 {
    padding-right: 4.75rem !important;
  }
  .pe-xxl-20 {
    padding-right: 5rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 0.75rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 1.25rem !important;
  }
  .pb-xxl-6 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-7 {
    padding-bottom: 1.75rem !important;
  }
  .pb-xxl-8 {
    padding-bottom: 2rem !important;
  }
  .pb-xxl-9 {
    padding-bottom: 2.25rem !important;
  }
  .pb-xxl-10 {
    padding-bottom: 2.5rem !important;
  }
  .pb-xxl-11 {
    padding-bottom: 2.75rem !important;
  }
  .pb-xxl-12 {
    padding-bottom: 3rem !important;
  }
  .pb-xxl-13 {
    padding-bottom: 3.25rem !important;
  }
  .pb-xxl-14 {
    padding-bottom: 3.5rem !important;
  }
  .pb-xxl-15 {
    padding-bottom: 3.75rem !important;
  }
  .pb-xxl-16 {
    padding-bottom: 4rem !important;
  }
  .pb-xxl-17 {
    padding-bottom: 4.25rem !important;
  }
  .pb-xxl-18 {
    padding-bottom: 4.5rem !important;
  }
  .pb-xxl-19 {
    padding-bottom: 4.75rem !important;
  }
  .pb-xxl-20 {
    padding-bottom: 5rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 0.75rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1rem !important;
  }
  .ps-xxl-5 {
    padding-left: 1.25rem !important;
  }
  .ps-xxl-6 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-7 {
    padding-left: 1.75rem !important;
  }
  .ps-xxl-8 {
    padding-left: 2rem !important;
  }
  .ps-xxl-9 {
    padding-left: 2.25rem !important;
  }
  .ps-xxl-10 {
    padding-left: 2.5rem !important;
  }
  .ps-xxl-11 {
    padding-left: 2.75rem !important;
  }
  .ps-xxl-12 {
    padding-left: 3rem !important;
  }
  .ps-xxl-13 {
    padding-left: 3.25rem !important;
  }
  .ps-xxl-14 {
    padding-left: 3.5rem !important;
  }
  .ps-xxl-15 {
    padding-left: 3.75rem !important;
  }
  .ps-xxl-16 {
    padding-left: 4rem !important;
  }
  .ps-xxl-17 {
    padding-left: 4.25rem !important;
  }
  .ps-xxl-18 {
    padding-left: 4.5rem !important;
  }
  .ps-xxl-19 {
    padding-left: 4.75rem !important;
  }
  .ps-xxl-20 {
    padding-left: 5rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 0.75rem !important;
  }
  .gap-xxl-4 {
    gap: 1rem !important;
  }
  .gap-xxl-5 {
    gap: 1.25rem !important;
  }
  .gap-xxl-6 {
    gap: 1.5rem !important;
  }
  .gap-xxl-7 {
    gap: 1.75rem !important;
  }
  .gap-xxl-8 {
    gap: 2rem !important;
  }
  .gap-xxl-9 {
    gap: 2.25rem !important;
  }
  .gap-xxl-10 {
    gap: 2.5rem !important;
  }
  .gap-xxl-11 {
    gap: 2.75rem !important;
  }
  .gap-xxl-12 {
    gap: 3rem !important;
  }
  .gap-xxl-13 {
    gap: 3.25rem !important;
  }
  .gap-xxl-14 {
    gap: 3.5rem !important;
  }
  .gap-xxl-15 {
    gap: 3.75rem !important;
  }
  .gap-xxl-16 {
    gap: 4rem !important;
  }
  .gap-xxl-17 {
    gap: 4.25rem !important;
  }
  .gap-xxl-18 {
    gap: 4.5rem !important;
  }
  .gap-xxl-19 {
    gap: 4.75rem !important;
  }
  .gap-xxl-20 {
    gap: 5rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 0.75rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 1.25rem !important;
  }
  .row-gap-xxl-6 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-7 {
    row-gap: 1.75rem !important;
  }
  .row-gap-xxl-8 {
    row-gap: 2rem !important;
  }
  .row-gap-xxl-9 {
    row-gap: 2.25rem !important;
  }
  .row-gap-xxl-10 {
    row-gap: 2.5rem !important;
  }
  .row-gap-xxl-11 {
    row-gap: 2.75rem !important;
  }
  .row-gap-xxl-12 {
    row-gap: 3rem !important;
  }
  .row-gap-xxl-13 {
    row-gap: 3.25rem !important;
  }
  .row-gap-xxl-14 {
    row-gap: 3.5rem !important;
  }
  .row-gap-xxl-15 {
    row-gap: 3.75rem !important;
  }
  .row-gap-xxl-16 {
    row-gap: 4rem !important;
  }
  .row-gap-xxl-17 {
    row-gap: 4.25rem !important;
  }
  .row-gap-xxl-18 {
    row-gap: 4.5rem !important;
  }
  .row-gap-xxl-19 {
    row-gap: 4.75rem !important;
  }
  .row-gap-xxl-20 {
    row-gap: 5rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 0.75rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 1.25rem !important;
  }
  .column-gap-xxl-6 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-7 {
    column-gap: 1.75rem !important;
  }
  .column-gap-xxl-8 {
    column-gap: 2rem !important;
  }
  .column-gap-xxl-9 {
    column-gap: 2.25rem !important;
  }
  .column-gap-xxl-10 {
    column-gap: 2.5rem !important;
  }
  .column-gap-xxl-11 {
    column-gap: 2.75rem !important;
  }
  .column-gap-xxl-12 {
    column-gap: 3rem !important;
  }
  .column-gap-xxl-13 {
    column-gap: 3.25rem !important;
  }
  .column-gap-xxl-14 {
    column-gap: 3.5rem !important;
  }
  .column-gap-xxl-15 {
    column-gap: 3.75rem !important;
  }
  .column-gap-xxl-16 {
    column-gap: 4rem !important;
  }
  .column-gap-xxl-17 {
    column-gap: 4.25rem !important;
  }
  .column-gap-xxl-18 {
    column-gap: 4.5rem !important;
  }
  .column-gap-xxl-19 {
    column-gap: 4.75rem !important;
  }
  .column-gap-xxl-20 {
    column-gap: 5rem !important;
  }
  .fs-xxl-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }
  .fs-xxl-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }
  .fs-xxl-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }
  .fs-xxl-4 {
    font-size: 1.25rem !important;
  }
  .fs-xxl-5 {
    font-size: 1.15rem !important;
  }
  .fs-xxl-6 {
    font-size: 1.075rem !important;
  }
  .fs-xxl-7 {
    font-size: 0.95rem !important;
  }
  .fs-xxl-8 {
    font-size: 0.85rem !important;
  }
  .fs-xxl-9 {
    font-size: 0.75rem !important;
  }
  .fs-xxl-10 {
    font-size: 0.5rem !important;
  }
  .fs-xxl-sm {
    font-size: 0.95rem !important;
  }
  .fs-xxl-base {
    font-size: 1rem !important;
  }
  .fs-xxl-lg {
    font-size: 1.075rem !important;
  }
  .fs-xxl-xl {
    font-size: 1.21rem !important;
  }
  .fs-xxl-fluid {
    font-size: 100% !important;
  }
  .fs-xxl-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }
  .fs-xxl-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }
  .fs-xxl-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }
  .fs-xxl-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }
  .fs-xxl-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }
  .fs-xxl-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }
  .fs-xxl-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }
  .fs-xxl-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }
  .fs-xxl-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }
  .fs-xxl-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }
  .fs-xxl-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }
  .fs-xxl-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }
  .fs-xxl-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }
  .fs-xxl-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }
  .fs-xxl-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }
  .fs-xxl-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }
  .fs-xxl-6x {
    font-size: calc(1.725rem + 5.7vw) !important;
  }
  .fs-xxl-6qx {
    font-size: calc(1.75rem + 6vw) !important;
  }
  .fs-xxl-6hx {
    font-size: calc(1.775rem + 6.3vw) !important;
  }
  .fs-xxl-6tx {
    font-size: calc(1.8rem + 6.6vw) !important;
  }
  .fs-xxl-7x {
    font-size: calc(1.825rem + 6.9vw) !important;
  }
  .fs-xxl-7qx {
    font-size: calc(1.85rem + 7.2vw) !important;
  }
  .fs-xxl-7hx {
    font-size: calc(1.875rem + 7.5vw) !important;
  }
  .fs-xxl-7tx {
    font-size: calc(1.9rem + 7.8vw) !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
  .min-w-xxl-unset {
    min-width: unset !important;
  }
  .min-w-xxl-25 {
    min-width: 25% !important;
  }
  .min-w-xxl-50 {
    min-width: 50% !important;
  }
  .min-w-xxl-75 {
    min-width: 75% !important;
  }
  .min-w-xxl-100 {
    min-width: 100% !important;
  }
  .min-w-xxl-auto {
    min-width: auto !important;
  }
  .min-w-xxl-1px {
    min-width: 1px !important;
  }
  .min-w-xxl-2px {
    min-width: 2px !important;
  }
  .min-w-xxl-3px {
    min-width: 3px !important;
  }
  .min-w-xxl-4px {
    min-width: 4px !important;
  }
  .min-w-xxl-5px {
    min-width: 5px !important;
  }
  .min-w-xxl-6px {
    min-width: 6px !important;
  }
  .min-w-xxl-7px {
    min-width: 7px !important;
  }
  .min-w-xxl-8px {
    min-width: 8px !important;
  }
  .min-w-xxl-9px {
    min-width: 9px !important;
  }
  .min-w-xxl-10px {
    min-width: 10px !important;
  }
  .min-w-xxl-15px {
    min-width: 15px !important;
  }
  .min-w-xxl-20px {
    min-width: 20px !important;
  }
  .min-w-xxl-25px {
    min-width: 25px !important;
  }
  .min-w-xxl-30px {
    min-width: 30px !important;
  }
  .min-w-xxl-35px {
    min-width: 35px !important;
  }
  .min-w-xxl-40px {
    min-width: 40px !important;
  }
  .min-w-xxl-45px {
    min-width: 45px !important;
  }
  .min-w-xxl-50px {
    min-width: 50px !important;
  }
  .min-w-xxl-55px {
    min-width: 55px !important;
  }
  .min-w-xxl-60px {
    min-width: 60px !important;
  }
  .min-w-xxl-65px {
    min-width: 65px !important;
  }
  .min-w-xxl-70px {
    min-width: 70px !important;
  }
  .min-w-xxl-75px {
    min-width: 75px !important;
  }
  .min-w-xxl-80px {
    min-width: 80px !important;
  }
  .min-w-xxl-85px {
    min-width: 85px !important;
  }
  .min-w-xxl-90px {
    min-width: 90px !important;
  }
  .min-w-xxl-95px {
    min-width: 95px !important;
  }
  .min-w-xxl-100px {
    min-width: 100px !important;
  }
  .min-w-xxl-125px {
    min-width: 125px !important;
  }
  .min-w-xxl-150px {
    min-width: 150px !important;
  }
  .min-w-xxl-175px {
    min-width: 175px !important;
  }
  .min-w-xxl-200px {
    min-width: 200px !important;
  }
  .min-w-xxl-225px {
    min-width: 225px !important;
  }
  .min-w-xxl-250px {
    min-width: 250px !important;
  }
  .min-w-xxl-275px {
    min-width: 275px !important;
  }
  .min-w-xxl-300px {
    min-width: 300px !important;
  }
  .min-w-xxl-325px {
    min-width: 325px !important;
  }
  .min-w-xxl-350px {
    min-width: 350px !important;
  }
  .min-w-xxl-375px {
    min-width: 375px !important;
  }
  .min-w-xxl-400px {
    min-width: 400px !important;
  }
  .min-w-xxl-425px {
    min-width: 425px !important;
  }
  .min-w-xxl-450px {
    min-width: 450px !important;
  }
  .min-w-xxl-475px {
    min-width: 475px !important;
  }
  .min-w-xxl-500px {
    min-width: 500px !important;
  }
  .min-w-xxl-550px {
    min-width: 550px !important;
  }
  .min-w-xxl-600px {
    min-width: 600px !important;
  }
  .min-w-xxl-650px {
    min-width: 650px !important;
  }
  .min-w-xxl-700px {
    min-width: 700px !important;
  }
  .min-w-xxl-750px {
    min-width: 750px !important;
  }
  .min-w-xxl-800px {
    min-width: 800px !important;
  }
  .min-w-xxl-850px {
    min-width: 850px !important;
  }
  .min-w-xxl-900px {
    min-width: 900px !important;
  }
  .min-w-xxl-950px {
    min-width: 950px !important;
  }
  .min-w-xxl-1000px {
    min-width: 1000px !important;
  }
  .min-h-xxl-unset {
    min-height: unset !important;
  }
  .min-h-xxl-25 {
    min-height: 25% !important;
  }
  .min-h-xxl-50 {
    min-height: 50% !important;
  }
  .min-h-xxl-75 {
    min-height: 75% !important;
  }
  .min-h-xxl-100 {
    min-height: 100% !important;
  }
  .min-h-xxl-auto {
    min-height: auto !important;
  }
  .min-h-xxl-1px {
    min-height: 1px !important;
  }
  .min-h-xxl-2px {
    min-height: 2px !important;
  }
  .min-h-xxl-3px {
    min-height: 3px !important;
  }
  .min-h-xxl-4px {
    min-height: 4px !important;
  }
  .min-h-xxl-5px {
    min-height: 5px !important;
  }
  .min-h-xxl-6px {
    min-height: 6px !important;
  }
  .min-h-xxl-7px {
    min-height: 7px !important;
  }
  .min-h-xxl-8px {
    min-height: 8px !important;
  }
  .min-h-xxl-9px {
    min-height: 9px !important;
  }
  .min-h-xxl-10px {
    min-height: 10px !important;
  }
  .min-h-xxl-15px {
    min-height: 15px !important;
  }
  .min-h-xxl-20px {
    min-height: 20px !important;
  }
  .min-h-xxl-25px {
    min-height: 25px !important;
  }
  .min-h-xxl-30px {
    min-height: 30px !important;
  }
  .min-h-xxl-35px {
    min-height: 35px !important;
  }
  .min-h-xxl-40px {
    min-height: 40px !important;
  }
  .min-h-xxl-45px {
    min-height: 45px !important;
  }
  .min-h-xxl-50px {
    min-height: 50px !important;
  }
  .min-h-xxl-55px {
    min-height: 55px !important;
  }
  .min-h-xxl-60px {
    min-height: 60px !important;
  }
  .min-h-xxl-65px {
    min-height: 65px !important;
  }
  .min-h-xxl-70px {
    min-height: 70px !important;
  }
  .min-h-xxl-75px {
    min-height: 75px !important;
  }
  .min-h-xxl-80px {
    min-height: 80px !important;
  }
  .min-h-xxl-85px {
    min-height: 85px !important;
  }
  .min-h-xxl-90px {
    min-height: 90px !important;
  }
  .min-h-xxl-95px {
    min-height: 95px !important;
  }
  .min-h-xxl-100px {
    min-height: 100px !important;
  }
  .min-h-xxl-125px {
    min-height: 125px !important;
  }
  .min-h-xxl-150px {
    min-height: 150px !important;
  }
  .min-h-xxl-175px {
    min-height: 175px !important;
  }
  .min-h-xxl-200px {
    min-height: 200px !important;
  }
  .min-h-xxl-225px {
    min-height: 225px !important;
  }
  .min-h-xxl-250px {
    min-height: 250px !important;
  }
  .min-h-xxl-275px {
    min-height: 275px !important;
  }
  .min-h-xxl-300px {
    min-height: 300px !important;
  }
  .min-h-xxl-325px {
    min-height: 325px !important;
  }
  .min-h-xxl-350px {
    min-height: 350px !important;
  }
  .min-h-xxl-375px {
    min-height: 375px !important;
  }
  .min-h-xxl-400px {
    min-height: 400px !important;
  }
  .min-h-xxl-425px {
    min-height: 425px !important;
  }
  .min-h-xxl-450px {
    min-height: 450px !important;
  }
  .min-h-xxl-475px {
    min-height: 475px !important;
  }
  .min-h-xxl-500px {
    min-height: 500px !important;
  }
  .min-h-xxl-550px {
    min-height: 550px !important;
  }
  .min-h-xxl-600px {
    min-height: 600px !important;
  }
  .min-h-xxl-650px {
    min-height: 650px !important;
  }
  .min-h-xxl-700px {
    min-height: 700px !important;
  }
  .min-h-xxl-750px {
    min-height: 750px !important;
  }
  .min-h-xxl-800px {
    min-height: 800px !important;
  }
  .min-h-xxl-850px {
    min-height: 850px !important;
  }
  .min-h-xxl-900px {
    min-height: 900px !important;
  }
  .min-h-xxl-950px {
    min-height: 950px !important;
  }
  .min-h-xxl-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 1.75rem !important;
  }
  .fs-2 {
    font-size: 1.5rem !important;
  }
  .fs-3 {
    font-size: 1.35rem !important;
  }
  .fs-2x {
    font-size: 2rem !important;
  }
  .fs-2qx {
    font-size: 2.25rem !important;
  }
  .fs-2hx {
    font-size: 2.5rem !important;
  }
  .fs-2tx {
    font-size: 2.75rem !important;
  }
  .fs-3x {
    font-size: 3rem !important;
  }
  .fs-3qx {
    font-size: 3.25rem !important;
  }
  .fs-3hx {
    font-size: 3.5rem !important;
  }
  .fs-3tx {
    font-size: 3.75rem !important;
  }
  .fs-4x {
    font-size: 4rem !important;
  }
  .fs-4qx {
    font-size: 4.25rem !important;
  }
  .fs-4hx {
    font-size: 4.5rem !important;
  }
  .fs-4tx {
    font-size: 4.75rem !important;
  }
  .fs-5x {
    font-size: 5rem !important;
  }
  .fs-5qx {
    font-size: 5.25rem !important;
  }
  .fs-5hx {
    font-size: 5.5rem !important;
  }
  .fs-5tx {
    font-size: 5.75rem !important;
  }
  .fs-6x {
    font-size: 6rem !important;
  }
  .fs-6qx {
    font-size: 6.25rem !important;
  }
  .fs-6hx {
    font-size: 6.5rem !important;
  }
  .fs-6tx {
    font-size: 6.75rem !important;
  }
  .fs-7x {
    font-size: 7rem !important;
  }
  .fs-7qx {
    font-size: 7.25rem !important;
  }
  .fs-7hx {
    font-size: 7.5rem !important;
  }
  .fs-7tx {
    font-size: 7.75rem !important;
  }
  .fs-sm-1 {
    font-size: 1.75rem !important;
  }
  .fs-sm-2 {
    font-size: 1.5rem !important;
  }
  .fs-sm-3 {
    font-size: 1.35rem !important;
  }
  .fs-sm-2x {
    font-size: 2rem !important;
  }
  .fs-sm-2qx {
    font-size: 2.25rem !important;
  }
  .fs-sm-2hx {
    font-size: 2.5rem !important;
  }
  .fs-sm-2tx {
    font-size: 2.75rem !important;
  }
  .fs-sm-3x {
    font-size: 3rem !important;
  }
  .fs-sm-3qx {
    font-size: 3.25rem !important;
  }
  .fs-sm-3hx {
    font-size: 3.5rem !important;
  }
  .fs-sm-3tx {
    font-size: 3.75rem !important;
  }
  .fs-sm-4x {
    font-size: 4rem !important;
  }
  .fs-sm-4qx {
    font-size: 4.25rem !important;
  }
  .fs-sm-4hx {
    font-size: 4.5rem !important;
  }
  .fs-sm-4tx {
    font-size: 4.75rem !important;
  }
  .fs-sm-5x {
    font-size: 5rem !important;
  }
  .fs-sm-5qx {
    font-size: 5.25rem !important;
  }
  .fs-sm-5hx {
    font-size: 5.5rem !important;
  }
  .fs-sm-5tx {
    font-size: 5.75rem !important;
  }
  .fs-sm-6x {
    font-size: 6rem !important;
  }
  .fs-sm-6qx {
    font-size: 6.25rem !important;
  }
  .fs-sm-6hx {
    font-size: 6.5rem !important;
  }
  .fs-sm-6tx {
    font-size: 6.75rem !important;
  }
  .fs-sm-7x {
    font-size: 7rem !important;
  }
  .fs-sm-7qx {
    font-size: 7.25rem !important;
  }
  .fs-sm-7hx {
    font-size: 7.5rem !important;
  }
  .fs-sm-7tx {
    font-size: 7.75rem !important;
  }
  .fs-md-1 {
    font-size: 1.75rem !important;
  }
  .fs-md-2 {
    font-size: 1.5rem !important;
  }
  .fs-md-3 {
    font-size: 1.35rem !important;
  }
  .fs-md-2x {
    font-size: 2rem !important;
  }
  .fs-md-2qx {
    font-size: 2.25rem !important;
  }
  .fs-md-2hx {
    font-size: 2.5rem !important;
  }
  .fs-md-2tx {
    font-size: 2.75rem !important;
  }
  .fs-md-3x {
    font-size: 3rem !important;
  }
  .fs-md-3qx {
    font-size: 3.25rem !important;
  }
  .fs-md-3hx {
    font-size: 3.5rem !important;
  }
  .fs-md-3tx {
    font-size: 3.75rem !important;
  }
  .fs-md-4x {
    font-size: 4rem !important;
  }
  .fs-md-4qx {
    font-size: 4.25rem !important;
  }
  .fs-md-4hx {
    font-size: 4.5rem !important;
  }
  .fs-md-4tx {
    font-size: 4.75rem !important;
  }
  .fs-md-5x {
    font-size: 5rem !important;
  }
  .fs-md-5qx {
    font-size: 5.25rem !important;
  }
  .fs-md-5hx {
    font-size: 5.5rem !important;
  }
  .fs-md-5tx {
    font-size: 5.75rem !important;
  }
  .fs-md-6x {
    font-size: 6rem !important;
  }
  .fs-md-6qx {
    font-size: 6.25rem !important;
  }
  .fs-md-6hx {
    font-size: 6.5rem !important;
  }
  .fs-md-6tx {
    font-size: 6.75rem !important;
  }
  .fs-md-7x {
    font-size: 7rem !important;
  }
  .fs-md-7qx {
    font-size: 7.25rem !important;
  }
  .fs-md-7hx {
    font-size: 7.5rem !important;
  }
  .fs-md-7tx {
    font-size: 7.75rem !important;
  }
  .fs-lg-1 {
    font-size: 1.75rem !important;
  }
  .fs-lg-2 {
    font-size: 1.5rem !important;
  }
  .fs-lg-3 {
    font-size: 1.35rem !important;
  }
  .fs-lg-2x {
    font-size: 2rem !important;
  }
  .fs-lg-2qx {
    font-size: 2.25rem !important;
  }
  .fs-lg-2hx {
    font-size: 2.5rem !important;
  }
  .fs-lg-2tx {
    font-size: 2.75rem !important;
  }
  .fs-lg-3x {
    font-size: 3rem !important;
  }
  .fs-lg-3qx {
    font-size: 3.25rem !important;
  }
  .fs-lg-3hx {
    font-size: 3.5rem !important;
  }
  .fs-lg-3tx {
    font-size: 3.75rem !important;
  }
  .fs-lg-4x {
    font-size: 4rem !important;
  }
  .fs-lg-4qx {
    font-size: 4.25rem !important;
  }
  .fs-lg-4hx {
    font-size: 4.5rem !important;
  }
  .fs-lg-4tx {
    font-size: 4.75rem !important;
  }
  .fs-lg-5x {
    font-size: 5rem !important;
  }
  .fs-lg-5qx {
    font-size: 5.25rem !important;
  }
  .fs-lg-5hx {
    font-size: 5.5rem !important;
  }
  .fs-lg-5tx {
    font-size: 5.75rem !important;
  }
  .fs-lg-6x {
    font-size: 6rem !important;
  }
  .fs-lg-6qx {
    font-size: 6.25rem !important;
  }
  .fs-lg-6hx {
    font-size: 6.5rem !important;
  }
  .fs-lg-6tx {
    font-size: 6.75rem !important;
  }
  .fs-lg-7x {
    font-size: 7rem !important;
  }
  .fs-lg-7qx {
    font-size: 7.25rem !important;
  }
  .fs-lg-7hx {
    font-size: 7.5rem !important;
  }
  .fs-lg-7tx {
    font-size: 7.75rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
:root {
  --bs-xs:0;
  --bs-sm:576px;
  --bs-md:768px;
  --bs-lg:992px;
  --bs-xl:1200px;
  --bs-xxl:1400px;
  --bs-scrollbar-size: 5px;
  --bs-scrollbar-overlay-size: 19px;
  --bs-scrollbar-overlay-space: 7px;
  --bs-white-bg-rgb: 255, 255, 255;
  --bs-black-bg-rgb: 0, 0, 0;
}

[data-bs-theme=light] {
  --bs-text-muted: #99A1B7;
  --bs-gray-100: #F9F9F9;
  --bs-gray-100-rgb: 249, 249, 249;
  --bs-gray-200: #F1F1F4;
  --bs-gray-200-rgb: 241, 241, 244;
  --bs-gray-300: #DBDFE9;
  --bs-gray-300-rgb: 219, 223, 233;
  --bs-gray-400: #C4CADA;
  --bs-gray-400-rgb: 196, 202, 218;
  --bs-gray-500: #99A1B7;
  --bs-gray-500-rgb: 153, 161, 183;
  --bs-gray-600: #78829D;
  --bs-gray-600-rgb: 120, 130, 157;
  --bs-gray-700: #4B5675;
  --bs-gray-700-rgb: 75, 86, 117;
  --bs-gray-800: #252F4A;
  --bs-gray-800-rgb: 37, 47, 74;
  --bs-gray-900: #071437;
  --bs-gray-900-rgb: 7, 20, 55;
  --bs-light: #F9F9F9;
  --bs-primary: #1B84FF;
  --bs-secondary: #F9F9F9;
  --bs-success: #17C653;
  --bs-info: #7239EA;
  --bs-warning: #F6C000;
  --bs-danger: #F8285A;
  --bs-dark: #1E2129;
  --bs-primary-active: #056EE9;
  --bs-secondary-active: #DBDFE9;
  --bs-light-active: #FCFCFC;
  --bs-success-active: #04B440;
  --bs-info-active: #5014D0;
  --bs-warning-active: #DEAD00;
  --bs-danger-active: #D81A48;
  --bs-dark-active: #111318;
  --bs-primary-light: #E9F3FF;
  --bs-secondary-light: #F9F9F9;
  --bs-success-light: #DFFFEA;
  --bs-info-light: #F8F5FF;
  --bs-warning-light: #FFF8DD;
  --bs-danger-light: #FFEEF3;
  --bs-dark-light: #F9F9F9;
  --bs-light-light: #ffffff;
  --bs-primary-inverse: #ffffff;
  --bs-secondary-inverse: #252F4A;
  --bs-light-inverse: #252F4A;
  --bs-success-inverse: #ffffff;
  --bs-info-inverse: #ffffff;
  --bs-warning-inverse: #ffffff;
  --bs-danger-inverse: #ffffff;
  --bs-dark-inverse: #ffffff;
  --bs-primary-clarity: rgba(27, 132, 255, 0.2);
  --bs-secondary-clarity: rgba(249, 249, 249, 0.2);
  --bs-success-clarity: rgba(23, 198, 83, 0.2);
  --bs-info-clarity: rgba(114, 57, 234, 0.2);
  --bs-warning-clarity: rgba(246, 192, 0, 0.2);
  --bs-danger-clarity: rgba(248, 40, 90, 0.2);
  --bs-dark-clarity: rgba(30, 33, 41, 0.2);
  --bs-light-clarity: rgba(255, 255, 255, 0.2);
  --bs-light-rgb: 249, 249, 249;
  --bs-primary-rgb: 27, 132, 255;
  --bs-secondary-rgb: 249, 249, 249;
  --bs-success-rgb: 23, 198, 83;
  --bs-info-rgb: 114, 57, 234;
  --bs-warning-rgb: 246, 192, 0;
  --bs-danger-rgb: 248, 40, 90;
  --bs-dark-rgb: 30, 33, 41;
  --bs-text-white: #ffffff;
  --bs-text-primary: #1B84FF;
  --bs-text-secondary: #F9F9F9;
  --bs-text-light: #F9F9F9;
  --bs-text-success: #17C653;
  --bs-text-info: #7239EA;
  --bs-text-warning: #F6C000;
  --bs-text-danger: #F8285A;
  --bs-text-dark: #1E2129;
  --bs-text-muted: #99A1B7;
  --bs-text-gray-100: #F9F9F9;
  --bs-text-gray-200: #F1F1F4;
  --bs-text-gray-300: #DBDFE9;
  --bs-text-gray-400: #C4CADA;
  --bs-text-gray-500: #99A1B7;
  --bs-text-gray-600: #78829D;
  --bs-text-gray-700: #4B5675;
  --bs-text-gray-800: #252F4A;
  --bs-text-gray-900: #071437;
  --bs-border-color: #F1F1F4;
  --bs-border-dashed-color: #DBDFE9;
  --bs-component-active-color: #ffffff;
  --bs-component-active-bg: #1B84FF;
  --bs-component-hover-color: #1B84FF;
  --bs-component-hover-bg: #F9F9F9;
  --bs-component-checked-color: #ffffff;
  --bs-component-checked-bg: #1B84FF;
  --bs-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);
  --bs-input-bg: var(--bs-body-bg);
  --bs-input-color: var(--bs-gray-700);
  --bs-input-solid-color: var(--bs-gray-700);
  --bs-input-solid-bg: var(--bs-gray-100);
  --bs-input-solid-bg-focus: var(--bs-gray-200);
  --bs-input-solid-placeholder-color: var(--bs-gray-500);
  --bs-root-card-box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);
  --bs-root-card-border-color: #F1F1F4;
  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
  --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);
  --bs-table-loading-message-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-code-bg: #f1f3f8;
  --bs-code-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);
  --bs-code-border-color: transparent;
  --bs-code-color: #b93993;
  --bs-symbol-label-color: var(--bs-gray-800);
  --bs-symbol-label-bg: var(--bs-gray-100);
  --bs-symbol-border-color: rgba(var(--bs-body-bg), 0.5);
  --bs-bullet-bg-color: var(--bs-gray-400);
  --bs-scrolltop-opacity: 0;
  --bs-scrolltop-opacity-on: 0.3;
  --bs-scrolltop-opacity-hover: 1;
  --bs-scrolltop-box-shadow: var(--bs-box-shadow);
  --bs-scrolltop-bg-color: var(--bs-primary);
  --bs-scrolltop-bg-color-hover: var(--bs-primary);
  --bs-scrolltop-icon-color: var(--bs-primary-inverse);
  --bs-scrolltop-icon-color-hover: var(--bs-primary-inverse);
  --bs-drawer-box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);
  --bs-drawer-bg-color: #ffffff;
  --bs-drawer-overlay-bg-color: rgba(0, 0, 0, 0.2);
  --bs-menu-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-menu-dropdown-bg-color: var(--bs-body-bg);
  --bs-menu-heading-color: #99A1B7;
  --bs-menu-link-color-hover: #1B84FF;
  --bs-menu-link-color-show: #1B84FF;
  --bs-menu-link-color-here: #1B84FF;
  --bs-menu-link-color-active: #1B84FF;
  --bs-menu-link-bg-color-hover: #F9F9F9;
  --bs-menu-link-bg-color-show: #F9F9F9;
  --bs-menu-link-bg-color-here: #F9F9F9;
  --bs-menu-link-bg-color-active: #F9F9F9;
  --bs-scrollbar-color: #F1F1F4;
  --bs-scrollbar-hover-color: #DBDFE9;
  --bs-overlay-bg: rgba(0, 0, 0, 0.05);
  --bs-blockui-overlay-bg: rgba(0, 0, 0, 0.05);
  --bs-rating-color-default: #C4CADA;
  --bs-rating-color-active: #FFAD0F;
  --bs-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(30, 33, 41, 0.1);
  --bs-ribbon-label-bg: #1B84FF;
  --bs-ribbon-label-border-color: #0053b4;
  --bs-ribbon-clip-bg: #1E2129;
  --bs-engage-btn-bg: #ffffff;
  --bs-engage-btn-box-shadow: 0px 0px 22px #E0E0E0;
  --bs-engage-btn-border-color: #E8E8E8;
  --bs-engage-btn-color: #252F4A;
  --bs-engage-btn-icon-color: #78829D;
  --bs-engage-btn-color-active: #252F4A;
}

[data-bs-theme=dark] {
  --bs-text-muted: #636674;
  --bs-gray-100: #1B1C22;
  --bs-gray-100-rgb: 27, 28, 34;
  --bs-gray-200: #26272F;
  --bs-gray-200-rgb: 38, 39, 47;
  --bs-gray-300: #363843;
  --bs-gray-300-rgb: 54, 56, 67;
  --bs-gray-400: #464852;
  --bs-gray-400-rgb: 70, 72, 82;
  --bs-gray-500: #636674;
  --bs-gray-500-rgb: 99, 102, 116;
  --bs-gray-600: #808290;
  --bs-gray-600-rgb: 128, 130, 144;
  --bs-gray-700: #9A9CAE;
  --bs-gray-700-rgb: 154, 156, 174;
  --bs-gray-800: #B5B7C8;
  --bs-gray-800-rgb: 181, 183, 200;
  --bs-gray-900: #F5F5F5;
  --bs-gray-900-rgb: 245, 245, 245;
  --bs-light: #1B1C22;
  --bs-primary: #006AE6;
  --bs-secondary: #363843;
  --bs-success: #00A261;
  --bs-info: #883FFF;
  --bs-warning: #C59A00;
  --bs-danger: #E42855;
  --bs-dark: #272A34;
  --bs-primary-active: #107EFF;
  --bs-secondary-active: #464852;
  --bs-light-active: #1F212A;
  --bs-success-active: #01BF73;
  --bs-info-active: #9E63FF;
  --bs-warning-active: #D9AA00;
  --bs-danger-active: #FF3767;
  --bs-dark-active: #2D2F39;
  --bs-primary-light: #172331;
  --bs-secondary-light: #363843;
  --bs-success-light: #1F212A;
  --bs-info-light: #272134;
  --bs-warning-light: #242320;
  --bs-danger-light: #302024;
  --bs-dark-light: #1E2027;
  --bs-light-light: #1F212A;
  --bs-primary-inverse: #ffffff;
  --bs-secondary-inverse: #ffffff;
  --bs-light-inverse: #808290;
  --bs-success-inverse: #ffffff;
  --bs-info-inverse: #ffffff;
  --bs-warning-inverse: #ffffff;
  --bs-danger-inverse: #ffffff;
  --bs-dark-inverse: #ffffff;
  --bs-primary-clarity: rgba(0, 106, 230, 0.2);
  --bs-secondary-clarity: rgba(54, 56, 67, 0.2);
  --bs-success-clarity: rgba(0, 162, 97, 0.2);
  --bs-info-clarity: rgba(136, 63, 255, 0.2);
  --bs-warning-clarity: rgba(197, 154, 0, 0.2);
  --bs-danger-clarity: rgba(228, 40, 85, 0.2);
  --bs-dark-clarity: rgba(39, 42, 52, 0.2);
  --bs-light-clarity: rgba(31, 33, 42, 0.2);
  --bs-light-rgb: 27, 28, 34;
  --bs-primary-rgb: 0, 106, 230;
  --bs-secondary-rgb: 54, 56, 67;
  --bs-success-rgb: 0, 162, 97;
  --bs-info-rgb: 136, 63, 255;
  --bs-warning-rgb: 197, 154, 0;
  --bs-danger-rgb: 228, 40, 85;
  --bs-dark-rgb: 39, 42, 52;
  --bs-text-white: #ffffff;
  --bs-text-primary: #006AE6;
  --bs-text-secondary: #363843;
  --bs-text-light: #1B1C22;
  --bs-text-success: #00A261;
  --bs-text-info: #883FFF;
  --bs-text-warning: #C59A00;
  --bs-text-danger: #E42855;
  --bs-text-dark: #272A34;
  --bs-text-muted: #636674;
  --bs-text-gray-100: #1B1C22;
  --bs-text-gray-200: #26272F;
  --bs-text-gray-300: #363843;
  --bs-text-gray-400: #464852;
  --bs-text-gray-500: #636674;
  --bs-text-gray-600: #808290;
  --bs-text-gray-700: #9A9CAE;
  --bs-text-gray-800: #B5B7C8;
  --bs-text-gray-900: #F5F5F5;
  --bs-border-color: #26272F;
  --bs-border-dashed-color: #363843;
  --bs-component-active-color: #ffffff;
  --bs-component-active-bg: #006AE6;
  --bs-component-hover-color: #006AE6;
  --bs-component-hover-bg: #1B1C22;
  --bs-component-checked-color: #ffffff;
  --bs-component-checked-bg: #006AE6;
  --bs-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);
  --bs-input-color: var(--bs-gray-700);
  --bs-input-bg: var(--bs-body-bg);
  --bs-input-solid-color: var(--bs-gray-700);
  --bs-input-solid-bg: var(--bs-gray-100);
  --bs-input-solid-bg-focus: var(--bs-gray-200);
  --bs-input-solid-placeholder-color: var(--bs-gray-500);
  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
  --bs-root-card-box-shadow: none;
  --bs-root-card-border-color: #1E2027;
  --bs-table-striped-bg: rgba(27, 28, 34, 0.75);
  --bs-table-loading-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-dropdown-bg: #1C1D22;
  --bs-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-code-bg: #2b2b40;
  --bs-code-shadow: rgba(0, 0, 0, 0.08) 0px 3px 9px 0px;
  --bs-code-border-color: transparent;
  --bs-code-color: #b93993;
  --bs-symbol-label-color: #B5B7C8;
  --bs-symbol-label-bg: #1B1C22;
  --bs-symbol-border-color: rgba(255, 255, 255, 0.5);
  --bs-bullet-bg-color: #464852;
  --bs-scrolltop-opacity: 0;
  --bs-scrolltop-opacity-on: 0.3;
  --bs-scrolltop-opacity-hover: 1;
  --bs-scrolltop-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --bs-scrolltop-bg-color: #1B84FF;
  --bs-scrolltop-bg-color-hover: #1B84FF;
  --bs-scrolltop-icon-color: #ffffff;
  --bs-scrolltop-icon-color-hover: #ffffff;
  --bs-drawer-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  --bs-drawer-bg-color: #1C1D22;
  --bs-drawer-overlay-bg-color: rgba(0, 0, 0, 0.4);
  --bs-menu-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-menu-dropdown-bg-color: #1C1D22;
  --bs-menu-heading-color: #636674;
  --bs-menu-link-color-hover: #006AE6;
  --bs-menu-link-color-show: #006AE6;
  --bs-menu-link-color-here: #006AE6;
  --bs-menu-link-color-active: #006AE6;
  --bs-menu-link-bg-color-hover: #1B1C22;
  --bs-menu-link-bg-color-show: #1B1C22;
  --bs-menu-link-bg-color-here: #1B1C22;
  --bs-menu-link-bg-color-active: #1B1C22;
  --bs-scrollbar-color: #26272F;
  --bs-scrollbar-hover-color: #363843;
  --bs-overlay-bg: rgba(255, 255, 255, 0.05);
  --bs-blockui-overlay-bg: rgba(255, 255, 255, 0.05);
  --bs-rating-color-default: #464852;
  --bs-rating-color-active: #FFAD0F;
  --bs-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(255, 255, 255, 0.1);
  --bs-ribbon-label-bg: #1B84FF;
  --bs-ribbon-label-border-color: #0053b4;
  --bs-ribbon-clip-bg: #F9F9F9;
  --bs-engage-btn-bg: #26272F;
  --bs-engage-btn-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-engage-btn-border-color: #26272F;
  --bs-engage-btn-color: #B5B7C8;
  --bs-engage-btn-icon-color: #808290;
  --bs-engage-btn-color-active: #B5B7C8;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  outline: 0;
}

.blockquote-footer {
  color: var(--bs-blockquote-footer-color);
}

.list-style-none {
  list-style: none;
}

[data-kt-theme-mode-switching=true] * {
  transition: none !important;
}

[data-bs-theme=light] .theme-dark-show {
  display: none !important;
}
[data-bs-theme=light] .theme-light-bg-transparent {
  background-color: transparent !important;
}
[data-bs-theme=light] .theme-light-bg-body {
  background-color: var(--bs-body-bg) !important;
}

[data-bs-theme=dark] .theme-light-show {
  display: none !important;
}
[data-bs-theme=dark] .theme-dark-bg-transparent {
  background-color: transparent !important;
}
[data-bs-theme=dark] .theme-dark-bg-body {
  background-color: var(--bs-body-bg) !important;
}

.animation {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes animationSlideInDown {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animation-slide-in-down {
  animation-name: animationSlideInDown;
}

@keyframes animationSlideInUp {
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animation-slide-in-up {
  animation-name: animationSlideInUp;
}

@keyframes animationFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.animation-fade-in {
  animation-name: animationFadeIn;
}

@keyframes animationFadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.animation-fade-out {
  animation-name: animationFadeOut;
}

.animation-blink {
  animation: animationBlink 1s steps(5, start) infinite;
}

@keyframes animationBlink {
  to {
    visibility: hidden;
  }
}
.alert-light {
  color: var(--bs-light);
  border-color: var(--bs-light);
  background-color: var(--bs-light-light);
}
.alert-light .alert-link {
  color: var(--bs-light);
}

.alert-primary {
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary-light);
}
.alert-primary .alert-link {
  color: var(--bs-primary);
}

.alert-secondary {
  color: var(--bs-secondary);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary-light);
}
.alert-secondary .alert-link {
  color: var(--bs-secondary);
}

.alert-success {
  color: var(--bs-success);
  border-color: var(--bs-success);
  background-color: var(--bs-success-light);
}
.alert-success .alert-link {
  color: var(--bs-success);
}

.alert-info {
  color: var(--bs-info);
  border-color: var(--bs-info);
  background-color: var(--bs-info-light);
}
.alert-info .alert-link {
  color: var(--bs-info);
}

.alert-warning {
  color: var(--bs-warning);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning-light);
}
.alert-warning .alert-link {
  color: var(--bs-warning);
}

.alert-danger {
  color: var(--bs-danger);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger-light);
}
.alert-danger .alert-link {
  color: var(--bs-danger);
}

.alert-dark {
  color: var(--bs-dark);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark-light);
}
.alert-dark .alert-link {
  color: var(--bs-dark);
}

[data-bs-theme=dark] .dropdown-menu {
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
}

.toast .toast-header .btn-close {
  margin-right: 0;
}

[data-bs-theme=dark] .toast {
  --bs-toast-bg: #26272F;
  --bs-toast-header-bg: #26272F;
  --bs-toast-header-border-color: #363843;
}

.nav-pills .nav-item {
  margin-right: 0.5rem;
}
.nav-pills .nav-item:last-child {
  margin-right: 0;
}

.nav-stretch {
  align-items: stretch;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.nav-stretch .nav-item {
  display: flex;
  align-items: stretch;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.nav-stretch .nav-link {
  display: flex;
  align-items: center;
}

.nav-group {
  padding: 0.35rem;
  border-radius: 0.65rem;
  background-color: var(--bs-gray-100);
}
.nav-group.nav-group-outline {
  background-color: transparent;
  border: 1px solid var(--bs-border-color);
}
.nav-group.nav-group-fluid {
  display: flex;
}
.nav-group.nav-group-fluid > label,
.nav-group.nav-group-fluid > .btn {
  position: relative;
  flex-shrink: 0;
  flex-grow: 1;
  flex-basis: 0;
}
.nav-group.nav-group-fluid > label {
  margin-right: 0.1rem;
}
.nav-group.nav-group-fluid > label > .btn {
  width: 100%;
}
.nav-group.nav-group-fluid > label:last-child {
  margin-right: 0;
}

.nav-line-tabs {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: var(--bs-border-color);
}
.nav-line-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-line-tabs .nav-item .nav-link {
  color: var(--bs-gray-500);
  border: 0;
  border-bottom: 1px solid transparent;
  transition: color 0.2s ease;
  padding: 0.5rem 0;
  margin: 0 1rem;
}
.nav-line-tabs .nav-item:first-child .nav-link {
  margin-left: 0;
}
.nav-line-tabs .nav-item:last-child .nav-link {
  margin-right: 0;
}
.nav-line-tabs .nav-item .nav-link.active,
.nav-line-tabs .nav-item.show .nav-link,
.nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid var(--bs-primary);
  transition: color 0.2s ease;
}
.nav-line-tabs.nav-line-tabs-2x {
  border-bottom-width: 2px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item {
  margin-bottom: -2px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link {
  border-bottom-width: 2px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active,
.nav-line-tabs.nav-line-tabs-2x .nav-item.show .nav-link,
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {
  border-bottom-width: 2px;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link,
.nav.nav-pills.nav-pills-custom .nav-link {
  border: 1px dashed var(--bs-border-dashed-color);
  border-radius: 0.85rem;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid,
.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid {
  border: 3px solid var(--bs-border-dashed-color);
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid.active,
.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid.active {
  border: 3px solid var(--bs-primary);
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img {
  width: 30px;
  transition: color 0.2s ease;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.default,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.default {
  display: inline-block;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.active,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.active {
  display: none;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.active,
.nav.nav-pills.nav-pills-custom .nav-link.active {
  background-color: transparent;
  border: 1px solid var(--bs-border-dashed-color);
  transition-duration: 1ms;
  position: relative;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.active .nav-text,
.nav.nav-pills.nav-pills-custom .nav-link.active .nav-text {
  color: var(--bs-gray-800) !important;
  transition: color 0.2s ease;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.active .bullet-custom,
.nav.nav-pills.nav-pills-custom .nav-link.active .bullet-custom {
  display: block;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .bullet-custom,
.nav.nav-pills.nav-pills-custom .nav-link .bullet-custom {
  display: none;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(1) {
  color: #B5B5C3;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(2) {
  color: #3F4254;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(1) {
  color: #ffffff !important;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(2) {
  color: #ffffff !important;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(1) {
  color: #ffffff !important;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(2) {
  color: #ffffff !important;
}

.pagination {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
}
.pagination.pagination-circle .page-link {
  border-radius: 50%;
}
.pagination.pagination-outline .page-link {
  border: 1px solid var(--bs-border-color);
}
.pagination.pagination-outline .page-item:hover:not(.disabled) .page-link, .pagination.pagination-outline .page-item.active .page-link {
  border-color: var(--bs-primary-light);
}

.page-item {
  margin-right: 0.5rem;
  /*rtl:end:ignore*/
}
.page-item:last-child {
  margin-right: 0;
}
.page-item .page-link {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.65rem;
  height: 2.5rem;
  min-width: 2.5rem;
  font-weight: 500;
  font-size: 1.075rem;
  /*rtl:options:{"autoRename":false}*/
  /*rtl:end:ignore*/
  /*rtl:options:{"autoRename":false}*/
}
.page-item .page-link i {
  font-size: 0.85rem;
}
.page-item .page-link .previous,
.page-item .page-link .next {
  display: block;
  height: 0.875rem;
  width: 0.875rem;
  /*rtl:raw:transform: rotateZ(-180deg);*/
}
.page-item .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.page-item .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.page-item:focus .page-link {
  color: var(--bs-pagination-focus-color);
  /*rtl:options:{"autoRename":false}*/
}
.page-item:focus .page-link .svg-icon,
.page-item:focus .page-link i {
  color: var(--bs-pagination-focus-color);
}
.page-item:focus .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-focus-color);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.page-item:focus .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-focus-color);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link {
  color: var(--bs-pagination-hover-color);
  /*rtl:options:{"autoRename":false}*/
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link.page-text {
  background-color: transparent;
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .svg-icon,
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link i {
  color: var(--bs-pagination-hover-color);
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-hover-color);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-hover-color);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.page-item.active .page-link {
  color: var(--bs-pagination-active-color);
  /*rtl:options:{"autoRename":false}*/
}
.page-item.active .page-link.page-text {
  background-color: transparent;
}
.page-item.active .page-link .svg-icon,
.page-item.active .page-link i {
  color: var(--bs-pagination-active-color);
}
.page-item.active .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-active-color);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.page-item.active .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-active-color);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.page-item.disabled .page-link {
  color: var(--bs-pagination-disabled-color);
  /*rtl:options:{"autoRename":false}*/
}
.page-item.disabled .page-link .svg-icon,
.page-item.disabled .page-link i {
  color: var(--bs-pagination-disabled-color);
}
.page-item.disabled .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-disabled-color);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.page-item.disabled .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-pagination-disabled-color);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}

@media (max-width: 991.98px) {
  .page-item {
    margin-right: 0.25rem;
  }
  .page-item:last-child {
    margin-right: 0;
  }
}
.separator {
  display: block;
  height: 0;
  border-bottom: 1px solid var(--bs-border-color);
}
.separator.separator-dotted {
  border-bottom-style: dotted;
  border-bottom-color: var(--bs-border-dashed-color);
}
.separator.separator-dashed {
  border-bottom-style: dashed;
  border-bottom-color: var(--bs-border-dashed-color);
}
.separator.separator-content {
  display: flex;
  align-items: center;
  border-bottom: 0;
  text-align: center;
}
.separator.separator-content::before, .separator.separator-content::after {
  content: " ";
  width: 50%;
  border-bottom: 1px solid var(--bs-border-color);
}
.separator.separator-content::before {
  margin-right: 1.25rem;
}
.separator.separator-content::after {
  margin-left: 1.25rem;
}
.separator.separator-content.separator-dotted::before, .separator.separator-content.separator-dotted::after {
  border-bottom-style: dotted;
  border-bottom-color: var(--bs-border-dashed-color);
}
.separator.separator-content.separator-dashed::before, .separator.separator-content.separator-dashed::after {
  border-bottom-style: dashed;
  border-bottom-color: var(--bs-border-dashed-color);
}
.separator.separator-content.border-light::before, .separator.separator-content.border-light::after {
  border-color: #F9F9F9 !important;
}
.separator.separator-content.border-primary::before, .separator.separator-content.border-primary::after {
  border-color: #1B84FF !important;
}
.separator.separator-content.border-secondary::before, .separator.separator-content.border-secondary::after {
  border-color: #F9F9F9 !important;
}
.separator.separator-content.border-success::before, .separator.separator-content.border-success::after {
  border-color: #17C653 !important;
}
.separator.separator-content.border-info::before, .separator.separator-content.border-info::after {
  border-color: #7239EA !important;
}
.separator.separator-content.border-warning::before, .separator.separator-content.border-warning::after {
  border-color: #F6C000 !important;
}
.separator.separator-content.border-danger::before, .separator.separator-content.border-danger::after {
  border-color: #F8285A !important;
}
.separator.separator-content.border-dark::before, .separator.separator-content.border-dark::after {
  border-color: #1E2129 !important;
}

.carousel-custom .carousel-indicators {
  align-items: center;
  position: static;
  z-index: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}
.carousel-custom .carousel-indicators li {
  transform: none;
  opacity: 1;
}
.carousel-custom .carousel-indicators li.active {
  transform: none;
  opacity: 1;
}
.carousel-custom .carousel-indicators.carousel-indicators-dots li {
  border-radius: 0;
  background-color: transparent !important;
  height: 13px;
  width: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.carousel-custom .carousel-indicators.carousel-indicators-dots li:after {
  display: inline-block;
  content: " ";
  border-radius: 50%;
  transition: all 0.3s ease;
  background-color: var(--bs-gray-200);
  height: 9px;
  width: 9px;
}
.carousel-custom .carousel-indicators.carousel-indicators-dots li.active {
  background-color: transparent;
}
.carousel-custom .carousel-indicators.carousel-indicators-dots li.active:after {
  transition: all 0.3s ease;
  height: 13px;
  width: 13px;
  background-color: var(--bs-gray-400);
}
.carousel-custom .carousel-indicators.carousel-indicators-bullet li {
  transition: all 0.3s ease;
  background-color: transparent !important;
  border-radius: 6px;
  height: 6px;
  width: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.carousel-custom .carousel-indicators.carousel-indicators-bullet li:after {
  display: inline-block;
  content: " ";
  transition: all 0.3s ease;
  background-color: var(--bs-gray-400);
  border-radius: 6px;
  height: 6px;
  width: 6px;
}
.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active {
  transition: all 0.3s ease;
  background-color: transparent;
  height: 6px;
  width: 16px;
}
.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active:after {
  transition: all 0.3s ease;
  height: 6px;
  width: 16px;
  background-color: var(--bs-gray-600);
}
.carousel-custom .carousel-indicators-active-light li.active:after {
  background-color: var(--bs-light) !important;
}
.carousel-custom .carousel-indicators-active-primary li.active:after {
  background-color: var(--bs-primary) !important;
}
.carousel-custom .carousel-indicators-active-secondary li.active:after {
  background-color: var(--bs-secondary) !important;
}
.carousel-custom .carousel-indicators-active-success li.active:after {
  background-color: var(--bs-success) !important;
}
.carousel-custom .carousel-indicators-active-info li.active:after {
  background-color: var(--bs-info) !important;
}
.carousel-custom .carousel-indicators-active-warning li.active:after {
  background-color: var(--bs-warning) !important;
}
.carousel-custom .carousel-indicators-active-danger li.active:after {
  background-color: var(--bs-danger) !important;
}
.carousel-custom .carousel-indicators-active-dark li.active:after {
  background-color: var(--bs-dark) !important;
}
.carousel-custom.carousel-stretch {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.carousel-custom.carousel-stretch .carousel-inner {
  flex-grow: 1;
}
.carousel-custom.carousel-stretch .carousel-item {
  height: 100%;
}
.carousel-custom.carousel-stretch .carousel-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.menu-group {
  display: flex;
}

.menu,
.menu-wrapper {
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
}

.menu-inner {
  padding: 0;
  margin: 0;
  list-style: none;
}

.menu-sub {
  display: none;
  padding: 0;
  margin: 0;
  list-style: none;
  flex-direction: column;
}

.menu-item {
  display: block;
  padding: 0.15rem 0;
}
.menu-item .menu-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  flex: 0 0 100%;
  padding: 0.65rem 1rem;
  transition: none;
  outline: none !important;
}
.menu-item .menu-link .menu-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  margin-right: 0.5rem;
}
.menu-item .menu-link .menu-icon i,
.menu-item .menu-link .menu-icon .svg-icon {
  line-height: 1;
}
.menu-item .menu-link .menu-bullet {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  margin-right: 0.5rem;
}
.menu-item .menu-link .menu-title {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.menu-item .menu-link .menu-badge {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 0.5rem;
}
.menu-item .menu-link .menu-arrow {
  display: flex;
  align-items: stretch;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin-left: 5px;
  width: 9px;
  height: 9px;
}
.menu-item .menu-link .menu-arrow:after {
  display: block;
  width: 100%;
  content: " ";
  will-change: transform;
  background-size: 100% 100%;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  /*rtl:end:remove*/
}
.menu-item .menu-content {
  padding: 0.65rem 1rem;
}

.menu-item.show .menu-link .menu-arrow:after {
  backface-visibility: hidden;
  transition: transform 0.3s ease;
}

.menu-nowrap .menu-title,
.menu-nowrap .menu-link {
  flex-wrap: nowrap;
  flex-shrink: 0;
}

.menu-center {
  justify-content: center;
}

.menu-heading {
  color: var(--bs-menu-heading-color);
}

.menu-item.menu-accordion .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(-90deg);
  /*rtl:remove*/
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}
.menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(90deg);
  /*rtl:remove*/
  transform: rotateZ(-90deg);
  transition: transform 0.3s ease;
}

.menu-sub-dropdown {
  display: none;
  border-radius: 0.65rem;
  background-color: var(--bs-menu-dropdown-bg-color);
  box-shadow: var(--bs-menu-dropdown-box-shadow);
  z-index: 107;
}
.show.menu-dropdown > .menu-sub-dropdown, .menu-sub-dropdown.menu.show, .menu-sub-dropdown.show[data-popper-placement] {
  display: flex;
  will-change: transform;
  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
}

.menu-sub-accordion {
  display: none;
}
.show:not(.menu-dropdown) > .menu-sub-accordion, .menu-sub-accordion.show {
  display: flex;
}

.menu-sub-indention .menu-sub:not([data-popper-placement]) {
  margin-left: 1rem;
}
.menu-sub-indention .menu-item .menu-item .menu-link.active {
  margin-right: 1rem;
}

.menu-inline {
  display: flex;
}

.menu-fit > .menu-item > .menu-content,
.menu-fit > .menu-item > .menu-link {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.menu-column {
  flex-direction: column;
  width: 100%;
}

.menu-row {
  flex-direction: row;
}
.menu-row > .menu-item {
  display: flex;
  align-items: center;
}
.menu-row > .menu-item > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(-90deg);
  /*rtl:remove*/
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}

.menu-rounded .menu-link {
  border-radius: 0.65rem;
}

.menu-pill .menu-link {
  border-radius: 50px;
}

.menu-rounded-0 .menu-link {
  border-radius: 0 !important;
}

@media (min-width: 576px) {
  .menu-item.menu-sm-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-sm-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-sm-dropdown, .menu-sub-sm-dropdown.menu.show, .menu-sub-sm-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-sm-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-sm-accordion, .menu-sub-sm-accordion.show {
    display: flex;
  }
  .menu-sub-sm-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-sm-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-sm-inline {
    display: flex;
  }
  .menu-sm-fit > .menu-item > .menu-content,
  .menu-sm-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-sm-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-sm-row {
    flex-direction: row;
  }
  .menu-sm-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-sm-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-sm-pill .menu-link {
    border-radius: 50px;
  }
  .menu-sm-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 768px) {
  .menu-item.menu-md-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-md-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-md-dropdown, .menu-sub-md-dropdown.menu.show, .menu-sub-md-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-md-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-md-accordion, .menu-sub-md-accordion.show {
    display: flex;
  }
  .menu-sub-md-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-md-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-md-inline {
    display: flex;
  }
  .menu-md-fit > .menu-item > .menu-content,
  .menu-md-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-md-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-md-row {
    flex-direction: row;
  }
  .menu-md-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-md-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-md-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-md-pill .menu-link {
    border-radius: 50px;
  }
  .menu-md-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 992px) {
  .menu-item.menu-lg-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-lg-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-lg-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-lg-accordion, .menu-sub-lg-accordion.show {
    display: flex;
  }
  .menu-sub-lg-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-lg-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-lg-inline {
    display: flex;
  }
  .menu-lg-fit > .menu-item > .menu-content,
  .menu-lg-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-lg-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-lg-row {
    flex-direction: row;
  }
  .menu-lg-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-lg-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-lg-pill .menu-link {
    border-radius: 50px;
  }
  .menu-lg-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 1200px) {
  .menu-item.menu-xl-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-xl-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xl-dropdown, .menu-sub-xl-dropdown.menu.show, .menu-sub-xl-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-xl-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xl-accordion, .menu-sub-xl-accordion.show {
    display: flex;
  }
  .menu-sub-xl-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xl-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-xl-inline {
    display: flex;
  }
  .menu-xl-fit > .menu-item > .menu-content,
  .menu-xl-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-xl-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-xl-row {
    flex-direction: row;
  }
  .menu-xl-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-xl-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-xl-pill .menu-link {
    border-radius: 50px;
  }
  .menu-xl-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 1400px) {
  .menu-item.menu-xxl-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-xxl-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xxl-dropdown, .menu-sub-xxl-dropdown.menu.show, .menu-sub-xxl-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-xxl-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xxl-accordion, .menu-sub-xxl-accordion.show {
    display: flex;
  }
  .menu-sub-xxl-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xxl-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-xxl-inline {
    display: flex;
  }
  .menu-xxl-fit > .menu-item > .menu-content,
  .menu-xxl-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-xxl-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-xxl-row {
    flex-direction: row;
  }
  .menu-xxl-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-xxl-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-xxl-pill .menu-link {
    border-radius: 50px;
  }
  .menu-xxl-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 575.98px) {
  .menu-item.menu-sm-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-sm-down-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-sm-down-dropdown, .menu-sub-sm-down-dropdown.menu.show, .menu-sub-sm-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-sm-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-sm-down-accordion, .menu-sub-sm-down-accordion.show {
    display: flex;
  }
  .menu-sub-sm-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-sm-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-sm-down-inline {
    display: flex;
  }
  .menu-sm-down-fit > .menu-item > .menu-content,
  .menu-sm-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-sm-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-sm-down-row {
    flex-direction: row;
  }
  .menu-sm-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-sm-down-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-sm-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-sm-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 767.98px) {
  .menu-item.menu-md-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-md-down-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-md-down-dropdown, .menu-sub-md-down-dropdown.menu.show, .menu-sub-md-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-md-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-md-down-accordion, .menu-sub-md-down-accordion.show {
    display: flex;
  }
  .menu-sub-md-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-md-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-md-down-inline {
    display: flex;
  }
  .menu-md-down-fit > .menu-item > .menu-content,
  .menu-md-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-md-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-md-down-row {
    flex-direction: row;
  }
  .menu-md-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-md-down-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-md-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-md-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 991.98px) {
  .menu-item.menu-lg-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-lg-down-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-lg-down-dropdown, .menu-sub-lg-down-dropdown.menu.show, .menu-sub-lg-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-lg-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-lg-down-accordion, .menu-sub-lg-down-accordion.show {
    display: flex;
  }
  .menu-sub-lg-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-lg-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-lg-down-inline {
    display: flex;
  }
  .menu-lg-down-fit > .menu-item > .menu-content,
  .menu-lg-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-lg-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-lg-down-row {
    flex-direction: row;
  }
  .menu-lg-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-lg-down-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-lg-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-lg-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 1199.98px) {
  .menu-item.menu-xl-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-xl-down-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xl-down-dropdown, .menu-sub-xl-down-dropdown.menu.show, .menu-sub-xl-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-xl-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xl-down-accordion, .menu-sub-xl-down-accordion.show {
    display: flex;
  }
  .menu-sub-xl-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xl-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-xl-down-inline {
    display: flex;
  }
  .menu-xl-down-fit > .menu-item > .menu-content,
  .menu-xl-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-xl-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-xl-down-row {
    flex-direction: row;
  }
  .menu-xl-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-xl-down-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-xl-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-xl-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 1399.98px) {
  .menu-item.menu-xxl-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }
  .menu-sub-xxl-down-dropdown {
    display: none;
    border-radius: 0.65rem;
    background-color: var(--bs-menu-dropdown-bg-color);
    box-shadow: var(--bs-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xxl-down-dropdown, .menu-sub-xxl-down-dropdown.menu.show, .menu-sub-xxl-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }
  .menu-sub-xxl-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xxl-down-accordion, .menu-sub-xxl-down-accordion.show {
    display: flex;
  }
  .menu-sub-xxl-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xxl-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }
  .menu-xxl-down-inline {
    display: flex;
  }
  .menu-xxl-down-fit > .menu-item > .menu-content,
  .menu-xxl-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .menu-xxl-down-column {
    flex-direction: column;
    width: 100%;
  }
  .menu-xxl-down-row {
    flex-direction: row;
  }
  .menu-xxl-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-xxl-down-rounded .menu-link {
    border-radius: 0.65rem;
  }
  .menu-xxl-down-pill .menu-link {
    border-radius: 50px;
  }
  .menu-xxl-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
.menu-link-indention .menu-item {
  padding-top: 0;
  padding-bottom: 0;
}
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(1rem + 1rem);
}
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(2rem + 1rem);
}
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(3rem + 1rem);
}
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(4rem + 1rem);
}
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 1rem;
  padding-right: 0;
}
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(2rem);
  padding-right: 0;
}
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(3rem);
  padding-right: 0;
}
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(4rem);
  padding-right: 0;
}

@keyframes menu-sub-dropdown-animation-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes menu-sub-dropdown-animation-move-up {
  from {
    margin-top: 0.75rem;
  }
  to {
    margin-top: 0;
  }
}
@keyframes menu-sub-dropdown-animation-move-down {
  from {
    margin-bottom: 0.75rem;
  }
  to {
    margin-bottom: 0;
  }
}
.menu-white .menu-item .menu-link {
  color: var(--bs-white);
}
.menu-white .menu-item .menu-link .menu-title {
  color: var(--bs-white);
}
.menu-white .menu-item .menu-link .menu-icon,
.menu-white .menu-item .menu-link .menu-icon .svg-icon,
.menu-white .menu-item .menu-link .menu-icon i {
  color: var(--bs-white);
}
.menu-white .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-white);
}
.menu-white .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-white);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-white);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  /*rtl:end:remove*/
}

.menu-title-white .menu-item .menu-link {
  color: var(--bs-text-white);
}
.menu-title-white .menu-item .menu-link .menu-title {
  color: var(--bs-text-white);
}

.menu-icon-white .menu-item .menu-link .menu-icon,
.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-white .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-white);
}

.menu-bullet-white .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-white);
}

.menu-arrow-white .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-white);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-white);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:end:remove*/
}

.menu-primary .menu-item .menu-link {
  color: var(--bs-primary);
}
.menu-primary .menu-item .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-primary .menu-item .menu-link .menu-icon,
.menu-primary .menu-item .menu-link .menu-icon .svg-icon,
.menu-primary .menu-item .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-primary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-primary .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-title-primary .menu-item .menu-link {
  color: var(--bs-text-primary);
}
.menu-title-primary .menu-item .menu-link .menu-title {
  color: var(--bs-text-primary);
}

.menu-icon-primary .menu-item .menu-link .menu-icon,
.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-primary .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-primary);
}

.menu-bullet-primary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-primary);
}

.menu-arrow-primary .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:end:remove*/
}

.menu-secondary .menu-item .menu-link {
  color: var(--bs-secondary);
}
.menu-secondary .menu-item .menu-link .menu-title {
  color: var(--bs-secondary);
}
.menu-secondary .menu-item .menu-link .menu-icon,
.menu-secondary .menu-item .menu-link .menu-icon .svg-icon,
.menu-secondary .menu-item .menu-link .menu-icon i {
  color: var(--bs-secondary);
}
.menu-secondary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-secondary);
}
.menu-secondary .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-secondary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-secondary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  /*rtl:end:remove*/
}

.menu-title-secondary .menu-item .menu-link {
  color: var(--bs-text-secondary);
}
.menu-title-secondary .menu-item .menu-link .menu-title {
  color: var(--bs-text-secondary);
}

.menu-icon-secondary .menu-item .menu-link .menu-icon,
.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-secondary .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-secondary);
}

.menu-bullet-secondary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-secondary);
}

.menu-arrow-secondary .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-secondary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-secondary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  /*rtl:end:remove*/
}

.menu-light .menu-item .menu-link {
  color: var(--bs-light);
}
.menu-light .menu-item .menu-link .menu-title {
  color: var(--bs-light);
}
.menu-light .menu-item .menu-link .menu-icon,
.menu-light .menu-item .menu-link .menu-icon .svg-icon,
.menu-light .menu-item .menu-link .menu-icon i {
  color: var(--bs-light);
}
.menu-light .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-light);
}
.menu-light .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-light);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-light);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  /*rtl:end:remove*/
}

.menu-title-light .menu-item .menu-link {
  color: var(--bs-text-light);
}
.menu-title-light .menu-item .menu-link .menu-title {
  color: var(--bs-text-light);
}

.menu-icon-light .menu-item .menu-link .menu-icon,
.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-light .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-light);
}

.menu-bullet-light .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-light);
}

.menu-arrow-light .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-light);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-light);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  /*rtl:end:remove*/
}

.menu-success .menu-item .menu-link {
  color: var(--bs-success);
}
.menu-success .menu-item .menu-link .menu-title {
  color: var(--bs-success);
}
.menu-success .menu-item .menu-link .menu-icon,
.menu-success .menu-item .menu-link .menu-icon .svg-icon,
.menu-success .menu-item .menu-link .menu-icon i {
  color: var(--bs-success);
}
.menu-success .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-success);
}
.menu-success .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-success);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-success);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  /*rtl:end:remove*/
}

.menu-title-success .menu-item .menu-link {
  color: var(--bs-text-success);
}
.menu-title-success .menu-item .menu-link .menu-title {
  color: var(--bs-text-success);
}

.menu-icon-success .menu-item .menu-link .menu-icon,
.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-success .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-success);
}

.menu-bullet-success .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-success);
}

.menu-arrow-success .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-success);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-success);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  /*rtl:end:remove*/
}

.menu-info .menu-item .menu-link {
  color: var(--bs-info);
}
.menu-info .menu-item .menu-link .menu-title {
  color: var(--bs-info);
}
.menu-info .menu-item .menu-link .menu-icon,
.menu-info .menu-item .menu-link .menu-icon .svg-icon,
.menu-info .menu-item .menu-link .menu-icon i {
  color: var(--bs-info);
}
.menu-info .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-info);
}
.menu-info .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-info);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-info);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  /*rtl:end:remove*/
}

.menu-title-info .menu-item .menu-link {
  color: var(--bs-text-info);
}
.menu-title-info .menu-item .menu-link .menu-title {
  color: var(--bs-text-info);
}

.menu-icon-info .menu-item .menu-link .menu-icon,
.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-info .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-info);
}

.menu-bullet-info .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-info);
}

.menu-arrow-info .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-info);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-info);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  /*rtl:end:remove*/
}

.menu-warning .menu-item .menu-link {
  color: var(--bs-warning);
}
.menu-warning .menu-item .menu-link .menu-title {
  color: var(--bs-warning);
}
.menu-warning .menu-item .menu-link .menu-icon,
.menu-warning .menu-item .menu-link .menu-icon .svg-icon,
.menu-warning .menu-item .menu-link .menu-icon i {
  color: var(--bs-warning);
}
.menu-warning .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-warning);
}
.menu-warning .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-warning);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-warning);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  /*rtl:end:remove*/
}

.menu-title-warning .menu-item .menu-link {
  color: var(--bs-text-warning);
}
.menu-title-warning .menu-item .menu-link .menu-title {
  color: var(--bs-text-warning);
}

.menu-icon-warning .menu-item .menu-link .menu-icon,
.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-warning .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-warning);
}

.menu-bullet-warning .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-warning);
}

.menu-arrow-warning .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-warning);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-warning);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
  /*rtl:end:remove*/
}

.menu-danger .menu-item .menu-link {
  color: var(--bs-danger);
}
.menu-danger .menu-item .menu-link .menu-title {
  color: var(--bs-danger);
}
.menu-danger .menu-item .menu-link .menu-icon,
.menu-danger .menu-item .menu-link .menu-icon .svg-icon,
.menu-danger .menu-item .menu-link .menu-icon i {
  color: var(--bs-danger);
}
.menu-danger .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-danger);
}
.menu-danger .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-danger);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-danger);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  /*rtl:end:remove*/
}

.menu-title-danger .menu-item .menu-link {
  color: var(--bs-text-danger);
}
.menu-title-danger .menu-item .menu-link .menu-title {
  color: var(--bs-text-danger);
}

.menu-icon-danger .menu-item .menu-link .menu-icon,
.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-danger .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-danger);
}

.menu-bullet-danger .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-danger);
}

.menu-arrow-danger .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-danger);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-danger);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  /*rtl:end:remove*/
}

.menu-dark .menu-item .menu-link {
  color: var(--bs-dark);
}
.menu-dark .menu-item .menu-link .menu-title {
  color: var(--bs-dark);
}
.menu-dark .menu-item .menu-link .menu-icon,
.menu-dark .menu-item .menu-link .menu-icon .svg-icon,
.menu-dark .menu-item .menu-link .menu-icon i {
  color: var(--bs-dark);
}
.menu-dark .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-dark);
}
.menu-dark .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /*rtl:end:remove*/
}

.menu-title-dark .menu-item .menu-link {
  color: var(--bs-text-dark);
}
.menu-title-dark .menu-item .menu-link .menu-title {
  color: var(--bs-text-dark);
}

.menu-icon-dark .menu-item .menu-link .menu-icon,
.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-dark .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-dark);
}

.menu-bullet-dark .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-dark);
}

.menu-arrow-dark .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  /*rtl:end:remove*/
}

.menu-muted .menu-item .menu-link {
  color: var(--bs-muted);
}
.menu-muted .menu-item .menu-link .menu-title {
  color: var(--bs-muted);
}
.menu-muted .menu-item .menu-link .menu-icon,
.menu-muted .menu-item .menu-link .menu-icon .svg-icon,
.menu-muted .menu-item .menu-link .menu-icon i {
  color: var(--bs-muted);
}
.menu-muted .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-muted);
}
.menu-muted .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-muted);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-muted);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  /*rtl:end:remove*/
}

.menu-title-muted .menu-item .menu-link {
  color: var(--bs-text-muted);
}
.menu-title-muted .menu-item .menu-link .menu-title {
  color: var(--bs-text-muted);
}

.menu-icon-muted .menu-item .menu-link .menu-icon,
.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-muted .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-muted);
}

.menu-bullet-muted .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-muted);
}

.menu-arrow-muted .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  /*rtl:end:remove*/
}

.menu-gray-100 .menu-item .menu-link {
  color: var(--bs-gray-100);
}
.menu-gray-100 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-100);
}
.menu-gray-100 .menu-item .menu-link .menu-icon,
.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-100 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-100);
}
.menu-gray-100 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-100);
}
.menu-gray-100 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-100);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-100);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  /*rtl:end:remove*/
}

.menu-title-gray-100 .menu-item .menu-link {
  color: var(--bs-text-gray-100);
}
.menu-title-gray-100 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-100);
}

.menu-icon-gray-100 .menu-item .menu-link .menu-icon,
.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-100 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-100);
}

.menu-bullet-gray-100 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-100);
}

.menu-arrow-gray-100 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-100);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-100);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  /*rtl:end:remove*/
}

.menu-gray-200 .menu-item .menu-link {
  color: var(--bs-gray-200);
}
.menu-gray-200 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-200);
}
.menu-gray-200 .menu-item .menu-link .menu-icon,
.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-200 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-200);
}
.menu-gray-200 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-200);
}
.menu-gray-200 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-200);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-200);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  /*rtl:end:remove*/
}

.menu-title-gray-200 .menu-item .menu-link {
  color: var(--bs-text-gray-200);
}
.menu-title-gray-200 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-200);
}

.menu-icon-gray-200 .menu-item .menu-link .menu-icon,
.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-200 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-200);
}

.menu-bullet-gray-200 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-200);
}

.menu-arrow-gray-200 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-200);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-200);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
  /*rtl:end:remove*/
}

.menu-gray-300 .menu-item .menu-link {
  color: var(--bs-gray-300);
}
.menu-gray-300 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-300);
}
.menu-gray-300 .menu-item .menu-link .menu-icon,
.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-300 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-300);
}
.menu-gray-300 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-300);
}
.menu-gray-300 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-300);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-300);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
  /*rtl:end:remove*/
}

.menu-title-gray-300 .menu-item .menu-link {
  color: var(--bs-text-gray-300);
}
.menu-title-gray-300 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-300);
}

.menu-icon-gray-300 .menu-item .menu-link .menu-icon,
.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-300 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-300);
}

.menu-bullet-gray-300 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-300);
}

.menu-arrow-gray-300 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-300);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-300);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
  /*rtl:end:remove*/
}

.menu-gray-400 .menu-item .menu-link {
  color: var(--bs-gray-400);
}
.menu-gray-400 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-400);
}
.menu-gray-400 .menu-item .menu-link .menu-icon,
.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-400 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-400);
}
.menu-gray-400 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-400);
}
.menu-gray-400 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-400);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-400);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
  /*rtl:end:remove*/
}

.menu-title-gray-400 .menu-item .menu-link {
  color: var(--bs-text-gray-400);
}
.menu-title-gray-400 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-400);
}

.menu-icon-gray-400 .menu-item .menu-link .menu-icon,
.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-400 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-400);
}

.menu-bullet-gray-400 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-400);
}

.menu-arrow-gray-400 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-400);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-400);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
  /*rtl:end:remove*/
}

.menu-gray-500 .menu-item .menu-link {
  color: var(--bs-gray-500);
}
.menu-gray-500 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-500);
}
.menu-gray-500 .menu-item .menu-link .menu-icon,
.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-500 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-500);
}
.menu-gray-500 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-500);
}
.menu-gray-500 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-500);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-500);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
  /*rtl:end:remove*/
}

.menu-title-gray-500 .menu-item .menu-link {
  color: var(--bs-text-gray-500);
}
.menu-title-gray-500 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-500);
}

.menu-icon-gray-500 .menu-item .menu-link .menu-icon,
.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-500 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-500);
}

.menu-bullet-gray-500 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-500);
}

.menu-arrow-gray-500 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-500);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-500);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
  /*rtl:end:remove*/
}

.menu-gray-600 .menu-item .menu-link {
  color: var(--bs-gray-600);
}
.menu-gray-600 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-600);
}
.menu-gray-600 .menu-item .menu-link .menu-icon,
.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-600 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-600);
}
.menu-gray-600 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-600);
}
.menu-gray-600 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-600);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-600);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
  /*rtl:end:remove*/
}

.menu-title-gray-600 .menu-item .menu-link {
  color: var(--bs-text-gray-600);
}
.menu-title-gray-600 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-600);
}

.menu-icon-gray-600 .menu-item .menu-link .menu-icon,
.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-600 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-600);
}

.menu-bullet-gray-600 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-600);
}

.menu-arrow-gray-600 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-600);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-600);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
  /*rtl:end:remove*/
}

.menu-gray-700 .menu-item .menu-link {
  color: var(--bs-gray-700);
}
.menu-gray-700 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-700);
}
.menu-gray-700 .menu-item .menu-link .menu-icon,
.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-700 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-700);
}
.menu-gray-700 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-700);
}
.menu-gray-700 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-700);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  /*rtl:end:remove*/
}

.menu-title-gray-700 .menu-item .menu-link {
  color: var(--bs-text-gray-700);
}
.menu-title-gray-700 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-700);
}

.menu-icon-gray-700 .menu-item .menu-link .menu-icon,
.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-700 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-700);
}

.menu-bullet-gray-700 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-700);
}

.menu-arrow-gray-700 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-700);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-700);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
  /*rtl:end:remove*/
}

.menu-gray-800 .menu-item .menu-link {
  color: var(--bs-gray-800);
}
.menu-gray-800 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-800);
}
.menu-gray-800 .menu-item .menu-link .menu-icon,
.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-800 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-800);
}
.menu-gray-800 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-800);
}
.menu-gray-800 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-800);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-800);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
  /*rtl:end:remove*/
}

.menu-title-gray-800 .menu-item .menu-link {
  color: var(--bs-text-gray-800);
}
.menu-title-gray-800 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-800);
}

.menu-icon-gray-800 .menu-item .menu-link .menu-icon,
.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-800 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-800);
}

.menu-bullet-gray-800 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-800);
}

.menu-arrow-gray-800 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-800);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-800);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
  /*rtl:end:remove*/
}

.menu-gray-900 .menu-item .menu-link {
  color: var(--bs-gray-900);
}
.menu-gray-900 .menu-item .menu-link .menu-title {
  color: var(--bs-gray-900);
}
.menu-gray-900 .menu-item .menu-link .menu-icon,
.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-900 .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-900);
}
.menu-gray-900 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-900);
}
.menu-gray-900 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  /*rtl:end:remove*/
}

.menu-title-gray-900 .menu-item .menu-link {
  color: var(--bs-text-gray-900);
}
.menu-title-gray-900 .menu-item .menu-link .menu-title {
  color: var(--bs-text-gray-900);
}

.menu-icon-gray-900 .menu-item .menu-link .menu-icon,
.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-900 .menu-item .menu-link .menu-icon i {
  color: var(--bs-text-gray-900);
}

.menu-bullet-gray-900 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-text-gray-900);
}

.menu-arrow-gray-900 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
  /*rtl:end:remove*/
}

.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-hover);
  color: var(--bs-menu-link-color-hover);
}
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-menu-link-color-hover);
}
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-menu-link-color-hover);
}
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-hover);
}
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-hover);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-hover);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  /*rtl:end:remove*/
}

.menu-here-bg .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-here);
  color: var(--bs-menu-link-color-here);
}
.menu-here-bg .menu-item.here > .menu-link .menu-title {
  color: var(--bs-menu-link-color-here);
}
.menu-here-bg .menu-item.here > .menu-link .menu-icon,
.menu-here-bg .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-bg .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-here);
}
.menu-here-bg .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-here);
}
.menu-here-bg .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  /*rtl:end:remove*/
}

.menu-root-here-bg > .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-here);
  color: var(--bs-menu-link-color-here);
}
.menu-root-here-bg > .menu-item.here > .menu-link .menu-title {
  color: var(--bs-menu-link-color-here);
}
.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon,
.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-here);
}
.menu-root-here-bg > .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-here);
}
.menu-root-here-bg > .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  /*rtl:end:remove*/
}

@media (min-width: 992px) {
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link {
    transition: color 0.2s ease;
    background-color: var(--bs-menu-link-bg-color-here);
    color: var(--bs-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-title {
    color: var(--bs-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon,
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon .svg-icon,
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon i {
    color: var(--bs-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-bullet .bullet {
    background-color: var(--bs-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-menu-link-color-here);
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--bs-menu-link-color-here);
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
    /*rtl:end:remove*/
  }
}
.menu-show-bg .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-show);
  color: var(--bs-menu-link-color-show);
}
.menu-show-bg .menu-item.show > .menu-link .menu-title {
  color: var(--bs-menu-link-color-show);
}
.menu-show-bg .menu-item.show > .menu-link .menu-icon,
.menu-show-bg .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-bg .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-show);
}
.menu-show-bg .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-show);
}
.menu-show-bg .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-show);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-show);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  /*rtl:end:remove*/
}

.menu-active-bg .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-active);
  color: var(--bs-menu-link-color-active);
}
.menu-active-bg .menu-item .menu-link.active .menu-title {
  color: var(--bs-menu-link-color-active);
}
.menu-active-bg .menu-item .menu-link.active .menu-icon,
.menu-active-bg .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-bg .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-menu-link-color-active);
}
.menu-active-bg .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-active);
}
.menu-active-bg .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-active);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-active);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:end:remove*/
}

.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-hover);
  color: var(--bs-menu-link-color-hover);
}
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-menu-link-color-hover);
}
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-menu-link-color-hover);
}
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-hover);
}
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-hover);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-hover);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  /*rtl:end:remove*/
}
.menu-state-bg .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-here);
  color: var(--bs-menu-link-color-here);
}
.menu-state-bg .menu-item.here > .menu-link .menu-title {
  color: var(--bs-menu-link-color-here);
}
.menu-state-bg .menu-item.here > .menu-link .menu-icon,
.menu-state-bg .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-bg .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-here);
}
.menu-state-bg .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-here);
}
.menu-state-bg .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  /*rtl:end:remove*/
}
.menu-state-bg .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-show);
  color: var(--bs-menu-link-color-show);
}
.menu-state-bg .menu-item.show > .menu-link .menu-title {
  color: var(--bs-menu-link-color-show);
}
.menu-state-bg .menu-item.show > .menu-link .menu-icon,
.menu-state-bg .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-show);
}
.menu-state-bg .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-show);
}
.menu-state-bg .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-show);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-show);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  /*rtl:end:remove*/
}
.menu-state-bg .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-menu-link-bg-color-active);
  color: var(--bs-menu-link-color-active);
}
.menu-state-bg .menu-item .menu-link.active .menu-title {
  color: var(--bs-menu-link-color-active);
}
.menu-state-bg .menu-item .menu-link.active .menu-icon,
.menu-state-bg .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-bg .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-menu-link-color-active);
}
.menu-state-bg .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-active);
}
.menu-state-bg .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-active);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-active);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:end:remove*/
}

.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-menu-link-color-hover);
}
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-menu-link-color-hover);
}
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-menu-link-color-hover);
}
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-hover);
}
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-hover);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-hover);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  /*rtl:end:remove*/
}
.menu-state-color .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-menu-link-color-here);
}
.menu-state-color .menu-item.here > .menu-link .menu-title {
  color: var(--bs-menu-link-color-here);
}
.menu-state-color .menu-item.here > .menu-link .menu-icon,
.menu-state-color .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-color .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-here);
}
.menu-state-color .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-here);
}
.menu-state-color .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-here);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  /*rtl:end:remove*/
}
.menu-state-color .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-menu-link-color-show);
}
.menu-state-color .menu-item.show > .menu-link .menu-title {
  color: var(--bs-menu-link-color-show);
}
.menu-state-color .menu-item.show > .menu-link .menu-icon,
.menu-state-color .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-color .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-menu-link-color-show);
}
.menu-state-color .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-show);
}
.menu-state-color .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-show);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-show);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  /*rtl:end:remove*/
}
.menu-state-color .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-menu-link-color-active);
}
.menu-state-color .menu-item .menu-link.active .menu-title {
  color: var(--bs-menu-link-color-active);
}
.menu-state-color .menu-item .menu-link.active .menu-icon,
.menu-state-color .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-color .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-menu-link-color-active);
}
.menu-state-color .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-menu-link-color-active);
}
.menu-state-color .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-active);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-menu-link-color-active);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:end:remove*/
}

.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary-inverse);
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary-inverse);
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:end:remove*/
}

.menu-show-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:end:remove*/
}

.menu-here-bg-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:end:remove*/
}

.menu-active-bg-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary-inverse);
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon,
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary-inverse);
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:end:remove*/
}

.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon,
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary);
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary-inverse);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:end:remove*/
}

.menu-show-bg-light-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-here-bg-light-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-active-bg-light-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon,
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-state-bg-light-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}
.menu-state-bg-light-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}
.menu-state-bg-light-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--bs-primary-light);
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon,
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-show-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-show-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-show-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-show-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-show-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-here-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-here-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-here-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-here-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-here-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-active-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-active-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}
.menu-active-primary .menu-item .menu-link.active .menu-icon,
.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}
.menu-active-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-active-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}
.menu-state-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-state-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-state-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}
.menu-state-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-state-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-state-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}
.menu-state-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-state-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}
.menu-state-primary .menu-item .menu-link.active .menu-icon,
.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-dark);
}
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-dark);
}
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-dark);
}
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-dark);
}
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /*rtl:end:remove*/
}
.menu-state-dark .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-dark);
}
.menu-state-dark .menu-item.show > .menu-link .menu-title {
  color: var(--bs-dark);
}
.menu-state-dark .menu-item.show > .menu-link .menu-icon,
.menu-state-dark .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-dark .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-dark);
}
.menu-state-dark .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-dark);
}
.menu-state-dark .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /*rtl:end:remove*/
}
.menu-state-dark .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-dark);
}
.menu-state-dark .menu-item.here > .menu-link .menu-title {
  color: var(--bs-dark);
}
.menu-state-dark .menu-item.here > .menu-link .menu-icon,
.menu-state-dark .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-dark .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-dark);
}
.menu-state-dark .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-dark);
}
.menu-state-dark .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /*rtl:end:remove*/
}
.menu-state-dark .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-dark);
}
.menu-state-dark .menu-item .menu-link.active .menu-title {
  color: var(--bs-dark);
}
.menu-state-dark .menu-item .menu-link.active .menu-icon,
.menu-state-dark .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-dark .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-dark);
}
.menu-state-dark .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-dark);
}
.menu-state-dark .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-dark);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /*rtl:end:remove*/
}

.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  /*rtl:end:remove*/
}
.menu-state-gray-900 .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.show > .menu-link .menu-title {
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.show > .menu-link .menu-icon,
.menu-state-gray-900 .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-gray-900 .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  /*rtl:end:remove*/
}
.menu-state-gray-900 .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.here > .menu-link .menu-title {
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.here > .menu-link .menu-icon,
.menu-state-gray-900 .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-gray-900 .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  /*rtl:end:remove*/
}
.menu-state-gray-900 .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item .menu-link.active .menu-title {
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item .menu-link.active .menu-icon,
.menu-state-gray-900 .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-gray-900 .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-gray-900);
}
.menu-state-gray-900 .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-900);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  /*rtl:end:remove*/
}

.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}

.menu-here-title-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-here-title-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-show-title-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-show-title-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}

.menu-active-title-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-active-title-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-primary);
}
.menu-state-title-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-state-title-primary .menu-item.here > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-state-title-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-state-title-primary .menu-item.show > .menu-link .menu-title {
  color: var(--bs-primary);
}
.menu-state-title-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--bs-primary);
}
.menu-state-title-primary .menu-item .menu-link.active .menu-title {
  color: var(--bs-primary);
}

.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}

.menu-here-icon-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-show-icon-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}

.menu-active-icon-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon,
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-icon-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-icon-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-primary);
}
.menu-state-icon-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon,
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-primary);
}

.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-show-bullet-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-show-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-here-bullet-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-here-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-active-bullet-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-active-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-bullet-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-bullet-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-primary);
}
.menu-state-bullet-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-state-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-primary);
}

.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-here-arrow-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-here-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-show-arrow-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-show-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-active-arrow-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-active-arrow-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}
.menu-state-arrow-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}
.menu-state-arrow-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}
.menu-state-arrow-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-state-arrow-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-primary);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:end:remove*/
}

.anchor {
  display: flex;
  align-items: center;
}
.anchor a {
  position: relative;
  display: none;
  align-items: center;
  justify-content: flex-start;
  height: 1em;
  width: 1.25em;
  margin-left: -1.25em;
  font-weight: 500;
  font-size: 0.8em;
  color: var(--bs-text-muted);
  transition: all 0.2s ease-in-out;
}
.anchor a:before {
  content: "#";
}
.anchor:hover a {
  display: flex;
}
.anchor:hover a:hover {
  color: var(--bs-primary);
  transition: all 0.2s ease-in-out;
}

.card {
  --bs-card-box-shadow: var(--bs-root-card-box-shadow);
  --bs-card-border-color: var(--bs-root-card-border-color);
  border: 1px solid var(--bs-card-border-color);
}
.card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  min-height: 70px;
  padding: 0 2.25rem;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: 1px solid var(--bs-card-border-color);
}
.card .card-header .card-title {
  display: flex;
  align-items: center;
  margin: 0.5rem;
  margin-left: 0;
}
.card .card-header .card-title.flex-column {
  align-items: flex-start;
  justify-content: center;
}
.card .card-header .card-title .card-icon {
  margin-right: 0.75rem;
  line-height: 0;
}
.card .card-header .card-title .card-icon i {
  font-size: 1.25rem;
  color: var(--bs-gray-600);
  line-height: 0;
}
.card .card-header .card-title .card-icon i:after, .card .card-header .card-title .card-icon i:before {
  line-height: 0;
}
.card .card-header .card-title .card-icon .svg-icon {
  color: var(--bs-gray-600);
}
.card .card-header .card-title .card-icon .svg-icon svg {
  height: 24px;
  width: 24px;
}
.card .card-header .card-title,
.card .card-header .card-title .card-label {
  font-weight: 500;
  font-size: 1.275rem;
  color: var(--bs-text-gray-900);
}
.card .card-header .card-title .card-label {
  margin: 0 0.75rem 0 0;
  flex-wrap: wrap;
}
.card .card-header .card-title small, .card .card-header .card-title .small {
  color: var(--bs-text-muted);
  font-size: 1rem;
}
.card .card-header .card-title h1, .card .card-header .card-title .h1, .card .card-header .card-title h2, .card .card-header .card-title .h2, .card .card-header .card-title h3, .card .card-header .card-title .h3, .card .card-header .card-title h4, .card .card-header .card-title .h4, .card .card-header .card-title h5, .card .card-header .card-title .h5, .card .card-header .card-title h6, .card .card-header .card-title .h6 {
  margin-bottom: 0;
}
.card .card-header .card-toolbar {
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
  flex-wrap: wrap;
}
.card .card-body {
  padding: 2rem 2.25rem;
  color: var(--bs-card-color);
}
.card .card-footer {
  padding: 2rem 2.25rem;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: 1px solid var(--bs-card-border-color);
}
.card .card-scroll {
  position: relative;
  overflow: auto;
}
.card.card-px-0 .card-header,
.card.card-px-0 .card-body,
.card.card-px-0 .card-footer {
  padding-left: 0;
  padding-right: 0;
}
.card.card-py-0 .card-header,
.card.card-py-0 .card-body,
.card.card-py-0 .card-footer {
  padding-top: 0;
  padding-bottom: 0;
}
.card.card-p-0 .card-header,
.card.card-p-0 .card-body,
.card.card-p-0 .card-footer {
  padding: 0;
}
.card.card-dashed {
  box-shadow: none;
  border: 1px dashed var(--bs-border-dashed-color);
}
.card.card-dashed > .card-header {
  border-bottom: 1px dashed var(--bs-border-dashed-color);
}
.card.card-dashed > .card-footer {
  border-top: 1px dashed var(--bs-border-dashed-color);
}
.card.card-bordered {
  box-shadow: none;
  border: 1px solid #F1F1F4;
}
.card.card-flush > .card-header {
  border-bottom: 0 !important;
}
.card.card-flush > .card-footer {
  border-top: 0 !important;
}
.card.card-shadow {
  box-shadow: var(--bs-card-box-shadow);
  border: 0;
}
.card.card-reset {
  border: 0 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.card.card-reset > .card-header {
  border-bottom: 0 !important;
}
.card.card-reset > .card-footer {
  border-top: 0 !important;
}
.card.card-borderless {
  border: 0 !important;
}
.card.card-borderless > .card-header {
  border-bottom: 0 !important;
}
.card.card-borderless > .card-footer {
  border-top: 0 !important;
}
.card.card-border-0 {
  border: 0 !important;
}

.card.card-stretch {
  height: calc(100% - var(--bs-gutter-y));
}
.card.card-stretch-75 {
  height: calc(75% - var(--bs-gutter-y));
}
.card.card-stretch-50 {
  height: calc(50% - var(--bs-gutter-y));
}
.card.card-stretch-33 {
  height: calc(33.333% - var(--bs-gutter-y));
}
.card.card-stretch-25 {
  height: calc(25% - var(--bs-gutter-y));
}
.card .card-header-stretch {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-items: stretch;
}
.card .card-header-stretch .card-toolbar {
  margin: 0;
  align-items: stretch;
}
@media (min-width: 576px) {
  .card.card-sm-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-sm-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-sm-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 768px) {
  .card.card-md-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-md-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-md-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 992px) {
  .card.card-lg-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-lg-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-lg-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 1200px) {
  .card.card-xl-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-xl-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-xl-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 1400px) {
  .card.card-xxl-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-xxl-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-xxl-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}

.card-p {
  padding: 2rem 2.25rem !important;
}

.card-px {
  padding-left: 2.25rem !important;
  padding-right: 2.25rem !important;
}

.card-shadow {
  box-shadow: var(--bs-card-box-shadow);
}

.card-py {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.card-rounded {
  border-radius: 0.85rem;
}

.card-rounded-start {
  border-top-left-radius: 0.85rem;
  border-bottom-left-radius: 0.85rem;
}

.card-rounded-end {
  border-top-right-radius: 0.85rem;
  border-bottom-right-radius: 0.85rem;
}

.card-rounded-top {
  border-top-left-radius: 0.85rem;
  border-top-right-radius: 0.85rem;
}

.card-rounded-bottom {
  border-bottom-left-radius: 0.85rem;
  border-bottom-right-radius: 0.85rem;
}

@media (max-width: 767.98px) {
  .card > .card-header:not(.flex-nowrap) {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
[data-bs-theme=dark] .card {
  --bs-card-box-shadow: none;
}

.breadcrumb {
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 0;
  margin: 0;
}
.breadcrumb .breadcrumb-item {
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
}
.breadcrumb .breadcrumb-item:last-child {
  padding-right: 0;
}
.breadcrumb .breadcrumb-item:after {
  padding-left: 0.5rem;
  content: "/";
}
.breadcrumb .breadcrumb-item:before {
  display: none;
}
.breadcrumb .breadcrumb-item:first-child {
  padding-left: 0;
}
.breadcrumb .breadcrumb-item:last-child:after {
  display: none;
}

.breadcrumb-line .breadcrumb-item:after {
  content: "-";
}

.breadcrumb-dot .breadcrumb-item:after {
  content: "•";
}

.breadcrumb-separatorless .breadcrumb-item:after {
  display: none;
}

.btn {
  --bs-btn-color: var(--bs-body-color);
  outline: none !important;
}
.btn:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg):not(.shadow-xs) {
  box-shadow: none;
}
.btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline) {
  border: 0;
  padding: calc(0.775rem + 1px) calc(1.5rem + 1px);
}
.btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline).btn-lg, .btn-group-lg > .btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline) {
  padding: calc(0.825rem + 1px) calc(1.75rem + 1px);
}
.btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline).btn-sm, .btn-group-sm > .btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline) {
  padding: calc(0.55rem + 1px) calc(1rem + 1px);
}
.btn.btn-link {
  border: 0;
  border-radius: 0;
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-decoration: none;
  font-weight: 500;
}
.btn.btn-outline:not(.btn-outline-dashed) {
  border: 1px solid var(--bs-gray-300);
}
.btn.btn-outline-dashed {
  border: 1px dashed var(--bs-gray-300);
}
.btn.btn-flush {
  appearance: none;
  box-shadow: none;
  border-radius: 0;
  border: none;
  cursor: pointer;
  background-color: transparent;
  outline: none !important;
  margin: 0;
  padding: 0;
}
.btn.btn-flex {
  display: inline-flex;
  align-items: center;
}
.btn.btn-trim-start {
  justify-content: flex-start !important;
  padding-left: 0 !important;
}
.btn.btn-trim-end {
  justify-content: flex-end !important;
  padding-right: 0 !important;
}

.btn-reset {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
}

.btn > i {
  display: inline-flex;
  font-size: 1rem;
  padding-right: 0.35rem;
  vertical-align: middle;
}
.btn.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: calc(1.5em + 1.55rem + 2px);
  width: calc(1.5em + 1.55rem + 2px);
  line-height: 1;
}
.btn.btn-icon i {
  padding-right: 0;
}
.btn.btn-icon:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {
  border: 0;
}
.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon {
  height: calc(1.5em + 1.1rem + 2px);
  width: calc(1.5em + 1.1rem + 2px);
}
.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon {
  height: calc(1.5em + 1.65rem + 2px);
  width: calc(1.5em + 1.65rem + 2px);
}
.btn.btn-icon.btn-circle {
  border-radius: 50%;
}

.btn.btn-outline.btn-outline-dashed {
  border-width: 1px;
  border-style: dashed;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dashed, .btn-check:active + .btn.btn-outline.btn-outline-dashed, .btn.btn-outline.btn-outline-dashed:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.active, .btn.btn-outline.btn-outline-dashed.show, .show > .btn.btn-outline.btn-outline-dashed {
  border-color: var(--bs-primary);
}

.btn.btn-hover-outline {
  border-width: 1px;
  border-style: solid;
}
.btn-check:checked + .btn.btn-hover-outline, .btn-check:active + .btn.btn-hover-outline, .btn.btn-hover-outline:focus:not(.btn-active), .btn.btn-hover-outline:hover:not(.btn-active), .btn.btn-hover-outline:active:not(.btn-active), .btn.btn-hover-outline.active, .btn.btn-hover-outline.show, .show > .btn.btn-hover-outline {
  border-color: var(--bs-gray-300);
}

.btn.btn-light {
  color: var(--bs-light-inverse);
  border-color: var(--bs-light);
  background-color: var(--bs-light);
}
.btn.btn-light i,
.btn.btn-light .svg-icon {
  color: var(--bs-light-inverse);
}
.btn.btn-light.dropdown-toggle:after {
  color: var(--bs-light-inverse);
}
.btn-check:checked + .btn.btn-light, .btn-check:active + .btn.btn-light, .btn.btn-light:focus:not(.btn-active), .btn.btn-light:hover:not(.btn-active), .btn.btn-light:active:not(.btn-active), .btn.btn-light.active, .btn.btn-light.show, .show > .btn.btn-light {
  color: var(--bs-light-inverse);
  border-color: var(--bs-light-active);
  background-color: var(--bs-light-active) !important;
}
.btn-check:checked + .btn.btn-light i,
.btn-check:checked + .btn.btn-light .svg-icon, .btn-check:active + .btn.btn-light i,
.btn-check:active + .btn.btn-light .svg-icon, .btn.btn-light:focus:not(.btn-active) i,
.btn.btn-light:focus:not(.btn-active) .svg-icon, .btn.btn-light:hover:not(.btn-active) i,
.btn.btn-light:hover:not(.btn-active) .svg-icon, .btn.btn-light:active:not(.btn-active) i,
.btn.btn-light:active:not(.btn-active) .svg-icon, .btn.btn-light.active i,
.btn.btn-light.active .svg-icon, .btn.btn-light.show i,
.btn.btn-light.show .svg-icon, .show > .btn.btn-light i,
.show > .btn.btn-light .svg-icon {
  color: var(--bs-light-inverse);
}
.btn-check:checked + .btn.btn-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light.dropdown-toggle:after, .btn.btn-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light.active.dropdown-toggle:after, .btn.btn-light.show.dropdown-toggle:after, .show > .btn.btn-light.dropdown-toggle:after {
  color: var(--bs-light-inverse);
}

.btn.btn-light-light {
  color: var(--bs-light);
  border-color: var(--bs-light-light);
  background-color: var(--bs-light-light);
}
.btn.btn-light-light i,
.btn.btn-light-light .svg-icon {
  color: var(--bs-light);
}
.btn.btn-light-light.dropdown-toggle:after {
  color: var(--bs-light);
}
.btn-check:checked + .btn.btn-light-light, .btn-check:active + .btn.btn-light-light, .btn.btn-light-light:focus:not(.btn-active), .btn.btn-light-light:hover:not(.btn-active), .btn.btn-light-light:active:not(.btn-active), .btn.btn-light-light.active, .btn.btn-light-light.show, .show > .btn.btn-light-light {
  color: var(--bs-light-inverse);
  border-color: var(--bs-light);
  background-color: var(--bs-light) !important;
}
.btn-check:checked + .btn.btn-light-light i,
.btn-check:checked + .btn.btn-light-light .svg-icon, .btn-check:active + .btn.btn-light-light i,
.btn-check:active + .btn.btn-light-light .svg-icon, .btn.btn-light-light:focus:not(.btn-active) i,
.btn.btn-light-light:focus:not(.btn-active) .svg-icon, .btn.btn-light-light:hover:not(.btn-active) i,
.btn.btn-light-light:hover:not(.btn-active) .svg-icon, .btn.btn-light-light:active:not(.btn-active) i,
.btn.btn-light-light:active:not(.btn-active) .svg-icon, .btn.btn-light-light.active i,
.btn.btn-light-light.active .svg-icon, .btn.btn-light-light.show i,
.btn.btn-light-light.show .svg-icon, .show > .btn.btn-light-light i,
.show > .btn.btn-light-light .svg-icon {
  color: var(--bs-light-inverse);
}
.btn-check:checked + .btn.btn-light-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light-light.dropdown-toggle:after, .btn.btn-light-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-light.active.dropdown-toggle:after, .btn.btn-light-light.show.dropdown-toggle:after, .show > .btn.btn-light-light.dropdown-toggle:after {
  color: var(--bs-light-inverse);
}

.btn.btn-bg-light {
  border-color: var(--bs-light);
  background-color: var(--bs-light);
}
.btn-check:checked + .btn.btn-active-light, .btn-check:active + .btn.btn-active-light, .btn.btn-active-light:focus:not(.btn-active), .btn.btn-active-light:hover:not(.btn-active), .btn.btn-active-light:active:not(.btn-active), .btn.btn-active-light.active, .btn.btn-active-light.show, .show > .btn.btn-active-light {
  color: var(--bs-light-inverse);
  border-color: var(--bs-light);
  background-color: var(--bs-light) !important;
}
.btn-check:checked + .btn.btn-active-light i,
.btn-check:checked + .btn.btn-active-light .svg-icon, .btn-check:active + .btn.btn-active-light i,
.btn-check:active + .btn.btn-active-light .svg-icon, .btn.btn-active-light:focus:not(.btn-active) i,
.btn.btn-active-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-light:hover:not(.btn-active) i,
.btn.btn-active-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-light:active:not(.btn-active) i,
.btn.btn-active-light:active:not(.btn-active) .svg-icon, .btn.btn-active-light.active i,
.btn.btn-active-light.active .svg-icon, .btn.btn-active-light.show i,
.btn.btn-active-light.show .svg-icon, .show > .btn.btn-active-light i,
.show > .btn.btn-active-light .svg-icon {
  color: var(--bs-light-inverse);
}
.btn-check:checked + .btn.btn-active-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light.dropdown-toggle:after, .btn.btn-active-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light.active.dropdown-toggle:after, .btn.btn-active-light.show.dropdown-toggle:after, .show > .btn.btn-active-light.dropdown-toggle:after {
  color: var(--bs-light-inverse);
}

.btn-check:checked + .btn.btn-active-light-light, .btn-check:active + .btn.btn-active-light-light, .btn.btn-active-light-light:focus:not(.btn-active), .btn.btn-active-light-light:hover:not(.btn-active), .btn.btn-active-light-light:active:not(.btn-active), .btn.btn-active-light-light.active, .btn.btn-active-light-light.show, .show > .btn.btn-active-light-light {
  color: var(--bs-light);
  border-color: var(--bs-light-light);
  background-color: var(--bs-light-light) !important;
}
.btn-check:checked + .btn.btn-active-light-light i,
.btn-check:checked + .btn.btn-active-light-light .svg-icon, .btn-check:active + .btn.btn-active-light-light i,
.btn-check:active + .btn.btn-active-light-light .svg-icon, .btn.btn-active-light-light:focus:not(.btn-active) i,
.btn.btn-active-light-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-light:hover:not(.btn-active) i,
.btn.btn-active-light-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-light:active:not(.btn-active) i,
.btn.btn-active-light-light:active:not(.btn-active) .svg-icon, .btn.btn-active-light-light.active i,
.btn.btn-active-light-light.active .svg-icon, .btn.btn-active-light-light.show i,
.btn.btn-active-light-light.show .svg-icon, .show > .btn.btn-active-light-light i,
.show > .btn.btn-active-light-light .svg-icon {
  color: var(--bs-light);
}
.btn-check:checked + .btn.btn-active-light-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-light.dropdown-toggle:after, .btn.btn-active-light-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-light.active.dropdown-toggle:after, .btn.btn-active-light-light.show.dropdown-toggle:after, .show > .btn.btn-active-light-light.dropdown-toggle:after {
  color: var(--bs-light);
}

.btn.btn-outline.btn-outline-light {
  color: var(--bs-light);
  border-color: var(--bs-light);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-light i,
.btn.btn-outline.btn-outline-light .svg-icon {
  color: var(--bs-light);
}
.btn.btn-outline.btn-outline-light.dropdown-toggle:after {
  color: var(--bs-light);
}
.btn-check:checked + .btn.btn-outline.btn-outline-light, .btn-check:active + .btn.btn-outline.btn-outline-light, .btn.btn-outline.btn-outline-light:focus:not(.btn-active), .btn.btn-outline.btn-outline-light:hover:not(.btn-active), .btn.btn-outline.btn-outline-light:active:not(.btn-active), .btn.btn-outline.btn-outline-light.active, .btn.btn-outline.btn-outline-light.show, .show > .btn.btn-outline.btn-outline-light {
  color: var(--bs-light-active);
  border-color: var(--bs-light);
  background-color: var(--bs-light-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-light i,
.btn-check:checked + .btn.btn-outline.btn-outline-light .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-light i,
.btn-check:active + .btn.btn-outline.btn-outline-light .svg-icon, .btn.btn-outline.btn-outline-light:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-light:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-light:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-light:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light.active i,
.btn.btn-outline.btn-outline-light.active .svg-icon, .btn.btn-outline.btn-outline-light.show i,
.btn.btn-outline.btn-outline-light.show .svg-icon, .show > .btn.btn-outline.btn-outline-light i,
.show > .btn.btn-outline.btn-outline-light .svg-icon {
  color: var(--bs-light-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn.btn-outline.btn-outline-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-light.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-light.dropdown-toggle:after {
  color: var(--bs-light-active);
}

.btn.btn-primary {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary);
}
.btn.btn-primary i,
.btn.btn-primary .svg-icon {
  color: var(--bs-primary-inverse);
}
.btn.btn-primary.dropdown-toggle:after {
  color: var(--bs-primary-inverse);
}
.btn-check:checked + .btn.btn-primary, .btn-check:active + .btn.btn-primary, .btn.btn-primary:focus:not(.btn-active), .btn.btn-primary:hover:not(.btn-active), .btn.btn-primary:active:not(.btn-active), .btn.btn-primary.active, .btn.btn-primary.show, .show > .btn.btn-primary {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary-active);
  background-color: var(--bs-primary-active) !important;
}
.btn-check:checked + .btn.btn-primary i,
.btn-check:checked + .btn.btn-primary .svg-icon, .btn-check:active + .btn.btn-primary i,
.btn-check:active + .btn.btn-primary .svg-icon, .btn.btn-primary:focus:not(.btn-active) i,
.btn.btn-primary:focus:not(.btn-active) .svg-icon, .btn.btn-primary:hover:not(.btn-active) i,
.btn.btn-primary:hover:not(.btn-active) .svg-icon, .btn.btn-primary:active:not(.btn-active) i,
.btn.btn-primary:active:not(.btn-active) .svg-icon, .btn.btn-primary.active i,
.btn.btn-primary.active .svg-icon, .btn.btn-primary.show i,
.btn.btn-primary.show .svg-icon, .show > .btn.btn-primary i,
.show > .btn.btn-primary .svg-icon {
  color: var(--bs-primary-inverse);
}
.btn-check:checked + .btn.btn-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-primary.dropdown-toggle:after, .btn.btn-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-primary.active.dropdown-toggle:after, .btn.btn-primary.show.dropdown-toggle:after, .show > .btn.btn-primary.dropdown-toggle:after {
  color: var(--bs-primary-inverse);
}

.btn.btn-light-primary {
  color: var(--bs-primary);
  border-color: var(--bs-primary-light);
  background-color: var(--bs-primary-light);
}
.btn.btn-light-primary i,
.btn.btn-light-primary .svg-icon {
  color: var(--bs-primary);
}
.btn.btn-light-primary.dropdown-toggle:after {
  color: var(--bs-primary);
}
.btn-check:checked + .btn.btn-light-primary, .btn-check:active + .btn.btn-light-primary, .btn.btn-light-primary:focus:not(.btn-active), .btn.btn-light-primary:hover:not(.btn-active), .btn.btn-light-primary:active:not(.btn-active), .btn.btn-light-primary.active, .btn.btn-light-primary.show, .show > .btn.btn-light-primary {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary) !important;
}
.btn-check:checked + .btn.btn-light-primary i,
.btn-check:checked + .btn.btn-light-primary .svg-icon, .btn-check:active + .btn.btn-light-primary i,
.btn-check:active + .btn.btn-light-primary .svg-icon, .btn.btn-light-primary:focus:not(.btn-active) i,
.btn.btn-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-light-primary:hover:not(.btn-active) i,
.btn.btn-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-light-primary:active:not(.btn-active) i,
.btn.btn-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-light-primary.active i,
.btn.btn-light-primary.active .svg-icon, .btn.btn-light-primary.show i,
.btn.btn-light-primary.show .svg-icon, .show > .btn.btn-light-primary i,
.show > .btn.btn-light-primary .svg-icon {
  color: var(--bs-primary-inverse);
}
.btn-check:checked + .btn.btn-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-primary.dropdown-toggle:after, .btn.btn-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary.active.dropdown-toggle:after, .btn.btn-light-primary.show.dropdown-toggle:after, .show > .btn.btn-light-primary.dropdown-toggle:after {
  color: var(--bs-primary-inverse);
}

.btn.btn-bg-primary {
  border-color: var(--bs-primary);
  background-color: var(--bs-primary);
}
.btn-check:checked + .btn.btn-active-primary, .btn-check:active + .btn.btn-active-primary, .btn.btn-active-primary:focus:not(.btn-active), .btn.btn-active-primary:hover:not(.btn-active), .btn.btn-active-primary:active:not(.btn-active), .btn.btn-active-primary.active, .btn.btn-active-primary.show, .show > .btn.btn-active-primary {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary) !important;
}
.btn-check:checked + .btn.btn-active-primary i,
.btn-check:checked + .btn.btn-active-primary .svg-icon, .btn-check:active + .btn.btn-active-primary i,
.btn-check:active + .btn.btn-active-primary .svg-icon, .btn.btn-active-primary:focus:not(.btn-active) i,
.btn.btn-active-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-primary:hover:not(.btn-active) i,
.btn.btn-active-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-primary:active:not(.btn-active) i,
.btn.btn-active-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-primary.active i,
.btn.btn-active-primary.active .svg-icon, .btn.btn-active-primary.show i,
.btn.btn-active-primary.show .svg-icon, .show > .btn.btn-active-primary i,
.show > .btn.btn-active-primary .svg-icon {
  color: var(--bs-primary-inverse);
}
.btn-check:checked + .btn.btn-active-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-primary.dropdown-toggle:after, .btn.btn-active-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary.active.dropdown-toggle:after, .btn.btn-active-primary.show.dropdown-toggle:after, .show > .btn.btn-active-primary.dropdown-toggle:after {
  color: var(--bs-primary-inverse);
}

.btn-check:checked + .btn.btn-active-light-primary, .btn-check:active + .btn.btn-active-light-primary, .btn.btn-active-light-primary:focus:not(.btn-active), .btn.btn-active-light-primary:hover:not(.btn-active), .btn.btn-active-light-primary:active:not(.btn-active), .btn.btn-active-light-primary.active, .btn.btn-active-light-primary.show, .show > .btn.btn-active-light-primary {
  color: var(--bs-primary);
  border-color: var(--bs-primary-light);
  background-color: var(--bs-primary-light) !important;
}
.btn-check:checked + .btn.btn-active-light-primary i,
.btn-check:checked + .btn.btn-active-light-primary .svg-icon, .btn-check:active + .btn.btn-active-light-primary i,
.btn-check:active + .btn.btn-active-light-primary .svg-icon, .btn.btn-active-light-primary:focus:not(.btn-active) i,
.btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:hover:not(.btn-active) i,
.btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:active:not(.btn-active) i,
.btn.btn-active-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-primary.active i,
.btn.btn-active-light-primary.active .svg-icon, .btn.btn-active-light-primary.show i,
.btn.btn-active-light-primary.show .svg-icon, .show > .btn.btn-active-light-primary i,
.show > .btn.btn-active-light-primary .svg-icon {
  color: var(--bs-primary);
}
.btn-check:checked + .btn.btn-active-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-primary.dropdown-toggle:after, .btn.btn-active-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary.active.dropdown-toggle:after, .btn.btn-active-light-primary.show.dropdown-toggle:after, .show > .btn.btn-active-light-primary.dropdown-toggle:after {
  color: var(--bs-primary);
}

.btn.btn-outline.btn-outline-primary {
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-primary i,
.btn.btn-outline.btn-outline-primary .svg-icon {
  color: var(--bs-primary);
}
.btn.btn-outline.btn-outline-primary.dropdown-toggle:after {
  color: var(--bs-primary);
}
.btn-check:checked + .btn.btn-outline.btn-outline-primary, .btn-check:active + .btn.btn-outline.btn-outline-primary, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active), .btn.btn-outline.btn-outline-primary:hover:not(.btn-active), .btn.btn-outline.btn-outline-primary:active:not(.btn-active), .btn.btn-outline.btn-outline-primary.active, .btn.btn-outline.btn-outline-primary.show, .show > .btn.btn-outline.btn-outline-primary {
  color: var(--bs-primary-active);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-primary i,
.btn-check:checked + .btn.btn-outline.btn-outline-primary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-primary i,
.btn-check:active + .btn.btn-outline.btn-outline-primary .svg-icon, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-primary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-primary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-primary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary.active i,
.btn.btn-outline.btn-outline-primary.active .svg-icon, .btn.btn-outline.btn-outline-primary.show i,
.btn.btn-outline.btn-outline-primary.show .svg-icon, .show > .btn.btn-outline.btn-outline-primary i,
.show > .btn.btn-outline.btn-outline-primary .svg-icon {
  color: var(--bs-primary-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-primary.dropdown-toggle:after {
  color: var(--bs-primary-active);
}

.btn.btn-secondary {
  color: var(--bs-secondary-inverse);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary);
}
.btn.btn-secondary i,
.btn.btn-secondary .svg-icon {
  color: var(--bs-secondary-inverse);
}
.btn.btn-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-inverse);
}
.btn-check:checked + .btn.btn-secondary, .btn-check:active + .btn.btn-secondary, .btn.btn-secondary:focus:not(.btn-active), .btn.btn-secondary:hover:not(.btn-active), .btn.btn-secondary:active:not(.btn-active), .btn.btn-secondary.active, .btn.btn-secondary.show, .show > .btn.btn-secondary {
  color: var(--bs-secondary-inverse);
  border-color: var(--bs-secondary-active);
  background-color: var(--bs-secondary-active) !important;
}
.btn-check:checked + .btn.btn-secondary i,
.btn-check:checked + .btn.btn-secondary .svg-icon, .btn-check:active + .btn.btn-secondary i,
.btn-check:active + .btn.btn-secondary .svg-icon, .btn.btn-secondary:focus:not(.btn-active) i,
.btn.btn-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-secondary:hover:not(.btn-active) i,
.btn.btn-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-secondary:active:not(.btn-active) i,
.btn.btn-secondary:active:not(.btn-active) .svg-icon, .btn.btn-secondary.active i,
.btn.btn-secondary.active .svg-icon, .btn.btn-secondary.show i,
.btn.btn-secondary.show .svg-icon, .show > .btn.btn-secondary i,
.show > .btn.btn-secondary .svg-icon {
  color: var(--bs-secondary-inverse);
}
.btn-check:checked + .btn.btn-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-secondary.dropdown-toggle:after, .btn.btn-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary.active.dropdown-toggle:after, .btn.btn-secondary.show.dropdown-toggle:after, .show > .btn.btn-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-inverse);
}

.btn.btn-light-secondary {
  color: var(--bs-secondary);
  border-color: var(--bs-secondary-light);
  background-color: var(--bs-secondary-light);
}
.btn.btn-light-secondary i,
.btn.btn-light-secondary .svg-icon {
  color: var(--bs-secondary);
}
.btn.btn-light-secondary.dropdown-toggle:after {
  color: var(--bs-secondary);
}
.btn-check:checked + .btn.btn-light-secondary, .btn-check:active + .btn.btn-light-secondary, .btn.btn-light-secondary:focus:not(.btn-active), .btn.btn-light-secondary:hover:not(.btn-active), .btn.btn-light-secondary:active:not(.btn-active), .btn.btn-light-secondary.active, .btn.btn-light-secondary.show, .show > .btn.btn-light-secondary {
  color: var(--bs-secondary-inverse);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary) !important;
}
.btn-check:checked + .btn.btn-light-secondary i,
.btn-check:checked + .btn.btn-light-secondary .svg-icon, .btn-check:active + .btn.btn-light-secondary i,
.btn-check:active + .btn.btn-light-secondary .svg-icon, .btn.btn-light-secondary:focus:not(.btn-active) i,
.btn.btn-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-light-secondary:hover:not(.btn-active) i,
.btn.btn-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-light-secondary:active:not(.btn-active) i,
.btn.btn-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-light-secondary.active i,
.btn.btn-light-secondary.active .svg-icon, .btn.btn-light-secondary.show i,
.btn.btn-light-secondary.show .svg-icon, .show > .btn.btn-light-secondary i,
.show > .btn.btn-light-secondary .svg-icon {
  color: var(--bs-secondary-inverse);
}
.btn-check:checked + .btn.btn-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-secondary.dropdown-toggle:after, .btn.btn-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary.active.dropdown-toggle:after, .btn.btn-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-light-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-inverse);
}

.btn.btn-bg-secondary {
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary);
}
.btn-check:checked + .btn.btn-active-secondary, .btn-check:active + .btn.btn-active-secondary, .btn.btn-active-secondary:focus:not(.btn-active), .btn.btn-active-secondary:hover:not(.btn-active), .btn.btn-active-secondary:active:not(.btn-active), .btn.btn-active-secondary.active, .btn.btn-active-secondary.show, .show > .btn.btn-active-secondary {
  color: var(--bs-secondary-inverse);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary) !important;
}
.btn-check:checked + .btn.btn-active-secondary i,
.btn-check:checked + .btn.btn-active-secondary .svg-icon, .btn-check:active + .btn.btn-active-secondary i,
.btn-check:active + .btn.btn-active-secondary .svg-icon, .btn.btn-active-secondary:focus:not(.btn-active) i,
.btn.btn-active-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-secondary:hover:not(.btn-active) i,
.btn.btn-active-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-secondary:active:not(.btn-active) i,
.btn.btn-active-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-secondary.active i,
.btn.btn-active-secondary.active .svg-icon, .btn.btn-active-secondary.show i,
.btn.btn-active-secondary.show .svg-icon, .show > .btn.btn-active-secondary i,
.show > .btn.btn-active-secondary .svg-icon {
  color: var(--bs-secondary-inverse);
}
.btn-check:checked + .btn.btn-active-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-secondary.dropdown-toggle:after, .btn.btn-active-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary.active.dropdown-toggle:after, .btn.btn-active-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-inverse);
}

.btn-check:checked + .btn.btn-active-light-secondary, .btn-check:active + .btn.btn-active-light-secondary, .btn.btn-active-light-secondary:focus:not(.btn-active), .btn.btn-active-light-secondary:hover:not(.btn-active), .btn.btn-active-light-secondary:active:not(.btn-active), .btn.btn-active-light-secondary.active, .btn.btn-active-light-secondary.show, .show > .btn.btn-active-light-secondary {
  color: var(--bs-secondary);
  border-color: var(--bs-secondary-light);
  background-color: var(--bs-secondary-light) !important;
}
.btn-check:checked + .btn.btn-active-light-secondary i,
.btn-check:checked + .btn.btn-active-light-secondary .svg-icon, .btn-check:active + .btn.btn-active-light-secondary i,
.btn-check:active + .btn.btn-active-light-secondary .svg-icon, .btn.btn-active-light-secondary:focus:not(.btn-active) i,
.btn.btn-active-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:hover:not(.btn-active) i,
.btn.btn-active-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:active:not(.btn-active) i,
.btn.btn-active-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary.active i,
.btn.btn-active-light-secondary.active .svg-icon, .btn.btn-active-light-secondary.show i,
.btn.btn-active-light-secondary.show .svg-icon, .show > .btn.btn-active-light-secondary i,
.show > .btn.btn-active-light-secondary .svg-icon {
  color: var(--bs-secondary);
}
.btn-check:checked + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn.btn-active-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary.active.dropdown-toggle:after, .btn.btn-active-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-light-secondary.dropdown-toggle:after {
  color: var(--bs-secondary);
}

.btn.btn-outline.btn-outline-secondary {
  color: var(--bs-secondary);
  border-color: var(--bs-secondary);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-secondary i,
.btn.btn-outline.btn-outline-secondary .svg-icon {
  color: var(--bs-secondary);
}
.btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {
  color: var(--bs-secondary);
}
.btn-check:checked + .btn.btn-outline.btn-outline-secondary, .btn-check:active + .btn.btn-outline.btn-outline-secondary, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active), .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active), .btn.btn-outline.btn-outline-secondary:active:not(.btn-active), .btn.btn-outline.btn-outline-secondary.active, .btn.btn-outline.btn-outline-secondary.show, .show > .btn.btn-outline.btn-outline-secondary {
  color: var(--bs-secondary-active);
  border-color: var(--bs-secondary);
  background-color: var(--bs-secondary-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-secondary i,
.btn-check:checked + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-secondary i,
.btn-check:active + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-secondary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary.active i,
.btn.btn-outline.btn-outline-secondary.active .svg-icon, .btn.btn-outline.btn-outline-secondary.show i,
.btn.btn-outline.btn-outline-secondary.show .svg-icon, .show > .btn.btn-outline.btn-outline-secondary i,
.show > .btn.btn-outline.btn-outline-secondary .svg-icon {
  color: var(--bs-secondary-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {
  color: var(--bs-secondary-active);
}

.btn.btn-success {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success);
  background-color: var(--bs-success);
}
.btn.btn-success i,
.btn.btn-success .svg-icon {
  color: var(--bs-success-inverse);
}
.btn.btn-success.dropdown-toggle:after {
  color: var(--bs-success-inverse);
}
.btn-check:checked + .btn.btn-success, .btn-check:active + .btn.btn-success, .btn.btn-success:focus:not(.btn-active), .btn.btn-success:hover:not(.btn-active), .btn.btn-success:active:not(.btn-active), .btn.btn-success.active, .btn.btn-success.show, .show > .btn.btn-success {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success-active);
  background-color: var(--bs-success-active) !important;
}
.btn-check:checked + .btn.btn-success i,
.btn-check:checked + .btn.btn-success .svg-icon, .btn-check:active + .btn.btn-success i,
.btn-check:active + .btn.btn-success .svg-icon, .btn.btn-success:focus:not(.btn-active) i,
.btn.btn-success:focus:not(.btn-active) .svg-icon, .btn.btn-success:hover:not(.btn-active) i,
.btn.btn-success:hover:not(.btn-active) .svg-icon, .btn.btn-success:active:not(.btn-active) i,
.btn.btn-success:active:not(.btn-active) .svg-icon, .btn.btn-success.active i,
.btn.btn-success.active .svg-icon, .btn.btn-success.show i,
.btn.btn-success.show .svg-icon, .show > .btn.btn-success i,
.show > .btn.btn-success .svg-icon {
  color: var(--bs-success-inverse);
}
.btn-check:checked + .btn.btn-success.dropdown-toggle:after, .btn-check:active + .btn.btn-success.dropdown-toggle:after, .btn.btn-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-success.active.dropdown-toggle:after, .btn.btn-success.show.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle:after {
  color: var(--bs-success-inverse);
}

.btn.btn-light-success {
  color: var(--bs-success);
  border-color: var(--bs-success-light);
  background-color: var(--bs-success-light);
}
.btn.btn-light-success i,
.btn.btn-light-success .svg-icon {
  color: var(--bs-success);
}
.btn.btn-light-success.dropdown-toggle:after {
  color: var(--bs-success);
}
.btn-check:checked + .btn.btn-light-success, .btn-check:active + .btn.btn-light-success, .btn.btn-light-success:focus:not(.btn-active), .btn.btn-light-success:hover:not(.btn-active), .btn.btn-light-success:active:not(.btn-active), .btn.btn-light-success.active, .btn.btn-light-success.show, .show > .btn.btn-light-success {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success);
  background-color: var(--bs-success) !important;
}
.btn-check:checked + .btn.btn-light-success i,
.btn-check:checked + .btn.btn-light-success .svg-icon, .btn-check:active + .btn.btn-light-success i,
.btn-check:active + .btn.btn-light-success .svg-icon, .btn.btn-light-success:focus:not(.btn-active) i,
.btn.btn-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-light-success:hover:not(.btn-active) i,
.btn.btn-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-light-success:active:not(.btn-active) i,
.btn.btn-light-success:active:not(.btn-active) .svg-icon, .btn.btn-light-success.active i,
.btn.btn-light-success.active .svg-icon, .btn.btn-light-success.show i,
.btn.btn-light-success.show .svg-icon, .show > .btn.btn-light-success i,
.show > .btn.btn-light-success .svg-icon {
  color: var(--bs-success-inverse);
}
.btn-check:checked + .btn.btn-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-light-success.dropdown-toggle:after, .btn.btn-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success.active.dropdown-toggle:after, .btn.btn-light-success.show.dropdown-toggle:after, .show > .btn.btn-light-success.dropdown-toggle:after {
  color: var(--bs-success-inverse);
}

.btn.btn-bg-success {
  border-color: var(--bs-success);
  background-color: var(--bs-success);
}
.btn-check:checked + .btn.btn-active-success, .btn-check:active + .btn.btn-active-success, .btn.btn-active-success:focus:not(.btn-active), .btn.btn-active-success:hover:not(.btn-active), .btn.btn-active-success:active:not(.btn-active), .btn.btn-active-success.active, .btn.btn-active-success.show, .show > .btn.btn-active-success {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success);
  background-color: var(--bs-success) !important;
}
.btn-check:checked + .btn.btn-active-success i,
.btn-check:checked + .btn.btn-active-success .svg-icon, .btn-check:active + .btn.btn-active-success i,
.btn-check:active + .btn.btn-active-success .svg-icon, .btn.btn-active-success:focus:not(.btn-active) i,
.btn.btn-active-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-success:hover:not(.btn-active) i,
.btn.btn-active-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-success:active:not(.btn-active) i,
.btn.btn-active-success:active:not(.btn-active) .svg-icon, .btn.btn-active-success.active i,
.btn.btn-active-success.active .svg-icon, .btn.btn-active-success.show i,
.btn.btn-active-success.show .svg-icon, .show > .btn.btn-active-success i,
.show > .btn.btn-active-success .svg-icon {
  color: var(--bs-success-inverse);
}
.btn-check:checked + .btn.btn-active-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-success.dropdown-toggle:after, .btn.btn-active-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success.active.dropdown-toggle:after, .btn.btn-active-success.show.dropdown-toggle:after, .show > .btn.btn-active-success.dropdown-toggle:after {
  color: var(--bs-success-inverse);
}

.btn-check:checked + .btn.btn-active-light-success, .btn-check:active + .btn.btn-active-light-success, .btn.btn-active-light-success:focus:not(.btn-active), .btn.btn-active-light-success:hover:not(.btn-active), .btn.btn-active-light-success:active:not(.btn-active), .btn.btn-active-light-success.active, .btn.btn-active-light-success.show, .show > .btn.btn-active-light-success {
  color: var(--bs-success);
  border-color: var(--bs-success-light);
  background-color: var(--bs-success-light) !important;
}
.btn-check:checked + .btn.btn-active-light-success i,
.btn-check:checked + .btn.btn-active-light-success .svg-icon, .btn-check:active + .btn.btn-active-light-success i,
.btn-check:active + .btn.btn-active-light-success .svg-icon, .btn.btn-active-light-success:focus:not(.btn-active) i,
.btn.btn-active-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-success:hover:not(.btn-active) i,
.btn.btn-active-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-success:active:not(.btn-active) i,
.btn.btn-active-light-success:active:not(.btn-active) .svg-icon, .btn.btn-active-light-success.active i,
.btn.btn-active-light-success.active .svg-icon, .btn.btn-active-light-success.show i,
.btn.btn-active-light-success.show .svg-icon, .show > .btn.btn-active-light-success i,
.show > .btn.btn-active-light-success .svg-icon {
  color: var(--bs-success);
}
.btn-check:checked + .btn.btn-active-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-success.dropdown-toggle:after, .btn.btn-active-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success.active.dropdown-toggle:after, .btn.btn-active-light-success.show.dropdown-toggle:after, .show > .btn.btn-active-light-success.dropdown-toggle:after {
  color: var(--bs-success);
}

.btn.btn-outline.btn-outline-success {
  color: var(--bs-success);
  border-color: var(--bs-success);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-success i,
.btn.btn-outline.btn-outline-success .svg-icon {
  color: var(--bs-success);
}
.btn.btn-outline.btn-outline-success.dropdown-toggle:after {
  color: var(--bs-success);
}
.btn-check:checked + .btn.btn-outline.btn-outline-success, .btn-check:active + .btn.btn-outline.btn-outline-success, .btn.btn-outline.btn-outline-success:focus:not(.btn-active), .btn.btn-outline.btn-outline-success:hover:not(.btn-active), .btn.btn-outline.btn-outline-success:active:not(.btn-active), .btn.btn-outline.btn-outline-success.active, .btn.btn-outline.btn-outline-success.show, .show > .btn.btn-outline.btn-outline-success {
  color: var(--bs-success-active);
  border-color: var(--bs-success);
  background-color: var(--bs-success-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-success i,
.btn-check:checked + .btn.btn-outline.btn-outline-success .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-success i,
.btn-check:active + .btn.btn-outline.btn-outline-success .svg-icon, .btn.btn-outline.btn-outline-success:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-success:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-success:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-success:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success.active i,
.btn.btn-outline.btn-outline-success.active .svg-icon, .btn.btn-outline.btn-outline-success.show i,
.btn.btn-outline.btn-outline-success.show .svg-icon, .show > .btn.btn-outline.btn-outline-success i,
.show > .btn.btn-outline.btn-outline-success .svg-icon {
  color: var(--bs-success-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn.btn-outline.btn-outline-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-success.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-success.dropdown-toggle:after {
  color: var(--bs-success-active);
}

.btn.btn-info {
  color: var(--bs-info-inverse);
  border-color: var(--bs-info);
  background-color: var(--bs-info);
}
.btn.btn-info i,
.btn.btn-info .svg-icon {
  color: var(--bs-info-inverse);
}
.btn.btn-info.dropdown-toggle:after {
  color: var(--bs-info-inverse);
}
.btn-check:checked + .btn.btn-info, .btn-check:active + .btn.btn-info, .btn.btn-info:focus:not(.btn-active), .btn.btn-info:hover:not(.btn-active), .btn.btn-info:active:not(.btn-active), .btn.btn-info.active, .btn.btn-info.show, .show > .btn.btn-info {
  color: var(--bs-info-inverse);
  border-color: var(--bs-info-active);
  background-color: var(--bs-info-active) !important;
}
.btn-check:checked + .btn.btn-info i,
.btn-check:checked + .btn.btn-info .svg-icon, .btn-check:active + .btn.btn-info i,
.btn-check:active + .btn.btn-info .svg-icon, .btn.btn-info:focus:not(.btn-active) i,
.btn.btn-info:focus:not(.btn-active) .svg-icon, .btn.btn-info:hover:not(.btn-active) i,
.btn.btn-info:hover:not(.btn-active) .svg-icon, .btn.btn-info:active:not(.btn-active) i,
.btn.btn-info:active:not(.btn-active) .svg-icon, .btn.btn-info.active i,
.btn.btn-info.active .svg-icon, .btn.btn-info.show i,
.btn.btn-info.show .svg-icon, .show > .btn.btn-info i,
.show > .btn.btn-info .svg-icon {
  color: var(--bs-info-inverse);
}
.btn-check:checked + .btn.btn-info.dropdown-toggle:after, .btn-check:active + .btn.btn-info.dropdown-toggle:after, .btn.btn-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-info.active.dropdown-toggle:after, .btn.btn-info.show.dropdown-toggle:after, .show > .btn.btn-info.dropdown-toggle:after {
  color: var(--bs-info-inverse);
}

.btn.btn-light-info {
  color: var(--bs-info);
  border-color: var(--bs-info-light);
  background-color: var(--bs-info-light);
}
.btn.btn-light-info i,
.btn.btn-light-info .svg-icon {
  color: var(--bs-info);
}
.btn.btn-light-info.dropdown-toggle:after {
  color: var(--bs-info);
}
.btn-check:checked + .btn.btn-light-info, .btn-check:active + .btn.btn-light-info, .btn.btn-light-info:focus:not(.btn-active), .btn.btn-light-info:hover:not(.btn-active), .btn.btn-light-info:active:not(.btn-active), .btn.btn-light-info.active, .btn.btn-light-info.show, .show > .btn.btn-light-info {
  color: var(--bs-info-inverse);
  border-color: var(--bs-info);
  background-color: var(--bs-info) !important;
}
.btn-check:checked + .btn.btn-light-info i,
.btn-check:checked + .btn.btn-light-info .svg-icon, .btn-check:active + .btn.btn-light-info i,
.btn-check:active + .btn.btn-light-info .svg-icon, .btn.btn-light-info:focus:not(.btn-active) i,
.btn.btn-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-light-info:hover:not(.btn-active) i,
.btn.btn-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-light-info:active:not(.btn-active) i,
.btn.btn-light-info:active:not(.btn-active) .svg-icon, .btn.btn-light-info.active i,
.btn.btn-light-info.active .svg-icon, .btn.btn-light-info.show i,
.btn.btn-light-info.show .svg-icon, .show > .btn.btn-light-info i,
.show > .btn.btn-light-info .svg-icon {
  color: var(--bs-info-inverse);
}
.btn-check:checked + .btn.btn-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-light-info.dropdown-toggle:after, .btn.btn-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info.active.dropdown-toggle:after, .btn.btn-light-info.show.dropdown-toggle:after, .show > .btn.btn-light-info.dropdown-toggle:after {
  color: var(--bs-info-inverse);
}

.btn.btn-bg-info {
  border-color: var(--bs-info);
  background-color: var(--bs-info);
}
.btn-check:checked + .btn.btn-active-info, .btn-check:active + .btn.btn-active-info, .btn.btn-active-info:focus:not(.btn-active), .btn.btn-active-info:hover:not(.btn-active), .btn.btn-active-info:active:not(.btn-active), .btn.btn-active-info.active, .btn.btn-active-info.show, .show > .btn.btn-active-info {
  color: var(--bs-info-inverse);
  border-color: var(--bs-info);
  background-color: var(--bs-info) !important;
}
.btn-check:checked + .btn.btn-active-info i,
.btn-check:checked + .btn.btn-active-info .svg-icon, .btn-check:active + .btn.btn-active-info i,
.btn-check:active + .btn.btn-active-info .svg-icon, .btn.btn-active-info:focus:not(.btn-active) i,
.btn.btn-active-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-info:hover:not(.btn-active) i,
.btn.btn-active-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-info:active:not(.btn-active) i,
.btn.btn-active-info:active:not(.btn-active) .svg-icon, .btn.btn-active-info.active i,
.btn.btn-active-info.active .svg-icon, .btn.btn-active-info.show i,
.btn.btn-active-info.show .svg-icon, .show > .btn.btn-active-info i,
.show > .btn.btn-active-info .svg-icon {
  color: var(--bs-info-inverse);
}
.btn-check:checked + .btn.btn-active-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-info.dropdown-toggle:after, .btn.btn-active-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info.active.dropdown-toggle:after, .btn.btn-active-info.show.dropdown-toggle:after, .show > .btn.btn-active-info.dropdown-toggle:after {
  color: var(--bs-info-inverse);
}

.btn-check:checked + .btn.btn-active-light-info, .btn-check:active + .btn.btn-active-light-info, .btn.btn-active-light-info:focus:not(.btn-active), .btn.btn-active-light-info:hover:not(.btn-active), .btn.btn-active-light-info:active:not(.btn-active), .btn.btn-active-light-info.active, .btn.btn-active-light-info.show, .show > .btn.btn-active-light-info {
  color: var(--bs-info);
  border-color: var(--bs-info-light);
  background-color: var(--bs-info-light) !important;
}
.btn-check:checked + .btn.btn-active-light-info i,
.btn-check:checked + .btn.btn-active-light-info .svg-icon, .btn-check:active + .btn.btn-active-light-info i,
.btn-check:active + .btn.btn-active-light-info .svg-icon, .btn.btn-active-light-info:focus:not(.btn-active) i,
.btn.btn-active-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-info:hover:not(.btn-active) i,
.btn.btn-active-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-info:active:not(.btn-active) i,
.btn.btn-active-light-info:active:not(.btn-active) .svg-icon, .btn.btn-active-light-info.active i,
.btn.btn-active-light-info.active .svg-icon, .btn.btn-active-light-info.show i,
.btn.btn-active-light-info.show .svg-icon, .show > .btn.btn-active-light-info i,
.show > .btn.btn-active-light-info .svg-icon {
  color: var(--bs-info);
}
.btn-check:checked + .btn.btn-active-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-info.dropdown-toggle:after, .btn.btn-active-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info.active.dropdown-toggle:after, .btn.btn-active-light-info.show.dropdown-toggle:after, .show > .btn.btn-active-light-info.dropdown-toggle:after {
  color: var(--bs-info);
}

.btn.btn-outline.btn-outline-info {
  color: var(--bs-info);
  border-color: var(--bs-info);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-info i,
.btn.btn-outline.btn-outline-info .svg-icon {
  color: var(--bs-info);
}
.btn.btn-outline.btn-outline-info.dropdown-toggle:after {
  color: var(--bs-info);
}
.btn-check:checked + .btn.btn-outline.btn-outline-info, .btn-check:active + .btn.btn-outline.btn-outline-info, .btn.btn-outline.btn-outline-info:focus:not(.btn-active), .btn.btn-outline.btn-outline-info:hover:not(.btn-active), .btn.btn-outline.btn-outline-info:active:not(.btn-active), .btn.btn-outline.btn-outline-info.active, .btn.btn-outline.btn-outline-info.show, .show > .btn.btn-outline.btn-outline-info {
  color: var(--bs-info-active);
  border-color: var(--bs-info);
  background-color: var(--bs-info-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-info i,
.btn-check:checked + .btn.btn-outline.btn-outline-info .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-info i,
.btn-check:active + .btn.btn-outline.btn-outline-info .svg-icon, .btn.btn-outline.btn-outline-info:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-info:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-info:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-info:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info.active i,
.btn.btn-outline.btn-outline-info.active .svg-icon, .btn.btn-outline.btn-outline-info.show i,
.btn.btn-outline.btn-outline-info.show .svg-icon, .show > .btn.btn-outline.btn-outline-info i,
.show > .btn.btn-outline.btn-outline-info .svg-icon {
  color: var(--bs-info-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn.btn-outline.btn-outline-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-info.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-info.dropdown-toggle:after {
  color: var(--bs-info-active);
}

.btn.btn-warning {
  color: var(--bs-warning-inverse);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning);
}
.btn.btn-warning i,
.btn.btn-warning .svg-icon {
  color: var(--bs-warning-inverse);
}
.btn.btn-warning.dropdown-toggle:after {
  color: var(--bs-warning-inverse);
}
.btn-check:checked + .btn.btn-warning, .btn-check:active + .btn.btn-warning, .btn.btn-warning:focus:not(.btn-active), .btn.btn-warning:hover:not(.btn-active), .btn.btn-warning:active:not(.btn-active), .btn.btn-warning.active, .btn.btn-warning.show, .show > .btn.btn-warning {
  color: var(--bs-warning-inverse);
  border-color: var(--bs-warning-active);
  background-color: var(--bs-warning-active) !important;
}
.btn-check:checked + .btn.btn-warning i,
.btn-check:checked + .btn.btn-warning .svg-icon, .btn-check:active + .btn.btn-warning i,
.btn-check:active + .btn.btn-warning .svg-icon, .btn.btn-warning:focus:not(.btn-active) i,
.btn.btn-warning:focus:not(.btn-active) .svg-icon, .btn.btn-warning:hover:not(.btn-active) i,
.btn.btn-warning:hover:not(.btn-active) .svg-icon, .btn.btn-warning:active:not(.btn-active) i,
.btn.btn-warning:active:not(.btn-active) .svg-icon, .btn.btn-warning.active i,
.btn.btn-warning.active .svg-icon, .btn.btn-warning.show i,
.btn.btn-warning.show .svg-icon, .show > .btn.btn-warning i,
.show > .btn.btn-warning .svg-icon {
  color: var(--bs-warning-inverse);
}
.btn-check:checked + .btn.btn-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-warning.dropdown-toggle:after, .btn.btn-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-warning.active.dropdown-toggle:after, .btn.btn-warning.show.dropdown-toggle:after, .show > .btn.btn-warning.dropdown-toggle:after {
  color: var(--bs-warning-inverse);
}

.btn.btn-light-warning {
  color: var(--bs-warning);
  border-color: var(--bs-warning-light);
  background-color: var(--bs-warning-light);
}
.btn.btn-light-warning i,
.btn.btn-light-warning .svg-icon {
  color: var(--bs-warning);
}
.btn.btn-light-warning.dropdown-toggle:after {
  color: var(--bs-warning);
}
.btn-check:checked + .btn.btn-light-warning, .btn-check:active + .btn.btn-light-warning, .btn.btn-light-warning:focus:not(.btn-active), .btn.btn-light-warning:hover:not(.btn-active), .btn.btn-light-warning:active:not(.btn-active), .btn.btn-light-warning.active, .btn.btn-light-warning.show, .show > .btn.btn-light-warning {
  color: var(--bs-warning-inverse);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning) !important;
}
.btn-check:checked + .btn.btn-light-warning i,
.btn-check:checked + .btn.btn-light-warning .svg-icon, .btn-check:active + .btn.btn-light-warning i,
.btn-check:active + .btn.btn-light-warning .svg-icon, .btn.btn-light-warning:focus:not(.btn-active) i,
.btn.btn-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-light-warning:hover:not(.btn-active) i,
.btn.btn-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-light-warning:active:not(.btn-active) i,
.btn.btn-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-light-warning.active i,
.btn.btn-light-warning.active .svg-icon, .btn.btn-light-warning.show i,
.btn.btn-light-warning.show .svg-icon, .show > .btn.btn-light-warning i,
.show > .btn.btn-light-warning .svg-icon {
  color: var(--bs-warning-inverse);
}
.btn-check:checked + .btn.btn-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-light-warning.dropdown-toggle:after, .btn.btn-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning.active.dropdown-toggle:after, .btn.btn-light-warning.show.dropdown-toggle:after, .show > .btn.btn-light-warning.dropdown-toggle:after {
  color: var(--bs-warning-inverse);
}

.btn.btn-bg-warning {
  border-color: var(--bs-warning);
  background-color: var(--bs-warning);
}
.btn-check:checked + .btn.btn-active-warning, .btn-check:active + .btn.btn-active-warning, .btn.btn-active-warning:focus:not(.btn-active), .btn.btn-active-warning:hover:not(.btn-active), .btn.btn-active-warning:active:not(.btn-active), .btn.btn-active-warning.active, .btn.btn-active-warning.show, .show > .btn.btn-active-warning {
  color: var(--bs-warning-inverse);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning) !important;
}
.btn-check:checked + .btn.btn-active-warning i,
.btn-check:checked + .btn.btn-active-warning .svg-icon, .btn-check:active + .btn.btn-active-warning i,
.btn-check:active + .btn.btn-active-warning .svg-icon, .btn.btn-active-warning:focus:not(.btn-active) i,
.btn.btn-active-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-warning:hover:not(.btn-active) i,
.btn.btn-active-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-warning:active:not(.btn-active) i,
.btn.btn-active-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-warning.active i,
.btn.btn-active-warning.active .svg-icon, .btn.btn-active-warning.show i,
.btn.btn-active-warning.show .svg-icon, .show > .btn.btn-active-warning i,
.show > .btn.btn-active-warning .svg-icon {
  color: var(--bs-warning-inverse);
}
.btn-check:checked + .btn.btn-active-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-warning.dropdown-toggle:after, .btn.btn-active-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning.active.dropdown-toggle:after, .btn.btn-active-warning.show.dropdown-toggle:after, .show > .btn.btn-active-warning.dropdown-toggle:after {
  color: var(--bs-warning-inverse);
}

.btn-check:checked + .btn.btn-active-light-warning, .btn-check:active + .btn.btn-active-light-warning, .btn.btn-active-light-warning:focus:not(.btn-active), .btn.btn-active-light-warning:hover:not(.btn-active), .btn.btn-active-light-warning:active:not(.btn-active), .btn.btn-active-light-warning.active, .btn.btn-active-light-warning.show, .show > .btn.btn-active-light-warning {
  color: var(--bs-warning);
  border-color: var(--bs-warning-light);
  background-color: var(--bs-warning-light) !important;
}
.btn-check:checked + .btn.btn-active-light-warning i,
.btn-check:checked + .btn.btn-active-light-warning .svg-icon, .btn-check:active + .btn.btn-active-light-warning i,
.btn-check:active + .btn.btn-active-light-warning .svg-icon, .btn.btn-active-light-warning:focus:not(.btn-active) i,
.btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:hover:not(.btn-active) i,
.btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:active:not(.btn-active) i,
.btn.btn-active-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-light-warning.active i,
.btn.btn-active-light-warning.active .svg-icon, .btn.btn-active-light-warning.show i,
.btn.btn-active-light-warning.show .svg-icon, .show > .btn.btn-active-light-warning i,
.show > .btn.btn-active-light-warning .svg-icon {
  color: var(--bs-warning);
}
.btn-check:checked + .btn.btn-active-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-warning.dropdown-toggle:after, .btn.btn-active-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning.active.dropdown-toggle:after, .btn.btn-active-light-warning.show.dropdown-toggle:after, .show > .btn.btn-active-light-warning.dropdown-toggle:after {
  color: var(--bs-warning);
}

.btn.btn-outline.btn-outline-warning {
  color: var(--bs-warning);
  border-color: var(--bs-warning);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-warning i,
.btn.btn-outline.btn-outline-warning .svg-icon {
  color: var(--bs-warning);
}
.btn.btn-outline.btn-outline-warning.dropdown-toggle:after {
  color: var(--bs-warning);
}
.btn-check:checked + .btn.btn-outline.btn-outline-warning, .btn-check:active + .btn.btn-outline.btn-outline-warning, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active), .btn.btn-outline.btn-outline-warning:hover:not(.btn-active), .btn.btn-outline.btn-outline-warning:active:not(.btn-active), .btn.btn-outline.btn-outline-warning.active, .btn.btn-outline.btn-outline-warning.show, .show > .btn.btn-outline.btn-outline-warning {
  color: var(--bs-warning-active);
  border-color: var(--bs-warning);
  background-color: var(--bs-warning-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-warning i,
.btn-check:checked + .btn.btn-outline.btn-outline-warning .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-warning i,
.btn-check:active + .btn.btn-outline.btn-outline-warning .svg-icon, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-warning:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-warning:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-warning:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning.active i,
.btn.btn-outline.btn-outline-warning.active .svg-icon, .btn.btn-outline.btn-outline-warning.show i,
.btn.btn-outline.btn-outline-warning.show .svg-icon, .show > .btn.btn-outline.btn-outline-warning i,
.show > .btn.btn-outline.btn-outline-warning .svg-icon {
  color: var(--bs-warning-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-warning.dropdown-toggle:after {
  color: var(--bs-warning-active);
}

.btn.btn-danger {
  color: var(--bs-danger-inverse);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger);
}
.btn.btn-danger i,
.btn.btn-danger .svg-icon {
  color: var(--bs-danger-inverse);
}
.btn.btn-danger.dropdown-toggle:after {
  color: var(--bs-danger-inverse);
}
.btn-check:checked + .btn.btn-danger, .btn-check:active + .btn.btn-danger, .btn.btn-danger:focus:not(.btn-active), .btn.btn-danger:hover:not(.btn-active), .btn.btn-danger:active:not(.btn-active), .btn.btn-danger.active, .btn.btn-danger.show, .show > .btn.btn-danger {
  color: var(--bs-danger-inverse);
  border-color: var(--bs-danger-active);
  background-color: var(--bs-danger-active) !important;
}
.btn-check:checked + .btn.btn-danger i,
.btn-check:checked + .btn.btn-danger .svg-icon, .btn-check:active + .btn.btn-danger i,
.btn-check:active + .btn.btn-danger .svg-icon, .btn.btn-danger:focus:not(.btn-active) i,
.btn.btn-danger:focus:not(.btn-active) .svg-icon, .btn.btn-danger:hover:not(.btn-active) i,
.btn.btn-danger:hover:not(.btn-active) .svg-icon, .btn.btn-danger:active:not(.btn-active) i,
.btn.btn-danger:active:not(.btn-active) .svg-icon, .btn.btn-danger.active i,
.btn.btn-danger.active .svg-icon, .btn.btn-danger.show i,
.btn.btn-danger.show .svg-icon, .show > .btn.btn-danger i,
.show > .btn.btn-danger .svg-icon {
  color: var(--bs-danger-inverse);
}
.btn-check:checked + .btn.btn-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-danger.dropdown-toggle:after, .btn.btn-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-danger.active.dropdown-toggle:after, .btn.btn-danger.show.dropdown-toggle:after, .show > .btn.btn-danger.dropdown-toggle:after {
  color: var(--bs-danger-inverse);
}

.btn.btn-light-danger {
  color: var(--bs-danger);
  border-color: var(--bs-danger-light);
  background-color: var(--bs-danger-light);
}
.btn.btn-light-danger i,
.btn.btn-light-danger .svg-icon {
  color: var(--bs-danger);
}
.btn.btn-light-danger.dropdown-toggle:after {
  color: var(--bs-danger);
}
.btn-check:checked + .btn.btn-light-danger, .btn-check:active + .btn.btn-light-danger, .btn.btn-light-danger:focus:not(.btn-active), .btn.btn-light-danger:hover:not(.btn-active), .btn.btn-light-danger:active:not(.btn-active), .btn.btn-light-danger.active, .btn.btn-light-danger.show, .show > .btn.btn-light-danger {
  color: var(--bs-danger-inverse);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger) !important;
}
.btn-check:checked + .btn.btn-light-danger i,
.btn-check:checked + .btn.btn-light-danger .svg-icon, .btn-check:active + .btn.btn-light-danger i,
.btn-check:active + .btn.btn-light-danger .svg-icon, .btn.btn-light-danger:focus:not(.btn-active) i,
.btn.btn-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-light-danger:hover:not(.btn-active) i,
.btn.btn-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-light-danger:active:not(.btn-active) i,
.btn.btn-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-light-danger.active i,
.btn.btn-light-danger.active .svg-icon, .btn.btn-light-danger.show i,
.btn.btn-light-danger.show .svg-icon, .show > .btn.btn-light-danger i,
.show > .btn.btn-light-danger .svg-icon {
  color: var(--bs-danger-inverse);
}
.btn-check:checked + .btn.btn-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-light-danger.dropdown-toggle:after, .btn.btn-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger.active.dropdown-toggle:after, .btn.btn-light-danger.show.dropdown-toggle:after, .show > .btn.btn-light-danger.dropdown-toggle:after {
  color: var(--bs-danger-inverse);
}

.btn.btn-bg-danger {
  border-color: var(--bs-danger);
  background-color: var(--bs-danger);
}
.btn-check:checked + .btn.btn-active-danger, .btn-check:active + .btn.btn-active-danger, .btn.btn-active-danger:focus:not(.btn-active), .btn.btn-active-danger:hover:not(.btn-active), .btn.btn-active-danger:active:not(.btn-active), .btn.btn-active-danger.active, .btn.btn-active-danger.show, .show > .btn.btn-active-danger {
  color: var(--bs-danger-inverse);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger) !important;
}
.btn-check:checked + .btn.btn-active-danger i,
.btn-check:checked + .btn.btn-active-danger .svg-icon, .btn-check:active + .btn.btn-active-danger i,
.btn-check:active + .btn.btn-active-danger .svg-icon, .btn.btn-active-danger:focus:not(.btn-active) i,
.btn.btn-active-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-danger:hover:not(.btn-active) i,
.btn.btn-active-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-danger:active:not(.btn-active) i,
.btn.btn-active-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-danger.active i,
.btn.btn-active-danger.active .svg-icon, .btn.btn-active-danger.show i,
.btn.btn-active-danger.show .svg-icon, .show > .btn.btn-active-danger i,
.show > .btn.btn-active-danger .svg-icon {
  color: var(--bs-danger-inverse);
}
.btn-check:checked + .btn.btn-active-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-danger.dropdown-toggle:after, .btn.btn-active-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger.active.dropdown-toggle:after, .btn.btn-active-danger.show.dropdown-toggle:after, .show > .btn.btn-active-danger.dropdown-toggle:after {
  color: var(--bs-danger-inverse);
}

.btn-check:checked + .btn.btn-active-light-danger, .btn-check:active + .btn.btn-active-light-danger, .btn.btn-active-light-danger:focus:not(.btn-active), .btn.btn-active-light-danger:hover:not(.btn-active), .btn.btn-active-light-danger:active:not(.btn-active), .btn.btn-active-light-danger.active, .btn.btn-active-light-danger.show, .show > .btn.btn-active-light-danger {
  color: var(--bs-danger);
  border-color: var(--bs-danger-light);
  background-color: var(--bs-danger-light) !important;
}
.btn-check:checked + .btn.btn-active-light-danger i,
.btn-check:checked + .btn.btn-active-light-danger .svg-icon, .btn-check:active + .btn.btn-active-light-danger i,
.btn-check:active + .btn.btn-active-light-danger .svg-icon, .btn.btn-active-light-danger:focus:not(.btn-active) i,
.btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:hover:not(.btn-active) i,
.btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:active:not(.btn-active) i,
.btn.btn-active-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-light-danger.active i,
.btn.btn-active-light-danger.active .svg-icon, .btn.btn-active-light-danger.show i,
.btn.btn-active-light-danger.show .svg-icon, .show > .btn.btn-active-light-danger i,
.show > .btn.btn-active-light-danger .svg-icon {
  color: var(--bs-danger);
}
.btn-check:checked + .btn.btn-active-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-danger.dropdown-toggle:after, .btn.btn-active-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger.active.dropdown-toggle:after, .btn.btn-active-light-danger.show.dropdown-toggle:after, .show > .btn.btn-active-light-danger.dropdown-toggle:after {
  color: var(--bs-danger);
}

.btn.btn-outline.btn-outline-danger {
  color: var(--bs-danger);
  border-color: var(--bs-danger);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-danger i,
.btn.btn-outline.btn-outline-danger .svg-icon {
  color: var(--bs-danger);
}
.btn.btn-outline.btn-outline-danger.dropdown-toggle:after {
  color: var(--bs-danger);
}
.btn-check:checked + .btn.btn-outline.btn-outline-danger, .btn-check:active + .btn.btn-outline.btn-outline-danger, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active), .btn.btn-outline.btn-outline-danger:hover:not(.btn-active), .btn.btn-outline.btn-outline-danger:active:not(.btn-active), .btn.btn-outline.btn-outline-danger.active, .btn.btn-outline.btn-outline-danger.show, .show > .btn.btn-outline.btn-outline-danger {
  color: var(--bs-danger-active);
  border-color: var(--bs-danger);
  background-color: var(--bs-danger-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-danger i,
.btn-check:checked + .btn.btn-outline.btn-outline-danger .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-danger i,
.btn-check:active + .btn.btn-outline.btn-outline-danger .svg-icon, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-danger:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-danger:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-danger:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger.active i,
.btn.btn-outline.btn-outline-danger.active .svg-icon, .btn.btn-outline.btn-outline-danger.show i,
.btn.btn-outline.btn-outline-danger.show .svg-icon, .show > .btn.btn-outline.btn-outline-danger i,
.show > .btn.btn-outline.btn-outline-danger .svg-icon {
  color: var(--bs-danger-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-danger.dropdown-toggle:after {
  color: var(--bs-danger-active);
}

.btn.btn-dark {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark);
}
.btn.btn-dark i,
.btn.btn-dark .svg-icon {
  color: var(--bs-dark-inverse);
}
.btn.btn-dark.dropdown-toggle:after {
  color: var(--bs-dark-inverse);
}
.btn-check:checked + .btn.btn-dark, .btn-check:active + .btn.btn-dark, .btn.btn-dark:focus:not(.btn-active), .btn.btn-dark:hover:not(.btn-active), .btn.btn-dark:active:not(.btn-active), .btn.btn-dark.active, .btn.btn-dark.show, .show > .btn.btn-dark {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark-active);
  background-color: var(--bs-dark-active) !important;
}
.btn-check:checked + .btn.btn-dark i,
.btn-check:checked + .btn.btn-dark .svg-icon, .btn-check:active + .btn.btn-dark i,
.btn-check:active + .btn.btn-dark .svg-icon, .btn.btn-dark:focus:not(.btn-active) i,
.btn.btn-dark:focus:not(.btn-active) .svg-icon, .btn.btn-dark:hover:not(.btn-active) i,
.btn.btn-dark:hover:not(.btn-active) .svg-icon, .btn.btn-dark:active:not(.btn-active) i,
.btn.btn-dark:active:not(.btn-active) .svg-icon, .btn.btn-dark.active i,
.btn.btn-dark.active .svg-icon, .btn.btn-dark.show i,
.btn.btn-dark.show .svg-icon, .show > .btn.btn-dark i,
.show > .btn.btn-dark .svg-icon {
  color: var(--bs-dark-inverse);
}
.btn-check:checked + .btn.btn-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-dark.dropdown-toggle:after, .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-dark.active.dropdown-toggle:after, .btn.btn-dark.show.dropdown-toggle:after, .show > .btn.btn-dark.dropdown-toggle:after {
  color: var(--bs-dark-inverse);
}

.btn.btn-light-dark {
  color: var(--bs-dark);
  border-color: var(--bs-dark-light);
  background-color: var(--bs-dark-light);
}
.btn.btn-light-dark i,
.btn.btn-light-dark .svg-icon {
  color: var(--bs-dark);
}
.btn.btn-light-dark.dropdown-toggle:after {
  color: var(--bs-dark);
}
.btn-check:checked + .btn.btn-light-dark, .btn-check:active + .btn.btn-light-dark, .btn.btn-light-dark:focus:not(.btn-active), .btn.btn-light-dark:hover:not(.btn-active), .btn.btn-light-dark:active:not(.btn-active), .btn.btn-light-dark.active, .btn.btn-light-dark.show, .show > .btn.btn-light-dark {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark) !important;
}
.btn-check:checked + .btn.btn-light-dark i,
.btn-check:checked + .btn.btn-light-dark .svg-icon, .btn-check:active + .btn.btn-light-dark i,
.btn-check:active + .btn.btn-light-dark .svg-icon, .btn.btn-light-dark:focus:not(.btn-active) i,
.btn.btn-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-light-dark:hover:not(.btn-active) i,
.btn.btn-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-light-dark:active:not(.btn-active) i,
.btn.btn-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-light-dark.active i,
.btn.btn-light-dark.active .svg-icon, .btn.btn-light-dark.show i,
.btn.btn-light-dark.show .svg-icon, .show > .btn.btn-light-dark i,
.show > .btn.btn-light-dark .svg-icon {
  color: var(--bs-dark-inverse);
}
.btn-check:checked + .btn.btn-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-light-dark.dropdown-toggle:after, .btn.btn-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark.active.dropdown-toggle:after, .btn.btn-light-dark.show.dropdown-toggle:after, .show > .btn.btn-light-dark.dropdown-toggle:after {
  color: var(--bs-dark-inverse);
}

.btn.btn-bg-dark {
  border-color: var(--bs-dark);
  background-color: var(--bs-dark);
}
.btn-check:checked + .btn.btn-active-dark, .btn-check:active + .btn.btn-active-dark, .btn.btn-active-dark:focus:not(.btn-active), .btn.btn-active-dark:hover:not(.btn-active), .btn.btn-active-dark:active:not(.btn-active), .btn.btn-active-dark.active, .btn.btn-active-dark.show, .show > .btn.btn-active-dark {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark) !important;
}
.btn-check:checked + .btn.btn-active-dark i,
.btn-check:checked + .btn.btn-active-dark .svg-icon, .btn-check:active + .btn.btn-active-dark i,
.btn-check:active + .btn.btn-active-dark .svg-icon, .btn.btn-active-dark:focus:not(.btn-active) i,
.btn.btn-active-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-dark:hover:not(.btn-active) i,
.btn.btn-active-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-dark:active:not(.btn-active) i,
.btn.btn-active-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-dark.active i,
.btn.btn-active-dark.active .svg-icon, .btn.btn-active-dark.show i,
.btn.btn-active-dark.show .svg-icon, .show > .btn.btn-active-dark i,
.show > .btn.btn-active-dark .svg-icon {
  color: var(--bs-dark-inverse);
}
.btn-check:checked + .btn.btn-active-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-dark.dropdown-toggle:after, .btn.btn-active-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark.active.dropdown-toggle:after, .btn.btn-active-dark.show.dropdown-toggle:after, .show > .btn.btn-active-dark.dropdown-toggle:after {
  color: var(--bs-dark-inverse);
}

.btn-check:checked + .btn.btn-active-light-dark, .btn-check:active + .btn.btn-active-light-dark, .btn.btn-active-light-dark:focus:not(.btn-active), .btn.btn-active-light-dark:hover:not(.btn-active), .btn.btn-active-light-dark:active:not(.btn-active), .btn.btn-active-light-dark.active, .btn.btn-active-light-dark.show, .show > .btn.btn-active-light-dark {
  color: var(--bs-dark);
  border-color: var(--bs-dark-light);
  background-color: var(--bs-dark-light) !important;
}
.btn-check:checked + .btn.btn-active-light-dark i,
.btn-check:checked + .btn.btn-active-light-dark .svg-icon, .btn-check:active + .btn.btn-active-light-dark i,
.btn-check:active + .btn.btn-active-light-dark .svg-icon, .btn.btn-active-light-dark:focus:not(.btn-active) i,
.btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:hover:not(.btn-active) i,
.btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:active:not(.btn-active) i,
.btn.btn-active-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-light-dark.active i,
.btn.btn-active-light-dark.active .svg-icon, .btn.btn-active-light-dark.show i,
.btn.btn-active-light-dark.show .svg-icon, .show > .btn.btn-active-light-dark i,
.show > .btn.btn-active-light-dark .svg-icon {
  color: var(--bs-dark);
}
.btn-check:checked + .btn.btn-active-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-dark.dropdown-toggle:after, .btn.btn-active-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark.active.dropdown-toggle:after, .btn.btn-active-light-dark.show.dropdown-toggle:after, .show > .btn.btn-active-light-dark.dropdown-toggle:after {
  color: var(--bs-dark);
}

.btn.btn-outline.btn-outline-dark {
  color: var(--bs-dark);
  border-color: var(--bs-dark);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-dark i,
.btn.btn-outline.btn-outline-dark .svg-icon {
  color: var(--bs-dark);
}
.btn.btn-outline.btn-outline-dark.dropdown-toggle:after {
  color: var(--bs-dark);
}
.btn-check:checked + .btn.btn-outline.btn-outline-dark, .btn-check:active + .btn.btn-outline.btn-outline-dark, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active), .btn.btn-outline.btn-outline-dark:hover:not(.btn-active), .btn.btn-outline.btn-outline-dark:active:not(.btn-active), .btn.btn-outline.btn-outline-dark.active, .btn.btn-outline.btn-outline-dark.show, .show > .btn.btn-outline.btn-outline-dark {
  color: var(--bs-dark-active);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dark i,
.btn-check:checked + .btn.btn-outline.btn-outline-dark .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-dark i,
.btn-check:active + .btn.btn-outline.btn-outline-dark .svg-icon, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-dark:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-dark:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-dark:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark.active i,
.btn.btn-outline.btn-outline-dark.active .svg-icon, .btn.btn-outline.btn-outline-dark.show i,
.btn.btn-outline.btn-outline-dark.show .svg-icon, .show > .btn.btn-outline.btn-outline-dark i,
.show > .btn.btn-outline.btn-outline-dark .svg-icon {
  color: var(--bs-dark-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-dark.dropdown-toggle:after {
  color: var(--bs-dark-active);
}

.btn.btn-color-white {
  color: var(--bs-text-white);
}
.btn.btn-color-white i,
.btn.btn-color-white .svg-icon {
  color: var(--bs-text-white);
}
.btn.btn-color-white.dropdown-toggle:after {
  color: var(--bs-text-white);
}
.btn-check:checked + .btn.btn-active-color-white, .btn-check:active + .btn.btn-active-color-white, .btn.btn-active-color-white:focus:not(.btn-active), .btn.btn-active-color-white:hover:not(.btn-active), .btn.btn-active-color-white:active:not(.btn-active), .btn.btn-active-color-white.active, .btn.btn-active-color-white.show, .show > .btn.btn-active-color-white {
  color: var(--bs-text-white);
}
.btn-check:checked + .btn.btn-active-color-white i,
.btn-check:checked + .btn.btn-active-color-white .svg-icon, .btn-check:active + .btn.btn-active-color-white i,
.btn-check:active + .btn.btn-active-color-white .svg-icon, .btn.btn-active-color-white:focus:not(.btn-active) i,
.btn.btn-active-color-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-white:hover:not(.btn-active) i,
.btn.btn-active-color-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-white:active:not(.btn-active) i,
.btn.btn-active-color-white:active:not(.btn-active) .svg-icon, .btn.btn-active-color-white.active i,
.btn.btn-active-color-white.active .svg-icon, .btn.btn-active-color-white.show i,
.btn.btn-active-color-white.show .svg-icon, .show > .btn.btn-active-color-white i,
.show > .btn.btn-active-color-white .svg-icon {
  color: var(--bs-text-white);
}
.btn-check:checked + .btn.btn-active-color-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-white.dropdown-toggle:after, .btn.btn-active-color-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white.active.dropdown-toggle:after, .btn.btn-active-color-white.show.dropdown-toggle:after, .show > .btn.btn-active-color-white.dropdown-toggle:after {
  color: var(--bs-text-white);
}

.btn.btn-icon-white i,
.btn.btn-icon-white .svg-icon {
  color: var(--bs-text-white);
}
.btn.btn-icon-white.dropdown-toggle:after {
  color: var(--bs-text-white);
}
.btn-check:checked + .btn.btn-active-icon-white i,
.btn-check:checked + .btn.btn-active-icon-white .svg-icon, .btn-check:active + .btn.btn-active-icon-white i,
.btn-check:active + .btn.btn-active-icon-white .svg-icon, .btn.btn-active-icon-white:focus:not(.btn-active) i,
.btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:hover:not(.btn-active) i,
.btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:active:not(.btn-active) i,
.btn.btn-active-icon-white:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-white.active i,
.btn.btn-active-icon-white.active .svg-icon, .btn.btn-active-icon-white.show i,
.btn.btn-active-icon-white.show .svg-icon, .show > .btn.btn-active-icon-white i,
.show > .btn.btn-active-icon-white .svg-icon {
  color: var(--bs-text-white);
}
.btn-check:checked + .btn.btn-active-icon-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-white.dropdown-toggle:after, .btn.btn-active-icon-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white.active.dropdown-toggle:after, .btn.btn-active-icon-white.show.dropdown-toggle:after, .show > .btn.btn-active-icon-white.dropdown-toggle:after {
  color: var(--bs-text-white);
}

.btn.btn-text-white {
  color: var(--bs-text-white);
}
.btn-check:checked + .btn.btn-active-text-white, .btn-check:active + .btn.btn-active-text-white, .btn.btn-active-text-white:focus:not(.btn-active), .btn.btn-active-text-white:hover:not(.btn-active), .btn.btn-active-text-white:active:not(.btn-active), .btn.btn-active-text-white.active, .btn.btn-active-text-white.show, .show > .btn.btn-active-text-white {
  color: var(--bs-text-white);
}

.btn.btn-color-primary {
  color: var(--bs-text-primary);
}
.btn.btn-color-primary i,
.btn.btn-color-primary .svg-icon {
  color: var(--bs-text-primary);
}
.btn.btn-color-primary.dropdown-toggle:after {
  color: var(--bs-text-primary);
}
.btn-check:checked + .btn.btn-active-color-primary, .btn-check:active + .btn.btn-active-color-primary, .btn.btn-active-color-primary:focus:not(.btn-active), .btn.btn-active-color-primary:hover:not(.btn-active), .btn.btn-active-color-primary:active:not(.btn-active), .btn.btn-active-color-primary.active, .btn.btn-active-color-primary.show, .show > .btn.btn-active-color-primary {
  color: var(--bs-text-primary);
}
.btn-check:checked + .btn.btn-active-color-primary i,
.btn-check:checked + .btn.btn-active-color-primary .svg-icon, .btn-check:active + .btn.btn-active-color-primary i,
.btn-check:active + .btn.btn-active-color-primary .svg-icon, .btn.btn-active-color-primary:focus:not(.btn-active) i,
.btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:hover:not(.btn-active) i,
.btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:active:not(.btn-active) i,
.btn.btn-active-color-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-primary.active i,
.btn.btn-active-color-primary.active .svg-icon, .btn.btn-active-color-primary.show i,
.btn.btn-active-color-primary.show .svg-icon, .show > .btn.btn-active-color-primary i,
.show > .btn.btn-active-color-primary .svg-icon {
  color: var(--bs-text-primary);
}
.btn-check:checked + .btn.btn-active-color-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-primary.dropdown-toggle:after, .btn.btn-active-color-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary.active.dropdown-toggle:after, .btn.btn-active-color-primary.show.dropdown-toggle:after, .show > .btn.btn-active-color-primary.dropdown-toggle:after {
  color: var(--bs-text-primary);
}

.btn.btn-icon-primary i,
.btn.btn-icon-primary .svg-icon {
  color: var(--bs-text-primary);
}
.btn.btn-icon-primary.dropdown-toggle:after {
  color: var(--bs-text-primary);
}
.btn-check:checked + .btn.btn-active-icon-primary i,
.btn-check:checked + .btn.btn-active-icon-primary .svg-icon, .btn-check:active + .btn.btn-active-icon-primary i,
.btn-check:active + .btn.btn-active-icon-primary .svg-icon, .btn.btn-active-icon-primary:focus:not(.btn-active) i,
.btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:hover:not(.btn-active) i,
.btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:active:not(.btn-active) i,
.btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary.active i,
.btn.btn-active-icon-primary.active .svg-icon, .btn.btn-active-icon-primary.show i,
.btn.btn-active-icon-primary.show .svg-icon, .show > .btn.btn-active-icon-primary i,
.show > .btn.btn-active-icon-primary .svg-icon {
  color: var(--bs-text-primary);
}
.btn-check:checked + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn.btn-active-icon-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary.active.dropdown-toggle:after, .btn.btn-active-icon-primary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-primary.dropdown-toggle:after {
  color: var(--bs-text-primary);
}

.btn.btn-text-primary {
  color: var(--bs-text-primary);
}
.btn-check:checked + .btn.btn-active-text-primary, .btn-check:active + .btn.btn-active-text-primary, .btn.btn-active-text-primary:focus:not(.btn-active), .btn.btn-active-text-primary:hover:not(.btn-active), .btn.btn-active-text-primary:active:not(.btn-active), .btn.btn-active-text-primary.active, .btn.btn-active-text-primary.show, .show > .btn.btn-active-text-primary {
  color: var(--bs-text-primary);
}

.btn.btn-color-secondary {
  color: var(--bs-text-secondary);
}
.btn.btn-color-secondary i,
.btn.btn-color-secondary .svg-icon {
  color: var(--bs-text-secondary);
}
.btn.btn-color-secondary.dropdown-toggle:after {
  color: var(--bs-text-secondary);
}
.btn-check:checked + .btn.btn-active-color-secondary, .btn-check:active + .btn.btn-active-color-secondary, .btn.btn-active-color-secondary:focus:not(.btn-active), .btn.btn-active-color-secondary:hover:not(.btn-active), .btn.btn-active-color-secondary:active:not(.btn-active), .btn.btn-active-color-secondary.active, .btn.btn-active-color-secondary.show, .show > .btn.btn-active-color-secondary {
  color: var(--bs-text-secondary);
}
.btn-check:checked + .btn.btn-active-color-secondary i,
.btn-check:checked + .btn.btn-active-color-secondary .svg-icon, .btn-check:active + .btn.btn-active-color-secondary i,
.btn-check:active + .btn.btn-active-color-secondary .svg-icon, .btn.btn-active-color-secondary:focus:not(.btn-active) i,
.btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:hover:not(.btn-active) i,
.btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:active:not(.btn-active) i,
.btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary.active i,
.btn.btn-active-color-secondary.active .svg-icon, .btn.btn-active-color-secondary.show i,
.btn.btn-active-color-secondary.show .svg-icon, .show > .btn.btn-active-color-secondary i,
.show > .btn.btn-active-color-secondary .svg-icon {
  color: var(--bs-text-secondary);
}
.btn-check:checked + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn.btn-active-color-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary.active.dropdown-toggle:after, .btn.btn-active-color-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-color-secondary.dropdown-toggle:after {
  color: var(--bs-text-secondary);
}

.btn.btn-icon-secondary i,
.btn.btn-icon-secondary .svg-icon {
  color: var(--bs-text-secondary);
}
.btn.btn-icon-secondary.dropdown-toggle:after {
  color: var(--bs-text-secondary);
}
.btn-check:checked + .btn.btn-active-icon-secondary i,
.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon, .btn-check:active + .btn.btn-active-icon-secondary i,
.btn-check:active + .btn.btn-active-icon-secondary .svg-icon, .btn.btn-active-icon-secondary:focus:not(.btn-active) i,
.btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:hover:not(.btn-active) i,
.btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:active:not(.btn-active) i,
.btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary.active i,
.btn.btn-active-icon-secondary.active .svg-icon, .btn.btn-active-icon-secondary.show i,
.btn.btn-active-icon-secondary.show .svg-icon, .show > .btn.btn-active-icon-secondary i,
.show > .btn.btn-active-icon-secondary .svg-icon {
  color: var(--bs-text-secondary);
}
.btn-check:checked + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn.btn-active-icon-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary.active.dropdown-toggle:after, .btn.btn-active-icon-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-secondary.dropdown-toggle:after {
  color: var(--bs-text-secondary);
}

.btn.btn-text-secondary {
  color: var(--bs-text-secondary);
}
.btn-check:checked + .btn.btn-active-text-secondary, .btn-check:active + .btn.btn-active-text-secondary, .btn.btn-active-text-secondary:focus:not(.btn-active), .btn.btn-active-text-secondary:hover:not(.btn-active), .btn.btn-active-text-secondary:active:not(.btn-active), .btn.btn-active-text-secondary.active, .btn.btn-active-text-secondary.show, .show > .btn.btn-active-text-secondary {
  color: var(--bs-text-secondary);
}

.btn.btn-color-light {
  color: var(--bs-text-light);
}
.btn.btn-color-light i,
.btn.btn-color-light .svg-icon {
  color: var(--bs-text-light);
}
.btn.btn-color-light.dropdown-toggle:after {
  color: var(--bs-text-light);
}
.btn-check:checked + .btn.btn-active-color-light, .btn-check:active + .btn.btn-active-color-light, .btn.btn-active-color-light:focus:not(.btn-active), .btn.btn-active-color-light:hover:not(.btn-active), .btn.btn-active-color-light:active:not(.btn-active), .btn.btn-active-color-light.active, .btn.btn-active-color-light.show, .show > .btn.btn-active-color-light {
  color: var(--bs-text-light);
}
.btn-check:checked + .btn.btn-active-color-light i,
.btn-check:checked + .btn.btn-active-color-light .svg-icon, .btn-check:active + .btn.btn-active-color-light i,
.btn-check:active + .btn.btn-active-color-light .svg-icon, .btn.btn-active-color-light:focus:not(.btn-active) i,
.btn.btn-active-color-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-light:hover:not(.btn-active) i,
.btn.btn-active-color-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-light:active:not(.btn-active) i,
.btn.btn-active-color-light:active:not(.btn-active) .svg-icon, .btn.btn-active-color-light.active i,
.btn.btn-active-color-light.active .svg-icon, .btn.btn-active-color-light.show i,
.btn.btn-active-color-light.show .svg-icon, .show > .btn.btn-active-color-light i,
.show > .btn.btn-active-color-light .svg-icon {
  color: var(--bs-text-light);
}
.btn-check:checked + .btn.btn-active-color-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-light.dropdown-toggle:after, .btn.btn-active-color-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light.active.dropdown-toggle:after, .btn.btn-active-color-light.show.dropdown-toggle:after, .show > .btn.btn-active-color-light.dropdown-toggle:after {
  color: var(--bs-text-light);
}

.btn.btn-icon-light i,
.btn.btn-icon-light .svg-icon {
  color: var(--bs-text-light);
}
.btn.btn-icon-light.dropdown-toggle:after {
  color: var(--bs-text-light);
}
.btn-check:checked + .btn.btn-active-icon-light i,
.btn-check:checked + .btn.btn-active-icon-light .svg-icon, .btn-check:active + .btn.btn-active-icon-light i,
.btn-check:active + .btn.btn-active-icon-light .svg-icon, .btn.btn-active-icon-light:focus:not(.btn-active) i,
.btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:hover:not(.btn-active) i,
.btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:active:not(.btn-active) i,
.btn.btn-active-icon-light:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-light.active i,
.btn.btn-active-icon-light.active .svg-icon, .btn.btn-active-icon-light.show i,
.btn.btn-active-icon-light.show .svg-icon, .show > .btn.btn-active-icon-light i,
.show > .btn.btn-active-icon-light .svg-icon {
  color: var(--bs-text-light);
}
.btn-check:checked + .btn.btn-active-icon-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-light.dropdown-toggle:after, .btn.btn-active-icon-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light.active.dropdown-toggle:after, .btn.btn-active-icon-light.show.dropdown-toggle:after, .show > .btn.btn-active-icon-light.dropdown-toggle:after {
  color: var(--bs-text-light);
}

.btn.btn-text-light {
  color: var(--bs-text-light);
}
.btn-check:checked + .btn.btn-active-text-light, .btn-check:active + .btn.btn-active-text-light, .btn.btn-active-text-light:focus:not(.btn-active), .btn.btn-active-text-light:hover:not(.btn-active), .btn.btn-active-text-light:active:not(.btn-active), .btn.btn-active-text-light.active, .btn.btn-active-text-light.show, .show > .btn.btn-active-text-light {
  color: var(--bs-text-light);
}

.btn.btn-color-success {
  color: var(--bs-text-success);
}
.btn.btn-color-success i,
.btn.btn-color-success .svg-icon {
  color: var(--bs-text-success);
}
.btn.btn-color-success.dropdown-toggle:after {
  color: var(--bs-text-success);
}
.btn-check:checked + .btn.btn-active-color-success, .btn-check:active + .btn.btn-active-color-success, .btn.btn-active-color-success:focus:not(.btn-active), .btn.btn-active-color-success:hover:not(.btn-active), .btn.btn-active-color-success:active:not(.btn-active), .btn.btn-active-color-success.active, .btn.btn-active-color-success.show, .show > .btn.btn-active-color-success {
  color: var(--bs-text-success);
}
.btn-check:checked + .btn.btn-active-color-success i,
.btn-check:checked + .btn.btn-active-color-success .svg-icon, .btn-check:active + .btn.btn-active-color-success i,
.btn-check:active + .btn.btn-active-color-success .svg-icon, .btn.btn-active-color-success:focus:not(.btn-active) i,
.btn.btn-active-color-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-success:hover:not(.btn-active) i,
.btn.btn-active-color-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-success:active:not(.btn-active) i,
.btn.btn-active-color-success:active:not(.btn-active) .svg-icon, .btn.btn-active-color-success.active i,
.btn.btn-active-color-success.active .svg-icon, .btn.btn-active-color-success.show i,
.btn.btn-active-color-success.show .svg-icon, .show > .btn.btn-active-color-success i,
.show > .btn.btn-active-color-success .svg-icon {
  color: var(--bs-text-success);
}
.btn-check:checked + .btn.btn-active-color-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-success.dropdown-toggle:after, .btn.btn-active-color-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success.active.dropdown-toggle:after, .btn.btn-active-color-success.show.dropdown-toggle:after, .show > .btn.btn-active-color-success.dropdown-toggle:after {
  color: var(--bs-text-success);
}

.btn.btn-icon-success i,
.btn.btn-icon-success .svg-icon {
  color: var(--bs-text-success);
}
.btn.btn-icon-success.dropdown-toggle:after {
  color: var(--bs-text-success);
}
.btn-check:checked + .btn.btn-active-icon-success i,
.btn-check:checked + .btn.btn-active-icon-success .svg-icon, .btn-check:active + .btn.btn-active-icon-success i,
.btn-check:active + .btn.btn-active-icon-success .svg-icon, .btn.btn-active-icon-success:focus:not(.btn-active) i,
.btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:hover:not(.btn-active) i,
.btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:active:not(.btn-active) i,
.btn.btn-active-icon-success:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-success.active i,
.btn.btn-active-icon-success.active .svg-icon, .btn.btn-active-icon-success.show i,
.btn.btn-active-icon-success.show .svg-icon, .show > .btn.btn-active-icon-success i,
.show > .btn.btn-active-icon-success .svg-icon {
  color: var(--bs-text-success);
}
.btn-check:checked + .btn.btn-active-icon-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-success.dropdown-toggle:after, .btn.btn-active-icon-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success.active.dropdown-toggle:after, .btn.btn-active-icon-success.show.dropdown-toggle:after, .show > .btn.btn-active-icon-success.dropdown-toggle:after {
  color: var(--bs-text-success);
}

.btn.btn-text-success {
  color: var(--bs-text-success);
}
.btn-check:checked + .btn.btn-active-text-success, .btn-check:active + .btn.btn-active-text-success, .btn.btn-active-text-success:focus:not(.btn-active), .btn.btn-active-text-success:hover:not(.btn-active), .btn.btn-active-text-success:active:not(.btn-active), .btn.btn-active-text-success.active, .btn.btn-active-text-success.show, .show > .btn.btn-active-text-success {
  color: var(--bs-text-success);
}

.btn.btn-color-info {
  color: var(--bs-text-info);
}
.btn.btn-color-info i,
.btn.btn-color-info .svg-icon {
  color: var(--bs-text-info);
}
.btn.btn-color-info.dropdown-toggle:after {
  color: var(--bs-text-info);
}
.btn-check:checked + .btn.btn-active-color-info, .btn-check:active + .btn.btn-active-color-info, .btn.btn-active-color-info:focus:not(.btn-active), .btn.btn-active-color-info:hover:not(.btn-active), .btn.btn-active-color-info:active:not(.btn-active), .btn.btn-active-color-info.active, .btn.btn-active-color-info.show, .show > .btn.btn-active-color-info {
  color: var(--bs-text-info);
}
.btn-check:checked + .btn.btn-active-color-info i,
.btn-check:checked + .btn.btn-active-color-info .svg-icon, .btn-check:active + .btn.btn-active-color-info i,
.btn-check:active + .btn.btn-active-color-info .svg-icon, .btn.btn-active-color-info:focus:not(.btn-active) i,
.btn.btn-active-color-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-info:hover:not(.btn-active) i,
.btn.btn-active-color-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-info:active:not(.btn-active) i,
.btn.btn-active-color-info:active:not(.btn-active) .svg-icon, .btn.btn-active-color-info.active i,
.btn.btn-active-color-info.active .svg-icon, .btn.btn-active-color-info.show i,
.btn.btn-active-color-info.show .svg-icon, .show > .btn.btn-active-color-info i,
.show > .btn.btn-active-color-info .svg-icon {
  color: var(--bs-text-info);
}
.btn-check:checked + .btn.btn-active-color-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-info.dropdown-toggle:after, .btn.btn-active-color-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info.active.dropdown-toggle:after, .btn.btn-active-color-info.show.dropdown-toggle:after, .show > .btn.btn-active-color-info.dropdown-toggle:after {
  color: var(--bs-text-info);
}

.btn.btn-icon-info i,
.btn.btn-icon-info .svg-icon {
  color: var(--bs-text-info);
}
.btn.btn-icon-info.dropdown-toggle:after {
  color: var(--bs-text-info);
}
.btn-check:checked + .btn.btn-active-icon-info i,
.btn-check:checked + .btn.btn-active-icon-info .svg-icon, .btn-check:active + .btn.btn-active-icon-info i,
.btn-check:active + .btn.btn-active-icon-info .svg-icon, .btn.btn-active-icon-info:focus:not(.btn-active) i,
.btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:hover:not(.btn-active) i,
.btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:active:not(.btn-active) i,
.btn.btn-active-icon-info:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-info.active i,
.btn.btn-active-icon-info.active .svg-icon, .btn.btn-active-icon-info.show i,
.btn.btn-active-icon-info.show .svg-icon, .show > .btn.btn-active-icon-info i,
.show > .btn.btn-active-icon-info .svg-icon {
  color: var(--bs-text-info);
}
.btn-check:checked + .btn.btn-active-icon-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-info.dropdown-toggle:after, .btn.btn-active-icon-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info.active.dropdown-toggle:after, .btn.btn-active-icon-info.show.dropdown-toggle:after, .show > .btn.btn-active-icon-info.dropdown-toggle:after {
  color: var(--bs-text-info);
}

.btn.btn-text-info {
  color: var(--bs-text-info);
}
.btn-check:checked + .btn.btn-active-text-info, .btn-check:active + .btn.btn-active-text-info, .btn.btn-active-text-info:focus:not(.btn-active), .btn.btn-active-text-info:hover:not(.btn-active), .btn.btn-active-text-info:active:not(.btn-active), .btn.btn-active-text-info.active, .btn.btn-active-text-info.show, .show > .btn.btn-active-text-info {
  color: var(--bs-text-info);
}

.btn.btn-color-warning {
  color: var(--bs-text-warning);
}
.btn.btn-color-warning i,
.btn.btn-color-warning .svg-icon {
  color: var(--bs-text-warning);
}
.btn.btn-color-warning.dropdown-toggle:after {
  color: var(--bs-text-warning);
}
.btn-check:checked + .btn.btn-active-color-warning, .btn-check:active + .btn.btn-active-color-warning, .btn.btn-active-color-warning:focus:not(.btn-active), .btn.btn-active-color-warning:hover:not(.btn-active), .btn.btn-active-color-warning:active:not(.btn-active), .btn.btn-active-color-warning.active, .btn.btn-active-color-warning.show, .show > .btn.btn-active-color-warning {
  color: var(--bs-text-warning);
}
.btn-check:checked + .btn.btn-active-color-warning i,
.btn-check:checked + .btn.btn-active-color-warning .svg-icon, .btn-check:active + .btn.btn-active-color-warning i,
.btn-check:active + .btn.btn-active-color-warning .svg-icon, .btn.btn-active-color-warning:focus:not(.btn-active) i,
.btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:hover:not(.btn-active) i,
.btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:active:not(.btn-active) i,
.btn.btn-active-color-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-color-warning.active i,
.btn.btn-active-color-warning.active .svg-icon, .btn.btn-active-color-warning.show i,
.btn.btn-active-color-warning.show .svg-icon, .show > .btn.btn-active-color-warning i,
.show > .btn.btn-active-color-warning .svg-icon {
  color: var(--bs-text-warning);
}
.btn-check:checked + .btn.btn-active-color-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-warning.dropdown-toggle:after, .btn.btn-active-color-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning.active.dropdown-toggle:after, .btn.btn-active-color-warning.show.dropdown-toggle:after, .show > .btn.btn-active-color-warning.dropdown-toggle:after {
  color: var(--bs-text-warning);
}

.btn.btn-icon-warning i,
.btn.btn-icon-warning .svg-icon {
  color: var(--bs-text-warning);
}
.btn.btn-icon-warning.dropdown-toggle:after {
  color: var(--bs-text-warning);
}
.btn-check:checked + .btn.btn-active-icon-warning i,
.btn-check:checked + .btn.btn-active-icon-warning .svg-icon, .btn-check:active + .btn.btn-active-icon-warning i,
.btn-check:active + .btn.btn-active-icon-warning .svg-icon, .btn.btn-active-icon-warning:focus:not(.btn-active) i,
.btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:hover:not(.btn-active) i,
.btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:active:not(.btn-active) i,
.btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning.active i,
.btn.btn-active-icon-warning.active .svg-icon, .btn.btn-active-icon-warning.show i,
.btn.btn-active-icon-warning.show .svg-icon, .show > .btn.btn-active-icon-warning i,
.show > .btn.btn-active-icon-warning .svg-icon {
  color: var(--bs-text-warning);
}
.btn-check:checked + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn.btn-active-icon-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning.active.dropdown-toggle:after, .btn.btn-active-icon-warning.show.dropdown-toggle:after, .show > .btn.btn-active-icon-warning.dropdown-toggle:after {
  color: var(--bs-text-warning);
}

.btn.btn-text-warning {
  color: var(--bs-text-warning);
}
.btn-check:checked + .btn.btn-active-text-warning, .btn-check:active + .btn.btn-active-text-warning, .btn.btn-active-text-warning:focus:not(.btn-active), .btn.btn-active-text-warning:hover:not(.btn-active), .btn.btn-active-text-warning:active:not(.btn-active), .btn.btn-active-text-warning.active, .btn.btn-active-text-warning.show, .show > .btn.btn-active-text-warning {
  color: var(--bs-text-warning);
}

.btn.btn-color-danger {
  color: var(--bs-text-danger);
}
.btn.btn-color-danger i,
.btn.btn-color-danger .svg-icon {
  color: var(--bs-text-danger);
}
.btn.btn-color-danger.dropdown-toggle:after {
  color: var(--bs-text-danger);
}
.btn-check:checked + .btn.btn-active-color-danger, .btn-check:active + .btn.btn-active-color-danger, .btn.btn-active-color-danger:focus:not(.btn-active), .btn.btn-active-color-danger:hover:not(.btn-active), .btn.btn-active-color-danger:active:not(.btn-active), .btn.btn-active-color-danger.active, .btn.btn-active-color-danger.show, .show > .btn.btn-active-color-danger {
  color: var(--bs-text-danger);
}
.btn-check:checked + .btn.btn-active-color-danger i,
.btn-check:checked + .btn.btn-active-color-danger .svg-icon, .btn-check:active + .btn.btn-active-color-danger i,
.btn-check:active + .btn.btn-active-color-danger .svg-icon, .btn.btn-active-color-danger:focus:not(.btn-active) i,
.btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:hover:not(.btn-active) i,
.btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:active:not(.btn-active) i,
.btn.btn-active-color-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-color-danger.active i,
.btn.btn-active-color-danger.active .svg-icon, .btn.btn-active-color-danger.show i,
.btn.btn-active-color-danger.show .svg-icon, .show > .btn.btn-active-color-danger i,
.show > .btn.btn-active-color-danger .svg-icon {
  color: var(--bs-text-danger);
}
.btn-check:checked + .btn.btn-active-color-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-danger.dropdown-toggle:after, .btn.btn-active-color-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger.active.dropdown-toggle:after, .btn.btn-active-color-danger.show.dropdown-toggle:after, .show > .btn.btn-active-color-danger.dropdown-toggle:after {
  color: var(--bs-text-danger);
}

.btn.btn-icon-danger i,
.btn.btn-icon-danger .svg-icon {
  color: var(--bs-text-danger);
}
.btn.btn-icon-danger.dropdown-toggle:after {
  color: var(--bs-text-danger);
}
.btn-check:checked + .btn.btn-active-icon-danger i,
.btn-check:checked + .btn.btn-active-icon-danger .svg-icon, .btn-check:active + .btn.btn-active-icon-danger i,
.btn-check:active + .btn.btn-active-icon-danger .svg-icon, .btn.btn-active-icon-danger:focus:not(.btn-active) i,
.btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:hover:not(.btn-active) i,
.btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:active:not(.btn-active) i,
.btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger.active i,
.btn.btn-active-icon-danger.active .svg-icon, .btn.btn-active-icon-danger.show i,
.btn.btn-active-icon-danger.show .svg-icon, .show > .btn.btn-active-icon-danger i,
.show > .btn.btn-active-icon-danger .svg-icon {
  color: var(--bs-text-danger);
}
.btn-check:checked + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn.btn-active-icon-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger.active.dropdown-toggle:after, .btn.btn-active-icon-danger.show.dropdown-toggle:after, .show > .btn.btn-active-icon-danger.dropdown-toggle:after {
  color: var(--bs-text-danger);
}

.btn.btn-text-danger {
  color: var(--bs-text-danger);
}
.btn-check:checked + .btn.btn-active-text-danger, .btn-check:active + .btn.btn-active-text-danger, .btn.btn-active-text-danger:focus:not(.btn-active), .btn.btn-active-text-danger:hover:not(.btn-active), .btn.btn-active-text-danger:active:not(.btn-active), .btn.btn-active-text-danger.active, .btn.btn-active-text-danger.show, .show > .btn.btn-active-text-danger {
  color: var(--bs-text-danger);
}

.btn.btn-color-dark {
  color: var(--bs-text-dark);
}
.btn.btn-color-dark i,
.btn.btn-color-dark .svg-icon {
  color: var(--bs-text-dark);
}
.btn.btn-color-dark.dropdown-toggle:after {
  color: var(--bs-text-dark);
}
.btn-check:checked + .btn.btn-active-color-dark, .btn-check:active + .btn.btn-active-color-dark, .btn.btn-active-color-dark:focus:not(.btn-active), .btn.btn-active-color-dark:hover:not(.btn-active), .btn.btn-active-color-dark:active:not(.btn-active), .btn.btn-active-color-dark.active, .btn.btn-active-color-dark.show, .show > .btn.btn-active-color-dark {
  color: var(--bs-text-dark);
}
.btn-check:checked + .btn.btn-active-color-dark i,
.btn-check:checked + .btn.btn-active-color-dark .svg-icon, .btn-check:active + .btn.btn-active-color-dark i,
.btn-check:active + .btn.btn-active-color-dark .svg-icon, .btn.btn-active-color-dark:focus:not(.btn-active) i,
.btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:hover:not(.btn-active) i,
.btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:active:not(.btn-active) i,
.btn.btn-active-color-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-color-dark.active i,
.btn.btn-active-color-dark.active .svg-icon, .btn.btn-active-color-dark.show i,
.btn.btn-active-color-dark.show .svg-icon, .show > .btn.btn-active-color-dark i,
.show > .btn.btn-active-color-dark .svg-icon {
  color: var(--bs-text-dark);
}
.btn-check:checked + .btn.btn-active-color-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-dark.dropdown-toggle:after, .btn.btn-active-color-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark.active.dropdown-toggle:after, .btn.btn-active-color-dark.show.dropdown-toggle:after, .show > .btn.btn-active-color-dark.dropdown-toggle:after {
  color: var(--bs-text-dark);
}

.btn.btn-icon-dark i,
.btn.btn-icon-dark .svg-icon {
  color: var(--bs-text-dark);
}
.btn.btn-icon-dark.dropdown-toggle:after {
  color: var(--bs-text-dark);
}
.btn-check:checked + .btn.btn-active-icon-dark i,
.btn-check:checked + .btn.btn-active-icon-dark .svg-icon, .btn-check:active + .btn.btn-active-icon-dark i,
.btn-check:active + .btn.btn-active-icon-dark .svg-icon, .btn.btn-active-icon-dark:focus:not(.btn-active) i,
.btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:hover:not(.btn-active) i,
.btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:active:not(.btn-active) i,
.btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark.active i,
.btn.btn-active-icon-dark.active .svg-icon, .btn.btn-active-icon-dark.show i,
.btn.btn-active-icon-dark.show .svg-icon, .show > .btn.btn-active-icon-dark i,
.show > .btn.btn-active-icon-dark .svg-icon {
  color: var(--bs-text-dark);
}
.btn-check:checked + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn.btn-active-icon-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark.active.dropdown-toggle:after, .btn.btn-active-icon-dark.show.dropdown-toggle:after, .show > .btn.btn-active-icon-dark.dropdown-toggle:after {
  color: var(--bs-text-dark);
}

.btn.btn-text-dark {
  color: var(--bs-text-dark);
}
.btn-check:checked + .btn.btn-active-text-dark, .btn-check:active + .btn.btn-active-text-dark, .btn.btn-active-text-dark:focus:not(.btn-active), .btn.btn-active-text-dark:hover:not(.btn-active), .btn.btn-active-text-dark:active:not(.btn-active), .btn.btn-active-text-dark.active, .btn.btn-active-text-dark.show, .show > .btn.btn-active-text-dark {
  color: var(--bs-text-dark);
}

.btn.btn-color-muted {
  color: var(--bs-text-muted);
}
.btn.btn-color-muted i,
.btn.btn-color-muted .svg-icon {
  color: var(--bs-text-muted);
}
.btn.btn-color-muted.dropdown-toggle:after {
  color: var(--bs-text-muted);
}
.btn-check:checked + .btn.btn-active-color-muted, .btn-check:active + .btn.btn-active-color-muted, .btn.btn-active-color-muted:focus:not(.btn-active), .btn.btn-active-color-muted:hover:not(.btn-active), .btn.btn-active-color-muted:active:not(.btn-active), .btn.btn-active-color-muted.active, .btn.btn-active-color-muted.show, .show > .btn.btn-active-color-muted {
  color: var(--bs-text-muted);
}
.btn-check:checked + .btn.btn-active-color-muted i,
.btn-check:checked + .btn.btn-active-color-muted .svg-icon, .btn-check:active + .btn.btn-active-color-muted i,
.btn-check:active + .btn.btn-active-color-muted .svg-icon, .btn.btn-active-color-muted:focus:not(.btn-active) i,
.btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:hover:not(.btn-active) i,
.btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:active:not(.btn-active) i,
.btn.btn-active-color-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-color-muted.active i,
.btn.btn-active-color-muted.active .svg-icon, .btn.btn-active-color-muted.show i,
.btn.btn-active-color-muted.show .svg-icon, .show > .btn.btn-active-color-muted i,
.show > .btn.btn-active-color-muted .svg-icon {
  color: var(--bs-text-muted);
}
.btn-check:checked + .btn.btn-active-color-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-muted.dropdown-toggle:after, .btn.btn-active-color-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted.active.dropdown-toggle:after, .btn.btn-active-color-muted.show.dropdown-toggle:after, .show > .btn.btn-active-color-muted.dropdown-toggle:after {
  color: var(--bs-text-muted);
}

.btn.btn-icon-muted i,
.btn.btn-icon-muted .svg-icon {
  color: var(--bs-text-muted);
}
.btn.btn-icon-muted.dropdown-toggle:after {
  color: var(--bs-text-muted);
}
.btn-check:checked + .btn.btn-active-icon-muted i,
.btn-check:checked + .btn.btn-active-icon-muted .svg-icon, .btn-check:active + .btn.btn-active-icon-muted i,
.btn-check:active + .btn.btn-active-icon-muted .svg-icon, .btn.btn-active-icon-muted:focus:not(.btn-active) i,
.btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:hover:not(.btn-active) i,
.btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:active:not(.btn-active) i,
.btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted.active i,
.btn.btn-active-icon-muted.active .svg-icon, .btn.btn-active-icon-muted.show i,
.btn.btn-active-icon-muted.show .svg-icon, .show > .btn.btn-active-icon-muted i,
.show > .btn.btn-active-icon-muted .svg-icon {
  color: var(--bs-text-muted);
}
.btn-check:checked + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn.btn-active-icon-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted.active.dropdown-toggle:after, .btn.btn-active-icon-muted.show.dropdown-toggle:after, .show > .btn.btn-active-icon-muted.dropdown-toggle:after {
  color: var(--bs-text-muted);
}

.btn.btn-text-muted {
  color: var(--bs-text-muted);
}
.btn-check:checked + .btn.btn-active-text-muted, .btn-check:active + .btn.btn-active-text-muted, .btn.btn-active-text-muted:focus:not(.btn-active), .btn.btn-active-text-muted:hover:not(.btn-active), .btn.btn-active-text-muted:active:not(.btn-active), .btn.btn-active-text-muted.active, .btn.btn-active-text-muted.show, .show > .btn.btn-active-text-muted {
  color: var(--bs-text-muted);
}

.btn.btn-color-gray-100 {
  color: var(--bs-text-gray-100);
}
.btn.btn-color-gray-100 i,
.btn.btn-color-gray-100 .svg-icon {
  color: var(--bs-text-gray-100);
}
.btn.btn-color-gray-100.dropdown-toggle:after {
  color: var(--bs-text-gray-100);
}
.btn-check:checked + .btn.btn-active-color-gray-100, .btn-check:active + .btn.btn-active-color-gray-100, .btn.btn-active-color-gray-100:focus:not(.btn-active), .btn.btn-active-color-gray-100:hover:not(.btn-active), .btn.btn-active-color-gray-100:active:not(.btn-active), .btn.btn-active-color-gray-100.active, .btn.btn-active-color-gray-100.show, .show > .btn.btn-active-color-gray-100 {
  color: var(--bs-text-gray-100);
}
.btn-check:checked + .btn.btn-active-color-gray-100 i,
.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-100 i,
.btn-check:active + .btn.btn-active-color-gray-100 .svg-icon, .btn.btn-active-color-gray-100:focus:not(.btn-active) i,
.btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:hover:not(.btn-active) i,
.btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:active:not(.btn-active) i,
.btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100.active i,
.btn.btn-active-color-gray-100.active .svg-icon, .btn.btn-active-color-gray-100.show i,
.btn.btn-active-color-gray-100.show .svg-icon, .show > .btn.btn-active-color-gray-100 i,
.show > .btn.btn-active-color-gray-100 .svg-icon {
  color: var(--bs-text-gray-100);
}
.btn-check:checked + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn.btn-active-color-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100.active.dropdown-toggle:after, .btn.btn-active-color-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-100.dropdown-toggle:after {
  color: var(--bs-text-gray-100);
}

.btn.btn-icon-gray-100 i,
.btn.btn-icon-gray-100 .svg-icon {
  color: var(--bs-text-gray-100);
}
.btn.btn-icon-gray-100.dropdown-toggle:after {
  color: var(--bs-text-gray-100);
}
.btn-check:checked + .btn.btn-active-icon-gray-100 i,
.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-100 i,
.btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon, .btn.btn-active-icon-gray-100:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:active:not(.btn-active) i,
.btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100.active i,
.btn.btn-active-icon-gray-100.active .svg-icon, .btn.btn-active-icon-gray-100.show i,
.btn.btn-active-icon-gray-100.show .svg-icon, .show > .btn.btn-active-icon-gray-100 i,
.show > .btn.btn-active-icon-gray-100 .svg-icon {
  color: var(--bs-text-gray-100);
}
.btn-check:checked + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn.btn-active-icon-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100.active.dropdown-toggle:after, .btn.btn-active-icon-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-100.dropdown-toggle:after {
  color: var(--bs-text-gray-100);
}

.btn.btn-text-gray-100 {
  color: var(--bs-text-gray-100);
}
.btn-check:checked + .btn.btn-active-text-gray-100, .btn-check:active + .btn.btn-active-text-gray-100, .btn.btn-active-text-gray-100:focus:not(.btn-active), .btn.btn-active-text-gray-100:hover:not(.btn-active), .btn.btn-active-text-gray-100:active:not(.btn-active), .btn.btn-active-text-gray-100.active, .btn.btn-active-text-gray-100.show, .show > .btn.btn-active-text-gray-100 {
  color: var(--bs-text-gray-100);
}

.btn.btn-color-gray-200 {
  color: var(--bs-text-gray-200);
}
.btn.btn-color-gray-200 i,
.btn.btn-color-gray-200 .svg-icon {
  color: var(--bs-text-gray-200);
}
.btn.btn-color-gray-200.dropdown-toggle:after {
  color: var(--bs-text-gray-200);
}
.btn-check:checked + .btn.btn-active-color-gray-200, .btn-check:active + .btn.btn-active-color-gray-200, .btn.btn-active-color-gray-200:focus:not(.btn-active), .btn.btn-active-color-gray-200:hover:not(.btn-active), .btn.btn-active-color-gray-200:active:not(.btn-active), .btn.btn-active-color-gray-200.active, .btn.btn-active-color-gray-200.show, .show > .btn.btn-active-color-gray-200 {
  color: var(--bs-text-gray-200);
}
.btn-check:checked + .btn.btn-active-color-gray-200 i,
.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-200 i,
.btn-check:active + .btn.btn-active-color-gray-200 .svg-icon, .btn.btn-active-color-gray-200:focus:not(.btn-active) i,
.btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:hover:not(.btn-active) i,
.btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:active:not(.btn-active) i,
.btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200.active i,
.btn.btn-active-color-gray-200.active .svg-icon, .btn.btn-active-color-gray-200.show i,
.btn.btn-active-color-gray-200.show .svg-icon, .show > .btn.btn-active-color-gray-200 i,
.show > .btn.btn-active-color-gray-200 .svg-icon {
  color: var(--bs-text-gray-200);
}
.btn-check:checked + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn.btn-active-color-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200.active.dropdown-toggle:after, .btn.btn-active-color-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-200.dropdown-toggle:after {
  color: var(--bs-text-gray-200);
}

.btn.btn-icon-gray-200 i,
.btn.btn-icon-gray-200 .svg-icon {
  color: var(--bs-text-gray-200);
}
.btn.btn-icon-gray-200.dropdown-toggle:after {
  color: var(--bs-text-gray-200);
}
.btn-check:checked + .btn.btn-active-icon-gray-200 i,
.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-200 i,
.btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon, .btn.btn-active-icon-gray-200:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:active:not(.btn-active) i,
.btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200.active i,
.btn.btn-active-icon-gray-200.active .svg-icon, .btn.btn-active-icon-gray-200.show i,
.btn.btn-active-icon-gray-200.show .svg-icon, .show > .btn.btn-active-icon-gray-200 i,
.show > .btn.btn-active-icon-gray-200 .svg-icon {
  color: var(--bs-text-gray-200);
}
.btn-check:checked + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn.btn-active-icon-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200.active.dropdown-toggle:after, .btn.btn-active-icon-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-200.dropdown-toggle:after {
  color: var(--bs-text-gray-200);
}

.btn.btn-text-gray-200 {
  color: var(--bs-text-gray-200);
}
.btn-check:checked + .btn.btn-active-text-gray-200, .btn-check:active + .btn.btn-active-text-gray-200, .btn.btn-active-text-gray-200:focus:not(.btn-active), .btn.btn-active-text-gray-200:hover:not(.btn-active), .btn.btn-active-text-gray-200:active:not(.btn-active), .btn.btn-active-text-gray-200.active, .btn.btn-active-text-gray-200.show, .show > .btn.btn-active-text-gray-200 {
  color: var(--bs-text-gray-200);
}

.btn.btn-color-gray-300 {
  color: var(--bs-text-gray-300);
}
.btn.btn-color-gray-300 i,
.btn.btn-color-gray-300 .svg-icon {
  color: var(--bs-text-gray-300);
}
.btn.btn-color-gray-300.dropdown-toggle:after {
  color: var(--bs-text-gray-300);
}
.btn-check:checked + .btn.btn-active-color-gray-300, .btn-check:active + .btn.btn-active-color-gray-300, .btn.btn-active-color-gray-300:focus:not(.btn-active), .btn.btn-active-color-gray-300:hover:not(.btn-active), .btn.btn-active-color-gray-300:active:not(.btn-active), .btn.btn-active-color-gray-300.active, .btn.btn-active-color-gray-300.show, .show > .btn.btn-active-color-gray-300 {
  color: var(--bs-text-gray-300);
}
.btn-check:checked + .btn.btn-active-color-gray-300 i,
.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-300 i,
.btn-check:active + .btn.btn-active-color-gray-300 .svg-icon, .btn.btn-active-color-gray-300:focus:not(.btn-active) i,
.btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:hover:not(.btn-active) i,
.btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:active:not(.btn-active) i,
.btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300.active i,
.btn.btn-active-color-gray-300.active .svg-icon, .btn.btn-active-color-gray-300.show i,
.btn.btn-active-color-gray-300.show .svg-icon, .show > .btn.btn-active-color-gray-300 i,
.show > .btn.btn-active-color-gray-300 .svg-icon {
  color: var(--bs-text-gray-300);
}
.btn-check:checked + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn.btn-active-color-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300.active.dropdown-toggle:after, .btn.btn-active-color-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-300.dropdown-toggle:after {
  color: var(--bs-text-gray-300);
}

.btn.btn-icon-gray-300 i,
.btn.btn-icon-gray-300 .svg-icon {
  color: var(--bs-text-gray-300);
}
.btn.btn-icon-gray-300.dropdown-toggle:after {
  color: var(--bs-text-gray-300);
}
.btn-check:checked + .btn.btn-active-icon-gray-300 i,
.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-300 i,
.btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon, .btn.btn-active-icon-gray-300:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:active:not(.btn-active) i,
.btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300.active i,
.btn.btn-active-icon-gray-300.active .svg-icon, .btn.btn-active-icon-gray-300.show i,
.btn.btn-active-icon-gray-300.show .svg-icon, .show > .btn.btn-active-icon-gray-300 i,
.show > .btn.btn-active-icon-gray-300 .svg-icon {
  color: var(--bs-text-gray-300);
}
.btn-check:checked + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn.btn-active-icon-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300.active.dropdown-toggle:after, .btn.btn-active-icon-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-300.dropdown-toggle:after {
  color: var(--bs-text-gray-300);
}

.btn.btn-text-gray-300 {
  color: var(--bs-text-gray-300);
}
.btn-check:checked + .btn.btn-active-text-gray-300, .btn-check:active + .btn.btn-active-text-gray-300, .btn.btn-active-text-gray-300:focus:not(.btn-active), .btn.btn-active-text-gray-300:hover:not(.btn-active), .btn.btn-active-text-gray-300:active:not(.btn-active), .btn.btn-active-text-gray-300.active, .btn.btn-active-text-gray-300.show, .show > .btn.btn-active-text-gray-300 {
  color: var(--bs-text-gray-300);
}

.btn.btn-color-gray-400 {
  color: var(--bs-text-gray-400);
}
.btn.btn-color-gray-400 i,
.btn.btn-color-gray-400 .svg-icon {
  color: var(--bs-text-gray-400);
}
.btn.btn-color-gray-400.dropdown-toggle:after {
  color: var(--bs-text-gray-400);
}
.btn-check:checked + .btn.btn-active-color-gray-400, .btn-check:active + .btn.btn-active-color-gray-400, .btn.btn-active-color-gray-400:focus:not(.btn-active), .btn.btn-active-color-gray-400:hover:not(.btn-active), .btn.btn-active-color-gray-400:active:not(.btn-active), .btn.btn-active-color-gray-400.active, .btn.btn-active-color-gray-400.show, .show > .btn.btn-active-color-gray-400 {
  color: var(--bs-text-gray-400);
}
.btn-check:checked + .btn.btn-active-color-gray-400 i,
.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-400 i,
.btn-check:active + .btn.btn-active-color-gray-400 .svg-icon, .btn.btn-active-color-gray-400:focus:not(.btn-active) i,
.btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:hover:not(.btn-active) i,
.btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:active:not(.btn-active) i,
.btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400.active i,
.btn.btn-active-color-gray-400.active .svg-icon, .btn.btn-active-color-gray-400.show i,
.btn.btn-active-color-gray-400.show .svg-icon, .show > .btn.btn-active-color-gray-400 i,
.show > .btn.btn-active-color-gray-400 .svg-icon {
  color: var(--bs-text-gray-400);
}
.btn-check:checked + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn.btn-active-color-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400.active.dropdown-toggle:after, .btn.btn-active-color-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-400.dropdown-toggle:after {
  color: var(--bs-text-gray-400);
}

.btn.btn-icon-gray-400 i,
.btn.btn-icon-gray-400 .svg-icon {
  color: var(--bs-text-gray-400);
}
.btn.btn-icon-gray-400.dropdown-toggle:after {
  color: var(--bs-text-gray-400);
}
.btn-check:checked + .btn.btn-active-icon-gray-400 i,
.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-400 i,
.btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon, .btn.btn-active-icon-gray-400:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:active:not(.btn-active) i,
.btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400.active i,
.btn.btn-active-icon-gray-400.active .svg-icon, .btn.btn-active-icon-gray-400.show i,
.btn.btn-active-icon-gray-400.show .svg-icon, .show > .btn.btn-active-icon-gray-400 i,
.show > .btn.btn-active-icon-gray-400 .svg-icon {
  color: var(--bs-text-gray-400);
}
.btn-check:checked + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn.btn-active-icon-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400.active.dropdown-toggle:after, .btn.btn-active-icon-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-400.dropdown-toggle:after {
  color: var(--bs-text-gray-400);
}

.btn.btn-text-gray-400 {
  color: var(--bs-text-gray-400);
}
.btn-check:checked + .btn.btn-active-text-gray-400, .btn-check:active + .btn.btn-active-text-gray-400, .btn.btn-active-text-gray-400:focus:not(.btn-active), .btn.btn-active-text-gray-400:hover:not(.btn-active), .btn.btn-active-text-gray-400:active:not(.btn-active), .btn.btn-active-text-gray-400.active, .btn.btn-active-text-gray-400.show, .show > .btn.btn-active-text-gray-400 {
  color: var(--bs-text-gray-400);
}

.btn.btn-color-gray-500 {
  color: var(--bs-text-gray-500);
}
.btn.btn-color-gray-500 i,
.btn.btn-color-gray-500 .svg-icon {
  color: var(--bs-text-gray-500);
}
.btn.btn-color-gray-500.dropdown-toggle:after {
  color: var(--bs-text-gray-500);
}
.btn-check:checked + .btn.btn-active-color-gray-500, .btn-check:active + .btn.btn-active-color-gray-500, .btn.btn-active-color-gray-500:focus:not(.btn-active), .btn.btn-active-color-gray-500:hover:not(.btn-active), .btn.btn-active-color-gray-500:active:not(.btn-active), .btn.btn-active-color-gray-500.active, .btn.btn-active-color-gray-500.show, .show > .btn.btn-active-color-gray-500 {
  color: var(--bs-text-gray-500);
}
.btn-check:checked + .btn.btn-active-color-gray-500 i,
.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-500 i,
.btn-check:active + .btn.btn-active-color-gray-500 .svg-icon, .btn.btn-active-color-gray-500:focus:not(.btn-active) i,
.btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:hover:not(.btn-active) i,
.btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:active:not(.btn-active) i,
.btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500.active i,
.btn.btn-active-color-gray-500.active .svg-icon, .btn.btn-active-color-gray-500.show i,
.btn.btn-active-color-gray-500.show .svg-icon, .show > .btn.btn-active-color-gray-500 i,
.show > .btn.btn-active-color-gray-500 .svg-icon {
  color: var(--bs-text-gray-500);
}
.btn-check:checked + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn.btn-active-color-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500.active.dropdown-toggle:after, .btn.btn-active-color-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-500.dropdown-toggle:after {
  color: var(--bs-text-gray-500);
}

.btn.btn-icon-gray-500 i,
.btn.btn-icon-gray-500 .svg-icon {
  color: var(--bs-text-gray-500);
}
.btn.btn-icon-gray-500.dropdown-toggle:after {
  color: var(--bs-text-gray-500);
}
.btn-check:checked + .btn.btn-active-icon-gray-500 i,
.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-500 i,
.btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon, .btn.btn-active-icon-gray-500:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:active:not(.btn-active) i,
.btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500.active i,
.btn.btn-active-icon-gray-500.active .svg-icon, .btn.btn-active-icon-gray-500.show i,
.btn.btn-active-icon-gray-500.show .svg-icon, .show > .btn.btn-active-icon-gray-500 i,
.show > .btn.btn-active-icon-gray-500 .svg-icon {
  color: var(--bs-text-gray-500);
}
.btn-check:checked + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn.btn-active-icon-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500.active.dropdown-toggle:after, .btn.btn-active-icon-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-500.dropdown-toggle:after {
  color: var(--bs-text-gray-500);
}

.btn.btn-text-gray-500 {
  color: var(--bs-text-gray-500);
}
.btn-check:checked + .btn.btn-active-text-gray-500, .btn-check:active + .btn.btn-active-text-gray-500, .btn.btn-active-text-gray-500:focus:not(.btn-active), .btn.btn-active-text-gray-500:hover:not(.btn-active), .btn.btn-active-text-gray-500:active:not(.btn-active), .btn.btn-active-text-gray-500.active, .btn.btn-active-text-gray-500.show, .show > .btn.btn-active-text-gray-500 {
  color: var(--bs-text-gray-500);
}

.btn.btn-color-gray-600 {
  color: var(--bs-text-gray-600);
}
.btn.btn-color-gray-600 i,
.btn.btn-color-gray-600 .svg-icon {
  color: var(--bs-text-gray-600);
}
.btn.btn-color-gray-600.dropdown-toggle:after {
  color: var(--bs-text-gray-600);
}
.btn-check:checked + .btn.btn-active-color-gray-600, .btn-check:active + .btn.btn-active-color-gray-600, .btn.btn-active-color-gray-600:focus:not(.btn-active), .btn.btn-active-color-gray-600:hover:not(.btn-active), .btn.btn-active-color-gray-600:active:not(.btn-active), .btn.btn-active-color-gray-600.active, .btn.btn-active-color-gray-600.show, .show > .btn.btn-active-color-gray-600 {
  color: var(--bs-text-gray-600);
}
.btn-check:checked + .btn.btn-active-color-gray-600 i,
.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-600 i,
.btn-check:active + .btn.btn-active-color-gray-600 .svg-icon, .btn.btn-active-color-gray-600:focus:not(.btn-active) i,
.btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:hover:not(.btn-active) i,
.btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:active:not(.btn-active) i,
.btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600.active i,
.btn.btn-active-color-gray-600.active .svg-icon, .btn.btn-active-color-gray-600.show i,
.btn.btn-active-color-gray-600.show .svg-icon, .show > .btn.btn-active-color-gray-600 i,
.show > .btn.btn-active-color-gray-600 .svg-icon {
  color: var(--bs-text-gray-600);
}
.btn-check:checked + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn.btn-active-color-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600.active.dropdown-toggle:after, .btn.btn-active-color-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-600.dropdown-toggle:after {
  color: var(--bs-text-gray-600);
}

.btn.btn-icon-gray-600 i,
.btn.btn-icon-gray-600 .svg-icon {
  color: var(--bs-text-gray-600);
}
.btn.btn-icon-gray-600.dropdown-toggle:after {
  color: var(--bs-text-gray-600);
}
.btn-check:checked + .btn.btn-active-icon-gray-600 i,
.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-600 i,
.btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon, .btn.btn-active-icon-gray-600:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:active:not(.btn-active) i,
.btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600.active i,
.btn.btn-active-icon-gray-600.active .svg-icon, .btn.btn-active-icon-gray-600.show i,
.btn.btn-active-icon-gray-600.show .svg-icon, .show > .btn.btn-active-icon-gray-600 i,
.show > .btn.btn-active-icon-gray-600 .svg-icon {
  color: var(--bs-text-gray-600);
}
.btn-check:checked + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn.btn-active-icon-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600.active.dropdown-toggle:after, .btn.btn-active-icon-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-600.dropdown-toggle:after {
  color: var(--bs-text-gray-600);
}

.btn.btn-text-gray-600 {
  color: var(--bs-text-gray-600);
}
.btn-check:checked + .btn.btn-active-text-gray-600, .btn-check:active + .btn.btn-active-text-gray-600, .btn.btn-active-text-gray-600:focus:not(.btn-active), .btn.btn-active-text-gray-600:hover:not(.btn-active), .btn.btn-active-text-gray-600:active:not(.btn-active), .btn.btn-active-text-gray-600.active, .btn.btn-active-text-gray-600.show, .show > .btn.btn-active-text-gray-600 {
  color: var(--bs-text-gray-600);
}

.btn.btn-color-gray-700 {
  color: var(--bs-text-gray-700);
}
.btn.btn-color-gray-700 i,
.btn.btn-color-gray-700 .svg-icon {
  color: var(--bs-text-gray-700);
}
.btn.btn-color-gray-700.dropdown-toggle:after {
  color: var(--bs-text-gray-700);
}
.btn-check:checked + .btn.btn-active-color-gray-700, .btn-check:active + .btn.btn-active-color-gray-700, .btn.btn-active-color-gray-700:focus:not(.btn-active), .btn.btn-active-color-gray-700:hover:not(.btn-active), .btn.btn-active-color-gray-700:active:not(.btn-active), .btn.btn-active-color-gray-700.active, .btn.btn-active-color-gray-700.show, .show > .btn.btn-active-color-gray-700 {
  color: var(--bs-text-gray-700);
}
.btn-check:checked + .btn.btn-active-color-gray-700 i,
.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-700 i,
.btn-check:active + .btn.btn-active-color-gray-700 .svg-icon, .btn.btn-active-color-gray-700:focus:not(.btn-active) i,
.btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:hover:not(.btn-active) i,
.btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:active:not(.btn-active) i,
.btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700.active i,
.btn.btn-active-color-gray-700.active .svg-icon, .btn.btn-active-color-gray-700.show i,
.btn.btn-active-color-gray-700.show .svg-icon, .show > .btn.btn-active-color-gray-700 i,
.show > .btn.btn-active-color-gray-700 .svg-icon {
  color: var(--bs-text-gray-700);
}
.btn-check:checked + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn.btn-active-color-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700.active.dropdown-toggle:after, .btn.btn-active-color-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-700.dropdown-toggle:after {
  color: var(--bs-text-gray-700);
}

.btn.btn-icon-gray-700 i,
.btn.btn-icon-gray-700 .svg-icon {
  color: var(--bs-text-gray-700);
}
.btn.btn-icon-gray-700.dropdown-toggle:after {
  color: var(--bs-text-gray-700);
}
.btn-check:checked + .btn.btn-active-icon-gray-700 i,
.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-700 i,
.btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon, .btn.btn-active-icon-gray-700:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:active:not(.btn-active) i,
.btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700.active i,
.btn.btn-active-icon-gray-700.active .svg-icon, .btn.btn-active-icon-gray-700.show i,
.btn.btn-active-icon-gray-700.show .svg-icon, .show > .btn.btn-active-icon-gray-700 i,
.show > .btn.btn-active-icon-gray-700 .svg-icon {
  color: var(--bs-text-gray-700);
}
.btn-check:checked + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn.btn-active-icon-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700.active.dropdown-toggle:after, .btn.btn-active-icon-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-700.dropdown-toggle:after {
  color: var(--bs-text-gray-700);
}

.btn.btn-text-gray-700 {
  color: var(--bs-text-gray-700);
}
.btn-check:checked + .btn.btn-active-text-gray-700, .btn-check:active + .btn.btn-active-text-gray-700, .btn.btn-active-text-gray-700:focus:not(.btn-active), .btn.btn-active-text-gray-700:hover:not(.btn-active), .btn.btn-active-text-gray-700:active:not(.btn-active), .btn.btn-active-text-gray-700.active, .btn.btn-active-text-gray-700.show, .show > .btn.btn-active-text-gray-700 {
  color: var(--bs-text-gray-700);
}

.btn.btn-color-gray-800 {
  color: var(--bs-text-gray-800);
}
.btn.btn-color-gray-800 i,
.btn.btn-color-gray-800 .svg-icon {
  color: var(--bs-text-gray-800);
}
.btn.btn-color-gray-800.dropdown-toggle:after {
  color: var(--bs-text-gray-800);
}
.btn-check:checked + .btn.btn-active-color-gray-800, .btn-check:active + .btn.btn-active-color-gray-800, .btn.btn-active-color-gray-800:focus:not(.btn-active), .btn.btn-active-color-gray-800:hover:not(.btn-active), .btn.btn-active-color-gray-800:active:not(.btn-active), .btn.btn-active-color-gray-800.active, .btn.btn-active-color-gray-800.show, .show > .btn.btn-active-color-gray-800 {
  color: var(--bs-text-gray-800);
}
.btn-check:checked + .btn.btn-active-color-gray-800 i,
.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-800 i,
.btn-check:active + .btn.btn-active-color-gray-800 .svg-icon, .btn.btn-active-color-gray-800:focus:not(.btn-active) i,
.btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:hover:not(.btn-active) i,
.btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:active:not(.btn-active) i,
.btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800.active i,
.btn.btn-active-color-gray-800.active .svg-icon, .btn.btn-active-color-gray-800.show i,
.btn.btn-active-color-gray-800.show .svg-icon, .show > .btn.btn-active-color-gray-800 i,
.show > .btn.btn-active-color-gray-800 .svg-icon {
  color: var(--bs-text-gray-800);
}
.btn-check:checked + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn.btn-active-color-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800.active.dropdown-toggle:after, .btn.btn-active-color-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-800.dropdown-toggle:after {
  color: var(--bs-text-gray-800);
}

.btn.btn-icon-gray-800 i,
.btn.btn-icon-gray-800 .svg-icon {
  color: var(--bs-text-gray-800);
}
.btn.btn-icon-gray-800.dropdown-toggle:after {
  color: var(--bs-text-gray-800);
}
.btn-check:checked + .btn.btn-active-icon-gray-800 i,
.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-800 i,
.btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon, .btn.btn-active-icon-gray-800:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:active:not(.btn-active) i,
.btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800.active i,
.btn.btn-active-icon-gray-800.active .svg-icon, .btn.btn-active-icon-gray-800.show i,
.btn.btn-active-icon-gray-800.show .svg-icon, .show > .btn.btn-active-icon-gray-800 i,
.show > .btn.btn-active-icon-gray-800 .svg-icon {
  color: var(--bs-text-gray-800);
}
.btn-check:checked + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn.btn-active-icon-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800.active.dropdown-toggle:after, .btn.btn-active-icon-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-800.dropdown-toggle:after {
  color: var(--bs-text-gray-800);
}

.btn.btn-text-gray-800 {
  color: var(--bs-text-gray-800);
}
.btn-check:checked + .btn.btn-active-text-gray-800, .btn-check:active + .btn.btn-active-text-gray-800, .btn.btn-active-text-gray-800:focus:not(.btn-active), .btn.btn-active-text-gray-800:hover:not(.btn-active), .btn.btn-active-text-gray-800:active:not(.btn-active), .btn.btn-active-text-gray-800.active, .btn.btn-active-text-gray-800.show, .show > .btn.btn-active-text-gray-800 {
  color: var(--bs-text-gray-800);
}

.btn.btn-color-gray-900 {
  color: var(--bs-text-gray-900);
}
.btn.btn-color-gray-900 i,
.btn.btn-color-gray-900 .svg-icon {
  color: var(--bs-text-gray-900);
}
.btn.btn-color-gray-900.dropdown-toggle:after {
  color: var(--bs-text-gray-900);
}
.btn-check:checked + .btn.btn-active-color-gray-900, .btn-check:active + .btn.btn-active-color-gray-900, .btn.btn-active-color-gray-900:focus:not(.btn-active), .btn.btn-active-color-gray-900:hover:not(.btn-active), .btn.btn-active-color-gray-900:active:not(.btn-active), .btn.btn-active-color-gray-900.active, .btn.btn-active-color-gray-900.show, .show > .btn.btn-active-color-gray-900 {
  color: var(--bs-text-gray-900);
}
.btn-check:checked + .btn.btn-active-color-gray-900 i,
.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-900 i,
.btn-check:active + .btn.btn-active-color-gray-900 .svg-icon, .btn.btn-active-color-gray-900:focus:not(.btn-active) i,
.btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:hover:not(.btn-active) i,
.btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:active:not(.btn-active) i,
.btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900.active i,
.btn.btn-active-color-gray-900.active .svg-icon, .btn.btn-active-color-gray-900.show i,
.btn.btn-active-color-gray-900.show .svg-icon, .show > .btn.btn-active-color-gray-900 i,
.show > .btn.btn-active-color-gray-900 .svg-icon {
  color: var(--bs-text-gray-900);
}
.btn-check:checked + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn.btn-active-color-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900.active.dropdown-toggle:after, .btn.btn-active-color-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-900.dropdown-toggle:after {
  color: var(--bs-text-gray-900);
}

.btn.btn-icon-gray-900 i,
.btn.btn-icon-gray-900 .svg-icon {
  color: var(--bs-text-gray-900);
}
.btn.btn-icon-gray-900.dropdown-toggle:after {
  color: var(--bs-text-gray-900);
}
.btn-check:checked + .btn.btn-active-icon-gray-900 i,
.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-900 i,
.btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon, .btn.btn-active-icon-gray-900:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:active:not(.btn-active) i,
.btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900.active i,
.btn.btn-active-icon-gray-900.active .svg-icon, .btn.btn-active-icon-gray-900.show i,
.btn.btn-active-icon-gray-900.show .svg-icon, .show > .btn.btn-active-icon-gray-900 i,
.show > .btn.btn-active-icon-gray-900 .svg-icon {
  color: var(--bs-text-gray-900);
}
.btn-check:checked + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn.btn-active-icon-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900.active.dropdown-toggle:after, .btn.btn-active-icon-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-900.dropdown-toggle:after {
  color: var(--bs-text-gray-900);
}

.btn.btn-text-gray-900 {
  color: var(--bs-text-gray-900);
}
.btn-check:checked + .btn.btn-active-text-gray-900, .btn-check:active + .btn.btn-active-text-gray-900, .btn.btn-active-text-gray-900:focus:not(.btn-active), .btn.btn-active-text-gray-900:hover:not(.btn-active), .btn.btn-active-text-gray-900:active:not(.btn-active), .btn.btn-active-text-gray-900.active, .btn.btn-active-text-gray-900.show, .show > .btn.btn-active-text-gray-900 {
  color: var(--bs-text-gray-900);
}

.btn.btn-facebook {
  color: #ffffff;
  border-color: #3b5998;
  background-color: #3b5998;
}
.btn.btn-facebook i,
.btn.btn-facebook .svg-icon {
  color: #ffffff;
}
.btn.btn-facebook.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-facebook, .btn-check:active + .btn.btn-facebook, .btn.btn-facebook:focus:not(.btn-active), .btn.btn-facebook:hover:not(.btn-active), .btn.btn-facebook:active:not(.btn-active), .btn.btn-facebook.active, .btn.btn-facebook.show, .show > .btn.btn-facebook {
  border-color: #30497c;
  background-color: #30497c !important;
}

.btn.btn-light-facebook {
  color: #3b5998;
  border-color: rgba(59, 89, 152, 0.1);
  background-color: rgba(59, 89, 152, 0.1);
}
.btn.btn-light-facebook i,
.btn.btn-light-facebook .svg-icon {
  color: #3b5998;
}
.btn.btn-light-facebook.dropdown-toggle:after {
  color: #3b5998;
}
.btn-check:checked + .btn.btn-light-facebook, .btn-check:active + .btn.btn-light-facebook, .btn.btn-light-facebook:focus:not(.btn-active), .btn.btn-light-facebook:hover:not(.btn-active), .btn.btn-light-facebook:active:not(.btn-active), .btn.btn-light-facebook.active, .btn.btn-light-facebook.show, .show > .btn.btn-light-facebook {
  color: #ffffff;
  border-color: #3b5998;
  background-color: #3b5998 !important;
}
.btn-check:checked + .btn.btn-light-facebook i,
.btn-check:checked + .btn.btn-light-facebook .svg-icon, .btn-check:active + .btn.btn-light-facebook i,
.btn-check:active + .btn.btn-light-facebook .svg-icon, .btn.btn-light-facebook:focus:not(.btn-active) i,
.btn.btn-light-facebook:focus:not(.btn-active) .svg-icon, .btn.btn-light-facebook:hover:not(.btn-active) i,
.btn.btn-light-facebook:hover:not(.btn-active) .svg-icon, .btn.btn-light-facebook:active:not(.btn-active) i,
.btn.btn-light-facebook:active:not(.btn-active) .svg-icon, .btn.btn-light-facebook.active i,
.btn.btn-light-facebook.active .svg-icon, .btn.btn-light-facebook.show i,
.btn.btn-light-facebook.show .svg-icon, .show > .btn.btn-light-facebook i,
.show > .btn.btn-light-facebook .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-facebook.dropdown-toggle:after, .btn-check:active + .btn.btn-light-facebook.dropdown-toggle:after, .btn.btn-light-facebook:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook.active.dropdown-toggle:after, .btn.btn-light-facebook.show.dropdown-toggle:after, .show > .btn.btn-light-facebook.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-google {
  color: #ffffff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}
.btn.btn-google i,
.btn.btn-google .svg-icon {
  color: #ffffff;
}
.btn.btn-google.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-google, .btn-check:active + .btn.btn-google, .btn.btn-google:focus:not(.btn-active), .btn.btn-google:hover:not(.btn-active), .btn.btn-google:active:not(.btn-active), .btn.btn-google.active, .btn.btn-google.show, .show > .btn.btn-google {
  border-color: #cd3623;
  background-color: #cd3623 !important;
}

.btn.btn-light-google {
  color: #dd4b39;
  border-color: rgba(221, 75, 57, 0.1);
  background-color: rgba(221, 75, 57, 0.1);
}
.btn.btn-light-google i,
.btn.btn-light-google .svg-icon {
  color: #dd4b39;
}
.btn.btn-light-google.dropdown-toggle:after {
  color: #dd4b39;
}
.btn-check:checked + .btn.btn-light-google, .btn-check:active + .btn.btn-light-google, .btn.btn-light-google:focus:not(.btn-active), .btn.btn-light-google:hover:not(.btn-active), .btn.btn-light-google:active:not(.btn-active), .btn.btn-light-google.active, .btn.btn-light-google.show, .show > .btn.btn-light-google {
  color: #ffffff;
  border-color: #dd4b39;
  background-color: #dd4b39 !important;
}
.btn-check:checked + .btn.btn-light-google i,
.btn-check:checked + .btn.btn-light-google .svg-icon, .btn-check:active + .btn.btn-light-google i,
.btn-check:active + .btn.btn-light-google .svg-icon, .btn.btn-light-google:focus:not(.btn-active) i,
.btn.btn-light-google:focus:not(.btn-active) .svg-icon, .btn.btn-light-google:hover:not(.btn-active) i,
.btn.btn-light-google:hover:not(.btn-active) .svg-icon, .btn.btn-light-google:active:not(.btn-active) i,
.btn.btn-light-google:active:not(.btn-active) .svg-icon, .btn.btn-light-google.active i,
.btn.btn-light-google.active .svg-icon, .btn.btn-light-google.show i,
.btn.btn-light-google.show .svg-icon, .show > .btn.btn-light-google i,
.show > .btn.btn-light-google .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-google.dropdown-toggle:after, .btn-check:active + .btn.btn-light-google.dropdown-toggle:after, .btn.btn-light-google:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google.active.dropdown-toggle:after, .btn.btn-light-google.show.dropdown-toggle:after, .show > .btn.btn-light-google.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-twitter {
  color: #ffffff;
  border-color: #1da1f2;
  background-color: #1da1f2;
}
.btn.btn-twitter i,
.btn.btn-twitter .svg-icon {
  color: #ffffff;
}
.btn.btn-twitter.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-twitter, .btn-check:active + .btn.btn-twitter, .btn.btn-twitter:focus:not(.btn-active), .btn.btn-twitter:hover:not(.btn-active), .btn.btn-twitter:active:not(.btn-active), .btn.btn-twitter.active, .btn.btn-twitter.show, .show > .btn.btn-twitter {
  border-color: #0d8ddc;
  background-color: #0d8ddc !important;
}

.btn.btn-light-twitter {
  color: #1da1f2;
  border-color: rgba(29, 161, 242, 0.1);
  background-color: rgba(29, 161, 242, 0.1);
}
.btn.btn-light-twitter i,
.btn.btn-light-twitter .svg-icon {
  color: #1da1f2;
}
.btn.btn-light-twitter.dropdown-toggle:after {
  color: #1da1f2;
}
.btn-check:checked + .btn.btn-light-twitter, .btn-check:active + .btn.btn-light-twitter, .btn.btn-light-twitter:focus:not(.btn-active), .btn.btn-light-twitter:hover:not(.btn-active), .btn.btn-light-twitter:active:not(.btn-active), .btn.btn-light-twitter.active, .btn.btn-light-twitter.show, .show > .btn.btn-light-twitter {
  color: #ffffff;
  border-color: #1da1f2;
  background-color: #1da1f2 !important;
}
.btn-check:checked + .btn.btn-light-twitter i,
.btn-check:checked + .btn.btn-light-twitter .svg-icon, .btn-check:active + .btn.btn-light-twitter i,
.btn-check:active + .btn.btn-light-twitter .svg-icon, .btn.btn-light-twitter:focus:not(.btn-active) i,
.btn.btn-light-twitter:focus:not(.btn-active) .svg-icon, .btn.btn-light-twitter:hover:not(.btn-active) i,
.btn.btn-light-twitter:hover:not(.btn-active) .svg-icon, .btn.btn-light-twitter:active:not(.btn-active) i,
.btn.btn-light-twitter:active:not(.btn-active) .svg-icon, .btn.btn-light-twitter.active i,
.btn.btn-light-twitter.active .svg-icon, .btn.btn-light-twitter.show i,
.btn.btn-light-twitter.show .svg-icon, .show > .btn.btn-light-twitter i,
.show > .btn.btn-light-twitter .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-twitter.dropdown-toggle:after, .btn-check:active + .btn.btn-light-twitter.dropdown-toggle:after, .btn.btn-light-twitter:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter.active.dropdown-toggle:after, .btn.btn-light-twitter.show.dropdown-toggle:after, .show > .btn.btn-light-twitter.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-instagram {
  color: #ffffff;
  border-color: #e1306c;
  background-color: #e1306c;
}
.btn.btn-instagram i,
.btn.btn-instagram .svg-icon {
  color: #ffffff;
}
.btn.btn-instagram.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-instagram, .btn-check:active + .btn.btn-instagram, .btn.btn-instagram:focus:not(.btn-active), .btn.btn-instagram:hover:not(.btn-active), .btn.btn-instagram:active:not(.btn-active), .btn.btn-instagram.active, .btn.btn-instagram.show, .show > .btn.btn-instagram {
  border-color: #cd1e59;
  background-color: #cd1e59 !important;
}

.btn.btn-light-instagram {
  color: #e1306c;
  border-color: rgba(225, 48, 108, 0.1);
  background-color: rgba(225, 48, 108, 0.1);
}
.btn.btn-light-instagram i,
.btn.btn-light-instagram .svg-icon {
  color: #e1306c;
}
.btn.btn-light-instagram.dropdown-toggle:after {
  color: #e1306c;
}
.btn-check:checked + .btn.btn-light-instagram, .btn-check:active + .btn.btn-light-instagram, .btn.btn-light-instagram:focus:not(.btn-active), .btn.btn-light-instagram:hover:not(.btn-active), .btn.btn-light-instagram:active:not(.btn-active), .btn.btn-light-instagram.active, .btn.btn-light-instagram.show, .show > .btn.btn-light-instagram {
  color: #ffffff;
  border-color: #e1306c;
  background-color: #e1306c !important;
}
.btn-check:checked + .btn.btn-light-instagram i,
.btn-check:checked + .btn.btn-light-instagram .svg-icon, .btn-check:active + .btn.btn-light-instagram i,
.btn-check:active + .btn.btn-light-instagram .svg-icon, .btn.btn-light-instagram:focus:not(.btn-active) i,
.btn.btn-light-instagram:focus:not(.btn-active) .svg-icon, .btn.btn-light-instagram:hover:not(.btn-active) i,
.btn.btn-light-instagram:hover:not(.btn-active) .svg-icon, .btn.btn-light-instagram:active:not(.btn-active) i,
.btn.btn-light-instagram:active:not(.btn-active) .svg-icon, .btn.btn-light-instagram.active i,
.btn.btn-light-instagram.active .svg-icon, .btn.btn-light-instagram.show i,
.btn.btn-light-instagram.show .svg-icon, .show > .btn.btn-light-instagram i,
.show > .btn.btn-light-instagram .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-instagram.dropdown-toggle:after, .btn-check:active + .btn.btn-light-instagram.dropdown-toggle:after, .btn.btn-light-instagram:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram.active.dropdown-toggle:after, .btn.btn-light-instagram.show.dropdown-toggle:after, .show > .btn.btn-light-instagram.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-youtube {
  color: #ffffff;
  border-color: #ff0000;
  background-color: #ff0000;
}
.btn.btn-youtube i,
.btn.btn-youtube .svg-icon {
  color: #ffffff;
}
.btn.btn-youtube.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-youtube, .btn-check:active + .btn.btn-youtube, .btn.btn-youtube:focus:not(.btn-active), .btn.btn-youtube:hover:not(.btn-active), .btn.btn-youtube:active:not(.btn-active), .btn.btn-youtube.active, .btn.btn-youtube.show, .show > .btn.btn-youtube {
  border-color: #d90000;
  background-color: #d90000 !important;
}

.btn.btn-light-youtube {
  color: #ff0000;
  border-color: rgba(255, 0, 0, 0.1);
  background-color: rgba(255, 0, 0, 0.1);
}
.btn.btn-light-youtube i,
.btn.btn-light-youtube .svg-icon {
  color: #ff0000;
}
.btn.btn-light-youtube.dropdown-toggle:after {
  color: #ff0000;
}
.btn-check:checked + .btn.btn-light-youtube, .btn-check:active + .btn.btn-light-youtube, .btn.btn-light-youtube:focus:not(.btn-active), .btn.btn-light-youtube:hover:not(.btn-active), .btn.btn-light-youtube:active:not(.btn-active), .btn.btn-light-youtube.active, .btn.btn-light-youtube.show, .show > .btn.btn-light-youtube {
  color: #ffffff;
  border-color: #ff0000;
  background-color: #ff0000 !important;
}
.btn-check:checked + .btn.btn-light-youtube i,
.btn-check:checked + .btn.btn-light-youtube .svg-icon, .btn-check:active + .btn.btn-light-youtube i,
.btn-check:active + .btn.btn-light-youtube .svg-icon, .btn.btn-light-youtube:focus:not(.btn-active) i,
.btn.btn-light-youtube:focus:not(.btn-active) .svg-icon, .btn.btn-light-youtube:hover:not(.btn-active) i,
.btn.btn-light-youtube:hover:not(.btn-active) .svg-icon, .btn.btn-light-youtube:active:not(.btn-active) i,
.btn.btn-light-youtube:active:not(.btn-active) .svg-icon, .btn.btn-light-youtube.active i,
.btn.btn-light-youtube.active .svg-icon, .btn.btn-light-youtube.show i,
.btn.btn-light-youtube.show .svg-icon, .show > .btn.btn-light-youtube i,
.show > .btn.btn-light-youtube .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-youtube.dropdown-toggle:after, .btn-check:active + .btn.btn-light-youtube.dropdown-toggle:after, .btn.btn-light-youtube:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube.active.dropdown-toggle:after, .btn.btn-light-youtube.show.dropdown-toggle:after, .show > .btn.btn-light-youtube.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-linkedin {
  color: #ffffff;
  border-color: #0077b5;
  background-color: #0077b5;
}
.btn.btn-linkedin i,
.btn.btn-linkedin .svg-icon {
  color: #ffffff;
}
.btn.btn-linkedin.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-linkedin, .btn-check:active + .btn.btn-linkedin, .btn.btn-linkedin:focus:not(.btn-active), .btn.btn-linkedin:hover:not(.btn-active), .btn.btn-linkedin:active:not(.btn-active), .btn.btn-linkedin.active, .btn.btn-linkedin.show, .show > .btn.btn-linkedin {
  border-color: #005e8f;
  background-color: #005e8f !important;
}

.btn.btn-light-linkedin {
  color: #0077b5;
  border-color: rgba(0, 119, 181, 0.1);
  background-color: rgba(0, 119, 181, 0.1);
}
.btn.btn-light-linkedin i,
.btn.btn-light-linkedin .svg-icon {
  color: #0077b5;
}
.btn.btn-light-linkedin.dropdown-toggle:after {
  color: #0077b5;
}
.btn-check:checked + .btn.btn-light-linkedin, .btn-check:active + .btn.btn-light-linkedin, .btn.btn-light-linkedin:focus:not(.btn-active), .btn.btn-light-linkedin:hover:not(.btn-active), .btn.btn-light-linkedin:active:not(.btn-active), .btn.btn-light-linkedin.active, .btn.btn-light-linkedin.show, .show > .btn.btn-light-linkedin {
  color: #ffffff;
  border-color: #0077b5;
  background-color: #0077b5 !important;
}
.btn-check:checked + .btn.btn-light-linkedin i,
.btn-check:checked + .btn.btn-light-linkedin .svg-icon, .btn-check:active + .btn.btn-light-linkedin i,
.btn-check:active + .btn.btn-light-linkedin .svg-icon, .btn.btn-light-linkedin:focus:not(.btn-active) i,
.btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:hover:not(.btn-active) i,
.btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:active:not(.btn-active) i,
.btn.btn-light-linkedin:active:not(.btn-active) .svg-icon, .btn.btn-light-linkedin.active i,
.btn.btn-light-linkedin.active .svg-icon, .btn.btn-light-linkedin.show i,
.btn.btn-light-linkedin.show .svg-icon, .show > .btn.btn-light-linkedin i,
.show > .btn.btn-light-linkedin .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-linkedin.dropdown-toggle:after, .btn-check:active + .btn.btn-light-linkedin.dropdown-toggle:after, .btn.btn-light-linkedin:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin.active.dropdown-toggle:after, .btn.btn-light-linkedin.show.dropdown-toggle:after, .show > .btn.btn-light-linkedin.dropdown-toggle:after {
  color: #ffffff;
}

[data-bs-theme=dark] .btn.btn-dark {
  color: #B5B7C8;
  background-color: #464852;
}
[data-bs-theme=dark] .btn.btn-dark i,
[data-bs-theme=dark] .btn.btn-dark .svg-icon {
  color: #B5B7C8;
}
[data-bs-theme=dark] .btn.btn-dark.dropdown-toggle:after {
  color: #B5B7C8;
}
.btn-check:checked + [data-bs-theme=dark] .btn.btn-dark, .btn-check:active + [data-bs-theme=dark] .btn.btn-dark, [data-bs-theme=dark] .btn.btn-dark:focus:not(.btn-active), [data-bs-theme=dark] .btn.btn-dark:hover:not(.btn-active), [data-bs-theme=dark] .btn.btn-dark:active:not(.btn-active), [data-bs-theme=dark] .btn.btn-dark.active, [data-bs-theme=dark] .btn.btn-dark.show, .show > [data-bs-theme=dark] .btn.btn-dark {
  color: #bec0cf;
  background-color: #4d4f5a !important;
}
.btn-check:checked + [data-bs-theme=dark] .btn.btn-dark i,
.btn-check:checked + [data-bs-theme=dark] .btn.btn-dark .svg-icon, .btn-check:active + [data-bs-theme=dark] .btn.btn-dark i,
.btn-check:active + [data-bs-theme=dark] .btn.btn-dark .svg-icon, [data-bs-theme=dark] .btn.btn-dark:focus:not(.btn-active) i,
[data-bs-theme=dark] .btn.btn-dark:focus:not(.btn-active) .svg-icon, [data-bs-theme=dark] .btn.btn-dark:hover:not(.btn-active) i,
[data-bs-theme=dark] .btn.btn-dark:hover:not(.btn-active) .svg-icon, [data-bs-theme=dark] .btn.btn-dark:active:not(.btn-active) i,
[data-bs-theme=dark] .btn.btn-dark:active:not(.btn-active) .svg-icon, [data-bs-theme=dark] .btn.btn-dark.active i,
[data-bs-theme=dark] .btn.btn-dark.active .svg-icon, [data-bs-theme=dark] .btn.btn-dark.show i,
[data-bs-theme=dark] .btn.btn-dark.show .svg-icon, .show > [data-bs-theme=dark] .btn.btn-dark i,
.show > [data-bs-theme=dark] .btn.btn-dark .svg-icon {
  color: #bec0cf;
}
.btn-check:checked + [data-bs-theme=dark] .btn.btn-dark.dropdown-toggle:after, .btn-check:active + [data-bs-theme=dark] .btn.btn-dark.dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark.active.dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark.show.dropdown-toggle:after, .show > [data-bs-theme=dark] .btn.btn-dark.dropdown-toggle:after {
  color: #bec0cf;
}

.modal-rounded {
  border-radius: 0.65rem !important;
}

code:not([class*=language-]) {
  font-weight: 400;
  color: var(--bs-code-color);
  border: 1px solid var(--bs-code-border-color);
  background-color: var(--bs-code-bg);
  border-radius: 0.3rem;
  line-height: inherit;
  font-size: 1rem;
  padding: 0.1rem 0.4rem;
  margin: 0 0.5rem;
  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);
}
code:not([class*=language-]).code-light {
  color: var(--bs-light);
  background-color: var(--bs-light-light);
  border: 1px solid var(--bs-light);
}
code:not([class*=language-]).code-primary {
  color: var(--bs-primary);
  background-color: var(--bs-primary-light);
  border: 1px solid var(--bs-primary);
}
code:not([class*=language-]).code-secondary {
  color: var(--bs-secondary);
  background-color: var(--bs-secondary-light);
  border: 1px solid var(--bs-secondary);
}
code:not([class*=language-]).code-success {
  color: var(--bs-success);
  background-color: var(--bs-success-light);
  border: 1px solid var(--bs-success);
}
code:not([class*=language-]).code-info {
  color: var(--bs-info);
  background-color: var(--bs-info-light);
  border: 1px solid var(--bs-info);
}
code:not([class*=language-]).code-warning {
  color: var(--bs-warning);
  background-color: var(--bs-warning-light);
  border: 1px solid var(--bs-warning);
}
code:not([class*=language-]).code-danger {
  color: var(--bs-danger);
  background-color: var(--bs-danger-light);
  border: 1px solid var(--bs-danger);
}
code:not([class*=language-]).code-dark {
  color: var(--bs-dark);
  background-color: var(--bs-dark-light);
  border: 1px solid var(--bs-dark);
}

.col-form-label {
  font-size: 1.05rem;
}

.form-control.form-control-transparent {
  background-color: transparent;
  border-color: transparent;
}
.dropdown.show > .form-control.form-control-transparent, .form-control.form-control-transparent:active, .form-control.form-control-transparent.active, .form-control.form-control-transparent:focus, .form-control.form-control-transparent.focus {
  background-color: transparent;
  border-color: transparent;
}
.form-control.form-control-flush {
  border: 0;
  background-color: transparent;
  outline: none !important;
  box-shadow: none;
  border-radius: 0;
}

.form-control.form-control-solid {
  background-color: var(--bs-gray-100);
  border-color: var(--bs-gray-100);
  color: var(--bs-gray-700);
  transition: color 0.2s ease;
}
.form-control.form-control-solid::placeholder {
  color: var(--bs-gray-500);
}
.form-control.form-control-solid::-moz-placeholder {
  color: var(--bs-gray-500);
  opacity: 1;
}
.dropdown.show > .form-control.form-control-solid, .form-control.form-control-solid:active, .form-control.form-control-solid.active, .form-control.form-control-solid:focus, .form-control.form-control-solid.focus {
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-200);
  color: var(--bs-gray-700);
  transition: color 0.2s ease;
}

.form-control-solid-bg {
  background-color: var(--bs-gray-100);
}

.form-control-plaintext {
  color: var(--bs-gray-700);
}

.placeholder-gray-500::placeholder {
  color: var(--bs-gray-500);
}

.placeholder-white::placeholder {
  color: #ffffff;
}
.placeholder-white::-moz-placeholder {
  color: #ffffff;
  opacity: 1;
}

.resize-none {
  resize: none;
}

.form-floating .form-control.form-control-solid::placeholder {
  color: transparent;
}
.form-floating.form-control-solid-bg label::after,
.form-floating > :disabled ~ label::after,
.form-floating > :focus ~ label::after {
  background-color: transparent !important;
}

.form-select {
  appearance: none;
}
.form-select:focus {
  border-color: var(--bs-gray-400);
  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);
}
.form-select:disabled {
  color: var(--bs-gray-500);
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-300);
}
.form-select:-moz-focusring {
  text-shadow: 0 0 0 var(--bs-gray-700);
}
.form-select.form-select-solid {
  background-color: var(--bs-gray-100);
  border-color: var(--bs-gray-100);
  color: var(--bs-gray-700);
  transition: color 0.2s ease;
}
.form-select.form-select-solid::placeholder {
  color: var(--bs-gray-500);
}
.form-select.form-select-solid::-moz-placeholder {
  color: var(--bs-gray-500);
  opacity: 1;
}
.dropdown.show > .form-select.form-select-solid, .form-select.form-select-solid:active, .form-select.form-select-solid.active, .form-select.form-select-solid:focus, .form-select.form-select-solid.focus {
  background-color: var(--bs-gray-200);
  border-color: var(--bs-gray-200) !important;
  color: var(--bs-gray-700);
  transition: color 0.2s ease;
}
.form-select.form-select-transparent {
  background-color: transparent;
  border-color: transparent;
  color: var(--bs-gray-700);
}
.form-select.form-select-transparent::placeholder {
  color: var(--bs-gray-500);
}
.form-select.form-select-transparent::-moz-placeholder {
  color: var(--bs-gray-500);
  opacity: 1;
}
.dropdown.show > .form-select.form-select-transparent, .form-select.form-select-transparent:active, .form-select.form-select-transparent.active, .form-select.form-select-transparent:focus, .form-select.form-select-transparent.focus {
  background-color: transparent;
  border-color: transparent !important;
  color: var(--bs-gray-700);
}

.form-check:not(.form-switch) .form-check-input[type=checkbox] {
  background-size: 60% 60%;
}
.form-check.form-check-sm .form-check-input {
  height: 1.55rem;
  width: 1.55rem;
}
.form-check.form-check-lg .form-check-input {
  height: 2.25rem;
  width: 2.25rem;
}
.form-check.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}
.form-check.form-check-solid .form-check-input {
  border: 0;
}
.form-check.form-check-solid .form-check-input:not(:checked) {
  background-color: var(--bs-gray-200);
}
.form-check.form-check-solid .form-check-input[type=checkbox]:indeterminate {
  background-color: #1B84FF;
}
.form-check.form-check-success .form-check-input:checked {
  background-color: var(--bs-success);
}
.form-check.form-check-danger .form-check-input:checked {
  background-color: var(--bs-danger);
}
.form-check.form-check-warning .form-check-input:checked {
  background-color: var(--bs-warning);
}

.form-check-custom {
  display: flex;
  align-items: center;
  padding-left: 0;
  margin: 0;
}
.form-check-custom .form-check-input {
  margin: 0;
  float: none;
  flex-shrink: 0;
}
.form-check-custom .form-check-label {
  margin-left: 0.55rem;
}

.form-switch.form-check-custom .form-check-input {
  height: 2.25rem;
}
.form-switch.form-check-custom.form-switch-sm .form-check-input {
  height: 1.5rem;
  width: 2.5rem;
}
.form-switch.form-check-custom.form-switch-lg .form-check-input {
  height: 2.75rem;
  width: 3.75rem;
}
.form-switch.form-check-solid .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch.form-check-solid .form-check-input:not(:checked) {
  background-color: var(--bs-gray-200);
}

[data-bs-theme=dark] .form-switch .form-check-input:focus:not(:checked) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-check-image {
  position: relative;
  overflow: hidden;
}
.form-check-image img {
  max-width: 100%;
}
.form-check-image .form-check-wrapper {
  border-radius: 0.85rem;
  border: 2px solid transparent;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  overflow: hidden;
  margin-bottom: 0.75rem;
}
.form-check-image .form-check-rounded {
  border-radius: 0.85rem;
}
.form-check-image .form-check-label {
  font-weight: 600;
  margin-left: 0.5rem;
}
.form-check-image.active:not(.form-check-success):not(.form-check-danger) .form-check-wrapper {
  border-color: var(--bs-primary) !important;
}
.form-check-image.form-check-success.active .form-check-wrapper {
  border-color: var(--bs-success) !important;
}
.form-check-image.form-check-danger.active .form-check-wrapper {
  border-color: var(--bs-danger) !important;
}
.form-check-image.disabled {
  opacity: 0.65;
}

.input-group.input-group-solid {
  border-radius: 0.65rem;
}
.input-group.input-group-solid.input-group-sm {
  border-radius: 0.3rem;
}
.input-group.input-group-solid.input-group-lg {
  border-radius: 0.85rem;
}
.input-group.input-group-solid .input-group-text {
  background-color: var(--bs-gray-100);
  border-color: var(--bs-gray-100);
}
.input-group.input-group-solid .input-group-text + .form-control {
  border-left-color: var(--bs-gray-300);
}
.input-group.input-group-solid .form-control {
  background-color: var(--bs-gray-100);
  border-color: var(--bs-gray-100);
}
.input-group.input-group-solid .form-control + .input-group-text {
  border-left-color: var(--bs-gray-300);
}

.form-floating .form-control.form-control-solid::placeholder {
  color: transparent;
}
.form-floating.form-control-solid-bg label::after,
.form-floating > :disabled ~ label::after,
.form-floating > :focus ~ label::after {
  background-color: transparent !important;
}

.required:after {
  content: "*";
  position: relative;
  font-size: inherit;
  color: var(--bs-danger);
  padding-left: 0.25rem;
  font-weight: 600;
}

.progress-vertical {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}
.progress-vertical .progress {
  height: 100%;
  border-radius: 0.65rem;
  display: flex;
  align-items: flex-end;
  margin-right: 1rem;
}
.progress-vertical .progress:last-child {
  margin-right: 0;
}
.progress-vertical .progress .progress-bar {
  width: 8px;
  border-radius: 0.65rem;
}

.table:not(.table-bordered) > :not(:first-child) {
  border-color: transparent;
  border-width: 0;
  border-style: none;
}
.table:not(.table-bordered) > :not(:last-child) > :last-child > * {
  border-bottom-color: inherit;
}
.table:not(.table-bordered) tr, .table:not(.table-bordered) th, .table:not(.table-bordered) td {
  border-color: inherit;
  border-width: inherit;
  border-style: inherit;
  text-transform: inherit;
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
  height: inherit;
  min-height: inherit;
}
.table:not(.table-bordered) tr:first-child, .table:not(.table-bordered) th:first-child, .table:not(.table-bordered) td:first-child {
  padding-left: 0;
}
.table:not(.table-bordered) tr:last-child, .table:not(.table-bordered) th:last-child, .table:not(.table-bordered) td:last-child {
  padding-right: 0;
}
.table:not(.table-bordered) tfoot tr:last-child,
.table:not(.table-bordered) tbody tr:last-child {
  border-bottom: 0 !important;
}
.table:not(.table-bordered) tfoot tr:last-child th, .table:not(.table-bordered) tfoot tr:last-child td,
.table:not(.table-bordered) tbody tr:last-child th,
.table:not(.table-bordered) tbody tr:last-child td {
  border-bottom: 0 !important;
}
.table:not(.table-bordered) tfoot th, .table:not(.table-bordered) tfoot td {
  border-top: inherit;
}
.table:not(.table-bordered).table-rounded {
  border-radius: 0.65rem;
  border-spacing: 0;
  border-collapse: separate;
}
.table:not(.table-bordered).table-rows-rounded th:first-child, .table:not(.table-bordered).table-rows-rounded td:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.table:not(.table-bordered).table-rows-rounded th:last-child, .table:not(.table-bordered).table-rows-rounded td:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.table:not(.table-bordered).table-flush tr, .table:not(.table-bordered).table-flush th, .table:not(.table-bordered).table-flush td {
  padding: inherit;
}
.table:not(.table-bordered).table-row-bordered tr {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: var(--bs-border-color);
}
.table:not(.table-bordered).table-row-bordered tfoot th, .table:not(.table-bordered).table-row-bordered tfoot td {
  border-top-width: 1px !important;
}
.table:not(.table-bordered).table-row-dashed tr {
  border-bottom-width: 1px;
  border-bottom-style: dashed;
  border-bottom-color: var(--bs-border-color);
}
.table:not(.table-bordered).table-row-dashed tfoot th, .table:not(.table-bordered).table-row-dashed tfoot td {
  border-top-width: 1px !important;
}
.table:not(.table-bordered).table-row-gray-100 tr {
  border-bottom-color: var(--bs-gray-100);
}
.table:not(.table-bordered).table-row-gray-200 tr {
  border-bottom-color: var(--bs-gray-200);
}
.table:not(.table-bordered).table-row-gray-300 tr {
  border-bottom-color: var(--bs-gray-300);
}
.table:not(.table-bordered).table-row-gray-400 tr {
  border-bottom-color: var(--bs-gray-400);
}
.table:not(.table-bordered).table-row-gray-500 tr {
  border-bottom-color: var(--bs-gray-500);
}
.table:not(.table-bordered).table-row-gray-600 tr {
  border-bottom-color: var(--bs-gray-600);
}
.table:not(.table-bordered).table-row-gray-700 tr {
  border-bottom-color: var(--bs-gray-700);
}
.table:not(.table-bordered).table-row-gray-800 tr {
  border-bottom-color: var(--bs-gray-800);
}
.table:not(.table-bordered).table-row-gray-900 tr {
  border-bottom-color: var(--bs-gray-900);
}

.table-layout-fixed {
  table-layout: fixed;
}

.table-sort:after {
  opacity: 0;
}

.table-sort,
.table-sort-asc,
.table-sort-desc {
  vertical-align: middle;
}
.table-sort:after,
.table-sort-asc:after,
.table-sort-desc:after {
  position: relative;
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  content: " ";
  bottom: auto;
  right: auto;
  left: auto;
  margin-left: 0.5rem;
}

.table-sort-asc:after {
  opacity: 1;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
}

.table-sort-desc:after {
  opacity: 1;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-text-muted);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
}

.table-loading-message {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 0.65rem;
  box-shadow: var(--bs-table-loading-message-box-shadow);
  background-color: var(--bs-body-bg);
  color: var(--bs-gray-700);
  font-weight: 600;
  margin: 0 !important;
  width: auto;
  padding: 0.85rem 2rem !important;
  transform: translateX(-50%) translateY(-50%);
}

.table-loading {
  position: relative;
}
.table-loading .table-loading-message {
  display: block;
}

.table.g-0 th, .table.g-0 td {
  padding: 0rem;
}
.table.g-0 th.dtr-control, .table.g-0 td.dtr-control {
  padding-left: 0rem !important;
}

.table.gy-0 th, .table.gy-0 td {
  padding-top: 0rem;
  padding-bottom: 0rem;
}

.table.gx-0 th, .table.gx-0 td {
  padding-left: 0rem;
  padding-right: 0rem;
}
.table.gx-0 th.dtr-control, .table.gx-0 td.dtr-control {
  padding-left: 0rem !important;
}

.table.gs-0 th:first-child, .table.gs-0 td:first-child {
  padding-left: 0rem;
}
.table.gs-0 th:last-child, .table.gs-0 td:last-child {
  padding-right: 0rem;
}
.table.gs-0 th.dtr-control:first-child, .table.gs-0 td.dtr-control:first-child {
  padding-left: 0rem !important;
}

.table.g-1 th, .table.g-1 td {
  padding: 0.25rem;
}
.table.g-1 th.dtr-control, .table.g-1 td.dtr-control {
  padding-left: 0.25rem !important;
}

.table.gy-1 th, .table.gy-1 td {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.table.gx-1 th, .table.gx-1 td {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.table.gx-1 th.dtr-control, .table.gx-1 td.dtr-control {
  padding-left: 0.25rem !important;
}

.table.gs-1 th:first-child, .table.gs-1 td:first-child {
  padding-left: 0.25rem;
}
.table.gs-1 th:last-child, .table.gs-1 td:last-child {
  padding-right: 0.25rem;
}
.table.gs-1 th.dtr-control:first-child, .table.gs-1 td.dtr-control:first-child {
  padding-left: 0.25rem !important;
}

.table.g-2 th, .table.g-2 td {
  padding: 0.5rem;
}
.table.g-2 th.dtr-control, .table.g-2 td.dtr-control {
  padding-left: 0.5rem !important;
}

.table.gy-2 th, .table.gy-2 td {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.table.gx-2 th, .table.gx-2 td {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.table.gx-2 th.dtr-control, .table.gx-2 td.dtr-control {
  padding-left: 0.5rem !important;
}

.table.gs-2 th:first-child, .table.gs-2 td:first-child {
  padding-left: 0.5rem;
}
.table.gs-2 th:last-child, .table.gs-2 td:last-child {
  padding-right: 0.5rem;
}
.table.gs-2 th.dtr-control:first-child, .table.gs-2 td.dtr-control:first-child {
  padding-left: 0.5rem !important;
}

.table.g-3 th, .table.g-3 td {
  padding: 0.75rem;
}
.table.g-3 th.dtr-control, .table.g-3 td.dtr-control {
  padding-left: 0.75rem !important;
}

.table.gy-3 th, .table.gy-3 td {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.table.gx-3 th, .table.gx-3 td {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.table.gx-3 th.dtr-control, .table.gx-3 td.dtr-control {
  padding-left: 0.75rem !important;
}

.table.gs-3 th:first-child, .table.gs-3 td:first-child {
  padding-left: 0.75rem;
}
.table.gs-3 th:last-child, .table.gs-3 td:last-child {
  padding-right: 0.75rem;
}
.table.gs-3 th.dtr-control:first-child, .table.gs-3 td.dtr-control:first-child {
  padding-left: 0.75rem !important;
}

.table.g-4 th, .table.g-4 td {
  padding: 1rem;
}
.table.g-4 th.dtr-control, .table.g-4 td.dtr-control {
  padding-left: 1rem !important;
}

.table.gy-4 th, .table.gy-4 td {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.table.gx-4 th, .table.gx-4 td {
  padding-left: 1rem;
  padding-right: 1rem;
}
.table.gx-4 th.dtr-control, .table.gx-4 td.dtr-control {
  padding-left: 1rem !important;
}

.table.gs-4 th:first-child, .table.gs-4 td:first-child {
  padding-left: 1rem;
}
.table.gs-4 th:last-child, .table.gs-4 td:last-child {
  padding-right: 1rem;
}
.table.gs-4 th.dtr-control:first-child, .table.gs-4 td.dtr-control:first-child {
  padding-left: 1rem !important;
}

.table.g-5 th, .table.g-5 td {
  padding: 1.25rem;
}
.table.g-5 th.dtr-control, .table.g-5 td.dtr-control {
  padding-left: 1.25rem !important;
}

.table.gy-5 th, .table.gy-5 td {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.table.gx-5 th, .table.gx-5 td {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.table.gx-5 th.dtr-control, .table.gx-5 td.dtr-control {
  padding-left: 1.25rem !important;
}

.table.gs-5 th:first-child, .table.gs-5 td:first-child {
  padding-left: 1.25rem;
}
.table.gs-5 th:last-child, .table.gs-5 td:last-child {
  padding-right: 1.25rem;
}
.table.gs-5 th.dtr-control:first-child, .table.gs-5 td.dtr-control:first-child {
  padding-left: 1.25rem !important;
}

.table.g-6 th, .table.g-6 td {
  padding: 1.5rem;
}
.table.g-6 th.dtr-control, .table.g-6 td.dtr-control {
  padding-left: 1.5rem !important;
}

.table.gy-6 th, .table.gy-6 td {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.table.gx-6 th, .table.gx-6 td {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.table.gx-6 th.dtr-control, .table.gx-6 td.dtr-control {
  padding-left: 1.5rem !important;
}

.table.gs-6 th:first-child, .table.gs-6 td:first-child {
  padding-left: 1.5rem;
}
.table.gs-6 th:last-child, .table.gs-6 td:last-child {
  padding-right: 1.5rem;
}
.table.gs-6 th.dtr-control:first-child, .table.gs-6 td.dtr-control:first-child {
  padding-left: 1.5rem !important;
}

.table.g-7 th, .table.g-7 td {
  padding: 1.75rem;
}
.table.g-7 th.dtr-control, .table.g-7 td.dtr-control {
  padding-left: 1.75rem !important;
}

.table.gy-7 th, .table.gy-7 td {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.table.gx-7 th, .table.gx-7 td {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.table.gx-7 th.dtr-control, .table.gx-7 td.dtr-control {
  padding-left: 1.75rem !important;
}

.table.gs-7 th:first-child, .table.gs-7 td:first-child {
  padding-left: 1.75rem;
}
.table.gs-7 th:last-child, .table.gs-7 td:last-child {
  padding-right: 1.75rem;
}
.table.gs-7 th.dtr-control:first-child, .table.gs-7 td.dtr-control:first-child {
  padding-left: 1.75rem !important;
}

.table.g-8 th, .table.g-8 td {
  padding: 2rem;
}
.table.g-8 th.dtr-control, .table.g-8 td.dtr-control {
  padding-left: 2rem !important;
}

.table.gy-8 th, .table.gy-8 td {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.table.gx-8 th, .table.gx-8 td {
  padding-left: 2rem;
  padding-right: 2rem;
}
.table.gx-8 th.dtr-control, .table.gx-8 td.dtr-control {
  padding-left: 2rem !important;
}

.table.gs-8 th:first-child, .table.gs-8 td:first-child {
  padding-left: 2rem;
}
.table.gs-8 th:last-child, .table.gs-8 td:last-child {
  padding-right: 2rem;
}
.table.gs-8 th.dtr-control:first-child, .table.gs-8 td.dtr-control:first-child {
  padding-left: 2rem !important;
}

.table.g-9 th, .table.g-9 td {
  padding: 2.25rem;
}
.table.g-9 th.dtr-control, .table.g-9 td.dtr-control {
  padding-left: 2.25rem !important;
}

.table.gy-9 th, .table.gy-9 td {
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}

.table.gx-9 th, .table.gx-9 td {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.table.gx-9 th.dtr-control, .table.gx-9 td.dtr-control {
  padding-left: 2.25rem !important;
}

.table.gs-9 th:first-child, .table.gs-9 td:first-child {
  padding-left: 2.25rem;
}
.table.gs-9 th:last-child, .table.gs-9 td:last-child {
  padding-right: 2.25rem;
}
.table.gs-9 th.dtr-control:first-child, .table.gs-9 td.dtr-control:first-child {
  padding-left: 2.25rem !important;
}

.table.g-10 th, .table.g-10 td {
  padding: 2.5rem;
}
.table.g-10 th.dtr-control, .table.g-10 td.dtr-control {
  padding-left: 2.5rem !important;
}

.table.gy-10 th, .table.gy-10 td {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.table.gx-10 th, .table.gx-10 td {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.table.gx-10 th.dtr-control, .table.gx-10 td.dtr-control {
  padding-left: 2.5rem !important;
}

.table.gs-10 th:first-child, .table.gs-10 td:first-child {
  padding-left: 2.5rem;
}
.table.gs-10 th:last-child, .table.gs-10 td:last-child {
  padding-right: 2.5rem;
}
.table.gs-10 th.dtr-control:first-child, .table.gs-10 td.dtr-control:first-child {
  padding-left: 2.5rem !important;
}

@media (min-width: 576px) {
  .table.g-sm-0 th, .table.g-sm-0 td {
    padding: 0rem;
  }
  .table.g-sm-0 th.dtr-control, .table.g-sm-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-sm-0 th, .table.gy-sm-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-sm-0 th, .table.gx-sm-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-sm-0 th.dtr-control, .table.gx-sm-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-sm-0 th:first-child, .table.gs-sm-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-sm-0 th:last-child, .table.gs-sm-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-sm-0 th.dtr-control:first-child, .table.gs-sm-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-sm-1 th, .table.g-sm-1 td {
    padding: 0.25rem;
  }
  .table.g-sm-1 th.dtr-control, .table.g-sm-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-sm-1 th, .table.gy-sm-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-sm-1 th, .table.gx-sm-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-sm-1 th.dtr-control, .table.gx-sm-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-sm-1 th:first-child, .table.gs-sm-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-sm-1 th:last-child, .table.gs-sm-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-sm-1 th.dtr-control:first-child, .table.gs-sm-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-sm-2 th, .table.g-sm-2 td {
    padding: 0.5rem;
  }
  .table.g-sm-2 th.dtr-control, .table.g-sm-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-sm-2 th, .table.gy-sm-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-sm-2 th, .table.gx-sm-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-sm-2 th.dtr-control, .table.gx-sm-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-sm-2 th:first-child, .table.gs-sm-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-sm-2 th:last-child, .table.gs-sm-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-sm-2 th.dtr-control:first-child, .table.gs-sm-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-sm-3 th, .table.g-sm-3 td {
    padding: 0.75rem;
  }
  .table.g-sm-3 th.dtr-control, .table.g-sm-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-sm-3 th, .table.gy-sm-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-sm-3 th, .table.gx-sm-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-sm-3 th.dtr-control, .table.gx-sm-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-sm-3 th:first-child, .table.gs-sm-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-sm-3 th:last-child, .table.gs-sm-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-sm-3 th.dtr-control:first-child, .table.gs-sm-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-sm-4 th, .table.g-sm-4 td {
    padding: 1rem;
  }
  .table.g-sm-4 th.dtr-control, .table.g-sm-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-sm-4 th, .table.gy-sm-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-sm-4 th, .table.gx-sm-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-sm-4 th.dtr-control, .table.gx-sm-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-sm-4 th:first-child, .table.gs-sm-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-sm-4 th:last-child, .table.gs-sm-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-sm-4 th.dtr-control:first-child, .table.gs-sm-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-sm-5 th, .table.g-sm-5 td {
    padding: 1.25rem;
  }
  .table.g-sm-5 th.dtr-control, .table.g-sm-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-sm-5 th, .table.gy-sm-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-sm-5 th, .table.gx-sm-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-sm-5 th.dtr-control, .table.gx-sm-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-sm-5 th:first-child, .table.gs-sm-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-sm-5 th:last-child, .table.gs-sm-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-sm-5 th.dtr-control:first-child, .table.gs-sm-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-sm-6 th, .table.g-sm-6 td {
    padding: 1.5rem;
  }
  .table.g-sm-6 th.dtr-control, .table.g-sm-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-sm-6 th, .table.gy-sm-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-sm-6 th, .table.gx-sm-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-sm-6 th.dtr-control, .table.gx-sm-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-sm-6 th:first-child, .table.gs-sm-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-sm-6 th:last-child, .table.gs-sm-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-sm-6 th.dtr-control:first-child, .table.gs-sm-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-sm-7 th, .table.g-sm-7 td {
    padding: 1.75rem;
  }
  .table.g-sm-7 th.dtr-control, .table.g-sm-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-sm-7 th, .table.gy-sm-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-sm-7 th, .table.gx-sm-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-sm-7 th.dtr-control, .table.gx-sm-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-sm-7 th:first-child, .table.gs-sm-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-sm-7 th:last-child, .table.gs-sm-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-sm-7 th.dtr-control:first-child, .table.gs-sm-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-sm-8 th, .table.g-sm-8 td {
    padding: 2rem;
  }
  .table.g-sm-8 th.dtr-control, .table.g-sm-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-sm-8 th, .table.gy-sm-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-sm-8 th, .table.gx-sm-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-sm-8 th.dtr-control, .table.gx-sm-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-sm-8 th:first-child, .table.gs-sm-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-sm-8 th:last-child, .table.gs-sm-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-sm-8 th.dtr-control:first-child, .table.gs-sm-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-sm-9 th, .table.g-sm-9 td {
    padding: 2.25rem;
  }
  .table.g-sm-9 th.dtr-control, .table.g-sm-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-sm-9 th, .table.gy-sm-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-sm-9 th, .table.gx-sm-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-sm-9 th.dtr-control, .table.gx-sm-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-sm-9 th:first-child, .table.gs-sm-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-sm-9 th:last-child, .table.gs-sm-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-sm-9 th.dtr-control:first-child, .table.gs-sm-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-sm-10 th, .table.g-sm-10 td {
    padding: 2.5rem;
  }
  .table.g-sm-10 th.dtr-control, .table.g-sm-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-sm-10 th, .table.gy-sm-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-sm-10 th, .table.gx-sm-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-sm-10 th.dtr-control, .table.gx-sm-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-sm-10 th:first-child, .table.gs-sm-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-sm-10 th:last-child, .table.gs-sm-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-sm-10 th.dtr-control:first-child, .table.gs-sm-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 768px) {
  .table.g-md-0 th, .table.g-md-0 td {
    padding: 0rem;
  }
  .table.g-md-0 th.dtr-control, .table.g-md-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-md-0 th, .table.gy-md-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-md-0 th, .table.gx-md-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-md-0 th.dtr-control, .table.gx-md-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-md-0 th:first-child, .table.gs-md-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-md-0 th:last-child, .table.gs-md-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-md-0 th.dtr-control:first-child, .table.gs-md-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-md-1 th, .table.g-md-1 td {
    padding: 0.25rem;
  }
  .table.g-md-1 th.dtr-control, .table.g-md-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-md-1 th, .table.gy-md-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-md-1 th, .table.gx-md-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-md-1 th.dtr-control, .table.gx-md-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-md-1 th:first-child, .table.gs-md-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-md-1 th:last-child, .table.gs-md-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-md-1 th.dtr-control:first-child, .table.gs-md-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-md-2 th, .table.g-md-2 td {
    padding: 0.5rem;
  }
  .table.g-md-2 th.dtr-control, .table.g-md-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-md-2 th, .table.gy-md-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-md-2 th, .table.gx-md-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-md-2 th.dtr-control, .table.gx-md-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-md-2 th:first-child, .table.gs-md-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-md-2 th:last-child, .table.gs-md-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-md-2 th.dtr-control:first-child, .table.gs-md-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-md-3 th, .table.g-md-3 td {
    padding: 0.75rem;
  }
  .table.g-md-3 th.dtr-control, .table.g-md-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-md-3 th, .table.gy-md-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-md-3 th, .table.gx-md-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-md-3 th.dtr-control, .table.gx-md-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-md-3 th:first-child, .table.gs-md-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-md-3 th:last-child, .table.gs-md-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-md-3 th.dtr-control:first-child, .table.gs-md-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-md-4 th, .table.g-md-4 td {
    padding: 1rem;
  }
  .table.g-md-4 th.dtr-control, .table.g-md-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-md-4 th, .table.gy-md-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-md-4 th, .table.gx-md-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-md-4 th.dtr-control, .table.gx-md-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-md-4 th:first-child, .table.gs-md-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-md-4 th:last-child, .table.gs-md-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-md-4 th.dtr-control:first-child, .table.gs-md-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-md-5 th, .table.g-md-5 td {
    padding: 1.25rem;
  }
  .table.g-md-5 th.dtr-control, .table.g-md-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-md-5 th, .table.gy-md-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-md-5 th, .table.gx-md-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-md-5 th.dtr-control, .table.gx-md-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-md-5 th:first-child, .table.gs-md-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-md-5 th:last-child, .table.gs-md-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-md-5 th.dtr-control:first-child, .table.gs-md-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-md-6 th, .table.g-md-6 td {
    padding: 1.5rem;
  }
  .table.g-md-6 th.dtr-control, .table.g-md-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-md-6 th, .table.gy-md-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-md-6 th, .table.gx-md-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-md-6 th.dtr-control, .table.gx-md-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-md-6 th:first-child, .table.gs-md-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-md-6 th:last-child, .table.gs-md-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-md-6 th.dtr-control:first-child, .table.gs-md-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-md-7 th, .table.g-md-7 td {
    padding: 1.75rem;
  }
  .table.g-md-7 th.dtr-control, .table.g-md-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-md-7 th, .table.gy-md-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-md-7 th, .table.gx-md-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-md-7 th.dtr-control, .table.gx-md-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-md-7 th:first-child, .table.gs-md-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-md-7 th:last-child, .table.gs-md-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-md-7 th.dtr-control:first-child, .table.gs-md-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-md-8 th, .table.g-md-8 td {
    padding: 2rem;
  }
  .table.g-md-8 th.dtr-control, .table.g-md-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-md-8 th, .table.gy-md-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-md-8 th, .table.gx-md-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-md-8 th.dtr-control, .table.gx-md-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-md-8 th:first-child, .table.gs-md-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-md-8 th:last-child, .table.gs-md-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-md-8 th.dtr-control:first-child, .table.gs-md-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-md-9 th, .table.g-md-9 td {
    padding: 2.25rem;
  }
  .table.g-md-9 th.dtr-control, .table.g-md-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-md-9 th, .table.gy-md-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-md-9 th, .table.gx-md-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-md-9 th.dtr-control, .table.gx-md-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-md-9 th:first-child, .table.gs-md-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-md-9 th:last-child, .table.gs-md-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-md-9 th.dtr-control:first-child, .table.gs-md-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-md-10 th, .table.g-md-10 td {
    padding: 2.5rem;
  }
  .table.g-md-10 th.dtr-control, .table.g-md-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-md-10 th, .table.gy-md-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-md-10 th, .table.gx-md-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-md-10 th.dtr-control, .table.gx-md-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-md-10 th:first-child, .table.gs-md-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-md-10 th:last-child, .table.gs-md-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-md-10 th.dtr-control:first-child, .table.gs-md-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 992px) {
  .table.g-lg-0 th, .table.g-lg-0 td {
    padding: 0rem;
  }
  .table.g-lg-0 th.dtr-control, .table.g-lg-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-lg-0 th, .table.gy-lg-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-lg-0 th, .table.gx-lg-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-lg-0 th.dtr-control, .table.gx-lg-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-lg-0 th:first-child, .table.gs-lg-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-lg-0 th:last-child, .table.gs-lg-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-lg-0 th.dtr-control:first-child, .table.gs-lg-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-lg-1 th, .table.g-lg-1 td {
    padding: 0.25rem;
  }
  .table.g-lg-1 th.dtr-control, .table.g-lg-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-lg-1 th, .table.gy-lg-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-lg-1 th, .table.gx-lg-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-lg-1 th.dtr-control, .table.gx-lg-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-lg-1 th:first-child, .table.gs-lg-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-lg-1 th:last-child, .table.gs-lg-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-lg-1 th.dtr-control:first-child, .table.gs-lg-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-lg-2 th, .table.g-lg-2 td {
    padding: 0.5rem;
  }
  .table.g-lg-2 th.dtr-control, .table.g-lg-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-lg-2 th, .table.gy-lg-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-lg-2 th, .table.gx-lg-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-lg-2 th.dtr-control, .table.gx-lg-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-lg-2 th:first-child, .table.gs-lg-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-lg-2 th:last-child, .table.gs-lg-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-lg-2 th.dtr-control:first-child, .table.gs-lg-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-lg-3 th, .table.g-lg-3 td {
    padding: 0.75rem;
  }
  .table.g-lg-3 th.dtr-control, .table.g-lg-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-lg-3 th, .table.gy-lg-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-lg-3 th, .table.gx-lg-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-lg-3 th.dtr-control, .table.gx-lg-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-lg-3 th:first-child, .table.gs-lg-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-lg-3 th:last-child, .table.gs-lg-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-lg-3 th.dtr-control:first-child, .table.gs-lg-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-lg-4 th, .table.g-lg-4 td {
    padding: 1rem;
  }
  .table.g-lg-4 th.dtr-control, .table.g-lg-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-lg-4 th, .table.gy-lg-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-lg-4 th, .table.gx-lg-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-lg-4 th.dtr-control, .table.gx-lg-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-lg-4 th:first-child, .table.gs-lg-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-lg-4 th:last-child, .table.gs-lg-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-lg-4 th.dtr-control:first-child, .table.gs-lg-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-lg-5 th, .table.g-lg-5 td {
    padding: 1.25rem;
  }
  .table.g-lg-5 th.dtr-control, .table.g-lg-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-lg-5 th, .table.gy-lg-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-lg-5 th, .table.gx-lg-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-lg-5 th.dtr-control, .table.gx-lg-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-lg-5 th:first-child, .table.gs-lg-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-lg-5 th:last-child, .table.gs-lg-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-lg-5 th.dtr-control:first-child, .table.gs-lg-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-lg-6 th, .table.g-lg-6 td {
    padding: 1.5rem;
  }
  .table.g-lg-6 th.dtr-control, .table.g-lg-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-lg-6 th, .table.gy-lg-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-lg-6 th, .table.gx-lg-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-lg-6 th.dtr-control, .table.gx-lg-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-lg-6 th:first-child, .table.gs-lg-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-lg-6 th:last-child, .table.gs-lg-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-lg-6 th.dtr-control:first-child, .table.gs-lg-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-lg-7 th, .table.g-lg-7 td {
    padding: 1.75rem;
  }
  .table.g-lg-7 th.dtr-control, .table.g-lg-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-lg-7 th, .table.gy-lg-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-lg-7 th, .table.gx-lg-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-lg-7 th.dtr-control, .table.gx-lg-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-lg-7 th:first-child, .table.gs-lg-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-lg-7 th:last-child, .table.gs-lg-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-lg-7 th.dtr-control:first-child, .table.gs-lg-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-lg-8 th, .table.g-lg-8 td {
    padding: 2rem;
  }
  .table.g-lg-8 th.dtr-control, .table.g-lg-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-lg-8 th, .table.gy-lg-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-lg-8 th, .table.gx-lg-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-lg-8 th.dtr-control, .table.gx-lg-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-lg-8 th:first-child, .table.gs-lg-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-lg-8 th:last-child, .table.gs-lg-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-lg-8 th.dtr-control:first-child, .table.gs-lg-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-lg-9 th, .table.g-lg-9 td {
    padding: 2.25rem;
  }
  .table.g-lg-9 th.dtr-control, .table.g-lg-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-lg-9 th, .table.gy-lg-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-lg-9 th, .table.gx-lg-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-lg-9 th.dtr-control, .table.gx-lg-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-lg-9 th:first-child, .table.gs-lg-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-lg-9 th:last-child, .table.gs-lg-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-lg-9 th.dtr-control:first-child, .table.gs-lg-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-lg-10 th, .table.g-lg-10 td {
    padding: 2.5rem;
  }
  .table.g-lg-10 th.dtr-control, .table.g-lg-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-lg-10 th, .table.gy-lg-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-lg-10 th, .table.gx-lg-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-lg-10 th.dtr-control, .table.gx-lg-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-lg-10 th:first-child, .table.gs-lg-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-lg-10 th:last-child, .table.gs-lg-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-lg-10 th.dtr-control:first-child, .table.gs-lg-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 1200px) {
  .table.g-xl-0 th, .table.g-xl-0 td {
    padding: 0rem;
  }
  .table.g-xl-0 th.dtr-control, .table.g-xl-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-xl-0 th, .table.gy-xl-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-xl-0 th, .table.gx-xl-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-xl-0 th.dtr-control, .table.gx-xl-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-xl-0 th:first-child, .table.gs-xl-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-xl-0 th:last-child, .table.gs-xl-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-xl-0 th.dtr-control:first-child, .table.gs-xl-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-xl-1 th, .table.g-xl-1 td {
    padding: 0.25rem;
  }
  .table.g-xl-1 th.dtr-control, .table.g-xl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-xl-1 th, .table.gy-xl-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-xl-1 th, .table.gx-xl-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-xl-1 th.dtr-control, .table.gx-xl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-xl-1 th:first-child, .table.gs-xl-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-xl-1 th:last-child, .table.gs-xl-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-xl-1 th.dtr-control:first-child, .table.gs-xl-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-xl-2 th, .table.g-xl-2 td {
    padding: 0.5rem;
  }
  .table.g-xl-2 th.dtr-control, .table.g-xl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-xl-2 th, .table.gy-xl-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-xl-2 th, .table.gx-xl-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-xl-2 th.dtr-control, .table.gx-xl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-xl-2 th:first-child, .table.gs-xl-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-xl-2 th:last-child, .table.gs-xl-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-xl-2 th.dtr-control:first-child, .table.gs-xl-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-xl-3 th, .table.g-xl-3 td {
    padding: 0.75rem;
  }
  .table.g-xl-3 th.dtr-control, .table.g-xl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-xl-3 th, .table.gy-xl-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-xl-3 th, .table.gx-xl-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-xl-3 th.dtr-control, .table.gx-xl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-xl-3 th:first-child, .table.gs-xl-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-xl-3 th:last-child, .table.gs-xl-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-xl-3 th.dtr-control:first-child, .table.gs-xl-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-xl-4 th, .table.g-xl-4 td {
    padding: 1rem;
  }
  .table.g-xl-4 th.dtr-control, .table.g-xl-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-xl-4 th, .table.gy-xl-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-xl-4 th, .table.gx-xl-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-xl-4 th.dtr-control, .table.gx-xl-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-xl-4 th:first-child, .table.gs-xl-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-xl-4 th:last-child, .table.gs-xl-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-xl-4 th.dtr-control:first-child, .table.gs-xl-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-xl-5 th, .table.g-xl-5 td {
    padding: 1.25rem;
  }
  .table.g-xl-5 th.dtr-control, .table.g-xl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-xl-5 th, .table.gy-xl-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-xl-5 th, .table.gx-xl-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-xl-5 th.dtr-control, .table.gx-xl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-xl-5 th:first-child, .table.gs-xl-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-xl-5 th:last-child, .table.gs-xl-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-xl-5 th.dtr-control:first-child, .table.gs-xl-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-xl-6 th, .table.g-xl-6 td {
    padding: 1.5rem;
  }
  .table.g-xl-6 th.dtr-control, .table.g-xl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-xl-6 th, .table.gy-xl-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-xl-6 th, .table.gx-xl-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-xl-6 th.dtr-control, .table.gx-xl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-xl-6 th:first-child, .table.gs-xl-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-xl-6 th:last-child, .table.gs-xl-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-xl-6 th.dtr-control:first-child, .table.gs-xl-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-xl-7 th, .table.g-xl-7 td {
    padding: 1.75rem;
  }
  .table.g-xl-7 th.dtr-control, .table.g-xl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-xl-7 th, .table.gy-xl-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-xl-7 th, .table.gx-xl-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-xl-7 th.dtr-control, .table.gx-xl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-xl-7 th:first-child, .table.gs-xl-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-xl-7 th:last-child, .table.gs-xl-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-xl-7 th.dtr-control:first-child, .table.gs-xl-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-xl-8 th, .table.g-xl-8 td {
    padding: 2rem;
  }
  .table.g-xl-8 th.dtr-control, .table.g-xl-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-xl-8 th, .table.gy-xl-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-xl-8 th, .table.gx-xl-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-xl-8 th.dtr-control, .table.gx-xl-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-xl-8 th:first-child, .table.gs-xl-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-xl-8 th:last-child, .table.gs-xl-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-xl-8 th.dtr-control:first-child, .table.gs-xl-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-xl-9 th, .table.g-xl-9 td {
    padding: 2.25rem;
  }
  .table.g-xl-9 th.dtr-control, .table.g-xl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-xl-9 th, .table.gy-xl-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-xl-9 th, .table.gx-xl-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-xl-9 th.dtr-control, .table.gx-xl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-xl-9 th:first-child, .table.gs-xl-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-xl-9 th:last-child, .table.gs-xl-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-xl-9 th.dtr-control:first-child, .table.gs-xl-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-xl-10 th, .table.g-xl-10 td {
    padding: 2.5rem;
  }
  .table.g-xl-10 th.dtr-control, .table.g-xl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-xl-10 th, .table.gy-xl-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-xl-10 th, .table.gx-xl-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-xl-10 th.dtr-control, .table.gx-xl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-xl-10 th:first-child, .table.gs-xl-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-xl-10 th:last-child, .table.gs-xl-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-xl-10 th.dtr-control:first-child, .table.gs-xl-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 1400px) {
  .table.g-xxl-0 th, .table.g-xxl-0 td {
    padding: 0rem;
  }
  .table.g-xxl-0 th.dtr-control, .table.g-xxl-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gy-xxl-0 th, .table.gy-xxl-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }
  .table.gx-xxl-0 th, .table.gx-xxl-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-xxl-0 th.dtr-control, .table.gx-xxl-0 td.dtr-control {
    padding-left: 0rem !important;
  }
  .table.gs-xxl-0 th:first-child, .table.gs-xxl-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-xxl-0 th:last-child, .table.gs-xxl-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-xxl-0 th.dtr-control:first-child, .table.gs-xxl-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }
  .table.g-xxl-1 th, .table.g-xxl-1 td {
    padding: 0.25rem;
  }
  .table.g-xxl-1 th.dtr-control, .table.g-xxl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gy-xxl-1 th, .table.gy-xxl-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .table.gx-xxl-1 th, .table.gx-xxl-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-xxl-1 th.dtr-control, .table.gx-xxl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }
  .table.gs-xxl-1 th:first-child, .table.gs-xxl-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-xxl-1 th:last-child, .table.gs-xxl-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-xxl-1 th.dtr-control:first-child, .table.gs-xxl-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }
  .table.g-xxl-2 th, .table.g-xxl-2 td {
    padding: 0.5rem;
  }
  .table.g-xxl-2 th.dtr-control, .table.g-xxl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gy-xxl-2 th, .table.gy-xxl-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .table.gx-xxl-2 th, .table.gx-xxl-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-xxl-2 th.dtr-control, .table.gx-xxl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }
  .table.gs-xxl-2 th:first-child, .table.gs-xxl-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-xxl-2 th:last-child, .table.gs-xxl-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-xxl-2 th.dtr-control:first-child, .table.gs-xxl-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }
  .table.g-xxl-3 th, .table.g-xxl-3 td {
    padding: 0.75rem;
  }
  .table.g-xxl-3 th.dtr-control, .table.g-xxl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gy-xxl-3 th, .table.gy-xxl-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .table.gx-xxl-3 th, .table.gx-xxl-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-xxl-3 th.dtr-control, .table.gx-xxl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }
  .table.gs-xxl-3 th:first-child, .table.gs-xxl-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-xxl-3 th:last-child, .table.gs-xxl-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-xxl-3 th.dtr-control:first-child, .table.gs-xxl-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }
  .table.g-xxl-4 th, .table.g-xxl-4 td {
    padding: 1rem;
  }
  .table.g-xxl-4 th.dtr-control, .table.g-xxl-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gy-xxl-4 th, .table.gy-xxl-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .table.gx-xxl-4 th, .table.gx-xxl-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-xxl-4 th.dtr-control, .table.gx-xxl-4 td.dtr-control {
    padding-left: 1rem !important;
  }
  .table.gs-xxl-4 th:first-child, .table.gs-xxl-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-xxl-4 th:last-child, .table.gs-xxl-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-xxl-4 th.dtr-control:first-child, .table.gs-xxl-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }
  .table.g-xxl-5 th, .table.g-xxl-5 td {
    padding: 1.25rem;
  }
  .table.g-xxl-5 th.dtr-control, .table.g-xxl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gy-xxl-5 th, .table.gy-xxl-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .table.gx-xxl-5 th, .table.gx-xxl-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-xxl-5 th.dtr-control, .table.gx-xxl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }
  .table.gs-xxl-5 th:first-child, .table.gs-xxl-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-xxl-5 th:last-child, .table.gs-xxl-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-xxl-5 th.dtr-control:first-child, .table.gs-xxl-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }
  .table.g-xxl-6 th, .table.g-xxl-6 td {
    padding: 1.5rem;
  }
  .table.g-xxl-6 th.dtr-control, .table.g-xxl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gy-xxl-6 th, .table.gy-xxl-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .table.gx-xxl-6 th, .table.gx-xxl-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-xxl-6 th.dtr-control, .table.gx-xxl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }
  .table.gs-xxl-6 th:first-child, .table.gs-xxl-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-xxl-6 th:last-child, .table.gs-xxl-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-xxl-6 th.dtr-control:first-child, .table.gs-xxl-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }
  .table.g-xxl-7 th, .table.g-xxl-7 td {
    padding: 1.75rem;
  }
  .table.g-xxl-7 th.dtr-control, .table.g-xxl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gy-xxl-7 th, .table.gy-xxl-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .table.gx-xxl-7 th, .table.gx-xxl-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-xxl-7 th.dtr-control, .table.gx-xxl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }
  .table.gs-xxl-7 th:first-child, .table.gs-xxl-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-xxl-7 th:last-child, .table.gs-xxl-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-xxl-7 th.dtr-control:first-child, .table.gs-xxl-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }
  .table.g-xxl-8 th, .table.g-xxl-8 td {
    padding: 2rem;
  }
  .table.g-xxl-8 th.dtr-control, .table.g-xxl-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gy-xxl-8 th, .table.gy-xxl-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .table.gx-xxl-8 th, .table.gx-xxl-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-xxl-8 th.dtr-control, .table.gx-xxl-8 td.dtr-control {
    padding-left: 2rem !important;
  }
  .table.gs-xxl-8 th:first-child, .table.gs-xxl-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-xxl-8 th:last-child, .table.gs-xxl-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-xxl-8 th.dtr-control:first-child, .table.gs-xxl-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }
  .table.g-xxl-9 th, .table.g-xxl-9 td {
    padding: 2.25rem;
  }
  .table.g-xxl-9 th.dtr-control, .table.g-xxl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gy-xxl-9 th, .table.gy-xxl-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }
  .table.gx-xxl-9 th, .table.gx-xxl-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-xxl-9 th.dtr-control, .table.gx-xxl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }
  .table.gs-xxl-9 th:first-child, .table.gs-xxl-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-xxl-9 th:last-child, .table.gs-xxl-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-xxl-9 th.dtr-control:first-child, .table.gs-xxl-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }
  .table.g-xxl-10 th, .table.g-xxl-10 td {
    padding: 2.5rem;
  }
  .table.g-xxl-10 th.dtr-control, .table.g-xxl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gy-xxl-10 th, .table.gy-xxl-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .table.gx-xxl-10 th, .table.gx-xxl-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-xxl-10 th.dtr-control, .table.gx-xxl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }
  .table.gs-xxl-10 th:first-child, .table.gs-xxl-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-xxl-10 th:last-child, .table.gs-xxl-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-xxl-10 th.dtr-control:first-child, .table.gs-xxl-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
.popover {
  --bs-popover-header-border-color: #F1F1F4;
}
.popover .popover-header {
  font-size: 1rem;
  font-weight: 500;
  border-bottom: 1px solid var(--bs-popover-header-border-color);
}
.popover .popover-dismiss {
  position: absolute;
  top: 0.85rem;
  right: 0.85rem;
  height: 1.25rem;
  width: 1.25rem;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-500);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
  mask-size: 50%;
  -webkit-mask-size: 50%;
}
.popover .popover-dismiss:hover {
  background-color: var(--bs-primary);
}
.popover .popover-dismiss + .popover-header {
  padding-right: 2.5rem;
}

.popover-inverse {
  --bs-popover-bg: var(--bs-gray-900);
  --bs-popover-border-color: var(--bs-gray-900);
  --bs-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-popover-header-color: var(--bs-gray-200);
  --bs-popover-header-bg: var(--bs-gray-900);
  --bs-popover-body-color: var(--bs-gray-400);
  --bs-popover-arrow-border: transparent;
  --bs-popover-header-border-color: var(--bs-gray-800);
}

[data-bs-theme=dark] .popover:not(.popover-inverse) {
  --bs-popover-bg: #26272F;
  --bs-popover-border-color: #26272F;
  --bs-popover-header-bg: #26272F;
  --bs-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --bs-popover-header-border-color: #363843;
}

.tooltip .tooltip-inner {
  box-shadow: var(--bs-tooltip-box-shadow);
}
.tooltip.tooltop-auto-width .tooltip-inner {
  white-space: nowrap;
  max-width: none;
}
.tooltip.tooltip-inverse {
  --bs-tooltip-color: var(--bs-dark-inverse);
  --bs-tooltip-bg: var(--bs-dark);
}

[data-bs-theme=dark] .tooltip:not(.tooltip-inverse) {
  --bs-tooltip-bg: #26272F;
  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
}

.accordion .accordion-header {
  cursor: pointer;
}
.accordion.accordion-icon-toggle .accordion-icon {
  display: flex;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;
  transform: rotate(90deg);
  align-items: center;
  justify-content: center;
}
.accordion.accordion-icon-toggle .accordion-icon i,
.accordion.accordion-icon-toggle .accordion-icon .svg-icon {
  color: var(--bs-primary);
}
.accordion.accordion-icon-toggle .collapsed .accordion-icon {
  transition: all 0.2s ease-in-out;
  transform: rotate(0);
}
.accordion.accordion-icon-toggle .collapsed .accordion-icon i,
.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon {
  color: var(--bs-text-muted);
}
.accordion.accordion-icon-collapse .accordion-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-in-out;
}
.accordion.accordion-icon-collapse .accordion-icon .accordion-icon-on {
  display: inline-flex;
}
.accordion.accordion-icon-collapse .accordion-icon .accordion-icon-off {
  display: none;
}
.accordion.accordion-icon-collapse .accordion-icon i,
.accordion.accordion-icon-collapse .accordion-icon .svg-icon {
  color: var(--bs-primary);
}
.accordion.accordion-icon-collapse .collapsed .accordion-icon {
  transition: all 0.2s ease-in-out;
}
.accordion.accordion-icon-collapse .collapsed .accordion-icon .accordion-icon-on {
  display: none;
}
.accordion.accordion-icon-collapse .collapsed .accordion-icon .accordion-icon-off {
  display: inline-flex;
}
.accordion.accordion-icon-collapse .collapsed .accordion-icon i,
.accordion.accordion-icon-collapse .collapsed .accordion-icon .svg-icon {
  color: var(--bs-text-muted);
}
.accordion.accordion-borderless .accordion-item {
  border: 0;
}
.accordion.accordion-flush .accordion-item {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}

.image-input {
  position: relative;
  display: inline-block;
  border-radius: 0.65rem;
  background-repeat: no-repeat;
  background-size: cover;
}
.image-input:not(.image-input-empty) {
  background-image: none !important;
}
.image-input .image-input-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 0.65rem;
  background-repeat: no-repeat;
  background-size: cover;
}
.image-input [data-kt-image-input-action] {
  cursor: pointer;
  position: absolute;
  transform: translate(-50%, -50%);
}
.image-input [data-kt-image-input-action=change] {
  left: 100%;
  top: 0;
}
.image-input [data-kt-image-input-action=change] input {
  width: 0 !important;
  height: 0 !important;
  overflow: hidden;
  opacity: 0;
}
.image-input [data-kt-image-input-action=cancel],
.image-input [data-kt-image-input-action=remove] {
  position: absolute;
  left: 100%;
  top: 100%;
}
.image-input [data-kt-image-input-action=cancel] {
  display: none;
}
.image-input.image-input-changed [data-kt-image-input-action=cancel] {
  display: flex;
}
.image-input.image-input-changed [data-kt-image-input-action=remove] {
  display: none;
}
.image-input.image-input-empty [data-kt-image-input-action=remove],
.image-input.image-input-empty [data-kt-image-input-action=cancel] {
  display: none;
}
.image-input.image-input-circle {
  border-radius: 50%;
}
.image-input.image-input-circle .image-input-wrapper {
  border-radius: 50%;
}
.image-input.image-input-circle [data-kt-image-input-action=change] {
  left: 100%;
  top: 0;
  transform: translate(-100%, 0%);
}
.image-input.image-input-circle [data-kt-image-input-action=cancel],
.image-input.image-input-circle [data-kt-image-input-action=remove] {
  left: 100%;
  top: 100%;
  transform: translate(-100%, -100%);
}
.image-input.image-input-outline .image-input-wrapper {
  border: 3px solid var(--bs-body-bg);
  box-shadow: var(--bs-box-shadow);
}

.symbol {
  display: inline-block;
  flex-shrink: 0;
  position: relative;
  border-radius: 0.65rem;
}
.symbol .symbol-label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: var(--bs-symbol-label-color);
  background-color: var(--bs-symbol-label-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 0.65rem;
}
.symbol .symbol-label:after {
  border-radius: 0.65rem;
}
.symbol .symbol-badge {
  position: absolute;
  border-radius: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) !important;
}
.symbol > img {
  width: 100%;
  flex-shrink: 0;
  display: inline-block;
  border-radius: 0.65rem;
}
.symbol.symbol-square,
.symbol.symbol-square > img,
.symbol.symbol-square .symbol-label {
  border-radius: 0 !important;
}
.symbol.symbol-circle,
.symbol.symbol-circle > img,
.symbol.symbol-circle .symbol-label {
  border-radius: 50%;
}
.symbol.symbol-circle:after,
.symbol.symbol-circle > img:after,
.symbol.symbol-circle .symbol-label:after {
  border-radius: 50%;
}
.symbol > img {
  width: 50px;
  height: 50px;
}
.symbol .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-fixed .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-fixed > img {
  width: 50px;
  height: 50px;
  max-width: none;
}
.symbol.symbol-2by3 .symbol-label {
  height: 50px;
  width: 75px;
}
.symbol.symbol-2by3 > img {
  height: 50px;
  width: 75px;
  max-width: none;
}
.symbol.symbol-20px > img {
  width: 20px;
  height: 20px;
}
.symbol.symbol-20px .symbol-label {
  width: 20px;
  height: 20px;
}
.symbol.symbol-20px.symbol-fixed .symbol-label {
  width: 20px;
  height: 20px;
}
.symbol.symbol-20px.symbol-fixed > img {
  width: 20px;
  height: 20px;
  max-width: none;
}
.symbol.symbol-20px.symbol-2by3 .symbol-label {
  height: 20px;
  width: 30px;
}
.symbol.symbol-20px.symbol-2by3 > img {
  height: 20px;
  width: 30px;
  max-width: none;
}
.symbol.symbol-25px > img {
  width: 25px;
  height: 25px;
}
.symbol.symbol-25px .symbol-label {
  width: 25px;
  height: 25px;
}
.symbol.symbol-25px.symbol-fixed .symbol-label {
  width: 25px;
  height: 25px;
}
.symbol.symbol-25px.symbol-fixed > img {
  width: 25px;
  height: 25px;
  max-width: none;
}
.symbol.symbol-25px.symbol-2by3 .symbol-label {
  height: 25px;
  width: 37.5px;
}
.symbol.symbol-25px.symbol-2by3 > img {
  height: 25px;
  width: 37.5px;
  max-width: none;
}
.symbol.symbol-30px > img {
  width: 30px;
  height: 30px;
}
.symbol.symbol-30px .symbol-label {
  width: 30px;
  height: 30px;
}
.symbol.symbol-30px.symbol-fixed .symbol-label {
  width: 30px;
  height: 30px;
}
.symbol.symbol-30px.symbol-fixed > img {
  width: 30px;
  height: 30px;
  max-width: none;
}
.symbol.symbol-30px.symbol-2by3 .symbol-label {
  height: 30px;
  width: 45px;
}
.symbol.symbol-30px.symbol-2by3 > img {
  height: 30px;
  width: 45px;
  max-width: none;
}
.symbol.symbol-35px > img {
  width: 35px;
  height: 35px;
}
.symbol.symbol-35px .symbol-label {
  width: 35px;
  height: 35px;
}
.symbol.symbol-35px.symbol-fixed .symbol-label {
  width: 35px;
  height: 35px;
}
.symbol.symbol-35px.symbol-fixed > img {
  width: 35px;
  height: 35px;
  max-width: none;
}
.symbol.symbol-35px.symbol-2by3 .symbol-label {
  height: 35px;
  width: 52.5px;
}
.symbol.symbol-35px.symbol-2by3 > img {
  height: 35px;
  width: 52.5px;
  max-width: none;
}
.symbol.symbol-40px > img {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40px .symbol-label {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40px.symbol-fixed .symbol-label {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40px.symbol-fixed > img {
  width: 40px;
  height: 40px;
  max-width: none;
}
.symbol.symbol-40px.symbol-2by3 .symbol-label {
  height: 40px;
  width: 60px;
}
.symbol.symbol-40px.symbol-2by3 > img {
  height: 40px;
  width: 60px;
  max-width: none;
}
.symbol.symbol-45px > img {
  width: 45px;
  height: 45px;
}
.symbol.symbol-45px .symbol-label {
  width: 45px;
  height: 45px;
}
.symbol.symbol-45px.symbol-fixed .symbol-label {
  width: 45px;
  height: 45px;
}
.symbol.symbol-45px.symbol-fixed > img {
  width: 45px;
  height: 45px;
  max-width: none;
}
.symbol.symbol-45px.symbol-2by3 .symbol-label {
  height: 45px;
  width: 67.5px;
}
.symbol.symbol-45px.symbol-2by3 > img {
  height: 45px;
  width: 67.5px;
  max-width: none;
}
.symbol.symbol-50px > img {
  width: 50px;
  height: 50px;
}
.symbol.symbol-50px .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-50px.symbol-fixed .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-50px.symbol-fixed > img {
  width: 50px;
  height: 50px;
  max-width: none;
}
.symbol.symbol-50px.symbol-2by3 .symbol-label {
  height: 50px;
  width: 75px;
}
.symbol.symbol-50px.symbol-2by3 > img {
  height: 50px;
  width: 75px;
  max-width: none;
}
.symbol.symbol-55px > img {
  width: 55px;
  height: 55px;
}
.symbol.symbol-55px .symbol-label {
  width: 55px;
  height: 55px;
}
.symbol.symbol-55px.symbol-fixed .symbol-label {
  width: 55px;
  height: 55px;
}
.symbol.symbol-55px.symbol-fixed > img {
  width: 55px;
  height: 55px;
  max-width: none;
}
.symbol.symbol-55px.symbol-2by3 .symbol-label {
  height: 55px;
  width: 82.5px;
}
.symbol.symbol-55px.symbol-2by3 > img {
  height: 55px;
  width: 82.5px;
  max-width: none;
}
.symbol.symbol-60px > img {
  width: 60px;
  height: 60px;
}
.symbol.symbol-60px .symbol-label {
  width: 60px;
  height: 60px;
}
.symbol.symbol-60px.symbol-fixed .symbol-label {
  width: 60px;
  height: 60px;
}
.symbol.symbol-60px.symbol-fixed > img {
  width: 60px;
  height: 60px;
  max-width: none;
}
.symbol.symbol-60px.symbol-2by3 .symbol-label {
  height: 60px;
  width: 90px;
}
.symbol.symbol-60px.symbol-2by3 > img {
  height: 60px;
  width: 90px;
  max-width: none;
}
.symbol.symbol-65px > img {
  width: 65px;
  height: 65px;
}
.symbol.symbol-65px .symbol-label {
  width: 65px;
  height: 65px;
}
.symbol.symbol-65px.symbol-fixed .symbol-label {
  width: 65px;
  height: 65px;
}
.symbol.symbol-65px.symbol-fixed > img {
  width: 65px;
  height: 65px;
  max-width: none;
}
.symbol.symbol-65px.symbol-2by3 .symbol-label {
  height: 65px;
  width: 97.5px;
}
.symbol.symbol-65px.symbol-2by3 > img {
  height: 65px;
  width: 97.5px;
  max-width: none;
}
.symbol.symbol-70px > img {
  width: 70px;
  height: 70px;
}
.symbol.symbol-70px .symbol-label {
  width: 70px;
  height: 70px;
}
.symbol.symbol-70px.symbol-fixed .symbol-label {
  width: 70px;
  height: 70px;
}
.symbol.symbol-70px.symbol-fixed > img {
  width: 70px;
  height: 70px;
  max-width: none;
}
.symbol.symbol-70px.symbol-2by3 .symbol-label {
  height: 70px;
  width: 105px;
}
.symbol.symbol-70px.symbol-2by3 > img {
  height: 70px;
  width: 105px;
  max-width: none;
}
.symbol.symbol-75px > img {
  width: 75px;
  height: 75px;
}
.symbol.symbol-75px .symbol-label {
  width: 75px;
  height: 75px;
}
.symbol.symbol-75px.symbol-fixed .symbol-label {
  width: 75px;
  height: 75px;
}
.symbol.symbol-75px.symbol-fixed > img {
  width: 75px;
  height: 75px;
  max-width: none;
}
.symbol.symbol-75px.symbol-2by3 .symbol-label {
  height: 75px;
  width: 112.5px;
}
.symbol.symbol-75px.symbol-2by3 > img {
  height: 75px;
  width: 112.5px;
  max-width: none;
}
.symbol.symbol-90px > img {
  width: 90px;
  height: 90px;
}
.symbol.symbol-90px .symbol-label {
  width: 90px;
  height: 90px;
}
.symbol.symbol-90px.symbol-fixed .symbol-label {
  width: 90px;
  height: 90px;
}
.symbol.symbol-90px.symbol-fixed > img {
  width: 90px;
  height: 90px;
  max-width: none;
}
.symbol.symbol-90px.symbol-2by3 .symbol-label {
  height: 90px;
  width: 135px;
}
.symbol.symbol-90px.symbol-2by3 > img {
  height: 90px;
  width: 135px;
  max-width: none;
}
.symbol.symbol-100px > img {
  width: 100px;
  height: 100px;
}
.symbol.symbol-100px .symbol-label {
  width: 100px;
  height: 100px;
}
.symbol.symbol-100px.symbol-fixed .symbol-label {
  width: 100px;
  height: 100px;
}
.symbol.symbol-100px.symbol-fixed > img {
  width: 100px;
  height: 100px;
  max-width: none;
}
.symbol.symbol-100px.symbol-2by3 .symbol-label {
  height: 100px;
  width: 150px;
}
.symbol.symbol-100px.symbol-2by3 > img {
  height: 100px;
  width: 150px;
  max-width: none;
}
.symbol.symbol-125px > img {
  width: 125px;
  height: 125px;
}
.symbol.symbol-125px .symbol-label {
  width: 125px;
  height: 125px;
}
.symbol.symbol-125px.symbol-fixed .symbol-label {
  width: 125px;
  height: 125px;
}
.symbol.symbol-125px.symbol-fixed > img {
  width: 125px;
  height: 125px;
  max-width: none;
}
.symbol.symbol-125px.symbol-2by3 .symbol-label {
  height: 125px;
  width: 187.5px;
}
.symbol.symbol-125px.symbol-2by3 > img {
  height: 125px;
  width: 187.5px;
  max-width: none;
}
.symbol.symbol-150px > img {
  width: 150px;
  height: 150px;
}
.symbol.symbol-150px .symbol-label {
  width: 150px;
  height: 150px;
}
.symbol.symbol-150px.symbol-fixed .symbol-label {
  width: 150px;
  height: 150px;
}
.symbol.symbol-150px.symbol-fixed > img {
  width: 150px;
  height: 150px;
  max-width: none;
}
.symbol.symbol-150px.symbol-2by3 .symbol-label {
  height: 150px;
  width: 225px;
}
.symbol.symbol-150px.symbol-2by3 > img {
  height: 150px;
  width: 225px;
  max-width: none;
}
.symbol.symbol-160px > img {
  width: 160px;
  height: 160px;
}
.symbol.symbol-160px .symbol-label {
  width: 160px;
  height: 160px;
}
.symbol.symbol-160px.symbol-fixed .symbol-label {
  width: 160px;
  height: 160px;
}
.symbol.symbol-160px.symbol-fixed > img {
  width: 160px;
  height: 160px;
  max-width: none;
}
.symbol.symbol-160px.symbol-2by3 .symbol-label {
  height: 160px;
  width: 240px;
}
.symbol.symbol-160px.symbol-2by3 > img {
  height: 160px;
  width: 240px;
  max-width: none;
}
.symbol.symbol-175px > img {
  width: 175px;
  height: 175px;
}
.symbol.symbol-175px .symbol-label {
  width: 175px;
  height: 175px;
}
.symbol.symbol-175px.symbol-fixed .symbol-label {
  width: 175px;
  height: 175px;
}
.symbol.symbol-175px.symbol-fixed > img {
  width: 175px;
  height: 175px;
  max-width: none;
}
.symbol.symbol-175px.symbol-2by3 .symbol-label {
  height: 175px;
  width: 262.5px;
}
.symbol.symbol-175px.symbol-2by3 > img {
  height: 175px;
  width: 262.5px;
  max-width: none;
}
.symbol.symbol-200px > img {
  width: 200px;
  height: 200px;
}
.symbol.symbol-200px .symbol-label {
  width: 200px;
  height: 200px;
}
.symbol.symbol-200px.symbol-fixed .symbol-label {
  width: 200px;
  height: 200px;
}
.symbol.symbol-200px.symbol-fixed > img {
  width: 200px;
  height: 200px;
  max-width: none;
}
.symbol.symbol-200px.symbol-2by3 .symbol-label {
  height: 200px;
  width: 300px;
}
.symbol.symbol-200px.symbol-2by3 > img {
  height: 200px;
  width: 300px;
  max-width: none;
}
@media (min-width: 576px) {
  .symbol.symbol-sm-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-sm-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-sm-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-sm-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-sm-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-sm-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-sm-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-sm-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-sm-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-sm-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-sm-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-sm-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-sm-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-sm-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-sm-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-sm-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-sm-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-sm-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-sm-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-sm-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-sm-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-sm-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-sm-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-sm-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-sm-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-sm-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-sm-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-sm-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-sm-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-sm-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-sm-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-sm-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-sm-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-sm-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-sm-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-sm-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-sm-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-sm-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-sm-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-sm-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-sm-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-sm-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-sm-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-sm-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-sm-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-sm-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-sm-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-sm-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-sm-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-sm-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-sm-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-sm-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-sm-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-sm-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-sm-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-sm-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-sm-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-sm-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-sm-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-sm-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 768px) {
  .symbol.symbol-md-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-md-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-md-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-md-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-md-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-md-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-md-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-md-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-md-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-md-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-md-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-md-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-md-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-md-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-md-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-md-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-md-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-md-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-md-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-md-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-md-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-md-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-md-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-md-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-md-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-md-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-md-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-md-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-md-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-md-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-md-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-md-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-md-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-md-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-md-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-md-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-md-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-md-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-md-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-md-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-md-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-md-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-md-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-md-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-md-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-md-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-md-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-md-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-md-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-md-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-md-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-md-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-md-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-md-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-md-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-md-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-md-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-md-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-md-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-md-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 992px) {
  .symbol.symbol-lg-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-lg-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-lg-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-lg-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-lg-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-lg-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-lg-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-lg-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-lg-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-lg-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-lg-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-lg-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-lg-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-lg-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-lg-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-lg-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-lg-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-lg-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-lg-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-lg-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-lg-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-lg-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-lg-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-lg-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-lg-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-lg-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-lg-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-lg-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-lg-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-lg-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-lg-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-lg-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-lg-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-lg-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-lg-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-lg-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-lg-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-lg-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-lg-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-lg-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-lg-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-lg-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-lg-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-lg-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-lg-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-lg-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-lg-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-lg-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-lg-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-lg-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-lg-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-lg-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-lg-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-lg-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-lg-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-lg-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-lg-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-lg-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-lg-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-lg-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 1200px) {
  .symbol.symbol-xl-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-xl-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-xl-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-xl-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-xl-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-xl-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-xl-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-xl-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-xl-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-xl-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-xl-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-xl-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-xl-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-xl-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-xl-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-xl-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-xl-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-xl-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-xl-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-xl-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-xl-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-xl-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-xl-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-xl-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-xl-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-xl-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-xl-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-xl-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-xl-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-xl-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-xl-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-xl-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-xl-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-xl-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-xl-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-xl-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-xl-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xl-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xl-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xl-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-xl-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-xl-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-xl-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-xl-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-xl-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-xl-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-xl-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-xl-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-xl-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-xl-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-xl-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-xl-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-xl-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-xl-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-xl-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-xl-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-xl-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-xl-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-xl-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-xl-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 1400px) {
  .symbol.symbol-xxl-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-xxl-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-xxl-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-xxl-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-xxl-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-xxl-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-xxl-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-xxl-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-xxl-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-xxl-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-xxl-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-xxl-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-xxl-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-xxl-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-xxl-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-xxl-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-xxl-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-xxl-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-xxl-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-xxl-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-xxl-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-xxl-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-xxl-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-xxl-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-xxl-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-xxl-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-xxl-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-xxl-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-xxl-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-xxl-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-xxl-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xxl-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xxl-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xxl-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-xxl-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-xxl-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-xxl-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-xxl-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-xxl-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-xxl-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-xxl-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-xxl-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-xxl-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-xxl-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-xxl-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-xxl-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-xxl-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-xxl-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-xxl-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-xxl-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-xxl-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-xxl-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}

.symbol-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: 10px;
}
.symbol-group .symbol {
  position: relative;
  z-index: 0;
  margin-left: -10px;
  transition: all 0.3s ease;
}
.symbol-group .symbol:hover {
  transition: all 0.3s ease;
  z-index: 1;
}
.symbol-group .symbol-badge {
  border: 2px solid var(--bs-body-bg);
}
.symbol-group .symbol-label {
  position: relative;
}
.symbol-group .symbol-label:after {
  display: block;
  content: " ";
  border-radius: inherit;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border: 2px solid var(--bs-symbol-border-color);
  -webkit-background-clip: padding-box; /* for Safari */
  background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */
}
.symbol-group.symbol-hover .symbol {
  cursor: pointer;
}

.pulse {
  position: relative;
}
.pulse.pulse-light .pulse-ring {
  border-color: var(--bs-light);
}
.pulse.pulse-primary .pulse-ring {
  border-color: var(--bs-primary);
}
.pulse.pulse-secondary .pulse-ring {
  border-color: var(--bs-secondary);
}
.pulse.pulse-success .pulse-ring {
  border-color: var(--bs-success);
}
.pulse.pulse-info .pulse-ring {
  border-color: var(--bs-info);
}
.pulse.pulse-warning .pulse-ring {
  border-color: var(--bs-warning);
}
.pulse.pulse-danger .pulse-ring {
  border-color: var(--bs-danger);
}
.pulse.pulse-dark .pulse-ring {
  border-color: var(--bs-dark);
}

.pulse-ring {
  display: block;
  border-radius: 40px;
  height: 40px;
  width: 40px;
  position: absolute;
  animation: animation-pulse 3.5s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
  border-width: 3px;
  border-style: solid;
  border-color: var(--bs-gray-500);
}

@keyframes animation-pulse {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  60% {
    -webkit-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  65% {
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    opacity: 0;
  }
}
[data-kt-app-page-loading=on] *,
.page-loading * {
  transition: none !important;
}

.page-loader {
  background-color: var(--bs-body-bg);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  display: none;
}
[data-kt-app-page-loading=on] .page-loader, .page-loading .page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scrolltop {
  position: fixed;
  display: none;
  cursor: pointer;
  z-index: 105;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  bottom: 40px;
  right: 20px;
  background-color: var(--bs-scrolltop-bg-color);
  box-shadow: var(--bs-scrolltop-box-shadow);
  opacity: 0;
  transition: color 0.2s ease;
  border-radius: 0.65rem;
}
.scrolltop .svg-icon {
  color: var(--bs-scrolltop-icon-color);
}
.scrolltop .svg-icon svg {
  height: 24px;
  width: 24px;
}
.scrolltop > i {
  font-size: 1.3rem;
  color: var(--bs-scrolltop-icon-color);
}
.scrolltop:hover {
  background-color: var(--bs-scrolltop-bg-color-hover);
}
.scrolltop:hover .svg-icon,
.scrolltop:hover i {
  color: var(--bs-scrolltop-icon-color-hover);
}
[data-kt-scrolltop=on] .scrolltop {
  opacity: var(--bs-scrolltop-opacity-on);
  animation: animation-scrolltop 0.4s ease-out 1;
  display: flex;
}
[data-kt-scrolltop=on] .scrolltop:hover {
  transition: color 0.2s ease;
  opacity: var(--bs-scrolltop-opacity-hover);
}

@media (max-width: 991.98px) {
  .scrolltop {
    bottom: 30px;
    right: 15px;
    width: 30px;
    height: 30px;
  }
}
@keyframes animation-scrolltop {
  from {
    margin-bottom: -15px;
  }
  to {
    margin-bottom: 0;
  }
}
.svg-icon {
  line-height: 1;
  color: var(--bs-text-muted);
}
.svg-icon svg {
  height: 1.15rem;
  width: 1.15rem;
}
.svg-icon.svg-icon-white {
  color: var(--bs-text-white);
}
.svg-icon.svg-icon-primary {
  color: var(--bs-text-primary);
}
.svg-icon.svg-icon-secondary {
  color: var(--bs-text-secondary);
}
.svg-icon.svg-icon-light {
  color: var(--bs-text-light);
}
.svg-icon.svg-icon-success {
  color: var(--bs-text-success);
}
.svg-icon.svg-icon-info {
  color: var(--bs-text-info);
}
.svg-icon.svg-icon-warning {
  color: var(--bs-text-warning);
}
.svg-icon.svg-icon-danger {
  color: var(--bs-text-danger);
}
.svg-icon.svg-icon-dark {
  color: var(--bs-text-dark);
}
.svg-icon.svg-icon-muted {
  color: var(--bs-text-muted);
}
.svg-icon.svg-icon-gray-100 {
  color: var(--bs-text-gray-100);
}
.svg-icon.svg-icon-gray-200 {
  color: var(--bs-text-gray-200);
}
.svg-icon.svg-icon-gray-300 {
  color: var(--bs-text-gray-300);
}
.svg-icon.svg-icon-gray-400 {
  color: var(--bs-text-gray-400);
}
.svg-icon.svg-icon-gray-500 {
  color: var(--bs-text-gray-500);
}
.svg-icon.svg-icon-gray-600 {
  color: var(--bs-text-gray-600);
}
.svg-icon.svg-icon-gray-700 {
  color: var(--bs-text-gray-700);
}
.svg-icon.svg-icon-gray-800 {
  color: var(--bs-text-gray-800);
}
.svg-icon.svg-icon-gray-900 {
  color: var(--bs-text-gray-900);
}
.svg-icon.svg-icon-1 svg {
  height: 1.75rem !important;
  width: 1.75rem !important;
}
.svg-icon.svg-icon-2 svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.svg-icon.svg-icon-3 svg {
  height: 1.35rem !important;
  width: 1.35rem !important;
}
.svg-icon.svg-icon-4 svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.svg-icon.svg-icon-5 svg {
  height: 1.15rem !important;
  width: 1.15rem !important;
}
.svg-icon.svg-icon-6 svg {
  height: 1.075rem !important;
  width: 1.075rem !important;
}
.svg-icon.svg-icon-7 svg {
  height: 0.95rem !important;
  width: 0.95rem !important;
}
.svg-icon.svg-icon-8 svg {
  height: 0.85rem !important;
  width: 0.85rem !important;
}
.svg-icon.svg-icon-9 svg {
  height: 0.75rem !important;
  width: 0.75rem !important;
}
.svg-icon.svg-icon-10 svg {
  height: 0.5rem !important;
  width: 0.5rem !important;
}
.svg-icon.svg-icon-sm svg {
  height: 0.95rem !important;
  width: 0.95rem !important;
}
.svg-icon.svg-icon-base svg {
  height: 1rem !important;
  width: 1rem !important;
}
.svg-icon.svg-icon-lg svg {
  height: 1.075rem !important;
  width: 1.075rem !important;
}
.svg-icon.svg-icon-xl svg {
  height: 1.21rem !important;
  width: 1.21rem !important;
}
.svg-icon.svg-icon-fluid svg {
  height: 100% !important;
  width: 100% !important;
}
.svg-icon.svg-icon-2x svg {
  height: 2rem !important;
  width: 2rem !important;
}
.svg-icon.svg-icon-2qx svg {
  height: 2.25rem !important;
  width: 2.25rem !important;
}
.svg-icon.svg-icon-2hx svg {
  height: 2.5rem !important;
  width: 2.5rem !important;
}
.svg-icon.svg-icon-2tx svg {
  height: 2.75rem !important;
  width: 2.75rem !important;
}
.svg-icon.svg-icon-3x svg {
  height: 3rem !important;
  width: 3rem !important;
}
.svg-icon.svg-icon-3qx svg {
  height: 3.25rem !important;
  width: 3.25rem !important;
}
.svg-icon.svg-icon-3hx svg {
  height: 3.5rem !important;
  width: 3.5rem !important;
}
.svg-icon.svg-icon-3tx svg {
  height: 3.75rem !important;
  width: 3.75rem !important;
}
.svg-icon.svg-icon-4x svg {
  height: 4rem !important;
  width: 4rem !important;
}
.svg-icon.svg-icon-4qx svg {
  height: 4.25rem !important;
  width: 4.25rem !important;
}
.svg-icon.svg-icon-4hx svg {
  height: 4.5rem !important;
  width: 4.5rem !important;
}
.svg-icon.svg-icon-4tx svg {
  height: 4.75rem !important;
  width: 4.75rem !important;
}
.svg-icon.svg-icon-5x svg {
  height: 5rem !important;
  width: 5rem !important;
}
.svg-icon.svg-icon-5qx svg {
  height: 5.25rem !important;
  width: 5.25rem !important;
}
.svg-icon.svg-icon-5hx svg {
  height: 5.5rem !important;
  width: 5.5rem !important;
}
.svg-icon.svg-icon-5tx svg {
  height: 5.75rem !important;
  width: 5.75rem !important;
}
.svg-icon.svg-icon-6x svg {
  height: 6rem !important;
  width: 6rem !important;
}
.svg-icon.svg-icon-6qx svg {
  height: 6.25rem !important;
  width: 6.25rem !important;
}
.svg-icon.svg-icon-6hx svg {
  height: 6.5rem !important;
  width: 6.5rem !important;
}
.svg-icon.svg-icon-6tx svg {
  height: 6.75rem !important;
  width: 6.75rem !important;
}
.svg-icon.svg-icon-7x svg {
  height: 7rem !important;
  width: 7rem !important;
}
.svg-icon.svg-icon-7qx svg {
  height: 7.25rem !important;
  width: 7.25rem !important;
}
.svg-icon.svg-icon-7hx svg {
  height: 7.5rem !important;
  width: 7.5rem !important;
}
.svg-icon.svg-icon-7tx svg {
  height: 7.75rem !important;
  width: 7.75rem !important;
}
@media (min-width: 576px) {
  .svg-icon.svg-icon-sm-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-sm-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-sm-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-sm-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-sm-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-sm-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-sm-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-sm-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-sm-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-sm-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-sm-sm svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-sm-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-sm-lg svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-sm-xl svg {
    height: 1.21rem !important;
    width: 1.21rem !important;
  }
  .svg-icon.svg-icon-sm-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-sm-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-sm-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-sm-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-sm-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-sm-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-sm-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-sm-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-sm-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-sm-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-sm-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-sm-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-sm-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-sm-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-sm-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-sm-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-sm-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-sm-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-sm-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-sm-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-sm-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-sm-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-sm-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-sm-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-sm-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}
@media (min-width: 768px) {
  .svg-icon.svg-icon-md-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-md-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-md-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-md-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-md-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-md-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-md-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-md-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-md-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-md-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-md-sm svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-md-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-md-lg svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-md-xl svg {
    height: 1.21rem !important;
    width: 1.21rem !important;
  }
  .svg-icon.svg-icon-md-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-md-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-md-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-md-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-md-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-md-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-md-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-md-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-md-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-md-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-md-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-md-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-md-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-md-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-md-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-md-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-md-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-md-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-md-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-md-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-md-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-md-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-md-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-md-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-md-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}
@media (min-width: 992px) {
  .svg-icon.svg-icon-lg-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-lg-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-lg-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-lg-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-lg-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-lg-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-lg-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-lg-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-lg-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-lg-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-lg-sm svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-lg-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-lg-lg svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-lg-xl svg {
    height: 1.21rem !important;
    width: 1.21rem !important;
  }
  .svg-icon.svg-icon-lg-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-lg-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-lg-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-lg-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-lg-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-lg-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-lg-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-lg-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-lg-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-lg-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-lg-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-lg-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-lg-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-lg-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-lg-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-lg-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-lg-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-lg-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-lg-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-lg-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-lg-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-lg-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-lg-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-lg-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-lg-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}
@media (min-width: 1200px) {
  .svg-icon.svg-icon-xl-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-xl-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-xl-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-xl-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-xl-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-xl-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xl-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xl-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-xl-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-xl-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-xl-sm svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xl-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-xl-lg svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xl-xl svg {
    height: 1.21rem !important;
    width: 1.21rem !important;
  }
  .svg-icon.svg-icon-xl-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-xl-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-xl-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-xl-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-xl-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-xl-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-xl-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-xl-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-xl-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-xl-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-xl-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-xl-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-xl-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-xl-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-xl-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-xl-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-xl-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-xl-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-xl-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-xl-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-xl-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-xl-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-xl-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-xl-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-xl-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}
@media (min-width: 1400px) {
  .svg-icon.svg-icon-xxl-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-xxl-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-xxl-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-xxl-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-xxl-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-xxl-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xxl-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xxl-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-xxl-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-xxl-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-xxl-sm svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xxl-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-xxl-lg svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xxl-xl svg {
    height: 1.21rem !important;
    width: 1.21rem !important;
  }
  .svg-icon.svg-icon-xxl-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-xxl-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-xxl-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-xxl-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-xxl-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-xxl-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-xxl-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-xxl-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-xxl-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-xxl-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-xxl-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-xxl-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-xxl-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-xxl-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-xxl-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-xxl-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-xxl-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
  .svg-icon.svg-icon-xxl-6x svg {
    height: 6rem !important;
    width: 6rem !important;
  }
  .svg-icon.svg-icon-xxl-6qx svg {
    height: 6.25rem !important;
    width: 6.25rem !important;
  }
  .svg-icon.svg-icon-xxl-6hx svg {
    height: 6.5rem !important;
    width: 6.5rem !important;
  }
  .svg-icon.svg-icon-xxl-6tx svg {
    height: 6.75rem !important;
    width: 6.75rem !important;
  }
  .svg-icon.svg-icon-xxl-7x svg {
    height: 7rem !important;
    width: 7rem !important;
  }
  .svg-icon.svg-icon-xxl-7qx svg {
    height: 7.25rem !important;
    width: 7.25rem !important;
  }
  .svg-icon.svg-icon-xxl-7hx svg {
    height: 7.5rem !important;
    width: 7.5rem !important;
  }
  .svg-icon.svg-icon-xxl-7tx svg {
    height: 7.75rem !important;
    width: 7.75rem !important;
  }
}

.fixed-top {
  position: fixed;
  z-index: 101;
  top: 0;
  left: 0;
  right: 0;
}

@media (min-width: 576px) {
  .fixed-top-sm {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 768px) {
  .fixed-top-md {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 992px) {
  .fixed-top-lg {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 1200px) {
  .fixed-top-xl {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 1400px) {
  .fixed-top-xxl {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
.timeline {
  --bs-timeline-icon-size: 38px;
  --bs-timeline-icon-space: 0.35rem;
}
.timeline .timeline-item {
  position: relative;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: flex-start;
}
.timeline .timeline-item:last-child .timeline-line {
  bottom: 100%;
}
.timeline .timeline-line {
  display: block;
  content: " ";
  justify-content: center;
  position: absolute;
  z-index: 0;
  left: 0;
  top: var(--bs-timeline-icon-size);
  bottom: 0;
  transform: translate(50%);
  border-left-width: 1px;
  border-left-style: solid;
  border-left-color: var(--bs-gray-300);
  width: var(--bs-timeline-icon-size);
  margin-top: var(--bs-timeline-icon-space);
  margin-bottom: var(--bs-timeline-icon-space);
}
.timeline .timeline-icon {
  z-index: 1;
  flex-shrink: 0;
  margin-right: 1rem;
  width: var(--bs-timeline-icon-size);
  height: var(--bs-timeline-icon-size);
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--bs-gray-300);
  border-radius: 50%;
}
.timeline .timeline-content {
  width: 100%;
  overflow: auto;
  margin-bottom: 1.5rem;
}
.timeline.timeline-center .timeline-item {
  align-items: center;
}
.timeline.timeline-center .timeline-item:first-child .timeline-line {
  top: 50%;
}
.timeline.timeline-center .timeline-item:last-child .timeline-line {
  bottom: 50%;
}
.timeline.timeline-border-dashed .timeline-line {
  border-left-style: dashed !important;
}
.timeline.timeline-border-dashed .timeline-icon {
  border-style: dashed !important;
}

.timeline-label {
  position: relative;
}
.timeline-label:before {
  content: "";
  position: absolute;
  left: 51px;
  width: 3px;
  top: 0;
  bottom: 0;
  background-color: var(--bs-gray-200);
}
.timeline-label .timeline-item {
  display: flex;
  align-items: flex-start;
  position: relative;
  margin-bottom: 1.7rem;
}
.timeline-label .timeline-item:last-child {
  margin-bottom: 0;
}
.timeline-label .timeline-label {
  width: 50px;
  flex-shrink: 0;
  position: relative;
  color: var(--bs-gray-800);
}
.timeline-label .timeline-badge {
  flex-shrink: 0;
  background-color: var(--bs-body-bg);
  width: 1rem;
  height: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: relative;
  margin-top: 1px;
  margin-left: -0.5rem;
  padding: 3px !important;
  border: 6px solid var(--bs-body-bg) !important;
}
.timeline-label .timeline-content {
  flex-grow: 1;
}

.overlay {
  position: relative;
}
.overlay .overlay-layer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bs-overlay-bg);
  transition: all 0.3s ease;
  opacity: 0;
}
.overlay.overlay-show .overlay-layer, .overlay.overlay-block .overlay-layer, .overlay:hover .overlay-layer {
  transition: all 0.3s ease;
  opacity: 1;
}
.overlay.overlay-block {
  cursor: wait;
}

.bullet {
  display: inline-block;
  background-color: var(--bs-bullet-bg-color);
  border-radius: 6px;
  width: 8px;
  height: 4px;
  flex-shrink: 0;
}

.bullet-dot {
  width: 4px;
  height: 4px;
  border-radius: 100% !important;
}

.bullet-vertical {
  width: 4px;
  height: 8px;
}

.bullet-line {
  width: 5px;
  height: 1px;
  border-radius: 0;
}

.drawer {
  display: flex !important;
  overflow: auto;
  z-index: 110;
  position: fixed;
  top: 0;
  bottom: 0;
  background-color: var(--bs-drawer-bg-color);
  transition: transform 0.3s ease-in-out !important;
}
.drawer.drawer-start {
  left: 0;
  transform: translateX(-100%);
}
.drawer.drawer-end {
  right: 0;
  transform: translateX(100%);
}
.drawer.drawer-bottom {
  bottom: 0;
  top: auto;
  left: 0;
  right: 0;
  transform: translateY(100%);
}
.drawer.drawer-top {
  top: 0;
  bottom: auto;
  left: 0;
  right: 0;
  transform: translateY(-100%);
}
.drawer.drawer-on {
  transform: none;
  box-shadow: var(--bs-drawer-box-shadow);
  transition: transform 0.3s ease-in-out !important;
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  z-index: 109;
  background-color: var(--bs-drawer-overlay-bg-color);
  animation: animation-drawer-fade-in 0.3s ease-in-out 1;
}

[data-kt-drawer=true] {
  display: none;
}

@keyframes animation-drawer-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 991.98px) {
  body[data-kt-drawer=on] {
    overflow: hidden;
  }
}
.badge {
  display: inline-flex;
  align-items: center;
}
.badge.badge-circle, .badge.badge-square {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.75rem;
  min-width: 1.75rem;
  padding: 0 0.1rem;
  line-height: 0;
}
.badge.badge-circle {
  border-radius: 50%;
  padding: 0;
  min-width: unset;
  width: 1.75rem;
}
.badge.badge-sm {
  min-width: 1.5rem;
  font-size: 0.8rem;
}
.badge.badge-sm.badge-square {
  height: 1.5rem;
}
.badge.badge-sm.badge-circle {
  width: 1.5rem;
  height: 1.5rem;
}
.badge.badge-lg {
  min-width: 2rem;
  font-size: 1rem;
}
.badge.badge-lg.badge-square {
  height: 2rem;
}
.badge.badge-lg.badge-circle {
  width: 2rem;
  height: 2rem;
}

.badge-light {
  color: var(--bs-light-inverse);
  background-color: var(--bs-light);
}
.badge-light.badge-outline {
  border: 1px solid var(--bs-light);
  color: var(--bs-light);
  background-color: transparent;
}

.badge-light-light {
  color: var(--bs-light);
  background-color: var(--bs-light-light);
}

.badge-primary {
  color: var(--bs-primary-inverse);
  background-color: var(--bs-primary);
}
.badge-primary.badge-outline {
  border: 1px solid var(--bs-primary);
  color: var(--bs-primary);
  background-color: transparent;
}

.badge-light-primary {
  color: var(--bs-primary);
  background-color: var(--bs-primary-light);
}

.badge-secondary {
  color: var(--bs-secondary-inverse);
  background-color: var(--bs-secondary);
}
.badge-secondary.badge-outline {
  border: 1px solid var(--bs-secondary);
  color: var(--bs-secondary);
  background-color: transparent;
}

.badge-light-secondary {
  color: var(--bs-secondary);
  background-color: var(--bs-secondary-light);
}

.badge-success {
  color: var(--bs-success-inverse);
  background-color: var(--bs-success);
}
.badge-success.badge-outline {
  border: 1px solid var(--bs-success);
  color: var(--bs-success);
  background-color: transparent;
}

.badge-light-success {
  color: var(--bs-success);
  background-color: var(--bs-success-light);
}

.badge-info {
  color: var(--bs-info-inverse);
  background-color: var(--bs-info);
}
.badge-info.badge-outline {
  border: 1px solid var(--bs-info);
  color: var(--bs-info);
  background-color: transparent;
}

.badge-light-info {
  color: var(--bs-info);
  background-color: var(--bs-info-light);
}

.badge-warning {
  color: var(--bs-warning-inverse);
  background-color: var(--bs-warning);
}
.badge-warning.badge-outline {
  border: 1px solid var(--bs-warning);
  color: var(--bs-warning);
  background-color: transparent;
}

.badge-light-warning {
  color: var(--bs-warning);
  background-color: var(--bs-warning-light);
}

.badge-danger {
  color: var(--bs-danger-inverse);
  background-color: var(--bs-danger);
}
.badge-danger.badge-outline {
  border: 1px solid var(--bs-danger);
  color: var(--bs-danger);
  background-color: transparent;
}

.badge-light-danger {
  color: var(--bs-danger);
  background-color: var(--bs-danger-light);
}

.badge-dark {
  color: var(--bs-dark-inverse);
  background-color: var(--bs-dark);
}
.badge-dark.badge-outline {
  border: 1px solid var(--bs-dark);
  color: var(--bs-dark);
  background-color: transparent;
}

.badge-light-dark {
  color: var(--bs-dark);
  background-color: var(--bs-dark-light);
}

.indicator-progress {
  display: none;
}
[data-kt-indicator=on] > .indicator-progress {
  display: inline-block;
}

[data-kt-indicator=on] > .indicator-label {
  display: none;
}

.hover-elevate-up {
  transition: transform 0.3s ease;
}
.hover-elevate-up:hover {
  transform: translateY(-2.5%);
  transition: transform 0.3s ease;
  will-change: transform;
}

.hover-elevate-down {
  transition: transform 0.3s ease;
}
.hover-elevate-down:hover {
  transform: translateY(2.5%);
  transition: transform 0.3s ease;
  will-change: transform;
}

.hover-scale {
  transition: transform 0.3s ease;
}
.hover-scale:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
  will-change: transform;
}

.hover-rotate-end {
  transition: transform 0.3s ease;
}
.hover-rotate-end:hover {
  transform: rotate(4deg);
  transition: transform 0.3s ease;
  will-change: transform;
}

.hover-rotate-start {
  transition: transform 0.3s ease;
}
.hover-rotate-start:hover {
  transform: rotate(-4deg);
  transition: transform 0.3s ease;
  will-change: transform;
}

.rotate {
  display: inline-flex;
  align-items: center;
}

.rotate-90 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-90, .show > .rotate-90, .active > .rotate-90 {
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-90, [direction=rtl] .show > .rotate-90, [direction=rtl] .active > .rotate-90 {
  transform: rotateZ(-90deg);
}

.rotate-n90 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-n90, .show > .rotate-n90, .active > .rotate-n90 {
  transform: rotateZ(-90deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-n90, [direction=rtl] .show > .rotate-n90, [direction=rtl] .active > .rotate-n90 {
  transform: rotateZ(90deg);
}

.rotate-180 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-180, .show > .rotate-180, .active > .rotate-180 {
  transform: rotateZ(180deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-180, [direction=rtl] .show > .rotate-180, [direction=rtl] .active > .rotate-180 {
  transform: rotateZ(-180deg);
}

.rotate-n180 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-n180, .show > .rotate-n180, .active > .rotate-n180 {
  transform: rotateZ(-180deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-n180, [direction=rtl] .show > .rotate-n180, [direction=rtl] .active > .rotate-n180 {
  transform: rotateZ(180deg);
}

.rotate-270 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-270, .show > .rotate-270, .active > .rotate-270 {
  transform: rotateZ(270deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-270, [direction=rtl] .show > .rotate-270, [direction=rtl] .active > .rotate-270 {
  transform: rotateZ(-270deg);
}

.rotate-n270 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-n270, .show > .rotate-n270, .active > .rotate-n270 {
  transform: rotateZ(-270deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-n270, [direction=rtl] .show > .rotate-n270, [direction=rtl] .active > .rotate-n270 {
  transform: rotateZ(270deg);
}

@media (min-width: 992px) {
  main,
  span,
  ol,
  ul,
  pre,
  div {
    scrollbar-width: thin;
    scrollbar-color: var(--bs-scrollbar-color) transparent;
  }
  main::-webkit-scrollbar,
  span::-webkit-scrollbar,
  ol::-webkit-scrollbar,
  ul::-webkit-scrollbar,
  pre::-webkit-scrollbar,
  div::-webkit-scrollbar {
    width: var(--bs-scrollbar-size);
    height: var(--bs-scrollbar-size);
  }
  main ::-webkit-scrollbar-track,
  span ::-webkit-scrollbar-track,
  ol ::-webkit-scrollbar-track,
  ul ::-webkit-scrollbar-track,
  pre ::-webkit-scrollbar-track,
  div ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  main ::-webkit-scrollbar-thumb,
  span ::-webkit-scrollbar-thumb,
  ol ::-webkit-scrollbar-thumb,
  ul ::-webkit-scrollbar-thumb,
  pre ::-webkit-scrollbar-thumb,
  div ::-webkit-scrollbar-thumb {
    border-radius: var(--bs-scrollbar-size);
  }
  main::-webkit-scrollbar-thumb,
  span::-webkit-scrollbar-thumb,
  ol::-webkit-scrollbar-thumb,
  ul::-webkit-scrollbar-thumb,
  pre::-webkit-scrollbar-thumb,
  div::-webkit-scrollbar-thumb {
    background-color: var(--bs-scrollbar-color);
  }
  main::-webkit-scrollbar-corner,
  span::-webkit-scrollbar-corner,
  ol::-webkit-scrollbar-corner,
  ul::-webkit-scrollbar-corner,
  pre::-webkit-scrollbar-corner,
  div::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  main:hover,
  span:hover,
  ol:hover,
  ul:hover,
  pre:hover,
  div:hover {
    scrollbar-color: var(--bs-scrollbar-hover-color) transparent;
  }
  main:hover::-webkit-scrollbar-thumb,
  span:hover::-webkit-scrollbar-thumb,
  ol:hover::-webkit-scrollbar-thumb,
  ul:hover::-webkit-scrollbar-thumb,
  pre:hover::-webkit-scrollbar-thumb,
  div:hover::-webkit-scrollbar-thumb {
    background-color: var(--bs-scrollbar-hover-color);
  }
  main:hover::-webkit-scrollbar-corner,
  span:hover::-webkit-scrollbar-corner,
  ol:hover::-webkit-scrollbar-corner,
  ul:hover::-webkit-scrollbar-corner,
  pre:hover::-webkit-scrollbar-corner,
  div:hover::-webkit-scrollbar-corner {
    background-color: transparent;
  }
}
.scroll,
.hover-scroll,
.hover-scroll-overlay {
  overflow: scroll;
  position: relative;
}
@media (max-width: 991.98px) {
  .scroll,
  .hover-scroll,
  .hover-scroll-overlay {
    overflow: auto;
  }
}

.scroll-x,
.hover-scroll-x,
.hover-scroll-overlay-x {
  overflow-x: scroll;
  position: relative;
}
@media (max-width: 991.98px) {
  .scroll-x,
  .hover-scroll-x,
  .hover-scroll-overlay-x {
    overflow-x: auto;
  }
}

.scroll-y,
.hover-scroll-y,
.hover-scroll-overlay-y {
  overflow-y: scroll;
  position: relative;
}
@media (max-width: 991.98px) {
  .scroll-y,
  .hover-scroll-y,
  .hover-scroll-overlay-y {
    overflow-y: auto;
  }
}

.hover-scroll,
.hover-scroll-overlay,
.hover-scroll-x,
.hover-scroll-overlay-x,
.hover-scroll-y,
.hover-scroll-overlay-y {
  scrollbar-color: transparent transparent;
}
.hover-scroll::-webkit-scrollbar-thumb,
.hover-scroll-overlay::-webkit-scrollbar-thumb,
.hover-scroll-x::-webkit-scrollbar-thumb,
.hover-scroll-overlay-x::-webkit-scrollbar-thumb,
.hover-scroll-y::-webkit-scrollbar-thumb,
.hover-scroll-overlay-y::-webkit-scrollbar-thumb {
  background-color: transparent;
}
.hover-scroll::-webkit-scrollbar-corner,
.hover-scroll-overlay::-webkit-scrollbar-corner,
.hover-scroll-x::-webkit-scrollbar-corner,
.hover-scroll-overlay-x::-webkit-scrollbar-corner,
.hover-scroll-y::-webkit-scrollbar-corner,
.hover-scroll-overlay-y::-webkit-scrollbar-corner {
  background-color: transparent;
}
.hover-scroll:hover,
.hover-scroll-overlay:hover,
.hover-scroll-x:hover,
.hover-scroll-overlay-x:hover,
.hover-scroll-y:hover,
.hover-scroll-overlay-y:hover {
  scrollbar-color: var(--bs-scrollbar-color) transparent;
}
.hover-scroll:hover::-webkit-scrollbar-thumb,
.hover-scroll-overlay:hover::-webkit-scrollbar-thumb,
.hover-scroll-x:hover::-webkit-scrollbar-thumb,
.hover-scroll-overlay-x:hover::-webkit-scrollbar-thumb,
.hover-scroll-y:hover::-webkit-scrollbar-thumb,
.hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {
  background-color: var(--bs-scrollbar-color);
}
.hover-scroll:hover::-webkit-scrollbar-corner,
.hover-scroll-overlay:hover::-webkit-scrollbar-corner,
.hover-scroll-x:hover::-webkit-scrollbar-corner,
.hover-scroll-overlay-x:hover::-webkit-scrollbar-corner,
.hover-scroll-y:hover::-webkit-scrollbar-corner,
.hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {
  background-color: transparent;
}

.scroll-ps {
  padding-left: var(--bs-scrollbar-size) !important;
}

.scroll-ms {
  margin-left: var(--bs-scrollbar-size) !important;
}

.scroll-mb {
  margin-bottom: var(--bs-scrollbar-size) !important;
}

.scroll-pe {
  padding-right: var(--bs-scrollbar-size) !important;
}

.scroll-me {
  margin-right: var(--bs-scrollbar-size) !important;
}

.scroll-px {
  padding-left: var(--bs-scrollbar-size) !important;
  padding-right: var(--bs-scrollbar-size) !important;
}

.scroll-mx {
  margin-left: var(--bs-scrollbar-size) !important;
  margin-right: var(--bs-scrollbar-size) !important;
}

@media (min-width: 576px) {
  .scroll-sm-ps {
    padding-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-sm-ms {
    margin-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-sm-mb {
    margin-bottom: var(--bs-scrollbar-size) !important;
  }
  .scroll-sm-pe {
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-sm-me {
    margin-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-sm-px {
    padding-left: var(--bs-scrollbar-size) !important;
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-sm-mx {
    margin-left: var(--bs-scrollbar-size) !important;
    margin-right: var(--bs-scrollbar-size) !important;
  }
}
@media (min-width: 768px) {
  .scroll-md-ps {
    padding-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-md-ms {
    margin-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-md-mb {
    margin-bottom: var(--bs-scrollbar-size) !important;
  }
  .scroll-md-pe {
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-md-me {
    margin-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-md-px {
    padding-left: var(--bs-scrollbar-size) !important;
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-md-mx {
    margin-left: var(--bs-scrollbar-size) !important;
    margin-right: var(--bs-scrollbar-size) !important;
  }
}
@media (min-width: 992px) {
  .scroll-lg-ps {
    padding-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-lg-ms {
    margin-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-lg-mb {
    margin-bottom: var(--bs-scrollbar-size) !important;
  }
  .scroll-lg-pe {
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-lg-me {
    margin-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-lg-px {
    padding-left: var(--bs-scrollbar-size) !important;
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-lg-mx {
    margin-left: var(--bs-scrollbar-size) !important;
    margin-right: var(--bs-scrollbar-size) !important;
  }
}
@media (min-width: 1200px) {
  .scroll-xl-ps {
    padding-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-xl-ms {
    margin-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-xl-mb {
    margin-bottom: var(--bs-scrollbar-size) !important;
  }
  .scroll-xl-pe {
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-xl-me {
    margin-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-xl-px {
    padding-left: var(--bs-scrollbar-size) !important;
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-xl-mx {
    margin-left: var(--bs-scrollbar-size) !important;
    margin-right: var(--bs-scrollbar-size) !important;
  }
}
@media (min-width: 1400px) {
  .scroll-xxl-ps {
    padding-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-xxl-ms {
    margin-left: var(--bs-scrollbar-size) !important;
  }
  .scroll-xxl-mb {
    margin-bottom: var(--bs-scrollbar-size) !important;
  }
  .scroll-xxl-pe {
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-xxl-me {
    margin-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-xxl-px {
    padding-left: var(--bs-scrollbar-size) !important;
    padding-right: var(--bs-scrollbar-size) !important;
  }
  .scroll-xxl-mx {
    margin-left: var(--bs-scrollbar-size) !important;
    margin-right: var(--bs-scrollbar-size) !important;
  }
}
.rating {
  display: flex;
  align-items: center;
}

.rating-input {
  position: absolute !important;
  left: -9999px !important;
}
.rating-input[disabled] {
  display: none;
}

.rating-label {
  padding: 0;
  margin: 0;
}
.rating-label > i, .rating-label > .svg-icon {
  line-height: 1;
  color: var(--bs-rating-color-default);
}

label.rating-label {
  cursor: pointer;
}

div.rating-label.checked > i, div.rating-label.checked > .svg-icon,
label.rating-label > i,
label.rating-label > .svg-icon {
  color: var(--bs-rating-color-active);
}

.rating-input:checked ~ .rating-label > i, .rating-input:checked ~ .rating-label > .svg-icon {
  color: var(--bs-rating-color-default);
}

.rating:hover label.rating-label > i, .rating:hover label.rating-label > .svg-icon {
  color: var(--bs-rating-color-active);
}

label.rating-label:hover ~ .rating-label {
  color: var(--bs-rating-color-default);
}
label.rating-label:hover ~ .rating-label > i, label.rating-label:hover ~ .rating-label > .svg-icon {
  color: var(--bs-rating-color-default);
}

.stepper [data-kt-stepper-element=info],
.stepper [data-kt-stepper-element=content] {
  display: none;
}
.stepper [data-kt-stepper-element=info].current,
.stepper [data-kt-stepper-element=content].current {
  display: flex;
}
.stepper .stepper-item[data-kt-stepper-action=step] {
  cursor: pointer;
}
.stepper [data-kt-stepper-action=final] {
  display: none;
}
.stepper [data-kt-stepper-action=previous] {
  display: none;
}
.stepper [data-kt-stepper-action=next] {
  display: inline-block;
}
.stepper [data-kt-stepper-action=submit] {
  display: none;
}
.stepper.first [data-kt-stepper-action=previous] {
  display: none;
}
.stepper.first [data-kt-stepper-action=next] {
  display: inline-block;
}
.stepper.first [data-kt-stepper-action=submit] {
  display: none;
}
.stepper.between [data-kt-stepper-action=previous] {
  display: inline-block;
}
.stepper.between [data-kt-stepper-action=next] {
  display: inline-block;
}
.stepper.between [data-kt-stepper-action=submit] {
  display: none;
}
.stepper.last [data-kt-stepper-action=final] {
  display: inline-block;
}
.stepper.last [data-kt-stepper-action=final].btn-flex {
  display: flex;
}
.stepper.last [data-kt-stepper-action=previous] {
  display: inline-block;
}
.stepper.last [data-kt-stepper-action=previous].btn-flex {
  display: flex;
}
.stepper.last [data-kt-stepper-action=previous][data-kt-stepper-state=hide-on-last-step] {
  display: none !important;
}
.stepper.last [data-kt-stepper-action=next] {
  display: none;
}
.stepper.last [data-kt-stepper-action=next].btn-flex {
  display: flex;
}
.stepper.last [data-kt-stepper-action=submit] {
  display: inline-block;
}
.stepper.last [data-kt-stepper-action=submit].btn-flex {
  display: flex;
}

.stepper.stepper-pills {
  --bs-stepper-pills-size: 40px;
  --bs-stepper-icon-border-radius: 9px;
  --bs-stepper-icon-check-size: 1rem;
  --bs-stepper-icon-bg-color: var(--bs-primary-light);
  --bs-stepper-icon-bg-color-current: var(--bs-primary);
  --bs-stepper-icon-bg-color-completed: var(--bs-primary-light);
  --bs-stepper-icon-border: 0;
  --bs-stepper-icon-border-current: 0;
  --bs-stepper-icon-border-completed: 0;
  --bs-stepper-icon-number-color: var(--bs-primary);
  --bs-stepper-icon-number-color-current: var(--bs-white);
  --bs-stepper-icon-check-color-completed: var(--bs-primary);
  --bs-stepper-label-title-opacity: 1;
  --bs-stepper-label-title-opacity-current: 1;
  --bs-stepper-label-title-opacity-completed: 1;
  --bs-stepper-label-title-color: var(--bs-gray-800);
  --bs-stepper-label-title-color-current: var(--bs-gray-600);
  --bs-stepper-label-title-color-completed: var(--bs-text-muted);
  --bs-stepper-label-desc-opacity: 1;
  --bs-stepper-label-desc-opacity-current: 1;
  --bs-stepper-label-desc-opacity-completed: 1;
  --bs-stepper-label-desc-color: var(--bs-text-muted);
  --bs-stepper-label-desc-color-current: var(--bs-gray-500);
  --bs-stepper-label-desc-color-completed: var(--bs-gray-500);
  --bs-stepper-line-border: 1px dashed var(--bs-gray-300);
}
.stepper.stepper-pills .stepper-nav {
  display: flex;
}
.stepper.stepper-pills .stepper-item {
  display: flex;
  align-items: center;
  transition: color 0.2s ease;
}
.stepper.stepper-pills .stepper-item .stepper-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.2s ease;
  width: var(--bs-stepper-pills-size);
  height: var(--bs-stepper-pills-size);
  border-radius: var(--bs-stepper-icon-border-radius);
  background-color: var(--bs-stepper-icon-bg-color);
  border: var(--bs-stepper-icon-border);
  margin-right: 1.5rem;
}
.stepper.stepper-pills .stepper-item .stepper-icon .stepper-check {
  display: none;
  font-size: var(--bs-stepper-icon-check-size);
}
.stepper.stepper-pills .stepper-item .stepper-icon .stepper-number {
  font-weight: 600;
  color: var(--bs-stepper-icon-number-color);
  font-size: 1.25rem;
}
.stepper.stepper-pills .stepper-item .stepper-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.stepper.stepper-pills .stepper-item .stepper-label .stepper-title {
  color: var(--bs-stepper-label-title-color);
  opacity: var(--bs-stepper-label-title-opacity);
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 0.3rem;
}
.stepper.stepper-pills .stepper-item .stepper-label .stepper-desc {
  opacity: var(--bs-stepper-label-desc-opacity);
  color: var(--bs-stepper-label-desc-color);
}
.stepper.stepper-pills .stepper-item.current {
  transition: color 0.2s ease;
}
.stepper.stepper-pills .stepper-item.current .stepper-icon {
  transition: color 0.2s ease;
  background-color: var(--bs-stepper-icon-bg-color-current);
  border: var(--bs-stepper-icon-border-current);
}
.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-check {
  display: none;
}
.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-number {
  color: var(--bs-stepper-icon-number-color-current);
  font-size: 1.35rem;
}
.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-title {
  opacity: var(--bs-stepper-label-title-opacity-current);
  color: var(--bs-stepper-label-title-color-current);
}
.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-desc {
  opacity: var(--bs-stepper-label-desc-opacity-current);
  color: var(--bs-stepper-label-desc-color-current);
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon, .stepper.stepper-pills .stepper-item.completed .stepper-icon {
  transition: color 0.2s ease;
  background-color: var(--bs-stepper-icon-bg-color-completed);
  border: var(--bs-stepper-icon-border-completed);
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-check, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-check {
  color: var(--bs-stepper-icon-check-color-completed);
  display: inline-block;
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-number, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-number {
  display: none;
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-title, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-title {
  opacity: var(--bs-stepper-label-title-opacity-completed);
  color: var(--bs-stepper-label-title-color-completed);
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-desc, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-desc {
  opacity: var(--bs-stepper-label-desc-opacity-completed);
  color: var(--bs-stepper-label-desc-color-completed);
}
.stepper.stepper-pills.stepper-column .stepper-nav {
  flex-direction: column;
  align-items: start;
}
.stepper.stepper-pills.stepper-column .stepper-item {
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  padding: 0;
  margin: 0;
}
.stepper.stepper-pills.stepper-column .stepper-wrapper {
  display: flex;
  align-items: center;
}
.stepper.stepper-pills.stepper-column .stepper-icon {
  z-index: 1;
}
.stepper.stepper-pills.stepper-column .stepper-line {
  display: block;
  flex-grow: 1;
  margin-left: calc(var(--bs-stepper-pills-size) / 2);
  border-left: var(--bs-stepper-line-border);
  margin-top: 2px;
  margin-bottom: 2px;
}

.stepper.stepper-links .stepper-nav {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.stepper.stepper-links .stepper-nav .stepper-item {
  position: relative;
  flex-shrink: 0;
  margin: 1rem 1.5rem;
}
.stepper.stepper-links .stepper-nav .stepper-item:after {
  content: " ";
  position: absolute;
  top: 2.3rem;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: transparent;
  transition: color 0.2s ease;
}
.stepper.stepper-links .stepper-nav .stepper-item .stepper-title {
  color: var(--bs-gray-900);
  font-weight: 600;
  font-size: 1.25rem;
}
.stepper.stepper-links .stepper-nav .stepper-item.current {
  transition: color 0.2s ease;
}
.stepper.stepper-links .stepper-nav .stepper-item.current .stepper-title {
  color: var(--bs-primary);
}
.stepper.stepper-links .stepper-nav .stepper-item.current:after {
  background-color: var(--bs-primary);
}
.stepper.stepper-links .stepper-nav .stepper-item.current.mark-completed:last-child .stepper-title, .stepper.stepper-links .stepper-nav .stepper-item.completed .stepper-title {
  color: var(--bs-gray-500);
}

.toggle.collapsible:not(.collapsed) .toggle-off, .toggle.active .toggle-off {
  display: none;
}
.toggle.collapsible.collapsed .toggle-on, .toggle:not(.collapsible):not(.active) .toggle-on {
  display: none;
}

.xehagon {
  clip-path: polygon(45% 1.3397459622%, 46.5797985667% 0.6030737921%, 48.2635182233% 0.1519224699%, 50% 0%, 51.7364817767% 0.1519224699%, 53.4202014333% 0.6030737921%, 55% 1.3397459622%, 89.6410161514% 21.3397459622%, 91.0688922482% 22.3395555688%, 92.3014605826% 23.5721239031%, 93.3012701892% 25%, 94.0379423592% 26.5797985667%, 94.4890936815% 28.2635182233%, 94.6410161514% 30%, 94.6410161514% 70%, 94.4890936815% 71.7364817767%, 94.0379423592% 73.4202014333%, 93.3012701892% 75%, 92.3014605826% 76.4278760969%, 91.0688922482% 77.6604444312%, 89.6410161514% 78.6602540378%, 55% 98.6602540378%, 53.4202014333% 99.3969262079%, 51.7364817767% 99.8480775301%, 50% 100%, 48.2635182233% 99.8480775301%, 46.5797985667% 99.3969262079%, 45% 98.6602540378%, 10.3589838486% 78.6602540378%, 8.9311077518% 77.6604444312%, 7.6985394174% 76.4278760969%, 6.6987298108% 75%, 5.9620576408% 73.4202014333%, 5.5109063185% 71.7364817767%, 5.3589838486% 70%, 5.3589838486% 30%, 5.5109063185% 28.2635182233%, 5.9620576408% 26.5797985667%, 6.6987298108% 25%, 7.6985394174% 23.5721239031%, 8.9311077518% 22.3395555688%, 10.3589838486% 21.3397459622%);
}

.octagon {
  clip-path: polygon(46.1731656763% 0.7612046749%, 47.411809549% 0.3407417371%, 48.6947380778% 0.0855513863%, 50% 0%, 51.3052619222% 0.0855513863%, 52.588190451% 0.3407417371%, 53.8268343237% 0.7612046749%, 82.1111055711% 12.4769334274%, 83.2842712475% 13.0554747147%, 84.3718855375% 13.7821953496%, 85.3553390593% 14.6446609407%, 86.2178046504% 15.6281144625%, 86.9445252853% 16.7157287525%, 87.5230665726% 17.8888944289%, 99.2387953251% 46.1731656763%, 99.6592582629% 47.411809549%, 99.9144486137% 48.6947380778%, 100% 50%, 99.9144486137% 51.3052619222%, 99.6592582629% 52.588190451%, 99.2387953251% 53.8268343237%, 87.5230665726% 82.1111055711%, 86.9445252853% 83.2842712475%, 86.2178046504% 84.3718855375%, 85.3553390593% 85.3553390593%, 84.3718855375% 86.2178046504%, 83.2842712475% 86.9445252853%, 82.1111055711% 87.5230665726%, 53.8268343237% 99.2387953251%, 52.588190451% 99.6592582629%, 51.3052619222% 99.9144486137%, 50% 100%, 48.6947380778% 99.9144486137%, 47.411809549% 99.6592582629%, 46.1731656763% 99.2387953251%, 17.8888944289% 87.5230665726%, 16.7157287525% 86.9445252853%, 15.6281144625% 86.2178046504%, 14.6446609407% 85.3553390593%, 13.7821953496% 84.3718855375%, 13.0554747147% 83.2842712475%, 12.4769334274% 82.1111055711%, 0.7612046749% 53.8268343237%, 0.3407417371% 52.588190451%, 0.0855513863% 51.3052619222%, 0% 50%, 0.0855513863% 48.6947380778%, 0.3407417371% 47.411809549%, 0.7612046749% 46.1731656763%, 12.4769334274% 17.8888944289%, 13.0554747147% 16.7157287525%, 13.7821953496% 15.6281144625%, 14.6446609407% 14.6446609407%, 15.6281144625% 13.7821953496%, 16.7157287525% 13.0554747147%, 17.8888944289% 12.4769334274%);
}

.ribbon {
  position: relative;
}
.ribbon .ribbon-label {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  background-color: var(--bs-ribbon-label-bg);
  box-shadow: var(--bs-ribbon-label-box-shadow);
  color: var(--bs-primary-inverse);
  top: 50%;
  right: 0;
  transform: translateX(5px) translateY(-50%);
}
.ribbon .ribbon-label > .ribbon-inner {
  z-index: -1;
  position: absolute;
  padding: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.ribbon .ribbon-label:after {
  border-color: var(--bs-ribbon-label-border-color);
}
.ribbon-vertical .ribbon-label {
  padding: 5px 10px;
  min-width: 36px;
  min-height: 46px;
  text-align: center;
}
.ribbon.ribbon-top .ribbon-label {
  top: 0;
  transform: translateX(-15px) translateY(-4px);
  border-bottom-right-radius: 0.65rem;
  border-bottom-left-radius: 0.65rem;
}
.ribbon.ribbon-bottom .ribbon-label {
  border-top-right-radius: 0.65rem;
  border-top-left-radius: 0.65rem;
}
.ribbon.ribbon-start .ribbon-label {
  top: 50%;
  left: 0;
  right: auto;
  transform: translateX(-5px) translateY(-50%);
  border-top-right-radius: 0.65rem;
  border-bottom-right-radius: 0.65rem;
}
.ribbon.ribbon-end .ribbon-label {
  border-top-left-radius: 0.65rem;
  border-bottom-left-radius: 0.65rem;
}

.ribbon.ribbon-clip.ribbon-start .ribbon-label {
  left: -5px;
}
.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner {
  border-top-right-radius: 0.65rem;
  border-bottom-right-radius: 0.65rem;
}
.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-color: transparent !important;
  bottom: -10px;
}
.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before {
  border-width: 0 10px 10px 0;
  border-right-color: var(--bs-ribbon-clip-bg) !important;
  left: 0;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label {
  right: -5px;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner {
  border-top-left-radius: 0.65rem;
  border-bottom-left-radius: 0.65rem;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-color: transparent !important;
  bottom: -10px;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before {
  border-width: 0 0 10px 10px;
  border-left-color: var(--bs-ribbon-clip-bg) !important;
  right: 0;
}

.ribbon.ribbon-triangle {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.ribbon.ribbon-triangle.ribbon-top-start {
  top: 0;
  left: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent !important;
  border-left: solid 2rem transparent;
  border-right: solid 2rem transparent !important;
  border-top: solid 2rem transparent;
}
.ribbon.ribbon-triangle.ribbon-top-end {
  top: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent !important;
  border-left: solid 2rem transparent !important;
  border-right: solid 2rem transparent;
  border-top: solid 2rem transparent;
}
.ribbon.ribbon-triangle.ribbon-bottom-start {
  bottom: 0;
  left: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent;
  border-left: solid 2rem transparent;
  border-right: solid 2rem transparent !important;
  border-top: solid 2rem transparent !important;
}
.ribbon.ribbon-triangle.ribbon-bottom-end {
  bottom: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent;
  border-right: solid 2rem transparent;
  border-left: solid 2rem transparent !important;
  border-top: solid 2rem transparent !important;
}

.blockui {
  position: relative;
}
.blockui .blockui-overlay {
  transition: all 0.3s ease;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bs-blockui-overlay-bg);
}
.blockui .blockui-overlay .spinner-border {
  height: 1.35rem;
  width: 1.35rem;
}
.blockui .blockui-message {
  display: flex;
  align-items: center;
  border-radius: 0.65rem;
  box-shadow: var(--bs-blockui-message-box-shadow);
  background-color: var(--bs-blockui-message-bg);
  color: var(--bs-gray-700);
  font-weight: 600;
  margin: 0 !important;
  width: auto;
  padding: 0.85rem 1.75rem !important;
}
.blockui .blockui-message .spinner-border {
  margin-right: 0.65rem;
}

[data-bs-theme=dark] .blockui {
  --bs-blockui-overlay-bg: rgba(255, 255, 255, 0.05);
  --bs-blockui-message-bg: #26272F;
  --bs-blockui-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);
}

.explore-btn-toggle {
  color: var(--bs-gray-600);
  background-color: #ffffff;
}
.explore-btn-toggle:hover, .explore-btn-toggle:focus, .explore-btn-toggle:active {
  color: #ffffff;
  background-color: #00B2FF;
}

.explore-btn-dismiss {
  border: 0;
}
.explore-btn-dismiss:hover i,
.explore-btn-dismiss:hover .svg-icon {
  color: #00B2FF;
}

.explore-btn-primary {
  border: 0;
  color: #ffffff;
  background-color: #00B2FF;
}
.explore-btn-primary:hover {
  color: #ffffff;
  background-color: #0098DA;
}

.explore-btn-secondary {
  border: 0;
  color: var(--bs-gray-600);
  background-color: var(--bs-gray-100);
}
.explore-btn-secondary:hover {
  color: var(--bs-gray-800);
  background-color: var(--bs-gray-200);
}

.explore-btn-outline {
  border: 1px dashed var(--bs-gray-300) !important;
}
.explore-btn-outline:hover, .explore-btn-outline.active {
  border: 1px dashed #50CD89 !important;
  background-color: #E8FFF3;
}

.explore-link {
  color: #00B2FF;
}
.explore-link:hover {
  color: #0098DA;
}

.explore-link-hover:hover {
  color: #00B2FF !important;
}

.explore-icon-success {
  color: #50CD89;
}

.explore-icon-danger {
  color: #F1416C;
}

.explore-label-free {
  color: #ffffff;
  background-color: #FFC700;
}

.explore-label-pro {
  color: #ffffff;
  background-color: #50CD89;
}

.app-engage {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 5;
  padding-right: 12px;
}
.app-engage .app-engage-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: var(--bs-engage-btn-box-shadow);
  border-width: 1px;
  border-style: solid;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 8px;
  border-radius: 6px;
  width: 66px;
  height: 70px;
  color: var(--bs-engage-btn-color);
  border-color: var(--bs-engage-btn-border-color);
  background-color: var(--bs-engage-btn-bg);
}
.app-engage .app-engage-btn i,
.app-engage .app-engage-btn .svg-icon {
  color: var(--bs-engage-btn-icon-color);
}
.app-engage .app-engage-btn.dropdown-toggle:after {
  color: var(--bs-engage-btn-icon-color);
}
.app-engage .app-engage-btn.hover-dark:hover {
  color: var(--bs-dark-inverse);
  border-color: var(--bs-dark);
  background-color: var(--bs-dark);
}
.app-engage .app-engage-btn.hover-dark:hover i,
.app-engage .app-engage-btn.hover-dark:hover .svg-icon {
  color: var(--bs-dark-inverse);
}
.app-engage .app-engage-btn.hover-primary:hover {
  color: var(--bs-primary-inverse);
  border-color: var(--bs-primary);
  background-color: var(--bs-primary);
}
.app-engage .app-engage-btn.hover-primary:hover i,
.app-engage .app-engage-btn.hover-primary:hover .svg-icon {
  color: var(--bs-primary-inverse);
}
.app-engage .app-engage-btn.hover-success:hover {
  color: var(--bs-success-inverse);
  border-color: var(--bs-success);
  background-color: var(--bs-success);
}
.app-engage .app-engage-btn.hover-success:hover i,
.app-engage .app-engage-btn.hover-success:hover .svg-icon {
  color: var(--bs-success-inverse);
}
.app-engage .app-engage-btn.app-engage-btn-toggle-off {
  width: 35px;
  height: 35px;
}
.app-engage .app-engage-btn.app-engage-btn-toggle-on {
  width: 35px;
  height: 35px;
  display: none;
}
.app-engage.app-engage-hide .app-engage-btn {
  visibility: hidden;
}
.app-engage.app-engage-hide .app-engage-btn.app-engage-btn-toggle-off {
  display: none;
}
.app-engage.app-engage-hide .app-engage-btn.app-engage-btn-toggle-on {
  visibility: visible;
  display: flex;
}

.engage-btn {
  display: flex;
  align-items: center;
  height: 35px !important;
  color: var(--bs-engage-btn-color);
  border-color: var(--bs-engage-btn-bg);
  background-color: var(--bs-engage-btn-bg);
}
.engage-btn i,
.engage-btn .svg-icon {
  color: var(--bs-engage-btn-color);
}
.engage-btn.dropdown-toggle:after {
  color: var(--bs-engage-btn-color);
}
.btn-check:checked + .engage-btn, .btn-check:active + .engage-btn, .engage-btn:focus:not(.btn-active), .engage-btn:hover:not(.btn-active), .engage-btn:active:not(.btn-active), .engage-btn.active, .engage-btn.show, .show > .engage-btn {
  color: var(--bs-engage-btn-color-active);
  border-color: var(--bs-engage-btn-bg);
  background-color: var(--bs-engage-btn-bg) !important;
}
.btn-check:checked + .engage-btn i,
.btn-check:checked + .engage-btn .svg-icon, .btn-check:active + .engage-btn i,
.btn-check:active + .engage-btn .svg-icon, .engage-btn:focus:not(.btn-active) i,
.engage-btn:focus:not(.btn-active) .svg-icon, .engage-btn:hover:not(.btn-active) i,
.engage-btn:hover:not(.btn-active) .svg-icon, .engage-btn:active:not(.btn-active) i,
.engage-btn:active:not(.btn-active) .svg-icon, .engage-btn.active i,
.engage-btn.active .svg-icon, .engage-btn.show i,
.engage-btn.show .svg-icon, .show > .engage-btn i,
.show > .engage-btn .svg-icon {
  color: var(--bs-engage-btn-color-active);
}
.btn-check:checked + .engage-btn.dropdown-toggle:after, .btn-check:active + .engage-btn.dropdown-toggle:after, .engage-btn:focus:not(.btn-active).dropdown-toggle:after, .engage-btn:hover:not(.btn-active).dropdown-toggle:after, .engage-btn:active:not(.btn-active).dropdown-toggle:after, .engage-btn.active.dropdown-toggle:after, .engage-btn.show.dropdown-toggle:after, .show > .engage-btn.dropdown-toggle:after {
  color: var(--bs-engage-btn-color-active);
}

.cookiealert {
  background: inherit;
  color: inherit;
}

@media print {
  .print-content-only {
    padding: 0 !important;
    background: none !important;
  }
  .print-content-only .wrapper,
  .print-content-only .page,
  .print-content-only .page-title .content,
  .print-content-only .container,
  .print-content-only .container-xxl,
  .print-content-only .container-fluid,
  .print-content-only .container-sm,
  .print-content-only .container-md,
  .print-content-only .container-lg,
  .print-content-only .container-xl {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .print-content-only .aside,
  .print-content-only .sidebar,
  .print-content-only .scrolltop,
  .print-content-only .header,
  .print-content-only .footer,
  .print-content-only .toolbar,
  .print-content-only .drawer,
  .print-content-only .btn {
    display: none !important;
  }
}
.bg-white {
  --bs-bg-rgb-color: var(--bs-white-bg-rgb);
  background-color: #ffffff !important;
}

.bg-black {
  --bs-bg-rgb-color: var(--bs-black-bg-rgb);
  background-color: #000000 !important;
}

.bg-body {
  --bs-bg-rgb-color: var(--bs-body-bg-rgb);
  background-color: var(--bs-body-bg) !important;
}

.bg-hover-body {
  cursor: pointer;
}
.bg-hover-body:hover {
  background-color: var(--bs-body-bg) !important;
}

.bg-active-body.active {
  background-color: var(--bs-body-bg) !important;
}

.bg-state-body {
  cursor: pointer;
}
.bg-state-body.active, .bg-state-body:hover {
  background-color: var(--bs-body-bg) !important;
}

.bg-hover-white {
  cursor: pointer;
}
.bg-hover-white:hover {
  --bs-bg-rgb-color: var(--bs-white-bg-rgb);
  background-color: #ffffff !important;
}

.bg-active-white.active {
  --bs-bg-rgb-color: var(--bs-white-bg-rgb);
  background-color: #ffffff !important;
}

.bg-state-white {
  cursor: pointer;
}
.bg-state-white.active, .bg-state-white:hover {
  --bs-bg-rgb-color: var(--bs-white-bg-rgb);
  background-color: #ffffff !important;
}

.bg-light-light {
  background-color: var(--bs-light-light) !important;
}

.bg-light {
  --bs-bg-rgb-color: var(--bs-light-rgb);
  background-color: var(--bs-light) !important;
}

.bg-light-active {
  --bs-bg-rgb-color: var(--bs-light-active-rgb);
  background-color: var(--bs-light-active) !important;
}

.bg-hover-light-light {
  cursor: pointer;
}
.bg-hover-light-light:hover {
  background-color: var(--bs-light-light) !important;
}

.bg-state-light-light {
  cursor: pointer;
}
.bg-state-light-light.active, .bg-state-light-light:hover {
  background-color: var(--bs-light-light) !important;
}

.bg-hover-light {
  cursor: pointer;
}
.bg-hover-light:hover {
  background-color: var(--bs-light) !important;
}

.bg-active-light.active {
  background-color: var(--bs-light) !important;
}

.bg-state-light {
  cursor: pointer;
}
.bg-state-light.active, .bg-state-light:hover {
  background-color: var(--bs-light) !important;
}

.bg-light-primary {
  background-color: var(--bs-primary-light) !important;
}

.bg-primary {
  --bs-bg-rgb-color: var(--bs-primary-rgb);
  background-color: var(--bs-primary) !important;
}

.bg-primary-active {
  --bs-bg-rgb-color: var(--bs-primary-active-rgb);
  background-color: var(--bs-primary-active) !important;
}

.bg-hover-light-primary {
  cursor: pointer;
}
.bg-hover-light-primary:hover {
  background-color: var(--bs-primary-light) !important;
}

.bg-state-light-primary {
  cursor: pointer;
}
.bg-state-light-primary.active, .bg-state-light-primary:hover {
  background-color: var(--bs-primary-light) !important;
}

.bg-hover-primary {
  cursor: pointer;
}
.bg-hover-primary:hover {
  background-color: var(--bs-primary) !important;
}

.bg-active-primary.active {
  background-color: var(--bs-primary) !important;
}

.bg-state-primary {
  cursor: pointer;
}
.bg-state-primary.active, .bg-state-primary:hover {
  background-color: var(--bs-primary) !important;
}

.bg-light-secondary {
  background-color: var(--bs-secondary-light) !important;
}

.bg-secondary {
  --bs-bg-rgb-color: var(--bs-secondary-rgb);
  background-color: var(--bs-secondary) !important;
}

.bg-secondary-active {
  --bs-bg-rgb-color: var(--bs-secondary-active-rgb);
  background-color: var(--bs-secondary-active) !important;
}

.bg-hover-light-secondary {
  cursor: pointer;
}
.bg-hover-light-secondary:hover {
  background-color: var(--bs-secondary-light) !important;
}

.bg-state-light-secondary {
  cursor: pointer;
}
.bg-state-light-secondary.active, .bg-state-light-secondary:hover {
  background-color: var(--bs-secondary-light) !important;
}

.bg-hover-secondary {
  cursor: pointer;
}
.bg-hover-secondary:hover {
  background-color: var(--bs-secondary) !important;
}

.bg-active-secondary.active {
  background-color: var(--bs-secondary) !important;
}

.bg-state-secondary {
  cursor: pointer;
}
.bg-state-secondary.active, .bg-state-secondary:hover {
  background-color: var(--bs-secondary) !important;
}

.bg-light-success {
  background-color: var(--bs-success-light) !important;
}

.bg-success {
  --bs-bg-rgb-color: var(--bs-success-rgb);
  background-color: var(--bs-success) !important;
}

.bg-success-active {
  --bs-bg-rgb-color: var(--bs-success-active-rgb);
  background-color: var(--bs-success-active) !important;
}

.bg-hover-light-success {
  cursor: pointer;
}
.bg-hover-light-success:hover {
  background-color: var(--bs-success-light) !important;
}

.bg-state-light-success {
  cursor: pointer;
}
.bg-state-light-success.active, .bg-state-light-success:hover {
  background-color: var(--bs-success-light) !important;
}

.bg-hover-success {
  cursor: pointer;
}
.bg-hover-success:hover {
  background-color: var(--bs-success) !important;
}

.bg-active-success.active {
  background-color: var(--bs-success) !important;
}

.bg-state-success {
  cursor: pointer;
}
.bg-state-success.active, .bg-state-success:hover {
  background-color: var(--bs-success) !important;
}

.bg-light-info {
  background-color: var(--bs-info-light) !important;
}

.bg-info {
  --bs-bg-rgb-color: var(--bs-info-rgb);
  background-color: var(--bs-info) !important;
}

.bg-info-active {
  --bs-bg-rgb-color: var(--bs-info-active-rgb);
  background-color: var(--bs-info-active) !important;
}

.bg-hover-light-info {
  cursor: pointer;
}
.bg-hover-light-info:hover {
  background-color: var(--bs-info-light) !important;
}

.bg-state-light-info {
  cursor: pointer;
}
.bg-state-light-info.active, .bg-state-light-info:hover {
  background-color: var(--bs-info-light) !important;
}

.bg-hover-info {
  cursor: pointer;
}
.bg-hover-info:hover {
  background-color: var(--bs-info) !important;
}

.bg-active-info.active {
  background-color: var(--bs-info) !important;
}

.bg-state-info {
  cursor: pointer;
}
.bg-state-info.active, .bg-state-info:hover {
  background-color: var(--bs-info) !important;
}

.bg-light-warning {
  background-color: var(--bs-warning-light) !important;
}

.bg-warning {
  --bs-bg-rgb-color: var(--bs-warning-rgb);
  background-color: var(--bs-warning) !important;
}

.bg-warning-active {
  --bs-bg-rgb-color: var(--bs-warning-active-rgb);
  background-color: var(--bs-warning-active) !important;
}

.bg-hover-light-warning {
  cursor: pointer;
}
.bg-hover-light-warning:hover {
  background-color: var(--bs-warning-light) !important;
}

.bg-state-light-warning {
  cursor: pointer;
}
.bg-state-light-warning.active, .bg-state-light-warning:hover {
  background-color: var(--bs-warning-light) !important;
}

.bg-hover-warning {
  cursor: pointer;
}
.bg-hover-warning:hover {
  background-color: var(--bs-warning) !important;
}

.bg-active-warning.active {
  background-color: var(--bs-warning) !important;
}

.bg-state-warning {
  cursor: pointer;
}
.bg-state-warning.active, .bg-state-warning:hover {
  background-color: var(--bs-warning) !important;
}

.bg-light-danger {
  background-color: var(--bs-danger-light) !important;
}

.bg-danger {
  --bs-bg-rgb-color: var(--bs-danger-rgb);
  background-color: var(--bs-danger) !important;
}

.bg-danger-active {
  --bs-bg-rgb-color: var(--bs-danger-active-rgb);
  background-color: var(--bs-danger-active) !important;
}

.bg-hover-light-danger {
  cursor: pointer;
}
.bg-hover-light-danger:hover {
  background-color: var(--bs-danger-light) !important;
}

.bg-state-light-danger {
  cursor: pointer;
}
.bg-state-light-danger.active, .bg-state-light-danger:hover {
  background-color: var(--bs-danger-light) !important;
}

.bg-hover-danger {
  cursor: pointer;
}
.bg-hover-danger:hover {
  background-color: var(--bs-danger) !important;
}

.bg-active-danger.active {
  background-color: var(--bs-danger) !important;
}

.bg-state-danger {
  cursor: pointer;
}
.bg-state-danger.active, .bg-state-danger:hover {
  background-color: var(--bs-danger) !important;
}

.bg-light-dark {
  background-color: var(--bs-dark-light) !important;
}

.bg-dark {
  --bs-bg-rgb-color: var(--bs-dark-rgb);
  background-color: var(--bs-dark) !important;
}

.bg-dark-active {
  --bs-bg-rgb-color: var(--bs-dark-active-rgb);
  background-color: var(--bs-dark-active) !important;
}

.bg-hover-light-dark {
  cursor: pointer;
}
.bg-hover-light-dark:hover {
  background-color: var(--bs-dark-light) !important;
}

.bg-state-light-dark {
  cursor: pointer;
}
.bg-state-light-dark.active, .bg-state-light-dark:hover {
  background-color: var(--bs-dark-light) !important;
}

.bg-hover-dark {
  cursor: pointer;
}
.bg-hover-dark:hover {
  background-color: var(--bs-dark) !important;
}

.bg-active-dark.active {
  background-color: var(--bs-dark) !important;
}

.bg-state-dark {
  cursor: pointer;
}
.bg-state-dark.active, .bg-state-dark:hover {
  background-color: var(--bs-dark) !important;
}

.bg-gray-100 {
  --bs-bg-rgb-color: var(--bs-gray-100-rgb);
  background-color: var(--bs-gray-100);
}

.bg-hover-gray-100:hover {
  --bs-bg-rgb-color: var(--bs-gray-100-rgb);
  background-color: var(--bs-gray-100);
}

.bg-gray-100i {
  --bs-bg-rgb-color: var(--bs-gray-100-rgb);
  background-color: var(--bs-gray-100) !important;
}

.bg-gray-200 {
  --bs-bg-rgb-color: var(--bs-gray-200-rgb);
  background-color: var(--bs-gray-200);
}

.bg-hover-gray-200:hover {
  --bs-bg-rgb-color: var(--bs-gray-200-rgb);
  background-color: var(--bs-gray-200);
}

.bg-gray-200i {
  --bs-bg-rgb-color: var(--bs-gray-200-rgb);
  background-color: var(--bs-gray-200) !important;
}

.bg-gray-300 {
  --bs-bg-rgb-color: var(--bs-gray-300-rgb);
  background-color: var(--bs-gray-300);
}

.bg-hover-gray-300:hover {
  --bs-bg-rgb-color: var(--bs-gray-300-rgb);
  background-color: var(--bs-gray-300);
}

.bg-gray-300i {
  --bs-bg-rgb-color: var(--bs-gray-300-rgb);
  background-color: var(--bs-gray-300) !important;
}

.bg-gray-400 {
  --bs-bg-rgb-color: var(--bs-gray-400-rgb);
  background-color: var(--bs-gray-400);
}

.bg-hover-gray-400:hover {
  --bs-bg-rgb-color: var(--bs-gray-400-rgb);
  background-color: var(--bs-gray-400);
}

.bg-gray-400i {
  --bs-bg-rgb-color: var(--bs-gray-400-rgb);
  background-color: var(--bs-gray-400) !important;
}

.bg-gray-500 {
  --bs-bg-rgb-color: var(--bs-gray-500-rgb);
  background-color: var(--bs-gray-500);
}

.bg-hover-gray-500:hover {
  --bs-bg-rgb-color: var(--bs-gray-500-rgb);
  background-color: var(--bs-gray-500);
}

.bg-gray-500i {
  --bs-bg-rgb-color: var(--bs-gray-500-rgb);
  background-color: var(--bs-gray-500) !important;
}

.bg-gray-600 {
  --bs-bg-rgb-color: var(--bs-gray-600-rgb);
  background-color: var(--bs-gray-600);
}

.bg-hover-gray-600:hover {
  --bs-bg-rgb-color: var(--bs-gray-600-rgb);
  background-color: var(--bs-gray-600);
}

.bg-gray-600i {
  --bs-bg-rgb-color: var(--bs-gray-600-rgb);
  background-color: var(--bs-gray-600) !important;
}

.bg-gray-700 {
  --bs-bg-rgb-color: var(--bs-gray-700-rgb);
  background-color: var(--bs-gray-700);
}

.bg-hover-gray-700:hover {
  --bs-bg-rgb-color: var(--bs-gray-700-rgb);
  background-color: var(--bs-gray-700);
}

.bg-gray-700i {
  --bs-bg-rgb-color: var(--bs-gray-700-rgb);
  background-color: var(--bs-gray-700) !important;
}

.bg-gray-800 {
  --bs-bg-rgb-color: var(--bs-gray-800-rgb);
  background-color: var(--bs-gray-800);
}

.bg-hover-gray-800:hover {
  --bs-bg-rgb-color: var(--bs-gray-800-rgb);
  background-color: var(--bs-gray-800);
}

.bg-gray-800i {
  --bs-bg-rgb-color: var(--bs-gray-800-rgb);
  background-color: var(--bs-gray-800) !important;
}

.bg-gray-900 {
  --bs-bg-rgb-color: var(--bs-gray-900-rgb);
  background-color: var(--bs-gray-900);
}

.bg-hover-gray-900:hover {
  --bs-bg-rgb-color: var(--bs-gray-900-rgb);
  background-color: var(--bs-gray-900);
}

.bg-gray-900i {
  --bs-bg-rgb-color: var(--bs-gray-900-rgb);
  background-color: var(--bs-gray-900) !important;
}

.bg-opacity-0 {
  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;
}

.bg-hover-opacity-0:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;
}

.bg-active-opacity-0.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;
}

.bg-state-opacity-0 .active, .bg-state-opacity-0:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;
}

.bg-opacity-5 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;
}

.bg-hover-opacity-5:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;
}

.bg-active-opacity-5.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;
}

.bg-state-opacity-5 .active, .bg-state-opacity-5:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;
}

.bg-opacity-10 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;
}

.bg-hover-opacity-10:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;
}

.bg-active-opacity-10.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;
}

.bg-state-opacity-10 .active, .bg-state-opacity-10:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;
}

.bg-opacity-15 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;
}

.bg-hover-opacity-15:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;
}

.bg-active-opacity-15.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;
}

.bg-state-opacity-15 .active, .bg-state-opacity-15:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;
}

.bg-opacity-20 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;
}

.bg-hover-opacity-20:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;
}

.bg-active-opacity-20.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;
}

.bg-state-opacity-20 .active, .bg-state-opacity-20:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;
}

.bg-opacity-25 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;
}

.bg-hover-opacity-25:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;
}

.bg-active-opacity-25.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;
}

.bg-state-opacity-25 .active, .bg-state-opacity-25:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;
}

.bg-opacity-50 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;
}

.bg-hover-opacity-50:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;
}

.bg-active-opacity-50.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;
}

.bg-state-opacity-50 .active, .bg-state-opacity-50:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;
}

.bg-opacity-75 {
  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;
}

.bg-hover-opacity-75:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;
}

.bg-active-opacity-75.active {
  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;
}

.bg-state-opacity-75 .active, .bg-state-opacity-75:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;
}

.bg-opacity-100 {
  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;
}

.bg-hover-opacity-100:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;
}

.bg-active-opacity-100.active {
  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;
}

.bg-state-opacity-100 .active, .bg-state-opacity-100:hover {
  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;
}

.bgi-no-repeat {
  background-repeat: no-repeat;
}

.bgi-position-y-top {
  background-position-y: top;
}

.bgi-position-y-bottom {
  background-position-y: bottom;
}

.bgi-position-y-center {
  background-position-y: center;
}

.bgi-position-x-start {
  background-position-x: left;
}

.bgi-position-x-end {
  background-position-x: right;
}

.bgi-position-x-center {
  background-position-x: center;
}

.bgi-position-top {
  background-position: 0 top;
}

.bgi-position-bottom {
  background-position: 0 bottom;
}

.bgi-position-center {
  background-position: center;
}

.bgi-size-auto {
  background-size: auto;
}

.bgi-size-cover {
  background-size: cover;
}

.bgi-size-contain {
  background-size: contain;
}

.bgi-attachment-fixed {
  background-attachment: fixed;
}

.bgi-attachment-scroll {
  background-attachment: scroll;
}

@media (min-width: 576px) {
  .bgi-size-sm-auto {
    background-size: auto;
  }
  .bgi-size-sm-cover {
    background-size: cover;
  }
  .bgi-size-sm-contain {
    background-size: contain;
  }
  .bgi-attachment-sm-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-sm-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 768px) {
  .bgi-size-md-auto {
    background-size: auto;
  }
  .bgi-size-md-cover {
    background-size: cover;
  }
  .bgi-size-md-contain {
    background-size: contain;
  }
  .bgi-attachment-md-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-md-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 992px) {
  .bgi-size-lg-auto {
    background-size: auto;
  }
  .bgi-size-lg-cover {
    background-size: cover;
  }
  .bgi-size-lg-contain {
    background-size: contain;
  }
  .bgi-attachment-lg-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-lg-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 1200px) {
  .bgi-size-xl-auto {
    background-size: auto;
  }
  .bgi-size-xl-cover {
    background-size: cover;
  }
  .bgi-size-xl-contain {
    background-size: contain;
  }
  .bgi-attachment-xl-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-xl-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 1400px) {
  .bgi-size-xxl-auto {
    background-size: auto;
  }
  .bgi-size-xxl-cover {
    background-size: cover;
  }
  .bgi-size-xxl-contain {
    background-size: contain;
  }
  .bgi-attachment-xxl-fixed {
    background-attachment: fixed;
  }
  .bgi-attachment-xxl-scroll {
    background-attachment: scroll;
  }
}
.border-active:not(.active):not(:active):not(:hover):not(:focus) {
  border-color: transparent !important;
}

.border-hover:not(:hover):not(:focus):not(.active):not(:active) {
  cursor: pointer;
  border-color: transparent !important;
}

.border-gray-100 {
  border-color: var(--bs-gray-100) !important;
}

.border-gray-200 {
  border-color: var(--bs-gray-200) !important;
}

.border-gray-300 {
  border-color: var(--bs-gray-300) !important;
}

.border-gray-400 {
  border-color: var(--bs-gray-400) !important;
}

.border-gray-500 {
  border-color: var(--bs-gray-500) !important;
}

.border-gray-600 {
  border-color: var(--bs-gray-600) !important;
}

.border-gray-700 {
  border-color: var(--bs-gray-700) !important;
}

.border-gray-800 {
  border-color: var(--bs-gray-800) !important;
}

.border-gray-900 {
  border-color: var(--bs-gray-900) !important;
}

.border-hover-light:hover {
  border-color: var(--bs-light) !important;
}

.border-active-light.active {
  border-color: var(--bs-light) !important;
}

.border-hover-primary:hover {
  border-color: var(--bs-primary) !important;
}

.border-active-primary.active {
  border-color: var(--bs-primary) !important;
}

.border-hover-secondary:hover {
  border-color: var(--bs-secondary) !important;
}

.border-active-secondary.active {
  border-color: var(--bs-secondary) !important;
}

.border-hover-success:hover {
  border-color: var(--bs-success) !important;
}

.border-active-success.active {
  border-color: var(--bs-success) !important;
}

.border-hover-info:hover {
  border-color: var(--bs-info) !important;
}

.border-active-info.active {
  border-color: var(--bs-info) !important;
}

.border-hover-warning:hover {
  border-color: var(--bs-warning) !important;
}

.border-active-warning.active {
  border-color: var(--bs-warning) !important;
}

.border-hover-danger:hover {
  border-color: var(--bs-danger) !important;
}

.border-active-danger.active {
  border-color: var(--bs-danger) !important;
}

.border-hover-dark:hover {
  border-color: var(--bs-dark) !important;
}

.border-active-dark.active {
  border-color: var(--bs-dark) !important;
}

.border-hover-transparent:hover {
  border-color: transparent !important;
}

.border-dashed {
  border-style: dashed !important;
  border-color: var(--bs-border-dashed-color);
}

.border-top-dashed {
  border-top-style: dashed !important;
}

.border-bottom-dashed {
  border-bottom-style: dashed !important;
}

.border-start-dashed {
  border-left-style: dashed !important;
}

.border-end-dashed {
  border-right-style: dashed !important;
}

.border-dotted {
  border-style: dotted !important;
}

.border-top-dotted {
  border-top-style: dotted !important;
}

.border-bottom-dotted {
  border-bottom-style: dotted !important;
}

.border-start-dotted {
  border-left-style: dotted !important;
}

.border-end-dotted {
  border-right-style: dotted !important;
}

.border-transparent {
  border-color: transparent !important;
}

.border-body {
  border-color: var(--bs-body-bg) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-bottom-0 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-start-0 {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.flex-root {
  flex: 1 1;
}

.flex-column-auto {
  flex: none;
}

.flex-column-fluid {
  flex: 1 0 auto;
}

.flex-row-auto {
  flex: 0 0 auto;
}

.flex-row-fluid {
  flex: 1 1 auto;
  min-width: 0;
}

.flex-center {
  justify-content: center;
  align-items: center;
}

.flex-start {
  justify-content: start;
  align-items: start;
}

.flex-end {
  justify-content: flex-end;
  align-items: flex-end;
}

.flex-stack {
  justify-content: space-between;
  align-items: center;
}

@media (min-width: 576px) {
  .flex-sm-root {
    flex: 1 1;
  }
  .flex-sm-column-auto {
    flex: none;
  }
  .flex-sm-column-fluid {
    flex: 1 0 auto;
  }
  .flex-sm-row-auto {
    flex: 0 0 auto;
  }
  .flex-sm-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-sm-center {
    justify-content: center;
    align-items: center;
  }
  .flex-sm-start {
    justify-content: start;
    align-items: start;
  }
  .flex-sm-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-sm-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 768px) {
  .flex-md-root {
    flex: 1 1;
  }
  .flex-md-column-auto {
    flex: none;
  }
  .flex-md-column-fluid {
    flex: 1 0 auto;
  }
  .flex-md-row-auto {
    flex: 0 0 auto;
  }
  .flex-md-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-md-center {
    justify-content: center;
    align-items: center;
  }
  .flex-md-start {
    justify-content: start;
    align-items: start;
  }
  .flex-md-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-md-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 992px) {
  .flex-lg-root {
    flex: 1 1;
  }
  .flex-lg-column-auto {
    flex: none;
  }
  .flex-lg-column-fluid {
    flex: 1 0 auto;
  }
  .flex-lg-row-auto {
    flex: 0 0 auto;
  }
  .flex-lg-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-lg-center {
    justify-content: center;
    align-items: center;
  }
  .flex-lg-start {
    justify-content: start;
    align-items: start;
  }
  .flex-lg-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-lg-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 1200px) {
  .flex-xl-root {
    flex: 1 1;
  }
  .flex-xl-column-auto {
    flex: none;
  }
  .flex-xl-column-fluid {
    flex: 1 0 auto;
  }
  .flex-xl-row-auto {
    flex: 0 0 auto;
  }
  .flex-xl-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-xl-center {
    justify-content: center;
    align-items: center;
  }
  .flex-xl-start {
    justify-content: start;
    align-items: start;
  }
  .flex-xl-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-xl-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 1400px) {
  .flex-xxl-root {
    flex: 1 1;
  }
  .flex-xxl-column-auto {
    flex: none;
  }
  .flex-xxl-column-fluid {
    flex: 1 0 auto;
  }
  .flex-xxl-row-auto {
    flex: 0 0 auto;
  }
  .flex-xxl-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }
  .flex-xxl-center {
    justify-content: center;
    align-items: center;
  }
  .flex-xxl-start {
    justify-content: start;
    align-items: start;
  }
  .flex-xxl-end {
    justify-content: flex-end;
    align-items: flex-end;
  }
  .flex-xxl-stack {
    justify-content: space-between;
    align-items: center;
  }
}
.flex-equal {
  flex-grow: 1;
  flex-basis: 0;
  flex-shrink: 0;
}

.shadow-xs {
  box-shadow: var(--bs-box-shadow-xs);
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm);
}

.shadow {
  box-shadow: var(--bs-box-shadow);
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg);
}

.text-white {
  color: var(--bs-text-white) !important;
}

.text-hover-white {
  transition: color 0.2s ease;
}
.text-hover-white i {
  transition: color 0.2s ease;
}
.text-hover-white:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}
.text-hover-white:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}
.text-hover-white:hover .svg-icon {
  color: var(--bs-text-white) !important;
}

.text-active-white {
  transition: color 0.2s ease;
}
.text-active-white i {
  transition: color 0.2s ease;
}
.text-active-white.active {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}
.text-active-white.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}
.text-active-white.active .svg-icon {
  color: var(--bs-text-white) !important;
}

.text-primary {
  color: var(--bs-text-primary) !important;
}

.text-inverse-primary {
  color: var(--bs-primary-inverse) !important;
}

.text-light-primary {
  color: var(--bs-primary-light) !important;
}

.text-hover-primary {
  transition: color 0.2s ease;
}
.text-hover-primary i {
  transition: color 0.2s ease;
}
.text-hover-primary:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}
.text-hover-primary:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}
.text-hover-primary:hover .svg-icon {
  color: var(--bs-text-primary) !important;
}

.text-active-primary {
  transition: color 0.2s ease;
}
.text-active-primary i {
  transition: color 0.2s ease;
}
.text-active-primary.active {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}
.text-active-primary.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}
.text-active-primary.active .svg-icon {
  color: var(--bs-text-primary) !important;
}

.text-secondary {
  color: var(--bs-text-secondary) !important;
}

.text-inverse-secondary {
  color: var(--bs-secondary-inverse) !important;
}

.text-light-secondary {
  color: var(--bs-secondary-light) !important;
}

.text-hover-secondary {
  transition: color 0.2s ease;
}
.text-hover-secondary i {
  transition: color 0.2s ease;
}
.text-hover-secondary:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}
.text-hover-secondary:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}
.text-hover-secondary:hover .svg-icon {
  color: var(--bs-text-secondary) !important;
}

.text-active-secondary {
  transition: color 0.2s ease;
}
.text-active-secondary i {
  transition: color 0.2s ease;
}
.text-active-secondary.active {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}
.text-active-secondary.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}
.text-active-secondary.active .svg-icon {
  color: var(--bs-text-secondary) !important;
}

.text-light {
  color: var(--bs-text-light) !important;
}

.text-inverse-light {
  color: var(--bs-light-inverse) !important;
}

.text-light-light {
  color: var(--bs-light-light) !important;
}

.text-hover-light {
  transition: color 0.2s ease;
}
.text-hover-light i {
  transition: color 0.2s ease;
}
.text-hover-light:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}
.text-hover-light:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}
.text-hover-light:hover .svg-icon {
  color: var(--bs-text-light) !important;
}

.text-active-light {
  transition: color 0.2s ease;
}
.text-active-light i {
  transition: color 0.2s ease;
}
.text-active-light.active {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}
.text-active-light.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}
.text-active-light.active .svg-icon {
  color: var(--bs-text-light) !important;
}

.text-success {
  color: var(--bs-text-success) !important;
}

.text-inverse-success {
  color: var(--bs-success-inverse) !important;
}

.text-light-success {
  color: var(--bs-success-light) !important;
}

.text-hover-success {
  transition: color 0.2s ease;
}
.text-hover-success i {
  transition: color 0.2s ease;
}
.text-hover-success:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}
.text-hover-success:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}
.text-hover-success:hover .svg-icon {
  color: var(--bs-text-success) !important;
}

.text-active-success {
  transition: color 0.2s ease;
}
.text-active-success i {
  transition: color 0.2s ease;
}
.text-active-success.active {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}
.text-active-success.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}
.text-active-success.active .svg-icon {
  color: var(--bs-text-success) !important;
}

.text-info {
  color: var(--bs-text-info) !important;
}

.text-inverse-info {
  color: var(--bs-info-inverse) !important;
}

.text-light-info {
  color: var(--bs-info-light) !important;
}

.text-hover-info {
  transition: color 0.2s ease;
}
.text-hover-info i {
  transition: color 0.2s ease;
}
.text-hover-info:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}
.text-hover-info:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}
.text-hover-info:hover .svg-icon {
  color: var(--bs-text-info) !important;
}

.text-active-info {
  transition: color 0.2s ease;
}
.text-active-info i {
  transition: color 0.2s ease;
}
.text-active-info.active {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}
.text-active-info.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}
.text-active-info.active .svg-icon {
  color: var(--bs-text-info) !important;
}

.text-warning {
  color: var(--bs-text-warning) !important;
}

.text-inverse-warning {
  color: var(--bs-warning-inverse) !important;
}

.text-light-warning {
  color: var(--bs-warning-light) !important;
}

.text-hover-warning {
  transition: color 0.2s ease;
}
.text-hover-warning i {
  transition: color 0.2s ease;
}
.text-hover-warning:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}
.text-hover-warning:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}
.text-hover-warning:hover .svg-icon {
  color: var(--bs-text-warning) !important;
}

.text-active-warning {
  transition: color 0.2s ease;
}
.text-active-warning i {
  transition: color 0.2s ease;
}
.text-active-warning.active {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}
.text-active-warning.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}
.text-active-warning.active .svg-icon {
  color: var(--bs-text-warning) !important;
}

.text-danger {
  color: var(--bs-text-danger) !important;
}

.text-inverse-danger {
  color: var(--bs-danger-inverse) !important;
}

.text-light-danger {
  color: var(--bs-danger-light) !important;
}

.text-hover-danger {
  transition: color 0.2s ease;
}
.text-hover-danger i {
  transition: color 0.2s ease;
}
.text-hover-danger:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}
.text-hover-danger:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}
.text-hover-danger:hover .svg-icon {
  color: var(--bs-text-danger) !important;
}

.text-active-danger {
  transition: color 0.2s ease;
}
.text-active-danger i {
  transition: color 0.2s ease;
}
.text-active-danger.active {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}
.text-active-danger.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}
.text-active-danger.active .svg-icon {
  color: var(--bs-text-danger) !important;
}

.text-dark {
  color: var(--bs-text-dark) !important;
}

.text-inverse-dark {
  color: var(--bs-dark-inverse) !important;
}

.text-light-dark {
  color: var(--bs-dark-light) !important;
}

.text-hover-dark {
  transition: color 0.2s ease;
}
.text-hover-dark i {
  transition: color 0.2s ease;
}
.text-hover-dark:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}
.text-hover-dark:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}
.text-hover-dark:hover .svg-icon {
  color: var(--bs-text-dark) !important;
}

.text-active-dark {
  transition: color 0.2s ease;
}
.text-active-dark i {
  transition: color 0.2s ease;
}
.text-active-dark.active {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}
.text-active-dark.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}
.text-active-dark.active .svg-icon {
  color: var(--bs-text-dark) !important;
}

.text-muted {
  color: var(--bs-text-muted) !important;
}

.text-hover-muted {
  transition: color 0.2s ease;
}
.text-hover-muted i {
  transition: color 0.2s ease;
}
.text-hover-muted:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}
.text-hover-muted:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}
.text-hover-muted:hover .svg-icon {
  color: var(--bs-text-muted) !important;
}

.text-active-muted {
  transition: color 0.2s ease;
}
.text-active-muted i {
  transition: color 0.2s ease;
}
.text-active-muted.active {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}
.text-active-muted.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}
.text-active-muted.active .svg-icon {
  color: var(--bs-text-muted) !important;
}

.text-gray-100 {
  color: var(--bs-text-gray-100) !important;
}

.text-hover-gray-100 {
  transition: color 0.2s ease;
}
.text-hover-gray-100 i {
  transition: color 0.2s ease;
}
.text-hover-gray-100:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}
.text-hover-gray-100:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}
.text-hover-gray-100:hover .svg-icon {
  color: var(--bs-text-gray-100) !important;
}

.text-active-gray-100 {
  transition: color 0.2s ease;
}
.text-active-gray-100 i {
  transition: color 0.2s ease;
}
.text-active-gray-100.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}
.text-active-gray-100.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}
.text-active-gray-100.active .svg-icon {
  color: var(--bs-text-gray-100) !important;
}

.text-gray-200 {
  color: var(--bs-text-gray-200) !important;
}

.text-hover-gray-200 {
  transition: color 0.2s ease;
}
.text-hover-gray-200 i {
  transition: color 0.2s ease;
}
.text-hover-gray-200:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}
.text-hover-gray-200:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}
.text-hover-gray-200:hover .svg-icon {
  color: var(--bs-text-gray-200) !important;
}

.text-active-gray-200 {
  transition: color 0.2s ease;
}
.text-active-gray-200 i {
  transition: color 0.2s ease;
}
.text-active-gray-200.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}
.text-active-gray-200.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}
.text-active-gray-200.active .svg-icon {
  color: var(--bs-text-gray-200) !important;
}

.text-gray-300 {
  color: var(--bs-text-gray-300) !important;
}

.text-hover-gray-300 {
  transition: color 0.2s ease;
}
.text-hover-gray-300 i {
  transition: color 0.2s ease;
}
.text-hover-gray-300:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}
.text-hover-gray-300:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}
.text-hover-gray-300:hover .svg-icon {
  color: var(--bs-text-gray-300) !important;
}

.text-active-gray-300 {
  transition: color 0.2s ease;
}
.text-active-gray-300 i {
  transition: color 0.2s ease;
}
.text-active-gray-300.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}
.text-active-gray-300.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}
.text-active-gray-300.active .svg-icon {
  color: var(--bs-text-gray-300) !important;
}

.text-gray-400 {
  color: var(--bs-text-gray-400) !important;
}

.text-hover-gray-400 {
  transition: color 0.2s ease;
}
.text-hover-gray-400 i {
  transition: color 0.2s ease;
}
.text-hover-gray-400:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}
.text-hover-gray-400:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}
.text-hover-gray-400:hover .svg-icon {
  color: var(--bs-text-gray-400) !important;
}

.text-active-gray-400 {
  transition: color 0.2s ease;
}
.text-active-gray-400 i {
  transition: color 0.2s ease;
}
.text-active-gray-400.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}
.text-active-gray-400.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}
.text-active-gray-400.active .svg-icon {
  color: var(--bs-text-gray-400) !important;
}

.text-gray-500 {
  color: var(--bs-text-gray-500) !important;
}

.text-hover-gray-500 {
  transition: color 0.2s ease;
}
.text-hover-gray-500 i {
  transition: color 0.2s ease;
}
.text-hover-gray-500:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}
.text-hover-gray-500:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}
.text-hover-gray-500:hover .svg-icon {
  color: var(--bs-text-gray-500) !important;
}

.text-active-gray-500 {
  transition: color 0.2s ease;
}
.text-active-gray-500 i {
  transition: color 0.2s ease;
}
.text-active-gray-500.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}
.text-active-gray-500.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}
.text-active-gray-500.active .svg-icon {
  color: var(--bs-text-gray-500) !important;
}

.text-gray-600 {
  color: var(--bs-text-gray-600) !important;
}

.text-hover-gray-600 {
  transition: color 0.2s ease;
}
.text-hover-gray-600 i {
  transition: color 0.2s ease;
}
.text-hover-gray-600:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}
.text-hover-gray-600:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}
.text-hover-gray-600:hover .svg-icon {
  color: var(--bs-text-gray-600) !important;
}

.text-active-gray-600 {
  transition: color 0.2s ease;
}
.text-active-gray-600 i {
  transition: color 0.2s ease;
}
.text-active-gray-600.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}
.text-active-gray-600.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}
.text-active-gray-600.active .svg-icon {
  color: var(--bs-text-gray-600) !important;
}

.text-gray-700 {
  color: var(--bs-text-gray-700) !important;
}

.text-hover-gray-700 {
  transition: color 0.2s ease;
}
.text-hover-gray-700 i {
  transition: color 0.2s ease;
}
.text-hover-gray-700:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}
.text-hover-gray-700:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}
.text-hover-gray-700:hover .svg-icon {
  color: var(--bs-text-gray-700) !important;
}

.text-active-gray-700 {
  transition: color 0.2s ease;
}
.text-active-gray-700 i {
  transition: color 0.2s ease;
}
.text-active-gray-700.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}
.text-active-gray-700.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}
.text-active-gray-700.active .svg-icon {
  color: var(--bs-text-gray-700) !important;
}

.text-gray-800 {
  color: var(--bs-text-gray-800) !important;
}

.text-hover-gray-800 {
  transition: color 0.2s ease;
}
.text-hover-gray-800 i {
  transition: color 0.2s ease;
}
.text-hover-gray-800:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}
.text-hover-gray-800:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}
.text-hover-gray-800:hover .svg-icon {
  color: var(--bs-text-gray-800) !important;
}

.text-active-gray-800 {
  transition: color 0.2s ease;
}
.text-active-gray-800 i {
  transition: color 0.2s ease;
}
.text-active-gray-800.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}
.text-active-gray-800.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}
.text-active-gray-800.active .svg-icon {
  color: var(--bs-text-gray-800) !important;
}

.text-gray-900 {
  color: var(--bs-text-gray-900) !important;
}

.text-hover-gray-900 {
  transition: color 0.2s ease;
}
.text-hover-gray-900 i {
  transition: color 0.2s ease;
}
.text-hover-gray-900:hover {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}
.text-hover-gray-900:hover i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}
.text-hover-gray-900:hover .svg-icon {
  color: var(--bs-text-gray-900) !important;
}

.text-active-gray-900 {
  transition: color 0.2s ease;
}
.text-active-gray-900 i {
  transition: color 0.2s ease;
}
.text-active-gray-900.active {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}
.text-active-gray-900.active i {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}
.text-active-gray-900.active .svg-icon {
  color: var(--bs-text-gray-900) !important;
}

.parent-hover .parent-hover-white {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-white {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}
.parent-hover .parent-hover-primary {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-primary {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}
.parent-hover .parent-hover-secondary {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-secondary {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}
.parent-hover .parent-hover-light {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-light {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}
.parent-hover .parent-hover-success {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-success {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}
.parent-hover .parent-hover-info {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-info {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}
.parent-hover .parent-hover-warning {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-warning {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}
.parent-hover .parent-hover-danger {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-danger {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}
.parent-hover .parent-hover-dark {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-dark {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}
.parent-hover .parent-hover-muted {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-muted {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}
.parent-hover .parent-hover-gray-100 {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-gray-100 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}
.parent-hover .parent-hover-gray-200 {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-gray-200 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}
.parent-hover .parent-hover-gray-300 {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-gray-300 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}
.parent-hover .parent-hover-gray-400 {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-gray-400 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}
.parent-hover .parent-hover-gray-500 {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-gray-500 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}
.parent-hover .parent-hover-gray-600 {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-gray-600 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}
.parent-hover .parent-hover-gray-700 {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-gray-700 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}
.parent-hover .parent-hover-gray-800 {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-gray-800 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}
.parent-hover .parent-hover-gray-900 {
  transition: color 0.2s ease;
}
.parent-hover:hover .parent-hover-gray-900 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}

.parent-active .parent-active-white {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-white {
  transition: color 0.2s ease;
  color: var(--bs-text-white) !important;
}
.parent-active .parent-active-primary {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-primary {
  transition: color 0.2s ease;
  color: var(--bs-text-primary) !important;
}
.parent-active .parent-active-secondary {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-secondary {
  transition: color 0.2s ease;
  color: var(--bs-text-secondary) !important;
}
.parent-active .parent-active-light {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-light {
  transition: color 0.2s ease;
  color: var(--bs-text-light) !important;
}
.parent-active .parent-active-success {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-success {
  transition: color 0.2s ease;
  color: var(--bs-text-success) !important;
}
.parent-active .parent-active-info {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-info {
  transition: color 0.2s ease;
  color: var(--bs-text-info) !important;
}
.parent-active .parent-active-warning {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-warning {
  transition: color 0.2s ease;
  color: var(--bs-text-warning) !important;
}
.parent-active .parent-active-danger {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-danger {
  transition: color 0.2s ease;
  color: var(--bs-text-danger) !important;
}
.parent-active .parent-active-dark {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-dark {
  transition: color 0.2s ease;
  color: var(--bs-text-dark) !important;
}
.parent-active .parent-active-muted {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-muted {
  transition: color 0.2s ease;
  color: var(--bs-text-muted) !important;
}
.parent-active .parent-active-gray-100 {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-gray-100 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-100) !important;
}
.parent-active .parent-active-gray-200 {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-gray-200 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-200) !important;
}
.parent-active .parent-active-gray-300 {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-gray-300 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-300) !important;
}
.parent-active .parent-active-gray-400 {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-gray-400 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-400) !important;
}
.parent-active .parent-active-gray-500 {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-gray-500 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-500) !important;
}
.parent-active .parent-active-gray-600 {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-gray-600 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-600) !important;
}
.parent-active .parent-active-gray-700 {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-gray-700 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-700) !important;
}
.parent-active .parent-active-gray-800 {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-gray-800 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-800) !important;
}
.parent-active .parent-active-gray-900 {
  transition: color 0.2s ease;
}
.parent-active.active .parent-active-gray-900 {
  transition: color 0.2s ease;
  color: var(--bs-text-gray-900) !important;
}

.text-transparent {
  color: transparent;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-default {
  cursor: default;
}

.cursor-move {
  cursor: move;
}

i.bi, i[class^=fonticon-], i[class*=" fonticon-"], i[class^=fa-], i[class*=" fa-"], i[class^=la-], i[class*=" la-"] {
  line-height: 1;
  font-size: 1rem;
  color: var(--bs-text-muted);
}

a {
  transition: color 0.2s ease;
}
a:hover {
  transition: color 0.2s ease;
}

.opacity-active-0.active {
  opacity: 0 !important;
}

.opacity-state-0:hover, .opacity-state-0.active {
  opacity: 0 !important;
}

.opacity-active-5.active {
  opacity: 0.05 !important;
}

.opacity-state-5:hover, .opacity-state-5.active {
  opacity: 0.05 !important;
}

.opacity-active-10.active {
  opacity: 0.1 !important;
}

.opacity-state-10:hover, .opacity-state-10.active {
  opacity: 0.1 !important;
}

.opacity-active-15.active {
  opacity: 0.15 !important;
}

.opacity-state-15:hover, .opacity-state-15.active {
  opacity: 0.15 !important;
}

.opacity-active-20.active {
  opacity: 0.2 !important;
}

.opacity-state-20:hover, .opacity-state-20.active {
  opacity: 0.2 !important;
}

.opacity-active-25.active {
  opacity: 0.25 !important;
}

.opacity-state-25:hover, .opacity-state-25.active {
  opacity: 0.25 !important;
}

.opacity-active-50.active {
  opacity: 0.5 !important;
}

.opacity-state-50:hover, .opacity-state-50.active {
  opacity: 0.5 !important;
}

.opacity-active-75.active {
  opacity: 0.75 !important;
}

.opacity-state-75:hover, .opacity-state-75.active {
  opacity: 0.75 !important;
}

.opacity-active-100.active {
  opacity: 1 !important;
}

.opacity-state-100:hover, .opacity-state-100.active {
  opacity: 1 !important;
}

.transform-90 {
  transform: rotate(90deg);
  transform-origin: right top;
}

.tree {
  --bs-tree-icon-size: 16px;
  --bs-tree-icon-gap: 14px;
  --bs-tree-icon-color-open: var(--bs-success);
  --bs-tree-icon-color-default: var(--bs-gray-500);
  --bs-tree-icon-color-close: var(--bs-gray-500);
  --bs-tree-line-color: var(--bs-gray-200);
}
.tree .tree-node {
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: start;
}
.tree .tree-sub {
  padding: 0.35rem 0;
}
.tree .tree-content {
  display: flex;
  align-items: center;
  padding: 0.35rem 0;
}
.tree .tree-wrapper {
  padding-left: calc(var(--bs-tree-icon-size) + var(--bs-tree-icon-size));
}
.tree .tree-section {
  display: flex;
  align-items: baseline;
  padding-left: var(--bs-tree-icon-gap);
}
.tree .tree-toggle {
  display: flex;
  align-items: center;
  width: var(--bs-tree-icon-size);
}
.tree .tree-toggle .tree-icon-default {
  font-size: 1.5rem;
  color: var(--bs-tree-icon-color-default);
}
.tree .tree-toggle .tree-icon-open {
  font-size: 1.5rem;
  color: var(--bs-tree-icon-color-open);
}
.tree .tree-toggle .tree-icon-close {
  font-size: 1.5rem;
  color: var(--bs-tree-icon-color-close);
}
.tree .tree-toggle.collapsed .tree-icon-close {
  display: flex;
}
.tree .tree-toggle.collapsed .tree-icon-open {
  display: none;
}
.tree .tree-toggle:not(.collapsed) .tree-icon-close {
  display: none;
}
.tree .tree-toggle:not(.collapsed) .tree-icon-open {
  display: flex;
}
.tree > .tree-node {
  padding-left: 0 !important;
}
.tree.tree-line .tree-sub {
  border-left: 1px solid var(--bs-tree-line-color);
  margin-left: calc(var(--bs-tree-icon-size) / 2);
}

@media (min-width: 992px) {
  .testimonials-slider-highlight {
    transition: all ease 0.3;
  }
  .testimonials-slider-highlight .testimonials-photo,
  .testimonials-slider-highlight .testimonials-title,
  .testimonials-slider-highlight .testimonials-body,
  .testimonials-slider-highlight .testimonials-author,
  .testimonials-slider-highlight .testimonials-positon {
    transition: all ease 0.3s;
  }
  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-photo {
    height: 200px;
    width: 200px;
    transition: all ease 0.3s;
  }
  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-title {
    color: var(--bs-gray-900) !important;
    font-size: 1.54rem !important;
    transition: all ease 0.3s;
    margin-bottom: 1.3rem !important;
  }
  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-description {
    color: var(--bs-gray-700) !important;
    font-size: 1.38rem !important;
    transition: all ease 0.3s;
    margin-bottom: 1.7rem !important;
  }
  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-author {
    color: var(--bs-primary) !important;
    font-size: 1.1rem !important;
    transition: all ease 0.3s;
  }
  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-positon {
    color: var(--bs-gray-500) !important;
    font-size: 0.9rem !important;
    transition: all ease 0.3s;
  }
}
.testimonials-slider-quote .testimonials-quote {
  opacity: 0.2;
}
.testimonials-slider-quote .tns-item:not(.tns-slide-active) + .tns-slide-active + .tns-slide-active .testimonials-quote {
  opacity: 0.5;
  color: var(--bs-primary) !important;
}

.stepper.stepper-pills.stepper-multistep {
  --bs-stepper-pills-size: 46px;
  --bs-stepper-icon-border-radius: 9px;
  --bs-stepper-icon-check-size: 1.25rem;
  --bs-stepper-icon-bg-color: rgba(255, 255, 255, 0.03);
  --bs-stepper-icon-bg-color-current: var(--bs-success);
  --bs-stepper-icon-bg-color-completed: rgba(255, 255, 255, 0.03);
  --bs-stepper-icon-border: 1px dashed rgba(255, 255, 255, 0.3);
  --bs-stepper-icon-border-current: 0;
  --bs-stepper-icon-border-completed: 1px dashed rgba(255, 255, 255, 0.3);
  --bs-stepper-icon-number-color: var(--bs-white);
  --bs-stepper-icon-number-color-current: var(--bs-white);
  --bs-stepper-icon-number-color-completed: var(--bs-white);
  --bs-stepper-icon-check-color-completed: var(--bs-success);
  --bs-stepper-label-title-opacity: 0.7;
  --bs-stepper-label-title-opacity-current: 1;
  --bs-stepper-label-title-opacity-completed: 1;
  --bs-stepper-label-title-color: var(--bs-white);
  --bs-stepper-label-title-color-current: var(--bs-white);
  --bs-stepper-label-title-color-completed: var(--bs-white);
  --bs-stepper-label-desc-opacity: 0.7;
  --bs-stepper-label-desc-opacity-current: 0.7;
  --bs-stepper-label-desc-opacity-completed: 0.7;
  --bs-stepper-label-desc-color: var(--bs-white);
  --bs-stepper-label-desc-color-current: var(--bs-white);
  --bs-stepper-label-desc-color-completed: var(--bs-white);
  --bs-stepper-line-border: 1px dashed rgba(255, 255, 255, 0.3);
}

.landing-dark-bg {
  background-color: #13263C;
}

.landing-dark-color {
  color: #13263C;
}

.landing-dark-border {
  border: 1px dashed #2C3F5B;
}

.landing-dark-separator {
  border-top: 1px dashed #2C3F5B;
}

.landing-curve {
  position: relative;
}
.landing-curve svg {
  position: relative;
  top: 0;
  display: block;
}

.landing-header {
  display: flex;
  align-items: center;
  height: 100px;
}
.landing-header .logo-default {
  display: block;
}
.landing-header .logo-sticky {
  display: none;
}
.landing-header .menu .menu-link.active {
  color: #ffffff;
}
[data-kt-sticky-landing-header=on] .landing-header .menu .menu-link.active {
  color: #1B84FF;
  background-color: rgba(239, 242, 245, 0.4);
}
[data-kt-sticky-landing-header=on] .landing-header {
  padding: 0;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  height: 70px;
}
[data-kt-sticky-landing-header=on] .landing-header .logo-sticky {
  display: block;
}
[data-kt-sticky-landing-header=on] .landing-header .logo-default {
  display: none;
}

body[data-kt-sticky-landing-header=on] {
  padding-top: 100px;
}

@media (max-width: 991.98px) {
  .landing-header {
    height: 70px;
  }
  .landing-header .landing-menu-wrapper {
    position: relative;
    overflow: auto;
  }
  [data-kt-sticky-landing-header=on] .landing-header {
    height: 70px;
  }
  .landing-header .menu .menu-link.active {
    color: #1B84FF;
    background-color: rgba(239, 242, 245, 0.4);
  }
  body[data-kt-sticky-landing-header=on] {
    padding-top: 70px;
  }
}
[data-bs-theme=light] {
  --bs-page-bg: #F9F9F9;
  --bs-app-blank-bg: #ffffff;
  --bs-header-desktop-fixed-bg-color: #ffffff;
  --bs-header-desktop-fixed-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
  --bs-header-desktop-fixed-bg-color: #ffffff;
  --bs-header-desktop-fixed-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
  --bs-aside-bg-color: #F1F1F4;
  --bs-sidebar-bg-color: #192440;
  --bs-sidebar-tabs-link-bg-color-default: #0e172e;
  --bs-sidebar-tabs-link-bg-color-active: #07122d;
  --bs-sidebar-tabs-link-icon-color-default: #5e6278;
  --bs-sidebar-tabs-link-icon-color-active: #ffffff;
  --bs-sidebar-dashed-border-color: #3e4a69;
  --bs-sidebar-muted-color: #546182;
  --bs-sidebar-muted-bg-color: #0e172e;
}

[data-bs-theme=dark] {
  --bs-page-bg: #0F1014;
  --bs-app-blank-bg: #0F1014;
  --bs-header-desktop-fixed-bg-color: #0F1014;
  --bs-header-desktop-fixed-box-shadow: none;
  --bs-header-desktop-fixed-bg-color: #15171C;
  --bs-header-desktop-fixed-box-shadow: none;
  --bs-aside-bg-color: #0D0E12;
  --bs-sidebar-bg-color: #1e1e2d;
  --bs-sidebar-tabs-link-bg-color-default: #161621;
  --bs-sidebar-tabs-link-bg-color-active: #12121b;
  --bs-sidebar-tabs-link-icon-color-default: #5e6278;
  --bs-sidebar-tabs-link-icon-color-active: #ffffff;
  --bs-sidebar-dashed-border-color: #26272F;
  --bs-sidebar-muted-color: #636674;
  --bs-sidebar-muted-bg-color: #1a1a27;
}

html {
  font-family: sans-serif;
  text-size-adjust: 100%;
}

html,
body {
  height: 100%;
  margin: 0px;
  padding: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px !important;
  font-weight: 400;
  font-family: Inter, Helvetica, "sans-serif";
}
@media (max-width: 991.98px) {
  html,
  body {
    font-size: 14px !important;
  }
}
@media (max-width: 767.98px) {
  html,
  body {
    font-size: 13px !important;
  }
}

body {
  display: flex;
  flex-direction: column;
}
body a:hover,
body a:active,
body a:focus {
  text-decoration: none !important;
}

canvas {
  -webkit-user-select: none;
          user-select: none;
}

router-outlet {
  display: none;
}

@media print {
  .print-content-only {
    padding: 0 !important;
    background: none !important;
  }
  .print-content-only .wrapper,
  .print-content-only .page,
  .print-content-only .page-title,
  .print-content-only .content,
  .print-content-only .container,
  .print-content-only .container-xxl,
  .print-content-only .container-fluid,
  .print-content-only .container-sm,
  .print-content-only .container-md,
  .print-content-only .container-lg,
  .print-content-only .container-xl {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .print-content-only .aside,
  .print-content-only .sidebar,
  .print-content-only .scrolltop,
  .print-content-only .header,
  .print-content-only .footer,
  .print-content-only .toolbar,
  .print-content-only .drawer,
  .print-content-only .btn {
    display: none !important;
  }
}
body {
  background-color: var(--bs-page-bg);
}

.text-page-bg {
  color: #F9F9F9;
}

.app-blank {
  background-color: var(--bs-app-blank-bg) !important;
}

@media (min-width: 1400px) {
  .sidebar-enabled .engage-toolbar {
    right: 400px !important;
  }
  .sidebar-enabled .scrolltop {
    right: 405px !important;
  }
}
@media (min-width: 992px) {
  .container,
  .container-xxl,
  .container-fluid,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    padding: 0 50px !important;
  }
  .wrapper {
    padding-top: 50px;
    padding-left: 350px;
  }
  .header-fixed[data-kt-sticky-header=on] .wrapper {
    padding-top: 130px;
  }
}
@media (max-width: 991.98px) {
  .container,
  .container-xxl,
  .container-fluid,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: none;
    padding: 0 20px !important;
  }
  .header-tablet-and-mobile-fixed[data-kt-sticky-header=on] .wrapper {
    padding-top: 55px;
  }
}
@media (min-width: 1400px) {
  .sidebar-enabled[data-kt-sticky-header=on] .header {
    right: 400px !important;
  }
}
@media (min-width: 992px) {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
  }
  .header-fixed[data-kt-sticky-header=on] .header {
    position: fixed;
    top: 0;
    right: 0;
    left: 350px;
    z-index: 97;
    background-color: var(--bs-header-desktop-fixed-bg-color);
    box-shadow: var(--bs-header-desktop-fixed-box-shadow);
    height: 65px;
    padding: 0;
    border-bottom-right-radius: 0.65rem;
    border-bottom-left-radius: 0.65rem;
  }
}
@media (max-width: 991.98px) {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
  }
  .header-tablet-and-mobile-fixed[data-kt-sticky-header=on] .header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 97;
    height: 55px;
    min-height: 55px;
    background-color: var(--bs-header-tablet-and-mobile-fixed-bg-color);
    box-shadow: var(--bs-header-tablet-and-mobile-fixed-box-shadow);
    border-bottom-right-radius: 0.65rem;
    border-bottom-left-radius: 0.65rem;
  }
  .header .page-title {
    display: none !important;
  }
}
.aside {
  display: flex;
  flex-direction: column;
  background-color: var(--bs-aside-bg-color);
  padding: 0;
}
.aside .aside-menu {
  display: flex;
  align-items: center;
  width: 100%;
}
.aside .aside-menu .menu > .menu-item > .menu-link .menu-title {
  font-size: 1.1rem;
}
.aside .aside-menu .menu > .menu-item.menu-accordion.show > .menu-link > .menu-icon i,
.aside .aside-menu .menu > .menu-item.menu-accordion.show > .menu-link > .menu-icon .svg-icon, .aside .aside-menu .menu > .menu-item.menu-accordion.showing > .menu-link > .menu-icon i,
.aside .aside-menu .menu > .menu-item.menu-accordion.showing > .menu-link > .menu-icon .svg-icon {
  /*rtl:ignore*/
  transform: rotateZ(-90deg);
  /*rtl:remove*/
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}
.aside .aside-menu .menu > .menu-item.menu-accordion.hiding > .menu-link > .menu-icon i,
.aside .aside-menu .menu > .menu-item.menu-accordion.hiding > .menu-link > .menu-icon .svg-icon {
  /*rtl:ignore*/
  transform: rotateZ(0);
  /*rtl:remove*/
  transform: rotateZ(0);
  transition: transform 0.3s ease;
}
.aside .aside-menu .menu .menu-item .menu-link {
  background-color: transparent;
  color: var(--bs-gray-700);
}
.aside .aside-menu .menu .menu-item .menu-link .menu-title {
  color: var(--bs-gray-700);
}
.aside .aside-menu .menu .menu-item .menu-link .menu-icon,
.aside .aside-menu .menu .menu-item .menu-link .menu-icon .svg-icon,
.aside .aside-menu .menu .menu-item .menu-link .menu-icon i {
  color: var(--bs-gray-600);
}
.aside .aside-menu .menu .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-400);
}
.aside .aside-menu .menu .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-400);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--bs-gray-400);
  -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
  /*rtl:end:remove*/
}
.aside .aside-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .aside .aside-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: transparent;
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .aside .aside-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: transparent;
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item.here > .menu-link .menu-title {
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: transparent;
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item.show > .menu-link .menu-title {
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item.show > .menu-link .menu-icon,
.aside .aside-menu .menu .menu-item.show > .menu-link .menu-icon .svg-icon,
.aside .aside-menu .menu .menu-item.show > .menu-link .menu-icon i {
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: transparent;
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item .menu-link.active .menu-title {
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item .menu-link.active .menu-icon,
.aside .aside-menu .menu .menu-item .menu-link.active .menu-icon .svg-icon,
.aside .aside-menu .menu .menu-item .menu-link.active .menu-icon i {
  color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--bs-gray-900);
}
.aside .aside-menu .menu .menu-item > .menu-link.active .menu-title {
  font-weight: 600;
}

@media (min-width: 992px) {
  .aside {
    position: fixed;
    top: 50px;
    bottom: 50px;
    left: 50px;
    z-index: 100;
    overflow: hidden;
    width: 300px;
    border-radius: 2rem;
  }
  .aside .scroll-y,
  .aside .hover-scroll-overlay-y {
    scrollbar-color: var(--bs-gray-300) transparent;
  }
  .aside .scroll-y::-webkit-scrollbar-thumb,
  .aside .hover-scroll-overlay-y::-webkit-scrollbar-thumb {
    background-color: var(--bs-gray-300);
  }
  .aside .scroll-y::-webkit-scrollbar-corner,
  .aside .hover-scroll-overlay-y::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  .aside .scroll-y:hover,
  .aside .hover-scroll-overlay-y:hover {
    scrollbar-color: var(--bs-gray-400) transparent;
  }
  .aside .scroll-y:hover::-webkit-scrollbar-thumb,
  .aside .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {
    background-color: var(--bs-gray-400);
  }
  .aside .scroll-y:hover::-webkit-scrollbar-corner,
  .aside .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  .aside .aside-logo {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
@media (max-width: 991.98px) {
  .aside {
    display: none;
  }
  .aside .aside-logo {
    display: none;
  }
}
[data-bs-theme=dark] .aside {
  border: 1px solid #15171C;
}

.sidebar {
  display: flex;
  flex-direction: column;
  background-color: var(--bs-sidebar-bg-color);
  padding: 0;
}
.sidebar .sidebar-nav {
  flex-wrap: nowrap;
  padding: 0;
  margin: 9;
  width: 100%;
  border: 0;
  justify-content: space-between;
  align-items: center;
}
.sidebar .sidebar-nav .nav-item {
  padding: 0;
  margin: 0;
  height: 85px;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar .sidebar-nav .nav-link {
  padding: 0;
  margin: 0;
  height: 75px;
  width: 60px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bs-sidebar-tabs-link-bg-color-default);
  border: 0;
  border-radius: 0.65rem;
}
.sidebar .sidebar-nav .nav-link i {
  transition: all 0.3s ease;
  font-size: 2.25rem;
  color: var(--bs-sidebar-tabs-link-icon-color-default);
}
.sidebar .sidebar-nav .nav-link.active {
  height: 85px;
  width: 70px;
  padding: 0;
  transition: all 0.3s ease;
  background-color: var(--bs-sidebar-tabs-link-bg-color-active);
}
.sidebar .sidebar-nav .nav-link.active i {
  font-size: 2.75rem;
  color: var(--bs-sidebar-tabs-link-icon-color-active);
}
.sidebar .sidebar-border-dashed {
  border: 1px dashed var(--bs-sidebar-dashed-border-color);
}
.sidebar .sidebar-text-muted {
  color: var(--bs-sidebar-muted-color);
}
.sidebar .sidebar-bg-muted {
  background-color: var(--bs-sidebar-muted-bg-color);
}

@media (min-width: 1400px) {
  .sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 101;
    width: 400px;
    overflow: hidden;
  }
  .sidebar-enabled .app-engage {
    right: 400px;
  }
}
@media (max-width: 1399.98px) {
  .sidebar {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .sidebar {
    display: none;
  }
  .sidebar .sidebar-nav .nav-item {
    height: 65px;
    width: 50px;
  }
  .sidebar .sidebar-nav .nav-link {
    height: 45px;
    width: 40px;
  }
  .sidebar .sidebar-nav .nav-link .svg-icon svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .sidebar .sidebar-nav .nav-link.active {
    height: 65px;
    width: 50px;
  }
  .sidebar .sidebar-nav .nav-link.active .svg-icon svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
}
@media (min-width: 992px) {
  .content {
    padding: 25px 0 0 0;
  }
}
@media (max-width: 991.98px) {
  .content {
    padding: 20px 0 0 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/sass/style.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./src/assets/sass/core/components/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_box-shadow.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/sass/core/components/_root.scss","webpack://./src/assets/sass/core/components/_reboot.scss","webpack://./src/assets/sass/core/components/_type.scss","webpack://./src/assets/sass/core/components/_theme-mode.scss","webpack://./src/assets/sass/core/components/_animation.scss","webpack://./src/assets/sass/core/components/_alert.scss","webpack://./src/assets/sass/core/components/_dropdown.scss","webpack://./src/assets/sass/core/components/_toasts.scss","webpack://./src/assets/sass/core/components/_nav.scss","webpack://./src/assets/sass/core/components/_nav-line-tabs.scss","webpack://./src/assets/sass/core/components/_nav-pills-custom.scss","webpack://./src/assets/sass/core/components/_pagination.scss","webpack://./src/assets/sass/components/_variables.custom.scss","webpack://./src/assets/sass/core/components/mixins/_svg-bg-icon.scss","webpack://./src/assets/sass/core/components/_separator.scss","webpack://./src/assets/sass/core/components/_carousel.scss","webpack://./src/assets/sass/core/components/menu/_base.scss","webpack://./src/assets/sass/core/components/mixins/_menu.scss","webpack://./src/assets/sass/core/base/mixins/_breakpoints.scss","webpack://./src/assets/sass/core/components/menu/_theme.scss","webpack://./src/assets/sass/core/components/_anchor.scss","webpack://./src/assets/sass/core/components/_card.scss","webpack://./src/assets/sass/core/components/mixins/_svg-icon.scss","webpack://./src/assets/sass/core/components/_breadcrumb.scss","webpack://./src/assets/sass/core/components/buttons/_base.scss","webpack://./src/assets/sass/core/base/mixins/_reset.scss","webpack://./src/assets/sass/core/components/buttons/_theme.scss","webpack://./src/assets/sass/core/components/mixins/_buttons.scss","webpack://./src/assets/sass/core/components/_variables-dark.scss","webpack://./src/assets/sass/core/components/_modal.scss","webpack://./src/assets/sass/core/components/_code.scss","webpack://./src/assets/sass/core/components/forms/_labels.scss","webpack://./src/assets/sass/core/components/forms/_form-control.scss","webpack://./src/assets/sass/core/base/mixins/_placeholder.scss","webpack://./src/assets/sass/core/components/forms/_floating-labels.scss","webpack://./src/assets/sass/core/components/forms/_form-select.scss","webpack://./src/assets/sass/core/components/forms/_form-check.scss","webpack://./src/assets/sass/core/components/forms/_input-group.scss","webpack://./src/assets/sass/core/components/forms/_required.scss","webpack://./src/assets/sass/core/components/_progress.scss","webpack://./src/assets/sass/core/components/_tables.scss","webpack://./src/assets/sass/core/components/_popover.scss","webpack://./src/assets/sass/core/components/_tooltip.scss","webpack://./src/assets/sass/core/components/_accordion.scss","webpack://./src/assets/sass/core/components/_image-input.scss","webpack://./src/assets/sass/core/components/_symbol.scss","webpack://./src/assets/sass/core/components/mixins/_symbol.scss","webpack://./src/assets/sass/core/components/_pulse.scss","webpack://./src/assets/sass/core/components/_page-loader.scss","webpack://./src/assets/sass/core/components/_scrolltop.scss","webpack://./src/assets/sass/core/components/_svg-icon.scss","webpack://./src/assets/sass/core/components/_fixed.scss","webpack://./src/assets/sass/core/components/_timeline.scss","webpack://./src/assets/sass/core/components/_timeline-label.scss","webpack://./src/assets/sass/core/components/_overlay.scss","webpack://./src/assets/sass/core/components/_bullet.scss","webpack://./src/assets/sass/core/components/_drawer.scss","webpack://./src/assets/sass/core/components/_badge.scss","webpack://./src/assets/sass/core/components/_indicator.scss","webpack://./src/assets/sass/core/components/_hover.scss","webpack://./src/assets/sass/core/components/_rotate.scss","webpack://./src/assets/sass/core/components/_scroll.scss","webpack://./src/assets/sass/core/components/mixins/_scroll.scss","webpack://./src/assets/sass/core/components/_rating.scss","webpack://./src/assets/sass/core/components/stepper/_base.scss","webpack://./src/assets/sass/core/components/stepper/_pills.scss","webpack://./src/assets/sass/core/components/stepper/_links.scss","webpack://./src/assets/sass/core/components/_toggle.scss","webpack://./src/assets/sass/core/components/_shape.scss","webpack://./src/assets/sass/core/components/mixins/_shape.scss","webpack://./src/assets/sass/core/components/_ribbon.scss","webpack://./src/assets/sass/core/components/_blockui.scss","webpack://./src/assets/sass/core/components/_explore.scss","webpack://./src/assets/sass/core/components/_engage.scss","webpack://./src/assets/sass/core/components/_cookiealert.scss","webpack://./src/assets/sass/core/components/_print.scss","webpack://./src/assets/sass/core/components/helpers/_background.scss","webpack://./src/assets/sass/core/components/helpers/_borders.scss","webpack://./src/assets/sass/core/components/helpers/_flex.scss","webpack://./src/assets/sass/core/components/helpers/_shadow.scss","webpack://./src/assets/sass/core/components/helpers/_text.scss","webpack://./src/assets/sass/core/components/helpers/_opacity.scss","webpack://./src/assets/sass/core/components/helpers/_transform.scss","webpack://./src/assets/sass/core/components/_tree.scss","webpack://./src/assets/sass/core/components/_testimonials-slider.scss","webpack://./src/assets/sass/components/stepper/_multistep.scss","webpack://./src/assets/sass/components/_landing.scss","webpack://./src/assets/sass/layout/_root.scss","webpack://./src/assets/sass/core/layout/_base.scss","webpack://./src/assets/sass/layout/_print.scss","webpack://./src/assets/sass/layout/_main.scss","webpack://./src/assets/sass/layout/_header.scss","webpack://./src/assets/sass/layout/_aside.scss","webpack://./src/assets/sass/layout/_sidebar.scss","webpack://./src/assets/sass/layout/_content.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,mBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,kBAAA;EAIA,6BAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,oDAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,8BAAA;EACA,qBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,gCAAA;EAEA,2CAAA;EACA,mCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,yCAAA;EACA,kCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,0BAAA;EAEA,8BAAA;EACA,sCAAA;EAGE,gCAAA;EAGF,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,2BAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,4DAAA;EACA,6DAAA;EACA,uDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFDF;;AI/GI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,4BAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,gCAAA;EACA,uCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFDJ;;AKvKA;;;EAGE,sBAAA;AL0KF;;AK5IA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AL+IF;;AKtIA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;ANhf9B;;AK/HA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBEyWwB;EFxWxB,gBE0W6B;EFzW7B,8BAAA;ALgIF;;AK7HA;EFuMQ,+BAAA;AHtER;AGtFI;EE3CJ;IF8MQ,kBAAA;EHzEN;AACF;;AKjIA;EFkMQ,iCAAA;AH7DR;AG/FI;EEtCJ;IFyMQ,iBAAA;EHhEN;AACF;;AKrIA;EF6LQ,iCAAA;AHpDR;AGxGI;EEjCJ;IFoMQ,kBAAA;EHvDN;AACF;;AKzIA;EFoLM,kBALI;AHlCV;;AKxIA;EF+KM,kBALI;AH9BV;;AKvIA;EF0KM,mBALI;AH1BV;;AKhIA;EACE,aAAA;EACA,mBEsIgC;APHlC;;AKzHA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AL4HF;;AKtHA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALyHF;;AKnHA;;EAEE,kBAAA;ALsHF;;AKnHA;;;EAGE,aAAA;EACA,mBAAA;ALsHF;;AKnHA;;;;EAIE,gBAAA;ALsHF;;AKnHA;EACE,gBEoMiB;AP9EnB;;AKjHA;EACE,qBAAA;EACA,cAAA;ALoHF;;AK9GA;EACE,gBAAA;ALiHF;;AKzGA;;EAEE,gBE6KmB;APjErB;;AKpGA;EF6EM,kBALI;AHgCV;;AKjGA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;ALoGF;;AK3FA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AL8FF;;AK3FA;EAAM,eAAA;AL+FN;;AK9FA;EAAM,WAAA;ALkGN;;AK7FA;EACE,gEAAA;EACA,qBEU0B;APsF5B;AK9FE;EACE,mDAAA;EACA,qBESwB;APuF5B;;AKtFE;EAEE,cAAA;EACA,qBAAA;ALwFJ;;AKjFA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AH4EV;;AK7EA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,eALI;AHoFV;AK5EE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AL8EJ;;AK1EA;EFVM,eALI;EEiBR,2BAAA;EACA,qBAAA;AL6EF;AK1EE;EACE,cAAA;AL4EJ;;AKxEA;EACE,2BAAA;EFtBI,eALI;EE6BR,wBCy5CkC;EDx5ClC,sCCy5CkC;EE9rDhC,qBAAA;ARiXJ;AKzEE;EACE,UAAA;EF7BE,cALI;AH8GV;;AKjEA;EACE,gBAAA;ALoEF;;AK9DA;;EAEE,sBAAA;ALiEF;;AKzDA;EACE,oBAAA;EACA,yBAAA;AL4DF;;AKzDA;EACE,oBEwH0C;EFvH1C,uBEuH0C;EFtH1C,cEpUS;EFqUT,gBAAA;AL4DF;;AKrDA;EAEE,mBAAA;EACA,gCAAA;ALuDF;;AKpDA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ALuDF;;AK/CA;EACE,qBAAA;ALkDF;;AK5CA;EAEE,gBAAA;AL8CF;;AKtCA;EACE,UAAA;ALyCF;;AKpCA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ALuCF;;AKnCA;;EAEE,oBAAA;ALsCF;;AKjCA;EACE,eAAA;ALoCF;;AKjCA;EAGE,iBAAA;ALkCF;AK/BE;EACE,UAAA;ALiCJ;;AK1BA;EACE,wBAAA;AL6BF;;AKrBA;;;;EAIE,0BAAA;ALwBF;AKrBI;;;;EACE,eAAA;AL0BN;;AKnBA;EACE,UAAA;EACA,kBAAA;ALsBF;;AKjBA;EACE,gBAAA;ALoBF;;AKVA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALaF;;AKLA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EHpatB,iCAAA;EEoNN,oBAAA;ALOF;AGvXI;EEyWJ;IFtMQ,iBAAA;EHwNN;AACF;AKVE;EACE,WAAA;ALYJ;;AKLA;;;;;;;EAOE,UAAA;ALQF;;AKLA;EACE,YAAA;ALQF;;AKCA;EACE,6BAAA;EACA,oBAAA;ALEF;;AKMA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALNF;;AKWA;EACE,UAAA;ALRF;;AKeA;EACE,aAAA;EACA,0BAAA;ALZF;;AKiBA;EACE,qBAAA;ALdF;;AKmBA;EACE,SAAA;ALhBF;;AKuBA;EACE,kBAAA;EACA,eAAA;ALpBF;;AK4BA;EACE,wBAAA;ALzBF;;AKiCA;EACE,wBAAA;AL9BF;;ASviBA;ENmQM,kBALI;EM5PR,gBHwoB4B;AN9F9B;;ASriBE;ENgQM,iCAAA;EM5PJ,gBFgViB;EE/UjB,gBF0Z2B;AP4I/B;AGvcI;EMpGF;INuQM,eAAA;EHwSN;AACF;;AShjBE;ENgQM,iCAAA;EM5PJ,gBFgViB;EE/UjB,gBF0Z2B;APuJ/B;AGldI;EMpGF;INuQM,iBAAA;EHmTN;AACF;;AS3jBE;ENgQM,iCAAA;EM5PJ,gBFgViB;EE/UjB,gBF0Z2B;APkK/B;AG7dI;EMpGF;INuQM,eAAA;EH8TN;AACF;;AStkBE;ENgQM,iCAAA;EM5PJ,gBFgViB;EE/UjB,gBF0Z2B;AP6K/B;AGxeI;EMpGF;INuQM,iBAAA;EHyUN;AACF;;ASjlBE;ENgQM,iCAAA;EM5PJ,gBFgViB;EE/UjB,gBF0Z2B;APwL/B;AGnfI;EMpGF;INuQM,eAAA;EHoVN;AACF;;AS5lBE;ENgQM,iCAAA;EM5PJ,gBFgViB;EE/UjB,gBF0Z2B;APmM/B;AG9fI;EMpGF;INuQM,iBAAA;EH+VN;AACF;;AS/kBA;ECvDE,eAAA;EACA,gBAAA;AV0oBF;;AS/kBA;EC5DE,eAAA;EACA,gBAAA;AV+oBF;;ASjlBA;EACE,qBAAA;ATolBF;ASllBE;EACE,oBHsoB0B;ANlD9B;;AS1kBA;EN8MM,kBALI;EMvMR,yBAAA;AT6kBF;;ASzkBA;EACE,mBFmHO;EJoFH,kBALI;AH2YV;AS1kBE;EACE,gBAAA;AT4kBJ;;ASxkBA;EACE,iBAAA;EACA,mBFyGO;EJoFH,kBALI;EMtLR,cFvES;APkpBX;ASzkBE;EACE,aAAA;AT2kBJ;;AW3qBA;ECIE,eAAA;EAGA,YAAA;AZyqBF;;AW1qBA;EACE,gBL+jDkC;EK9jDlC,mCJm5BkC;EIl5BlC,2DAAA;EHGE,sCAAA;EKLE,mCARW;EDKf,eAAA;EAGA,YAAA;AZmrBF;;AWrqBA;EAEE,qBAAA;AXuqBF;;AWpqBA;EACE,qBAAA;EACA,cAAA;AXuqBF;;AWpqBA;ERyPM,kBALI;EQlPR,yBJg4BkC;APzNpC;;AczsBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AfstBF;;AgBhqBI;EF5CE;IACE,gBP0Qe;EPscrB;AACF;AgBtqBI;EF5CE;IACE,gBP0Qe;EP2crB;AACF;AgB3qBI;EF5CE;IACE,gBP0Qe;EPgdrB;AACF;AgBhrBI;EF5CE;IACE,iBP0Qe;EPqdrB;AACF;AgBrrBI;EF5CE;IACE,iBP0Qe;EP0drB;AACF;AiBrvBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AjB2vBJ;;AiBtvBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AlB+vBF;AiB7vBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AlByvBF;;AkB1sBM;EACE,SAAA;AlB6sBR;;AkB1sBM;EApCJ,cAAA;EACA,WAAA;AlBkvBF;;AkBpuBE;EACE,cAAA;EACA,WAAA;AlBuuBJ;;AkBzuBE;EACE,cAAA;EACA,UAAA;AlB4uBJ;;AkB9uBE;EACE,cAAA;EACA,mBAAA;AlBivBJ;;AkBnvBE;EACE,cAAA;EACA,UAAA;AlBsvBJ;;AkBxvBE;EACE,cAAA;EACA,UAAA;AlB2vBJ;;AkB7vBE;EACE,cAAA;EACA,mBAAA;AlBgwBJ;;AkBjuBM;EAhDJ,cAAA;EACA,WAAA;AlBqxBF;;AkBhuBU;EAhEN,cAAA;EACA,kBAAA;AlBoyBJ;;AkBruBU;EAhEN,cAAA;EACA,mBAAA;AlByyBJ;;AkB1uBU;EAhEN,cAAA;EACA,UAAA;AlB8yBJ;;AkB/uBU;EAhEN,cAAA;EACA,mBAAA;AlBmzBJ;;AkBpvBU;EAhEN,cAAA;EACA,mBAAA;AlBwzBJ;;AkBzvBU;EAhEN,cAAA;EACA,UAAA;AlB6zBJ;;AkB9vBU;EAhEN,cAAA;EACA,mBAAA;AlBk0BJ;;AkBnwBU;EAhEN,cAAA;EACA,mBAAA;AlBu0BJ;;AkBxwBU;EAhEN,cAAA;EACA,UAAA;AlB40BJ;;AkB7wBU;EAhEN,cAAA;EACA,mBAAA;AlBi1BJ;;AkBlxBU;EAhEN,cAAA;EACA,mBAAA;AlBs1BJ;;AkBvxBU;EAhEN,cAAA;EACA,WAAA;AlB21BJ;;AkBpxBY;EAxDV,wBAAA;AlBg1BF;;AkBxxBY;EAxDV,yBAAA;AlBo1BF;;AkB5xBY;EAxDV,gBAAA;AlBw1BF;;AkBhyBY;EAxDV,yBAAA;AlB41BF;;AkBpyBY;EAxDV,yBAAA;AlBg2BF;;AkBxyBY;EAxDV,gBAAA;AlBo2BF;;AkB5yBY;EAxDV,yBAAA;AlBw2BF;;AkBhzBY;EAxDV,yBAAA;AlB42BF;;AkBpzBY;EAxDV,gBAAA;AlBg3BF;;AkBxzBY;EAxDV,yBAAA;AlBo3BF;;AkB5zBY;EAxDV,yBAAA;AlBw3BF;;AkBrzBQ;;EAEE,mBAAA;AlBwzBV;;AkBrzBQ;;EAEE,mBAAA;AlBwzBV;;AkB/zBQ;;EAEE,sBAAA;AlBk0BV;;AkB/zBQ;;EAEE,sBAAA;AlBk0BV;;AkBz0BQ;;EAEE,qBAAA;AlB40BV;;AkBz0BQ;;EAEE,qBAAA;AlB40BV;;AkBn1BQ;;EAEE,sBAAA;AlBs1BV;;AkBn1BQ;;EAEE,sBAAA;AlBs1BV;;AkB71BQ;;EAEE,mBAAA;AlBg2BV;;AkB71BQ;;EAEE,mBAAA;AlBg2BV;;AkBv2BQ;;EAEE,sBAAA;AlB02BV;;AkBv2BQ;;EAEE,sBAAA;AlB02BV;;AkBj3BQ;;EAEE,qBAAA;AlBo3BV;;AkBj3BQ;;EAEE,qBAAA;AlBo3BV;;AkB33BQ;;EAEE,sBAAA;AlB83BV;;AkB33BQ;;EAEE,sBAAA;AlB83BV;;AkBr4BQ;;EAEE,mBAAA;AlBw4BV;;AkBr4BQ;;EAEE,mBAAA;AlBw4BV;;AkB/4BQ;;EAEE,sBAAA;AlBk5BV;;AkB/4BQ;;EAEE,sBAAA;AlBk5BV;;AkBz5BQ;;EAEE,qBAAA;AlB45BV;;AkBz5BQ;;EAEE,qBAAA;AlB45BV;;AgBt9BI;EEUE;IACE,SAAA;ElBg9BN;EkB78BI;IApCJ,cAAA;IACA,WAAA;ElBo/BA;EkBt+BA;IACE,cAAA;IACA,WAAA;ElBw+BF;EkB1+BA;IACE,cAAA;IACA,UAAA;ElB4+BF;EkB9+BA;IACE,cAAA;IACA,mBAAA;ElBg/BF;EkBl/BA;IACE,cAAA;IACA,UAAA;ElBo/BF;EkBt/BA;IACE,cAAA;IACA,UAAA;ElBw/BF;EkB1/BA;IACE,cAAA;IACA,mBAAA;ElB4/BF;EkB79BI;IAhDJ,cAAA;IACA,WAAA;ElBghCA;EkB39BQ;IAhEN,cAAA;IACA,kBAAA;ElB8hCF;EkB/9BQ;IAhEN,cAAA;IACA,mBAAA;ElBkiCF;EkBn+BQ;IAhEN,cAAA;IACA,UAAA;ElBsiCF;EkBv+BQ;IAhEN,cAAA;IACA,mBAAA;ElB0iCF;EkB3+BQ;IAhEN,cAAA;IACA,mBAAA;ElB8iCF;EkB/+BQ;IAhEN,cAAA;IACA,UAAA;ElBkjCF;EkBn/BQ;IAhEN,cAAA;IACA,mBAAA;ElBsjCF;EkBv/BQ;IAhEN,cAAA;IACA,mBAAA;ElB0jCF;EkB3/BQ;IAhEN,cAAA;IACA,UAAA;ElB8jCF;EkB//BQ;IAhEN,cAAA;IACA,mBAAA;ElBkkCF;EkBngCQ;IAhEN,cAAA;IACA,mBAAA;ElBskCF;EkBvgCQ;IAhEN,cAAA;IACA,WAAA;ElB0kCF;EkBngCU;IAxDV,cAAA;ElB8jCA;EkBtgCU;IAxDV,wBAAA;ElBikCA;EkBzgCU;IAxDV,yBAAA;ElBokCA;EkB5gCU;IAxDV,gBAAA;ElBukCA;EkB/gCU;IAxDV,yBAAA;ElB0kCA;EkBlhCU;IAxDV,yBAAA;ElB6kCA;EkBrhCU;IAxDV,gBAAA;ElBglCA;EkBxhCU;IAxDV,yBAAA;ElBmlCA;EkB3hCU;IAxDV,yBAAA;ElBslCA;EkB9hCU;IAxDV,gBAAA;ElBylCA;EkBjiCU;IAxDV,yBAAA;ElB4lCA;EkBpiCU;IAxDV,yBAAA;ElB+lCA;EkB5hCM;;IAEE,mBAAA;ElB8hCR;EkB3hCM;;IAEE,mBAAA;ElB6hCR;EkBpiCM;;IAEE,sBAAA;ElBsiCR;EkBniCM;;IAEE,sBAAA;ElBqiCR;EkB5iCM;;IAEE,qBAAA;ElB8iCR;EkB3iCM;;IAEE,qBAAA;ElB6iCR;EkBpjCM;;IAEE,sBAAA;ElBsjCR;EkBnjCM;;IAEE,sBAAA;ElBqjCR;EkB5jCM;;IAEE,mBAAA;ElB8jCR;EkB3jCM;;IAEE,mBAAA;ElB6jCR;EkBpkCM;;IAEE,sBAAA;ElBskCR;EkBnkCM;;IAEE,sBAAA;ElBqkCR;EkB5kCM;;IAEE,qBAAA;ElB8kCR;EkB3kCM;;IAEE,qBAAA;ElB6kCR;EkBplCM;;IAEE,sBAAA;ElBslCR;EkBnlCM;;IAEE,sBAAA;ElBqlCR;EkB5lCM;;IAEE,mBAAA;ElB8lCR;EkB3lCM;;IAEE,mBAAA;ElB6lCR;EkBpmCM;;IAEE,sBAAA;ElBsmCR;EkBnmCM;;IAEE,sBAAA;ElBqmCR;EkB5mCM;;IAEE,qBAAA;ElB8mCR;EkB3mCM;;IAEE,qBAAA;ElB6mCR;AACF;AgBxqCI;EEUE;IACE,SAAA;ElBiqCN;EkB9pCI;IApCJ,cAAA;IACA,WAAA;ElBqsCA;EkBvrCA;IACE,cAAA;IACA,WAAA;ElByrCF;EkB3rCA;IACE,cAAA;IACA,UAAA;ElB6rCF;EkB/rCA;IACE,cAAA;IACA,mBAAA;ElBisCF;EkBnsCA;IACE,cAAA;IACA,UAAA;ElBqsCF;EkBvsCA;IACE,cAAA;IACA,UAAA;ElBysCF;EkB3sCA;IACE,cAAA;IACA,mBAAA;ElB6sCF;EkB9qCI;IAhDJ,cAAA;IACA,WAAA;ElBiuCA;EkB5qCQ;IAhEN,cAAA;IACA,kBAAA;ElB+uCF;EkBhrCQ;IAhEN,cAAA;IACA,mBAAA;ElBmvCF;EkBprCQ;IAhEN,cAAA;IACA,UAAA;ElBuvCF;EkBxrCQ;IAhEN,cAAA;IACA,mBAAA;ElB2vCF;EkB5rCQ;IAhEN,cAAA;IACA,mBAAA;ElB+vCF;EkBhsCQ;IAhEN,cAAA;IACA,UAAA;ElBmwCF;EkBpsCQ;IAhEN,cAAA;IACA,mBAAA;ElBuwCF;EkBxsCQ;IAhEN,cAAA;IACA,mBAAA;ElB2wCF;EkB5sCQ;IAhEN,cAAA;IACA,UAAA;ElB+wCF;EkBhtCQ;IAhEN,cAAA;IACA,mBAAA;ElBmxCF;EkBptCQ;IAhEN,cAAA;IACA,mBAAA;ElBuxCF;EkBxtCQ;IAhEN,cAAA;IACA,WAAA;ElB2xCF;EkBptCU;IAxDV,cAAA;ElB+wCA;EkBvtCU;IAxDV,wBAAA;ElBkxCA;EkB1tCU;IAxDV,yBAAA;ElBqxCA;EkB7tCU;IAxDV,gBAAA;ElBwxCA;EkBhuCU;IAxDV,yBAAA;ElB2xCA;EkBnuCU;IAxDV,yBAAA;ElB8xCA;EkBtuCU;IAxDV,gBAAA;ElBiyCA;EkBzuCU;IAxDV,yBAAA;ElBoyCA;EkB5uCU;IAxDV,yBAAA;ElBuyCA;EkB/uCU;IAxDV,gBAAA;ElB0yCA;EkBlvCU;IAxDV,yBAAA;ElB6yCA;EkBrvCU;IAxDV,yBAAA;ElBgzCA;EkB7uCM;;IAEE,mBAAA;ElB+uCR;EkB5uCM;;IAEE,mBAAA;ElB8uCR;EkBrvCM;;IAEE,sBAAA;ElBuvCR;EkBpvCM;;IAEE,sBAAA;ElBsvCR;EkB7vCM;;IAEE,qBAAA;ElB+vCR;EkB5vCM;;IAEE,qBAAA;ElB8vCR;EkBrwCM;;IAEE,sBAAA;ElBuwCR;EkBpwCM;;IAEE,sBAAA;ElBswCR;EkB7wCM;;IAEE,mBAAA;ElB+wCR;EkB5wCM;;IAEE,mBAAA;ElB8wCR;EkBrxCM;;IAEE,sBAAA;ElBuxCR;EkBpxCM;;IAEE,sBAAA;ElBsxCR;EkB7xCM;;IAEE,qBAAA;ElB+xCR;EkB5xCM;;IAEE,qBAAA;ElB8xCR;EkBryCM;;IAEE,sBAAA;ElBuyCR;EkBpyCM;;IAEE,sBAAA;ElBsyCR;EkB7yCM;;IAEE,mBAAA;ElB+yCR;EkB5yCM;;IAEE,mBAAA;ElB8yCR;EkBrzCM;;IAEE,sBAAA;ElBuzCR;EkBpzCM;;IAEE,sBAAA;ElBszCR;EkB7zCM;;IAEE,qBAAA;ElB+zCR;EkB5zCM;;IAEE,qBAAA;ElB8zCR;AACF;AgBz3CI;EEUE;IACE,SAAA;ElBk3CN;EkB/2CI;IApCJ,cAAA;IACA,WAAA;ElBs5CA;EkBx4CA;IACE,cAAA;IACA,WAAA;ElB04CF;EkB54CA;IACE,cAAA;IACA,UAAA;ElB84CF;EkBh5CA;IACE,cAAA;IACA,mBAAA;ElBk5CF;EkBp5CA;IACE,cAAA;IACA,UAAA;ElBs5CF;EkBx5CA;IACE,cAAA;IACA,UAAA;ElB05CF;EkB55CA;IACE,cAAA;IACA,mBAAA;ElB85CF;EkB/3CI;IAhDJ,cAAA;IACA,WAAA;ElBk7CA;EkB73CQ;IAhEN,cAAA;IACA,kBAAA;ElBg8CF;EkBj4CQ;IAhEN,cAAA;IACA,mBAAA;ElBo8CF;EkBr4CQ;IAhEN,cAAA;IACA,UAAA;ElBw8CF;EkBz4CQ;IAhEN,cAAA;IACA,mBAAA;ElB48CF;EkB74CQ;IAhEN,cAAA;IACA,mBAAA;ElBg9CF;EkBj5CQ;IAhEN,cAAA;IACA,UAAA;ElBo9CF;EkBr5CQ;IAhEN,cAAA;IACA,mBAAA;ElBw9CF;EkBz5CQ;IAhEN,cAAA;IACA,mBAAA;ElB49CF;EkB75CQ;IAhEN,cAAA;IACA,UAAA;ElBg+CF;EkBj6CQ;IAhEN,cAAA;IACA,mBAAA;ElBo+CF;EkBr6CQ;IAhEN,cAAA;IACA,mBAAA;ElBw+CF;EkBz6CQ;IAhEN,cAAA;IACA,WAAA;ElB4+CF;EkBr6CU;IAxDV,cAAA;ElBg+CA;EkBx6CU;IAxDV,wBAAA;ElBm+CA;EkB36CU;IAxDV,yBAAA;ElBs+CA;EkB96CU;IAxDV,gBAAA;ElBy+CA;EkBj7CU;IAxDV,yBAAA;ElB4+CA;EkBp7CU;IAxDV,yBAAA;ElB++CA;EkBv7CU;IAxDV,gBAAA;ElBk/CA;EkB17CU;IAxDV,yBAAA;ElBq/CA;EkB77CU;IAxDV,yBAAA;ElBw/CA;EkBh8CU;IAxDV,gBAAA;ElB2/CA;EkBn8CU;IAxDV,yBAAA;ElB8/CA;EkBt8CU;IAxDV,yBAAA;ElBigDA;EkB97CM;;IAEE,mBAAA;ElBg8CR;EkB77CM;;IAEE,mBAAA;ElB+7CR;EkBt8CM;;IAEE,sBAAA;ElBw8CR;EkBr8CM;;IAEE,sBAAA;ElBu8CR;EkB98CM;;IAEE,qBAAA;ElBg9CR;EkB78CM;;IAEE,qBAAA;ElB+8CR;EkBt9CM;;IAEE,sBAAA;ElBw9CR;EkBr9CM;;IAEE,sBAAA;ElBu9CR;EkB99CM;;IAEE,mBAAA;ElBg+CR;EkB79CM;;IAEE,mBAAA;ElB+9CR;EkBt+CM;;IAEE,sBAAA;ElBw+CR;EkBr+CM;;IAEE,sBAAA;ElBu+CR;EkB9+CM;;IAEE,qBAAA;ElBg/CR;EkB7+CM;;IAEE,qBAAA;ElB++CR;EkBt/CM;;IAEE,sBAAA;ElBw/CR;EkBr/CM;;IAEE,sBAAA;ElBu/CR;EkB9/CM;;IAEE,mBAAA;ElBggDR;EkB7/CM;;IAEE,mBAAA;ElB+/CR;EkBtgDM;;IAEE,sBAAA;ElBwgDR;EkBrgDM;;IAEE,sBAAA;ElBugDR;EkB9gDM;;IAEE,qBAAA;ElBghDR;EkB7gDM;;IAEE,qBAAA;ElB+gDR;AACF;AgB1kDI;EEUE;IACE,SAAA;ElBmkDN;EkBhkDI;IApCJ,cAAA;IACA,WAAA;ElBumDA;EkBzlDA;IACE,cAAA;IACA,WAAA;ElB2lDF;EkB7lDA;IACE,cAAA;IACA,UAAA;ElB+lDF;EkBjmDA;IACE,cAAA;IACA,mBAAA;ElBmmDF;EkBrmDA;IACE,cAAA;IACA,UAAA;ElBumDF;EkBzmDA;IACE,cAAA;IACA,UAAA;ElB2mDF;EkB7mDA;IACE,cAAA;IACA,mBAAA;ElB+mDF;EkBhlDI;IAhDJ,cAAA;IACA,WAAA;ElBmoDA;EkB9kDQ;IAhEN,cAAA;IACA,kBAAA;ElBipDF;EkBllDQ;IAhEN,cAAA;IACA,mBAAA;ElBqpDF;EkBtlDQ;IAhEN,cAAA;IACA,UAAA;ElBypDF;EkB1lDQ;IAhEN,cAAA;IACA,mBAAA;ElB6pDF;EkB9lDQ;IAhEN,cAAA;IACA,mBAAA;ElBiqDF;EkBlmDQ;IAhEN,cAAA;IACA,UAAA;ElBqqDF;EkBtmDQ;IAhEN,cAAA;IACA,mBAAA;ElByqDF;EkB1mDQ;IAhEN,cAAA;IACA,mBAAA;ElB6qDF;EkB9mDQ;IAhEN,cAAA;IACA,UAAA;ElBirDF;EkBlnDQ;IAhEN,cAAA;IACA,mBAAA;ElBqrDF;EkBtnDQ;IAhEN,cAAA;IACA,mBAAA;ElByrDF;EkB1nDQ;IAhEN,cAAA;IACA,WAAA;ElB6rDF;EkBtnDU;IAxDV,cAAA;ElBirDA;EkBznDU;IAxDV,wBAAA;ElBorDA;EkB5nDU;IAxDV,yBAAA;ElBurDA;EkB/nDU;IAxDV,gBAAA;ElB0rDA;EkBloDU;IAxDV,yBAAA;ElB6rDA;EkBroDU;IAxDV,yBAAA;ElBgsDA;EkBxoDU;IAxDV,gBAAA;ElBmsDA;EkB3oDU;IAxDV,yBAAA;ElBssDA;EkB9oDU;IAxDV,yBAAA;ElBysDA;EkBjpDU;IAxDV,gBAAA;ElB4sDA;EkBppDU;IAxDV,yBAAA;ElB+sDA;EkBvpDU;IAxDV,yBAAA;ElBktDA;EkB/oDM;;IAEE,mBAAA;ElBipDR;EkB9oDM;;IAEE,mBAAA;ElBgpDR;EkBvpDM;;IAEE,sBAAA;ElBypDR;EkBtpDM;;IAEE,sBAAA;ElBwpDR;EkB/pDM;;IAEE,qBAAA;ElBiqDR;EkB9pDM;;IAEE,qBAAA;ElBgqDR;EkBvqDM;;IAEE,sBAAA;ElByqDR;EkBtqDM;;IAEE,sBAAA;ElBwqDR;EkB/qDM;;IAEE,mBAAA;ElBirDR;EkB9qDM;;IAEE,mBAAA;ElBgrDR;EkBvrDM;;IAEE,sBAAA;ElByrDR;EkBtrDM;;IAEE,sBAAA;ElBwrDR;EkB/rDM;;IAEE,qBAAA;ElBisDR;EkB9rDM;;IAEE,qBAAA;ElBgsDR;EkBvsDM;;IAEE,sBAAA;ElBysDR;EkBtsDM;;IAEE,sBAAA;ElBwsDR;EkB/sDM;;IAEE,mBAAA;ElBitDR;EkB9sDM;;IAEE,mBAAA;ElBgtDR;EkBvtDM;;IAEE,sBAAA;ElBytDR;EkBttDM;;IAEE,sBAAA;ElBwtDR;EkB/tDM;;IAEE,qBAAA;ElBiuDR;EkB9tDM;;IAEE,qBAAA;ElBguDR;AACF;AgB3xDI;EEUE;IACE,SAAA;ElBoxDN;EkBjxDI;IApCJ,cAAA;IACA,WAAA;ElBwzDA;EkB1yDA;IACE,cAAA;IACA,WAAA;ElB4yDF;EkB9yDA;IACE,cAAA;IACA,UAAA;ElBgzDF;EkBlzDA;IACE,cAAA;IACA,mBAAA;ElBozDF;EkBtzDA;IACE,cAAA;IACA,UAAA;ElBwzDF;EkB1zDA;IACE,cAAA;IACA,UAAA;ElB4zDF;EkB9zDA;IACE,cAAA;IACA,mBAAA;ElBg0DF;EkBjyDI;IAhDJ,cAAA;IACA,WAAA;ElBo1DA;EkB/xDQ;IAhEN,cAAA;IACA,kBAAA;ElBk2DF;EkBnyDQ;IAhEN,cAAA;IACA,mBAAA;ElBs2DF;EkBvyDQ;IAhEN,cAAA;IACA,UAAA;ElB02DF;EkB3yDQ;IAhEN,cAAA;IACA,mBAAA;ElB82DF;EkB/yDQ;IAhEN,cAAA;IACA,mBAAA;ElBk3DF;EkBnzDQ;IAhEN,cAAA;IACA,UAAA;ElBs3DF;EkBvzDQ;IAhEN,cAAA;IACA,mBAAA;ElB03DF;EkB3zDQ;IAhEN,cAAA;IACA,mBAAA;ElB83DF;EkB/zDQ;IAhEN,cAAA;IACA,UAAA;ElBk4DF;EkBn0DQ;IAhEN,cAAA;IACA,mBAAA;ElBs4DF;EkBv0DQ;IAhEN,cAAA;IACA,mBAAA;ElB04DF;EkB30DQ;IAhEN,cAAA;IACA,WAAA;ElB84DF;EkBv0DU;IAxDV,cAAA;ElBk4DA;EkB10DU;IAxDV,wBAAA;ElBq4DA;EkB70DU;IAxDV,yBAAA;ElBw4DA;EkBh1DU;IAxDV,gBAAA;ElB24DA;EkBn1DU;IAxDV,yBAAA;ElB84DA;EkBt1DU;IAxDV,yBAAA;ElBi5DA;EkBz1DU;IAxDV,gBAAA;ElBo5DA;EkB51DU;IAxDV,yBAAA;ElBu5DA;EkB/1DU;IAxDV,yBAAA;ElB05DA;EkBl2DU;IAxDV,gBAAA;ElB65DA;EkBr2DU;IAxDV,yBAAA;ElBg6DA;EkBx2DU;IAxDV,yBAAA;ElBm6DA;EkBh2DM;;IAEE,mBAAA;ElBk2DR;EkB/1DM;;IAEE,mBAAA;ElBi2DR;EkBx2DM;;IAEE,sBAAA;ElB02DR;EkBv2DM;;IAEE,sBAAA;ElBy2DR;EkBh3DM;;IAEE,qBAAA;ElBk3DR;EkB/2DM;;IAEE,qBAAA;ElBi3DR;EkBx3DM;;IAEE,sBAAA;ElB03DR;EkBv3DM;;IAEE,sBAAA;ElBy3DR;EkBh4DM;;IAEE,mBAAA;ElBk4DR;EkB/3DM;;IAEE,mBAAA;ElBi4DR;EkBx4DM;;IAEE,sBAAA;ElB04DR;EkBv4DM;;IAEE,sBAAA;ElBy4DR;EkBh5DM;;IAEE,qBAAA;ElBk5DR;EkB/4DM;;IAEE,qBAAA;ElBi5DR;EkBx5DM;;IAEE,sBAAA;ElB05DR;EkBv5DM;;IAEE,sBAAA;ElBy5DR;EkBh6DM;;IAEE,mBAAA;ElBk6DR;EkB/5DM;;IAEE,mBAAA;ElBi6DR;EkBx6DM;;IAEE,sBAAA;ElB06DR;EkBv6DM;;IAEE,sBAAA;ElBy6DR;EkBh7DM;;IAEE,qBAAA;ElBk7DR;EkB/6DM;;IAEE,qBAAA;ElBi7DR;AACF;AmBviEA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,yDAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,uCAAA;EAEA,WAAA;EACA,mBZoLO;EYnLP,mBbusB4B;EatsB5B,0CAAA;AnBsiEF;AmB/hEE;EACE,wBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,wBZqQ4B;EYpQ5B,2GAAA;AnBgiEJ;AmB7hEE;EACE,uBAAA;AnB+hEJ;AmB5hEE;EACE,sBAAA;AnB8hEJ;;AmB1hEA;EACE,4CAAA;AnB6hEF;;AmBthEA;EACE,iBAAA;AnByhEF;;AmB/gEE;EACE,sBAAA;AnBkhEJ;;AmBngEE;EACE,mBAAA;AnBsgEJ;AmBngEI;EACE,mBAAA;AnBqgEN;;AmB9/DE;EACE,sBAAA;AnBigEJ;AmB9/DE;EACE,mBAAA;AnBggEJ;;AmBt/DE;EACE,oDAAA;EACA,8CAAA;AnBy/DJ;;AmBn/DE;EACE,oDAAA;EACA,8CAAA;AnBs/DJ;;AmB9+DA;EACE,oDAAA;EACA,8CAAA;AnBi/DF;;AmBz+DE;EACE,mDAAA;EACA,6CAAA;AnB4+DJ;;AoBxnEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBonEJ;;AoBtoEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBkoEJ;;AoBppEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBgpEJ;;AoBlqEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB8pEJ;;AoBhrEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB4qEJ;;AoB9rEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApB0rEJ;;AoB5sEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBwsEJ;;AoB1tEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;ApBstEJ;;AmBrkEI;EACE,gBAAA;EACA,iCAAA;AnBwkEN;;AgBnqEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnB8kEJ;AACF;AgB1qEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBolEJ;AACF;AgBhrEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnB0lEJ;AACF;AgBtrEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBgmEJ;AACF;AgB5rEI;EGyFA;IACE,gBAAA;IACA,iCAAA;EnBsmEJ;AACF;AqB1wEA;EACE,qBdgjB0C;EJtRtC,kBALI;EkBlRR,gBd+iB0C;Ec9iB1C,yBd+iB0C;AP4tD5C;;AqBtwEA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;ElB8QI,kBALI;EkBtQR,gBdmiB0C;EcliB1C,gBduWiB;EctWjB,yBdkiB0C;APsuD5C;;AqBrwEA;EACE,iCAAA;EACA,oCAAA;ElBoQI,kBALI;AH0gEV;;AqBrwEA;EACE,gCAAA;EACA,mCAAA;ElB8PI,kBALI;AHghEV;;AsBtyEA;EACE,kBf4iB0C;EJlRtC,kBALI;EmBjRR,2Bf0iB0C;AP6vD5C;;AuB5yEA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EpBwRI,iBALI;EoBhRR,gBhB2WqB;EgB1WrB,gBhBiXiB;EgBhXjB,yBhBwjB0C;EgBvjB1C,gBAAA;EACA,mChBmjB0C;EgBljB1C,4BAAA;EACA,oCAAA;EfGE,sBAAA;EKLE,iBARW;EWUX,wEDMJ;AvB2yEF;AwB7yEM;EDhBN;ICiBQ,gBAAA;ExBgzEN;AACF;AuB9yEE;EACE,gBAAA;AvBgzEJ;AuB9yEI;EACE,eAAA;AvBgzEN;AuB3yEE;EACE,yBhBkiBwC;EgBjiBxC,mChB8hBwC;EgB7hBxC,gChBwiBwC;EgBviBxC,UAAA;EVvBE,yDARW;Ab60EjB;AuBryEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AvByxEJ;AuBpxEE;EACE,cAAA;EACA,UAAA;AvBsxEJ;AuBlxEE;EACE,yBhB0gBwC;EgBxgBxC,UAAA;AvBmxEJ;AuB3wEE;EACE,yBhB2fwC;EgB1fxC,oChB2fwC;EgB1fxC,gChB6ewC;EgB3exC,UAAA;AvB4wEJ;AuBxwEE;EACE,sBAAA;EACA,uBAAA;EACA,uBhBqZwC;EgBpZxC,yBhBkewC;EkBhkB1C,oClBgqBkD;EgBhkBhD,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BhBkM4B;EgBjM5B,gBAAA;ECzFE,qID0FF;AvB0wEJ;AwBh2EM;ED0EJ;ICzEM,gBAAA;ExBm2EN;AACF;AuB5wEE;EACE,qDhBmlBgD;AP2rDpD;;AuBrwEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBhBgQiB;EgB/PjB,yBhByd0C;EgBxd1C,6BAAA;EACA,yBAAA;EACA,mBAAA;AvBwwEF;AuBtwEE;EACE,UAAA;AvBwwEJ;AuBrwEE;EAEE,gBAAA;EACA,eAAA;AvBswEJ;;AuB3vEA;EACE,sCjB4wBsC;EiB3wBtC,wBAAA;EpByII,kBALI;EKvQN,qBAAA;ARm4EJ;AuB5vEE;EACE,wBAAA;EACA,yBAAA;EACA,0BhBqWwC;APy5D5C;;AuB1vEA;EACE,uCjBgwBsC;EiB/vBtC,wBAAA;EpB4HI,kBALI;EKvQN,sBAAA;AR+4EJ;AuB3vEE;EACE,wBAAA;EACA,yBAAA;EACA,yBhB4VwC;APi6D5C;;AuBrvEE;EACE,uCjB6uBoC;AN2gDxC;AuBrvEE;EACE,sCjB0uBoC;AN6gDxC;AuBpvEE;EACE,uCjBuuBoC;AN+gDxC;;AuBjvEA;EACE,WjBquBsC;EiBpuBtC,mCjB8tBsC;EiB7tBtC,iBhBkT0C;APk8D5C;AuBlvEE;EACE,eAAA;AvBovEJ;AuBjvEE;EACE,oBAAA;EfvLA,sBAAA;AR26EJ;AuBhvEE;EACE,oBAAA;Ef5LA,sBAAA;AR+6EJ;AuB/uEE;EAAoB,kCjB8sBkB;ANoiDxC;AuBjvEE;EAAoB,mCjB8sBkB;ANsiDxC;;A0Bn8EA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,oCAAA;EvBqRI,iBALI;EuB7QR,gBnBwWqB;EmBvWrB,gBnB8WiB;EmB7WjB,yBnBqjB0C;EmBpjB1C,gBAAA;EACA,mCnBgjB0C;EmB/iB1C,mFAAA;EACA,4BAAA;EACA,sCpB+9BkC;EoB99BlC,0BpB+9BkC;EoB99BlC,oCAAA;ElBHE,sBAAA;EKLE,iBARW;EWUX,wEESJ;A1Bo8EF;AwBz8EM;EEfN;IFgBQ,gBAAA;ExB48EN;AACF;A0Bv8EE;EACE,gCnBgjBwC;EmB/iBxC,UAAA;EbfE,0EARW;Abi+EjB;A0Bj8EE;EAEE,mBnB8cwC;EmB7cxC,sBAAA;A1Bk8EJ;A0B/7EE;EACE,yBnBoiBwC;EmBniBxC,oCnB+nBgD;EmB9nBhD,gCnBshBwC;AP26D5C;A0B77EE;EACE,kBAAA;EACA,qCAAA;A1B+7EJ;;A0B37EA;EACE,oBnBuc0C;EmBtc1C,uBnBsc0C;EmBrc1C,qBnBsc0C;EJnOtC,kBALI;EKvQN,qBAAA;ARy+EJ;;A0B37EA;EACE,qBnBmc0C;EmBlc1C,wBnBkc0C;EmBjc1C,oBnBkc0C;EJvOtC,kBALI;EKvQN,sBAAA;ARi/EJ;;A0Bz7EI;EACE,gEAAA;A1B47EN;;A2BpgFA;EACE,cAAA;EACA,kBpBgmB0C;EoB/lB1C,qBpBgmB0C;EoB/lB1C,uBpBimB0C;APs6D5C;A2BrgFE;EACE,WAAA;EACA,qBAAA;A3BugFJ;;A2BngFA;EACE,sBpBslB0C;EoBrlB1C,eAAA;EACA,iBAAA;A3BsgFF;A2BpgFE;EACE,YAAA;EACA,sBAAA;EACA,cAAA;A3BsgFJ;;A2BlgFA;EACE,+BAAA;EAEA,cAAA;EACA,cpBkkB0C;EoBjkB1C,epBikB0C;EoBhkB1C,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,oCpB0kB0C;EoBzkB1C,iCAAA;UAAA,yBAAA;A3BogFF;A2BjgFE;EnB3BE,qBAAA;AR+hFJ;A2BhgFE;EAEE,kBpBkkBwC;AP+7D5C;A2B9/EE;EACE,uBpBwjBwC;APw8D5C;A2B7/EE;EACE,gCpBghBwC;EoB/gBxC,UAAA;EACA,gBpB0jBwC;APq8D5C;A2B5/EE;EACE,yBpBdW;EoBeX,qBpBfW;AP6gFf;A2B5/EI;EAII,iEAAA;A3B2/ER;A2Bv/EI;EAII,iEAAA;A3Bs/ER;A2Bj/EE;EACE,yBpBnCW;EoBoCX,qBpBpCW;EoByCT,iEAAA;A3B++EN;A2B3+EE;EACE,oBAAA;EACA,YAAA;EACA,YpBoiBgD;APy8DpD;A2Bt+EI;EACE,eAAA;EACA,YpB2hB8C;AP68DpD;;A2Bn+EA;EACE,yBpBuf0C;AP++D5C;;A2B99EA;EACE,qBpByhBkD;APw8DpD;A2B/9EE;EACE,4DAAA;EAEA,cpB6gBgD;EoB5gBhD,qBAAA;EACA,0CAAA;EACA,gCAAA;EnBjHA,sBAAA;EgBHE,iDGsHF;A3Bg+EJ;AwBllFM;EG0GJ;IHzGM,gBAAA;ExBqlFN;AACF;A2Bn+EI;EACE,4DAAA;A3Bq+EN;A2Bl+EI;EACE,iCpBmhB8C;EoB9gB5C,4DAAA;A3Bg+ER;A2B39EE;EACE,sBpB6fgD;EoB5fhD,eAAA;A3B69EJ;A2B39EI;EACE,sBAAA;EACA,cAAA;A3B69EN;;A2Bx9EA;EACE,qBAAA;EACA,kBrBsyBgC;ANqrDlC;;A2Bx9EA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A3B29EF;A2Bv9EI;EACE,oBAAA;EACA,YAAA;EACA,apBkXsC;APumE5C;;A2Bl9EI;EACE,4DAAA;A3Bq9EN;;A4BxoFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A5B2oFF;A4BzoFE;EACE,UAAA;A5B2oFJ;A4BvoFI;EAA0B,qEtB8gCa;AN4nD3C;A4BzoFI;EAA0B,qEtB6gCa;AN+nD3C;A4BzoFE;EACE,SAAA;A5B2oFJ;A4BxoFE;EACE,WtB+/BuC;EsB9/BvC,YtB8/BuC;EsB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBlBgDa;EqBpBX,StB6/BuC;EE1gCvC,mBAAA;EKLE,+CARW;EWUX,oHImBF;EJnBE,4GImBF;A5B0oFJ;AwBzpFM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;ExB4pFN;AACF;A4B7oFI;EHjCF,yBnB8hCyC;ANmpD3C;A4B3oFE;EACE,WtBw+B8B;EsBv+B9B,ctBw+B8B;EsBv+B9B,kBAAA;EACA,etBu+B8B;EsBt+B9B,oCrB2oBgD;EqB1oBhD,yBAAA;EpB7BA,sBAAA;EKLE,sCARW;AbyrFjB;A4B1oFE;EACE,WtBo+BuC;EsBn+BvC,YtBm+BuC;EsBl+BvC,gBAAA;EHpDF,yBlBgDa;EqBMX,StBm+BuC;EE1gCvC,mBAAA;EKLE,+CARW;EWUX,iHI6CF;EJ7CE,4GI6CF;A5B4oFJ;AwBrrFM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;ExBwrFN;AACF;A4B/oFI;EH3DF,yBnB8hCyC;AN+qD3C;A4B7oFE;EACE,WtB88B8B;EsB78B9B,ctB88B8B;EsB78B9B,kBAAA;EACA,etB68B8B;EsB58B9B,oCrBinBgD;EqBhnBhD,yBAAA;EpBvDA,sBAAA;EKLE,sCARW;AbqtFjB;A4B5oFE;EACE,oBAAA;A5B8oFJ;A4B5oFI;EACE,oCrBwmB8C;APsiEpD;A4B3oFI;EACE,oCrBomB8C;APyiEpD;;A6BpuFA;EACE,kBAAA;A7BuuFF;A6BruFE;;;EAGE,2BtBgsBmC;EsB/rBnC,+BtB+rBmC;EsB9rBnC,iBvBuiCoC;ANgsDxC;A6BpuFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELRE,gEKSF;A7BsuFJ;AwB3uFM;EKTJ;ILUM,gBAAA;ExB8uFN;AACF;A6BxuFE;;EAEE,kBAAA;A7B0uFJ;A6BxuFI;;EACE,kBAAA;A7B2uFN;A6BxuFI;;;EAEE,oBtBiqB8C;EsBhqB9C,wBvB4gCkC;AN+tDxC;A6BxuFI;;EACE,oBtB4pB8C;EsB3pB9C,wBvBugCkC;ANouDxC;A6BvuFE;EACE,oBtBspBgD;EsBrpBhD,wBvBigCoC;ANwuDxC;A6BluFI;;;;EACE,2CAAA;EACA,8DvB2/BkC;AN4uDxC;A6BruFM;;;;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,avBm/BgC;EuBl/BhC,WAAA;EACA,mCtB8foC;EC9iBxC,sBAAA;AR2xFJ;A6BpuFI;EACE,2CAAA;EACA,8DvB0+BkC;AN4vDxC;A6BjuFI;EACE,mBAAA;A7BmuFN;A6B/tFE;;EAEE,ctB3DO;AP4xFX;A6B/tFI;;EACE,oCtBufsC;AP2uE5C;;A8BzzFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9B4zFF;A8B1zFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A9B4zFJ;A8BxzFE;;;EAGE,UAAA;A9B0zFJ;A8BpzFE;EACE,kBAAA;EACA,UAAA;A9BszFJ;A8BpzFI;EACE,UAAA;A9BszFN;;A8B3yFA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;E3B8OI,iBALI;E2BvOR,gBvBkUqB;EuBjUrB,gBvBwUiB;EuBvUjB,yBvBgnBkD;EuB/mBlD,kBAAA;EACA,mBAAA;EACA,oCvB4mBkD;EuB3mBlD,oCAAA;EtBtCE,sBAAA;ARq1FJ;;A8BryFA;;;;EAIE,wBAAA;E3BwNI,kBALI;EKvQN,sBAAA;AR81FJ;;A8BryFA;;;;EAIE,wBAAA;E3B+MI,kBALI;EKvQN,qBAAA;ARu2FJ;;A8BryFA;;EAEE,mBAAA;A9BwyFF;;A8B3xFI;;;;EtBjEA,0BAAA;EACA,6BAAA;ARm2FJ;A8B1xFI;;;;EtB1EA,0BAAA;EACA,6BAAA;AR02FJ;A8BpxFE;EACE,2BAAA;EtB1EA,yBAAA;EACA,4BAAA;ARi2FJ;A8BpxFE;;EtB9EE,yBAAA;EACA,4BAAA;ARs2FJ;;A+B93FE;EACE,aAAA;EACA,WAAA;EACA,kBxBohBwC;EJlRtC,kBALI;E4B1PN,iCzBkjCqB;AN80DzB;;A+B73FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;E5BqPE,eALI;E4B7ON,WzBqiCqB;EyBpiCrB,mCzBoiCqB;EE/jCrB,sBAAA;AR25FJ;;A+B33FI;;;;EAEE,cAAA;A/Bg4FN;;A+B/6FI;EAqDE,+CzBuhCmB;EyBphCjB,oCzB81BgC;EyB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A/B43FR;A+Bz3FM;EACE,+CzB4gCiB;EOpkCnB,kEARW;Ab47FjB;;A+B57FI;EA+EI,oCzBu0BgC;EyBt0BhC,kFAAA;A/Bi3FR;;A+Bj8FI;EAuFE,+CzBq/BmB;ANy3DzB;A+B32FQ;EAEE,iEAAA;EACA,qBzBq5B8B;EyBp5B9B,yDAAA;EACA,2EAAA;A/B42FV;A+Bx2FM;EACE,+CzBw+BiB;EOpkCnB,kEARW;Ab+8FjB;;A+B/8FI;EAkHI,yCAAA;A/Bi2FR;;A+Bn9FI;EAyHE,+CzBm9BmB;AN24DzB;A+B51FM;EACE,4CzBg9BiB;AN84DzB;A+B31FM;EACE,2DzB48BiB;ANi5DzB;A+B11FM;EACE,iCzBw8BiB;ANo5DzB;;A+Bv1FI;EACE,kBAAA;A/B01FN;;A+Bp+FI;;;;;EAoJM,UAAA;A/Bw1FV;;A+Bx9FE;EACE,aAAA;EACA,WAAA;EACA,kBxBohBwC;EJlRtC,kBALI;E4B1PN,mCzBkjCqB;ANw6DzB;;A+Bv9FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;E5BqPE,eALI;E4B7ON,WzBqiCqB;EyBpiCrB,kCzBoiCqB;EE/jCrB,sBAAA;ARq/FJ;;A+Br9FI;;;;EAEE,cAAA;A/B09FN;;A+BzgGI;EAqDE,iDzBuhCmB;EyBphCjB,oCzB81BgC;EyB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A/Bs9FR;A+Bn9FM;EACE,iDzB4gCiB;EOpkCnB,iEARW;AbshGjB;;A+BthGI;EA+EI,oCzBu0BgC;EyBt0BhC,kFAAA;A/B28FR;;A+B3hGI;EAuFE,iDzBq/BmB;ANm9DzB;A+Br8FQ;EAEE,iEAAA;EACA,qBzBq5B8B;EyBp5B9B,yDAAA;EACA,2EAAA;A/Bs8FV;A+Bl8FM;EACE,iDzBw+BiB;EOpkCnB,iEARW;AbyiGjB;;A+BziGI;EAkHI,yCAAA;A/B27FR;;A+B7iGI;EAyHE,iDzBm9BmB;ANq+DzB;A+Bt7FM;EACE,8CzBg9BiB;ANw+DzB;A+Br7FM;EACE,0DzB48BiB;AN2+DzB;A+Bp7FM;EACE,mCzBw8BiB;AN8+DzB;;A+Bj7FI;EACE,kBAAA;A/Bo7FN;;A+B9jGI;;;;;EAsJM,UAAA;A/Bg7FV;;AgCxkGA;EAEE,0BAAA;EACA,4BAAA;EACA,sBAAA;E7BuRI,0BALI;E6BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,+BAAA;EACA,wCAAA;EACA,yBAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E7BsQI,kCALI;E6B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ExBjBE,0CAAA;EiBfF,kCOkCqB;EnBxBjB,oCARW;EWUX,qIQwBJ;AhCskGF;AwB1lGM;EQhBN;IRiBQ,gBAAA;ExB6lGN;AACF;AgCzkGE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AhC0kGJ;AgCvkGE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AhCwkGJ;AgCrkGE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAGE,oEAAA;AhCqkGN;AgC/jGE;EACE,8CAAA;EACA,UAAA;EAGE,oEAAA;AhC+jGN;AgCzjGE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;EnB3EE,uCARW;AbyoGjB;AgCnjGI;EAGI,uEAAA;AhCmjGR;AgC5iGE;EAGI,uEAAA;AhC4iGN;AgCtiGE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;EnBzGE,gBARW;AbupGjB;;AgC1hGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC6oGF;;AgC3iGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC8pGF;;AgC5jGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjC+qGF;;AgC7kGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCgsGF;;AgC9lGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCitGF;;AgC/mGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCkuGF;;AgChoGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCmvGF;;AgCjpGE;EC/GA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AjCowGF;;AgCxoGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC4vGF;;AgCzpGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC6wGF;;AgC1qGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC8xGF;;AgC3rGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjC+yGF;;AgC5sGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCg0GF;;AgC7tGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCi1GF;;AgC9uGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCk2GF;;AgC/vGE;EChHA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjCm3GF;;AgCpwGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,2CAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,qBzBwE0B;AP8rG5B;AgCjwGE;EAEE,qBzBoEwB;AP8rG5B;AgC/vGE;EACE,0BAAA;AhCiwGJ;AgC9vGE;EACE,gCAAA;AhCgwGJ;;AgCrvGA;ECjJE,4BAAA;EACA,2BAAA;E9B8NI,2BALI;E8BvNR,+BAAA;AjC04GF;;AgCxvGA;ECrJE,2BAAA;EACA,wBAAA;E9B8NI,2BALI;E8BvNR,8BAAA;AjCi5GF;;AkCp9GA;EVgBM,gCUfJ;AlCu9GF;AwBp8GM;EUpBN;IVqBQ,gBAAA;ExBu8GN;AACF;AkC19GE;EACE,UAAA;AlC49GJ;;AkCt9GE;EACE,aAAA;AlCy9GJ;;AkCr9GA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AlCw9GF;AwBt9GM;EULN;IVMQ,gBAAA;ExBy9GN;AACF;AkC39GE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AlC69GJ;AwBh+GM;EUAJ;IVCM,gBAAA;ExBm+GN;AACF;;AmCx/GA;;;;;;EAME,kBAAA;AnC2/GF;;AmCx/GA;EACE,mBAAA;AnC2/GF;AoCn+GI;EACE,qBAAA;EACA,oB9B6hBwB;E8B5hBxB,uB9B2hBwB;E8B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ApC2gHF;AoCj9GI;EACE,cAAA;ApCm9GN;;AmCjgHA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EhCuQI,6BALI;EgChQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oCAAA;EACA,gCAAA;EACA,uDAAA;EACA,4CAAA;EACA,sCAAA;EACA,kEAAA;EACA,4CAAA;EACA,kDAAA;EACA,kDAAA;EACA,gEAAA;EACA,0DAAA;EACA,qDAAA;EACA,qCAAA;EACA,qCAAA;EACA,8CAAA;EACA,uCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;EhC0OI,uCALI;EgCnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E3BzCE,+CAAA;EKLE,yCARW;AbyjHjB;AmC//GE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AnCigHJ;;AmCz+GI;EACE,oBAAA;AnC4+GN;AmC1+GM;EACE,WAAA;EACA,OAAA;AnC4+GR;;AmCx+GI;EACE,kBAAA;AnC2+GN;AmCz+GM;EACE,QAAA;EACA,UAAA;AnC2+GR;;AgBrhHI;EmB4BA;IACE,oBAAA;EnC6/GJ;EmC3/GI;IACE,WAAA;IACA,OAAA;EnC6/GN;EmCz/GE;IACE,kBAAA;EnC2/GJ;EmCz/GI;IACE,QAAA;IACA,UAAA;EnC2/GN;AACF;AgBtiHI;EmB4BA;IACE,oBAAA;EnC6gHJ;EmC3gHI;IACE,WAAA;IACA,OAAA;EnC6gHN;EmCzgHE;IACE,kBAAA;EnC2gHJ;EmCzgHI;IACE,QAAA;IACA,UAAA;EnC2gHN;AACF;AgBtjHI;EmB4BA;IACE,oBAAA;EnC6hHJ;EmC3hHI;IACE,WAAA;IACA,OAAA;EnC6hHN;EmCzhHE;IACE,kBAAA;EnC2hHJ;EmCzhHI;IACE,QAAA;IACA,UAAA;EnC2hHN;AACF;AgBtkHI;EmB4BA;IACE,oBAAA;EnC6iHJ;EmC3iHI;IACE,WAAA;IACA,OAAA;EnC6iHN;EmCziHE;IACE,kBAAA;EnC2iHJ;EmCziHI;IACE,QAAA;IACA,UAAA;EnC2iHN;AACF;AgBtlHI;EmB4BA;IACE,oBAAA;EnC6jHJ;EmC3jHI;IACE,WAAA;IACA,OAAA;EnC6jHN;EmCzjHE;IACE,kBAAA;EnC2jHJ;EmCzjHI;IACE,QAAA;IACA,UAAA;EnC2jHN;AACF;AmCljHE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AnCojHJ;AoCxoHI;EACE,qBAAA;EACA,oB9B6hBwB;E8B5hBxB,uB9B2hBwB;E8B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ApCyqHF;AoCtnHI;EACE,cAAA;ApCwnHN;;AmCxjHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AnC2jHJ;AoC7pHI;EACE,qBAAA;EACA,oB9B6hBwB;E8B5hBxB,uB9B2hBwB;E8B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ApCurHF;AoC3oHI;EACE,cAAA;ApC6oHN;AmCnkHI;EACE,iBAAA;AnCqkHN;;AmC/jHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AnCkkHJ;AoCrrHI;EACE,qBAAA;EACA,oB9B6hBwB;E8B5hBxB,uB9B2hBwB;E8B1hBxB,WAAA;ApCurHN;AoC5qHM;EACE,aAAA;ApC8qHR;AoC3qHM;EACE,qBAAA;EACA,qB9B0gBsB;E8BzgBtB,uB9BwgBsB;E8BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ApCitHF;AoC3qHI;EACE,cAAA;ApC6qHN;AmCllHI;EACE,iBAAA;AnColHN;;AmC7kHA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AnCglHF;;AmC1kHA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB5BiMmB;E4BhMnB,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,uDAAA;ARmvHJ;AmC1kHE;EAEE,0CAAA;EV1LF,kDU4LuB;AnC0kHzB;AmCvkHE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AnCwkHzB;AmCrkHE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AnCskHJ;;AmChkHA;EACE,cAAA;AnCmkHF;;AmC/jHA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;EhCmEI,kBALI;EgC5DR,sCAAA;EACA,mBAAA;AnCkkHF;;AmC9jHA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AnCikHF;;AmC7jHA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,uCAAA;EACA,4CAAA;EACA,sDAAA;EACA,gEAAA;EACA,0DAAA;EACA,0CAAA;EACA,mCAAA;AnC+jHF;;AqCrzHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ArCwzHF;AqCtzHE;;EACE,kBAAA;EACA,cAAA;ArCyzHJ;AqCpzHE;;;;;;;;;;;;EAME,UAAA;ArC4zHJ;;AqCvzHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ArC0zHF;AqCxzHE;EACE,WAAA;ArC0zHJ;;AqCtzHA;E7BhBI,sBAAA;AR00HJ;AqCtzHE;;EAEE,2BAAA;ArCwzHJ;AqCpzHE;;;E7BVE,0BAAA;EACA,6BAAA;ARm0HJ;AqChzHE;;;E7BNE,yBAAA;EACA,4BAAA;AR2zHJ;;AqCnyHA;EACE,uBAAA;EACA,sBAAA;ArCsyHF;AqCpyHE;EAGE,cAAA;ArCoyHJ;AqCjyHE;EACE,eAAA;ArCmyHJ;;AqC/xHA;EACE,sBAAA;EACA,qBAAA;ArCkyHF;;AqC/xHA;EACE,wBAAA;EACA,uBAAA;ArCkyHF;;AqC5xHA;ExBxFM,gBARW;Abg4HjB;AqC5xHE;ExB5FI,gBARW;Abm4HjB;;AqCrxHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ArCwxHF;AqCtxHE;;EAEE,WAAA;ArCwxHJ;AqCrxHE;;EAEE,0BAAA;ArCuxHJ;AqCnxHE;;E7B1FE,6BAAA;EACA,4BAAA;ARi3HJ;AqCnxHE;;E7B7GE,yBAAA;EACA,0BAAA;ARo4HJ;;AsC55HA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtC25HF;;AsCx5HA;EACE,cAAA;EACA,kEAAA;EnCsQI,uCALI;EmC/PR,2CAAA;EACA,+BAAA;EAEA,gBAAA;EACA,SAAA;EdfI,mCcgBJ;AtC05HF;AwBt6HM;EcGN;IdFQ,gBAAA;ExBy6HN;AACF;AsC75HE;EAEE,qCAAA;AtC85HJ;AsC15HE;EACE,UAAA;EACA,kDhCkhBoB;AN04GxB;AsCx5HE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AtCy5HJ;;AsCj5HA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;AtCi5HF;AsC/4HE;EACE,yDAAA;EACA,yDAAA;E9B7CA,wDAAA;EACA,yDAAA;AR+7HJ;AsCh5HI;EAGE,kBAAA;EACA,wDAAA;AtCg5HN;AsC54HE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AtC84HJ;AsC34HE;EAEE,sDAAA;E9BjEA,yBAAA;EACA,0BAAA;AR88HJ;;AsCn4HA;EAEE,qDAAA;EACA,yCAAA;EACA,sCAAA;AtCq4HF;AsCl4HE;E9B5FE,gDAAA;ARi+HJ;AsCj4HE;;EAEE,4CAAA;EbjHF,oDakHuB;AtCm4HzB;;AsC13HA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AtC03HF;AsCx3HE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AtC03HJ;AsCx3HI;EAEE,iCAAA;AtCy3HN;AsCr3HE;;EAEE,gB/BiOe;E+BhOf,gDAAA;EACA,iCAAA;AtCu3HJ;;AsC72HE;;EAEE,cAAA;EACA,kBAAA;AtCg3HJ;;AsC32HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AtC82HJ;;AsCx2HE;;EACE,WAAA;AtC42HJ;;AsCl2HE;EACE,aAAA;AtCq2HJ;AsCn2HE;EACE,cAAA;AtCq2HJ;;AuCliIA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,uCAAA;EACA,kCAAA;EACA,qCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AvCkiIF;AuC5hIE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AvCoiIJ;AuChhIA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EpC4NI,2CALI;EoCrNR,mCAAA;EAEA,mBAAA;AvCihIF;AuC/gIE;EAEE,yCAAA;AvCghIJ;;AuCtgIA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AvCqgIF;AuClgII;EAEE,oCAAA;AvCmgIN;AuC//HE;EACE,gBAAA;AvCigIJ;;AuCx/HA;EACE,mBjC8gCkC;EiC7gClC,sBjC6gCkC;EiC5gClC,6BAAA;AvC2/HF;AuCz/HE;;;EAGE,oCAAA;AvC2/HJ;;AuC9+HA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AvC++HF;;AuC3+HA;EACE,8EAAA;EpCyII,6CALI;EoClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E/BxIE,qDAAA;EgBHE,+Ce6IJ;AvC8+HF;AwBvnIM;EeiIN;IfhIQ,gBAAA;ExB0nIN;AACF;AuCj/HE;EACE,qBAAA;AvCm/HJ;AuCh/HE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AvCk/HJ;;AuC5+HA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AvC++HF;;AuC5+HA;EACE,yCAAA;EACA,gBAAA;AvC++HF;;AgBzmII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCs+HN;EuCp+HM;IACE,mBAAA;EvCs+HR;EuCp+HQ;IACE,kBAAA;EvCs+HV;EuCn+HQ;IACE,kDAAA;IACA,iDAAA;EvCq+HV;EuCj+HM;IACE,iBAAA;EvCm+HR;EuCh+HM;IACE,wBAAA;IACA,gBAAA;EvCk+HR;EuC/9HM;IACE,aAAA;EvCi+HR;EuC99HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1BhOJ,gBARW;IWUX,gBegOI;EvC+9HR;EuC59HQ;IACE,aAAA;EvC89HV;EuC39HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC69HV;AACF;AgB1pII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCshIN;EuCphIM;IACE,mBAAA;EvCshIR;EuCphIQ;IACE,kBAAA;EvCshIV;EuCnhIQ;IACE,kDAAA;IACA,iDAAA;EvCqhIV;EuCjhIM;IACE,iBAAA;EvCmhIR;EuChhIM;IACE,wBAAA;IACA,gBAAA;EvCkhIR;EuC/gIM;IACE,aAAA;EvCihIR;EuC9gIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1BhOJ,gBARW;IWUX,gBegOI;EvC+gIR;EuC5gIQ;IACE,aAAA;EvC8gIV;EuC3gIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC6gIV;AACF;AgB1sII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCskIN;EuCpkIM;IACE,mBAAA;EvCskIR;EuCpkIQ;IACE,kBAAA;EvCskIV;EuCnkIQ;IACE,kDAAA;IACA,iDAAA;EvCqkIV;EuCjkIM;IACE,iBAAA;EvCmkIR;EuChkIM;IACE,wBAAA;IACA,gBAAA;EvCkkIR;EuC/jIM;IACE,aAAA;EvCikIR;EuC9jIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1BhOJ,gBARW;IWUX,gBegOI;EvC+jIR;EuC5jIQ;IACE,aAAA;EvC8jIV;EuC3jIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC6jIV;AACF;AgB1vII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCsnIN;EuCpnIM;IACE,mBAAA;EvCsnIR;EuCpnIQ;IACE,kBAAA;EvCsnIV;EuCnnIQ;IACE,kDAAA;IACA,iDAAA;EvCqnIV;EuCjnIM;IACE,iBAAA;EvCmnIR;EuChnIM;IACE,wBAAA;IACA,gBAAA;EvCknIR;EuC/mIM;IACE,aAAA;EvCinIR;EuC9mIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1BhOJ,gBARW;IWUX,gBegOI;EvC+mIR;EuC5mIQ;IACE,aAAA;EvC8mIV;EuC3mIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC6mIV;AACF;AgB1yII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EvCsqIN;EuCpqIM;IACE,mBAAA;EvCsqIR;EuCpqIQ;IACE,kBAAA;EvCsqIV;EuCnqIQ;IACE,kDAAA;IACA,iDAAA;EvCqqIV;EuCjqIM;IACE,iBAAA;EvCmqIR;EuChqIM;IACE,wBAAA;IACA,gBAAA;EvCkqIR;EuC/pIM;IACE,aAAA;EvCiqIR;EuC9pIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1BhOJ,gBARW;IWUX,gBegOI;EvC+pIR;EuC5pIQ;IACE,aAAA;EvC8pIV;EuC3pIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvC6pIV;AACF;AuCptII;EAEI,iBAAA;EACA,2BAAA;AvCqtIR;AuCntIQ;EACE,mBAAA;AvCqtIV;AuCntIU;EACE,kBAAA;AvCqtIZ;AuCltIU;EACE,kDAAA;EACA,iDAAA;AvCotIZ;AuChtIQ;EACE,iBAAA;AvCktIV;AuC/sIQ;EACE,wBAAA;EACA,gBAAA;AvCitIV;AuC9sIQ;EACE,aAAA;AvCgtIV;AuC7sIQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;E1BhOJ,gBARW;EWUX,gBegOI;AvC8sIV;AuC3sIU;EACE,aAAA;AvC6sIZ;AuC1sIU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AvC4sIZ;;AuC3rIA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,iCAAA;EACA,gCAAA;EACA,sCAAA;EACA,0DAAA;EACA,qEAAA;AvC6rIF;;AuCvrII;EACE,qEAAA;AvC0rIN;;AwCn9IA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,yCAAA;EACA,0BAAA;EACA,2BAAA;EACA,+BAAA;EACA,gCAAA;EACA,yDAAA;EACA,kDAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;EhCjBE,2CAAA;EKLE,qCARW;Abm/IjB;AwCj9IE;EACE,eAAA;EACA,cAAA;AxCm9IJ;AwCh9IE;EACE,mBAAA;EACA,sBAAA;AxCk9IJ;AwCh9II;EACE,mBAAA;EhCtBF,0DAAA;EACA,2DAAA;ARy+IJ;AwCh9II;EACE,sBAAA;EhCbF,8DAAA;EACA,6DAAA;ARg+IJ;AwC78IE;;EAEE,aAAA;AxC+8IJ;;AwC38IA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AxC48IF;;AwCz8IA;EACE,4CAAA;EACA,iCAAA;AxC48IF;;AwCz8IA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AxC48IF;;AwCz8IA;EACE,gBAAA;AxC48IF;;AwCp8IE;EACE,oCAAA;AxCu8IJ;;AwC/7IA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AxCk8IF;AwCh8IE;EhC7FE,wFAAA;ARgiJJ;;AwC97IA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AxCi8IF;AwC/7IE;EhCxGE,wFAAA;AR0iJJ;;AwCx7IA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AxC27IF;AwCz7IE;EACE,mCAAA;EACA,sCAAA;AxC27IJ;;AwCv7IA;EACE,uDAAA;EACA,sDAAA;AxC07IF;;AwCt7IA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;EhC1IE,iDAAA;ARokJJ;;AwCt7IA;;;EAGE,WAAA;AxCy7IF;;AwCt7IA;;EhC3II,0DAAA;EACA,2DAAA;ARskJJ;;AwCv7IA;;EhClII,8DAAA;EACA,6DAAA;AR8jJJ;;AwCh7IE;EACE,0CAAA;AxCm7IJ;AgB9iJI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;ExCm7IF;EwCh7IE;IAEE,SAAA;IACA,gBAAA;ExCi7IJ;EwC/6II;IACE,cAAA;IACA,cAAA;ExCi7IN;EwC56IM;IhC3KJ,0BAAA;IACA,6BAAA;ER0lJF;EwC76IQ;;IAGE,0BAAA;ExC86IV;EwC56IQ;;IAGE,6BAAA;ExC66IV;EwCz6IM;IhC5KJ,yBAAA;IACA,4BAAA;ERwlJF;EwC16IQ;;IAGE,yBAAA;ExC26IV;EwCz6IQ;;IAGE,4BAAA;ExC06IV;AACF;;AyC/oJA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qCAAA;EACA,4EAAA;EACA,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,wCAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,yCAAA;EACA,qCAAA;EACA,qCAAA;EACA,8CAAA;EACA,4CAAA;AzCipJF;;AyC7oJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EtC4PI,eALI;EsCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EjCrBE,gBAAA;EiCuBF,qBAAA;EjB1BI,0CiB2BJ;AzCgpJF;AwBvqJM;EiBUN;IjBTQ,gBAAA;ExB0qJN;AACF;AyCnpJE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AzCqpJJ;AyCnpJI;EACE,qDAAA;EACA,iDAAA;AzCqpJN;AyChpJE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AzCkpJJ;AwBhsJM;EiBqCJ;IjBpCM,gBAAA;ExBmsJN;AACF;AyCppJE;EACE,UAAA;AzCspJJ;AyCnpJE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AzCqpJJ;;AyCjpJA;EACE,gBAAA;AzCopJF;;AyCjpJA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AzCopJF;AyClpJE;EjC7DE,yDAAA;EACA,0DAAA;ARktJJ;AyCnpJI;EjChEA,+DAAA;EACA,gEAAA;ARstJJ;AyClpJE;EACE,aAAA;AzCopJJ;AyChpJE;EjC5DE,6DAAA;EACA,4DAAA;AR+sJJ;AyChpJM;EjChEF,mEAAA;EACA,kEAAA;ARmtJJ;AyC/oJI;EjCrEA,6DAAA;EACA,4DAAA;ARutJJ;;AyC7oJA;EACE,8EAAA;AzCgpJF;;AyCvoJE;EACE,eAAA;EACA,cAAA;EjC9GA,gBAAA;ARyvJJ;AyCxoJI;EAAgB,aAAA;AzC2oJpB;AyC1oJI;EAAe,gBAAA;AzC6oJnB;AyCzoJM;EjCtHF,gBAAA;ARkwJJ;AyCroJI;EjC7HA,gBAAA;ARqwJJ;;AyChoJI;EACE,iEAAA;EACA,wEAAA;AzCmoJN;;A0C7xJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,iDAAA;EACA,sCAAA;EACA,oDAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EvC+QI,yCALI;EuCxQR,gBAAA;EACA,yCAAA;ElCAE,iDAAA;AR6xJJ;;A0CvxJE;EACE,iDAAA;A1C0xJJ;A0CxxJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A1C0xJN;A0CtxJE;EACE,6CAAA;A1CwxJJ;;A2C7zJA;EAEE,kCAAA;EACA,mCAAA;ExC4RI,mCALI;EwCrRR,yCAAA;EACA,+BAAA;EACA,+BAAA;EACA,yCAAA;EACA,sCAAA;EACA,4DAAA;EACA,sDAAA;EACA,+CAAA;EACA,4DAAA;EACA,sDAAA;EACA,sCAAA;EACA,8DAAA;EACA,wDAAA;EACA,gDAAA;EACA,kDAAA;EACA,wCAAA;EACA,kDAAA;EAGA,aAAA;EjCpBA,eAAA;EACA,gBAAA;AVk1JF;;A2C3zJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;ExCgQI,yCALI;EwCzPR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A3C6zJF;AwB90JM;EmBQN;InBPQ,gBAAA;ExBi1JN;AACF;A2Ch0JE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A3Ci0JJ;A2C9zJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UpC0sBgD;EoCzsBhD,iDAAA;A3Cg0JJ;A2C7zJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A3C8zJJ;A2C3zJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A3C4zJJ;;A2CvzJE;EACE,yBrC8sCgC;AN4mHpC;A2CrzJM;EnC9BF,0DAAA;EACA,6DAAA;ARs1JJ;A2CnzJM;EnClDF,2DAAA;EACA,8DAAA;ARw2JJ;;A2CtyJA;EClGE,iCAAA;EACA,kCAAA;EzC0RI,mCALI;EyCnRR,yDAAA;A5C44JF;;A2CzyJA;ECtGE,iCAAA;EACA,kCAAA;EzC0RI,kCALI;EyCnRR,yDAAA;A5Cm5JF;;A6Cr5JA;EAEE,4BAAA;EACA,8BAAA;E1CuRI,6BALI;E0ChRR,2BAAA;EACA,sCAAA;EACA,gCAAA;EAGA,qBAAA;EACA,4DAAA;E1C+QI,oCALI;E0CxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;ErCJE,4CAAA;AR05JJ;A6Cj5JE;EACE,aAAA;A7Cm5JJ;;A6C94JA;EACE,kBAAA;EACA,SAAA;A7Ci5JF;;A8Cj7JA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EtCHE,4CAAA;ARq7JJ;;A8C76JA;EAEE,cAAA;A9C+6JF;;A8C36JA;EACE,gBvCoViB;EuCnVjB,iCAAA;A9C86JF;;A8Ct6JA;EACE,mBxCs+C8B;ANm8GhC;A8Ct6JE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A9Cw6JJ;;A8Ch6JE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9Cm6JJ;;A8Cv6JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9C06JJ;;A8C96JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A9Ci7JJ;;A8Cr7JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Cw7JJ;;A8C57JE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9C+7JJ;;A8Cn8JE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Cs8JJ;;A8C18JE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9C68JJ;;A8Cj9JE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Co9JJ;;A+ChhKE;EACE;IAAK,2BxCk4B2B;EPkpIlC;AACF;A+ChhKA;;EAGE,0BAAA;E5CkRI,gCALI;E4C3QR,oCAAA;EACA,gCAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E5CsQI,uCALI;E4C/PR,uCAAA;EvCRE,+CAAA;EKLE,yCARW;AbsiKjB;;A+C5gKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A/C+gKF;AwBpiKM;EuBYN;IvBXQ,gBAAA;ExBuiKN;AACF;;A+CjhKA;EtBAE,qMAAA;EsBEA,oEAAA;A/CohKF;;A+CjhKA;EACE,iBAAA;A/CohKF;;A+CjhKA;EACE,WAAA;A/CohKF;;A+ChhKE;EACE,kDAAA;A/CmhKJ;A+ChhKM;EAJJ;IAKM,eAAA;E/CmhKN;AACF;;AgD/kKA;EAEE,yCAAA;EACA,2BAAA;EACA,kDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,gDAAA;EACA,sDAAA;EACA,mDAAA;EACA,yDAAA;EACA,oDAAA;EACA,kDAAA;EACA,oCAAA;EACA,8DAAA;EACA,wDAAA;EACA,kEAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ExCXE,iDAAA;ARylKJ;;AgD1kKA;EACE,qBAAA;EACA,sBAAA;AhD6kKF;AgD3kKE;EAEE,oCAAA;EACA,0BAAA;AhD4kKJ;;AgDnkKA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AhDskKF;AgDnkKE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AhDokKJ;AgDjkKE;EACE,+CAAA;EACA,uDAAA;AhDmkKJ;;AgD3jKA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;AhD6jKF;AgD3jKE;ExCvDE,+BAAA;EACA,gCAAA;ARqnKJ;AgD3jKE;ExC7CE,mCAAA;EACA,kCAAA;AR2mKJ;AgD3jKE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AhD4jKJ;AgDxjKE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AhD0jKJ;AgDtjKE;EACE,mBAAA;AhDwjKJ;AgDtjKI;EACE,wDAAA;EACA,mDAAA;AhDwjKN;;AgD3iKI;EACE,mBAAA;AhD8iKN;AgD3iKQ;ExCvDJ,6DAAA;EAZA,0BAAA;ARknKJ;AgD1iKQ;ExCxEJ,2DAAA;EAYA,4BAAA;AR0mKJ;AgDziKQ;EACE,aAAA;AhD2iKV;AgDxiKQ;EACE,mDAAA;EACA,oBAAA;AhD0iKV;AgDxiKU;EACE,yDAAA;EACA,oDAAA;AhD0iKZ;;AgBhoKI;EgC8DA;IACE,mBAAA;EhDskKJ;EgDnkKM;IxCvDJ,6DAAA;IAZA,0BAAA;ER0oKF;EgDlkKM;IxCxEJ,2DAAA;IAYA,4BAAA;ERkoKF;EgDjkKM;IACE,aAAA;EhDmkKR;EgDhkKM;IACE,mDAAA;IACA,oBAAA;EhDkkKR;EgDhkKQ;IACE,yDAAA;IACA,oDAAA;EhDkkKV;AACF;AgBzpKI;EgC8DA;IACE,mBAAA;EhD8lKJ;EgD3lKM;IxCvDJ,6DAAA;IAZA,0BAAA;ERkqKF;EgD1lKM;IxCxEJ,2DAAA;IAYA,4BAAA;ER0pKF;EgDzlKM;IACE,aAAA;EhD2lKR;EgDxlKM;IACE,mDAAA;IACA,oBAAA;EhD0lKR;EgDxlKQ;IACE,yDAAA;IACA,oDAAA;EhD0lKV;AACF;AgBjrKI;EgC8DA;IACE,mBAAA;EhDsnKJ;EgDnnKM;IxCvDJ,6DAAA;IAZA,0BAAA;ER0rKF;EgDlnKM;IxCxEJ,2DAAA;IAYA,4BAAA;ERkrKF;EgDjnKM;IACE,aAAA;EhDmnKR;EgDhnKM;IACE,mDAAA;IACA,oBAAA;EhDknKR;EgDhnKQ;IACE,yDAAA;IACA,oDAAA;EhDknKV;AACF;AgBzsKI;EgC8DA;IACE,mBAAA;EhD8oKJ;EgD3oKM;IxCvDJ,6DAAA;IAZA,0BAAA;ERktKF;EgD1oKM;IxCxEJ,2DAAA;IAYA,4BAAA;ER0sKF;EgDzoKM;IACE,aAAA;EhD2oKR;EgDxoKM;IACE,mDAAA;IACA,oBAAA;EhD0oKR;EgDxoKQ;IACE,yDAAA;IACA,oDAAA;EhD0oKV;AACF;AgBjuKI;EgC8DA;IACE,mBAAA;EhDsqKJ;EgDnqKM;IxCvDJ,6DAAA;IAZA,0BAAA;ER0uKF;EgDlqKM;IxCxEJ,2DAAA;IAYA,4BAAA;ERkuKF;EgDjqKM;IACE,aAAA;EhDmqKR;EgDhqKM;IACE,mDAAA;IACA,oBAAA;EhDkqKR;EgDhqKQ;IACE,yDAAA;IACA,oDAAA;EhDkqKV;AACF;AgDrpKA;ExChJI,gBAAA;ARwyKJ;AgDrpKE;EACE,mDAAA;AhDupKJ;AgDrpKI;EACE,sBAAA;AhDupKN;;AgD1oKE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhD6oKJ;;AgDvpKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhD0pKJ;;AgDpqKE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AhDuqKJ;;AgDjrKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhDorKJ;;AgD9rKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDisKJ;;AgD3sKE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhD8sKJ;;AgDxtKE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhD2tKJ;;AgDruKE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhDwuKJ;;AiDp6KA;EAEE,6BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,iCAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,c1Co7B+B;E0Cn7B/B,e1Cm7B+B;E0Cl7B/B,sBAAA;EACA,gCAAA;EACA,4EAAA;EACA,SAAA;EzCJE,sBAAA;EyCMF,oCAAA;AjDo6KF;AiDj6KE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AjDm6KJ;AiDh6KE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AjDk6KJ;AiD/5KE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AjDg6KJ;;AiDx5KA;EAHE,wCAAA;AjD+5KF;;AiDt5KI;EATF,wCAAA;AjDm6KF;;AkDp9KA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E/CyRI,8BALI;E+ClRR,oCAAA;EACA,gCAAA;EACA,+CAAA;EACA,oCAAA;EACA,iDAAA;EACA,2CAAA;EACA,2CAAA;EACA,uCAAA;EACA,sDAAA;EAGA,gCAAA;EACA,eAAA;E/C2QI,oCALI;E+CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;E1CRE,4CAAA;AR69KJ;AkDl9KE;EACE,UAAA;AlDo9KJ;AkDj9KE;EACE,aAAA;AlDm9KJ;;AkD/8KA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AlDi9KF;AkD/8KE;EACE,sCAAA;AlDi9KJ;;AkD78KA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;E1ChCE,0FAAA;EACA,2FAAA;ARi/KJ;AkD/8KE;EACE,oDAAA;EACA,sCAAA;AlDi9KJ;;AkD78KA;EACE,kCAAA;EACA,qBAAA;AlDg9KF;;AmD9gLA;EAEE,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,0BAAA;EACA,iCAAA;EACA,0DAAA;EACA,uCAAA;EACA,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,sDAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AnD4gLF;;AmDrgLA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AnDugLF;AmDpgLE;E3B5CI,mC2B6CF;EACA,8B7Ck8CgC;ANokIpC;AwBhjLM;E2BwCJ;I3BvCM,gBAAA;ExBmjLN;AACF;AmDzgLE;EACE,e7Cg8CgC;AN2kIpC;AmDvgLE;EACE,sB7C67CgC;AN4kIpC;;AmDrgLA;EACE,+CAAA;AnDwgLF;AmDtgLE;EACE,gBAAA;EACA,gBAAA;AnDwgLJ;AmDrgLE;EACE,gBAAA;AnDugLJ;;AmDngLA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AnDsgLF;;AmDlgLA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E3CrFE,4CAAA;EKLE,sCARW;EsCsGf,UAAA;AnDmgLF;;AmD//KA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AnDqgL9D;AoDjnLE;EAAS,UAAA;ApDonLX;AoDnnLE;EAAS,mCD2GiF;AnD2gL5F;;AmDtgLA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E3CrGE,2DAAA;EACA,4DAAA;AR+mLJ;AmDxgLE;EACE,kGAAA;EACA,sJAAA;AnD0gLJ;;AmDrgLA;EACE,gBAAA;EACA,8CAAA;AnDwgLF;;AmDngLA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AnDogLF;;AmDhgLA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E3CzHE,+DAAA;EACA,8DAAA;AR6nLJ;AmD//KE;EACE,8CAAA;AnDigLJ;;AgB5mLI;EmCiHF;IACE,0BAAA;IACA,uDAAA;EnD+/KF;EmD3/KA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EnD6/KF;EmD1/KA;IACE,uBAAA;EnD4/KF;AACF;AgB3nLI;EmCmIF;;IAEE,uBAAA;EnD2/KF;AACF;AgBjoLI;EmC0IF;IACE,wBAAA;EnD0/KF;AACF;AmDj/KI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AnDm/KN;AmDj/KM;EACE,YAAA;EACA,SAAA;E3CzMJ,gBAAA;AR6rLJ;AmDh/KM;;E3C7MF,gBAAA;ARisLJ;AmD/+KM;EACE,gBAAA;AnDi/KR;;AgB3oLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDugLJ;EmDrgLI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;ERitLF;EmDpgLI;;I3C7MF,gBAAA;ERqtLF;EmDngLI;IACE,gBAAA;EnDqgLN;AACF;AgBhqLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD2hLJ;EmDzhLI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;ERquLF;EmDxhLI;;I3C7MF,gBAAA;ERyuLF;EmDvhLI;IACE,gBAAA;EnDyhLN;AACF;AgBprLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnD+iLJ;EmD7iLI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;ERyvLF;EmD5iLI;;I3C7MF,gBAAA;ER6vLF;EmD3iLI;IACE,gBAAA;EnD6iLN;AACF;AgBxsLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDmkLJ;EmDjkLI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;ER6wLF;EmDhkLI;;I3C7MF,gBAAA;ERixLF;EmD/jLI;IACE,gBAAA;EnDikLN;AACF;AgB5tLI;EmCwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnDulLJ;EmDrlLI;IACE,YAAA;IACA,SAAA;I3CzMJ,gBAAA;ERiyLF;EmDplLI;;I3C7MF,gBAAA;ERqyLF;EmDnlLI;IACE,gBAAA;EnDqlLN;AACF;AqD3zLA;EAEE,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,+BAAA;EACA,sBAAA;ElDwRI,4BALI;EkDjRR,sCAAA;EACA,kCAAA;EACA,mCAAA;EACA,uBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sChD+lB4B;EgD7lB5B,kBAAA;EACA,gB/CgXmB;E+C/WnB,gB/CuXiB;E+CtXjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EnDgRI,sCALI;EkDhQR,qBAAA;EACA,UAAA;ArDm0LF;AqDj0LE;EAAS,kCAAA;ArDo0LX;AqDl0LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArDo0LJ;AqDl0LI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArDo0LN;;AqD/zLA;EACE,iDAAA;ArDk0LF;AqDh0LE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ArDk0LJ;;AqD9zLA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ArDi0LF;AqD/zLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ArDi0LJ;;AqD7zLA,mBAAA;AAEA;EACE,8CAAA;ArD+zLF;AqD7zLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ArD+zLJ;;AqD3zLA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ArD8zLF;AqD5zLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ArD8zLJ;;AqD1zLA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E7CjGE,8CAAA;AR84LJ;;AuDj6LA;EAEE,yBAAA;EACA,6BAAA;EpD4RI,4BALI;EoDrRR,wBAAA;EACA,iDAAA;EACA,kCAAA;EACA,mCAAA;EACA,yCAAA;EACA,iEAAA;EACA,sCAAA;EACA,mCAAA;EpDmRI,mCALI;EoD5QR,6CAAA;EACA,+BAAA;EACA,oCAAA;EACA,oCAAA;EACA,2CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sChD+lB4B;EgD7lB5B,kBAAA;EACA,gB/CgXmB;E+C/WnB,gB/CuXiB;E+CtXjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EnDgRI,sCALI;EoD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E/ChBE,8CAAA;EKLE,wCARW;Ab08LjB;AuDz6LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AvD26LJ;AuDz6LI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AvD06LN;;AuDp6LE;EACE,oFAAA;AvDu6LJ;AuDr6LI;EAEE,wFAAA;AvDs6LN;AuDn6LI;EACE,SAAA;EACA,gDAAA;AvDq6LN;AuDl6LI;EACE,sCAAA;EACA,sCAAA;AvDo6LN;;AuD/5LA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AvDi6LJ;AuD/5LI;EAEE,kIAAA;AvDg6LN;AuD75LI;EACE,OAAA;EACA,kDAAA;AvD+5LN;AuD55LI;EACE,oCAAA;EACA,wCAAA;AvD85LN;;AuDz5LA,mBAAA;AAGE;EACE,iFAAA;AvD05LJ;AuDx5LI;EAEE,wFAAA;AvDy5LN;AuDt5LI;EACE,MAAA;EACA,mDAAA;AvDw5LN;AuDr5LI;EACE,mCAAA;EACA,yCAAA;AvDu5LN;AuDl5LE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AvDo5LJ;;AuDh5LA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AvDk5LJ;AuDh5LI;EAEE,kIAAA;AvDi5LN;AuD94LI;EACE,QAAA;EACA,iDAAA;AvDg5LN;AuD74LI;EACE,qCAAA;EACA,uCAAA;AvD+4LN;;AuD14LA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EpD2GI,6CALI;EoDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E/C5JE,6DAAA;EACA,8DAAA;ARyhMJ;AuD33LE;EACE,aAAA;AvD63LJ;;AuDz3LA;EACE,0EAAA;EACA,mCAAA;AvD43LF;;AwDjjMA;EACE,kBAAA;AxDojMF;;AwDjjMA;EACE,mBAAA;AxDojMF;;AwDjjMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AxDojMF;AyD1kME;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzD4kMJ;;AwDrjMA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AxDwjMF;AwBvkMM;EgCQN;IhCPQ,gBAAA;ExB0kMN;AACF;;AwD1jMA;;;EAGE,cAAA;AxD6jMF;;AwD1jMA;;EAEE,2BAAA;AxD6jMF;;AwD1jMA;;EAEE,4BAAA;AxD6jMF;;AwDpjME;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AxDujMJ;AwDpjME;;;EAGE,UAAA;EACA,UAAA;AxDsjMJ;AwDnjME;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AxDqjMJ;AwB9mMM;EgCqDJ;;IhCpDM,gBAAA;ExBknMN;AACF;;AwDljMA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UlDkhDmC;EkDjhDnC,UAAA;EACA,cjD9EM;EiD+EN,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YlD6gDmC;EkBnmD/B,8BgCuFJ;AxDojMF;AwBvoMM;EgCkEN;;IhCjEQ,gBAAA;ExB2oMN;AACF;AwDvjME;;;EAEE,cjDxFI;EiDyFJ,qBAAA;EACA,UAAA;EACA,YlDqgDiC;ANqjJrC;;AwDvjMA;EACE,OAAA;AxD0jMF;;AwDvjMA;EACE,QAAA;AxD0jMF;;AwDrjMA;;EAEE,qBAAA;EACA,WlDsgDmC;EkDrgDnC,YlDqgDmC;EkDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AxDwjMF;;AwDrjMA;EACE,8TAAA;AxDwjMF;;AwDtjMA;EACE,6TAAA;AxDyjMF;;AwDjjMA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBlDs9CmC;EkDr9CnC,mBAAA;EACA,gBlDo9CmC;AN+lJrC;AwDjjME;EACE,uBAAA;EACA,cAAA;EACA,WlDo9CiC;EkDn9CjC,WlDo9CiC;EkDn9CjC,UAAA;EACA,iBlDo9CiC;EkDn9CjC,gBlDm9CiC;EkDl9CjC,mBAAA;EACA,eAAA;EACA,yBjDtJI;EiDuJJ,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YlD28CiC;EkB3mD/B,6BgCiKF;AxDkjMJ;AwB/sMM;EgC4IJ;IhC3IM,gBAAA;ExBktMN;AACF;AwDpjME;EACE,UlDw8CiC;AN8mJrC;;AwD7iMA;EACE,kBAAA;EACA,UAAA;EACA,elDk8CmC;EkDj8CnC,SAAA;EACA,oBlD+7CmC;EkD97CnC,uBlD87CmC;EkD77CnC,cjDjLM;EiDkLN,kBAAA;AxDgjMF;;AwD1iME;;EAEE,gClDm8CiC;AN0mJrC;AwD1iME;EACE,yBjD7LG;APyuMP;AwDziME;EACE,cjDjMG;AP4uMP;;AwDrjME;;;EAEE,gClDm8CiC;ANsnJrC;AwDtjME;EACE,yBjD7LG;APqvMP;AwDrjME;EACE,cjDjMG;APwvMP;;A0DzwMA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A1D2wMF;;A0DvwMA;EACE;IAAK,0CAAA;E1D2wML;AACF;A0DxwMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A1DuwMF;;A0DpwMA;EAEE,wBAAA;EACA,yBAAA;EACA,kCAAA;A1DswMF;;A0D7vMA;EACE;IACE,mBAAA;E1DgwMF;E0D9vMA;IACE,UAAA;IACA,eAAA;E1DgwMF;AACF;A0D5vMA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A1D2vMF;;A0DxvMA;EACE,wBAAA;EACA,yBAAA;A1D2vMF;;A0DvvME;EACE;;IAEE,kCAAA;E1D0vMJ;AACF;A2D10MA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCAAA;EACA,iCAAA;EACA,0CAAA;EACA,oCAAA;EACA,8BAAA;EACA,+DAAA;EACA,8DAAA;EACA,qDAAA;EACA,qCAAA;A3D20MF;;AgB9wMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;I9C9BA,0CARW;IWUX,0CmC8BA;E3D6zMJ;AACF;AwBx1MM;EmCYJ;InCXM,gBAAA;ExB21MN;AACF;AgBryMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3Do0MN;E2Dj0MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3Dm0MN;E2Dh0MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3Dk0MN;E2D/zMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3Di0MN;E2D9zMI;IAEE,eAAA;E3D+zMN;E2D5zMI;IAGE,mBAAA;E3D4zMN;AACF;AgBz1MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3D2zMN;E2DzzMM;IACE,aAAA;E3D2zMR;E2DxzMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DyzMR;AACF;;AgB71MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;I9C9BA,0CARW;IWUX,0CmC8BA;E3D44MJ;AACF;AwBv6MM;EmCYJ;InCXM,gBAAA;ExB06MN;AACF;AgBp3MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3Dm5MN;E2Dh5MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3Dk5MN;E2D/4MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3Di5MN;E2D94MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3Dg5MN;E2D74MI;IAEE,eAAA;E3D84MN;E2D34MI;IAGE,mBAAA;E3D24MN;AACF;AgBx6MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3D04MN;E2Dx4MM;IACE,aAAA;E3D04MR;E2Dv4MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3Dw4MR;AACF;;AgB56MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;I9C9BA,0CARW;IWUX,0CmC8BA;E3D29MJ;AACF;AwBt/MM;EmCYJ;InCXM,gBAAA;ExBy/MN;AACF;AgBn8MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3Dk+MN;E2D/9MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3Di+MN;E2D99MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3Dg+MN;E2D79MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3D+9MN;E2D59MI;IAEE,eAAA;E3D69MN;E2D19MI;IAGE,mBAAA;E3D09MN;AACF;AgBv/MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3Dy9MN;E2Dv9MM;IACE,aAAA;E3Dy9MR;E2Dt9MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3Du9MR;AACF;;AgB3/MI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;I9C9BA,0CARW;IWUX,0CmC8BA;E3D0iNJ;AACF;AwBrkNM;EmCYJ;InCXM,gBAAA;ExBwkNN;AACF;AgBlhNI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3DijNN;E2D9iNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3DgjNN;E2D7iNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3D+iNN;E2D5iNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3D8iNN;E2D3iNI;IAEE,eAAA;E3D4iNN;E2DziNI;IAGE,mBAAA;E3DyiNN;AACF;AgBtkNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DwiNN;E2DtiNM;IACE,aAAA;E3DwiNR;E2DriNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DsiNR;AACF;;AgB1kNI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;I9C9BA,0CARW;IWUX,0CmC8BA;E3DynNJ;AACF;AwBppNM;EmCYJ;InCXM,gBAAA;ExBupNN;AACF;AgBjmNI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E3DgoNN;E2D7nNI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E3D+nNN;E2D5nNI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E3D8nNN;E2D3nNI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E3D6nNN;E2D1nNI;IAEE,eAAA;E3D2nNN;E2DxnNI;IAGE,mBAAA;E3DwnNN;AACF;AgBrpNI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E3DunNN;E2DrnNM;IACE,aAAA;E3DunNR;E2DpnNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E3DqnNR;AACF;;A2DrsNE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;E9C9BA,0CARW;EWUX,0CmC8BA;A3DusNN;AwBjuNM;EmCYJ;InCXM,gBAAA;ExBouNN;AACF;A2D1sNM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A3D4sNR;A2DzsNM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A3D2sNR;A2DxsNM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A3D0sNR;A2DvsNM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A3DysNR;A2DtsNM;EAEE,eAAA;A3DusNR;A2DpsNM;EAGE,mBAAA;A3DosNR;;A2DzqNA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9C0mCkC;E8CzmClC,YAAA;EACA,aAAA;EACA,yB7CaK;APoxNP;AoD9xNE;EAAS,UAAA;ApDiyNX;AoDhyNE;EAAS,Y7Cm3B4B;APg7LvC;;A2DrrNA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A3DwrNF;A2DtrNE;EACE,4FAAA;EACA,6IAAA;A3DwrNJ;;A2DprNA;EACE,gBAAA;EACA,kDAAA;A3DurNF;;A2DprNA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A3DurNF;;A4Dp0NA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YtDgzCkC;ANuhLpC;A4Dr0NE;EACE,qBAAA;EACA,WAAA;A5Du0NJ;;A4Dl0NA;EACE,iBAAA;A5Dq0NF;;A4Dl0NA;EACE,iBAAA;A5Dq0NF;;A4Dl0NA;EACE,iBAAA;A5Dq0NF;;A4Dh0NE;EACE,mDAAA;A5Dm0NJ;;A4D/zNA;EACE;IACE,YtDmxCgC;EN+iLlC;AACF;A4D/zNA;EACE,6FAAA;UAAA,qFAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A5Di0NF;;A4D9zNA;EACE;IACE,+BAAA;YAAA,uBAAA;E5Di0NF;AACF;AyDh3NE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDk3NJ;;A6Dr3NE;EACE,yBAAA;EACA,+EAAA;A7Dw3NJ;;A6D13NE;EACE,yBAAA;EACA,iFAAA;A7D63NJ;;A6D/3NE;EACE,yBAAA;EACA,mFAAA;A7Dk4NJ;;A6Dp4NE;EACE,yBAAA;EACA,iFAAA;A7Du4NJ;;A6Dz4NE;EACE,yBAAA;EACA,8EAAA;A7D44NJ;;A6D94NE;EACE,yBAAA;EACA,iFAAA;A7Di5NJ;;A6Dn5NE;EACE,yBAAA;EACA,gFAAA;A7Ds5NJ;;A6Dx5NE;EACE,yBAAA;EACA,8EAAA;A7D25NJ;;A8D75NE;EACE,sEAAA;EACA,gGAAA;A9Dg6NJ;A8D75NM;EAGE,gEAAA;EACA,0FAAA;A9D65NR;;A8Dt6NE;EACE,wEAAA;EACA,kGAAA;A9Dy6NJ;A8Dt6NM;EAGE,+DAAA;EACA,yFAAA;A9Ds6NR;;A8D/6NE;EACE,0EAAA;EACA,oGAAA;A9Dk7NJ;A8D/6NM;EAGE,gEAAA;EACA,0FAAA;A9D+6NR;;A8Dx7NE;EACE,wEAAA;EACA,kGAAA;A9D27NJ;A8Dx7NM;EAGE,+DAAA;EACA,yFAAA;A9Dw7NR;;A8Dj8NE;EACE,qEAAA;EACA,+FAAA;A9Do8NJ;A8Dj8NM;EAGE,8DAAA;EACA,wFAAA;A9Di8NR;;A8D18NE;EACE,wEAAA;EACA,kGAAA;A9D68NJ;A8D18NM;EAGE,+DAAA;EACA,yFAAA;A9D08NR;;A8Dn9NE;EACE,uEAAA;EACA,iGAAA;A9Ds9NJ;A8Dn9NM;EAGE,+DAAA;EACA,yFAAA;A9Dm9NR;;A8D59NE;EACE,qEAAA;EACA,+FAAA;A9D+9NJ;A8D59NM;EAGE,6DAAA;EACA,uFAAA;A9D49NR;;A8Dr9NA;EACE,+EAAA;EACA,yGAAA;A9Dw9NF;A8Dr9NI;EAEE,kFAAA;EACA,4GAAA;A9Ds9NN;;A+Dh/NA;EACE,UAAA;EAEA,kJAAA;A/Dk/NF;;AgEr/NA;EACE,oBAAA;EACA,a1D6c4B;E0D5c5B,mBAAA;EACA,kFAAA;EACA,6B1D2c4B;E0D1c5B,2BAAA;AhEw/NF;AgEt/NE;EACE,cAAA;EACA,U1Duc0B;E0Dtc1B,W1Dsc0B;E0Drc1B,kBAAA;ExCIE,sCwCHF;AhEw/NJ;AwBj/NM;EwCZJ;IxCaM,gBAAA;ExBo/NN;AACF;;AgEt/NI;EACE,mEAAA;AhEy/NN;;AiE5gOA;EACE,kBAAA;EACA,WAAA;AjE+gOF;AiE7gOE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AjE+gOJ;AiE5gOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AjE8gOJ;;AiEzgOE;EACE,uBAAA;AjE4gOJ;;AiE7gOE;EACE,sBAAA;AjEghOJ;;AiEjhOE;EACE,yBAAA;AjEohOJ;;AiErhOE;EACE,iCAAA;AjEwhOJ;;AkE7iOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a5DumCkC;ANy8LpC;;AkE7iOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a5D+lCkC;ANi9LpC;;AkExiOI;EACE,gBAAA;EACA,MAAA;EACA,a5DmlC8B;ANw9LpC;;AkExiOI;EACE,gBAAA;EACA,SAAA;EACA,a5D6kC8B;AN89LpC;;AgB5gOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a5DmlC8B;ENq+LlC;EkErjOE;IACE,gBAAA;IACA,SAAA;IACA,a5D6kC8B;EN0+LlC;AACF;AgBzhOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a5DmlC8B;ENi/LlC;EkEjkOE;IACE,gBAAA;IACA,SAAA;IACA,a5D6kC8B;ENs/LlC;AACF;AgBriOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a5DmlC8B;EN6/LlC;EkE7kOE;IACE,gBAAA;IACA,SAAA;IACA,a5D6kC8B;ENkgMlC;AACF;AgBjjOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a5DmlC8B;ENygMlC;EkEzlOE;IACE,gBAAA;IACA,SAAA;IACA,a5D6kC8B;EN8gMlC;AACF;AgB7jOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a5DmlC8B;ENqhMlC;EkErmOE;IACE,gBAAA;IACA,SAAA;IACA,a5D6kC8B;EN0hMlC;AACF;AmEvoOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AnEyoOF;;AmEtoOA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AnEyoOF;;AoEjpOA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ArEkpOF;AqE/oOE;;EACE,6BAAA;ArEkpOJ;;AsEhqOE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UhEgcsC;EgE/btC,WAAA;AtEmqOJ;;AuE3qOA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AxE+qOF;;AyErrOA;EACE,qBAAA;EACA,mBAAA;EACA,6BnEisB4B;EmEhsB5B,eAAA;EACA,8BAAA;EACA,anE2rB4B;AN6/M9B;;A0E5nOQ;EAOI,mCAAA;A1EynOZ;;A0EhoOQ;EAOI,8BAAA;A1E6nOZ;;A0EpoOQ;EAOI,iCAAA;A1EioOZ;;A0ExoOQ;EAOI,iCAAA;A1EqoOZ;;A0E5oOQ;EAOI,sCAAA;A1EyoOZ;;A0EhpOQ;EAOI,mCAAA;A1E6oOZ;;A0EppOQ;EAOI,sBAAA;A1EipOZ;;A0ExpOQ;EAOI,uBAAA;A1EqpOZ;;A0E5pOQ;EAOI,sBAAA;A1EypOZ;;A0EhqOQ;EAOI,8BAAA;A1E6pOZ;;A0EpqOQ;EAOI,4BAAA;A1EiqOZ;;A0ExqOQ;EAOI,2BAAA;A1EqqOZ;;A0E5qOQ;EAOI,iCAAA;A1EyqOZ;;A0EhrOQ;EAOI,2BAAA;A1E6qOZ;;A0EprOQ;EAOI,qBAAA;A1EirOZ;;A0ExrOQ;EAOI,wBAAA;A1EqrOZ;;A0E5rOQ;EAOI,uBAAA;A1EyrOZ;;A0EhsOQ;EAOI,wBAAA;A1E6rOZ;;A0EpsOQ;EAOI,uBAAA;A1EisOZ;;A0ExsOQ;EAOI,wBAAA;A1EqsOZ;;A0E5sOQ;EAOI,uBAAA;A1EysOZ;;A0EhtOQ;EAOI,wBAAA;A1E6sOZ;;A0EptOQ;EAOI,qBAAA;A1EitOZ;;A0ExtOQ;EAOI,yBAAA;A1EqtOZ;;A0E5tOQ;EAOI,2BAAA;A1EytOZ;;A0EhuOQ;EAOI,4BAAA;A1E6tOZ;;A0EpuOQ;EAOI,2BAAA;A1EiuOZ;;A0ExuOQ;EAOI,2BAAA;A1EquOZ;;A0E5uOQ;EAOI,6BAAA;A1EyuOZ;;A0EhvOQ;EAOI,8BAAA;A1E6uOZ;;A0EpvOQ;EAOI,6BAAA;A1EivOZ;;A0ExvOQ;EAOI,2BAAA;A1EqvOZ;;A0E5vOQ;EAOI,6BAAA;A1EyvOZ;;A0EhwOQ;EAOI,8BAAA;A1E6vOZ;;A0EpwOQ;EAOI,6BAAA;A1EiwOZ;;A0ExwOQ;EAOI,0BAAA;A1EqwOZ;;A0E5wOQ;EAOI,gCAAA;A1EywOZ;;A0EhxOQ;EAOI,yBAAA;A1E6wOZ;;A0EpxOQ;EAOI,wBAAA;A1EixOZ;;A0ExxOQ;EAOI,+BAAA;A1EqxOZ;;A0E5xOQ;EAOI,yBAAA;A1EyxOZ;;A0EhyOQ;EAOI,6BAAA;A1E6xOZ;;A0EpyOQ;EAOI,8BAAA;A1EiyOZ;;A0ExyOQ;EAOI,wBAAA;A1EqyOZ;;A0E5yOQ;EAOI,+BAAA;A1EyyOZ;;A0EhzOQ;EAOI,wBAAA;A1E6yOZ;;A0EpzOQ;EAOI,2CAAA;A1EizOZ;;A0ExzOQ;EAOI,8CAAA;A1EqzOZ;;A0E5zOQ;EAOI,8CAAA;A1EyzOZ;;A0Eh0OQ;EAOI,2BAAA;A1E6zOZ;;A0E90OQ;EACE,8EAAA;A1Ei1OV;;A0El1OQ;EACE,gFAAA;A1Eq1OV;;A0Et1OQ;EACE,kFAAA;A1Ey1OV;;A0E11OQ;EACE,gFAAA;A1E61OV;;A0E91OQ;EACE,6EAAA;A1Ei2OV;;A0El2OQ;EACE,gFAAA;A1Eq2OV;;A0Et2OQ;EACE,+EAAA;A1Ey2OV;;A0E12OQ;EACE,6EAAA;A1E62OV;;A0Ep2OQ;EAOI,2BAAA;A1Ei2OZ;;A0Ex2OQ;EAOI,6BAAA;A1Eq2OZ;;A0E52OQ;EAOI,6BAAA;A1Ey2OZ;;A0Eh3OQ;EAOI,0BAAA;A1E62OZ;;A0Ep3OQ;EAOI,2BAAA;A1Ei3OZ;;A0Ex3OQ;EAOI,iBAAA;A1Eq3OZ;;A0E53OQ;EAOI,mBAAA;A1Ey3OZ;;A0Eh4OQ;EAOI,mBAAA;A1E63OZ;;A0Ep4OQ;EAOI,mBAAA;A1Ei4OZ;;A0Ex4OQ;EAOI,oBAAA;A1Eq4OZ;;A0E54OQ;EAOI,oBAAA;A1Ey4OZ;;A0Eh5OQ;EAOI,sBAAA;A1E64OZ;;A0Ep5OQ;EAOI,sBAAA;A1Ei5OZ;;A0Ex5OQ;EAOI,sBAAA;A1Eq5OZ;;A0E55OQ;EAOI,uBAAA;A1Ey5OZ;;A0Eh6OQ;EAOI,kBAAA;A1E65OZ;;A0Ep6OQ;EAOI,oBAAA;A1Ei6OZ;;A0Ex6OQ;EAOI,oBAAA;A1Eq6OZ;;A0E56OQ;EAOI,oBAAA;A1Ey6OZ;;A0Eh7OQ;EAOI,qBAAA;A1E66OZ;;A0Ep7OQ;EAOI,mBAAA;A1Ei7OZ;;A0Ex7OQ;EAOI,qBAAA;A1Eq7OZ;;A0E57OQ;EAOI,qBAAA;A1Ey7OZ;;A0Eh8OQ;EAOI,qBAAA;A1E67OZ;;A0Ep8OQ;EAOI,sBAAA;A1Ei8OZ;;A0Ex8OQ;EAOI,2CAAA;A1Eq8OZ;;A0E58OQ;EAOI,sCAAA;A1Ey8OZ;;A0Eh9OQ;EAOI,sCAAA;A1E68OZ;;A0Ep9OQ;EAOI,uFAAA;A1Ei9OZ;;A0Ex9OQ;EAOI,oBAAA;A1Eq9OZ;;A0E59OQ;EAOI,2FAAA;A1Ey9OZ;;A0Eh+OQ;EAOI,wBAAA;A1E69OZ;;A0Ep+OQ;EAOI,6FAAA;A1Ei+OZ;;A0Ex+OQ;EAOI,0BAAA;A1Eq+OZ;;A0E5+OQ;EAOI,8FAAA;A1Ey+OZ;;A0Eh/OQ;EAOI,2BAAA;A1E6+OZ;;A0Ep/OQ;EAOI,4FAAA;A1Ei/OZ;;A0Ex/OQ;EAOI,yBAAA;A1Eq/OZ;;A0E5/OQ;EAIQ,sBAAA;EAGJ,4EAAA;A1E0/OZ;;A0EjgPQ;EAIQ,sBAAA;EAGJ,8EAAA;A1E+/OZ;;A0EtgPQ;EAIQ,sBAAA;EAGJ,gFAAA;A1EogPZ;;A0E3gPQ;EAIQ,sBAAA;EAGJ,8EAAA;A1EygPZ;;A0EhhPQ;EAIQ,sBAAA;EAGJ,2EAAA;A1E8gPZ;;A0ErhPQ;EAIQ,sBAAA;EAGJ,8EAAA;A1EmhPZ;;A0E1hPQ;EAIQ,sBAAA;EAGJ,6EAAA;A1EwhPZ;;A0E/hPQ;EAIQ,sBAAA;EAGJ,2EAAA;A1E6hPZ;;A0EpiPQ;EAIQ,sBAAA;EAGJ,4EAAA;A1EkiPZ;;A0EziPQ;EAIQ,sBAAA;EAGJ,4EAAA;A1EuiPZ;;A0E9iPQ;EAOI,wDAAA;A1E2iPZ;;A0EljPQ;EAOI,0DAAA;A1E+iPZ;;A0EtjPQ;EAOI,wDAAA;A1EmjPZ;;A0E1jPQ;EAOI,qDAAA;A1EujPZ;;A0E9jPQ;EAOI,wDAAA;A1E2jPZ;;A0ElkPQ;EAOI,uDAAA;A1E+jPZ;;A0EtkPQ;EAOI,sDAAA;A1EmkPZ;;A0E1kPQ;EAOI,qDAAA;A1EukPZ;;A0E9kPQ;EAOI,0BAAA;A1E2kPZ;;A0EllPQ;EAOI,4BAAA;A1E+kPZ;;A0EtlPQ;EAOI,4BAAA;A1EmlPZ;;A0E1lPQ;EAOI,4BAAA;A1EulPZ;;A0E9lPQ;EAOI,4BAAA;A1E2lPZ;;A0ElmPQ;EAOI,4BAAA;A1E+lPZ;;A0EhnPQ;EACE,wBAAA;A1EmnPV;;A0EpnPQ;EACE,yBAAA;A1EunPV;;A0ExnPQ;EACE,wBAAA;A1E2nPV;;A0E5nPQ;EACE,yBAAA;A1E+nPV;;A0EhoPQ;EACE,sBAAA;A1EmoPV;;A0E1nPQ;EAOI,uBAAA;A1EunPZ;;A0E9nPQ;EAOI,qBAAA;A1E2nPZ;;A0EloPQ;EAOI,qBAAA;A1E+nPZ;;A0EtoPQ;EAOI,qBAAA;A1EmoPZ;;A0E1oPQ;EAOI,sBAAA;A1EuoPZ;;A0E9oPQ;EAOI,sBAAA;A1E2oPZ;;A0ElpPQ;EAOI,qBAAA;A1E+oPZ;;A0EtpPQ;EAOI,qBAAA;A1EmpPZ;;A0E1pPQ;EAOI,qBAAA;A1EupPZ;;A0E9pPQ;EAOI,qBAAA;A1E2pPZ;;A0ElqPQ;EAOI,qBAAA;A1E+pPZ;;A0EtqPQ;EAOI,qBAAA;A1EmqPZ;;A0E1qPQ;EAOI,qBAAA;A1EuqPZ;;A0E9qPQ;EAOI,qBAAA;A1E2qPZ;;A0ElrPQ;EAOI,qBAAA;A1E+qPZ;;A0EtrPQ;EAOI,sBAAA;A1EmrPZ;;A0E1rPQ;EAOI,sBAAA;A1EurPZ;;A0E9rPQ;EAOI,sBAAA;A1E2rPZ;;A0ElsPQ;EAOI,sBAAA;A1E+rPZ;;A0EtsPQ;EAOI,sBAAA;A1EmsPZ;;A0E1sPQ;EAOI,sBAAA;A1EusPZ;;A0E9sPQ;EAOI,sBAAA;A1E2sPZ;;A0EltPQ;EAOI,sBAAA;A1E+sPZ;;A0EttPQ;EAOI,sBAAA;A1EmtPZ;;A0E1tPQ;EAOI,sBAAA;A1EutPZ;;A0E9tPQ;EAOI,sBAAA;A1E2tPZ;;A0EluPQ;EAOI,sBAAA;A1E+tPZ;;A0EtuPQ;EAOI,sBAAA;A1EmuPZ;;A0E1uPQ;EAOI,sBAAA;A1EuuPZ;;A0E9uPQ;EAOI,sBAAA;A1E2uPZ;;A0ElvPQ;EAOI,sBAAA;A1E+uPZ;;A0EtvPQ;EAOI,sBAAA;A1EmvPZ;;A0E1vPQ;EAOI,sBAAA;A1EuvPZ;;A0E9vPQ;EAOI,uBAAA;A1E2vPZ;;A0ElwPQ;EAOI,uBAAA;A1E+vPZ;;A0EtwPQ;EAOI,uBAAA;A1EmwPZ;;A0E1wPQ;EAOI,uBAAA;A1EuwPZ;;A0E9wPQ;EAOI,uBAAA;A1E2wPZ;;A0ElxPQ;EAOI,uBAAA;A1E+wPZ;;A0EtxPQ;EAOI,uBAAA;A1EmxPZ;;A0E1xPQ;EAOI,uBAAA;A1EuxPZ;;A0E9xPQ;EAOI,uBAAA;A1E2xPZ;;A0ElyPQ;EAOI,uBAAA;A1E+xPZ;;A0EtyPQ;EAOI,uBAAA;A1EmyPZ;;A0E1yPQ;EAOI,uBAAA;A1EuyPZ;;A0E9yPQ;EAOI,uBAAA;A1E2yPZ;;A0ElzPQ;EAOI,uBAAA;A1E+yPZ;;A0EtzPQ;EAOI,uBAAA;A1EmzPZ;;A0E1zPQ;EAOI,uBAAA;A1EuzPZ;;A0E9zPQ;EAOI,uBAAA;A1E2zPZ;;A0El0PQ;EAOI,uBAAA;A1E+zPZ;;A0Et0PQ;EAOI,uBAAA;A1Em0PZ;;A0E10PQ;EAOI,uBAAA;A1Eu0PZ;;A0E90PQ;EAOI,uBAAA;A1E20PZ;;A0El1PQ;EAOI,uBAAA;A1E+0PZ;;A0Et1PQ;EAOI,uBAAA;A1Em1PZ;;A0E11PQ;EAOI,uBAAA;A1Eu1PZ;;A0E91PQ;EAOI,uBAAA;A1E21PZ;;A0El2PQ;EAOI,uBAAA;A1E+1PZ;;A0Et2PQ;EAOI,wBAAA;A1Em2PZ;;A0E12PQ;EAOI,2BAAA;A1Eu2PZ;;A0E92PQ;EAOI,yBAAA;A1E22PZ;;A0El3PQ;EAOI,yBAAA;A1E+2PZ;;A0Et3PQ;EAOI,yBAAA;A1Em3PZ;;A0E13PQ;EAOI,0BAAA;A1Eu3PZ;;A0E93PQ;EAOI,0BAAA;A1E23PZ;;A0El4PQ;EAOI,yBAAA;A1E+3PZ;;A0Et4PQ;EAOI,yBAAA;A1Em4PZ;;A0E14PQ;EAOI,yBAAA;A1Eu4PZ;;A0E94PQ;EAOI,yBAAA;A1E24PZ;;A0El5PQ;EAOI,yBAAA;A1E+4PZ;;A0Et5PQ;EAOI,yBAAA;A1Em5PZ;;A0E15PQ;EAOI,yBAAA;A1Eu5PZ;;A0E95PQ;EAOI,yBAAA;A1E25PZ;;A0El6PQ;EAOI,yBAAA;A1E+5PZ;;A0Et6PQ;EAOI,0BAAA;A1Em6PZ;;A0E16PQ;EAOI,0BAAA;A1Eu6PZ;;A0E96PQ;EAOI,0BAAA;A1E26PZ;;A0El7PQ;EAOI,0BAAA;A1E+6PZ;;A0Et7PQ;EAOI,0BAAA;A1Em7PZ;;A0E17PQ;EAOI,0BAAA;A1Eu7PZ;;A0E97PQ;EAOI,0BAAA;A1E27PZ;;A0El8PQ;EAOI,0BAAA;A1E+7PZ;;A0Et8PQ;EAOI,0BAAA;A1Em8PZ;;A0E18PQ;EAOI,0BAAA;A1Eu8PZ;;A0E98PQ;EAOI,0BAAA;A1E28PZ;;A0El9PQ;EAOI,0BAAA;A1E+8PZ;;A0Et9PQ;EAOI,0BAAA;A1Em9PZ;;A0E19PQ;EAOI,0BAAA;A1Eu9PZ;;A0E99PQ;EAOI,0BAAA;A1E29PZ;;A0El+PQ;EAOI,0BAAA;A1E+9PZ;;A0Et+PQ;EAOI,0BAAA;A1Em+PZ;;A0E1+PQ;EAOI,0BAAA;A1Eu+PZ;;A0E9+PQ;EAOI,2BAAA;A1E2+PZ;;A0El/PQ;EAOI,2BAAA;A1E++PZ;;A0Et/PQ;EAOI,2BAAA;A1Em/PZ;;A0E1/PQ;EAOI,2BAAA;A1Eu/PZ;;A0E9/PQ;EAOI,2BAAA;A1E2/PZ;;A0ElgQQ;EAOI,2BAAA;A1E+/PZ;;A0EtgQQ;EAOI,2BAAA;A1EmgQZ;;A0E1gQQ;EAOI,2BAAA;A1EugQZ;;A0E9gQQ;EAOI,2BAAA;A1E2gQZ;;A0ElhQQ;EAOI,2BAAA;A1E+gQZ;;A0EthQQ;EAOI,2BAAA;A1EmhQZ;;A0E1hQQ;EAOI,2BAAA;A1EuhQZ;;A0E9hQQ;EAOI,2BAAA;A1E2hQZ;;A0EliQQ;EAOI,2BAAA;A1E+hQZ;;A0EtiQQ;EAOI,2BAAA;A1EmiQZ;;A0E1iQQ;EAOI,2BAAA;A1EuiQZ;;A0E9iQQ;EAOI,2BAAA;A1E2iQZ;;A0EljQQ;EAOI,2BAAA;A1E+iQZ;;A0EtjQQ;EAOI,2BAAA;A1EmjQZ;;A0E1jQQ;EAOI,2BAAA;A1EujQZ;;A0E9jQQ;EAOI,2BAAA;A1E2jQZ;;A0ElkQQ;EAOI,2BAAA;A1E+jQZ;;A0EtkQQ;EAOI,2BAAA;A1EmkQZ;;A0E1kQQ;EAOI,2BAAA;A1EukQZ;;A0E9kQQ;EAOI,2BAAA;A1E2kQZ;;A0EllQQ;EAOI,2BAAA;A1E+kQZ;;A0EtlQQ;EAOI,4BAAA;A1EmlQZ;;A0E1lQQ;EAOI,uBAAA;A1EulQZ;;A0E9lQQ;EAOI,2BAAA;A1E2lQZ;;A0ElmQQ;EAOI,wBAAA;A1E+lQZ;;A0EtmQQ;EAOI,sBAAA;A1EmmQZ;;A0E1mQQ;EAOI,sBAAA;A1EumQZ;;A0E9mQQ;EAOI,sBAAA;A1E2mQZ;;A0ElnQQ;EAOI,uBAAA;A1E+mQZ;;A0EtnQQ;EAOI,uBAAA;A1EmnQZ;;A0E1nQQ;EAOI,sBAAA;A1EunQZ;;A0E9nQQ;EAOI,sBAAA;A1E2nQZ;;A0EloQQ;EAOI,sBAAA;A1E+nQZ;;A0EtoQQ;EAOI,sBAAA;A1EmoQZ;;A0E1oQQ;EAOI,sBAAA;A1EuoQZ;;A0E9oQQ;EAOI,sBAAA;A1E2oQZ;;A0ElpQQ;EAOI,sBAAA;A1E+oQZ;;A0EtpQQ;EAOI,sBAAA;A1EmpQZ;;A0E1pQQ;EAOI,sBAAA;A1EupQZ;;A0E9pQQ;EAOI,uBAAA;A1E2pQZ;;A0ElqQQ;EAOI,uBAAA;A1E+pQZ;;A0EtqQQ;EAOI,uBAAA;A1EmqQZ;;A0E1qQQ;EAOI,uBAAA;A1EuqQZ;;A0E9qQQ;EAOI,uBAAA;A1E2qQZ;;A0ElrQQ;EAOI,uBAAA;A1E+qQZ;;A0EtrQQ;EAOI,uBAAA;A1EmrQZ;;A0E1rQQ;EAOI,uBAAA;A1EurQZ;;A0E9rQQ;EAOI,uBAAA;A1E2rQZ;;A0ElsQQ;EAOI,uBAAA;A1E+rQZ;;A0EtsQQ;EAOI,uBAAA;A1EmsQZ;;A0E1sQQ;EAOI,uBAAA;A1EusQZ;;A0E9sQQ;EAOI,uBAAA;A1E2sQZ;;A0EltQQ;EAOI,uBAAA;A1E+sQZ;;A0EttQQ;EAOI,uBAAA;A1EmtQZ;;A0E1tQQ;EAOI,uBAAA;A1EutQZ;;A0E9tQQ;EAOI,uBAAA;A1E2tQZ;;A0EluQQ;EAOI,uBAAA;A1E+tQZ;;A0EtuQQ;EAOI,wBAAA;A1EmuQZ;;A0E1uQQ;EAOI,wBAAA;A1EuuQZ;;A0E9uQQ;EAOI,wBAAA;A1E2uQZ;;A0ElvQQ;EAOI,wBAAA;A1E+uQZ;;A0EtvQQ;EAOI,wBAAA;A1EmvQZ;;A0E1vQQ;EAOI,wBAAA;A1EuvQZ;;A0E9vQQ;EAOI,wBAAA;A1E2vQZ;;A0ElwQQ;EAOI,wBAAA;A1E+vQZ;;A0EtwQQ;EAOI,wBAAA;A1EmwQZ;;A0E1wQQ;EAOI,wBAAA;A1EuwQZ;;A0E9wQQ;EAOI,wBAAA;A1E2wQZ;;A0ElxQQ;EAOI,wBAAA;A1E+wQZ;;A0EtxQQ;EAOI,wBAAA;A1EmxQZ;;A0E1xQQ;EAOI,wBAAA;A1EuxQZ;;A0E9xQQ;EAOI,wBAAA;A1E2xQZ;;A0ElyQQ;EAOI,wBAAA;A1E+xQZ;;A0EtyQQ;EAOI,wBAAA;A1EmyQZ;;A0E1yQQ;EAOI,wBAAA;A1EuyQZ;;A0E9yQQ;EAOI,wBAAA;A1E2yQZ;;A0ElzQQ;EAOI,wBAAA;A1E+yQZ;;A0EtzQQ;EAOI,wBAAA;A1EmzQZ;;A0E1zQQ;EAOI,wBAAA;A1EuzQZ;;A0E9zQQ;EAOI,wBAAA;A1E2zQZ;;A0El0QQ;EAOI,wBAAA;A1E+zQZ;;A0Et0QQ;EAOI,wBAAA;A1Em0QZ;;A0E10QQ;EAOI,wBAAA;A1Eu0QZ;;A0E90QQ;EAOI,yBAAA;A1E20QZ;;A0El1QQ;EAOI,4BAAA;A1E+0QZ;;A0Et1QQ;EAOI,0BAAA;A1Em1QZ;;A0E11QQ;EAOI,0BAAA;A1Eu1QZ;;A0E91QQ;EAOI,0BAAA;A1E21QZ;;A0El2QQ;EAOI,2BAAA;A1E+1QZ;;A0Et2QQ;EAOI,2BAAA;A1Em2QZ;;A0E12QQ;EAOI,0BAAA;A1Eu2QZ;;A0E92QQ;EAOI,0BAAA;A1E22QZ;;A0El3QQ;EAOI,0BAAA;A1E+2QZ;;A0Et3QQ;EAOI,0BAAA;A1Em3QZ;;A0E13QQ;EAOI,0BAAA;A1Eu3QZ;;A0E93QQ;EAOI,0BAAA;A1E23QZ;;A0El4QQ;EAOI,0BAAA;A1E+3QZ;;A0Et4QQ;EAOI,0BAAA;A1Em4QZ;;A0E14QQ;EAOI,0BAAA;A1Eu4QZ;;A0E94QQ;EAOI,2BAAA;A1E24QZ;;A0El5QQ;EAOI,2BAAA;A1E+4QZ;;A0Et5QQ;EAOI,2BAAA;A1Em5QZ;;A0E15QQ;EAOI,2BAAA;A1Eu5QZ;;A0E95QQ;EAOI,2BAAA;A1E25QZ;;A0El6QQ;EAOI,2BAAA;A1E+5QZ;;A0Et6QQ;EAOI,2BAAA;A1Em6QZ;;A0E16QQ;EAOI,2BAAA;A1Eu6QZ;;A0E96QQ;EAOI,2BAAA;A1E26QZ;;A0El7QQ;EAOI,2BAAA;A1E+6QZ;;A0Et7QQ;EAOI,2BAAA;A1Em7QZ;;A0E17QQ;EAOI,2BAAA;A1Eu7QZ;;A0E97QQ;EAOI,2BAAA;A1E27QZ;;A0El8QQ;EAOI,2BAAA;A1E+7QZ;;A0Et8QQ;EAOI,2BAAA;A1Em8QZ;;A0E18QQ;EAOI,2BAAA;A1Eu8QZ;;A0E98QQ;EAOI,2BAAA;A1E28QZ;;A0El9QQ;EAOI,2BAAA;A1E+8QZ;;A0Et9QQ;EAOI,4BAAA;A1Em9QZ;;A0E19QQ;EAOI,4BAAA;A1Eu9QZ;;A0E99QQ;EAOI,4BAAA;A1E29QZ;;A0El+QQ;EAOI,4BAAA;A1E+9QZ;;A0Et+QQ;EAOI,4BAAA;A1Em+QZ;;A0E1+QQ;EAOI,4BAAA;A1Eu+QZ;;A0E9+QQ;EAOI,4BAAA;A1E2+QZ;;A0El/QQ;EAOI,4BAAA;A1E++QZ;;A0Et/QQ;EAOI,4BAAA;A1Em/QZ;;A0E1/QQ;EAOI,4BAAA;A1Eu/QZ;;A0E9/QQ;EAOI,4BAAA;A1E2/QZ;;A0ElgRQ;EAOI,4BAAA;A1E+/QZ;;A0EtgRQ;EAOI,4BAAA;A1EmgRZ;;A0E1gRQ;EAOI,4BAAA;A1EugRZ;;A0E9gRQ;EAOI,4BAAA;A1E2gRZ;;A0ElhRQ;EAOI,4BAAA;A1E+gRZ;;A0EthRQ;EAOI,4BAAA;A1EmhRZ;;A0E1hRQ;EAOI,4BAAA;A1EuhRZ;;A0E9hRQ;EAOI,4BAAA;A1E2hRZ;;A0EliRQ;EAOI,4BAAA;A1E+hRZ;;A0EtiRQ;EAOI,4BAAA;A1EmiRZ;;A0E1iRQ;EAOI,4BAAA;A1EuiRZ;;A0E9iRQ;EAOI,4BAAA;A1E2iRZ;;A0EljRQ;EAOI,4BAAA;A1E+iRZ;;A0EtjRQ;EAOI,4BAAA;A1EmjRZ;;A0E1jRQ;EAOI,4BAAA;A1EujRZ;;A0E9jRQ;EAOI,6BAAA;A1E2jRZ;;A0ElkRQ;EAOI,wBAAA;A1E+jRZ;;A0EtkRQ;EAOI,4BAAA;A1EmkRZ;;A0E1kRQ;EAOI,yBAAA;A1EukRZ;;A0E9kRQ;EAOI,8BAAA;A1E2kRZ;;A0EllRQ;EAOI,iCAAA;A1E+kRZ;;A0EtlRQ;EAOI,sCAAA;A1EmlRZ;;A0E1lRQ;EAOI,yCAAA;A1EulRZ;;A0E9lRQ;EAOI,uBAAA;A1E2lRZ;;A0ElmRQ;EAOI,uBAAA;A1E+lRZ;;A0EtmRQ;EAOI,yBAAA;A1EmmRZ;;A0E1mRQ;EAOI,yBAAA;A1EumRZ;;A0E9mRQ;EAOI,0BAAA;A1E2mRZ;;A0ElnRQ;EAOI,4BAAA;A1E+mRZ;;A0EtnRQ;EAOI,kCAAA;A1EmnRZ;;A0E1nRQ;EAOI,sCAAA;A1EunRZ;;A0E9nRQ;EAOI,oCAAA;A1E2nRZ;;A0EloRQ;EAOI,kCAAA;A1E+nRZ;;A0EtoRQ;EAOI,yCAAA;A1EmoRZ;;A0E1oRQ;EAOI,wCAAA;A1EuoRZ;;A0E9oRQ;EAOI,wCAAA;A1E2oRZ;;A0ElpRQ;EAOI,kCAAA;A1E+oRZ;;A0EtpRQ;EAOI,gCAAA;A1EmpRZ;;A0E1pRQ;EAOI,8BAAA;A1EupRZ;;A0E9pRQ;EAOI,gCAAA;A1E2pRZ;;A0ElqRQ;EAOI,+BAAA;A1E+pRZ;;A0EtqRQ;EAOI,oCAAA;A1EmqRZ;;A0E1qRQ;EAOI,kCAAA;A1EuqRZ;;A0E9qRQ;EAOI,gCAAA;A1E2qRZ;;A0ElrRQ;EAOI,uCAAA;A1E+qRZ;;A0EtrRQ;EAOI,sCAAA;A1EmrRZ;;A0E1rRQ;EAOI,iCAAA;A1EurRZ;;A0E9rRQ;EAOI,2BAAA;A1E2rRZ;;A0ElsRQ;EAOI,iCAAA;A1E+rRZ;;A0EtsRQ;EAOI,+BAAA;A1EmsRZ;;A0E1sRQ;EAOI,6BAAA;A1EusRZ;;A0E9sRQ;EAOI,+BAAA;A1E2sRZ;;A0EltRQ;EAOI,8BAAA;A1E+sRZ;;A0EttRQ;EAOI,oBAAA;A1EmtRZ;;A0E1tRQ;EAOI,mBAAA;A1EutRZ;;A0E9tRQ;EAOI,mBAAA;A1E2tRZ;;A0EluRQ;EAOI,mBAAA;A1E+tRZ;;A0EtuRQ;EAOI,mBAAA;A1EmuRZ;;A0E1uRQ;EAOI,mBAAA;A1EuuRZ;;A0E9uRQ;EAOI,mBAAA;A1E2uRZ;;A0ElvRQ;EAOI,mBAAA;A1E+uRZ;;A0EtvRQ;EAOI,oBAAA;A1EmvRZ;;A0E1vRQ;EAOI,0BAAA;A1EuvRZ;;A0E9vRQ;EAOI,yBAAA;A1E2vRZ;;A0ElwRQ;EAOI,0BAAA;A1E+vRZ;;A0EtwRQ;EAOI,uBAAA;A1EmwRZ;;A0E1wRQ;EAOI,0BAAA;A1EuwRZ;;A0E9wRQ;EAOI,yBAAA;A1E2wRZ;;A0ElxRQ;EAOI,0BAAA;A1E+wRZ;;A0EtxRQ;EAOI,uBAAA;A1EmxRZ;;A0E1xRQ;EAOI,0BAAA;A1EuxRZ;;A0E9xRQ;EAOI,yBAAA;A1E2xRZ;;A0ElyRQ;EAOI,0BAAA;A1E+xRZ;;A0EtyRQ;EAOI,uBAAA;A1EmyRZ;;A0E1yRQ;EAOI,0BAAA;A1EuyRZ;;A0E9yRQ;EAOI,yBAAA;A1E2yRZ;;A0ElzRQ;EAOI,0BAAA;A1E+yRZ;;A0EtzRQ;EAOI,uBAAA;A1EmzRZ;;A0E1zRQ;EAOI,0BAAA;A1EuzRZ;;A0E9zRQ;EAOI,yBAAA;A1E2zRZ;;A0El0RQ;EAOI,0BAAA;A1E+zRZ;;A0Et0RQ;EAOI,uBAAA;A1Em0RZ;;A0E10RQ;EAOI,uBAAA;A1Eu0RZ;;A0E90RQ;EAOI,0BAAA;EAAA,yBAAA;A1E40RZ;;A0En1RQ;EAOI,gCAAA;EAAA,+BAAA;A1Ei1RZ;;A0Ex1RQ;EAOI,+BAAA;EAAA,8BAAA;A1Es1RZ;;A0E71RQ;EAOI,gCAAA;EAAA,+BAAA;A1E21RZ;;A0El2RQ;EAOI,6BAAA;EAAA,4BAAA;A1Eg2RZ;;A0Ev2RQ;EAOI,gCAAA;EAAA,+BAAA;A1Eq2RZ;;A0E52RQ;EAOI,+BAAA;EAAA,8BAAA;A1E02RZ;;A0Ej3RQ;EAOI,gCAAA;EAAA,+BAAA;A1E+2RZ;;A0Et3RQ;EAOI,6BAAA;EAAA,4BAAA;A1Eo3RZ;;A0E33RQ;EAOI,gCAAA;EAAA,+BAAA;A1Ey3RZ;;A0Eh4RQ;EAOI,+BAAA;EAAA,8BAAA;A1E83RZ;;A0Er4RQ;EAOI,gCAAA;EAAA,+BAAA;A1Em4RZ;;A0E14RQ;EAOI,6BAAA;EAAA,4BAAA;A1Ew4RZ;;A0E/4RQ;EAOI,gCAAA;EAAA,+BAAA;A1E64RZ;;A0Ep5RQ;EAOI,+BAAA;EAAA,8BAAA;A1Ek5RZ;;A0Ez5RQ;EAOI,gCAAA;EAAA,+BAAA;A1Eu5RZ;;A0E95RQ;EAOI,6BAAA;EAAA,4BAAA;A1E45RZ;;A0En6RQ;EAOI,gCAAA;EAAA,+BAAA;A1Ei6RZ;;A0Ex6RQ;EAOI,+BAAA;EAAA,8BAAA;A1Es6RZ;;A0E76RQ;EAOI,gCAAA;EAAA,+BAAA;A1E26RZ;;A0El7RQ;EAOI,6BAAA;EAAA,4BAAA;A1Eg7RZ;;A0Ev7RQ;EAOI,6BAAA;EAAA,4BAAA;A1Eq7RZ;;A0E57RQ;EAOI,wBAAA;EAAA,2BAAA;A1E07RZ;;A0Ej8RQ;EAOI,8BAAA;EAAA,iCAAA;A1E+7RZ;;A0Et8RQ;EAOI,6BAAA;EAAA,gCAAA;A1Eo8RZ;;A0E38RQ;EAOI,8BAAA;EAAA,iCAAA;A1Ey8RZ;;A0Eh9RQ;EAOI,2BAAA;EAAA,8BAAA;A1E88RZ;;A0Er9RQ;EAOI,8BAAA;EAAA,iCAAA;A1Em9RZ;;A0E19RQ;EAOI,6BAAA;EAAA,gCAAA;A1Ew9RZ;;A0E/9RQ;EAOI,8BAAA;EAAA,iCAAA;A1E69RZ;;A0Ep+RQ;EAOI,2BAAA;EAAA,8BAAA;A1Ek+RZ;;A0Ez+RQ;EAOI,8BAAA;EAAA,iCAAA;A1Eu+RZ;;A0E9+RQ;EAOI,6BAAA;EAAA,gCAAA;A1E4+RZ;;A0En/RQ;EAOI,8BAAA;EAAA,iCAAA;A1Ei/RZ;;A0Ex/RQ;EAOI,2BAAA;EAAA,8BAAA;A1Es/RZ;;A0E7/RQ;EAOI,8BAAA;EAAA,iCAAA;A1E2/RZ;;A0ElgSQ;EAOI,6BAAA;EAAA,gCAAA;A1EggSZ;;A0EvgSQ;EAOI,8BAAA;EAAA,iCAAA;A1EqgSZ;;A0E5gSQ;EAOI,2BAAA;EAAA,8BAAA;A1E0gSZ;;A0EjhSQ;EAOI,8BAAA;EAAA,iCAAA;A1E+gSZ;;A0EthSQ;EAOI,6BAAA;EAAA,gCAAA;A1EohSZ;;A0E3hSQ;EAOI,8BAAA;EAAA,iCAAA;A1EyhSZ;;A0EhiSQ;EAOI,2BAAA;EAAA,8BAAA;A1E8hSZ;;A0EriSQ;EAOI,2BAAA;EAAA,8BAAA;A1EmiSZ;;A0E1iSQ;EAOI,wBAAA;A1EuiSZ;;A0E9iSQ;EAOI,8BAAA;A1E2iSZ;;A0EljSQ;EAOI,6BAAA;A1E+iSZ;;A0EtjSQ;EAOI,8BAAA;A1EmjSZ;;A0E1jSQ;EAOI,2BAAA;A1EujSZ;;A0E9jSQ;EAOI,8BAAA;A1E2jSZ;;A0ElkSQ;EAOI,6BAAA;A1E+jSZ;;A0EtkSQ;EAOI,8BAAA;A1EmkSZ;;A0E1kSQ;EAOI,2BAAA;A1EukSZ;;A0E9kSQ;EAOI,8BAAA;A1E2kSZ;;A0EllSQ;EAOI,6BAAA;A1E+kSZ;;A0EtlSQ;EAOI,8BAAA;A1EmlSZ;;A0E1lSQ;EAOI,2BAAA;A1EulSZ;;A0E9lSQ;EAOI,8BAAA;A1E2lSZ;;A0ElmSQ;EAOI,6BAAA;A1E+lSZ;;A0EtmSQ;EAOI,8BAAA;A1EmmSZ;;A0E1mSQ;EAOI,2BAAA;A1EumSZ;;A0E9mSQ;EAOI,8BAAA;A1E2mSZ;;A0ElnSQ;EAOI,6BAAA;A1E+mSZ;;A0EtnSQ;EAOI,8BAAA;A1EmnSZ;;A0E1nSQ;EAOI,2BAAA;A1EunSZ;;A0E9nSQ;EAOI,2BAAA;A1E2nSZ;;A0EloSQ;EAOI,0BAAA;A1E+nSZ;;A0EtoSQ;EAOI,gCAAA;A1EmoSZ;;A0E1oSQ;EAOI,+BAAA;A1EuoSZ;;A0E9oSQ;EAOI,gCAAA;A1E2oSZ;;A0ElpSQ;EAOI,6BAAA;A1E+oSZ;;A0EtpSQ;EAOI,gCAAA;A1EmpSZ;;A0E1pSQ;EAOI,+BAAA;A1EupSZ;;A0E9pSQ;EAOI,gCAAA;A1E2pSZ;;A0ElqSQ;EAOI,6BAAA;A1E+pSZ;;A0EtqSQ;EAOI,gCAAA;A1EmqSZ;;A0E1qSQ;EAOI,+BAAA;A1EuqSZ;;A0E9qSQ;EAOI,gCAAA;A1E2qSZ;;A0ElrSQ;EAOI,6BAAA;A1E+qSZ;;A0EtrSQ;EAOI,gCAAA;A1EmrSZ;;A0E1rSQ;EAOI,+BAAA;A1EurSZ;;A0E9rSQ;EAOI,gCAAA;A1E2rSZ;;A0ElsSQ;EAOI,6BAAA;A1E+rSZ;;A0EtsSQ;EAOI,gCAAA;A1EmsSZ;;A0E1sSQ;EAOI,+BAAA;A1EusSZ;;A0E9sSQ;EAOI,gCAAA;A1E2sSZ;;A0EltSQ;EAOI,6BAAA;A1E+sSZ;;A0EttSQ;EAOI,6BAAA;A1EmtSZ;;A0E1tSQ;EAOI,2BAAA;A1EutSZ;;A0E9tSQ;EAOI,iCAAA;A1E2tSZ;;A0EluSQ;EAOI,gCAAA;A1E+tSZ;;A0EtuSQ;EAOI,iCAAA;A1EmuSZ;;A0E1uSQ;EAOI,8BAAA;A1EuuSZ;;A0E9uSQ;EAOI,iCAAA;A1E2uSZ;;A0ElvSQ;EAOI,gCAAA;A1E+uSZ;;A0EtvSQ;EAOI,iCAAA;A1EmvSZ;;A0E1vSQ;EAOI,8BAAA;A1EuvSZ;;A0E9vSQ;EAOI,iCAAA;A1E2vSZ;;A0ElwSQ;EAOI,gCAAA;A1E+vSZ;;A0EtwSQ;EAOI,iCAAA;A1EmwSZ;;A0E1wSQ;EAOI,8BAAA;A1EuwSZ;;A0E9wSQ;EAOI,iCAAA;A1E2wSZ;;A0ElxSQ;EAOI,gCAAA;A1E+wSZ;;A0EtxSQ;EAOI,iCAAA;A1EmxSZ;;A0E1xSQ;EAOI,8BAAA;A1EuxSZ;;A0E9xSQ;EAOI,iCAAA;A1E2xSZ;;A0ElySQ;EAOI,gCAAA;A1E+xSZ;;A0EtySQ;EAOI,iCAAA;A1EmySZ;;A0E1ySQ;EAOI,8BAAA;A1EuySZ;;A0E9ySQ;EAOI,8BAAA;A1E2ySZ;;A0ElzSQ;EAOI,yBAAA;A1E+ySZ;;A0EtzSQ;EAOI,+BAAA;A1EmzSZ;;A0E1zSQ;EAOI,8BAAA;A1EuzSZ;;A0E9zSQ;EAOI,+BAAA;A1E2zSZ;;A0El0SQ;EAOI,4BAAA;A1E+zSZ;;A0Et0SQ;EAOI,+BAAA;A1Em0SZ;;A0E10SQ;EAOI,8BAAA;A1Eu0SZ;;A0E90SQ;EAOI,+BAAA;A1E20SZ;;A0El1SQ;EAOI,4BAAA;A1E+0SZ;;A0Et1SQ;EAOI,+BAAA;A1Em1SZ;;A0E11SQ;EAOI,8BAAA;A1Eu1SZ;;A0E91SQ;EAOI,+BAAA;A1E21SZ;;A0El2SQ;EAOI,4BAAA;A1E+1SZ;;A0Et2SQ;EAOI,+BAAA;A1Em2SZ;;A0E12SQ;EAOI,8BAAA;A1Eu2SZ;;A0E92SQ;EAOI,+BAAA;A1E22SZ;;A0El3SQ;EAOI,4BAAA;A1E+2SZ;;A0Et3SQ;EAOI,+BAAA;A1Em3SZ;;A0E13SQ;EAOI,8BAAA;A1Eu3SZ;;A0E93SQ;EAOI,+BAAA;A1E23SZ;;A0El4SQ;EAOI,4BAAA;A1E+3SZ;;A0Et4SQ;EAOI,4BAAA;A1Em4SZ;;A0E14SQ;EAOI,2BAAA;A1Eu4SZ;;A0E94SQ;EAOI,0BAAA;A1E24SZ;;A0El5SQ;EAOI,2BAAA;A1E+4SZ;;A0Et5SQ;EAOI,wBAAA;A1Em5SZ;;A0E15SQ;EAOI,2BAAA;A1Eu5SZ;;A0E95SQ;EAOI,0BAAA;A1E25SZ;;A0El6SQ;EAOI,2BAAA;A1E+5SZ;;A0Et6SQ;EAOI,wBAAA;A1Em6SZ;;A0E16SQ;EAOI,2BAAA;A1Eu6SZ;;A0E96SQ;EAOI,0BAAA;A1E26SZ;;A0El7SQ;EAOI,2BAAA;A1E+6SZ;;A0Et7SQ;EAOI,wBAAA;A1Em7SZ;;A0E17SQ;EAOI,2BAAA;A1Eu7SZ;;A0E97SQ;EAOI,0BAAA;A1E27SZ;;A0El8SQ;EAOI,2BAAA;A1E+7SZ;;A0Et8SQ;EAOI,wBAAA;A1Em8SZ;;A0E18SQ;EAOI,2BAAA;A1Eu8SZ;;A0E98SQ;EAOI,0BAAA;A1E28SZ;;A0El9SQ;EAOI,2BAAA;A1E+8SZ;;A0Et9SQ;EAOI,wBAAA;A1Em9SZ;;A0E19SQ;EAOI,iCAAA;EAAA,gCAAA;A1Ew9SZ;;A0E/9SQ;EAOI,gCAAA;EAAA,+BAAA;A1E69SZ;;A0Ep+SQ;EAOI,iCAAA;EAAA,gCAAA;A1Ek+SZ;;A0Ez+SQ;EAOI,8BAAA;EAAA,6BAAA;A1Eu+SZ;;A0E9+SQ;EAOI,iCAAA;EAAA,gCAAA;A1E4+SZ;;A0En/SQ;EAOI,gCAAA;EAAA,+BAAA;A1Ei/SZ;;A0Ex/SQ;EAOI,iCAAA;EAAA,gCAAA;A1Es/SZ;;A0E7/SQ;EAOI,8BAAA;EAAA,6BAAA;A1E2/SZ;;A0ElgTQ;EAOI,iCAAA;EAAA,gCAAA;A1EggTZ;;A0EvgTQ;EAOI,gCAAA;EAAA,+BAAA;A1EqgTZ;;A0E5gTQ;EAOI,iCAAA;EAAA,gCAAA;A1E0gTZ;;A0EjhTQ;EAOI,8BAAA;EAAA,6BAAA;A1E+gTZ;;A0EthTQ;EAOI,iCAAA;EAAA,gCAAA;A1EohTZ;;A0E3hTQ;EAOI,gCAAA;EAAA,+BAAA;A1EyhTZ;;A0EhiTQ;EAOI,iCAAA;EAAA,gCAAA;A1E8hTZ;;A0EriTQ;EAOI,8BAAA;EAAA,6BAAA;A1EmiTZ;;A0E1iTQ;EAOI,iCAAA;EAAA,gCAAA;A1EwiTZ;;A0E/iTQ;EAOI,gCAAA;EAAA,+BAAA;A1E6iTZ;;A0EpjTQ;EAOI,iCAAA;EAAA,gCAAA;A1EkjTZ;;A0EzjTQ;EAOI,8BAAA;EAAA,6BAAA;A1EujTZ;;A0E9jTQ;EAOI,+BAAA;EAAA,kCAAA;A1E4jTZ;;A0EnkTQ;EAOI,8BAAA;EAAA,iCAAA;A1EikTZ;;A0ExkTQ;EAOI,+BAAA;EAAA,kCAAA;A1EskTZ;;A0E7kTQ;EAOI,4BAAA;EAAA,+BAAA;A1E2kTZ;;A0EllTQ;EAOI,+BAAA;EAAA,kCAAA;A1EglTZ;;A0EvlTQ;EAOI,8BAAA;EAAA,iCAAA;A1EqlTZ;;A0E5lTQ;EAOI,+BAAA;EAAA,kCAAA;A1E0lTZ;;A0EjmTQ;EAOI,4BAAA;EAAA,+BAAA;A1E+lTZ;;A0EtmTQ;EAOI,+BAAA;EAAA,kCAAA;A1EomTZ;;A0E3mTQ;EAOI,8BAAA;EAAA,iCAAA;A1EymTZ;;A0EhnTQ;EAOI,+BAAA;EAAA,kCAAA;A1E8mTZ;;A0ErnTQ;EAOI,4BAAA;EAAA,+BAAA;A1EmnTZ;;A0E1nTQ;EAOI,+BAAA;EAAA,kCAAA;A1EwnTZ;;A0E/nTQ;EAOI,8BAAA;EAAA,iCAAA;A1E6nTZ;;A0EpoTQ;EAOI,+BAAA;EAAA,kCAAA;A1EkoTZ;;A0EzoTQ;EAOI,4BAAA;EAAA,+BAAA;A1EuoTZ;;A0E9oTQ;EAOI,+BAAA;EAAA,kCAAA;A1E4oTZ;;A0EnpTQ;EAOI,8BAAA;EAAA,iCAAA;A1EipTZ;;A0ExpTQ;EAOI,+BAAA;EAAA,kCAAA;A1EspTZ;;A0E7pTQ;EAOI,4BAAA;EAAA,+BAAA;A1E2pTZ;;A0ElqTQ;EAOI,+BAAA;A1E+pTZ;;A0EtqTQ;EAOI,8BAAA;A1EmqTZ;;A0E1qTQ;EAOI,+BAAA;A1EuqTZ;;A0E9qTQ;EAOI,4BAAA;A1E2qTZ;;A0ElrTQ;EAOI,+BAAA;A1E+qTZ;;A0EtrTQ;EAOI,8BAAA;A1EmrTZ;;A0E1rTQ;EAOI,+BAAA;A1EurTZ;;A0E9rTQ;EAOI,4BAAA;A1E2rTZ;;A0ElsTQ;EAOI,+BAAA;A1E+rTZ;;A0EtsTQ;EAOI,8BAAA;A1EmsTZ;;A0E1sTQ;EAOI,+BAAA;A1EusTZ;;A0E9sTQ;EAOI,4BAAA;A1E2sTZ;;A0EltTQ;EAOI,+BAAA;A1E+sTZ;;A0EttTQ;EAOI,8BAAA;A1EmtTZ;;A0E1tTQ;EAOI,+BAAA;A1EutTZ;;A0E9tTQ;EAOI,4BAAA;A1E2tTZ;;A0EluTQ;EAOI,+BAAA;A1E+tTZ;;A0EtuTQ;EAOI,8BAAA;A1EmuTZ;;A0E1uTQ;EAOI,+BAAA;A1EuuTZ;;A0E9uTQ;EAOI,4BAAA;A1E2uTZ;;A0ElvTQ;EAOI,iCAAA;A1E+uTZ;;A0EtvTQ;EAOI,gCAAA;A1EmvTZ;;A0E1vTQ;EAOI,iCAAA;A1EuvTZ;;A0E9vTQ;EAOI,8BAAA;A1E2vTZ;;A0ElwTQ;EAOI,iCAAA;A1E+vTZ;;A0EtwTQ;EAOI,gCAAA;A1EmwTZ;;A0E1wTQ;EAOI,iCAAA;A1EuwTZ;;A0E9wTQ;EAOI,8BAAA;A1E2wTZ;;A0ElxTQ;EAOI,iCAAA;A1E+wTZ;;A0EtxTQ;EAOI,gCAAA;A1EmxTZ;;A0E1xTQ;EAOI,iCAAA;A1EuxTZ;;A0E9xTQ;EAOI,8BAAA;A1E2xTZ;;A0ElyTQ;EAOI,iCAAA;A1E+xTZ;;A0EtyTQ;EAOI,gCAAA;A1EmyTZ;;A0E1yTQ;EAOI,iCAAA;A1EuyTZ;;A0E9yTQ;EAOI,8BAAA;A1E2yTZ;;A0ElzTQ;EAOI,iCAAA;A1E+yTZ;;A0EtzTQ;EAOI,gCAAA;A1EmzTZ;;A0E1zTQ;EAOI,iCAAA;A1EuzTZ;;A0E9zTQ;EAOI,8BAAA;A1E2zTZ;;A0El0TQ;EAOI,kCAAA;A1E+zTZ;;A0Et0TQ;EAOI,iCAAA;A1Em0TZ;;A0E10TQ;EAOI,kCAAA;A1Eu0TZ;;A0E90TQ;EAOI,+BAAA;A1E20TZ;;A0El1TQ;EAOI,kCAAA;A1E+0TZ;;A0Et1TQ;EAOI,iCAAA;A1Em1TZ;;A0E11TQ;EAOI,kCAAA;A1Eu1TZ;;A0E91TQ;EAOI,+BAAA;A1E21TZ;;A0El2TQ;EAOI,kCAAA;A1E+1TZ;;A0Et2TQ;EAOI,iCAAA;A1Em2TZ;;A0E12TQ;EAOI,kCAAA;A1Eu2TZ;;A0E92TQ;EAOI,+BAAA;A1E22TZ;;A0El3TQ;EAOI,kCAAA;A1E+2TZ;;A0Et3TQ;EAOI,iCAAA;A1Em3TZ;;A0E13TQ;EAOI,kCAAA;A1Eu3TZ;;A0E93TQ;EAOI,+BAAA;A1E23TZ;;A0El4TQ;EAOI,kCAAA;A1E+3TZ;;A0Et4TQ;EAOI,iCAAA;A1Em4TZ;;A0E14TQ;EAOI,kCAAA;A1Eu4TZ;;A0E94TQ;EAOI,+BAAA;A1E24TZ;;A0El5TQ;EAOI,gCAAA;A1E+4TZ;;A0Et5TQ;EAOI,+BAAA;A1Em5TZ;;A0E15TQ;EAOI,gCAAA;A1Eu5TZ;;A0E95TQ;EAOI,6BAAA;A1E25TZ;;A0El6TQ;EAOI,gCAAA;A1E+5TZ;;A0Et6TQ;EAOI,+BAAA;A1Em6TZ;;A0E16TQ;EAOI,gCAAA;A1Eu6TZ;;A0E96TQ;EAOI,6BAAA;A1E26TZ;;A0El7TQ;EAOI,gCAAA;A1E+6TZ;;A0Et7TQ;EAOI,+BAAA;A1Em7TZ;;A0E17TQ;EAOI,gCAAA;A1Eu7TZ;;A0E97TQ;EAOI,6BAAA;A1E27TZ;;A0El8TQ;EAOI,gCAAA;A1E+7TZ;;A0Et8TQ;EAOI,+BAAA;A1Em8TZ;;A0E18TQ;EAOI,gCAAA;A1Eu8TZ;;A0E98TQ;EAOI,6BAAA;A1E28TZ;;A0El9TQ;EAOI,gCAAA;A1E+8TZ;;A0Et9TQ;EAOI,+BAAA;A1Em9TZ;;A0E19TQ;EAOI,gCAAA;A1Eu9TZ;;A0E99TQ;EAOI,6BAAA;A1E29TZ;;A0El+TQ;EAOI,qBAAA;A1E+9TZ;;A0Et+TQ;EAOI,2BAAA;A1Em+TZ;;A0E1+TQ;EAOI,0BAAA;A1Eu+TZ;;A0E9+TQ;EAOI,2BAAA;A1E2+TZ;;A0El/TQ;EAOI,wBAAA;A1E++TZ;;A0Et/TQ;EAOI,2BAAA;A1Em/TZ;;A0E1/TQ;EAOI,0BAAA;A1Eu/TZ;;A0E9/TQ;EAOI,2BAAA;A1E2/TZ;;A0ElgUQ;EAOI,wBAAA;A1E+/TZ;;A0EtgUQ;EAOI,2BAAA;A1EmgUZ;;A0E1gUQ;EAOI,0BAAA;A1EugUZ;;A0E9gUQ;EAOI,2BAAA;A1E2gUZ;;A0ElhUQ;EAOI,wBAAA;A1E+gUZ;;A0EthUQ;EAOI,2BAAA;A1EmhUZ;;A0E1hUQ;EAOI,0BAAA;A1EuhUZ;;A0E9hUQ;EAOI,2BAAA;A1E2hUZ;;A0EliUQ;EAOI,wBAAA;A1E+hUZ;;A0EtiUQ;EAOI,2BAAA;A1EmiUZ;;A0E1iUQ;EAOI,0BAAA;A1EuiUZ;;A0E9iUQ;EAOI,2BAAA;A1E2iUZ;;A0EljUQ;EAOI,wBAAA;A1E+iUZ;;A0EtjUQ;EAOI,2BAAA;EAAA,0BAAA;A1EojUZ;;A0E3jUQ;EAOI,iCAAA;EAAA,gCAAA;A1EyjUZ;;A0EhkUQ;EAOI,gCAAA;EAAA,+BAAA;A1E8jUZ;;A0ErkUQ;EAOI,iCAAA;EAAA,gCAAA;A1EmkUZ;;A0E1kUQ;EAOI,8BAAA;EAAA,6BAAA;A1EwkUZ;;A0E/kUQ;EAOI,iCAAA;EAAA,gCAAA;A1E6kUZ;;A0EplUQ;EAOI,gCAAA;EAAA,+BAAA;A1EklUZ;;A0EzlUQ;EAOI,iCAAA;EAAA,gCAAA;A1EulUZ;;A0E9lUQ;EAOI,8BAAA;EAAA,6BAAA;A1E4lUZ;;A0EnmUQ;EAOI,iCAAA;EAAA,gCAAA;A1EimUZ;;A0ExmUQ;EAOI,gCAAA;EAAA,+BAAA;A1EsmUZ;;A0E7mUQ;EAOI,iCAAA;EAAA,gCAAA;A1E2mUZ;;A0ElnUQ;EAOI,8BAAA;EAAA,6BAAA;A1EgnUZ;;A0EvnUQ;EAOI,iCAAA;EAAA,gCAAA;A1EqnUZ;;A0E5nUQ;EAOI,gCAAA;EAAA,+BAAA;A1E0nUZ;;A0EjoUQ;EAOI,iCAAA;EAAA,gCAAA;A1E+nUZ;;A0EtoUQ;EAOI,8BAAA;EAAA,6BAAA;A1EooUZ;;A0E3oUQ;EAOI,iCAAA;EAAA,gCAAA;A1EyoUZ;;A0EhpUQ;EAOI,gCAAA;EAAA,+BAAA;A1E8oUZ;;A0ErpUQ;EAOI,iCAAA;EAAA,gCAAA;A1EmpUZ;;A0E1pUQ;EAOI,8BAAA;EAAA,6BAAA;A1EwpUZ;;A0E/pUQ;EAOI,yBAAA;EAAA,4BAAA;A1E6pUZ;;A0EpqUQ;EAOI,+BAAA;EAAA,kCAAA;A1EkqUZ;;A0EzqUQ;EAOI,8BAAA;EAAA,iCAAA;A1EuqUZ;;A0E9qUQ;EAOI,+BAAA;EAAA,kCAAA;A1E4qUZ;;A0EnrUQ;EAOI,4BAAA;EAAA,+BAAA;A1EirUZ;;A0ExrUQ;EAOI,+BAAA;EAAA,kCAAA;A1EsrUZ;;A0E7rUQ;EAOI,8BAAA;EAAA,iCAAA;A1E2rUZ;;A0ElsUQ;EAOI,+BAAA;EAAA,kCAAA;A1EgsUZ;;A0EvsUQ;EAOI,4BAAA;EAAA,+BAAA;A1EqsUZ;;A0E5sUQ;EAOI,+BAAA;EAAA,kCAAA;A1E0sUZ;;A0EjtUQ;EAOI,8BAAA;EAAA,iCAAA;A1E+sUZ;;A0EttUQ;EAOI,+BAAA;EAAA,kCAAA;A1EotUZ;;A0E3tUQ;EAOI,4BAAA;EAAA,+BAAA;A1EytUZ;;A0EhuUQ;EAOI,+BAAA;EAAA,kCAAA;A1E8tUZ;;A0EruUQ;EAOI,8BAAA;EAAA,iCAAA;A1EmuUZ;;A0E1uUQ;EAOI,+BAAA;EAAA,kCAAA;A1EwuUZ;;A0E/uUQ;EAOI,4BAAA;EAAA,+BAAA;A1E6uUZ;;A0EpvUQ;EAOI,+BAAA;EAAA,kCAAA;A1EkvUZ;;A0EzvUQ;EAOI,8BAAA;EAAA,iCAAA;A1EuvUZ;;A0E9vUQ;EAOI,+BAAA;EAAA,kCAAA;A1E4vUZ;;A0EnwUQ;EAOI,4BAAA;EAAA,+BAAA;A1EiwUZ;;A0ExwUQ;EAOI,yBAAA;A1EqwUZ;;A0E5wUQ;EAOI,+BAAA;A1EywUZ;;A0EhxUQ;EAOI,8BAAA;A1E6wUZ;;A0EpxUQ;EAOI,+BAAA;A1EixUZ;;A0ExxUQ;EAOI,4BAAA;A1EqxUZ;;A0E5xUQ;EAOI,+BAAA;A1EyxUZ;;A0EhyUQ;EAOI,8BAAA;A1E6xUZ;;A0EpyUQ;EAOI,+BAAA;A1EiyUZ;;A0ExyUQ;EAOI,4BAAA;A1EqyUZ;;A0E5yUQ;EAOI,+BAAA;A1EyyUZ;;A0EhzUQ;EAOI,8BAAA;A1E6yUZ;;A0EpzUQ;EAOI,+BAAA;A1EizUZ;;A0ExzUQ;EAOI,4BAAA;A1EqzUZ;;A0E5zUQ;EAOI,+BAAA;A1EyzUZ;;A0Eh0UQ;EAOI,8BAAA;A1E6zUZ;;A0Ep0UQ;EAOI,+BAAA;A1Ei0UZ;;A0Ex0UQ;EAOI,4BAAA;A1Eq0UZ;;A0E50UQ;EAOI,+BAAA;A1Ey0UZ;;A0Eh1UQ;EAOI,8BAAA;A1E60UZ;;A0Ep1UQ;EAOI,+BAAA;A1Ei1UZ;;A0Ex1UQ;EAOI,4BAAA;A1Eq1UZ;;A0E51UQ;EAOI,2BAAA;A1Ey1UZ;;A0Eh2UQ;EAOI,iCAAA;A1E61UZ;;A0Ep2UQ;EAOI,gCAAA;A1Ei2UZ;;A0Ex2UQ;EAOI,iCAAA;A1Eq2UZ;;A0E52UQ;EAOI,8BAAA;A1Ey2UZ;;A0Eh3UQ;EAOI,iCAAA;A1E62UZ;;A0Ep3UQ;EAOI,gCAAA;A1Ei3UZ;;A0Ex3UQ;EAOI,iCAAA;A1Eq3UZ;;A0E53UQ;EAOI,8BAAA;A1Ey3UZ;;A0Eh4UQ;EAOI,iCAAA;A1E63UZ;;A0Ep4UQ;EAOI,gCAAA;A1Ei4UZ;;A0Ex4UQ;EAOI,iCAAA;A1Eq4UZ;;A0E54UQ;EAOI,8BAAA;A1Ey4UZ;;A0Eh5UQ;EAOI,iCAAA;A1E64UZ;;A0Ep5UQ;EAOI,gCAAA;A1Ei5UZ;;A0Ex5UQ;EAOI,iCAAA;A1Eq5UZ;;A0E55UQ;EAOI,8BAAA;A1Ey5UZ;;A0Eh6UQ;EAOI,iCAAA;A1E65UZ;;A0Ep6UQ;EAOI,gCAAA;A1Ei6UZ;;A0Ex6UQ;EAOI,iCAAA;A1Eq6UZ;;A0E56UQ;EAOI,8BAAA;A1Ey6UZ;;A0Eh7UQ;EAOI,4BAAA;A1E66UZ;;A0Ep7UQ;EAOI,kCAAA;A1Ei7UZ;;A0Ex7UQ;EAOI,iCAAA;A1Eq7UZ;;A0E57UQ;EAOI,kCAAA;A1Ey7UZ;;A0Eh8UQ;EAOI,+BAAA;A1E67UZ;;A0Ep8UQ;EAOI,kCAAA;A1Ei8UZ;;A0Ex8UQ;EAOI,iCAAA;A1Eq8UZ;;A0E58UQ;EAOI,kCAAA;A1Ey8UZ;;A0Eh9UQ;EAOI,+BAAA;A1E68UZ;;A0Ep9UQ;EAOI,kCAAA;A1Ei9UZ;;A0Ex9UQ;EAOI,iCAAA;A1Eq9UZ;;A0E59UQ;EAOI,kCAAA;A1Ey9UZ;;A0Eh+UQ;EAOI,+BAAA;A1E69UZ;;A0Ep+UQ;EAOI,kCAAA;A1Ei+UZ;;A0Ex+UQ;EAOI,iCAAA;A1Eq+UZ;;A0E5+UQ;EAOI,kCAAA;A1Ey+UZ;;A0Eh/UQ;EAOI,+BAAA;A1E6+UZ;;A0Ep/UQ;EAOI,kCAAA;A1Ei/UZ;;A0Ex/UQ;EAOI,iCAAA;A1Eq/UZ;;A0E5/UQ;EAOI,kCAAA;A1Ey/UZ;;A0EhgVQ;EAOI,+BAAA;A1E6/UZ;;A0EpgVQ;EAOI,0BAAA;A1EigVZ;;A0ExgVQ;EAOI,gCAAA;A1EqgVZ;;A0E5gVQ;EAOI,+BAAA;A1EygVZ;;A0EhhVQ;EAOI,gCAAA;A1E6gVZ;;A0EphVQ;EAOI,6BAAA;A1EihVZ;;A0ExhVQ;EAOI,gCAAA;A1EqhVZ;;A0E5hVQ;EAOI,+BAAA;A1EyhVZ;;A0EhiVQ;EAOI,gCAAA;A1E6hVZ;;A0EpiVQ;EAOI,6BAAA;A1EiiVZ;;A0ExiVQ;EAOI,gCAAA;A1EqiVZ;;A0E5iVQ;EAOI,+BAAA;A1EyiVZ;;A0EhjVQ;EAOI,gCAAA;A1E6iVZ;;A0EpjVQ;EAOI,6BAAA;A1EijVZ;;A0ExjVQ;EAOI,gCAAA;A1EqjVZ;;A0E5jVQ;EAOI,+BAAA;A1EyjVZ;;A0EhkVQ;EAOI,gCAAA;A1E6jVZ;;A0EpkVQ;EAOI,6BAAA;A1EikVZ;;A0ExkVQ;EAOI,gCAAA;A1EqkVZ;;A0E5kVQ;EAOI,+BAAA;A1EykVZ;;A0EhlVQ;EAOI,gCAAA;A1E6kVZ;;A0EplVQ;EAOI,6BAAA;A1EilVZ;;A0ExlVQ;EAOI,iBAAA;A1EqlVZ;;A0E5lVQ;EAOI,uBAAA;A1EylVZ;;A0EhmVQ;EAOI,sBAAA;A1E6lVZ;;A0EpmVQ;EAOI,uBAAA;A1EimVZ;;A0ExmVQ;EAOI,oBAAA;A1EqmVZ;;A0E5mVQ;EAOI,uBAAA;A1EymVZ;;A0EhnVQ;EAOI,sBAAA;A1E6mVZ;;A0EpnVQ;EAOI,uBAAA;A1EinVZ;;A0ExnVQ;EAOI,oBAAA;A1EqnVZ;;A0E5nVQ;EAOI,uBAAA;A1EynVZ;;A0EhoVQ;EAOI,sBAAA;A1E6nVZ;;A0EpoVQ;EAOI,uBAAA;A1EioVZ;;A0ExoVQ;EAOI,oBAAA;A1EqoVZ;;A0E5oVQ;EAOI,uBAAA;A1EyoVZ;;A0EhpVQ;EAOI,sBAAA;A1E6oVZ;;A0EppVQ;EAOI,uBAAA;A1EipVZ;;A0ExpVQ;EAOI,oBAAA;A1EqpVZ;;A0E5pVQ;EAOI,uBAAA;A1EypVZ;;A0EhqVQ;EAOI,sBAAA;A1E6pVZ;;A0EpqVQ;EAOI,uBAAA;A1EiqVZ;;A0ExqVQ;EAOI,oBAAA;A1EqqVZ;;A0E5qVQ;EAOI,qBAAA;A1EyqVZ;;A0EhrVQ;EAOI,2BAAA;A1E6qVZ;;A0EprVQ;EAOI,0BAAA;A1EirVZ;;A0ExrVQ;EAOI,2BAAA;A1EqrVZ;;A0E5rVQ;EAOI,wBAAA;A1EyrVZ;;A0EhsVQ;EAOI,2BAAA;A1E6rVZ;;A0EpsVQ;EAOI,0BAAA;A1EisVZ;;A0ExsVQ;EAOI,2BAAA;A1EqsVZ;;A0E5sVQ;EAOI,wBAAA;A1EysVZ;;A0EhtVQ;EAOI,2BAAA;A1E6sVZ;;A0EptVQ;EAOI,0BAAA;A1EitVZ;;A0ExtVQ;EAOI,2BAAA;A1EqtVZ;;A0E5tVQ;EAOI,wBAAA;A1EytVZ;;A0EhuVQ;EAOI,2BAAA;A1E6tVZ;;A0EpuVQ;EAOI,0BAAA;A1EiuVZ;;A0ExuVQ;EAOI,2BAAA;A1EquVZ;;A0E5uVQ;EAOI,wBAAA;A1EyuVZ;;A0EhvVQ;EAOI,2BAAA;A1E6uVZ;;A0EpvVQ;EAOI,0BAAA;A1EivVZ;;A0ExvVQ;EAOI,2BAAA;A1EqvVZ;;A0E5vVQ;EAOI,wBAAA;A1EyvVZ;;A0EhwVQ;EAOI,wBAAA;A1E6vVZ;;A0EpwVQ;EAOI,8BAAA;A1EiwVZ;;A0ExwVQ;EAOI,6BAAA;A1EqwVZ;;A0E5wVQ;EAOI,8BAAA;A1EywVZ;;A0EhxVQ;EAOI,2BAAA;A1E6wVZ;;A0EpxVQ;EAOI,8BAAA;A1EixVZ;;A0ExxVQ;EAOI,6BAAA;A1EqxVZ;;A0E5xVQ;EAOI,8BAAA;A1EyxVZ;;A0EhyVQ;EAOI,2BAAA;A1E6xVZ;;A0EpyVQ;EAOI,8BAAA;A1EiyVZ;;A0ExyVQ;EAOI,6BAAA;A1EqyVZ;;A0E5yVQ;EAOI,8BAAA;A1EyyVZ;;A0EhzVQ;EAOI,2BAAA;A1E6yVZ;;A0EpzVQ;EAOI,8BAAA;A1EizVZ;;A0ExzVQ;EAOI,6BAAA;A1EqzVZ;;A0E5zVQ;EAOI,8BAAA;A1EyzVZ;;A0Eh0VQ;EAOI,2BAAA;A1E6zVZ;;A0Ep0VQ;EAOI,8BAAA;A1Ei0VZ;;A0Ex0VQ;EAOI,6BAAA;A1Eq0VZ;;A0E50VQ;EAOI,8BAAA;A1Ey0VZ;;A0Eh1VQ;EAOI,2BAAA;A1E60VZ;;A0Ep1VQ;EAOI,gDAAA;A1Ei1VZ;;A0Ex1VQ;EAOI,0CAAA;A1Eq1VZ;;A0E51VQ;EAOI,4CAAA;A1Ey1VZ;;A0Eh2VQ;EAOI,4CAAA;A1E61VZ;;A0Ep2VQ;EAOI,6BAAA;A1Ei2VZ;;A0Ex2VQ;EAOI,6BAAA;A1Eq2VZ;;A0E52VQ;EAOI,8BAAA;A1Ey2VZ;;A0Eh3VQ;EAOI,6BAAA;A1E62VZ;;A0Ep3VQ;EAOI,6BAAA;A1Ei3VZ;;A0Ex3VQ;EAOI,6BAAA;A1Eq3VZ;;A0E53VQ;EAOI,4BAAA;A1Ey3VZ;;A0Eh4VQ;EAOI,6BAAA;A1E63VZ;;A0Ep4VQ;EAOI,0BAAA;A1Ei4VZ;;A0Ex4VQ;EAOI,8BAAA;A1Eq4VZ;;A0E54VQ;EAOI,6BAAA;A1Ey4VZ;;A0Eh5VQ;EAOI,0BAAA;A1E64VZ;;A0Ep5VQ;EAOI,4CAAA;A1Ei5VZ;;A0Ex5VQ;EAOI,2CAAA;A1Eq5VZ;;A0E55VQ;EAOI,4CAAA;A1Ey5VZ;;A0Eh6VQ;EAOI,0CAAA;A1E65VZ;;A0Ep6VQ;EAOI,4CAAA;A1Ei6VZ;;A0Ex6VQ;EAOI,2CAAA;A1Eq6VZ;;A0E56VQ;EAOI,4CAAA;A1Ey6VZ;;A0Eh7VQ;EAOI,wCAAA;A1E66VZ;;A0Ep7VQ;EAOI,4CAAA;A1Ei7VZ;;A0Ex7VQ;EAOI,2CAAA;A1Eq7VZ;;A0E57VQ;EAOI,4CAAA;A1Ey7VZ;;A0Eh8VQ;EAOI,0CAAA;A1E67VZ;;A0Ep8VQ;EAOI,4CAAA;A1Ei8VZ;;A0Ex8VQ;EAOI,2CAAA;A1Eq8VZ;;A0E58VQ;EAOI,4CAAA;A1Ey8VZ;;A0Eh9VQ;EAOI,0CAAA;A1E68VZ;;A0Ep9VQ;EAOI,4CAAA;A1Ei9VZ;;A0Ex9VQ;EAOI,yCAAA;A1Eq9VZ;;A0E59VQ;EAOI,4CAAA;A1Ey9VZ;;A0Eh+VQ;EAOI,0CAAA;A1E69VZ;;A0Ep+VQ;EAOI,4CAAA;A1Ei+VZ;;A0Ex+VQ;EAOI,2CAAA;A1Eq+VZ;;A0E5+VQ;EAOI,4CAAA;A1Ey+VZ;;A0Eh/VQ;EAOI,0CAAA;A1E6+VZ;;A0Ep/VQ;EAOI,6BAAA;A1Ei/VZ;;A0Ex/VQ;EAOI,6BAAA;A1Eq/VZ;;A0E5/VQ;EAOI,+BAAA;A1Ey/VZ;;A0EhgWQ;EAOI,2BAAA;A1E6/VZ;;A0EpgWQ;EAOI,2BAAA;A1EigWZ;;A0ExgWQ;EAOI,2BAAA;A1EqgWZ;;A0E5gWQ;EAOI,2BAAA;A1EygWZ;;A0EhhWQ;EAOI,2BAAA;A1E6gWZ;;A0EphWQ;EAOI,2BAAA;A1EihWZ;;A0ExhWQ;EAOI,yBAAA;A1EqhWZ;;A0E5hWQ;EAOI,yBAAA;A1EyhWZ;;A0EhiWQ;EAOI,4BAAA;A1E6hWZ;;A0EpiWQ;EAOI,2BAAA;A1EiiWZ;;A0ExiWQ;EAOI,4BAAA;A1EqiWZ;;A0E5iWQ;EAOI,yBAAA;A1EyiWZ;;A0EhjWQ;EAOI,4BAAA;A1E6iWZ;;A0EpjWQ;EAOI,2BAAA;A1EijWZ;;A0ExjWQ;EAOI,4BAAA;A1EqjWZ;;A0E5jWQ;EAOI,6BAAA;A1EyjWZ;;A0EhkWQ;EAOI,gCAAA;A1E6jWZ;;A0EpkWQ;EAOI,qCAAA;A1EikWZ;;A0ExkWQ;EAOI,wCAAA;A1EqkWZ;;A0E5kWQ;EAOI,oCAAA;A1EykWZ;;A0EhlWQ;EAOI,oCAAA;A1E6kWZ;;A0EplWQ;EAOI,qCAAA;A1EilWZ;;A0ExlWQ;EAOI,8BAAA;A1EqlWZ;;A0E5lWQ;EAOI,8BAAA;A1EylWZ;;A0E9mWQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A1E+lWZ;;A0E5kWQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,mEAAA;A1EqmWZ;;A0E5mWQ;EAIQ,oBAAA;EAGJ,qEAAA;A1E0mWZ;;A0EjnWQ;EAIQ,oBAAA;EAGJ,uEAAA;A1E+mWZ;;A0EtnWQ;EAIQ,oBAAA;EAGJ,qEAAA;A1EonWZ;;A0E3nWQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EynWZ;;A0EhoWQ;EAIQ,oBAAA;EAGJ,qEAAA;A1E8nWZ;;A0EroWQ;EAIQ,oBAAA;EAGJ,oEAAA;A1EmoWZ;;A0E1oWQ;EAIQ,oBAAA;EAGJ,kEAAA;A1EwoWZ;;A0E/oWQ;EAIQ,oBAAA;EAGJ,mEAAA;A1E6oWZ;;A0EppWQ;EAIQ,oBAAA;EAGJ,mEAAA;A1EkpWZ;;A0EzpWQ;EAIQ,oBAAA;EAGJ,wEAAA;A1EupWZ;;A0E9pWQ;EAIQ,oBAAA;EAGJ,2CAAA;A1E4pWZ;;A0EnqWQ;EAIQ,oBAAA;EAGJ,oCAAA;A1EiqWZ;;A0ExqWQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EsqWZ;;A0E7qWQ;EAIQ,oBAAA;EAGJ,2CAAA;A1E2qWZ;;A0ElrWQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EgrWZ;;A0EvrWQ;EAIQ,oBAAA;EAGJ,0CAAA;A1EqrWZ;;A0E5rWQ;EAIQ,oBAAA;EAGJ,yBAAA;A1E0rWZ;;A0E3sWQ;EACE,uBAAA;A1E8sWV;;A0E/sWQ;EACE,sBAAA;A1EktWV;;A0EntWQ;EACE,uBAAA;A1EstWV;;A0EvtWQ;EACE,oBAAA;A1E0tWV;;A0EjtWQ;EAOI,iDAAA;A1E8sWZ;;A0ErtWQ;EAOI,mDAAA;A1EktWZ;;A0EztWQ;EAOI,iDAAA;A1EstWZ;;A0E7tWQ;EAOI,8CAAA;A1E0tWZ;;A0EjuWQ;EAOI,iDAAA;A1E8tWZ;;A0EruWQ;EAOI,gDAAA;A1EkuWZ;;A0EzuWQ;EAOI,+CAAA;A1EsuWZ;;A0E7uWQ;EAOI,8CAAA;A1E0uWZ;;A0E3vWQ;EACE,sBAAA;A1E8vWV;;A0E1vWU;EACE,sBAAA;A1E6vWZ;;A0EnwWQ;EACE,uBAAA;A1EswWV;;A0ElwWU;EACE,uBAAA;A1EqwWZ;;A0E3wWQ;EACE,sBAAA;A1E8wWV;;A0E1wWU;EACE,sBAAA;A1E6wWZ;;A0EnxWQ;EACE,uBAAA;A1EsxWV;;A0ElxWU;EACE,uBAAA;A1EqxWZ;;A0E3xWQ;EACE,oBAAA;A1E8xWV;;A0E1xWU;EACE,oBAAA;A1E6xWZ;;A0EzxWQ;EAOI,yCAAA;A1EsxWZ;;A0EjxWU;EAOI,yCAAA;A1E8wWd;;A0EjyWQ;EAOI,wCAAA;A1E8xWZ;;A0EzxWU;EAOI,wCAAA;A1EsxWd;;A0EzyWQ;EAOI,yCAAA;A1EsyWZ;;A0EjyWU;EAOI,yCAAA;A1E8xWd;;A0EjzWQ;EAIQ,8BAAA;EAGJ,6FAAA;A1E+yWZ;;A0EtzWQ;EAIQ,8BAAA;EAGJ,+FAAA;A1EozWZ;;A0E3zWQ;EAIQ,8BAAA;EAGJ,iGAAA;A1EyzWZ;;A0Eh0WQ;EAIQ,8BAAA;EAGJ,+FAAA;A1E8zWZ;;A0Er0WQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Em0WZ;;A0E10WQ;EAIQ,8BAAA;EAGJ,+FAAA;A1Ew0WZ;;A0E/0WQ;EAIQ,8BAAA;EAGJ,8FAAA;A1E60WZ;;A0Ep1WQ;EAIQ,8BAAA;EAGJ,4FAAA;A1Ek1WZ;;A0Ez1WQ;EAIQ,8BAAA;EAGJ,qGAAA;A1Eu1WZ;;A0Ex2WQ;EACE,8BAAA;A1E22WV;;A0Ev2WU;EACE,8BAAA;A1E02WZ;;A0Eh3WQ;EACE,gCAAA;A1Em3WV;;A0E/2WU;EACE,gCAAA;A1Ek3WZ;;A0Ex3WQ;EACE,iCAAA;A1E23WV;;A0Ev3WU;EACE,iCAAA;A1E03WZ;;A0Eh4WQ;EACE,gCAAA;A1Em4WV;;A0E/3WU;EACE,gCAAA;A1Ek4WZ;;A0Ex4WQ;EACE,iCAAA;A1E24WV;;A0Ev4WU;EACE,iCAAA;A1E04WZ;;A0Eh5WQ;EACE,8BAAA;A1Em5WV;;A0E/4WU;EACE,8BAAA;A1Ek5WZ;;A0E94WQ;EAIQ,kBAAA;EAGJ,4EAAA;A1E44WZ;;A0En5WQ;EAIQ,kBAAA;EAGJ,8EAAA;A1Ei5WZ;;A0Ex5WQ;EAIQ,kBAAA;EAGJ,gFAAA;A1Es5WZ;;A0E75WQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E25WZ;;A0El6WQ;EAIQ,kBAAA;EAGJ,2EAAA;A1Eg6WZ;;A0Ev6WQ;EAIQ,kBAAA;EAGJ,8EAAA;A1Eq6WZ;;A0E56WQ;EAIQ,kBAAA;EAGJ,6EAAA;A1E06WZ;;A0Ej7WQ;EAIQ,kBAAA;EAGJ,2EAAA;A1E+6WZ;;A0Et7WQ;EAIQ,kBAAA;EAGJ,4EAAA;A1Eo7WZ;;A0E37WQ;EAIQ,kBAAA;EAGJ,4EAAA;A1Ey7WZ;;A0Eh8WQ;EAIQ,kBAAA;EAGJ,8EAAA;A1E87WZ;;A0Er8WQ;EAIQ,kBAAA;EAGJ,wCAAA;A1Em8WZ;;A0E18WQ;EAIQ,kBAAA;EAGJ,mFAAA;A1Ew8WZ;;A0E/8WQ;EAIQ,kBAAA;EAGJ,kFAAA;A1E68WZ;;A0E99WQ;EACE,oBAAA;A1Ei+WV;;A0El+WQ;EACE,qBAAA;A1Eq+WV;;A0Et+WQ;EACE,oBAAA;A1Ey+WV;;A0E1+WQ;EACE,qBAAA;A1E6+WV;;A0E9+WQ;EACE,kBAAA;A1Ei/WV;;A0Ex+WQ;EAOI,wDAAA;A1Eq+WZ;;A0E5+WQ;EAOI,0DAAA;A1Ey+WZ;;A0Eh/WQ;EAOI,wDAAA;A1E6+WZ;;A0Ep/WQ;EAOI,qDAAA;A1Ei/WZ;;A0Ex/WQ;EAOI,wDAAA;A1Eq/WZ;;A0E5/WQ;EAOI,uDAAA;A1Ey/WZ;;A0EhgXQ;EAOI,sDAAA;A1E6/WZ;;A0EpgXQ;EAOI,qDAAA;A1EigXZ;;A0ExgXQ;EAOI,+CAAA;A1EqgXZ;;A0E5gXQ;EAOI,mCAAA;UAAA,2BAAA;A1EygXZ;;A0EhhXQ;EAOI,oCAAA;UAAA,4BAAA;A1E6gXZ;;A0EphXQ;EAOI,oCAAA;UAAA,4BAAA;A1EihXZ;;A0ExhXQ;EAOI,+BAAA;A1EqhXZ;;A0E5hXQ;EAOI,+BAAA;A1EyhXZ;;A0EhiXQ;EAOI,iCAAA;A1E6hXZ;;A0EpiXQ;EAOI,2BAAA;A1EiiXZ;;A0ExiXQ;EAOI,gCAAA;A1EqiXZ;;A0E5iXQ;EAOI,iCAAA;A1EyiXZ;;A0EhjXQ;EAOI,iCAAA;A1E6iXZ;;A0EpjXQ;EAOI,iCAAA;A1EijXZ;;A0ExjXQ;EAOI,6BAAA;A1EqjXZ;;A0E5jXQ;EAOI,+BAAA;A1EyjXZ;;A0EhkXQ;EAOI,0DAAA;EAAA,2DAAA;A1E8jXZ;;A0ErkXQ;EAOI,oCAAA;EAAA,qCAAA;A1EmkXZ;;A0E1kXQ;EAOI,6DAAA;EAAA,8DAAA;A1EwkXZ;;A0E/kXQ;EAOI,0DAAA;EAAA,2DAAA;A1E6kXZ;;A0EplXQ;EAOI,6DAAA;EAAA,8DAAA;A1EklXZ;;A0EzlXQ;EAOI,6DAAA;EAAA,8DAAA;A1EulXZ;;A0E9lXQ;EAOI,8DAAA;EAAA,+DAAA;A1E4lXZ;;A0EnmXQ;EAOI,sCAAA;EAAA,uCAAA;A1EimXZ;;A0ExmXQ;EAOI,+DAAA;EAAA,gEAAA;A1EsmXZ;;A0E7mXQ;EAOI,2DAAA;EAAA,8DAAA;A1E2mXZ;;A0ElnXQ;EAOI,qCAAA;EAAA,wCAAA;A1EgnXZ;;A0EvnXQ;EAOI,8DAAA;EAAA,iEAAA;A1EqnXZ;;A0E5nXQ;EAOI,2DAAA;EAAA,8DAAA;A1E0nXZ;;A0EjoXQ;EAOI,8DAAA;EAAA,iEAAA;A1E+nXZ;;A0EtoXQ;EAOI,8DAAA;EAAA,iEAAA;A1EooXZ;;A0E3oXQ;EAOI,+DAAA;EAAA,kEAAA;A1EyoXZ;;A0EhpXQ;EAOI,uCAAA;EAAA,0CAAA;A1E8oXZ;;A0ErpXQ;EAOI,gEAAA;EAAA,mEAAA;A1EmpXZ;;A0E1pXQ;EAOI,8DAAA;EAAA,6DAAA;A1EwpXZ;;A0E/pXQ;EAOI,wCAAA;EAAA,uCAAA;A1E6pXZ;;A0EpqXQ;EAOI,iEAAA;EAAA,gEAAA;A1EkqXZ;;A0EzqXQ;EAOI,8DAAA;EAAA,6DAAA;A1EuqXZ;;A0E9qXQ;EAOI,iEAAA;EAAA,gEAAA;A1E4qXZ;;A0EnrXQ;EAOI,iEAAA;EAAA,gEAAA;A1EirXZ;;A0ExrXQ;EAOI,kEAAA;EAAA,iEAAA;A1EsrXZ;;A0E7rXQ;EAOI,0CAAA;EAAA,yCAAA;A1E2rXZ;;A0ElsXQ;EAOI,mEAAA;EAAA,kEAAA;A1EgsXZ;;A0EvsXQ;EAOI,6DAAA;EAAA,0DAAA;A1EqsXZ;;A0E5sXQ;EAOI,uCAAA;EAAA,oCAAA;A1E0sXZ;;A0EjtXQ;EAOI,gEAAA;EAAA,6DAAA;A1E+sXZ;;A0EttXQ;EAOI,6DAAA;EAAA,0DAAA;A1EotXZ;;A0E3tXQ;EAOI,gEAAA;EAAA,6DAAA;A1EytXZ;;A0EhuXQ;EAOI,gEAAA;EAAA,6DAAA;A1E8tXZ;;A0EruXQ;EAOI,iEAAA;EAAA,8DAAA;A1EmuXZ;;A0E1uXQ;EAOI,yCAAA;EAAA,sCAAA;A1EwuXZ;;A0E/uXQ;EAOI,kEAAA;EAAA,+DAAA;A1E6uXZ;;A0EpvXQ;EAOI,8BAAA;A1EivXZ;;A0ExvXQ;EAOI,6BAAA;A1EqvXZ;;A0E5vXQ;EAOI,sBAAA;A1EyvXZ;;A0EhwXQ;EAOI,sBAAA;A1E6vXZ;;A0EpwXQ;EAOI,qBAAA;A1EiwXZ;;A0ExwXQ;EAOI,qBAAA;A1EqwXZ;;A0E5wXQ;EAOI,qBAAA;A1EywXZ;;A0EhxXQ;EAOI,qBAAA;A1E6wXZ;;A0EpxXQ;EAOI,uBAAA;A1EixXZ;;A0ExxXQ;EAOI,uBAAA;A1EqxXZ;;A0E5xXQ;EAOI,4BAAA;A1EyxXZ;;A0EhyXQ;EAOI,8BAAA;A1E6xXZ;;A0EpyXQ;EAOI,0BAAA;A1EiyXZ;;A0ExyXQ;EAOI,uBAAA;A1EqyXZ;;A0E5yXQ;EAOI,0BAAA;A1EyyXZ;;A0EhzXQ;EAOI,qBAAA;A1E6yXZ;;A0ExyXU;EAOI,qBAAA;A1EqyXd;;A0ExzXQ;EAOI,wBAAA;A1EqzXZ;;A0EhzXU;EAOI,wBAAA;A1E6yXd;;A0Eh0XQ;EAOI,uBAAA;A1E6zXZ;;A0ExzXU;EAOI,uBAAA;A1EqzXd;;A0Ex0XQ;EAOI,wBAAA;A1Eq0XZ;;A0Eh0XU;EAOI,wBAAA;A1E6zXd;;A0Eh1XQ;EAOI,uBAAA;A1E60XZ;;A0Ex0XU;EAOI,uBAAA;A1Eq0Xd;;A0Ex1XQ;EAOI,wBAAA;A1Eq1XZ;;A0Eh1XU;EAOI,wBAAA;A1E60Xd;;A0Eh2XQ;EAOI,uBAAA;A1E61XZ;;A0Ex1XU;EAOI,uBAAA;A1Eq1Xd;;A0Ex2XQ;EAOI,wBAAA;A1Eq2XZ;;A0Eh2XU;EAOI,wBAAA;A1E61Xd;;A0Eh3XQ;EAOI,qBAAA;A1E62XZ;;A0Ex2XU;EAOI,qBAAA;A1Eq2Xd;;A0Ex3XQ;EAOI,2BAAA;A1Eq3XZ;;A0E53XQ;EAOI,yBAAA;A1Ey3XZ;;A0Eh4XQ;EAOI,yBAAA;A1E63XZ;;A0Ep4XQ;EAOI,yBAAA;A1Ei4XZ;;A0Ex4XQ;EAOI,0BAAA;A1Eq4XZ;;A0E54XQ;EAOI,0BAAA;A1Ey4XZ;;A0Eh5XQ;EAOI,yBAAA;A1E64XZ;;A0Ep5XQ;EAOI,yBAAA;A1Ei5XZ;;A0Ex5XQ;EAOI,yBAAA;A1Eq5XZ;;A0E55XQ;EAOI,yBAAA;A1Ey5XZ;;A0Eh6XQ;EAOI,yBAAA;A1E65XZ;;A0Ep6XQ;EAOI,yBAAA;A1Ei6XZ;;A0Ex6XQ;EAOI,yBAAA;A1Eq6XZ;;A0E56XQ;EAOI,yBAAA;A1Ey6XZ;;A0Eh7XQ;EAOI,yBAAA;A1E66XZ;;A0Ep7XQ;EAOI,0BAAA;A1Ei7XZ;;A0Ex7XQ;EAOI,0BAAA;A1Eq7XZ;;A0E57XQ;EAOI,0BAAA;A1Ey7XZ;;A0Eh8XQ;EAOI,0BAAA;A1E67XZ;;A0Ep8XQ;EAOI,0BAAA;A1Ei8XZ;;A0Ex8XQ;EAOI,0BAAA;A1Eq8XZ;;A0E58XQ;EAOI,0BAAA;A1Ey8XZ;;A0Eh9XQ;EAOI,0BAAA;A1E68XZ;;A0Ep9XQ;EAOI,0BAAA;A1Ei9XZ;;A0Ex9XQ;EAOI,0BAAA;A1Eq9XZ;;A0E59XQ;EAOI,0BAAA;A1Ey9XZ;;A0Eh+XQ;EAOI,0BAAA;A1E69XZ;;A0Ep+XQ;EAOI,0BAAA;A1Ei+XZ;;A0Ex+XQ;EAOI,0BAAA;A1Eq+XZ;;A0E5+XQ;EAOI,0BAAA;A1Ey+XZ;;A0Eh/XQ;EAOI,0BAAA;A1E6+XZ;;A0Ep/XQ;EAOI,0BAAA;A1Ei/XZ;;A0Ex/XQ;EAOI,0BAAA;A1Eq/XZ;;A0E5/XQ;EAOI,2BAAA;A1Ey/XZ;;A0EhgYQ;EAOI,2BAAA;A1E6/XZ;;A0EpgYQ;EAOI,2BAAA;A1EigYZ;;A0ExgYQ;EAOI,2BAAA;A1EqgYZ;;A0E5gYQ;EAOI,2BAAA;A1EygYZ;;A0EhhYQ;EAOI,2BAAA;A1E6gYZ;;A0EphYQ;EAOI,2BAAA;A1EihYZ;;A0ExhYQ;EAOI,2BAAA;A1EqhYZ;;A0E5hYQ;EAOI,2BAAA;A1EyhYZ;;A0EhiYQ;EAOI,2BAAA;A1E6hYZ;;A0EpiYQ;EAOI,2BAAA;A1EiiYZ;;A0ExiYQ;EAOI,2BAAA;A1EqiYZ;;A0E5iYQ;EAOI,2BAAA;A1EyiYZ;;A0EhjYQ;EAOI,2BAAA;A1E6iYZ;;A0EpjYQ;EAOI,2BAAA;A1EijYZ;;A0ExjYQ;EAOI,2BAAA;A1EqjYZ;;A0E5jYQ;EAOI,2BAAA;A1EyjYZ;;A0EhkYQ;EAOI,2BAAA;A1E6jYZ;;A0EpkYQ;EAOI,2BAAA;A1EikYZ;;A0ExkYQ;EAOI,2BAAA;A1EqkYZ;;A0E5kYQ;EAOI,2BAAA;A1EykYZ;;A0EhlYQ;EAOI,2BAAA;A1E6kYZ;;A0EplYQ;EAOI,2BAAA;A1EilYZ;;A0ExlYQ;EAOI,2BAAA;A1EqlYZ;;A0E5lYQ;EAOI,2BAAA;A1EylYZ;;A0EhmYQ;EAOI,2BAAA;A1E6lYZ;;A0EpmYQ;EAOI,4BAAA;A1EimYZ;;A0ExmYQ;EAOI,4BAAA;A1EqmYZ;;A0E5mYQ;EAOI,0BAAA;A1EymYZ;;A0EhnYQ;EAOI,0BAAA;A1E6mYZ;;A0EpnYQ;EAOI,0BAAA;A1EinYZ;;A0ExnYQ;EAOI,2BAAA;A1EqnYZ;;A0E5nYQ;EAOI,2BAAA;A1EynYZ;;A0EhoYQ;EAOI,0BAAA;A1E6nYZ;;A0EpoYQ;EAOI,0BAAA;A1EioYZ;;A0ExoYQ;EAOI,0BAAA;A1EqoYZ;;A0E5oYQ;EAOI,0BAAA;A1EyoYZ;;A0EhpYQ;EAOI,0BAAA;A1E6oYZ;;A0EppYQ;EAOI,0BAAA;A1EipYZ;;A0ExpYQ;EAOI,0BAAA;A1EqpYZ;;A0E5pYQ;EAOI,0BAAA;A1EypYZ;;A0EhqYQ;EAOI,0BAAA;A1E6pYZ;;A0EpqYQ;EAOI,2BAAA;A1EiqYZ;;A0ExqYQ;EAOI,2BAAA;A1EqqYZ;;A0E5qYQ;EAOI,2BAAA;A1EyqYZ;;A0EhrYQ;EAOI,2BAAA;A1E6qYZ;;A0EprYQ;EAOI,2BAAA;A1EirYZ;;A0ExrYQ;EAOI,2BAAA;A1EqrYZ;;A0E5rYQ;EAOI,2BAAA;A1EyrYZ;;A0EhsYQ;EAOI,2BAAA;A1E6rYZ;;A0EpsYQ;EAOI,2BAAA;A1EisYZ;;A0ExsYQ;EAOI,2BAAA;A1EqsYZ;;A0E5sYQ;EAOI,2BAAA;A1EysYZ;;A0EhtYQ;EAOI,2BAAA;A1E6sYZ;;A0EptYQ;EAOI,2BAAA;A1EitYZ;;A0ExtYQ;EAOI,2BAAA;A1EqtYZ;;A0E5tYQ;EAOI,2BAAA;A1EytYZ;;A0EhuYQ;EAOI,2BAAA;A1E6tYZ;;A0EpuYQ;EAOI,2BAAA;A1EiuYZ;;A0ExuYQ;EAOI,2BAAA;A1EquYZ;;A0E5uYQ;EAOI,4BAAA;A1EyuYZ;;A0EhvYQ;EAOI,4BAAA;A1E6uYZ;;A0EpvYQ;EAOI,4BAAA;A1EivYZ;;A0ExvYQ;EAOI,4BAAA;A1EqvYZ;;A0E5vYQ;EAOI,4BAAA;A1EyvYZ;;A0EhwYQ;EAOI,4BAAA;A1E6vYZ;;A0EpwYQ;EAOI,4BAAA;A1EiwYZ;;A0ExwYQ;EAOI,4BAAA;A1EqwYZ;;A0E5wYQ;EAOI,4BAAA;A1EywYZ;;A0EhxYQ;EAOI,4BAAA;A1E6wYZ;;A0EpxYQ;EAOI,4BAAA;A1EixYZ;;A0ExxYQ;EAOI,4BAAA;A1EqxYZ;;A0E5xYQ;EAOI,4BAAA;A1EyxYZ;;A0EhyYQ;EAOI,4BAAA;A1E6xYZ;;A0EpyYQ;EAOI,4BAAA;A1EiyYZ;;A0ExyYQ;EAOI,4BAAA;A1EqyYZ;;A0E5yYQ;EAOI,4BAAA;A1EyyYZ;;A0EhzYQ;EAOI,4BAAA;A1E6yYZ;;A0EpzYQ;EAOI,4BAAA;A1EizYZ;;A0ExzYQ;EAOI,4BAAA;A1EqzYZ;;A0E5zYQ;EAOI,4BAAA;A1EyzYZ;;A0Eh0YQ;EAOI,4BAAA;A1E6zYZ;;A0Ep0YQ;EAOI,4BAAA;A1Ei0YZ;;A0Ex0YQ;EAOI,4BAAA;A1Eq0YZ;;A0E50YQ;EAOI,4BAAA;A1Ey0YZ;;A0Eh1YQ;EAOI,4BAAA;A1E60YZ;;A0Ep1YQ;EAOI,6BAAA;A1Ei1YZ;;A0Ex1YQ;EAOI,8BAAA;A1Eq1YZ;;A0E51YQ;EAOI,gCAAA;A1Ey1YZ;;A0Eh2YQ;EAOI,gCAAA;A1E61YZ;;A0Ep2YQ;EAOI,gCAAA;A1Ei2YZ;;A0Ex2YQ;EAOI,gCAAA;A1Eq2YZ;;A0E52YQ;EAOI,gCAAA;A1Ey2YZ;;A0Eh3YQ;EAOI,iCAAA;A1E62YZ;;A0Ep3YQ;EAOI,mCAAA;A1Ei3YZ;;A0Ex3YQ;EAOI,mCAAA;A1Eq3YZ;;A0E53YQ;EAOI,mCAAA;A1Ey3YZ;;A0Eh4YQ;EAOI,mCAAA;A1E63YZ;;A0Ep4YQ;EAOI,mCAAA;A1Ei4YZ;;A0Ex4YQ;EAOI,gCAAA;A1Eq4YZ;;A0E54YQ;EAOI,kCAAA;A1Ey4YZ;;A0Eh5YQ;EAOI,kCAAA;A1E64YZ;;A0Ep5YQ;EAOI,kCAAA;A1Ei5YZ;;A0Ex5YQ;EAOI,kCAAA;A1Eq5YZ;;A0E55YQ;EAOI,kCAAA;A1Ey5YZ;;A0Eh6YQ;EAOI,+BAAA;A1E65YZ;;A0Ep6YQ;EAOI,iCAAA;A1Ei6YZ;;A0Ex6YQ;EAOI,iCAAA;A1Eq6YZ;;A0E56YQ;EAOI,iCAAA;A1Ey6YZ;;A0Eh7YQ;EAOI,iCAAA;A1E66YZ;;A0Ep7YQ;EAOI,iCAAA;A1Ei7YZ;;A0Ex7YQ;EAOI,iCAAA;A1Eq7YZ;;A0E57YQ;EAOI,mCAAA;A1Ey7YZ;;A0Eh8YQ;EAOI,mCAAA;A1E67YZ;;A0Ep8YQ;EAOI,kCAAA;A1Ei8YZ;;A0Ex8YQ;EAOI,iCAAA;A1Eq8YZ;;A0E58YQ;EAOI,kCAAA;A1Ey8YZ;;A0Eh9YQ;EAOI,oCAAA;A1E68YZ;;A0Ep9YQ;EAOI,oCAAA;A1Ei9YZ;;A0Ex9YQ;EAOI,mCAAA;A1Eq9YZ;;A0E59YQ;EAOI,kCAAA;A1Ey9YZ;;AgBn+YI;E0DGI;IAOI,sBAAA;E1E89YV;E0Er+YM;IAOI,uBAAA;E1Ei+YV;E0Ex+YM;IAOI,sBAAA;E1Eo+YV;E0E3+YM;IAOI,8BAAA;E1Eu+YV;E0E9+YM;IAOI,4BAAA;E1E0+YV;E0Ej/YM;IAOI,2BAAA;E1E6+YV;E0Ep/YM;IAOI,iCAAA;E1Eg/YV;E0Ev/YM;IAOI,2BAAA;E1Em/YV;E0E1/YM;IAOI,yBAAA;E1Es/YV;E0E7/YM;IAOI,2BAAA;E1Ey/YV;E0EhgZM;IAOI,4BAAA;E1E4/YV;E0EngZM;IAOI,2BAAA;E1E+/YV;E0EtgZM;IAOI,0BAAA;E1EkgZV;E0EzgZM;IAOI,gCAAA;E1EqgZV;E0E5gZM;IAOI,yBAAA;E1EwgZV;E0E/gZM;IAOI,wBAAA;E1E2gZV;E0ElhZM;IAOI,+BAAA;E1E8gZV;E0ErhZM;IAOI,yBAAA;E1EihZV;E0ExhZM;IAOI,6BAAA;E1EohZV;E0E3hZM;IAOI,8BAAA;E1EuhZV;E0E9hZM;IAOI,wBAAA;E1E0hZV;E0EjiZM;IAOI,+BAAA;E1E6hZV;E0EpiZM;IAOI,wBAAA;E1EgiZV;E0EviZM;IAOI,2BAAA;E1EmiZV;E0E1iZM;IAOI,6BAAA;E1EsiZV;E0E7iZM;IAOI,6BAAA;E1EyiZV;E0EhjZM;IAOI,0BAAA;E1E4iZV;E0EnjZM;IAOI,2BAAA;E1E+iZV;E0EtjZM;IAOI,uBAAA;E1EkjZV;E0EzjZM;IAOI,qBAAA;E1EqjZV;E0E5jZM;IAOI,qBAAA;E1EwjZV;E0E/jZM;IAOI,qBAAA;E1E2jZV;E0ElkZM;IAOI,sBAAA;E1E8jZV;E0ErkZM;IAOI,sBAAA;E1EikZV;E0ExkZM;IAOI,qBAAA;E1EokZV;E0E3kZM;IAOI,qBAAA;E1EukZV;E0E9kZM;IAOI,qBAAA;E1E0kZV;E0EjlZM;IAOI,qBAAA;E1E6kZV;E0EplZM;IAOI,qBAAA;E1EglZV;E0EvlZM;IAOI,qBAAA;E1EmlZV;E0E1lZM;IAOI,qBAAA;E1EslZV;E0E7lZM;IAOI,qBAAA;E1EylZV;E0EhmZM;IAOI,qBAAA;E1E4lZV;E0EnmZM;IAOI,sBAAA;E1E+lZV;E0EtmZM;IAOI,sBAAA;E1EkmZV;E0EzmZM;IAOI,sBAAA;E1EqmZV;E0E5mZM;IAOI,sBAAA;E1EwmZV;E0E/mZM;IAOI,sBAAA;E1E2mZV;E0ElnZM;IAOI,sBAAA;E1E8mZV;E0ErnZM;IAOI,sBAAA;E1EinZV;E0ExnZM;IAOI,sBAAA;E1EonZV;E0E3nZM;IAOI,sBAAA;E1EunZV;E0E9nZM;IAOI,sBAAA;E1E0nZV;E0EjoZM;IAOI,sBAAA;E1E6nZV;E0EpoZM;IAOI,sBAAA;E1EgoZV;E0EvoZM;IAOI,sBAAA;E1EmoZV;E0E1oZM;IAOI,sBAAA;E1EsoZV;E0E7oZM;IAOI,sBAAA;E1EyoZV;E0EhpZM;IAOI,sBAAA;E1E4oZV;E0EnpZM;IAOI,sBAAA;E1E+oZV;E0EtpZM;IAOI,sBAAA;E1EkpZV;E0EzpZM;IAOI,uBAAA;E1EqpZV;E0E5pZM;IAOI,uBAAA;E1EwpZV;E0E/pZM;IAOI,uBAAA;E1E2pZV;E0ElqZM;IAOI,uBAAA;E1E8pZV;E0ErqZM;IAOI,uBAAA;E1EiqZV;E0ExqZM;IAOI,uBAAA;E1EoqZV;E0E3qZM;IAOI,uBAAA;E1EuqZV;E0E9qZM;IAOI,uBAAA;E1E0qZV;E0EjrZM;IAOI,uBAAA;E1E6qZV;E0EprZM;IAOI,uBAAA;E1EgrZV;E0EvrZM;IAOI,uBAAA;E1EmrZV;E0E1rZM;IAOI,uBAAA;E1EsrZV;E0E7rZM;IAOI,uBAAA;E1EyrZV;E0EhsZM;IAOI,uBAAA;E1E4rZV;E0EnsZM;IAOI,uBAAA;E1E+rZV;E0EtsZM;IAOI,uBAAA;E1EksZV;E0EzsZM;IAOI,uBAAA;E1EqsZV;E0E5sZM;IAOI,uBAAA;E1EwsZV;E0E/sZM;IAOI,uBAAA;E1E2sZV;E0EltZM;IAOI,uBAAA;E1E8sZV;E0ErtZM;IAOI,uBAAA;E1EitZV;E0ExtZM;IAOI,uBAAA;E1EotZV;E0E3tZM;IAOI,uBAAA;E1EutZV;E0E9tZM;IAOI,uBAAA;E1E0tZV;E0EjuZM;IAOI,uBAAA;E1E6tZV;E0EpuZM;IAOI,uBAAA;E1EguZV;E0EvuZM;IAOI,wBAAA;E1EmuZV;E0E1uZM;IAOI,2BAAA;E1EsuZV;E0E7uZM;IAOI,yBAAA;E1EyuZV;E0EhvZM;IAOI,yBAAA;E1E4uZV;E0EnvZM;IAOI,yBAAA;E1E+uZV;E0EtvZM;IAOI,0BAAA;E1EkvZV;E0EzvZM;IAOI,0BAAA;E1EqvZV;E0E5vZM;IAOI,yBAAA;E1EwvZV;E0E/vZM;IAOI,yBAAA;E1E2vZV;E0ElwZM;IAOI,yBAAA;E1E8vZV;E0ErwZM;IAOI,yBAAA;E1EiwZV;E0ExwZM;IAOI,yBAAA;E1EowZV;E0E3wZM;IAOI,yBAAA;E1EuwZV;E0E9wZM;IAOI,yBAAA;E1E0wZV;E0EjxZM;IAOI,yBAAA;E1E6wZV;E0EpxZM;IAOI,yBAAA;E1EgxZV;E0EvxZM;IAOI,0BAAA;E1EmxZV;E0E1xZM;IAOI,0BAAA;E1EsxZV;E0E7xZM;IAOI,0BAAA;E1EyxZV;E0EhyZM;IAOI,0BAAA;E1E4xZV;E0EnyZM;IAOI,0BAAA;E1E+xZV;E0EtyZM;IAOI,0BAAA;E1EkyZV;E0EzyZM;IAOI,0BAAA;E1EqyZV;E0E5yZM;IAOI,0BAAA;E1EwyZV;E0E/yZM;IAOI,0BAAA;E1E2yZV;E0ElzZM;IAOI,0BAAA;E1E8yZV;E0ErzZM;IAOI,0BAAA;E1EizZV;E0ExzZM;IAOI,0BAAA;E1EozZV;E0E3zZM;IAOI,0BAAA;E1EuzZV;E0E9zZM;IAOI,0BAAA;E1E0zZV;E0Ej0ZM;IAOI,0BAAA;E1E6zZV;E0Ep0ZM;IAOI,0BAAA;E1Eg0ZV;E0Ev0ZM;IAOI,0BAAA;E1Em0ZV;E0E10ZM;IAOI,0BAAA;E1Es0ZV;E0E70ZM;IAOI,2BAAA;E1Ey0ZV;E0Eh1ZM;IAOI,2BAAA;E1E40ZV;E0En1ZM;IAOI,2BAAA;E1E+0ZV;E0Et1ZM;IAOI,2BAAA;E1Ek1ZV;E0Ez1ZM;IAOI,2BAAA;E1Eq1ZV;E0E51ZM;IAOI,2BAAA;E1Ew1ZV;E0E/1ZM;IAOI,2BAAA;E1E21ZV;E0El2ZM;IAOI,2BAAA;E1E81ZV;E0Er2ZM;IAOI,2BAAA;E1Ei2ZV;E0Ex2ZM;IAOI,2BAAA;E1Eo2ZV;E0E32ZM;IAOI,2BAAA;E1Eu2ZV;E0E92ZM;IAOI,2BAAA;E1E02ZV;E0Ej3ZM;IAOI,2BAAA;E1E62ZV;E0Ep3ZM;IAOI,2BAAA;E1Eg3ZV;E0Ev3ZM;IAOI,2BAAA;E1Em3ZV;E0E13ZM;IAOI,2BAAA;E1Es3ZV;E0E73ZM;IAOI,2BAAA;E1Ey3ZV;E0Eh4ZM;IAOI,2BAAA;E1E43ZV;E0En4ZM;IAOI,2BAAA;E1E+3ZV;E0Et4ZM;IAOI,2BAAA;E1Ek4ZV;E0Ez4ZM;IAOI,2BAAA;E1Eq4ZV;E0E54ZM;IAOI,2BAAA;E1Ew4ZV;E0E/4ZM;IAOI,2BAAA;E1E24ZV;E0El5ZM;IAOI,2BAAA;E1E84ZV;E0Er5ZM;IAOI,2BAAA;E1Ei5ZV;E0Ex5ZM;IAOI,2BAAA;E1Eo5ZV;E0E35ZM;IAOI,4BAAA;E1Eu5ZV;E0E95ZM;IAOI,wBAAA;E1E05ZV;E0Ej6ZM;IAOI,sBAAA;E1E65ZV;E0Ep6ZM;IAOI,sBAAA;E1Eg6ZV;E0Ev6ZM;IAOI,sBAAA;E1Em6ZV;E0E16ZM;IAOI,uBAAA;E1Es6ZV;E0E76ZM;IAOI,uBAAA;E1Ey6ZV;E0Eh7ZM;IAOI,sBAAA;E1E46ZV;E0En7ZM;IAOI,sBAAA;E1E+6ZV;E0Et7ZM;IAOI,sBAAA;E1Ek7ZV;E0Ez7ZM;IAOI,sBAAA;E1Eq7ZV;E0E57ZM;IAOI,sBAAA;E1Ew7ZV;E0E/7ZM;IAOI,sBAAA;E1E27ZV;E0El8ZM;IAOI,sBAAA;E1E87ZV;E0Er8ZM;IAOI,sBAAA;E1Ei8ZV;E0Ex8ZM;IAOI,sBAAA;E1Eo8ZV;E0E38ZM;IAOI,uBAAA;E1Eu8ZV;E0E98ZM;IAOI,uBAAA;E1E08ZV;E0Ej9ZM;IAOI,uBAAA;E1E68ZV;E0Ep9ZM;IAOI,uBAAA;E1Eg9ZV;E0Ev9ZM;IAOI,uBAAA;E1Em9ZV;E0E19ZM;IAOI,uBAAA;E1Es9ZV;E0E79ZM;IAOI,uBAAA;E1Ey9ZV;E0Eh+ZM;IAOI,uBAAA;E1E49ZV;E0En+ZM;IAOI,uBAAA;E1E+9ZV;E0Et+ZM;IAOI,uBAAA;E1Ek+ZV;E0Ez+ZM;IAOI,uBAAA;E1Eq+ZV;E0E5+ZM;IAOI,uBAAA;E1Ew+ZV;E0E/+ZM;IAOI,uBAAA;E1E2+ZV;E0El/ZM;IAOI,uBAAA;E1E8+ZV;E0Er/ZM;IAOI,uBAAA;E1Ei/ZV;E0Ex/ZM;IAOI,uBAAA;E1Eo/ZV;E0E3/ZM;IAOI,uBAAA;E1Eu/ZV;E0E9/ZM;IAOI,uBAAA;E1E0/ZV;E0EjgaM;IAOI,wBAAA;E1E6/ZV;E0EpgaM;IAOI,wBAAA;E1EggaV;E0EvgaM;IAOI,wBAAA;E1EmgaV;E0E1gaM;IAOI,wBAAA;E1EsgaV;E0E7gaM;IAOI,wBAAA;E1EygaV;E0EhhaM;IAOI,wBAAA;E1E4gaV;E0EnhaM;IAOI,wBAAA;E1E+gaV;E0EthaM;IAOI,wBAAA;E1EkhaV;E0EzhaM;IAOI,wBAAA;E1EqhaV;E0E5haM;IAOI,wBAAA;E1EwhaV;E0E/haM;IAOI,wBAAA;E1E2haV;E0EliaM;IAOI,wBAAA;E1E8haV;E0EriaM;IAOI,wBAAA;E1EiiaV;E0ExiaM;IAOI,wBAAA;E1EoiaV;E0E3iaM;IAOI,wBAAA;E1EuiaV;E0E9iaM;IAOI,wBAAA;E1E0iaV;E0EjjaM;IAOI,wBAAA;E1E6iaV;E0EpjaM;IAOI,wBAAA;E1EgjaV;E0EvjaM;IAOI,wBAAA;E1EmjaV;E0E1jaM;IAOI,wBAAA;E1EsjaV;E0E7jaM;IAOI,wBAAA;E1EyjaV;E0EhkaM;IAOI,wBAAA;E1E4jaV;E0EnkaM;IAOI,wBAAA;E1E+jaV;E0EtkaM;IAOI,wBAAA;E1EkkaV;E0EzkaM;IAOI,wBAAA;E1EqkaV;E0E5kaM;IAOI,wBAAA;E1EwkaV;E0E/kaM;IAOI,yBAAA;E1E2kaV;E0EllaM;IAOI,4BAAA;E1E8kaV;E0ErlaM;IAOI,0BAAA;E1EilaV;E0ExlaM;IAOI,0BAAA;E1EolaV;E0E3laM;IAOI,0BAAA;E1EulaV;E0E9laM;IAOI,2BAAA;E1E0laV;E0EjmaM;IAOI,2BAAA;E1E6laV;E0EpmaM;IAOI,0BAAA;E1EgmaV;E0EvmaM;IAOI,0BAAA;E1EmmaV;E0E1maM;IAOI,0BAAA;E1EsmaV;E0E7maM;IAOI,0BAAA;E1EymaV;E0EhnaM;IAOI,0BAAA;E1E4maV;E0EnnaM;IAOI,0BAAA;E1E+maV;E0EtnaM;IAOI,0BAAA;E1EknaV;E0EznaM;IAOI,0BAAA;E1EqnaV;E0E5naM;IAOI,0BAAA;E1EwnaV;E0E/naM;IAOI,2BAAA;E1E2naV;E0EloaM;IAOI,2BAAA;E1E8naV;E0EroaM;IAOI,2BAAA;E1EioaV;E0ExoaM;IAOI,2BAAA;E1EooaV;E0E3oaM;IAOI,2BAAA;E1EuoaV;E0E9oaM;IAOI,2BAAA;E1E0oaV;E0EjpaM;IAOI,2BAAA;E1E6oaV;E0EppaM;IAOI,2BAAA;E1EgpaV;E0EvpaM;IAOI,2BAAA;E1EmpaV;E0E1paM;IAOI,2BAAA;E1EspaV;E0E7paM;IAOI,2BAAA;E1EypaV;E0EhqaM;IAOI,2BAAA;E1E4paV;E0EnqaM;IAOI,2BAAA;E1E+paV;E0EtqaM;IAOI,2BAAA;E1EkqaV;E0EzqaM;IAOI,2BAAA;E1EqqaV;E0E5qaM;IAOI,2BAAA;E1EwqaV;E0E/qaM;IAOI,2BAAA;E1E2qaV;E0ElraM;IAOI,2BAAA;E1E8qaV;E0ErraM;IAOI,4BAAA;E1EiraV;E0ExraM;IAOI,4BAAA;E1EoraV;E0E3raM;IAOI,4BAAA;E1EuraV;E0E9raM;IAOI,4BAAA;E1E0raV;E0EjsaM;IAOI,4BAAA;E1E6raV;E0EpsaM;IAOI,4BAAA;E1EgsaV;E0EvsaM;IAOI,4BAAA;E1EmsaV;E0E1saM;IAOI,4BAAA;E1EssaV;E0E7saM;IAOI,4BAAA;E1EysaV;E0EhtaM;IAOI,4BAAA;E1E4saV;E0EntaM;IAOI,4BAAA;E1E+saV;E0EttaM;IAOI,4BAAA;E1EktaV;E0EztaM;IAOI,4BAAA;E1EqtaV;E0E5taM;IAOI,4BAAA;E1EwtaV;E0E/taM;IAOI,4BAAA;E1E2taV;E0EluaM;IAOI,4BAAA;E1E8taV;E0EruaM;IAOI,4BAAA;E1EiuaV;E0ExuaM;IAOI,4BAAA;E1EouaV;E0E3uaM;IAOI,4BAAA;E1EuuaV;E0E9uaM;IAOI,4BAAA;E1E0uaV;E0EjvaM;IAOI,4BAAA;E1E6uaV;E0EpvaM;IAOI,4BAAA;E1EgvaV;E0EvvaM;IAOI,4BAAA;E1EmvaV;E0E1vaM;IAOI,4BAAA;E1EsvaV;E0E7vaM;IAOI,4BAAA;E1EyvaV;E0EhwaM;IAOI,4BAAA;E1E4vaV;E0EnwaM;IAOI,6BAAA;E1E+vaV;E0EtwaM;IAOI,yBAAA;E1EkwaV;E0EzwaM;IAOI,8BAAA;E1EqwaV;E0E5waM;IAOI,iCAAA;E1EwwaV;E0E/waM;IAOI,sCAAA;E1E2waV;E0ElxaM;IAOI,yCAAA;E1E8waV;E0ErxaM;IAOI,uBAAA;E1EixaV;E0ExxaM;IAOI,uBAAA;E1EoxaV;E0E3xaM;IAOI,yBAAA;E1EuxaV;E0E9xaM;IAOI,yBAAA;E1E0xaV;E0EjyaM;IAOI,0BAAA;E1E6xaV;E0EpyaM;IAOI,4BAAA;E1EgyaV;E0EvyaM;IAOI,kCAAA;E1EmyaV;E0E1yaM;IAOI,sCAAA;E1EsyaV;E0E7yaM;IAOI,oCAAA;E1EyyaV;E0EhzaM;IAOI,kCAAA;E1E4yaV;E0EnzaM;IAOI,yCAAA;E1E+yaV;E0EtzaM;IAOI,wCAAA;E1EkzaV;E0EzzaM;IAOI,wCAAA;E1EqzaV;E0E5zaM;IAOI,kCAAA;E1EwzaV;E0E/zaM;IAOI,gCAAA;E1E2zaV;E0El0aM;IAOI,8BAAA;E1E8zaV;E0Er0aM;IAOI,gCAAA;E1Ei0aV;E0Ex0aM;IAOI,+BAAA;E1Eo0aV;E0E30aM;IAOI,oCAAA;E1Eu0aV;E0E90aM;IAOI,kCAAA;E1E00aV;E0Ej1aM;IAOI,gCAAA;E1E60aV;E0Ep1aM;IAOI,uCAAA;E1Eg1aV;E0Ev1aM;IAOI,sCAAA;E1Em1aV;E0E11aM;IAOI,iCAAA;E1Es1aV;E0E71aM;IAOI,2BAAA;E1Ey1aV;E0Eh2aM;IAOI,iCAAA;E1E41aV;E0En2aM;IAOI,+BAAA;E1E+1aV;E0Et2aM;IAOI,6BAAA;E1Ek2aV;E0Ez2aM;IAOI,+BAAA;E1Eq2aV;E0E52aM;IAOI,8BAAA;E1Ew2aV;E0E/2aM;IAOI,oBAAA;E1E22aV;E0El3aM;IAOI,mBAAA;E1E82aV;E0Er3aM;IAOI,mBAAA;E1Ei3aV;E0Ex3aM;IAOI,mBAAA;E1Eo3aV;E0E33aM;IAOI,mBAAA;E1Eu3aV;E0E93aM;IAOI,mBAAA;E1E03aV;E0Ej4aM;IAOI,mBAAA;E1E63aV;E0Ep4aM;IAOI,mBAAA;E1Eg4aV;E0Ev4aM;IAOI,oBAAA;E1Em4aV;E0E14aM;IAOI,0BAAA;E1Es4aV;E0E74aM;IAOI,yBAAA;E1Ey4aV;E0Eh5aM;IAOI,0BAAA;E1E44aV;E0En5aM;IAOI,uBAAA;E1E+4aV;E0Et5aM;IAOI,0BAAA;E1Ek5aV;E0Ez5aM;IAOI,yBAAA;E1Eq5aV;E0E55aM;IAOI,0BAAA;E1Ew5aV;E0E/5aM;IAOI,uBAAA;E1E25aV;E0El6aM;IAOI,0BAAA;E1E85aV;E0Er6aM;IAOI,yBAAA;E1Ei6aV;E0Ex6aM;IAOI,0BAAA;E1Eo6aV;E0E36aM;IAOI,uBAAA;E1Eu6aV;E0E96aM;IAOI,0BAAA;E1E06aV;E0Ej7aM;IAOI,yBAAA;E1E66aV;E0Ep7aM;IAOI,0BAAA;E1Eg7aV;E0Ev7aM;IAOI,uBAAA;E1Em7aV;E0E17aM;IAOI,0BAAA;E1Es7aV;E0E77aM;IAOI,yBAAA;E1Ey7aV;E0Eh8aM;IAOI,0BAAA;E1E47aV;E0En8aM;IAOI,uBAAA;E1E+7aV;E0Et8aM;IAOI,uBAAA;E1Ek8aV;E0Ez8aM;IAOI,0BAAA;IAAA,yBAAA;E1Es8aV;E0E78aM;IAOI,gCAAA;IAAA,+BAAA;E1E08aV;E0Ej9aM;IAOI,+BAAA;IAAA,8BAAA;E1E88aV;E0Er9aM;IAOI,gCAAA;IAAA,+BAAA;E1Ek9aV;E0Ez9aM;IAOI,6BAAA;IAAA,4BAAA;E1Es9aV;E0E79aM;IAOI,gCAAA;IAAA,+BAAA;E1E09aV;E0Ej+aM;IAOI,+BAAA;IAAA,8BAAA;E1E89aV;E0Er+aM;IAOI,gCAAA;IAAA,+BAAA;E1Ek+aV;E0Ez+aM;IAOI,6BAAA;IAAA,4BAAA;E1Es+aV;E0E7+aM;IAOI,gCAAA;IAAA,+BAAA;E1E0+aV;E0Ej/aM;IAOI,+BAAA;IAAA,8BAAA;E1E8+aV;E0Er/aM;IAOI,gCAAA;IAAA,+BAAA;E1Ek/aV;E0Ez/aM;IAOI,6BAAA;IAAA,4BAAA;E1Es/aV;E0E7/aM;IAOI,gCAAA;IAAA,+BAAA;E1E0/aV;E0EjgbM;IAOI,+BAAA;IAAA,8BAAA;E1E8/aV;E0ErgbM;IAOI,gCAAA;IAAA,+BAAA;E1EkgbV;E0EzgbM;IAOI,6BAAA;IAAA,4BAAA;E1EsgbV;E0E7gbM;IAOI,gCAAA;IAAA,+BAAA;E1E0gbV;E0EjhbM;IAOI,+BAAA;IAAA,8BAAA;E1E8gbV;E0ErhbM;IAOI,gCAAA;IAAA,+BAAA;E1EkhbV;E0EzhbM;IAOI,6BAAA;IAAA,4BAAA;E1EshbV;E0E7hbM;IAOI,6BAAA;IAAA,4BAAA;E1E0hbV;E0EjibM;IAOI,wBAAA;IAAA,2BAAA;E1E8hbV;E0EribM;IAOI,8BAAA;IAAA,iCAAA;E1EkibV;E0EzibM;IAOI,6BAAA;IAAA,gCAAA;E1EsibV;E0E7ibM;IAOI,8BAAA;IAAA,iCAAA;E1E0ibV;E0EjjbM;IAOI,2BAAA;IAAA,8BAAA;E1E8ibV;E0ErjbM;IAOI,8BAAA;IAAA,iCAAA;E1EkjbV;E0EzjbM;IAOI,6BAAA;IAAA,gCAAA;E1EsjbV;E0E7jbM;IAOI,8BAAA;IAAA,iCAAA;E1E0jbV;E0EjkbM;IAOI,2BAAA;IAAA,8BAAA;E1E8jbV;E0ErkbM;IAOI,8BAAA;IAAA,iCAAA;E1EkkbV;E0EzkbM;IAOI,6BAAA;IAAA,gCAAA;E1EskbV;E0E7kbM;IAOI,8BAAA;IAAA,iCAAA;E1E0kbV;E0EjlbM;IAOI,2BAAA;IAAA,8BAAA;E1E8kbV;E0ErlbM;IAOI,8BAAA;IAAA,iCAAA;E1EklbV;E0EzlbM;IAOI,6BAAA;IAAA,gCAAA;E1EslbV;E0E7lbM;IAOI,8BAAA;IAAA,iCAAA;E1E0lbV;E0EjmbM;IAOI,2BAAA;IAAA,8BAAA;E1E8lbV;E0ErmbM;IAOI,8BAAA;IAAA,iCAAA;E1EkmbV;E0EzmbM;IAOI,6BAAA;IAAA,gCAAA;E1EsmbV;E0E7mbM;IAOI,8BAAA;IAAA,iCAAA;E1E0mbV;E0EjnbM;IAOI,2BAAA;IAAA,8BAAA;E1E8mbV;E0ErnbM;IAOI,2BAAA;IAAA,8BAAA;E1EknbV;E0EznbM;IAOI,wBAAA;E1EqnbV;E0E5nbM;IAOI,8BAAA;E1EwnbV;E0E/nbM;IAOI,6BAAA;E1E2nbV;E0ElobM;IAOI,8BAAA;E1E8nbV;E0ErobM;IAOI,2BAAA;E1EiobV;E0ExobM;IAOI,8BAAA;E1EoobV;E0E3obM;IAOI,6BAAA;E1EuobV;E0E9obM;IAOI,8BAAA;E1E0obV;E0EjpbM;IAOI,2BAAA;E1E6obV;E0EppbM;IAOI,8BAAA;E1EgpbV;E0EvpbM;IAOI,6BAAA;E1EmpbV;E0E1pbM;IAOI,8BAAA;E1EspbV;E0E7pbM;IAOI,2BAAA;E1EypbV;E0EhqbM;IAOI,8BAAA;E1E4pbV;E0EnqbM;IAOI,6BAAA;E1E+pbV;E0EtqbM;IAOI,8BAAA;E1EkqbV;E0EzqbM;IAOI,2BAAA;E1EqqbV;E0E5qbM;IAOI,8BAAA;E1EwqbV;E0E/qbM;IAOI,6BAAA;E1E2qbV;E0ElrbM;IAOI,8BAAA;E1E8qbV;E0ErrbM;IAOI,2BAAA;E1EirbV;E0ExrbM;IAOI,2BAAA;E1EorbV;E0E3rbM;IAOI,0BAAA;E1EurbV;E0E9rbM;IAOI,gCAAA;E1E0rbV;E0EjsbM;IAOI,+BAAA;E1E6rbV;E0EpsbM;IAOI,gCAAA;E1EgsbV;E0EvsbM;IAOI,6BAAA;E1EmsbV;E0E1sbM;IAOI,gCAAA;E1EssbV;E0E7sbM;IAOI,+BAAA;E1EysbV;E0EhtbM;IAOI,gCAAA;E1E4sbV;E0EntbM;IAOI,6BAAA;E1E+sbV;E0EttbM;IAOI,gCAAA;E1EktbV;E0EztbM;IAOI,+BAAA;E1EqtbV;E0E5tbM;IAOI,gCAAA;E1EwtbV;E0E/tbM;IAOI,6BAAA;E1E2tbV;E0ElubM;IAOI,gCAAA;E1E8tbV;E0ErubM;IAOI,+BAAA;E1EiubV;E0ExubM;IAOI,gCAAA;E1EoubV;E0E3ubM;IAOI,6BAAA;E1EuubV;E0E9ubM;IAOI,gCAAA;E1E0ubV;E0EjvbM;IAOI,+BAAA;E1E6ubV;E0EpvbM;IAOI,gCAAA;E1EgvbV;E0EvvbM;IAOI,6BAAA;E1EmvbV;E0E1vbM;IAOI,6BAAA;E1EsvbV;E0E7vbM;IAOI,2BAAA;E1EyvbV;E0EhwbM;IAOI,iCAAA;E1E4vbV;E0EnwbM;IAOI,gCAAA;E1E+vbV;E0EtwbM;IAOI,iCAAA;E1EkwbV;E0EzwbM;IAOI,8BAAA;E1EqwbV;E0E5wbM;IAOI,iCAAA;E1EwwbV;E0E/wbM;IAOI,gCAAA;E1E2wbV;E0ElxbM;IAOI,iCAAA;E1E8wbV;E0ErxbM;IAOI,8BAAA;E1EixbV;E0ExxbM;IAOI,iCAAA;E1EoxbV;E0E3xbM;IAOI,gCAAA;E1EuxbV;E0E9xbM;IAOI,iCAAA;E1E0xbV;E0EjybM;IAOI,8BAAA;E1E6xbV;E0EpybM;IAOI,iCAAA;E1EgybV;E0EvybM;IAOI,gCAAA;E1EmybV;E0E1ybM;IAOI,iCAAA;E1EsybV;E0E7ybM;IAOI,8BAAA;E1EyybV;E0EhzbM;IAOI,iCAAA;E1E4ybV;E0EnzbM;IAOI,gCAAA;E1E+ybV;E0EtzbM;IAOI,iCAAA;E1EkzbV;E0EzzbM;IAOI,8BAAA;E1EqzbV;E0E5zbM;IAOI,8BAAA;E1EwzbV;E0E/zbM;IAOI,yBAAA;E1E2zbV;E0El0bM;IAOI,+BAAA;E1E8zbV;E0Er0bM;IAOI,8BAAA;E1Ei0bV;E0Ex0bM;IAOI,+BAAA;E1Eo0bV;E0E30bM;IAOI,4BAAA;E1Eu0bV;E0E90bM;IAOI,+BAAA;E1E00bV;E0Ej1bM;IAOI,8BAAA;E1E60bV;E0Ep1bM;IAOI,+BAAA;E1Eg1bV;E0Ev1bM;IAOI,4BAAA;E1Em1bV;E0E11bM;IAOI,+BAAA;E1Es1bV;E0E71bM;IAOI,8BAAA;E1Ey1bV;E0Eh2bM;IAOI,+BAAA;E1E41bV;E0En2bM;IAOI,4BAAA;E1E+1bV;E0Et2bM;IAOI,+BAAA;E1Ek2bV;E0Ez2bM;IAOI,8BAAA;E1Eq2bV;E0E52bM;IAOI,+BAAA;E1Ew2bV;E0E/2bM;IAOI,4BAAA;E1E22bV;E0El3bM;IAOI,+BAAA;E1E82bV;E0Er3bM;IAOI,8BAAA;E1Ei3bV;E0Ex3bM;IAOI,+BAAA;E1Eo3bV;E0E33bM;IAOI,4BAAA;E1Eu3bV;E0E93bM;IAOI,4BAAA;E1E03bV;E0Ej4bM;IAOI,2BAAA;E1E63bV;E0Ep4bM;IAOI,0BAAA;E1Eg4bV;E0Ev4bM;IAOI,2BAAA;E1Em4bV;E0E14bM;IAOI,wBAAA;E1Es4bV;E0E74bM;IAOI,2BAAA;E1Ey4bV;E0Eh5bM;IAOI,0BAAA;E1E44bV;E0En5bM;IAOI,2BAAA;E1E+4bV;E0Et5bM;IAOI,wBAAA;E1Ek5bV;E0Ez5bM;IAOI,2BAAA;E1Eq5bV;E0E55bM;IAOI,0BAAA;E1Ew5bV;E0E/5bM;IAOI,2BAAA;E1E25bV;E0El6bM;IAOI,wBAAA;E1E85bV;E0Er6bM;IAOI,2BAAA;E1Ei6bV;E0Ex6bM;IAOI,0BAAA;E1Eo6bV;E0E36bM;IAOI,2BAAA;E1Eu6bV;E0E96bM;IAOI,wBAAA;E1E06bV;E0Ej7bM;IAOI,2BAAA;E1E66bV;E0Ep7bM;IAOI,0BAAA;E1Eg7bV;E0Ev7bM;IAOI,2BAAA;E1Em7bV;E0E17bM;IAOI,wBAAA;E1Es7bV;E0E77bM;IAOI,iCAAA;IAAA,gCAAA;E1E07bV;E0Ej8bM;IAOI,gCAAA;IAAA,+BAAA;E1E87bV;E0Er8bM;IAOI,iCAAA;IAAA,gCAAA;E1Ek8bV;E0Ez8bM;IAOI,8BAAA;IAAA,6BAAA;E1Es8bV;E0E78bM;IAOI,iCAAA;IAAA,gCAAA;E1E08bV;E0Ej9bM;IAOI,gCAAA;IAAA,+BAAA;E1E88bV;E0Er9bM;IAOI,iCAAA;IAAA,gCAAA;E1Ek9bV;E0Ez9bM;IAOI,8BAAA;IAAA,6BAAA;E1Es9bV;E0E79bM;IAOI,iCAAA;IAAA,gCAAA;E1E09bV;E0Ej+bM;IAOI,gCAAA;IAAA,+BAAA;E1E89bV;E0Er+bM;IAOI,iCAAA;IAAA,gCAAA;E1Ek+bV;E0Ez+bM;IAOI,8BAAA;IAAA,6BAAA;E1Es+bV;E0E7+bM;IAOI,iCAAA;IAAA,gCAAA;E1E0+bV;E0Ej/bM;IAOI,gCAAA;IAAA,+BAAA;E1E8+bV;E0Er/bM;IAOI,iCAAA;IAAA,gCAAA;E1Ek/bV;E0Ez/bM;IAOI,8BAAA;IAAA,6BAAA;E1Es/bV;E0E7/bM;IAOI,iCAAA;IAAA,gCAAA;E1E0/bV;E0EjgcM;IAOI,gCAAA;IAAA,+BAAA;E1E8/bV;E0ErgcM;IAOI,iCAAA;IAAA,gCAAA;E1EkgcV;E0EzgcM;IAOI,8BAAA;IAAA,6BAAA;E1EsgcV;E0E7gcM;IAOI,+BAAA;IAAA,kCAAA;E1E0gcV;E0EjhcM;IAOI,8BAAA;IAAA,iCAAA;E1E8gcV;E0ErhcM;IAOI,+BAAA;IAAA,kCAAA;E1EkhcV;E0EzhcM;IAOI,4BAAA;IAAA,+BAAA;E1EshcV;E0E7hcM;IAOI,+BAAA;IAAA,kCAAA;E1E0hcV;E0EjicM;IAOI,8BAAA;IAAA,iCAAA;E1E8hcV;E0EricM;IAOI,+BAAA;IAAA,kCAAA;E1EkicV;E0EzicM;IAOI,4BAAA;IAAA,+BAAA;E1EsicV;E0E7icM;IAOI,+BAAA;IAAA,kCAAA;E1E0icV;E0EjjcM;IAOI,8BAAA;IAAA,iCAAA;E1E8icV;E0ErjcM;IAOI,+BAAA;IAAA,kCAAA;E1EkjcV;E0EzjcM;IAOI,4BAAA;IAAA,+BAAA;E1EsjcV;E0E7jcM;IAOI,+BAAA;IAAA,kCAAA;E1E0jcV;E0EjkcM;IAOI,8BAAA;IAAA,iCAAA;E1E8jcV;E0ErkcM;IAOI,+BAAA;IAAA,kCAAA;E1EkkcV;E0EzkcM;IAOI,4BAAA;IAAA,+BAAA;E1EskcV;E0E7kcM;IAOI,+BAAA;IAAA,kCAAA;E1E0kcV;E0EjlcM;IAOI,8BAAA;IAAA,iCAAA;E1E8kcV;E0ErlcM;IAOI,+BAAA;IAAA,kCAAA;E1EklcV;E0EzlcM;IAOI,4BAAA;IAAA,+BAAA;E1EslcV;E0E7lcM;IAOI,+BAAA;E1EylcV;E0EhmcM;IAOI,8BAAA;E1E4lcV;E0EnmcM;IAOI,+BAAA;E1E+lcV;E0EtmcM;IAOI,4BAAA;E1EkmcV;E0EzmcM;IAOI,+BAAA;E1EqmcV;E0E5mcM;IAOI,8BAAA;E1EwmcV;E0E/mcM;IAOI,+BAAA;E1E2mcV;E0ElncM;IAOI,4BAAA;E1E8mcV;E0ErncM;IAOI,+BAAA;E1EincV;E0ExncM;IAOI,8BAAA;E1EoncV;E0E3ncM;IAOI,+BAAA;E1EuncV;E0E9ncM;IAOI,4BAAA;E1E0ncV;E0EjocM;IAOI,+BAAA;E1E6ncV;E0EpocM;IAOI,8BAAA;E1EgocV;E0EvocM;IAOI,+BAAA;E1EmocV;E0E1ocM;IAOI,4BAAA;E1EsocV;E0E7ocM;IAOI,+BAAA;E1EyocV;E0EhpcM;IAOI,8BAAA;E1E4ocV;E0EnpcM;IAOI,+BAAA;E1E+ocV;E0EtpcM;IAOI,4BAAA;E1EkpcV;E0EzpcM;IAOI,iCAAA;E1EqpcV;E0E5pcM;IAOI,gCAAA;E1EwpcV;E0E/pcM;IAOI,iCAAA;E1E2pcV;E0ElqcM;IAOI,8BAAA;E1E8pcV;E0ErqcM;IAOI,iCAAA;E1EiqcV;E0ExqcM;IAOI,gCAAA;E1EoqcV;E0E3qcM;IAOI,iCAAA;E1EuqcV;E0E9qcM;IAOI,8BAAA;E1E0qcV;E0EjrcM;IAOI,iCAAA;E1E6qcV;E0EprcM;IAOI,gCAAA;E1EgrcV;E0EvrcM;IAOI,iCAAA;E1EmrcV;E0E1rcM;IAOI,8BAAA;E1EsrcV;E0E7rcM;IAOI,iCAAA;E1EyrcV;E0EhscM;IAOI,gCAAA;E1E4rcV;E0EnscM;IAOI,iCAAA;E1E+rcV;E0EtscM;IAOI,8BAAA;E1EkscV;E0EzscM;IAOI,iCAAA;E1EqscV;E0E5scM;IAOI,gCAAA;E1EwscV;E0E/scM;IAOI,iCAAA;E1E2scV;E0EltcM;IAOI,8BAAA;E1E8scV;E0ErtcM;IAOI,kCAAA;E1EitcV;E0ExtcM;IAOI,iCAAA;E1EotcV;E0E3tcM;IAOI,kCAAA;E1EutcV;E0E9tcM;IAOI,+BAAA;E1E0tcV;E0EjucM;IAOI,kCAAA;E1E6tcV;E0EpucM;IAOI,iCAAA;E1EgucV;E0EvucM;IAOI,kCAAA;E1EmucV;E0E1ucM;IAOI,+BAAA;E1EsucV;E0E7ucM;IAOI,kCAAA;E1EyucV;E0EhvcM;IAOI,iCAAA;E1E4ucV;E0EnvcM;IAOI,kCAAA;E1E+ucV;E0EtvcM;IAOI,+BAAA;E1EkvcV;E0EzvcM;IAOI,kCAAA;E1EqvcV;E0E5vcM;IAOI,iCAAA;E1EwvcV;E0E/vcM;IAOI,kCAAA;E1E2vcV;E0ElwcM;IAOI,+BAAA;E1E8vcV;E0ErwcM;IAOI,kCAAA;E1EiwcV;E0ExwcM;IAOI,iCAAA;E1EowcV;E0E3wcM;IAOI,kCAAA;E1EuwcV;E0E9wcM;IAOI,+BAAA;E1E0wcV;E0EjxcM;IAOI,gCAAA;E1E6wcV;E0EpxcM;IAOI,+BAAA;E1EgxcV;E0EvxcM;IAOI,gCAAA;E1EmxcV;E0E1xcM;IAOI,6BAAA;E1EsxcV;E0E7xcM;IAOI,gCAAA;E1EyxcV;E0EhycM;IAOI,+BAAA;E1E4xcV;E0EnycM;IAOI,gCAAA;E1E+xcV;E0EtycM;IAOI,6BAAA;E1EkycV;E0EzycM;IAOI,gCAAA;E1EqycV;E0E5ycM;IAOI,+BAAA;E1EwycV;E0E/ycM;IAOI,gCAAA;E1E2ycV;E0ElzcM;IAOI,6BAAA;E1E8ycV;E0ErzcM;IAOI,gCAAA;E1EizcV;E0ExzcM;IAOI,+BAAA;E1EozcV;E0E3zcM;IAOI,gCAAA;E1EuzcV;E0E9zcM;IAOI,6BAAA;E1E0zcV;E0Ej0cM;IAOI,gCAAA;E1E6zcV;E0Ep0cM;IAOI,+BAAA;E1Eg0cV;E0Ev0cM;IAOI,gCAAA;E1Em0cV;E0E10cM;IAOI,6BAAA;E1Es0cV;E0E70cM;IAOI,qBAAA;E1Ey0cV;E0Eh1cM;IAOI,2BAAA;E1E40cV;E0En1cM;IAOI,0BAAA;E1E+0cV;E0Et1cM;IAOI,2BAAA;E1Ek1cV;E0Ez1cM;IAOI,wBAAA;E1Eq1cV;E0E51cM;IAOI,2BAAA;E1Ew1cV;E0E/1cM;IAOI,0BAAA;E1E21cV;E0El2cM;IAOI,2BAAA;E1E81cV;E0Er2cM;IAOI,wBAAA;E1Ei2cV;E0Ex2cM;IAOI,2BAAA;E1Eo2cV;E0E32cM;IAOI,0BAAA;E1Eu2cV;E0E92cM;IAOI,2BAAA;E1E02cV;E0Ej3cM;IAOI,wBAAA;E1E62cV;E0Ep3cM;IAOI,2BAAA;E1Eg3cV;E0Ev3cM;IAOI,0BAAA;E1Em3cV;E0E13cM;IAOI,2BAAA;E1Es3cV;E0E73cM;IAOI,wBAAA;E1Ey3cV;E0Eh4cM;IAOI,2BAAA;E1E43cV;E0En4cM;IAOI,0BAAA;E1E+3cV;E0Et4cM;IAOI,2BAAA;E1Ek4cV;E0Ez4cM;IAOI,wBAAA;E1Eq4cV;E0E54cM;IAOI,2BAAA;IAAA,0BAAA;E1Ey4cV;E0Eh5cM;IAOI,iCAAA;IAAA,gCAAA;E1E64cV;E0Ep5cM;IAOI,gCAAA;IAAA,+BAAA;E1Ei5cV;E0Ex5cM;IAOI,iCAAA;IAAA,gCAAA;E1Eq5cV;E0E55cM;IAOI,8BAAA;IAAA,6BAAA;E1Ey5cV;E0Eh6cM;IAOI,iCAAA;IAAA,gCAAA;E1E65cV;E0Ep6cM;IAOI,gCAAA;IAAA,+BAAA;E1Ei6cV;E0Ex6cM;IAOI,iCAAA;IAAA,gCAAA;E1Eq6cV;E0E56cM;IAOI,8BAAA;IAAA,6BAAA;E1Ey6cV;E0Eh7cM;IAOI,iCAAA;IAAA,gCAAA;E1E66cV;E0Ep7cM;IAOI,gCAAA;IAAA,+BAAA;E1Ei7cV;E0Ex7cM;IAOI,iCAAA;IAAA,gCAAA;E1Eq7cV;E0E57cM;IAOI,8BAAA;IAAA,6BAAA;E1Ey7cV;E0Eh8cM;IAOI,iCAAA;IAAA,gCAAA;E1E67cV;E0Ep8cM;IAOI,gCAAA;IAAA,+BAAA;E1Ei8cV;E0Ex8cM;IAOI,iCAAA;IAAA,gCAAA;E1Eq8cV;E0E58cM;IAOI,8BAAA;IAAA,6BAAA;E1Ey8cV;E0Eh9cM;IAOI,iCAAA;IAAA,gCAAA;E1E68cV;E0Ep9cM;IAOI,gCAAA;IAAA,+BAAA;E1Ei9cV;E0Ex9cM;IAOI,iCAAA;IAAA,gCAAA;E1Eq9cV;E0E59cM;IAOI,8BAAA;IAAA,6BAAA;E1Ey9cV;E0Eh+cM;IAOI,yBAAA;IAAA,4BAAA;E1E69cV;E0Ep+cM;IAOI,+BAAA;IAAA,kCAAA;E1Ei+cV;E0Ex+cM;IAOI,8BAAA;IAAA,iCAAA;E1Eq+cV;E0E5+cM;IAOI,+BAAA;IAAA,kCAAA;E1Ey+cV;E0Eh/cM;IAOI,4BAAA;IAAA,+BAAA;E1E6+cV;E0Ep/cM;IAOI,+BAAA;IAAA,kCAAA;E1Ei/cV;E0Ex/cM;IAOI,8BAAA;IAAA,iCAAA;E1Eq/cV;E0E5/cM;IAOI,+BAAA;IAAA,kCAAA;E1Ey/cV;E0EhgdM;IAOI,4BAAA;IAAA,+BAAA;E1E6/cV;E0EpgdM;IAOI,+BAAA;IAAA,kCAAA;E1EigdV;E0ExgdM;IAOI,8BAAA;IAAA,iCAAA;E1EqgdV;E0E5gdM;IAOI,+BAAA;IAAA,kCAAA;E1EygdV;E0EhhdM;IAOI,4BAAA;IAAA,+BAAA;E1E6gdV;E0EphdM;IAOI,+BAAA;IAAA,kCAAA;E1EihdV;E0ExhdM;IAOI,8BAAA;IAAA,iCAAA;E1EqhdV;E0E5hdM;IAOI,+BAAA;IAAA,kCAAA;E1EyhdV;E0EhidM;IAOI,4BAAA;IAAA,+BAAA;E1E6hdV;E0EpidM;IAOI,+BAAA;IAAA,kCAAA;E1EiidV;E0ExidM;IAOI,8BAAA;IAAA,iCAAA;E1EqidV;E0E5idM;IAOI,+BAAA;IAAA,kCAAA;E1EyidV;E0EhjdM;IAOI,4BAAA;IAAA,+BAAA;E1E6idV;E0EpjdM;IAOI,yBAAA;E1EgjdV;E0EvjdM;IAOI,+BAAA;E1EmjdV;E0E1jdM;IAOI,8BAAA;E1EsjdV;E0E7jdM;IAOI,+BAAA;E1EyjdV;E0EhkdM;IAOI,4BAAA;E1E4jdV;E0EnkdM;IAOI,+BAAA;E1E+jdV;E0EtkdM;IAOI,8BAAA;E1EkkdV;E0EzkdM;IAOI,+BAAA;E1EqkdV;E0E5kdM;IAOI,4BAAA;E1EwkdV;E0E/kdM;IAOI,+BAAA;E1E2kdV;E0ElldM;IAOI,8BAAA;E1E8kdV;E0ErldM;IAOI,+BAAA;E1EildV;E0ExldM;IAOI,4BAAA;E1EoldV;E0E3ldM;IAOI,+BAAA;E1EuldV;E0E9ldM;IAOI,8BAAA;E1E0ldV;E0EjmdM;IAOI,+BAAA;E1E6ldV;E0EpmdM;IAOI,4BAAA;E1EgmdV;E0EvmdM;IAOI,+BAAA;E1EmmdV;E0E1mdM;IAOI,8BAAA;E1EsmdV;E0E7mdM;IAOI,+BAAA;E1EymdV;E0EhndM;IAOI,4BAAA;E1E4mdV;E0EnndM;IAOI,2BAAA;E1E+mdV;E0EtndM;IAOI,iCAAA;E1EkndV;E0EzndM;IAOI,gCAAA;E1EqndV;E0E5ndM;IAOI,iCAAA;E1EwndV;E0E/ndM;IAOI,8BAAA;E1E2ndV;E0ElodM;IAOI,iCAAA;E1E8ndV;E0ErodM;IAOI,gCAAA;E1EiodV;E0ExodM;IAOI,iCAAA;E1EoodV;E0E3odM;IAOI,8BAAA;E1EuodV;E0E9odM;IAOI,iCAAA;E1E0odV;E0EjpdM;IAOI,gCAAA;E1E6odV;E0EppdM;IAOI,iCAAA;E1EgpdV;E0EvpdM;IAOI,8BAAA;E1EmpdV;E0E1pdM;IAOI,iCAAA;E1EspdV;E0E7pdM;IAOI,gCAAA;E1EypdV;E0EhqdM;IAOI,iCAAA;E1E4pdV;E0EnqdM;IAOI,8BAAA;E1E+pdV;E0EtqdM;IAOI,iCAAA;E1EkqdV;E0EzqdM;IAOI,gCAAA;E1EqqdV;E0E5qdM;IAOI,iCAAA;E1EwqdV;E0E/qdM;IAOI,8BAAA;E1E2qdV;E0ElrdM;IAOI,4BAAA;E1E8qdV;E0ErrdM;IAOI,kCAAA;E1EirdV;E0ExrdM;IAOI,iCAAA;E1EordV;E0E3rdM;IAOI,kCAAA;E1EurdV;E0E9rdM;IAOI,+BAAA;E1E0rdV;E0EjsdM;IAOI,kCAAA;E1E6rdV;E0EpsdM;IAOI,iCAAA;E1EgsdV;E0EvsdM;IAOI,kCAAA;E1EmsdV;E0E1sdM;IAOI,+BAAA;E1EssdV;E0E7sdM;IAOI,kCAAA;E1EysdV;E0EhtdM;IAOI,iCAAA;E1E4sdV;E0EntdM;IAOI,kCAAA;E1E+sdV;E0EttdM;IAOI,+BAAA;E1EktdV;E0EztdM;IAOI,kCAAA;E1EqtdV;E0E5tdM;IAOI,iCAAA;E1EwtdV;E0E/tdM;IAOI,kCAAA;E1E2tdV;E0EludM;IAOI,+BAAA;E1E8tdV;E0ErudM;IAOI,kCAAA;E1EiudV;E0ExudM;IAOI,iCAAA;E1EoudV;E0E3udM;IAOI,kCAAA;E1EuudV;E0E9udM;IAOI,+BAAA;E1E0udV;E0EjvdM;IAOI,0BAAA;E1E6udV;E0EpvdM;IAOI,gCAAA;E1EgvdV;E0EvvdM;IAOI,+BAAA;E1EmvdV;E0E1vdM;IAOI,gCAAA;E1EsvdV;E0E7vdM;IAOI,6BAAA;E1EyvdV;E0EhwdM;IAOI,gCAAA;E1E4vdV;E0EnwdM;IAOI,+BAAA;E1E+vdV;E0EtwdM;IAOI,gCAAA;E1EkwdV;E0EzwdM;IAOI,6BAAA;E1EqwdV;E0E5wdM;IAOI,gCAAA;E1EwwdV;E0E/wdM;IAOI,+BAAA;E1E2wdV;E0ElxdM;IAOI,gCAAA;E1E8wdV;E0ErxdM;IAOI,6BAAA;E1EixdV;E0ExxdM;IAOI,gCAAA;E1EoxdV;E0E3xdM;IAOI,+BAAA;E1EuxdV;E0E9xdM;IAOI,gCAAA;E1E0xdV;E0EjydM;IAOI,6BAAA;E1E6xdV;E0EpydM;IAOI,gCAAA;E1EgydV;E0EvydM;IAOI,+BAAA;E1EmydV;E0E1ydM;IAOI,gCAAA;E1EsydV;E0E7ydM;IAOI,6BAAA;E1EyydV;E0EhzdM;IAOI,iBAAA;E1E4ydV;E0EnzdM;IAOI,uBAAA;E1E+ydV;E0EtzdM;IAOI,sBAAA;E1EkzdV;E0EzzdM;IAOI,uBAAA;E1EqzdV;E0E5zdM;IAOI,oBAAA;E1EwzdV;E0E/zdM;IAOI,uBAAA;E1E2zdV;E0El0dM;IAOI,sBAAA;E1E8zdV;E0Er0dM;IAOI,uBAAA;E1Ei0dV;E0Ex0dM;IAOI,oBAAA;E1Eo0dV;E0E30dM;IAOI,uBAAA;E1Eu0dV;E0E90dM;IAOI,sBAAA;E1E00dV;E0Ej1dM;IAOI,uBAAA;E1E60dV;E0Ep1dM;IAOI,oBAAA;E1Eg1dV;E0Ev1dM;IAOI,uBAAA;E1Em1dV;E0E11dM;IAOI,sBAAA;E1Es1dV;E0E71dM;IAOI,uBAAA;E1Ey1dV;E0Eh2dM;IAOI,oBAAA;E1E41dV;E0En2dM;IAOI,uBAAA;E1E+1dV;E0Et2dM;IAOI,sBAAA;E1Ek2dV;E0Ez2dM;IAOI,uBAAA;E1Eq2dV;E0E52dM;IAOI,oBAAA;E1Ew2dV;E0E/2dM;IAOI,qBAAA;E1E22dV;E0El3dM;IAOI,2BAAA;E1E82dV;E0Er3dM;IAOI,0BAAA;E1Ei3dV;E0Ex3dM;IAOI,2BAAA;E1Eo3dV;E0E33dM;IAOI,wBAAA;E1Eu3dV;E0E93dM;IAOI,2BAAA;E1E03dV;E0Ej4dM;IAOI,0BAAA;E1E63dV;E0Ep4dM;IAOI,2BAAA;E1Eg4dV;E0Ev4dM;IAOI,wBAAA;E1Em4dV;E0E14dM;IAOI,2BAAA;E1Es4dV;E0E74dM;IAOI,0BAAA;E1Ey4dV;E0Eh5dM;IAOI,2BAAA;E1E44dV;E0En5dM;IAOI,wBAAA;E1E+4dV;E0Et5dM;IAOI,2BAAA;E1Ek5dV;E0Ez5dM;IAOI,0BAAA;E1Eq5dV;E0E55dM;IAOI,2BAAA;E1Ew5dV;E0E/5dM;IAOI,wBAAA;E1E25dV;E0El6dM;IAOI,2BAAA;E1E85dV;E0Er6dM;IAOI,0BAAA;E1Ei6dV;E0Ex6dM;IAOI,2BAAA;E1Eo6dV;E0E36dM;IAOI,wBAAA;E1Eu6dV;E0E96dM;IAOI,wBAAA;E1E06dV;E0Ej7dM;IAOI,8BAAA;E1E66dV;E0Ep7dM;IAOI,6BAAA;E1Eg7dV;E0Ev7dM;IAOI,8BAAA;E1Em7dV;E0E17dM;IAOI,2BAAA;E1Es7dV;E0E77dM;IAOI,8BAAA;E1Ey7dV;E0Eh8dM;IAOI,6BAAA;E1E47dV;E0En8dM;IAOI,8BAAA;E1E+7dV;E0Et8dM;IAOI,2BAAA;E1Ek8dV;E0Ez8dM;IAOI,8BAAA;E1Eq8dV;E0E58dM;IAOI,6BAAA;E1Ew8dV;E0E/8dM;IAOI,8BAAA;E1E28dV;E0El9dM;IAOI,2BAAA;E1E88dV;E0Er9dM;IAOI,8BAAA;E1Ei9dV;E0Ex9dM;IAOI,6BAAA;E1Eo9dV;E0E39dM;IAOI,8BAAA;E1Eu9dV;E0E99dM;IAOI,2BAAA;E1E09dV;E0Ej+dM;IAOI,8BAAA;E1E69dV;E0Ep+dM;IAOI,6BAAA;E1Eg+dV;E0Ev+dM;IAOI,8BAAA;E1Em+dV;E0E1+dM;IAOI,2BAAA;E1Es+dV;E0E7+dM;IAOI,0CAAA;E1Ey+dV;E0Eh/dM;IAOI,4CAAA;E1E4+dV;E0En/dM;IAOI,4CAAA;E1E++dV;E0Et/dM;IAOI,6BAAA;E1Ek/dV;E0Ez/dM;IAOI,6BAAA;E1Eq/dV;E0E5/dM;IAOI,8BAAA;E1Ew/dV;E0E//dM;IAOI,6BAAA;E1E2/dV;E0ElgeM;IAOI,6BAAA;E1E8/dV;E0ErgeM;IAOI,6BAAA;E1EigeV;E0ExgeM;IAOI,4BAAA;E1EogeV;E0E3geM;IAOI,6BAAA;E1EugeV;E0E9geM;IAOI,0BAAA;E1E0geV;E0EjheM;IAOI,8BAAA;E1E6geV;E0EpheM;IAOI,6BAAA;E1EgheV;E0EvheM;IAOI,0BAAA;E1EmheV;E0E1heM;IAOI,4CAAA;E1EsheV;E0E7heM;IAOI,2CAAA;E1EyheV;E0EhieM;IAOI,4CAAA;E1E4heV;E0EnieM;IAOI,0CAAA;E1E+heV;E0EtieM;IAOI,4CAAA;E1EkieV;E0EzieM;IAOI,2CAAA;E1EqieV;E0E5ieM;IAOI,4CAAA;E1EwieV;E0E/ieM;IAOI,wCAAA;E1E2ieV;E0EljeM;IAOI,4CAAA;E1E8ieV;E0ErjeM;IAOI,2CAAA;E1EijeV;E0ExjeM;IAOI,4CAAA;E1EojeV;E0E3jeM;IAOI,0CAAA;E1EujeV;E0E9jeM;IAOI,4CAAA;E1E0jeV;E0EjkeM;IAOI,2CAAA;E1E6jeV;E0EpkeM;IAOI,4CAAA;E1EgkeV;E0EvkeM;IAOI,0CAAA;E1EmkeV;E0E1keM;IAOI,4CAAA;E1EskeV;E0E7keM;IAOI,yCAAA;E1EykeV;E0EhleM;IAOI,4CAAA;E1E4keV;E0EnleM;IAOI,0CAAA;E1E+keV;E0EtleM;IAOI,4CAAA;E1EkleV;E0EzleM;IAOI,2CAAA;E1EqleV;E0E5leM;IAOI,4CAAA;E1EwleV;E0E/leM;IAOI,0CAAA;E1E2leV;E0ElmeM;IAOI,2BAAA;E1E8leV;E0ErmeM;IAOI,4BAAA;E1EimeV;E0ExmeM;IAOI,6BAAA;E1EomeV;E0E3meM;IAOI,2BAAA;E1EumeV;E0E9meM;IAOI,yBAAA;E1E0meV;E0EjneM;IAOI,yBAAA;E1E6meV;E0EpneM;IAOI,yBAAA;E1EgneV;E0EvneM;IAOI,0BAAA;E1EmneV;E0E1neM;IAOI,0BAAA;E1EsneV;E0E7neM;IAOI,yBAAA;E1EyneV;E0EhoeM;IAOI,yBAAA;E1E4neV;E0EnoeM;IAOI,yBAAA;E1E+neV;E0EtoeM;IAOI,yBAAA;E1EkoeV;E0EzoeM;IAOI,yBAAA;E1EqoeV;E0E5oeM;IAOI,yBAAA;E1EwoeV;E0E/oeM;IAOI,yBAAA;E1E2oeV;E0ElpeM;IAOI,yBAAA;E1E8oeV;E0ErpeM;IAOI,yBAAA;E1EipeV;E0ExpeM;IAOI,0BAAA;E1EopeV;E0E3peM;IAOI,0BAAA;E1EupeV;E0E9peM;IAOI,0BAAA;E1E0peV;E0EjqeM;IAOI,0BAAA;E1E6peV;E0EpqeM;IAOI,0BAAA;E1EgqeV;E0EvqeM;IAOI,0BAAA;E1EmqeV;E0E1qeM;IAOI,0BAAA;E1EsqeV;E0E7qeM;IAOI,0BAAA;E1EyqeV;E0EhreM;IAOI,0BAAA;E1E4qeV;E0EnreM;IAOI,0BAAA;E1E+qeV;E0EtreM;IAOI,0BAAA;E1EkreV;E0EzreM;IAOI,0BAAA;E1EqreV;E0E5reM;IAOI,0BAAA;E1EwreV;E0E/reM;IAOI,0BAAA;E1E2reV;E0ElseM;IAOI,0BAAA;E1E8reV;E0ErseM;IAOI,0BAAA;E1EiseV;E0ExseM;IAOI,0BAAA;E1EoseV;E0E3seM;IAOI,0BAAA;E1EuseV;E0E9seM;IAOI,2BAAA;E1E0seV;E0EjteM;IAOI,2BAAA;E1E6seV;E0EpteM;IAOI,2BAAA;E1EgteV;E0EvteM;IAOI,2BAAA;E1EmteV;E0E1teM;IAOI,2BAAA;E1EsteV;E0E7teM;IAOI,2BAAA;E1EyteV;E0EhueM;IAOI,2BAAA;E1E4teV;E0EnueM;IAOI,2BAAA;E1E+teV;E0EtueM;IAOI,2BAAA;E1EkueV;E0EzueM;IAOI,2BAAA;E1EqueV;E0E5ueM;IAOI,2BAAA;E1EwueV;E0E/ueM;IAOI,2BAAA;E1E2ueV;E0ElveM;IAOI,2BAAA;E1E8ueV;E0ErveM;IAOI,2BAAA;E1EiveV;E0ExveM;IAOI,2BAAA;E1EoveV;E0E3veM;IAOI,2BAAA;E1EuveV;E0E9veM;IAOI,2BAAA;E1E0veV;E0EjweM;IAOI,2BAAA;E1E6veV;E0EpweM;IAOI,2BAAA;E1EgweV;E0EvweM;IAOI,2BAAA;E1EmweV;E0E1weM;IAOI,2BAAA;E1EsweV;E0E7weM;IAOI,2BAAA;E1EyweV;E0EhxeM;IAOI,2BAAA;E1E4weV;E0EnxeM;IAOI,2BAAA;E1E+weV;E0EtxeM;IAOI,2BAAA;E1EkxeV;E0EzxeM;IAOI,2BAAA;E1EqxeV;E0E5xeM;IAOI,4BAAA;E1EwxeV;E0E/xeM;IAOI,4BAAA;E1E2xeV;E0ElyeM;IAOI,0BAAA;E1E8xeV;E0EryeM;IAOI,0BAAA;E1EiyeV;E0ExyeM;IAOI,0BAAA;E1EoyeV;E0E3yeM;IAOI,2BAAA;E1EuyeV;E0E9yeM;IAOI,2BAAA;E1E0yeV;E0EjzeM;IAOI,0BAAA;E1E6yeV;E0EpzeM;IAOI,0BAAA;E1EgzeV;E0EvzeM;IAOI,0BAAA;E1EmzeV;E0E1zeM;IAOI,0BAAA;E1EszeV;E0E7zeM;IAOI,0BAAA;E1EyzeV;E0Eh0eM;IAOI,0BAAA;E1E4zeV;E0En0eM;IAOI,0BAAA;E1E+zeV;E0Et0eM;IAOI,0BAAA;E1Ek0eV;E0Ez0eM;IAOI,0BAAA;E1Eq0eV;E0E50eM;IAOI,2BAAA;E1Ew0eV;E0E/0eM;IAOI,2BAAA;E1E20eV;E0El1eM;IAOI,2BAAA;E1E80eV;E0Er1eM;IAOI,2BAAA;E1Ei1eV;E0Ex1eM;IAOI,2BAAA;E1Eo1eV;E0E31eM;IAOI,2BAAA;E1Eu1eV;E0E91eM;IAOI,2BAAA;E1E01eV;E0Ej2eM;IAOI,2BAAA;E1E61eV;E0Ep2eM;IAOI,2BAAA;E1Eg2eV;E0Ev2eM;IAOI,2BAAA;E1Em2eV;E0E12eM;IAOI,2BAAA;E1Es2eV;E0E72eM;IAOI,2BAAA;E1Ey2eV;E0Eh3eM;IAOI,2BAAA;E1E42eV;E0En3eM;IAOI,2BAAA;E1E+2eV;E0Et3eM;IAOI,2BAAA;E1Ek3eV;E0Ez3eM;IAOI,2BAAA;E1Eq3eV;E0E53eM;IAOI,2BAAA;E1Ew3eV;E0E/3eM;IAOI,2BAAA;E1E23eV;E0El4eM;IAOI,4BAAA;E1E83eV;E0Er4eM;IAOI,4BAAA;E1Ei4eV;E0Ex4eM;IAOI,4BAAA;E1Eo4eV;E0E34eM;IAOI,4BAAA;E1Eu4eV;E0E94eM;IAOI,4BAAA;E1E04eV;E0Ej5eM;IAOI,4BAAA;E1E64eV;E0Ep5eM;IAOI,4BAAA;E1Eg5eV;E0Ev5eM;IAOI,4BAAA;E1Em5eV;E0E15eM;IAOI,4BAAA;E1Es5eV;E0E75eM;IAOI,4BAAA;E1Ey5eV;E0Eh6eM;IAOI,4BAAA;E1E45eV;E0En6eM;IAOI,4BAAA;E1E+5eV;E0Et6eM;IAOI,4BAAA;E1Ek6eV;E0Ez6eM;IAOI,4BAAA;E1Eq6eV;E0E56eM;IAOI,4BAAA;E1Ew6eV;E0E/6eM;IAOI,4BAAA;E1E26eV;E0El7eM;IAOI,4BAAA;E1E86eV;E0Er7eM;IAOI,4BAAA;E1Ei7eV;E0Ex7eM;IAOI,4BAAA;E1Eo7eV;E0E37eM;IAOI,4BAAA;E1Eu7eV;E0E97eM;IAOI,4BAAA;E1E07eV;E0Ej8eM;IAOI,4BAAA;E1E67eV;E0Ep8eM;IAOI,4BAAA;E1Eg8eV;E0Ev8eM;IAOI,4BAAA;E1Em8eV;E0E18eM;IAOI,4BAAA;E1Es8eV;E0E78eM;IAOI,4BAAA;E1Ey8eV;E0Eh9eM;IAOI,6BAAA;E1E48eV;AACF;AgBv9eI;E0DGI;IAOI,sBAAA;E1Ei9eV;E0Ex9eM;IAOI,uBAAA;E1Eo9eV;E0E39eM;IAOI,sBAAA;E1Eu9eV;E0E99eM;IAOI,8BAAA;E1E09eV;E0Ej+eM;IAOI,4BAAA;E1E69eV;E0Ep+eM;IAOI,2BAAA;E1Eg+eV;E0Ev+eM;IAOI,iCAAA;E1Em+eV;E0E1+eM;IAOI,2BAAA;E1Es+eV;E0E7+eM;IAOI,yBAAA;E1Ey+eV;E0Eh/eM;IAOI,2BAAA;E1E4+eV;E0En/eM;IAOI,4BAAA;E1E++eV;E0Et/eM;IAOI,2BAAA;E1Ek/eV;E0Ez/eM;IAOI,0BAAA;E1Eq/eV;E0E5/eM;IAOI,gCAAA;E1Ew/eV;E0E//eM;IAOI,yBAAA;E1E2/eV;E0ElgfM;IAOI,wBAAA;E1E8/eV;E0ErgfM;IAOI,+BAAA;E1EigfV;E0ExgfM;IAOI,yBAAA;E1EogfV;E0E3gfM;IAOI,6BAAA;E1EugfV;E0E9gfM;IAOI,8BAAA;E1E0gfV;E0EjhfM;IAOI,wBAAA;E1E6gfV;E0EphfM;IAOI,+BAAA;E1EghfV;E0EvhfM;IAOI,wBAAA;E1EmhfV;E0E1hfM;IAOI,2BAAA;E1EshfV;E0E7hfM;IAOI,6BAAA;E1EyhfV;E0EhifM;IAOI,6BAAA;E1E4hfV;E0EnifM;IAOI,0BAAA;E1E+hfV;E0EtifM;IAOI,2BAAA;E1EkifV;E0EzifM;IAOI,uBAAA;E1EqifV;E0E5ifM;IAOI,qBAAA;E1EwifV;E0E/ifM;IAOI,qBAAA;E1E2ifV;E0EljfM;IAOI,qBAAA;E1E8ifV;E0ErjfM;IAOI,sBAAA;E1EijfV;E0ExjfM;IAOI,sBAAA;E1EojfV;E0E3jfM;IAOI,qBAAA;E1EujfV;E0E9jfM;IAOI,qBAAA;E1E0jfV;E0EjkfM;IAOI,qBAAA;E1E6jfV;E0EpkfM;IAOI,qBAAA;E1EgkfV;E0EvkfM;IAOI,qBAAA;E1EmkfV;E0E1kfM;IAOI,qBAAA;E1EskfV;E0E7kfM;IAOI,qBAAA;E1EykfV;E0EhlfM;IAOI,qBAAA;E1E4kfV;E0EnlfM;IAOI,qBAAA;E1E+kfV;E0EtlfM;IAOI,sBAAA;E1EklfV;E0EzlfM;IAOI,sBAAA;E1EqlfV;E0E5lfM;IAOI,sBAAA;E1EwlfV;E0E/lfM;IAOI,sBAAA;E1E2lfV;E0ElmfM;IAOI,sBAAA;E1E8lfV;E0ErmfM;IAOI,sBAAA;E1EimfV;E0ExmfM;IAOI,sBAAA;E1EomfV;E0E3mfM;IAOI,sBAAA;E1EumfV;E0E9mfM;IAOI,sBAAA;E1E0mfV;E0EjnfM;IAOI,sBAAA;E1E6mfV;E0EpnfM;IAOI,sBAAA;E1EgnfV;E0EvnfM;IAOI,sBAAA;E1EmnfV;E0E1nfM;IAOI,sBAAA;E1EsnfV;E0E7nfM;IAOI,sBAAA;E1EynfV;E0EhofM;IAOI,sBAAA;E1E4nfV;E0EnofM;IAOI,sBAAA;E1E+nfV;E0EtofM;IAOI,sBAAA;E1EkofV;E0EzofM;IAOI,sBAAA;E1EqofV;E0E5ofM;IAOI,uBAAA;E1EwofV;E0E/ofM;IAOI,uBAAA;E1E2ofV;E0ElpfM;IAOI,uBAAA;E1E8ofV;E0ErpfM;IAOI,uBAAA;E1EipfV;E0ExpfM;IAOI,uBAAA;E1EopfV;E0E3pfM;IAOI,uBAAA;E1EupfV;E0E9pfM;IAOI,uBAAA;E1E0pfV;E0EjqfM;IAOI,uBAAA;E1E6pfV;E0EpqfM;IAOI,uBAAA;E1EgqfV;E0EvqfM;IAOI,uBAAA;E1EmqfV;E0E1qfM;IAOI,uBAAA;E1EsqfV;E0E7qfM;IAOI,uBAAA;E1EyqfV;E0EhrfM;IAOI,uBAAA;E1E4qfV;E0EnrfM;IAOI,uBAAA;E1E+qfV;E0EtrfM;IAOI,uBAAA;E1EkrfV;E0EzrfM;IAOI,uBAAA;E1EqrfV;E0E5rfM;IAOI,uBAAA;E1EwrfV;E0E/rfM;IAOI,uBAAA;E1E2rfV;E0ElsfM;IAOI,uBAAA;E1E8rfV;E0ErsfM;IAOI,uBAAA;E1EisfV;E0ExsfM;IAOI,uBAAA;E1EosfV;E0E3sfM;IAOI,uBAAA;E1EusfV;E0E9sfM;IAOI,uBAAA;E1E0sfV;E0EjtfM;IAOI,uBAAA;E1E6sfV;E0EptfM;IAOI,uBAAA;E1EgtfV;E0EvtfM;IAOI,uBAAA;E1EmtfV;E0E1tfM;IAOI,wBAAA;E1EstfV;E0E7tfM;IAOI,2BAAA;E1EytfV;E0EhufM;IAOI,yBAAA;E1E4tfV;E0EnufM;IAOI,yBAAA;E1E+tfV;E0EtufM;IAOI,yBAAA;E1EkufV;E0EzufM;IAOI,0BAAA;E1EqufV;E0E5ufM;IAOI,0BAAA;E1EwufV;E0E/ufM;IAOI,yBAAA;E1E2ufV;E0ElvfM;IAOI,yBAAA;E1E8ufV;E0ErvfM;IAOI,yBAAA;E1EivfV;E0ExvfM;IAOI,yBAAA;E1EovfV;E0E3vfM;IAOI,yBAAA;E1EuvfV;E0E9vfM;IAOI,yBAAA;E1E0vfV;E0EjwfM;IAOI,yBAAA;E1E6vfV;E0EpwfM;IAOI,yBAAA;E1EgwfV;E0EvwfM;IAOI,yBAAA;E1EmwfV;E0E1wfM;IAOI,0BAAA;E1EswfV;E0E7wfM;IAOI,0BAAA;E1EywfV;E0EhxfM;IAOI,0BAAA;E1E4wfV;E0EnxfM;IAOI,0BAAA;E1E+wfV;E0EtxfM;IAOI,0BAAA;E1EkxfV;E0EzxfM;IAOI,0BAAA;E1EqxfV;E0E5xfM;IAOI,0BAAA;E1EwxfV;E0E/xfM;IAOI,0BAAA;E1E2xfV;E0ElyfM;IAOI,0BAAA;E1E8xfV;E0EryfM;IAOI,0BAAA;E1EiyfV;E0ExyfM;IAOI,0BAAA;E1EoyfV;E0E3yfM;IAOI,0BAAA;E1EuyfV;E0E9yfM;IAOI,0BAAA;E1E0yfV;E0EjzfM;IAOI,0BAAA;E1E6yfV;E0EpzfM;IAOI,0BAAA;E1EgzfV;E0EvzfM;IAOI,0BAAA;E1EmzfV;E0E1zfM;IAOI,0BAAA;E1EszfV;E0E7zfM;IAOI,0BAAA;E1EyzfV;E0Eh0fM;IAOI,2BAAA;E1E4zfV;E0En0fM;IAOI,2BAAA;E1E+zfV;E0Et0fM;IAOI,2BAAA;E1Ek0fV;E0Ez0fM;IAOI,2BAAA;E1Eq0fV;E0E50fM;IAOI,2BAAA;E1Ew0fV;E0E/0fM;IAOI,2BAAA;E1E20fV;E0El1fM;IAOI,2BAAA;E1E80fV;E0Er1fM;IAOI,2BAAA;E1Ei1fV;E0Ex1fM;IAOI,2BAAA;E1Eo1fV;E0E31fM;IAOI,2BAAA;E1Eu1fV;E0E91fM;IAOI,2BAAA;E1E01fV;E0Ej2fM;IAOI,2BAAA;E1E61fV;E0Ep2fM;IAOI,2BAAA;E1Eg2fV;E0Ev2fM;IAOI,2BAAA;E1Em2fV;E0E12fM;IAOI,2BAAA;E1Es2fV;E0E72fM;IAOI,2BAAA;E1Ey2fV;E0Eh3fM;IAOI,2BAAA;E1E42fV;E0En3fM;IAOI,2BAAA;E1E+2fV;E0Et3fM;IAOI,2BAAA;E1Ek3fV;E0Ez3fM;IAOI,2BAAA;E1Eq3fV;E0E53fM;IAOI,2BAAA;E1Ew3fV;E0E/3fM;IAOI,2BAAA;E1E23fV;E0El4fM;IAOI,2BAAA;E1E83fV;E0Er4fM;IAOI,2BAAA;E1Ei4fV;E0Ex4fM;IAOI,2BAAA;E1Eo4fV;E0E34fM;IAOI,2BAAA;E1Eu4fV;E0E94fM;IAOI,4BAAA;E1E04fV;E0Ej5fM;IAOI,wBAAA;E1E64fV;E0Ep5fM;IAOI,sBAAA;E1Eg5fV;E0Ev5fM;IAOI,sBAAA;E1Em5fV;E0E15fM;IAOI,sBAAA;E1Es5fV;E0E75fM;IAOI,uBAAA;E1Ey5fV;E0Eh6fM;IAOI,uBAAA;E1E45fV;E0En6fM;IAOI,sBAAA;E1E+5fV;E0Et6fM;IAOI,sBAAA;E1Ek6fV;E0Ez6fM;IAOI,sBAAA;E1Eq6fV;E0E56fM;IAOI,sBAAA;E1Ew6fV;E0E/6fM;IAOI,sBAAA;E1E26fV;E0El7fM;IAOI,sBAAA;E1E86fV;E0Er7fM;IAOI,sBAAA;E1Ei7fV;E0Ex7fM;IAOI,sBAAA;E1Eo7fV;E0E37fM;IAOI,sBAAA;E1Eu7fV;E0E97fM;IAOI,uBAAA;E1E07fV;E0Ej8fM;IAOI,uBAAA;E1E67fV;E0Ep8fM;IAOI,uBAAA;E1Eg8fV;E0Ev8fM;IAOI,uBAAA;E1Em8fV;E0E18fM;IAOI,uBAAA;E1Es8fV;E0E78fM;IAOI,uBAAA;E1Ey8fV;E0Eh9fM;IAOI,uBAAA;E1E48fV;E0En9fM;IAOI,uBAAA;E1E+8fV;E0Et9fM;IAOI,uBAAA;E1Ek9fV;E0Ez9fM;IAOI,uBAAA;E1Eq9fV;E0E59fM;IAOI,uBAAA;E1Ew9fV;E0E/9fM;IAOI,uBAAA;E1E29fV;E0El+fM;IAOI,uBAAA;E1E89fV;E0Er+fM;IAOI,uBAAA;E1Ei+fV;E0Ex+fM;IAOI,uBAAA;E1Eo+fV;E0E3+fM;IAOI,uBAAA;E1Eu+fV;E0E9+fM;IAOI,uBAAA;E1E0+fV;E0Ej/fM;IAOI,uBAAA;E1E6+fV;E0Ep/fM;IAOI,wBAAA;E1Eg/fV;E0Ev/fM;IAOI,wBAAA;E1Em/fV;E0E1/fM;IAOI,wBAAA;E1Es/fV;E0E7/fM;IAOI,wBAAA;E1Ey/fV;E0EhggBM;IAOI,wBAAA;E1E4/fV;E0EnggBM;IAOI,wBAAA;E1E+/fV;E0EtggBM;IAOI,wBAAA;E1EkggBV;E0EzggBM;IAOI,wBAAA;E1EqggBV;E0E5ggBM;IAOI,wBAAA;E1EwggBV;E0E/ggBM;IAOI,wBAAA;E1E2ggBV;E0ElhgBM;IAOI,wBAAA;E1E8ggBV;E0ErhgBM;IAOI,wBAAA;E1EihgBV;E0ExhgBM;IAOI,wBAAA;E1EohgBV;E0E3hgBM;IAOI,wBAAA;E1EuhgBV;E0E9hgBM;IAOI,wBAAA;E1E0hgBV;E0EjigBM;IAOI,wBAAA;E1E6hgBV;E0EpigBM;IAOI,wBAAA;E1EgigBV;E0EvigBM;IAOI,wBAAA;E1EmigBV;E0E1igBM;IAOI,wBAAA;E1EsigBV;E0E7igBM;IAOI,wBAAA;E1EyigBV;E0EhjgBM;IAOI,wBAAA;E1E4igBV;E0EnjgBM;IAOI,wBAAA;E1E+igBV;E0EtjgBM;IAOI,wBAAA;E1EkjgBV;E0EzjgBM;IAOI,wBAAA;E1EqjgBV;E0E5jgBM;IAOI,wBAAA;E1EwjgBV;E0E/jgBM;IAOI,wBAAA;E1E2jgBV;E0ElkgBM;IAOI,yBAAA;E1E8jgBV;E0ErkgBM;IAOI,4BAAA;E1EikgBV;E0ExkgBM;IAOI,0BAAA;E1EokgBV;E0E3kgBM;IAOI,0BAAA;E1EukgBV;E0E9kgBM;IAOI,0BAAA;E1E0kgBV;E0EjlgBM;IAOI,2BAAA;E1E6kgBV;E0EplgBM;IAOI,2BAAA;E1EglgBV;E0EvlgBM;IAOI,0BAAA;E1EmlgBV;E0E1lgBM;IAOI,0BAAA;E1EslgBV;E0E7lgBM;IAOI,0BAAA;E1EylgBV;E0EhmgBM;IAOI,0BAAA;E1E4lgBV;E0EnmgBM;IAOI,0BAAA;E1E+lgBV;E0EtmgBM;IAOI,0BAAA;E1EkmgBV;E0EzmgBM;IAOI,0BAAA;E1EqmgBV;E0E5mgBM;IAOI,0BAAA;E1EwmgBV;E0E/mgBM;IAOI,0BAAA;E1E2mgBV;E0ElngBM;IAOI,2BAAA;E1E8mgBV;E0ErngBM;IAOI,2BAAA;E1EingBV;E0ExngBM;IAOI,2BAAA;E1EongBV;E0E3ngBM;IAOI,2BAAA;E1EungBV;E0E9ngBM;IAOI,2BAAA;E1E0ngBV;E0EjogBM;IAOI,2BAAA;E1E6ngBV;E0EpogBM;IAOI,2BAAA;E1EgogBV;E0EvogBM;IAOI,2BAAA;E1EmogBV;E0E1ogBM;IAOI,2BAAA;E1EsogBV;E0E7ogBM;IAOI,2BAAA;E1EyogBV;E0EhpgBM;IAOI,2BAAA;E1E4ogBV;E0EnpgBM;IAOI,2BAAA;E1E+ogBV;E0EtpgBM;IAOI,2BAAA;E1EkpgBV;E0EzpgBM;IAOI,2BAAA;E1EqpgBV;E0E5pgBM;IAOI,2BAAA;E1EwpgBV;E0E/pgBM;IAOI,2BAAA;E1E2pgBV;E0ElqgBM;IAOI,2BAAA;E1E8pgBV;E0ErqgBM;IAOI,2BAAA;E1EiqgBV;E0ExqgBM;IAOI,4BAAA;E1EoqgBV;E0E3qgBM;IAOI,4BAAA;E1EuqgBV;E0E9qgBM;IAOI,4BAAA;E1E0qgBV;E0EjrgBM;IAOI,4BAAA;E1E6qgBV;E0EprgBM;IAOI,4BAAA;E1EgrgBV;E0EvrgBM;IAOI,4BAAA;E1EmrgBV;E0E1rgBM;IAOI,4BAAA;E1EsrgBV;E0E7rgBM;IAOI,4BAAA;E1EyrgBV;E0EhsgBM;IAOI,4BAAA;E1E4rgBV;E0EnsgBM;IAOI,4BAAA;E1E+rgBV;E0EtsgBM;IAOI,4BAAA;E1EksgBV;E0EzsgBM;IAOI,4BAAA;E1EqsgBV;E0E5sgBM;IAOI,4BAAA;E1EwsgBV;E0E/sgBM;IAOI,4BAAA;E1E2sgBV;E0EltgBM;IAOI,4BAAA;E1E8sgBV;E0ErtgBM;IAOI,4BAAA;E1EitgBV;E0ExtgBM;IAOI,4BAAA;E1EotgBV;E0E3tgBM;IAOI,4BAAA;E1EutgBV;E0E9tgBM;IAOI,4BAAA;E1E0tgBV;E0EjugBM;IAOI,4BAAA;E1E6tgBV;E0EpugBM;IAOI,4BAAA;E1EgugBV;E0EvugBM;IAOI,4BAAA;E1EmugBV;E0E1ugBM;IAOI,4BAAA;E1EsugBV;E0E7ugBM;IAOI,4BAAA;E1EyugBV;E0EhvgBM;IAOI,4BAAA;E1E4ugBV;E0EnvgBM;IAOI,4BAAA;E1E+ugBV;E0EtvgBM;IAOI,6BAAA;E1EkvgBV;E0EzvgBM;IAOI,yBAAA;E1EqvgBV;E0E5vgBM;IAOI,8BAAA;E1EwvgBV;E0E/vgBM;IAOI,iCAAA;E1E2vgBV;E0ElwgBM;IAOI,sCAAA;E1E8vgBV;E0ErwgBM;IAOI,yCAAA;E1EiwgBV;E0ExwgBM;IAOI,uBAAA;E1EowgBV;E0E3wgBM;IAOI,uBAAA;E1EuwgBV;E0E9wgBM;IAOI,yBAAA;E1E0wgBV;E0EjxgBM;IAOI,yBAAA;E1E6wgBV;E0EpxgBM;IAOI,0BAAA;E1EgxgBV;E0EvxgBM;IAOI,4BAAA;E1EmxgBV;E0E1xgBM;IAOI,kCAAA;E1EsxgBV;E0E7xgBM;IAOI,sCAAA;E1EyxgBV;E0EhygBM;IAOI,oCAAA;E1E4xgBV;E0EnygBM;IAOI,kCAAA;E1E+xgBV;E0EtygBM;IAOI,yCAAA;E1EkygBV;E0EzygBM;IAOI,wCAAA;E1EqygBV;E0E5ygBM;IAOI,wCAAA;E1EwygBV;E0E/ygBM;IAOI,kCAAA;E1E2ygBV;E0ElzgBM;IAOI,gCAAA;E1E8ygBV;E0ErzgBM;IAOI,8BAAA;E1EizgBV;E0ExzgBM;IAOI,gCAAA;E1EozgBV;E0E3zgBM;IAOI,+BAAA;E1EuzgBV;E0E9zgBM;IAOI,oCAAA;E1E0zgBV;E0Ej0gBM;IAOI,kCAAA;E1E6zgBV;E0Ep0gBM;IAOI,gCAAA;E1Eg0gBV;E0Ev0gBM;IAOI,uCAAA;E1Em0gBV;E0E10gBM;IAOI,sCAAA;E1Es0gBV;E0E70gBM;IAOI,iCAAA;E1Ey0gBV;E0Eh1gBM;IAOI,2BAAA;E1E40gBV;E0En1gBM;IAOI,iCAAA;E1E+0gBV;E0Et1gBM;IAOI,+BAAA;E1Ek1gBV;E0Ez1gBM;IAOI,6BAAA;E1Eq1gBV;E0E51gBM;IAOI,+BAAA;E1Ew1gBV;E0E/1gBM;IAOI,8BAAA;E1E21gBV;E0El2gBM;IAOI,oBAAA;E1E81gBV;E0Er2gBM;IAOI,mBAAA;E1Ei2gBV;E0Ex2gBM;IAOI,mBAAA;E1Eo2gBV;E0E32gBM;IAOI,mBAAA;E1Eu2gBV;E0E92gBM;IAOI,mBAAA;E1E02gBV;E0Ej3gBM;IAOI,mBAAA;E1E62gBV;E0Ep3gBM;IAOI,mBAAA;E1Eg3gBV;E0Ev3gBM;IAOI,mBAAA;E1Em3gBV;E0E13gBM;IAOI,oBAAA;E1Es3gBV;E0E73gBM;IAOI,0BAAA;E1Ey3gBV;E0Eh4gBM;IAOI,yBAAA;E1E43gBV;E0En4gBM;IAOI,0BAAA;E1E+3gBV;E0Et4gBM;IAOI,uBAAA;E1Ek4gBV;E0Ez4gBM;IAOI,0BAAA;E1Eq4gBV;E0E54gBM;IAOI,yBAAA;E1Ew4gBV;E0E/4gBM;IAOI,0BAAA;E1E24gBV;E0El5gBM;IAOI,uBAAA;E1E84gBV;E0Er5gBM;IAOI,0BAAA;E1Ei5gBV;E0Ex5gBM;IAOI,yBAAA;E1Eo5gBV;E0E35gBM;IAOI,0BAAA;E1Eu5gBV;E0E95gBM;IAOI,uBAAA;E1E05gBV;E0Ej6gBM;IAOI,0BAAA;E1E65gBV;E0Ep6gBM;IAOI,yBAAA;E1Eg6gBV;E0Ev6gBM;IAOI,0BAAA;E1Em6gBV;E0E16gBM;IAOI,uBAAA;E1Es6gBV;E0E76gBM;IAOI,0BAAA;E1Ey6gBV;E0Eh7gBM;IAOI,yBAAA;E1E46gBV;E0En7gBM;IAOI,0BAAA;E1E+6gBV;E0Et7gBM;IAOI,uBAAA;E1Ek7gBV;E0Ez7gBM;IAOI,uBAAA;E1Eq7gBV;E0E57gBM;IAOI,0BAAA;IAAA,yBAAA;E1Ey7gBV;E0Eh8gBM;IAOI,gCAAA;IAAA,+BAAA;E1E67gBV;E0Ep8gBM;IAOI,+BAAA;IAAA,8BAAA;E1Ei8gBV;E0Ex8gBM;IAOI,gCAAA;IAAA,+BAAA;E1Eq8gBV;E0E58gBM;IAOI,6BAAA;IAAA,4BAAA;E1Ey8gBV;E0Eh9gBM;IAOI,gCAAA;IAAA,+BAAA;E1E68gBV;E0Ep9gBM;IAOI,+BAAA;IAAA,8BAAA;E1Ei9gBV;E0Ex9gBM;IAOI,gCAAA;IAAA,+BAAA;E1Eq9gBV;E0E59gBM;IAOI,6BAAA;IAAA,4BAAA;E1Ey9gBV;E0Eh+gBM;IAOI,gCAAA;IAAA,+BAAA;E1E69gBV;E0Ep+gBM;IAOI,+BAAA;IAAA,8BAAA;E1Ei+gBV;E0Ex+gBM;IAOI,gCAAA;IAAA,+BAAA;E1Eq+gBV;E0E5+gBM;IAOI,6BAAA;IAAA,4BAAA;E1Ey+gBV;E0Eh/gBM;IAOI,gCAAA;IAAA,+BAAA;E1E6+gBV;E0Ep/gBM;IAOI,+BAAA;IAAA,8BAAA;E1Ei/gBV;E0Ex/gBM;IAOI,gCAAA;IAAA,+BAAA;E1Eq/gBV;E0E5/gBM;IAOI,6BAAA;IAAA,4BAAA;E1Ey/gBV;E0EhghBM;IAOI,gCAAA;IAAA,+BAAA;E1E6/gBV;E0EpghBM;IAOI,+BAAA;IAAA,8BAAA;E1EighBV;E0ExghBM;IAOI,gCAAA;IAAA,+BAAA;E1EqghBV;E0E5ghBM;IAOI,6BAAA;IAAA,4BAAA;E1EyghBV;E0EhhhBM;IAOI,6BAAA;IAAA,4BAAA;E1E6ghBV;E0EphhBM;IAOI,wBAAA;IAAA,2BAAA;E1EihhBV;E0ExhhBM;IAOI,8BAAA;IAAA,iCAAA;E1EqhhBV;E0E5hhBM;IAOI,6BAAA;IAAA,gCAAA;E1EyhhBV;E0EhihBM;IAOI,8BAAA;IAAA,iCAAA;E1E6hhBV;E0EpihBM;IAOI,2BAAA;IAAA,8BAAA;E1EiihBV;E0ExihBM;IAOI,8BAAA;IAAA,iCAAA;E1EqihBV;E0E5ihBM;IAOI,6BAAA;IAAA,gCAAA;E1EyihBV;E0EhjhBM;IAOI,8BAAA;IAAA,iCAAA;E1E6ihBV;E0EpjhBM;IAOI,2BAAA;IAAA,8BAAA;E1EijhBV;E0ExjhBM;IAOI,8BAAA;IAAA,iCAAA;E1EqjhBV;E0E5jhBM;IAOI,6BAAA;IAAA,gCAAA;E1EyjhBV;E0EhkhBM;IAOI,8BAAA;IAAA,iCAAA;E1E6jhBV;E0EpkhBM;IAOI,2BAAA;IAAA,8BAAA;E1EikhBV;E0ExkhBM;IAOI,8BAAA;IAAA,iCAAA;E1EqkhBV;E0E5khBM;IAOI,6BAAA;IAAA,gCAAA;E1EykhBV;E0EhlhBM;IAOI,8BAAA;IAAA,iCAAA;E1E6khBV;E0EplhBM;IAOI,2BAAA;IAAA,8BAAA;E1EilhBV;E0ExlhBM;IAOI,8BAAA;IAAA,iCAAA;E1EqlhBV;E0E5lhBM;IAOI,6BAAA;IAAA,gCAAA;E1EylhBV;E0EhmhBM;IAOI,8BAAA;IAAA,iCAAA;E1E6lhBV;E0EpmhBM;IAOI,2BAAA;IAAA,8BAAA;E1EimhBV;E0ExmhBM;IAOI,2BAAA;IAAA,8BAAA;E1EqmhBV;E0E5mhBM;IAOI,wBAAA;E1EwmhBV;E0E/mhBM;IAOI,8BAAA;E1E2mhBV;E0ElnhBM;IAOI,6BAAA;E1E8mhBV;E0ErnhBM;IAOI,8BAAA;E1EinhBV;E0ExnhBM;IAOI,2BAAA;E1EonhBV;E0E3nhBM;IAOI,8BAAA;E1EunhBV;E0E9nhBM;IAOI,6BAAA;E1E0nhBV;E0EjohBM;IAOI,8BAAA;E1E6nhBV;E0EpohBM;IAOI,2BAAA;E1EgohBV;E0EvohBM;IAOI,8BAAA;E1EmohBV;E0E1ohBM;IAOI,6BAAA;E1EsohBV;E0E7ohBM;IAOI,8BAAA;E1EyohBV;E0EhphBM;IAOI,2BAAA;E1E4ohBV;E0EnphBM;IAOI,8BAAA;E1E+ohBV;E0EtphBM;IAOI,6BAAA;E1EkphBV;E0EzphBM;IAOI,8BAAA;E1EqphBV;E0E5phBM;IAOI,2BAAA;E1EwphBV;E0E/phBM;IAOI,8BAAA;E1E2phBV;E0ElqhBM;IAOI,6BAAA;E1E8phBV;E0ErqhBM;IAOI,8BAAA;E1EiqhBV;E0ExqhBM;IAOI,2BAAA;E1EoqhBV;E0E3qhBM;IAOI,2BAAA;E1EuqhBV;E0E9qhBM;IAOI,0BAAA;E1E0qhBV;E0EjrhBM;IAOI,gCAAA;E1E6qhBV;E0EprhBM;IAOI,+BAAA;E1EgrhBV;E0EvrhBM;IAOI,gCAAA;E1EmrhBV;E0E1rhBM;IAOI,6BAAA;E1EsrhBV;E0E7rhBM;IAOI,gCAAA;E1EyrhBV;E0EhshBM;IAOI,+BAAA;E1E4rhBV;E0EnshBM;IAOI,gCAAA;E1E+rhBV;E0EtshBM;IAOI,6BAAA;E1EkshBV;E0EzshBM;IAOI,gCAAA;E1EqshBV;E0E5shBM;IAOI,+BAAA;E1EwshBV;E0E/shBM;IAOI,gCAAA;E1E2shBV;E0ElthBM;IAOI,6BAAA;E1E8shBV;E0ErthBM;IAOI,gCAAA;E1EithBV;E0ExthBM;IAOI,+BAAA;E1EothBV;E0E3thBM;IAOI,gCAAA;E1EuthBV;E0E9thBM;IAOI,6BAAA;E1E0thBV;E0EjuhBM;IAOI,gCAAA;E1E6thBV;E0EpuhBM;IAOI,+BAAA;E1EguhBV;E0EvuhBM;IAOI,gCAAA;E1EmuhBV;E0E1uhBM;IAOI,6BAAA;E1EsuhBV;E0E7uhBM;IAOI,6BAAA;E1EyuhBV;E0EhvhBM;IAOI,2BAAA;E1E4uhBV;E0EnvhBM;IAOI,iCAAA;E1E+uhBV;E0EtvhBM;IAOI,gCAAA;E1EkvhBV;E0EzvhBM;IAOI,iCAAA;E1EqvhBV;E0E5vhBM;IAOI,8BAAA;E1EwvhBV;E0E/vhBM;IAOI,iCAAA;E1E2vhBV;E0ElwhBM;IAOI,gCAAA;E1E8vhBV;E0ErwhBM;IAOI,iCAAA;E1EiwhBV;E0ExwhBM;IAOI,8BAAA;E1EowhBV;E0E3whBM;IAOI,iCAAA;E1EuwhBV;E0E9whBM;IAOI,gCAAA;E1E0whBV;E0EjxhBM;IAOI,iCAAA;E1E6whBV;E0EpxhBM;IAOI,8BAAA;E1EgxhBV;E0EvxhBM;IAOI,iCAAA;E1EmxhBV;E0E1xhBM;IAOI,gCAAA;E1EsxhBV;E0E7xhBM;IAOI,iCAAA;E1EyxhBV;E0EhyhBM;IAOI,8BAAA;E1E4xhBV;E0EnyhBM;IAOI,iCAAA;E1E+xhBV;E0EtyhBM;IAOI,gCAAA;E1EkyhBV;E0EzyhBM;IAOI,iCAAA;E1EqyhBV;E0E5yhBM;IAOI,8BAAA;E1EwyhBV;E0E/yhBM;IAOI,8BAAA;E1E2yhBV;E0ElzhBM;IAOI,yBAAA;E1E8yhBV;E0ErzhBM;IAOI,+BAAA;E1EizhBV;E0ExzhBM;IAOI,8BAAA;E1EozhBV;E0E3zhBM;IAOI,+BAAA;E1EuzhBV;E0E9zhBM;IAOI,4BAAA;E1E0zhBV;E0Ej0hBM;IAOI,+BAAA;E1E6zhBV;E0Ep0hBM;IAOI,8BAAA;E1Eg0hBV;E0Ev0hBM;IAOI,+BAAA;E1Em0hBV;E0E10hBM;IAOI,4BAAA;E1Es0hBV;E0E70hBM;IAOI,+BAAA;E1Ey0hBV;E0Eh1hBM;IAOI,8BAAA;E1E40hBV;E0En1hBM;IAOI,+BAAA;E1E+0hBV;E0Et1hBM;IAOI,4BAAA;E1Ek1hBV;E0Ez1hBM;IAOI,+BAAA;E1Eq1hBV;E0E51hBM;IAOI,8BAAA;E1Ew1hBV;E0E/1hBM;IAOI,+BAAA;E1E21hBV;E0El2hBM;IAOI,4BAAA;E1E81hBV;E0Er2hBM;IAOI,+BAAA;E1Ei2hBV;E0Ex2hBM;IAOI,8BAAA;E1Eo2hBV;E0E32hBM;IAOI,+BAAA;E1Eu2hBV;E0E92hBM;IAOI,4BAAA;E1E02hBV;E0Ej3hBM;IAOI,4BAAA;E1E62hBV;E0Ep3hBM;IAOI,2BAAA;E1Eg3hBV;E0Ev3hBM;IAOI,0BAAA;E1Em3hBV;E0E13hBM;IAOI,2BAAA;E1Es3hBV;E0E73hBM;IAOI,wBAAA;E1Ey3hBV;E0Eh4hBM;IAOI,2BAAA;E1E43hBV;E0En4hBM;IAOI,0BAAA;E1E+3hBV;E0Et4hBM;IAOI,2BAAA;E1Ek4hBV;E0Ez4hBM;IAOI,wBAAA;E1Eq4hBV;E0E54hBM;IAOI,2BAAA;E1Ew4hBV;E0E/4hBM;IAOI,0BAAA;E1E24hBV;E0El5hBM;IAOI,2BAAA;E1E84hBV;E0Er5hBM;IAOI,wBAAA;E1Ei5hBV;E0Ex5hBM;IAOI,2BAAA;E1Eo5hBV;E0E35hBM;IAOI,0BAAA;E1Eu5hBV;E0E95hBM;IAOI,2BAAA;E1E05hBV;E0Ej6hBM;IAOI,wBAAA;E1E65hBV;E0Ep6hBM;IAOI,2BAAA;E1Eg6hBV;E0Ev6hBM;IAOI,0BAAA;E1Em6hBV;E0E16hBM;IAOI,2BAAA;E1Es6hBV;E0E76hBM;IAOI,wBAAA;E1Ey6hBV;E0Eh7hBM;IAOI,iCAAA;IAAA,gCAAA;E1E66hBV;E0Ep7hBM;IAOI,gCAAA;IAAA,+BAAA;E1Ei7hBV;E0Ex7hBM;IAOI,iCAAA;IAAA,gCAAA;E1Eq7hBV;E0E57hBM;IAOI,8BAAA;IAAA,6BAAA;E1Ey7hBV;E0Eh8hBM;IAOI,iCAAA;IAAA,gCAAA;E1E67hBV;E0Ep8hBM;IAOI,gCAAA;IAAA,+BAAA;E1Ei8hBV;E0Ex8hBM;IAOI,iCAAA;IAAA,gCAAA;E1Eq8hBV;E0E58hBM;IAOI,8BAAA;IAAA,6BAAA;E1Ey8hBV;E0Eh9hBM;IAOI,iCAAA;IAAA,gCAAA;E1E68hBV;E0Ep9hBM;IAOI,gCAAA;IAAA,+BAAA;E1Ei9hBV;E0Ex9hBM;IAOI,iCAAA;IAAA,gCAAA;E1Eq9hBV;E0E59hBM;IAOI,8BAAA;IAAA,6BAAA;E1Ey9hBV;E0Eh+hBM;IAOI,iCAAA;IAAA,gCAAA;E1E69hBV;E0Ep+hBM;IAOI,gCAAA;IAAA,+BAAA;E1Ei+hBV;E0Ex+hBM;IAOI,iCAAA;IAAA,gCAAA;E1Eq+hBV;E0E5+hBM;IAOI,8BAAA;IAAA,6BAAA;E1Ey+hBV;E0Eh/hBM;IAOI,iCAAA;IAAA,gCAAA;E1E6+hBV;E0Ep/hBM;IAOI,gCAAA;IAAA,+BAAA;E1Ei/hBV;E0Ex/hBM;IAOI,iCAAA;IAAA,gCAAA;E1Eq/hBV;E0E5/hBM;IAOI,8BAAA;IAAA,6BAAA;E1Ey/hBV;E0EhgiBM;IAOI,+BAAA;IAAA,kCAAA;E1E6/hBV;E0EpgiBM;IAOI,8BAAA;IAAA,iCAAA;E1EigiBV;E0ExgiBM;IAOI,+BAAA;IAAA,kCAAA;E1EqgiBV;E0E5giBM;IAOI,4BAAA;IAAA,+BAAA;E1EygiBV;E0EhhiBM;IAOI,+BAAA;IAAA,kCAAA;E1E6giBV;E0EphiBM;IAOI,8BAAA;IAAA,iCAAA;E1EihiBV;E0ExhiBM;IAOI,+BAAA;IAAA,kCAAA;E1EqhiBV;E0E5hiBM;IAOI,4BAAA;IAAA,+BAAA;E1EyhiBV;E0EhiiBM;IAOI,+BAAA;IAAA,kCAAA;E1E6hiBV;E0EpiiBM;IAOI,8BAAA;IAAA,iCAAA;E1EiiiBV;E0ExiiBM;IAOI,+BAAA;IAAA,kCAAA;E1EqiiBV;E0E5iiBM;IAOI,4BAAA;IAAA,+BAAA;E1EyiiBV;E0EhjiBM;IAOI,+BAAA;IAAA,kCAAA;E1E6iiBV;E0EpjiBM;IAOI,8BAAA;IAAA,iCAAA;E1EijiBV;E0ExjiBM;IAOI,+BAAA;IAAA,kCAAA;E1EqjiBV;E0E5jiBM;IAOI,4BAAA;IAAA,+BAAA;E1EyjiBV;E0EhkiBM;IAOI,+BAAA;IAAA,kCAAA;E1E6jiBV;E0EpkiBM;IAOI,8BAAA;IAAA,iCAAA;E1EikiBV;E0ExkiBM;IAOI,+BAAA;IAAA,kCAAA;E1EqkiBV;E0E5kiBM;IAOI,4BAAA;IAAA,+BAAA;E1EykiBV;E0EhliBM;IAOI,+BAAA;E1E4kiBV;E0EnliBM;IAOI,8BAAA;E1E+kiBV;E0EtliBM;IAOI,+BAAA;E1EkliBV;E0EzliBM;IAOI,4BAAA;E1EqliBV;E0E5liBM;IAOI,+BAAA;E1EwliBV;E0E/liBM;IAOI,8BAAA;E1E2liBV;E0ElmiBM;IAOI,+BAAA;E1E8liBV;E0ErmiBM;IAOI,4BAAA;E1EimiBV;E0ExmiBM;IAOI,+BAAA;E1EomiBV;E0E3miBM;IAOI,8BAAA;E1EumiBV;E0E9miBM;IAOI,+BAAA;E1E0miBV;E0EjniBM;IAOI,4BAAA;E1E6miBV;E0EpniBM;IAOI,+BAAA;E1EgniBV;E0EvniBM;IAOI,8BAAA;E1EmniBV;E0E1niBM;IAOI,+BAAA;E1EsniBV;E0E7niBM;IAOI,4BAAA;E1EyniBV;E0EhoiBM;IAOI,+BAAA;E1E4niBV;E0EnoiBM;IAOI,8BAAA;E1E+niBV;E0EtoiBM;IAOI,+BAAA;E1EkoiBV;E0EzoiBM;IAOI,4BAAA;E1EqoiBV;E0E5oiBM;IAOI,iCAAA;E1EwoiBV;E0E/oiBM;IAOI,gCAAA;E1E2oiBV;E0ElpiBM;IAOI,iCAAA;E1E8oiBV;E0ErpiBM;IAOI,8BAAA;E1EipiBV;E0ExpiBM;IAOI,iCAAA;E1EopiBV;E0E3piBM;IAOI,gCAAA;E1EupiBV;E0E9piBM;IAOI,iCAAA;E1E0piBV;E0EjqiBM;IAOI,8BAAA;E1E6piBV;E0EpqiBM;IAOI,iCAAA;E1EgqiBV;E0EvqiBM;IAOI,gCAAA;E1EmqiBV;E0E1qiBM;IAOI,iCAAA;E1EsqiBV;E0E7qiBM;IAOI,8BAAA;E1EyqiBV;E0EhriBM;IAOI,iCAAA;E1E4qiBV;E0EnriBM;IAOI,gCAAA;E1E+qiBV;E0EtriBM;IAOI,iCAAA;E1EkriBV;E0EzriBM;IAOI,8BAAA;E1EqriBV;E0E5riBM;IAOI,iCAAA;E1EwriBV;E0E/riBM;IAOI,gCAAA;E1E2riBV;E0ElsiBM;IAOI,iCAAA;E1E8riBV;E0ErsiBM;IAOI,8BAAA;E1EisiBV;E0ExsiBM;IAOI,kCAAA;E1EosiBV;E0E3siBM;IAOI,iCAAA;E1EusiBV;E0E9siBM;IAOI,kCAAA;E1E0siBV;E0EjtiBM;IAOI,+BAAA;E1E6siBV;E0EptiBM;IAOI,kCAAA;E1EgtiBV;E0EvtiBM;IAOI,iCAAA;E1EmtiBV;E0E1tiBM;IAOI,kCAAA;E1EstiBV;E0E7tiBM;IAOI,+BAAA;E1EytiBV;E0EhuiBM;IAOI,kCAAA;E1E4tiBV;E0EnuiBM;IAOI,iCAAA;E1E+tiBV;E0EtuiBM;IAOI,kCAAA;E1EkuiBV;E0EzuiBM;IAOI,+BAAA;E1EquiBV;E0E5uiBM;IAOI,kCAAA;E1EwuiBV;E0E/uiBM;IAOI,iCAAA;E1E2uiBV;E0ElviBM;IAOI,kCAAA;E1E8uiBV;E0ErviBM;IAOI,+BAAA;E1EiviBV;E0ExviBM;IAOI,kCAAA;E1EoviBV;E0E3viBM;IAOI,iCAAA;E1EuviBV;E0E9viBM;IAOI,kCAAA;E1E0viBV;E0EjwiBM;IAOI,+BAAA;E1E6viBV;E0EpwiBM;IAOI,gCAAA;E1EgwiBV;E0EvwiBM;IAOI,+BAAA;E1EmwiBV;E0E1wiBM;IAOI,gCAAA;E1EswiBV;E0E7wiBM;IAOI,6BAAA;E1EywiBV;E0EhxiBM;IAOI,gCAAA;E1E4wiBV;E0EnxiBM;IAOI,+BAAA;E1E+wiBV;E0EtxiBM;IAOI,gCAAA;E1EkxiBV;E0EzxiBM;IAOI,6BAAA;E1EqxiBV;E0E5xiBM;IAOI,gCAAA;E1EwxiBV;E0E/xiBM;IAOI,+BAAA;E1E2xiBV;E0ElyiBM;IAOI,gCAAA;E1E8xiBV;E0EryiBM;IAOI,6BAAA;E1EiyiBV;E0ExyiBM;IAOI,gCAAA;E1EoyiBV;E0E3yiBM;IAOI,+BAAA;E1EuyiBV;E0E9yiBM;IAOI,gCAAA;E1E0yiBV;E0EjziBM;IAOI,6BAAA;E1E6yiBV;E0EpziBM;IAOI,gCAAA;E1EgziBV;E0EvziBM;IAOI,+BAAA;E1EmziBV;E0E1ziBM;IAOI,gCAAA;E1EsziBV;E0E7ziBM;IAOI,6BAAA;E1EyziBV;E0Eh0iBM;IAOI,qBAAA;E1E4ziBV;E0En0iBM;IAOI,2BAAA;E1E+ziBV;E0Et0iBM;IAOI,0BAAA;E1Ek0iBV;E0Ez0iBM;IAOI,2BAAA;E1Eq0iBV;E0E50iBM;IAOI,wBAAA;E1Ew0iBV;E0E/0iBM;IAOI,2BAAA;E1E20iBV;E0El1iBM;IAOI,0BAAA;E1E80iBV;E0Er1iBM;IAOI,2BAAA;E1Ei1iBV;E0Ex1iBM;IAOI,wBAAA;E1Eo1iBV;E0E31iBM;IAOI,2BAAA;E1Eu1iBV;E0E91iBM;IAOI,0BAAA;E1E01iBV;E0Ej2iBM;IAOI,2BAAA;E1E61iBV;E0Ep2iBM;IAOI,wBAAA;E1Eg2iBV;E0Ev2iBM;IAOI,2BAAA;E1Em2iBV;E0E12iBM;IAOI,0BAAA;E1Es2iBV;E0E72iBM;IAOI,2BAAA;E1Ey2iBV;E0Eh3iBM;IAOI,wBAAA;E1E42iBV;E0En3iBM;IAOI,2BAAA;E1E+2iBV;E0Et3iBM;IAOI,0BAAA;E1Ek3iBV;E0Ez3iBM;IAOI,2BAAA;E1Eq3iBV;E0E53iBM;IAOI,wBAAA;E1Ew3iBV;E0E/3iBM;IAOI,2BAAA;IAAA,0BAAA;E1E43iBV;E0En4iBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg4iBV;E0Ev4iBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo4iBV;E0E34iBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew4iBV;E0E/4iBM;IAOI,8BAAA;IAAA,6BAAA;E1E44iBV;E0En5iBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg5iBV;E0Ev5iBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo5iBV;E0E35iBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew5iBV;E0E/5iBM;IAOI,8BAAA;IAAA,6BAAA;E1E45iBV;E0En6iBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg6iBV;E0Ev6iBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo6iBV;E0E36iBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew6iBV;E0E/6iBM;IAOI,8BAAA;IAAA,6BAAA;E1E46iBV;E0En7iBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg7iBV;E0Ev7iBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo7iBV;E0E37iBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew7iBV;E0E/7iBM;IAOI,8BAAA;IAAA,6BAAA;E1E47iBV;E0En8iBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg8iBV;E0Ev8iBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo8iBV;E0E38iBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew8iBV;E0E/8iBM;IAOI,8BAAA;IAAA,6BAAA;E1E48iBV;E0En9iBM;IAOI,yBAAA;IAAA,4BAAA;E1Eg9iBV;E0Ev9iBM;IAOI,+BAAA;IAAA,kCAAA;E1Eo9iBV;E0E39iBM;IAOI,8BAAA;IAAA,iCAAA;E1Ew9iBV;E0E/9iBM;IAOI,+BAAA;IAAA,kCAAA;E1E49iBV;E0En+iBM;IAOI,4BAAA;IAAA,+BAAA;E1Eg+iBV;E0Ev+iBM;IAOI,+BAAA;IAAA,kCAAA;E1Eo+iBV;E0E3+iBM;IAOI,8BAAA;IAAA,iCAAA;E1Ew+iBV;E0E/+iBM;IAOI,+BAAA;IAAA,kCAAA;E1E4+iBV;E0En/iBM;IAOI,4BAAA;IAAA,+BAAA;E1Eg/iBV;E0Ev/iBM;IAOI,+BAAA;IAAA,kCAAA;E1Eo/iBV;E0E3/iBM;IAOI,8BAAA;IAAA,iCAAA;E1Ew/iBV;E0E//iBM;IAOI,+BAAA;IAAA,kCAAA;E1E4/iBV;E0EngjBM;IAOI,4BAAA;IAAA,+BAAA;E1EggjBV;E0EvgjBM;IAOI,+BAAA;IAAA,kCAAA;E1EogjBV;E0E3gjBM;IAOI,8BAAA;IAAA,iCAAA;E1EwgjBV;E0E/gjBM;IAOI,+BAAA;IAAA,kCAAA;E1E4gjBV;E0EnhjBM;IAOI,4BAAA;IAAA,+BAAA;E1EghjBV;E0EvhjBM;IAOI,+BAAA;IAAA,kCAAA;E1EohjBV;E0E3hjBM;IAOI,8BAAA;IAAA,iCAAA;E1EwhjBV;E0E/hjBM;IAOI,+BAAA;IAAA,kCAAA;E1E4hjBV;E0EnijBM;IAOI,4BAAA;IAAA,+BAAA;E1EgijBV;E0EvijBM;IAOI,yBAAA;E1EmijBV;E0E1ijBM;IAOI,+BAAA;E1EsijBV;E0E7ijBM;IAOI,8BAAA;E1EyijBV;E0EhjjBM;IAOI,+BAAA;E1E4ijBV;E0EnjjBM;IAOI,4BAAA;E1E+ijBV;E0EtjjBM;IAOI,+BAAA;E1EkjjBV;E0EzjjBM;IAOI,8BAAA;E1EqjjBV;E0E5jjBM;IAOI,+BAAA;E1EwjjBV;E0E/jjBM;IAOI,4BAAA;E1E2jjBV;E0ElkjBM;IAOI,+BAAA;E1E8jjBV;E0ErkjBM;IAOI,8BAAA;E1EikjBV;E0ExkjBM;IAOI,+BAAA;E1EokjBV;E0E3kjBM;IAOI,4BAAA;E1EukjBV;E0E9kjBM;IAOI,+BAAA;E1E0kjBV;E0EjljBM;IAOI,8BAAA;E1E6kjBV;E0EpljBM;IAOI,+BAAA;E1EgljBV;E0EvljBM;IAOI,4BAAA;E1EmljBV;E0E1ljBM;IAOI,+BAAA;E1EsljBV;E0E7ljBM;IAOI,8BAAA;E1EyljBV;E0EhmjBM;IAOI,+BAAA;E1E4ljBV;E0EnmjBM;IAOI,4BAAA;E1E+ljBV;E0EtmjBM;IAOI,2BAAA;E1EkmjBV;E0EzmjBM;IAOI,iCAAA;E1EqmjBV;E0E5mjBM;IAOI,gCAAA;E1EwmjBV;E0E/mjBM;IAOI,iCAAA;E1E2mjBV;E0ElnjBM;IAOI,8BAAA;E1E8mjBV;E0ErnjBM;IAOI,iCAAA;E1EinjBV;E0ExnjBM;IAOI,gCAAA;E1EonjBV;E0E3njBM;IAOI,iCAAA;E1EunjBV;E0E9njBM;IAOI,8BAAA;E1E0njBV;E0EjojBM;IAOI,iCAAA;E1E6njBV;E0EpojBM;IAOI,gCAAA;E1EgojBV;E0EvojBM;IAOI,iCAAA;E1EmojBV;E0E1ojBM;IAOI,8BAAA;E1EsojBV;E0E7ojBM;IAOI,iCAAA;E1EyojBV;E0EhpjBM;IAOI,gCAAA;E1E4ojBV;E0EnpjBM;IAOI,iCAAA;E1E+ojBV;E0EtpjBM;IAOI,8BAAA;E1EkpjBV;E0EzpjBM;IAOI,iCAAA;E1EqpjBV;E0E5pjBM;IAOI,gCAAA;E1EwpjBV;E0E/pjBM;IAOI,iCAAA;E1E2pjBV;E0ElqjBM;IAOI,8BAAA;E1E8pjBV;E0ErqjBM;IAOI,4BAAA;E1EiqjBV;E0ExqjBM;IAOI,kCAAA;E1EoqjBV;E0E3qjBM;IAOI,iCAAA;E1EuqjBV;E0E9qjBM;IAOI,kCAAA;E1E0qjBV;E0EjrjBM;IAOI,+BAAA;E1E6qjBV;E0EprjBM;IAOI,kCAAA;E1EgrjBV;E0EvrjBM;IAOI,iCAAA;E1EmrjBV;E0E1rjBM;IAOI,kCAAA;E1EsrjBV;E0E7rjBM;IAOI,+BAAA;E1EyrjBV;E0EhsjBM;IAOI,kCAAA;E1E4rjBV;E0EnsjBM;IAOI,iCAAA;E1E+rjBV;E0EtsjBM;IAOI,kCAAA;E1EksjBV;E0EzsjBM;IAOI,+BAAA;E1EqsjBV;E0E5sjBM;IAOI,kCAAA;E1EwsjBV;E0E/sjBM;IAOI,iCAAA;E1E2sjBV;E0EltjBM;IAOI,kCAAA;E1E8sjBV;E0ErtjBM;IAOI,+BAAA;E1EitjBV;E0ExtjBM;IAOI,kCAAA;E1EotjBV;E0E3tjBM;IAOI,iCAAA;E1EutjBV;E0E9tjBM;IAOI,kCAAA;E1E0tjBV;E0EjujBM;IAOI,+BAAA;E1E6tjBV;E0EpujBM;IAOI,0BAAA;E1EgujBV;E0EvujBM;IAOI,gCAAA;E1EmujBV;E0E1ujBM;IAOI,+BAAA;E1EsujBV;E0E7ujBM;IAOI,gCAAA;E1EyujBV;E0EhvjBM;IAOI,6BAAA;E1E4ujBV;E0EnvjBM;IAOI,gCAAA;E1E+ujBV;E0EtvjBM;IAOI,+BAAA;E1EkvjBV;E0EzvjBM;IAOI,gCAAA;E1EqvjBV;E0E5vjBM;IAOI,6BAAA;E1EwvjBV;E0E/vjBM;IAOI,gCAAA;E1E2vjBV;E0ElwjBM;IAOI,+BAAA;E1E8vjBV;E0ErwjBM;IAOI,gCAAA;E1EiwjBV;E0ExwjBM;IAOI,6BAAA;E1EowjBV;E0E3wjBM;IAOI,gCAAA;E1EuwjBV;E0E9wjBM;IAOI,+BAAA;E1E0wjBV;E0EjxjBM;IAOI,gCAAA;E1E6wjBV;E0EpxjBM;IAOI,6BAAA;E1EgxjBV;E0EvxjBM;IAOI,gCAAA;E1EmxjBV;E0E1xjBM;IAOI,+BAAA;E1EsxjBV;E0E7xjBM;IAOI,gCAAA;E1EyxjBV;E0EhyjBM;IAOI,6BAAA;E1E4xjBV;E0EnyjBM;IAOI,iBAAA;E1E+xjBV;E0EtyjBM;IAOI,uBAAA;E1EkyjBV;E0EzyjBM;IAOI,sBAAA;E1EqyjBV;E0E5yjBM;IAOI,uBAAA;E1EwyjBV;E0E/yjBM;IAOI,oBAAA;E1E2yjBV;E0ElzjBM;IAOI,uBAAA;E1E8yjBV;E0ErzjBM;IAOI,sBAAA;E1EizjBV;E0ExzjBM;IAOI,uBAAA;E1EozjBV;E0E3zjBM;IAOI,oBAAA;E1EuzjBV;E0E9zjBM;IAOI,uBAAA;E1E0zjBV;E0Ej0jBM;IAOI,sBAAA;E1E6zjBV;E0Ep0jBM;IAOI,uBAAA;E1Eg0jBV;E0Ev0jBM;IAOI,oBAAA;E1Em0jBV;E0E10jBM;IAOI,uBAAA;E1Es0jBV;E0E70jBM;IAOI,sBAAA;E1Ey0jBV;E0Eh1jBM;IAOI,uBAAA;E1E40jBV;E0En1jBM;IAOI,oBAAA;E1E+0jBV;E0Et1jBM;IAOI,uBAAA;E1Ek1jBV;E0Ez1jBM;IAOI,sBAAA;E1Eq1jBV;E0E51jBM;IAOI,uBAAA;E1Ew1jBV;E0E/1jBM;IAOI,oBAAA;E1E21jBV;E0El2jBM;IAOI,qBAAA;E1E81jBV;E0Er2jBM;IAOI,2BAAA;E1Ei2jBV;E0Ex2jBM;IAOI,0BAAA;E1Eo2jBV;E0E32jBM;IAOI,2BAAA;E1Eu2jBV;E0E92jBM;IAOI,wBAAA;E1E02jBV;E0Ej3jBM;IAOI,2BAAA;E1E62jBV;E0Ep3jBM;IAOI,0BAAA;E1Eg3jBV;E0Ev3jBM;IAOI,2BAAA;E1Em3jBV;E0E13jBM;IAOI,wBAAA;E1Es3jBV;E0E73jBM;IAOI,2BAAA;E1Ey3jBV;E0Eh4jBM;IAOI,0BAAA;E1E43jBV;E0En4jBM;IAOI,2BAAA;E1E+3jBV;E0Et4jBM;IAOI,wBAAA;E1Ek4jBV;E0Ez4jBM;IAOI,2BAAA;E1Eq4jBV;E0E54jBM;IAOI,0BAAA;E1Ew4jBV;E0E/4jBM;IAOI,2BAAA;E1E24jBV;E0El5jBM;IAOI,wBAAA;E1E84jBV;E0Er5jBM;IAOI,2BAAA;E1Ei5jBV;E0Ex5jBM;IAOI,0BAAA;E1Eo5jBV;E0E35jBM;IAOI,2BAAA;E1Eu5jBV;E0E95jBM;IAOI,wBAAA;E1E05jBV;E0Ej6jBM;IAOI,wBAAA;E1E65jBV;E0Ep6jBM;IAOI,8BAAA;E1Eg6jBV;E0Ev6jBM;IAOI,6BAAA;E1Em6jBV;E0E16jBM;IAOI,8BAAA;E1Es6jBV;E0E76jBM;IAOI,2BAAA;E1Ey6jBV;E0Eh7jBM;IAOI,8BAAA;E1E46jBV;E0En7jBM;IAOI,6BAAA;E1E+6jBV;E0Et7jBM;IAOI,8BAAA;E1Ek7jBV;E0Ez7jBM;IAOI,2BAAA;E1Eq7jBV;E0E57jBM;IAOI,8BAAA;E1Ew7jBV;E0E/7jBM;IAOI,6BAAA;E1E27jBV;E0El8jBM;IAOI,8BAAA;E1E87jBV;E0Er8jBM;IAOI,2BAAA;E1Ei8jBV;E0Ex8jBM;IAOI,8BAAA;E1Eo8jBV;E0E38jBM;IAOI,6BAAA;E1Eu8jBV;E0E98jBM;IAOI,8BAAA;E1E08jBV;E0Ej9jBM;IAOI,2BAAA;E1E68jBV;E0Ep9jBM;IAOI,8BAAA;E1Eg9jBV;E0Ev9jBM;IAOI,6BAAA;E1Em9jBV;E0E19jBM;IAOI,8BAAA;E1Es9jBV;E0E79jBM;IAOI,2BAAA;E1Ey9jBV;E0Eh+jBM;IAOI,0CAAA;E1E49jBV;E0En+jBM;IAOI,4CAAA;E1E+9jBV;E0Et+jBM;IAOI,4CAAA;E1Ek+jBV;E0Ez+jBM;IAOI,6BAAA;E1Eq+jBV;E0E5+jBM;IAOI,6BAAA;E1Ew+jBV;E0E/+jBM;IAOI,8BAAA;E1E2+jBV;E0El/jBM;IAOI,6BAAA;E1E8+jBV;E0Er/jBM;IAOI,6BAAA;E1Ei/jBV;E0Ex/jBM;IAOI,6BAAA;E1Eo/jBV;E0E3/jBM;IAOI,4BAAA;E1Eu/jBV;E0E9/jBM;IAOI,6BAAA;E1E0/jBV;E0EjgkBM;IAOI,0BAAA;E1E6/jBV;E0EpgkBM;IAOI,8BAAA;E1EggkBV;E0EvgkBM;IAOI,6BAAA;E1EmgkBV;E0E1gkBM;IAOI,0BAAA;E1EsgkBV;E0E7gkBM;IAOI,4CAAA;E1EygkBV;E0EhhkBM;IAOI,2CAAA;E1E4gkBV;E0EnhkBM;IAOI,4CAAA;E1E+gkBV;E0EthkBM;IAOI,0CAAA;E1EkhkBV;E0EzhkBM;IAOI,4CAAA;E1EqhkBV;E0E5hkBM;IAOI,2CAAA;E1EwhkBV;E0E/hkBM;IAOI,4CAAA;E1E2hkBV;E0ElikBM;IAOI,wCAAA;E1E8hkBV;E0ErikBM;IAOI,4CAAA;E1EiikBV;E0ExikBM;IAOI,2CAAA;E1EoikBV;E0E3ikBM;IAOI,4CAAA;E1EuikBV;E0E9ikBM;IAOI,0CAAA;E1E0ikBV;E0EjjkBM;IAOI,4CAAA;E1E6ikBV;E0EpjkBM;IAOI,2CAAA;E1EgjkBV;E0EvjkBM;IAOI,4CAAA;E1EmjkBV;E0E1jkBM;IAOI,0CAAA;E1EsjkBV;E0E7jkBM;IAOI,4CAAA;E1EyjkBV;E0EhkkBM;IAOI,yCAAA;E1E4jkBV;E0EnkkBM;IAOI,4CAAA;E1E+jkBV;E0EtkkBM;IAOI,0CAAA;E1EkkkBV;E0EzkkBM;IAOI,4CAAA;E1EqkkBV;E0E5kkBM;IAOI,2CAAA;E1EwkkBV;E0E/kkBM;IAOI,4CAAA;E1E2kkBV;E0EllkBM;IAOI,0CAAA;E1E8kkBV;E0ErlkBM;IAOI,2BAAA;E1EilkBV;E0ExlkBM;IAOI,4BAAA;E1EolkBV;E0E3lkBM;IAOI,6BAAA;E1EulkBV;E0E9lkBM;IAOI,2BAAA;E1E0lkBV;E0EjmkBM;IAOI,yBAAA;E1E6lkBV;E0EpmkBM;IAOI,yBAAA;E1EgmkBV;E0EvmkBM;IAOI,yBAAA;E1EmmkBV;E0E1mkBM;IAOI,0BAAA;E1EsmkBV;E0E7mkBM;IAOI,0BAAA;E1EymkBV;E0EhnkBM;IAOI,yBAAA;E1E4mkBV;E0EnnkBM;IAOI,yBAAA;E1E+mkBV;E0EtnkBM;IAOI,yBAAA;E1EknkBV;E0EznkBM;IAOI,yBAAA;E1EqnkBV;E0E5nkBM;IAOI,yBAAA;E1EwnkBV;E0E/nkBM;IAOI,yBAAA;E1E2nkBV;E0ElokBM;IAOI,yBAAA;E1E8nkBV;E0ErokBM;IAOI,yBAAA;E1EiokBV;E0ExokBM;IAOI,yBAAA;E1EookBV;E0E3okBM;IAOI,0BAAA;E1EuokBV;E0E9okBM;IAOI,0BAAA;E1E0okBV;E0EjpkBM;IAOI,0BAAA;E1E6okBV;E0EppkBM;IAOI,0BAAA;E1EgpkBV;E0EvpkBM;IAOI,0BAAA;E1EmpkBV;E0E1pkBM;IAOI,0BAAA;E1EspkBV;E0E7pkBM;IAOI,0BAAA;E1EypkBV;E0EhqkBM;IAOI,0BAAA;E1E4pkBV;E0EnqkBM;IAOI,0BAAA;E1E+pkBV;E0EtqkBM;IAOI,0BAAA;E1EkqkBV;E0EzqkBM;IAOI,0BAAA;E1EqqkBV;E0E5qkBM;IAOI,0BAAA;E1EwqkBV;E0E/qkBM;IAOI,0BAAA;E1E2qkBV;E0ElrkBM;IAOI,0BAAA;E1E8qkBV;E0ErrkBM;IAOI,0BAAA;E1EirkBV;E0ExrkBM;IAOI,0BAAA;E1EorkBV;E0E3rkBM;IAOI,0BAAA;E1EurkBV;E0E9rkBM;IAOI,0BAAA;E1E0rkBV;E0EjskBM;IAOI,2BAAA;E1E6rkBV;E0EpskBM;IAOI,2BAAA;E1EgskBV;E0EvskBM;IAOI,2BAAA;E1EmskBV;E0E1skBM;IAOI,2BAAA;E1EsskBV;E0E7skBM;IAOI,2BAAA;E1EyskBV;E0EhtkBM;IAOI,2BAAA;E1E4skBV;E0EntkBM;IAOI,2BAAA;E1E+skBV;E0EttkBM;IAOI,2BAAA;E1EktkBV;E0EztkBM;IAOI,2BAAA;E1EqtkBV;E0E5tkBM;IAOI,2BAAA;E1EwtkBV;E0E/tkBM;IAOI,2BAAA;E1E2tkBV;E0ElukBM;IAOI,2BAAA;E1E8tkBV;E0ErukBM;IAOI,2BAAA;E1EiukBV;E0ExukBM;IAOI,2BAAA;E1EoukBV;E0E3ukBM;IAOI,2BAAA;E1EuukBV;E0E9ukBM;IAOI,2BAAA;E1E0ukBV;E0EjvkBM;IAOI,2BAAA;E1E6ukBV;E0EpvkBM;IAOI,2BAAA;E1EgvkBV;E0EvvkBM;IAOI,2BAAA;E1EmvkBV;E0E1vkBM;IAOI,2BAAA;E1EsvkBV;E0E7vkBM;IAOI,2BAAA;E1EyvkBV;E0EhwkBM;IAOI,2BAAA;E1E4vkBV;E0EnwkBM;IAOI,2BAAA;E1E+vkBV;E0EtwkBM;IAOI,2BAAA;E1EkwkBV;E0EzwkBM;IAOI,2BAAA;E1EqwkBV;E0E5wkBM;IAOI,2BAAA;E1EwwkBV;E0E/wkBM;IAOI,4BAAA;E1E2wkBV;E0ElxkBM;IAOI,4BAAA;E1E8wkBV;E0ErxkBM;IAOI,0BAAA;E1EixkBV;E0ExxkBM;IAOI,0BAAA;E1EoxkBV;E0E3xkBM;IAOI,0BAAA;E1EuxkBV;E0E9xkBM;IAOI,2BAAA;E1E0xkBV;E0EjykBM;IAOI,2BAAA;E1E6xkBV;E0EpykBM;IAOI,0BAAA;E1EgykBV;E0EvykBM;IAOI,0BAAA;E1EmykBV;E0E1ykBM;IAOI,0BAAA;E1EsykBV;E0E7ykBM;IAOI,0BAAA;E1EyykBV;E0EhzkBM;IAOI,0BAAA;E1E4ykBV;E0EnzkBM;IAOI,0BAAA;E1E+ykBV;E0EtzkBM;IAOI,0BAAA;E1EkzkBV;E0EzzkBM;IAOI,0BAAA;E1EqzkBV;E0E5zkBM;IAOI,0BAAA;E1EwzkBV;E0E/zkBM;IAOI,2BAAA;E1E2zkBV;E0El0kBM;IAOI,2BAAA;E1E8zkBV;E0Er0kBM;IAOI,2BAAA;E1Ei0kBV;E0Ex0kBM;IAOI,2BAAA;E1Eo0kBV;E0E30kBM;IAOI,2BAAA;E1Eu0kBV;E0E90kBM;IAOI,2BAAA;E1E00kBV;E0Ej1kBM;IAOI,2BAAA;E1E60kBV;E0Ep1kBM;IAOI,2BAAA;E1Eg1kBV;E0Ev1kBM;IAOI,2BAAA;E1Em1kBV;E0E11kBM;IAOI,2BAAA;E1Es1kBV;E0E71kBM;IAOI,2BAAA;E1Ey1kBV;E0Eh2kBM;IAOI,2BAAA;E1E41kBV;E0En2kBM;IAOI,2BAAA;E1E+1kBV;E0Et2kBM;IAOI,2BAAA;E1Ek2kBV;E0Ez2kBM;IAOI,2BAAA;E1Eq2kBV;E0E52kBM;IAOI,2BAAA;E1Ew2kBV;E0E/2kBM;IAOI,2BAAA;E1E22kBV;E0El3kBM;IAOI,2BAAA;E1E82kBV;E0Er3kBM;IAOI,4BAAA;E1Ei3kBV;E0Ex3kBM;IAOI,4BAAA;E1Eo3kBV;E0E33kBM;IAOI,4BAAA;E1Eu3kBV;E0E93kBM;IAOI,4BAAA;E1E03kBV;E0Ej4kBM;IAOI,4BAAA;E1E63kBV;E0Ep4kBM;IAOI,4BAAA;E1Eg4kBV;E0Ev4kBM;IAOI,4BAAA;E1Em4kBV;E0E14kBM;IAOI,4BAAA;E1Es4kBV;E0E74kBM;IAOI,4BAAA;E1Ey4kBV;E0Eh5kBM;IAOI,4BAAA;E1E44kBV;E0En5kBM;IAOI,4BAAA;E1E+4kBV;E0Et5kBM;IAOI,4BAAA;E1Ek5kBV;E0Ez5kBM;IAOI,4BAAA;E1Eq5kBV;E0E55kBM;IAOI,4BAAA;E1Ew5kBV;E0E/5kBM;IAOI,4BAAA;E1E25kBV;E0El6kBM;IAOI,4BAAA;E1E85kBV;E0Er6kBM;IAOI,4BAAA;E1Ei6kBV;E0Ex6kBM;IAOI,4BAAA;E1Eo6kBV;E0E36kBM;IAOI,4BAAA;E1Eu6kBV;E0E96kBM;IAOI,4BAAA;E1E06kBV;E0Ej7kBM;IAOI,4BAAA;E1E66kBV;E0Ep7kBM;IAOI,4BAAA;E1Eg7kBV;E0Ev7kBM;IAOI,4BAAA;E1Em7kBV;E0E17kBM;IAOI,4BAAA;E1Es7kBV;E0E77kBM;IAOI,4BAAA;E1Ey7kBV;E0Eh8kBM;IAOI,4BAAA;E1E47kBV;E0En8kBM;IAOI,6BAAA;E1E+7kBV;AACF;AgB18kBI;E0DGI;IAOI,sBAAA;E1Eo8kBV;E0E38kBM;IAOI,uBAAA;E1Eu8kBV;E0E98kBM;IAOI,sBAAA;E1E08kBV;E0Ej9kBM;IAOI,8BAAA;E1E68kBV;E0Ep9kBM;IAOI,4BAAA;E1Eg9kBV;E0Ev9kBM;IAOI,2BAAA;E1Em9kBV;E0E19kBM;IAOI,iCAAA;E1Es9kBV;E0E79kBM;IAOI,2BAAA;E1Ey9kBV;E0Eh+kBM;IAOI,yBAAA;E1E49kBV;E0En+kBM;IAOI,2BAAA;E1E+9kBV;E0Et+kBM;IAOI,4BAAA;E1Ek+kBV;E0Ez+kBM;IAOI,2BAAA;E1Eq+kBV;E0E5+kBM;IAOI,0BAAA;E1Ew+kBV;E0E/+kBM;IAOI,gCAAA;E1E2+kBV;E0El/kBM;IAOI,yBAAA;E1E8+kBV;E0Er/kBM;IAOI,wBAAA;E1Ei/kBV;E0Ex/kBM;IAOI,+BAAA;E1Eo/kBV;E0E3/kBM;IAOI,yBAAA;E1Eu/kBV;E0E9/kBM;IAOI,6BAAA;E1E0/kBV;E0EjglBM;IAOI,8BAAA;E1E6/kBV;E0EpglBM;IAOI,wBAAA;E1EgglBV;E0EvglBM;IAOI,+BAAA;E1EmglBV;E0E1glBM;IAOI,wBAAA;E1EsglBV;E0E7glBM;IAOI,2BAAA;E1EyglBV;E0EhhlBM;IAOI,6BAAA;E1E4glBV;E0EnhlBM;IAOI,6BAAA;E1E+glBV;E0EthlBM;IAOI,0BAAA;E1EkhlBV;E0EzhlBM;IAOI,2BAAA;E1EqhlBV;E0E5hlBM;IAOI,uBAAA;E1EwhlBV;E0E/hlBM;IAOI,qBAAA;E1E2hlBV;E0ElilBM;IAOI,qBAAA;E1E8hlBV;E0ErilBM;IAOI,qBAAA;E1EiilBV;E0ExilBM;IAOI,sBAAA;E1EoilBV;E0E3ilBM;IAOI,sBAAA;E1EuilBV;E0E9ilBM;IAOI,qBAAA;E1E0ilBV;E0EjjlBM;IAOI,qBAAA;E1E6ilBV;E0EpjlBM;IAOI,qBAAA;E1EgjlBV;E0EvjlBM;IAOI,qBAAA;E1EmjlBV;E0E1jlBM;IAOI,qBAAA;E1EsjlBV;E0E7jlBM;IAOI,qBAAA;E1EyjlBV;E0EhklBM;IAOI,qBAAA;E1E4jlBV;E0EnklBM;IAOI,qBAAA;E1E+jlBV;E0EtklBM;IAOI,qBAAA;E1EkklBV;E0EzklBM;IAOI,sBAAA;E1EqklBV;E0E5klBM;IAOI,sBAAA;E1EwklBV;E0E/klBM;IAOI,sBAAA;E1E2klBV;E0ElllBM;IAOI,sBAAA;E1E8klBV;E0ErllBM;IAOI,sBAAA;E1EillBV;E0ExllBM;IAOI,sBAAA;E1EollBV;E0E3llBM;IAOI,sBAAA;E1EullBV;E0E9llBM;IAOI,sBAAA;E1E0llBV;E0EjmlBM;IAOI,sBAAA;E1E6llBV;E0EpmlBM;IAOI,sBAAA;E1EgmlBV;E0EvmlBM;IAOI,sBAAA;E1EmmlBV;E0E1mlBM;IAOI,sBAAA;E1EsmlBV;E0E7mlBM;IAOI,sBAAA;E1EymlBV;E0EhnlBM;IAOI,sBAAA;E1E4mlBV;E0EnnlBM;IAOI,sBAAA;E1E+mlBV;E0EtnlBM;IAOI,sBAAA;E1EknlBV;E0EznlBM;IAOI,sBAAA;E1EqnlBV;E0E5nlBM;IAOI,sBAAA;E1EwnlBV;E0E/nlBM;IAOI,uBAAA;E1E2nlBV;E0ElolBM;IAOI,uBAAA;E1E8nlBV;E0ErolBM;IAOI,uBAAA;E1EiolBV;E0ExolBM;IAOI,uBAAA;E1EoolBV;E0E3olBM;IAOI,uBAAA;E1EuolBV;E0E9olBM;IAOI,uBAAA;E1E0olBV;E0EjplBM;IAOI,uBAAA;E1E6olBV;E0EpplBM;IAOI,uBAAA;E1EgplBV;E0EvplBM;IAOI,uBAAA;E1EmplBV;E0E1plBM;IAOI,uBAAA;E1EsplBV;E0E7plBM;IAOI,uBAAA;E1EyplBV;E0EhqlBM;IAOI,uBAAA;E1E4plBV;E0EnqlBM;IAOI,uBAAA;E1E+plBV;E0EtqlBM;IAOI,uBAAA;E1EkqlBV;E0EzqlBM;IAOI,uBAAA;E1EqqlBV;E0E5qlBM;IAOI,uBAAA;E1EwqlBV;E0E/qlBM;IAOI,uBAAA;E1E2qlBV;E0ElrlBM;IAOI,uBAAA;E1E8qlBV;E0ErrlBM;IAOI,uBAAA;E1EirlBV;E0ExrlBM;IAOI,uBAAA;E1EorlBV;E0E3rlBM;IAOI,uBAAA;E1EurlBV;E0E9rlBM;IAOI,uBAAA;E1E0rlBV;E0EjslBM;IAOI,uBAAA;E1E6rlBV;E0EpslBM;IAOI,uBAAA;E1EgslBV;E0EvslBM;IAOI,uBAAA;E1EmslBV;E0E1slBM;IAOI,uBAAA;E1EsslBV;E0E7slBM;IAOI,wBAAA;E1EyslBV;E0EhtlBM;IAOI,2BAAA;E1E4slBV;E0EntlBM;IAOI,yBAAA;E1E+slBV;E0EttlBM;IAOI,yBAAA;E1EktlBV;E0EztlBM;IAOI,yBAAA;E1EqtlBV;E0E5tlBM;IAOI,0BAAA;E1EwtlBV;E0E/tlBM;IAOI,0BAAA;E1E2tlBV;E0ElulBM;IAOI,yBAAA;E1E8tlBV;E0ErulBM;IAOI,yBAAA;E1EiulBV;E0ExulBM;IAOI,yBAAA;E1EoulBV;E0E3ulBM;IAOI,yBAAA;E1EuulBV;E0E9ulBM;IAOI,yBAAA;E1E0ulBV;E0EjvlBM;IAOI,yBAAA;E1E6ulBV;E0EpvlBM;IAOI,yBAAA;E1EgvlBV;E0EvvlBM;IAOI,yBAAA;E1EmvlBV;E0E1vlBM;IAOI,yBAAA;E1EsvlBV;E0E7vlBM;IAOI,0BAAA;E1EyvlBV;E0EhwlBM;IAOI,0BAAA;E1E4vlBV;E0EnwlBM;IAOI,0BAAA;E1E+vlBV;E0EtwlBM;IAOI,0BAAA;E1EkwlBV;E0EzwlBM;IAOI,0BAAA;E1EqwlBV;E0E5wlBM;IAOI,0BAAA;E1EwwlBV;E0E/wlBM;IAOI,0BAAA;E1E2wlBV;E0ElxlBM;IAOI,0BAAA;E1E8wlBV;E0ErxlBM;IAOI,0BAAA;E1EixlBV;E0ExxlBM;IAOI,0BAAA;E1EoxlBV;E0E3xlBM;IAOI,0BAAA;E1EuxlBV;E0E9xlBM;IAOI,0BAAA;E1E0xlBV;E0EjylBM;IAOI,0BAAA;E1E6xlBV;E0EpylBM;IAOI,0BAAA;E1EgylBV;E0EvylBM;IAOI,0BAAA;E1EmylBV;E0E1ylBM;IAOI,0BAAA;E1EsylBV;E0E7ylBM;IAOI,0BAAA;E1EyylBV;E0EhzlBM;IAOI,0BAAA;E1E4ylBV;E0EnzlBM;IAOI,2BAAA;E1E+ylBV;E0EtzlBM;IAOI,2BAAA;E1EkzlBV;E0EzzlBM;IAOI,2BAAA;E1EqzlBV;E0E5zlBM;IAOI,2BAAA;E1EwzlBV;E0E/zlBM;IAOI,2BAAA;E1E2zlBV;E0El0lBM;IAOI,2BAAA;E1E8zlBV;E0Er0lBM;IAOI,2BAAA;E1Ei0lBV;E0Ex0lBM;IAOI,2BAAA;E1Eo0lBV;E0E30lBM;IAOI,2BAAA;E1Eu0lBV;E0E90lBM;IAOI,2BAAA;E1E00lBV;E0Ej1lBM;IAOI,2BAAA;E1E60lBV;E0Ep1lBM;IAOI,2BAAA;E1Eg1lBV;E0Ev1lBM;IAOI,2BAAA;E1Em1lBV;E0E11lBM;IAOI,2BAAA;E1Es1lBV;E0E71lBM;IAOI,2BAAA;E1Ey1lBV;E0Eh2lBM;IAOI,2BAAA;E1E41lBV;E0En2lBM;IAOI,2BAAA;E1E+1lBV;E0Et2lBM;IAOI,2BAAA;E1Ek2lBV;E0Ez2lBM;IAOI,2BAAA;E1Eq2lBV;E0E52lBM;IAOI,2BAAA;E1Ew2lBV;E0E/2lBM;IAOI,2BAAA;E1E22lBV;E0El3lBM;IAOI,2BAAA;E1E82lBV;E0Er3lBM;IAOI,2BAAA;E1Ei3lBV;E0Ex3lBM;IAOI,2BAAA;E1Eo3lBV;E0E33lBM;IAOI,2BAAA;E1Eu3lBV;E0E93lBM;IAOI,2BAAA;E1E03lBV;E0Ej4lBM;IAOI,4BAAA;E1E63lBV;E0Ep4lBM;IAOI,wBAAA;E1Eg4lBV;E0Ev4lBM;IAOI,sBAAA;E1Em4lBV;E0E14lBM;IAOI,sBAAA;E1Es4lBV;E0E74lBM;IAOI,sBAAA;E1Ey4lBV;E0Eh5lBM;IAOI,uBAAA;E1E44lBV;E0En5lBM;IAOI,uBAAA;E1E+4lBV;E0Et5lBM;IAOI,sBAAA;E1Ek5lBV;E0Ez5lBM;IAOI,sBAAA;E1Eq5lBV;E0E55lBM;IAOI,sBAAA;E1Ew5lBV;E0E/5lBM;IAOI,sBAAA;E1E25lBV;E0El6lBM;IAOI,sBAAA;E1E85lBV;E0Er6lBM;IAOI,sBAAA;E1Ei6lBV;E0Ex6lBM;IAOI,sBAAA;E1Eo6lBV;E0E36lBM;IAOI,sBAAA;E1Eu6lBV;E0E96lBM;IAOI,sBAAA;E1E06lBV;E0Ej7lBM;IAOI,uBAAA;E1E66lBV;E0Ep7lBM;IAOI,uBAAA;E1Eg7lBV;E0Ev7lBM;IAOI,uBAAA;E1Em7lBV;E0E17lBM;IAOI,uBAAA;E1Es7lBV;E0E77lBM;IAOI,uBAAA;E1Ey7lBV;E0Eh8lBM;IAOI,uBAAA;E1E47lBV;E0En8lBM;IAOI,uBAAA;E1E+7lBV;E0Et8lBM;IAOI,uBAAA;E1Ek8lBV;E0Ez8lBM;IAOI,uBAAA;E1Eq8lBV;E0E58lBM;IAOI,uBAAA;E1Ew8lBV;E0E/8lBM;IAOI,uBAAA;E1E28lBV;E0El9lBM;IAOI,uBAAA;E1E88lBV;E0Er9lBM;IAOI,uBAAA;E1Ei9lBV;E0Ex9lBM;IAOI,uBAAA;E1Eo9lBV;E0E39lBM;IAOI,uBAAA;E1Eu9lBV;E0E99lBM;IAOI,uBAAA;E1E09lBV;E0Ej+lBM;IAOI,uBAAA;E1E69lBV;E0Ep+lBM;IAOI,uBAAA;E1Eg+lBV;E0Ev+lBM;IAOI,wBAAA;E1Em+lBV;E0E1+lBM;IAOI,wBAAA;E1Es+lBV;E0E7+lBM;IAOI,wBAAA;E1Ey+lBV;E0Eh/lBM;IAOI,wBAAA;E1E4+lBV;E0En/lBM;IAOI,wBAAA;E1E++lBV;E0Et/lBM;IAOI,wBAAA;E1Ek/lBV;E0Ez/lBM;IAOI,wBAAA;E1Eq/lBV;E0E5/lBM;IAOI,wBAAA;E1Ew/lBV;E0E//lBM;IAOI,wBAAA;E1E2/lBV;E0ElgmBM;IAOI,wBAAA;E1E8/lBV;E0ErgmBM;IAOI,wBAAA;E1EigmBV;E0ExgmBM;IAOI,wBAAA;E1EogmBV;E0E3gmBM;IAOI,wBAAA;E1EugmBV;E0E9gmBM;IAOI,wBAAA;E1E0gmBV;E0EjhmBM;IAOI,wBAAA;E1E6gmBV;E0EphmBM;IAOI,wBAAA;E1EghmBV;E0EvhmBM;IAOI,wBAAA;E1EmhmBV;E0E1hmBM;IAOI,wBAAA;E1EshmBV;E0E7hmBM;IAOI,wBAAA;E1EyhmBV;E0EhimBM;IAOI,wBAAA;E1E4hmBV;E0EnimBM;IAOI,wBAAA;E1E+hmBV;E0EtimBM;IAOI,wBAAA;E1EkimBV;E0EzimBM;IAOI,wBAAA;E1EqimBV;E0E5imBM;IAOI,wBAAA;E1EwimBV;E0E/imBM;IAOI,wBAAA;E1E2imBV;E0EljmBM;IAOI,wBAAA;E1E8imBV;E0ErjmBM;IAOI,yBAAA;E1EijmBV;E0ExjmBM;IAOI,4BAAA;E1EojmBV;E0E3jmBM;IAOI,0BAAA;E1EujmBV;E0E9jmBM;IAOI,0BAAA;E1E0jmBV;E0EjkmBM;IAOI,0BAAA;E1E6jmBV;E0EpkmBM;IAOI,2BAAA;E1EgkmBV;E0EvkmBM;IAOI,2BAAA;E1EmkmBV;E0E1kmBM;IAOI,0BAAA;E1EskmBV;E0E7kmBM;IAOI,0BAAA;E1EykmBV;E0EhlmBM;IAOI,0BAAA;E1E4kmBV;E0EnlmBM;IAOI,0BAAA;E1E+kmBV;E0EtlmBM;IAOI,0BAAA;E1EklmBV;E0EzlmBM;IAOI,0BAAA;E1EqlmBV;E0E5lmBM;IAOI,0BAAA;E1EwlmBV;E0E/lmBM;IAOI,0BAAA;E1E2lmBV;E0ElmmBM;IAOI,0BAAA;E1E8lmBV;E0ErmmBM;IAOI,2BAAA;E1EimmBV;E0ExmmBM;IAOI,2BAAA;E1EommBV;E0E3mmBM;IAOI,2BAAA;E1EummBV;E0E9mmBM;IAOI,2BAAA;E1E0mmBV;E0EjnmBM;IAOI,2BAAA;E1E6mmBV;E0EpnmBM;IAOI,2BAAA;E1EgnmBV;E0EvnmBM;IAOI,2BAAA;E1EmnmBV;E0E1nmBM;IAOI,2BAAA;E1EsnmBV;E0E7nmBM;IAOI,2BAAA;E1EynmBV;E0EhomBM;IAOI,2BAAA;E1E4nmBV;E0EnomBM;IAOI,2BAAA;E1E+nmBV;E0EtomBM;IAOI,2BAAA;E1EkomBV;E0EzomBM;IAOI,2BAAA;E1EqomBV;E0E5omBM;IAOI,2BAAA;E1EwomBV;E0E/omBM;IAOI,2BAAA;E1E2omBV;E0ElpmBM;IAOI,2BAAA;E1E8omBV;E0ErpmBM;IAOI,2BAAA;E1EipmBV;E0ExpmBM;IAOI,2BAAA;E1EopmBV;E0E3pmBM;IAOI,4BAAA;E1EupmBV;E0E9pmBM;IAOI,4BAAA;E1E0pmBV;E0EjqmBM;IAOI,4BAAA;E1E6pmBV;E0EpqmBM;IAOI,4BAAA;E1EgqmBV;E0EvqmBM;IAOI,4BAAA;E1EmqmBV;E0E1qmBM;IAOI,4BAAA;E1EsqmBV;E0E7qmBM;IAOI,4BAAA;E1EyqmBV;E0EhrmBM;IAOI,4BAAA;E1E4qmBV;E0EnrmBM;IAOI,4BAAA;E1E+qmBV;E0EtrmBM;IAOI,4BAAA;E1EkrmBV;E0EzrmBM;IAOI,4BAAA;E1EqrmBV;E0E5rmBM;IAOI,4BAAA;E1EwrmBV;E0E/rmBM;IAOI,4BAAA;E1E2rmBV;E0ElsmBM;IAOI,4BAAA;E1E8rmBV;E0ErsmBM;IAOI,4BAAA;E1EismBV;E0ExsmBM;IAOI,4BAAA;E1EosmBV;E0E3smBM;IAOI,4BAAA;E1EusmBV;E0E9smBM;IAOI,4BAAA;E1E0smBV;E0EjtmBM;IAOI,4BAAA;E1E6smBV;E0EptmBM;IAOI,4BAAA;E1EgtmBV;E0EvtmBM;IAOI,4BAAA;E1EmtmBV;E0E1tmBM;IAOI,4BAAA;E1EstmBV;E0E7tmBM;IAOI,4BAAA;E1EytmBV;E0EhumBM;IAOI,4BAAA;E1E4tmBV;E0EnumBM;IAOI,4BAAA;E1E+tmBV;E0EtumBM;IAOI,4BAAA;E1EkumBV;E0EzumBM;IAOI,6BAAA;E1EqumBV;E0E5umBM;IAOI,yBAAA;E1EwumBV;E0E/umBM;IAOI,8BAAA;E1E2umBV;E0ElvmBM;IAOI,iCAAA;E1E8umBV;E0ErvmBM;IAOI,sCAAA;E1EivmBV;E0ExvmBM;IAOI,yCAAA;E1EovmBV;E0E3vmBM;IAOI,uBAAA;E1EuvmBV;E0E9vmBM;IAOI,uBAAA;E1E0vmBV;E0EjwmBM;IAOI,yBAAA;E1E6vmBV;E0EpwmBM;IAOI,yBAAA;E1EgwmBV;E0EvwmBM;IAOI,0BAAA;E1EmwmBV;E0E1wmBM;IAOI,4BAAA;E1EswmBV;E0E7wmBM;IAOI,kCAAA;E1EywmBV;E0EhxmBM;IAOI,sCAAA;E1E4wmBV;E0EnxmBM;IAOI,oCAAA;E1E+wmBV;E0EtxmBM;IAOI,kCAAA;E1EkxmBV;E0EzxmBM;IAOI,yCAAA;E1EqxmBV;E0E5xmBM;IAOI,wCAAA;E1EwxmBV;E0E/xmBM;IAOI,wCAAA;E1E2xmBV;E0ElymBM;IAOI,kCAAA;E1E8xmBV;E0ErymBM;IAOI,gCAAA;E1EiymBV;E0ExymBM;IAOI,8BAAA;E1EoymBV;E0E3ymBM;IAOI,gCAAA;E1EuymBV;E0E9ymBM;IAOI,+BAAA;E1E0ymBV;E0EjzmBM;IAOI,oCAAA;E1E6ymBV;E0EpzmBM;IAOI,kCAAA;E1EgzmBV;E0EvzmBM;IAOI,gCAAA;E1EmzmBV;E0E1zmBM;IAOI,uCAAA;E1EszmBV;E0E7zmBM;IAOI,sCAAA;E1EyzmBV;E0Eh0mBM;IAOI,iCAAA;E1E4zmBV;E0En0mBM;IAOI,2BAAA;E1E+zmBV;E0Et0mBM;IAOI,iCAAA;E1Ek0mBV;E0Ez0mBM;IAOI,+BAAA;E1Eq0mBV;E0E50mBM;IAOI,6BAAA;E1Ew0mBV;E0E/0mBM;IAOI,+BAAA;E1E20mBV;E0El1mBM;IAOI,8BAAA;E1E80mBV;E0Er1mBM;IAOI,oBAAA;E1Ei1mBV;E0Ex1mBM;IAOI,mBAAA;E1Eo1mBV;E0E31mBM;IAOI,mBAAA;E1Eu1mBV;E0E91mBM;IAOI,mBAAA;E1E01mBV;E0Ej2mBM;IAOI,mBAAA;E1E61mBV;E0Ep2mBM;IAOI,mBAAA;E1Eg2mBV;E0Ev2mBM;IAOI,mBAAA;E1Em2mBV;E0E12mBM;IAOI,mBAAA;E1Es2mBV;E0E72mBM;IAOI,oBAAA;E1Ey2mBV;E0Eh3mBM;IAOI,0BAAA;E1E42mBV;E0En3mBM;IAOI,yBAAA;E1E+2mBV;E0Et3mBM;IAOI,0BAAA;E1Ek3mBV;E0Ez3mBM;IAOI,uBAAA;E1Eq3mBV;E0E53mBM;IAOI,0BAAA;E1Ew3mBV;E0E/3mBM;IAOI,yBAAA;E1E23mBV;E0El4mBM;IAOI,0BAAA;E1E83mBV;E0Er4mBM;IAOI,uBAAA;E1Ei4mBV;E0Ex4mBM;IAOI,0BAAA;E1Eo4mBV;E0E34mBM;IAOI,yBAAA;E1Eu4mBV;E0E94mBM;IAOI,0BAAA;E1E04mBV;E0Ej5mBM;IAOI,uBAAA;E1E64mBV;E0Ep5mBM;IAOI,0BAAA;E1Eg5mBV;E0Ev5mBM;IAOI,yBAAA;E1Em5mBV;E0E15mBM;IAOI,0BAAA;E1Es5mBV;E0E75mBM;IAOI,uBAAA;E1Ey5mBV;E0Eh6mBM;IAOI,0BAAA;E1E45mBV;E0En6mBM;IAOI,yBAAA;E1E+5mBV;E0Et6mBM;IAOI,0BAAA;E1Ek6mBV;E0Ez6mBM;IAOI,uBAAA;E1Eq6mBV;E0E56mBM;IAOI,uBAAA;E1Ew6mBV;E0E/6mBM;IAOI,0BAAA;IAAA,yBAAA;E1E46mBV;E0En7mBM;IAOI,gCAAA;IAAA,+BAAA;E1Eg7mBV;E0Ev7mBM;IAOI,+BAAA;IAAA,8BAAA;E1Eo7mBV;E0E37mBM;IAOI,gCAAA;IAAA,+BAAA;E1Ew7mBV;E0E/7mBM;IAOI,6BAAA;IAAA,4BAAA;E1E47mBV;E0En8mBM;IAOI,gCAAA;IAAA,+BAAA;E1Eg8mBV;E0Ev8mBM;IAOI,+BAAA;IAAA,8BAAA;E1Eo8mBV;E0E38mBM;IAOI,gCAAA;IAAA,+BAAA;E1Ew8mBV;E0E/8mBM;IAOI,6BAAA;IAAA,4BAAA;E1E48mBV;E0En9mBM;IAOI,gCAAA;IAAA,+BAAA;E1Eg9mBV;E0Ev9mBM;IAOI,+BAAA;IAAA,8BAAA;E1Eo9mBV;E0E39mBM;IAOI,gCAAA;IAAA,+BAAA;E1Ew9mBV;E0E/9mBM;IAOI,6BAAA;IAAA,4BAAA;E1E49mBV;E0En+mBM;IAOI,gCAAA;IAAA,+BAAA;E1Eg+mBV;E0Ev+mBM;IAOI,+BAAA;IAAA,8BAAA;E1Eo+mBV;E0E3+mBM;IAOI,gCAAA;IAAA,+BAAA;E1Ew+mBV;E0E/+mBM;IAOI,6BAAA;IAAA,4BAAA;E1E4+mBV;E0En/mBM;IAOI,gCAAA;IAAA,+BAAA;E1Eg/mBV;E0Ev/mBM;IAOI,+BAAA;IAAA,8BAAA;E1Eo/mBV;E0E3/mBM;IAOI,gCAAA;IAAA,+BAAA;E1Ew/mBV;E0E//mBM;IAOI,6BAAA;IAAA,4BAAA;E1E4/mBV;E0EngnBM;IAOI,6BAAA;IAAA,4BAAA;E1EggnBV;E0EvgnBM;IAOI,wBAAA;IAAA,2BAAA;E1EognBV;E0E3gnBM;IAOI,8BAAA;IAAA,iCAAA;E1EwgnBV;E0E/gnBM;IAOI,6BAAA;IAAA,gCAAA;E1E4gnBV;E0EnhnBM;IAOI,8BAAA;IAAA,iCAAA;E1EghnBV;E0EvhnBM;IAOI,2BAAA;IAAA,8BAAA;E1EohnBV;E0E3hnBM;IAOI,8BAAA;IAAA,iCAAA;E1EwhnBV;E0E/hnBM;IAOI,6BAAA;IAAA,gCAAA;E1E4hnBV;E0EninBM;IAOI,8BAAA;IAAA,iCAAA;E1EginBV;E0EvinBM;IAOI,2BAAA;IAAA,8BAAA;E1EoinBV;E0E3inBM;IAOI,8BAAA;IAAA,iCAAA;E1EwinBV;E0E/inBM;IAOI,6BAAA;IAAA,gCAAA;E1E4inBV;E0EnjnBM;IAOI,8BAAA;IAAA,iCAAA;E1EgjnBV;E0EvjnBM;IAOI,2BAAA;IAAA,8BAAA;E1EojnBV;E0E3jnBM;IAOI,8BAAA;IAAA,iCAAA;E1EwjnBV;E0E/jnBM;IAOI,6BAAA;IAAA,gCAAA;E1E4jnBV;E0EnknBM;IAOI,8BAAA;IAAA,iCAAA;E1EgknBV;E0EvknBM;IAOI,2BAAA;IAAA,8BAAA;E1EoknBV;E0E3knBM;IAOI,8BAAA;IAAA,iCAAA;E1EwknBV;E0E/knBM;IAOI,6BAAA;IAAA,gCAAA;E1E4knBV;E0EnlnBM;IAOI,8BAAA;IAAA,iCAAA;E1EglnBV;E0EvlnBM;IAOI,2BAAA;IAAA,8BAAA;E1EolnBV;E0E3lnBM;IAOI,2BAAA;IAAA,8BAAA;E1EwlnBV;E0E/lnBM;IAOI,wBAAA;E1E2lnBV;E0ElmnBM;IAOI,8BAAA;E1E8lnBV;E0ErmnBM;IAOI,6BAAA;E1EimnBV;E0ExmnBM;IAOI,8BAAA;E1EomnBV;E0E3mnBM;IAOI,2BAAA;E1EumnBV;E0E9mnBM;IAOI,8BAAA;E1E0mnBV;E0EjnnBM;IAOI,6BAAA;E1E6mnBV;E0EpnnBM;IAOI,8BAAA;E1EgnnBV;E0EvnnBM;IAOI,2BAAA;E1EmnnBV;E0E1nnBM;IAOI,8BAAA;E1EsnnBV;E0E7nnBM;IAOI,6BAAA;E1EynnBV;E0EhonBM;IAOI,8BAAA;E1E4nnBV;E0EnonBM;IAOI,2BAAA;E1E+nnBV;E0EtonBM;IAOI,8BAAA;E1EkonBV;E0EzonBM;IAOI,6BAAA;E1EqonBV;E0E5onBM;IAOI,8BAAA;E1EwonBV;E0E/onBM;IAOI,2BAAA;E1E2onBV;E0ElpnBM;IAOI,8BAAA;E1E8onBV;E0ErpnBM;IAOI,6BAAA;E1EipnBV;E0ExpnBM;IAOI,8BAAA;E1EopnBV;E0E3pnBM;IAOI,2BAAA;E1EupnBV;E0E9pnBM;IAOI,2BAAA;E1E0pnBV;E0EjqnBM;IAOI,0BAAA;E1E6pnBV;E0EpqnBM;IAOI,gCAAA;E1EgqnBV;E0EvqnBM;IAOI,+BAAA;E1EmqnBV;E0E1qnBM;IAOI,gCAAA;E1EsqnBV;E0E7qnBM;IAOI,6BAAA;E1EyqnBV;E0EhrnBM;IAOI,gCAAA;E1E4qnBV;E0EnrnBM;IAOI,+BAAA;E1E+qnBV;E0EtrnBM;IAOI,gCAAA;E1EkrnBV;E0EzrnBM;IAOI,6BAAA;E1EqrnBV;E0E5rnBM;IAOI,gCAAA;E1EwrnBV;E0E/rnBM;IAOI,+BAAA;E1E2rnBV;E0ElsnBM;IAOI,gCAAA;E1E8rnBV;E0ErsnBM;IAOI,6BAAA;E1EisnBV;E0ExsnBM;IAOI,gCAAA;E1EosnBV;E0E3snBM;IAOI,+BAAA;E1EusnBV;E0E9snBM;IAOI,gCAAA;E1E0snBV;E0EjtnBM;IAOI,6BAAA;E1E6snBV;E0EptnBM;IAOI,gCAAA;E1EgtnBV;E0EvtnBM;IAOI,+BAAA;E1EmtnBV;E0E1tnBM;IAOI,gCAAA;E1EstnBV;E0E7tnBM;IAOI,6BAAA;E1EytnBV;E0EhunBM;IAOI,6BAAA;E1E4tnBV;E0EnunBM;IAOI,2BAAA;E1E+tnBV;E0EtunBM;IAOI,iCAAA;E1EkunBV;E0EzunBM;IAOI,gCAAA;E1EqunBV;E0E5unBM;IAOI,iCAAA;E1EwunBV;E0E/unBM;IAOI,8BAAA;E1E2unBV;E0ElvnBM;IAOI,iCAAA;E1E8unBV;E0ErvnBM;IAOI,gCAAA;E1EivnBV;E0ExvnBM;IAOI,iCAAA;E1EovnBV;E0E3vnBM;IAOI,8BAAA;E1EuvnBV;E0E9vnBM;IAOI,iCAAA;E1E0vnBV;E0EjwnBM;IAOI,gCAAA;E1E6vnBV;E0EpwnBM;IAOI,iCAAA;E1EgwnBV;E0EvwnBM;IAOI,8BAAA;E1EmwnBV;E0E1wnBM;IAOI,iCAAA;E1EswnBV;E0E7wnBM;IAOI,gCAAA;E1EywnBV;E0EhxnBM;IAOI,iCAAA;E1E4wnBV;E0EnxnBM;IAOI,8BAAA;E1E+wnBV;E0EtxnBM;IAOI,iCAAA;E1EkxnBV;E0EzxnBM;IAOI,gCAAA;E1EqxnBV;E0E5xnBM;IAOI,iCAAA;E1EwxnBV;E0E/xnBM;IAOI,8BAAA;E1E2xnBV;E0ElynBM;IAOI,8BAAA;E1E8xnBV;E0ErynBM;IAOI,yBAAA;E1EiynBV;E0ExynBM;IAOI,+BAAA;E1EoynBV;E0E3ynBM;IAOI,8BAAA;E1EuynBV;E0E9ynBM;IAOI,+BAAA;E1E0ynBV;E0EjznBM;IAOI,4BAAA;E1E6ynBV;E0EpznBM;IAOI,+BAAA;E1EgznBV;E0EvznBM;IAOI,8BAAA;E1EmznBV;E0E1znBM;IAOI,+BAAA;E1EsznBV;E0E7znBM;IAOI,4BAAA;E1EyznBV;E0Eh0nBM;IAOI,+BAAA;E1E4znBV;E0En0nBM;IAOI,8BAAA;E1E+znBV;E0Et0nBM;IAOI,+BAAA;E1Ek0nBV;E0Ez0nBM;IAOI,4BAAA;E1Eq0nBV;E0E50nBM;IAOI,+BAAA;E1Ew0nBV;E0E/0nBM;IAOI,8BAAA;E1E20nBV;E0El1nBM;IAOI,+BAAA;E1E80nBV;E0Er1nBM;IAOI,4BAAA;E1Ei1nBV;E0Ex1nBM;IAOI,+BAAA;E1Eo1nBV;E0E31nBM;IAOI,8BAAA;E1Eu1nBV;E0E91nBM;IAOI,+BAAA;E1E01nBV;E0Ej2nBM;IAOI,4BAAA;E1E61nBV;E0Ep2nBM;IAOI,4BAAA;E1Eg2nBV;E0Ev2nBM;IAOI,2BAAA;E1Em2nBV;E0E12nBM;IAOI,0BAAA;E1Es2nBV;E0E72nBM;IAOI,2BAAA;E1Ey2nBV;E0Eh3nBM;IAOI,wBAAA;E1E42nBV;E0En3nBM;IAOI,2BAAA;E1E+2nBV;E0Et3nBM;IAOI,0BAAA;E1Ek3nBV;E0Ez3nBM;IAOI,2BAAA;E1Eq3nBV;E0E53nBM;IAOI,wBAAA;E1Ew3nBV;E0E/3nBM;IAOI,2BAAA;E1E23nBV;E0El4nBM;IAOI,0BAAA;E1E83nBV;E0Er4nBM;IAOI,2BAAA;E1Ei4nBV;E0Ex4nBM;IAOI,wBAAA;E1Eo4nBV;E0E34nBM;IAOI,2BAAA;E1Eu4nBV;E0E94nBM;IAOI,0BAAA;E1E04nBV;E0Ej5nBM;IAOI,2BAAA;E1E64nBV;E0Ep5nBM;IAOI,wBAAA;E1Eg5nBV;E0Ev5nBM;IAOI,2BAAA;E1Em5nBV;E0E15nBM;IAOI,0BAAA;E1Es5nBV;E0E75nBM;IAOI,2BAAA;E1Ey5nBV;E0Eh6nBM;IAOI,wBAAA;E1E45nBV;E0En6nBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg6nBV;E0Ev6nBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo6nBV;E0E36nBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew6nBV;E0E/6nBM;IAOI,8BAAA;IAAA,6BAAA;E1E46nBV;E0En7nBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg7nBV;E0Ev7nBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo7nBV;E0E37nBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew7nBV;E0E/7nBM;IAOI,8BAAA;IAAA,6BAAA;E1E47nBV;E0En8nBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg8nBV;E0Ev8nBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo8nBV;E0E38nBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew8nBV;E0E/8nBM;IAOI,8BAAA;IAAA,6BAAA;E1E48nBV;E0En9nBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg9nBV;E0Ev9nBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo9nBV;E0E39nBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew9nBV;E0E/9nBM;IAOI,8BAAA;IAAA,6BAAA;E1E49nBV;E0En+nBM;IAOI,iCAAA;IAAA,gCAAA;E1Eg+nBV;E0Ev+nBM;IAOI,gCAAA;IAAA,+BAAA;E1Eo+nBV;E0E3+nBM;IAOI,iCAAA;IAAA,gCAAA;E1Ew+nBV;E0E/+nBM;IAOI,8BAAA;IAAA,6BAAA;E1E4+nBV;E0En/nBM;IAOI,+BAAA;IAAA,kCAAA;E1Eg/nBV;E0Ev/nBM;IAOI,8BAAA;IAAA,iCAAA;E1Eo/nBV;E0E3/nBM;IAOI,+BAAA;IAAA,kCAAA;E1Ew/nBV;E0E//nBM;IAOI,4BAAA;IAAA,+BAAA;E1E4/nBV;E0EngoBM;IAOI,+BAAA;IAAA,kCAAA;E1EggoBV;E0EvgoBM;IAOI,8BAAA;IAAA,iCAAA;E1EogoBV;E0E3goBM;IAOI,+BAAA;IAAA,kCAAA;E1EwgoBV;E0E/goBM;IAOI,4BAAA;IAAA,+BAAA;E1E4goBV;E0EnhoBM;IAOI,+BAAA;IAAA,kCAAA;E1EghoBV;E0EvhoBM;IAOI,8BAAA;IAAA,iCAAA;E1EohoBV;E0E3hoBM;IAOI,+BAAA;IAAA,kCAAA;E1EwhoBV;E0E/hoBM;IAOI,4BAAA;IAAA,+BAAA;E1E4hoBV;E0EnioBM;IAOI,+BAAA;IAAA,kCAAA;E1EgioBV;E0EvioBM;IAOI,8BAAA;IAAA,iCAAA;E1EoioBV;E0E3ioBM;IAOI,+BAAA;IAAA,kCAAA;E1EwioBV;E0E/ioBM;IAOI,4BAAA;IAAA,+BAAA;E1E4ioBV;E0EnjoBM;IAOI,+BAAA;IAAA,kCAAA;E1EgjoBV;E0EvjoBM;IAOI,8BAAA;IAAA,iCAAA;E1EojoBV;E0E3joBM;IAOI,+BAAA;IAAA,kCAAA;E1EwjoBV;E0E/joBM;IAOI,4BAAA;IAAA,+BAAA;E1E4joBV;E0EnkoBM;IAOI,+BAAA;E1E+joBV;E0EtkoBM;IAOI,8BAAA;E1EkkoBV;E0EzkoBM;IAOI,+BAAA;E1EqkoBV;E0E5koBM;IAOI,4BAAA;E1EwkoBV;E0E/koBM;IAOI,+BAAA;E1E2koBV;E0ElloBM;IAOI,8BAAA;E1E8koBV;E0ErloBM;IAOI,+BAAA;E1EiloBV;E0ExloBM;IAOI,4BAAA;E1EoloBV;E0E3loBM;IAOI,+BAAA;E1EuloBV;E0E9loBM;IAOI,8BAAA;E1E0loBV;E0EjmoBM;IAOI,+BAAA;E1E6loBV;E0EpmoBM;IAOI,4BAAA;E1EgmoBV;E0EvmoBM;IAOI,+BAAA;E1EmmoBV;E0E1moBM;IAOI,8BAAA;E1EsmoBV;E0E7moBM;IAOI,+BAAA;E1EymoBV;E0EhnoBM;IAOI,4BAAA;E1E4moBV;E0EnnoBM;IAOI,+BAAA;E1E+moBV;E0EtnoBM;IAOI,8BAAA;E1EknoBV;E0EznoBM;IAOI,+BAAA;E1EqnoBV;E0E5noBM;IAOI,4BAAA;E1EwnoBV;E0E/noBM;IAOI,iCAAA;E1E2noBV;E0ElooBM;IAOI,gCAAA;E1E8noBV;E0ErooBM;IAOI,iCAAA;E1EiooBV;E0ExooBM;IAOI,8BAAA;E1EoooBV;E0E3ooBM;IAOI,iCAAA;E1EuooBV;E0E9ooBM;IAOI,gCAAA;E1E0ooBV;E0EjpoBM;IAOI,iCAAA;E1E6ooBV;E0EppoBM;IAOI,8BAAA;E1EgpoBV;E0EvpoBM;IAOI,iCAAA;E1EmpoBV;E0E1poBM;IAOI,gCAAA;E1EspoBV;E0E7poBM;IAOI,iCAAA;E1EypoBV;E0EhqoBM;IAOI,8BAAA;E1E4poBV;E0EnqoBM;IAOI,iCAAA;E1E+poBV;E0EtqoBM;IAOI,gCAAA;E1EkqoBV;E0EzqoBM;IAOI,iCAAA;E1EqqoBV;E0E5qoBM;IAOI,8BAAA;E1EwqoBV;E0E/qoBM;IAOI,iCAAA;E1E2qoBV;E0ElroBM;IAOI,gCAAA;E1E8qoBV;E0ErroBM;IAOI,iCAAA;E1EiroBV;E0ExroBM;IAOI,8BAAA;E1EoroBV;E0E3roBM;IAOI,kCAAA;E1EuroBV;E0E9roBM;IAOI,iCAAA;E1E0roBV;E0EjsoBM;IAOI,kCAAA;E1E6roBV;E0EpsoBM;IAOI,+BAAA;E1EgsoBV;E0EvsoBM;IAOI,kCAAA;E1EmsoBV;E0E1soBM;IAOI,iCAAA;E1EssoBV;E0E7soBM;IAOI,kCAAA;E1EysoBV;E0EhtoBM;IAOI,+BAAA;E1E4soBV;E0EntoBM;IAOI,kCAAA;E1E+soBV;E0EttoBM;IAOI,iCAAA;E1EktoBV;E0EztoBM;IAOI,kCAAA;E1EqtoBV;E0E5toBM;IAOI,+BAAA;E1EwtoBV;E0E/toBM;IAOI,kCAAA;E1E2toBV;E0EluoBM;IAOI,iCAAA;E1E8toBV;E0EruoBM;IAOI,kCAAA;E1EiuoBV;E0ExuoBM;IAOI,+BAAA;E1EouoBV;E0E3uoBM;IAOI,kCAAA;E1EuuoBV;E0E9uoBM;IAOI,iCAAA;E1E0uoBV;E0EjvoBM;IAOI,kCAAA;E1E6uoBV;E0EpvoBM;IAOI,+BAAA;E1EgvoBV;E0EvvoBM;IAOI,gCAAA;E1EmvoBV;E0E1voBM;IAOI,+BAAA;E1EsvoBV;E0E7voBM;IAOI,gCAAA;E1EyvoBV;E0EhwoBM;IAOI,6BAAA;E1E4voBV;E0EnwoBM;IAOI,gCAAA;E1E+voBV;E0EtwoBM;IAOI,+BAAA;E1EkwoBV;E0EzwoBM;IAOI,gCAAA;E1EqwoBV;E0E5woBM;IAOI,6BAAA;E1EwwoBV;E0E/woBM;IAOI,gCAAA;E1E2woBV;E0ElxoBM;IAOI,+BAAA;E1E8woBV;E0ErxoBM;IAOI,gCAAA;E1EixoBV;E0ExxoBM;IAOI,6BAAA;E1EoxoBV;E0E3xoBM;IAOI,gCAAA;E1EuxoBV;E0E9xoBM;IAOI,+BAAA;E1E0xoBV;E0EjyoBM;IAOI,gCAAA;E1E6xoBV;E0EpyoBM;IAOI,6BAAA;E1EgyoBV;E0EvyoBM;IAOI,gCAAA;E1EmyoBV;E0E1yoBM;IAOI,+BAAA;E1EsyoBV;E0E7yoBM;IAOI,gCAAA;E1EyyoBV;E0EhzoBM;IAOI,6BAAA;E1E4yoBV;E0EnzoBM;IAOI,qBAAA;E1E+yoBV;E0EtzoBM;IAOI,2BAAA;E1EkzoBV;E0EzzoBM;IAOI,0BAAA;E1EqzoBV;E0E5zoBM;IAOI,2BAAA;E1EwzoBV;E0E/zoBM;IAOI,wBAAA;E1E2zoBV;E0El0oBM;IAOI,2BAAA;E1E8zoBV;E0Er0oBM;IAOI,0BAAA;E1Ei0oBV;E0Ex0oBM;IAOI,2BAAA;E1Eo0oBV;E0E30oBM;IAOI,wBAAA;E1Eu0oBV;E0E90oBM;IAOI,2BAAA;E1E00oBV;E0Ej1oBM;IAOI,0BAAA;E1E60oBV;E0Ep1oBM;IAOI,2BAAA;E1Eg1oBV;E0Ev1oBM;IAOI,wBAAA;E1Em1oBV;E0E11oBM;IAOI,2BAAA;E1Es1oBV;E0E71oBM;IAOI,0BAAA;E1Ey1oBV;E0Eh2oBM;IAOI,2BAAA;E1E41oBV;E0En2oBM;IAOI,wBAAA;E1E+1oBV;E0Et2oBM;IAOI,2BAAA;E1Ek2oBV;E0Ez2oBM;IAOI,0BAAA;E1Eq2oBV;E0E52oBM;IAOI,2BAAA;E1Ew2oBV;E0E/2oBM;IAOI,wBAAA;E1E22oBV;E0El3oBM;IAOI,2BAAA;IAAA,0BAAA;E1E+2oBV;E0Et3oBM;IAOI,iCAAA;IAAA,gCAAA;E1Em3oBV;E0E13oBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu3oBV;E0E93oBM;IAOI,iCAAA;IAAA,gCAAA;E1E23oBV;E0El4oBM;IAOI,8BAAA;IAAA,6BAAA;E1E+3oBV;E0Et4oBM;IAOI,iCAAA;IAAA,gCAAA;E1Em4oBV;E0E14oBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu4oBV;E0E94oBM;IAOI,iCAAA;IAAA,gCAAA;E1E24oBV;E0El5oBM;IAOI,8BAAA;IAAA,6BAAA;E1E+4oBV;E0Et5oBM;IAOI,iCAAA;IAAA,gCAAA;E1Em5oBV;E0E15oBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu5oBV;E0E95oBM;IAOI,iCAAA;IAAA,gCAAA;E1E25oBV;E0El6oBM;IAOI,8BAAA;IAAA,6BAAA;E1E+5oBV;E0Et6oBM;IAOI,iCAAA;IAAA,gCAAA;E1Em6oBV;E0E16oBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu6oBV;E0E96oBM;IAOI,iCAAA;IAAA,gCAAA;E1E26oBV;E0El7oBM;IAOI,8BAAA;IAAA,6BAAA;E1E+6oBV;E0Et7oBM;IAOI,iCAAA;IAAA,gCAAA;E1Em7oBV;E0E17oBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu7oBV;E0E97oBM;IAOI,iCAAA;IAAA,gCAAA;E1E27oBV;E0El8oBM;IAOI,8BAAA;IAAA,6BAAA;E1E+7oBV;E0Et8oBM;IAOI,yBAAA;IAAA,4BAAA;E1Em8oBV;E0E18oBM;IAOI,+BAAA;IAAA,kCAAA;E1Eu8oBV;E0E98oBM;IAOI,8BAAA;IAAA,iCAAA;E1E28oBV;E0El9oBM;IAOI,+BAAA;IAAA,kCAAA;E1E+8oBV;E0Et9oBM;IAOI,4BAAA;IAAA,+BAAA;E1Em9oBV;E0E19oBM;IAOI,+BAAA;IAAA,kCAAA;E1Eu9oBV;E0E99oBM;IAOI,8BAAA;IAAA,iCAAA;E1E29oBV;E0El+oBM;IAOI,+BAAA;IAAA,kCAAA;E1E+9oBV;E0Et+oBM;IAOI,4BAAA;IAAA,+BAAA;E1Em+oBV;E0E1+oBM;IAOI,+BAAA;IAAA,kCAAA;E1Eu+oBV;E0E9+oBM;IAOI,8BAAA;IAAA,iCAAA;E1E2+oBV;E0El/oBM;IAOI,+BAAA;IAAA,kCAAA;E1E++oBV;E0Et/oBM;IAOI,4BAAA;IAAA,+BAAA;E1Em/oBV;E0E1/oBM;IAOI,+BAAA;IAAA,kCAAA;E1Eu/oBV;E0E9/oBM;IAOI,8BAAA;IAAA,iCAAA;E1E2/oBV;E0ElgpBM;IAOI,+BAAA;IAAA,kCAAA;E1E+/oBV;E0EtgpBM;IAOI,4BAAA;IAAA,+BAAA;E1EmgpBV;E0E1gpBM;IAOI,+BAAA;IAAA,kCAAA;E1EugpBV;E0E9gpBM;IAOI,8BAAA;IAAA,iCAAA;E1E2gpBV;E0ElhpBM;IAOI,+BAAA;IAAA,kCAAA;E1E+gpBV;E0EthpBM;IAOI,4BAAA;IAAA,+BAAA;E1EmhpBV;E0E1hpBM;IAOI,yBAAA;E1EshpBV;E0E7hpBM;IAOI,+BAAA;E1EyhpBV;E0EhipBM;IAOI,8BAAA;E1E4hpBV;E0EnipBM;IAOI,+BAAA;E1E+hpBV;E0EtipBM;IAOI,4BAAA;E1EkipBV;E0EzipBM;IAOI,+BAAA;E1EqipBV;E0E5ipBM;IAOI,8BAAA;E1EwipBV;E0E/ipBM;IAOI,+BAAA;E1E2ipBV;E0EljpBM;IAOI,4BAAA;E1E8ipBV;E0ErjpBM;IAOI,+BAAA;E1EijpBV;E0ExjpBM;IAOI,8BAAA;E1EojpBV;E0E3jpBM;IAOI,+BAAA;E1EujpBV;E0E9jpBM;IAOI,4BAAA;E1E0jpBV;E0EjkpBM;IAOI,+BAAA;E1E6jpBV;E0EpkpBM;IAOI,8BAAA;E1EgkpBV;E0EvkpBM;IAOI,+BAAA;E1EmkpBV;E0E1kpBM;IAOI,4BAAA;E1EskpBV;E0E7kpBM;IAOI,+BAAA;E1EykpBV;E0EhlpBM;IAOI,8BAAA;E1E4kpBV;E0EnlpBM;IAOI,+BAAA;E1E+kpBV;E0EtlpBM;IAOI,4BAAA;E1EklpBV;E0EzlpBM;IAOI,2BAAA;E1EqlpBV;E0E5lpBM;IAOI,iCAAA;E1EwlpBV;E0E/lpBM;IAOI,gCAAA;E1E2lpBV;E0ElmpBM;IAOI,iCAAA;E1E8lpBV;E0ErmpBM;IAOI,8BAAA;E1EimpBV;E0ExmpBM;IAOI,iCAAA;E1EompBV;E0E3mpBM;IAOI,gCAAA;E1EumpBV;E0E9mpBM;IAOI,iCAAA;E1E0mpBV;E0EjnpBM;IAOI,8BAAA;E1E6mpBV;E0EpnpBM;IAOI,iCAAA;E1EgnpBV;E0EvnpBM;IAOI,gCAAA;E1EmnpBV;E0E1npBM;IAOI,iCAAA;E1EsnpBV;E0E7npBM;IAOI,8BAAA;E1EynpBV;E0EhopBM;IAOI,iCAAA;E1E4npBV;E0EnopBM;IAOI,gCAAA;E1E+npBV;E0EtopBM;IAOI,iCAAA;E1EkopBV;E0EzopBM;IAOI,8BAAA;E1EqopBV;E0E5opBM;IAOI,iCAAA;E1EwopBV;E0E/opBM;IAOI,gCAAA;E1E2opBV;E0ElppBM;IAOI,iCAAA;E1E8opBV;E0ErppBM;IAOI,8BAAA;E1EippBV;E0ExppBM;IAOI,4BAAA;E1EoppBV;E0E3ppBM;IAOI,kCAAA;E1EuppBV;E0E9ppBM;IAOI,iCAAA;E1E0ppBV;E0EjqpBM;IAOI,kCAAA;E1E6ppBV;E0EpqpBM;IAOI,+BAAA;E1EgqpBV;E0EvqpBM;IAOI,kCAAA;E1EmqpBV;E0E1qpBM;IAOI,iCAAA;E1EsqpBV;E0E7qpBM;IAOI,kCAAA;E1EyqpBV;E0EhrpBM;IAOI,+BAAA;E1E4qpBV;E0EnrpBM;IAOI,kCAAA;E1E+qpBV;E0EtrpBM;IAOI,iCAAA;E1EkrpBV;E0EzrpBM;IAOI,kCAAA;E1EqrpBV;E0E5rpBM;IAOI,+BAAA;E1EwrpBV;E0E/rpBM;IAOI,kCAAA;E1E2rpBV;E0ElspBM;IAOI,iCAAA;E1E8rpBV;E0ErspBM;IAOI,kCAAA;E1EispBV;E0ExspBM;IAOI,+BAAA;E1EospBV;E0E3spBM;IAOI,kCAAA;E1EuspBV;E0E9spBM;IAOI,iCAAA;E1E0spBV;E0EjtpBM;IAOI,kCAAA;E1E6spBV;E0EptpBM;IAOI,+BAAA;E1EgtpBV;E0EvtpBM;IAOI,0BAAA;E1EmtpBV;E0E1tpBM;IAOI,gCAAA;E1EstpBV;E0E7tpBM;IAOI,+BAAA;E1EytpBV;E0EhupBM;IAOI,gCAAA;E1E4tpBV;E0EnupBM;IAOI,6BAAA;E1E+tpBV;E0EtupBM;IAOI,gCAAA;E1EkupBV;E0EzupBM;IAOI,+BAAA;E1EqupBV;E0E5upBM;IAOI,gCAAA;E1EwupBV;E0E/upBM;IAOI,6BAAA;E1E2upBV;E0ElvpBM;IAOI,gCAAA;E1E8upBV;E0ErvpBM;IAOI,+BAAA;E1EivpBV;E0ExvpBM;IAOI,gCAAA;E1EovpBV;E0E3vpBM;IAOI,6BAAA;E1EuvpBV;E0E9vpBM;IAOI,gCAAA;E1E0vpBV;E0EjwpBM;IAOI,+BAAA;E1E6vpBV;E0EpwpBM;IAOI,gCAAA;E1EgwpBV;E0EvwpBM;IAOI,6BAAA;E1EmwpBV;E0E1wpBM;IAOI,gCAAA;E1EswpBV;E0E7wpBM;IAOI,+BAAA;E1EywpBV;E0EhxpBM;IAOI,gCAAA;E1E4wpBV;E0EnxpBM;IAOI,6BAAA;E1E+wpBV;E0EtxpBM;IAOI,iBAAA;E1EkxpBV;E0EzxpBM;IAOI,uBAAA;E1EqxpBV;E0E5xpBM;IAOI,sBAAA;E1EwxpBV;E0E/xpBM;IAOI,uBAAA;E1E2xpBV;E0ElypBM;IAOI,oBAAA;E1E8xpBV;E0ErypBM;IAOI,uBAAA;E1EiypBV;E0ExypBM;IAOI,sBAAA;E1EoypBV;E0E3ypBM;IAOI,uBAAA;E1EuypBV;E0E9ypBM;IAOI,oBAAA;E1E0ypBV;E0EjzpBM;IAOI,uBAAA;E1E6ypBV;E0EpzpBM;IAOI,sBAAA;E1EgzpBV;E0EvzpBM;IAOI,uBAAA;E1EmzpBV;E0E1zpBM;IAOI,oBAAA;E1EszpBV;E0E7zpBM;IAOI,uBAAA;E1EyzpBV;E0Eh0pBM;IAOI,sBAAA;E1E4zpBV;E0En0pBM;IAOI,uBAAA;E1E+zpBV;E0Et0pBM;IAOI,oBAAA;E1Ek0pBV;E0Ez0pBM;IAOI,uBAAA;E1Eq0pBV;E0E50pBM;IAOI,sBAAA;E1Ew0pBV;E0E/0pBM;IAOI,uBAAA;E1E20pBV;E0El1pBM;IAOI,oBAAA;E1E80pBV;E0Er1pBM;IAOI,qBAAA;E1Ei1pBV;E0Ex1pBM;IAOI,2BAAA;E1Eo1pBV;E0E31pBM;IAOI,0BAAA;E1Eu1pBV;E0E91pBM;IAOI,2BAAA;E1E01pBV;E0Ej2pBM;IAOI,wBAAA;E1E61pBV;E0Ep2pBM;IAOI,2BAAA;E1Eg2pBV;E0Ev2pBM;IAOI,0BAAA;E1Em2pBV;E0E12pBM;IAOI,2BAAA;E1Es2pBV;E0E72pBM;IAOI,wBAAA;E1Ey2pBV;E0Eh3pBM;IAOI,2BAAA;E1E42pBV;E0En3pBM;IAOI,0BAAA;E1E+2pBV;E0Et3pBM;IAOI,2BAAA;E1Ek3pBV;E0Ez3pBM;IAOI,wBAAA;E1Eq3pBV;E0E53pBM;IAOI,2BAAA;E1Ew3pBV;E0E/3pBM;IAOI,0BAAA;E1E23pBV;E0El4pBM;IAOI,2BAAA;E1E83pBV;E0Er4pBM;IAOI,wBAAA;E1Ei4pBV;E0Ex4pBM;IAOI,2BAAA;E1Eo4pBV;E0E34pBM;IAOI,0BAAA;E1Eu4pBV;E0E94pBM;IAOI,2BAAA;E1E04pBV;E0Ej5pBM;IAOI,wBAAA;E1E64pBV;E0Ep5pBM;IAOI,wBAAA;E1Eg5pBV;E0Ev5pBM;IAOI,8BAAA;E1Em5pBV;E0E15pBM;IAOI,6BAAA;E1Es5pBV;E0E75pBM;IAOI,8BAAA;E1Ey5pBV;E0Eh6pBM;IAOI,2BAAA;E1E45pBV;E0En6pBM;IAOI,8BAAA;E1E+5pBV;E0Et6pBM;IAOI,6BAAA;E1Ek6pBV;E0Ez6pBM;IAOI,8BAAA;E1Eq6pBV;E0E56pBM;IAOI,2BAAA;E1Ew6pBV;E0E/6pBM;IAOI,8BAAA;E1E26pBV;E0El7pBM;IAOI,6BAAA;E1E86pBV;E0Er7pBM;IAOI,8BAAA;E1Ei7pBV;E0Ex7pBM;IAOI,2BAAA;E1Eo7pBV;E0E37pBM;IAOI,8BAAA;E1Eu7pBV;E0E97pBM;IAOI,6BAAA;E1E07pBV;E0Ej8pBM;IAOI,8BAAA;E1E67pBV;E0Ep8pBM;IAOI,2BAAA;E1Eg8pBV;E0Ev8pBM;IAOI,8BAAA;E1Em8pBV;E0E18pBM;IAOI,6BAAA;E1Es8pBV;E0E78pBM;IAOI,8BAAA;E1Ey8pBV;E0Eh9pBM;IAOI,2BAAA;E1E48pBV;E0En9pBM;IAOI,0CAAA;E1E+8pBV;E0Et9pBM;IAOI,4CAAA;E1Ek9pBV;E0Ez9pBM;IAOI,4CAAA;E1Eq9pBV;E0E59pBM;IAOI,6BAAA;E1Ew9pBV;E0E/9pBM;IAOI,6BAAA;E1E29pBV;E0El+pBM;IAOI,8BAAA;E1E89pBV;E0Er+pBM;IAOI,6BAAA;E1Ei+pBV;E0Ex+pBM;IAOI,6BAAA;E1Eo+pBV;E0E3+pBM;IAOI,6BAAA;E1Eu+pBV;E0E9+pBM;IAOI,4BAAA;E1E0+pBV;E0Ej/pBM;IAOI,6BAAA;E1E6+pBV;E0Ep/pBM;IAOI,0BAAA;E1Eg/pBV;E0Ev/pBM;IAOI,8BAAA;E1Em/pBV;E0E1/pBM;IAOI,6BAAA;E1Es/pBV;E0E7/pBM;IAOI,0BAAA;E1Ey/pBV;E0EhgqBM;IAOI,4CAAA;E1E4/pBV;E0EngqBM;IAOI,2CAAA;E1E+/pBV;E0EtgqBM;IAOI,4CAAA;E1EkgqBV;E0EzgqBM;IAOI,0CAAA;E1EqgqBV;E0E5gqBM;IAOI,4CAAA;E1EwgqBV;E0E/gqBM;IAOI,2CAAA;E1E2gqBV;E0ElhqBM;IAOI,4CAAA;E1E8gqBV;E0ErhqBM;IAOI,wCAAA;E1EihqBV;E0ExhqBM;IAOI,4CAAA;E1EohqBV;E0E3hqBM;IAOI,2CAAA;E1EuhqBV;E0E9hqBM;IAOI,4CAAA;E1E0hqBV;E0EjiqBM;IAOI,0CAAA;E1E6hqBV;E0EpiqBM;IAOI,4CAAA;E1EgiqBV;E0EviqBM;IAOI,2CAAA;E1EmiqBV;E0E1iqBM;IAOI,4CAAA;E1EsiqBV;E0E7iqBM;IAOI,0CAAA;E1EyiqBV;E0EhjqBM;IAOI,4CAAA;E1E4iqBV;E0EnjqBM;IAOI,yCAAA;E1E+iqBV;E0EtjqBM;IAOI,4CAAA;E1EkjqBV;E0EzjqBM;IAOI,0CAAA;E1EqjqBV;E0E5jqBM;IAOI,4CAAA;E1EwjqBV;E0E/jqBM;IAOI,2CAAA;E1E2jqBV;E0ElkqBM;IAOI,4CAAA;E1E8jqBV;E0ErkqBM;IAOI,0CAAA;E1EikqBV;E0ExkqBM;IAOI,2BAAA;E1EokqBV;E0E3kqBM;IAOI,4BAAA;E1EukqBV;E0E9kqBM;IAOI,6BAAA;E1E0kqBV;E0EjlqBM;IAOI,2BAAA;E1E6kqBV;E0EplqBM;IAOI,yBAAA;E1EglqBV;E0EvlqBM;IAOI,yBAAA;E1EmlqBV;E0E1lqBM;IAOI,yBAAA;E1EslqBV;E0E7lqBM;IAOI,0BAAA;E1EylqBV;E0EhmqBM;IAOI,0BAAA;E1E4lqBV;E0EnmqBM;IAOI,yBAAA;E1E+lqBV;E0EtmqBM;IAOI,yBAAA;E1EkmqBV;E0EzmqBM;IAOI,yBAAA;E1EqmqBV;E0E5mqBM;IAOI,yBAAA;E1EwmqBV;E0E/mqBM;IAOI,yBAAA;E1E2mqBV;E0ElnqBM;IAOI,yBAAA;E1E8mqBV;E0ErnqBM;IAOI,yBAAA;E1EinqBV;E0ExnqBM;IAOI,yBAAA;E1EonqBV;E0E3nqBM;IAOI,yBAAA;E1EunqBV;E0E9nqBM;IAOI,0BAAA;E1E0nqBV;E0EjoqBM;IAOI,0BAAA;E1E6nqBV;E0EpoqBM;IAOI,0BAAA;E1EgoqBV;E0EvoqBM;IAOI,0BAAA;E1EmoqBV;E0E1oqBM;IAOI,0BAAA;E1EsoqBV;E0E7oqBM;IAOI,0BAAA;E1EyoqBV;E0EhpqBM;IAOI,0BAAA;E1E4oqBV;E0EnpqBM;IAOI,0BAAA;E1E+oqBV;E0EtpqBM;IAOI,0BAAA;E1EkpqBV;E0EzpqBM;IAOI,0BAAA;E1EqpqBV;E0E5pqBM;IAOI,0BAAA;E1EwpqBV;E0E/pqBM;IAOI,0BAAA;E1E2pqBV;E0ElqqBM;IAOI,0BAAA;E1E8pqBV;E0ErqqBM;IAOI,0BAAA;E1EiqqBV;E0ExqqBM;IAOI,0BAAA;E1EoqqBV;E0E3qqBM;IAOI,0BAAA;E1EuqqBV;E0E9qqBM;IAOI,0BAAA;E1E0qqBV;E0EjrqBM;IAOI,0BAAA;E1E6qqBV;E0EprqBM;IAOI,2BAAA;E1EgrqBV;E0EvrqBM;IAOI,2BAAA;E1EmrqBV;E0E1rqBM;IAOI,2BAAA;E1EsrqBV;E0E7rqBM;IAOI,2BAAA;E1EyrqBV;E0EhsqBM;IAOI,2BAAA;E1E4rqBV;E0EnsqBM;IAOI,2BAAA;E1E+rqBV;E0EtsqBM;IAOI,2BAAA;E1EksqBV;E0EzsqBM;IAOI,2BAAA;E1EqsqBV;E0E5sqBM;IAOI,2BAAA;E1EwsqBV;E0E/sqBM;IAOI,2BAAA;E1E2sqBV;E0EltqBM;IAOI,2BAAA;E1E8sqBV;E0ErtqBM;IAOI,2BAAA;E1EitqBV;E0ExtqBM;IAOI,2BAAA;E1EotqBV;E0E3tqBM;IAOI,2BAAA;E1EutqBV;E0E9tqBM;IAOI,2BAAA;E1E0tqBV;E0EjuqBM;IAOI,2BAAA;E1E6tqBV;E0EpuqBM;IAOI,2BAAA;E1EguqBV;E0EvuqBM;IAOI,2BAAA;E1EmuqBV;E0E1uqBM;IAOI,2BAAA;E1EsuqBV;E0E7uqBM;IAOI,2BAAA;E1EyuqBV;E0EhvqBM;IAOI,2BAAA;E1E4uqBV;E0EnvqBM;IAOI,2BAAA;E1E+uqBV;E0EtvqBM;IAOI,2BAAA;E1EkvqBV;E0EzvqBM;IAOI,2BAAA;E1EqvqBV;E0E5vqBM;IAOI,2BAAA;E1EwvqBV;E0E/vqBM;IAOI,2BAAA;E1E2vqBV;E0ElwqBM;IAOI,4BAAA;E1E8vqBV;E0ErwqBM;IAOI,4BAAA;E1EiwqBV;E0ExwqBM;IAOI,0BAAA;E1EowqBV;E0E3wqBM;IAOI,0BAAA;E1EuwqBV;E0E9wqBM;IAOI,0BAAA;E1E0wqBV;E0EjxqBM;IAOI,2BAAA;E1E6wqBV;E0EpxqBM;IAOI,2BAAA;E1EgxqBV;E0EvxqBM;IAOI,0BAAA;E1EmxqBV;E0E1xqBM;IAOI,0BAAA;E1EsxqBV;E0E7xqBM;IAOI,0BAAA;E1EyxqBV;E0EhyqBM;IAOI,0BAAA;E1E4xqBV;E0EnyqBM;IAOI,0BAAA;E1E+xqBV;E0EtyqBM;IAOI,0BAAA;E1EkyqBV;E0EzyqBM;IAOI,0BAAA;E1EqyqBV;E0E5yqBM;IAOI,0BAAA;E1EwyqBV;E0E/yqBM;IAOI,0BAAA;E1E2yqBV;E0ElzqBM;IAOI,2BAAA;E1E8yqBV;E0ErzqBM;IAOI,2BAAA;E1EizqBV;E0ExzqBM;IAOI,2BAAA;E1EozqBV;E0E3zqBM;IAOI,2BAAA;E1EuzqBV;E0E9zqBM;IAOI,2BAAA;E1E0zqBV;E0Ej0qBM;IAOI,2BAAA;E1E6zqBV;E0Ep0qBM;IAOI,2BAAA;E1Eg0qBV;E0Ev0qBM;IAOI,2BAAA;E1Em0qBV;E0E10qBM;IAOI,2BAAA;E1Es0qBV;E0E70qBM;IAOI,2BAAA;E1Ey0qBV;E0Eh1qBM;IAOI,2BAAA;E1E40qBV;E0En1qBM;IAOI,2BAAA;E1E+0qBV;E0Et1qBM;IAOI,2BAAA;E1Ek1qBV;E0Ez1qBM;IAOI,2BAAA;E1Eq1qBV;E0E51qBM;IAOI,2BAAA;E1Ew1qBV;E0E/1qBM;IAOI,2BAAA;E1E21qBV;E0El2qBM;IAOI,2BAAA;E1E81qBV;E0Er2qBM;IAOI,2BAAA;E1Ei2qBV;E0Ex2qBM;IAOI,4BAAA;E1Eo2qBV;E0E32qBM;IAOI,4BAAA;E1Eu2qBV;E0E92qBM;IAOI,4BAAA;E1E02qBV;E0Ej3qBM;IAOI,4BAAA;E1E62qBV;E0Ep3qBM;IAOI,4BAAA;E1Eg3qBV;E0Ev3qBM;IAOI,4BAAA;E1Em3qBV;E0E13qBM;IAOI,4BAAA;E1Es3qBV;E0E73qBM;IAOI,4BAAA;E1Ey3qBV;E0Eh4qBM;IAOI,4BAAA;E1E43qBV;E0En4qBM;IAOI,4BAAA;E1E+3qBV;E0Et4qBM;IAOI,4BAAA;E1Ek4qBV;E0Ez4qBM;IAOI,4BAAA;E1Eq4qBV;E0E54qBM;IAOI,4BAAA;E1Ew4qBV;E0E/4qBM;IAOI,4BAAA;E1E24qBV;E0El5qBM;IAOI,4BAAA;E1E84qBV;E0Er5qBM;IAOI,4BAAA;E1Ei5qBV;E0Ex5qBM;IAOI,4BAAA;E1Eo5qBV;E0E35qBM;IAOI,4BAAA;E1Eu5qBV;E0E95qBM;IAOI,4BAAA;E1E05qBV;E0Ej6qBM;IAOI,4BAAA;E1E65qBV;E0Ep6qBM;IAOI,4BAAA;E1Eg6qBV;E0Ev6qBM;IAOI,4BAAA;E1Em6qBV;E0E16qBM;IAOI,4BAAA;E1Es6qBV;E0E76qBM;IAOI,4BAAA;E1Ey6qBV;E0Eh7qBM;IAOI,4BAAA;E1E46qBV;E0En7qBM;IAOI,4BAAA;E1E+6qBV;E0Et7qBM;IAOI,6BAAA;E1Ek7qBV;AACF;AgB77qBI;E0DGI;IAOI,sBAAA;E1Eu7qBV;E0E97qBM;IAOI,uBAAA;E1E07qBV;E0Ej8qBM;IAOI,sBAAA;E1E67qBV;E0Ep8qBM;IAOI,8BAAA;E1Eg8qBV;E0Ev8qBM;IAOI,4BAAA;E1Em8qBV;E0E18qBM;IAOI,2BAAA;E1Es8qBV;E0E78qBM;IAOI,iCAAA;E1Ey8qBV;E0Eh9qBM;IAOI,2BAAA;E1E48qBV;E0En9qBM;IAOI,yBAAA;E1E+8qBV;E0Et9qBM;IAOI,2BAAA;E1Ek9qBV;E0Ez9qBM;IAOI,4BAAA;E1Eq9qBV;E0E59qBM;IAOI,2BAAA;E1Ew9qBV;E0E/9qBM;IAOI,0BAAA;E1E29qBV;E0El+qBM;IAOI,gCAAA;E1E89qBV;E0Er+qBM;IAOI,yBAAA;E1Ei+qBV;E0Ex+qBM;IAOI,wBAAA;E1Eo+qBV;E0E3+qBM;IAOI,+BAAA;E1Eu+qBV;E0E9+qBM;IAOI,yBAAA;E1E0+qBV;E0Ej/qBM;IAOI,6BAAA;E1E6+qBV;E0Ep/qBM;IAOI,8BAAA;E1Eg/qBV;E0Ev/qBM;IAOI,wBAAA;E1Em/qBV;E0E1/qBM;IAOI,+BAAA;E1Es/qBV;E0E7/qBM;IAOI,wBAAA;E1Ey/qBV;E0EhgrBM;IAOI,2BAAA;E1E4/qBV;E0EngrBM;IAOI,6BAAA;E1E+/qBV;E0EtgrBM;IAOI,6BAAA;E1EkgrBV;E0EzgrBM;IAOI,0BAAA;E1EqgrBV;E0E5grBM;IAOI,2BAAA;E1EwgrBV;E0E/grBM;IAOI,uBAAA;E1E2grBV;E0ElhrBM;IAOI,qBAAA;E1E8grBV;E0ErhrBM;IAOI,qBAAA;E1EihrBV;E0ExhrBM;IAOI,qBAAA;E1EohrBV;E0E3hrBM;IAOI,sBAAA;E1EuhrBV;E0E9hrBM;IAOI,sBAAA;E1E0hrBV;E0EjirBM;IAOI,qBAAA;E1E6hrBV;E0EpirBM;IAOI,qBAAA;E1EgirBV;E0EvirBM;IAOI,qBAAA;E1EmirBV;E0E1irBM;IAOI,qBAAA;E1EsirBV;E0E7irBM;IAOI,qBAAA;E1EyirBV;E0EhjrBM;IAOI,qBAAA;E1E4irBV;E0EnjrBM;IAOI,qBAAA;E1E+irBV;E0EtjrBM;IAOI,qBAAA;E1EkjrBV;E0EzjrBM;IAOI,qBAAA;E1EqjrBV;E0E5jrBM;IAOI,sBAAA;E1EwjrBV;E0E/jrBM;IAOI,sBAAA;E1E2jrBV;E0ElkrBM;IAOI,sBAAA;E1E8jrBV;E0ErkrBM;IAOI,sBAAA;E1EikrBV;E0ExkrBM;IAOI,sBAAA;E1EokrBV;E0E3krBM;IAOI,sBAAA;E1EukrBV;E0E9krBM;IAOI,sBAAA;E1E0krBV;E0EjlrBM;IAOI,sBAAA;E1E6krBV;E0EplrBM;IAOI,sBAAA;E1EglrBV;E0EvlrBM;IAOI,sBAAA;E1EmlrBV;E0E1lrBM;IAOI,sBAAA;E1EslrBV;E0E7lrBM;IAOI,sBAAA;E1EylrBV;E0EhmrBM;IAOI,sBAAA;E1E4lrBV;E0EnmrBM;IAOI,sBAAA;E1E+lrBV;E0EtmrBM;IAOI,sBAAA;E1EkmrBV;E0EzmrBM;IAOI,sBAAA;E1EqmrBV;E0E5mrBM;IAOI,sBAAA;E1EwmrBV;E0E/mrBM;IAOI,sBAAA;E1E2mrBV;E0ElnrBM;IAOI,uBAAA;E1E8mrBV;E0ErnrBM;IAOI,uBAAA;E1EinrBV;E0ExnrBM;IAOI,uBAAA;E1EonrBV;E0E3nrBM;IAOI,uBAAA;E1EunrBV;E0E9nrBM;IAOI,uBAAA;E1E0nrBV;E0EjorBM;IAOI,uBAAA;E1E6nrBV;E0EporBM;IAOI,uBAAA;E1EgorBV;E0EvorBM;IAOI,uBAAA;E1EmorBV;E0E1orBM;IAOI,uBAAA;E1EsorBV;E0E7orBM;IAOI,uBAAA;E1EyorBV;E0EhprBM;IAOI,uBAAA;E1E4orBV;E0EnprBM;IAOI,uBAAA;E1E+orBV;E0EtprBM;IAOI,uBAAA;E1EkprBV;E0EzprBM;IAOI,uBAAA;E1EqprBV;E0E5prBM;IAOI,uBAAA;E1EwprBV;E0E/prBM;IAOI,uBAAA;E1E2prBV;E0ElqrBM;IAOI,uBAAA;E1E8prBV;E0ErqrBM;IAOI,uBAAA;E1EiqrBV;E0ExqrBM;IAOI,uBAAA;E1EoqrBV;E0E3qrBM;IAOI,uBAAA;E1EuqrBV;E0E9qrBM;IAOI,uBAAA;E1E0qrBV;E0EjrrBM;IAOI,uBAAA;E1E6qrBV;E0EprrBM;IAOI,uBAAA;E1EgrrBV;E0EvrrBM;IAOI,uBAAA;E1EmrrBV;E0E1rrBM;IAOI,uBAAA;E1EsrrBV;E0E7rrBM;IAOI,uBAAA;E1EyrrBV;E0EhsrBM;IAOI,wBAAA;E1E4rrBV;E0EnsrBM;IAOI,2BAAA;E1E+rrBV;E0EtsrBM;IAOI,yBAAA;E1EksrBV;E0EzsrBM;IAOI,yBAAA;E1EqsrBV;E0E5srBM;IAOI,yBAAA;E1EwsrBV;E0E/srBM;IAOI,0BAAA;E1E2srBV;E0EltrBM;IAOI,0BAAA;E1E8srBV;E0ErtrBM;IAOI,yBAAA;E1EitrBV;E0ExtrBM;IAOI,yBAAA;E1EotrBV;E0E3trBM;IAOI,yBAAA;E1EutrBV;E0E9trBM;IAOI,yBAAA;E1E0trBV;E0EjurBM;IAOI,yBAAA;E1E6trBV;E0EpurBM;IAOI,yBAAA;E1EgurBV;E0EvurBM;IAOI,yBAAA;E1EmurBV;E0E1urBM;IAOI,yBAAA;E1EsurBV;E0E7urBM;IAOI,yBAAA;E1EyurBV;E0EhvrBM;IAOI,0BAAA;E1E4urBV;E0EnvrBM;IAOI,0BAAA;E1E+urBV;E0EtvrBM;IAOI,0BAAA;E1EkvrBV;E0EzvrBM;IAOI,0BAAA;E1EqvrBV;E0E5vrBM;IAOI,0BAAA;E1EwvrBV;E0E/vrBM;IAOI,0BAAA;E1E2vrBV;E0ElwrBM;IAOI,0BAAA;E1E8vrBV;E0ErwrBM;IAOI,0BAAA;E1EiwrBV;E0ExwrBM;IAOI,0BAAA;E1EowrBV;E0E3wrBM;IAOI,0BAAA;E1EuwrBV;E0E9wrBM;IAOI,0BAAA;E1E0wrBV;E0EjxrBM;IAOI,0BAAA;E1E6wrBV;E0EpxrBM;IAOI,0BAAA;E1EgxrBV;E0EvxrBM;IAOI,0BAAA;E1EmxrBV;E0E1xrBM;IAOI,0BAAA;E1EsxrBV;E0E7xrBM;IAOI,0BAAA;E1EyxrBV;E0EhyrBM;IAOI,0BAAA;E1E4xrBV;E0EnyrBM;IAOI,0BAAA;E1E+xrBV;E0EtyrBM;IAOI,2BAAA;E1EkyrBV;E0EzyrBM;IAOI,2BAAA;E1EqyrBV;E0E5yrBM;IAOI,2BAAA;E1EwyrBV;E0E/yrBM;IAOI,2BAAA;E1E2yrBV;E0ElzrBM;IAOI,2BAAA;E1E8yrBV;E0ErzrBM;IAOI,2BAAA;E1EizrBV;E0ExzrBM;IAOI,2BAAA;E1EozrBV;E0E3zrBM;IAOI,2BAAA;E1EuzrBV;E0E9zrBM;IAOI,2BAAA;E1E0zrBV;E0Ej0rBM;IAOI,2BAAA;E1E6zrBV;E0Ep0rBM;IAOI,2BAAA;E1Eg0rBV;E0Ev0rBM;IAOI,2BAAA;E1Em0rBV;E0E10rBM;IAOI,2BAAA;E1Es0rBV;E0E70rBM;IAOI,2BAAA;E1Ey0rBV;E0Eh1rBM;IAOI,2BAAA;E1E40rBV;E0En1rBM;IAOI,2BAAA;E1E+0rBV;E0Et1rBM;IAOI,2BAAA;E1Ek1rBV;E0Ez1rBM;IAOI,2BAAA;E1Eq1rBV;E0E51rBM;IAOI,2BAAA;E1Ew1rBV;E0E/1rBM;IAOI,2BAAA;E1E21rBV;E0El2rBM;IAOI,2BAAA;E1E81rBV;E0Er2rBM;IAOI,2BAAA;E1Ei2rBV;E0Ex2rBM;IAOI,2BAAA;E1Eo2rBV;E0E32rBM;IAOI,2BAAA;E1Eu2rBV;E0E92rBM;IAOI,2BAAA;E1E02rBV;E0Ej3rBM;IAOI,2BAAA;E1E62rBV;E0Ep3rBM;IAOI,4BAAA;E1Eg3rBV;E0Ev3rBM;IAOI,wBAAA;E1Em3rBV;E0E13rBM;IAOI,sBAAA;E1Es3rBV;E0E73rBM;IAOI,sBAAA;E1Ey3rBV;E0Eh4rBM;IAOI,sBAAA;E1E43rBV;E0En4rBM;IAOI,uBAAA;E1E+3rBV;E0Et4rBM;IAOI,uBAAA;E1Ek4rBV;E0Ez4rBM;IAOI,sBAAA;E1Eq4rBV;E0E54rBM;IAOI,sBAAA;E1Ew4rBV;E0E/4rBM;IAOI,sBAAA;E1E24rBV;E0El5rBM;IAOI,sBAAA;E1E84rBV;E0Er5rBM;IAOI,sBAAA;E1Ei5rBV;E0Ex5rBM;IAOI,sBAAA;E1Eo5rBV;E0E35rBM;IAOI,sBAAA;E1Eu5rBV;E0E95rBM;IAOI,sBAAA;E1E05rBV;E0Ej6rBM;IAOI,sBAAA;E1E65rBV;E0Ep6rBM;IAOI,uBAAA;E1Eg6rBV;E0Ev6rBM;IAOI,uBAAA;E1Em6rBV;E0E16rBM;IAOI,uBAAA;E1Es6rBV;E0E76rBM;IAOI,uBAAA;E1Ey6rBV;E0Eh7rBM;IAOI,uBAAA;E1E46rBV;E0En7rBM;IAOI,uBAAA;E1E+6rBV;E0Et7rBM;IAOI,uBAAA;E1Ek7rBV;E0Ez7rBM;IAOI,uBAAA;E1Eq7rBV;E0E57rBM;IAOI,uBAAA;E1Ew7rBV;E0E/7rBM;IAOI,uBAAA;E1E27rBV;E0El8rBM;IAOI,uBAAA;E1E87rBV;E0Er8rBM;IAOI,uBAAA;E1Ei8rBV;E0Ex8rBM;IAOI,uBAAA;E1Eo8rBV;E0E38rBM;IAOI,uBAAA;E1Eu8rBV;E0E98rBM;IAOI,uBAAA;E1E08rBV;E0Ej9rBM;IAOI,uBAAA;E1E68rBV;E0Ep9rBM;IAOI,uBAAA;E1Eg9rBV;E0Ev9rBM;IAOI,uBAAA;E1Em9rBV;E0E19rBM;IAOI,wBAAA;E1Es9rBV;E0E79rBM;IAOI,wBAAA;E1Ey9rBV;E0Eh+rBM;IAOI,wBAAA;E1E49rBV;E0En+rBM;IAOI,wBAAA;E1E+9rBV;E0Et+rBM;IAOI,wBAAA;E1Ek+rBV;E0Ez+rBM;IAOI,wBAAA;E1Eq+rBV;E0E5+rBM;IAOI,wBAAA;E1Ew+rBV;E0E/+rBM;IAOI,wBAAA;E1E2+rBV;E0El/rBM;IAOI,wBAAA;E1E8+rBV;E0Er/rBM;IAOI,wBAAA;E1Ei/rBV;E0Ex/rBM;IAOI,wBAAA;E1Eo/rBV;E0E3/rBM;IAOI,wBAAA;E1Eu/rBV;E0E9/rBM;IAOI,wBAAA;E1E0/rBV;E0EjgsBM;IAOI,wBAAA;E1E6/rBV;E0EpgsBM;IAOI,wBAAA;E1EggsBV;E0EvgsBM;IAOI,wBAAA;E1EmgsBV;E0E1gsBM;IAOI,wBAAA;E1EsgsBV;E0E7gsBM;IAOI,wBAAA;E1EygsBV;E0EhhsBM;IAOI,wBAAA;E1E4gsBV;E0EnhsBM;IAOI,wBAAA;E1E+gsBV;E0EthsBM;IAOI,wBAAA;E1EkhsBV;E0EzhsBM;IAOI,wBAAA;E1EqhsBV;E0E5hsBM;IAOI,wBAAA;E1EwhsBV;E0E/hsBM;IAOI,wBAAA;E1E2hsBV;E0ElisBM;IAOI,wBAAA;E1E8hsBV;E0ErisBM;IAOI,wBAAA;E1EiisBV;E0ExisBM;IAOI,yBAAA;E1EoisBV;E0E3isBM;IAOI,4BAAA;E1EuisBV;E0E9isBM;IAOI,0BAAA;E1E0isBV;E0EjjsBM;IAOI,0BAAA;E1E6isBV;E0EpjsBM;IAOI,0BAAA;E1EgjsBV;E0EvjsBM;IAOI,2BAAA;E1EmjsBV;E0E1jsBM;IAOI,2BAAA;E1EsjsBV;E0E7jsBM;IAOI,0BAAA;E1EyjsBV;E0EhksBM;IAOI,0BAAA;E1E4jsBV;E0EnksBM;IAOI,0BAAA;E1E+jsBV;E0EtksBM;IAOI,0BAAA;E1EkksBV;E0EzksBM;IAOI,0BAAA;E1EqksBV;E0E5ksBM;IAOI,0BAAA;E1EwksBV;E0E/ksBM;IAOI,0BAAA;E1E2ksBV;E0EllsBM;IAOI,0BAAA;E1E8ksBV;E0ErlsBM;IAOI,0BAAA;E1EilsBV;E0ExlsBM;IAOI,2BAAA;E1EolsBV;E0E3lsBM;IAOI,2BAAA;E1EulsBV;E0E9lsBM;IAOI,2BAAA;E1E0lsBV;E0EjmsBM;IAOI,2BAAA;E1E6lsBV;E0EpmsBM;IAOI,2BAAA;E1EgmsBV;E0EvmsBM;IAOI,2BAAA;E1EmmsBV;E0E1msBM;IAOI,2BAAA;E1EsmsBV;E0E7msBM;IAOI,2BAAA;E1EymsBV;E0EhnsBM;IAOI,2BAAA;E1E4msBV;E0EnnsBM;IAOI,2BAAA;E1E+msBV;E0EtnsBM;IAOI,2BAAA;E1EknsBV;E0EznsBM;IAOI,2BAAA;E1EqnsBV;E0E5nsBM;IAOI,2BAAA;E1EwnsBV;E0E/nsBM;IAOI,2BAAA;E1E2nsBV;E0ElosBM;IAOI,2BAAA;E1E8nsBV;E0ErosBM;IAOI,2BAAA;E1EiosBV;E0ExosBM;IAOI,2BAAA;E1EoosBV;E0E3osBM;IAOI,2BAAA;E1EuosBV;E0E9osBM;IAOI,4BAAA;E1E0osBV;E0EjpsBM;IAOI,4BAAA;E1E6osBV;E0EppsBM;IAOI,4BAAA;E1EgpsBV;E0EvpsBM;IAOI,4BAAA;E1EmpsBV;E0E1psBM;IAOI,4BAAA;E1EspsBV;E0E7psBM;IAOI,4BAAA;E1EypsBV;E0EhqsBM;IAOI,4BAAA;E1E4psBV;E0EnqsBM;IAOI,4BAAA;E1E+psBV;E0EtqsBM;IAOI,4BAAA;E1EkqsBV;E0EzqsBM;IAOI,4BAAA;E1EqqsBV;E0E5qsBM;IAOI,4BAAA;E1EwqsBV;E0E/qsBM;IAOI,4BAAA;E1E2qsBV;E0ElrsBM;IAOI,4BAAA;E1E8qsBV;E0ErrsBM;IAOI,4BAAA;E1EirsBV;E0ExrsBM;IAOI,4BAAA;E1EorsBV;E0E3rsBM;IAOI,4BAAA;E1EursBV;E0E9rsBM;IAOI,4BAAA;E1E0rsBV;E0EjssBM;IAOI,4BAAA;E1E6rsBV;E0EpssBM;IAOI,4BAAA;E1EgssBV;E0EvssBM;IAOI,4BAAA;E1EmssBV;E0E1ssBM;IAOI,4BAAA;E1EsssBV;E0E7ssBM;IAOI,4BAAA;E1EyssBV;E0EhtsBM;IAOI,4BAAA;E1E4ssBV;E0EntsBM;IAOI,4BAAA;E1E+ssBV;E0EttsBM;IAOI,4BAAA;E1EktsBV;E0EztsBM;IAOI,4BAAA;E1EqtsBV;E0E5tsBM;IAOI,6BAAA;E1EwtsBV;E0E/tsBM;IAOI,yBAAA;E1E2tsBV;E0ElusBM;IAOI,8BAAA;E1E8tsBV;E0ErusBM;IAOI,iCAAA;E1EiusBV;E0ExusBM;IAOI,sCAAA;E1EousBV;E0E3usBM;IAOI,yCAAA;E1EuusBV;E0E9usBM;IAOI,uBAAA;E1E0usBV;E0EjvsBM;IAOI,uBAAA;E1E6usBV;E0EpvsBM;IAOI,yBAAA;E1EgvsBV;E0EvvsBM;IAOI,yBAAA;E1EmvsBV;E0E1vsBM;IAOI,0BAAA;E1EsvsBV;E0E7vsBM;IAOI,4BAAA;E1EyvsBV;E0EhwsBM;IAOI,kCAAA;E1E4vsBV;E0EnwsBM;IAOI,sCAAA;E1E+vsBV;E0EtwsBM;IAOI,oCAAA;E1EkwsBV;E0EzwsBM;IAOI,kCAAA;E1EqwsBV;E0E5wsBM;IAOI,yCAAA;E1EwwsBV;E0E/wsBM;IAOI,wCAAA;E1E2wsBV;E0ElxsBM;IAOI,wCAAA;E1E8wsBV;E0ErxsBM;IAOI,kCAAA;E1EixsBV;E0ExxsBM;IAOI,gCAAA;E1EoxsBV;E0E3xsBM;IAOI,8BAAA;E1EuxsBV;E0E9xsBM;IAOI,gCAAA;E1E0xsBV;E0EjysBM;IAOI,+BAAA;E1E6xsBV;E0EpysBM;IAOI,oCAAA;E1EgysBV;E0EvysBM;IAOI,kCAAA;E1EmysBV;E0E1ysBM;IAOI,gCAAA;E1EsysBV;E0E7ysBM;IAOI,uCAAA;E1EyysBV;E0EhzsBM;IAOI,sCAAA;E1E4ysBV;E0EnzsBM;IAOI,iCAAA;E1E+ysBV;E0EtzsBM;IAOI,2BAAA;E1EkzsBV;E0EzzsBM;IAOI,iCAAA;E1EqzsBV;E0E5zsBM;IAOI,+BAAA;E1EwzsBV;E0E/zsBM;IAOI,6BAAA;E1E2zsBV;E0El0sBM;IAOI,+BAAA;E1E8zsBV;E0Er0sBM;IAOI,8BAAA;E1Ei0sBV;E0Ex0sBM;IAOI,oBAAA;E1Eo0sBV;E0E30sBM;IAOI,mBAAA;E1Eu0sBV;E0E90sBM;IAOI,mBAAA;E1E00sBV;E0Ej1sBM;IAOI,mBAAA;E1E60sBV;E0Ep1sBM;IAOI,mBAAA;E1Eg1sBV;E0Ev1sBM;IAOI,mBAAA;E1Em1sBV;E0E11sBM;IAOI,mBAAA;E1Es1sBV;E0E71sBM;IAOI,mBAAA;E1Ey1sBV;E0Eh2sBM;IAOI,oBAAA;E1E41sBV;E0En2sBM;IAOI,0BAAA;E1E+1sBV;E0Et2sBM;IAOI,yBAAA;E1Ek2sBV;E0Ez2sBM;IAOI,0BAAA;E1Eq2sBV;E0E52sBM;IAOI,uBAAA;E1Ew2sBV;E0E/2sBM;IAOI,0BAAA;E1E22sBV;E0El3sBM;IAOI,yBAAA;E1E82sBV;E0Er3sBM;IAOI,0BAAA;E1Ei3sBV;E0Ex3sBM;IAOI,uBAAA;E1Eo3sBV;E0E33sBM;IAOI,0BAAA;E1Eu3sBV;E0E93sBM;IAOI,yBAAA;E1E03sBV;E0Ej4sBM;IAOI,0BAAA;E1E63sBV;E0Ep4sBM;IAOI,uBAAA;E1Eg4sBV;E0Ev4sBM;IAOI,0BAAA;E1Em4sBV;E0E14sBM;IAOI,yBAAA;E1Es4sBV;E0E74sBM;IAOI,0BAAA;E1Ey4sBV;E0Eh5sBM;IAOI,uBAAA;E1E44sBV;E0En5sBM;IAOI,0BAAA;E1E+4sBV;E0Et5sBM;IAOI,yBAAA;E1Ek5sBV;E0Ez5sBM;IAOI,0BAAA;E1Eq5sBV;E0E55sBM;IAOI,uBAAA;E1Ew5sBV;E0E/5sBM;IAOI,uBAAA;E1E25sBV;E0El6sBM;IAOI,0BAAA;IAAA,yBAAA;E1E+5sBV;E0Et6sBM;IAOI,gCAAA;IAAA,+BAAA;E1Em6sBV;E0E16sBM;IAOI,+BAAA;IAAA,8BAAA;E1Eu6sBV;E0E96sBM;IAOI,gCAAA;IAAA,+BAAA;E1E26sBV;E0El7sBM;IAOI,6BAAA;IAAA,4BAAA;E1E+6sBV;E0Et7sBM;IAOI,gCAAA;IAAA,+BAAA;E1Em7sBV;E0E17sBM;IAOI,+BAAA;IAAA,8BAAA;E1Eu7sBV;E0E97sBM;IAOI,gCAAA;IAAA,+BAAA;E1E27sBV;E0El8sBM;IAOI,6BAAA;IAAA,4BAAA;E1E+7sBV;E0Et8sBM;IAOI,gCAAA;IAAA,+BAAA;E1Em8sBV;E0E18sBM;IAOI,+BAAA;IAAA,8BAAA;E1Eu8sBV;E0E98sBM;IAOI,gCAAA;IAAA,+BAAA;E1E28sBV;E0El9sBM;IAOI,6BAAA;IAAA,4BAAA;E1E+8sBV;E0Et9sBM;IAOI,gCAAA;IAAA,+BAAA;E1Em9sBV;E0E19sBM;IAOI,+BAAA;IAAA,8BAAA;E1Eu9sBV;E0E99sBM;IAOI,gCAAA;IAAA,+BAAA;E1E29sBV;E0El+sBM;IAOI,6BAAA;IAAA,4BAAA;E1E+9sBV;E0Et+sBM;IAOI,gCAAA;IAAA,+BAAA;E1Em+sBV;E0E1+sBM;IAOI,+BAAA;IAAA,8BAAA;E1Eu+sBV;E0E9+sBM;IAOI,gCAAA;IAAA,+BAAA;E1E2+sBV;E0El/sBM;IAOI,6BAAA;IAAA,4BAAA;E1E++sBV;E0Et/sBM;IAOI,6BAAA;IAAA,4BAAA;E1Em/sBV;E0E1/sBM;IAOI,wBAAA;IAAA,2BAAA;E1Eu/sBV;E0E9/sBM;IAOI,8BAAA;IAAA,iCAAA;E1E2/sBV;E0ElgtBM;IAOI,6BAAA;IAAA,gCAAA;E1E+/sBV;E0EtgtBM;IAOI,8BAAA;IAAA,iCAAA;E1EmgtBV;E0E1gtBM;IAOI,2BAAA;IAAA,8BAAA;E1EugtBV;E0E9gtBM;IAOI,8BAAA;IAAA,iCAAA;E1E2gtBV;E0ElhtBM;IAOI,6BAAA;IAAA,gCAAA;E1E+gtBV;E0EthtBM;IAOI,8BAAA;IAAA,iCAAA;E1EmhtBV;E0E1htBM;IAOI,2BAAA;IAAA,8BAAA;E1EuhtBV;E0E9htBM;IAOI,8BAAA;IAAA,iCAAA;E1E2htBV;E0ElitBM;IAOI,6BAAA;IAAA,gCAAA;E1E+htBV;E0EtitBM;IAOI,8BAAA;IAAA,iCAAA;E1EmitBV;E0E1itBM;IAOI,2BAAA;IAAA,8BAAA;E1EuitBV;E0E9itBM;IAOI,8BAAA;IAAA,iCAAA;E1E2itBV;E0EljtBM;IAOI,6BAAA;IAAA,gCAAA;E1E+itBV;E0EtjtBM;IAOI,8BAAA;IAAA,iCAAA;E1EmjtBV;E0E1jtBM;IAOI,2BAAA;IAAA,8BAAA;E1EujtBV;E0E9jtBM;IAOI,8BAAA;IAAA,iCAAA;E1E2jtBV;E0ElktBM;IAOI,6BAAA;IAAA,gCAAA;E1E+jtBV;E0EtktBM;IAOI,8BAAA;IAAA,iCAAA;E1EmktBV;E0E1ktBM;IAOI,2BAAA;IAAA,8BAAA;E1EuktBV;E0E9ktBM;IAOI,2BAAA;IAAA,8BAAA;E1E2ktBV;E0ElltBM;IAOI,wBAAA;E1E8ktBV;E0ErltBM;IAOI,8BAAA;E1EiltBV;E0ExltBM;IAOI,6BAAA;E1EoltBV;E0E3ltBM;IAOI,8BAAA;E1EultBV;E0E9ltBM;IAOI,2BAAA;E1E0ltBV;E0EjmtBM;IAOI,8BAAA;E1E6ltBV;E0EpmtBM;IAOI,6BAAA;E1EgmtBV;E0EvmtBM;IAOI,8BAAA;E1EmmtBV;E0E1mtBM;IAOI,2BAAA;E1EsmtBV;E0E7mtBM;IAOI,8BAAA;E1EymtBV;E0EhntBM;IAOI,6BAAA;E1E4mtBV;E0EnntBM;IAOI,8BAAA;E1E+mtBV;E0EtntBM;IAOI,2BAAA;E1EkntBV;E0EzntBM;IAOI,8BAAA;E1EqntBV;E0E5ntBM;IAOI,6BAAA;E1EwntBV;E0E/ntBM;IAOI,8BAAA;E1E2ntBV;E0ElotBM;IAOI,2BAAA;E1E8ntBV;E0ErotBM;IAOI,8BAAA;E1EiotBV;E0ExotBM;IAOI,6BAAA;E1EootBV;E0E3otBM;IAOI,8BAAA;E1EuotBV;E0E9otBM;IAOI,2BAAA;E1E0otBV;E0EjptBM;IAOI,2BAAA;E1E6otBV;E0EpptBM;IAOI,0BAAA;E1EgptBV;E0EvptBM;IAOI,gCAAA;E1EmptBV;E0E1ptBM;IAOI,+BAAA;E1EsptBV;E0E7ptBM;IAOI,gCAAA;E1EyptBV;E0EhqtBM;IAOI,6BAAA;E1E4ptBV;E0EnqtBM;IAOI,gCAAA;E1E+ptBV;E0EtqtBM;IAOI,+BAAA;E1EkqtBV;E0EzqtBM;IAOI,gCAAA;E1EqqtBV;E0E5qtBM;IAOI,6BAAA;E1EwqtBV;E0E/qtBM;IAOI,gCAAA;E1E2qtBV;E0ElrtBM;IAOI,+BAAA;E1E8qtBV;E0ErrtBM;IAOI,gCAAA;E1EirtBV;E0ExrtBM;IAOI,6BAAA;E1EortBV;E0E3rtBM;IAOI,gCAAA;E1EurtBV;E0E9rtBM;IAOI,+BAAA;E1E0rtBV;E0EjstBM;IAOI,gCAAA;E1E6rtBV;E0EpstBM;IAOI,6BAAA;E1EgstBV;E0EvstBM;IAOI,gCAAA;E1EmstBV;E0E1stBM;IAOI,+BAAA;E1EsstBV;E0E7stBM;IAOI,gCAAA;E1EystBV;E0EhttBM;IAOI,6BAAA;E1E4stBV;E0EnttBM;IAOI,6BAAA;E1E+stBV;E0EtttBM;IAOI,2BAAA;E1EkttBV;E0EzttBM;IAOI,iCAAA;E1EqttBV;E0E5ttBM;IAOI,gCAAA;E1EwttBV;E0E/ttBM;IAOI,iCAAA;E1E2ttBV;E0ElutBM;IAOI,8BAAA;E1E8ttBV;E0ErutBM;IAOI,iCAAA;E1EiutBV;E0ExutBM;IAOI,gCAAA;E1EoutBV;E0E3utBM;IAOI,iCAAA;E1EuutBV;E0E9utBM;IAOI,8BAAA;E1E0utBV;E0EjvtBM;IAOI,iCAAA;E1E6utBV;E0EpvtBM;IAOI,gCAAA;E1EgvtBV;E0EvvtBM;IAOI,iCAAA;E1EmvtBV;E0E1vtBM;IAOI,8BAAA;E1EsvtBV;E0E7vtBM;IAOI,iCAAA;E1EyvtBV;E0EhwtBM;IAOI,gCAAA;E1E4vtBV;E0EnwtBM;IAOI,iCAAA;E1E+vtBV;E0EtwtBM;IAOI,8BAAA;E1EkwtBV;E0EzwtBM;IAOI,iCAAA;E1EqwtBV;E0E5wtBM;IAOI,gCAAA;E1EwwtBV;E0E/wtBM;IAOI,iCAAA;E1E2wtBV;E0ElxtBM;IAOI,8BAAA;E1E8wtBV;E0ErxtBM;IAOI,8BAAA;E1EixtBV;E0ExxtBM;IAOI,yBAAA;E1EoxtBV;E0E3xtBM;IAOI,+BAAA;E1EuxtBV;E0E9xtBM;IAOI,8BAAA;E1E0xtBV;E0EjytBM;IAOI,+BAAA;E1E6xtBV;E0EpytBM;IAOI,4BAAA;E1EgytBV;E0EvytBM;IAOI,+BAAA;E1EmytBV;E0E1ytBM;IAOI,8BAAA;E1EsytBV;E0E7ytBM;IAOI,+BAAA;E1EyytBV;E0EhztBM;IAOI,4BAAA;E1E4ytBV;E0EnztBM;IAOI,+BAAA;E1E+ytBV;E0EtztBM;IAOI,8BAAA;E1EkztBV;E0EzztBM;IAOI,+BAAA;E1EqztBV;E0E5ztBM;IAOI,4BAAA;E1EwztBV;E0E/ztBM;IAOI,+BAAA;E1E2ztBV;E0El0tBM;IAOI,8BAAA;E1E8ztBV;E0Er0tBM;IAOI,+BAAA;E1Ei0tBV;E0Ex0tBM;IAOI,4BAAA;E1Eo0tBV;E0E30tBM;IAOI,+BAAA;E1Eu0tBV;E0E90tBM;IAOI,8BAAA;E1E00tBV;E0Ej1tBM;IAOI,+BAAA;E1E60tBV;E0Ep1tBM;IAOI,4BAAA;E1Eg1tBV;E0Ev1tBM;IAOI,4BAAA;E1Em1tBV;E0E11tBM;IAOI,2BAAA;E1Es1tBV;E0E71tBM;IAOI,0BAAA;E1Ey1tBV;E0Eh2tBM;IAOI,2BAAA;E1E41tBV;E0En2tBM;IAOI,wBAAA;E1E+1tBV;E0Et2tBM;IAOI,2BAAA;E1Ek2tBV;E0Ez2tBM;IAOI,0BAAA;E1Eq2tBV;E0E52tBM;IAOI,2BAAA;E1Ew2tBV;E0E/2tBM;IAOI,wBAAA;E1E22tBV;E0El3tBM;IAOI,2BAAA;E1E82tBV;E0Er3tBM;IAOI,0BAAA;E1Ei3tBV;E0Ex3tBM;IAOI,2BAAA;E1Eo3tBV;E0E33tBM;IAOI,wBAAA;E1Eu3tBV;E0E93tBM;IAOI,2BAAA;E1E03tBV;E0Ej4tBM;IAOI,0BAAA;E1E63tBV;E0Ep4tBM;IAOI,2BAAA;E1Eg4tBV;E0Ev4tBM;IAOI,wBAAA;E1Em4tBV;E0E14tBM;IAOI,2BAAA;E1Es4tBV;E0E74tBM;IAOI,0BAAA;E1Ey4tBV;E0Eh5tBM;IAOI,2BAAA;E1E44tBV;E0En5tBM;IAOI,wBAAA;E1E+4tBV;E0Et5tBM;IAOI,iCAAA;IAAA,gCAAA;E1Em5tBV;E0E15tBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu5tBV;E0E95tBM;IAOI,iCAAA;IAAA,gCAAA;E1E25tBV;E0El6tBM;IAOI,8BAAA;IAAA,6BAAA;E1E+5tBV;E0Et6tBM;IAOI,iCAAA;IAAA,gCAAA;E1Em6tBV;E0E16tBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu6tBV;E0E96tBM;IAOI,iCAAA;IAAA,gCAAA;E1E26tBV;E0El7tBM;IAOI,8BAAA;IAAA,6BAAA;E1E+6tBV;E0Et7tBM;IAOI,iCAAA;IAAA,gCAAA;E1Em7tBV;E0E17tBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu7tBV;E0E97tBM;IAOI,iCAAA;IAAA,gCAAA;E1E27tBV;E0El8tBM;IAOI,8BAAA;IAAA,6BAAA;E1E+7tBV;E0Et8tBM;IAOI,iCAAA;IAAA,gCAAA;E1Em8tBV;E0E18tBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu8tBV;E0E98tBM;IAOI,iCAAA;IAAA,gCAAA;E1E28tBV;E0El9tBM;IAOI,8BAAA;IAAA,6BAAA;E1E+8tBV;E0Et9tBM;IAOI,iCAAA;IAAA,gCAAA;E1Em9tBV;E0E19tBM;IAOI,gCAAA;IAAA,+BAAA;E1Eu9tBV;E0E99tBM;IAOI,iCAAA;IAAA,gCAAA;E1E29tBV;E0El+tBM;IAOI,8BAAA;IAAA,6BAAA;E1E+9tBV;E0Et+tBM;IAOI,+BAAA;IAAA,kCAAA;E1Em+tBV;E0E1+tBM;IAOI,8BAAA;IAAA,iCAAA;E1Eu+tBV;E0E9+tBM;IAOI,+BAAA;IAAA,kCAAA;E1E2+tBV;E0El/tBM;IAOI,4BAAA;IAAA,+BAAA;E1E++tBV;E0Et/tBM;IAOI,+BAAA;IAAA,kCAAA;E1Em/tBV;E0E1/tBM;IAOI,8BAAA;IAAA,iCAAA;E1Eu/tBV;E0E9/tBM;IAOI,+BAAA;IAAA,kCAAA;E1E2/tBV;E0ElguBM;IAOI,4BAAA;IAAA,+BAAA;E1E+/tBV;E0EtguBM;IAOI,+BAAA;IAAA,kCAAA;E1EmguBV;E0E1guBM;IAOI,8BAAA;IAAA,iCAAA;E1EuguBV;E0E9guBM;IAOI,+BAAA;IAAA,kCAAA;E1E2guBV;E0ElhuBM;IAOI,4BAAA;IAAA,+BAAA;E1E+guBV;E0EthuBM;IAOI,+BAAA;IAAA,kCAAA;E1EmhuBV;E0E1huBM;IAOI,8BAAA;IAAA,iCAAA;E1EuhuBV;E0E9huBM;IAOI,+BAAA;IAAA,kCAAA;E1E2huBV;E0EliuBM;IAOI,4BAAA;IAAA,+BAAA;E1E+huBV;E0EtiuBM;IAOI,+BAAA;IAAA,kCAAA;E1EmiuBV;E0E1iuBM;IAOI,8BAAA;IAAA,iCAAA;E1EuiuBV;E0E9iuBM;IAOI,+BAAA;IAAA,kCAAA;E1E2iuBV;E0EljuBM;IAOI,4BAAA;IAAA,+BAAA;E1E+iuBV;E0EtjuBM;IAOI,+BAAA;E1EkjuBV;E0EzjuBM;IAOI,8BAAA;E1EqjuBV;E0E5juBM;IAOI,+BAAA;E1EwjuBV;E0E/juBM;IAOI,4BAAA;E1E2juBV;E0ElkuBM;IAOI,+BAAA;E1E8juBV;E0ErkuBM;IAOI,8BAAA;E1EikuBV;E0ExkuBM;IAOI,+BAAA;E1EokuBV;E0E3kuBM;IAOI,4BAAA;E1EukuBV;E0E9kuBM;IAOI,+BAAA;E1E0kuBV;E0EjluBM;IAOI,8BAAA;E1E6kuBV;E0EpluBM;IAOI,+BAAA;E1EgluBV;E0EvluBM;IAOI,4BAAA;E1EmluBV;E0E1luBM;IAOI,+BAAA;E1EsluBV;E0E7luBM;IAOI,8BAAA;E1EyluBV;E0EhmuBM;IAOI,+BAAA;E1E4luBV;E0EnmuBM;IAOI,4BAAA;E1E+luBV;E0EtmuBM;IAOI,+BAAA;E1EkmuBV;E0EzmuBM;IAOI,8BAAA;E1EqmuBV;E0E5muBM;IAOI,+BAAA;E1EwmuBV;E0E/muBM;IAOI,4BAAA;E1E2muBV;E0ElnuBM;IAOI,iCAAA;E1E8muBV;E0ErnuBM;IAOI,gCAAA;E1EinuBV;E0ExnuBM;IAOI,iCAAA;E1EonuBV;E0E3nuBM;IAOI,8BAAA;E1EunuBV;E0E9nuBM;IAOI,iCAAA;E1E0nuBV;E0EjouBM;IAOI,gCAAA;E1E6nuBV;E0EpouBM;IAOI,iCAAA;E1EgouBV;E0EvouBM;IAOI,8BAAA;E1EmouBV;E0E1ouBM;IAOI,iCAAA;E1EsouBV;E0E7ouBM;IAOI,gCAAA;E1EyouBV;E0EhpuBM;IAOI,iCAAA;E1E4ouBV;E0EnpuBM;IAOI,8BAAA;E1E+ouBV;E0EtpuBM;IAOI,iCAAA;E1EkpuBV;E0EzpuBM;IAOI,gCAAA;E1EqpuBV;E0E5puBM;IAOI,iCAAA;E1EwpuBV;E0E/puBM;IAOI,8BAAA;E1E2puBV;E0ElquBM;IAOI,iCAAA;E1E8puBV;E0ErquBM;IAOI,gCAAA;E1EiquBV;E0ExquBM;IAOI,iCAAA;E1EoquBV;E0E3quBM;IAOI,8BAAA;E1EuquBV;E0E9quBM;IAOI,kCAAA;E1E0quBV;E0EjruBM;IAOI,iCAAA;E1E6quBV;E0EpruBM;IAOI,kCAAA;E1EgruBV;E0EvruBM;IAOI,+BAAA;E1EmruBV;E0E1ruBM;IAOI,kCAAA;E1EsruBV;E0E7ruBM;IAOI,iCAAA;E1EyruBV;E0EhsuBM;IAOI,kCAAA;E1E4ruBV;E0EnsuBM;IAOI,+BAAA;E1E+ruBV;E0EtsuBM;IAOI,kCAAA;E1EksuBV;E0EzsuBM;IAOI,iCAAA;E1EqsuBV;E0E5suBM;IAOI,kCAAA;E1EwsuBV;E0E/suBM;IAOI,+BAAA;E1E2suBV;E0EltuBM;IAOI,kCAAA;E1E8suBV;E0ErtuBM;IAOI,iCAAA;E1EituBV;E0ExtuBM;IAOI,kCAAA;E1EotuBV;E0E3tuBM;IAOI,+BAAA;E1EutuBV;E0E9tuBM;IAOI,kCAAA;E1E0tuBV;E0EjuuBM;IAOI,iCAAA;E1E6tuBV;E0EpuuBM;IAOI,kCAAA;E1EguuBV;E0EvuuBM;IAOI,+BAAA;E1EmuuBV;E0E1uuBM;IAOI,gCAAA;E1EsuuBV;E0E7uuBM;IAOI,+BAAA;E1EyuuBV;E0EhvuBM;IAOI,gCAAA;E1E4uuBV;E0EnvuBM;IAOI,6BAAA;E1E+uuBV;E0EtvuBM;IAOI,gCAAA;E1EkvuBV;E0EzvuBM;IAOI,+BAAA;E1EqvuBV;E0E5vuBM;IAOI,gCAAA;E1EwvuBV;E0E/vuBM;IAOI,6BAAA;E1E2vuBV;E0ElwuBM;IAOI,gCAAA;E1E8vuBV;E0ErwuBM;IAOI,+BAAA;E1EiwuBV;E0ExwuBM;IAOI,gCAAA;E1EowuBV;E0E3wuBM;IAOI,6BAAA;E1EuwuBV;E0E9wuBM;IAOI,gCAAA;E1E0wuBV;E0EjxuBM;IAOI,+BAAA;E1E6wuBV;E0EpxuBM;IAOI,gCAAA;E1EgxuBV;E0EvxuBM;IAOI,6BAAA;E1EmxuBV;E0E1xuBM;IAOI,gCAAA;E1EsxuBV;E0E7xuBM;IAOI,+BAAA;E1EyxuBV;E0EhyuBM;IAOI,gCAAA;E1E4xuBV;E0EnyuBM;IAOI,6BAAA;E1E+xuBV;E0EtyuBM;IAOI,qBAAA;E1EkyuBV;E0EzyuBM;IAOI,2BAAA;E1EqyuBV;E0E5yuBM;IAOI,0BAAA;E1EwyuBV;E0E/yuBM;IAOI,2BAAA;E1E2yuBV;E0ElzuBM;IAOI,wBAAA;E1E8yuBV;E0ErzuBM;IAOI,2BAAA;E1EizuBV;E0ExzuBM;IAOI,0BAAA;E1EozuBV;E0E3zuBM;IAOI,2BAAA;E1EuzuBV;E0E9zuBM;IAOI,wBAAA;E1E0zuBV;E0Ej0uBM;IAOI,2BAAA;E1E6zuBV;E0Ep0uBM;IAOI,0BAAA;E1Eg0uBV;E0Ev0uBM;IAOI,2BAAA;E1Em0uBV;E0E10uBM;IAOI,wBAAA;E1Es0uBV;E0E70uBM;IAOI,2BAAA;E1Ey0uBV;E0Eh1uBM;IAOI,0BAAA;E1E40uBV;E0En1uBM;IAOI,2BAAA;E1E+0uBV;E0Et1uBM;IAOI,wBAAA;E1Ek1uBV;E0Ez1uBM;IAOI,2BAAA;E1Eq1uBV;E0E51uBM;IAOI,0BAAA;E1Ew1uBV;E0E/1uBM;IAOI,2BAAA;E1E21uBV;E0El2uBM;IAOI,wBAAA;E1E81uBV;E0Er2uBM;IAOI,2BAAA;IAAA,0BAAA;E1Ek2uBV;E0Ez2uBM;IAOI,iCAAA;IAAA,gCAAA;E1Es2uBV;E0E72uBM;IAOI,gCAAA;IAAA,+BAAA;E1E02uBV;E0Ej3uBM;IAOI,iCAAA;IAAA,gCAAA;E1E82uBV;E0Er3uBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek3uBV;E0Ez3uBM;IAOI,iCAAA;IAAA,gCAAA;E1Es3uBV;E0E73uBM;IAOI,gCAAA;IAAA,+BAAA;E1E03uBV;E0Ej4uBM;IAOI,iCAAA;IAAA,gCAAA;E1E83uBV;E0Er4uBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek4uBV;E0Ez4uBM;IAOI,iCAAA;IAAA,gCAAA;E1Es4uBV;E0E74uBM;IAOI,gCAAA;IAAA,+BAAA;E1E04uBV;E0Ej5uBM;IAOI,iCAAA;IAAA,gCAAA;E1E84uBV;E0Er5uBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek5uBV;E0Ez5uBM;IAOI,iCAAA;IAAA,gCAAA;E1Es5uBV;E0E75uBM;IAOI,gCAAA;IAAA,+BAAA;E1E05uBV;E0Ej6uBM;IAOI,iCAAA;IAAA,gCAAA;E1E85uBV;E0Er6uBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek6uBV;E0Ez6uBM;IAOI,iCAAA;IAAA,gCAAA;E1Es6uBV;E0E76uBM;IAOI,gCAAA;IAAA,+BAAA;E1E06uBV;E0Ej7uBM;IAOI,iCAAA;IAAA,gCAAA;E1E86uBV;E0Er7uBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek7uBV;E0Ez7uBM;IAOI,yBAAA;IAAA,4BAAA;E1Es7uBV;E0E77uBM;IAOI,+BAAA;IAAA,kCAAA;E1E07uBV;E0Ej8uBM;IAOI,8BAAA;IAAA,iCAAA;E1E87uBV;E0Er8uBM;IAOI,+BAAA;IAAA,kCAAA;E1Ek8uBV;E0Ez8uBM;IAOI,4BAAA;IAAA,+BAAA;E1Es8uBV;E0E78uBM;IAOI,+BAAA;IAAA,kCAAA;E1E08uBV;E0Ej9uBM;IAOI,8BAAA;IAAA,iCAAA;E1E88uBV;E0Er9uBM;IAOI,+BAAA;IAAA,kCAAA;E1Ek9uBV;E0Ez9uBM;IAOI,4BAAA;IAAA,+BAAA;E1Es9uBV;E0E79uBM;IAOI,+BAAA;IAAA,kCAAA;E1E09uBV;E0Ej+uBM;IAOI,8BAAA;IAAA,iCAAA;E1E89uBV;E0Er+uBM;IAOI,+BAAA;IAAA,kCAAA;E1Ek+uBV;E0Ez+uBM;IAOI,4BAAA;IAAA,+BAAA;E1Es+uBV;E0E7+uBM;IAOI,+BAAA;IAAA,kCAAA;E1E0+uBV;E0Ej/uBM;IAOI,8BAAA;IAAA,iCAAA;E1E8+uBV;E0Er/uBM;IAOI,+BAAA;IAAA,kCAAA;E1Ek/uBV;E0Ez/uBM;IAOI,4BAAA;IAAA,+BAAA;E1Es/uBV;E0E7/uBM;IAOI,+BAAA;IAAA,kCAAA;E1E0/uBV;E0EjgvBM;IAOI,8BAAA;IAAA,iCAAA;E1E8/uBV;E0ErgvBM;IAOI,+BAAA;IAAA,kCAAA;E1EkgvBV;E0EzgvBM;IAOI,4BAAA;IAAA,+BAAA;E1EsgvBV;E0E7gvBM;IAOI,yBAAA;E1EygvBV;E0EhhvBM;IAOI,+BAAA;E1E4gvBV;E0EnhvBM;IAOI,8BAAA;E1E+gvBV;E0EthvBM;IAOI,+BAAA;E1EkhvBV;E0EzhvBM;IAOI,4BAAA;E1EqhvBV;E0E5hvBM;IAOI,+BAAA;E1EwhvBV;E0E/hvBM;IAOI,8BAAA;E1E2hvBV;E0ElivBM;IAOI,+BAAA;E1E8hvBV;E0ErivBM;IAOI,4BAAA;E1EiivBV;E0ExivBM;IAOI,+BAAA;E1EoivBV;E0E3ivBM;IAOI,8BAAA;E1EuivBV;E0E9ivBM;IAOI,+BAAA;E1E0ivBV;E0EjjvBM;IAOI,4BAAA;E1E6ivBV;E0EpjvBM;IAOI,+BAAA;E1EgjvBV;E0EvjvBM;IAOI,8BAAA;E1EmjvBV;E0E1jvBM;IAOI,+BAAA;E1EsjvBV;E0E7jvBM;IAOI,4BAAA;E1EyjvBV;E0EhkvBM;IAOI,+BAAA;E1E4jvBV;E0EnkvBM;IAOI,8BAAA;E1E+jvBV;E0EtkvBM;IAOI,+BAAA;E1EkkvBV;E0EzkvBM;IAOI,4BAAA;E1EqkvBV;E0E5kvBM;IAOI,2BAAA;E1EwkvBV;E0E/kvBM;IAOI,iCAAA;E1E2kvBV;E0EllvBM;IAOI,gCAAA;E1E8kvBV;E0ErlvBM;IAOI,iCAAA;E1EilvBV;E0ExlvBM;IAOI,8BAAA;E1EolvBV;E0E3lvBM;IAOI,iCAAA;E1EulvBV;E0E9lvBM;IAOI,gCAAA;E1E0lvBV;E0EjmvBM;IAOI,iCAAA;E1E6lvBV;E0EpmvBM;IAOI,8BAAA;E1EgmvBV;E0EvmvBM;IAOI,iCAAA;E1EmmvBV;E0E1mvBM;IAOI,gCAAA;E1EsmvBV;E0E7mvBM;IAOI,iCAAA;E1EymvBV;E0EhnvBM;IAOI,8BAAA;E1E4mvBV;E0EnnvBM;IAOI,iCAAA;E1E+mvBV;E0EtnvBM;IAOI,gCAAA;E1EknvBV;E0EznvBM;IAOI,iCAAA;E1EqnvBV;E0E5nvBM;IAOI,8BAAA;E1EwnvBV;E0E/nvBM;IAOI,iCAAA;E1E2nvBV;E0ElovBM;IAOI,gCAAA;E1E8nvBV;E0ErovBM;IAOI,iCAAA;E1EiovBV;E0ExovBM;IAOI,8BAAA;E1EoovBV;E0E3ovBM;IAOI,4BAAA;E1EuovBV;E0E9ovBM;IAOI,kCAAA;E1E0ovBV;E0EjpvBM;IAOI,iCAAA;E1E6ovBV;E0EppvBM;IAOI,kCAAA;E1EgpvBV;E0EvpvBM;IAOI,+BAAA;E1EmpvBV;E0E1pvBM;IAOI,kCAAA;E1EspvBV;E0E7pvBM;IAOI,iCAAA;E1EypvBV;E0EhqvBM;IAOI,kCAAA;E1E4pvBV;E0EnqvBM;IAOI,+BAAA;E1E+pvBV;E0EtqvBM;IAOI,kCAAA;E1EkqvBV;E0EzqvBM;IAOI,iCAAA;E1EqqvBV;E0E5qvBM;IAOI,kCAAA;E1EwqvBV;E0E/qvBM;IAOI,+BAAA;E1E2qvBV;E0ElrvBM;IAOI,kCAAA;E1E8qvBV;E0ErrvBM;IAOI,iCAAA;E1EirvBV;E0ExrvBM;IAOI,kCAAA;E1EorvBV;E0E3rvBM;IAOI,+BAAA;E1EurvBV;E0E9rvBM;IAOI,kCAAA;E1E0rvBV;E0EjsvBM;IAOI,iCAAA;E1E6rvBV;E0EpsvBM;IAOI,kCAAA;E1EgsvBV;E0EvsvBM;IAOI,+BAAA;E1EmsvBV;E0E1svBM;IAOI,0BAAA;E1EssvBV;E0E7svBM;IAOI,gCAAA;E1EysvBV;E0EhtvBM;IAOI,+BAAA;E1E4svBV;E0EntvBM;IAOI,gCAAA;E1E+svBV;E0EttvBM;IAOI,6BAAA;E1EktvBV;E0EztvBM;IAOI,gCAAA;E1EqtvBV;E0E5tvBM;IAOI,+BAAA;E1EwtvBV;E0E/tvBM;IAOI,gCAAA;E1E2tvBV;E0EluvBM;IAOI,6BAAA;E1E8tvBV;E0EruvBM;IAOI,gCAAA;E1EiuvBV;E0ExuvBM;IAOI,+BAAA;E1EouvBV;E0E3uvBM;IAOI,gCAAA;E1EuuvBV;E0E9uvBM;IAOI,6BAAA;E1E0uvBV;E0EjvvBM;IAOI,gCAAA;E1E6uvBV;E0EpvvBM;IAOI,+BAAA;E1EgvvBV;E0EvvvBM;IAOI,gCAAA;E1EmvvBV;E0E1vvBM;IAOI,6BAAA;E1EsvvBV;E0E7vvBM;IAOI,gCAAA;E1EyvvBV;E0EhwvBM;IAOI,+BAAA;E1E4vvBV;E0EnwvBM;IAOI,gCAAA;E1E+vvBV;E0EtwvBM;IAOI,6BAAA;E1EkwvBV;E0EzwvBM;IAOI,iBAAA;E1EqwvBV;E0E5wvBM;IAOI,uBAAA;E1EwwvBV;E0E/wvBM;IAOI,sBAAA;E1E2wvBV;E0ElxvBM;IAOI,uBAAA;E1E8wvBV;E0ErxvBM;IAOI,oBAAA;E1EixvBV;E0ExxvBM;IAOI,uBAAA;E1EoxvBV;E0E3xvBM;IAOI,sBAAA;E1EuxvBV;E0E9xvBM;IAOI,uBAAA;E1E0xvBV;E0EjyvBM;IAOI,oBAAA;E1E6xvBV;E0EpyvBM;IAOI,uBAAA;E1EgyvBV;E0EvyvBM;IAOI,sBAAA;E1EmyvBV;E0E1yvBM;IAOI,uBAAA;E1EsyvBV;E0E7yvBM;IAOI,oBAAA;E1EyyvBV;E0EhzvBM;IAOI,uBAAA;E1E4yvBV;E0EnzvBM;IAOI,sBAAA;E1E+yvBV;E0EtzvBM;IAOI,uBAAA;E1EkzvBV;E0EzzvBM;IAOI,oBAAA;E1EqzvBV;E0E5zvBM;IAOI,uBAAA;E1EwzvBV;E0E/zvBM;IAOI,sBAAA;E1E2zvBV;E0El0vBM;IAOI,uBAAA;E1E8zvBV;E0Er0vBM;IAOI,oBAAA;E1Ei0vBV;E0Ex0vBM;IAOI,qBAAA;E1Eo0vBV;E0E30vBM;IAOI,2BAAA;E1Eu0vBV;E0E90vBM;IAOI,0BAAA;E1E00vBV;E0Ej1vBM;IAOI,2BAAA;E1E60vBV;E0Ep1vBM;IAOI,wBAAA;E1Eg1vBV;E0Ev1vBM;IAOI,2BAAA;E1Em1vBV;E0E11vBM;IAOI,0BAAA;E1Es1vBV;E0E71vBM;IAOI,2BAAA;E1Ey1vBV;E0Eh2vBM;IAOI,wBAAA;E1E41vBV;E0En2vBM;IAOI,2BAAA;E1E+1vBV;E0Et2vBM;IAOI,0BAAA;E1Ek2vBV;E0Ez2vBM;IAOI,2BAAA;E1Eq2vBV;E0E52vBM;IAOI,wBAAA;E1Ew2vBV;E0E/2vBM;IAOI,2BAAA;E1E22vBV;E0El3vBM;IAOI,0BAAA;E1E82vBV;E0Er3vBM;IAOI,2BAAA;E1Ei3vBV;E0Ex3vBM;IAOI,wBAAA;E1Eo3vBV;E0E33vBM;IAOI,2BAAA;E1Eu3vBV;E0E93vBM;IAOI,0BAAA;E1E03vBV;E0Ej4vBM;IAOI,2BAAA;E1E63vBV;E0Ep4vBM;IAOI,wBAAA;E1Eg4vBV;E0Ev4vBM;IAOI,wBAAA;E1Em4vBV;E0E14vBM;IAOI,8BAAA;E1Es4vBV;E0E74vBM;IAOI,6BAAA;E1Ey4vBV;E0Eh5vBM;IAOI,8BAAA;E1E44vBV;E0En5vBM;IAOI,2BAAA;E1E+4vBV;E0Et5vBM;IAOI,8BAAA;E1Ek5vBV;E0Ez5vBM;IAOI,6BAAA;E1Eq5vBV;E0E55vBM;IAOI,8BAAA;E1Ew5vBV;E0E/5vBM;IAOI,2BAAA;E1E25vBV;E0El6vBM;IAOI,8BAAA;E1E85vBV;E0Er6vBM;IAOI,6BAAA;E1Ei6vBV;E0Ex6vBM;IAOI,8BAAA;E1Eo6vBV;E0E36vBM;IAOI,2BAAA;E1Eu6vBV;E0E96vBM;IAOI,8BAAA;E1E06vBV;E0Ej7vBM;IAOI,6BAAA;E1E66vBV;E0Ep7vBM;IAOI,8BAAA;E1Eg7vBV;E0Ev7vBM;IAOI,2BAAA;E1Em7vBV;E0E17vBM;IAOI,8BAAA;E1Es7vBV;E0E77vBM;IAOI,6BAAA;E1Ey7vBV;E0Eh8vBM;IAOI,8BAAA;E1E47vBV;E0En8vBM;IAOI,2BAAA;E1E+7vBV;E0Et8vBM;IAOI,0CAAA;E1Ek8vBV;E0Ez8vBM;IAOI,4CAAA;E1Eq8vBV;E0E58vBM;IAOI,4CAAA;E1Ew8vBV;E0E/8vBM;IAOI,6BAAA;E1E28vBV;E0El9vBM;IAOI,6BAAA;E1E88vBV;E0Er9vBM;IAOI,8BAAA;E1Ei9vBV;E0Ex9vBM;IAOI,6BAAA;E1Eo9vBV;E0E39vBM;IAOI,6BAAA;E1Eu9vBV;E0E99vBM;IAOI,6BAAA;E1E09vBV;E0Ej+vBM;IAOI,4BAAA;E1E69vBV;E0Ep+vBM;IAOI,6BAAA;E1Eg+vBV;E0Ev+vBM;IAOI,0BAAA;E1Em+vBV;E0E1+vBM;IAOI,8BAAA;E1Es+vBV;E0E7+vBM;IAOI,6BAAA;E1Ey+vBV;E0Eh/vBM;IAOI,0BAAA;E1E4+vBV;E0En/vBM;IAOI,4CAAA;E1E++vBV;E0Et/vBM;IAOI,2CAAA;E1Ek/vBV;E0Ez/vBM;IAOI,4CAAA;E1Eq/vBV;E0E5/vBM;IAOI,0CAAA;E1Ew/vBV;E0E//vBM;IAOI,4CAAA;E1E2/vBV;E0ElgwBM;IAOI,2CAAA;E1E8/vBV;E0ErgwBM;IAOI,4CAAA;E1EigwBV;E0ExgwBM;IAOI,wCAAA;E1EogwBV;E0E3gwBM;IAOI,4CAAA;E1EugwBV;E0E9gwBM;IAOI,2CAAA;E1E0gwBV;E0EjhwBM;IAOI,4CAAA;E1E6gwBV;E0EphwBM;IAOI,0CAAA;E1EghwBV;E0EvhwBM;IAOI,4CAAA;E1EmhwBV;E0E1hwBM;IAOI,2CAAA;E1EshwBV;E0E7hwBM;IAOI,4CAAA;E1EyhwBV;E0EhiwBM;IAOI,0CAAA;E1E4hwBV;E0EniwBM;IAOI,4CAAA;E1E+hwBV;E0EtiwBM;IAOI,yCAAA;E1EkiwBV;E0EziwBM;IAOI,4CAAA;E1EqiwBV;E0E5iwBM;IAOI,0CAAA;E1EwiwBV;E0E/iwBM;IAOI,4CAAA;E1E2iwBV;E0EljwBM;IAOI,2CAAA;E1E8iwBV;E0ErjwBM;IAOI,4CAAA;E1EijwBV;E0ExjwBM;IAOI,0CAAA;E1EojwBV;E0E3jwBM;IAOI,2BAAA;E1EujwBV;E0E9jwBM;IAOI,4BAAA;E1E0jwBV;E0EjkwBM;IAOI,6BAAA;E1E6jwBV;E0EpkwBM;IAOI,2BAAA;E1EgkwBV;E0EvkwBM;IAOI,yBAAA;E1EmkwBV;E0E1kwBM;IAOI,yBAAA;E1EskwBV;E0E7kwBM;IAOI,yBAAA;E1EykwBV;E0EhlwBM;IAOI,0BAAA;E1E4kwBV;E0EnlwBM;IAOI,0BAAA;E1E+kwBV;E0EtlwBM;IAOI,yBAAA;E1EklwBV;E0EzlwBM;IAOI,yBAAA;E1EqlwBV;E0E5lwBM;IAOI,yBAAA;E1EwlwBV;E0E/lwBM;IAOI,yBAAA;E1E2lwBV;E0ElmwBM;IAOI,yBAAA;E1E8lwBV;E0ErmwBM;IAOI,yBAAA;E1EimwBV;E0ExmwBM;IAOI,yBAAA;E1EomwBV;E0E3mwBM;IAOI,yBAAA;E1EumwBV;E0E9mwBM;IAOI,yBAAA;E1E0mwBV;E0EjnwBM;IAOI,0BAAA;E1E6mwBV;E0EpnwBM;IAOI,0BAAA;E1EgnwBV;E0EvnwBM;IAOI,0BAAA;E1EmnwBV;E0E1nwBM;IAOI,0BAAA;E1EsnwBV;E0E7nwBM;IAOI,0BAAA;E1EynwBV;E0EhowBM;IAOI,0BAAA;E1E4nwBV;E0EnowBM;IAOI,0BAAA;E1E+nwBV;E0EtowBM;IAOI,0BAAA;E1EkowBV;E0EzowBM;IAOI,0BAAA;E1EqowBV;E0E5owBM;IAOI,0BAAA;E1EwowBV;E0E/owBM;IAOI,0BAAA;E1E2owBV;E0ElpwBM;IAOI,0BAAA;E1E8owBV;E0ErpwBM;IAOI,0BAAA;E1EipwBV;E0ExpwBM;IAOI,0BAAA;E1EopwBV;E0E3pwBM;IAOI,0BAAA;E1EupwBV;E0E9pwBM;IAOI,0BAAA;E1E0pwBV;E0EjqwBM;IAOI,0BAAA;E1E6pwBV;E0EpqwBM;IAOI,0BAAA;E1EgqwBV;E0EvqwBM;IAOI,2BAAA;E1EmqwBV;E0E1qwBM;IAOI,2BAAA;E1EsqwBV;E0E7qwBM;IAOI,2BAAA;E1EyqwBV;E0EhrwBM;IAOI,2BAAA;E1E4qwBV;E0EnrwBM;IAOI,2BAAA;E1E+qwBV;E0EtrwBM;IAOI,2BAAA;E1EkrwBV;E0EzrwBM;IAOI,2BAAA;E1EqrwBV;E0E5rwBM;IAOI,2BAAA;E1EwrwBV;E0E/rwBM;IAOI,2BAAA;E1E2rwBV;E0ElswBM;IAOI,2BAAA;E1E8rwBV;E0ErswBM;IAOI,2BAAA;E1EiswBV;E0ExswBM;IAOI,2BAAA;E1EoswBV;E0E3swBM;IAOI,2BAAA;E1EuswBV;E0E9swBM;IAOI,2BAAA;E1E0swBV;E0EjtwBM;IAOI,2BAAA;E1E6swBV;E0EptwBM;IAOI,2BAAA;E1EgtwBV;E0EvtwBM;IAOI,2BAAA;E1EmtwBV;E0E1twBM;IAOI,2BAAA;E1EstwBV;E0E7twBM;IAOI,2BAAA;E1EytwBV;E0EhuwBM;IAOI,2BAAA;E1E4twBV;E0EnuwBM;IAOI,2BAAA;E1E+twBV;E0EtuwBM;IAOI,2BAAA;E1EkuwBV;E0EzuwBM;IAOI,2BAAA;E1EquwBV;E0E5uwBM;IAOI,2BAAA;E1EwuwBV;E0E/uwBM;IAOI,2BAAA;E1E2uwBV;E0ElvwBM;IAOI,2BAAA;E1E8uwBV;E0ErvwBM;IAOI,4BAAA;E1EivwBV;E0ExvwBM;IAOI,4BAAA;E1EovwBV;E0E3vwBM;IAOI,0BAAA;E1EuvwBV;E0E9vwBM;IAOI,0BAAA;E1E0vwBV;E0EjwwBM;IAOI,0BAAA;E1E6vwBV;E0EpwwBM;IAOI,2BAAA;E1EgwwBV;E0EvwwBM;IAOI,2BAAA;E1EmwwBV;E0E1wwBM;IAOI,0BAAA;E1EswwBV;E0E7wwBM;IAOI,0BAAA;E1EywwBV;E0EhxwBM;IAOI,0BAAA;E1E4wwBV;E0EnxwBM;IAOI,0BAAA;E1E+wwBV;E0EtxwBM;IAOI,0BAAA;E1EkxwBV;E0EzxwBM;IAOI,0BAAA;E1EqxwBV;E0E5xwBM;IAOI,0BAAA;E1EwxwBV;E0E/xwBM;IAOI,0BAAA;E1E2xwBV;E0ElywBM;IAOI,0BAAA;E1E8xwBV;E0ErywBM;IAOI,2BAAA;E1EiywBV;E0ExywBM;IAOI,2BAAA;E1EoywBV;E0E3ywBM;IAOI,2BAAA;E1EuywBV;E0E9ywBM;IAOI,2BAAA;E1E0ywBV;E0EjzwBM;IAOI,2BAAA;E1E6ywBV;E0EpzwBM;IAOI,2BAAA;E1EgzwBV;E0EvzwBM;IAOI,2BAAA;E1EmzwBV;E0E1zwBM;IAOI,2BAAA;E1EszwBV;E0E7zwBM;IAOI,2BAAA;E1EyzwBV;E0Eh0wBM;IAOI,2BAAA;E1E4zwBV;E0En0wBM;IAOI,2BAAA;E1E+zwBV;E0Et0wBM;IAOI,2BAAA;E1Ek0wBV;E0Ez0wBM;IAOI,2BAAA;E1Eq0wBV;E0E50wBM;IAOI,2BAAA;E1Ew0wBV;E0E/0wBM;IAOI,2BAAA;E1E20wBV;E0El1wBM;IAOI,2BAAA;E1E80wBV;E0Er1wBM;IAOI,2BAAA;E1Ei1wBV;E0Ex1wBM;IAOI,2BAAA;E1Eo1wBV;E0E31wBM;IAOI,4BAAA;E1Eu1wBV;E0E91wBM;IAOI,4BAAA;E1E01wBV;E0Ej2wBM;IAOI,4BAAA;E1E61wBV;E0Ep2wBM;IAOI,4BAAA;E1Eg2wBV;E0Ev2wBM;IAOI,4BAAA;E1Em2wBV;E0E12wBM;IAOI,4BAAA;E1Es2wBV;E0E72wBM;IAOI,4BAAA;E1Ey2wBV;E0Eh3wBM;IAOI,4BAAA;E1E42wBV;E0En3wBM;IAOI,4BAAA;E1E+2wBV;E0Et3wBM;IAOI,4BAAA;E1Ek3wBV;E0Ez3wBM;IAOI,4BAAA;E1Eq3wBV;E0E53wBM;IAOI,4BAAA;E1Ew3wBV;E0E/3wBM;IAOI,4BAAA;E1E23wBV;E0El4wBM;IAOI,4BAAA;E1E83wBV;E0Er4wBM;IAOI,4BAAA;E1Ei4wBV;E0Ex4wBM;IAOI,4BAAA;E1Eo4wBV;E0E34wBM;IAOI,4BAAA;E1Eu4wBV;E0E94wBM;IAOI,4BAAA;E1E04wBV;E0Ej5wBM;IAOI,4BAAA;E1E64wBV;E0Ep5wBM;IAOI,4BAAA;E1Eg5wBV;E0Ev5wBM;IAOI,4BAAA;E1Em5wBV;E0E15wBM;IAOI,4BAAA;E1Es5wBV;E0E75wBM;IAOI,4BAAA;E1Ey5wBV;E0Eh6wBM;IAOI,4BAAA;E1E45wBV;E0En6wBM;IAOI,4BAAA;E1E+5wBV;E0Et6wBM;IAOI,4BAAA;E1Ek6wBV;E0Ez6wBM;IAOI,6BAAA;E1Eq6wBV;AACF;AgBh7wBI;E0DGI;IAOI,sBAAA;E1E06wBV;E0Ej7wBM;IAOI,uBAAA;E1E66wBV;E0Ep7wBM;IAOI,sBAAA;E1Eg7wBV;E0Ev7wBM;IAOI,8BAAA;E1Em7wBV;E0E17wBM;IAOI,4BAAA;E1Es7wBV;E0E77wBM;IAOI,2BAAA;E1Ey7wBV;E0Eh8wBM;IAOI,iCAAA;E1E47wBV;E0En8wBM;IAOI,2BAAA;E1E+7wBV;E0Et8wBM;IAOI,yBAAA;E1Ek8wBV;E0Ez8wBM;IAOI,2BAAA;E1Eq8wBV;E0E58wBM;IAOI,4BAAA;E1Ew8wBV;E0E/8wBM;IAOI,2BAAA;E1E28wBV;E0El9wBM;IAOI,0BAAA;E1E88wBV;E0Er9wBM;IAOI,gCAAA;E1Ei9wBV;E0Ex9wBM;IAOI,yBAAA;E1Eo9wBV;E0E39wBM;IAOI,wBAAA;E1Eu9wBV;E0E99wBM;IAOI,+BAAA;E1E09wBV;E0Ej+wBM;IAOI,yBAAA;E1E69wBV;E0Ep+wBM;IAOI,6BAAA;E1Eg+wBV;E0Ev+wBM;IAOI,8BAAA;E1Em+wBV;E0E1+wBM;IAOI,wBAAA;E1Es+wBV;E0E7+wBM;IAOI,+BAAA;E1Ey+wBV;E0Eh/wBM;IAOI,wBAAA;E1E4+wBV;E0En/wBM;IAOI,2BAAA;E1E++wBV;E0Et/wBM;IAOI,6BAAA;E1Ek/wBV;E0Ez/wBM;IAOI,6BAAA;E1Eq/wBV;E0E5/wBM;IAOI,0BAAA;E1Ew/wBV;E0E//wBM;IAOI,2BAAA;E1E2/wBV;E0ElgxBM;IAOI,uBAAA;E1E8/wBV;E0ErgxBM;IAOI,qBAAA;E1EigxBV;E0ExgxBM;IAOI,qBAAA;E1EogxBV;E0E3gxBM;IAOI,qBAAA;E1EugxBV;E0E9gxBM;IAOI,sBAAA;E1E0gxBV;E0EjhxBM;IAOI,sBAAA;E1E6gxBV;E0EphxBM;IAOI,qBAAA;E1EghxBV;E0EvhxBM;IAOI,qBAAA;E1EmhxBV;E0E1hxBM;IAOI,qBAAA;E1EshxBV;E0E7hxBM;IAOI,qBAAA;E1EyhxBV;E0EhixBM;IAOI,qBAAA;E1E4hxBV;E0EnixBM;IAOI,qBAAA;E1E+hxBV;E0EtixBM;IAOI,qBAAA;E1EkixBV;E0EzixBM;IAOI,qBAAA;E1EqixBV;E0E5ixBM;IAOI,qBAAA;E1EwixBV;E0E/ixBM;IAOI,sBAAA;E1E2ixBV;E0EljxBM;IAOI,sBAAA;E1E8ixBV;E0ErjxBM;IAOI,sBAAA;E1EijxBV;E0ExjxBM;IAOI,sBAAA;E1EojxBV;E0E3jxBM;IAOI,sBAAA;E1EujxBV;E0E9jxBM;IAOI,sBAAA;E1E0jxBV;E0EjkxBM;IAOI,sBAAA;E1E6jxBV;E0EpkxBM;IAOI,sBAAA;E1EgkxBV;E0EvkxBM;IAOI,sBAAA;E1EmkxBV;E0E1kxBM;IAOI,sBAAA;E1EskxBV;E0E7kxBM;IAOI,sBAAA;E1EykxBV;E0EhlxBM;IAOI,sBAAA;E1E4kxBV;E0EnlxBM;IAOI,sBAAA;E1E+kxBV;E0EtlxBM;IAOI,sBAAA;E1EklxBV;E0EzlxBM;IAOI,sBAAA;E1EqlxBV;E0E5lxBM;IAOI,sBAAA;E1EwlxBV;E0E/lxBM;IAOI,sBAAA;E1E2lxBV;E0ElmxBM;IAOI,sBAAA;E1E8lxBV;E0ErmxBM;IAOI,uBAAA;E1EimxBV;E0ExmxBM;IAOI,uBAAA;E1EomxBV;E0E3mxBM;IAOI,uBAAA;E1EumxBV;E0E9mxBM;IAOI,uBAAA;E1E0mxBV;E0EjnxBM;IAOI,uBAAA;E1E6mxBV;E0EpnxBM;IAOI,uBAAA;E1EgnxBV;E0EvnxBM;IAOI,uBAAA;E1EmnxBV;E0E1nxBM;IAOI,uBAAA;E1EsnxBV;E0E7nxBM;IAOI,uBAAA;E1EynxBV;E0EhoxBM;IAOI,uBAAA;E1E4nxBV;E0EnoxBM;IAOI,uBAAA;E1E+nxBV;E0EtoxBM;IAOI,uBAAA;E1EkoxBV;E0EzoxBM;IAOI,uBAAA;E1EqoxBV;E0E5oxBM;IAOI,uBAAA;E1EwoxBV;E0E/oxBM;IAOI,uBAAA;E1E2oxBV;E0ElpxBM;IAOI,uBAAA;E1E8oxBV;E0ErpxBM;IAOI,uBAAA;E1EipxBV;E0ExpxBM;IAOI,uBAAA;E1EopxBV;E0E3pxBM;IAOI,uBAAA;E1EupxBV;E0E9pxBM;IAOI,uBAAA;E1E0pxBV;E0EjqxBM;IAOI,uBAAA;E1E6pxBV;E0EpqxBM;IAOI,uBAAA;E1EgqxBV;E0EvqxBM;IAOI,uBAAA;E1EmqxBV;E0E1qxBM;IAOI,uBAAA;E1EsqxBV;E0E7qxBM;IAOI,uBAAA;E1EyqxBV;E0EhrxBM;IAOI,uBAAA;E1E4qxBV;E0EnrxBM;IAOI,wBAAA;E1E+qxBV;E0EtrxBM;IAOI,2BAAA;E1EkrxBV;E0EzrxBM;IAOI,yBAAA;E1EqrxBV;E0E5rxBM;IAOI,yBAAA;E1EwrxBV;E0E/rxBM;IAOI,yBAAA;E1E2rxBV;E0ElsxBM;IAOI,0BAAA;E1E8rxBV;E0ErsxBM;IAOI,0BAAA;E1EisxBV;E0ExsxBM;IAOI,yBAAA;E1EosxBV;E0E3sxBM;IAOI,yBAAA;E1EusxBV;E0E9sxBM;IAOI,yBAAA;E1E0sxBV;E0EjtxBM;IAOI,yBAAA;E1E6sxBV;E0EptxBM;IAOI,yBAAA;E1EgtxBV;E0EvtxBM;IAOI,yBAAA;E1EmtxBV;E0E1txBM;IAOI,yBAAA;E1EstxBV;E0E7txBM;IAOI,yBAAA;E1EytxBV;E0EhuxBM;IAOI,yBAAA;E1E4txBV;E0EnuxBM;IAOI,0BAAA;E1E+txBV;E0EtuxBM;IAOI,0BAAA;E1EkuxBV;E0EzuxBM;IAOI,0BAAA;E1EquxBV;E0E5uxBM;IAOI,0BAAA;E1EwuxBV;E0E/uxBM;IAOI,0BAAA;E1E2uxBV;E0ElvxBM;IAOI,0BAAA;E1E8uxBV;E0ErvxBM;IAOI,0BAAA;E1EivxBV;E0ExvxBM;IAOI,0BAAA;E1EovxBV;E0E3vxBM;IAOI,0BAAA;E1EuvxBV;E0E9vxBM;IAOI,0BAAA;E1E0vxBV;E0EjwxBM;IAOI,0BAAA;E1E6vxBV;E0EpwxBM;IAOI,0BAAA;E1EgwxBV;E0EvwxBM;IAOI,0BAAA;E1EmwxBV;E0E1wxBM;IAOI,0BAAA;E1EswxBV;E0E7wxBM;IAOI,0BAAA;E1EywxBV;E0EhxxBM;IAOI,0BAAA;E1E4wxBV;E0EnxxBM;IAOI,0BAAA;E1E+wxBV;E0EtxxBM;IAOI,0BAAA;E1EkxxBV;E0EzxxBM;IAOI,2BAAA;E1EqxxBV;E0E5xxBM;IAOI,2BAAA;E1EwxxBV;E0E/xxBM;IAOI,2BAAA;E1E2xxBV;E0ElyxBM;IAOI,2BAAA;E1E8xxBV;E0EryxBM;IAOI,2BAAA;E1EiyxBV;E0ExyxBM;IAOI,2BAAA;E1EoyxBV;E0E3yxBM;IAOI,2BAAA;E1EuyxBV;E0E9yxBM;IAOI,2BAAA;E1E0yxBV;E0EjzxBM;IAOI,2BAAA;E1E6yxBV;E0EpzxBM;IAOI,2BAAA;E1EgzxBV;E0EvzxBM;IAOI,2BAAA;E1EmzxBV;E0E1zxBM;IAOI,2BAAA;E1EszxBV;E0E7zxBM;IAOI,2BAAA;E1EyzxBV;E0Eh0xBM;IAOI,2BAAA;E1E4zxBV;E0En0xBM;IAOI,2BAAA;E1E+zxBV;E0Et0xBM;IAOI,2BAAA;E1Ek0xBV;E0Ez0xBM;IAOI,2BAAA;E1Eq0xBV;E0E50xBM;IAOI,2BAAA;E1Ew0xBV;E0E/0xBM;IAOI,2BAAA;E1E20xBV;E0El1xBM;IAOI,2BAAA;E1E80xBV;E0Er1xBM;IAOI,2BAAA;E1Ei1xBV;E0Ex1xBM;IAOI,2BAAA;E1Eo1xBV;E0E31xBM;IAOI,2BAAA;E1Eu1xBV;E0E91xBM;IAOI,2BAAA;E1E01xBV;E0Ej2xBM;IAOI,2BAAA;E1E61xBV;E0Ep2xBM;IAOI,2BAAA;E1Eg2xBV;E0Ev2xBM;IAOI,4BAAA;E1Em2xBV;E0E12xBM;IAOI,wBAAA;E1Es2xBV;E0E72xBM;IAOI,sBAAA;E1Ey2xBV;E0Eh3xBM;IAOI,sBAAA;E1E42xBV;E0En3xBM;IAOI,sBAAA;E1E+2xBV;E0Et3xBM;IAOI,uBAAA;E1Ek3xBV;E0Ez3xBM;IAOI,uBAAA;E1Eq3xBV;E0E53xBM;IAOI,sBAAA;E1Ew3xBV;E0E/3xBM;IAOI,sBAAA;E1E23xBV;E0El4xBM;IAOI,sBAAA;E1E83xBV;E0Er4xBM;IAOI,sBAAA;E1Ei4xBV;E0Ex4xBM;IAOI,sBAAA;E1Eo4xBV;E0E34xBM;IAOI,sBAAA;E1Eu4xBV;E0E94xBM;IAOI,sBAAA;E1E04xBV;E0Ej5xBM;IAOI,sBAAA;E1E64xBV;E0Ep5xBM;IAOI,sBAAA;E1Eg5xBV;E0Ev5xBM;IAOI,uBAAA;E1Em5xBV;E0E15xBM;IAOI,uBAAA;E1Es5xBV;E0E75xBM;IAOI,uBAAA;E1Ey5xBV;E0Eh6xBM;IAOI,uBAAA;E1E45xBV;E0En6xBM;IAOI,uBAAA;E1E+5xBV;E0Et6xBM;IAOI,uBAAA;E1Ek6xBV;E0Ez6xBM;IAOI,uBAAA;E1Eq6xBV;E0E56xBM;IAOI,uBAAA;E1Ew6xBV;E0E/6xBM;IAOI,uBAAA;E1E26xBV;E0El7xBM;IAOI,uBAAA;E1E86xBV;E0Er7xBM;IAOI,uBAAA;E1Ei7xBV;E0Ex7xBM;IAOI,uBAAA;E1Eo7xBV;E0E37xBM;IAOI,uBAAA;E1Eu7xBV;E0E97xBM;IAOI,uBAAA;E1E07xBV;E0Ej8xBM;IAOI,uBAAA;E1E67xBV;E0Ep8xBM;IAOI,uBAAA;E1Eg8xBV;E0Ev8xBM;IAOI,uBAAA;E1Em8xBV;E0E18xBM;IAOI,uBAAA;E1Es8xBV;E0E78xBM;IAOI,wBAAA;E1Ey8xBV;E0Eh9xBM;IAOI,wBAAA;E1E48xBV;E0En9xBM;IAOI,wBAAA;E1E+8xBV;E0Et9xBM;IAOI,wBAAA;E1Ek9xBV;E0Ez9xBM;IAOI,wBAAA;E1Eq9xBV;E0E59xBM;IAOI,wBAAA;E1Ew9xBV;E0E/9xBM;IAOI,wBAAA;E1E29xBV;E0El+xBM;IAOI,wBAAA;E1E89xBV;E0Er+xBM;IAOI,wBAAA;E1Ei+xBV;E0Ex+xBM;IAOI,wBAAA;E1Eo+xBV;E0E3+xBM;IAOI,wBAAA;E1Eu+xBV;E0E9+xBM;IAOI,wBAAA;E1E0+xBV;E0Ej/xBM;IAOI,wBAAA;E1E6+xBV;E0Ep/xBM;IAOI,wBAAA;E1Eg/xBV;E0Ev/xBM;IAOI,wBAAA;E1Em/xBV;E0E1/xBM;IAOI,wBAAA;E1Es/xBV;E0E7/xBM;IAOI,wBAAA;E1Ey/xBV;E0EhgyBM;IAOI,wBAAA;E1E4/xBV;E0EngyBM;IAOI,wBAAA;E1E+/xBV;E0EtgyBM;IAOI,wBAAA;E1EkgyBV;E0EzgyBM;IAOI,wBAAA;E1EqgyBV;E0E5gyBM;IAOI,wBAAA;E1EwgyBV;E0E/gyBM;IAOI,wBAAA;E1E2gyBV;E0ElhyBM;IAOI,wBAAA;E1E8gyBV;E0ErhyBM;IAOI,wBAAA;E1EihyBV;E0ExhyBM;IAOI,wBAAA;E1EohyBV;E0E3hyBM;IAOI,yBAAA;E1EuhyBV;E0E9hyBM;IAOI,4BAAA;E1E0hyBV;E0EjiyBM;IAOI,0BAAA;E1E6hyBV;E0EpiyBM;IAOI,0BAAA;E1EgiyBV;E0EviyBM;IAOI,0BAAA;E1EmiyBV;E0E1iyBM;IAOI,2BAAA;E1EsiyBV;E0E7iyBM;IAOI,2BAAA;E1EyiyBV;E0EhjyBM;IAOI,0BAAA;E1E4iyBV;E0EnjyBM;IAOI,0BAAA;E1E+iyBV;E0EtjyBM;IAOI,0BAAA;E1EkjyBV;E0EzjyBM;IAOI,0BAAA;E1EqjyBV;E0E5jyBM;IAOI,0BAAA;E1EwjyBV;E0E/jyBM;IAOI,0BAAA;E1E2jyBV;E0ElkyBM;IAOI,0BAAA;E1E8jyBV;E0ErkyBM;IAOI,0BAAA;E1EikyBV;E0ExkyBM;IAOI,0BAAA;E1EokyBV;E0E3kyBM;IAOI,2BAAA;E1EukyBV;E0E9kyBM;IAOI,2BAAA;E1E0kyBV;E0EjlyBM;IAOI,2BAAA;E1E6kyBV;E0EplyBM;IAOI,2BAAA;E1EglyBV;E0EvlyBM;IAOI,2BAAA;E1EmlyBV;E0E1lyBM;IAOI,2BAAA;E1EslyBV;E0E7lyBM;IAOI,2BAAA;E1EylyBV;E0EhmyBM;IAOI,2BAAA;E1E4lyBV;E0EnmyBM;IAOI,2BAAA;E1E+lyBV;E0EtmyBM;IAOI,2BAAA;E1EkmyBV;E0EzmyBM;IAOI,2BAAA;E1EqmyBV;E0E5myBM;IAOI,2BAAA;E1EwmyBV;E0E/myBM;IAOI,2BAAA;E1E2myBV;E0ElnyBM;IAOI,2BAAA;E1E8myBV;E0ErnyBM;IAOI,2BAAA;E1EinyBV;E0ExnyBM;IAOI,2BAAA;E1EonyBV;E0E3nyBM;IAOI,2BAAA;E1EunyBV;E0E9nyBM;IAOI,2BAAA;E1E0nyBV;E0EjoyBM;IAOI,4BAAA;E1E6nyBV;E0EpoyBM;IAOI,4BAAA;E1EgoyBV;E0EvoyBM;IAOI,4BAAA;E1EmoyBV;E0E1oyBM;IAOI,4BAAA;E1EsoyBV;E0E7oyBM;IAOI,4BAAA;E1EyoyBV;E0EhpyBM;IAOI,4BAAA;E1E4oyBV;E0EnpyBM;IAOI,4BAAA;E1E+oyBV;E0EtpyBM;IAOI,4BAAA;E1EkpyBV;E0EzpyBM;IAOI,4BAAA;E1EqpyBV;E0E5pyBM;IAOI,4BAAA;E1EwpyBV;E0E/pyBM;IAOI,4BAAA;E1E2pyBV;E0ElqyBM;IAOI,4BAAA;E1E8pyBV;E0ErqyBM;IAOI,4BAAA;E1EiqyBV;E0ExqyBM;IAOI,4BAAA;E1EoqyBV;E0E3qyBM;IAOI,4BAAA;E1EuqyBV;E0E9qyBM;IAOI,4BAAA;E1E0qyBV;E0EjryBM;IAOI,4BAAA;E1E6qyBV;E0EpryBM;IAOI,4BAAA;E1EgryBV;E0EvryBM;IAOI,4BAAA;E1EmryBV;E0E1ryBM;IAOI,4BAAA;E1EsryBV;E0E7ryBM;IAOI,4BAAA;E1EyryBV;E0EhsyBM;IAOI,4BAAA;E1E4ryBV;E0EnsyBM;IAOI,4BAAA;E1E+ryBV;E0EtsyBM;IAOI,4BAAA;E1EksyBV;E0EzsyBM;IAOI,4BAAA;E1EqsyBV;E0E5syBM;IAOI,4BAAA;E1EwsyBV;E0E/syBM;IAOI,6BAAA;E1E2syBV;E0EltyBM;IAOI,yBAAA;E1E8syBV;E0ErtyBM;IAOI,8BAAA;E1EityBV;E0ExtyBM;IAOI,iCAAA;E1EotyBV;E0E3tyBM;IAOI,sCAAA;E1EutyBV;E0E9tyBM;IAOI,yCAAA;E1E0tyBV;E0EjuyBM;IAOI,uBAAA;E1E6tyBV;E0EpuyBM;IAOI,uBAAA;E1EguyBV;E0EvuyBM;IAOI,yBAAA;E1EmuyBV;E0E1uyBM;IAOI,yBAAA;E1EsuyBV;E0E7uyBM;IAOI,0BAAA;E1EyuyBV;E0EhvyBM;IAOI,4BAAA;E1E4uyBV;E0EnvyBM;IAOI,kCAAA;E1E+uyBV;E0EtvyBM;IAOI,sCAAA;E1EkvyBV;E0EzvyBM;IAOI,oCAAA;E1EqvyBV;E0E5vyBM;IAOI,kCAAA;E1EwvyBV;E0E/vyBM;IAOI,yCAAA;E1E2vyBV;E0ElwyBM;IAOI,wCAAA;E1E8vyBV;E0ErwyBM;IAOI,wCAAA;E1EiwyBV;E0ExwyBM;IAOI,kCAAA;E1EowyBV;E0E3wyBM;IAOI,gCAAA;E1EuwyBV;E0E9wyBM;IAOI,8BAAA;E1E0wyBV;E0EjxyBM;IAOI,gCAAA;E1E6wyBV;E0EpxyBM;IAOI,+BAAA;E1EgxyBV;E0EvxyBM;IAOI,oCAAA;E1EmxyBV;E0E1xyBM;IAOI,kCAAA;E1EsxyBV;E0E7xyBM;IAOI,gCAAA;E1EyxyBV;E0EhyyBM;IAOI,uCAAA;E1E4xyBV;E0EnyyBM;IAOI,sCAAA;E1E+xyBV;E0EtyyBM;IAOI,iCAAA;E1EkyyBV;E0EzyyBM;IAOI,2BAAA;E1EqyyBV;E0E5yyBM;IAOI,iCAAA;E1EwyyBV;E0E/yyBM;IAOI,+BAAA;E1E2yyBV;E0ElzyBM;IAOI,6BAAA;E1E8yyBV;E0ErzyBM;IAOI,+BAAA;E1EizyBV;E0ExzyBM;IAOI,8BAAA;E1EozyBV;E0E3zyBM;IAOI,oBAAA;E1EuzyBV;E0E9zyBM;IAOI,mBAAA;E1E0zyBV;E0Ej0yBM;IAOI,mBAAA;E1E6zyBV;E0Ep0yBM;IAOI,mBAAA;E1Eg0yBV;E0Ev0yBM;IAOI,mBAAA;E1Em0yBV;E0E10yBM;IAOI,mBAAA;E1Es0yBV;E0E70yBM;IAOI,mBAAA;E1Ey0yBV;E0Eh1yBM;IAOI,mBAAA;E1E40yBV;E0En1yBM;IAOI,oBAAA;E1E+0yBV;E0Et1yBM;IAOI,0BAAA;E1Ek1yBV;E0Ez1yBM;IAOI,yBAAA;E1Eq1yBV;E0E51yBM;IAOI,0BAAA;E1Ew1yBV;E0E/1yBM;IAOI,uBAAA;E1E21yBV;E0El2yBM;IAOI,0BAAA;E1E81yBV;E0Er2yBM;IAOI,yBAAA;E1Ei2yBV;E0Ex2yBM;IAOI,0BAAA;E1Eo2yBV;E0E32yBM;IAOI,uBAAA;E1Eu2yBV;E0E92yBM;IAOI,0BAAA;E1E02yBV;E0Ej3yBM;IAOI,yBAAA;E1E62yBV;E0Ep3yBM;IAOI,0BAAA;E1Eg3yBV;E0Ev3yBM;IAOI,uBAAA;E1Em3yBV;E0E13yBM;IAOI,0BAAA;E1Es3yBV;E0E73yBM;IAOI,yBAAA;E1Ey3yBV;E0Eh4yBM;IAOI,0BAAA;E1E43yBV;E0En4yBM;IAOI,uBAAA;E1E+3yBV;E0Et4yBM;IAOI,0BAAA;E1Ek4yBV;E0Ez4yBM;IAOI,yBAAA;E1Eq4yBV;E0E54yBM;IAOI,0BAAA;E1Ew4yBV;E0E/4yBM;IAOI,uBAAA;E1E24yBV;E0El5yBM;IAOI,uBAAA;E1E84yBV;E0Er5yBM;IAOI,0BAAA;IAAA,yBAAA;E1Ek5yBV;E0Ez5yBM;IAOI,gCAAA;IAAA,+BAAA;E1Es5yBV;E0E75yBM;IAOI,+BAAA;IAAA,8BAAA;E1E05yBV;E0Ej6yBM;IAOI,gCAAA;IAAA,+BAAA;E1E85yBV;E0Er6yBM;IAOI,6BAAA;IAAA,4BAAA;E1Ek6yBV;E0Ez6yBM;IAOI,gCAAA;IAAA,+BAAA;E1Es6yBV;E0E76yBM;IAOI,+BAAA;IAAA,8BAAA;E1E06yBV;E0Ej7yBM;IAOI,gCAAA;IAAA,+BAAA;E1E86yBV;E0Er7yBM;IAOI,6BAAA;IAAA,4BAAA;E1Ek7yBV;E0Ez7yBM;IAOI,gCAAA;IAAA,+BAAA;E1Es7yBV;E0E77yBM;IAOI,+BAAA;IAAA,8BAAA;E1E07yBV;E0Ej8yBM;IAOI,gCAAA;IAAA,+BAAA;E1E87yBV;E0Er8yBM;IAOI,6BAAA;IAAA,4BAAA;E1Ek8yBV;E0Ez8yBM;IAOI,gCAAA;IAAA,+BAAA;E1Es8yBV;E0E78yBM;IAOI,+BAAA;IAAA,8BAAA;E1E08yBV;E0Ej9yBM;IAOI,gCAAA;IAAA,+BAAA;E1E88yBV;E0Er9yBM;IAOI,6BAAA;IAAA,4BAAA;E1Ek9yBV;E0Ez9yBM;IAOI,gCAAA;IAAA,+BAAA;E1Es9yBV;E0E79yBM;IAOI,+BAAA;IAAA,8BAAA;E1E09yBV;E0Ej+yBM;IAOI,gCAAA;IAAA,+BAAA;E1E89yBV;E0Er+yBM;IAOI,6BAAA;IAAA,4BAAA;E1Ek+yBV;E0Ez+yBM;IAOI,6BAAA;IAAA,4BAAA;E1Es+yBV;E0E7+yBM;IAOI,wBAAA;IAAA,2BAAA;E1E0+yBV;E0Ej/yBM;IAOI,8BAAA;IAAA,iCAAA;E1E8+yBV;E0Er/yBM;IAOI,6BAAA;IAAA,gCAAA;E1Ek/yBV;E0Ez/yBM;IAOI,8BAAA;IAAA,iCAAA;E1Es/yBV;E0E7/yBM;IAOI,2BAAA;IAAA,8BAAA;E1E0/yBV;E0EjgzBM;IAOI,8BAAA;IAAA,iCAAA;E1E8/yBV;E0ErgzBM;IAOI,6BAAA;IAAA,gCAAA;E1EkgzBV;E0EzgzBM;IAOI,8BAAA;IAAA,iCAAA;E1EsgzBV;E0E7gzBM;IAOI,2BAAA;IAAA,8BAAA;E1E0gzBV;E0EjhzBM;IAOI,8BAAA;IAAA,iCAAA;E1E8gzBV;E0ErhzBM;IAOI,6BAAA;IAAA,gCAAA;E1EkhzBV;E0EzhzBM;IAOI,8BAAA;IAAA,iCAAA;E1EshzBV;E0E7hzBM;IAOI,2BAAA;IAAA,8BAAA;E1E0hzBV;E0EjizBM;IAOI,8BAAA;IAAA,iCAAA;E1E8hzBV;E0ErizBM;IAOI,6BAAA;IAAA,gCAAA;E1EkizBV;E0EzizBM;IAOI,8BAAA;IAAA,iCAAA;E1EsizBV;E0E7izBM;IAOI,2BAAA;IAAA,8BAAA;E1E0izBV;E0EjjzBM;IAOI,8BAAA;IAAA,iCAAA;E1E8izBV;E0ErjzBM;IAOI,6BAAA;IAAA,gCAAA;E1EkjzBV;E0EzjzBM;IAOI,8BAAA;IAAA,iCAAA;E1EsjzBV;E0E7jzBM;IAOI,2BAAA;IAAA,8BAAA;E1E0jzBV;E0EjkzBM;IAOI,2BAAA;IAAA,8BAAA;E1E8jzBV;E0ErkzBM;IAOI,wBAAA;E1EikzBV;E0ExkzBM;IAOI,8BAAA;E1EokzBV;E0E3kzBM;IAOI,6BAAA;E1EukzBV;E0E9kzBM;IAOI,8BAAA;E1E0kzBV;E0EjlzBM;IAOI,2BAAA;E1E6kzBV;E0EplzBM;IAOI,8BAAA;E1EglzBV;E0EvlzBM;IAOI,6BAAA;E1EmlzBV;E0E1lzBM;IAOI,8BAAA;E1EslzBV;E0E7lzBM;IAOI,2BAAA;E1EylzBV;E0EhmzBM;IAOI,8BAAA;E1E4lzBV;E0EnmzBM;IAOI,6BAAA;E1E+lzBV;E0EtmzBM;IAOI,8BAAA;E1EkmzBV;E0EzmzBM;IAOI,2BAAA;E1EqmzBV;E0E5mzBM;IAOI,8BAAA;E1EwmzBV;E0E/mzBM;IAOI,6BAAA;E1E2mzBV;E0ElnzBM;IAOI,8BAAA;E1E8mzBV;E0ErnzBM;IAOI,2BAAA;E1EinzBV;E0ExnzBM;IAOI,8BAAA;E1EonzBV;E0E3nzBM;IAOI,6BAAA;E1EunzBV;E0E9nzBM;IAOI,8BAAA;E1E0nzBV;E0EjozBM;IAOI,2BAAA;E1E6nzBV;E0EpozBM;IAOI,2BAAA;E1EgozBV;E0EvozBM;IAOI,0BAAA;E1EmozBV;E0E1ozBM;IAOI,gCAAA;E1EsozBV;E0E7ozBM;IAOI,+BAAA;E1EyozBV;E0EhpzBM;IAOI,gCAAA;E1E4ozBV;E0EnpzBM;IAOI,6BAAA;E1E+ozBV;E0EtpzBM;IAOI,gCAAA;E1EkpzBV;E0EzpzBM;IAOI,+BAAA;E1EqpzBV;E0E5pzBM;IAOI,gCAAA;E1EwpzBV;E0E/pzBM;IAOI,6BAAA;E1E2pzBV;E0ElqzBM;IAOI,gCAAA;E1E8pzBV;E0ErqzBM;IAOI,+BAAA;E1EiqzBV;E0ExqzBM;IAOI,gCAAA;E1EoqzBV;E0E3qzBM;IAOI,6BAAA;E1EuqzBV;E0E9qzBM;IAOI,gCAAA;E1E0qzBV;E0EjrzBM;IAOI,+BAAA;E1E6qzBV;E0EprzBM;IAOI,gCAAA;E1EgrzBV;E0EvrzBM;IAOI,6BAAA;E1EmrzBV;E0E1rzBM;IAOI,gCAAA;E1EsrzBV;E0E7rzBM;IAOI,+BAAA;E1EyrzBV;E0EhszBM;IAOI,gCAAA;E1E4rzBV;E0EnszBM;IAOI,6BAAA;E1E+rzBV;E0EtszBM;IAOI,6BAAA;E1EkszBV;E0EzszBM;IAOI,2BAAA;E1EqszBV;E0E5szBM;IAOI,iCAAA;E1EwszBV;E0E/szBM;IAOI,gCAAA;E1E2szBV;E0EltzBM;IAOI,iCAAA;E1E8szBV;E0ErtzBM;IAOI,8BAAA;E1EitzBV;E0ExtzBM;IAOI,iCAAA;E1EotzBV;E0E3tzBM;IAOI,gCAAA;E1EutzBV;E0E9tzBM;IAOI,iCAAA;E1E0tzBV;E0EjuzBM;IAOI,8BAAA;E1E6tzBV;E0EpuzBM;IAOI,iCAAA;E1EguzBV;E0EvuzBM;IAOI,gCAAA;E1EmuzBV;E0E1uzBM;IAOI,iCAAA;E1EsuzBV;E0E7uzBM;IAOI,8BAAA;E1EyuzBV;E0EhvzBM;IAOI,iCAAA;E1E4uzBV;E0EnvzBM;IAOI,gCAAA;E1E+uzBV;E0EtvzBM;IAOI,iCAAA;E1EkvzBV;E0EzvzBM;IAOI,8BAAA;E1EqvzBV;E0E5vzBM;IAOI,iCAAA;E1EwvzBV;E0E/vzBM;IAOI,gCAAA;E1E2vzBV;E0ElwzBM;IAOI,iCAAA;E1E8vzBV;E0ErwzBM;IAOI,8BAAA;E1EiwzBV;E0ExwzBM;IAOI,8BAAA;E1EowzBV;E0E3wzBM;IAOI,yBAAA;E1EuwzBV;E0E9wzBM;IAOI,+BAAA;E1E0wzBV;E0EjxzBM;IAOI,8BAAA;E1E6wzBV;E0EpxzBM;IAOI,+BAAA;E1EgxzBV;E0EvxzBM;IAOI,4BAAA;E1EmxzBV;E0E1xzBM;IAOI,+BAAA;E1EsxzBV;E0E7xzBM;IAOI,8BAAA;E1EyxzBV;E0EhyzBM;IAOI,+BAAA;E1E4xzBV;E0EnyzBM;IAOI,4BAAA;E1E+xzBV;E0EtyzBM;IAOI,+BAAA;E1EkyzBV;E0EzyzBM;IAOI,8BAAA;E1EqyzBV;E0E5yzBM;IAOI,+BAAA;E1EwyzBV;E0E/yzBM;IAOI,4BAAA;E1E2yzBV;E0ElzzBM;IAOI,+BAAA;E1E8yzBV;E0ErzzBM;IAOI,8BAAA;E1EizzBV;E0ExzzBM;IAOI,+BAAA;E1EozzBV;E0E3zzBM;IAOI,4BAAA;E1EuzzBV;E0E9zzBM;IAOI,+BAAA;E1E0zzBV;E0Ej0zBM;IAOI,8BAAA;E1E6zzBV;E0Ep0zBM;IAOI,+BAAA;E1Eg0zBV;E0Ev0zBM;IAOI,4BAAA;E1Em0zBV;E0E10zBM;IAOI,4BAAA;E1Es0zBV;E0E70zBM;IAOI,2BAAA;E1Ey0zBV;E0Eh1zBM;IAOI,0BAAA;E1E40zBV;E0En1zBM;IAOI,2BAAA;E1E+0zBV;E0Et1zBM;IAOI,wBAAA;E1Ek1zBV;E0Ez1zBM;IAOI,2BAAA;E1Eq1zBV;E0E51zBM;IAOI,0BAAA;E1Ew1zBV;E0E/1zBM;IAOI,2BAAA;E1E21zBV;E0El2zBM;IAOI,wBAAA;E1E81zBV;E0Er2zBM;IAOI,2BAAA;E1Ei2zBV;E0Ex2zBM;IAOI,0BAAA;E1Eo2zBV;E0E32zBM;IAOI,2BAAA;E1Eu2zBV;E0E92zBM;IAOI,wBAAA;E1E02zBV;E0Ej3zBM;IAOI,2BAAA;E1E62zBV;E0Ep3zBM;IAOI,0BAAA;E1Eg3zBV;E0Ev3zBM;IAOI,2BAAA;E1Em3zBV;E0E13zBM;IAOI,wBAAA;E1Es3zBV;E0E73zBM;IAOI,2BAAA;E1Ey3zBV;E0Eh4zBM;IAOI,0BAAA;E1E43zBV;E0En4zBM;IAOI,2BAAA;E1E+3zBV;E0Et4zBM;IAOI,wBAAA;E1Ek4zBV;E0Ez4zBM;IAOI,iCAAA;IAAA,gCAAA;E1Es4zBV;E0E74zBM;IAOI,gCAAA;IAAA,+BAAA;E1E04zBV;E0Ej5zBM;IAOI,iCAAA;IAAA,gCAAA;E1E84zBV;E0Er5zBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek5zBV;E0Ez5zBM;IAOI,iCAAA;IAAA,gCAAA;E1Es5zBV;E0E75zBM;IAOI,gCAAA;IAAA,+BAAA;E1E05zBV;E0Ej6zBM;IAOI,iCAAA;IAAA,gCAAA;E1E85zBV;E0Er6zBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek6zBV;E0Ez6zBM;IAOI,iCAAA;IAAA,gCAAA;E1Es6zBV;E0E76zBM;IAOI,gCAAA;IAAA,+BAAA;E1E06zBV;E0Ej7zBM;IAOI,iCAAA;IAAA,gCAAA;E1E86zBV;E0Er7zBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek7zBV;E0Ez7zBM;IAOI,iCAAA;IAAA,gCAAA;E1Es7zBV;E0E77zBM;IAOI,gCAAA;IAAA,+BAAA;E1E07zBV;E0Ej8zBM;IAOI,iCAAA;IAAA,gCAAA;E1E87zBV;E0Er8zBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek8zBV;E0Ez8zBM;IAOI,iCAAA;IAAA,gCAAA;E1Es8zBV;E0E78zBM;IAOI,gCAAA;IAAA,+BAAA;E1E08zBV;E0Ej9zBM;IAOI,iCAAA;IAAA,gCAAA;E1E88zBV;E0Er9zBM;IAOI,8BAAA;IAAA,6BAAA;E1Ek9zBV;E0Ez9zBM;IAOI,+BAAA;IAAA,kCAAA;E1Es9zBV;E0E79zBM;IAOI,8BAAA;IAAA,iCAAA;E1E09zBV;E0Ej+zBM;IAOI,+BAAA;IAAA,kCAAA;E1E89zBV;E0Er+zBM;IAOI,4BAAA;IAAA,+BAAA;E1Ek+zBV;E0Ez+zBM;IAOI,+BAAA;IAAA,kCAAA;E1Es+zBV;E0E7+zBM;IAOI,8BAAA;IAAA,iCAAA;E1E0+zBV;E0Ej/zBM;IAOI,+BAAA;IAAA,kCAAA;E1E8+zBV;E0Er/zBM;IAOI,4BAAA;IAAA,+BAAA;E1Ek/zBV;E0Ez/zBM;IAOI,+BAAA;IAAA,kCAAA;E1Es/zBV;E0E7/zBM;IAOI,8BAAA;IAAA,iCAAA;E1E0/zBV;E0Ejg0BM;IAOI,+BAAA;IAAA,kCAAA;E1E8/zBV;E0Erg0BM;IAOI,4BAAA;IAAA,+BAAA;E1Ekg0BV;E0Ezg0BM;IAOI,+BAAA;IAAA,kCAAA;E1Esg0BV;E0E7g0BM;IAOI,8BAAA;IAAA,iCAAA;E1E0g0BV;E0Ejh0BM;IAOI,+BAAA;IAAA,kCAAA;E1E8g0BV;E0Erh0BM;IAOI,4BAAA;IAAA,+BAAA;E1Ekh0BV;E0Ezh0BM;IAOI,+BAAA;IAAA,kCAAA;E1Esh0BV;E0E7h0BM;IAOI,8BAAA;IAAA,iCAAA;E1E0h0BV;E0Eji0BM;IAOI,+BAAA;IAAA,kCAAA;E1E8h0BV;E0Eri0BM;IAOI,4BAAA;IAAA,+BAAA;E1Eki0BV;E0Ezi0BM;IAOI,+BAAA;E1Eqi0BV;E0E5i0BM;IAOI,8BAAA;E1Ewi0BV;E0E/i0BM;IAOI,+BAAA;E1E2i0BV;E0Elj0BM;IAOI,4BAAA;E1E8i0BV;E0Erj0BM;IAOI,+BAAA;E1Eij0BV;E0Exj0BM;IAOI,8BAAA;E1Eoj0BV;E0E3j0BM;IAOI,+BAAA;E1Euj0BV;E0E9j0BM;IAOI,4BAAA;E1E0j0BV;E0Ejk0BM;IAOI,+BAAA;E1E6j0BV;E0Epk0BM;IAOI,8BAAA;E1Egk0BV;E0Evk0BM;IAOI,+BAAA;E1Emk0BV;E0E1k0BM;IAOI,4BAAA;E1Esk0BV;E0E7k0BM;IAOI,+BAAA;E1Eyk0BV;E0Ehl0BM;IAOI,8BAAA;E1E4k0BV;E0Enl0BM;IAOI,+BAAA;E1E+k0BV;E0Etl0BM;IAOI,4BAAA;E1Ekl0BV;E0Ezl0BM;IAOI,+BAAA;E1Eql0BV;E0E5l0BM;IAOI,8BAAA;E1Ewl0BV;E0E/l0BM;IAOI,+BAAA;E1E2l0BV;E0Elm0BM;IAOI,4BAAA;E1E8l0BV;E0Erm0BM;IAOI,iCAAA;E1Eim0BV;E0Exm0BM;IAOI,gCAAA;E1Eom0BV;E0E3m0BM;IAOI,iCAAA;E1Eum0BV;E0E9m0BM;IAOI,8BAAA;E1E0m0BV;E0Ejn0BM;IAOI,iCAAA;E1E6m0BV;E0Epn0BM;IAOI,gCAAA;E1Egn0BV;E0Evn0BM;IAOI,iCAAA;E1Emn0BV;E0E1n0BM;IAOI,8BAAA;E1Esn0BV;E0E7n0BM;IAOI,iCAAA;E1Eyn0BV;E0Eho0BM;IAOI,gCAAA;E1E4n0BV;E0Eno0BM;IAOI,iCAAA;E1E+n0BV;E0Eto0BM;IAOI,8BAAA;E1Eko0BV;E0Ezo0BM;IAOI,iCAAA;E1Eqo0BV;E0E5o0BM;IAOI,gCAAA;E1Ewo0BV;E0E/o0BM;IAOI,iCAAA;E1E2o0BV;E0Elp0BM;IAOI,8BAAA;E1E8o0BV;E0Erp0BM;IAOI,iCAAA;E1Eip0BV;E0Exp0BM;IAOI,gCAAA;E1Eop0BV;E0E3p0BM;IAOI,iCAAA;E1Eup0BV;E0E9p0BM;IAOI,8BAAA;E1E0p0BV;E0Ejq0BM;IAOI,kCAAA;E1E6p0BV;E0Epq0BM;IAOI,iCAAA;E1Egq0BV;E0Evq0BM;IAOI,kCAAA;E1Emq0BV;E0E1q0BM;IAOI,+BAAA;E1Esq0BV;E0E7q0BM;IAOI,kCAAA;E1Eyq0BV;E0Ehr0BM;IAOI,iCAAA;E1E4q0BV;E0Enr0BM;IAOI,kCAAA;E1E+q0BV;E0Etr0BM;IAOI,+BAAA;E1Ekr0BV;E0Ezr0BM;IAOI,kCAAA;E1Eqr0BV;E0E5r0BM;IAOI,iCAAA;E1Ewr0BV;E0E/r0BM;IAOI,kCAAA;E1E2r0BV;E0Els0BM;IAOI,+BAAA;E1E8r0BV;E0Ers0BM;IAOI,kCAAA;E1Eis0BV;E0Exs0BM;IAOI,iCAAA;E1Eos0BV;E0E3s0BM;IAOI,kCAAA;E1Eus0BV;E0E9s0BM;IAOI,+BAAA;E1E0s0BV;E0Ejt0BM;IAOI,kCAAA;E1E6s0BV;E0Ept0BM;IAOI,iCAAA;E1Egt0BV;E0Evt0BM;IAOI,kCAAA;E1Emt0BV;E0E1t0BM;IAOI,+BAAA;E1Est0BV;E0E7t0BM;IAOI,gCAAA;E1Eyt0BV;E0Ehu0BM;IAOI,+BAAA;E1E4t0BV;E0Enu0BM;IAOI,gCAAA;E1E+t0BV;E0Etu0BM;IAOI,6BAAA;E1Eku0BV;E0Ezu0BM;IAOI,gCAAA;E1Equ0BV;E0E5u0BM;IAOI,+BAAA;E1Ewu0BV;E0E/u0BM;IAOI,gCAAA;E1E2u0BV;E0Elv0BM;IAOI,6BAAA;E1E8u0BV;E0Erv0BM;IAOI,gCAAA;E1Eiv0BV;E0Exv0BM;IAOI,+BAAA;E1Eov0BV;E0E3v0BM;IAOI,gCAAA;E1Euv0BV;E0E9v0BM;IAOI,6BAAA;E1E0v0BV;E0Ejw0BM;IAOI,gCAAA;E1E6v0BV;E0Epw0BM;IAOI,+BAAA;E1Egw0BV;E0Evw0BM;IAOI,gCAAA;E1Emw0BV;E0E1w0BM;IAOI,6BAAA;E1Esw0BV;E0E7w0BM;IAOI,gCAAA;E1Eyw0BV;E0Ehx0BM;IAOI,+BAAA;E1E4w0BV;E0Enx0BM;IAOI,gCAAA;E1E+w0BV;E0Etx0BM;IAOI,6BAAA;E1Ekx0BV;E0Ezx0BM;IAOI,qBAAA;E1Eqx0BV;E0E5x0BM;IAOI,2BAAA;E1Ewx0BV;E0E/x0BM;IAOI,0BAAA;E1E2x0BV;E0Ely0BM;IAOI,2BAAA;E1E8x0BV;E0Ery0BM;IAOI,wBAAA;E1Eiy0BV;E0Exy0BM;IAOI,2BAAA;E1Eoy0BV;E0E3y0BM;IAOI,0BAAA;E1Euy0BV;E0E9y0BM;IAOI,2BAAA;E1E0y0BV;E0Ejz0BM;IAOI,wBAAA;E1E6y0BV;E0Epz0BM;IAOI,2BAAA;E1Egz0BV;E0Evz0BM;IAOI,0BAAA;E1Emz0BV;E0E1z0BM;IAOI,2BAAA;E1Esz0BV;E0E7z0BM;IAOI,wBAAA;E1Eyz0BV;E0Eh00BM;IAOI,2BAAA;E1E4z0BV;E0En00BM;IAOI,0BAAA;E1E+z0BV;E0Et00BM;IAOI,2BAAA;E1Ek00BV;E0Ez00BM;IAOI,wBAAA;E1Eq00BV;E0E500BM;IAOI,2BAAA;E1Ew00BV;E0E/00BM;IAOI,0BAAA;E1E200BV;E0El10BM;IAOI,2BAAA;E1E800BV;E0Er10BM;IAOI,wBAAA;E1Ei10BV;E0Ex10BM;IAOI,2BAAA;IAAA,0BAAA;E1Eq10BV;E0E510BM;IAOI,iCAAA;IAAA,gCAAA;E1Ey10BV;E0Eh20BM;IAOI,gCAAA;IAAA,+BAAA;E1E610BV;E0Ep20BM;IAOI,iCAAA;IAAA,gCAAA;E1Ei20BV;E0Ex20BM;IAOI,8BAAA;IAAA,6BAAA;E1Eq20BV;E0E520BM;IAOI,iCAAA;IAAA,gCAAA;E1Ey20BV;E0Eh30BM;IAOI,gCAAA;IAAA,+BAAA;E1E620BV;E0Ep30BM;IAOI,iCAAA;IAAA,gCAAA;E1Ei30BV;E0Ex30BM;IAOI,8BAAA;IAAA,6BAAA;E1Eq30BV;E0E530BM;IAOI,iCAAA;IAAA,gCAAA;E1Ey30BV;E0Eh40BM;IAOI,gCAAA;IAAA,+BAAA;E1E630BV;E0Ep40BM;IAOI,iCAAA;IAAA,gCAAA;E1Ei40BV;E0Ex40BM;IAOI,8BAAA;IAAA,6BAAA;E1Eq40BV;E0E540BM;IAOI,iCAAA;IAAA,gCAAA;E1Ey40BV;E0Eh50BM;IAOI,gCAAA;IAAA,+BAAA;E1E640BV;E0Ep50BM;IAOI,iCAAA;IAAA,gCAAA;E1Ei50BV;E0Ex50BM;IAOI,8BAAA;IAAA,6BAAA;E1Eq50BV;E0E550BM;IAOI,iCAAA;IAAA,gCAAA;E1Ey50BV;E0Eh60BM;IAOI,gCAAA;IAAA,+BAAA;E1E650BV;E0Ep60BM;IAOI,iCAAA;IAAA,gCAAA;E1Ei60BV;E0Ex60BM;IAOI,8BAAA;IAAA,6BAAA;E1Eq60BV;E0E560BM;IAOI,yBAAA;IAAA,4BAAA;E1Ey60BV;E0Eh70BM;IAOI,+BAAA;IAAA,kCAAA;E1E660BV;E0Ep70BM;IAOI,8BAAA;IAAA,iCAAA;E1Ei70BV;E0Ex70BM;IAOI,+BAAA;IAAA,kCAAA;E1Eq70BV;E0E570BM;IAOI,4BAAA;IAAA,+BAAA;E1Ey70BV;E0Eh80BM;IAOI,+BAAA;IAAA,kCAAA;E1E670BV;E0Ep80BM;IAOI,8BAAA;IAAA,iCAAA;E1Ei80BV;E0Ex80BM;IAOI,+BAAA;IAAA,kCAAA;E1Eq80BV;E0E580BM;IAOI,4BAAA;IAAA,+BAAA;E1Ey80BV;E0Eh90BM;IAOI,+BAAA;IAAA,kCAAA;E1E680BV;E0Ep90BM;IAOI,8BAAA;IAAA,iCAAA;E1Ei90BV;E0Ex90BM;IAOI,+BAAA;IAAA,kCAAA;E1Eq90BV;E0E590BM;IAOI,4BAAA;IAAA,+BAAA;E1Ey90BV;E0Eh+0BM;IAOI,+BAAA;IAAA,kCAAA;E1E690BV;E0Ep+0BM;IAOI,8BAAA;IAAA,iCAAA;E1Ei+0BV;E0Ex+0BM;IAOI,+BAAA;IAAA,kCAAA;E1Eq+0BV;E0E5+0BM;IAOI,4BAAA;IAAA,+BAAA;E1Ey+0BV;E0Eh/0BM;IAOI,+BAAA;IAAA,kCAAA;E1E6+0BV;E0Ep/0BM;IAOI,8BAAA;IAAA,iCAAA;E1Ei/0BV;E0Ex/0BM;IAOI,+BAAA;IAAA,kCAAA;E1Eq/0BV;E0E5/0BM;IAOI,4BAAA;IAAA,+BAAA;E1Ey/0BV;E0Ehg1BM;IAOI,yBAAA;E1E4/0BV;E0Eng1BM;IAOI,+BAAA;E1E+/0BV;E0Etg1BM;IAOI,8BAAA;E1Ekg1BV;E0Ezg1BM;IAOI,+BAAA;E1Eqg1BV;E0E5g1BM;IAOI,4BAAA;E1Ewg1BV;E0E/g1BM;IAOI,+BAAA;E1E2g1BV;E0Elh1BM;IAOI,8BAAA;E1E8g1BV;E0Erh1BM;IAOI,+BAAA;E1Eih1BV;E0Exh1BM;IAOI,4BAAA;E1Eoh1BV;E0E3h1BM;IAOI,+BAAA;E1Euh1BV;E0E9h1BM;IAOI,8BAAA;E1E0h1BV;E0Eji1BM;IAOI,+BAAA;E1E6h1BV;E0Epi1BM;IAOI,4BAAA;E1Egi1BV;E0Evi1BM;IAOI,+BAAA;E1Emi1BV;E0E1i1BM;IAOI,8BAAA;E1Esi1BV;E0E7i1BM;IAOI,+BAAA;E1Eyi1BV;E0Ehj1BM;IAOI,4BAAA;E1E4i1BV;E0Enj1BM;IAOI,+BAAA;E1E+i1BV;E0Etj1BM;IAOI,8BAAA;E1Ekj1BV;E0Ezj1BM;IAOI,+BAAA;E1Eqj1BV;E0E5j1BM;IAOI,4BAAA;E1Ewj1BV;E0E/j1BM;IAOI,2BAAA;E1E2j1BV;E0Elk1BM;IAOI,iCAAA;E1E8j1BV;E0Erk1BM;IAOI,gCAAA;E1Eik1BV;E0Exk1BM;IAOI,iCAAA;E1Eok1BV;E0E3k1BM;IAOI,8BAAA;E1Euk1BV;E0E9k1BM;IAOI,iCAAA;E1E0k1BV;E0Ejl1BM;IAOI,gCAAA;E1E6k1BV;E0Epl1BM;IAOI,iCAAA;E1Egl1BV;E0Evl1BM;IAOI,8BAAA;E1Eml1BV;E0E1l1BM;IAOI,iCAAA;E1Esl1BV;E0E7l1BM;IAOI,gCAAA;E1Eyl1BV;E0Ehm1BM;IAOI,iCAAA;E1E4l1BV;E0Enm1BM;IAOI,8BAAA;E1E+l1BV;E0Etm1BM;IAOI,iCAAA;E1Ekm1BV;E0Ezm1BM;IAOI,gCAAA;E1Eqm1BV;E0E5m1BM;IAOI,iCAAA;E1Ewm1BV;E0E/m1BM;IAOI,8BAAA;E1E2m1BV;E0Eln1BM;IAOI,iCAAA;E1E8m1BV;E0Ern1BM;IAOI,gCAAA;E1Ein1BV;E0Exn1BM;IAOI,iCAAA;E1Eon1BV;E0E3n1BM;IAOI,8BAAA;E1Eun1BV;E0E9n1BM;IAOI,4BAAA;E1E0n1BV;E0Ejo1BM;IAOI,kCAAA;E1E6n1BV;E0Epo1BM;IAOI,iCAAA;E1Ego1BV;E0Evo1BM;IAOI,kCAAA;E1Emo1BV;E0E1o1BM;IAOI,+BAAA;E1Eso1BV;E0E7o1BM;IAOI,kCAAA;E1Eyo1BV;E0Ehp1BM;IAOI,iCAAA;E1E4o1BV;E0Enp1BM;IAOI,kCAAA;E1E+o1BV;E0Etp1BM;IAOI,+BAAA;E1Ekp1BV;E0Ezp1BM;IAOI,kCAAA;E1Eqp1BV;E0E5p1BM;IAOI,iCAAA;E1Ewp1BV;E0E/p1BM;IAOI,kCAAA;E1E2p1BV;E0Elq1BM;IAOI,+BAAA;E1E8p1BV;E0Erq1BM;IAOI,kCAAA;E1Eiq1BV;E0Exq1BM;IAOI,iCAAA;E1Eoq1BV;E0E3q1BM;IAOI,kCAAA;E1Euq1BV;E0E9q1BM;IAOI,+BAAA;E1E0q1BV;E0Ejr1BM;IAOI,kCAAA;E1E6q1BV;E0Epr1BM;IAOI,iCAAA;E1Egr1BV;E0Evr1BM;IAOI,kCAAA;E1Emr1BV;E0E1r1BM;IAOI,+BAAA;E1Esr1BV;E0E7r1BM;IAOI,0BAAA;E1Eyr1BV;E0Ehs1BM;IAOI,gCAAA;E1E4r1BV;E0Ens1BM;IAOI,+BAAA;E1E+r1BV;E0Ets1BM;IAOI,gCAAA;E1Eks1BV;E0Ezs1BM;IAOI,6BAAA;E1Eqs1BV;E0E5s1BM;IAOI,gCAAA;E1Ews1BV;E0E/s1BM;IAOI,+BAAA;E1E2s1BV;E0Elt1BM;IAOI,gCAAA;E1E8s1BV;E0Ert1BM;IAOI,6BAAA;E1Eit1BV;E0Ext1BM;IAOI,gCAAA;E1Eot1BV;E0E3t1BM;IAOI,+BAAA;E1Eut1BV;E0E9t1BM;IAOI,gCAAA;E1E0t1BV;E0Eju1BM;IAOI,6BAAA;E1E6t1BV;E0Epu1BM;IAOI,gCAAA;E1Egu1BV;E0Evu1BM;IAOI,+BAAA;E1Emu1BV;E0E1u1BM;IAOI,gCAAA;E1Esu1BV;E0E7u1BM;IAOI,6BAAA;E1Eyu1BV;E0Ehv1BM;IAOI,gCAAA;E1E4u1BV;E0Env1BM;IAOI,+BAAA;E1E+u1BV;E0Etv1BM;IAOI,gCAAA;E1Ekv1BV;E0Ezv1BM;IAOI,6BAAA;E1Eqv1BV;E0E5v1BM;IAOI,iBAAA;E1Ewv1BV;E0E/v1BM;IAOI,uBAAA;E1E2v1BV;E0Elw1BM;IAOI,sBAAA;E1E8v1BV;E0Erw1BM;IAOI,uBAAA;E1Eiw1BV;E0Exw1BM;IAOI,oBAAA;E1Eow1BV;E0E3w1BM;IAOI,uBAAA;E1Euw1BV;E0E9w1BM;IAOI,sBAAA;E1E0w1BV;E0Ejx1BM;IAOI,uBAAA;E1E6w1BV;E0Epx1BM;IAOI,oBAAA;E1Egx1BV;E0Evx1BM;IAOI,uBAAA;E1Emx1BV;E0E1x1BM;IAOI,sBAAA;E1Esx1BV;E0E7x1BM;IAOI,uBAAA;E1Eyx1BV;E0Ehy1BM;IAOI,oBAAA;E1E4x1BV;E0Eny1BM;IAOI,uBAAA;E1E+x1BV;E0Ety1BM;IAOI,sBAAA;E1Eky1BV;E0Ezy1BM;IAOI,uBAAA;E1Eqy1BV;E0E5y1BM;IAOI,oBAAA;E1Ewy1BV;E0E/y1BM;IAOI,uBAAA;E1E2y1BV;E0Elz1BM;IAOI,sBAAA;E1E8y1BV;E0Erz1BM;IAOI,uBAAA;E1Eiz1BV;E0Exz1BM;IAOI,oBAAA;E1Eoz1BV;E0E3z1BM;IAOI,qBAAA;E1Euz1BV;E0E9z1BM;IAOI,2BAAA;E1E0z1BV;E0Ej01BM;IAOI,0BAAA;E1E6z1BV;E0Ep01BM;IAOI,2BAAA;E1Eg01BV;E0Ev01BM;IAOI,wBAAA;E1Em01BV;E0E101BM;IAOI,2BAAA;E1Es01BV;E0E701BM;IAOI,0BAAA;E1Ey01BV;E0Eh11BM;IAOI,2BAAA;E1E401BV;E0En11BM;IAOI,wBAAA;E1E+01BV;E0Et11BM;IAOI,2BAAA;E1Ek11BV;E0Ez11BM;IAOI,0BAAA;E1Eq11BV;E0E511BM;IAOI,2BAAA;E1Ew11BV;E0E/11BM;IAOI,wBAAA;E1E211BV;E0El21BM;IAOI,2BAAA;E1E811BV;E0Er21BM;IAOI,0BAAA;E1Ei21BV;E0Ex21BM;IAOI,2BAAA;E1Eo21BV;E0E321BM;IAOI,wBAAA;E1Eu21BV;E0E921BM;IAOI,2BAAA;E1E021BV;E0Ej31BM;IAOI,0BAAA;E1E621BV;E0Ep31BM;IAOI,2BAAA;E1Eg31BV;E0Ev31BM;IAOI,wBAAA;E1Em31BV;E0E131BM;IAOI,wBAAA;E1Es31BV;E0E731BM;IAOI,8BAAA;E1Ey31BV;E0Eh41BM;IAOI,6BAAA;E1E431BV;E0En41BM;IAOI,8BAAA;E1E+31BV;E0Et41BM;IAOI,2BAAA;E1Ek41BV;E0Ez41BM;IAOI,8BAAA;E1Eq41BV;E0E541BM;IAOI,6BAAA;E1Ew41BV;E0E/41BM;IAOI,8BAAA;E1E241BV;E0El51BM;IAOI,2BAAA;E1E841BV;E0Er51BM;IAOI,8BAAA;E1Ei51BV;E0Ex51BM;IAOI,6BAAA;E1Eo51BV;E0E351BM;IAOI,8BAAA;E1Eu51BV;E0E951BM;IAOI,2BAAA;E1E051BV;E0Ej61BM;IAOI,8BAAA;E1E651BV;E0Ep61BM;IAOI,6BAAA;E1Eg61BV;E0Ev61BM;IAOI,8BAAA;E1Em61BV;E0E161BM;IAOI,2BAAA;E1Es61BV;E0E761BM;IAOI,8BAAA;E1Ey61BV;E0Eh71BM;IAOI,6BAAA;E1E461BV;E0En71BM;IAOI,8BAAA;E1E+61BV;E0Et71BM;IAOI,2BAAA;E1Ek71BV;E0Ez71BM;IAOI,0CAAA;E1Eq71BV;E0E571BM;IAOI,4CAAA;E1Ew71BV;E0E/71BM;IAOI,4CAAA;E1E271BV;E0El81BM;IAOI,6BAAA;E1E871BV;E0Er81BM;IAOI,6BAAA;E1Ei81BV;E0Ex81BM;IAOI,8BAAA;E1Eo81BV;E0E381BM;IAOI,6BAAA;E1Eu81BV;E0E981BM;IAOI,6BAAA;E1E081BV;E0Ej91BM;IAOI,6BAAA;E1E681BV;E0Ep91BM;IAOI,4BAAA;E1Eg91BV;E0Ev91BM;IAOI,6BAAA;E1Em91BV;E0E191BM;IAOI,0BAAA;E1Es91BV;E0E791BM;IAOI,8BAAA;E1Ey91BV;E0Eh+1BM;IAOI,6BAAA;E1E491BV;E0En+1BM;IAOI,0BAAA;E1E+91BV;E0Et+1BM;IAOI,4CAAA;E1Ek+1BV;E0Ez+1BM;IAOI,2CAAA;E1Eq+1BV;E0E5+1BM;IAOI,4CAAA;E1Ew+1BV;E0E/+1BM;IAOI,0CAAA;E1E2+1BV;E0El/1BM;IAOI,4CAAA;E1E8+1BV;E0Er/1BM;IAOI,2CAAA;E1Ei/1BV;E0Ex/1BM;IAOI,4CAAA;E1Eo/1BV;E0E3/1BM;IAOI,wCAAA;E1Eu/1BV;E0E9/1BM;IAOI,4CAAA;E1E0/1BV;E0Ejg2BM;IAOI,2CAAA;E1E6/1BV;E0Epg2BM;IAOI,4CAAA;E1Egg2BV;E0Evg2BM;IAOI,0CAAA;E1Emg2BV;E0E1g2BM;IAOI,4CAAA;E1Esg2BV;E0E7g2BM;IAOI,2CAAA;E1Eyg2BV;E0Ehh2BM;IAOI,4CAAA;E1E4g2BV;E0Enh2BM;IAOI,0CAAA;E1E+g2BV;E0Eth2BM;IAOI,4CAAA;E1Ekh2BV;E0Ezh2BM;IAOI,yCAAA;E1Eqh2BV;E0E5h2BM;IAOI,4CAAA;E1Ewh2BV;E0E/h2BM;IAOI,0CAAA;E1E2h2BV;E0Eli2BM;IAOI,4CAAA;E1E8h2BV;E0Eri2BM;IAOI,2CAAA;E1Eii2BV;E0Exi2BM;IAOI,4CAAA;E1Eoi2BV;E0E3i2BM;IAOI,0CAAA;E1Eui2BV;E0E9i2BM;IAOI,2BAAA;E1E0i2BV;E0Ejj2BM;IAOI,4BAAA;E1E6i2BV;E0Epj2BM;IAOI,6BAAA;E1Egj2BV;E0Evj2BM;IAOI,2BAAA;E1Emj2BV;E0E1j2BM;IAOI,yBAAA;E1Esj2BV;E0E7j2BM;IAOI,yBAAA;E1Eyj2BV;E0Ehk2BM;IAOI,yBAAA;E1E4j2BV;E0Enk2BM;IAOI,0BAAA;E1E+j2BV;E0Etk2BM;IAOI,0BAAA;E1Ekk2BV;E0Ezk2BM;IAOI,yBAAA;E1Eqk2BV;E0E5k2BM;IAOI,yBAAA;E1Ewk2BV;E0E/k2BM;IAOI,yBAAA;E1E2k2BV;E0Ell2BM;IAOI,yBAAA;E1E8k2BV;E0Erl2BM;IAOI,yBAAA;E1Eil2BV;E0Exl2BM;IAOI,yBAAA;E1Eol2BV;E0E3l2BM;IAOI,yBAAA;E1Eul2BV;E0E9l2BM;IAOI,yBAAA;E1E0l2BV;E0Ejm2BM;IAOI,yBAAA;E1E6l2BV;E0Epm2BM;IAOI,0BAAA;E1Egm2BV;E0Evm2BM;IAOI,0BAAA;E1Emm2BV;E0E1m2BM;IAOI,0BAAA;E1Esm2BV;E0E7m2BM;IAOI,0BAAA;E1Eym2BV;E0Ehn2BM;IAOI,0BAAA;E1E4m2BV;E0Enn2BM;IAOI,0BAAA;E1E+m2BV;E0Etn2BM;IAOI,0BAAA;E1Ekn2BV;E0Ezn2BM;IAOI,0BAAA;E1Eqn2BV;E0E5n2BM;IAOI,0BAAA;E1Ewn2BV;E0E/n2BM;IAOI,0BAAA;E1E2n2BV;E0Elo2BM;IAOI,0BAAA;E1E8n2BV;E0Ero2BM;IAOI,0BAAA;E1Eio2BV;E0Exo2BM;IAOI,0BAAA;E1Eoo2BV;E0E3o2BM;IAOI,0BAAA;E1Euo2BV;E0E9o2BM;IAOI,0BAAA;E1E0o2BV;E0Ejp2BM;IAOI,0BAAA;E1E6o2BV;E0Epp2BM;IAOI,0BAAA;E1Egp2BV;E0Evp2BM;IAOI,0BAAA;E1Emp2BV;E0E1p2BM;IAOI,2BAAA;E1Esp2BV;E0E7p2BM;IAOI,2BAAA;E1Eyp2BV;E0Ehq2BM;IAOI,2BAAA;E1E4p2BV;E0Enq2BM;IAOI,2BAAA;E1E+p2BV;E0Etq2BM;IAOI,2BAAA;E1Ekq2BV;E0Ezq2BM;IAOI,2BAAA;E1Eqq2BV;E0E5q2BM;IAOI,2BAAA;E1Ewq2BV;E0E/q2BM;IAOI,2BAAA;E1E2q2BV;E0Elr2BM;IAOI,2BAAA;E1E8q2BV;E0Err2BM;IAOI,2BAAA;E1Eir2BV;E0Exr2BM;IAOI,2BAAA;E1Eor2BV;E0E3r2BM;IAOI,2BAAA;E1Eur2BV;E0E9r2BM;IAOI,2BAAA;E1E0r2BV;E0Ejs2BM;IAOI,2BAAA;E1E6r2BV;E0Eps2BM;IAOI,2BAAA;E1Egs2BV;E0Evs2BM;IAOI,2BAAA;E1Ems2BV;E0E1s2BM;IAOI,2BAAA;E1Ess2BV;E0E7s2BM;IAOI,2BAAA;E1Eys2BV;E0Eht2BM;IAOI,2BAAA;E1E4s2BV;E0Ent2BM;IAOI,2BAAA;E1E+s2BV;E0Ett2BM;IAOI,2BAAA;E1Ekt2BV;E0Ezt2BM;IAOI,2BAAA;E1Eqt2BV;E0E5t2BM;IAOI,2BAAA;E1Ewt2BV;E0E/t2BM;IAOI,2BAAA;E1E2t2BV;E0Elu2BM;IAOI,2BAAA;E1E8t2BV;E0Eru2BM;IAOI,2BAAA;E1Eiu2BV;E0Exu2BM;IAOI,4BAAA;E1Eou2BV;E0E3u2BM;IAOI,4BAAA;E1Euu2BV;E0E9u2BM;IAOI,0BAAA;E1E0u2BV;E0Ejv2BM;IAOI,0BAAA;E1E6u2BV;E0Epv2BM;IAOI,0BAAA;E1Egv2BV;E0Evv2BM;IAOI,2BAAA;E1Emv2BV;E0E1v2BM;IAOI,2BAAA;E1Esv2BV;E0E7v2BM;IAOI,0BAAA;E1Eyv2BV;E0Ehw2BM;IAOI,0BAAA;E1E4v2BV;E0Enw2BM;IAOI,0BAAA;E1E+v2BV;E0Etw2BM;IAOI,0BAAA;E1Ekw2BV;E0Ezw2BM;IAOI,0BAAA;E1Eqw2BV;E0E5w2BM;IAOI,0BAAA;E1Eww2BV;E0E/w2BM;IAOI,0BAAA;E1E2w2BV;E0Elx2BM;IAOI,0BAAA;E1E8w2BV;E0Erx2BM;IAOI,0BAAA;E1Eix2BV;E0Exx2BM;IAOI,2BAAA;E1Eox2BV;E0E3x2BM;IAOI,2BAAA;E1Eux2BV;E0E9x2BM;IAOI,2BAAA;E1E0x2BV;E0Ejy2BM;IAOI,2BAAA;E1E6x2BV;E0Epy2BM;IAOI,2BAAA;E1Egy2BV;E0Evy2BM;IAOI,2BAAA;E1Emy2BV;E0E1y2BM;IAOI,2BAAA;E1Esy2BV;E0E7y2BM;IAOI,2BAAA;E1Eyy2BV;E0Ehz2BM;IAOI,2BAAA;E1E4y2BV;E0Enz2BM;IAOI,2BAAA;E1E+y2BV;E0Etz2BM;IAOI,2BAAA;E1Ekz2BV;E0Ezz2BM;IAOI,2BAAA;E1Eqz2BV;E0E5z2BM;IAOI,2BAAA;E1Ewz2BV;E0E/z2BM;IAOI,2BAAA;E1E2z2BV;E0El02BM;IAOI,2BAAA;E1E8z2BV;E0Er02BM;IAOI,2BAAA;E1Ei02BV;E0Ex02BM;IAOI,2BAAA;E1Eo02BV;E0E302BM;IAOI,2BAAA;E1Eu02BV;E0E902BM;IAOI,4BAAA;E1E002BV;E0Ej12BM;IAOI,4BAAA;E1E602BV;E0Ep12BM;IAOI,4BAAA;E1Eg12BV;E0Ev12BM;IAOI,4BAAA;E1Em12BV;E0E112BM;IAOI,4BAAA;E1Es12BV;E0E712BM;IAOI,4BAAA;E1Ey12BV;E0Eh22BM;IAOI,4BAAA;E1E412BV;E0En22BM;IAOI,4BAAA;E1E+12BV;E0Et22BM;IAOI,4BAAA;E1Ek22BV;E0Ez22BM;IAOI,4BAAA;E1Eq22BV;E0E522BM;IAOI,4BAAA;E1Ew22BV;E0E/22BM;IAOI,4BAAA;E1E222BV;E0El32BM;IAOI,4BAAA;E1E822BV;E0Er32BM;IAOI,4BAAA;E1Ei32BV;E0Ex32BM;IAOI,4BAAA;E1Eo32BV;E0E332BM;IAOI,4BAAA;E1Eu32BV;E0E932BM;IAOI,4BAAA;E1E032BV;E0Ej42BM;IAOI,4BAAA;E1E632BV;E0Ep42BM;IAOI,4BAAA;E1Eg42BV;E0Ev42BM;IAOI,4BAAA;E1Em42BV;E0E142BM;IAOI,4BAAA;E1Es42BV;E0E742BM;IAOI,4BAAA;E1Ey42BV;E0Eh52BM;IAOI,4BAAA;E1E442BV;E0En52BM;IAOI,4BAAA;E1E+42BV;E0Et52BM;IAOI,4BAAA;E1Ek52BV;E0Ez52BM;IAOI,4BAAA;E1Eq52BV;E0E552BM;IAOI,6BAAA;E1Ew52BV;AACF;A2E/82BA;ED+CQ;IAOI,6BAAA;E1E652BV;E0Ep62BM;IAOI,4BAAA;E1Eg62BV;E0Ev62BM;IAOI,6BAAA;E1Em62BV;E0E162BM;IAOI,0BAAA;E1Es62BV;E0E762BM;IAOI,6BAAA;E1Ey62BV;E0Eh72BM;IAOI,4BAAA;E1E462BV;E0En72BM;IAOI,6BAAA;E1E+62BV;E0Et72BM;IAOI,0BAAA;E1Ek72BV;E0Ez72BM;IAOI,6BAAA;E1Eq72BV;E0E572BM;IAOI,4BAAA;E1Ew72BV;E0E/72BM;IAOI,6BAAA;E1E272BV;E0El82BM;IAOI,0BAAA;E1E872BV;E0Er82BM;IAOI,6BAAA;E1Ei82BV;E0Ex82BM;IAOI,4BAAA;E1Eo82BV;E0E382BM;IAOI,6BAAA;E1Eu82BV;E0E982BM;IAOI,0BAAA;E1E082BV;E0Ej92BM;IAOI,6BAAA;E1E682BV;E0Ep92BM;IAOI,4BAAA;E1Eg92BV;E0Ev92BM;IAOI,6BAAA;E1Em92BV;E0E192BM;IAOI,0BAAA;E1Es92BV;E0E792BM;IAOI,6BAAA;E1Ey92BV;E0Eh+2BM;IAOI,4BAAA;E1E492BV;E0En+2BM;IAOI,6BAAA;E1E+92BV;E0Et+2BM;IAOI,0BAAA;E1Ek+2BV;E0Ez+2BM;IAOI,6BAAA;E1Eq+2BV;E0E5+2BM;IAOI,4BAAA;E1Ew+2BV;E0E/+2BM;IAOI,6BAAA;E1E2+2BV;E0El/2BM;IAOI,6BAAA;E1E8+2BV;E0Er/2BM;IAOI,4BAAA;E1Ei/2BV;E0Ex/2BM;IAOI,6BAAA;E1Eo/2BV;E0E3/2BM;IAOI,0BAAA;E1Eu/2BV;E0E9/2BM;IAOI,6BAAA;E1E0/2BV;E0Ejg3BM;IAOI,4BAAA;E1E6/2BV;E0Epg3BM;IAOI,6BAAA;E1Egg3BV;E0Evg3BM;IAOI,0BAAA;E1Emg3BV;E0E1g3BM;IAOI,6BAAA;E1Esg3BV;E0E7g3BM;IAOI,4BAAA;E1Eyg3BV;E0Ehh3BM;IAOI,6BAAA;E1E4g3BV;E0Enh3BM;IAOI,0BAAA;E1E+g3BV;E0Eth3BM;IAOI,6BAAA;E1Ekh3BV;E0Ezh3BM;IAOI,4BAAA;E1Eqh3BV;E0E5h3BM;IAOI,6BAAA;E1Ewh3BV;E0E/h3BM;IAOI,0BAAA;E1E2h3BV;E0Eli3BM;IAOI,6BAAA;E1E8h3BV;E0Eri3BM;IAOI,4BAAA;E1Eii3BV;E0Exi3BM;IAOI,6BAAA;E1Eoi3BV;E0E3i3BM;IAOI,0BAAA;E1Eui3BV;E0E9i3BM;IAOI,6BAAA;E1E0i3BV;E0Ejj3BM;IAOI,4BAAA;E1E6i3BV;E0Epj3BM;IAOI,6BAAA;E1Egj3BV;E0Evj3BM;IAOI,0BAAA;E1Emj3BV;E0E1j3BM;IAOI,6BAAA;E1Esj3BV;E0E7j3BM;IAOI,4BAAA;E1Eyj3BV;E0Ehk3BM;IAOI,6BAAA;E1E4j3BV;E0Enk3BM;IAOI,6BAAA;E1E+j3BV;E0Etk3BM;IAOI,4BAAA;E1Ekk3BV;E0Ezk3BM;IAOI,6BAAA;E1Eqk3BV;E0E5k3BM;IAOI,0BAAA;E1Ewk3BV;E0E/k3BM;IAOI,6BAAA;E1E2k3BV;E0Ell3BM;IAOI,4BAAA;E1E8k3BV;E0Erl3BM;IAOI,6BAAA;E1Eil3BV;E0Exl3BM;IAOI,0BAAA;E1Eol3BV;E0E3l3BM;IAOI,6BAAA;E1Eul3BV;E0E9l3BM;IAOI,4BAAA;E1E0l3BV;E0Ejm3BM;IAOI,6BAAA;E1E6l3BV;E0Epm3BM;IAOI,0BAAA;E1Egm3BV;E0Evm3BM;IAOI,6BAAA;E1Emm3BV;E0E1m3BM;IAOI,4BAAA;E1Esm3BV;E0E7m3BM;IAOI,6BAAA;E1Eym3BV;E0Ehn3BM;IAOI,0BAAA;E1E4m3BV;E0Enn3BM;IAOI,6BAAA;E1E+m3BV;E0Etn3BM;IAOI,4BAAA;E1Ekn3BV;E0Ezn3BM;IAOI,6BAAA;E1Eqn3BV;E0E5n3BM;IAOI,0BAAA;E1Ewn3BV;E0E/n3BM;IAOI,6BAAA;E1E2n3BV;E0Elo3BM;IAOI,4BAAA;E1E8n3BV;E0Ero3BM;IAOI,6BAAA;E1Eio3BV;E0Exo3BM;IAOI,0BAAA;E1Eoo3BV;E0E3o3BM;IAOI,6BAAA;E1Euo3BV;E0E9o3BM;IAOI,4BAAA;E1E0o3BV;E0Ejp3BM;IAOI,6BAAA;E1E6o3BV;E0Epp3BM;IAOI,6BAAA;E1Egp3BV;E0Evp3BM;IAOI,4BAAA;E1Emp3BV;E0E1p3BM;IAOI,6BAAA;E1Esp3BV;E0E7p3BM;IAOI,0BAAA;E1Eyp3BV;E0Ehq3BM;IAOI,6BAAA;E1E4p3BV;E0Enq3BM;IAOI,4BAAA;E1E+p3BV;E0Etq3BM;IAOI,6BAAA;E1Ekq3BV;E0Ezq3BM;IAOI,0BAAA;E1Eqq3BV;E0E5q3BM;IAOI,6BAAA;E1Ewq3BV;E0E/q3BM;IAOI,4BAAA;E1E2q3BV;E0Elr3BM;IAOI,6BAAA;E1E8q3BV;E0Err3BM;IAOI,0BAAA;E1Eir3BV;E0Exr3BM;IAOI,6BAAA;E1Eor3BV;E0E3r3BM;IAOI,4BAAA;E1Eur3BV;E0E9r3BM;IAOI,6BAAA;E1E0r3BV;E0Ejs3BM;IAOI,0BAAA;E1E6r3BV;E0Eps3BM;IAOI,6BAAA;E1Egs3BV;E0Evs3BM;IAOI,4BAAA;E1Ems3BV;E0E1s3BM;IAOI,6BAAA;E1Ess3BV;E0E7s3BM;IAOI,0BAAA;E1Eys3BV;E0Eht3BM;IAOI,6BAAA;E1E4s3BV;E0Ent3BM;IAOI,4BAAA;E1E+s3BV;E0Ett3BM;IAOI,6BAAA;E1Ekt3BV;E0Ezt3BM;IAOI,0BAAA;E1Eqt3BV;E0E5t3BM;IAOI,6BAAA;E1Ewt3BV;E0E/t3BM;IAOI,4BAAA;E1E2t3BV;E0Elu3BM;IAOI,6BAAA;E1E8t3BV;AACF;A2Elw3BA;ED4BQ;IAOI,0BAAA;E1Emu3BV;E0E1u3BM;IAOI,gCAAA;E1Esu3BV;E0E7u3BM;IAOI,yBAAA;E1Eyu3BV;E0Ehv3BM;IAOI,wBAAA;E1E4u3BV;E0Env3BM;IAOI,+BAAA;E1E+u3BV;E0Etv3BM;IAOI,yBAAA;E1Ekv3BV;E0Ezv3BM;IAOI,6BAAA;E1Eqv3BV;E0E5v3BM;IAOI,8BAAA;E1Ewv3BV;E0E/v3BM;IAOI,wBAAA;E1E2v3BV;E0Elw3BM;IAOI,+BAAA;E1E8v3BV;E0Erw3BM;IAOI,wBAAA;E1Eiw3BV;AACF;A4Ev03BA;EAGQ,SAAA;EAAA,aAAA;EAAA,aAAA;EAAA,aAAA;EAAA,cAAA;EAAA,eAAA;EAIJ,wBAAA;EACA,iCAAA;EACA,iCAAA;EAGA,gCAAA;EACA,0BAAA;A5Eu03BJ;;AIz03BI;EwEOA,wBAAA;EAII,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,8BAAA;EADA,sBAAA;EACA,6BAAA;EADA,sBAAA;EACA,4BAAA;EAKA,mBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,kBAAA;EAKA,4BAAA;EAAA,8BAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,yBAAA;EAAA,4BAAA;EAAA,2BAAA;EAAA,yBAAA;EAKA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,yBAAA;EAKA,6BAAA;EAAA,+BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,0BAAA;EAKA,6CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,4CAAA;EAKA,6BAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,yBAAA;EAKA,wBAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAIJ,0BAAA;EACA,iCAAA;EAEA,oCAAA;EACA,iCAAA;EACA,mCAAA;EACA,gCAAA;EACA,qCAAA;EACA,kCAAA;EAGA,gEAAA;EACA,6DAAA;EACA,4DAAA;EACA,uDAAA;EAGA,gCAAA;EACA,oCAAA;EACA,0CAAA;EACA,uCAAA;EACA,6CAAA;EACA,sDAAA;EAGA,8DAAA;EACA,oCAAA;EAGA,yDAAA;EAGA,yDAAA;EACA,+EAAA;EAGA,mCAAA;EACA,kEAAA;EAGA,qBAAA;EACA,iDAAA;EACA,mCAAA;EACA,wBAAA;EAGA,2CAAA;EACA,wCAAA;EACA,sDAAA;EAGA,wCAAA;EAGA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,+CAAA;EACA,0CAAA;EACA,gDAAA;EACA,oDAAA;EACA,0DAAA;EAGA,4DAAA;EACA,6BAAA;EACA,gDAAA;EAGA,uEAAA;EACA,8CAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,6BAAA;EACA,mCAAA;EAGA,oCAAA;EAGA,4CAAA;EAGA,kCAAA;EACA,iCAAA;EAGA,oEAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EAGA,2BAAA;EACA,gDAAA;EACA,qCAAA;EACA,8BAAA;EACA,mCAAA;EACA,qCAAA;A5E203BJ;;AIz+3BI;EwEmKA,wBAAA;EAII,sBAAA;EACA,6BAAA;EADA,sBAAA;EACA,6BAAA;EADA,sBAAA;EACA,6BAAA;EADA,sBAAA;EACA,6BAAA;EADA,sBAAA;EACA,+BAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EADA,sBAAA;EACA,gCAAA;EAKA,mBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,kBAAA;EAKA,4BAAA;EAAA,8BAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,yBAAA;EAAA,4BAAA;EAAA,2BAAA;EAAA,yBAAA;EAKA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,yBAAA;EAKA,6BAAA;EAAA,+BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,0BAAA;EAKA,4CAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,yCAAA;EAKA,0BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,yBAAA;EAKA,wBAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAIJ,0BAAA;EACA,iCAAA;EAEA,oCAAA;EACA,iCAAA;EACA,mCAAA;EACA,gCAAA;EACA,qCAAA;EACA,kCAAA;EAGA,gEAAA;EACA,6DAAA;EACA,4DAAA;EACA,uDAAA;EAGA,oCAAA;EACA,gCAAA;EACA,0CAAA;EACA,uCAAA;EACA,6CAAA;EACA,sDAAA;EAGA,yDAAA;EAGA,+BAAA;EACA,oCAAA;EAGA,6CAAA;EACA,sEAAA;EAGA,yBAAA;EACA,yDAAA;EAGA,qBAAA;EACA,qDAAA;EACA,mCAAA;EACA,wBAAA;EAGA,gCAAA;EACA,6BAAA;EACA,kDAAA;EAGA,6BAAA;EAGA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,sEAAA;EACA,gCAAA;EACA,sCAAA;EACA,kCAAA;EACA,wCAAA;EAGA,uDAAA;EACA,6BAAA;EACA,gDAAA;EAGA,8DAAA;EACA,oCAAA;EACA,gCAAA;EAEA,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,6BAAA;EACA,mCAAA;EAGA,0CAAA;EAGA,kDAAA;EAGA,kCAAA;EACA,iCAAA;EAGA,uEAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EAGA,2BAAA;EACA,2DAAA;EACA,qCAAA;EACA,8BAAA;EACA,mCAAA;EACA,qCAAA;A5E803BJ;;A6Epp4BA;EACC,UAAA;A7Eup4BD;;A8E1p4BA;EACC,wCAAA;A9E6p4BD;;A8E1p4BA;EACC,gBAAA;A9E6p4BD;;A+E/p4BA;EACI,2BAAA;A/Ekq4BJ;;A+E7p4BC;EACC,wBAAA;A/Egq4BF;A+E7p4BC;EACC,wCAAA;A/E+p4BF;A+E5p4BC;EACC,8CAAA;A/E8p4BF;;A+Exp4BC;EACC,wBAAA;A/E2p4BF;A+Exp4BC;EACC,wCAAA;A/E0p4BF;A+Evp4BC;EACC,8CAAA;A/Eyp4BF;;AgFvr4BA;EACE,sBAAA;EACA,yBAAA;AhF0r4BF;;AgFtr4BA;EACI;IACI,mCAAA;IACA,mBAAA;EhFyr4BN;EgFtr4BE;IACI,+BAAA;EhFwr4BN;AACF;AgFrr4BA;EACI,oCAAA;AhFur4BJ;;AgFnr4BA;EACI;IACI,kCAAA;IACA,mBAAA;EhFsr4BN;EgFnr4BE;IACI,+BAAA;EhFqr4BN;AACF;AgFlr4BA;EACI,kCAAA;AhFor4BJ;;AgFhr4BA;EACI;IACI,UAAA;EhFmr4BN;EgFhr4BE;IACI,UAAA;EhFkr4BN;AACF;AgF/q4BA;EACI,+BAAA;AhFir4BJ;;AgF7q4BA;EACI;IACI,UAAA;EhFgr4BN;EgF7q4BE;IACI,UAAA;EhF+q4BN;AACF;AgF7q4BA;EACI,gCAAA;AhF+q4BJ;;AgF3q4BA;EACI,qDAAA;AhF8q4BJ;;AgF3q4BA;EACI;IACI,kBAAA;EhF8q4BN;AACF;AiFxv4BC;EACC,sBAAA;EACA,6BAAA;EACA,uCAAA;AjF0v4BF;AiFxv4BE;EACI,sBAAA;AjF0v4BN;;AiFhw4BC;EACC,wBAAA;EACA,+BAAA;EACA,yCAAA;AjFmw4BF;AiFjw4BE;EACI,wBAAA;AjFmw4BN;;AiFzw4BC;EACC,0BAAA;EACA,iCAAA;EACA,2CAAA;AjF4w4BF;AiF1w4BE;EACI,0BAAA;AjF4w4BN;;AiFlx4BC;EACC,wBAAA;EACA,+BAAA;EACA,yCAAA;AjFqx4BF;AiFnx4BE;EACI,wBAAA;AjFqx4BN;;AiF3x4BC;EACC,qBAAA;EACA,4BAAA;EACA,sCAAA;AjF8x4BF;AiF5x4BE;EACI,qBAAA;AjF8x4BN;;AiFpy4BC;EACC,wBAAA;EACA,+BAAA;EACA,yCAAA;AjFuy4BF;AiFry4BE;EACI,wBAAA;AjFuy4BN;;AiF7y4BC;EACC,uBAAA;EACA,8BAAA;EACA,wCAAA;AjFgz4BF;AiF9y4BE;EACI,uBAAA;AjFgz4BN;;AiFtz4BC;EACC,qBAAA;EACA,4BAAA;EACA,sCAAA;AjFyz4BF;AiFvz4BE;EACI,qBAAA;AjFyz4BN;;AkF7z4BQ;ErEOF,2CARW;Abk04BjB;;AmFt04BE;EACC,eAAA;AnFy04BH;;AmFl04BQ;EACL,sBAAA;EACA,6BAAA;EACA,uCAAA;AnFq04BH;;AoF504BC;EACC,oBAAA;ApF+04BF;AoF704BE;EACC,eAAA;ApF+04BH;;AoFz04BA;EACC,oBAAA;EACA,yBAAA;EACA,4BAAA;ApF404BD;AoF104BC;EACC,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;ApF404BF;AoFz04BC;EACC,aAAA;EACA,mBAAA;ApF204BF;;AoFt04BA;EACC,gBAAA;E5EjBG,sBAAA;E4EmBH,oCAAA;ApFy04BD;AoFt04BC;EACC,6BAAA;EACA,wCAAA;ApFw04BF;AoFp04BC;EACC,aAAA;ApFs04BF;AoFp04BE;;EAEC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;ApFs04BH;AoFn04BE;EACC,oBAAA;ApFq04BH;AoFn04BG;EACC,WAAA;ApFq04BJ;AoFl04BG;EACC,eAAA;ApFo04BJ;;AqFj44BA;EACC,wBAAA;EACA,0BAAA;EACA,2CAAA;ArFo44BD;AqFl44BC;EACC,mBAAA;ArFo44BF;AqFj44BE;EACC,yBAAA;EACA,SAAA;EACA,oCAAA;EACA,2B9E0Te;E8EzTf,iBAAA;EACA,cAAA;ArFm44BH;AqF934BG;EACC,cAAA;ArFg44BJ;AqF134BG;EACC,eAAA;ArF434BJ;AqFt34BC;;;EAGC,6BAAA;EACA,SAAA;EACA,0CAAA;EACA,2B9E+RgB;APyl4BlB;AqFp34BC;EACC,wBAAA;ArFs34BF;AqFp34BE;EACC,mBAAA;ArFs34BH;AqFp34BG;EACC,wBAAA;ArFs34BJ;AqFj34BE;;;EAGC,wBAAA;ArFm34BH;;AsF764BC;;EAEC,gDAAA;E9EWE,sBAAA;ARs64BJ;AsF964BE;;EACC,+CAAA;AtFi74BH;AsF/64BG;;EACC,mCAAA;AtFk74BJ;AsF764BY;;EACI,WAAA;EACA,2B/EsTE;AP0n4BlB;AsF964BgB;;EACI,qBAAA;AtFi74BpB;AsF964BgB;;EACI,aAAA;AtFi74BpB;AsF564BQ;;EACL,6BAAA;EACA,+CAAA;EACA,wBAAA;EACA,kBAAA;AtF+64BH;AsF764BG;;EACC,oCAAA;EACA,2B/EkSc;AP8o4BlB;AsF764BG;;EACC,cAAA;AtFg74BJ;AsF564BE;;EACC,aAAA;AtF+64BH;AsFv64BK;EACC,cAAA;AtFy64BN;AsFt64BK;EACC,cAAA;AtFw64BN;AsFn64BK;EACC,yBAAA;AtFq64BN;AsFl64BK;EACC,yBAAA;AtFo64BN;AsF/54BK;EACC,yBAAA;AtFi64BN;AsF954BK;EACC,yBAAA;AtFg64BN;;AuFh/4BA;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AvFm/4BD;AuF/+4BE;EACC,kBAAA;AvFi/4BH;AuF3+4BE;EACC,wCAAA;AvF6+4BH;AuFv+4BO;EACI,qCAAA;AvFy+4BX;;AuFl+4BA;EACI,oBhFksBgD;EgFlkBnD,iBAAA;AvFs24BD;AuFp+4BC;EACO,eAAA;AvFs+4BR;AuFn+4BC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBCrCkC;EDsClC,chFqrBkD;EgFprBlD,iBhForBkD;EgFnrBlD,gBhFqUqB;EgFpUrB,mBhF6Ta;EgFvTb,mCAAA;EASA,iBAAA;EAMA,mCAAA;AvFm94BF;AuFt+4BE;EACC,kBhFqrBiD;APmz3BpD;AuFp+4BE;;EAEC,cAAA;EACA,gBhF+qBiD;EgF9qBjD,ehF8qBiD;EgF5qBjD,uCAAA;AvFq+4BH;AuFj+4BE;EEZM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oClFsrB4C;EkFnrBhD,4DAAA;EACA,oDAAA;AzF2+4BJ;AuFr+4BE;EEjBM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oClFsrB4C;EkFnrBhD,4DAAA;EACA,oDAAA;AzFo/4BJ;AuFx+4BE;EACC,uCAAA;EAWA,mCAAA;AvFg+4BH;AuFz+4BG;;EAEC,uCAAA;AvF2+4BJ;AuFx+4BG;EE/BK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDFyB8B;EEtBlC,4DAAA;EACA,oDAAA;AzFqg5BJ;AuF5+4BG;EEpCK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDF8B4B;EE3BhC,4DAAA;EACA,oDAAA;AzF8g5BJ;AuF9+4BE;EACC,uCAAA;EAeA,mCAAA;AvFk+4BH;AuF/+4BG;EACC,6BAAA;AvFi/4BJ;AuF9+4BG;;EAEC,uCAAA;AvFg/4BJ;AuF7+4BG;EEvDK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDFiD8B;EE9ClC,4DAAA;EACA,oDAAA;AzFki5BJ;AuFj/4BG;EE5DK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDFsD4B;EEnDhC,4DAAA;EACA,oDAAA;AzF2i5BJ;AuFn/4BE;EACC,wCAAA;EAeA,mCAAA;AvFu+4BH;AuFp/4BG;EACC,6BAAA;AvFs/4BJ;AuFn/4BG;;EAEC,wCAAA;AvFq/4BJ;AuFl/4BG;EE/EK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mDFyE8B;EEtElC,4DAAA;EACA,oDAAA;AzF+j5BJ;AuFt/4BG;EEpFK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mDF8E4B;EE3EhC,4DAAA;EACA,oDAAA;AzFwk5BJ;AuFx/4BE;EACC,0CAAA;EAWA,mCAAA;AvFg/4BH;AuFz/4BG;;EAEC,0CAAA;AvF2/4BJ;AuFx/4BG;EEnGK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qDF6F8B;EE1FlC,4DAAA;EACA,oDAAA;AzFyl5BJ;AuF5/4BG;EExGK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qDFkG4B;EE/FhC,4DAAA;EACA,oDAAA;AzFkm5BJ;;AgBvl5BI;EuE4FH;IACC,qBhF6jBkD;EPk83BlD;EuF7/4BA;IACC,eAAA;EvF+/4BD;AACF;A0Fxq5BA;EACI,cAAA;EACA,SAAA;EACA,+CAAA;A1F0q5BJ;A0Fxq5BI;EACI,2BAAA;EACA,kDAAA;A1F0q5BR;A0Fvq5BI;EACI,2BAAA;EACA,kDAAA;A1Fyq5BR;A0Ftq5BI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;A1Fwq5BR;A0Ftq5BQ;EAEI,YAAA;EACA,UAAA;EACA,+CAAA;A1Fuq5BZ;A0Fpq5BQ;EACI,qBAAA;A1Fsq5BZ;A0Fnq5BQ;EACI,oBAAA;A1Fqq5BZ;A0Fjq5BY;EAEI,2BAAA;EACA,kDAAA;A1Fkq5BhB;A0F7p5BY;EAEI,2BAAA;EACA,kDAAA;A1F8p5BhB;A0Fxp5BgB;EAEI,gCAAA;A1Fyp5BpB;A0F3p5BgB;EAEI,gCAAA;A1F4p5BpB;A0F9p5BgB;EAEI,gCAAA;A1F+p5BpB;A0Fjq5BgB;EAEI,gCAAA;A1Fkq5BpB;A0Fpq5BgB;EAEI,gCAAA;A1Fqq5BpB;A0Fvq5BgB;EAEI,gCAAA;A1Fwq5BpB;A0F1q5BgB;EAEI,gCAAA;A1F2q5BpB;A0F7q5BgB;EAEI,gCAAA;A1F8q5BpB;;A2Fnu5BI;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;A3Fsu5BR;A2Fpu5BQ;EACI,eAAA;EACA,UAAA;A3Fsu5BZ;A2Fpu5BY;EACI,eAAA;EACA,UAAA;A3Fsu5BhB;A2Fhu5BY;EACI,gBAAA;EACA,wCAAA;EACA,YpF05BgD;EoFz5BhD,WpFy5BgD;EoFx5BhD,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A3Fku5BhB;A2Fhu5BgB;EACI,qBAAA;EACA,YAAA;EnFpBhB,kBAAA;EmFsBgB,yBAAA;EACA,oCpF04B4C;EoFz4B5C,WpF44B4C;EoF34B5C,UpF24B4C;APu13BhE;A2F/t5BgB;EACI,6BAAA;A3Fiu5BpB;A2F/t5BoB;EACI,yBAAA;EACA,YpFo4BwC;EoFn4BxC,WpFm4BwC;EoFl4BxC,oCpF+3BwC;APk23BhE;A2Fzt5BY;EACI,yBAAA;EACA,wCAAA;EACA,kBpFy3BgD;EoFx3BhD,WpFw3BgD;EoFv3BhD,UpFu3BgD;EoFt3BhD,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A3F2t5BhB;A2Fzt5BgB;EACI,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,oCpF+2B4C;EoF92B5C,kBpF42B4C;EoF32B5C,WpF22B4C;EoF12B5C,UpF02B4C;APi33BhE;A2Fxt5BgB;EACI,yBAAA;EACA,6BAAA;EACA,WpFo2B4C;EoFn2B5C,WpFo2B4C;APs33BhE;A2Fxt5BoB;EACI,yBAAA;EACA,WpF+1BwC;EoF91BxC,WpF+1BwC;EoF91BxC,oCpFg2BwC;AP033BhE;A2Fht5BY;EACI,4CAAA;A3Fkt5BhB;A2Fnt5BY;EACI,8CAAA;A3Fqt5BhB;A2Ftt5BY;EACI,gDAAA;A3Fwt5BhB;A2Fzt5BY;EACI,8CAAA;A3F2t5BhB;A2F5t5BY;EACI,2CAAA;A3F8t5BhB;A2F/t5BY;EACI,8CAAA;A3Fiu5BhB;A2Flu5BY;EACI,6CAAA;A3Fou5BhB;A2Fru5BY;EACI,2CAAA;A3Fuu5BhB;A2Fju5BI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;A3Fmu5BR;A2Fju5BQ;EACI,YAAA;A3Fmu5BZ;A2Fhu5BQ;EACI,YAAA;A3Fku5BZ;A2F/t5BQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;A3Fiu5BZ;;A4F115BA;EACI,aAAA;A5F615BJ;;A4Fz15BA;;EAEI,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;A5F415BJ;;A4Fx15BA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;A5F215BJ;;A4Fv15BA;EACI,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;A5F015BJ;;A4Ft15BA;EACI,cAAA;EACA,kBAAA;A5Fy15BJ;A4Ft15BI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;A5Fw15BR;A4Ft15BQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WrFsmCK;EqFrmCL,oBrFsmCM;APkv3BlB;A4Ft15BY;;EAEI,cAAA;A5Fw15BhB;A4Fp15BQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,crF0lCO;EqFzlCP,oBrF0lCQ;AP4v3BpB;A4Fn15BQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;A5Fq15BZ;A4Fl15BQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mBrF8kCO;APsw3BnB;A4Fj15BQ;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBrFukCO;EqFtkCP,UrFqkCM;EqFpkCN,WrFokCM;AP+w3BlB;A4Fj15BY;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,0BAAA;EH/CR,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCGyC0C;EHtC9C,4DAAA;EACA,oDAAA;EGsCY,mBAAA;EHjDR,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCG2CwC;EHxC5C,4DAAA;EACA,oDAAA;EGwCY,iBAAA;A5F+15BhB;A4Fz15BI;EACI,qBAAA;A5F215BR;;A4Fn15BY;EACI,2BAAA;EACA,+BrFqhCkB;APi03BlC;;A4F905BI;;EAEI,iBAAA;EACA,cAAA;A5Fi15BR;;A4F505BA;EACI,uBAAA;A5F+05BJ;;A4F305BA;EACI,mCAAA;A5F805BJ;;A4F/z5BgB;ECzJf,aAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,+BtFqoCiC;APu13BlC;A4Fh05BwB;EChKvB,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,+BtFqoCiC;AP813BlC;;A4F/z5BY;EACI,aAAA;EACA,sBJxKoB;EIyKpB,kDAAA;EACA,8CAAA;EACA,YrFq9BQ;AP623BxB;A4F/z5BgB;EAGI,aAAA;EACA,sBAAA;EAKI,2GAAA;A5F2z5BxB;;A4Frz5BY;EACI,aAAA;A5Fwz5BhB;A4Ftz5BgB;EAEI,aAAA;A5Fuz5BpB;;A6Fj45BC;EACC,iBtF6gCyB;APu33B3B;A4Flz5BgB;EACI,kBrF+7BE;APq33BtB;;A4F/y5BY;EACI,aAAA;A5Fkz5BhB;;A4F5y5BoB;;EAEI,0BAAA;EACA,2BAAA;A5F+y5BxB;;A4F1y5BY;EACI,sBAAA;EACA,WAAA;A5F6y5BhB;;A4F1y5BY;EACI,mBAAA;A5F6y5BhB;A4F3y5BgB;EACI,aAAA;EACA,mBAAA;A5F6y5BpB;A4F1y5BwB;EC/OvB,aAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,+BtFqoCiC;APu53BlC;;A4Fxy5BgB;EpF3OZ,sBAAA;ARuh6BJ;;A4Fry5BgB;EACI,mBAAA;A5Fwy5BpB;;A4Fly5BgB;EACI,2BAAA;A5Fqy5BpB;;A8F1i6BY;EFuJI;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EP463BhC;E4Fr55BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EPm73BhC;E4Fp55BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EPi83BtB;E4Fn55Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5F+45BtB;E4Fz45BU;IACI,aAAA;E5F245Bd;E4Fz45Bc;IAEI,aAAA;E5F045BlB;E6Fp95BD;IACC,iBtF6gCyB;EPy83BzB;E4Fp45Bc;IACI,kBrF+7BE;EPu83BpB;E4Fj45BU;IACI,aAAA;E5Fm45Bd;E4F735BkB;;IAEI,0BAAA;IACA,2BAAA;E5F+35BtB;E4F135BU;IACI,sBAAA;IACA,WAAA;E5F435Bd;E4Fz35BU;IACI,mBAAA;E5F235Bd;E4Fz35Bc;IACI,aAAA;IACA,mBAAA;E5F235BlB;E4Fx35BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPq+3BhC;E4Ft35Bc;IpF3OZ,sBAAA;ERom6BF;E4Fl35Bc;IACI,mBAAA;E5Fo35BlB;E4F925Bc;IACI,2BAAA;E5Fg35BlB;AACF;A8Ftn6BY;EFuJI;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPu/3BhC;E4Fh+5BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EP8/3BhC;E4F/95BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EP4g4BtB;E4F995Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5F095BtB;E4Fp95BU;IACI,aAAA;E5Fs95Bd;E4Fp95Bc;IAEI,aAAA;E5Fq95BlB;E6F/h6BD;IACC,iBtF6gCyB;EPoh4BzB;E4F/85Bc;IACI,kBrF+7BE;EPkh4BpB;E4F585BU;IACI,aAAA;E5F885Bd;E4Fx85BkB;;IAEI,0BAAA;IACA,2BAAA;E5F085BtB;E4Fr85BU;IACI,sBAAA;IACA,WAAA;E5Fu85Bd;E4Fp85BU;IACI,mBAAA;E5Fs85Bd;E4Fp85Bc;IACI,aAAA;IACA,mBAAA;E5Fs85BlB;E4Fn85BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPgj4BhC;E4Fj85Bc;IpF3OZ,sBAAA;ER+q6BF;E4F775Bc;IACI,mBAAA;E5F+75BlB;E4Fz75Bc;IACI,2BAAA;E5F275BlB;AACF;A8Fjs6BY;EFuJI;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPkk4BhC;E4F3i6BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EPyk4BhC;E4F1i6BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EPul4BtB;E4Fzi6Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5Fqi6BtB;E4F/h6BU;IACI,aAAA;E5Fii6Bd;E4F/h6Bc;IAEI,aAAA;E5Fgi6BlB;E6F1m6BD;IACC,iBtF6gCyB;EP+l4BzB;E4F1h6Bc;IACI,kBrF+7BE;EP6l4BpB;E4Fvh6BU;IACI,aAAA;E5Fyh6Bd;E4Fnh6BkB;;IAEI,0BAAA;IACA,2BAAA;E5Fqh6BtB;E4Fhh6BU;IACI,sBAAA;IACA,WAAA;E5Fkh6Bd;E4F/g6BU;IACI,mBAAA;E5Fih6Bd;E4F/g6Bc;IACI,aAAA;IACA,mBAAA;E5Fih6BlB;E4F9g6BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EP2n4BhC;E4F5g6Bc;IpF3OZ,sBAAA;ER0v6BF;E4Fxg6Bc;IACI,mBAAA;E5F0g6BlB;E4Fpg6Bc;IACI,2BAAA;E5Fsg6BlB;AACF;A8F5w6BY;EFuJI;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EP6o4BhC;E4Ftn6BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EPop4BhC;E4Frn6BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EPkq4BtB;E4Fpn6Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5Fgn6BtB;E4F1m6BU;IACI,aAAA;E5F4m6Bd;E4F1m6Bc;IAEI,aAAA;E5F2m6BlB;E6Frr6BD;IACC,iBtF6gCyB;EP0q4BzB;E4Frm6Bc;IACI,kBrF+7BE;EPwq4BpB;E4Flm6BU;IACI,aAAA;E5Fom6Bd;E4F9l6BkB;;IAEI,0BAAA;IACA,2BAAA;E5Fgm6BtB;E4F3l6BU;IACI,sBAAA;IACA,WAAA;E5F6l6Bd;E4F1l6BU;IACI,mBAAA;E5F4l6Bd;E4F1l6Bc;IACI,aAAA;IACA,mBAAA;E5F4l6BlB;E4Fzl6BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPss4BhC;E4Fvl6Bc;IpF3OZ,sBAAA;ERq06BF;E4Fnl6Bc;IACI,mBAAA;E5Fql6BlB;E4F/k6Bc;IACI,2BAAA;E5Fil6BlB;AACF;A8Fv16BY;EFuJI;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPwt4BhC;E4Fjs6BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EP+t4BhC;E4Fhs6BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EP6u4BtB;E4F/r6Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5F2r6BtB;E4Frr6BU;IACI,aAAA;E5Fur6Bd;E4Frr6Bc;IAEI,aAAA;E5Fsr6BlB;E6Fhw6BD;IACC,iBtF6gCyB;EPqv4BzB;E4Fhr6Bc;IACI,kBrF+7BE;EPmv4BpB;E4F7q6BU;IACI,aAAA;E5F+q6Bd;E4Fzq6BkB;;IAEI,0BAAA;IACA,2BAAA;E5F2q6BtB;E4Ftq6BU;IACI,sBAAA;IACA,WAAA;E5Fwq6Bd;E4Frq6BU;IACI,mBAAA;E5Fuq6Bd;E4Frq6Bc;IACI,aAAA;IACA,mBAAA;E5Fuq6BlB;E4Fpq6BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPix4BhC;E4Flq6Bc;IpF3OZ,sBAAA;ERg56BF;E4F9p6Bc;IACI,mBAAA;E5Fgq6BlB;E4F1p6Bc;IACI,2BAAA;E5F4p6BlB;AACF;A8Fv56BY;EF4II;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPmy4BhC;E4F5w6BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EP0y4BhC;E4F3w6BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EPwz4BtB;E4F1w6Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5Fsw6BtB;E4Fhw6BU;IACI,aAAA;E5Fkw6Bd;E4Fhw6Bc;IAEI,aAAA;E5Fiw6BlB;E6F306BD;IACC,iBtF6gCyB;EPg04BzB;E4F3v6Bc;IACI,kBrF+7BE;EP8z4BpB;E4Fxv6BU;IACI,aAAA;E5F0v6Bd;E4Fpv6BkB;;IAEI,0BAAA;IACA,2BAAA;E5Fsv6BtB;E4Fjv6BU;IACI,sBAAA;IACA,WAAA;E5Fmv6Bd;E4Fhv6BU;IACI,mBAAA;E5Fkv6Bd;E4Fhv6Bc;IACI,aAAA;IACA,mBAAA;E5Fkv6BlB;E4F/u6BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EP414BhC;E4F7u6Bc;IpF3OZ,sBAAA;ER296BF;E4Fzu6Bc;IACI,mBAAA;E5F2u6BlB;E4Fru6Bc;IACI,2BAAA;E5Fuu6BlB;AACF;A8Fl+6BY;EF4II;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EP824BhC;E4Fv16BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EPq34BhC;E4Ft16BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EPm44BtB;E4Fr16Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5Fi16BtB;E4F306BU;IACI,aAAA;E5F606Bd;E4F306Bc;IAEI,aAAA;E5F406BlB;E6Ft56BD;IACC,iBtF6gCyB;EP244BzB;E4Ft06Bc;IACI,kBrF+7BE;EPy44BpB;E4Fn06BU;IACI,aAAA;E5Fq06Bd;E4F/z6BkB;;IAEI,0BAAA;IACA,2BAAA;E5Fi06BtB;E4F5z6BU;IACI,sBAAA;IACA,WAAA;E5F8z6Bd;E4F3z6BU;IACI,mBAAA;E5F6z6Bd;E4F3z6Bc;IACI,aAAA;IACA,mBAAA;E5F6z6BlB;E4F1z6BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPu64BhC;E4Fxz6Bc;IpF3OZ,sBAAA;ERsi7BF;E4Fpz6Bc;IACI,mBAAA;E5Fsz6BlB;E4Fhz6Bc;IACI,2BAAA;E5Fkz6BlB;AACF;A8F7i7BY;EF4II;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPy74BhC;E4Fl66BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EPg84BhC;E4Fj66BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EP884BtB;E4Fh66Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5F456BtB;E4Ft56BU;IACI,aAAA;E5Fw56Bd;E4Ft56Bc;IAEI,aAAA;E5Fu56BlB;E6Fj+6BD;IACC,iBtF6gCyB;EPs94BzB;E4Fj56Bc;IACI,kBrF+7BE;EPo94BpB;E4F946BU;IACI,aAAA;E5Fg56Bd;E4F146BkB;;IAEI,0BAAA;IACA,2BAAA;E5F446BtB;E4Fv46BU;IACI,sBAAA;IACA,WAAA;E5Fy46Bd;E4Ft46BU;IACI,mBAAA;E5Fw46Bd;E4Ft46Bc;IACI,aAAA;IACA,mBAAA;E5Fw46BlB;E4Fr46BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPk/4BhC;E4Fn46Bc;IpF3OZ,sBAAA;ERin7BF;E4F/36Bc;IACI,mBAAA;E5Fi46BlB;E4F336Bc;IACI,2BAAA;E5F636BlB;AACF;A8Fxn7BY;EF4II;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPog5BhC;E4F7+6BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EP2g5BhC;E4F5+6BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EPyh5BtB;E4F3+6Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5Fu+6BtB;E4Fj+6BU;IACI,aAAA;E5Fm+6Bd;E4Fj+6Bc;IAEI,aAAA;E5Fk+6BlB;E6F5i7BD;IACC,iBtF6gCyB;EPii5BzB;E4F596Bc;IACI,kBrF+7BE;EP+h5BpB;E4Fz96BU;IACI,aAAA;E5F296Bd;E4Fr96BkB;;IAEI,0BAAA;IACA,2BAAA;E5Fu96BtB;E4Fl96BU;IACI,sBAAA;IACA,WAAA;E5Fo96Bd;E4Fj96BU;IACI,mBAAA;E5Fm96Bd;E4Fj96Bc;IACI,aAAA;IACA,mBAAA;E5Fm96BlB;E4Fh96BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EP6j5BhC;E4F986Bc;IpF3OZ,sBAAA;ER4r7BF;E4F186Bc;IACI,mBAAA;E5F486BlB;E4Ft86Bc;IACI,2BAAA;E5Fw86BlB;AACF;A8Fns7BY;EF4II;ICzJf,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EP+k5BhC;E4Fxj7BsB;IChKvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+BtFqoCiC;EPsl5BhC;E4Fvj7BU;IACI,aAAA;IACA,sBJxKoB;IIyKpB,kDAAA;IACA,8CAAA;IACA,YrFq9BQ;EPom5BtB;E4Ftj7Bc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;E5Fkj7BtB;E4F5i7BU;IACI,aAAA;E5F8i7Bd;E4F5i7Bc;IAEI,aAAA;E5F6i7BlB;E6Fvn7BD;IACC,iBtF6gCyB;EP4m5BzB;E4Fvi7Bc;IACI,kBrF+7BE;EP0m5BpB;E4Fpi7BU;IACI,aAAA;E5Fsi7Bd;E4Fhi7BkB;;IAEI,0BAAA;IACA,2BAAA;E5Fki7BtB;E4F7h7BU;IACI,sBAAA;IACA,WAAA;E5F+h7Bd;E4F5h7BU;IACI,mBAAA;E5F8h7Bd;E4F5h7Bc;IACI,aAAA;IACA,mBAAA;E5F8h7BlB;E4F3h7BsB;IC/OvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+BtFqoCiC;EPwo5BhC;E4Fzh7Bc;IpF3OZ,sBAAA;ERuw7BF;E4Frh7Bc;IACI,mBAAA;E5Fuh7BlB;E4Fjh7Bc;IACI,2BAAA;E5Fmh7BlB;AACF;A4F3g7BI;EACI,cAAA;EACA,iBAAA;A5F6g7BR;A6F3v7BG;;;;EAEC,+BAAA;A7F+v7BJ;A6Fzv7BK;;;;;;;;EAEC,+BAAA;A7Fiw7BN;A6F3v7BO;;;;;;;;;;;;;;;;EAEC,+BAAA;A7F2w7BR;A6Frw7BS;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAEC,+BAAA;A7Fqy7BV;A6Ftx7BI;;;;EAEC,kBAAA;EACA,gBAAA;A7F0x7BL;A6Fpx7BM;;;;;;;;EAEC,wBAAA;EACA,gBAAA;A7F4x7BP;A6Ftx7BQ;;;;;;;;;;;;;;;;EAEC,wBAAA;EACA,gBAAA;A7Fsy7BT;A6Fhy7BU;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAEC,wBAAA;EACA,gBAAA;A7Fg07BX;;A4Flp7BA;EACI;IACI,UAAA;E5Fqp7BN;E4Flp7BE;IACI,UAAA;E5Fop7BN;AACF;A4Fjp7BA;EACI;IACI,mBAAA;E5Fmp7BN;E4Fhp7BE;IACI,aAAA;E5Fkp7BN;AACF;A4F/o7BA;EACI;IACI,sBAAA;E5Fip7BN;E4F9o7BE;IACI,gBAAA;E5Fgp7BN;AACF;A6Flx7BQ;EA5CN,sBEnI4C;A/Fo87B9C;A6F/z7BE;EACC,sBEtI2C;A/Fu87B9C;A6F3z7BG;;;EAGC,sBE/IqE;A/F487BzE;A6Ftz7BG;EACC,iCEvJgG;A/F+87BpG;A6Fjz7BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F+z7BH;;A6Flz7BQ;EA5CN,2BE5H4C;A/F897B9C;A6Fh27BE;EACC,2BE/H2C;A/Fi+7B9C;;A6F517BG;;;EAGC,2BEjIgD;A/Fg+7BpD;;A6Fx17BG;EACC,sCElIsD;A/F697B1D;;A6Fp17BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fm27BH;;A6Ft17BQ;EA5CN,wBEnI4C;A/Fyg8B9C;A6Fp47BE;EACC,wBEtI2C;A/F4g8B9C;A6Fh47BG;;;EAGC,wBE/IqE;A/Fih8BzE;A6F337BG;EACC,mCEvJgG;A/Foh8BpG;A6Ft37BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fo47BH;;A6Fv37BQ;EA5CN,6BE5H4C;A/Fmi8B9C;A6Fr67BE;EACC,6BE/H2C;A/Fsi8B9C;;A6Fj67BG;;;EAGC,6BEjIgD;A/Fqi8BpD;;A6F757BG;EACC,wCElIsD;A/Fki8B1D;;A6Fz57BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fw67BH;;A6F357BQ;EA5CN,0BEnI4C;A/F8k8B9C;A6Fz87BE;EACC,0BEtI2C;A/Fil8B9C;A6Fr87BG;;;EAGC,0BE/IqE;A/Fsl8BzE;A6Fh87BG;EACC,qCEvJgG;A/Fyl8BpG;A6F377BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fy87BH;;A6F577BQ;EA5CN,+BE5H4C;A/Fwm8B9C;A6F1+7BE;EACC,+BE/H2C;A/F2m8B9C;;A6Ft+7BG;;;EAGC,+BEjIgD;A/F0m8BpD;;A6Fl+7BG;EACC,0CElIsD;A/Fum8B1D;;A6F997BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,0CMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,0CMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F6+7BH;;A6Fh+7BQ;EA5CN,sBEnI4C;A/Fmp8B9C;A6F9g8BE;EACC,sBEtI2C;A/Fsp8B9C;A6F1g8BG;;;EAGC,sBE/IqE;A/F2p8BzE;A6Frg8BG;EACC,iCEvJgG;A/F8p8BpG;A6Fhg8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F8g8BH;;A6Fjg8BQ;EA5CN,2BE5H4C;A/F6q8B9C;A6F/i8BE;EACC,2BE/H2C;A/Fgr8B9C;;A6F3i8BG;;;EAGC,2BEjIgD;A/F+q8BpD;;A6Fvi8BG;EACC,sCElIsD;A/F4q8B1D;;A6Fni8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fkj8BH;;A6Fri8BQ;EA5CN,wBEnI4C;A/Fwt8B9C;A6Fnl8BE;EACC,wBEtI2C;A/F2t8B9C;A6F/k8BG;;;EAGC,wBE/IqE;A/Fgu8BzE;A6F1k8BG;EACC,mCEvJgG;A/Fmu8BpG;A6Frk8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fml8BH;;A6Ftk8BQ;EA5CN,6BE5H4C;A/Fkv8B9C;A6Fpn8BE;EACC,6BE/H2C;A/Fqv8B9C;;A6Fhn8BG;;;EAGC,6BEjIgD;A/Fov8BpD;;A6F5m8BG;EACC,wCElIsD;A/Fiv8B1D;;A6Fxm8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fun8BH;;A6F1m8BQ;EA5CN,qBEnI4C;A/F6x8B9C;A6Fxp8BE;EACC,qBEtI2C;A/Fgy8B9C;A6Fpp8BG;;;EAGC,qBE/IqE;A/Fqy8BzE;A6F/o8BG;EACC,gCEvJgG;A/Fwy8BpG;A6F1o8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fwp8BH;;A6F3o8BQ;EA5CN,0BE5H4C;A/Fuz8B9C;A6Fzr8BE;EACC,0BE/H2C;A/F0z8B9C;;A6Frr8BG;;;EAGC,0BEjIgD;A/Fyz8BpD;;A6Fjr8BG;EACC,qCElIsD;A/Fsz8B1D;;A6F7q8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F4r8BH;;A6F/q8BQ;EA5CN,wBEnI4C;A/Fk28B9C;A6F7t8BE;EACC,wBEtI2C;A/Fq28B9C;A6Fzt8BG;;;EAGC,wBE/IqE;A/F028BzE;A6Fpt8BG;EACC,mCEvJgG;A/F628BpG;A6F/s8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F6t8BH;;A6Fht8BQ;EA5CN,6BE5H4C;A/F438B9C;A6F9v8BE;EACC,6BE/H2C;A/F+38B9C;;A6F1v8BG;;;EAGC,6BEjIgD;A/F838BpD;;A6Ftv8BG;EACC,wCElIsD;A/F238B1D;;A6Flv8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fiw8BH;;A6Fpv8BQ;EA5CN,uBEnI4C;A/Fu68B9C;A6Fly8BE;EACC,uBEtI2C;A/F068B9C;A6F9x8BG;;;EAGC,uBE/IqE;A/F+68BzE;A6Fzx8BG;EACC,kCEvJgG;A/Fk78BpG;A6Fpx8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fky8BH;;A6Frx8BQ;EA5CN,4BE5H4C;A/Fi88B9C;A6Fn08BE;EACC,4BE/H2C;A/Fo88B9C;;A6F/z8BG;;;EAGC,4BEjIgD;A/Fm88BpD;;A6F3z8BG;EACC,uCElIsD;A/Fg88B1D;;A6Fvz8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,uCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,uCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fs08BH;;A6Fzz8BQ;EA5CN,qBEnI4C;A/F4+8B9C;A6Fv28BE;EACC,qBEtI2C;A/F++8B9C;A6Fn28BG;;;EAGC,qBE/IqE;A/Fo/8BzE;A6F918BG;EACC,gCEvJgG;A/Fu/8BpG;A6Fz18BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fu28BH;;A6F118BQ;EA5CN,0BE5H4C;A/Fsg9B9C;A6Fx48BE;EACC,0BE/H2C;A/Fyg9B9C;;A6Fp48BG;;;EAGC,0BEjIgD;A/Fwg9BpD;;A6Fh48BG;EACC,qCElIsD;A/Fqg9B1D;;A6F538BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F248BH;;A6F938BQ;EA5CN,sBEnI4C;A/Fij9B9C;A6F568BE;EACC,sBEtI2C;A/Foj9B9C;A6Fx68BG;;;EAGC,sBE/IqE;A/Fyj9BzE;A6Fn68BG;EACC,iCEvJgG;A/F4j9BpG;A6F958BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F468BH;;A6F/58BQ;EA5CN,2BE5H4C;A/F2k9B9C;A6F788BE;EACC,2BE/H2C;A/F8k9B9C;;A6Fz88BG;;;EAGC,2BEjIgD;A/F6k9BpD;;A6Fr88BG;EACC,sCElIsD;A/F0k9B1D;;A6Fj88BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fg98BH;;A6Fn88BQ;EA5CN,yBEnI4C;A/Fsn9B9C;A6Fj/8BE;EACC,yBEtI2C;A/Fyn9B9C;A6F7+8BG;;;EAGC,yBE/IqE;A/F8n9BzE;A6Fx+8BG;EACC,oCEvJgG;A/Fio9BpG;A6Fn+8BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fi/8BH;;A6Fp+8BQ;EA5CN,8BE5H4C;A/Fgp9B9C;A6Flh9BE;EACC,8BE/H2C;A/Fmp9B9C;;A6F9g9BG;;;EAGC,8BEjIgD;A/Fkp9BpD;;A6F1g9BG;EACC,yCElIsD;A/F+o9B1D;;A6Ftg9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fqh9BH;;A6Fxg9BQ;EA5CN,yBEnI4C;A/F2r9B9C;A6Ftj9BE;EACC,yBEtI2C;A/F8r9B9C;A6Flj9BG;;;EAGC,yBE/IqE;A/Fms9BzE;A6F7i9BG;EACC,oCEvJgG;A/Fss9BpG;A6Fxi9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fsj9BH;;A6Fzi9BQ;EA5CN,8BE5H4C;A/Fqt9B9C;A6Fvl9BE;EACC,8BE/H2C;A/Fwt9B9C;;A6Fnl9BG;;;EAGC,8BEjIgD;A/Fut9BpD;;A6F/k9BG;EACC,yCElIsD;A/Fot9B1D;;A6F3k9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F0l9BH;;A6F7k9BQ;EA5CN,yBEnI4C;A/Fgw9B9C;A6F3n9BE;EACC,yBEtI2C;A/Fmw9B9C;A6Fvn9BG;;;EAGC,yBE/IqE;A/Fww9BzE;A6Fln9BG;EACC,oCEvJgG;A/F2w9BpG;A6F7m9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F2n9BH;;A6F9m9BQ;EA5CN,8BE5H4C;A/F0x9B9C;A6F5p9BE;EACC,8BE/H2C;A/F6x9B9C;;A6Fxp9BG;;;EAGC,8BEjIgD;A/F4x9BpD;;A6Fpp9BG;EACC,yCElIsD;A/Fyx9B1D;;A6Fhp9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F+p9BH;;A6Flp9BQ;EA5CN,yBEnI4C;A/Fq09B9C;A6Fhs9BE;EACC,yBEtI2C;A/Fw09B9C;A6F5r9BG;;;EAGC,yBE/IqE;A/F609BzE;A6Fvr9BG;EACC,oCEvJgG;A/Fg19BpG;A6Flr9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fgs9BH;;A6Fnr9BQ;EA5CN,8BE5H4C;A/F+19B9C;A6Fju9BE;EACC,8BE/H2C;A/Fk29B9C;;A6F7t9BG;;;EAGC,8BEjIgD;A/Fi29BpD;;A6Fzt9BG;EACC,yCElIsD;A/F819B1D;;A6Frt9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fou9BH;;A6Fvt9BQ;EA5CN,yBEnI4C;A/F049B9C;A6Frw9BE;EACC,yBEtI2C;A/F649B9C;A6Fjw9BG;;;EAGC,yBE/IqE;A/Fk59BzE;A6F5v9BG;EACC,oCEvJgG;A/Fq59BpG;A6Fvv9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fqw9BH;;A6Fxv9BQ;EA5CN,8BE5H4C;A/Fo69B9C;A6Fty9BE;EACC,8BE/H2C;A/Fu69B9C;;A6Fly9BG;;;EAGC,8BEjIgD;A/Fs69BpD;;A6F9x9BG;EACC,yCElIsD;A/Fm69B1D;;A6F1x9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fyy9BH;;A6F5x9BQ;EA5CN,yBEnI4C;A/F+89B9C;A6F109BE;EACC,yBEtI2C;A/Fk99B9C;A6Ft09BG;;;EAGC,yBE/IqE;A/Fu99BzE;A6Fj09BG;EACC,oCEvJgG;A/F099BpG;A6F5z9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F009BH;;A6F7z9BQ;EA5CN,8BE5H4C;A/Fy+9B9C;A6F329BE;EACC,8BE/H2C;A/F4+9B9C;;A6Fv29BG;;;EAGC,8BEjIgD;A/F2+9BpD;;A6Fn29BG;EACC,yCElIsD;A/Fw+9B1D;;A6F/19BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F829BH;;A6Fj29BQ;EA5CN,yBEnI4C;A/Foh+B9C;A6F/49BE;EACC,yBEtI2C;A/Fuh+B9C;A6F349BG;;;EAGC,yBE/IqE;A/F4h+BzE;A6Ft49BG;EACC,oCEvJgG;A/F+h+BpG;A6Fj49BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F+49BH;;A6Fl49BQ;EA5CN,8BE5H4C;A/F8i+B9C;A6Fh79BE;EACC,8BE/H2C;A/Fij+B9C;;A6F569BG;;;EAGC,8BEjIgD;A/Fgj+BpD;;A6Fx69BG;EACC,yCElIsD;A/F6i+B1D;;A6Fp69BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fm79BH;;A6Ft69BQ;EA5CN,yBEnI4C;A/Fyl+B9C;A6Fp99BE;EACC,yBEtI2C;A/F4l+B9C;A6Fh99BG;;;EAGC,yBE/IqE;A/Fim+BzE;A6F389BG;EACC,oCEvJgG;A/Fom+BpG;A6Ft89BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fo99BH;;A6Fv89BQ;EA5CN,8BE5H4C;A/Fmn+B9C;A6Fr/9BE;EACC,8BE/H2C;A/Fsn+B9C;;A6Fj/9BG;;;EAGC,8BEjIgD;A/Fqn+BpD;;A6F7+9BG;EACC,yCElIsD;A/Fkn+B1D;;A6Fz+9BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fw/9BH;;A6F3+9BQ;EA5CN,yBEnI4C;A/F8p+B9C;A6Fzh+BE;EACC,yBEtI2C;A/Fiq+B9C;A6Frh+BG;;;EAGC,yBE/IqE;A/Fsq+BzE;A6Fhh+BG;EACC,oCEvJgG;A/Fyq+BpG;A6F3g+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDuH;ENuD3H,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fyh+BH;;A6F5g+BQ;EA5CN,8BE5H4C;A/Fwr+B9C;A6F1j+BE;EACC,8BE/H2C;A/F2r+B9C;;A6Ftj+BG;;;EAGC,8BEjIgD;A/F0r+BpD;;A6Flj+BG;EACC,yCElIsD;A/Fur+B1D;;A6F9i+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN2B5D,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7F6j+BH;;A6Fni+BC;EAEC,2BtFqIgB;EsFpMhB,oDEtFU;EF0FV,sCE9FU;A/Fgs+BZ;A6Fhm+BE;EACC,sCEjGS;A/Fms+BZ;A6F5l+BG;;;;;EAGC,sCEzGQ;A/Fys+BZ;A6Fzl+BG;EACC,iDEhHQ;A/F2s+BZ;A6Fpl+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDMZI;ENeR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDMZI;ENeR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fkm+BH;;A6Fri+BC;EACC,2BtFmGgB;EsFpMhB,mDE1EU;EF8EV,qCElFU;A/Fyt+BZ;A6Fro+BE;EACC,qCErFS;A/F4t+BZ;A6Fjo+BG;;;EAGC,qCE7FQ;A/Fgu+BZ;A6F5n+BG;EACC,gDEpGQ;A/Fku+BZ;A6Fvn+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDAAA;EAGJ,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDAAA;EAGJ,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fqo+BH;;A6Fxk+BC;EACC,2BtFmGgB;EsFpMhB,mDE9DU;EFkEV,qCEtEU;A/Fgv+BZ;A6Fxq+BE;EACC,qCEzES;A/Fmv+BZ;A6Fpq+BG;;;EAGC,qCEjFQ;A/Fuv+BZ;A6F/p+BG;EACC,gDExFQ;A/Fyv+BZ;A6F1p+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMYI;ENTR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMYI;ENTR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fwq+BH;;AgBpx+BI;E6EyKH;IACC,2BtFmGgB;IsFpMhB,mDEhDc;IFoDd,qCExDc;E/Fsw+Bd;E6F5s+BA;IACC,qCE3Da;E/Fyw+Bd;E6Fxs+BC;;;IAGC,qCEnEY;E/F6w+Bd;E6Fns+BC;IACC,gDE1EY;E/F+w+Bd;E6F9r+BA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,gDM0BQ;INvBZ,6DAAA;IACA,qDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,gDM0BQ;INvBZ,6DAAA;IACA,qDAAA;II0GD,iBAAA;E7F4s+BD;AACF;A6Fzp+BC;EACC,2BtF4GgB;EsFpMhB,mDEnCU;EFuCV,qCE3CU;A/F4x+BZ;A6F/u+BE;EACC,qCE9CS;A/F+x+BZ;A6F3u+BG;;;EAGC,qCEtDQ;A/Fmy+BZ;A6Ftu+BG;EACC,gDE7DQ;A/Fqy+BZ;A6Fju+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMuCI;ENpCR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMuCI;ENpCR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7F+u+BH;;A6Frs+BQ;EACN,2BtFsHgB;EsFpMhB,qDEvBU;EF2BV,uCE/BU;A/Fmz+BZ;A6Flx+BE;EACC,uCElCS;A/Fsz+BZ;A6F9w+BG;;;EAGC,uCE1CQ;A/F0z+BZ;A6Fzw+BG;EACC,kDEjDQ;A/F4z+BZ;A6Fpw+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDMmDI;ENhDR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDMmDI;ENhDR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fkx+BH;;A6Fxv+BC;EAEC,2BtFqIgB;EsFpMhB,oDEXU;EFeV,sCEnBU;A/F00+BZ;A6Frz+BE;EACC,sCEtBS;A/F60+BZ;A6Fjz+BG;;;;;EAGC,sCE9BQ;A/Fm1+BZ;A6F9y+BG;EACC,iDErCQ;A/Fq1+BZ;A6Fzy+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDM+DI;EN5DR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDM+DI;EN5DR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fuz+BH;A6F1v+BC;EACC,2BtFmGgB;EsFpMhB,mDEHU;EFOV,qCEXU;A/Fs2+BZ;A6Fz1+BE;EACC,qCEdS;A/Fy2+BZ;A6Fr1+BG;;;EAGC,qCEtBQ;A/F62+BZ;A6Fh1+BG;EACC,gDE7BQ;A/F+2+BZ;A6F30+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMuEI;ENpER,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMuEI;ENpER,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fy1+BH;A6Fry+BC;EACC,2BtF4GgB;EsFpMhB,mDEKU;EFDV,qCEHU;A/Fg4+BZ;A6F33+BE;EACC,qCENS;A/Fm4+BZ;A6Fv3+BG;;;EAGC,qCEdQ;A/Fu4+BZ;A6Fl3+BG;EACC,gDErBQ;A/Fy4+BZ;A6F72+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDM+EI;EN5ER,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDM+EI;EN5ER,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7F23+BH;A6Fj1+BQ;EACN,2BtFsHgB;EsFpMhB,qDEaU;EFTV,uCEKU;A/F05+BZ;A6F75+BE;EACC,uCEES;A/F65+BZ;A6Fz5+BG;;;EAGC,uCENQ;A/Fi6+BZ;A6Fp5+BG;EACC,kDEbQ;A/Fm6+BZ;A6F/4+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDMuFI;ENpFR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDMuFI;ENpFR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7F65+BH;;A6Fn4+BC;EAEC,2BtFqIgB;EsFhMhB,sCEiBU;A/Fg7+BZ;A6F/7+BE;EACC,sCEcS;A/Fm7+BZ;A6F37+BG;;;;;EAGC,sCEMQ;A/Fy7+BZ;A6Fx7+BG;EACC,iDEDQ;A/F27+BZ;A6Fn7+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDMmGI;ENhGR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDMmGI;ENhGR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fi8+BH;A6Fp4+BC;EACC,2BtFmGgB;EsFhMhB,qCEyBU;A/F28+BZ;A6Fl++BE;EACC,qCEsBS;A/F88+BZ;A6F99+BG;;;EAGC,qCEcQ;A/Fk9+BZ;A6Fz9+BG;EACC,gDEOQ;A/Fo9+BZ;A6Fp9+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDM2GI;ENxGR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDM2GI;ENxGR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fk++BH;A6F96+BC;EACC,2BtF4GgB;EsFhMhB,qCEiCU;A/Fo++BZ;A6Fng/BE;EACC,qCE8BS;A/Fu++BZ;A6F//+BG;;;EAGC,qCEsBQ;A/F2++BZ;A6F1/+BG;EACC,gDEeQ;A/F6++BZ;A6Fr/+BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMmHI;ENhHR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMmHI;ENhHR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fmg/BH;A6Fz9+BQ;EACN,2BtFsHgB;EsFhMhB,uCEyCU;A/F6/+BZ;A6Fpi/BE;EACC,uCEsCS;A/Fgg/BZ;A6Fhi/BG;;;EAGC,uCE8BQ;A/Fog/BZ;A6F3h/BG;EACC,kDEuBQ;A/Fsg/BZ;A6Fth/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDM2HI;ENxHR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDM2HI;ENxHR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Foi/BH;;A6F1g/BC;EAEC,2BtFqIgB;EsFpMhB,mCE8DU;EF1DV,gCEsDU;A/Fmh/BZ;A6Fvk/BE;EACC,gCEmDS;A/Fsh/BZ;A6Fnk/BG;;;;;EAGC,gCE2CQ;A/F4h/BZ;A6Fhk/BG;EACC,2CEoCQ;A/F8h/BZ;A6F3j/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwII;ENrIR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwII;ENrIR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fyk/BH;;A6Frh/BC;EACC,2BtF4GgB;EsFpMhB,mCE0EU;EFtEV,gCEkEU;A/F4i/BZ;A6F5m/BE;EACC,gCE+DS;A/F+i/BZ;A6Fxm/BG;;;EAGC,gCEuDQ;A/Fmj/BZ;A6Fnm/BG;EACC,2CEgDQ;A/Fqj/BZ;A6F9l/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMoJI;ENjJR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMoJI;ENjJR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7F4m/BH;;A6F/i/BC;EACC,2BtFmGgB;EsFpMhB,mCEsFU;EFlFV,gCE8EU;A/Fmk/BZ;A6F/o/BE;EACC,gCE2ES;A/Fsk/BZ;A6F3o/BG;;;EAGC,gCEmEQ;A/F0k/BZ;A6Fto/BG;EACC,2CE4DQ;A/F4k/BZ;A6Fjo/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgKI;EN7JR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgKI;EN7JR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7F+o/BH;;A6Frm/BQ;EACN,2BtFsHgB;EsFpMhB,mCEkGU;EF9FV,gCE0FU;A/F0l/BZ;A6Flr/BE;EACC,gCEuFS;A/F6l/BZ;A6F9q/BG;;;EAGC,gCE+EQ;A/Fim/BZ;A6Fzq/BG;EACC,2CEwEQ;A/Fmm/BZ;A6Fpq/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CM4KI;ENzKR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CM4KI;ENzKR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fkr/BH;;A6Fxp/BC;EAEC,2BtFqIgB;EsFpMhB,mCE8GU;EF1GV,gCEsGU;A/Fin/BZ;A6Frt/BE;EACC,gCEmGS;A/Fon/BZ;A6Fjt/BG;;;;;EAGC,gCE2FQ;A/F0n/BZ;A6F9s/BG;EACC,2CEoFQ;A/F4n/BZ;A6Fzs/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwLI;ENrLR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwLI;ENrLR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fut/BH;A6Fnq/BC;EACC,2BtF4GgB;EsFpMhB,mCEsHU;EFlHV,gCE8GU;A/F6o/BZ;A6Fzv/BE;EACC,gCE2GS;A/Fgp/BZ;A6Frv/BG;;;EAGC,gCEmGQ;A/Fop/BZ;A6Fhv/BG;EACC,2CE4FQ;A/Fsp/BZ;A6F3u/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgMI;EN7LR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgMI;EN7LR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7Fyv/BH;A6F5r/BC;EACC,2BtFmGgB;EsFpMhB,mCE8HU;EF1HV,gCEsHU;A/Fuq/BZ;A6F3x/BE;EACC,gCEmHS;A/F0q/BZ;A6Fvx/BG;;;EAGC,gCE2GQ;A/F8q/BZ;A6Flx/BG;EACC,2CEoGQ;A/Fgr/BZ;A6F7w/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwMI;ENrMR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwMI;ENrMR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7F2x/BH;A6Fjv/BQ;EACN,2BtFsHgB;EsFpMhB,mCEsIU;EFlIV,gCE8HU;A/Fis/BZ;A6F7z/BE;EACC,gCE2HS;A/Fos/BZ;A6Fzz/BG;;;EAGC,gCEmHQ;A/Fws/BZ;A6Fpz/BG;EACC,2CE4GQ;A/F0s/BZ;A6F/y/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgNI;EN7MR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgNI;EN7MR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7F6z/BH;A6Fzw/BC;EACC,2BtF4GgB;EsFpMhB,mCE8IU;EF1IV,gCEsIU;A/F2t/BZ;A6F/1/BE;EACC,gCEmIS;A/F8t/BZ;A6F31/BG;;;EAGC,gCE2HQ;A/Fku/BZ;A6Ft1/BG;EACC,2CEoHQ;A/Fou/BZ;A6Fj1/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwNI;ENrNR,6DAAA;EACA,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwNI;ENrNR,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7F+1/BH;;A6F3y/BC;EACC,2BtF4GgB;EsFpMhB,yCEsJ6I;EFlJ7I,wBEkJqC;A/Fkv/BvC;A6Fl4/BE;EACC,wBE+IoC;A/Fqv/BvC;A6F93/BG;;;EAGC,wBEsI6D;A/F0v/BjE;A6Fz3/BG;EACC,mCE8HuF;A/F6v/B3F;A6Fp3/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMiO6G;EN9NjH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMiO6G;EN9NjH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fk4/BH;;A6Fr0/BC;EACC,2BtFmGgB;EsFpMhB,yCE4J6I;EFxJ7I,wBEwJqC;A/F+w/BvC;A6Fr6/BE;EACC,wBEqJoC;A/Fkx/BvC;A6Fj6/BG;;;EAGC,wBE4I6D;A/Fux/BjE;A6F55/BG;EACC,mCEoIuF;A/F0x/B3F;A6Fv5/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMuO6G;ENpOjH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMuO6G;ENpOjH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fq6/BH;;A6F34/BC;EAEC,2BtFqIgB;EsFpMhB,yCEkK8I;EF9J9I,wBE8JsC;A/F4y/BxC;A6Fx8/BE;EACC,wBE2JqC;A/F+y/BxC;A6Fp8/BG;;;;;EAGC,wBEkJ8D;A/Fsz/BlE;A6Fj8/BG;EACC,mCE0IwF;A/Fyz/B5F;A6F57/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6O8G;EN1OlH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6O8G;EN1OlH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F08/BH;;A6Fh6/BQ;EACN,2BtFsHgB;EsFpMhB,yCEwK+I;EFpK/I,wBEoKuC;A/F20/BzC;A6F7+/BE;EACC,wBEiKsC;A/F80/BzC;A6Fz+/BG;;;EAGC,wBEwJ+D;A/Fm1/BnE;A6Fp+/BG;EACC,mCEgJyF;A/Fs1/B7F;A6F/9/BE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMmP+G;ENhPnH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMmP+G;ENhPnH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F6+/BH;;A6Fz7/BC;EACC,2BtF4GgB;EsFpMhB,yCE8K6I;EF1K7I,wBE0KqC;A/Fw2/BvC;A6FhhgCE;EACC,wBEuKoC;A/F22/BvC;A6F5ggCG;;;EAGC,wBE8J6D;A/Fg3/BjE;A6FvggCG;EACC,mCEsJuF;A/Fm3/B3F;A6FlggCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMyP6G;ENtPjH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMyP6G;ENtPjH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7FghgCH;A6Fn9/BC;EACC,2BtFmGgB;EsFpMhB,yCE+K6I;EF3K7I,wBE2KqC;A/Fy4/BvC;A6FljgCE;EACC,wBEwKoC;A/F44/BvC;A6F9igCG;;;EAGC,wBE+J6D;A/Fi5/BjE;A6FzigCG;EACC,mCEuJuF;A/Fo5/B3F;A6FpigCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM0P6G;ENvPjH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM0P6G;ENvPjH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7FkjgCH;A6FxhgCC;EAEC,2BtFqIgB;EsFpMhB,yCEgL8I;EF5K9I,wBE4KsC;A/F06/BxC;A6FplgCE;EACC,wBEyKqC;A/F66/BxC;A6FhlgCG;;;;;EAGC,wBEgK8D;A/Fo7/BlE;A6F7kgCG;EACC,mCEwJwF;A/Fu7/B5F;A6FxkgCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2P8G;ENxPlH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2P8G;ENxPlH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7FslgCH;A6F5igCQ;EACN,2BtFsHgB;EsFpMhB,yCEiL+I;EF7K/I,wBE6KuC;A/F68/BzC;A6FxngCE;EACC,wBE0KsC;A/Fg9/BzC;A6FpngCG;;;EAGC,wBEiK+D;A/Fq9/BnE;A6F/mgCG;EACC,mCEyJyF;A/Fw9/B7F;A6F1mgCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4P+G;ENzPnH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4P+G;ENzPnH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7FwngCH;;A6F9lgCC;EAEC,2BtFqIgB;EsFhMhB,wBEoLsC;A/Fw+/BxC;A6F1pgCE;EACC,wBEiLqC;A/F2+/BxC;A6FtpgCG;;;;;EAGC,wBEwK8D;A/Fk//BlE;A6FnpgCG;EACC,mCEgKwF;A/Fq//B5F;A6F9ogCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMmQ8G;ENhQlH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMmQ8G;ENhQlH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F4pgCH;;A6FxmgCC;EACC,2BtF4GgB;EsFhMhB,wBE0LqC;A/FsggCvC;A6F9rgCE;EACC,wBEuLoC;A/FyggCvC;A6F1rgCG;;;EAGC,wBE8K6D;A/F8ggCjE;A6FrrgCG;EACC,mCEsKuF;A/FihgC3F;A6FhrgCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMyQ6G;ENtQjH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMyQ6G;ENtQjH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F8rgCH;;A6FjogCC;EACC,2BtFmGgB;EsFhMhB,wBEgMqC;A/FkigCvC;A6FhugCE;EACC,wBE6LoC;A/FqigCvC;A6F5tgCG;;;EAGC,wBEoL6D;A/F0igCjE;A6FvtgCG;EACC,mCE4KuF;A/F6igC3F;A6FltgCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM+Q6G;EN5QjH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM+Q6G;EN5QjH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7FgugCH;;A6FtrgCQ;EACN,2BtFsHgB;EsFhMhB,wBEsMuC;A/F8jgCzC;A6FlwgCE;EACC,wBEmMsC;A/FikgCzC;A6F9vgCG;;;EAGC,wBE0L+D;A/FskgCnE;A6FzvgCG;EACC,mCEkLyF;A/FykgC7F;A6FpvgCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMqR+G;ENlRnH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMqR+G;ENlRnH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7FkwgCH;;A6FxugCC;EAEC,2BtFqIgB;EsFhMhB,wBE4MsC;A/F0lgCxC;A6FpygCE;EACC,wBEyMqC;A/F6lgCxC;A6FhygCG;;;;;EAGC,wBEgM8D;A/FomgClE;A6F7xgCG;EACC,mCEwLwF;A/FumgC5F;A6FxxgCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2R8G;ENxRlH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2R8G;ENxRlH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7FsygCH;A6FlvgCC;EACC,2BtF4GgB;EsFhMhB,wBE6MqC;A/F4ngCvC;A6Fv0gCE;EACC,wBE0MoC;A/F+ngCvC;A6Fn0gCG;;;EAGC,wBEiM6D;A/FoogCjE;A6F9zgCG;EACC,mCEyLuF;A/FuogC3F;A6FzzgCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4R6G;ENzRjH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4R6G;ENzRjH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fu0gCH;A6F1wgCC;EACC,2BtFmGgB;EsFhMhB,wBE8MqC;A/F4pgCvC;A6Fx2gCE;EACC,wBE2MoC;A/F+pgCvC;A6Fp2gCG;;;EAGC,wBEkM6D;A/FoqgCjE;A6F/1gCG;EACC,mCE0LuF;A/FuqgC3F;A6F11gCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6R6G;EN1RjH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6R6G;EN1RjH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fw2gCH;A6F9zgCQ;EACN,2BtFsHgB;EsFhMhB,wBE+MuC;A/F4rgCzC;A6Fz4gCE;EACC,wBE4MsC;A/F+rgCzC;A6Fr4gCG;;;EAGC,wBEmM+D;A/FosgCnE;A6Fh4gCG;EACC,mCE2LyF;A/FusgC7F;A6F33gCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM8R+G;EN3RnH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM8R+G;EN3RnH,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fy4gCH;;A6F/2gCC;EAEC,2BtFqIgB;EsFhMhB,qBEqNsC;A/FwtgCxC;A6F36gCE;EACC,qBEkNqC;A/F2tgCxC;A6Fv6gCG;;;;;EAGC,qBEyM2D;A/FkugC/D;A6Fp6gCG;EACC,gCEiMkF;A/FqugCtF;A6F/5gCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMoSqG;ENjSzG,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMoSqG;ENjSzG,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F66gCH;A6Fz3gCC;EACC,2BtF4GgB;EsFhMhB,qBEsNqC;A/F0vgCvC;A6F98gCE;EACC,qBEmNoC;A/F6vgCvC;A6F18gCG;;;EAGC,qBE0M0D;A/FkwgC9D;A6Fr8gCG;EACC,gCEkMiF;A/FqwgCrF;A6Fh8gCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMqSoG;ENlSxG,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMqSoG;ENlSxG,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F88gCH;A6Fj5gCC;EACC,2BtFmGgB;EsFhMhB,qBEuNqC;A/F0xgCvC;A6F/+gCE;EACC,qBEoNoC;A/F6xgCvC;A6F3+gCG;;;EAGC,qBE2M0D;A/FkygC9D;A6Ft+gCG;EACC,gCEmMiF;A/FqygCrF;A6Fj+gCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMsSoG;ENnSxG,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMsSoG;ENnSxG,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F++gCH;A6Fr8gCQ;EACN,2BtFsHgB;EsFhMhB,qBEwNuC;A/F0zgCzC;A6FhhhCE;EACC,qBEqNsC;A/F6zgCzC;A6F5ghCG;;;EAGC,qBE4M4D;A/Fk0gChE;A6FvghCG;EACC,gCEoMmF;A/Fq0gCvF;A6FlghCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMuSsG;ENpS1G,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMuSsG;ENpS1G,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7FghhCH;;A6Ft/gCC;EAEC,2BtFqIgB;EsFhMhB,yBE8NsC;A/Fs1gCxC;A6FljhCE;EACC,yBE2NqC;A/Fy1gCxC;A6F9ihCG;;;;;EAGC,yBEkN+D;A/Fg2gCnE;A6F3ihCG;EACC,oCE0M0F;A/Fm2gC9F;A6FtihCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCM6SiH;EN1SrH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCM6SiH;EN1SrH,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7FojhCH;A6FhghCC;EACC,2BtF4GgB;EsFhMhB,yBE+NqC;A/Fw3gCvC;A6FrlhCE;EACC,yBE4NoC;A/F23gCvC;A6FjlhCG;;;EAGC,yBEmN8D;A/Fg4gClE;A6F5khCG;EACC,oCE2MyF;A/Fm4gC7F;A6FvkhCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCM8SgH;EN3SpH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCM8SgH;EN3SpH,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7FqlhCH;A6FxhhCC;EACC,2BtFmGgB;EsFhMhB,yBEgOqC;A/Fw5gCvC;A6FtnhCE;EACC,yBE6NoC;A/F25gCvC;A6FlnhCG;;;EAGC,yBEoN8D;A/Fg6gClE;A6F7mhCG;EACC,oCE4MyF;A/Fm6gC7F;A6FxmhCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCM+SgH;EN5SpH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCM+SgH;EN5SpH,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7FsnhCH;A6F5khCQ;EACN,2BtFsHgB;EsFhMhB,yBEiOuC;A/Fw7gCzC;A6FvphCE;EACC,yBE8NsC;A/F27gCzC;A6FnphCG;;;EAGC,yBEqNgE;A/Fg8gCpE;A6F9ohCG;EACC,oCE6M2F;A/Fm8gC/F;A6FzohCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMgTkH;EN7StH,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMgTkH;EN7StH,6DAAA;EACA,qDAAA;EI0GD,iBAAA;A7FuphCH;;A6F7nhCC;EAEC,2BtFqIgB;EsFhMhB,wBEwOsC;A/Fm9gCxC;A6FzrhCE;EACC,wBEqOqC;A/Fs9gCxC;;A6FlmhCC;EACC,2BtFmGgB;EsFhMhB,wBE8OqC;A/Fq9gCvC;A6FjshCE;EACC,wBE2OoC;A/Fw9gCvC;;A6FnnhCC;EACC,2BtF4GgB;EsFhMhB,wBEoPqC;A/Fu9gCvC;A6FzshCE;EACC,wBEiPoC;A/F09gCvC;;A6FrohCQ;EACN,2BtFsHgB;EsFhMhB,wBE0PuC;A/Fy9gCzC;A6FjthCE;EACC,wBEuPsC;A/F49gCzC;;A6F7phCC;EAEC,2BtFqIgB;EsFhMhB,wBEgQsC;A/F29gCxC;A6FzthCE;EACC,wBE6PqC;A/F89gCxC;A6FlohCC;EACC,2BtFmGgB;EsFhMhB,wBEiQqC;A/Fi+gCvC;A6FhuhCE;EACC,wBE8PoC;A/Fo+gCvC;A6FlphCC;EACC,2BtF4GgB;EsFhMhB,wBEkQqC;A/Fu+gCvC;A6FvuhCE;EACC,wBE+PoC;A/F0+gCvC;A6FnqhCQ;EACN,2BtFsHgB;EsFhMhB,wBEmQuC;A/F6+gCzC;A6F9uhCE;EACC,wBEgQsC;A/Fg/gCzC;;A6F1rhCC;EAEC,2BtFqIgB;APujhClB;A6F9uhCG;;;;;EAGC,wBE+P0C;A/Fm/gC9C;;A6FlqhCC;EACC,2BtFmGgB;APkkhClB;A6FzvhCG;;;EAGC,wBEsQyC;A/Fq/gC7C;;A6FprhCC;EACC,2BtF4GgB;AP2khClB;A6FlwhCG;;;EAGC,wBE6QyC;A/Fu/gC7C;;A6FvshCQ;EACN,2BtFsHgB;APolhClB;A6F3whCG;;;EAGC,wBEoR2C;A/Fy/gC/C;;A6FhuhCC;EAEC,2BtFqIgB;AP6lhClB;A6FpxhCG;;;;;EAGC,wBE2R0C;A/F6/gC9C;A6FxshCC;EACC,2BtFmGgB;APumhClB;A6F9xhCG;;;EAGC,wBE4RyC;A/FoghC7C;A6FzthCC;EACC,2BtF4GgB;AP+mhClB;A6FtyhCG;;;EAGC,wBE6RyC;A/F2ghC7C;A6F3uhCQ;EACN,2BtFsHgB;APunhClB;A6F9yhCG;;;EAGC,wBE8R2C;A/FkhhC/C;;A6FnwhCC;EAEC,2BtFqIgB;APgohClB;A6F7yhCG;EACC,mCE8RgD;A/FihhCpD;;A6FhvhCC;EACC,2BtF4GgB;APuohClB;A6FpzhCG;EACC,mCEqS+C;A/FihhCnD;;A6F9uhCC;EACC,2BtFmGgB;AP8ohClB;A6F3zhCG;EACC,mCE4S+C;A/FihhCnD;;A6FxwhCQ;EACN,2BtFsHgB;APqphClB;A6Fl0hCG;EACC,mCEmTiD;A/FihhCrD;;A6F/xhCC;EAEC,2BtFqIgB;AP4phClB;A6Fz0hCG;EACC,mCE0TgD;A/FihhCpD;A6FnwhCC;EACC,2BtFmGgB;APkqhClB;A6F/0hCG;EACC,mCE2T+C;A/FshhCnD;A6FlxhCC;EACC,2BtF4GgB;APwqhClB;A6Fr1hCG;EACC,mCE4T+C;A/F2hhCnD;A6FlyhCQ;EACN,2BtFsHgB;AP8qhClB;A6F31hCG;EACC,mCE6TiD;A/FgihCrD;;A6FxzhCC;EAEC,2BtFqIgB;APqrhClB;A6F11hCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMwakD;ENratD,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMwakD;ENratD,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fw2hCH;;A6F3yhCC;EACC,2BtFmGgB;AP2shClB;A6Fh3hCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM+aiD;EN5arD,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM+aiD;EN5arD,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F83hCH;;A6F10hCC;EACC,2BtF4GgB;APiuhClB;A6Ft4hCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMsbiD;ENnbrD,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMsbiD;ENnbrD,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fo5hCH;;A6F12hCQ;EACN,2BtFsHgB;APuvhClB;A6F55hCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6bmD;EN1bvD,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6bmD;EN1bvD,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F06hCH;;A6Fh5hCC;EAEC,2BtFqIgB;AP6whClB;A6Fl7hCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMockD;ENjctD,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMockD;ENjctD,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fg8hCH;A6Fn4hCC;EACC,2BtFmGgB;APkyhClB;A6Fv8hCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMqciD;ENlcrD,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMqciD;ENlcrD,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fq9hCH;A6Fj6hCC;EACC,2BtF4GgB;APuzhClB;A6F59hCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMsciD;ENncrD,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMsciD;ENncrD,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F0+hCH;A6Fh8hCQ;EACN,2BtFsHgB;AP40hClB;A6Fj/hCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMucmD;ENpcvD,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMucmD;ENpcvD,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7F+/hCH;;AgGtqiCA;EACI,aAAA;EACA,mBAAA;AhGyqiCJ;AgGvqiCI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gC1FkjBsB;ANunhC9B;AgGvqiCQ;EACI,YAAA;AhGyqiCZ;AgGpqiCQ;EACI,aAAA;AhGsqiCZ;AgGpqiCY;EACI,wBAAA;EACA,gC1FqiBc;ANiohC9B;;AiGjsiCA;EACI,oDAAA;EACA,wDAAA;EAGI,6CAAA;AjGksiCR;AiG5riCI;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,gB1FkwBqB;E0FjwBrB,kBAAA;EACA,+BAAA;EACA,uCAAA;EACA,oDAAA;AjG8riCR;AiG3riCQ;EACI,aAAA;EACA,mBAAA;EACA,c1FuvB4B;E0FtvB5B,cAAA;AjG6riCZ;AiG3riCY;EACI,uBAAA;EACA,uBAAA;AjG6riChB;AiG1riCY;EACI,qBAAA;EACA,cAAA;AjG4riChB;AiG1riCgB;EACI,kBAAA;EACA,yBAAA;EACA,cAAA;AjG4riCpB;AiG1riCoB;EAEI,cAAA;AjG2riCxB;AiGvriCgB;EACI,yBAAA;AjGyriCpB;AkG1uiCI;EACI,YAAA;EACA,WAAA;AlG4uiCR;AiGxriCY;;EAEI,gBAAA;EACA,mBAAA;EACA,8BAAA;AjG0riChB;AiGvriCY;EACI,qBAAA;EACA,eAAA;AjGyriChB;AiGrriCY;EACI,2BAAA;EACA,eAAA;AjGuriChB;AiGnriCY;EACI,gBAAA;AjGqriChB;AiGhriCQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AjGkriCZ;AiG7qiCI;EACI,qBAAA;EACA,2BAAA;AjG+qiCR;AiG3qiCI;EACI,qBAAA;EACA,+BAAA;EACA,uCAAA;EACA,iDAAA;AjG6qiCR;AiGzqiCI;EACI,kBAAA;EACA,cAAA;AjG2qiCR;AiGtqiCQ;;;EAGI,eAAA;EACA,gBAAA;AjGwqiCZ;AiGnqiCQ;;;EAGI,cAAA;EACA,iBAAA;AjGqqiCZ;AiGhqiCQ;;;EAGI,UAAA;AjGkqiCZ;AiG7piCI;EACI,gBAAA;EACA,gDAAA;AjG+piCR;AiG7piCQ;EACI,uDAAA;AjG+piCZ;AiG5piCQ;EACI,oDAAA;AjG8piCZ;AiGzpiCI;EACI,gBAAA;EACA,yBAAA;AjG2piCR;AiGtpiCQ;EACI,2BAAA;AjGwpiCZ;AiGrpiCQ;EACI,wBAAA;AjGupiCZ;AiGlpiCI;EACI,qCAAA;EACA,SAAA;AjGopiCR;AiGhpiCI;EACI,oBAAA;EACA,2BAAA;EACA,wCAAA;AjGkpiCR;AiGhpiCQ;EACI,2BAAA;AjGkpiCZ;AiG/oiCQ;EACI,wBAAA;AjGipiCZ;AiG5oiCI;EACI,oBAAA;AjG8oiCR;AiG5oiCQ;EACI,2BAAA;AjG8oiCZ;AiG3oiCQ;EACI,wBAAA;AjG6oiCZ;AiGxoiCI;EACI,oBAAA;AjG0oiCR;;AiG/niCY;EACI,uCAAA;AjGkoiChB;AiG9niCY;EACI,sCAAA;AjGgoiChB;AiG5niCY;EACI,sCAAA;AjG8niChB;AiG1niCY;EACI,0CAAA;AjG4niChB;AiGxniCY;EACI,sCAAA;AjG0niChB;AiGtniCY;EACI,yBAAA;EACA,4BAAA;EACA,oBAAA;AjGwniChB;AiGtniCgB;EACI,SAAA;EACA,oBAAA;AjGwniCpB;AgBnziCI;EiF2JQ;IACI,uCAAA;EjG2piCd;EiGvpiCU;IACI,sCAAA;EjGypiCd;EiGrpiCU;IACI,sCAAA;EjGupiCd;EiGnpiCU;IACI,0CAAA;EjGqpiCd;EiGjpiCU;IACI,sCAAA;EjGmpiCd;EiG/oiCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;EjGipiCd;EiG/oiCc;IACI,SAAA;IACA,oBAAA;EjGipiClB;AACF;AgB70iCI;EiF2JQ;IACI,uCAAA;EjGqriCd;EiGjriCU;IACI,sCAAA;EjGmriCd;EiG/qiCU;IACI,sCAAA;EjGiriCd;EiG7qiCU;IACI,0CAAA;EjG+qiCd;EiG3qiCU;IACI,sCAAA;EjG6qiCd;EiGzqiCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;EjG2qiCd;EiGzqiCc;IACI,SAAA;IACA,oBAAA;EjG2qiClB;AACF;AgBv2iCI;EiF2JQ;IACI,uCAAA;EjG+siCd;EiG3siCU;IACI,sCAAA;EjG6siCd;EiGzsiCU;IACI,sCAAA;EjG2siCd;EiGvsiCU;IACI,0CAAA;EjGysiCd;EiGrsiCU;IACI,sCAAA;EjGusiCd;EiGnsiCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;EjGqsiCd;EiGnsiCc;IACI,SAAA;IACA,oBAAA;EjGqsiClB;AACF;AgBj4iCI;EiF2JQ;IACI,uCAAA;EjGyuiCd;EiGruiCU;IACI,sCAAA;EjGuuiCd;EiGnuiCU;IACI,sCAAA;EjGquiCd;EiGjuiCU;IACI,0CAAA;EjGmuiCd;EiG/tiCU;IACI,sCAAA;EjGiuiCd;EiG7tiCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;EjG+tiCd;EiG7tiCc;IACI,SAAA;IACA,oBAAA;EjG+tiClB;AACF;AgB35iCI;EiF2JQ;IACI,uCAAA;EjGmwiCd;EiG/viCU;IACI,sCAAA;EjGiwiCd;EiG7viCU;IACI,sCAAA;EjG+viCd;EiG3viCU;IACI,0CAAA;EjG6viCd;EiGzviCU;IACI,sCAAA;EjG2viCd;EiGvviCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;EjGyviCd;EiGvviCc;IACI,SAAA;IACA,oBAAA;EjGyviClB;AACF;;AiGlviCA;EACI,gCAAA;AjGqviCJ;;AiGlviCA;EACI,gCAAA;EACA,iCAAA;AjGqviCJ;;AiGlviCA;EACI,qCAAA;AjGqviCJ;;AiGlviCA;EACI,4BAAA;EACA,+BAAA;AjGqviCJ;;AiGlviCA;EACI,sBT5QgC;AxFigjCpC;;AiGlviCA;EACI,+BThRgC;ESiRhC,kCTjRgC;AxFsgjCpC;;AiGlviCA;EACI,gCTrRgC;ESsRhC,mCTtRgC;AxF2gjCpC;;AiGlviCA;EACI,+BT1RgC;ES2RhC,gCT3RgC;AxFghjCpC;;AiGlviCA;EACI,kCT/RgC;ESgShC,mCThSgC;AxFqhjCpC;;AgBl9iCI;EiFmOI;IACI,mB1Fse4B;I0Fre5B,sB1Fqe4B;EP8whCtC;AACF;AiG7uiCQ;EACI,0BAAA;AjG+uiCZ;;AmGnijCA;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AnGsijCJ;AmGnijCI;EACI,aAAA;EACA,mBAAA;EACA,oB5F+5BgC;APsohCxC;AmGnijCQ;EACI,gBAAA;AnGqijCZ;AmGlijCQ;EACI,oB5Fw5B4B;E4Fv5B5B,YAAA;AnGoijCZ;AmGjijCQ;EACI,aAAA;AnGmijCZ;AmGhijCQ;EACI,eAAA;AnGkijCZ;AmG9hjCY;EACI,aAAA;AnGgijChB;;AmGvhjCQ;EACI,YAAA;AnG0hjCZ;;AmGlhjCQ;EACI,YAAA;AnGqhjCZ;;AmG7gjCQ;EACI,aAAA;AnGghjCZ;;AoG5kjCA;EACC,oCAAA;EAGA,wBAAA;ApG6kjCD;AoG1kjCC;EACC,gBAAA;ApG4kjCF;AoGxkjCC;EACC,SAAA;EACA,gDAAA;ApG0kjCF;AoGxkjCE;EACC,iDAAA;ApG0kjCH;AoGvkjCE;EACC,6CAAA;ApGykjCH;AoGpkjCC;EACC,SAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,qBAAA;EACA,gB7FgVqB;APsviCvB;AoGlkjCC;EACC,oCAAA;ApGokjCF;AoGhkjCC;EACC,qCAAA;ApGkkjCF;AoG9jjCC;EC9CG,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,SAAA;EACA,UAAA;ArG+mjCJ;AoGpkjCC;EACC,oBAAA;EACA,mBAAA;ApGskjCF;AoGlkjCC;EACC,sCAAA;EACA,0BAAA;ApGokjCF;AoGhkjCC;EACC,oCAAA;EACA,2BAAA;ApGkkjCF;;AoG7jjCA;EACC,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,aAAA;ApGgkjCD;;AoG1jjCC;EACC,oBAAA;EACA,e7FqRe;E6FpRf,sBAAA;EACA,sBAAA;ApG6jjCF;AoGzjjCC;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mC9F6zBsC;E8F5zBtC,kC9F4zBsC;E8F3zBtC,cAAA;ApG2jjCF;AoGzjjCE;EACC,gBAAA;ApG2jjCH;AoGvjjCE;EACC,SAAA;ApGyjjCH;AoGrjjCE;EACC,kC9F+yBqC;E8F9yBrC,iC9F8yBqC;ANywhCxC;AoGnjjCE;EACC,mC9F0yBqC;E8FzyBrC,kC9FyyBqC;AN4whCxC;AoGljjCE;EACC,kBAAA;ApGojjCH;;AsG5qjCA;EACC,iBAAA;EACA,oBAAA;AtG+qjCD;AuG/ojCI;EAwBQ,+BD/CW;AtGyqjCvB;;AsGlqjCA;EACC,iBAAA;EACA,mBAAA;AtGqqjCD;AuGvpjCI;EAwBQ,gChGsgBgC;AP4niC5C;;AsGtpjCC;EC1BO,8BD2BE;ECZF,6BDcS;ECVT,iCDWK;AtGwpjCb;AuGlrjCQ;;EAEF,8BDsBS;AtG8pjCf;AuGjrjCQ;EACI,8BDkBG;AtGiqjCf;AuGvqjCI;EASQ,8BDCK;ECcL,oCDZY;ECgBZ,mDAAA;AvGgpjCZ;AuG/pjCY;;;;;;;;;EAEF,8BDJY;AtG4qjCtB;AuGrqjCY;EACI,8BDRM;AtG+qjCtB;;AsGtqjCE;EC1CM,sBD2CG;EC5BH,mCD8BU;EC1BV,uCD2BM;AtGwqjCd;AuGltjCQ;;EAEF,sBDsCU;AtG8qjChB;AuGjtjCQ;EACI,sBDkCI;AtGirjChB;AuGvsjCI;EASQ,8BDiBM;ECFN,6BDIa;ECAb,4CAAA;AvGgrjCZ;AuG/rjCY;;;;;;;;;EAEF,8BDYa;AtG4rjCvB;AuGrsjCY;EACI,8BDQO;AtG+rjCvB;;AsGtrjCC;EC3CO,6BD8CS;EC1CT,iCD2CK;AtGurjCb;AuG/tjCI;EASQ,8BDgDK;ECjCL,6BDmCY;EC/BZ,4CAAA;AvGwsjCZ;AuGvtjCY;;;;;;;;;EAEF,8BD2CY;AtGqrjCtB;AuG7tjCY;EACI,8BDuCM;AtGwrjCtB;;AuGlvjCI;EASQ,sBDgEM;ECjDN,mCDmDa;EC/Cb,kDAAA;AvG4tjCZ;AuG3ujCY;;;;;;;;;EAEF,sBD2Da;AtGyrjCvB;AuGjvjCY;EACI,sBDuDO;AtG4rjCvB;;AsGnrjCC;ECzGO,sBD0GE;EC3FF,6BD6FS;ECzFT,6BD0FK;AtGqrjCb;AuG9xjCQ;;EAEF,sBDqGS;AtG2rjCf;AuG7xjCQ;EACI,sBDiGG;AtG8rjCf;AuGnxjCI;EASQ,6BDgFK;ECjEL,6BDmEY;EC/DZ,kDAAA;AvG4vjCZ;AuG3wjCY;;;;;;;;;EAEF,6BD2EY;AtGysjCtB;AuGjxjCY;EACI,6BDuEM;AtG4sjCtB;;AsGlyjCC;EC1BO,gCD2BE;ECZF,+BDcS;ECVT,mCDWK;AtGoyjCb;AuG9zjCQ;;EAEF,gCDsBS;AtG0yjCf;AuG7zjCQ;EACI,gCDkBG;AtG6yjCf;AuGnzjCI;EASQ,gCDCK;ECcL,sCDZY;ECgBZ,qDAAA;AvG4xjCZ;AuG3yjCY;;;;;;;;;EAEF,gCDJY;AtGwzjCtB;AuGjzjCY;EACI,gCDRM;AtG2zjCtB;;AsGlzjCE;EC1CM,wBD2CG;EC5BH,qCD8BU;EC1BV,yCD2BM;AtGozjCd;AuG91jCQ;;EAEF,wBDsCU;AtG0zjChB;AuG71jCQ;EACI,wBDkCI;AtG6zjChB;AuGn1jCI;EASQ,gCDiBM;ECFN,+BDIa;ECAb,8CAAA;AvG4zjCZ;AuG30jCY;;;;;;;;;EAEF,gCDYa;AtGw0jCvB;AuGj1jCY;EACI,gCDQO;AtG20jCvB;;AsGl0jCC;EC3CO,+BD8CS;EC1CT,mCD2CK;AtGm0jCb;AuG32jCI;EASQ,gCDgDK;ECjCL,+BDmCY;EC/BZ,8CAAA;AvGo1jCZ;AuGn2jCY;;;;;;;;;EAEF,gCD2CY;AtGi0jCtB;AuGz2jCY;EACI,gCDuCM;AtGo0jCtB;;AuG93jCI;EASQ,wBDgEM;ECjDN,qCDmDa;EC/Cb,oDAAA;AvGw2jCZ;AuGv3jCY;;;;;;;;;EAEF,wBD2Da;AtGq0jCvB;AuG73jCY;EACI,wBDuDO;AtGw0jCvB;;AsG/zjCC;ECzGO,wBD0GE;EC3FF,+BD6FS;ECzFT,6BD0FK;AtGi0jCb;AuG16jCQ;;EAEF,wBDqGS;AtGu0jCf;AuGz6jCQ;EACI,wBDiGG;AtG00jCf;AuG/5jCI;EASQ,+BDgFK;ECjEL,+BDmEY;EC/DZ,oDAAA;AvGw4jCZ;AuGv5jCY;;;;;;;;;EAEF,+BD2EY;AtGq1jCtB;AuG75jCY;EACI,+BDuEM;AtGw1jCtB;;AsG96jCC;EC1BO,kCD2BE;ECZF,iCDcS;ECVT,qCDWK;AtGg7jCb;AuG18jCQ;;EAEF,kCDsBS;AtGs7jCf;AuGz8jCQ;EACI,kCDkBG;AtGy7jCf;AuG/7jCI;EASQ,kCDCK;ECcL,wCDZY;ECgBZ,uDAAA;AvGw6jCZ;AuGv7jCY;;;;;;;;;EAEF,kCDJY;AtGo8jCtB;AuG77jCY;EACI,kCDRM;AtGu8jCtB;;AsG97jCE;EC1CM,0BD2CG;EC5BH,uCD8BU;EC1BV,2CD2BM;AtGg8jCd;AuG1+jCQ;;EAEF,0BDsCU;AtGs8jChB;AuGz+jCQ;EACI,0BDkCI;AtGy8jChB;AuG/9jCI;EASQ,kCDiBM;ECFN,iCDIa;ECAb,gDAAA;AvGw8jCZ;AuGv9jCY;;;;;;;;;EAEF,kCDYa;AtGo9jCvB;AuG79jCY;EACI,kCDQO;AtGu9jCvB;;AsG98jCC;EC3CO,iCD8CS;EC1CT,qCD2CK;AtG+8jCb;AuGv/jCI;EASQ,kCDgDK;ECjCL,iCDmCY;EC/BZ,gDAAA;AvGg+jCZ;AuG/+jCY;;;;;;;;;EAEF,kCD2CY;AtG68jCtB;AuGr/jCY;EACI,kCDuCM;AtGg9jCtB;;AuG1gkCI;EASQ,0BDgEM;ECjDN,uCDmDa;EC/Cb,sDAAA;AvGo/jCZ;AuGngkCY;;;;;;;;;EAEF,0BD2Da;AtGi9jCvB;AuGzgkCY;EACI,0BDuDO;AtGo9jCvB;;AsG38jCC;ECzGO,0BD0GE;EC3FF,iCD6FS;ECzFT,6BD0FK;AtG68jCb;AuGtjkCQ;;EAEF,0BDqGS;AtGm9jCf;AuGrjkCQ;EACI,0BDiGG;AtGs9jCf;AuG3ikCI;EASQ,iCDgFK;ECjEL,iCDmEY;EC/DZ,sDAAA;AvGohkCZ;AuGnikCY;;;;;;;;;EAEF,iCD2EY;AtGi+jCtB;AuGzikCY;EACI,iCDuEM;AtGo+jCtB;;AsG1jkCC;EC1BO,gCD2BE;ECZF,+BDcS;ECVT,mCDWK;AtG4jkCb;AuGtlkCQ;;EAEF,gCDsBS;AtGkkkCf;AuGrlkCQ;EACI,gCDkBG;AtGqkkCf;AuG3kkCI;EASQ,gCDCK;ECcL,sCDZY;ECgBZ,qDAAA;AvGojkCZ;AuGnkkCY;;;;;;;;;EAEF,gCDJY;AtGglkCtB;AuGzkkCY;EACI,gCDRM;AtGmlkCtB;;AsG1kkCE;EC1CM,wBD2CG;EC5BH,qCD8BU;EC1BV,yCD2BM;AtG4kkCd;AuGtnkCQ;;EAEF,wBDsCU;AtGklkChB;AuGrnkCQ;EACI,wBDkCI;AtGqlkChB;AuG3mkCI;EASQ,gCDiBM;ECFN,+BDIa;ECAb,8CAAA;AvGolkCZ;AuGnmkCY;;;;;;;;;EAEF,gCDYa;AtGgmkCvB;AuGzmkCY;EACI,gCDQO;AtGmmkCvB;;AsG1lkCC;EC3CO,+BD8CS;EC1CT,mCD2CK;AtG2lkCb;AuGnokCI;EASQ,gCDgDK;ECjCL,+BDmCY;EC/BZ,8CAAA;AvG4mkCZ;AuG3nkCY;;;;;;;;;EAEF,gCD2CY;AtGylkCtB;AuGjokCY;EACI,gCDuCM;AtG4lkCtB;;AuGtpkCI;EASQ,wBDgEM;ECjDN,qCDmDa;EC/Cb,oDAAA;AvGgokCZ;AuG/okCY;;;;;;;;;EAEF,wBD2Da;AtG6lkCvB;AuGrpkCY;EACI,wBDuDO;AtGgmkCvB;;AsGvlkCC;ECzGO,wBD0GE;EC3FF,+BD6FS;ECzFT,6BD0FK;AtGylkCb;AuGlskCQ;;EAEF,wBDqGS;AtG+lkCf;AuGjskCQ;EACI,wBDiGG;AtGkmkCf;AuGvrkCI;EASQ,+BDgFK;ECjEL,+BDmEY;EC/DZ,oDAAA;AvGgqkCZ;AuG/qkCY;;;;;;;;;EAEF,+BD2EY;AtG6mkCtB;AuGrrkCY;EACI,+BDuEM;AtGgnkCtB;;AsGtskCC;EC1BO,6BD2BE;ECZF,4BDcS;ECVT,gCDWK;AtGwskCb;AuGlukCQ;;EAEF,6BDsBS;AtG8skCf;AuGjukCQ;EACI,6BDkBG;AtGitkCf;AuGvtkCI;EASQ,6BDCK;ECcL,mCDZY;ECgBZ,kDAAA;AvGgskCZ;AuG/skCY;;;;;;;;;EAEF,6BDJY;AtG4tkCtB;AuGrtkCY;EACI,6BDRM;AtG+tkCtB;;AsGttkCE;EC1CM,qBD2CG;EC5BH,kCD8BU;EC1BV,sCD2BM;AtGwtkCd;AuGlwkCQ;;EAEF,qBDsCU;AtG8tkChB;AuGjwkCQ;EACI,qBDkCI;AtGiukChB;AuGvvkCI;EASQ,6BDiBM;ECFN,4BDIa;ECAb,2CAAA;AvGgukCZ;AuG/ukCY;;;;;;;;;EAEF,6BDYa;AtG4ukCvB;AuGrvkCY;EACI,6BDQO;AtG+ukCvB;;AsGtukCC;EC3CO,4BD8CS;EC1CT,gCD2CK;AtGuukCb;AuG/wkCI;EASQ,6BDgDK;ECjCL,4BDmCY;EC/BZ,2CAAA;AvGwvkCZ;AuGvwkCY;;;;;;;;;EAEF,6BD2CY;AtGqukCtB;AuG7wkCY;EACI,6BDuCM;AtGwukCtB;;AuGlykCI;EASQ,qBDgEM;ECjDN,kCDmDa;EC/Cb,iDAAA;AvG4wkCZ;AuG3xkCY;;;;;;;;;EAEF,qBD2Da;AtGyukCvB;AuGjykCY;EACI,qBDuDO;AtG4ukCvB;;AsGnukCC;ECzGO,qBD0GE;EC3FF,4BD6FS;ECzFT,6BD0FK;AtGqukCb;AuG90kCQ;;EAEF,qBDqGS;AtG2ukCf;AuG70kCQ;EACI,qBDiGG;AtG8ukCf;AuGn0kCI;EASQ,4BDgFK;ECjEL,4BDmEY;EC/DZ,iDAAA;AvG4ykCZ;AuG3zkCY;;;;;;;;;EAEF,4BD2EY;AtGyvkCtB;AuGj0kCY;EACI,4BDuEM;AtG4vkCtB;;AsGl1kCC;EC1BO,gCD2BE;ECZF,+BDcS;ECVT,mCDWK;AtGo1kCb;AuG92kCQ;;EAEF,gCDsBS;AtG01kCf;AuG72kCQ;EACI,gCDkBG;AtG61kCf;AuGn2kCI;EASQ,gCDCK;ECcL,sCDZY;ECgBZ,qDAAA;AvG40kCZ;AuG31kCY;;;;;;;;;EAEF,gCDJY;AtGw2kCtB;AuGj2kCY;EACI,gCDRM;AtG22kCtB;;AsGl2kCE;EC1CM,wBD2CG;EC5BH,qCD8BU;EC1BV,yCD2BM;AtGo2kCd;AuG94kCQ;;EAEF,wBDsCU;AtG02kChB;AuG74kCQ;EACI,wBDkCI;AtG62kChB;AuGn4kCI;EASQ,gCDiBM;ECFN,+BDIa;ECAb,8CAAA;AvG42kCZ;AuG33kCY;;;;;;;;;EAEF,gCDYa;AtGw3kCvB;AuGj4kCY;EACI,gCDQO;AtG23kCvB;;AsGl3kCC;EC3CO,+BD8CS;EC1CT,mCD2CK;AtGm3kCb;AuG35kCI;EASQ,gCDgDK;ECjCL,+BDmCY;EC/BZ,8CAAA;AvGo4kCZ;AuGn5kCY;;;;;;;;;EAEF,gCD2CY;AtGi3kCtB;AuGz5kCY;EACI,gCDuCM;AtGo3kCtB;;AuG96kCI;EASQ,wBDgEM;ECjDN,qCDmDa;EC/Cb,oDAAA;AvGw5kCZ;AuGv6kCY;;;;;;;;;EAEF,wBD2Da;AtGq3kCvB;AuG76kCY;EACI,wBDuDO;AtGw3kCvB;;AsG/2kCC;ECzGO,wBD0GE;EC3FF,+BD6FS;ECzFT,6BD0FK;AtGi3kCb;AuG19kCQ;;EAEF,wBDqGS;AtGu3kCf;AuGz9kCQ;EACI,wBDiGG;AtG03kCf;AuG/8kCI;EASQ,+BDgFK;ECjEL,+BDmEY;EC/DZ,oDAAA;AvGw7kCZ;AuGv8kCY;;;;;;;;;EAEF,+BD2EY;AtGq4kCtB;AuG78kCY;EACI,+BDuEM;AtGw4kCtB;;AsG99kCC;EC1BO,+BD2BE;ECZF,8BDcS;ECVT,kCDWK;AtGg+kCb;AuG1/kCQ;;EAEF,+BDsBS;AtGs+kCf;AuGz/kCQ;EACI,+BDkBG;AtGy+kCf;AuG/+kCI;EASQ,+BDCK;ECcL,qCDZY;ECgBZ,oDAAA;AvGw9kCZ;AuGv+kCY;;;;;;;;;EAEF,+BDJY;AtGo/kCtB;AuG7+kCY;EACI,+BDRM;AtGu/kCtB;;AsG9+kCE;EC1CM,uBD2CG;EC5BH,oCD8BU;EC1BV,wCD2BM;AtGg/kCd;AuG1hlCQ;;EAEF,uBDsCU;AtGs/kChB;AuGzhlCQ;EACI,uBDkCI;AtGy/kChB;AuG/glCI;EASQ,+BDiBM;ECFN,8BDIa;ECAb,6CAAA;AvGw/kCZ;AuGvglCY;;;;;;;;;EAEF,+BDYa;AtGoglCvB;AuG7glCY;EACI,+BDQO;AtGuglCvB;;AsG9/kCC;EC3CO,8BD8CS;EC1CT,kCD2CK;AtG+/kCb;AuGvilCI;EASQ,+BDgDK;ECjCL,8BDmCY;EC/BZ,6CAAA;AvGghlCZ;AuG/hlCY;;;;;;;;;EAEF,+BD2CY;AtG6/kCtB;AuGrilCY;EACI,+BDuCM;AtGgglCtB;;AuG1jlCI;EASQ,uBDgEM;ECjDN,oCDmDa;EC/Cb,mDAAA;AvGoilCZ;AuGnjlCY;;;;;;;;;EAEF,uBD2Da;AtGiglCvB;AuGzjlCY;EACI,uBDuDO;AtGoglCvB;;AsG3/kCC;ECzGO,uBD0GE;EC3FF,8BD6FS;ECzFT,6BD0FK;AtG6/kCb;AuGtmlCQ;;EAEF,uBDqGS;AtGmglCf;AuGrmlCQ;EACI,uBDiGG;AtGsglCf;AuG3llCI;EASQ,8BDgFK;ECjEL,8BDmEY;EC/DZ,mDAAA;AvGoklCZ;AuGnllCY;;;;;;;;;EAEF,8BD2EY;AtGihlCtB;AuGzllCY;EACI,8BDuEM;AtGohlCtB;;AsG1mlCC;EC1BO,6BD2BE;ECZF,4BDcS;ECVT,gCDWK;AtG4mlCb;AuGtolCQ;;EAEF,6BDsBS;AtGknlCf;AuGrolCQ;EACI,6BDkBG;AtGqnlCf;AuG3nlCI;EASQ,6BDCK;ECcL,mCDZY;ECgBZ,kDAAA;AvGomlCZ;AuGnnlCY;;;;;;;;;EAEF,6BDJY;AtGgolCtB;AuGznlCY;EACI,6BDRM;AtGmolCtB;;AsG1nlCE;EC1CM,qBD2CG;EC5BH,kCD8BU;EC1BV,sCD2BM;AtG4nlCd;AuGtqlCQ;;EAEF,qBDsCU;AtGkolChB;AuGrqlCQ;EACI,qBDkCI;AtGqolChB;AuG3plCI;EASQ,6BDiBM;ECFN,4BDIa;ECAb,2CAAA;AvGoolCZ;AuGnplCY;;;;;;;;;EAEF,6BDYa;AtGgplCvB;AuGzplCY;EACI,6BDQO;AtGmplCvB;;AsG1olCC;EC3CO,4BD8CS;EC1CT,gCD2CK;AtG2olCb;AuGnrlCI;EASQ,6BDgDK;ECjCL,4BDmCY;EC/BZ,2CAAA;AvG4plCZ;AuG3qlCY;;;;;;;;;EAEF,6BD2CY;AtGyolCtB;AuGjrlCY;EACI,6BDuCM;AtG4olCtB;;AuGtslCI;EASQ,qBDgEM;ECjDN,kCDmDa;EC/Cb,iDAAA;AvGgrlCZ;AuG/rlCY;;;;;;;;;EAEF,qBD2Da;AtG6olCvB;AuGrslCY;EACI,qBDuDO;AtGgplCvB;;AsGvolCC;ECzGO,qBD0GE;EC3FF,4BD6FS;ECzFT,6BD0FK;AtGyolCb;AuGlvlCQ;;EAEF,qBDqGS;AtG+olCf;AuGjvlCQ;EACI,qBDiGG;AtGkplCf;AuGvulCI;EASQ,4BDgFK;ECjEL,4BDmEY;EC/DZ,iDAAA;AvGgtlCZ;AuG/tlCY;;;;;;;;;EAEF,4BD2EY;AtG6plCtB;AuGrulCY;EACI,4BDuEM;AtGgqlCtB;;AsGrplCC;EC3HO,2BD4HE;AtGwplCV;AuGhxlCQ;;EAEF,2BDuHS;AtG2plCf;AuG/wlCQ;EACI,2BDmHG;AtG8plCf;AuGrwlCI;EASQ,2BDiHK;AtG8olCjB;AuG3vlCY;;;;;;;;;EAEF,2BD4GY;AtGwplCtB;AuGjwlCY;EACI,2BDwGM;AtG2plCtB;;AuGxylCQ;;EAEF,2BDqJS;AtGsplCf;AuGxylCQ;EACI,2BDiJG;AtGyplCf;AuGjxlCY;;;;;;;;;EAEF,2BD0IY;AtGgplCtB;AuGvxlCY;EACI,2BDsIM;AtGmplCtB;;AsG3olCC;ECvLO,2BDwLE;AtG8olCV;AuGhzlCI;EASQ,2BD6KK;AtG6nlCjB;;AsG9slCC;EC3HO,6BD4HE;AtGitlCV;AuGz0lCQ;;EAEF,6BDuHS;AtGotlCf;AuGx0lCQ;EACI,6BDmHG;AtGutlCf;AuG9zlCI;EASQ,6BDiHK;AtGuslCjB;AuGpzlCY;;;;;;;;;EAEF,6BD4GY;AtGitlCtB;AuG1zlCY;EACI,6BDwGM;AtGotlCtB;;AuGj2lCQ;;EAEF,6BDqJS;AtG+slCf;AuGj2lCQ;EACI,6BDiJG;AtGktlCf;AuG10lCY;;;;;;;;;EAEF,6BD0IY;AtGyslCtB;AuGh1lCY;EACI,6BDsIM;AtG4slCtB;;AsGpslCC;ECvLO,6BDwLE;AtGuslCV;AuGz2lCI;EASQ,6BD6KK;AtGsrlCjB;;AsGvwlCC;EC3HO,+BD4HE;AtG0wlCV;AuGl4lCQ;;EAEF,+BDuHS;AtG6wlCf;AuGj4lCQ;EACI,+BDmHG;AtGgxlCf;AuGv3lCI;EASQ,+BDiHK;AtGgwlCjB;AuG72lCY;;;;;;;;;EAEF,+BD4GY;AtG0wlCtB;AuGn3lCY;EACI,+BDwGM;AtG6wlCtB;;AuG15lCQ;;EAEF,+BDqJS;AtGwwlCf;AuG15lCQ;EACI,+BDiJG;AtG2wlCf;AuGn4lCY;;;;;;;;;EAEF,+BD0IY;AtGkwlCtB;AuGz4lCY;EACI,+BDsIM;AtGqwlCtB;;AsG7vlCC;ECvLO,+BDwLE;AtGgwlCV;AuGl6lCI;EASQ,+BD6KK;AtG+ulCjB;;AsGh0lCC;EC3HO,2BD4HE;AtGm0lCV;AuG37lCQ;;EAEF,2BDuHS;AtGs0lCf;AuG17lCQ;EACI,2BDmHG;AtGy0lCf;AuGh7lCI;EASQ,2BDiHK;AtGyzlCjB;AuGt6lCY;;;;;;;;;EAEF,2BD4GY;AtGm0lCtB;AuG56lCY;EACI,2BDwGM;AtGs0lCtB;;AuGn9lCQ;;EAEF,2BDqJS;AtGi0lCf;AuGn9lCQ;EACI,2BDiJG;AtGo0lCf;AuG57lCY;;;;;;;;;EAEF,2BD0IY;AtG2zlCtB;AuGl8lCY;EACI,2BDsIM;AtG8zlCtB;;AsGtzlCC;ECvLO,2BDwLE;AtGyzlCV;AuG39lCI;EASQ,2BD6KK;AtGwylCjB;;AsGz3lCC;EC3HO,6BD4HE;AtG43lCV;AuGp/lCQ;;EAEF,6BDuHS;AtG+3lCf;AuGn/lCQ;EACI,6BDmHG;AtGk4lCf;AuGz+lCI;EASQ,6BDiHK;AtGk3lCjB;AuG/9lCY;;;;;;;;;EAEF,6BD4GY;AtG43lCtB;AuGr+lCY;EACI,6BDwGM;AtG+3lCtB;;AuG5gmCQ;;EAEF,6BDqJS;AtG03lCf;AuG5gmCQ;EACI,6BDiJG;AtG63lCf;AuGr/lCY;;;;;;;;;EAEF,6BD0IY;AtGo3lCtB;AuG3/lCY;EACI,6BDsIM;AtGu3lCtB;;AsG/2lCC;ECvLO,6BDwLE;AtGk3lCV;AuGphmCI;EASQ,6BD6KK;AtGi2lCjB;;AsGl7lCC;EC3HO,0BD4HE;AtGq7lCV;AuG7imCQ;;EAEF,0BDuHS;AtGw7lCf;AuG5imCQ;EACI,0BDmHG;AtG27lCf;AuGlimCI;EASQ,0BDiHK;AtG26lCjB;AuGxhmCY;;;;;;;;;EAEF,0BD4GY;AtGq7lCtB;AuG9hmCY;EACI,0BDwGM;AtGw7lCtB;;AuGrkmCQ;;EAEF,0BDqJS;AtGm7lCf;AuGrkmCQ;EACI,0BDiJG;AtGs7lCf;AuG9imCY;;;;;;;;;EAEF,0BD0IY;AtG66lCtB;AuGpjmCY;EACI,0BDsIM;AtGg7lCtB;;AsGx6lCC;ECvLO,0BDwLE;AtG26lCV;AuG7kmCI;EASQ,0BD6KK;AtG05lCjB;;AsG3+lCC;EC3HO,6BD4HE;AtG8+lCV;AuGtmmCQ;;EAEF,6BDuHS;AtGi/lCf;AuGrmmCQ;EACI,6BDmHG;AtGo/lCf;AuG3lmCI;EASQ,6BDiHK;AtGo+lCjB;AuGjlmCY;;;;;;;;;EAEF,6BD4GY;AtG8+lCtB;AuGvlmCY;EACI,6BDwGM;AtGi/lCtB;;AuG9nmCQ;;EAEF,6BDqJS;AtG4+lCf;AuG9nmCQ;EACI,6BDiJG;AtG++lCf;AuGvmmCY;;;;;;;;;EAEF,6BD0IY;AtGs+lCtB;AuG7mmCY;EACI,6BDsIM;AtGy+lCtB;;AsGj+lCC;ECvLO,6BDwLE;AtGo+lCV;AuGtomCI;EASQ,6BD6KK;AtGm9lCjB;;AsGpimCC;EC3HO,4BD4HE;AtGuimCV;AuG/pmCQ;;EAEF,4BDuHS;AtG0imCf;AuG9pmCQ;EACI,4BDmHG;AtG6imCf;AuGppmCI;EASQ,4BDiHK;AtG6hmCjB;AuG1omCY;;;;;;;;;EAEF,4BD4GY;AtGuimCtB;AuGhpmCY;EACI,4BDwGM;AtG0imCtB;;AuGvrmCQ;;EAEF,4BDqJS;AtGqimCf;AuGvrmCQ;EACI,4BDiJG;AtGwimCf;AuGhqmCY;;;;;;;;;EAEF,4BD0IY;AtG+hmCtB;AuGtqmCY;EACI,4BDsIM;AtGkimCtB;;AsG1hmCC;ECvLO,4BDwLE;AtG6hmCV;AuG/rmCI;EASQ,4BD6KK;AtG4gmCjB;;AsG7lmCC;EC3HO,0BD4HE;AtGgmmCV;AuGxtmCQ;;EAEF,0BDuHS;AtGmmmCf;AuGvtmCQ;EACI,0BDmHG;AtGsmmCf;AuG7smCI;EASQ,0BDiHK;AtGslmCjB;AuGnsmCY;;;;;;;;;EAEF,0BD4GY;AtGgmmCtB;AuGzsmCY;EACI,0BDwGM;AtGmmmCtB;;AuGhvmCQ;;EAEF,0BDqJS;AtG8lmCf;AuGhvmCQ;EACI,0BDiJG;AtGimmCf;AuGztmCY;;;;;;;;;EAEF,0BD0IY;AtGwlmCtB;AuG/tmCY;EACI,0BDsIM;AtG2lmCtB;;AsGnlmCC;ECvLO,0BDwLE;AtGslmCV;AuGxvmCI;EASQ,0BD6KK;AtGqkmCjB;;AsGtpmCC;EC3HO,2BD4HE;AtGypmCV;AuGjxmCQ;;EAEF,2BDuHS;AtG4pmCf;AuGhxmCQ;EACI,2BDmHG;AtG+pmCf;AuGtwmCI;EASQ,2BDiHK;AtG+omCjB;AuG5vmCY;;;;;;;;;EAEF,2BD4GY;AtGypmCtB;AuGlwmCY;EACI,2BDwGM;AtG4pmCtB;;AuGzymCQ;;EAEF,2BDqJS;AtGupmCf;AuGzymCQ;EACI,2BDiJG;AtG0pmCf;AuGlxmCY;;;;;;;;;EAEF,2BD0IY;AtGipmCtB;AuGxxmCY;EACI,2BDsIM;AtGopmCtB;;AsG5omCC;ECvLO,2BDwLE;AtG+omCV;AuGjzmCI;EASQ,2BD6KK;AtG8nmCjB;;AsG/smCC;EC3HO,8BD4HE;AtGktmCV;AuG10mCQ;;EAEF,8BDuHS;AtGqtmCf;AuGz0mCQ;EACI,8BDmHG;AtGwtmCf;AuG/zmCI;EASQ,8BDiHK;AtGwsmCjB;AuGrzmCY;;;;;;;;;EAEF,8BD4GY;AtGktmCtB;AuG3zmCY;EACI,8BDwGM;AtGqtmCtB;;AuGl2mCQ;;EAEF,8BDqJS;AtGgtmCf;AuGl2mCQ;EACI,8BDiJG;AtGmtmCf;AuG30mCY;;;;;;;;;EAEF,8BD0IY;AtG0smCtB;AuGj1mCY;EACI,8BDsIM;AtG6smCtB;;AsGrsmCC;ECvLO,8BDwLE;AtGwsmCV;AuG12mCI;EASQ,8BD6KK;AtGurmCjB;;AsGxwmCC;EC3HO,8BD4HE;AtG2wmCV;AuGn4mCQ;;EAEF,8BDuHS;AtG8wmCf;AuGl4mCQ;EACI,8BDmHG;AtGixmCf;AuGx3mCI;EASQ,8BDiHK;AtGiwmCjB;AuG92mCY;;;;;;;;;EAEF,8BD4GY;AtG2wmCtB;AuGp3mCY;EACI,8BDwGM;AtG8wmCtB;;AuG35mCQ;;EAEF,8BDqJS;AtGywmCf;AuG35mCQ;EACI,8BDiJG;AtG4wmCf;AuGp4mCY;;;;;;;;;EAEF,8BD0IY;AtGmwmCtB;AuG14mCY;EACI,8BDsIM;AtGswmCtB;;AsG9vmCC;ECvLO,8BDwLE;AtGiwmCV;AuGn6mCI;EASQ,8BD6KK;AtGgvmCjB;;AsGj0mCC;EC3HO,8BD4HE;AtGo0mCV;AuG57mCQ;;EAEF,8BDuHS;AtGu0mCf;AuG37mCQ;EACI,8BDmHG;AtG00mCf;AuGj7mCI;EASQ,8BDiHK;AtG0zmCjB;AuGv6mCY;;;;;;;;;EAEF,8BD4GY;AtGo0mCtB;AuG76mCY;EACI,8BDwGM;AtGu0mCtB;;AuGp9mCQ;;EAEF,8BDqJS;AtGk0mCf;AuGp9mCQ;EACI,8BDiJG;AtGq0mCf;AuG77mCY;;;;;;;;;EAEF,8BD0IY;AtG4zmCtB;AuGn8mCY;EACI,8BDsIM;AtG+zmCtB;;AsGvzmCC;ECvLO,8BDwLE;AtG0zmCV;AuG59mCI;EASQ,8BD6KK;AtGyymCjB;;AsG13mCC;EC3HO,8BD4HE;AtG63mCV;AuGr/mCQ;;EAEF,8BDuHS;AtGg4mCf;AuGp/mCQ;EACI,8BDmHG;AtGm4mCf;AuG1+mCI;EASQ,8BDiHK;AtGm3mCjB;AuGh+mCY;;;;;;;;;EAEF,8BD4GY;AtG63mCtB;AuGt+mCY;EACI,8BDwGM;AtGg4mCtB;;AuG7gnCQ;;EAEF,8BDqJS;AtG23mCf;AuG7gnCQ;EACI,8BDiJG;AtG83mCf;AuGt/mCY;;;;;;;;;EAEF,8BD0IY;AtGq3mCtB;AuG5/mCY;EACI,8BDsIM;AtGw3mCtB;;AsGh3mCC;ECvLO,8BDwLE;AtGm3mCV;AuGrhnCI;EASQ,8BD6KK;AtGk2mCjB;;AsGn7mCC;EC3HO,8BD4HE;AtGs7mCV;AuG9inCQ;;EAEF,8BDuHS;AtGy7mCf;AuG7inCQ;EACI,8BDmHG;AtG47mCf;AuGninCI;EASQ,8BDiHK;AtG46mCjB;AuGzhnCY;;;;;;;;;EAEF,8BD4GY;AtGs7mCtB;AuG/hnCY;EACI,8BDwGM;AtGy7mCtB;;AuGtknCQ;;EAEF,8BDqJS;AtGo7mCf;AuGtknCQ;EACI,8BDiJG;AtGu7mCf;AuG/inCY;;;;;;;;;EAEF,8BD0IY;AtG86mCtB;AuGrjnCY;EACI,8BDsIM;AtGi7mCtB;;AsGz6mCC;ECvLO,8BDwLE;AtG46mCV;AuG9knCI;EASQ,8BD6KK;AtG25mCjB;;AsG5+mCC;EC3HO,8BD4HE;AtG++mCV;AuGvmnCQ;;EAEF,8BDuHS;AtGk/mCf;AuGtmnCQ;EACI,8BDmHG;AtGq/mCf;AuG5lnCI;EASQ,8BDiHK;AtGq+mCjB;AuGllnCY;;;;;;;;;EAEF,8BD4GY;AtG++mCtB;AuGxlnCY;EACI,8BDwGM;AtGk/mCtB;;AuG/nnCQ;;EAEF,8BDqJS;AtG6+mCf;AuG/nnCQ;EACI,8BDiJG;AtGg/mCf;AuGxmnCY;;;;;;;;;EAEF,8BD0IY;AtGu+mCtB;AuG9mnCY;EACI,8BDsIM;AtG0+mCtB;;AsGl+mCC;ECvLO,8BDwLE;AtGq+mCV;AuGvonCI;EASQ,8BD6KK;AtGo9mCjB;;AsGrinCC;EC3HO,8BD4HE;AtGwinCV;AuGhqnCQ;;EAEF,8BDuHS;AtG2inCf;AuG/pnCQ;EACI,8BDmHG;AtG8inCf;AuGrpnCI;EASQ,8BDiHK;AtG8hnCjB;AuG3onCY;;;;;;;;;EAEF,8BD4GY;AtGwinCtB;AuGjpnCY;EACI,8BDwGM;AtG2inCtB;;AuGxrnCQ;;EAEF,8BDqJS;AtGsinCf;AuGxrnCQ;EACI,8BDiJG;AtGyinCf;AuGjqnCY;;;;;;;;;EAEF,8BD0IY;AtGginCtB;AuGvqnCY;EACI,8BDsIM;AtGminCtB;;AsG3hnCC;ECvLO,8BDwLE;AtG8hnCV;AuGhsnCI;EASQ,8BD6KK;AtG6gnCjB;;AsG9lnCC;EC3HO,8BD4HE;AtGimnCV;AuGztnCQ;;EAEF,8BDuHS;AtGomnCf;AuGxtnCQ;EACI,8BDmHG;AtGumnCf;AuG9snCI;EASQ,8BDiHK;AtGulnCjB;AuGpsnCY;;;;;;;;;EAEF,8BD4GY;AtGimnCtB;AuG1snCY;EACI,8BDwGM;AtGomnCtB;;AuGjvnCQ;;EAEF,8BDqJS;AtG+lnCf;AuGjvnCQ;EACI,8BDiJG;AtGkmnCf;AuG1tnCY;;;;;;;;;EAEF,8BD0IY;AtGylnCtB;AuGhunCY;EACI,8BDsIM;AtG4lnCtB;;AsGplnCC;ECvLO,8BDwLE;AtGulnCV;AuGzvnCI;EASQ,8BD6KK;AtGsknCjB;;AsGvpnCC;EC3HO,8BD4HE;AtG0pnCV;AuGlxnCQ;;EAEF,8BDuHS;AtG6pnCf;AuGjxnCQ;EACI,8BDmHG;AtGgqnCf;AuGvwnCI;EASQ,8BDiHK;AtGgpnCjB;AuG7vnCY;;;;;;;;;EAEF,8BD4GY;AtG0pnCtB;AuGnwnCY;EACI,8BDwGM;AtG6pnCtB;;AuG1ynCQ;;EAEF,8BDqJS;AtGwpnCf;AuG1ynCQ;EACI,8BDiJG;AtG2pnCf;AuGnxnCY;;;;;;;;;EAEF,8BD0IY;AtGkpnCtB;AuGzxnCY;EACI,8BDsIM;AtGqpnCtB;;AsG7onCC;ECvLO,8BDwLE;AtGgpnCV;AuGlznCI;EASQ,8BD6KK;AtG+nnCjB;;AsGnnnCC;ECxNO,cDyNE;EC1MF,qBD4MS;ECxMT,yBDyMK;AtGqnnCb;AuG70nCQ;;EAEF,cDoNS;AtG2nnCf;AuG50nCQ;EACI,cDgNG;AtG8nnCf;AuGl0nCI;EAwBQ,qBDkLY;EC9KZ,oCAAA;AvG0ynCZ;;AsGrnnCC;ECvOO,cDwOE;ECzNF,oCD4NS;ECxNT,wCDuNK;AtGwnnCb;AuG91nCQ;;EAEF,cDmOS;AtG6nnCf;AuG71nCQ;EACI,cD+NG;AtGgonCf;AuGn1nCI;EASQ,cD8MK;EC/LL,qBDkMY;EC9LZ,oCAAA;AvG4znCZ;AuG30nCY;;;;;;;;;EAEF,cDyMY;AtG2onCtB;AuGj1nCY;EACI,cDqMM;AtG8onCtB;;AsGpqnCC;ECxNO,cDyNE;EC1MF,qBD4MS;ECxMT,yBDyMK;AtGsqnCb;AuG93nCQ;;EAEF,cDoNS;AtG4qnCf;AuG73nCQ;EACI,cDgNG;AtG+qnCf;AuGn3nCI;EAwBQ,qBDkLY;EC9KZ,oCAAA;AvG21nCZ;;AsGtqnCC;ECvOO,cDwOE;ECzNF,oCD4NS;ECxNT,wCDuNK;AtGyqnCb;AuG/4nCQ;;EAEF,cDmOS;AtG8qnCf;AuG94nCQ;EACI,cD+NG;AtGirnCf;AuGp4nCI;EASQ,cD8MK;EC/LL,qBDkMY;EC9LZ,oCAAA;AvG62nCZ;AuG53nCY;;;;;;;;;EAEF,cDyMY;AtG4rnCtB;AuGl4nCY;EACI,cDqMM;AtG+rnCtB;;AsGrtnCC;ECxNO,cDyNE;EC1MF,qBD4MS;ECxMT,yBDyMK;AtGutnCb;AuG/6nCQ;;EAEF,cDoNS;AtG6tnCf;AuG96nCQ;EACI,cDgNG;AtGgunCf;AuGp6nCI;EAwBQ,qBDkLY;EC9KZ,oCAAA;AvG44nCZ;;AsGvtnCC;ECvOO,cDwOE;ECzNF,qCD4NS;ECxNT,yCDuNK;AtG0tnCb;AuGh8nCQ;;EAEF,cDmOS;AtG+tnCf;AuG/7nCQ;EACI,cD+NG;AtGkunCf;AuGr7nCI;EASQ,cD8MK;EC/LL,qBDkMY;EC9LZ,oCAAA;AvG85nCZ;AuG76nCY;;;;;;;;;EAEF,cDyMY;AtG6unCtB;AuGn7nCY;EACI,cDqMM;AtGgvnCtB;;AsGtwnCC;ECxNO,cDyNE;EC1MF,qBD4MS;ECxMT,yBDyMK;AtGwwnCb;AuGh+nCQ;;EAEF,cDoNS;AtG8wnCf;AuG/9nCQ;EACI,cDgNG;AtGixnCf;AuGr9nCI;EAwBQ,qBDkLY;EC9KZ,oCAAA;AvG67nCZ;;AsGxwnCC;ECvOO,cDwOE;ECzNF,qCD4NS;ECxNT,yCDuNK;AtG2wnCb;AuGj/nCQ;;EAEF,cDmOS;AtGgxnCf;AuGh/nCQ;EACI,cD+NG;AtGmxnCf;AuGt+nCI;EASQ,cD8MK;EC/LL,qBDkMY;EC9LZ,oCAAA;AvG+8nCZ;AuG99nCY;;;;;;;;;EAEF,cDyMY;AtG8xnCtB;AuGp+nCY;EACI,cDqMM;AtGiynCtB;;AsGvznCC;ECxNO,cDyNE;EC1MF,qBD4MS;ECxMT,yBDyMK;AtGyznCb;AuGjhoCQ;;EAEF,cDoNS;AtG+znCf;AuGhhoCQ;EACI,cDgNG;AtGk0nCf;AuGtgoCI;EAwBQ,qBDkLY;EC9KZ,oCAAA;AvG8+nCZ;;AsGzznCC;ECvOO,cDwOE;ECzNF,kCD4NS;ECxNT,sCDuNK;AtG4znCb;AuGlioCQ;;EAEF,cDmOS;AtGi0nCf;AuGjioCQ;EACI,cD+NG;AtGo0nCf;AuGvhoCI;EASQ,cD8MK;EC/LL,qBDkMY;EC9LZ,oCAAA;AvGggoCZ;AuG/goCY;;;;;;;;;EAEF,cDyMY;AtG+0nCtB;AuGrhoCY;EACI,cDqMM;AtGk1nCtB;;AsGx2nCC;ECxNO,cDyNE;EC1MF,qBD4MS;ECxMT,yBDyMK;AtG02nCb;AuGlkoCQ;;EAEF,cDoNS;AtGg3nCf;AuGjkoCQ;EACI,cDgNG;AtGm3nCf;AuGvjoCI;EAwBQ,qBDkLY;EC9KZ,oCAAA;AvG+hoCZ;;AsG12nCC;ECvOO,cDwOE;ECzNF,oCD4NS;ECxNT,wCDuNK;AtG62nCb;AuGnloCQ;;EAEF,cDmOS;AtGk3nCf;AuGlloCQ;EACI,cD+NG;AtGq3nCf;AuGxkoCI;EASQ,cD8MK;EC/LL,qBDkMY;EC9LZ,oCAAA;AvGijoCZ;AuGhkoCY;;;;;;;;;EAEF,cDyMY;AtGg4nCtB;AuGtkoCY;EACI,cDqMM;AtGm4nCtB;;AsG13nCC;ECvPO,cCHS;EDsBT,yBC1BS;AxG6noCjB;AuGlnoCQ;;EAEF,cCTW;AxG6noCjB;AuGjnoCQ;EACI,cCbK;AxGgooCjB;AuGvmoCI;EASQ,cD8NM;EC3MN,oCAAA;AvG+koCZ;AuG9loCY;;;;;;;;;EAEF,cDyNa;AtG84nCvB;AuGpmoCY;EACI,cDqNO;AtGi5nCvB;;AyG5poCA;EACC,iCAAA;AzG+poCD;;A0GhqoCA;EACI,gBnG+8BwB;EmG98BxB,2BAAA;EACA,6CAAA;EACA,mCAAA;ElGWA,qBAAA;EkGTA,oBAAA;EACA,enGw8BgB;EmGv8BhB,sBnGq8BwB;EmGp8BxB,gBnGq8BwB;EmGp8BxB,2CnGg8Ba;APmumCjB;A0GhqoCQ;EACI,sBAAA;EACA,uCAAA;EACA,iCAAA;A1GkqoCZ;A0GrqoCQ;EACI,wBAAA;EACA,yCAAA;EACA,mCAAA;A1GuqoCZ;A0G1qoCQ;EACI,0BAAA;EACA,2CAAA;EACA,qCAAA;A1G4qoCZ;A0G/qoCQ;EACI,wBAAA;EACA,yCAAA;EACA,mCAAA;A1GiroCZ;A0GproCQ;EACI,qBAAA;EACA,sCAAA;EACA,gCAAA;A1GsroCZ;A0GzroCQ;EACI,wBAAA;EACA,yCAAA;EACA,mCAAA;A1G2roCZ;A0G9roCQ;EACI,uBAAA;EACA,wCAAA;EACA,kCAAA;A1GgsoCZ;A0GnsoCQ;EACI,qBAAA;EACA,sCAAA;EACA,gCAAA;A1GqsoCZ;;A2GptoCA;ExG0RM,kBALI;AHm8nCV;;A4GttoCC;EACC,6BAAA;EACA,yBAAA;A5GytoCF;A4GvtoCE;EAKC,6BAAA;EACA,yBAAA;A5GqtoCH;A4GhtoCC;EPLA,SAAA;EACA,6BAAA;EACG,wBAAA;EACH,gBAAA;EACG,gBAAA;ArGwtoCJ;;A4GjtoCA;EACC,oCrG+jB2C;EqG9jB3C,gCrG8jB2C;EqG7jB3C,yBrG4jBwC;EqG1jBxC,2BrG4SkB;APu6nCnB;A6G9uoCI;EACI,yBtGulBoC;APypnC5C;A6G5uoCI;EACI,yBtGklBoC;EsGjlBpC,UAAA;A7G8uoCR;A4GxtoCC;EAKC,oCrGqjB0C;EqGpjB1C,gCrGojB0C;EqGnjB1C,yBrGijBuC;EqGhjBvC,2BrGkSiB;APo7nCnB;;A4GjtoCA;EACC,oCrG2iB2C;APyqnC5C;;A4GhtoCA;EACG,yBrGgiByC;APmrnC5C;;A6GnwoCI;EACI,yBDoDc;A5GktoCtB;;A6GvwoCI;EACI,ctGaA;APiwoCR;A6G1woCI;EACI,ctGQA;EsGPA,UAAA;A7G4woCR;;A4GttoCA;EACC,YAAA;A5GytoCD;;A8GvxoCQ;EACI,kBAAA;A9G0xoCZ;A8GnxoCQ;;;EACI,wCAAA;A9GuxoCZ;;A+GjyoCA;EACC,gBAAA;A/GoyoCD;A+GjyoCC;EACC,gCxGkkB0C;EM9jBtC,0EARW;AbwyoCjB;A+G3xoCC;EACC,yBxG6jB0C;EwG5jB1C,oCxGwpBkD;EwGvpBlD,gCxG+iB0C;AP8unC5C;A+GzxoCC;EACC,qCAAA;A/G2xoCF;A+GvxoCC;EAEC,oCxG2jB0C;EwG1jB1C,gCxG0jB0C;EwGzjB1C,yBxGwjBuC;EwGvjBvC,2BxGySiB;AP++nCnB;A6GtzoCI;EACI,yBtGulBoC;APiunC5C;A6GpzoCI;EACI,yBtGklBoC;EsGjlBpC,UAAA;A7GszoCR;A+G7xoCE;EAKC,oCxGkjByC;EwGjjBzC,2CAAA;EACA,yBxG8iBsC;EwG7iBtC,2BxG+RgB;AP4/nCnB;A+GtxoCC;EAEC,6BAAA;EACA,yBAAA;EACA,yBxG6gB0C;AP0wnC5C;A6Gx0oCI;EACI,yBtG8kBoC;AP4vnC5C;A6Gt0oCI;EACI,yBtGykBoC;EsGxkBpC,UAAA;A7Gw0oCR;A+G5xoCE;EAKC,6BAAA;EACA,oCAAA;EACA,yBxGogByC;APsxnC5C;;AgHj1oCY;EACI,wBzG2lB4B;APyvnC5C;AgH70oCQ;EACI,ezGilBgC;EyGhlBhC,czGglBgC;AP+vnC5C;AgH10oCQ;EACI,ezG2kBgC;EyG1kBhC,czG0kBgC;APkwnC5C;AgHv0oCI;EACI,qBAAA;EACA,kB1Gy6B0B;ANg6mClC;AgHp0oCQ;EACI,SAAA;AhHs0oCZ;AgHp0oCY;EACI,oCzGykB4B;AP6vnC5C;AgHn0oCY;EACI,yBzGMD;AP+zoCf;AgH5zoCY;EACI,mCAAA;AhH8zoChB;AgHtzoCY;EACI,kCAAA;AhHwzoChB;AgHhzoCY;EACI,mCAAA;AhHkzoChB;;AgH3yoCA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AhH8yoCJ;AgH3yoCI;EACI,SAAA;EACA,WAAA;EACA,cAAA;AhH6yoCR;AgHzyoCI;EACI,oBAAA;AhH2yoCR;;AgHpyoCQ;EACI,ezGuiBwC;APgwnCpD;AgHnyoCY;EACI,czGoiBoC;EyGniBpC,azGkiBoC;APmwnCpD;AgHhyoCY;EACI,ezG+hBoC;EyG9hBpC,czG6hBoC;APqwnCpD;AgH3xoCQ;EACI,4DAAA;AhH6xoCZ;AgH3xoCY;EACI,oCzGmf4B;AP0ynC5C;;AgHpxoCY;EACI,4DAAA;AhHuxoChB;;AgHhxoCA;EACI,kBAAA;EACA,gBAAA;AhHmxoCJ;AgHjxoCI;EACI,eAAA;AhHmxoCR;AgHhxoCI;ExGtIA,sBAAA;EwGwII,6BAAA;EACA,gC1GyasB;E0GxatB,eAAA;EACA,gBAAA;EACA,sBAAA;AhHkxoCR;AgH/woCI;ExG/IA,sBAAA;ARi6oCJ;AgH9woCI;EACI,gBzG+MW;EyG9MX,mBAAA;AhHgxoCR;AgH5woCQ;EACI,0CAAA;AhH8woCZ;AgHzwoCQ;EACI,0CAAA;AhH2woCZ;AgHtwoCQ;EACI,yCAAA;AhHwwoCZ;AgHpwoCI;EACI,azGqWoC;APi6nC5C;;AiH97oCI;EzGaA,sBAAA;ARq7oCJ;AiH/7oCQ;EzGUJ,qBAAA;ARw7oCJ;AiH97oCQ;EzGMJ,sBAAA;AR27oCJ;AiH77oCQ;EACI,oC1G0kBgC;E0GzkBtC,gC1GykBsC;APs3nC5C;AiH77oCY;EACI,qC1G+iB4B;APg5nC5C;AiH37oCQ;EACI,oC1GikBgC;E0GhkBtC,gC1GgkBsC;AP63nC5C;AiH37oCY;EACI,qC1GsiB4B;APu5nC5C;;A8Gt9oCQ;EACI,kBAAA;A9Gy9oCZ;A8Gl9oCQ;;;EACI,wCAAA;A9Gs9oCZ;;AkHh+oCI;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gB3G2WW;APwnoCnB;;AmHz+oCA;EACI,aAAA;EACA,oBAAA;EACA,8BAAA;AnH4+oCJ;AmH1+oCI;EACI,YAAA;E3GQJ,sBAAA;E2GNI,aAAA;EACA,qBAAA;EACA,kBAAA;AnH4+oCR;AmH1+oCQ;EACI,eAAA;AnH4+oCZ;AmHz+oCQ;EACI,UAAA;E3GHR,sBAAA;AR++oCJ;;AoH3/oCC;EACI,yBAAA;EACH,eAAA;EACA,kBAAA;ApH8/oCF;AoH3/oCC;EACC,4BAAA;ApH6/oCF;AoH1/oCC;EACC,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;ApH4/oCF;AoH1/oCE;EACC,eAAA;ApH4/oCH;AoHz/oCE;EACC,gBAAA;ApH2/oCH;AoHr/oCE;;EACC,2BAAA;ApHw/oCH;AoHt/oCG;;;EACC,2BAAA;ApH0/oCJ;AoHp/oCE;EACC,mBAAA;ApHs/oCH;AoHj/oCC;EACC,sB5BhDkC;E4BiDlC,iBAAA;EACA,yBAAA;ApHm/oCF;AoH7+oCG;EACC,2BAAA;EACA,8BAAA;ApH++oCJ;AoH5+oCG;EACC,4BAAA;EACA,+BAAA;ApH8+oCJ;AoHt+oCE;EACC,gBAAA;ApHw+oCH;AoHl+oCE;EACC,wBAAA;EACA,0BAAA;EACA,2CAAA;ApHo+oCH;AoHh+oCG;EACC,gCAAA;ApHk+oCJ;AoH39oCE;EACC,wBAAA;EACA,2BAAA;EACA,2CAAA;ApH69oCH;AoHz9oCG;EACC,gCAAA;ApH29oCJ;AoHn9oCG;EACC,uCAAA;ApHq9oCJ;AoHt9oCG;EACC,uCAAA;ApHw9oCJ;AoHz9oCG;EACC,uCAAA;ApH29oCJ;AoH59oCG;EACC,uCAAA;ApH89oCJ;AoH/9oCG;EACC,uCAAA;ApHi+oCJ;AoHl+oCG;EACC,uCAAA;ApHo+oCJ;AoHr+oCG;EACC,uCAAA;ApHu+oCJ;AoHx+oCG;EACC,uCAAA;ApH0+oCJ;AoH3+oCG;EACC,uCAAA;ApH6+oCJ;;AoHt+oCA;EACC,mBAAA;ApHy+oCD;;AoHp+oCC;EACC,UAAA;ApHu+oCF;;AoHn+oCA;;;EAGC,sBAAA;ApHs+oCD;AoHp+oCC;;;EACC,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;ApHw+oCF;;AoHn+oCC;EACC,UAAA;E3BtGM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sC2BgG0B;E3B7F9B,6DAAA;EACA,qDAAA;AzFwkpCJ;;AoHv+oCC;EACC,UAAA;E3B7GM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sC2BuG6B;E3BpGjC,6DAAA;EACA,qDAAA;AzFmlpCJ;;AoH3+oCA;EACC,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;E5G1JG,sBAAA;E4G4JH,sDAAA;EACA,mC7G8T2C;E6G7T3C,yB7G8T2C;E6G7T3C,gB7GoMkB;E6GnMlB,oBAAA;EACA,WAAA;EACA,gCAAA;EACA,4CAAA;ApH8+oCD;;AoH3+oCA;EACC,kBAAA;ApH8+oCD;AoH5+oCC;EACC,cAAA;ApH8+oCF;;AoHn+oCI;EACC,a7G+IK;APu1oCV;AoHn+oCK;EACC,6BAAA;ApHq+oCN;;AoH/9oCI;EACC,iB7GoIK;E6GnIL,oB7GmIK;AP+1oCV;;AoH79oCI;EACC,kB7G6HK;E6G5HL,mB7G4HK;APo2oCV;AoH79oCK;EACC,6BAAA;ApH+9oCN;;AoHx9oCK;EACI,kB7GgHC;AP22oCV;AoHx9oCK;EACI,mB7G4GC;AP82oCV;AoHt9oCK;EACC,6BAAA;ApHw9oCN;;AoHjgpCI;EACC,gB7G+IK;APq3oCV;AoHjgpCK;EACC,gCAAA;ApHmgpCN;;AoH7/oCI;EACC,oB7GoIK;E6GnIL,uB7GmIK;AP63oCV;;AoH3/oCI;EACC,qB7G6HK;E6G5HL,sB7G4HK;APk4oCV;AoH3/oCK;EACC,gCAAA;ApH6/oCN;;AoHt/oCK;EACI,qB7GgHC;APy4oCV;AoHt/oCK;EACI,sB7G4GC;AP44oCV;AoHp/oCK;EACC,gCAAA;ApHs/oCN;;AoH/hpCI;EACC,e7G+IK;APm5oCV;AoH/hpCK;EACC,+BAAA;ApHiipCN;;AoH3hpCI;EACC,mB7GoIK;E6GnIL,sB7GmIK;AP25oCV;;AoHzhpCI;EACC,oB7G6HK;E6G5HL,qB7G4HK;APg6oCV;AoHzhpCK;EACC,+BAAA;ApH2hpCN;;AoHphpCK;EACI,oB7GgHC;APu6oCV;AoHphpCK;EACI,qB7G4GC;AP06oCV;AoHlhpCK;EACC,+BAAA;ApHohpCN;;AoH7jpCI;EACC,gB7G+IK;APi7oCV;AoH7jpCK;EACC,gCAAA;ApH+jpCN;;AoHzjpCI;EACC,oB7GoIK;E6GnIL,uB7GmIK;APy7oCV;;AoHvjpCI;EACC,qB7G6HK;E6G5HL,sB7G4HK;AP87oCV;AoHvjpCK;EACC,gCAAA;ApHyjpCN;;AoHljpCK;EACI,qB7GgHC;APq8oCV;AoHljpCK;EACI,sB7G4GC;APw8oCV;AoHhjpCK;EACC,gCAAA;ApHkjpCN;;AoH3lpCI;EACC,a7G+IK;AP+8oCV;AoH3lpCK;EACC,6BAAA;ApH6lpCN;;AoHvlpCI;EACC,iB7GoIK;E6GnIL,oB7GmIK;APu9oCV;;AoHrlpCI;EACC,kB7G6HK;E6G5HL,mB7G4HK;AP49oCV;AoHrlpCK;EACC,6BAAA;ApHulpCN;;AoHhlpCK;EACI,kB7GgHC;APm+oCV;AoHhlpCK;EACI,mB7G4GC;APs+oCV;AoH9kpCK;EACC,6BAAA;ApHglpCN;;AoHznpCI;EACC,gB7G+IK;AP6+oCV;AoHznpCK;EACC,gCAAA;ApH2npCN;;AoHrnpCI;EACC,oB7GoIK;E6GnIL,uB7GmIK;APq/oCV;;AoHnnpCI;EACC,qB7G6HK;E6G5HL,sB7G4HK;AP0/oCV;AoHnnpCK;EACC,gCAAA;ApHqnpCN;;AoH9mpCK;EACI,qB7GgHC;APigpCV;AoH9mpCK;EACI,sB7G4GC;APogpCV;AoH5mpCK;EACC,gCAAA;ApH8mpCN;;AoHvppCI;EACC,e7G+IK;AP2gpCV;AoHvppCK;EACC,+BAAA;ApHyppCN;;AoHnppCI;EACC,mB7GoIK;E6GnIL,sB7GmIK;APmhpCV;;AoHjppCI;EACC,oB7G6HK;E6G5HL,qB7G4HK;APwhpCV;AoHjppCK;EACC,+BAAA;ApHmppCN;;AoH5opCK;EACI,oB7GgHC;AP+hpCV;AoH5opCK;EACI,qB7G4GC;APkipCV;AoH1opCK;EACC,+BAAA;ApH4opCN;;AoHrrpCI;EACC,gB7G+IK;APyipCV;AoHrrpCK;EACC,gCAAA;ApHurpCN;;AoHjrpCI;EACC,oB7GoIK;E6GnIL,uB7GmIK;APijpCV;;AoH/qpCI;EACC,qB7G6HK;E6G5HL,sB7G4HK;APsjpCV;AoH/qpCK;EACC,gCAAA;ApHirpCN;;AoH1qpCK;EACI,qB7GgHC;AP6jpCV;AoH1qpCK;EACI,sB7G4GC;APgkpCV;AoHxqpCK;EACC,gCAAA;ApH0qpCN;;AoHntpCI;EACC,a7G+IK;APukpCV;AoHntpCK;EACC,6BAAA;ApHqtpCN;;AoH/spCI;EACC,iB7GoIK;E6GnIL,oB7GmIK;AP+kpCV;;AoH7spCI;EACC,kB7G6HK;E6G5HL,mB7G4HK;APolpCV;AoH7spCK;EACC,6BAAA;ApH+spCN;;AoHxspCK;EACI,kB7GgHC;AP2lpCV;AoHxspCK;EACI,mB7G4GC;AP8lpCV;AoHtspCK;EACC,6BAAA;ApHwspCN;;AoHjvpCI;EACC,gB7G+IK;APqmpCV;AoHjvpCK;EACC,gCAAA;ApHmvpCN;;AoH7upCI;EACC,oB7GoIK;E6GnIL,uB7GmIK;AP6mpCV;;AoH3upCI;EACC,qB7G6HK;E6G5HL,sB7G4HK;APknpCV;AoH3upCK;EACC,gCAAA;ApH6upCN;;AoHtupCK;EACI,qB7GgHC;APynpCV;AoHtupCK;EACI,sB7G4GC;AP4npCV;AoHpupCK;EACC,gCAAA;ApHsupCN;;AoH/wpCI;EACC,e7G+IK;APmopCV;AoH/wpCK;EACC,+BAAA;ApHixpCN;;AoH3wpCI;EACC,mB7GoIK;E6GnIL,sB7GmIK;AP2opCV;;AoHzwpCI;EACC,oB7G6HK;E6G5HL,qB7G4HK;APgppCV;AoHzwpCK;EACC,+BAAA;ApH2wpCN;;AoHpwpCK;EACI,oB7GgHC;APuppCV;AoHpwpCK;EACI,qB7G4GC;AP0ppCV;AoHlwpCK;EACC,+BAAA;ApHowpCN;;AgBt7pCI;EoGyIA;IACC,a7G+IK;EPkqpCR;EoH9ypCG;IACC,6BAAA;EpHgzpCJ;EoH1ypCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPyqpCR;EoHvypCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP6qpCR;EoHtypCG;IACC,6BAAA;EpHwypCJ;EoHjypCG;IACI,kB7GgHC;EPmrpCR;EoHhypCG;IACI,mB7G4GC;EPsrpCR;EoH9xpCG;IACC,6BAAA;EpHgypCJ;EoHz0pCE;IACC,gB7G+IK;EP4rpCR;EoHx0pCG;IACC,gCAAA;EpH00pCJ;EoHp0pCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPmspCR;EoHj0pCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPuspCR;EoHh0pCG;IACC,gCAAA;EpHk0pCJ;EoH3zpCG;IACI,qB7GgHC;EP6spCR;EoH1zpCG;IACI,sB7G4GC;EPgtpCR;EoHxzpCG;IACC,gCAAA;EpH0zpCJ;EoHn2pCE;IACC,e7G+IK;EPstpCR;EoHl2pCG;IACC,+BAAA;EpHo2pCJ;EoH91pCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP6tpCR;EoH31pCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPiupCR;EoH11pCG;IACC,+BAAA;EpH41pCJ;EoHr1pCG;IACI,oB7GgHC;EPuupCR;EoHp1pCG;IACI,qB7G4GC;EP0upCR;EoHl1pCG;IACC,+BAAA;EpHo1pCJ;EoH73pCE;IACC,gB7G+IK;EPgvpCR;EoH53pCG;IACC,gCAAA;EpH83pCJ;EoHx3pCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPuvpCR;EoHr3pCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP2vpCR;EoHp3pCG;IACC,gCAAA;EpHs3pCJ;EoH/2pCG;IACI,qB7GgHC;EPiwpCR;EoH92pCG;IACI,sB7G4GC;EPowpCR;EoH52pCG;IACC,gCAAA;EpH82pCJ;EoHv5pCE;IACC,a7G+IK;EP0wpCR;EoHt5pCG;IACC,6BAAA;EpHw5pCJ;EoHl5pCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPixpCR;EoH/4pCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EPqxpCR;EoH94pCG;IACC,6BAAA;EpHg5pCJ;EoHz4pCG;IACI,kB7GgHC;EP2xpCR;EoHx4pCG;IACI,mB7G4GC;EP8xpCR;EoHt4pCG;IACC,6BAAA;EpHw4pCJ;EoHj7pCE;IACC,gB7G+IK;EPoypCR;EoHh7pCG;IACC,gCAAA;EpHk7pCJ;EoH56pCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP2ypCR;EoHz6pCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP+ypCR;EoHx6pCG;IACC,gCAAA;EpH06pCJ;EoHn6pCG;IACI,qB7GgHC;EPqzpCR;EoHl6pCG;IACI,sB7G4GC;EPwzpCR;EoHh6pCG;IACC,gCAAA;EpHk6pCJ;EoH38pCE;IACC,e7G+IK;EP8zpCR;EoH18pCG;IACC,+BAAA;EpH48pCJ;EoHt8pCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EPq0pCR;EoHn8pCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPy0pCR;EoHl8pCG;IACC,+BAAA;EpHo8pCJ;EoH77pCG;IACI,oB7GgHC;EP+0pCR;EoH57pCG;IACI,qB7G4GC;EPk1pCR;EoH17pCG;IACC,+BAAA;EpH47pCJ;EoHr+pCE;IACC,gB7G+IK;EPw1pCR;EoHp+pCG;IACC,gCAAA;EpHs+pCJ;EoHh+pCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP+1pCR;EoH79pCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPm2pCR;EoH59pCG;IACC,gCAAA;EpH89pCJ;EoHv9pCG;IACI,qB7GgHC;EPy2pCR;EoHt9pCG;IACI,sB7G4GC;EP42pCR;EoHp9pCG;IACC,gCAAA;EpHs9pCJ;EoH//pCE;IACC,a7G+IK;EPk3pCR;EoH9/pCG;IACC,6BAAA;EpHggqCJ;EoH1/pCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPy3pCR;EoHv/pCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP63pCR;EoHt/pCG;IACC,6BAAA;EpHw/pCJ;EoHj/pCG;IACI,kB7GgHC;EPm4pCR;EoHh/pCG;IACI,mB7G4GC;EPs4pCR;EoH9+pCG;IACC,6BAAA;EpHg/pCJ;EoHzhqCE;IACC,gB7G+IK;EP44pCR;EoHxhqCG;IACC,gCAAA;EpH0hqCJ;EoHphqCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPm5pCR;EoHjhqCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPu5pCR;EoHhhqCG;IACC,gCAAA;EpHkhqCJ;EoH3gqCG;IACI,qB7GgHC;EP65pCR;EoH1gqCG;IACI,sB7G4GC;EPg6pCR;EoHxgqCG;IACC,gCAAA;EpH0gqCJ;EoHnjqCE;IACC,e7G+IK;EPs6pCR;EoHljqCG;IACC,+BAAA;EpHojqCJ;EoH9iqCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP66pCR;EoH3iqCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPi7pCR;EoH1iqCG;IACC,+BAAA;EpH4iqCJ;EoHriqCG;IACI,oB7GgHC;EPu7pCR;EoHpiqCG;IACI,qB7G4GC;EP07pCR;EoHliqCG;IACC,+BAAA;EpHoiqCJ;AACF;AgBvtqCI;EoGyIA;IACC,a7G+IK;EPk8pCR;EoH9kqCG;IACC,6BAAA;EpHglqCJ;EoH1kqCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPy8pCR;EoHvkqCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP68pCR;EoHtkqCG;IACC,6BAAA;EpHwkqCJ;EoHjkqCG;IACI,kB7GgHC;EPm9pCR;EoHhkqCG;IACI,mB7G4GC;EPs9pCR;EoH9jqCG;IACC,6BAAA;EpHgkqCJ;EoHzmqCE;IACC,gB7G+IK;EP49pCR;EoHxmqCG;IACC,gCAAA;EpH0mqCJ;EoHpmqCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPm+pCR;EoHjmqCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPu+pCR;EoHhmqCG;IACC,gCAAA;EpHkmqCJ;EoH3lqCG;IACI,qB7GgHC;EP6+pCR;EoH1lqCG;IACI,sB7G4GC;EPg/pCR;EoHxlqCG;IACC,gCAAA;EpH0lqCJ;EoHnoqCE;IACC,e7G+IK;EPs/pCR;EoHloqCG;IACC,+BAAA;EpHooqCJ;EoH9nqCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP6/pCR;EoH3nqCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPigqCR;EoH1nqCG;IACC,+BAAA;EpH4nqCJ;EoHrnqCG;IACI,oB7GgHC;EPugqCR;EoHpnqCG;IACI,qB7G4GC;EP0gqCR;EoHlnqCG;IACC,+BAAA;EpHonqCJ;EoH7pqCE;IACC,gB7G+IK;EPghqCR;EoH5pqCG;IACC,gCAAA;EpH8pqCJ;EoHxpqCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPuhqCR;EoHrpqCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP2hqCR;EoHppqCG;IACC,gCAAA;EpHspqCJ;EoH/oqCG;IACI,qB7GgHC;EPiiqCR;EoH9oqCG;IACI,sB7G4GC;EPoiqCR;EoH5oqCG;IACC,gCAAA;EpH8oqCJ;EoHvrqCE;IACC,a7G+IK;EP0iqCR;EoHtrqCG;IACC,6BAAA;EpHwrqCJ;EoHlrqCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPijqCR;EoH/qqCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EPqjqCR;EoH9qqCG;IACC,6BAAA;EpHgrqCJ;EoHzqqCG;IACI,kB7GgHC;EP2jqCR;EoHxqqCG;IACI,mB7G4GC;EP8jqCR;EoHtqqCG;IACC,6BAAA;EpHwqqCJ;EoHjtqCE;IACC,gB7G+IK;EPokqCR;EoHhtqCG;IACC,gCAAA;EpHktqCJ;EoH5sqCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP2kqCR;EoHzsqCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP+kqCR;EoHxsqCG;IACC,gCAAA;EpH0sqCJ;EoHnsqCG;IACI,qB7GgHC;EPqlqCR;EoHlsqCG;IACI,sB7G4GC;EPwlqCR;EoHhsqCG;IACC,gCAAA;EpHksqCJ;EoH3uqCE;IACC,e7G+IK;EP8lqCR;EoH1uqCG;IACC,+BAAA;EpH4uqCJ;EoHtuqCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EPqmqCR;EoHnuqCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPymqCR;EoHluqCG;IACC,+BAAA;EpHouqCJ;EoH7tqCG;IACI,oB7GgHC;EP+mqCR;EoH5tqCG;IACI,qB7G4GC;EPknqCR;EoH1tqCG;IACC,+BAAA;EpH4tqCJ;EoHrwqCE;IACC,gB7G+IK;EPwnqCR;EoHpwqCG;IACC,gCAAA;EpHswqCJ;EoHhwqCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP+nqCR;EoH7vqCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPmoqCR;EoH5vqCG;IACC,gCAAA;EpH8vqCJ;EoHvvqCG;IACI,qB7GgHC;EPyoqCR;EoHtvqCG;IACI,sB7G4GC;EP4oqCR;EoHpvqCG;IACC,gCAAA;EpHsvqCJ;EoH/xqCE;IACC,a7G+IK;EPkpqCR;EoH9xqCG;IACC,6BAAA;EpHgyqCJ;EoH1xqCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPypqCR;EoHvxqCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP6pqCR;EoHtxqCG;IACC,6BAAA;EpHwxqCJ;EoHjxqCG;IACI,kB7GgHC;EPmqqCR;EoHhxqCG;IACI,mB7G4GC;EPsqqCR;EoH9wqCG;IACC,6BAAA;EpHgxqCJ;EoHzzqCE;IACC,gB7G+IK;EP4qqCR;EoHxzqCG;IACC,gCAAA;EpH0zqCJ;EoHpzqCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPmrqCR;EoHjzqCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPurqCR;EoHhzqCG;IACC,gCAAA;EpHkzqCJ;EoH3yqCG;IACI,qB7GgHC;EP6rqCR;EoH1yqCG;IACI,sB7G4GC;EPgsqCR;EoHxyqCG;IACC,gCAAA;EpH0yqCJ;EoHn1qCE;IACC,e7G+IK;EPssqCR;EoHl1qCG;IACC,+BAAA;EpHo1qCJ;EoH90qCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP6sqCR;EoH30qCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPitqCR;EoH10qCG;IACC,+BAAA;EpH40qCJ;EoHr0qCG;IACI,oB7GgHC;EPutqCR;EoHp0qCG;IACI,qB7G4GC;EP0tqCR;EoHl0qCG;IACC,+BAAA;EpHo0qCJ;AACF;AgBv/qCI;EoGyIA;IACC,a7G+IK;EPkuqCR;EoH92qCG;IACC,6BAAA;EpHg3qCJ;EoH12qCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPyuqCR;EoHv2qCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP6uqCR;EoHt2qCG;IACC,6BAAA;EpHw2qCJ;EoHj2qCG;IACI,kB7GgHC;EPmvqCR;EoHh2qCG;IACI,mB7G4GC;EPsvqCR;EoH91qCG;IACC,6BAAA;EpHg2qCJ;EoHz4qCE;IACC,gB7G+IK;EP4vqCR;EoHx4qCG;IACC,gCAAA;EpH04qCJ;EoHp4qCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPmwqCR;EoHj4qCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPuwqCR;EoHh4qCG;IACC,gCAAA;EpHk4qCJ;EoH33qCG;IACI,qB7GgHC;EP6wqCR;EoH13qCG;IACI,sB7G4GC;EPgxqCR;EoHx3qCG;IACC,gCAAA;EpH03qCJ;EoHn6qCE;IACC,e7G+IK;EPsxqCR;EoHl6qCG;IACC,+BAAA;EpHo6qCJ;EoH95qCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP6xqCR;EoH35qCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPiyqCR;EoH15qCG;IACC,+BAAA;EpH45qCJ;EoHr5qCG;IACI,oB7GgHC;EPuyqCR;EoHp5qCG;IACI,qB7G4GC;EP0yqCR;EoHl5qCG;IACC,+BAAA;EpHo5qCJ;EoH77qCE;IACC,gB7G+IK;EPgzqCR;EoH57qCG;IACC,gCAAA;EpH87qCJ;EoHx7qCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPuzqCR;EoHr7qCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP2zqCR;EoHp7qCG;IACC,gCAAA;EpHs7qCJ;EoH/6qCG;IACI,qB7GgHC;EPi0qCR;EoH96qCG;IACI,sB7G4GC;EPo0qCR;EoH56qCG;IACC,gCAAA;EpH86qCJ;EoHv9qCE;IACC,a7G+IK;EP00qCR;EoHt9qCG;IACC,6BAAA;EpHw9qCJ;EoHl9qCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPi1qCR;EoH/8qCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EPq1qCR;EoH98qCG;IACC,6BAAA;EpHg9qCJ;EoHz8qCG;IACI,kB7GgHC;EP21qCR;EoHx8qCG;IACI,mB7G4GC;EP81qCR;EoHt8qCG;IACC,6BAAA;EpHw8qCJ;EoHj/qCE;IACC,gB7G+IK;EPo2qCR;EoHh/qCG;IACC,gCAAA;EpHk/qCJ;EoH5+qCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP22qCR;EoHz+qCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP+2qCR;EoHx+qCG;IACC,gCAAA;EpH0+qCJ;EoHn+qCG;IACI,qB7GgHC;EPq3qCR;EoHl+qCG;IACI,sB7G4GC;EPw3qCR;EoHh+qCG;IACC,gCAAA;EpHk+qCJ;EoH3grCE;IACC,e7G+IK;EP83qCR;EoH1grCG;IACC,+BAAA;EpH4grCJ;EoHtgrCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EPq4qCR;EoHngrCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPy4qCR;EoHlgrCG;IACC,+BAAA;EpHogrCJ;EoH7/qCG;IACI,oB7GgHC;EP+4qCR;EoH5/qCG;IACI,qB7G4GC;EPk5qCR;EoH1/qCG;IACC,+BAAA;EpH4/qCJ;EoHrirCE;IACC,gB7G+IK;EPw5qCR;EoHpirCG;IACC,gCAAA;EpHsirCJ;EoHhirCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP+5qCR;EoH7hrCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPm6qCR;EoH5hrCG;IACC,gCAAA;EpH8hrCJ;EoHvhrCG;IACI,qB7GgHC;EPy6qCR;EoHthrCG;IACI,sB7G4GC;EP46qCR;EoHphrCG;IACC,gCAAA;EpHshrCJ;EoH/jrCE;IACC,a7G+IK;EPk7qCR;EoH9jrCG;IACC,6BAAA;EpHgkrCJ;EoH1jrCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPy7qCR;EoHvjrCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP67qCR;EoHtjrCG;IACC,6BAAA;EpHwjrCJ;EoHjjrCG;IACI,kB7GgHC;EPm8qCR;EoHhjrCG;IACI,mB7G4GC;EPs8qCR;EoH9irCG;IACC,6BAAA;EpHgjrCJ;EoHzlrCE;IACC,gB7G+IK;EP48qCR;EoHxlrCG;IACC,gCAAA;EpH0lrCJ;EoHplrCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPm9qCR;EoHjlrCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPu9qCR;EoHhlrCG;IACC,gCAAA;EpHklrCJ;EoH3krCG;IACI,qB7GgHC;EP69qCR;EoH1krCG;IACI,sB7G4GC;EPg+qCR;EoHxkrCG;IACC,gCAAA;EpH0krCJ;EoHnnrCE;IACC,e7G+IK;EPs+qCR;EoHlnrCG;IACC,+BAAA;EpHonrCJ;EoH9mrCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP6+qCR;EoH3mrCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPi/qCR;EoH1mrCG;IACC,+BAAA;EpH4mrCJ;EoHrmrCG;IACI,oB7GgHC;EPu/qCR;EoHpmrCG;IACI,qB7G4GC;EP0/qCR;EoHlmrCG;IACC,+BAAA;EpHomrCJ;AACF;AgBvxrCI;EoGyIA;IACC,a7G+IK;EPkgrCR;EoH9orCG;IACC,6BAAA;EpHgprCJ;EoH1orCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPygrCR;EoHvorCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP6grCR;EoHtorCG;IACC,6BAAA;EpHworCJ;EoHjorCG;IACI,kB7GgHC;EPmhrCR;EoHhorCG;IACI,mB7G4GC;EPshrCR;EoH9nrCG;IACC,6BAAA;EpHgorCJ;EoHzqrCE;IACC,gB7G+IK;EP4hrCR;EoHxqrCG;IACC,gCAAA;EpH0qrCJ;EoHpqrCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPmirCR;EoHjqrCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPuirCR;EoHhqrCG;IACC,gCAAA;EpHkqrCJ;EoH3prCG;IACI,qB7GgHC;EP6irCR;EoH1prCG;IACI,sB7G4GC;EPgjrCR;EoHxprCG;IACC,gCAAA;EpH0prCJ;EoHnsrCE;IACC,e7G+IK;EPsjrCR;EoHlsrCG;IACC,+BAAA;EpHosrCJ;EoH9rrCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP6jrCR;EoH3rrCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPikrCR;EoH1rrCG;IACC,+BAAA;EpH4rrCJ;EoHrrrCG;IACI,oB7GgHC;EPukrCR;EoHprrCG;IACI,qB7G4GC;EP0krCR;EoHlrrCG;IACC,+BAAA;EpHorrCJ;EoH7trCE;IACC,gB7G+IK;EPglrCR;EoH5trCG;IACC,gCAAA;EpH8trCJ;EoHxtrCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPulrCR;EoHrtrCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP2lrCR;EoHptrCG;IACC,gCAAA;EpHstrCJ;EoH/srCG;IACI,qB7GgHC;EPimrCR;EoH9srCG;IACI,sB7G4GC;EPomrCR;EoH5srCG;IACC,gCAAA;EpH8srCJ;EoHvvrCE;IACC,a7G+IK;EP0mrCR;EoHtvrCG;IACC,6BAAA;EpHwvrCJ;EoHlvrCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPinrCR;EoH/urCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EPqnrCR;EoH9urCG;IACC,6BAAA;EpHgvrCJ;EoHzurCG;IACI,kB7GgHC;EP2nrCR;EoHxurCG;IACI,mB7G4GC;EP8nrCR;EoHturCG;IACC,6BAAA;EpHwurCJ;EoHjxrCE;IACC,gB7G+IK;EPoorCR;EoHhxrCG;IACC,gCAAA;EpHkxrCJ;EoH5wrCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP2orCR;EoHzwrCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP+orCR;EoHxwrCG;IACC,gCAAA;EpH0wrCJ;EoHnwrCG;IACI,qB7GgHC;EPqprCR;EoHlwrCG;IACI,sB7G4GC;EPwprCR;EoHhwrCG;IACC,gCAAA;EpHkwrCJ;EoH3yrCE;IACC,e7G+IK;EP8prCR;EoH1yrCG;IACC,+BAAA;EpH4yrCJ;EoHtyrCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EPqqrCR;EoHnyrCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPyqrCR;EoHlyrCG;IACC,+BAAA;EpHoyrCJ;EoH7xrCG;IACI,oB7GgHC;EP+qrCR;EoH5xrCG;IACI,qB7G4GC;EPkrrCR;EoH1xrCG;IACC,+BAAA;EpH4xrCJ;EoHr0rCE;IACC,gB7G+IK;EPwrrCR;EoHp0rCG;IACC,gCAAA;EpHs0rCJ;EoHh0rCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP+rrCR;EoH7zrCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPmsrCR;EoH5zrCG;IACC,gCAAA;EpH8zrCJ;EoHvzrCG;IACI,qB7GgHC;EPysrCR;EoHtzrCG;IACI,sB7G4GC;EP4srCR;EoHpzrCG;IACC,gCAAA;EpHszrCJ;EoH/1rCE;IACC,a7G+IK;EPktrCR;EoH91rCG;IACC,6BAAA;EpHg2rCJ;EoH11rCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPytrCR;EoHv1rCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP6trCR;EoHt1rCG;IACC,6BAAA;EpHw1rCJ;EoHj1rCG;IACI,kB7GgHC;EPmurCR;EoHh1rCG;IACI,mB7G4GC;EPsurCR;EoH90rCG;IACC,6BAAA;EpHg1rCJ;EoHz3rCE;IACC,gB7G+IK;EP4urCR;EoHx3rCG;IACC,gCAAA;EpH03rCJ;EoHp3rCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPmvrCR;EoHj3rCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPuvrCR;EoHh3rCG;IACC,gCAAA;EpHk3rCJ;EoH32rCG;IACI,qB7GgHC;EP6vrCR;EoH12rCG;IACI,sB7G4GC;EPgwrCR;EoHx2rCG;IACC,gCAAA;EpH02rCJ;EoHn5rCE;IACC,e7G+IK;EPswrCR;EoHl5rCG;IACC,+BAAA;EpHo5rCJ;EoH94rCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP6wrCR;EoH34rCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPixrCR;EoH14rCG;IACC,+BAAA;EpH44rCJ;EoHr4rCG;IACI,oB7GgHC;EPuxrCR;EoHp4rCG;IACI,qB7G4GC;EP0xrCR;EoHl4rCG;IACC,+BAAA;EpHo4rCJ;AACF;AgBvjsCI;EoGyIA;IACC,a7G+IK;EPkyrCR;EoH96rCG;IACC,6BAAA;EpHg7rCJ;EoH16rCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPyyrCR;EoHv6rCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP6yrCR;EoHt6rCG;IACC,6BAAA;EpHw6rCJ;EoHj6rCG;IACI,kB7GgHC;EPmzrCR;EoHh6rCG;IACI,mB7G4GC;EPszrCR;EoH95rCG;IACC,6BAAA;EpHg6rCJ;EoHz8rCE;IACC,gB7G+IK;EP4zrCR;EoHx8rCG;IACC,gCAAA;EpH08rCJ;EoHp8rCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPm0rCR;EoHj8rCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPu0rCR;EoHh8rCG;IACC,gCAAA;EpHk8rCJ;EoH37rCG;IACI,qB7GgHC;EP60rCR;EoH17rCG;IACI,sB7G4GC;EPg1rCR;EoHx7rCG;IACC,gCAAA;EpH07rCJ;EoHn+rCE;IACC,e7G+IK;EPs1rCR;EoHl+rCG;IACC,+BAAA;EpHo+rCJ;EoH99rCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP61rCR;EoH39rCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPi2rCR;EoH19rCG;IACC,+BAAA;EpH49rCJ;EoHr9rCG;IACI,oB7GgHC;EPu2rCR;EoHp9rCG;IACI,qB7G4GC;EP02rCR;EoHl9rCG;IACC,+BAAA;EpHo9rCJ;EoH7/rCE;IACC,gB7G+IK;EPg3rCR;EoH5/rCG;IACC,gCAAA;EpH8/rCJ;EoHx/rCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPu3rCR;EoHr/rCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP23rCR;EoHp/rCG;IACC,gCAAA;EpHs/rCJ;EoH/+rCG;IACI,qB7GgHC;EPi4rCR;EoH9+rCG;IACI,sB7G4GC;EPo4rCR;EoH5+rCG;IACC,gCAAA;EpH8+rCJ;EoHvhsCE;IACC,a7G+IK;EP04rCR;EoHthsCG;IACC,6BAAA;EpHwhsCJ;EoHlhsCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPi5rCR;EoH/gsCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EPq5rCR;EoH9gsCG;IACC,6BAAA;EpHghsCJ;EoHzgsCG;IACI,kB7GgHC;EP25rCR;EoHxgsCG;IACI,mB7G4GC;EP85rCR;EoHtgsCG;IACC,6BAAA;EpHwgsCJ;EoHjjsCE;IACC,gB7G+IK;EPo6rCR;EoHhjsCG;IACC,gCAAA;EpHkjsCJ;EoH5isCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP26rCR;EoHzisCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EP+6rCR;EoHxisCG;IACC,gCAAA;EpH0isCJ;EoHnisCG;IACI,qB7GgHC;EPq7rCR;EoHlisCG;IACI,sB7G4GC;EPw7rCR;EoHhisCG;IACC,gCAAA;EpHkisCJ;EoH3ksCE;IACC,e7G+IK;EP87rCR;EoH1ksCG;IACC,+BAAA;EpH4ksCJ;EoHtksCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EPq8rCR;EoHnksCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPy8rCR;EoHlksCG;IACC,+BAAA;EpHoksCJ;EoH7jsCG;IACI,oB7GgHC;EP+8rCR;EoH5jsCG;IACI,qB7G4GC;EPk9rCR;EoH1jsCG;IACC,+BAAA;EpH4jsCJ;EoHrmsCE;IACC,gB7G+IK;EPw9rCR;EoHpmsCG;IACC,gCAAA;EpHsmsCJ;EoHhmsCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EP+9rCR;EoH7lsCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPm+rCR;EoH5lsCG;IACC,gCAAA;EpH8lsCJ;EoHvlsCG;IACI,qB7GgHC;EPy+rCR;EoHtlsCG;IACI,sB7G4GC;EP4+rCR;EoHplsCG;IACC,gCAAA;EpHslsCJ;EoH/nsCE;IACC,a7G+IK;EPk/rCR;EoH9nsCG;IACC,6BAAA;EpHgosCJ;EoH1nsCE;IACC,iB7GoIK;I6GnIL,oB7GmIK;EPy/rCR;EoHvnsCE;IACC,kB7G6HK;I6G5HL,mB7G4HK;EP6/rCR;EoHtnsCG;IACC,6BAAA;EpHwnsCJ;EoHjnsCG;IACI,kB7GgHC;EPmgsCR;EoHhnsCG;IACI,mB7G4GC;EPsgsCR;EoH9msCG;IACC,6BAAA;EpHgnsCJ;EoHzpsCE;IACC,gB7G+IK;EP4gsCR;EoHxpsCG;IACC,gCAAA;EpH0psCJ;EoHppsCE;IACC,oB7GoIK;I6GnIL,uB7GmIK;EPmhsCR;EoHjpsCE;IACC,qB7G6HK;I6G5HL,sB7G4HK;EPuhsCR;EoHhpsCG;IACC,gCAAA;EpHkpsCJ;EoH3osCG;IACI,qB7GgHC;EP6hsCR;EoH1osCG;IACI,sB7G4GC;EPgisCR;EoHxosCG;IACC,gCAAA;EpH0osCJ;EoHnrsCE;IACC,e7G+IK;EPsisCR;EoHlrsCG;IACC,+BAAA;EpHorsCJ;EoH9qsCE;IACC,mB7GoIK;I6GnIL,sB7GmIK;EP6isCR;EoH3qsCE;IACC,oB7G6HK;I6G5HL,qB7G4HK;EPijsCR;EoH1qsCG;IACC,+BAAA;EpH4qsCJ;EoHrqsCG;IACI,oB7GgHC;EPujsCR;EoHpqsCG;IACI,qB7G4GC;EP0jsCR;EoHlqsCG;IACC,+BAAA;EpHoqsCJ;AACF;AqHh5sCA;EACI,yCAAA;ArHk5sCJ;AqHh5sCI;EACI,e9G6zByB;E8G5zBzB,gB9G2zB2B;E8G1zB3B,8DAAA;ArHk5sCR;AqH/4sCI;EACI,kBAAA;EACA,Y9G8zBgC;E8G7zBhC,c9G8zBgC;E8G7zBhC,e9G2zB+B;E8G1zB/B,c9G0zB+B;EkFxxB/B,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC4BxC4B;E5B2ChC,6DAAA;EACA,qDAAA;E4B3CI,cAAA;EACA,sBAAA;ArHu5sCR;AqHr5sCQ;EACI,mCAAA;ArHu5sCZ;AqHp5sCQ;EACI,qBAAA;ArHs5sCZ;;AqHh5sCA;EACI,mCAAA;EACA,6CAAA;EACA,wDAAA;EACA,6CAAA;EACA,0CAAA;EACA,2CAAA;EACA,sCAAA;EACA,oDAAA;ArHm5sCJ;;AqH94sCQ;EACI,wBAAA;EACA,kCAAA;EACA,+BAAA;EACA,wDAAA;EACA,yCAAA;ArHi5sCZ;;AsHh8sCI;EACI,wCAAA;AtHm8sCR;AsH/7sCQ;EACC,mBAAA;EACJ,eAAA;AtHi8sCL;AsH77sCI;EACI,0CAAA;EACA,+BAAA;AtH+7sCR;;AsHz7sCQ;EACI,wBAAA;EACA,yDAAA;AtH47sCZ;;AuHj9sCC;EACC,eAAA;AvHo9sCF;AuH98sCE;EACC,aAAA;EACA,cAAA;EACA,gCjHojB2B;EiHnjB3B,wBAAA;EACA,mBAAA;EACA,uBAAA;AvHg9sCH;AuH98sCG;;EAEI,wBAAA;AvHg9sCP;AuH18sCG;EACC,gCjHsiB0B;EiHriB1B,oBAAA;AvH48sCJ;AuH18sCI;;EAEI,2BAAA;AvH48sCR;AuHn8sCE;EACC,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCjHmhB2B;ANk7rC9B;AuHn8sCG;EACC,oBAAA;AvHq8sCJ;AuHl8sCG;EACC,aAAA;AvHo8sCJ;AuHj8sCG;;EAEI,wBAAA;AvHm8sCP;AuH77sCG;EACC,gCjHggB0B;AN+7rC9B;AuH77sCI;EACC,aAAA;AvH+7sCL;AuH57sCI;EACC,oBAAA;AvH87sCL;AuH37sCI;;EAEI,2BAAA;AvH67sCR;AuHp7sCE;EACC,SAAA;AvHs7sCH;AuH/6sCE;EACC,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AvHi7sCH;;AwHlhtCA;EACC,kBAAA;EACA,qBAAA;EhHWG,sBAAA;EgHTH,4BAAA;EACA,sBAAA;AxHqhtCD;AwHlhtCC;EACC,iCAAA;AxHohtCF;AwHhhtCC;EACC,YAAA;EACA,aAAA;EhHFE,sBAAA;EgHIF,4BAAA;EACA,sBAAA;AxHkhtCF;AwH9gtCC;EACC,eAAA;EACA,kBAAA;EACA,gCAAA;AxHghtCF;AwH5gtCC;EACC,UAAA;EACA,MAAA;AxH8gtCF;AwH5gtCE;EACC,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;AxH8gtCH;AwHzgtCC;;EAEC,kBAAA;EACA,UAAA;EACA,SAAA;AxH2gtCF;AwHxgtCC;EACC,aAAA;AxH0gtCF;AwHrgtCE;EACC,aAAA;AxHugtCH;AwHpgtCE;EACC,aAAA;AxHsgtCH;AwHhgtCE;;EAEC,aAAA;AxHkgtCH;AwH7/sCC;EACC,kBAAA;AxH+/sCF;AwH5/sCE;EACC,kBAAA;AxH8/sCH;AwH1/sCE;EACC,UAAA;EACA,MAAA;EACA,+BAAA;AxH4/sCH;AwHx/sCE;;EAEC,UAAA;EACA,SAAA;EACA,kCAAA;AxH0/sCH;AwHp/sCE;EACC,mCAAA;EACA,gCAAA;AxHs/sCH;;AyH5ltCA;EACI,qBAAA;EACA,cAAA;EACA,kBAAA;EjHWA,sBAAA;ARqltCJ;AyH5ltCI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;EjHFJ,sBAAA;ARimtCJ;AyH5ltCQ;EjHLJ,sBAAA;ARomtCJ;AyHzltCI;EACI,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,SAAA;EACA,uDAAA;AzH2ltCR;AyHvltCI;EACI,WAAA;EACA,cAAA;EACA,qBAAA;EjHvBJ,sBAAA;ARintCJ;AyHpltCQ;;;EAGI,2BAAA;AzHsltCZ;AyHhltCQ;;;EAGI,kBAAA;AzHkltCZ;AyHhltCY;;;EACI,kBAAA;AzHoltChB;A0H9otCI;EACI,WD+DiB;EC9DjB,YD8DiB;AzHkltCzB;A0H7otCI;EACI,WD0DiB;ECzDjB,YDyDiB;AzHsltCzB;A0H3otCQ;EACI,WDoDa;ECnDb,YDmDa;AzH0ltCzB;A0H1otCQ;EACI,WD+Ca;EC9Cb,YD8Ca;EC7Cb,eAAA;A1H4otCZ;A0HtotCQ;EACI,YDsCa;ECrCb,WAAA;A1HwotCZ;A0HrotCQ;EACI,YDiCa;EChCb,WAAA;EACA,eAAA;A1HuotCZ;A0HxqtCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;APknrCf;A0HvqtCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;APsnrCf;A0HrqtCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;AP0nrCf;A0HpqtCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1HsqtCZ;A0HhqtCQ;EACI,YnHgiCG;EmH/hCH,WAAA;A1HkqtCZ;A0H/ptCQ;EACI,YnH2hCG;EmH1hCH,WAAA;EACA,eAAA;A1HiqtCZ;A0HlstCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;AP4orCf;A0HjstCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;APgprCf;A0H/rtCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;APoprCf;A0H9rtCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1HgstCZ;A0H1rtCQ;EACI,YnHgiCG;EmH/hCH,aAAA;A1H4rtCZ;A0HzrtCQ;EACI,YnH2hCG;EmH1hCH,aAAA;EACA,eAAA;A1H2rtCZ;A0H5ttCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;APsqrCf;A0H3ttCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;AP0qrCf;A0HzttCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;AP8qrCf;A0HxttCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1H0ttCZ;A0HpttCQ;EACI,YnHgiCG;EmH/hCH,WAAA;A1HsttCZ;A0HnttCQ;EACI,YnH2hCG;EmH1hCH,WAAA;EACA,eAAA;A1HqttCZ;A0HtvtCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;APgsrCf;A0HrvtCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;APosrCf;A0HnvtCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;APwsrCf;A0HlvtCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1HovtCZ;A0H9utCQ;EACI,YnHgiCG;EmH/hCH,aAAA;A1HgvtCZ;A0H7utCQ;EACI,YnH2hCG;EmH1hCH,aAAA;EACA,eAAA;A1H+utCZ;A0HhxtCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;AP0trCf;A0H/wtCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;AP8trCf;A0H7wtCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;APkurCf;A0H5wtCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1H8wtCZ;A0HxwtCQ;EACI,YnHgiCG;EmH/hCH,WAAA;A1H0wtCZ;A0HvwtCQ;EACI,YnH2hCG;EmH1hCH,WAAA;EACA,eAAA;A1HywtCZ;A0H1ytCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;APovrCf;A0HzytCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;APwvrCf;A0HvytCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;AP4vrCf;A0HtytCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1HwytCZ;A0HlytCQ;EACI,YnHgiCG;EmH/hCH,aAAA;A1HoytCZ;A0HjytCQ;EACI,YnH2hCG;EmH1hCH,aAAA;EACA,eAAA;A1HmytCZ;A0Hp0tCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;AP8wrCf;A0Hn0tCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;APkxrCf;A0Hj0tCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;APsxrCf;A0Hh0tCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1Hk0tCZ;A0H5ztCQ;EACI,YnHgiCG;EmH/hCH,WAAA;A1H8ztCZ;A0H3ztCQ;EACI,YnH2hCG;EmH1hCH,WAAA;EACA,eAAA;A1H6ztCZ;A0H91tCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;APwyrCf;A0H71tCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;AP4yrCf;A0H31tCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;APgzrCf;A0H11tCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1H41tCZ;A0Ht1tCQ;EACI,YnHgiCG;EmH/hCH,aAAA;A1Hw1tCZ;A0Hr1tCQ;EACI,YnH2hCG;EmH1hCH,aAAA;EACA,eAAA;A1Hu1tCZ;A0Hx3tCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;APk0rCf;A0Hv3tCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;APs0rCf;A0Hr3tCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;AP00rCf;A0Hp3tCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1Hs3tCZ;A0Hh3tCQ;EACI,YnHgiCG;EmH/hCH,WAAA;A1Hk3tCZ;A0H/2tCQ;EACI,YnH2hCG;EmH1hCH,WAAA;EACA,eAAA;A1Hi3tCZ;A0Hl5tCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;AP41rCf;A0Hj5tCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;APg2rCf;A0H/4tCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;APo2rCf;A0H94tCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1Hg5tCZ;A0H14tCQ;EACI,YnHgiCG;EmH/hCH,aAAA;A1H44tCZ;A0Hz4tCQ;EACI,YnH2hCG;EmH1hCH,aAAA;EACA,eAAA;A1H24tCZ;A0H56tCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;APs3rCf;A0H36tCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;AP03rCf;A0Hz6tCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;AP83rCf;A0Hx6tCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1H06tCZ;A0Hp6tCQ;EACI,YnHgiCG;EmH/hCH,YAAA;A1Hs6tCZ;A0Hn6tCQ;EACI,YnH2hCG;EmH1hCH,YAAA;EACA,eAAA;A1Hq6tCZ;A0Ht8tCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;APg5rCf;A0Hr8tCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;APo5rCf;A0Hn8tCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;APw5rCf;A0Hl8tCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1Ho8tCZ;A0H97tCQ;EACI,YnHgiCG;EmH/hCH,cAAA;A1Hg8tCZ;A0H77tCQ;EACI,YnH2hCG;EmH1hCH,cAAA;EACA,eAAA;A1H+7tCZ;A0Hh+tCI;EACI,WnHyjCO;EmHxjCP,YnHwjCO;AP06rCf;A0H/9tCI;EACI,WnHojCO;EmHnjCP,YnHmjCO;AP86rCf;A0H79tCQ;EACI,WnH8iCG;EmH7iCH,YnH6iCG;APk7rCf;A0H59tCQ;EACI,WnHyiCG;EmHxiCH,YnHwiCG;EmHviCH,eAAA;A1H89tCZ;A0Hx9tCQ;EACI,YnHgiCG;EmH/hCH,YAAA;A1H09tCZ;A0Hv9tCQ;EACI,YnH2hCG;EmH1hCH,YAAA;EACA,eAAA;A1Hy9tCZ;A0H1/tCI;EACI,YnHyjCO;EmHxjCP,anHwjCO;APo8rCf;A0Hz/tCI;EACI,YnHojCO;EmHnjCP,anHmjCO;APw8rCf;A0Hv/tCQ;EACI,YnH8iCG;EmH7iCH,anH6iCG;AP48rCf;A0Ht/tCQ;EACI,YnHyiCG;EmHxiCH,anHwiCG;EmHviCH,eAAA;A1Hw/tCZ;A0Hl/tCQ;EACI,anHgiCG;EmH/hCH,YAAA;A1Ho/tCZ;A0Hj/tCQ;EACI,anH2hCG;EmH1hCH,YAAA;EACA,eAAA;A1Hm/tCZ;A0HphuCI;EACI,YnHyjCO;EmHxjCP,anHwjCO;AP89rCf;A0HnhuCI;EACI,YnHojCO;EmHnjCP,anHmjCO;APk+rCf;A0HjhuCQ;EACI,YnH8iCG;EmH7iCH,anH6iCG;APs+rCf;A0HhhuCQ;EACI,YnHyiCG;EmHxiCH,anHwiCG;EmHviCH,eAAA;A1HkhuCZ;A0H5guCQ;EACI,anHgiCG;EmH/hCH,cAAA;A1H8guCZ;A0H3guCQ;EACI,anH2hCG;EmH1hCH,cAAA;EACA,eAAA;A1H6guCZ;A0H9iuCI;EACI,YnHyjCO;EmHxjCP,anHwjCO;APw/rCf;A0H7iuCI;EACI,YnHojCO;EmHnjCP,anHmjCO;AP4/rCf;A0H3iuCQ;EACI,YnH8iCG;EmH7iCH,anH6iCG;APggsCf;A0H1iuCQ;EACI,YnHyiCG;EmHxiCH,anHwiCG;EmHviCH,eAAA;A1H4iuCZ;A0HtiuCQ;EACI,anHgiCG;EmH/hCH,YAAA;A1HwiuCZ;A0HriuCQ;EACI,anH2hCG;EmH1hCH,YAAA;EACA,eAAA;A1HuiuCZ;A0HxkuCI;EACI,YnHyjCO;EmHxjCP,anHwjCO;APkhsCf;A0HvkuCI;EACI,YnHojCO;EmHnjCP,anHmjCO;APshsCf;A0HrkuCQ;EACI,YnH8iCG;EmH7iCH,anH6iCG;AP0hsCf;A0HpkuCQ;EACI,YnHyiCG;EmHxiCH,anHwiCG;EmHviCH,eAAA;A1HskuCZ;A0HhkuCQ;EACI,anHgiCG;EmH/hCH,YAAA;A1HkkuCZ;A0H/juCQ;EACI,anH2hCG;EmH1hCH,YAAA;EACA,eAAA;A1HikuCZ;A0HlmuCI;EACI,YnHyjCO;EmHxjCP,anHwjCO;AP4isCf;A0HjmuCI;EACI,YnHojCO;EmHnjCP,anHmjCO;APgjsCf;A0H/luCQ;EACI,YnH8iCG;EmH7iCH,anH6iCG;APojsCf;A0H9luCQ;EACI,YnHyiCG;EmHxiCH,anHwiCG;EmHviCH,eAAA;A1HgmuCZ;A0H1luCQ;EACI,anHgiCG;EmH/hCH,cAAA;A1H4luCZ;A0HzluCQ;EACI,anH2hCG;EmH1hCH,cAAA;EACA,eAAA;A1H2luCZ;A0H5nuCI;EACI,YnHyjCO;EmHxjCP,anHwjCO;APsksCf;A0H3nuCI;EACI,YnHojCO;EmHnjCP,anHmjCO;AP0ksCf;A0HznuCQ;EACI,YnH8iCG;EmH7iCH,anH6iCG;AP8ksCf;A0HxnuCQ;EACI,YnHyiCG;EmHxiCH,anHwiCG;EmHviCH,eAAA;A1H0nuCZ;A0HpnuCQ;EACI,anHgiCG;EmH/hCH,YAAA;A1HsnuCZ;A0HnnuCQ;EACI,anH2hCG;EmH1hCH,YAAA;EACA,eAAA;A1HqnuCZ;AgB5luCI;E0G1DA;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPimsCb;E0HtpuCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqmsCb;E0HppuCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPymsCb;E0HnpuCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HqpuCV;E0H/ouCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HipuCV;E0H9ouCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HgpuCV;E0HjruCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP2nsCb;E0HhruCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+nsCb;E0H9quCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPmosCb;E0H7quCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+quCV;E0HzquCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H2quCV;E0HxquCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H0quCV;E0H3suCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPqpsCb;E0H1suCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPypsCb;E0HxsuCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP6psCb;E0HvsuCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HysuCV;E0HnsuCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HqsuCV;E0HlsuCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HosuCV;E0HruuCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+qsCb;E0HpuuCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPmrsCb;E0HluuCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPursCb;E0HjuuCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HmuuCV;E0H7tuCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H+tuCV;E0H5tuCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H8tuCV;E0H/vuCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPyssCb;E0H9vuCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP6ssCb;E0H5vuCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPitsCb;E0H3vuCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H6vuCV;E0HvvuCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HyvuCV;E0HtvuCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HwvuCV;E0HzxuCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPmusCb;E0HxxuCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPuusCb;E0HtxuCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP2usCb;E0HrxuCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HuxuCV;E0HjxuCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1HmxuCV;E0HhxuCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1HkxuCV;E0HnzuCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP6vsCb;E0HlzuCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPiwsCb;E0HhzuCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPqwsCb;E0H/yuCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HizuCV;E0H3yuCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1H6yuCV;E0H1yuCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1H4yuCV;E0H70uCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPuxsCb;E0H50uCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP2xsCb;E0H10uCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP+xsCb;E0Hz0uCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H20uCV;E0Hr0uCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1Hu0uCV;E0Hp0uCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1Hs0uCV;E0Hv2uCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPizsCb;E0Ht2uCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqzsCb;E0Hp2uCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPyzsCb;E0Hn2uCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hq2uCV;E0H/1uCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1Hi2uCV;E0H91uCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1Hg2uCV;E0Hj4uCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP20sCb;E0Hh4uCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+0sCb;E0H93uCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPm1sCb;E0H73uCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+3uCV;E0Hz3uCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H23uCV;E0Hx3uCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H03uCV;E0H35uCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPq2sCb;E0H15uCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPy2sCb;E0Hx5uCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP62sCb;E0Hv5uCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hy5uCV;E0Hn5uCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hq5uCV;E0Hl5uCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Ho5uCV;E0Hr7uCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+3sCb;E0Hp7uCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPm4sCb;E0Hl7uCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPu4sCb;E0Hj7uCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hm7uCV;E0H76uCM;IACI,YnHgiCG;ImH/hCH,cAAA;E1H+6uCV;E0H56uCM;IACI,YnH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H86uCV;E0H/8uCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPy5sCb;E0H98uCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP65sCb;E0H58uCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPi6sCb;E0H38uCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H68uCV;E0Hv8uCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hy8uCV;E0Ht8uCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hw8uCV;E0Hz+uCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPm7sCb;E0Hx+uCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPu7sCb;E0Ht+uCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP27sCb;E0Hr+uCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hu+uCV;E0Hj+uCM;IACI,anHgiCG;ImH/hCH,YAAA;E1Hm+uCV;E0Hh+uCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hk+uCV;E0HngvCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP68sCb;E0HlgvCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPi9sCb;E0HhgvCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPq9sCb;E0H//uCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HigvCV;E0H3/uCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H6/uCV;E0H1/uCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H4/uCV;E0H7hvCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPu+sCb;E0H5hvCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP2+sCb;E0H1hvCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP++sCb;E0HzhvCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H2hvCV;E0HrhvCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HuhvCV;E0HphvCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HshvCV;E0HvjvCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPigtCb;E0HtjvCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPqgtCb;E0HpjvCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPygtCb;E0HnjvCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HqjvCV;E0H/ivCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HijvCV;E0H9ivCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HgjvCV;E0HjlvCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP2htCb;E0HhlvCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP+htCb;E0H9kvCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPmitCb;E0H7kvCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H+kvCV;E0HzkvCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H2kvCV;E0HxkvCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H0kvCV;E0H3mvCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPqjtCb;E0H1mvCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPyjtCb;E0HxmvCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP6jtCb;E0HvmvCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HymvCV;E0HnmvCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HqmvCV;E0HlmvCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HomvCV;AACF;AgB5kvCI;E0G1DA;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPiltCb;E0HtovCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqltCb;E0HpovCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPyltCb;E0HnovCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HqovCV;E0H/nvCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HiovCV;E0H9nvCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HgovCV;E0HjqvCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP2mtCb;E0HhqvCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+mtCb;E0H9pvCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPmntCb;E0H7pvCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+pvCV;E0HzpvCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H2pvCV;E0HxpvCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H0pvCV;E0H3rvCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPqotCb;E0H1rvCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPyotCb;E0HxrvCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP6otCb;E0HvrvCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HyrvCV;E0HnrvCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HqrvCV;E0HlrvCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HorvCV;E0HrtvCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+ptCb;E0HptvCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPmqtCb;E0HltvCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPuqtCb;E0HjtvCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HmtvCV;E0H7svCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H+svCV;E0H5svCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H8svCV;E0H/uvCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPyrtCb;E0H9uvCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP6rtCb;E0H5uvCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPistCb;E0H3uvCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H6uvCV;E0HvuvCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HyuvCV;E0HtuvCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HwuvCV;E0HzwvCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPmttCb;E0HxwvCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPuttCb;E0HtwvCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP2ttCb;E0HrwvCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HuwvCV;E0HjwvCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1HmwvCV;E0HhwvCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1HkwvCV;E0HnyvCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP6utCb;E0HlyvCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPivtCb;E0HhyvCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPqvtCb;E0H/xvCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HiyvCV;E0H3xvCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1H6xvCV;E0H1xvCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1H4xvCV;E0H7zvCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPuwtCb;E0H5zvCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP2wtCb;E0H1zvCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP+wtCb;E0HzzvCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H2zvCV;E0HrzvCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1HuzvCV;E0HpzvCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1HszvCV;E0Hv1vCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPiytCb;E0Ht1vCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqytCb;E0Hp1vCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPyytCb;E0Hn1vCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hq1vCV;E0H/0vCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1Hi1vCV;E0H90vCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1Hg1vCV;E0Hj3vCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP2ztCb;E0Hh3vCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+ztCb;E0H92vCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPm0tCb;E0H72vCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+2vCV;E0Hz2vCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H22vCV;E0Hx2vCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H02vCV;E0H34vCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPq1tCb;E0H14vCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPy1tCb;E0Hx4vCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP61tCb;E0Hv4vCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hy4vCV;E0Hn4vCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hq4vCV;E0Hl4vCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Ho4vCV;E0Hr6vCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+2tCb;E0Hp6vCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPm3tCb;E0Hl6vCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPu3tCb;E0Hj6vCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hm6vCV;E0H75vCM;IACI,YnHgiCG;ImH/hCH,cAAA;E1H+5vCV;E0H55vCM;IACI,YnH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H85vCV;E0H/7vCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPy4tCb;E0H97vCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP64tCb;E0H57vCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPi5tCb;E0H37vCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H67vCV;E0Hv7vCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hy7vCV;E0Ht7vCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hw7vCV;E0Hz9vCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPm6tCb;E0Hx9vCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPu6tCb;E0Ht9vCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP26tCb;E0Hr9vCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hu9vCV;E0Hj9vCM;IACI,anHgiCG;ImH/hCH,YAAA;E1Hm9vCV;E0Hh9vCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hk9vCV;E0Hn/vCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP67tCb;E0Hl/vCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPi8tCb;E0Hh/vCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPq8tCb;E0H/+vCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hi/vCV;E0H3+vCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H6+vCV;E0H1+vCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H4+vCV;E0H7gwCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPu9tCb;E0H5gwCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP29tCb;E0H1gwCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP+9tCb;E0HzgwCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H2gwCV;E0HrgwCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HugwCV;E0HpgwCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HsgwCV;E0HviwCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPi/tCb;E0HtiwCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPq/tCb;E0HpiwCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPy/tCb;E0HniwCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HqiwCV;E0H/hwCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HiiwCV;E0H9hwCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HgiwCV;E0HjkwCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP2guCb;E0HhkwCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP+guCb;E0H9jwCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPmhuCb;E0H7jwCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H+jwCV;E0HzjwCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H2jwCV;E0HxjwCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H0jwCV;E0H3lwCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPqiuCb;E0H1lwCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPyiuCb;E0HxlwCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP6iuCb;E0HvlwCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HylwCV;E0HnlwCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HqlwCV;E0HllwCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HolwCV;AACF;AgB5jwCI;E0G1DA;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPikuCb;E0HtnwCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqkuCb;E0HpnwCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPykuCb;E0HnnwCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HqnwCV;E0H/mwCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HinwCV;E0H9mwCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HgnwCV;E0HjpwCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP2luCb;E0HhpwCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+luCb;E0H9owCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPmmuCb;E0H7owCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+owCV;E0HzowCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H2owCV;E0HxowCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H0owCV;E0H3qwCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPqnuCb;E0H1qwCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPynuCb;E0HxqwCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP6nuCb;E0HvqwCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HyqwCV;E0HnqwCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HqqwCV;E0HlqwCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HoqwCV;E0HrswCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+ouCb;E0HpswCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPmpuCb;E0HlswCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPupuCb;E0HjswCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HmswCV;E0H7rwCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H+rwCV;E0H5rwCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H8rwCV;E0H/twCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPyquCb;E0H9twCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP6quCb;E0H5twCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPiruCb;E0H3twCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H6twCV;E0HvtwCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HytwCV;E0HttwCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HwtwCV;E0HzvwCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPmsuCb;E0HxvwCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPusuCb;E0HtvwCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP2suCb;E0HrvwCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HuvwCV;E0HjvwCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1HmvwCV;E0HhvwCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1HkvwCV;E0HnxwCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP6tuCb;E0HlxwCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPiuuCb;E0HhxwCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPquuCb;E0H/wwCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HixwCV;E0H3wwCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1H6wwCV;E0H1wwCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1H4wwCV;E0H7ywCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPuvuCb;E0H5ywCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP2vuCb;E0H1ywCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP+vuCb;E0HzywCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H2ywCV;E0HrywCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1HuywCV;E0HpywCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1HsywCV;E0Hv0wCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPixuCb;E0Ht0wCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqxuCb;E0Hp0wCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPyxuCb;E0Hn0wCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hq0wCV;E0H/zwCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1Hi0wCV;E0H9zwCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1Hg0wCV;E0Hj2wCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP2yuCb;E0Hh2wCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+yuCb;E0H91wCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPmzuCb;E0H71wCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+1wCV;E0Hz1wCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H21wCV;E0Hx1wCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H01wCV;E0H33wCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPq0uCb;E0H13wCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPy0uCb;E0Hx3wCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP60uCb;E0Hv3wCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hy3wCV;E0Hn3wCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hq3wCV;E0Hl3wCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Ho3wCV;E0Hr5wCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+1uCb;E0Hp5wCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPm2uCb;E0Hl5wCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPu2uCb;E0Hj5wCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hm5wCV;E0H74wCM;IACI,YnHgiCG;ImH/hCH,cAAA;E1H+4wCV;E0H54wCM;IACI,YnH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H84wCV;E0H/6wCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPy3uCb;E0H96wCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP63uCb;E0H56wCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPi4uCb;E0H36wCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H66wCV;E0Hv6wCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hy6wCV;E0Ht6wCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hw6wCV;E0Hz8wCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPm5uCb;E0Hx8wCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPu5uCb;E0Ht8wCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP25uCb;E0Hr8wCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hu8wCV;E0Hj8wCM;IACI,anHgiCG;ImH/hCH,YAAA;E1Hm8wCV;E0Hh8wCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hk8wCV;E0Hn+wCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP66uCb;E0Hl+wCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPi7uCb;E0Hh+wCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPq7uCb;E0H/9wCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hi+wCV;E0H39wCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H69wCV;E0H19wCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H49wCV;E0H7/wCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPu8uCb;E0H5/wCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP28uCb;E0H1/wCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP+8uCb;E0Hz/wCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H2/wCV;E0Hr/wCM;IACI,anHgiCG;ImH/hCH,YAAA;E1Hu/wCV;E0Hp/wCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hs/wCV;E0HvhxCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPi+uCb;E0HthxCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPq+uCb;E0HphxCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPy+uCb;E0HnhxCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HqhxCV;E0H/gxCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HihxCV;E0H9gxCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HghxCV;E0HjjxCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP2/uCb;E0HhjxCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP+/uCb;E0H9ixCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPmgvCb;E0H7ixCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H+ixCV;E0HzixCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H2ixCV;E0HxixCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H0ixCV;E0H3kxCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPqhvCb;E0H1kxCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPyhvCb;E0HxkxCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP6hvCb;E0HvkxCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HykxCV;E0HnkxCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HqkxCV;E0HlkxCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HokxCV;AACF;AgB5ixCI;E0G1DA;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPijvCb;E0HtmxCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqjvCb;E0HpmxCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPyjvCb;E0HnmxCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HqmxCV;E0H/lxCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HimxCV;E0H9lxCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HgmxCV;E0HjoxCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP2kvCb;E0HhoxCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+kvCb;E0H9nxCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPmlvCb;E0H7nxCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+nxCV;E0HznxCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H2nxCV;E0HxnxCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H0nxCV;E0H3pxCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPqmvCb;E0H1pxCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPymvCb;E0HxpxCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP6mvCb;E0HvpxCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HypxCV;E0HnpxCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HqpxCV;E0HlpxCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HopxCV;E0HrrxCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+nvCb;E0HprxCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPmovCb;E0HlrxCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPuovCb;E0HjrxCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HmrxCV;E0H7qxCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H+qxCV;E0H5qxCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H8qxCV;E0H/sxCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPypvCb;E0H9sxCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP6pvCb;E0H5sxCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPiqvCb;E0H3sxCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H6sxCV;E0HvsxCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HysxCV;E0HtsxCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HwsxCV;E0HzuxCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPmrvCb;E0HxuxCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPurvCb;E0HtuxCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP2rvCb;E0HruxCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HuuxCV;E0HjuxCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1HmuxCV;E0HhuxCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1HkuxCV;E0HnwxCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP6svCb;E0HlwxCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPitvCb;E0HhwxCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPqtvCb;E0H/vxCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HiwxCV;E0H3vxCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1H6vxCV;E0H1vxCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1H4vxCV;E0H7xxCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPuuvCb;E0H5xxCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP2uvCb;E0H1xxCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP+uvCb;E0HzxxCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H2xxCV;E0HrxxCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1HuxxCV;E0HpxxCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1HsxxCV;E0HvzxCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPiwvCb;E0HtzxCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqwvCb;E0HpzxCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPywvCb;E0HnzxCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HqzxCV;E0H/yxCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HizxCV;E0H9yxCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HgzxCV;E0Hj1xCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP2xvCb;E0Hh1xCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+xvCb;E0H90xCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPmyvCb;E0H70xCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+0xCV;E0Hz0xCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H20xCV;E0Hx0xCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H00xCV;E0H32xCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPqzvCb;E0H12xCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPyzvCb;E0Hx2xCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP6zvCb;E0Hv2xCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hy2xCV;E0Hn2xCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hq2xCV;E0Hl2xCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Ho2xCV;E0Hr4xCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+0vCb;E0Hp4xCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPm1vCb;E0Hl4xCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPu1vCb;E0Hj4xCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hm4xCV;E0H73xCM;IACI,YnHgiCG;ImH/hCH,cAAA;E1H+3xCV;E0H53xCM;IACI,YnH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H83xCV;E0H/5xCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPy2vCb;E0H95xCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP62vCb;E0H55xCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPi3vCb;E0H35xCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H65xCV;E0Hv5xCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hy5xCV;E0Ht5xCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hw5xCV;E0Hz7xCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPm4vCb;E0Hx7xCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPu4vCb;E0Ht7xCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP24vCb;E0Hr7xCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hu7xCV;E0Hj7xCM;IACI,anHgiCG;ImH/hCH,YAAA;E1Hm7xCV;E0Hh7xCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hk7xCV;E0Hn9xCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP65vCb;E0Hl9xCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPi6vCb;E0Hh9xCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPq6vCb;E0H/8xCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hi9xCV;E0H38xCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H68xCV;E0H18xCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H48xCV;E0H7+xCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPu7vCb;E0H5+xCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP27vCb;E0H1+xCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP+7vCb;E0Hz+xCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H2+xCV;E0Hr+xCM;IACI,anHgiCG;ImH/hCH,YAAA;E1Hu+xCV;E0Hp+xCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hs+xCV;E0HvgyCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPi9vCb;E0HtgyCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPq9vCb;E0HpgyCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPy9vCb;E0HngyCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HqgyCV;E0H//xCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HigyCV;E0H9/xCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HggyCV;E0HjiyCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP2+vCb;E0HhiyCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP++vCb;E0H9hyCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPm/vCb;E0H7hyCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H+hyCV;E0HzhyCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H2hyCV;E0HxhyCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H0hyCV;E0H3jyCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPqgwCb;E0H1jyCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPygwCb;E0HxjyCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP6gwCb;E0HvjyCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HyjyCV;E0HnjyCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HqjyCV;E0HljyCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HojyCV;AACF;AgB5hyCI;E0G1DA;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPiiwCb;E0HtlyCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqiwCb;E0HplyCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPyiwCb;E0HnlyCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HqlyCV;E0H/kyCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HilyCV;E0H9kyCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HglyCV;E0HjnyCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP2jwCb;E0HhnyCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+jwCb;E0H9myCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPmkwCb;E0H7myCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+myCV;E0HzmyCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H2myCV;E0HxmyCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H0myCV;E0H3oyCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPqlwCb;E0H1oyCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPylwCb;E0HxoyCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP6lwCb;E0HvoyCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HyoyCV;E0HnoyCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HqoyCV;E0HloyCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HooyCV;E0HrqyCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+mwCb;E0HpqyCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPmnwCb;E0HlqyCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPunwCb;E0HjqyCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HmqyCV;E0H7pyCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H+pyCV;E0H5pyCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H8pyCV;E0H/ryCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPyowCb;E0H9ryCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP6owCb;E0H5ryCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPipwCb;E0H3ryCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H6ryCV;E0HvryCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HyryCV;E0HtryCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HwryCV;E0HztyCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPmqwCb;E0HxtyCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPuqwCb;E0HttyCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP2qwCb;E0HrtyCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HutyCV;E0HjtyCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1HmtyCV;E0HhtyCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1HktyCV;E0HnvyCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP6rwCb;E0HlvyCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPiswCb;E0HhvyCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPqswCb;E0H/uyCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HivyCV;E0H3uyCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1H6uyCV;E0H1uyCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1H4uyCV;E0H7wyCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPutwCb;E0H5wyCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP2twCb;E0H1wyCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP+twCb;E0HzwyCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H2wyCV;E0HrwyCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1HuwyCV;E0HpwyCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1HswyCV;E0HvyyCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPivwCb;E0HtyyCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPqvwCb;E0HpyyCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPyvwCb;E0HnyyCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1HqyyCV;E0H/xyCM;IACI,YnHgiCG;ImH/hCH,WAAA;E1HiyyCV;E0H9xyCM;IACI,YnH2hCG;ImH1hCH,WAAA;IACA,eAAA;E1HgyyCV;E0Hj0yCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP2wwCb;E0Hh0yCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP+wwCb;E0H9zyCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPmxwCb;E0H7zyCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H+zyCV;E0HzzyCM;IACI,YnHgiCG;ImH/hCH,aAAA;E1H2zyCV;E0HxzyCM;IACI,YnH2hCG;ImH1hCH,aAAA;IACA,eAAA;E1H0zyCV;E0H31yCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPqywCb;E0H11yCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPyywCb;E0Hx1yCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EP6ywCb;E0Hv1yCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hy1yCV;E0Hn1yCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hq1yCV;E0Hl1yCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Ho1yCV;E0Hr3yCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EP+zwCb;E0Hp3yCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EPm0wCb;E0Hl3yCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPu0wCb;E0Hj3yCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1Hm3yCV;E0H72yCM;IACI,YnHgiCG;ImH/hCH,cAAA;E1H+2yCV;E0H52yCM;IACI,YnH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H82yCV;E0H/4yCE;IACI,WnHyjCO;ImHxjCP,YnHwjCO;EPy1wCb;E0H94yCE;IACI,WnHojCO;ImHnjCP,YnHmjCO;EP61wCb;E0H54yCM;IACI,WnH8iCG;ImH7iCH,YnH6iCG;EPi2wCb;E0H34yCM;IACI,WnHyiCG;ImHxiCH,YnHwiCG;ImHviCH,eAAA;E1H64yCV;E0Hv4yCM;IACI,YnHgiCG;ImH/hCH,YAAA;E1Hy4yCV;E0Ht4yCM;IACI,YnH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hw4yCV;E0Hz6yCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPm3wCb;E0Hx6yCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPu3wCb;E0Ht6yCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP23wCb;E0Hr6yCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hu6yCV;E0Hj6yCM;IACI,anHgiCG;ImH/hCH,YAAA;E1Hm6yCV;E0Hh6yCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hk6yCV;E0Hn8yCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP64wCb;E0Hl8yCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPi5wCb;E0Hh8yCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPq5wCb;E0H/7yCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hi8yCV;E0H37yCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H67yCV;E0H17yCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H47yCV;E0H79yCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPu6wCb;E0H59yCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP26wCb;E0H19yCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP+6wCb;E0Hz9yCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H29yCV;E0Hr9yCM;IACI,anHgiCG;ImH/hCH,YAAA;E1Hu9yCV;E0Hp9yCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hs9yCV;E0Hv/yCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPi8wCb;E0Ht/yCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPq8wCb;E0Hp/yCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPy8wCb;E0Hn/yCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1Hq/yCV;E0H/+yCM;IACI,anHgiCG;ImH/hCH,YAAA;E1Hi/yCV;E0H9+yCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1Hg/yCV;E0HjhzCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EP29wCb;E0HhhzCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EP+9wCb;E0H9gzCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EPm+wCb;E0H7gzCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1H+gzCV;E0HzgzCM;IACI,anHgiCG;ImH/hCH,cAAA;E1H2gzCV;E0HxgzCM;IACI,anH2hCG;ImH1hCH,cAAA;IACA,eAAA;E1H0gzCV;E0H3izCE;IACI,YnHyjCO;ImHxjCP,anHwjCO;EPq/wCb;E0H1izCE;IACI,YnHojCO;ImHnjCP,anHmjCO;EPy/wCb;E0HxizCM;IACI,YnH8iCG;ImH7iCH,anH6iCG;EP6/wCb;E0HvizCM;IACI,YnHyiCG;ImHxiCH,anHwiCG;ImHviCH,eAAA;E1HyizCV;E0HnizCM;IACI,anHgiCG;ImH/hCH,YAAA;E1HqizCV;E0HlizCM;IACI,anH2hCG;ImH1hCH,YAAA;IACA,eAAA;E1HoizCV;AACF;;AyHp/yCA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AzHu/yCJ;AyHr/yCI;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AzHu/yCR;AyHr/yCQ;EACI,yBAAA;EACA,UAAA;AzHu/yCZ;AyHn/yCI;EACI,mCAAA;AzHq/yCR;AyHl/yCI;EACI,kBAAA;AzHo/yCR;AyHl/yCQ;EACI,cAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,+CAAA;EACA,oCAAA,EAAA,eAAA;EACA,4BAAA,EAAA,wCAAA;AzHo/yCZ;AyH/+yCQ;EACI,eAAA;AzHi/yCZ;;A2H5mzCA;EACI,kBAAA;A3H+mzCJ;A2H1mzCY;EACI,6BAAA;A3H4mzChB;A2H7mzCY;EACI,+BAAA;A3H+mzChB;A2HhnzCY;EACI,iCAAA;A3HknzChB;A2HnnzCY;EACI,+BAAA;A3HqnzChB;A2HtnzCY;EACI,4BAAA;A3HwnzChB;A2HznzCY;EACI,+BAAA;A3H2nzChB;A2H5nzCY;EACI,8BAAA;A3H8nzChB;A2H/nzCY;EACI,4BAAA;A3HiozChB;;A2H3nzCA;EACI,cAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,mCAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;A3H8nzCJ;;A2H3nzCA;EACI;IAAI,kCAAA;IAAoC,UAAA;E3HgozC1C;E2H/nzCE;IAAK,kCAAA;IAAoC,UAAA;E3HmozC3C;E2HlozCE;IAAK,UAAA;E3HqozCP;E2HpozCE;IAAM,kCAAA;IAAoC,UAAA;E3HwozC5C;AACF;A4HzqzCA;;EAEI,2BAAA;A5H2qzCJ;;A4HvqzCA;EACC,mCAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACG,aAAA;A5H0qzCJ;A4HxqzCC;EAEC,aAAA;EACA,uBAAA;EACG,mBAAA;A5HyqzCL;;A6H9rzCA;EACI,eAAA;EACA,aAAA;EACA,eAAA;EACA,YtHkmCgB;EsHjmChB,uBAAA;EACA,mBAAA;EACA,WtHumCa;EsHtmCb,YtHsmCa;EsHrmCb,YtHimCe;EsHhmCf,WtHkmCY;EsHjmCZ,8CAAA;EACA,0CAAA;EACA,UtH0lCgB;EsHzlChB,2BtH0Tc;ECzTd,sBAAA;ARiszCJ;A6H/rzCI;EAEI,qCAAA;A7HgszCR;AkGjtzCI;EACI,YAAA;EACA,WAAA;AlGmtzCR;A6HjszCI;EACI,iBAAA;EACA,qCAAA;A7HmszCR;A6HhszCI;EACI,oDAAA;A7HkszCR;A6HhszCQ;;EAEI,2CAAA;A7HkszCZ;A6H9rzCI;EACI,uCAAA;EACA,8CAAA;EACA,aAAA;A7HgszCR;A6H9rzCQ;EACI,2BtH8RM;EsH7RN,0CAAA;A7HgszCZ;;AgBnqzCI;E6GpBA;IACI,YtHsjCkB;IsHrjClB,WtHujCe;IsHtjCf,WtHwjCgB;IsHvjChB,YtHujCgB;EPooxCtB;AACF;A6HvrzCA;EACI;IAAS,oBAAA;E7H0rzCX;E6HzrzCE;IAAM,gBAAA;E7H4rzCR;AACF;A8H5vzCA;EACI,cAAA;EACA,2BAAA;A9H8vzCJ;AkG9vzCI;EACI,eAAA;EACA,cAAA;AlGgwzCR;A8H7vzCQ;EACI,2BAAA;A9H+vzCZ;A8HhwzCQ;EACI,6BAAA;A9HkwzCZ;A8HnwzCQ;EACI,+BAAA;A9HqwzCZ;A8HtwzCQ;EACI,2BAAA;A9HwwzCZ;A8HzwzCQ;EACI,6BAAA;A9H2wzCZ;A8H5wzCQ;EACI,0BAAA;A9H8wzCZ;A8H/wzCQ;EACI,6BAAA;A9HixzCZ;A8HlxzCQ;EACI,4BAAA;A9HoxzCZ;A8HrxzCQ;EACI,0BAAA;A9HuxzCZ;A8HxxzCQ;EACI,2BAAA;A9H0xzCZ;A8H3xzCQ;EACI,8BAAA;A9H6xzCZ;A8H9xzCQ;EACI,8BAAA;A9HgyzCZ;A8HjyzCQ;EACI,8BAAA;A9HmyzCZ;A8HpyzCQ;EACI,8BAAA;A9HsyzCZ;A8HvyzCQ;EACI,8BAAA;A9HyyzCZ;A8H1yzCQ;EACI,8BAAA;A9H4yzCZ;A8H7yzCQ;EACI,8BAAA;A9H+yzCZ;A8HhzzCQ;EACI,8BAAA;A9HkzzCZ;A8HnzzCQ;EACI,8BAAA;A9HqzzCZ;AkG3zzCI;EACI,0BAAA;EACA,yBAAA;AlG6zzCR;AkG/zzCI;EACI,yBAAA;EACA,wBAAA;AlGi0zCR;AkGn0zCI;EACI,0BAAA;EACA,yBAAA;AlGq0zCR;AkGv0zCI;EACI,0BAAA;EACA,yBAAA;AlGy0zCR;AkG30zCI;EACI,0BAAA;EACA,yBAAA;AlG60zCR;AkG/0zCI;EACI,2BAAA;EACA,0BAAA;AlGi1zCR;AkGn1zCI;EACI,0BAAA;EACA,yBAAA;AlGq1zCR;AkGv1zCI;EACI,0BAAA;EACA,yBAAA;AlGy1zCR;AkG31zCI;EACI,0BAAA;EACA,yBAAA;AlG61zCR;AkG/1zCI;EACI,yBAAA;EACA,wBAAA;AlGi2zCR;AkGn2zCI;EACI,0BAAA;EACA,yBAAA;AlGq2zCR;AkGv2zCI;EACI,uBAAA;EACA,sBAAA;AlGy2zCR;AkG32zCI;EACI,2BAAA;EACA,0BAAA;AlG62zCR;AkG/2zCI;EACI,0BAAA;EACA,yBAAA;AlGi3zCR;AkGn3zCI;EACI,uBAAA;EACA,sBAAA;AlGq3zCR;AkGv3zCI;EACI,uBAAA;EACA,sBAAA;AlGy3zCR;AkG33zCI;EACI,0BAAA;EACA,yBAAA;AlG63zCR;AkG/3zCI;EACI,yBAAA;EACA,wBAAA;AlGi4zCR;AkGn4zCI;EACI,0BAAA;EACA,yBAAA;AlGq4zCR;AkGv4zCI;EACI,uBAAA;EACA,sBAAA;AlGy4zCR;AkG34zCI;EACI,0BAAA;EACA,yBAAA;AlG64zCR;AkG/4zCI;EACI,yBAAA;EACA,wBAAA;AlGi5zCR;AkGn5zCI;EACI,0BAAA;EACA,yBAAA;AlGq5zCR;AkGv5zCI;EACI,uBAAA;EACA,sBAAA;AlGy5zCR;AkG35zCI;EACI,0BAAA;EACA,yBAAA;AlG65zCR;AkG/5zCI;EACI,yBAAA;EACA,wBAAA;AlGi6zCR;AkGn6zCI;EACI,0BAAA;EACA,yBAAA;AlGq6zCR;AkGv6zCI;EACI,uBAAA;EACA,sBAAA;AlGy6zCR;AkG36zCI;EACI,0BAAA;EACA,yBAAA;AlG66zCR;AkG/6zCI;EACI,yBAAA;EACA,wBAAA;AlGi7zCR;AkGn7zCI;EACI,0BAAA;EACA,yBAAA;AlGq7zCR;AkGv7zCI;EACI,uBAAA;EACA,sBAAA;AlGy7zCR;AkG37zCI;EACI,0BAAA;EACA,yBAAA;AlG67zCR;AkG/7zCI;EACI,yBAAA;EACA,wBAAA;AlGi8zCR;AkGn8zCI;EACI,0BAAA;EACA,yBAAA;AlGq8zCR;AkGv8zCI;EACI,uBAAA;EACA,sBAAA;AlGy8zCR;AkG38zCI;EACI,0BAAA;EACA,yBAAA;AlG68zCR;AkG/8zCI;EACI,yBAAA;EACA,wBAAA;AlGi9zCR;AkGn9zCI;EACI,0BAAA;EACA,yBAAA;AlGq9zCR;AgB95zCI;EkFzDA;IACI,0BAAA;IACA,yBAAA;ElG09zCN;EkG59zCE;IACI,yBAAA;IACA,wBAAA;ElG89zCN;EkGh+zCE;IACI,0BAAA;IACA,yBAAA;ElGk+zCN;EkGp+zCE;IACI,0BAAA;IACA,yBAAA;ElGs+zCN;EkGx+zCE;IACI,0BAAA;IACA,yBAAA;ElG0+zCN;EkG5+zCE;IACI,2BAAA;IACA,0BAAA;ElG8+zCN;EkGh/zCE;IACI,0BAAA;IACA,yBAAA;ElGk/zCN;EkGp/zCE;IACI,0BAAA;IACA,yBAAA;ElGs/zCN;EkGx/zCE;IACI,0BAAA;IACA,yBAAA;ElG0/zCN;EkG5/zCE;IACI,yBAAA;IACA,wBAAA;ElG8/zCN;EkGhg0CE;IACI,0BAAA;IACA,yBAAA;ElGkg0CN;EkGpg0CE;IACI,uBAAA;IACA,sBAAA;ElGsg0CN;EkGxg0CE;IACI,2BAAA;IACA,0BAAA;ElG0g0CN;EkG5g0CE;IACI,0BAAA;IACA,yBAAA;ElG8g0CN;EkGhh0CE;IACI,uBAAA;IACA,sBAAA;ElGkh0CN;EkGph0CE;IACI,uBAAA;IACA,sBAAA;ElGsh0CN;EkGxh0CE;IACI,0BAAA;IACA,yBAAA;ElG0h0CN;EkG5h0CE;IACI,yBAAA;IACA,wBAAA;ElG8h0CN;EkGhi0CE;IACI,0BAAA;IACA,yBAAA;ElGki0CN;EkGpi0CE;IACI,uBAAA;IACA,sBAAA;ElGsi0CN;EkGxi0CE;IACI,0BAAA;IACA,yBAAA;ElG0i0CN;EkG5i0CE;IACI,yBAAA;IACA,wBAAA;ElG8i0CN;EkGhj0CE;IACI,0BAAA;IACA,yBAAA;ElGkj0CN;EkGpj0CE;IACI,uBAAA;IACA,sBAAA;ElGsj0CN;EkGxj0CE;IACI,0BAAA;IACA,yBAAA;ElG0j0CN;EkG5j0CE;IACI,yBAAA;IACA,wBAAA;ElG8j0CN;EkGhk0CE;IACI,0BAAA;IACA,yBAAA;ElGkk0CN;EkGpk0CE;IACI,uBAAA;IACA,sBAAA;ElGsk0CN;EkGxk0CE;IACI,0BAAA;IACA,yBAAA;ElG0k0CN;EkG5k0CE;IACI,yBAAA;IACA,wBAAA;ElG8k0CN;EkGhl0CE;IACI,0BAAA;IACA,yBAAA;ElGkl0CN;EkGpl0CE;IACI,uBAAA;IACA,sBAAA;ElGsl0CN;EkGxl0CE;IACI,0BAAA;IACA,yBAAA;ElG0l0CN;EkG5l0CE;IACI,yBAAA;IACA,wBAAA;ElG8l0CN;EkGhm0CE;IACI,0BAAA;IACA,yBAAA;ElGkm0CN;EkGpm0CE;IACI,uBAAA;IACA,sBAAA;ElGsm0CN;EkGxm0CE;IACI,0BAAA;IACA,yBAAA;ElG0m0CN;EkG5m0CE;IACI,yBAAA;IACA,wBAAA;ElG8m0CN;EkGhn0CE;IACI,0BAAA;IACA,yBAAA;ElGkn0CN;AACF;AgB5j0CI;EkFzDA;IACI,0BAAA;IACA,yBAAA;ElGwn0CN;EkG1n0CE;IACI,yBAAA;IACA,wBAAA;ElG4n0CN;EkG9n0CE;IACI,0BAAA;IACA,yBAAA;ElGgo0CN;EkGlo0CE;IACI,0BAAA;IACA,yBAAA;ElGoo0CN;EkGto0CE;IACI,0BAAA;IACA,yBAAA;ElGwo0CN;EkG1o0CE;IACI,2BAAA;IACA,0BAAA;ElG4o0CN;EkG9o0CE;IACI,0BAAA;IACA,yBAAA;ElGgp0CN;EkGlp0CE;IACI,0BAAA;IACA,yBAAA;ElGop0CN;EkGtp0CE;IACI,0BAAA;IACA,yBAAA;ElGwp0CN;EkG1p0CE;IACI,yBAAA;IACA,wBAAA;ElG4p0CN;EkG9p0CE;IACI,0BAAA;IACA,yBAAA;ElGgq0CN;EkGlq0CE;IACI,uBAAA;IACA,sBAAA;ElGoq0CN;EkGtq0CE;IACI,2BAAA;IACA,0BAAA;ElGwq0CN;EkG1q0CE;IACI,0BAAA;IACA,yBAAA;ElG4q0CN;EkG9q0CE;IACI,uBAAA;IACA,sBAAA;ElGgr0CN;EkGlr0CE;IACI,uBAAA;IACA,sBAAA;ElGor0CN;EkGtr0CE;IACI,0BAAA;IACA,yBAAA;ElGwr0CN;EkG1r0CE;IACI,yBAAA;IACA,wBAAA;ElG4r0CN;EkG9r0CE;IACI,0BAAA;IACA,yBAAA;ElGgs0CN;EkGls0CE;IACI,uBAAA;IACA,sBAAA;ElGos0CN;EkGts0CE;IACI,0BAAA;IACA,yBAAA;ElGws0CN;EkG1s0CE;IACI,yBAAA;IACA,wBAAA;ElG4s0CN;EkG9s0CE;IACI,0BAAA;IACA,yBAAA;ElGgt0CN;EkGlt0CE;IACI,uBAAA;IACA,sBAAA;ElGot0CN;EkGtt0CE;IACI,0BAAA;IACA,yBAAA;ElGwt0CN;EkG1t0CE;IACI,yBAAA;IACA,wBAAA;ElG4t0CN;EkG9t0CE;IACI,0BAAA;IACA,yBAAA;ElGgu0CN;EkGlu0CE;IACI,uBAAA;IACA,sBAAA;ElGou0CN;EkGtu0CE;IACI,0BAAA;IACA,yBAAA;ElGwu0CN;EkG1u0CE;IACI,yBAAA;IACA,wBAAA;ElG4u0CN;EkG9u0CE;IACI,0BAAA;IACA,yBAAA;ElGgv0CN;EkGlv0CE;IACI,uBAAA;IACA,sBAAA;ElGov0CN;EkGtv0CE;IACI,0BAAA;IACA,yBAAA;ElGwv0CN;EkG1v0CE;IACI,yBAAA;IACA,wBAAA;ElG4v0CN;EkG9v0CE;IACI,0BAAA;IACA,yBAAA;ElGgw0CN;EkGlw0CE;IACI,uBAAA;IACA,sBAAA;ElGow0CN;EkGtw0CE;IACI,0BAAA;IACA,yBAAA;ElGww0CN;EkG1w0CE;IACI,yBAAA;IACA,wBAAA;ElG4w0CN;EkG9w0CE;IACI,0BAAA;IACA,yBAAA;ElGgx0CN;AACF;AgB1t0CI;EkFzDA;IACI,0BAAA;IACA,yBAAA;ElGsx0CN;EkGxx0CE;IACI,yBAAA;IACA,wBAAA;ElG0x0CN;EkG5x0CE;IACI,0BAAA;IACA,yBAAA;ElG8x0CN;EkGhy0CE;IACI,0BAAA;IACA,yBAAA;ElGky0CN;EkGpy0CE;IACI,0BAAA;IACA,yBAAA;ElGsy0CN;EkGxy0CE;IACI,2BAAA;IACA,0BAAA;ElG0y0CN;EkG5y0CE;IACI,0BAAA;IACA,yBAAA;ElG8y0CN;EkGhz0CE;IACI,0BAAA;IACA,yBAAA;ElGkz0CN;EkGpz0CE;IACI,0BAAA;IACA,yBAAA;ElGsz0CN;EkGxz0CE;IACI,yBAAA;IACA,wBAAA;ElG0z0CN;EkG5z0CE;IACI,0BAAA;IACA,yBAAA;ElG8z0CN;EkGh00CE;IACI,uBAAA;IACA,sBAAA;ElGk00CN;EkGp00CE;IACI,2BAAA;IACA,0BAAA;ElGs00CN;EkGx00CE;IACI,0BAAA;IACA,yBAAA;ElG000CN;EkG500CE;IACI,uBAAA;IACA,sBAAA;ElG800CN;EkGh10CE;IACI,uBAAA;IACA,sBAAA;ElGk10CN;EkGp10CE;IACI,0BAAA;IACA,yBAAA;ElGs10CN;EkGx10CE;IACI,yBAAA;IACA,wBAAA;ElG010CN;EkG510CE;IACI,0BAAA;IACA,yBAAA;ElG810CN;EkGh20CE;IACI,uBAAA;IACA,sBAAA;ElGk20CN;EkGp20CE;IACI,0BAAA;IACA,yBAAA;ElGs20CN;EkGx20CE;IACI,yBAAA;IACA,wBAAA;ElG020CN;EkG520CE;IACI,0BAAA;IACA,yBAAA;ElG820CN;EkGh30CE;IACI,uBAAA;IACA,sBAAA;ElGk30CN;EkGp30CE;IACI,0BAAA;IACA,yBAAA;ElGs30CN;EkGx30CE;IACI,yBAAA;IACA,wBAAA;ElG030CN;EkG530CE;IACI,0BAAA;IACA,yBAAA;ElG830CN;EkGh40CE;IACI,uBAAA;IACA,sBAAA;ElGk40CN;EkGp40CE;IACI,0BAAA;IACA,yBAAA;ElGs40CN;EkGx40CE;IACI,yBAAA;IACA,wBAAA;ElG040CN;EkG540CE;IACI,0BAAA;IACA,yBAAA;ElG840CN;EkGh50CE;IACI,uBAAA;IACA,sBAAA;ElGk50CN;EkGp50CE;IACI,0BAAA;IACA,yBAAA;ElGs50CN;EkGx50CE;IACI,yBAAA;IACA,wBAAA;ElG050CN;EkG550CE;IACI,0BAAA;IACA,yBAAA;ElG850CN;EkGh60CE;IACI,uBAAA;IACA,sBAAA;ElGk60CN;EkGp60CE;IACI,0BAAA;IACA,yBAAA;ElGs60CN;EkGx60CE;IACI,yBAAA;IACA,wBAAA;ElG060CN;EkG560CE;IACI,0BAAA;IACA,yBAAA;ElG860CN;AACF;AgBx30CI;EkFzDA;IACI,0BAAA;IACA,yBAAA;ElGo70CN;EkGt70CE;IACI,yBAAA;IACA,wBAAA;ElGw70CN;EkG170CE;IACI,0BAAA;IACA,yBAAA;ElG470CN;EkG970CE;IACI,0BAAA;IACA,yBAAA;ElGg80CN;EkGl80CE;IACI,0BAAA;IACA,yBAAA;ElGo80CN;EkGt80CE;IACI,2BAAA;IACA,0BAAA;ElGw80CN;EkG180CE;IACI,0BAAA;IACA,yBAAA;ElG480CN;EkG980CE;IACI,0BAAA;IACA,yBAAA;ElGg90CN;EkGl90CE;IACI,0BAAA;IACA,yBAAA;ElGo90CN;EkGt90CE;IACI,yBAAA;IACA,wBAAA;ElGw90CN;EkG190CE;IACI,0BAAA;IACA,yBAAA;ElG490CN;EkG990CE;IACI,uBAAA;IACA,sBAAA;ElGg+0CN;EkGl+0CE;IACI,2BAAA;IACA,0BAAA;ElGo+0CN;EkGt+0CE;IACI,0BAAA;IACA,yBAAA;ElGw+0CN;EkG1+0CE;IACI,uBAAA;IACA,sBAAA;ElG4+0CN;EkG9+0CE;IACI,uBAAA;IACA,sBAAA;ElGg/0CN;EkGl/0CE;IACI,0BAAA;IACA,yBAAA;ElGo/0CN;EkGt/0CE;IACI,yBAAA;IACA,wBAAA;ElGw/0CN;EkG1/0CE;IACI,0BAAA;IACA,yBAAA;ElG4/0CN;EkG9/0CE;IACI,uBAAA;IACA,sBAAA;ElGgg1CN;EkGlg1CE;IACI,0BAAA;IACA,yBAAA;ElGog1CN;EkGtg1CE;IACI,yBAAA;IACA,wBAAA;ElGwg1CN;EkG1g1CE;IACI,0BAAA;IACA,yBAAA;ElG4g1CN;EkG9g1CE;IACI,uBAAA;IACA,sBAAA;ElGgh1CN;EkGlh1CE;IACI,0BAAA;IACA,yBAAA;ElGoh1CN;EkGth1CE;IACI,yBAAA;IACA,wBAAA;ElGwh1CN;EkG1h1CE;IACI,0BAAA;IACA,yBAAA;ElG4h1CN;EkG9h1CE;IACI,uBAAA;IACA,sBAAA;ElGgi1CN;EkGli1CE;IACI,0BAAA;IACA,yBAAA;ElGoi1CN;EkGti1CE;IACI,yBAAA;IACA,wBAAA;ElGwi1CN;EkG1i1CE;IACI,0BAAA;IACA,yBAAA;ElG4i1CN;EkG9i1CE;IACI,uBAAA;IACA,sBAAA;ElGgj1CN;EkGlj1CE;IACI,0BAAA;IACA,yBAAA;ElGoj1CN;EkGtj1CE;IACI,yBAAA;IACA,wBAAA;ElGwj1CN;EkG1j1CE;IACI,0BAAA;IACA,yBAAA;ElG4j1CN;EkG9j1CE;IACI,uBAAA;IACA,sBAAA;ElGgk1CN;EkGlk1CE;IACI,0BAAA;IACA,yBAAA;ElGok1CN;EkGtk1CE;IACI,yBAAA;IACA,wBAAA;ElGwk1CN;EkG1k1CE;IACI,0BAAA;IACA,yBAAA;ElG4k1CN;AACF;AgBth1CI;EkFzDA;IACI,0BAAA;IACA,yBAAA;ElGkl1CN;EkGpl1CE;IACI,yBAAA;IACA,wBAAA;ElGsl1CN;EkGxl1CE;IACI,0BAAA;IACA,yBAAA;ElG0l1CN;EkG5l1CE;IACI,0BAAA;IACA,yBAAA;ElG8l1CN;EkGhm1CE;IACI,0BAAA;IACA,yBAAA;ElGkm1CN;EkGpm1CE;IACI,2BAAA;IACA,0BAAA;ElGsm1CN;EkGxm1CE;IACI,0BAAA;IACA,yBAAA;ElG0m1CN;EkG5m1CE;IACI,0BAAA;IACA,yBAAA;ElG8m1CN;EkGhn1CE;IACI,0BAAA;IACA,yBAAA;ElGkn1CN;EkGpn1CE;IACI,yBAAA;IACA,wBAAA;ElGsn1CN;EkGxn1CE;IACI,0BAAA;IACA,yBAAA;ElG0n1CN;EkG5n1CE;IACI,uBAAA;IACA,sBAAA;ElG8n1CN;EkGho1CE;IACI,2BAAA;IACA,0BAAA;ElGko1CN;EkGpo1CE;IACI,0BAAA;IACA,yBAAA;ElGso1CN;EkGxo1CE;IACI,uBAAA;IACA,sBAAA;ElG0o1CN;EkG5o1CE;IACI,uBAAA;IACA,sBAAA;ElG8o1CN;EkGhp1CE;IACI,0BAAA;IACA,yBAAA;ElGkp1CN;EkGpp1CE;IACI,yBAAA;IACA,wBAAA;ElGsp1CN;EkGxp1CE;IACI,0BAAA;IACA,yBAAA;ElG0p1CN;EkG5p1CE;IACI,uBAAA;IACA,sBAAA;ElG8p1CN;EkGhq1CE;IACI,0BAAA;IACA,yBAAA;ElGkq1CN;EkGpq1CE;IACI,yBAAA;IACA,wBAAA;ElGsq1CN;EkGxq1CE;IACI,0BAAA;IACA,yBAAA;ElG0q1CN;EkG5q1CE;IACI,uBAAA;IACA,sBAAA;ElG8q1CN;EkGhr1CE;IACI,0BAAA;IACA,yBAAA;ElGkr1CN;EkGpr1CE;IACI,yBAAA;IACA,wBAAA;ElGsr1CN;EkGxr1CE;IACI,0BAAA;IACA,yBAAA;ElG0r1CN;EkG5r1CE;IACI,uBAAA;IACA,sBAAA;ElG8r1CN;EkGhs1CE;IACI,0BAAA;IACA,yBAAA;ElGks1CN;EkGps1CE;IACI,yBAAA;IACA,wBAAA;ElGss1CN;EkGxs1CE;IACI,0BAAA;IACA,yBAAA;ElG0s1CN;EkG5s1CE;IACI,uBAAA;IACA,sBAAA;ElG8s1CN;EkGht1CE;IACI,0BAAA;IACA,yBAAA;ElGkt1CN;EkGpt1CE;IACI,yBAAA;IACA,wBAAA;ElGst1CN;EkGxt1CE;IACI,0BAAA;IACA,yBAAA;ElG0t1CN;EkG5t1CE;IACI,uBAAA;IACA,sBAAA;ElG8t1CN;EkGhu1CE;IACI,0BAAA;IACA,yBAAA;ElGku1CN;EkGpu1CE;IACI,yBAAA;IACA,wBAAA;ElGsu1CN;EkGxu1CE;IACI,0BAAA;IACA,yBAAA;ElG0u1CN;AACF;;A+H3u1CQ;EACI,eAAA;EACA,YxH8rCI;EwH7rCJ,MAAA;EACA,OAAA;EACA,QAAA;A/H8u1CZ;;AgB5r1CI;E+GvDI;IACI,eAAA;IACA,YxH8rCI;IwH7rCJ,MAAA;IACA,OAAA;IACA,QAAA;E/Huv1CV;AACF;AgBts1CI;E+GvDI;IACI,eAAA;IACA,YxH8rCI;IwH7rCJ,MAAA;IACA,OAAA;IACA,QAAA;E/Hgw1CV;AACF;AgB/s1CI;E+GvDI;IACI,eAAA;IACA,YxH8rCI;IwH7rCJ,MAAA;IACA,OAAA;IACA,QAAA;E/Hyw1CV;AACF;AgBxt1CI;E+GvDI;IACI,eAAA;IACA,YxH8rCI;IwH7rCJ,MAAA;IACA,OAAA;IACA,QAAA;E/Hkx1CV;AACF;AgBju1CI;E+GvDI;IACI,eAAA;IACA,YxH8rCI;IwH7rCJ,MAAA;IACA,OAAA;IACA,QAAA;E/H2x1CV;AACF;AgIpy1CA;EAEC,6BAAA;EACA,iCAAA;AhIqy1CD;AgIly1CC;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AhIoy1CF;AgIjy1CG;EACC,YAAA;AhImy1CJ;AgI7x1CC;EACC,cAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,iCAAA;EACA,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EACA,4CAAA;AhI+x1CF;AgI3x1CC;EACC,UAAA;EACA,cAAA;EACA,kBAAA;EACA,mCAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,kBAAA;AhI6x1CF;AgIzx1CC;EACC,WAAA;EACA,cAAA;EACA,qBAAA;AhI2x1CF;AgItx1CE;EACC,mBAAA;AhIwx1CH;AgIrx1CgB;EACI,QAAA;AhIux1CpB;AgIlx1CgB;EACI,WAAA;AhIox1CpB;AgI5w1CE;EACC,oCAAA;AhI8w1CH;AgI3w1CE;EACC,+BAAA;AhI6w1CH;;AiIp21CA;EACC,kBAAA;AjIu21CD;AiIn21CC;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;AjIq21CF;AiIj21CC;EACC,aAAA;EACM,uBAAA;EACN,kBAAA;EACA,qBAAA;AjIm21CF;AiIj21CQ;EACI,gBAAA;AjIm21CZ;AiI/11CC;EACC,WAzBgB;EA0BhB,cAAA;EACA,kBAAA;EACA,yBAAA;AjIi21CF;AiI911CC;EACC,cAAA;EACA,mCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,8CAAA;AjIg21CF;AiI711CC;EACC,YAAA;AjI+11CF;;AkIl51CA;EACI,kBAAA;AlIq51CJ;AkIn51CI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,UAAA;AlIq51CR;AkI/41CQ;EACI,yBAAA;EACA,UAAA;AlIi51CZ;AkI741CI;EACI,YAAA;AlI+41CR;;AmI161CA;EACI,qBAAA;EACA,2CAAA;E3HYA,kBAAA;E2HVA,U5H0lCe;E4HzlCf,W5HwlCgB;E4HvlChB,cAAA;AnI661CJ;;AmIz61CA;EACI,U5HilCc;E4HhlCd,W5HglCc;E4H/kCd,8BAAA;AnI461CJ;;AmIx61CA;EACI,U5H2kCgB;E4H1kChB,W5H2kCe;APg2zCnB;;AmIv61CA;EACI,U5HykCgB;E4HxkChB,W5HukCiB;E4HtkCjB,gBAAA;AnI061CJ;;AoIp81CA;EACC,wBAAA;EACA,cAAA;EACA,Y7HunCgB;E6HtnChB,eAAA;EACA,MAAA;EACA,SAAA;EACA,2CAAA;EACA,iDAAA;ApIu81CD;AoIr81CC;EACC,OAAA;EACA,4BAAA;ApIu81CF;AoIp81CC;EACC,QAAA;EACA,2BAAA;ApIs81CF;AoIn81CC;EACC,SAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;ApIq81CF;AoIl81CC;EACC,MAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,4BAAA;ApIo81CF;AoIj81CC;EACC,eAAA;EACA,uCAAA;EACA,iDAAA;ApIm81CF;;AoI971CA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,mDAAA;EACA,sDAAA;ApIi81CD;;AoI771CA;EACC,aAAA;ApIg81CD;;AoI571CA;EACC;IAAS,UAAA;EpIg81CR;EoI/71CD;IAAK,UAAA;EpIk81CJ;AACF;AgB571CI;EoHFH;IACC,gBAAA;EpIi81CA;AACF;AqIzg2CA;EACI,oBAAA;EACA,mBAAA;ArI2g2CJ;AqIxg2CI;EAEI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,e9Hw1BwB;E8Hv1BxB,kB9Hu1BwB;E8Ht1BxB,iBAAA;EACA,cAAA;ArIyg2CR;AqIrg2CI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,c9H60BwB;AP0r0ChC;AqIng2CI;EACI,iB9Hy0BwB;E8Hx0BxB,iB9Hg0BwB;APqs0ChC;AqIng2CQ;EACI,c9Hq0BoB;APgs0ChC;AqIlg2CQ;EACI,a9Hi0BoB;E8Hh0BpB,c9Hg0BoB;APos0ChC;AqIhg2CI;EACI,e9H4zBwB;E8H3zBxB,e9HmzBwB;AP+s0ChC;AqIhg2CQ;EACI,Y9HwzBoB;AP0s0ChC;AqI//1CQ;EACI,W9HozBoB;E8HnzBpB,Y9HmzBoB;AP8s0ChC;;AqI3/1CI;EACI,8BAAA;EACA,iCAAA;ArI8/1CR;AqI5/1CQ;EACI,iCAAA;EACA,sBAAA;EACA,6BAAA;ArI8/1CZ;;AqI1/1CI;EACI,sBAAA;EACA,uCAAA;ArI6/1CR;;AqI1g2CI;EACI,gCAAA;EACA,mCAAA;ArI6g2CR;AqI3g2CQ;EACI,mCAAA;EACA,wBAAA;EACA,6BAAA;ArI6g2CZ;;AqIzg2CI;EACI,wBAAA;EACA,yCAAA;ArI4g2CR;;AqIzh2CI;EACI,kCAAA;EACA,qCAAA;ArI4h2CR;AqI1h2CQ;EACI,qCAAA;EACA,0BAAA;EACA,6BAAA;ArI4h2CZ;;AqIxh2CI;EACI,0BAAA;EACA,2CAAA;ArI2h2CR;;AqIxi2CI;EACI,gCAAA;EACA,mCAAA;ArI2i2CR;AqIzi2CQ;EACI,mCAAA;EACA,wBAAA;EACA,6BAAA;ArI2i2CZ;;AqIvi2CI;EACI,wBAAA;EACA,yCAAA;ArI0i2CR;;AqIvj2CI;EACI,6BAAA;EACA,gCAAA;ArI0j2CR;AqIxj2CQ;EACI,gCAAA;EACA,qBAAA;EACA,6BAAA;ArI0j2CZ;;AqItj2CI;EACI,qBAAA;EACA,sCAAA;ArIyj2CR;;AqItk2CI;EACI,gCAAA;EACA,mCAAA;ArIyk2CR;AqIvk2CQ;EACI,mCAAA;EACA,wBAAA;EACA,6BAAA;ArIyk2CZ;;AqIrk2CI;EACI,wBAAA;EACA,yCAAA;ArIwk2CR;;AqIrl2CI;EACI,+BAAA;EACA,kCAAA;ArIwl2CR;AqItl2CQ;EACI,kCAAA;EACA,uBAAA;EACA,6BAAA;ArIwl2CZ;;AqIpl2CI;EACI,uBAAA;EACA,wCAAA;ArIul2CR;;AqIpm2CI;EACI,6BAAA;EACA,gCAAA;ArIum2CR;AqIrm2CQ;EACI,gCAAA;EACA,qBAAA;EACA,6BAAA;ArIum2CZ;;AqInm2CI;EACI,qBAAA;EACA,sCAAA;ArIsm2CR;;AsI1q2CA;EACI,aAAA;AtI6q2CJ;AsI3q2CI;EACI,qBAAA;AtI6q2CR;;AsIxq2CI;EACI,aAAA;AtI2q2CR;;AuIrr2CA;EACC,+BAAA;AvIwr2CD;AuItr2CC;EACC,4BAAA;EACA,+BAAA;EACA,sBAAA;AvIwr2CF;;AuIpr2CA;EACC,+BAAA;AvIur2CD;AuIrr2CC;EACC,2BAAA;EACA,+BAAA;EACA,sBAAA;AvIur2CF;;AuInr2CA;EACC,+BAAA;AvIsr2CD;AuIpr2CC;EACC,qBAAA;EACA,+BAAA;EACA,sBAAA;AvIsr2CF;;AuIlr2CA;EACC,+BAAA;AvIqr2CD;AuInr2CC;EACC,uBAAA;EACA,+BAAA;EACA,sBAAA;AvIqr2CF;;AuIjr2CA;EACC,+BAAA;AvIor2CD;AuIlr2CC;EACC,wBAAA;EACA,+BAAA;EACA,sBAAA;AvIor2CF;;AwI/t2CA;EACI,oBAAA;EACA,mBAAA;AxIku2CJ;;AwI9t2CI;EACI,+BATY;EAUZ,2BAAA;EACA,sBAAA;AxIiu2CR;AwI/t2CQ;EAGI,yBAAA;EACA,+BAjBQ;AxIgv2CpB;AwI7t2CY;EACI,0BAAA;AxI+t2ChB;;AwI1t2CI;EACI,+BA1BY;EA2BZ,2BAAA;EACA,sBAAA;AxI6t2CR;AwI3t2CQ;EAGI,0BAAA;EACA,+BAlCQ;AxI6v2CpB;AwIzt2CY;EACI,yBAAA;AxI2t2ChB;;AwIxv2CI;EACI,+BATY;EAUZ,2BAAA;EACA,sBAAA;AxI2v2CR;AwIzv2CQ;EAGI,0BAAA;EACA,+BAjBQ;AxI0w2CpB;AwIvv2CY;EACI,2BAAA;AxIyv2ChB;;AwIpv2CI;EACI,+BA1BY;EA2BZ,2BAAA;EACA,sBAAA;AxIuv2CR;AwIrv2CQ;EAGI,2BAAA;EACA,+BAlCQ;AxIux2CpB;AwInv2CY;EACI,0BAAA;AxIqv2ChB;;AwIlx2CI;EACI,+BATY;EAUZ,2BAAA;EACA,sBAAA;AxIqx2CR;AwInx2CQ;EAGI,0BAAA;EACA,+BAjBQ;AxIoy2CpB;AwIjx2CY;EACI,2BAAA;AxImx2ChB;;AwI9w2CI;EACI,+BA1BY;EA2BZ,2BAAA;EACA,sBAAA;AxIix2CR;AwI/w2CQ;EAGI,2BAAA;EACA,+BAlCQ;AxIiz2CpB;AwI7w2CY;EACI,0BAAA;AxI+w2ChB;;AgB1v2CI;EyHxDA;;;;;;IAOI,qBAAA;ICRJ,sDAAA;E1I8z2CF;EyInz2CM;;;;;;IACI,+BAAA;IACA,gCAAA;EzI0z2CV;EyIvz2CM;;;;;;IACG,6BAAA;EzI8z2CT;EyI3z2CM;;;;;;IjIPJ,uCAAA;ER002CF;E0Ip12CE;;;;;;IACI,2CDqByB;EzIs02C/B;E0Ix12CE;;;;;;IACI,6BAAA;E1I+12CN;E0I112CM;;;;;;IAEI,4DAAA;E1Ig22CV;E0I712CU;;;;;;IACI,iDDMmD;EzI812CjE;E0Ij22CU;;;;;;IACI,6BAAA;E1Iw22Cd;AACF;AyIl22CA;;;EAGI,gBAAA;EACA,kBAAA;AzIo22CJ;AgBh02CI;EyHxCJ;;;IAQQ,cAAA;EzIs22CN;AACF;;AyIn22CA;;;EAGI,kBAAA;EACA,kBAAA;AzIs22CJ;AgB902CI;EyH5BJ;;;IAQQ,gBAAA;EzIw22CN;AACF;;AyIr22CA;;;EAGI,kBAAA;EACA,kBAAA;AzIw22CJ;AgB512CI;EyHhBJ;;;IAQQ,gBAAA;EzI022CN;AACF;;AyIv22CA;;;;;;EClEI,wCAAA;A1Ik72CJ;A0I/62CI;;;;;;EACI,6BDoEqB;AzIk32C7B;A0In72CI;;;;;;EACI,6BAAA;A1I072CR;A0Ir72CQ;;;;;;EAEI,sDAAA;A1I272CZ;A0Ix72CY;;;;;;EACI,2CDqD0B;AzI042C1C;A0I572CY;;;;;;EACI,6BAAA;A1Im82ChB;;AyI142CQ;EACI,iDAAA;AzI642CZ;;AyI142CQ;EACI,gDAAA;AzI642CZ;;AyI142CQ;EACI,kDAAA;AzI642CZ;;AyI142CQ;EACI,kDAAA;AzI642CZ;;AyI142CQ;EACI,iDAAA;AzI642CZ;;AyI142CQ;EACI,iDAAA;EACA,kDAAA;AzI642CZ;;AyI142CQ;EACI,gDAAA;EACA,iDAAA;AzI642CZ;;AgB/72CI;EyHuBI;IACI,iDAAA;EzI462CV;EyIz62CM;IACI,gDAAA;EzI262CV;EyIx62CM;IACI,kDAAA;EzI062CV;EyIv62CM;IACI,kDAAA;EzIy62CV;EyIt62CM;IACI,iDAAA;EzIw62CV;EyIr62CM;IACI,iDAAA;IACA,kDAAA;EzIu62CV;EyIp62CM;IACI,gDAAA;IACA,iDAAA;EzIs62CV;AACF;AgBz92CI;EyHuBI;IACI,iDAAA;EzIq82CV;EyIl82CM;IACI,gDAAA;EzIo82CV;EyIj82CM;IACI,kDAAA;EzIm82CV;EyIh82CM;IACI,kDAAA;EzIk82CV;EyI/72CM;IACI,iDAAA;EzIi82CV;EyI972CM;IACI,iDAAA;IACA,kDAAA;EzIg82CV;EyI772CM;IACI,gDAAA;IACA,iDAAA;EzI+72CV;AACF;AgBl/2CI;EyHuBI;IACI,iDAAA;EzI892CV;EyI392CM;IACI,gDAAA;EzI692CV;EyI192CM;IACI,kDAAA;EzI492CV;EyIz92CM;IACI,kDAAA;EzI292CV;EyIx92CM;IACI,iDAAA;EzI092CV;EyIv92CM;IACI,iDAAA;IACA,kDAAA;EzIy92CV;EyIt92CM;IACI,gDAAA;IACA,iDAAA;EzIw92CV;AACF;AgB3g3CI;EyHuBI;IACI,iDAAA;EzIu/2CV;EyIp/2CM;IACI,gDAAA;EzIs/2CV;EyIn/2CM;IACI,kDAAA;EzIq/2CV;EyIl/2CM;IACI,kDAAA;EzIo/2CV;EyIj/2CM;IACI,iDAAA;EzIm/2CV;EyIh/2CM;IACI,iDAAA;IACA,kDAAA;EzIk/2CV;EyI/+2CM;IACI,gDAAA;IACA,iDAAA;EzIi/2CV;AACF;AgBpi3CI;EyHuBI;IACI,iDAAA;EzIgh3CV;EyI7g3CM;IACI,gDAAA;EzI+g3CV;EyI5g3CM;IACI,kDAAA;EzI8g3CV;EyI3g3CM;IACI,kDAAA;EzI6g3CV;EyI1g3CM;IACI,iDAAA;EzI4g3CV;EyIzg3CM;IACI,iDAAA;IACA,kDAAA;EzI2g3CV;EyIxg3CM;IACI,gDAAA;IACA,iDAAA;EzI0g3CV;AACF;A2Ixn3CA;EACI,aAAA;EACA,mBAAA;A3I0n3CJ;;A2Ivn3CA;EACI,6BAAA;EACA,wBAAA;A3I0n3CJ;A2Ixn3CI;EACI,aAAA;A3I0n3CR;;A2Itn3CA;EACI,UAAA;EACA,SAAA;A3Iyn3CJ;A2Ivn3CI;EAEI,cAAA;EACA,qCAAA;A3Iwn3CR;;A2Ipn3CA;EACI,eAAA;A3Iun3CJ;;A2Iln3CI;;;EAEI,oCAAA;A3Isn3CR;;A2Ijn3CI;EAEI,qCAAA;A3Imn3CR;;A2I9m3CI;EAEI,oCAAA;A3Ign3CR;;A2I5m3CA;EAKI,qCAAA;A3I2m3CJ;A2I/m3CI;EAEI,qCAAA;A3Ign3CR;;A4Inq3CC;;EAEC,aAAA;A5Isq3CF;A4Ipq3CE;;EACC,aAAA;A5Iuq3CH;A4Ilq3CC;EACC,eAAA;A5Ioq3CF;A4I/p3CE;EACC,aAAA;A5Iiq3CH;A4I9p3CE;EACC,aAAA;A5Igq3CH;A4I7p3CE;EACC,qBAAA;A5I+p3CH;A4I5p3CE;EACC,aAAA;A5I8p3CH;A4Izp3CE;EACC,aAAA;A5I2p3CH;A4Ixp3CE;EACC,qBAAA;A5I0p3CH;A4Ivp3CE;EACC,aAAA;A5Iyp3CH;A4Ipp3CE;EACC,qBAAA;A5Isp3CH;A4Inp3CE;EACC,qBAAA;A5Iqp3CH;A4Ilp3CE;EACC,aAAA;A5Iop3CH;A4I/o3CE;EACC,qBAAA;A5Iip3CH;A4I9o3CE;EACC,aAAA;A5Igp3CH;A4I7o3CE;EACC,qBAAA;A5I+o3CH;A4I5o3CE;EACC,aAAA;A5I8o3CH;A4I3o3CE;EACC,wBAAA;A5I6o3CH;A4I1o3CE;EACC,aAAA;A5I4o3CH;A4Izo3CE;EACC,aAAA;A5I2o3CH;A4Ixo3CE;EACC,qBAAA;A5I0o3CH;A4Ivo3CE;EACC,aAAA;A5Iyo3CH;;A6I1u3CA;EACI,6BAAA;EACA,oCAAA;EACA,kCAAA;EAEA,mDAAA;EACA,qDAAA;EACA,6DAAA;EAEA,2BAAA;EACA,mCAAA;EACA,qCAAA;EAEA,iDAAA;EACA,uDAAA;EAEA,0DAAA;EAEA,mCAAA;EACA,2CAAA;EACA,6CAAA;EAEA,kDAAA;EACA,0DAAA;EACA,8DAAA;EAEA,kCAAA;EACA,0CAAA;EACA,4CAAA;EAEA,mDAAA;EACA,yDAAA;EACA,2DAAA;EAEA,uDAAA;A7Iou3CJ;A6Iju3CI;EACI,aAAA;A7Imu3CR;A6I/t3CI;EACI,aAAA;EACA,mBAAA;EACA,2BtI0RU;APu82ClB;A6I9t3CQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BtIkRM;EsIjRN,mCAAA;EACA,oCAAA;EACA,mDAAA;EACA,iDAAA;EACA,qCAAA;EACA,oBAAA;A7Igu3CZ;A6I9t3CY;EACI,aAAA;EACA,4CAAA;A7Igu3ChB;A6I7t3CY;EACI,gBtI8SG;EsI7SH,0CAAA;EACA,kBAAA;A7I+t3ChB;A6I1t3CQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;A7I4t3CZ;A6I1t3CY;EACI,0CAAA;EACA,8CAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;A7I4t3ChB;A6Izt3CY;EACI,6CAAA;EACA,yCAAA;A7I2t3ChB;A6Itt3CQ;EACI,2BtIwOM;APg/2ClB;A6Itt3CY;EACI,2BtIqOE;EsIpOF,yDAAA;EACA,6CAAA;A7Iwt3ChB;A6Itt3CgB;EACI,aAAA;A7Iwt3CpB;A6Irt3CgB;EACI,kDAAA;EACA,kBAAA;A7Iut3CpB;A6Ilt3CgB;EACI,sDAAA;EACA,kDAAA;A7Iot3CpB;A6Ijt3CgB;EACI,qDAAA;EACA,iDAAA;A7Imt3CpB;A6I3s3CY;EACI,2BtIsME;EsIrMF,2DAAA;EACA,+CAAA;A7I6s3ChB;A6I3s3CgB;EACI,mDAAA;EACA,qBAAA;A7I6s3CpB;A6I1s3CgB;EACI,aAAA;A7I4s3CpB;A6Ivs3CgB;EACI,wDAAA;EACA,oDAAA;A7Iys3CpB;A6Its3CgB;EACI,uDAAA;EACA,mDAAA;A7Iws3CpB;A6I/r3CQ;EACI,sBAAA;EACA,kBAAA;A7Iis3CZ;A6I7r3CQ;EACI,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;EACN,SAAA;A7I+r3CN;A6I3r3CQ;EACI,aAAA;EACA,mBAAA;A7I6r3CZ;A6Izr3CQ;EACI,UAAA;A7I2r3CZ;A6Ivr3CQ;EACI,cAAA;EACA,YAAA;EACA,mDAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;A7Iyr3CZ;;A8Ix33CI;EACF,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;A9I233CF;A8Iz33CQ;EACL,kBAAA;EACA,cAAA;EACA,mBAAA;A9I233CH;A8Iz33CG;EACC,YAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,2BvIkTc;APyk3ClB;A8Ix33CY;EACI,yBAAA;EACA,gBAAA;EACA,kBAAA;A9I033ChB;A8It33CY;EACR,2BvIuSc;APil3ClB;A8It33CI;EACC,wBAAA;A9Iw33CL;A8Ir33CI;EACC,mCAAA;A9Iu33CL;A8Ij33CI;EACC,yBAAA;A9Im33CL;;A+I/53CQ;EACI,aAAA;A/Ik63CZ;A+I553CQ;EACI,aAAA;A/I853CZ;;AgJz63CA;ECuBC,smCAAA;AjJs53CD;;AgJx63CA;ECkBC,8mDAAA;AjJ053CD;;AkJh73CA;EACC,kBAAA;AlJm73CD;AkJh73CC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,2CAAA;EACA,6CAAA;EACA,gCAAA;EACA,QAAA;EACA,QAAA;EACA,2CAAA;AlJk73CF;AkJh73CE;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AlJk73CH;AkJ/63CE;EACC,iDAAA;AlJi73CH;AkJ363CE;EACC,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AlJ663CH;AkJx63CE;EACC,MAAA;EACA,6CAAA;EACA,mC1D5CiC;E0D6CjC,kC1D7CiC;AxFu93CpC;AkJr63CE;EACC,gC1DnDiC;E0DoDjC,+B1DpDiC;AxF293CpC;AkJl63CE;EACC,QAAA;EACA,OAAA;EACA,WAAA;EACA,4CAAA;EACA,gC1D9DiC;E0D+DjC,mC1D/DiC;AxFm+3CpC;AkJ/53CE;EACC,+B1DrEiC;E0DsEjC,kC1DtEiC;AxFu+3CpC;;AkJz53CE;EACC,UAAA;AlJ453CH;AkJ153CG;EACC,gC1DlFgC;E0DmFhC,mC1DnFgC;AxF++3CpC;AkJ153CI;EAEC,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AlJ253CL;AkJx53CI;EACC,2BAAA;EACA,uDAAA;EACA,OAAA;AlJ053CL;AkJn53CE;EACC,WAAA;AlJq53CH;AkJn53CG;EACC,+B1D5GgC;E0D6GhC,kC1D7GgC;AxFkg4CpC;AkJn53CI;EAEC,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;AlJo53CL;AkJj53CI;EACC,2BAAA;EACA,sDAAA;EACA,QAAA;AlJm53CL;;AkJ343CA;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;AlJ843CD;AkJ343CC;EACC,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,mCAAA;EACA,+CAAA;EACA,kCAAA;AlJ643CF;AkJz43CC;EACC,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,8CAAA;EACA,oCAAA;EACA,kCAAA;AlJ243CF;AkJv43CC;EACC,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,mCAAA;EACA,+CAAA;EACA,6CAAA;AlJy43CF;AkJr43CC;EACC,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,6CAAA;AlJu43CF;;AmJjk4CA;EACI,kBAAA;AnJok4CJ;AmJlk4CI;EACI,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;AnJok4CR;AmJlk4CQ;EACI,eAAA;EACA,cAAA;AnJok4CZ;AmJhk4CI;EACI,aAAA;EACA,mBAAA;E3ITJ,sBAAA;E2IWI,gDAAA;EACA,8CAAA;EACA,yBAAA;EACA,gB5IqVW;E4IpVX,oBAAA;EACA,WAAA;EACA,mCAAA;AnJkk4CR;AmJhk4CQ;EACI,qBAAA;AnJkk4CZ;;AmJ3j4CQ;EACI,kDAAA;EACA,gCAAA;EACA,iEAAA;AnJ8j4CZ;;AoJ3l4CA;EACI,yBAAA;EACA,yB7IFI;APgm4CR;AoJ5l4CI;EAGI,c7IPA;E6IQA,yBAxBU;ApJon4ClB;;AoJxl4CA;EACI,SAAA;ApJ2l4CJ;AoJxl4CQ;;EAEI,cAlCM;ApJ4n4ClB;;AoJrl4CA;EACC,SAAA;EACG,c7IzBI;E6I0BJ,yBA1Cc;ApJko4ClB;AoJtl4CI;EACI,c7I7BA;E6I8BA,yBA5CiB;ApJoo4CzB;;AoJpl4CA;EACC,SAAA;EACG,yBAAA;EACA,oCAAA;ApJul4CJ;AoJrl4CI;EACI,yBAAA;EACA,oCAAA;ApJul4CR;;AoJnl4CA;EACI,gDAAA;ApJsl4CJ;AoJpl4CI;EAEI,qCAAA;EACA,yBA7DgB;ApJkp4CxB;;AoJjl4CA;EACI,cAxEc;ApJ4p4ClB;AoJll4CI;EACI,cAzEiB;ApJ6p4CzB;;AoJhl4CA;EACI,yBAAA;ApJml4CJ;;AoJhl4CA;EACI,cA/Ec;ApJkq4ClB;;AoJhl4CA;EACI,cA3Ea;ApJ8p4CjB;;AoJhl4CA;EACI,c7I5EI;E6I6EJ,yBAnFc;ApJsq4ClB;;AoJhl4CA;EACI,c7IjFI;E6IkFJ,yBA7Fc;ApJgr4ClB;;AqJrr4CA;EACC,eAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,U9IqsCgB;E8IpsChB,mBAAA;ArJwr4CD;AqJtr4CC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,2CAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gB9I8ViB;E8I7VjB,kBAAA;E7INE,kBAAA;E6IQF,WAAA;EACA,YAAA;E9CXM,iC8CcG;E9CCH,+C8CCU;E9CGV,yC8CFM;ArJqr4Cd;AuGls4CQ;;EAEF,sC8CSU;ArJ2r4ChB;AuGjs4CQ;EACI,sC8CKI;ArJ8r4ChB;AqJrr4CE;EACC,6BAAA;EACA,4BAAA;EACA,gCAAA;ArJur4CH;AqJrr4CG;;EAEC,6BAAA;ArJur4CJ;AqJnr4CE;EACC,gCAAA;EACA,+BAAA;EACA,mCAAA;ArJqr4CH;AqJnr4CG;;EAEC,gCAAA;ArJqr4CJ;AqJjr4CE;EACC,gCAAA;EACA,+BAAA;EACA,mCAAA;ArJmr4CH;AqJjr4CG;;EAEC,gCAAA;ArJmr4CJ;AqJ/q4CE;EACC,WAAA;EACA,YAAA;ArJir4CH;AqJ9q4CE;EACC,WAAA;EACA,YAAA;EACA,aAAA;ArJgr4CH;AqJ3q4CE;EACC,kBAAA;ArJ6q4CH;AqJ3q4CG;EACC,aAAA;ArJ6q4CJ;AqJ1q4CG;EACC,mBAAA;EACA,aAAA;ArJ4q4CJ;;AqJtq4CA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;E9CxFO,iC8C2FE;E9C5EF,qC8C8ES;E9C1ET,yC8C2EK;ArJsq4Cb;AuGhw4CQ;;EAEF,iC8CsFS;ArJ4q4Cf;AuG/v4CQ;EACI,iC8CkFG;ArJ+q4Cf;AuGrv4CI;EASQ,wC8CgEK;E9CjDL,qC8CmDY;E9C/CZ,oDAAA;AvG8t4CZ;AuG7u4CY;;;;;;;;;EAEF,wC8C2DY;ArJ2r4CtB;AuGnv4CY;EACI,wC8CuDM;ArJ8r4CtB;;AsJ3y4CA;EACI,mBAAA;EACA,cAAA;AtJ8y4CJ;;AuJ/y4CA;EACI;IACI,qBAAA;IACA,2BAAA;EvJkz4CN;EuJhz4CM;;;;;;;;;;IAOI,2BAAA;IACA,qBAAA;IACA,oBAAA;EvJqz4CV;EuJlz4CM;;;;;;;;IAQI,wBAAA;EvJoz4CV;AACF;AwJ904CA;EACC,yCAAA;EACA,oCAAA;AxJg14CD;;AwJ504CA;EACC,yCAAA;EACA,oCAAA;AxJ+04CD;;AwJ304CA;EACC,wCAAA;EACA,8CAAA;AxJ804CD;;AwJ304CA;EACC,eAAA;AxJ804CD;AwJ504CC;EACC,8CAAA;AxJ804CF;;AwJz04CC;EACC,8CAAA;AxJ404CF;;AwJx04CA;EACC,eAAA;AxJ204CD;AwJz04CC;EAEC,8CAAA;AxJ004CF;;AwJt04CA;EACC,eAAA;AxJy04CD;AwJv04CC;EACC,yCAAA;EACA,oCAAA;AxJy04CF;;AwJp04CC;EACC,yCAAA;EACA,oCAAA;AxJu04CF;;AwJn04CA;EACC,eAAA;AxJs04CD;AwJp04CC;EAEC,yCAAA;EACA,oCAAA;AxJq04CF;;AwJ9z4CE;EACC,kDAAA;AxJi04CH;;AwJ7z4CC;EACC,sCAAA;EACA,4CAAA;AxJg04CF;;AwJ7z4CC;EACC,6CAAA;EACA,mDAAA;AxJg04CF;;AwJ5z4CE;EACC,eAAA;AxJ+z4CH;AwJ7z4CG;EACC,kDAAA;AxJ+z4CJ;;AwJ3z4CE;EACC,eAAA;AxJ8z4CH;AwJ5z4CG;EAEC,kDAAA;AxJ6z4CJ;;AwJxz4CC;EACC,eAAA;AxJ2z4CF;AwJzz4CE;EACC,4CAAA;AxJ2z4CH;;AwJtz4CE;EACC,4CAAA;AxJyz4CH;;AwJrz4CC;EACC,eAAA;AxJwz4CF;AwJtz4CE;EAEC,4CAAA;AxJuz4CH;;AwJ524CE;EACC,oDAAA;AxJ+24CH;;AwJ324CC;EACC,wCAAA;EACA,8CAAA;AxJ824CF;;AwJ324CC;EACC,+CAAA;EACA,qDAAA;AxJ824CF;;AwJ124CE;EACC,eAAA;AxJ624CH;AwJ324CG;EACC,oDAAA;AxJ624CJ;;AwJz24CE;EACC,eAAA;AxJ424CH;AwJ124CG;EAEC,oDAAA;AxJ224CJ;;AwJt24CC;EACC,eAAA;AxJy24CF;AwJv24CE;EACC,8CAAA;AxJy24CH;;AwJp24CE;EACC,8CAAA;AxJu24CH;;AwJn24CC;EACC,eAAA;AxJs24CF;AwJp24CE;EAEC,8CAAA;AxJq24CH;;AwJ154CE;EACC,sDAAA;AxJ654CH;;AwJz54CC;EACC,0CAAA;EACA,gDAAA;AxJ454CF;;AwJz54CC;EACC,iDAAA;EACA,uDAAA;AxJ454CF;;AwJx54CE;EACC,eAAA;AxJ254CH;AwJz54CG;EACC,sDAAA;AxJ254CJ;;AwJv54CE;EACC,eAAA;AxJ054CH;AwJx54CG;EAEC,sDAAA;AxJy54CJ;;AwJp54CC;EACC,eAAA;AxJu54CF;AwJr54CE;EACC,gDAAA;AxJu54CH;;AwJl54CE;EACC,gDAAA;AxJq54CH;;AwJj54CC;EACC,eAAA;AxJo54CF;AwJl54CE;EAEC,gDAAA;AxJm54CH;;AwJx84CE;EACC,oDAAA;AxJ284CH;;AwJv84CC;EACC,wCAAA;EACA,8CAAA;AxJ084CF;;AwJv84CC;EACC,+CAAA;EACA,qDAAA;AxJ084CF;;AwJt84CE;EACC,eAAA;AxJy84CH;AwJv84CG;EACC,oDAAA;AxJy84CJ;;AwJr84CE;EACC,eAAA;AxJw84CH;AwJt84CG;EAEC,oDAAA;AxJu84CJ;;AwJl84CC;EACC,eAAA;AxJq84CF;AwJn84CE;EACC,8CAAA;AxJq84CH;;AwJh84CE;EACC,8CAAA;AxJm84CH;;AwJ/74CC;EACC,eAAA;AxJk84CF;AwJh84CE;EAEC,8CAAA;AxJi84CH;;AwJt/4CE;EACC,iDAAA;AxJy/4CH;;AwJr/4CC;EACC,qCAAA;EACA,2CAAA;AxJw/4CF;;AwJr/4CC;EACC,4CAAA;EACA,kDAAA;AxJw/4CF;;AwJp/4CE;EACC,eAAA;AxJu/4CH;AwJr/4CG;EACC,iDAAA;AxJu/4CJ;;AwJn/4CE;EACC,eAAA;AxJs/4CH;AwJp/4CG;EAEC,iDAAA;AxJq/4CJ;;AwJh/4CC;EACC,eAAA;AxJm/4CF;AwJj/4CE;EACC,2CAAA;AxJm/4CH;;AwJ9+4CE;EACC,2CAAA;AxJi/4CH;;AwJ7+4CC;EACC,eAAA;AxJg/4CF;AwJ9+4CE;EAEC,2CAAA;AxJ++4CH;;AwJpi5CE;EACC,oDAAA;AxJui5CH;;AwJni5CC;EACC,wCAAA;EACA,8CAAA;AxJsi5CF;;AwJni5CC;EACC,+CAAA;EACA,qDAAA;AxJsi5CF;;AwJli5CE;EACC,eAAA;AxJqi5CH;AwJni5CG;EACC,oDAAA;AxJqi5CJ;;AwJji5CE;EACC,eAAA;AxJoi5CH;AwJli5CG;EAEC,oDAAA;AxJmi5CJ;;AwJ9h5CC;EACC,eAAA;AxJii5CF;AwJ/h5CE;EACC,8CAAA;AxJii5CH;;AwJ5h5CE;EACC,8CAAA;AxJ+h5CH;;AwJ3h5CC;EACC,eAAA;AxJ8h5CF;AwJ5h5CE;EAEC,8CAAA;AxJ6h5CH;;AwJll5CE;EACC,mDAAA;AxJql5CH;;AwJjl5CC;EACC,uCAAA;EACA,6CAAA;AxJol5CF;;AwJjl5CC;EACC,8CAAA;EACA,oDAAA;AxJol5CF;;AwJhl5CE;EACC,eAAA;AxJml5CH;AwJjl5CG;EACC,mDAAA;AxJml5CJ;;AwJ/k5CE;EACC,eAAA;AxJkl5CH;AwJhl5CG;EAEC,mDAAA;AxJil5CJ;;AwJ5k5CC;EACC,eAAA;AxJ+k5CF;AwJ7k5CE;EACC,6CAAA;AxJ+k5CH;;AwJ1k5CE;EACC,6CAAA;AxJ6k5CH;;AwJzk5CC;EACC,eAAA;AxJ4k5CF;AwJ1k5CE;EAEC,6CAAA;AxJ2k5CH;;AwJho5CE;EACC,iDAAA;AxJmo5CH;;AwJ/n5CC;EACC,qCAAA;EACA,2CAAA;AxJko5CF;;AwJ/n5CC;EACC,4CAAA;EACA,kDAAA;AxJko5CF;;AwJ9n5CE;EACC,eAAA;AxJio5CH;AwJ/n5CG;EACC,iDAAA;AxJio5CJ;;AwJ7n5CE;EACC,eAAA;AxJgo5CH;AwJ9n5CG;EAEC,iDAAA;AxJ+n5CJ;;AwJ1n5CC;EACC,eAAA;AxJ6n5CF;AwJ3n5CE;EACC,2CAAA;AxJ6n5CH;;AwJxn5CE;EACC,2CAAA;AxJ2n5CH;;AwJvn5CC;EACC,eAAA;AxJ0n5CF;AwJxn5CE;EAEC,2CAAA;AxJyn5CH;;AwJln5CI;EACF,yCAAA;EACA,oCAAA;AxJqn5CF;;AwJjn5CE;EACC,yCAAA;EACA,oCAAA;AxJon5CH;;AwJhn5CC;EACC,yCAAA;EACA,+CAAA;AxJmn5CF;;AwJjo5CI;EACF,yCAAA;EACA,oCAAA;AxJoo5CF;;AwJho5CE;EACC,yCAAA;EACA,oCAAA;AxJmo5CH;;AwJ/n5CC;EACC,yCAAA;EACA,+CAAA;AxJko5CF;;AwJhp5CI;EACF,yCAAA;EACA,oCAAA;AxJmp5CF;;AwJ/o5CE;EACC,yCAAA;EACA,oCAAA;AxJkp5CH;;AwJ9o5CC;EACC,yCAAA;EACA,+CAAA;AxJip5CF;;AwJ/p5CI;EACF,yCAAA;EACA,oCAAA;AxJkq5CF;;AwJ9p5CE;EACC,yCAAA;EACA,oCAAA;AxJiq5CH;;AwJ7p5CC;EACC,yCAAA;EACA,+CAAA;AxJgq5CF;;AwJ9q5CI;EACF,yCAAA;EACA,oCAAA;AxJir5CF;;AwJ7q5CE;EACC,yCAAA;EACA,oCAAA;AxJgr5CH;;AwJ5q5CC;EACC,yCAAA;EACA,+CAAA;AxJ+q5CF;;AwJ7r5CI;EACF,yCAAA;EACA,oCAAA;AxJgs5CF;;AwJ5r5CE;EACC,yCAAA;EACA,oCAAA;AxJ+r5CH;;AwJ3r5CC;EACC,yCAAA;EACA,+CAAA;AxJ8r5CF;;AwJ5s5CI;EACF,yCAAA;EACA,oCAAA;AxJ+s5CF;;AwJ3s5CE;EACC,yCAAA;EACA,oCAAA;AxJ8s5CH;;AwJ1s5CC;EACC,yCAAA;EACA,+CAAA;AxJ6s5CF;;AwJ3t5CI;EACF,yCAAA;EACA,oCAAA;AxJ8t5CF;;AwJ1t5CE;EACC,yCAAA;EACA,oCAAA;AxJ6t5CH;;AwJzt5CC;EACC,yCAAA;EACA,+CAAA;AxJ4t5CF;;AwJ1u5CI;EACF,yCAAA;EACA,oCAAA;AxJ6u5CF;;AwJzu5CE;EACC,yCAAA;EACA,oCAAA;AxJ4u5CH;;AwJxu5CC;EACC,yCAAA;EACA,+CAAA;AxJ2u5CF;;AwJru5CC;EACC,4DAAA;AxJwu5CF;;AwJru5CC;EACC,4DAAA;AxJwu5CF;;AwJru5CC;EACC,4DAAA;AxJwu5CF;;AwJpu5CE;EAEC,4DAAA;AxJsu5CH;;AwJrv5CC;EACC,+DAAA;AxJwv5CF;;AwJrv5CC;EACC,+DAAA;AxJwv5CF;;AwJrv5CC;EACC,+DAAA;AxJwv5CF;;AwJpv5CE;EAEC,+DAAA;AxJsv5CH;;AwJrw5CC;EACC,8DAAA;AxJww5CF;;AwJrw5CC;EACC,8DAAA;AxJww5CF;;AwJrw5CC;EACC,8DAAA;AxJww5CF;;AwJpw5CE;EAEC,8DAAA;AxJsw5CH;;AwJrx5CC;EACC,+DAAA;AxJwx5CF;;AwJrx5CC;EACC,+DAAA;AxJwx5CF;;AwJrx5CC;EACC,+DAAA;AxJwx5CF;;AwJpx5CE;EAEC,+DAAA;AxJsx5CH;;AwJry5CC;EACC,8DAAA;AxJwy5CF;;AwJry5CC;EACC,8DAAA;AxJwy5CF;;AwJry5CC;EACC,8DAAA;AxJwy5CF;;AwJpy5CE;EAEC,8DAAA;AxJsy5CH;;AwJrz5CC;EACC,+DAAA;AxJwz5CF;;AwJrz5CC;EACC,+DAAA;AxJwz5CF;;AwJrz5CC;EACC,+DAAA;AxJwz5CF;;AwJpz5CE;EAEC,+DAAA;AxJsz5CH;;AwJr05CC;EACC,8DAAA;AxJw05CF;;AwJr05CC;EACC,8DAAA;AxJw05CF;;AwJr05CC;EACC,8DAAA;AxJw05CF;;AwJp05CE;EAEC,8DAAA;AxJs05CH;;AwJr15CC;EACC,+DAAA;AxJw15CF;;AwJr15CC;EACC,+DAAA;AxJw15CF;;AwJr15CC;EACC,+DAAA;AxJw15CF;;AwJp15CE;EAEC,+DAAA;AxJs15CH;;AwJr25CC;EACC,4DAAA;AxJw25CF;;AwJr25CC;EACC,4DAAA;AxJw25CF;;AwJr25CC;EACC,4DAAA;AxJw25CF;;AwJp25CE;EAEC,4DAAA;AxJs25CH;;AwJ/15CA;EACC,4BAAA;AxJk25CD;;AwJ915CA;EACC,0BAAA;AxJi25CD;;AwJ915CA;EACC,6BAAA;AxJi25CD;;AwJ915CA;EACC,6BAAA;AxJi25CD;;AwJ915CA;EACC,2BAAA;AxJi25CD;;AwJ915CA;EACC,4BAAA;AxJi25CD;;AwJ915CA;EACC,6BAAA;AxJi25CD;;AwJ915CA;EACC,0BAAA;AxJi25CD;;AwJ915CA;EACC,6BAAA;AxJi25CD;;AwJ915CA;EACC,2BAAA;AxJi25CD;;AwJx15CE;EACC,qBAAA;AxJ215CH;;AwJx15CE;EACC,sBAAA;AxJ215CH;;AwJx15CE;EACC,wBAAA;AxJ215CH;;AwJv15CE;EACC,4BAAA;AxJ015CH;;AwJv15CE;EACC,6BAAA;AxJ015CH;;AgB5g6CI;EwIgKF;IACC,qBAAA;ExJg35CD;EwJ725CA;IACC,sBAAA;ExJ+25CD;EwJ525CA;IACC,wBAAA;ExJ825CD;EwJ125CA;IACC,4BAAA;ExJ425CD;EwJz25CA;IACC,6BAAA;ExJ225CD;AACF;AgB9h6CI;EwIgKF;IACC,qBAAA;ExJi45CD;EwJ935CA;IACC,sBAAA;ExJg45CD;EwJ735CA;IACC,wBAAA;ExJ+35CD;EwJ335CA;IACC,4BAAA;ExJ635CD;EwJ135CA;IACC,6BAAA;ExJ435CD;AACF;AgB/i6CI;EwIgKF;IACC,qBAAA;ExJk55CD;EwJ/45CA;IACC,sBAAA;ExJi55CD;EwJ945CA;IACC,wBAAA;ExJg55CD;EwJ545CA;IACC,4BAAA;ExJ845CD;EwJ345CA;IACC,6BAAA;ExJ645CD;AACF;AgBhk6CI;EwIgKF;IACC,qBAAA;ExJm65CD;EwJh65CA;IACC,sBAAA;ExJk65CD;EwJ/55CA;IACC,wBAAA;ExJi65CD;EwJ755CA;IACC,4BAAA;ExJ+55CD;EwJ555CA;IACC,6BAAA;ExJ855CD;AACF;AgBjl6CI;EwIgKF;IACC,qBAAA;ExJo75CD;EwJj75CA;IACC,sBAAA;ExJm75CD;EwJh75CA;IACC,wBAAA;ExJk75CD;EwJ965CA;IACC,4BAAA;ExJg75CD;EwJ765CA;IACC,6BAAA;ExJ+65CD;AACF;AyJ7p6CA;EACI,oCAAA;AzJ+p6CJ;;AyJ5p6CA;EACI,eAAA;EACA,oCAAA;AzJ+p6CJ;;AyJzp6CC;EACC,2CAAA;AzJ4p6CF;;AyJ7p6CC;EACC,2CAAA;AzJgq6CF;;AyJjq6CC;EACC,2CAAA;AzJoq6CF;;AyJrq6CC;EACC,2CAAA;AzJwq6CF;;AyJzq6CC;EACC,2CAAA;AzJ4q6CF;;AyJ7q6CC;EACC,2CAAA;AzJgr6CF;;AyJjr6CC;EACC,2CAAA;AzJor6CF;;AyJrr6CC;EACC,2CAAA;AzJwr6CF;;AyJzr6CC;EACC,2CAAA;AzJ4r6CF;;AyJtr6CI;EACI,wCAAA;AzJyr6CR;;AyJtr6CI;EACI,wCAAA;AzJyr6CR;;AyJ9r6CI;EACI,0CAAA;AzJis6CR;;AyJ9r6CI;EACI,0CAAA;AzJis6CR;;AyJts6CI;EACI,4CAAA;AzJys6CR;;AyJts6CI;EACI,4CAAA;AzJys6CR;;AyJ9s6CI;EACI,0CAAA;AzJit6CR;;AyJ9s6CI;EACI,0CAAA;AzJit6CR;;AyJtt6CI;EACI,uCAAA;AzJyt6CR;;AyJtt6CI;EACI,uCAAA;AzJyt6CR;;AyJ9t6CI;EACI,0CAAA;AzJiu6CR;;AyJ9t6CI;EACI,0CAAA;AzJiu6CR;;AyJtu6CI;EACI,yCAAA;AzJyu6CR;;AyJtu6CI;EACI,yCAAA;AzJyu6CR;;AyJ9u6CI;EACI,uCAAA;AzJiv6CR;;AyJ9u6CI;EACI,uCAAA;AzJiv6CR;;AyJ5u6CA;EACI,oCAAA;AzJ+u6CJ;;AyJ3u6CA;EACI,+BAAA;EACA,2CAAA;AzJ8u6CJ;;AyJ3u6CA;EACI,mCAAA;AzJ8u6CJ;;AyJ3u6CA;EACI,sCAAA;AzJ8u6CJ;;AyJ3u6CA;EACI,oCAAA;AzJ8u6CJ;;AyJ3u6CA;EACI,qCAAA;AzJ8u6CJ;;AyJ1u6CA;EACI,+BAAA;AzJ6u6CJ;;AyJ1u6CA;EACI,mCAAA;AzJ6u6CJ;;AyJ1u6CA;EACI,sCAAA;AzJ6u6CJ;;AyJ1u6CA;EACI,oCAAA;AzJ6u6CJ;;AyJ1u6CA;EACI,qCAAA;AzJ6u6CJ;;AyJzu6CA;EACI,oCAAA;AzJ4u6CJ;;AyJxu6CA;EACI,0CAAA;AzJ2u6CJ;;AyJvu6CA;EACI,oCAAA;EACA,qCAAA;AzJ0u6CJ;;AyJvu6CA;EACI,uCAAA;EACA,wCAAA;AzJ0u6CJ;;AyJvu6CA;EACI,oCAAA;EACA,uCAAA;AzJ0u6CJ;;AyJvu6CA;EACI,qCAAA;EACA,wCAAA;AzJ0u6CJ;;AyJvu6CA;EACI,6BAAA;AzJ0u6CJ;;A0Jj16CQ;EACL,SAAA;A1Jo16CH;;A0Jj16CQ;EACI,UAAA;A1Jo16CZ;;A0Jj16CQ;EACI,cAAA;A1Jo16CZ;;A0Jj16CQ;EACI,cAAA;A1Jo16CZ;;A0Jj16CQ;EACI,cAAA;EACA,YAAA;A1Jo16CZ;;A0Jj16CK;EACC,uBAAA;EACA,mBAAA;A1Jo16CN;;A0Jj16CQ;EACF,sBAAA;EACA,kBAAA;A1Jo16CN;;A0Jj16CQ;EACF,yBAAA;EACA,qBAAA;A1Jo16CN;;A0Jj16CQ;EACL,8BAAA;EACG,mBAAA;A1Jo16CN;;AgBp06CI;E0ItDI;IACL,SAAA;E1J836CD;E0J336CM;IACI,UAAA;E1J636CV;E0J136CM;IACI,cAAA;E1J436CV;E0Jz36CM;IACI,cAAA;E1J236CV;E0Jx36CM;IACI,cAAA;IACA,YAAA;E1J036CV;E0Jv36CG;IACC,uBAAA;IACA,mBAAA;E1Jy36CJ;E0Jt36CM;IACF,sBAAA;IACA,kBAAA;E1Jw36CJ;E0Jr36CM;IACF,yBAAA;IACA,qBAAA;E1Ju36CJ;E0Jp36CM;IACL,8BAAA;IACG,mBAAA;E1Js36CJ;AACF;AgBv26CI;E0ItDI;IACL,SAAA;E1Jg66CD;E0J756CM;IACI,UAAA;E1J+56CV;E0J556CM;IACI,cAAA;E1J856CV;E0J356CM;IACI,cAAA;E1J656CV;E0J156CM;IACI,cAAA;IACA,YAAA;E1J456CV;E0Jz56CG;IACC,uBAAA;IACA,mBAAA;E1J256CJ;E0Jx56CM;IACF,sBAAA;IACA,kBAAA;E1J056CJ;E0Jv56CM;IACF,yBAAA;IACA,qBAAA;E1Jy56CJ;E0Jt56CM;IACL,8BAAA;IACG,mBAAA;E1Jw56CJ;AACF;AgBz46CI;E0ItDI;IACL,SAAA;E1Jk86CD;E0J/76CM;IACI,UAAA;E1Ji86CV;E0J976CM;IACI,cAAA;E1Jg86CV;E0J776CM;IACI,cAAA;E1J+76CV;E0J576CM;IACI,cAAA;IACA,YAAA;E1J876CV;E0J376CG;IACC,uBAAA;IACA,mBAAA;E1J676CJ;E0J176CM;IACF,sBAAA;IACA,kBAAA;E1J476CJ;E0Jz76CM;IACF,yBAAA;IACA,qBAAA;E1J276CJ;E0Jx76CM;IACL,8BAAA;IACG,mBAAA;E1J076CJ;AACF;AgB366CI;E0ItDI;IACL,SAAA;E1Jo+6CD;E0Jj+6CM;IACI,UAAA;E1Jm+6CV;E0Jh+6CM;IACI,cAAA;E1Jk+6CV;E0J/96CM;IACI,cAAA;E1Ji+6CV;E0J996CM;IACI,cAAA;IACA,YAAA;E1Jg+6CV;E0J796CG;IACC,uBAAA;IACA,mBAAA;E1J+96CJ;E0J596CM;IACF,sBAAA;IACA,kBAAA;E1J896CJ;E0J396CM;IACF,yBAAA;IACA,qBAAA;E1J696CJ;E0J196CM;IACL,8BAAA;IACG,mBAAA;E1J496CJ;AACF;AgB786CI;E0ItDI;IACL,SAAA;E1Jsg7CD;E0Jng7CM;IACI,UAAA;E1Jqg7CV;E0Jlg7CM;IACI,cAAA;E1Jog7CV;E0Jjg7CM;IACI,cAAA;E1Jmg7CV;E0Jhg7CM;IACI,cAAA;IACA,YAAA;E1Jkg7CV;E0J//6CG;IACC,uBAAA;IACA,mBAAA;E1Jig7CJ;E0J9/6CM;IACF,sBAAA;IACA,kBAAA;E1Jgg7CJ;E0J7/6CM;IACF,yBAAA;IACA,qBAAA;E1J+/6CJ;E0J5/6CM;IACL,8BAAA;IACG,mBAAA;E1J8/6CJ;AACF;A0J1/6CA;EACI,YAAA;EACA,aAAA;EACA,cAAA;A1J4/6CJ;;A2J/i7CA;EACI,mCAAA;A3Jkj7CJ;;A2J/i7CA;EACI,mCAAA;A3Jkj7CJ;;A2J/i7CA;EACI,gCAAA;A3Jkj7CJ;;A2J/i7CA;EACI,mCAAA;A3Jkj7CJ;;A4J5j7CI;EACI,sCAAA;A5J+j7CR;;A4J7i7CI;EACI,2BrJiTU;AP+v6ClB;A4J9i7CQ;EACI,2BrJ8SM;APkw6ClB;A4J7i7CQ;EACI,2BrJ0SM;EqJzSN,sCAAA;A5J+i7CZ;A4J7i7CY;EACI,2BrJsSE;EqJrSd,sCAAA;A5J+i7CJ;A4J5i7CG;EACC,sCAAA;A5J8i7CJ;;A4Jxi7CI;EACI,2BrJ0RU;APix6ClB;A4Jzi7CQ;EACI,2BrJuRM;APox6ClB;A4Jxi7CQ;EACI,2BrJmRM;EqJlRN,sCAAA;A5J0i7CZ;A4Jxi7CY;EACI,2BrJ+QE;EqJ9QF,sCAAA;A5J0i7ChB;A4Jvi7CY;EACI,sCAAA;A5Jyi7ChB;;A4Jpm7CI;EACI,wCAAA;A5Jum7CR;;A4Jlm7CQ;EACI,2CAAA;A5Jqm7CZ;;A4J/l7CQ;EACI,yCAAA;A5Jkm7CZ;;A4J7l7CI;EACI,2BrJiTU;AP+y6ClB;A4J9l7CQ;EACI,2BrJ8SM;APkz6ClB;A4J7l7CQ;EACI,2BrJ0SM;EqJzSN,wCAAA;A5J+l7CZ;A4J7l7CY;EACI,2BrJsSE;EqJrSd,wCAAA;A5J+l7CJ;A4J5l7CG;EACC,wCAAA;A5J8l7CJ;;A4Jxl7CI;EACI,2BrJ0RU;APi06ClB;A4Jzl7CQ;EACI,2BrJuRM;APo06ClB;A4Jxl7CQ;EACI,2BrJmRM;EqJlRN,wCAAA;A5J0l7CZ;A4Jxl7CY;EACI,2BrJ+QE;EqJ9QF,wCAAA;A5J0l7ChB;A4Jvl7CY;EACI,wCAAA;A5Jyl7ChB;;A4Jpp7CI;EACI,0CAAA;A5Jup7CR;;A4Jlp7CQ;EACI,6CAAA;A5Jqp7CZ;;A4J/o7CQ;EACI,2CAAA;A5Jkp7CZ;;A4J7o7CI;EACI,2BrJiTU;AP+16ClB;A4J9o7CQ;EACI,2BrJ8SM;APk26ClB;A4J7o7CQ;EACI,2BrJ0SM;EqJzSN,0CAAA;A5J+o7CZ;A4J7o7CY;EACI,2BrJsSE;EqJrSd,0CAAA;A5J+o7CJ;A4J5o7CG;EACC,0CAAA;A5J8o7CJ;;A4Jxo7CI;EACI,2BrJ0RU;APi36ClB;A4Jzo7CQ;EACI,2BrJuRM;APo36ClB;A4Jxo7CQ;EACI,2BrJmRM;EqJlRN,0CAAA;A5J0o7CZ;A4Jxo7CY;EACI,2BrJ+QE;EqJ9QF,0CAAA;A5J0o7ChB;A4Jvo7CY;EACI,0CAAA;A5Jyo7ChB;;A4Jps7CI;EACI,sCAAA;A5Jus7CR;;A4Jls7CQ;EACI,yCAAA;A5Jqs7CZ;;A4J/r7CQ;EACI,uCAAA;A5Jks7CZ;;A4J7r7CI;EACI,2BrJiTU;AP+46ClB;A4J9r7CQ;EACI,2BrJ8SM;APk56ClB;A4J7r7CQ;EACI,2BrJ0SM;EqJzSN,sCAAA;A5J+r7CZ;A4J7r7CY;EACI,2BrJsSE;EqJrSd,sCAAA;A5J+r7CJ;A4J5r7CG;EACC,sCAAA;A5J8r7CJ;;A4Jxr7CI;EACI,2BrJ0RU;APi66ClB;A4Jzr7CQ;EACI,2BrJuRM;APo66ClB;A4Jxr7CQ;EACI,2BrJmRM;EqJlRN,sCAAA;A5J0r7CZ;A4Jxr7CY;EACI,2BrJ+QE;EqJ9QF,sCAAA;A5J0r7ChB;A4Jvr7CY;EACI,sCAAA;A5Jyr7ChB;;A4Jpv7CI;EACI,wCAAA;A5Juv7CR;;A4Jlv7CQ;EACI,2CAAA;A5Jqv7CZ;;A4J/u7CQ;EACI,yCAAA;A5Jkv7CZ;;A4J7u7CI;EACI,2BrJiTU;AP+76ClB;A4J9u7CQ;EACI,2BrJ8SM;APk86ClB;A4J7u7CQ;EACI,2BrJ0SM;EqJzSN,wCAAA;A5J+u7CZ;A4J7u7CY;EACI,2BrJsSE;EqJrSd,wCAAA;A5J+u7CJ;A4J5u7CG;EACC,wCAAA;A5J8u7CJ;;A4Jxu7CI;EACI,2BrJ0RU;APi96ClB;A4Jzu7CQ;EACI,2BrJuRM;APo96ClB;A4Jxu7CQ;EACI,2BrJmRM;EqJlRN,wCAAA;A5J0u7CZ;A4Jxu7CY;EACI,2BrJ+QE;EqJ9QF,wCAAA;A5J0u7ChB;A4Jvu7CY;EACI,wCAAA;A5Jyu7ChB;;A4Jpy7CI;EACI,qCAAA;A5Juy7CR;;A4Jly7CQ;EACI,wCAAA;A5Jqy7CZ;;A4J/x7CQ;EACI,sCAAA;A5Jky7CZ;;A4J7x7CI;EACI,2BrJiTU;AP++6ClB;A4J9x7CQ;EACI,2BrJ8SM;APk/6ClB;A4J7x7CQ;EACI,2BrJ0SM;EqJzSN,qCAAA;A5J+x7CZ;A4J7x7CY;EACI,2BrJsSE;EqJrSd,qCAAA;A5J+x7CJ;A4J5x7CG;EACC,qCAAA;A5J8x7CJ;;A4Jxx7CI;EACI,2BrJ0RU;APig7ClB;A4Jzx7CQ;EACI,2BrJuRM;APog7ClB;A4Jxx7CQ;EACI,2BrJmRM;EqJlRN,qCAAA;A5J0x7CZ;A4Jxx7CY;EACI,2BrJ+QE;EqJ9QF,qCAAA;A5J0x7ChB;A4Jvx7CY;EACI,qCAAA;A5Jyx7ChB;;A4Jp17CI;EACI,wCAAA;A5Ju17CR;;A4Jl17CQ;EACI,2CAAA;A5Jq17CZ;;A4J/07CQ;EACI,yCAAA;A5Jk17CZ;;A4J707CI;EACI,2BrJiTU;AP+h7ClB;A4J907CQ;EACI,2BrJ8SM;APki7ClB;A4J707CQ;EACI,2BrJ0SM;EqJzSN,wCAAA;A5J+07CZ;A4J707CY;EACI,2BrJsSE;EqJrSd,wCAAA;A5J+07CJ;A4J507CG;EACC,wCAAA;A5J807CJ;;A4Jx07CI;EACI,2BrJ0RU;APij7ClB;A4Jz07CQ;EACI,2BrJuRM;APoj7ClB;A4Jx07CQ;EACI,2BrJmRM;EqJlRN,wCAAA;A5J007CZ;A4Jx07CY;EACI,2BrJ+QE;EqJ9QF,wCAAA;A5J007ChB;A4Jv07CY;EACI,wCAAA;A5Jy07ChB;;A4Jp47CI;EACI,uCAAA;A5Ju47CR;;A4Jl47CQ;EACI,0CAAA;A5Jq47CZ;;A4J/37CQ;EACI,wCAAA;A5Jk47CZ;;A4J737CI;EACI,2BrJiTU;AP+k7ClB;A4J937CQ;EACI,2BrJ8SM;APkl7ClB;A4J737CQ;EACI,2BrJ0SM;EqJzSN,uCAAA;A5J+37CZ;A4J737CY;EACI,2BrJsSE;EqJrSd,uCAAA;A5J+37CJ;A4J537CG;EACC,uCAAA;A5J837CJ;;A4Jx37CI;EACI,2BrJ0RU;APim7ClB;A4Jz37CQ;EACI,2BrJuRM;APom7ClB;A4Jx37CQ;EACI,2BrJmRM;EqJlRN,uCAAA;A5J037CZ;A4Jx37CY;EACI,2BrJ+QE;EqJ9QF,uCAAA;A5J037ChB;A4Jv37CY;EACI,uCAAA;A5Jy37ChB;;A4Jp77CI;EACI,qCAAA;A5Ju77CR;;A4Jl77CQ;EACI,wCAAA;A5Jq77CZ;;A4J/67CQ;EACI,sCAAA;A5Jk77CZ;;A4J767CI;EACI,2BrJiTU;AP+n7ClB;A4J967CQ;EACI,2BrJ8SM;APko7ClB;A4J767CQ;EACI,2BrJ0SM;EqJzSN,qCAAA;A5J+67CZ;A4J767CY;EACI,2BrJsSE;EqJrSd,qCAAA;A5J+67CJ;A4J567CG;EACC,qCAAA;A5J867CJ;;A4Jx67CI;EACI,2BrJ0RU;APip7ClB;A4Jz67CQ;EACI,2BrJuRM;APop7ClB;A4Jx67CQ;EACI,2BrJmRM;EqJlRN,qCAAA;A5J067CZ;A4Jx67CY;EACI,2BrJ+QE;EqJ9QF,qCAAA;A5J067ChB;A4Jv67CY;EACI,qCAAA;A5Jy67ChB;;A4Jp+7CI;EACI,sCAAA;A5Ju+7CR;;A4Jr97CI;EACI,2BrJiTU;APuq7ClB;A4Jt97CQ;EACI,2BrJ8SM;AP0q7ClB;A4Jr97CQ;EACI,2BrJ0SM;EqJzSN,sCAAA;A5Ju97CZ;A4Jr97CY;EACI,2BrJsSE;EqJrSd,sCAAA;A5Ju97CJ;A4Jp97CG;EACC,sCAAA;A5Js97CJ;;A4Jh97CI;EACI,2BrJ0RU;APyr7ClB;A4Jj97CQ;EACI,2BrJuRM;AP4r7ClB;A4Jh97CQ;EACI,2BrJmRM;EqJlRN,sCAAA;A5Jk97CZ;A4Jh97CY;EACI,2BrJ+QE;EqJ9QF,sCAAA;A5Jk97ChB;A4J/87CY;EACI,sCAAA;A5Ji97ChB;;A4J5g8CI;EACI,yCAAA;A5J+g8CR;;A4J7/7CI;EACI,2BrJiTU;AP+s7ClB;A4J9/7CQ;EACI,2BrJ8SM;APkt7ClB;A4J7/7CQ;EACI,2BrJ0SM;EqJzSN,yCAAA;A5J+/7CZ;A4J7/7CY;EACI,2BrJsSE;EqJrSd,yCAAA;A5J+/7CJ;A4J5/7CG;EACC,yCAAA;A5J8/7CJ;;A4Jx/7CI;EACI,2BrJ0RU;APiu7ClB;A4Jz/7CQ;EACI,2BrJuRM;APou7ClB;A4Jx/7CQ;EACI,2BrJmRM;EqJlRN,yCAAA;A5J0/7CZ;A4Jx/7CY;EACI,2BrJ+QE;EqJ9QF,yCAAA;A5J0/7ChB;A4Jv/7CY;EACI,yCAAA;A5Jy/7ChB;;A4Jpj8CI;EACI,yCAAA;A5Juj8CR;;A4Jri8CI;EACI,2BrJiTU;APuv7ClB;A4Jti8CQ;EACI,2BrJ8SM;AP0v7ClB;A4Jri8CQ;EACI,2BrJ0SM;EqJzSN,yCAAA;A5Jui8CZ;A4Jri8CY;EACI,2BrJsSE;EqJrSd,yCAAA;A5Jui8CJ;A4Jpi8CG;EACC,yCAAA;A5Jsi8CJ;;A4Jhi8CI;EACI,2BrJ0RU;APyw7ClB;A4Jji8CQ;EACI,2BrJuRM;AP4w7ClB;A4Jhi8CQ;EACI,2BrJmRM;EqJlRN,yCAAA;A5Jki8CZ;A4Jhi8CY;EACI,2BrJ+QE;EqJ9QF,yCAAA;A5Jki8ChB;A4J/h8CY;EACI,yCAAA;A5Jii8ChB;;A4J5l8CI;EACI,yCAAA;A5J+l8CR;;A4J7k8CI;EACI,2BrJiTU;AP+x7ClB;A4J9k8CQ;EACI,2BrJ8SM;APky7ClB;A4J7k8CQ;EACI,2BrJ0SM;EqJzSN,yCAAA;A5J+k8CZ;A4J7k8CY;EACI,2BrJsSE;EqJrSd,yCAAA;A5J+k8CJ;A4J5k8CG;EACC,yCAAA;A5J8k8CJ;;A4Jxk8CI;EACI,2BrJ0RU;APiz7ClB;A4Jzk8CQ;EACI,2BrJuRM;APoz7ClB;A4Jxk8CQ;EACI,2BrJmRM;EqJlRN,yCAAA;A5J0k8CZ;A4Jxk8CY;EACI,2BrJ+QE;EqJ9QF,yCAAA;A5J0k8ChB;A4Jvk8CY;EACI,yCAAA;A5Jyk8ChB;;A4Jpo8CI;EACI,yCAAA;A5Juo8CR;;A4Jrn8CI;EACI,2BrJiTU;APu07ClB;A4Jtn8CQ;EACI,2BrJ8SM;AP007ClB;A4Jrn8CQ;EACI,2BrJ0SM;EqJzSN,yCAAA;A5Jun8CZ;A4Jrn8CY;EACI,2BrJsSE;EqJrSd,yCAAA;A5Jun8CJ;A4Jpn8CG;EACC,yCAAA;A5Jsn8CJ;;A4Jhn8CI;EACI,2BrJ0RU;APy17ClB;A4Jjn8CQ;EACI,2BrJuRM;AP417ClB;A4Jhn8CQ;EACI,2BrJmRM;EqJlRN,yCAAA;A5Jkn8CZ;A4Jhn8CY;EACI,2BrJ+QE;EqJ9QF,yCAAA;A5Jkn8ChB;A4J/m8CY;EACI,yCAAA;A5Jin8ChB;;A4J5q8CI;EACI,yCAAA;A5J+q8CR;;A4J7p8CI;EACI,2BrJiTU;AP+27ClB;A4J9p8CQ;EACI,2BrJ8SM;APk37ClB;A4J7p8CQ;EACI,2BrJ0SM;EqJzSN,yCAAA;A5J+p8CZ;A4J7p8CY;EACI,2BrJsSE;EqJrSd,yCAAA;A5J+p8CJ;A4J5p8CG;EACC,yCAAA;A5J8p8CJ;;A4Jxp8CI;EACI,2BrJ0RU;APi47ClB;A4Jzp8CQ;EACI,2BrJuRM;APo47ClB;A4Jxp8CQ;EACI,2BrJmRM;EqJlRN,yCAAA;A5J0p8CZ;A4Jxp8CY;EACI,2BrJ+QE;EqJ9QF,yCAAA;A5J0p8ChB;A4Jvp8CY;EACI,yCAAA;A5Jyp8ChB;;A4Jpt8CI;EACI,yCAAA;A5Jut8CR;;A4Jrs8CI;EACI,2BrJiTU;APu57ClB;A4Jts8CQ;EACI,2BrJ8SM;AP057ClB;A4Jrs8CQ;EACI,2BrJ0SM;EqJzSN,yCAAA;A5Jus8CZ;A4Jrs8CY;EACI,2BrJsSE;EqJrSd,yCAAA;A5Jus8CJ;A4Jps8CG;EACC,yCAAA;A5Jss8CJ;;A4Jhs8CI;EACI,2BrJ0RU;APy67ClB;A4Jjs8CQ;EACI,2BrJuRM;AP467ClB;A4Jhs8CQ;EACI,2BrJmRM;EqJlRN,yCAAA;A5Jks8CZ;A4Jhs8CY;EACI,2BrJ+QE;EqJ9QF,yCAAA;A5Jks8ChB;A4J/r8CY;EACI,yCAAA;A5Jis8ChB;;A4J5v8CI;EACI,yCAAA;A5J+v8CR;;A4J7u8CI;EACI,2BrJiTU;AP+77ClB;A4J9u8CQ;EACI,2BrJ8SM;APk87ClB;A4J7u8CQ;EACI,2BrJ0SM;EqJzSN,yCAAA;A5J+u8CZ;A4J7u8CY;EACI,2BrJsSE;EqJrSd,yCAAA;A5J+u8CJ;A4J5u8CG;EACC,yCAAA;A5J8u8CJ;;A4Jxu8CI;EACI,2BrJ0RU;APi97ClB;A4Jzu8CQ;EACI,2BrJuRM;APo97ClB;A4Jxu8CQ;EACI,2BrJmRM;EqJlRN,yCAAA;A5J0u8CZ;A4Jxu8CY;EACI,2BrJ+QE;EqJ9QF,yCAAA;A5J0u8ChB;A4Jvu8CY;EACI,yCAAA;A5Jyu8ChB;;A4Jpy8CI;EACI,yCAAA;A5Juy8CR;;A4Jrx8CI;EACI,2BrJiTU;APu+7ClB;A4Jtx8CQ;EACI,2BrJ8SM;AP0+7ClB;A4Jrx8CQ;EACI,2BrJ0SM;EqJzSN,yCAAA;A5Jux8CZ;A4Jrx8CY;EACI,2BrJsSE;EqJrSd,yCAAA;A5Jux8CJ;A4Jpx8CG;EACC,yCAAA;A5Jsx8CJ;;A4Jhx8CI;EACI,2BrJ0RU;APy/7ClB;A4Jjx8CQ;EACI,2BrJuRM;AP4/7ClB;A4Jhx8CQ;EACI,2BrJmRM;EqJlRN,yCAAA;A5Jkx8CZ;A4Jhx8CY;EACI,2BrJ+QE;EqJ9QF,yCAAA;A5Jkx8ChB;A4J/w8CY;EACI,yCAAA;A5Jix8ChB;;A4J508CI;EACI,yCAAA;A5J+08CR;;A4J7z8CI;EACI,2BrJiTU;AP+g8ClB;A4J9z8CQ;EACI,2BrJ8SM;APkh8ClB;A4J7z8CQ;EACI,2BrJ0SM;EqJzSN,yCAAA;A5J+z8CZ;A4J7z8CY;EACI,2BrJsSE;EqJrSd,yCAAA;A5J+z8CJ;A4J5z8CG;EACC,yCAAA;A5J8z8CJ;;A4Jxz8CI;EACI,2BrJ0RU;APii8ClB;A4Jzz8CQ;EACI,2BrJuRM;APoi8ClB;A4Jxz8CQ;EACI,2BrJmRM;EqJlRN,yCAAA;A5J0z8CZ;A4Jxz8CY;EACI,2BrJ+QE;EqJ9QF,yCAAA;A5J0z8ChB;A4Jvz8CY;EACI,yCAAA;A5Jyz8ChB;;A4Jhz8CQ;EACI,2BrJgQM;APmj8ClB;A4J/y8CY;EACI,2BrJ2PE;EqJ1PF,sCAAA;A5Jiz8ChB;A4Jxz8CQ;EACI,2BrJgQM;AP0j8ClB;A4Jtz8CY;EACI,2BrJ2PE;EqJ1PF,wCAAA;A5Jwz8ChB;A4J/z8CQ;EACI,2BrJgQM;APik8ClB;A4J7z8CY;EACI,2BrJ2PE;EqJ1PF,0CAAA;A5J+z8ChB;A4Jt08CQ;EACI,2BrJgQM;APwk8ClB;A4Jp08CY;EACI,2BrJ2PE;EqJ1PF,sCAAA;A5Js08ChB;A4J708CQ;EACI,2BrJgQM;AP+k8ClB;A4J308CY;EACI,2BrJ2PE;EqJ1PF,wCAAA;A5J608ChB;A4Jp18CQ;EACI,2BrJgQM;APsl8ClB;A4Jl18CY;EACI,2BrJ2PE;EqJ1PF,qCAAA;A5Jo18ChB;A4J318CQ;EACI,2BrJgQM;AP6l8ClB;A4Jz18CY;EACI,2BrJ2PE;EqJ1PF,wCAAA;A5J218ChB;A4Jl28CQ;EACI,2BrJgQM;APom8ClB;A4Jh28CY;EACI,2BrJ2PE;EqJ1PF,uCAAA;A5Jk28ChB;A4Jz28CQ;EACI,2BrJgQM;AP2m8ClB;A4Jv28CY;EACI,2BrJ2PE;EqJ1PF,qCAAA;A5Jy28ChB;A4Jh38CQ;EACI,2BrJgQM;APkn8ClB;A4J928CY;EACI,2BrJ2PE;EqJ1PF,sCAAA;A5Jg38ChB;A4Jv38CQ;EACI,2BrJgQM;APyn8ClB;A4Jr38CY;EACI,2BrJ2PE;EqJ1PF,yCAAA;A5Ju38ChB;A4J938CQ;EACI,2BrJgQM;APgo8ClB;A4J538CY;EACI,2BrJ2PE;EqJ1PF,yCAAA;A5J838ChB;A4Jr48CQ;EACI,2BrJgQM;APuo8ClB;A4Jn48CY;EACI,2BrJ2PE;EqJ1PF,yCAAA;A5Jq48ChB;A4J548CQ;EACI,2BrJgQM;AP8o8ClB;A4J148CY;EACI,2BrJ2PE;EqJ1PF,yCAAA;A5J448ChB;A4Jn58CQ;EACI,2BrJgQM;APqp8ClB;A4Jj58CY;EACI,2BrJ2PE;EqJ1PF,yCAAA;A5Jm58ChB;A4J158CQ;EACI,2BrJgQM;AP4p8ClB;A4Jx58CY;EACI,2BrJ2PE;EqJ1PF,yCAAA;A5J058ChB;A4Jj68CQ;EACI,2BrJgQM;APmq8ClB;A4J/58CY;EACI,2BrJ2PE;EqJ1PF,yCAAA;A5Ji68ChB;A4Jx68CQ;EACI,2BrJgQM;AP0q8ClB;A4Jt68CY;EACI,2BrJ2PE;EqJ1PF,yCAAA;A5Jw68ChB;A4J/68CQ;EACI,2BrJgQM;APir8ClB;A4J768CY;EACI,2BrJ2PE;EqJ1PF,yCAAA;A5J+68ChB;;A4Jt68CQ;EACI,2BrJgPM;APyr8ClB;A4Jr68CY;EACI,2BrJ2OE;EqJ1OF,sCAAA;A5Ju68ChB;A4J968CQ;EACI,2BrJgPM;APgs8ClB;A4J568CY;EACI,2BrJ2OE;EqJ1OF,wCAAA;A5J868ChB;A4Jr78CQ;EACI,2BrJgPM;APus8ClB;A4Jn78CY;EACI,2BrJ2OE;EqJ1OF,0CAAA;A5Jq78ChB;A4J578CQ;EACI,2BrJgPM;AP8s8ClB;A4J178CY;EACI,2BrJ2OE;EqJ1OF,sCAAA;A5J478ChB;A4Jn88CQ;EACI,2BrJgPM;APqt8ClB;A4Jj88CY;EACI,2BrJ2OE;EqJ1OF,wCAAA;A5Jm88ChB;A4J188CQ;EACI,2BrJgPM;AP4t8ClB;A4Jx88CY;EACI,2BrJ2OE;EqJ1OF,qCAAA;A5J088ChB;A4Jj98CQ;EACI,2BrJgPM;APmu8ClB;A4J/88CY;EACI,2BrJ2OE;EqJ1OF,wCAAA;A5Ji98ChB;A4Jx98CQ;EACI,2BrJgPM;AP0u8ClB;A4Jt98CY;EACI,2BrJ2OE;EqJ1OF,uCAAA;A5Jw98ChB;A4J/98CQ;EACI,2BrJgPM;APiv8ClB;A4J798CY;EACI,2BrJ2OE;EqJ1OF,qCAAA;A5J+98ChB;A4Jt+8CQ;EACI,2BrJgPM;APwv8ClB;A4Jp+8CY;EACI,2BrJ2OE;EqJ1OF,sCAAA;A5Js+8ChB;A4J7+8CQ;EACI,2BrJgPM;AP+v8ClB;A4J3+8CY;EACI,2BrJ2OE;EqJ1OF,yCAAA;A5J6+8ChB;A4Jp/8CQ;EACI,2BrJgPM;APsw8ClB;A4Jl/8CY;EACI,2BrJ2OE;EqJ1OF,yCAAA;A5Jo/8ChB;A4J3/8CQ;EACI,2BrJgPM;AP6w8ClB;A4Jz/8CY;EACI,2BrJ2OE;EqJ1OF,yCAAA;A5J2/8ChB;A4Jlg9CQ;EACI,2BrJgPM;APox8ClB;A4Jhg9CY;EACI,2BrJ2OE;EqJ1OF,yCAAA;A5Jkg9ChB;A4Jzg9CQ;EACI,2BrJgPM;AP2x8ClB;A4Jvg9CY;EACI,2BrJ2OE;EqJ1OF,yCAAA;A5Jyg9ChB;A4Jhh9CQ;EACI,2BrJgPM;APky8ClB;A4J9g9CY;EACI,2BrJ2OE;EqJ1OF,yCAAA;A5Jgh9ChB;A4Jvh9CQ;EACI,2BrJgPM;APyy8ClB;A4Jrh9CY;EACI,2BrJ2OE;EqJ1OF,yCAAA;A5Juh9ChB;A4J9h9CQ;EACI,2BrJgPM;APgz8ClB;A4J5h9CY;EACI,2BrJ2OE;EqJ1OF,yCAAA;A5J8h9ChB;A4Jri9CQ;EACI,2BrJgPM;APuz8ClB;A4Jni9CY;EACI,2BrJ2OE;EqJ1OF,yCAAA;A5Jqi9ChB;;A4J9h9CA;EACI,kBAAA;A5Jii9CJ;;A4J7h9CA;EACI,eAAA;A5Jgi9CJ;;A4J5h9CA;EACI,eAAA;A5J+h9CJ;;A4J5h9CA;EACI,YAAA;A5J+h9CJ;;A4J1h9CI;EAOI,cAAA;EACA,eAAA;EACA,2BAAA;A5Juh9CR;;A4Jlh9CA;EACI,2BrJgMc;APq18ClB;A4Jnh9CI;EACI,2BrJ6LU;APw18ClB;;A6J9p9CC;EACC,qBAAA;A7Jiq9CF;;A6J5p9CE;EAEC,qBAAA;A7J8p9CH;;A6Jtq9CC;EACC,wBAAA;A7Jyq9CF;;A6Jpq9CE;EAEC,wBAAA;A7Jsq9CH;;A6J9q9CC;EACC,uBAAA;A7Jir9CF;;A6J5q9CE;EAEC,uBAAA;A7J8q9CH;;A6Jtr9CC;EACC,wBAAA;A7Jyr9CF;;A6Jpr9CE;EAEC,wBAAA;A7Jsr9CH;;A6J9r9CC;EACC,uBAAA;A7Jis9CF;;A6J5r9CE;EAEC,uBAAA;A7J8r9CH;;A6Jts9CC;EACC,wBAAA;A7Jys9CF;;A6Jps9CE;EAEC,wBAAA;A7Jss9CH;;A6J9s9CC;EACC,uBAAA;A7Jit9CF;;A6J5s9CE;EAEC,uBAAA;A7J8s9CH;;A6Jtt9CC;EACC,wBAAA;A7Jyt9CF;;A6Jpt9CE;EAEC,wBAAA;A7Jst9CH;;A6J9t9CC;EACC,qBAAA;A7Jiu9CF;;A6J5t9CE;EAEC,qBAAA;A7J8t9CH;;A8Jxu9CA;EACI,wBAAA;EACA,2BAAA;A9J2u9CJ;;A+J7u9CA;EAEC,yBAAA;EACA,wBAAA;EACA,4CAAA;EACA,gDAAA;EACA,8CAAA;EACA,wCAAA;A/J+u9CD;A+J7u9CC;EACC,qBxJ4pCoB;EwJ3pCpB,aAAA;EACA,sBAAA;EACA,kBAAA;A/J+u9CF;A+J5u9CC;EACC,kBAAA;A/J8u9CF;A+J3u9CC;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;A/J6u9CF;A+J1u9CC;EACC,uEAAA;A/J4u9CF;A+Jzu9CC;EACC,aAAA;EACA,qBAAA;EACA,qCAAA;A/J2u9CF;A+Jxu9CC;EACC,aAAA;EACA,mBAAA;EACA,+BAAA;A/J0u9CF;A+Jxu9CE;EACC,iBAAA;EACA,wCAAA;A/J0u9CH;A+Jvu9CE;EACC,iBAAA;EACA,qCAAA;A/Jyu9CH;A+Jtu9CE;EACC,iBAAA;EACA,sCAAA;A/Jwu9CH;A+Jpu9CG;EACC,aAAA;A/Jsu9CJ;A+Jnu9CG;EACC,aAAA;A/Jqu9CJ;A+Jhu9CG;EACC,aAAA;A/Jku9CJ;A+J/t9CG;EACC,aAAA;A/Jiu9CJ;A+J5t9CC;EACC,0BAAA;A/J8t9CF;A+J1t9CE;EACC,gDAAA;EACA,+CAAA;A/J4t9CH;;AgBrv9CI;EgJzDH;IACC,wBAAA;EhKkz9CA;EgKhz9CA;;;;;IAKC,yBAAA;EhKkz9CD;EgK9y9CC;IACC,aAAA;IACA,YAAA;IACA,yBAAA;EhKgz9CF;EgK7y9CC;IACC,oCAAA;IACA,6BAAA;IACA,yBAAA;IACA,gCAAA;EhK+y9CF;EgK5y9CC;IACC,oCAAA;IACA,6BAAA;IACA,yBAAA;IACA,gCAAA;EhK8y9CF;EgK3y9CC;IACC,mCAAA;IACA,4BAAA;IACA,yBAAA;EhK6y9CF;EgK1y9CC;IACC,oCAAA;IACA,4BAAA;IACA,yBAAA;EhK4y9CF;AACF;AgKty9CC;EACC,YAAA;AhKwy9CF;AgKpy9CE;EACC,YAAA;EACA,mCAAA;AhKsy9CH;;AiK919CA;EACI,6BAAA;EACA,oCAAA;EACA,qCAAA;EAEA,qDAAA;EACA,qDAAA;EACA,+DAAA;EAEA,6DAAA;EACA,mCAAA;EACA,uEAAA;EAEA,+CAAA;EACA,uDAAA;EACA,yDAAA;EAEA,0DAAA;EAEA,qCAAA;EACA,2CAAA;EACA,6CAAA;EAEA,+CAAA;EACA,uDAAA;EACA,yDAAA;EAEA,oCAAA;EACA,4CAAA;EACA,8CAAA;EAEA,8CAAA;EACA,sDAAA;EACA,wDAAA;EAEA,6DAAA;AjKw19CJ;;AkKp39CA;EACI,yBARiB;AlK+39CrB;;AkKp39CA;EACI,cAZiB;AlKm49CrB;;AkKp39CA;EACI,0BAAA;AlKu39CJ;;AkKp39CA;EACI,8BAAA;AlKu39CJ;;AkKp39CA;EACI,kBAAA;AlKu39CJ;AkKr39CI;EACI,kBAAA;EACA,MAAA;EACA,cAAA;AlKu39CR;;AkKl39CA;EACI,aAAA;EACA,mBAAA;EACA,aApCoB;AlKy59CxB;AkKl39CI;EACI,cAAA;AlKo39CR;AkKj39CI;EACI,aAAA;AlKm39CR;AkK529CY;EACI,c3JtCR;APo59CR;AkKt29CgB;EACI,c3JfL;E2JgBK,0CAAA;AlKw29CpB;AkKj29CI;EACI,UAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,yB3J9DA;E2J+DA,qDAAA;EACA,YA5EuB;AlK+69C/B;AkKh29CQ;EACI,cAAA;AlKk29CZ;AkK/19CQ;EACI,aAAA;AlKi29CZ;;AkK319CA;EACI,kBA7FoB;AlK279CxB;;AgBr39CI;EkJ6BA;IACI,YAnGkC;ElK+79CxC;EkKz19CM;IACI,kBAAA;IACA,cAAA;ElK219CV;EkKv19CM;IACI,YA3GqC;ElKo89C/C;EkKl19Cc;IACI,c3JxEL;I2JyEK,0CAAA;ElKo19ClB;EkK709CE;IACI,iBA9HkC;ElK689CxC;AACF;AIt89CI;E+JRA,qBAAA;EAGA,0BAAA;EAGA,2CAAA;EACA,+EAAA;EAEA,2CAAA;EACA,+EAAA;EAGA,4BAAA;EAGA,8BAAA;EACA,gDAAA;EACA,+CAAA;EACA,kDAAA;EACA,iDAAA;EACA,yCAAA;EACA,iCAAA;EACA,oCAAA;AnKw89CJ;;AIv99CI;E+JqBA,qBAAA;EAGA,0BAAA;EAGA,2CAAA;EACA,0CAAA;EAEA,2CAAA;EACA,0CAAA;EAGA,4BAAA;EAGA,8BAAA;EACA,gDAAA;EACA,+CAAA;EACA,kDAAA;EACA,iDAAA;EACA,yCAAA;EACA,iCAAA;EACA,oCAAA;AnK679CJ;;AoKp/9CA;EACE,uBAAA;EACA,sBAAA;ApKu/9CF;;AoKp/9CA;;EAEI,YAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kCAAA;EACA,0BAAA;EACA,gB7JmWiB;E6JlWjB,2C7JyVqB;AP8p9CzB;AgB779CI;EoJnEJ;;IAaQ,0BAAA;EpKw/9CN;AACF;AgBn89CI;EoJnEJ;;IAkBQ,0BAAA;EpKy/9CN;AACF;;AoKt/9CA;EACI,aAAA;EACA,sBAAA;ApKy/9CJ;AoKv/9CI;;;EAGI,gCAAA;ApKy/9CR;;AoKr/9CA;EACI,yBAAA;UAAA,iBAAA;ApKw/9CJ;;AoKp/9CA;EACI,aAAA;ApKu/9CJ;;AqKli+CA;EACI;IACI,qBAAA;IACA,2BAAA;ErKqi+CN;EqKni+CM;;;;;;;;;;;IAOI,2BAAA;IACA,qBAAA;IACA,oBAAA;ErKyi+CV;EqKti+CM;;;;;;;;IAQI,wBAAA;ErKwi+CV;AACF;AsKlk+CA;EACC,mCAAA;AtKok+CD;;AsKhk+CA;EACC,c/JaU;APsj+CX;;AsKhk+CA;EACC,mDAAA;AtKmk+CD;;AgBnh+CI;EsJlCH;IACC,uBAAA;EtKyj+CA;EsKrj+CD;IACC,uBAAA;EtKuj+CA;AACF;AgB5h+CI;EsJrBH;;;;;;;IAGC,0BAAA;EtKwj+CA;EsKpj+CD;IACC,iBAAA;IACA,mBAAA;EtKsj+CA;EsKnj+CA;IACC,kBAAA;EtKqj+CD;AACF;AgBji+CI;EsJbH;;;;;;;IAGC,eAAA;IACA,0BAAA;EtKqj+CA;EsK/i+CA;IACC,iBAAA;EtKij+CD;AACF;AgB7j+CI;EuJvDF;IACC,uBAAA;EvKun+CD;AACF;AgBlk+CI;EuJ/CH;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,YAAA;EvKon+CA;EuKjn+CA;IACC,eAAA;IACA,MAAA;IACA,QAAA;IACA,WAAA;IACA,WAAA;IACA,yDAAA;IACA,qDAAA;IACA,YAAA;IACA,UAAA;I/JUC,mCAAA;IACA,kCAAA;ER0m+CF;AACF;AgB1k+CI;EuJpCH;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,YAAA;EvKin+CA;EuK9m+CA;IACC,eAAA;IACA,MAAA;IACA,QAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,mEAAA;IACA,+DAAA;I/JdC,mCAAA;IACA,kCAAA;ER+n+CF;EuK7m+CA;IACC,wBAAA;EvK+m+CD;AACF;AwKzq+CA;EACC,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,UAAA;AxK2q+CD;AwKxq+CC;EACC,aAAA;EACA,mBAAA;EACA,WAAA;AxK0q+CF;AwKpq+CK;EACC,iBAAA;AxKsq+CN;AwK7p+CQ;;;E3EzBP,aAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,+BtFqoCiC;APsj8ClC;AwK3p+CQ;;E3EpCP,aAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;EACA,+BtFqoCiC;AP8j8ClC;A6Frh+CQ;EAhDN,6B2ElFmN;E3EsFnN,yB2EtFkD;AxK2p+CpD;A6Fnk+CE;EACC,yB2EzFiD;AxK8p+CpD;A6F/j+CG;;;EAGC,yB2ElGwF;AxKmq+C5F;A6F1j+CG;EACC,oC2E1GkI;AxKsq+CtI;A6Frj+CE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC+EPuK;E/EU3K,4DAAA;EACA,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC+EPuK;E/EU3K,4DAAA;EACA,oDAAA;EI0GD,iBAAA;A7Fmk+CH;A6Fzi+CC;EAEC,2BtFqIgB;EsFpMhB,6B2EjFkJ;E3EqFlJ,yB2ErFgD;AxK4r+ClD;A6Frm+CE;EACC,yB2ExF+C;AxK+r+ClD;A6F9g+CC;EACC,2BtFmGgB;EsFpMhB,6B2EhFiJ;E3EoFjJ,yB2EpF+C;AxKms+CjD;A6F7m+CE;EACC,yB2EvF8C;AxKss+CjD;A6F/h+CC;EACC,2BtF4GgB;EsFpMhB,6B2E/E2L;E3EmF3L,yB2EnF+C;AxK0s+CjD;A6Frn+CE;EACC,yB2EtF8C;AxK6s+CjD;A6Fjn+CG;;;EAGC,yB2E/FqF;AxKkt+CzF;A6F5m+CG;EACC,oC2EvG+H;AxKqt+CnI;A6Fzj+CQ;EACN,2BtFsHgB;EsFpMhB,6B2E9E6L;E3EkF7L,yB2ElFiD;AxKyt+CnD;A6Fro+CE;EACC,yB2ErFgD;AxK4t+CnD;A6Fjo+CG;;;EAGC,yB2E9FuF;AxKiu+C3F;A6F5n+CG;EACC,oC2EtGiI;AxKou+CrI;AwKju+CK;EACC,gBjKwTa;AP269CnB;;AgBlu+CI;EwJSH;IACC,eAAA;IACA,SAAA;IACA,YAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,YAAA;IhK5DE,mBAAA;ER0x+CF;EwK3t+CA;;I9B5EE,+CAAA;E1I2y+CF;E0Ixy+CE;;IACI,oC8B0E6B;ExKiu+CnC;E0Ixy+CE;;IACI,6BAAA;E1I2y+CN;E0Ity+CM;;IAEI,+CAAA;E1Iwy+CV;E0Iry+CU;;IACI,oC8B2DgD;ExK6u+C9D;E0Iry+CU;;IACI,6BAAA;E1Iwy+Cd;EwK7u+CA;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;ExK+u+CD;AACF;AgB/v+CI;EwJsBH;IACC,aAAA;ExK4u+CA;EwKzu+CA;IACC,aAAA;ExK2u+CD;AACF;AwKtu+CC;EACC,yBAAA;AxKwu+CF;;AyKj1+CA;EACC,aAAA;EACA,sBAAA;EACA,4CAAA;EACA,UAAA;AzKo1+CD;AyKj1+CC;EAOC,iBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,8BAAA;EACA,mBAAA;AzK60+CF;AyK30+CE;EACC,UAAA;EACA,SAAA;EACA,YAjBgB;EAkBhB,WAjBe;EAkBf,aAAA;EACA,mBAAA;EACA,uBAAA;AzK60+CH;AyK10+CE;EACC,UAAA;EACA,SAAA;EACA,YAzBmB;EA0BnB,WAzBkB;EA0BlB,yBAzBoB;EA0BpB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8DAAA;EACA,SAAA;EjK5BC,sBAAA;ARy2+CJ;AyK10+CG;EACC,yBAlCmB;EAmCnB,kBAAA;EACA,qDAAA;AzK40+CJ;AyKz0+CG;EACC,YA5Ce;EA6Cf,WA5Cc;EA6Cd,UAAA;EACA,yBA3CmB;EA4CnB,6DAAA;AzK20+CJ;AyKz0+CI;EACC,kBAAA;EACA,oDAAA;AzK20+CL;AyKp0+CC;EACC,wDAAA;AzKs0+CF;AyKl0+CC;EACC,oCAAA;AzKo0+CF;AyKj0+CC;EACC,kDAAA;AzKm0+CF;;AgBt1+CI;EyJyBH;IACC,eAAA;IACA,MAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;EzKi0+CA;EyK7z+CA;IACC,YAAA;EzK+z+CD;AACF;AgBx1+CI;EyJ+BH;IACC,aAAA;EzK4z+CA;AACF;AgB71+CI;EyJsCH;IACC,aAAA;EzK0z+CA;EyKjz+CC;IACC,YANgB;IAOhB,WANe;EzKyz+CjB;EyKhz+CC;IACC,YATmB;IAUnB,WATkB;EzK2z+CpB;EkG/6+CE;IACI,0BAAA;IACA,yBAAA;ElGi7+CN;EyKhz+CE;IACC,YAnBe;IAoBf,WAnBc;EzKq0+CjB;EkGv7+CE;IACI,0BAAA;IACA,yBAAA;ElGy7+CN;AACF;AgBn4+CI;E0JzDH;IACC,mBAAA;E1K+7+CA;AACF;AgB33+CI;E0J/DH;IACC,mBAAA;E1K67+CA;AACF","sourcesContent":["@charset \"UTF-8\";\n/*!\n * Bootstrap  v5.3.3 (https://getbootstrap.com/)\n * Copyright 2011-2024 The Bootstrap Authors\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root,\n[data-bs-theme=light] {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000000;\n  --bs-white: #ffffff;\n  --bs-gray: #78829D;\n  --bs-gray-dark: #252F4A;\n  --bs-gray-100: #F9F9F9;\n  --bs-gray-200: #F1F1F4;\n  --bs-gray-300: #DBDFE9;\n  --bs-gray-400: #C4CADA;\n  --bs-gray-500: #99A1B7;\n  --bs-gray-600: #78829D;\n  --bs-gray-700: #4B5675;\n  --bs-gray-800: #252F4A;\n  --bs-gray-900: #071437;\n  --bs-light: #F9F9F9;\n  --bs-primary: #1B84FF;\n  --bs-secondary: #F9F9F9;\n  --bs-success: #17C653;\n  --bs-info: #7239EA;\n  --bs-warning: #F6C000;\n  --bs-danger: #F8285A;\n  --bs-dark: #1E2129;\n  --bs-light-rgb: 249, 249, 249;\n  --bs-primary-rgb: 27, 132, 255;\n  --bs-secondary-rgb: 249, 249, 249;\n  --bs-success-rgb: 23, 198, 83;\n  --bs-info-rgb: 114, 57, 234;\n  --bs-warning-rgb: 246, 192, 0;\n  --bs-danger-rgb: 248, 40, 90;\n  --bs-dark-rgb: 30, 33, 41;\n  --bs-primary-text-emphasis: #0b3566;\n  --bs-secondary-text-emphasis: #646464;\n  --bs-success-text-emphasis: #094f21;\n  --bs-info-text-emphasis: #2e175e;\n  --bs-warning-text-emphasis: #624d00;\n  --bs-danger-text-emphasis: #631024;\n  --bs-light-text-emphasis: #4B5675;\n  --bs-dark-text-emphasis: #4B5675;\n  --bs-primary-bg-subtle: #d1e6ff;\n  --bs-secondary-bg-subtle: #fefefe;\n  --bs-success-bg-subtle: #d1f4dd;\n  --bs-info-bg-subtle: #e3d7fb;\n  --bs-warning-bg-subtle: #fdf2cc;\n  --bs-danger-bg-subtle: #fed4de;\n  --bs-light-bg-subtle: #fcfcfc;\n  --bs-dark-bg-subtle: #C4CADA;\n  --bs-primary-border-subtle: #a4ceff;\n  --bs-secondary-border-subtle: #fdfdfd;\n  --bs-success-border-subtle: #a2e8ba;\n  --bs-info-border-subtle: #c7b0f7;\n  --bs-warning-border-subtle: #fbe699;\n  --bs-danger-border-subtle: #fca9bd;\n  --bs-light-border-subtle: #F1F1F4;\n  --bs-dark-border-subtle: #99A1B7;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-font-sans-serif: Inter, Helvetica, \"sans-serif\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #071437;\n  --bs-body-color-rgb: 7, 20, 55;\n  --bs-body-bg: #ffffff;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-emphasis-color: #000000;\n  --bs-emphasis-color-rgb: 0, 0, 0;\n  --bs-secondary-color: rgba(7, 20, 55, 0.75);\n  --bs-secondary-color-rgb: 7, 20, 55;\n  --bs-secondary-bg: #F1F1F4;\n  --bs-secondary-bg-rgb: 241, 241, 244;\n  --bs-tertiary-color: rgba(7, 20, 55, 0.5);\n  --bs-tertiary-color-rgb: 7, 20, 55;\n  --bs-tertiary-bg: #F9F9F9;\n  --bs-tertiary-bg-rgb: 249, 249, 249;\n  --bs-heading-color: #071437;\n  --bs-link-color: #1B84FF;\n  --bs-link-color-rgb: 27, 132, 255;\n  --bs-link-decoration: none;\n  --bs-link-hover-color: #056EE9;\n  --bs-link-hover-color-rgb: 5, 110, 233;\n  --bs-link-hover-decoration: none;\n  --bs-code-color: #b93993;\n  --bs-highlight-color: #071437;\n  --bs-highlight-bg: #fff3cd;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #F1F1F4;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.65rem;\n  --bs-border-radius-sm: 0.3rem;\n  --bs-border-radius-lg: 0.85rem;\n  --bs-border-radius-xl: 1.25rem;\n  --bs-border-radius-xxl: 2rem;\n  --bs-border-radius-2xl: var(--bs-border-radius-xxl);\n  --bs-border-radius-pill: 50rem;\n  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);\n  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --bs-focus-ring-width: 0.25rem;\n  --bs-focus-ring-opacity: 0.25;\n  --bs-focus-ring-color: rgba(27, 132, 255, 0.25);\n  --bs-form-valid-color: #17C653;\n  --bs-form-valid-border-color: #17C653;\n  --bs-form-invalid-color: #F8285A;\n  --bs-form-invalid-border-color: #F8285A;\n}\n\n[data-bs-theme=dark] {\n  color-scheme: dark;\n  --bs-body-color: #F5F5F5;\n  --bs-body-color-rgb: 245, 245, 245;\n  --bs-body-bg: #15171C;\n  --bs-body-bg-rgb: 21, 23, 28;\n  --bs-emphasis-color: #ffffff;\n  --bs-emphasis-color-rgb: 255, 255, 255;\n  --bs-secondary-color: rgba(245, 245, 245, 0.75);\n  --bs-secondary-color-rgb: 245, 245, 245;\n  --bs-secondary-bg: #252F4A;\n  --bs-secondary-bg-rgb: 37, 47, 74;\n  --bs-tertiary-color: rgba(245, 245, 245, 0.5);\n  --bs-tertiary-color-rgb: 245, 245, 245;\n  --bs-tertiary-bg: #162241;\n  --bs-tertiary-bg-rgb: 22, 34, 65;\n  --bs-primary-text-emphasis: #76b5ff;\n  --bs-secondary-text-emphasis: #fbfbfb;\n  --bs-success-text-emphasis: #74dd98;\n  --bs-info-text-emphasis: #aa88f2;\n  --bs-warning-text-emphasis: #fad966;\n  --bs-danger-text-emphasis: #fb7e9c;\n  --bs-light-text-emphasis: #F9F9F9;\n  --bs-dark-text-emphasis: #DBDFE9;\n  --bs-primary-bg-subtle: #051a33;\n  --bs-secondary-bg-subtle: #323232;\n  --bs-success-bg-subtle: #052811;\n  --bs-info-bg-subtle: #170b2f;\n  --bs-warning-bg-subtle: #312600;\n  --bs-danger-bg-subtle: #320812;\n  --bs-light-bg-subtle: #252F4A;\n  --bs-dark-bg-subtle: #131825;\n  --bs-primary-border-subtle: #104f99;\n  --bs-secondary-border-subtle: #959595;\n  --bs-success-border-subtle: #0e7732;\n  --bs-info-border-subtle: #44228c;\n  --bs-warning-border-subtle: #947300;\n  --bs-danger-border-subtle: #951836;\n  --bs-light-border-subtle: #4B5675;\n  --bs-dark-border-subtle: #252F4A;\n  --bs-heading-color: #F5F5F5;\n  --bs-link-color: #006AE6;\n  --bs-link-hover-color: #3388eb;\n  --bs-link-color-rgb: 0, 106, 230;\n  --bs-link-hover-color-rgb: 51, 136, 235;\n  --bs-code-color: #b93993;\n  --bs-highlight-color: #F5F5F5;\n  --bs-highlight-bg: #664d03;\n  --bs-border-color: #26272F;\n  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);\n  --bs-form-valid-color: #75b798;\n  --bs-form-valid-border-color: #75b798;\n  --bs-form-invalid-color: #ea868f;\n  --bs-form-invalid-border-color: #ea868f;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: var(--bs-border-width) solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n  color: var(--bs-heading-color);\n}\n\nh1, .h1 {\n  font-size: calc(1.3rem + 0.6vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 1.75rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.5rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.26rem + 0.12vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.35rem;\n  }\n}\n\nh4, .h4 {\n  font-size: 1.25rem;\n}\n\nh5, .h5 {\n  font-size: 1.15rem;\n}\n\nh6, .h6 {\n  font-size: 1.075rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 600;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: 700;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  color: var(--bs-highlight-color);\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));\n  text-decoration: none;\n}\na:hover {\n  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);\n  text-decoration: none;\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 1rem;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 1rem;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 1rem;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.3rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #99A1B7;\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #78829D;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--bs-body-bg);\n  border: var(--bs-border-width) solid var(--bs-border-color);\n  border-radius: var(--bs-border-radius);\n  box-shadow: var(--bs-box-shadow-sm);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: var(--bs-gray-600);\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n:root {\n  --bs-breakpoint-xs: 0;\n  --bs-breakpoint-sm: 576px;\n  --bs-breakpoint-md: 768px;\n  --bs-breakpoint-lg: 992px;\n  --bs-breakpoint-xl: 1200px;\n  --bs-breakpoint-xxl: 1400px;\n}\n\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0rem;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0rem;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 0.75rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 0.75rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 1.25rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 1.25rem;\n}\n\n.g-6,\n.gx-6 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-6,\n.gy-6 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-7,\n.gx-7 {\n  --bs-gutter-x: 1.75rem;\n}\n\n.g-7,\n.gy-7 {\n  --bs-gutter-y: 1.75rem;\n}\n\n.g-8,\n.gx-8 {\n  --bs-gutter-x: 2rem;\n}\n\n.g-8,\n.gy-8 {\n  --bs-gutter-y: 2rem;\n}\n\n.g-9,\n.gx-9 {\n  --bs-gutter-x: 2.25rem;\n}\n\n.g-9,\n.gy-9 {\n  --bs-gutter-y: 2.25rem;\n}\n\n.g-10,\n.gx-10 {\n  --bs-gutter-x: 2.5rem;\n}\n\n.g-10,\n.gy-10 {\n  --bs-gutter-y: 2.5rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-sm-0,\n  .gx-sm-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-sm-0,\n  .gy-sm-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-sm-1,\n  .gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-sm-1,\n  .gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-sm-2,\n  .gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-sm-2,\n  .gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-sm-3,\n  .gx-sm-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-sm-3,\n  .gy-sm-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-sm-4,\n  .gx-sm-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-sm-4,\n  .gy-sm-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-sm-5,\n  .gx-sm-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-sm-5,\n  .gy-sm-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-sm-6,\n  .gx-sm-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-sm-6,\n  .gy-sm-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-sm-7,\n  .gx-sm-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-sm-7,\n  .gy-sm-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-sm-8,\n  .gx-sm-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-sm-8,\n  .gy-sm-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-sm-9,\n  .gx-sm-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-sm-9,\n  .gy-sm-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-sm-10,\n  .gx-sm-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-sm-10,\n  .gy-sm-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-md-0,\n  .gx-md-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-md-0,\n  .gy-md-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-md-1,\n  .gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-md-1,\n  .gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-md-2,\n  .gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-md-2,\n  .gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-md-3,\n  .gx-md-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-md-3,\n  .gy-md-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-md-4,\n  .gx-md-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-md-4,\n  .gy-md-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-md-5,\n  .gx-md-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-md-5,\n  .gy-md-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-md-6,\n  .gx-md-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-md-6,\n  .gy-md-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-md-7,\n  .gx-md-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-md-7,\n  .gy-md-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-md-8,\n  .gx-md-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-md-8,\n  .gy-md-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-md-9,\n  .gx-md-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-md-9,\n  .gy-md-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-md-10,\n  .gx-md-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-md-10,\n  .gy-md-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-lg-0,\n  .gx-lg-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-lg-0,\n  .gy-lg-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-lg-1,\n  .gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-lg-1,\n  .gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-lg-2,\n  .gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-lg-2,\n  .gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-lg-3,\n  .gx-lg-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-lg-3,\n  .gy-lg-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-lg-4,\n  .gx-lg-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-lg-4,\n  .gy-lg-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-lg-5,\n  .gx-lg-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-lg-5,\n  .gy-lg-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-lg-6,\n  .gx-lg-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-lg-6,\n  .gy-lg-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-lg-7,\n  .gx-lg-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-lg-7,\n  .gy-lg-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-lg-8,\n  .gx-lg-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-lg-8,\n  .gy-lg-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-lg-9,\n  .gx-lg-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-lg-9,\n  .gy-lg-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-lg-10,\n  .gx-lg-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-lg-10,\n  .gy-lg-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xl-0,\n  .gx-xl-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-xl-0,\n  .gy-xl-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-xl-1,\n  .gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xl-1,\n  .gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xl-2,\n  .gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xl-2,\n  .gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xl-3,\n  .gx-xl-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xl-3,\n  .gy-xl-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xl-4,\n  .gx-xl-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xl-4,\n  .gy-xl-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xl-5,\n  .gx-xl-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-xl-5,\n  .gy-xl-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-xl-6,\n  .gx-xl-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xl-6,\n  .gy-xl-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xl-7,\n  .gx-xl-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-xl-7,\n  .gy-xl-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-xl-8,\n  .gx-xl-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-xl-8,\n  .gy-xl-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-xl-9,\n  .gx-xl-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-xl-9,\n  .gy-xl-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-xl-10,\n  .gx-xl-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-xl-10,\n  .gy-xl-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n  .g-xxl-0,\n  .gx-xxl-0 {\n    --bs-gutter-x: 0rem;\n  }\n  .g-xxl-0,\n  .gy-xxl-0 {\n    --bs-gutter-y: 0rem;\n  }\n  .g-xxl-1,\n  .gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n  .g-xxl-1,\n  .gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n  .g-xxl-2,\n  .gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n  .g-xxl-2,\n  .gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n  .g-xxl-3,\n  .gx-xxl-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n  .g-xxl-3,\n  .gy-xxl-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n  .g-xxl-4,\n  .gx-xxl-4 {\n    --bs-gutter-x: 1rem;\n  }\n  .g-xxl-4,\n  .gy-xxl-4 {\n    --bs-gutter-y: 1rem;\n  }\n  .g-xxl-5,\n  .gx-xxl-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n  .g-xxl-5,\n  .gy-xxl-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n  .g-xxl-6,\n  .gx-xxl-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n  .g-xxl-6,\n  .gy-xxl-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n  .g-xxl-7,\n  .gx-xxl-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n  .g-xxl-7,\n  .gy-xxl-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n  .g-xxl-8,\n  .gx-xxl-8 {\n    --bs-gutter-x: 2rem;\n  }\n  .g-xxl-8,\n  .gy-xxl-8 {\n    --bs-gutter-y: 2rem;\n  }\n  .g-xxl-9,\n  .gx-xxl-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n  .g-xxl-9,\n  .gy-xxl-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n  .g-xxl-10,\n  .gx-xxl-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n  .g-xxl-10,\n  .gy-xxl-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n.table {\n  --bs-table-color-type: initial;\n  --bs-table-bg-type: initial;\n  --bs-table-color-state: initial;\n  --bs-table-bg-state: initial;\n  --bs-table-color: var(--bs-body-color);\n  --bs-table-bg: transparent;\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-body-color);\n  --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);\n  --bs-table-active-color: var(--bs-body-color);\n  --bs-table-active-bg: var(--bs-gray-100);\n  --bs-table-hover-color: var(--bs-body-color);\n  --bs-table-hover-bg: var(--bs-gray-100);\n  width: 100%;\n  margin-bottom: 1rem;\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.75rem 0.75rem;\n  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: calc(1px * 2) solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 1px 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-color-type: var(--bs-table-striped-color);\n  --bs-table-bg-type: var(--bs-table-striped-bg);\n}\n\n.table-active {\n  --bs-table-color-state: var(--bs-table-active-color);\n  --bs-table-bg-state: var(--bs-table-active-bg);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-color-state: var(--bs-table-hover-color);\n  --bs-table-bg-state: var(--bs-table-hover-bg);\n}\n\n.table-primary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #d1e6ff;\n  --bs-table-border-color: #bccfe6;\n  --bs-table-striped-bg: #c7dbf2;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #bccfe6;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #c1d5ec;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fefefe;\n  --bs-table-border-color: #e5e5e5;\n  --bs-table-striped-bg: #f1f1f1;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e5e5e5;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #ebebeb;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000000;\n  --bs-table-bg: #d1f4dd;\n  --bs-table-border-color: #bcdcc7;\n  --bs-table-striped-bg: #c7e8d2;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #bcdcc7;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #c1e2cc;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000000;\n  --bs-table-bg: #e3d7fb;\n  --bs-table-border-color: #ccc2e2;\n  --bs-table-striped-bg: #d8ccee;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #ccc2e2;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #d2c7e8;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fdf2cc;\n  --bs-table-border-color: #e4dab8;\n  --bs-table-striped-bg: #f0e6c2;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e4dab8;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #eae0bd;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fed4de;\n  --bs-table-border-color: #e5bfc8;\n  --bs-table-striped-bg: #f1c9d3;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e5bfc8;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #ebc4cd;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000000;\n  --bs-table-bg: #F9F9F9;\n  --bs-table-border-color: #e0e0e0;\n  --bs-table-striped-bg: #ededed;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e0e0e0;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e6e6e6;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #ffffff;\n  --bs-table-bg: #1E2129;\n  --bs-table-border-color: #35373e;\n  --bs-table-striped-bg: #292c34;\n  --bs-table-striped-color: #ffffff;\n  --bs-table-active-bg: #35373e;\n  --bs-table-active-color: #ffffff;\n  --bs-table-hover-bg: #2f3239;\n  --bs-table-hover-color: #ffffff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: var(--bs-gray-800);\n}\n\n.col-form-label {\n  padding-top: calc(0.775rem + 1px);\n  padding-bottom: calc(0.775rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-gray-800);\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.825rem + 1px);\n  padding-bottom: calc(0.825rem + 1px);\n  font-size: 1.15rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.55rem + 1px);\n  padding-bottom: calc(0.55rem + 1px);\n  font-size: 0.95rem;\n}\n\n.form-text {\n  margin-top: 0.5rem;\n  font-size: 0.95rem;\n  color: var(--bs-text-muted);\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.775rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-clip: padding-box;\n  border: 1px solid var(--bs-gray-300);\n  border-radius: 0.65rem;\n  box-shadow: false;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: var(--bs-gray-700);\n  background-color: var(--bs-body-bg);\n  border-color: var(--bs-gray-400);\n  outline: 0;\n  box-shadow: false, 0 0 0 0.25rem rgba(27, 132, 255, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  min-width: 85px;\n  height: 1.5em;\n  margin: 0;\n}\n.form-control::-webkit-datetime-edit {\n  display: block;\n  padding: 0;\n}\n.form-control::placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n.form-control:disabled {\n  color: var(--bs-gray-500);\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-300);\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.775rem 1rem;\n  margin: -0.775rem -1rem;\n  margin-inline-end: 1rem;\n  color: var(--bs-gray-700);\n  background-color: var(--bs-gray-100);\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: shade-color(var(--bs-gray-100), 5%);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.775rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 1.1rem + 2px);\n  padding: 0.55rem 0.75rem;\n  font-size: 0.95rem;\n  border-radius: 0.3rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.55rem 0.75rem;\n  margin: -0.55rem -0.75rem;\n  margin-inline-end: 0.75rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1.65rem + 2px);\n  padding: 0.825rem 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.85rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.825rem 1.5rem;\n  margin: -0.825rem -1.5rem;\n  margin-inline-end: 1.5rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 1.55rem + 2px);\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 1.1rem + 2px);\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1.65rem + 2px);\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 1.55rem + 2px);\n  padding: 0.775rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 0.65rem;\n}\n.form-control-color::-webkit-color-swatch {\n  border: 0 !important;\n  border-radius: 0.65rem;\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 1.1rem + 2px);\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1.65rem + 2px);\n}\n\n.form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%2378829D' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  display: block;\n  width: 100%;\n  padding: 0.775rem 3rem 0.775rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  appearance: none;\n  background-color: var(--bs-body-bg);\n  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 16px 12px;\n  border: 1px solid var(--bs-gray-300);\n  border-radius: 0.65rem;\n  box-shadow: false;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: var(--bs-gray-400);\n  outline: 0;\n  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 1rem;\n  background-image: none;\n}\n.form-select:disabled {\n  color: var(--bs-gray-500);\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-300);\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 var(--bs-gray-700);\n}\n\n.form-select-sm {\n  padding-top: 0.55rem;\n  padding-bottom: 0.55rem;\n  padding-left: 0.75rem;\n  font-size: 0.95rem;\n  border-radius: 0.3rem;\n}\n\n.form-select-lg {\n  padding-top: 0.825rem;\n  padding-bottom: 0.825rem;\n  padding-left: 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.85rem;\n}\n\n[data-bs-theme=dark] .form-select {\n  --bs-form-select-bg-img: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23808290' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 2.25rem;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -2.25rem;\n}\n\n.form-check-reverse {\n  padding-right: 2.25rem;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -2.25rem;\n  margin-left: 0;\n}\n\n.form-check-input {\n  --bs-form-check-bg: transparent;\n  flex-shrink: 0;\n  width: 1.75rem;\n  height: 1.75rem;\n  margin-top: -0.125rem;\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--bs-form-check-bg);\n  background-image: var(--bs-form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid var(--bs-gray-300);\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.45em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: var(--bs-gray-400);\n  outline: 0;\n  box-shadow: none;\n}\n.form-check-input:checked {\n  background-color: #1B84FF;\n  border-color: #1B84FF;\n}\n.form-check-input:checked[type=checkbox] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'%3e%3cpath d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #1B84FF;\n  border-color: #1B84FF;\n  --bs-form-check-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-check-label {\n  color: var(--bs-gray-500);\n}\n\n.form-switch {\n  padding-left: 3.75rem;\n}\n.form-switch .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  width: 3.25rem;\n  margin-left: -3.75rem;\n  background-image: var(--bs-form-switch-bg);\n  background-position: left center;\n  border-radius: 3.25rem;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 3.75rem;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -3.75rem;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  appearance: none;\n  background-color: transparent;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(27, 132, 255, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(27, 132, 255, 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  appearance: none;\n  background-color: #1B84FF;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: #bbdaff;\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-gray-300);\n  border-color: transparent;\n  border-radius: 0.65rem;\n  box-shadow: var(--bs-box-shadow-inset);\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  appearance: none;\n  background-color: #1B84FF;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: #bbdaff;\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--bs-gray-300);\n  border-color: transparent;\n  border-radius: 0.65rem;\n  box-shadow: var(--bs-box-shadow-inset);\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--bs-gray-500);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--bs-gray-500);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.75rem + 2px);\n  min-height: calc(3.75rem + 2px);\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  height: 100%;\n  padding: 1rem 1rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 1rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.85rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.85rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.85rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-select ~ label::after {\n  position: absolute;\n  inset: 1rem 0.5rem;\n  z-index: -1;\n  height: 1.5em;\n  content: \"\";\n  background-color: var(--bs-body-bg);\n  border-radius: 0.65rem;\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  color: rgba(var(--bs-body-color-rgb), 0.65);\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: 1px 0;\n}\n.form-floating > :disabled ~ label,\n.form-floating > .form-control:disabled ~ label {\n  color: #78829D;\n}\n.form-floating > :disabled ~ label::after,\n.form-floating > .form-control:disabled ~ label::after {\n  background-color: var(--bs-gray-200);\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.775rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--bs-gray-700);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-gray-100);\n  border: 1px solid var(--bs-gray-300);\n  border-radius: 0.65rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.825rem 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.85rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.55rem 0.75rem;\n  font-size: 0.95rem;\n  border-radius: 0.3rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 4rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: calc(1px * -1);\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.95rem;\n  color: var(--bs-form-valid-color);\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 1rem;\n  color: #fff;\n  background-color: var(--bs-success);\n  border-radius: 0.65rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n  padding-right: calc(1.5em + 1.55rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2317C653' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.3875rem) center;\n  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 1.55rem);\n  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2317C653' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  padding-right: 5.5rem;\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: var(--bs-form-valid-border-color);\n  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 1.55rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: var(--bs-form-valid-border-color);\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: var(--bs-form-valid-color);\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: var(--bs-form-valid-color);\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.95rem;\n  color: var(--bs-form-invalid-color);\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 1rem;\n  color: #fff;\n  background-color: var(--bs-danger);\n  border-radius: 0.65rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n  padding-right: calc(1.5em + 1.55rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23F8285A'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F8285A' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.3875rem) center;\n  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 1.55rem);\n  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  --bs-form-select-bg-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23F8285A'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23F8285A' stroke='none'/%3e%3c/svg%3e\");\n  padding-right: 5.5rem;\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: var(--bs-form-invalid-border-color);\n  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 1.55rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: var(--bs-form-invalid-border-color);\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: var(--bs-form-invalid-color);\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: var(--bs-form-invalid-color);\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 1.5rem;\n  --bs-btn-padding-y: 0.775rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1.1rem;\n  --bs-btn-font-weight: 500;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: 1px;\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 0.65rem;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: none;\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  box-shadow: var(--bs-btn-box-shadow);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n  box-shadow: var(--bs-btn-active-shadow);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked:focus-visible + .btn {\n  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n  box-shadow: none;\n}\n\n.btn-light {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #F9F9F9;\n  --bs-btn-border-color: #F9F9F9;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #d4d4d4;\n  --bs-btn-hover-border-color: #c7c7c7;\n  --bs-btn-focus-shadow-rgb: 212, 212, 212;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #c7c7c7;\n  --bs-btn-active-border-color: #bbbbbb;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #F9F9F9;\n  --bs-btn-disabled-border-color: #F9F9F9;\n}\n\n.btn-primary {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #1B84FF;\n  --bs-btn-border-color: #1B84FF;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #3d96ff;\n  --bs-btn-hover-border-color: #3290ff;\n  --bs-btn-focus-shadow-rgb: 23, 112, 217;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #499dff;\n  --bs-btn-active-border-color: #3290ff;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #1B84FF;\n  --bs-btn-disabled-border-color: #1B84FF;\n}\n\n.btn-secondary {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #F9F9F9;\n  --bs-btn-border-color: #F9F9F9;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #fafafa;\n  --bs-btn-hover-border-color: #fafafa;\n  --bs-btn-focus-shadow-rgb: 212, 212, 212;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #fafafa;\n  --bs-btn-active-border-color: #fafafa;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #F9F9F9;\n  --bs-btn-disabled-border-color: #F9F9F9;\n}\n\n.btn-success {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #17C653;\n  --bs-btn-border-color: #17C653;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #3acf6d;\n  --bs-btn-hover-border-color: #2ecc64;\n  --bs-btn-focus-shadow-rgb: 20, 168, 71;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #45d175;\n  --bs-btn-active-border-color: #2ecc64;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #17C653;\n  --bs-btn-disabled-border-color: #17C653;\n}\n\n.btn-info {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #7239EA;\n  --bs-btn-border-color: #7239EA;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #6130c7;\n  --bs-btn-hover-border-color: #5b2ebb;\n  --bs-btn-focus-shadow-rgb: 135, 87, 237;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #5b2ebb;\n  --bs-btn-active-border-color: #562bb0;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #7239EA;\n  --bs-btn-disabled-border-color: #7239EA;\n}\n\n.btn-warning {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #F6C000;\n  --bs-btn-border-color: #F6C000;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #f7c926;\n  --bs-btn-hover-border-color: #f7c61a;\n  --bs-btn-focus-shadow-rgb: 209, 163, 0;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #f8cd33;\n  --bs-btn-active-border-color: #f7c61a;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #F6C000;\n  --bs-btn-disabled-border-color: #F6C000;\n}\n\n.btn-danger {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #F8285A;\n  --bs-btn-border-color: #F8285A;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #f94873;\n  --bs-btn-hover-border-color: #f93e6b;\n  --bs-btn-focus-shadow-rgb: 211, 34, 77;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #f9537b;\n  --bs-btn-active-border-color: #f93e6b;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #F8285A;\n  --bs-btn-disabled-border-color: #F8285A;\n}\n\n.btn-dark {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #1E2129;\n  --bs-btn-border-color: #1E2129;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #404249;\n  --bs-btn-hover-border-color: #35373e;\n  --bs-btn-focus-shadow-rgb: 64, 66, 73;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #4b4d54;\n  --bs-btn-active-border-color: #35373e;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #1E2129;\n  --bs-btn-disabled-border-color: #1E2129;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #F9F9F9;\n  --bs-btn-border-color: #F9F9F9;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #F9F9F9;\n  --bs-btn-hover-border-color: #F9F9F9;\n  --bs-btn-focus-shadow-rgb: 249, 249, 249;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #F9F9F9;\n  --bs-btn-active-border-color: #F9F9F9;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #F9F9F9;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F9F9F9;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #1B84FF;\n  --bs-btn-border-color: #1B84FF;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #1B84FF;\n  --bs-btn-hover-border-color: #1B84FF;\n  --bs-btn-focus-shadow-rgb: 27, 132, 255;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #1B84FF;\n  --bs-btn-active-border-color: #1B84FF;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #1B84FF;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #1B84FF;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #F9F9F9;\n  --bs-btn-border-color: #F9F9F9;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #F9F9F9;\n  --bs-btn-hover-border-color: #F9F9F9;\n  --bs-btn-focus-shadow-rgb: 249, 249, 249;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #F9F9F9;\n  --bs-btn-active-border-color: #F9F9F9;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #F9F9F9;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F9F9F9;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #17C653;\n  --bs-btn-border-color: #17C653;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #17C653;\n  --bs-btn-hover-border-color: #17C653;\n  --bs-btn-focus-shadow-rgb: 23, 198, 83;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #17C653;\n  --bs-btn-active-border-color: #17C653;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #17C653;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #17C653;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #7239EA;\n  --bs-btn-border-color: #7239EA;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #7239EA;\n  --bs-btn-hover-border-color: #7239EA;\n  --bs-btn-focus-shadow-rgb: 114, 57, 234;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #7239EA;\n  --bs-btn-active-border-color: #7239EA;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #7239EA;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #7239EA;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #F6C000;\n  --bs-btn-border-color: #F6C000;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #F6C000;\n  --bs-btn-hover-border-color: #F6C000;\n  --bs-btn-focus-shadow-rgb: 246, 192, 0;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #F6C000;\n  --bs-btn-active-border-color: #F6C000;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #F6C000;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F6C000;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #F8285A;\n  --bs-btn-border-color: #F8285A;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #F8285A;\n  --bs-btn-hover-border-color: #F8285A;\n  --bs-btn-focus-shadow-rgb: 248, 40, 90;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #F8285A;\n  --bs-btn-active-border-color: #F8285A;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #F8285A;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #F8285A;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #1E2129;\n  --bs-btn-border-color: #1E2129;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #1E2129;\n  --bs-btn-hover-border-color: #1E2129;\n  --bs-btn-focus-shadow-rgb: 30, 33, 41;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #1E2129;\n  --bs-btn-active-border-color: #1E2129;\n  --bs-btn-active-shadow: none;\n  --bs-btn-disabled-color: #1E2129;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #1E2129;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: var(--bs-link-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: var(--bs-link-hover-color);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: var(--bs-link-hover-color);\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: var(--bs-gray-600);\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: 0 0 0 #000;\n  --bs-btn-focus-shadow-rgb: 23, 112, 217;\n  text-decoration: none;\n}\n.btn-link:hover, .btn-link:focus-visible {\n  text-decoration: none;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.825rem;\n  --bs-btn-padding-x: 1.75rem;\n  --bs-btn-font-size: 1.15rem;\n  --bs-btn-border-radius: 0.85rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.55rem;\n  --bs-btn-padding-x: 1rem;\n  --bs-btn-font-size: 0.95rem;\n  --bs-btn-border-radius: 0.3rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: var(--bs-body-color);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: 0.65rem;\n  --bs-dropdown-border-width: 0rem;\n  --bs-dropdown-inner-border-radius: calc(0.65rem - 0rem);\n  --bs-dropdown-divider-bg: var(--bs-gray-100);\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-dropdown-link-color: var(--bs-gray-900);\n  --bs-dropdown-link-hover-color: var(--bs-gray-900);\n  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);\n  --bs-dropdown-link-active-color: var(--bs-component-hover-color);\n  --bs-dropdown-link-active-bg: var(--bs-component-hover-bg);\n  --bs-dropdown-link-disabled-color: var(--bs-gray-500);\n  --bs-dropdown-item-padding-x: 0.85rem;\n  --bs-dropdown-item-padding-y: 0.65rem;\n  --bs-dropdown-header-color: var(--bs-gray-600);\n  --bs-dropdown-header-padding-x: 0.85rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n  box-shadow: var(--bs-dropdown-box-shadow);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  border-radius: var(--bs-dropdown-item-border-radius, 0);\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.95rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #DBDFE9;\n  --bs-dropdown-bg: #252F4A;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #DBDFE9;\n  --bs-dropdown-link-hover-color: #ffffff;\n  --bs-dropdown-divider-bg: var(--bs-gray-100);\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: var(--bs-component-hover-color);\n  --bs-dropdown-link-active-bg: var(--bs-component-hover-bg);\n  --bs-dropdown-link-disabled-color: #99A1B7;\n  --bs-dropdown-header-color: #99A1B7;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: 0.65rem;\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: calc(1px * -1);\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 1.125rem;\n  padding-left: 1.125rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1.3125rem;\n  padding-left: 1.3125rem;\n}\n\n.btn-group.show .dropdown-toggle {\n  box-shadow: none;\n}\n.btn-group.show .dropdown-toggle.btn-link {\n  box-shadow: none;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: calc(1px * -1);\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-secondary-color);\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  background: none;\n  border: 0;\n  transition: color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link:focus-visible {\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgba(27, 132, 255, 0.25);\n}\n.nav-link.disabled, .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: var(--bs-border-width);\n  --bs-nav-tabs-border-color: var(--bs-border-color);\n  --bs-nav-tabs-border-radius: var(--bs-border-radius);\n  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);\n  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);\n  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);\n  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: var(--bs-border-radius);\n  --bs-nav-pills-link-active-color: #ffffff;\n  --bs-nav-pills-link-active-bg: #1B84FF;\n}\n.nav-pills .nav-link {\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-underline {\n  --bs-nav-underline-gap: 1rem;\n  --bs-nav-underline-border-width: 0.125rem;\n  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);\n  gap: var(--bs-nav-underline-gap);\n}\n.nav-underline .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n  border-bottom: var(--bs-nav-underline-border-width) solid transparent;\n}\n.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {\n  border-bottom-color: currentcolor;\n}\n.nav-underline .nav-link.active,\n.nav-underline .show > .nav-link {\n  font-weight: 600;\n  color: var(--bs-nav-underline-link-active-color);\n  border-bottom-color: currentcolor;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);\n  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);\n  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);\n  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-padding-y: 0.44375rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.075rem;\n  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.075rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%287, 20, 55, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);\n  --bs-navbar-toggler-border-radius: 0.65rem;\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  box-shadow: none;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=dark] {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #ffffff;\n  --bs-navbar-brand-color: #ffffff;\n  --bs-navbar-brand-hover-color: #ffffff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n[data-bs-theme=dark] .navbar-toggler-icon {\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-title-color: var(--bs-gray-900);\n  --bs-card-subtitle-color: ;\n  --bs-card-border-width: 1px;\n  --bs-card-border-color: #F1F1F4;\n  --bs-card-border-radius: 0.85rem;\n  --bs-card-box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);\n  --bs-card-inner-border-radius: calc(0.85rem - 1px);\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: transparent;\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: var(--bs-body-bg);\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  color: var(--bs-body-color);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n  box-shadow: var(--bs-card-box-shadow);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n  color: var(--bs-card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n  color: var(--bs-card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: var(--bs-body-color);\n  --bs-accordion-bg: var(--bs-body-bg);\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: var(--bs-border-color);\n  --bs-accordion-border-width: var(--bs-border-width);\n  --bs-accordion-border-radius: 0.65rem;\n  --bs-accordion-inner-border-radius: calc(0.65rem - (var(--bs-border-width)));\n  --bs-accordion-btn-padding-x: 1.5rem;\n  --bs-accordion-btn-padding-y: 1.5rem;\n  --bs-accordion-btn-color: var(--bs-body-color);\n  --bs-accordion-btn-bg: var(--bs-body-bg);\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23071437'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.15rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%231B84FF'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-box-shadow: none;\n  --bs-accordion-body-padding-x: 1.5rem;\n  --bs-accordion-body-padding-y: 1.5rem;\n  --bs-accordion-active-color: var(--bs-primary);\n  --bs-accordion-active-bg: var(--bs-gray-100);\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type > .accordion-header .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type > .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush > .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush > .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {\n  border-radius: 0;\n}\n.accordion-flush > .accordion-item > .accordion-collapse {\n  border-radius: 0;\n}\n\n[data-bs-theme=dark] .accordion-button::after {\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23F5F5F5'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23006AE6'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: var(--bs-gray-600);\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: var(--bs-primary);\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1.075rem;\n  --bs-pagination-color: var(--bs-gray-700);\n  --bs-pagination-bg: transparent;\n  --bs-pagination-border-width: 0;\n  --bs-pagination-border-color: transparent;\n  --bs-pagination-border-radius: 0.65rem;\n  --bs-pagination-hover-color: var(--bs-component-hover-color);\n  --bs-pagination-hover-bg: var(--bs-component-hover-bg);\n  --bs-pagination-hover-border-color: transparent;\n  --bs-pagination-focus-color: var(--bs-component-hover-color);\n  --bs-pagination-focus-bg: var(--bs-component-hover-bg);\n  --bs-pagination-focus-box-shadow: none;\n  --bs-pagination-active-color: var(--bs-component-active-color);\n  --bs-pagination-active-bg: var(--bs-component-active-bg);\n  --bs-pagination-active-border-color: transparent;\n  --bs-pagination-disabled-color: var(--bs-gray-400);\n  --bs-pagination-disabled-bg: transparent;\n  --bs-pagination-disabled-border-color: transparent;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: calc(0 * -1);\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.075rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-lg);\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.95rem;\n  --bs-pagination-border-radius: var(--bs-border-radius-sm);\n}\n\n.badge {\n  --bs-badge-padding-x: 0.5rem;\n  --bs-badge-padding-y: 0.325rem;\n  --bs-badge-font-size: 0.85rem;\n  --bs-badge-font-weight: 600;\n  --bs-badge-color: var(--bs-body-color);\n  --bs-badge-border-radius: 0.3rem;\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: var(--bs-border-radius);\n  --bs-alert-link-color: inherit;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 600;\n  color: var(--bs-alert-link-color);\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-light {\n  --bs-alert-color: var(--bs-light-text-emphasis);\n  --bs-alert-bg: var(--bs-light-bg-subtle);\n  --bs-alert-border-color: var(--bs-light-border-subtle);\n  --bs-alert-link-color: var(--bs-light-text-emphasis);\n}\n\n.alert-primary {\n  --bs-alert-color: var(--bs-primary-text-emphasis);\n  --bs-alert-bg: var(--bs-primary-bg-subtle);\n  --bs-alert-border-color: var(--bs-primary-border-subtle);\n  --bs-alert-link-color: var(--bs-primary-text-emphasis);\n}\n\n.alert-secondary {\n  --bs-alert-color: var(--bs-secondary-text-emphasis);\n  --bs-alert-bg: var(--bs-secondary-bg-subtle);\n  --bs-alert-border-color: var(--bs-secondary-border-subtle);\n  --bs-alert-link-color: var(--bs-secondary-text-emphasis);\n}\n\n.alert-success {\n  --bs-alert-color: var(--bs-success-text-emphasis);\n  --bs-alert-bg: var(--bs-success-bg-subtle);\n  --bs-alert-border-color: var(--bs-success-border-subtle);\n  --bs-alert-link-color: var(--bs-success-text-emphasis);\n}\n\n.alert-info {\n  --bs-alert-color: var(--bs-info-text-emphasis);\n  --bs-alert-bg: var(--bs-info-bg-subtle);\n  --bs-alert-border-color: var(--bs-info-border-subtle);\n  --bs-alert-link-color: var(--bs-info-text-emphasis);\n}\n\n.alert-warning {\n  --bs-alert-color: var(--bs-warning-text-emphasis);\n  --bs-alert-bg: var(--bs-warning-bg-subtle);\n  --bs-alert-border-color: var(--bs-warning-border-subtle);\n  --bs-alert-link-color: var(--bs-warning-text-emphasis);\n}\n\n.alert-danger {\n  --bs-alert-color: var(--bs-danger-text-emphasis);\n  --bs-alert-bg: var(--bs-danger-bg-subtle);\n  --bs-alert-border-color: var(--bs-danger-border-subtle);\n  --bs-alert-link-color: var(--bs-danger-text-emphasis);\n}\n\n.alert-dark {\n  --bs-alert-color: var(--bs-dark-text-emphasis);\n  --bs-alert-bg: var(--bs-dark-bg-subtle);\n  --bs-alert-border-color: var(--bs-dark-border-subtle);\n  --bs-alert-link-color: var(--bs-dark-text-emphasis);\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress,\n.progress-stacked {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: var(--bs-gray-100);\n  --bs-progress-border-radius: 6px;\n  --bs-progress-box-shadow: none;\n  --bs-progress-bar-color: #ffffff;\n  --bs-progress-bar-bg: #1B84FF;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n  box-shadow: var(--bs-progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: var(--bs-gray-900);\n  --bs-list-group-bg: #ffffff;\n  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);\n  --bs-list-group-border-width: var(--bs-border-width);\n  --bs-list-group-border-radius: var(--bs-border-radius);\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: var(--bs-gray-700);\n  --bs-list-group-action-hover-color: var(--bs-gray-700);\n  --bs-list-group-action-hover-bg: var(--bs-gray-100);\n  --bs-list-group-action-active-color: var(--bs-body-color);\n  --bs-list-group-action-active-bg: var(--bs-gray-200);\n  --bs-list-group-disabled-color: var(--bs-gray-600);\n  --bs-list-group-disabled-bg: #ffffff;\n  --bs-list-group-active-color: var(--bs-component-active-color);\n  --bs-list-group-active-bg: var(--bs-component-active-bg);\n  --bs-list-group-active-border-color: var(--bs-component-active-bg);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-light {\n  --bs-list-group-color: var(--bs-light-text-emphasis);\n  --bs-list-group-bg: var(--bs-light-bg-subtle);\n  --bs-list-group-border-color: var(--bs-light-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);\n  --bs-list-group-active-color: var(--bs-light-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-light-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);\n}\n\n.list-group-item-primary {\n  --bs-list-group-color: var(--bs-primary-text-emphasis);\n  --bs-list-group-bg: var(--bs-primary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-primary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);\n  --bs-list-group-active-color: var(--bs-primary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);\n}\n\n.list-group-item-secondary {\n  --bs-list-group-color: var(--bs-secondary-text-emphasis);\n  --bs-list-group-bg: var(--bs-secondary-bg-subtle);\n  --bs-list-group-border-color: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);\n  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);\n}\n\n.list-group-item-success {\n  --bs-list-group-color: var(--bs-success-text-emphasis);\n  --bs-list-group-bg: var(--bs-success-bg-subtle);\n  --bs-list-group-border-color: var(--bs-success-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);\n  --bs-list-group-active-color: var(--bs-success-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-success-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);\n}\n\n.list-group-item-info {\n  --bs-list-group-color: var(--bs-info-text-emphasis);\n  --bs-list-group-bg: var(--bs-info-bg-subtle);\n  --bs-list-group-border-color: var(--bs-info-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);\n  --bs-list-group-active-color: var(--bs-info-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-info-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);\n}\n\n.list-group-item-warning {\n  --bs-list-group-color: var(--bs-warning-text-emphasis);\n  --bs-list-group-bg: var(--bs-warning-bg-subtle);\n  --bs-list-group-border-color: var(--bs-warning-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);\n  --bs-list-group-active-color: var(--bs-warning-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);\n}\n\n.list-group-item-danger {\n  --bs-list-group-color: var(--bs-danger-text-emphasis);\n  --bs-list-group-bg: var(--bs-danger-bg-subtle);\n  --bs-list-group-border-color: var(--bs-danger-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);\n  --bs-list-group-active-color: var(--bs-danger-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);\n}\n\n.list-group-item-dark {\n  --bs-list-group-color: var(--bs-dark-text-emphasis);\n  --bs-list-group-bg: var(--bs-dark-bg-subtle);\n  --bs-list-group-border-color: var(--bs-dark-border-subtle);\n  --bs-list-group-action-hover-color: var(--bs-emphasis-color);\n  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-action-active-color: var(--bs-emphasis-color);\n  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);\n  --bs-list-group-active-color: var(--bs-dark-bg-subtle);\n  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);\n  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);\n}\n\n.btn-close {\n  --bs-btn-close-color: #000000;\n  --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --bs-btn-close-opacity: 0.5;\n  --bs-btn-close-hover-opacity: 0.75;\n  --bs-btn-close-focus-shadow: none;\n  --bs-btn-close-focus-opacity: 1;\n  --bs-btn-close-disabled-opacity: 0.25;\n  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);\n  box-sizing: content-box;\n  width: 0.75rem;\n  height: 0.75rem;\n  padding: 0.25em 0.25em;\n  color: var(--bs-btn-close-color);\n  background: transparent var(--bs-btn-close-bg) center/0.75rem auto no-repeat;\n  border: 0;\n  border-radius: 0.65rem;\n  opacity: var(--bs-btn-close-opacity);\n}\n.btn-close:hover {\n  color: var(--bs-btn-close-color);\n  text-decoration: none;\n  opacity: var(--bs-btn-close-hover-opacity);\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: var(--bs-btn-close-focus-shadow);\n  opacity: var(--bs-btn-close-focus-opacity);\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: var(--bs-btn-close-disabled-opacity);\n}\n\n.btn-close-white {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n[data-bs-theme=dark] .btn-close {\n  filter: var(--bs-btn-close-white-filter);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: var(--bs-gray-700);\n  --bs-toast-bg: var(--bs-body-bg);\n  --bs-toast-border-width: var(--bs-border-width);\n  --bs-toast-border-color: transparent;\n  --bs-toast-border-radius: var(--bs-border-radius);\n  --bs-toast-box-shadow: var(--bs-box-shadow);\n  --bs-toast-header-color: var(--bs-gray-700);\n  --bs-toast-header-bg: var(--bs-body-bg);\n  --bs-toast-header-border-color: var(--bs-border-color);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1.75rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: var(--bs-body-bg);\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: 0;\n  --bs-modal-border-radius: 0.65rem;\n  --bs-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  --bs-modal-inner-border-radius: 0.65rem;\n  --bs-modal-header-padding-x: 1.75rem;\n  --bs-modal-header-padding-y: 1.75rem;\n  --bs-modal-header-padding: 1.75rem 1.75rem;\n  --bs-modal-header-border-color: var(--bs-border-color);\n  --bs-modal-header-border-width: 1px;\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: var(--bs-border-color);\n  --bs-modal-footer-border-width: 1px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  box-shadow: var(--bs-modal-box-shadow);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000000;\n  --bs-backdrop-opacity: 0.4;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\n  }\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n  .modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n  .modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n  .modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n  .modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n  .modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 1rem;\n  --bs-tooltip-padding-y: 0.75rem;\n  --bs-tooltip-margin: 0;\n  --bs-tooltip-font-size: 1rem;\n  --bs-tooltip-color: var(--bs-gray-800);\n  --bs-tooltip-bg: var(--bs-body-bg);\n  --bs-tooltip-border-radius: 0.65rem;\n  --bs-tooltip-opacity: 1;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: calc(-1 * var(--bs-tooltip-arrow-height));\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: calc(-1 * var(--bs-tooltip-arrow-height));\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 1rem;\n  --bs-popover-bg: #ffffff;\n  --bs-popover-border-width: var(--bs-border-width);\n  --bs-popover-border-color: #ffffff;\n  --bs-popover-border-radius: 0.65rem;\n  --bs-popover-inner-border-radius: 0.65rem;\n  --bs-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-popover-header-padding-x: 1.25rem;\n  --bs-popover-header-padding-y: 1rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: var(--bs-gray-800);\n  --bs-popover-header-bg: #ffffff;\n  --bs-popover-body-padding-x: 1.25rem;\n  --bs-popover-body-padding-y: 1.25rem;\n  --bs-popover-body-color: var(--bs-gray-800);\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n  box-shadow: var(--bs-popover-box-shadow);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n  .carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #ffffff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #ffffff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\") /*rtl:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\")*/;\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #ffffff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000000;\n}\n.carousel-dark .carousel-caption {\n  color: #000000;\n}\n\n[data-bs-theme=dark] .carousel .carousel-control-prev-icon,\n[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,\n[data-bs-theme=dark].carousel .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {\n  background-color: #000000;\n}\n[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {\n  color: #000000;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.185rem;\n  --bs-spinner-animation-speed: 0.65s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.145em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.65s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n  .spinner-grow {\n    --bs-spinner-animation-speed: 1.3s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1.75rem;\n  --bs-offcanvas-padding-y: 1.75rem;\n  --bs-offcanvas-color: var(--bs-body-color);\n  --bs-offcanvas-bg: var(--bs-body-bg);\n  --bs-offcanvas-border-width: 0;\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  --bs-offcanvas-transition: transform 0.3s ease-in-out;\n  --bs-offcanvas-title-line-height: 1.5;\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: var(--bs-offcanvas-transition);\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  box-shadow: var(--bs-offcanvas-box-shadow);\n  transition: var(--bs-offcanvas-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000000;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.4;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--bs-offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-light {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #000000 !important;\n  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #ffffff !important;\n  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-light {\n  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-light:hover, .link-light:focus {\n  color: RGBA(250, 250, 250, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(250, 250, 250, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-primary {\n  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: RGBA(73, 157, 255, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(73, 157, 255, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-secondary {\n  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: RGBA(250, 250, 250, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(250, 250, 250, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-success {\n  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-success:hover, .link-success:focus {\n  color: RGBA(69, 209, 117, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(69, 209, 117, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-info {\n  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-info:hover, .link-info:focus {\n  color: RGBA(91, 46, 187, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(91, 46, 187, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-warning {\n  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: RGBA(248, 205, 51, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(248, 205, 51, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-danger {\n  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: RGBA(249, 83, 123, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(249, 83, 123, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-dark {\n  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: RGBA(24, 26, 33, var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(24, 26, 33, var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-body-emphasis {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n.link-body-emphasis:hover, .link-body-emphasis:focus {\n  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;\n  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;\n}\n\n.focus-ring:focus {\n  outline: 0;\n  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);\n}\n\n.icon-link {\n  display: inline-flex;\n  gap: 0.375rem;\n  align-items: center;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));\n  text-underline-offset: 0.25em;\n  backface-visibility: hidden;\n}\n.icon-link > .bi {\n  flex-shrink: 0;\n  width: 1em;\n  height: 1em;\n  fill: currentcolor;\n  transition: 0.2s ease-in-out transform;\n}\n@media (prefers-reduced-motion: reduce) {\n  .icon-link > .bi {\n    transition: none;\n  }\n}\n\n.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {\n  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n.visually-hidden:not(caption),\n.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {\n  position: absolute !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: var(--bs-border-width);\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.object-fit-contain {\n  object-fit: contain !important;\n}\n\n.object-fit-cover {\n  object-fit: cover !important;\n}\n\n.object-fit-fill {\n  object-fit: fill !important;\n}\n\n.object-fit-scale {\n  object-fit: scale-down !important;\n}\n\n.object-fit-none {\n  object-fit: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-5 {\n  opacity: 0.05 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.overflow-x-auto {\n  overflow-x: auto !important;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden !important;\n}\n\n.overflow-x-visible {\n  overflow-x: visible !important;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll !important;\n}\n\n.overflow-y-auto {\n  overflow-y: auto !important;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden !important;\n}\n\n.overflow-y-visible {\n  overflow-y: visible !important;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-inline-grid {\n  display: inline-grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm) !important;\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.focus-ring-light {\n  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-primary {\n  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-secondary {\n  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-success {\n  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-info {\n  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-warning {\n  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-danger {\n  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));\n}\n\n.focus-ring-dark {\n  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-25 {\n  top: 25% !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-75 {\n  top: 75% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-25 {\n  bottom: 25% !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-75 {\n  bottom: 75% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-25 {\n  left: 25% !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-75 {\n  left: 75% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-25 {\n  right: 25% !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-75 {\n  right: 75% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-black {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary-subtle {\n  border-color: var(--bs-primary-border-subtle) !important;\n}\n\n.border-secondary-subtle {\n  border-color: var(--bs-secondary-border-subtle) !important;\n}\n\n.border-success-subtle {\n  border-color: var(--bs-success-border-subtle) !important;\n}\n\n.border-info-subtle {\n  border-color: var(--bs-info-border-subtle) !important;\n}\n\n.border-warning-subtle {\n  border-color: var(--bs-warning-border-subtle) !important;\n}\n\n.border-danger-subtle {\n  border-color: var(--bs-danger-border-subtle) !important;\n}\n\n.border-light-subtle {\n  border-color: var(--bs-light-border-subtle) !important;\n}\n\n.border-dark-subtle {\n  border-color: var(--bs-dark-border-subtle) !important;\n}\n\n.border-0 {\n  border-width: 0 !important;\n}\n\n.border-1 {\n  border-width: 1px !important;\n}\n\n.border-2 {\n  border-width: 2px !important;\n}\n\n.border-3 {\n  border-width: 3px !important;\n}\n\n.border-4 {\n  border-width: 4px !important;\n}\n\n.border-5 {\n  border-width: 5px !important;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-unset {\n  width: unset !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.w-1px {\n  width: 1px !important;\n}\n\n.w-2px {\n  width: 2px !important;\n}\n\n.w-3px {\n  width: 3px !important;\n}\n\n.w-4px {\n  width: 4px !important;\n}\n\n.w-5px {\n  width: 5px !important;\n}\n\n.w-6px {\n  width: 6px !important;\n}\n\n.w-7px {\n  width: 7px !important;\n}\n\n.w-8px {\n  width: 8px !important;\n}\n\n.w-9px {\n  width: 9px !important;\n}\n\n.w-10px {\n  width: 10px !important;\n}\n\n.w-15px {\n  width: 15px !important;\n}\n\n.w-20px {\n  width: 20px !important;\n}\n\n.w-25px {\n  width: 25px !important;\n}\n\n.w-30px {\n  width: 30px !important;\n}\n\n.w-35px {\n  width: 35px !important;\n}\n\n.w-40px {\n  width: 40px !important;\n}\n\n.w-45px {\n  width: 45px !important;\n}\n\n.w-50px {\n  width: 50px !important;\n}\n\n.w-55px {\n  width: 55px !important;\n}\n\n.w-60px {\n  width: 60px !important;\n}\n\n.w-65px {\n  width: 65px !important;\n}\n\n.w-70px {\n  width: 70px !important;\n}\n\n.w-75px {\n  width: 75px !important;\n}\n\n.w-80px {\n  width: 80px !important;\n}\n\n.w-85px {\n  width: 85px !important;\n}\n\n.w-90px {\n  width: 90px !important;\n}\n\n.w-95px {\n  width: 95px !important;\n}\n\n.w-100px {\n  width: 100px !important;\n}\n\n.w-125px {\n  width: 125px !important;\n}\n\n.w-150px {\n  width: 150px !important;\n}\n\n.w-175px {\n  width: 175px !important;\n}\n\n.w-200px {\n  width: 200px !important;\n}\n\n.w-225px {\n  width: 225px !important;\n}\n\n.w-250px {\n  width: 250px !important;\n}\n\n.w-275px {\n  width: 275px !important;\n}\n\n.w-300px {\n  width: 300px !important;\n}\n\n.w-325px {\n  width: 325px !important;\n}\n\n.w-350px {\n  width: 350px !important;\n}\n\n.w-375px {\n  width: 375px !important;\n}\n\n.w-400px {\n  width: 400px !important;\n}\n\n.w-425px {\n  width: 425px !important;\n}\n\n.w-450px {\n  width: 450px !important;\n}\n\n.w-475px {\n  width: 475px !important;\n}\n\n.w-500px {\n  width: 500px !important;\n}\n\n.w-550px {\n  width: 550px !important;\n}\n\n.w-600px {\n  width: 600px !important;\n}\n\n.w-650px {\n  width: 650px !important;\n}\n\n.w-700px {\n  width: 700px !important;\n}\n\n.w-750px {\n  width: 750px !important;\n}\n\n.w-800px {\n  width: 800px !important;\n}\n\n.w-850px {\n  width: 850px !important;\n}\n\n.w-900px {\n  width: 900px !important;\n}\n\n.w-950px {\n  width: 950px !important;\n}\n\n.w-1000px {\n  width: 1000px !important;\n}\n\n.mw-unset {\n  max-width: unset !important;\n}\n\n.mw-25 {\n  max-width: 25% !important;\n}\n\n.mw-50 {\n  max-width: 50% !important;\n}\n\n.mw-75 {\n  max-width: 75% !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mw-auto {\n  max-width: auto !important;\n}\n\n.mw-1px {\n  max-width: 1px !important;\n}\n\n.mw-2px {\n  max-width: 2px !important;\n}\n\n.mw-3px {\n  max-width: 3px !important;\n}\n\n.mw-4px {\n  max-width: 4px !important;\n}\n\n.mw-5px {\n  max-width: 5px !important;\n}\n\n.mw-6px {\n  max-width: 6px !important;\n}\n\n.mw-7px {\n  max-width: 7px !important;\n}\n\n.mw-8px {\n  max-width: 8px !important;\n}\n\n.mw-9px {\n  max-width: 9px !important;\n}\n\n.mw-10px {\n  max-width: 10px !important;\n}\n\n.mw-15px {\n  max-width: 15px !important;\n}\n\n.mw-20px {\n  max-width: 20px !important;\n}\n\n.mw-25px {\n  max-width: 25px !important;\n}\n\n.mw-30px {\n  max-width: 30px !important;\n}\n\n.mw-35px {\n  max-width: 35px !important;\n}\n\n.mw-40px {\n  max-width: 40px !important;\n}\n\n.mw-45px {\n  max-width: 45px !important;\n}\n\n.mw-50px {\n  max-width: 50px !important;\n}\n\n.mw-55px {\n  max-width: 55px !important;\n}\n\n.mw-60px {\n  max-width: 60px !important;\n}\n\n.mw-65px {\n  max-width: 65px !important;\n}\n\n.mw-70px {\n  max-width: 70px !important;\n}\n\n.mw-75px {\n  max-width: 75px !important;\n}\n\n.mw-80px {\n  max-width: 80px !important;\n}\n\n.mw-85px {\n  max-width: 85px !important;\n}\n\n.mw-90px {\n  max-width: 90px !important;\n}\n\n.mw-95px {\n  max-width: 95px !important;\n}\n\n.mw-100px {\n  max-width: 100px !important;\n}\n\n.mw-125px {\n  max-width: 125px !important;\n}\n\n.mw-150px {\n  max-width: 150px !important;\n}\n\n.mw-175px {\n  max-width: 175px !important;\n}\n\n.mw-200px {\n  max-width: 200px !important;\n}\n\n.mw-225px {\n  max-width: 225px !important;\n}\n\n.mw-250px {\n  max-width: 250px !important;\n}\n\n.mw-275px {\n  max-width: 275px !important;\n}\n\n.mw-300px {\n  max-width: 300px !important;\n}\n\n.mw-325px {\n  max-width: 325px !important;\n}\n\n.mw-350px {\n  max-width: 350px !important;\n}\n\n.mw-375px {\n  max-width: 375px !important;\n}\n\n.mw-400px {\n  max-width: 400px !important;\n}\n\n.mw-425px {\n  max-width: 425px !important;\n}\n\n.mw-450px {\n  max-width: 450px !important;\n}\n\n.mw-475px {\n  max-width: 475px !important;\n}\n\n.mw-500px {\n  max-width: 500px !important;\n}\n\n.mw-550px {\n  max-width: 550px !important;\n}\n\n.mw-600px {\n  max-width: 600px !important;\n}\n\n.mw-650px {\n  max-width: 650px !important;\n}\n\n.mw-700px {\n  max-width: 700px !important;\n}\n\n.mw-750px {\n  max-width: 750px !important;\n}\n\n.mw-800px {\n  max-width: 800px !important;\n}\n\n.mw-850px {\n  max-width: 850px !important;\n}\n\n.mw-900px {\n  max-width: 900px !important;\n}\n\n.mw-950px {\n  max-width: 950px !important;\n}\n\n.mw-1000px {\n  max-width: 1000px !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-unset {\n  height: unset !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.h-1px {\n  height: 1px !important;\n}\n\n.h-2px {\n  height: 2px !important;\n}\n\n.h-3px {\n  height: 3px !important;\n}\n\n.h-4px {\n  height: 4px !important;\n}\n\n.h-5px {\n  height: 5px !important;\n}\n\n.h-6px {\n  height: 6px !important;\n}\n\n.h-7px {\n  height: 7px !important;\n}\n\n.h-8px {\n  height: 8px !important;\n}\n\n.h-9px {\n  height: 9px !important;\n}\n\n.h-10px {\n  height: 10px !important;\n}\n\n.h-15px {\n  height: 15px !important;\n}\n\n.h-20px {\n  height: 20px !important;\n}\n\n.h-25px {\n  height: 25px !important;\n}\n\n.h-30px {\n  height: 30px !important;\n}\n\n.h-35px {\n  height: 35px !important;\n}\n\n.h-40px {\n  height: 40px !important;\n}\n\n.h-45px {\n  height: 45px !important;\n}\n\n.h-50px {\n  height: 50px !important;\n}\n\n.h-55px {\n  height: 55px !important;\n}\n\n.h-60px {\n  height: 60px !important;\n}\n\n.h-65px {\n  height: 65px !important;\n}\n\n.h-70px {\n  height: 70px !important;\n}\n\n.h-75px {\n  height: 75px !important;\n}\n\n.h-80px {\n  height: 80px !important;\n}\n\n.h-85px {\n  height: 85px !important;\n}\n\n.h-90px {\n  height: 90px !important;\n}\n\n.h-95px {\n  height: 95px !important;\n}\n\n.h-100px {\n  height: 100px !important;\n}\n\n.h-125px {\n  height: 125px !important;\n}\n\n.h-150px {\n  height: 150px !important;\n}\n\n.h-175px {\n  height: 175px !important;\n}\n\n.h-200px {\n  height: 200px !important;\n}\n\n.h-225px {\n  height: 225px !important;\n}\n\n.h-250px {\n  height: 250px !important;\n}\n\n.h-275px {\n  height: 275px !important;\n}\n\n.h-300px {\n  height: 300px !important;\n}\n\n.h-325px {\n  height: 325px !important;\n}\n\n.h-350px {\n  height: 350px !important;\n}\n\n.h-375px {\n  height: 375px !important;\n}\n\n.h-400px {\n  height: 400px !important;\n}\n\n.h-425px {\n  height: 425px !important;\n}\n\n.h-450px {\n  height: 450px !important;\n}\n\n.h-475px {\n  height: 475px !important;\n}\n\n.h-500px {\n  height: 500px !important;\n}\n\n.h-550px {\n  height: 550px !important;\n}\n\n.h-600px {\n  height: 600px !important;\n}\n\n.h-650px {\n  height: 650px !important;\n}\n\n.h-700px {\n  height: 700px !important;\n}\n\n.h-750px {\n  height: 750px !important;\n}\n\n.h-800px {\n  height: 800px !important;\n}\n\n.h-850px {\n  height: 850px !important;\n}\n\n.h-900px {\n  height: 900px !important;\n}\n\n.h-950px {\n  height: 950px !important;\n}\n\n.h-1000px {\n  height: 1000px !important;\n}\n\n.mh-unset {\n  max-height: unset !important;\n}\n\n.mh-25 {\n  max-height: 25% !important;\n}\n\n.mh-50 {\n  max-height: 50% !important;\n}\n\n.mh-75 {\n  max-height: 75% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.mh-auto {\n  max-height: auto !important;\n}\n\n.mh-1px {\n  max-height: 1px !important;\n}\n\n.mh-2px {\n  max-height: 2px !important;\n}\n\n.mh-3px {\n  max-height: 3px !important;\n}\n\n.mh-4px {\n  max-height: 4px !important;\n}\n\n.mh-5px {\n  max-height: 5px !important;\n}\n\n.mh-6px {\n  max-height: 6px !important;\n}\n\n.mh-7px {\n  max-height: 7px !important;\n}\n\n.mh-8px {\n  max-height: 8px !important;\n}\n\n.mh-9px {\n  max-height: 9px !important;\n}\n\n.mh-10px {\n  max-height: 10px !important;\n}\n\n.mh-15px {\n  max-height: 15px !important;\n}\n\n.mh-20px {\n  max-height: 20px !important;\n}\n\n.mh-25px {\n  max-height: 25px !important;\n}\n\n.mh-30px {\n  max-height: 30px !important;\n}\n\n.mh-35px {\n  max-height: 35px !important;\n}\n\n.mh-40px {\n  max-height: 40px !important;\n}\n\n.mh-45px {\n  max-height: 45px !important;\n}\n\n.mh-50px {\n  max-height: 50px !important;\n}\n\n.mh-55px {\n  max-height: 55px !important;\n}\n\n.mh-60px {\n  max-height: 60px !important;\n}\n\n.mh-65px {\n  max-height: 65px !important;\n}\n\n.mh-70px {\n  max-height: 70px !important;\n}\n\n.mh-75px {\n  max-height: 75px !important;\n}\n\n.mh-80px {\n  max-height: 80px !important;\n}\n\n.mh-85px {\n  max-height: 85px !important;\n}\n\n.mh-90px {\n  max-height: 90px !important;\n}\n\n.mh-95px {\n  max-height: 95px !important;\n}\n\n.mh-100px {\n  max-height: 100px !important;\n}\n\n.mh-125px {\n  max-height: 125px !important;\n}\n\n.mh-150px {\n  max-height: 150px !important;\n}\n\n.mh-175px {\n  max-height: 175px !important;\n}\n\n.mh-200px {\n  max-height: 200px !important;\n}\n\n.mh-225px {\n  max-height: 225px !important;\n}\n\n.mh-250px {\n  max-height: 250px !important;\n}\n\n.mh-275px {\n  max-height: 275px !important;\n}\n\n.mh-300px {\n  max-height: 300px !important;\n}\n\n.mh-325px {\n  max-height: 325px !important;\n}\n\n.mh-350px {\n  max-height: 350px !important;\n}\n\n.mh-375px {\n  max-height: 375px !important;\n}\n\n.mh-400px {\n  max-height: 400px !important;\n}\n\n.mh-425px {\n  max-height: 425px !important;\n}\n\n.mh-450px {\n  max-height: 450px !important;\n}\n\n.mh-475px {\n  max-height: 475px !important;\n}\n\n.mh-500px {\n  max-height: 500px !important;\n}\n\n.mh-550px {\n  max-height: 550px !important;\n}\n\n.mh-600px {\n  max-height: 600px !important;\n}\n\n.mh-650px {\n  max-height: 650px !important;\n}\n\n.mh-700px {\n  max-height: 700px !important;\n}\n\n.mh-750px {\n  max-height: 750px !important;\n}\n\n.mh-800px {\n  max-height: 800px !important;\n}\n\n.mh-850px {\n  max-height: 850px !important;\n}\n\n.mh-900px {\n  max-height: 900px !important;\n}\n\n.mh-950px {\n  max-height: 950px !important;\n}\n\n.mh-1000px {\n  max-height: 1000px !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 0.75rem !important;\n}\n\n.m-4 {\n  margin: 1rem !important;\n}\n\n.m-5 {\n  margin: 1.25rem !important;\n}\n\n.m-6 {\n  margin: 1.5rem !important;\n}\n\n.m-7 {\n  margin: 1.75rem !important;\n}\n\n.m-8 {\n  margin: 2rem !important;\n}\n\n.m-9 {\n  margin: 2.25rem !important;\n}\n\n.m-10 {\n  margin: 2.5rem !important;\n}\n\n.m-11 {\n  margin: 2.75rem !important;\n}\n\n.m-12 {\n  margin: 3rem !important;\n}\n\n.m-13 {\n  margin: 3.25rem !important;\n}\n\n.m-14 {\n  margin: 3.5rem !important;\n}\n\n.m-15 {\n  margin: 3.75rem !important;\n}\n\n.m-16 {\n  margin: 4rem !important;\n}\n\n.m-17 {\n  margin: 4.25rem !important;\n}\n\n.m-18 {\n  margin: 4.5rem !important;\n}\n\n.m-19 {\n  margin: 4.75rem !important;\n}\n\n.m-20 {\n  margin: 5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 0.75rem !important;\n  margin-left: 0.75rem !important;\n}\n\n.mx-4 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-5 {\n  margin-right: 1.25rem !important;\n  margin-left: 1.25rem !important;\n}\n\n.mx-6 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-7 {\n  margin-right: 1.75rem !important;\n  margin-left: 1.75rem !important;\n}\n\n.mx-8 {\n  margin-right: 2rem !important;\n  margin-left: 2rem !important;\n}\n\n.mx-9 {\n  margin-right: 2.25rem !important;\n  margin-left: 2.25rem !important;\n}\n\n.mx-10 {\n  margin-right: 2.5rem !important;\n  margin-left: 2.5rem !important;\n}\n\n.mx-11 {\n  margin-right: 2.75rem !important;\n  margin-left: 2.75rem !important;\n}\n\n.mx-12 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-13 {\n  margin-right: 3.25rem !important;\n  margin-left: 3.25rem !important;\n}\n\n.mx-14 {\n  margin-right: 3.5rem !important;\n  margin-left: 3.5rem !important;\n}\n\n.mx-15 {\n  margin-right: 3.75rem !important;\n  margin-left: 3.75rem !important;\n}\n\n.mx-16 {\n  margin-right: 4rem !important;\n  margin-left: 4rem !important;\n}\n\n.mx-17 {\n  margin-right: 4.25rem !important;\n  margin-left: 4.25rem !important;\n}\n\n.mx-18 {\n  margin-right: 4.5rem !important;\n  margin-left: 4.5rem !important;\n}\n\n.mx-19 {\n  margin-right: 4.75rem !important;\n  margin-left: 4.75rem !important;\n}\n\n.mx-20 {\n  margin-right: 5rem !important;\n  margin-left: 5rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 0.75rem !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.my-4 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-5 {\n  margin-top: 1.25rem !important;\n  margin-bottom: 1.25rem !important;\n}\n\n.my-6 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-7 {\n  margin-top: 1.75rem !important;\n  margin-bottom: 1.75rem !important;\n}\n\n.my-8 {\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}\n\n.my-9 {\n  margin-top: 2.25rem !important;\n  margin-bottom: 2.25rem !important;\n}\n\n.my-10 {\n  margin-top: 2.5rem !important;\n  margin-bottom: 2.5rem !important;\n}\n\n.my-11 {\n  margin-top: 2.75rem !important;\n  margin-bottom: 2.75rem !important;\n}\n\n.my-12 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-13 {\n  margin-top: 3.25rem !important;\n  margin-bottom: 3.25rem !important;\n}\n\n.my-14 {\n  margin-top: 3.5rem !important;\n  margin-bottom: 3.5rem !important;\n}\n\n.my-15 {\n  margin-top: 3.75rem !important;\n  margin-bottom: 3.75rem !important;\n}\n\n.my-16 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n\n.my-17 {\n  margin-top: 4.25rem !important;\n  margin-bottom: 4.25rem !important;\n}\n\n.my-18 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-19 {\n  margin-top: 4.75rem !important;\n  margin-bottom: 4.75rem !important;\n}\n\n.my-20 {\n  margin-top: 5rem !important;\n  margin-bottom: 5rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 0.75rem !important;\n}\n\n.mt-4 {\n  margin-top: 1rem !important;\n}\n\n.mt-5 {\n  margin-top: 1.25rem !important;\n}\n\n.mt-6 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-7 {\n  margin-top: 1.75rem !important;\n}\n\n.mt-8 {\n  margin-top: 2rem !important;\n}\n\n.mt-9 {\n  margin-top: 2.25rem !important;\n}\n\n.mt-10 {\n  margin-top: 2.5rem !important;\n}\n\n.mt-11 {\n  margin-top: 2.75rem !important;\n}\n\n.mt-12 {\n  margin-top: 3rem !important;\n}\n\n.mt-13 {\n  margin-top: 3.25rem !important;\n}\n\n.mt-14 {\n  margin-top: 3.5rem !important;\n}\n\n.mt-15 {\n  margin-top: 3.75rem !important;\n}\n\n.mt-16 {\n  margin-top: 4rem !important;\n}\n\n.mt-17 {\n  margin-top: 4.25rem !important;\n}\n\n.mt-18 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-19 {\n  margin-top: 4.75rem !important;\n}\n\n.mt-20 {\n  margin-top: 5rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 0.75rem !important;\n}\n\n.me-4 {\n  margin-right: 1rem !important;\n}\n\n.me-5 {\n  margin-right: 1.25rem !important;\n}\n\n.me-6 {\n  margin-right: 1.5rem !important;\n}\n\n.me-7 {\n  margin-right: 1.75rem !important;\n}\n\n.me-8 {\n  margin-right: 2rem !important;\n}\n\n.me-9 {\n  margin-right: 2.25rem !important;\n}\n\n.me-10 {\n  margin-right: 2.5rem !important;\n}\n\n.me-11 {\n  margin-right: 2.75rem !important;\n}\n\n.me-12 {\n  margin-right: 3rem !important;\n}\n\n.me-13 {\n  margin-right: 3.25rem !important;\n}\n\n.me-14 {\n  margin-right: 3.5rem !important;\n}\n\n.me-15 {\n  margin-right: 3.75rem !important;\n}\n\n.me-16 {\n  margin-right: 4rem !important;\n}\n\n.me-17 {\n  margin-right: 4.25rem !important;\n}\n\n.me-18 {\n  margin-right: 4.5rem !important;\n}\n\n.me-19 {\n  margin-right: 4.75rem !important;\n}\n\n.me-20 {\n  margin-right: 5rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem !important;\n}\n\n.mb-6 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-7 {\n  margin-bottom: 1.75rem !important;\n}\n\n.mb-8 {\n  margin-bottom: 2rem !important;\n}\n\n.mb-9 {\n  margin-bottom: 2.25rem !important;\n}\n\n.mb-10 {\n  margin-bottom: 2.5rem !important;\n}\n\n.mb-11 {\n  margin-bottom: 2.75rem !important;\n}\n\n.mb-12 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-13 {\n  margin-bottom: 3.25rem !important;\n}\n\n.mb-14 {\n  margin-bottom: 3.5rem !important;\n}\n\n.mb-15 {\n  margin-bottom: 3.75rem !important;\n}\n\n.mb-16 {\n  margin-bottom: 4rem !important;\n}\n\n.mb-17 {\n  margin-bottom: 4.25rem !important;\n}\n\n.mb-18 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-19 {\n  margin-bottom: 4.75rem !important;\n}\n\n.mb-20 {\n  margin-bottom: 5rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 0.75rem !important;\n}\n\n.ms-4 {\n  margin-left: 1rem !important;\n}\n\n.ms-5 {\n  margin-left: 1.25rem !important;\n}\n\n.ms-6 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-7 {\n  margin-left: 1.75rem !important;\n}\n\n.ms-8 {\n  margin-left: 2rem !important;\n}\n\n.ms-9 {\n  margin-left: 2.25rem !important;\n}\n\n.ms-10 {\n  margin-left: 2.5rem !important;\n}\n\n.ms-11 {\n  margin-left: 2.75rem !important;\n}\n\n.ms-12 {\n  margin-left: 3rem !important;\n}\n\n.ms-13 {\n  margin-left: 3.25rem !important;\n}\n\n.ms-14 {\n  margin-left: 3.5rem !important;\n}\n\n.ms-15 {\n  margin-left: 3.75rem !important;\n}\n\n.ms-16 {\n  margin-left: 4rem !important;\n}\n\n.ms-17 {\n  margin-left: 4.25rem !important;\n}\n\n.ms-18 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-19 {\n  margin-left: 4.75rem !important;\n}\n\n.ms-20 {\n  margin-left: 5rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -0.75rem !important;\n}\n\n.m-n4 {\n  margin: -1rem !important;\n}\n\n.m-n5 {\n  margin: -1.25rem !important;\n}\n\n.m-n6 {\n  margin: -1.5rem !important;\n}\n\n.m-n7 {\n  margin: -1.75rem !important;\n}\n\n.m-n8 {\n  margin: -2rem !important;\n}\n\n.m-n9 {\n  margin: -2.25rem !important;\n}\n\n.m-n10 {\n  margin: -2.5rem !important;\n}\n\n.m-n11 {\n  margin: -2.75rem !important;\n}\n\n.m-n12 {\n  margin: -3rem !important;\n}\n\n.m-n13 {\n  margin: -3.25rem !important;\n}\n\n.m-n14 {\n  margin: -3.5rem !important;\n}\n\n.m-n15 {\n  margin: -3.75rem !important;\n}\n\n.m-n16 {\n  margin: -4rem !important;\n}\n\n.m-n17 {\n  margin: -4.25rem !important;\n}\n\n.m-n18 {\n  margin: -4.5rem !important;\n}\n\n.m-n19 {\n  margin: -4.75rem !important;\n}\n\n.m-n20 {\n  margin: -5rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.25rem !important;\n  margin-left: -0.25rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.5rem !important;\n  margin-left: -0.5rem !important;\n}\n\n.mx-n3 {\n  margin-right: -0.75rem !important;\n  margin-left: -0.75rem !important;\n}\n\n.mx-n4 {\n  margin-right: -1rem !important;\n  margin-left: -1rem !important;\n}\n\n.mx-n5 {\n  margin-right: -1.25rem !important;\n  margin-left: -1.25rem !important;\n}\n\n.mx-n6 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n7 {\n  margin-right: -1.75rem !important;\n  margin-left: -1.75rem !important;\n}\n\n.mx-n8 {\n  margin-right: -2rem !important;\n  margin-left: -2rem !important;\n}\n\n.mx-n9 {\n  margin-right: -2.25rem !important;\n  margin-left: -2.25rem !important;\n}\n\n.mx-n10 {\n  margin-right: -2.5rem !important;\n  margin-left: -2.5rem !important;\n}\n\n.mx-n11 {\n  margin-right: -2.75rem !important;\n  margin-left: -2.75rem !important;\n}\n\n.mx-n12 {\n  margin-right: -3rem !important;\n  margin-left: -3rem !important;\n}\n\n.mx-n13 {\n  margin-right: -3.25rem !important;\n  margin-left: -3.25rem !important;\n}\n\n.mx-n14 {\n  margin-right: -3.5rem !important;\n  margin-left: -3.5rem !important;\n}\n\n.mx-n15 {\n  margin-right: -3.75rem !important;\n  margin-left: -3.75rem !important;\n}\n\n.mx-n16 {\n  margin-right: -4rem !important;\n  margin-left: -4rem !important;\n}\n\n.mx-n17 {\n  margin-right: -4.25rem !important;\n  margin-left: -4.25rem !important;\n}\n\n.mx-n18 {\n  margin-right: -4.5rem !important;\n  margin-left: -4.5rem !important;\n}\n\n.mx-n19 {\n  margin-right: -4.75rem !important;\n  margin-left: -4.75rem !important;\n}\n\n.mx-n20 {\n  margin-right: -5rem !important;\n  margin-left: -5rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.25rem !important;\n  margin-bottom: -0.25rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.5rem !important;\n  margin-bottom: -0.5rem !important;\n}\n\n.my-n3 {\n  margin-top: -0.75rem !important;\n  margin-bottom: -0.75rem !important;\n}\n\n.my-n4 {\n  margin-top: -1rem !important;\n  margin-bottom: -1rem !important;\n}\n\n.my-n5 {\n  margin-top: -1.25rem !important;\n  margin-bottom: -1.25rem !important;\n}\n\n.my-n6 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n7 {\n  margin-top: -1.75rem !important;\n  margin-bottom: -1.75rem !important;\n}\n\n.my-n8 {\n  margin-top: -2rem !important;\n  margin-bottom: -2rem !important;\n}\n\n.my-n9 {\n  margin-top: -2.25rem !important;\n  margin-bottom: -2.25rem !important;\n}\n\n.my-n10 {\n  margin-top: -2.5rem !important;\n  margin-bottom: -2.5rem !important;\n}\n\n.my-n11 {\n  margin-top: -2.75rem !important;\n  margin-bottom: -2.75rem !important;\n}\n\n.my-n12 {\n  margin-top: -3rem !important;\n  margin-bottom: -3rem !important;\n}\n\n.my-n13 {\n  margin-top: -3.25rem !important;\n  margin-bottom: -3.25rem !important;\n}\n\n.my-n14 {\n  margin-top: -3.5rem !important;\n  margin-bottom: -3.5rem !important;\n}\n\n.my-n15 {\n  margin-top: -3.75rem !important;\n  margin-bottom: -3.75rem !important;\n}\n\n.my-n16 {\n  margin-top: -4rem !important;\n  margin-bottom: -4rem !important;\n}\n\n.my-n17 {\n  margin-top: -4.25rem !important;\n  margin-bottom: -4.25rem !important;\n}\n\n.my-n18 {\n  margin-top: -4.5rem !important;\n  margin-bottom: -4.5rem !important;\n}\n\n.my-n19 {\n  margin-top: -4.75rem !important;\n  margin-bottom: -4.75rem !important;\n}\n\n.my-n20 {\n  margin-top: -5rem !important;\n  margin-bottom: -5rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mt-n3 {\n  margin-top: -0.75rem !important;\n}\n\n.mt-n4 {\n  margin-top: -1rem !important;\n}\n\n.mt-n5 {\n  margin-top: -1.25rem !important;\n}\n\n.mt-n6 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n7 {\n  margin-top: -1.75rem !important;\n}\n\n.mt-n8 {\n  margin-top: -2rem !important;\n}\n\n.mt-n9 {\n  margin-top: -2.25rem !important;\n}\n\n.mt-n10 {\n  margin-top: -2.5rem !important;\n}\n\n.mt-n11 {\n  margin-top: -2.75rem !important;\n}\n\n.mt-n12 {\n  margin-top: -3rem !important;\n}\n\n.mt-n13 {\n  margin-top: -3.25rem !important;\n}\n\n.mt-n14 {\n  margin-top: -3.5rem !important;\n}\n\n.mt-n15 {\n  margin-top: -3.75rem !important;\n}\n\n.mt-n16 {\n  margin-top: -4rem !important;\n}\n\n.mt-n17 {\n  margin-top: -4.25rem !important;\n}\n\n.mt-n18 {\n  margin-top: -4.5rem !important;\n}\n\n.mt-n19 {\n  margin-top: -4.75rem !important;\n}\n\n.mt-n20 {\n  margin-top: -5rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.me-n3 {\n  margin-right: -0.75rem !important;\n}\n\n.me-n4 {\n  margin-right: -1rem !important;\n}\n\n.me-n5 {\n  margin-right: -1.25rem !important;\n}\n\n.me-n6 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n7 {\n  margin-right: -1.75rem !important;\n}\n\n.me-n8 {\n  margin-right: -2rem !important;\n}\n\n.me-n9 {\n  margin-right: -2.25rem !important;\n}\n\n.me-n10 {\n  margin-right: -2.5rem !important;\n}\n\n.me-n11 {\n  margin-right: -2.75rem !important;\n}\n\n.me-n12 {\n  margin-right: -3rem !important;\n}\n\n.me-n13 {\n  margin-right: -3.25rem !important;\n}\n\n.me-n14 {\n  margin-right: -3.5rem !important;\n}\n\n.me-n15 {\n  margin-right: -3.75rem !important;\n}\n\n.me-n16 {\n  margin-right: -4rem !important;\n}\n\n.me-n17 {\n  margin-right: -4.25rem !important;\n}\n\n.me-n18 {\n  margin-right: -4.5rem !important;\n}\n\n.me-n19 {\n  margin-right: -4.75rem !important;\n}\n\n.me-n20 {\n  margin-right: -5rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -0.75rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -1rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -1.25rem !important;\n}\n\n.mb-n6 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n7 {\n  margin-bottom: -1.75rem !important;\n}\n\n.mb-n8 {\n  margin-bottom: -2rem !important;\n}\n\n.mb-n9 {\n  margin-bottom: -2.25rem !important;\n}\n\n.mb-n10 {\n  margin-bottom: -2.5rem !important;\n}\n\n.mb-n11 {\n  margin-bottom: -2.75rem !important;\n}\n\n.mb-n12 {\n  margin-bottom: -3rem !important;\n}\n\n.mb-n13 {\n  margin-bottom: -3.25rem !important;\n}\n\n.mb-n14 {\n  margin-bottom: -3.5rem !important;\n}\n\n.mb-n15 {\n  margin-bottom: -3.75rem !important;\n}\n\n.mb-n16 {\n  margin-bottom: -4rem !important;\n}\n\n.mb-n17 {\n  margin-bottom: -4.25rem !important;\n}\n\n.mb-n18 {\n  margin-bottom: -4.5rem !important;\n}\n\n.mb-n19 {\n  margin-bottom: -4.75rem !important;\n}\n\n.mb-n20 {\n  margin-bottom: -5rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.ms-n3 {\n  margin-left: -0.75rem !important;\n}\n\n.ms-n4 {\n  margin-left: -1rem !important;\n}\n\n.ms-n5 {\n  margin-left: -1.25rem !important;\n}\n\n.ms-n6 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n7 {\n  margin-left: -1.75rem !important;\n}\n\n.ms-n8 {\n  margin-left: -2rem !important;\n}\n\n.ms-n9 {\n  margin-left: -2.25rem !important;\n}\n\n.ms-n10 {\n  margin-left: -2.5rem !important;\n}\n\n.ms-n11 {\n  margin-left: -2.75rem !important;\n}\n\n.ms-n12 {\n  margin-left: -3rem !important;\n}\n\n.ms-n13 {\n  margin-left: -3.25rem !important;\n}\n\n.ms-n14 {\n  margin-left: -3.5rem !important;\n}\n\n.ms-n15 {\n  margin-left: -3.75rem !important;\n}\n\n.ms-n16 {\n  margin-left: -4rem !important;\n}\n\n.ms-n17 {\n  margin-left: -4.25rem !important;\n}\n\n.ms-n18 {\n  margin-left: -4.5rem !important;\n}\n\n.ms-n19 {\n  margin-left: -4.75rem !important;\n}\n\n.ms-n20 {\n  margin-left: -5rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 0.75rem !important;\n}\n\n.p-4 {\n  padding: 1rem !important;\n}\n\n.p-5 {\n  padding: 1.25rem !important;\n}\n\n.p-6 {\n  padding: 1.5rem !important;\n}\n\n.p-7 {\n  padding: 1.75rem !important;\n}\n\n.p-8 {\n  padding: 2rem !important;\n}\n\n.p-9 {\n  padding: 2.25rem !important;\n}\n\n.p-10 {\n  padding: 2.5rem !important;\n}\n\n.p-11 {\n  padding: 2.75rem !important;\n}\n\n.p-12 {\n  padding: 3rem !important;\n}\n\n.p-13 {\n  padding: 3.25rem !important;\n}\n\n.p-14 {\n  padding: 3.5rem !important;\n}\n\n.p-15 {\n  padding: 3.75rem !important;\n}\n\n.p-16 {\n  padding: 4rem !important;\n}\n\n.p-17 {\n  padding: 4.25rem !important;\n}\n\n.p-18 {\n  padding: 4.5rem !important;\n}\n\n.p-19 {\n  padding: 4.75rem !important;\n}\n\n.p-20 {\n  padding: 5rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 0.75rem !important;\n  padding-left: 0.75rem !important;\n}\n\n.px-4 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-5 {\n  padding-right: 1.25rem !important;\n  padding-left: 1.25rem !important;\n}\n\n.px-6 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-7 {\n  padding-right: 1.75rem !important;\n  padding-left: 1.75rem !important;\n}\n\n.px-8 {\n  padding-right: 2rem !important;\n  padding-left: 2rem !important;\n}\n\n.px-9 {\n  padding-right: 2.25rem !important;\n  padding-left: 2.25rem !important;\n}\n\n.px-10 {\n  padding-right: 2.5rem !important;\n  padding-left: 2.5rem !important;\n}\n\n.px-11 {\n  padding-right: 2.75rem !important;\n  padding-left: 2.75rem !important;\n}\n\n.px-12 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.px-13 {\n  padding-right: 3.25rem !important;\n  padding-left: 3.25rem !important;\n}\n\n.px-14 {\n  padding-right: 3.5rem !important;\n  padding-left: 3.5rem !important;\n}\n\n.px-15 {\n  padding-right: 3.75rem !important;\n  padding-left: 3.75rem !important;\n}\n\n.px-16 {\n  padding-right: 4rem !important;\n  padding-left: 4rem !important;\n}\n\n.px-17 {\n  padding-right: 4.25rem !important;\n  padding-left: 4.25rem !important;\n}\n\n.px-18 {\n  padding-right: 4.5rem !important;\n  padding-left: 4.5rem !important;\n}\n\n.px-19 {\n  padding-right: 4.75rem !important;\n  padding-left: 4.75rem !important;\n}\n\n.px-20 {\n  padding-right: 5rem !important;\n  padding-left: 5rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-5 {\n  padding-top: 1.25rem !important;\n  padding-bottom: 1.25rem !important;\n}\n\n.py-6 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-7 {\n  padding-top: 1.75rem !important;\n  padding-bottom: 1.75rem !important;\n}\n\n.py-8 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.py-9 {\n  padding-top: 2.25rem !important;\n  padding-bottom: 2.25rem !important;\n}\n\n.py-10 {\n  padding-top: 2.5rem !important;\n  padding-bottom: 2.5rem !important;\n}\n\n.py-11 {\n  padding-top: 2.75rem !important;\n  padding-bottom: 2.75rem !important;\n}\n\n.py-12 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.py-13 {\n  padding-top: 3.25rem !important;\n  padding-bottom: 3.25rem !important;\n}\n\n.py-14 {\n  padding-top: 3.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n.py-15 {\n  padding-top: 3.75rem !important;\n  padding-bottom: 3.75rem !important;\n}\n\n.py-16 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n\n.py-17 {\n  padding-top: 4.25rem !important;\n  padding-bottom: 4.25rem !important;\n}\n\n.py-18 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.py-19 {\n  padding-top: 4.75rem !important;\n  padding-bottom: 4.75rem !important;\n}\n\n.py-20 {\n  padding-top: 5rem !important;\n  padding-bottom: 5rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 0.75rem !important;\n}\n\n.pt-4 {\n  padding-top: 1rem !important;\n}\n\n.pt-5 {\n  padding-top: 1.25rem !important;\n}\n\n.pt-6 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-7 {\n  padding-top: 1.75rem !important;\n}\n\n.pt-8 {\n  padding-top: 2rem !important;\n}\n\n.pt-9 {\n  padding-top: 2.25rem !important;\n}\n\n.pt-10 {\n  padding-top: 2.5rem !important;\n}\n\n.pt-11 {\n  padding-top: 2.75rem !important;\n}\n\n.pt-12 {\n  padding-top: 3rem !important;\n}\n\n.pt-13 {\n  padding-top: 3.25rem !important;\n}\n\n.pt-14 {\n  padding-top: 3.5rem !important;\n}\n\n.pt-15 {\n  padding-top: 3.75rem !important;\n}\n\n.pt-16 {\n  padding-top: 4rem !important;\n}\n\n.pt-17 {\n  padding-top: 4.25rem !important;\n}\n\n.pt-18 {\n  padding-top: 4.5rem !important;\n}\n\n.pt-19 {\n  padding-top: 4.75rem !important;\n}\n\n.pt-20 {\n  padding-top: 5rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 0.75rem !important;\n}\n\n.pe-4 {\n  padding-right: 1rem !important;\n}\n\n.pe-5 {\n  padding-right: 1.25rem !important;\n}\n\n.pe-6 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-7 {\n  padding-right: 1.75rem !important;\n}\n\n.pe-8 {\n  padding-right: 2rem !important;\n}\n\n.pe-9 {\n  padding-right: 2.25rem !important;\n}\n\n.pe-10 {\n  padding-right: 2.5rem !important;\n}\n\n.pe-11 {\n  padding-right: 2.75rem !important;\n}\n\n.pe-12 {\n  padding-right: 3rem !important;\n}\n\n.pe-13 {\n  padding-right: 3.25rem !important;\n}\n\n.pe-14 {\n  padding-right: 3.5rem !important;\n}\n\n.pe-15 {\n  padding-right: 3.75rem !important;\n}\n\n.pe-16 {\n  padding-right: 4rem !important;\n}\n\n.pe-17 {\n  padding-right: 4.25rem !important;\n}\n\n.pe-18 {\n  padding-right: 4.5rem !important;\n}\n\n.pe-19 {\n  padding-right: 4.75rem !important;\n}\n\n.pe-20 {\n  padding-right: 5rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 0.75rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 1.25rem !important;\n}\n\n.pb-6 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-7 {\n  padding-bottom: 1.75rem !important;\n}\n\n.pb-8 {\n  padding-bottom: 2rem !important;\n}\n\n.pb-9 {\n  padding-bottom: 2.25rem !important;\n}\n\n.pb-10 {\n  padding-bottom: 2.5rem !important;\n}\n\n.pb-11 {\n  padding-bottom: 2.75rem !important;\n}\n\n.pb-12 {\n  padding-bottom: 3rem !important;\n}\n\n.pb-13 {\n  padding-bottom: 3.25rem !important;\n}\n\n.pb-14 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pb-15 {\n  padding-bottom: 3.75rem !important;\n}\n\n.pb-16 {\n  padding-bottom: 4rem !important;\n}\n\n.pb-17 {\n  padding-bottom: 4.25rem !important;\n}\n\n.pb-18 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pb-19 {\n  padding-bottom: 4.75rem !important;\n}\n\n.pb-20 {\n  padding-bottom: 5rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 0.75rem !important;\n}\n\n.ps-4 {\n  padding-left: 1rem !important;\n}\n\n.ps-5 {\n  padding-left: 1.25rem !important;\n}\n\n.ps-6 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-7 {\n  padding-left: 1.75rem !important;\n}\n\n.ps-8 {\n  padding-left: 2rem !important;\n}\n\n.ps-9 {\n  padding-left: 2.25rem !important;\n}\n\n.ps-10 {\n  padding-left: 2.5rem !important;\n}\n\n.ps-11 {\n  padding-left: 2.75rem !important;\n}\n\n.ps-12 {\n  padding-left: 3rem !important;\n}\n\n.ps-13 {\n  padding-left: 3.25rem !important;\n}\n\n.ps-14 {\n  padding-left: 3.5rem !important;\n}\n\n.ps-15 {\n  padding-left: 3.75rem !important;\n}\n\n.ps-16 {\n  padding-left: 4rem !important;\n}\n\n.ps-17 {\n  padding-left: 4.25rem !important;\n}\n\n.ps-18 {\n  padding-left: 4.5rem !important;\n}\n\n.ps-19 {\n  padding-left: 4.75rem !important;\n}\n\n.ps-20 {\n  padding-left: 5rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 0.75rem !important;\n}\n\n.gap-4 {\n  gap: 1rem !important;\n}\n\n.gap-5 {\n  gap: 1.25rem !important;\n}\n\n.gap-6 {\n  gap: 1.5rem !important;\n}\n\n.gap-7 {\n  gap: 1.75rem !important;\n}\n\n.gap-8 {\n  gap: 2rem !important;\n}\n\n.gap-9 {\n  gap: 2.25rem !important;\n}\n\n.gap-10 {\n  gap: 2.5rem !important;\n}\n\n.gap-11 {\n  gap: 2.75rem !important;\n}\n\n.gap-12 {\n  gap: 3rem !important;\n}\n\n.gap-13 {\n  gap: 3.25rem !important;\n}\n\n.gap-14 {\n  gap: 3.5rem !important;\n}\n\n.gap-15 {\n  gap: 3.75rem !important;\n}\n\n.gap-16 {\n  gap: 4rem !important;\n}\n\n.gap-17 {\n  gap: 4.25rem !important;\n}\n\n.gap-18 {\n  gap: 4.5rem !important;\n}\n\n.gap-19 {\n  gap: 4.75rem !important;\n}\n\n.gap-20 {\n  gap: 5rem !important;\n}\n\n.row-gap-0 {\n  row-gap: 0 !important;\n}\n\n.row-gap-1 {\n  row-gap: 0.25rem !important;\n}\n\n.row-gap-2 {\n  row-gap: 0.5rem !important;\n}\n\n.row-gap-3 {\n  row-gap: 0.75rem !important;\n}\n\n.row-gap-4 {\n  row-gap: 1rem !important;\n}\n\n.row-gap-5 {\n  row-gap: 1.25rem !important;\n}\n\n.row-gap-6 {\n  row-gap: 1.5rem !important;\n}\n\n.row-gap-7 {\n  row-gap: 1.75rem !important;\n}\n\n.row-gap-8 {\n  row-gap: 2rem !important;\n}\n\n.row-gap-9 {\n  row-gap: 2.25rem !important;\n}\n\n.row-gap-10 {\n  row-gap: 2.5rem !important;\n}\n\n.row-gap-11 {\n  row-gap: 2.75rem !important;\n}\n\n.row-gap-12 {\n  row-gap: 3rem !important;\n}\n\n.row-gap-13 {\n  row-gap: 3.25rem !important;\n}\n\n.row-gap-14 {\n  row-gap: 3.5rem !important;\n}\n\n.row-gap-15 {\n  row-gap: 3.75rem !important;\n}\n\n.row-gap-16 {\n  row-gap: 4rem !important;\n}\n\n.row-gap-17 {\n  row-gap: 4.25rem !important;\n}\n\n.row-gap-18 {\n  row-gap: 4.5rem !important;\n}\n\n.row-gap-19 {\n  row-gap: 4.75rem !important;\n}\n\n.row-gap-20 {\n  row-gap: 5rem !important;\n}\n\n.column-gap-0 {\n  column-gap: 0 !important;\n}\n\n.column-gap-1 {\n  column-gap: 0.25rem !important;\n}\n\n.column-gap-2 {\n  column-gap: 0.5rem !important;\n}\n\n.column-gap-3 {\n  column-gap: 0.75rem !important;\n}\n\n.column-gap-4 {\n  column-gap: 1rem !important;\n}\n\n.column-gap-5 {\n  column-gap: 1.25rem !important;\n}\n\n.column-gap-6 {\n  column-gap: 1.5rem !important;\n}\n\n.column-gap-7 {\n  column-gap: 1.75rem !important;\n}\n\n.column-gap-8 {\n  column-gap: 2rem !important;\n}\n\n.column-gap-9 {\n  column-gap: 2.25rem !important;\n}\n\n.column-gap-10 {\n  column-gap: 2.5rem !important;\n}\n\n.column-gap-11 {\n  column-gap: 2.75rem !important;\n}\n\n.column-gap-12 {\n  column-gap: 3rem !important;\n}\n\n.column-gap-13 {\n  column-gap: 3.25rem !important;\n}\n\n.column-gap-14 {\n  column-gap: 3.5rem !important;\n}\n\n.column-gap-15 {\n  column-gap: 3.75rem !important;\n}\n\n.column-gap-16 {\n  column-gap: 4rem !important;\n}\n\n.column-gap-17 {\n  column-gap: 4.25rem !important;\n}\n\n.column-gap-18 {\n  column-gap: 4.5rem !important;\n}\n\n.column-gap-19 {\n  column-gap: 4.75rem !important;\n}\n\n.column-gap-20 {\n  column-gap: 5rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.26rem + 0.12vw) !important;\n}\n\n.fs-4 {\n  font-size: 1.25rem !important;\n}\n\n.fs-5 {\n  font-size: 1.15rem !important;\n}\n\n.fs-6 {\n  font-size: 1.075rem !important;\n}\n\n.fs-7 {\n  font-size: 0.95rem !important;\n}\n\n.fs-8 {\n  font-size: 0.85rem !important;\n}\n\n.fs-9 {\n  font-size: 0.75rem !important;\n}\n\n.fs-10 {\n  font-size: 0.5rem !important;\n}\n\n.fs-sm {\n  font-size: 0.95rem !important;\n}\n\n.fs-base {\n  font-size: 1rem !important;\n}\n\n.fs-lg {\n  font-size: 1.075rem !important;\n}\n\n.fs-xl {\n  font-size: 1.21rem !important;\n}\n\n.fs-fluid {\n  font-size: 100% !important;\n}\n\n.fs-2x {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-2qx {\n  font-size: calc(1.35rem + 1.2vw) !important;\n}\n\n.fs-2hx {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2tx {\n  font-size: calc(1.4rem + 1.8vw) !important;\n}\n\n.fs-3x {\n  font-size: calc(1.425rem + 2.1vw) !important;\n}\n\n.fs-3qx {\n  font-size: calc(1.45rem + 2.4vw) !important;\n}\n\n.fs-3hx {\n  font-size: calc(1.475rem + 2.7vw) !important;\n}\n\n.fs-3tx {\n  font-size: calc(1.5rem + 3vw) !important;\n}\n\n.fs-4x {\n  font-size: calc(1.525rem + 3.3vw) !important;\n}\n\n.fs-4qx {\n  font-size: calc(1.55rem + 3.6vw) !important;\n}\n\n.fs-4hx {\n  font-size: calc(1.575rem + 3.9vw) !important;\n}\n\n.fs-4tx {\n  font-size: calc(1.6rem + 4.2vw) !important;\n}\n\n.fs-5x {\n  font-size: calc(1.625rem + 4.5vw) !important;\n}\n\n.fs-5qx {\n  font-size: calc(1.65rem + 4.8vw) !important;\n}\n\n.fs-5hx {\n  font-size: calc(1.675rem + 5.1vw) !important;\n}\n\n.fs-5tx {\n  font-size: calc(1.7rem + 5.4vw) !important;\n}\n\n.fs-6x {\n  font-size: calc(1.725rem + 5.7vw) !important;\n}\n\n.fs-6qx {\n  font-size: calc(1.75rem + 6vw) !important;\n}\n\n.fs-6hx {\n  font-size: calc(1.775rem + 6.3vw) !important;\n}\n\n.fs-6tx {\n  font-size: calc(1.8rem + 6.6vw) !important;\n}\n\n.fs-7x {\n  font-size: calc(1.825rem + 6.9vw) !important;\n}\n\n.fs-7qx {\n  font-size: calc(1.85rem + 7.2vw) !important;\n}\n\n.fs-7hx {\n  font-size: calc(1.875rem + 7.5vw) !important;\n}\n\n.fs-7tx {\n  font-size: calc(1.9rem + 7.8vw) !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-medium {\n  font-weight: 500 !important;\n}\n\n.fw-semibold {\n  font-weight: 500 !important;\n}\n\n.fw-bold {\n  font-weight: 600 !important;\n}\n\n.fw-bolder {\n  font-weight: 700 !important;\n}\n\n.lh-0 {\n  line-height: 0 !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 1.75 !important;\n}\n\n.lh-xl {\n  line-height: 2 !important;\n}\n\n.lh-xxl {\n  line-height: 2.25 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-body-secondary {\n  --bs-text-opacity: 1;\n  color: var(--bs-secondary-color) !important;\n}\n\n.text-body-tertiary {\n  --bs-text-opacity: 1;\n  color: var(--bs-tertiary-color) !important;\n}\n\n.text-body-emphasis {\n  --bs-text-opacity: 1;\n  color: var(--bs-emphasis-color) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.text-primary-emphasis {\n  color: var(--bs-primary-text-emphasis) !important;\n}\n\n.text-secondary-emphasis {\n  color: var(--bs-secondary-text-emphasis) !important;\n}\n\n.text-success-emphasis {\n  color: var(--bs-success-text-emphasis) !important;\n}\n\n.text-info-emphasis {\n  color: var(--bs-info-text-emphasis) !important;\n}\n\n.text-warning-emphasis {\n  color: var(--bs-warning-text-emphasis) !important;\n}\n\n.text-danger-emphasis {\n  color: var(--bs-danger-text-emphasis) !important;\n}\n\n.text-light-emphasis {\n  color: var(--bs-light-text-emphasis) !important;\n}\n\n.text-dark-emphasis {\n  color: var(--bs-dark-text-emphasis) !important;\n}\n\n.link-opacity-10 {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-10-hover:hover {\n  --bs-link-opacity: 0.1;\n}\n\n.link-opacity-25 {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-25-hover:hover {\n  --bs-link-opacity: 0.25;\n}\n\n.link-opacity-50 {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-50-hover:hover {\n  --bs-link-opacity: 0.5;\n}\n\n.link-opacity-75 {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-75-hover:hover {\n  --bs-link-opacity: 0.75;\n}\n\n.link-opacity-100 {\n  --bs-link-opacity: 1;\n}\n\n.link-opacity-100-hover:hover {\n  --bs-link-opacity: 1;\n}\n\n.link-offset-1 {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-1-hover:hover {\n  text-underline-offset: 0.125em !important;\n}\n\n.link-offset-2 {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-2-hover:hover {\n  text-underline-offset: 0.25em !important;\n}\n\n.link-offset-3 {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-offset-3-hover:hover {\n  text-underline-offset: 0.375em !important;\n}\n\n.link-underline-light {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-primary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-secondary {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-success {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-info {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-warning {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-danger {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline-dark {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;\n}\n\n.link-underline {\n  --bs-link-underline-opacity: 1;\n  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;\n}\n\n.link-underline-opacity-0 {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-0-hover:hover {\n  --bs-link-underline-opacity: 0;\n}\n\n.link-underline-opacity-10 {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-10-hover:hover {\n  --bs-link-underline-opacity: 0.1;\n}\n\n.link-underline-opacity-25 {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-25-hover:hover {\n  --bs-link-underline-opacity: 0.25;\n}\n\n.link-underline-opacity-50 {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-50-hover:hover {\n  --bs-link-underline-opacity: 0.5;\n}\n\n.link-underline-opacity-75 {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-75-hover:hover {\n  --bs-link-underline-opacity: 0.75;\n}\n\n.link-underline-opacity-100 {\n  --bs-link-underline-opacity: 1;\n}\n\n.link-underline-opacity-100-hover:hover {\n  --bs-link-underline-opacity: 1;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-body-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body-tertiary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-primary-subtle {\n  background-color: var(--bs-primary-bg-subtle) !important;\n}\n\n.bg-secondary-subtle {\n  background-color: var(--bs-secondary-bg-subtle) !important;\n}\n\n.bg-success-subtle {\n  background-color: var(--bs-success-bg-subtle) !important;\n}\n\n.bg-info-subtle {\n  background-color: var(--bs-info-bg-subtle) !important;\n}\n\n.bg-warning-subtle {\n  background-color: var(--bs-warning-bg-subtle) !important;\n}\n\n.bg-danger-subtle {\n  background-color: var(--bs-danger-bg-subtle) !important;\n}\n\n.bg-light-subtle {\n  background-color: var(--bs-light-bg-subtle) !important;\n}\n\n.bg-dark-subtle {\n  background-color: var(--bs-dark-bg-subtle) !important;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: 0.65rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: 0.3rem !important;\n}\n\n.rounded-2 {\n  border-radius: 0.65rem !important;\n}\n\n.rounded-3 {\n  border-radius: 0.85rem !important;\n}\n\n.rounded-4 {\n  border-radius: 1.25rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-top-1 {\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-top-2 {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-top-3 {\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-top-4 {\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-top-5 {\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-top-circle {\n  border-top-left-radius: 50% !important;\n  border-top-right-radius: 50% !important;\n}\n\n.rounded-top-pill {\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-end-1 {\n  border-top-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-end-2 {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end-3 {\n  border-top-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-end-4 {\n  border-top-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-end-5 {\n  border-top-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-end-circle {\n  border-top-right-radius: 50% !important;\n  border-bottom-right-radius: 50% !important;\n}\n\n.rounded-end-pill {\n  border-top-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-bottom-1 {\n  border-bottom-right-radius: var(--bs-border-radius-sm) !important;\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-bottom-2 {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom-3 {\n  border-bottom-right-radius: var(--bs-border-radius-lg) !important;\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-bottom-4 {\n  border-bottom-right-radius: var(--bs-border-radius-xl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-bottom-5 {\n  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-bottom-circle {\n  border-bottom-right-radius: 50% !important;\n  border-bottom-left-radius: 50% !important;\n}\n\n.rounded-bottom-pill {\n  border-bottom-right-radius: var(--bs-border-radius-pill) !important;\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-0 {\n  border-bottom-left-radius: 0 !important;\n  border-top-left-radius: 0 !important;\n}\n\n.rounded-start-1 {\n  border-bottom-left-radius: var(--bs-border-radius-sm) !important;\n  border-top-left-radius: var(--bs-border-radius-sm) !important;\n}\n\n.rounded-start-2 {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start-3 {\n  border-bottom-left-radius: var(--bs-border-radius-lg) !important;\n  border-top-left-radius: var(--bs-border-radius-lg) !important;\n}\n\n.rounded-start-4 {\n  border-bottom-left-radius: var(--bs-border-radius-xl) !important;\n  border-top-left-radius: var(--bs-border-radius-xl) !important;\n}\n\n.rounded-start-5 {\n  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;\n  border-top-left-radius: var(--bs-border-radius-xxl) !important;\n}\n\n.rounded-start-circle {\n  border-bottom-left-radius: 50% !important;\n  border-top-left-radius: 50% !important;\n}\n\n.rounded-start-pill {\n  border-bottom-left-radius: var(--bs-border-radius-pill) !important;\n  border-top-left-radius: var(--bs-border-radius-pill) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.z-index-n1 {\n  z-index: -1 !important;\n}\n\n.z-index-n2 {\n  z-index: -2 !important;\n}\n\n.z-index-0 {\n  z-index: 0 !important;\n}\n\n.z-index-1 {\n  z-index: 1 !important;\n}\n\n.z-index-2 {\n  z-index: 2 !important;\n}\n\n.z-index-3 {\n  z-index: 3 !important;\n}\n\n.cursor-help {\n  cursor: help !important;\n}\n\n.cursor-wait {\n  cursor: wait !important;\n}\n\n.cursor-crosshair {\n  cursor: crosshair !important;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n.cursor-zoom-in {\n  cursor: zoom-in !important;\n}\n\n.cursor-grab {\n  cursor: grab !important;\n}\n\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-0-hover:hover {\n  opacity: 0 !important;\n}\n\n.opacity-5 {\n  opacity: 0.05 !important;\n}\n\n.opacity-5-hover:hover {\n  opacity: 0.05 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-10-hover:hover {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-15-hover:hover {\n  opacity: 0.15 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-20-hover:hover {\n  opacity: 0.2 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-25-hover:hover {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-50-hover:hover {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-75-hover:hover {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.opacity-100-hover:hover {\n  opacity: 1 !important;\n}\n\n.min-w-unset {\n  min-width: unset !important;\n}\n\n.min-w-25 {\n  min-width: 25% !important;\n}\n\n.min-w-50 {\n  min-width: 50% !important;\n}\n\n.min-w-75 {\n  min-width: 75% !important;\n}\n\n.min-w-100 {\n  min-width: 100% !important;\n}\n\n.min-w-auto {\n  min-width: auto !important;\n}\n\n.min-w-1px {\n  min-width: 1px !important;\n}\n\n.min-w-2px {\n  min-width: 2px !important;\n}\n\n.min-w-3px {\n  min-width: 3px !important;\n}\n\n.min-w-4px {\n  min-width: 4px !important;\n}\n\n.min-w-5px {\n  min-width: 5px !important;\n}\n\n.min-w-6px {\n  min-width: 6px !important;\n}\n\n.min-w-7px {\n  min-width: 7px !important;\n}\n\n.min-w-8px {\n  min-width: 8px !important;\n}\n\n.min-w-9px {\n  min-width: 9px !important;\n}\n\n.min-w-10px {\n  min-width: 10px !important;\n}\n\n.min-w-15px {\n  min-width: 15px !important;\n}\n\n.min-w-20px {\n  min-width: 20px !important;\n}\n\n.min-w-25px {\n  min-width: 25px !important;\n}\n\n.min-w-30px {\n  min-width: 30px !important;\n}\n\n.min-w-35px {\n  min-width: 35px !important;\n}\n\n.min-w-40px {\n  min-width: 40px !important;\n}\n\n.min-w-45px {\n  min-width: 45px !important;\n}\n\n.min-w-50px {\n  min-width: 50px !important;\n}\n\n.min-w-55px {\n  min-width: 55px !important;\n}\n\n.min-w-60px {\n  min-width: 60px !important;\n}\n\n.min-w-65px {\n  min-width: 65px !important;\n}\n\n.min-w-70px {\n  min-width: 70px !important;\n}\n\n.min-w-75px {\n  min-width: 75px !important;\n}\n\n.min-w-80px {\n  min-width: 80px !important;\n}\n\n.min-w-85px {\n  min-width: 85px !important;\n}\n\n.min-w-90px {\n  min-width: 90px !important;\n}\n\n.min-w-95px {\n  min-width: 95px !important;\n}\n\n.min-w-100px {\n  min-width: 100px !important;\n}\n\n.min-w-125px {\n  min-width: 125px !important;\n}\n\n.min-w-150px {\n  min-width: 150px !important;\n}\n\n.min-w-175px {\n  min-width: 175px !important;\n}\n\n.min-w-200px {\n  min-width: 200px !important;\n}\n\n.min-w-225px {\n  min-width: 225px !important;\n}\n\n.min-w-250px {\n  min-width: 250px !important;\n}\n\n.min-w-275px {\n  min-width: 275px !important;\n}\n\n.min-w-300px {\n  min-width: 300px !important;\n}\n\n.min-w-325px {\n  min-width: 325px !important;\n}\n\n.min-w-350px {\n  min-width: 350px !important;\n}\n\n.min-w-375px {\n  min-width: 375px !important;\n}\n\n.min-w-400px {\n  min-width: 400px !important;\n}\n\n.min-w-425px {\n  min-width: 425px !important;\n}\n\n.min-w-450px {\n  min-width: 450px !important;\n}\n\n.min-w-475px {\n  min-width: 475px !important;\n}\n\n.min-w-500px {\n  min-width: 500px !important;\n}\n\n.min-w-550px {\n  min-width: 550px !important;\n}\n\n.min-w-600px {\n  min-width: 600px !important;\n}\n\n.min-w-650px {\n  min-width: 650px !important;\n}\n\n.min-w-700px {\n  min-width: 700px !important;\n}\n\n.min-w-750px {\n  min-width: 750px !important;\n}\n\n.min-w-800px {\n  min-width: 800px !important;\n}\n\n.min-w-850px {\n  min-width: 850px !important;\n}\n\n.min-w-900px {\n  min-width: 900px !important;\n}\n\n.min-w-950px {\n  min-width: 950px !important;\n}\n\n.min-w-1000px {\n  min-width: 1000px !important;\n}\n\n.min-h-unset {\n  min-height: unset !important;\n}\n\n.min-h-25 {\n  min-height: 25% !important;\n}\n\n.min-h-50 {\n  min-height: 50% !important;\n}\n\n.min-h-75 {\n  min-height: 75% !important;\n}\n\n.min-h-100 {\n  min-height: 100% !important;\n}\n\n.min-h-auto {\n  min-height: auto !important;\n}\n\n.min-h-1px {\n  min-height: 1px !important;\n}\n\n.min-h-2px {\n  min-height: 2px !important;\n}\n\n.min-h-3px {\n  min-height: 3px !important;\n}\n\n.min-h-4px {\n  min-height: 4px !important;\n}\n\n.min-h-5px {\n  min-height: 5px !important;\n}\n\n.min-h-6px {\n  min-height: 6px !important;\n}\n\n.min-h-7px {\n  min-height: 7px !important;\n}\n\n.min-h-8px {\n  min-height: 8px !important;\n}\n\n.min-h-9px {\n  min-height: 9px !important;\n}\n\n.min-h-10px {\n  min-height: 10px !important;\n}\n\n.min-h-15px {\n  min-height: 15px !important;\n}\n\n.min-h-20px {\n  min-height: 20px !important;\n}\n\n.min-h-25px {\n  min-height: 25px !important;\n}\n\n.min-h-30px {\n  min-height: 30px !important;\n}\n\n.min-h-35px {\n  min-height: 35px !important;\n}\n\n.min-h-40px {\n  min-height: 40px !important;\n}\n\n.min-h-45px {\n  min-height: 45px !important;\n}\n\n.min-h-50px {\n  min-height: 50px !important;\n}\n\n.min-h-55px {\n  min-height: 55px !important;\n}\n\n.min-h-60px {\n  min-height: 60px !important;\n}\n\n.min-h-65px {\n  min-height: 65px !important;\n}\n\n.min-h-70px {\n  min-height: 70px !important;\n}\n\n.min-h-75px {\n  min-height: 75px !important;\n}\n\n.min-h-80px {\n  min-height: 80px !important;\n}\n\n.min-h-85px {\n  min-height: 85px !important;\n}\n\n.min-h-90px {\n  min-height: 90px !important;\n}\n\n.min-h-95px {\n  min-height: 95px !important;\n}\n\n.min-h-100px {\n  min-height: 100px !important;\n}\n\n.min-h-125px {\n  min-height: 125px !important;\n}\n\n.min-h-150px {\n  min-height: 150px !important;\n}\n\n.min-h-175px {\n  min-height: 175px !important;\n}\n\n.min-h-200px {\n  min-height: 200px !important;\n}\n\n.min-h-225px {\n  min-height: 225px !important;\n}\n\n.min-h-250px {\n  min-height: 250px !important;\n}\n\n.min-h-275px {\n  min-height: 275px !important;\n}\n\n.min-h-300px {\n  min-height: 300px !important;\n}\n\n.min-h-325px {\n  min-height: 325px !important;\n}\n\n.min-h-350px {\n  min-height: 350px !important;\n}\n\n.min-h-375px {\n  min-height: 375px !important;\n}\n\n.min-h-400px {\n  min-height: 400px !important;\n}\n\n.min-h-425px {\n  min-height: 425px !important;\n}\n\n.min-h-450px {\n  min-height: 450px !important;\n}\n\n.min-h-475px {\n  min-height: 475px !important;\n}\n\n.min-h-500px {\n  min-height: 500px !important;\n}\n\n.min-h-550px {\n  min-height: 550px !important;\n}\n\n.min-h-600px {\n  min-height: 600px !important;\n}\n\n.min-h-650px {\n  min-height: 650px !important;\n}\n\n.min-h-700px {\n  min-height: 700px !important;\n}\n\n.min-h-750px {\n  min-height: 750px !important;\n}\n\n.min-h-800px {\n  min-height: 800px !important;\n}\n\n.min-h-850px {\n  min-height: 850px !important;\n}\n\n.min-h-900px {\n  min-height: 900px !important;\n}\n\n.min-h-950px {\n  min-height: 950px !important;\n}\n\n.min-h-1000px {\n  min-height: 1000px !important;\n}\n\n.border-top-0 {\n  border-top-width: 0 !important;\n}\n\n.border-top-1 {\n  border-top-width: 1px !important;\n}\n\n.border-top-2 {\n  border-top-width: 2px !important;\n}\n\n.border-top-3 {\n  border-top-width: 3px !important;\n}\n\n.border-top-4 {\n  border-top-width: 4px !important;\n}\n\n.border-top-5 {\n  border-top-width: 5px !important;\n}\n\n.border-bottom-0 {\n  border-bottom-width: 0 !important;\n}\n\n.border-bottom-1 {\n  border-bottom-width: 1px !important;\n}\n\n.border-bottom-2 {\n  border-bottom-width: 2px !important;\n}\n\n.border-bottom-3 {\n  border-bottom-width: 3px !important;\n}\n\n.border-bottom-4 {\n  border-bottom-width: 4px !important;\n}\n\n.border-bottom-5 {\n  border-bottom-width: 5px !important;\n}\n\n.border-right-0 {\n  border-right-width: 0 !important;\n}\n\n.border-right-1 {\n  border-right-width: 1px !important;\n}\n\n.border-right-2 {\n  border-right-width: 2px !important;\n}\n\n.border-right-3 {\n  border-right-width: 3px !important;\n}\n\n.border-right-4 {\n  border-right-width: 4px !important;\n}\n\n.border-right-5 {\n  border-right-width: 5px !important;\n}\n\n.border-left-0 {\n  border-left-width: 0 !important;\n}\n\n.border-left-1 {\n  border-left-width: 1px !important;\n}\n\n.border-left-2 {\n  border-left-width: 2px !important;\n}\n\n.border-left-3 {\n  border-left-width: 3px !important;\n}\n\n.border-left-4 {\n  border-left-width: 4px !important;\n}\n\n.border-left-5 {\n  border-left-width: 5px !important;\n}\n\n.ls-1 {\n  letter-spacing: 0.1rem !important;\n}\n\n.ls-2 {\n  letter-spacing: 0.115rem !important;\n}\n\n.ls-3 {\n  letter-spacing: 0.125rem !important;\n}\n\n.ls-4 {\n  letter-spacing: 0.25rem !important;\n}\n\n.ls-5 {\n  letter-spacing: 0.5rem !important;\n}\n\n.ls-n1 {\n  letter-spacing: -0.1rem !important;\n}\n\n.ls-n2 {\n  letter-spacing: -0.115rem !important;\n}\n\n.ls-n3 {\n  letter-spacing: -0.125rem !important;\n}\n\n.ls-n4 {\n  letter-spacing: -0.25rem !important;\n}\n\n.ls-n5 {\n  letter-spacing: -0.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n  .float-sm-end {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n  .object-fit-sm-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-sm-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-sm-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-sm-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-sm-none {\n    object-fit: none !important;\n  }\n  .overflow-sm-auto {\n    overflow: auto !important;\n  }\n  .overflow-sm-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-sm-visible {\n    overflow: visible !important;\n  }\n  .overflow-sm-scroll {\n    overflow: scroll !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-grid {\n    display: grid !important;\n  }\n  .d-sm-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-sm-none {\n    display: none !important;\n  }\n  .position-sm-static {\n    position: static !important;\n  }\n  .position-sm-relative {\n    position: relative !important;\n  }\n  .position-sm-absolute {\n    position: absolute !important;\n  }\n  .position-sm-fixed {\n    position: fixed !important;\n  }\n  .position-sm-sticky {\n    position: sticky !important;\n  }\n  .w-sm-unset {\n    width: unset !important;\n  }\n  .w-sm-25 {\n    width: 25% !important;\n  }\n  .w-sm-50 {\n    width: 50% !important;\n  }\n  .w-sm-75 {\n    width: 75% !important;\n  }\n  .w-sm-100 {\n    width: 100% !important;\n  }\n  .w-sm-auto {\n    width: auto !important;\n  }\n  .w-sm-1px {\n    width: 1px !important;\n  }\n  .w-sm-2px {\n    width: 2px !important;\n  }\n  .w-sm-3px {\n    width: 3px !important;\n  }\n  .w-sm-4px {\n    width: 4px !important;\n  }\n  .w-sm-5px {\n    width: 5px !important;\n  }\n  .w-sm-6px {\n    width: 6px !important;\n  }\n  .w-sm-7px {\n    width: 7px !important;\n  }\n  .w-sm-8px {\n    width: 8px !important;\n  }\n  .w-sm-9px {\n    width: 9px !important;\n  }\n  .w-sm-10px {\n    width: 10px !important;\n  }\n  .w-sm-15px {\n    width: 15px !important;\n  }\n  .w-sm-20px {\n    width: 20px !important;\n  }\n  .w-sm-25px {\n    width: 25px !important;\n  }\n  .w-sm-30px {\n    width: 30px !important;\n  }\n  .w-sm-35px {\n    width: 35px !important;\n  }\n  .w-sm-40px {\n    width: 40px !important;\n  }\n  .w-sm-45px {\n    width: 45px !important;\n  }\n  .w-sm-50px {\n    width: 50px !important;\n  }\n  .w-sm-55px {\n    width: 55px !important;\n  }\n  .w-sm-60px {\n    width: 60px !important;\n  }\n  .w-sm-65px {\n    width: 65px !important;\n  }\n  .w-sm-70px {\n    width: 70px !important;\n  }\n  .w-sm-75px {\n    width: 75px !important;\n  }\n  .w-sm-80px {\n    width: 80px !important;\n  }\n  .w-sm-85px {\n    width: 85px !important;\n  }\n  .w-sm-90px {\n    width: 90px !important;\n  }\n  .w-sm-95px {\n    width: 95px !important;\n  }\n  .w-sm-100px {\n    width: 100px !important;\n  }\n  .w-sm-125px {\n    width: 125px !important;\n  }\n  .w-sm-150px {\n    width: 150px !important;\n  }\n  .w-sm-175px {\n    width: 175px !important;\n  }\n  .w-sm-200px {\n    width: 200px !important;\n  }\n  .w-sm-225px {\n    width: 225px !important;\n  }\n  .w-sm-250px {\n    width: 250px !important;\n  }\n  .w-sm-275px {\n    width: 275px !important;\n  }\n  .w-sm-300px {\n    width: 300px !important;\n  }\n  .w-sm-325px {\n    width: 325px !important;\n  }\n  .w-sm-350px {\n    width: 350px !important;\n  }\n  .w-sm-375px {\n    width: 375px !important;\n  }\n  .w-sm-400px {\n    width: 400px !important;\n  }\n  .w-sm-425px {\n    width: 425px !important;\n  }\n  .w-sm-450px {\n    width: 450px !important;\n  }\n  .w-sm-475px {\n    width: 475px !important;\n  }\n  .w-sm-500px {\n    width: 500px !important;\n  }\n  .w-sm-550px {\n    width: 550px !important;\n  }\n  .w-sm-600px {\n    width: 600px !important;\n  }\n  .w-sm-650px {\n    width: 650px !important;\n  }\n  .w-sm-700px {\n    width: 700px !important;\n  }\n  .w-sm-750px {\n    width: 750px !important;\n  }\n  .w-sm-800px {\n    width: 800px !important;\n  }\n  .w-sm-850px {\n    width: 850px !important;\n  }\n  .w-sm-900px {\n    width: 900px !important;\n  }\n  .w-sm-950px {\n    width: 950px !important;\n  }\n  .w-sm-1000px {\n    width: 1000px !important;\n  }\n  .mw-sm-unset {\n    max-width: unset !important;\n  }\n  .mw-sm-25 {\n    max-width: 25% !important;\n  }\n  .mw-sm-50 {\n    max-width: 50% !important;\n  }\n  .mw-sm-75 {\n    max-width: 75% !important;\n  }\n  .mw-sm-100 {\n    max-width: 100% !important;\n  }\n  .mw-sm-auto {\n    max-width: auto !important;\n  }\n  .mw-sm-1px {\n    max-width: 1px !important;\n  }\n  .mw-sm-2px {\n    max-width: 2px !important;\n  }\n  .mw-sm-3px {\n    max-width: 3px !important;\n  }\n  .mw-sm-4px {\n    max-width: 4px !important;\n  }\n  .mw-sm-5px {\n    max-width: 5px !important;\n  }\n  .mw-sm-6px {\n    max-width: 6px !important;\n  }\n  .mw-sm-7px {\n    max-width: 7px !important;\n  }\n  .mw-sm-8px {\n    max-width: 8px !important;\n  }\n  .mw-sm-9px {\n    max-width: 9px !important;\n  }\n  .mw-sm-10px {\n    max-width: 10px !important;\n  }\n  .mw-sm-15px {\n    max-width: 15px !important;\n  }\n  .mw-sm-20px {\n    max-width: 20px !important;\n  }\n  .mw-sm-25px {\n    max-width: 25px !important;\n  }\n  .mw-sm-30px {\n    max-width: 30px !important;\n  }\n  .mw-sm-35px {\n    max-width: 35px !important;\n  }\n  .mw-sm-40px {\n    max-width: 40px !important;\n  }\n  .mw-sm-45px {\n    max-width: 45px !important;\n  }\n  .mw-sm-50px {\n    max-width: 50px !important;\n  }\n  .mw-sm-55px {\n    max-width: 55px !important;\n  }\n  .mw-sm-60px {\n    max-width: 60px !important;\n  }\n  .mw-sm-65px {\n    max-width: 65px !important;\n  }\n  .mw-sm-70px {\n    max-width: 70px !important;\n  }\n  .mw-sm-75px {\n    max-width: 75px !important;\n  }\n  .mw-sm-80px {\n    max-width: 80px !important;\n  }\n  .mw-sm-85px {\n    max-width: 85px !important;\n  }\n  .mw-sm-90px {\n    max-width: 90px !important;\n  }\n  .mw-sm-95px {\n    max-width: 95px !important;\n  }\n  .mw-sm-100px {\n    max-width: 100px !important;\n  }\n  .mw-sm-125px {\n    max-width: 125px !important;\n  }\n  .mw-sm-150px {\n    max-width: 150px !important;\n  }\n  .mw-sm-175px {\n    max-width: 175px !important;\n  }\n  .mw-sm-200px {\n    max-width: 200px !important;\n  }\n  .mw-sm-225px {\n    max-width: 225px !important;\n  }\n  .mw-sm-250px {\n    max-width: 250px !important;\n  }\n  .mw-sm-275px {\n    max-width: 275px !important;\n  }\n  .mw-sm-300px {\n    max-width: 300px !important;\n  }\n  .mw-sm-325px {\n    max-width: 325px !important;\n  }\n  .mw-sm-350px {\n    max-width: 350px !important;\n  }\n  .mw-sm-375px {\n    max-width: 375px !important;\n  }\n  .mw-sm-400px {\n    max-width: 400px !important;\n  }\n  .mw-sm-425px {\n    max-width: 425px !important;\n  }\n  .mw-sm-450px {\n    max-width: 450px !important;\n  }\n  .mw-sm-475px {\n    max-width: 475px !important;\n  }\n  .mw-sm-500px {\n    max-width: 500px !important;\n  }\n  .mw-sm-550px {\n    max-width: 550px !important;\n  }\n  .mw-sm-600px {\n    max-width: 600px !important;\n  }\n  .mw-sm-650px {\n    max-width: 650px !important;\n  }\n  .mw-sm-700px {\n    max-width: 700px !important;\n  }\n  .mw-sm-750px {\n    max-width: 750px !important;\n  }\n  .mw-sm-800px {\n    max-width: 800px !important;\n  }\n  .mw-sm-850px {\n    max-width: 850px !important;\n  }\n  .mw-sm-900px {\n    max-width: 900px !important;\n  }\n  .mw-sm-950px {\n    max-width: 950px !important;\n  }\n  .mw-sm-1000px {\n    max-width: 1000px !important;\n  }\n  .h-sm-unset {\n    height: unset !important;\n  }\n  .h-sm-25 {\n    height: 25% !important;\n  }\n  .h-sm-50 {\n    height: 50% !important;\n  }\n  .h-sm-75 {\n    height: 75% !important;\n  }\n  .h-sm-100 {\n    height: 100% !important;\n  }\n  .h-sm-auto {\n    height: auto !important;\n  }\n  .h-sm-1px {\n    height: 1px !important;\n  }\n  .h-sm-2px {\n    height: 2px !important;\n  }\n  .h-sm-3px {\n    height: 3px !important;\n  }\n  .h-sm-4px {\n    height: 4px !important;\n  }\n  .h-sm-5px {\n    height: 5px !important;\n  }\n  .h-sm-6px {\n    height: 6px !important;\n  }\n  .h-sm-7px {\n    height: 7px !important;\n  }\n  .h-sm-8px {\n    height: 8px !important;\n  }\n  .h-sm-9px {\n    height: 9px !important;\n  }\n  .h-sm-10px {\n    height: 10px !important;\n  }\n  .h-sm-15px {\n    height: 15px !important;\n  }\n  .h-sm-20px {\n    height: 20px !important;\n  }\n  .h-sm-25px {\n    height: 25px !important;\n  }\n  .h-sm-30px {\n    height: 30px !important;\n  }\n  .h-sm-35px {\n    height: 35px !important;\n  }\n  .h-sm-40px {\n    height: 40px !important;\n  }\n  .h-sm-45px {\n    height: 45px !important;\n  }\n  .h-sm-50px {\n    height: 50px !important;\n  }\n  .h-sm-55px {\n    height: 55px !important;\n  }\n  .h-sm-60px {\n    height: 60px !important;\n  }\n  .h-sm-65px {\n    height: 65px !important;\n  }\n  .h-sm-70px {\n    height: 70px !important;\n  }\n  .h-sm-75px {\n    height: 75px !important;\n  }\n  .h-sm-80px {\n    height: 80px !important;\n  }\n  .h-sm-85px {\n    height: 85px !important;\n  }\n  .h-sm-90px {\n    height: 90px !important;\n  }\n  .h-sm-95px {\n    height: 95px !important;\n  }\n  .h-sm-100px {\n    height: 100px !important;\n  }\n  .h-sm-125px {\n    height: 125px !important;\n  }\n  .h-sm-150px {\n    height: 150px !important;\n  }\n  .h-sm-175px {\n    height: 175px !important;\n  }\n  .h-sm-200px {\n    height: 200px !important;\n  }\n  .h-sm-225px {\n    height: 225px !important;\n  }\n  .h-sm-250px {\n    height: 250px !important;\n  }\n  .h-sm-275px {\n    height: 275px !important;\n  }\n  .h-sm-300px {\n    height: 300px !important;\n  }\n  .h-sm-325px {\n    height: 325px !important;\n  }\n  .h-sm-350px {\n    height: 350px !important;\n  }\n  .h-sm-375px {\n    height: 375px !important;\n  }\n  .h-sm-400px {\n    height: 400px !important;\n  }\n  .h-sm-425px {\n    height: 425px !important;\n  }\n  .h-sm-450px {\n    height: 450px !important;\n  }\n  .h-sm-475px {\n    height: 475px !important;\n  }\n  .h-sm-500px {\n    height: 500px !important;\n  }\n  .h-sm-550px {\n    height: 550px !important;\n  }\n  .h-sm-600px {\n    height: 600px !important;\n  }\n  .h-sm-650px {\n    height: 650px !important;\n  }\n  .h-sm-700px {\n    height: 700px !important;\n  }\n  .h-sm-750px {\n    height: 750px !important;\n  }\n  .h-sm-800px {\n    height: 800px !important;\n  }\n  .h-sm-850px {\n    height: 850px !important;\n  }\n  .h-sm-900px {\n    height: 900px !important;\n  }\n  .h-sm-950px {\n    height: 950px !important;\n  }\n  .h-sm-1000px {\n    height: 1000px !important;\n  }\n  .mh-sm-unset {\n    max-height: unset !important;\n  }\n  .mh-sm-25 {\n    max-height: 25% !important;\n  }\n  .mh-sm-50 {\n    max-height: 50% !important;\n  }\n  .mh-sm-75 {\n    max-height: 75% !important;\n  }\n  .mh-sm-100 {\n    max-height: 100% !important;\n  }\n  .mh-sm-auto {\n    max-height: auto !important;\n  }\n  .mh-sm-1px {\n    max-height: 1px !important;\n  }\n  .mh-sm-2px {\n    max-height: 2px !important;\n  }\n  .mh-sm-3px {\n    max-height: 3px !important;\n  }\n  .mh-sm-4px {\n    max-height: 4px !important;\n  }\n  .mh-sm-5px {\n    max-height: 5px !important;\n  }\n  .mh-sm-6px {\n    max-height: 6px !important;\n  }\n  .mh-sm-7px {\n    max-height: 7px !important;\n  }\n  .mh-sm-8px {\n    max-height: 8px !important;\n  }\n  .mh-sm-9px {\n    max-height: 9px !important;\n  }\n  .mh-sm-10px {\n    max-height: 10px !important;\n  }\n  .mh-sm-15px {\n    max-height: 15px !important;\n  }\n  .mh-sm-20px {\n    max-height: 20px !important;\n  }\n  .mh-sm-25px {\n    max-height: 25px !important;\n  }\n  .mh-sm-30px {\n    max-height: 30px !important;\n  }\n  .mh-sm-35px {\n    max-height: 35px !important;\n  }\n  .mh-sm-40px {\n    max-height: 40px !important;\n  }\n  .mh-sm-45px {\n    max-height: 45px !important;\n  }\n  .mh-sm-50px {\n    max-height: 50px !important;\n  }\n  .mh-sm-55px {\n    max-height: 55px !important;\n  }\n  .mh-sm-60px {\n    max-height: 60px !important;\n  }\n  .mh-sm-65px {\n    max-height: 65px !important;\n  }\n  .mh-sm-70px {\n    max-height: 70px !important;\n  }\n  .mh-sm-75px {\n    max-height: 75px !important;\n  }\n  .mh-sm-80px {\n    max-height: 80px !important;\n  }\n  .mh-sm-85px {\n    max-height: 85px !important;\n  }\n  .mh-sm-90px {\n    max-height: 90px !important;\n  }\n  .mh-sm-95px {\n    max-height: 95px !important;\n  }\n  .mh-sm-100px {\n    max-height: 100px !important;\n  }\n  .mh-sm-125px {\n    max-height: 125px !important;\n  }\n  .mh-sm-150px {\n    max-height: 150px !important;\n  }\n  .mh-sm-175px {\n    max-height: 175px !important;\n  }\n  .mh-sm-200px {\n    max-height: 200px !important;\n  }\n  .mh-sm-225px {\n    max-height: 225px !important;\n  }\n  .mh-sm-250px {\n    max-height: 250px !important;\n  }\n  .mh-sm-275px {\n    max-height: 275px !important;\n  }\n  .mh-sm-300px {\n    max-height: 300px !important;\n  }\n  .mh-sm-325px {\n    max-height: 325px !important;\n  }\n  .mh-sm-350px {\n    max-height: 350px !important;\n  }\n  .mh-sm-375px {\n    max-height: 375px !important;\n  }\n  .mh-sm-400px {\n    max-height: 400px !important;\n  }\n  .mh-sm-425px {\n    max-height: 425px !important;\n  }\n  .mh-sm-450px {\n    max-height: 450px !important;\n  }\n  .mh-sm-475px {\n    max-height: 475px !important;\n  }\n  .mh-sm-500px {\n    max-height: 500px !important;\n  }\n  .mh-sm-550px {\n    max-height: 550px !important;\n  }\n  .mh-sm-600px {\n    max-height: 600px !important;\n  }\n  .mh-sm-650px {\n    max-height: 650px !important;\n  }\n  .mh-sm-700px {\n    max-height: 700px !important;\n  }\n  .mh-sm-750px {\n    max-height: 750px !important;\n  }\n  .mh-sm-800px {\n    max-height: 800px !important;\n  }\n  .mh-sm-850px {\n    max-height: 850px !important;\n  }\n  .mh-sm-900px {\n    max-height: 900px !important;\n  }\n  .mh-sm-950px {\n    max-height: 950px !important;\n  }\n  .mh-sm-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n  .order-sm-first {\n    order: -1 !important;\n  }\n  .order-sm-0 {\n    order: 0 !important;\n  }\n  .order-sm-1 {\n    order: 1 !important;\n  }\n  .order-sm-2 {\n    order: 2 !important;\n  }\n  .order-sm-3 {\n    order: 3 !important;\n  }\n  .order-sm-4 {\n    order: 4 !important;\n  }\n  .order-sm-5 {\n    order: 5 !important;\n  }\n  .order-sm-last {\n    order: 6 !important;\n  }\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 0.75rem !important;\n  }\n  .m-sm-4 {\n    margin: 1rem !important;\n  }\n  .m-sm-5 {\n    margin: 1.25rem !important;\n  }\n  .m-sm-6 {\n    margin: 1.5rem !important;\n  }\n  .m-sm-7 {\n    margin: 1.75rem !important;\n  }\n  .m-sm-8 {\n    margin: 2rem !important;\n  }\n  .m-sm-9 {\n    margin: 2.25rem !important;\n  }\n  .m-sm-10 {\n    margin: 2.5rem !important;\n  }\n  .m-sm-11 {\n    margin: 2.75rem !important;\n  }\n  .m-sm-12 {\n    margin: 3rem !important;\n  }\n  .m-sm-13 {\n    margin: 3.25rem !important;\n  }\n  .m-sm-14 {\n    margin: 3.5rem !important;\n  }\n  .m-sm-15 {\n    margin: 3.75rem !important;\n  }\n  .m-sm-16 {\n    margin: 4rem !important;\n  }\n  .m-sm-17 {\n    margin: 4.25rem !important;\n  }\n  .m-sm-18 {\n    margin: 4.5rem !important;\n  }\n  .m-sm-19 {\n    margin: 4.75rem !important;\n  }\n  .m-sm-20 {\n    margin: 5rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-sm-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-sm-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-sm-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-sm-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-sm-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-sm-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-sm-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-sm-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-sm-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-sm-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-sm-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-sm-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-sm-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-sm-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-sm-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-sm-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-sm-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-sm-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-sm-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-sm-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-sm-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-sm-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-sm-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-sm-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-sm-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-sm-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-sm-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-sm-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-sm-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-sm-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-sm-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-sm-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-sm-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-sm-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-sm-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-sm-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-sm-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-sm-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-sm-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-sm-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-sm-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-sm-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-sm-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-sm-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-sm-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-sm-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-sm-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-sm-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-sm-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-sm-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-sm-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-sm-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-sm-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-sm-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-sm-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-sm-4 {\n    margin-right: 1rem !important;\n  }\n  .me-sm-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-sm-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-sm-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-sm-8 {\n    margin-right: 2rem !important;\n  }\n  .me-sm-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-sm-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-sm-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-sm-12 {\n    margin-right: 3rem !important;\n  }\n  .me-sm-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-sm-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-sm-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-sm-16 {\n    margin-right: 4rem !important;\n  }\n  .me-sm-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-sm-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-sm-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-sm-20 {\n    margin-right: 5rem !important;\n  }\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-sm-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-sm-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-sm-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-sm-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-sm-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-sm-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-sm-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-sm-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-sm-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-sm-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-sm-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-sm-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-sm-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-sm-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-sm-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-sm-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-sm-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-sm-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-sm-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-sm-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-sm-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-sm-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-sm-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-sm-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-sm-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-sm-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-sm-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-sm-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-sm-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-sm-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-sm-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-sm-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-sm-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-sm-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-sm-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-sm-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1rem !important;\n  }\n  .m-sm-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-sm-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-sm-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-sm-n8 {\n    margin: -2rem !important;\n  }\n  .m-sm-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-sm-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-sm-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-sm-n12 {\n    margin: -3rem !important;\n  }\n  .m-sm-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-sm-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-sm-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-sm-n16 {\n    margin: -4rem !important;\n  }\n  .m-sm-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-sm-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-sm-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-sm-n20 {\n    margin: -5rem !important;\n  }\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-sm-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-sm-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-sm-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-sm-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-sm-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-sm-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-sm-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-sm-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-sm-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-sm-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-sm-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-sm-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-sm-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-sm-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-sm-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-sm-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-sm-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-sm-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-sm-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-sm-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-sm-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-sm-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-sm-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-sm-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-sm-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-sm-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-sm-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-sm-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-sm-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-sm-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-sm-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-sm-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-sm-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-sm-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-sm-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-sm-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-sm-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-sm-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-sm-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-sm-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-sm-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-sm-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-sm-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-sm-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-sm-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-sm-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-sm-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-sm-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-sm-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-sm-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-sm-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-sm-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-sm-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-sm-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-sm-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-sm-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-sm-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-sm-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-sm-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-sm-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-sm-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-sm-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-sm-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-sm-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-sm-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-sm-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-sm-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-sm-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-sm-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-sm-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-sm-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-sm-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-sm-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-sm-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-sm-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-sm-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-sm-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-sm-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-sm-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-sm-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-sm-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-sm-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-sm-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-sm-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-sm-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-sm-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-sm-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-sm-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-sm-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-sm-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-sm-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-sm-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-sm-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-sm-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-sm-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-sm-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-sm-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-sm-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-sm-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-sm-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-sm-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-sm-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-sm-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-sm-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-sm-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-sm-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-sm-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-sm-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 0.75rem !important;\n  }\n  .p-sm-4 {\n    padding: 1rem !important;\n  }\n  .p-sm-5 {\n    padding: 1.25rem !important;\n  }\n  .p-sm-6 {\n    padding: 1.5rem !important;\n  }\n  .p-sm-7 {\n    padding: 1.75rem !important;\n  }\n  .p-sm-8 {\n    padding: 2rem !important;\n  }\n  .p-sm-9 {\n    padding: 2.25rem !important;\n  }\n  .p-sm-10 {\n    padding: 2.5rem !important;\n  }\n  .p-sm-11 {\n    padding: 2.75rem !important;\n  }\n  .p-sm-12 {\n    padding: 3rem !important;\n  }\n  .p-sm-13 {\n    padding: 3.25rem !important;\n  }\n  .p-sm-14 {\n    padding: 3.5rem !important;\n  }\n  .p-sm-15 {\n    padding: 3.75rem !important;\n  }\n  .p-sm-16 {\n    padding: 4rem !important;\n  }\n  .p-sm-17 {\n    padding: 4.25rem !important;\n  }\n  .p-sm-18 {\n    padding: 4.5rem !important;\n  }\n  .p-sm-19 {\n    padding: 4.75rem !important;\n  }\n  .p-sm-20 {\n    padding: 5rem !important;\n  }\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-sm-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-sm-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-sm-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-sm-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-sm-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-sm-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-sm-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-sm-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-sm-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-sm-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-sm-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-sm-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-sm-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-sm-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-sm-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-sm-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-sm-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-sm-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-sm-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-sm-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-sm-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-sm-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-sm-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-sm-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-sm-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-sm-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-sm-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-sm-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-sm-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-sm-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-sm-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-sm-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-sm-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-sm-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-sm-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-sm-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-sm-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-sm-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-sm-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-sm-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-sm-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-sm-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-sm-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-sm-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-sm-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-sm-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-sm-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-sm-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-sm-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-sm-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-sm-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-sm-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-sm-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-sm-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-sm-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-sm-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-sm-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-sm-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-sm-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-sm-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-sm-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-sm-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-sm-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-sm-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-sm-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-sm-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-sm-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-sm-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-sm-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-sm-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-sm-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-sm-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-sm-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-sm-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-sm-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-sm-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-sm-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-sm-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-sm-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-sm-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-sm-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-sm-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-sm-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-sm-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-sm-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-sm-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-sm-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-sm-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-sm-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-sm-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-sm-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-sm-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-sm-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-sm-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-sm-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-sm-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-sm-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-sm-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-sm-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-sm-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-sm-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-sm-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-sm-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-sm-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-sm-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-sm-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-sm-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-sm-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-sm-4 {\n    gap: 1rem !important;\n  }\n  .gap-sm-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-sm-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-sm-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-sm-8 {\n    gap: 2rem !important;\n  }\n  .gap-sm-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-sm-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-sm-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-sm-12 {\n    gap: 3rem !important;\n  }\n  .gap-sm-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-sm-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-sm-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-sm-16 {\n    gap: 4rem !important;\n  }\n  .gap-sm-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-sm-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-sm-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-sm-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-sm-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-sm-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-sm-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-sm-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-sm-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-sm-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-sm-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-sm-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-sm-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-sm-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-sm-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-sm-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-sm-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-sm-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-sm-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-sm-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-sm-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-sm-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-sm-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-sm-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-sm-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-sm-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-sm-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-sm-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-sm-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-sm-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-sm-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-sm-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-sm-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-sm-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-sm-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-sm-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-sm-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-sm-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-sm-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-sm-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-sm-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-sm-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-sm-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-sm-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-sm-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-sm-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-sm-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-sm-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-sm-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-sm-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-sm-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-sm-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-sm-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-sm-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-sm-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-sm-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-sm-sm {\n    font-size: 0.95rem !important;\n  }\n  .fs-sm-base {\n    font-size: 1rem !important;\n  }\n  .fs-sm-lg {\n    font-size: 1.075rem !important;\n  }\n  .fs-sm-xl {\n    font-size: 1.21rem !important;\n  }\n  .fs-sm-fluid {\n    font-size: 100% !important;\n  }\n  .fs-sm-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-sm-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-sm-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-sm-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-sm-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-sm-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-sm-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-sm-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-sm-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-sm-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-sm-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-sm-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-sm-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-sm-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-sm-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-sm-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-sm-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-sm-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-sm-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-sm-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-sm-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-sm-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-sm-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-sm-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-sm-start {\n    text-align: left !important;\n  }\n  .text-sm-end {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n  .min-w-sm-unset {\n    min-width: unset !important;\n  }\n  .min-w-sm-25 {\n    min-width: 25% !important;\n  }\n  .min-w-sm-50 {\n    min-width: 50% !important;\n  }\n  .min-w-sm-75 {\n    min-width: 75% !important;\n  }\n  .min-w-sm-100 {\n    min-width: 100% !important;\n  }\n  .min-w-sm-auto {\n    min-width: auto !important;\n  }\n  .min-w-sm-1px {\n    min-width: 1px !important;\n  }\n  .min-w-sm-2px {\n    min-width: 2px !important;\n  }\n  .min-w-sm-3px {\n    min-width: 3px !important;\n  }\n  .min-w-sm-4px {\n    min-width: 4px !important;\n  }\n  .min-w-sm-5px {\n    min-width: 5px !important;\n  }\n  .min-w-sm-6px {\n    min-width: 6px !important;\n  }\n  .min-w-sm-7px {\n    min-width: 7px !important;\n  }\n  .min-w-sm-8px {\n    min-width: 8px !important;\n  }\n  .min-w-sm-9px {\n    min-width: 9px !important;\n  }\n  .min-w-sm-10px {\n    min-width: 10px !important;\n  }\n  .min-w-sm-15px {\n    min-width: 15px !important;\n  }\n  .min-w-sm-20px {\n    min-width: 20px !important;\n  }\n  .min-w-sm-25px {\n    min-width: 25px !important;\n  }\n  .min-w-sm-30px {\n    min-width: 30px !important;\n  }\n  .min-w-sm-35px {\n    min-width: 35px !important;\n  }\n  .min-w-sm-40px {\n    min-width: 40px !important;\n  }\n  .min-w-sm-45px {\n    min-width: 45px !important;\n  }\n  .min-w-sm-50px {\n    min-width: 50px !important;\n  }\n  .min-w-sm-55px {\n    min-width: 55px !important;\n  }\n  .min-w-sm-60px {\n    min-width: 60px !important;\n  }\n  .min-w-sm-65px {\n    min-width: 65px !important;\n  }\n  .min-w-sm-70px {\n    min-width: 70px !important;\n  }\n  .min-w-sm-75px {\n    min-width: 75px !important;\n  }\n  .min-w-sm-80px {\n    min-width: 80px !important;\n  }\n  .min-w-sm-85px {\n    min-width: 85px !important;\n  }\n  .min-w-sm-90px {\n    min-width: 90px !important;\n  }\n  .min-w-sm-95px {\n    min-width: 95px !important;\n  }\n  .min-w-sm-100px {\n    min-width: 100px !important;\n  }\n  .min-w-sm-125px {\n    min-width: 125px !important;\n  }\n  .min-w-sm-150px {\n    min-width: 150px !important;\n  }\n  .min-w-sm-175px {\n    min-width: 175px !important;\n  }\n  .min-w-sm-200px {\n    min-width: 200px !important;\n  }\n  .min-w-sm-225px {\n    min-width: 225px !important;\n  }\n  .min-w-sm-250px {\n    min-width: 250px !important;\n  }\n  .min-w-sm-275px {\n    min-width: 275px !important;\n  }\n  .min-w-sm-300px {\n    min-width: 300px !important;\n  }\n  .min-w-sm-325px {\n    min-width: 325px !important;\n  }\n  .min-w-sm-350px {\n    min-width: 350px !important;\n  }\n  .min-w-sm-375px {\n    min-width: 375px !important;\n  }\n  .min-w-sm-400px {\n    min-width: 400px !important;\n  }\n  .min-w-sm-425px {\n    min-width: 425px !important;\n  }\n  .min-w-sm-450px {\n    min-width: 450px !important;\n  }\n  .min-w-sm-475px {\n    min-width: 475px !important;\n  }\n  .min-w-sm-500px {\n    min-width: 500px !important;\n  }\n  .min-w-sm-550px {\n    min-width: 550px !important;\n  }\n  .min-w-sm-600px {\n    min-width: 600px !important;\n  }\n  .min-w-sm-650px {\n    min-width: 650px !important;\n  }\n  .min-w-sm-700px {\n    min-width: 700px !important;\n  }\n  .min-w-sm-750px {\n    min-width: 750px !important;\n  }\n  .min-w-sm-800px {\n    min-width: 800px !important;\n  }\n  .min-w-sm-850px {\n    min-width: 850px !important;\n  }\n  .min-w-sm-900px {\n    min-width: 900px !important;\n  }\n  .min-w-sm-950px {\n    min-width: 950px !important;\n  }\n  .min-w-sm-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-sm-unset {\n    min-height: unset !important;\n  }\n  .min-h-sm-25 {\n    min-height: 25% !important;\n  }\n  .min-h-sm-50 {\n    min-height: 50% !important;\n  }\n  .min-h-sm-75 {\n    min-height: 75% !important;\n  }\n  .min-h-sm-100 {\n    min-height: 100% !important;\n  }\n  .min-h-sm-auto {\n    min-height: auto !important;\n  }\n  .min-h-sm-1px {\n    min-height: 1px !important;\n  }\n  .min-h-sm-2px {\n    min-height: 2px !important;\n  }\n  .min-h-sm-3px {\n    min-height: 3px !important;\n  }\n  .min-h-sm-4px {\n    min-height: 4px !important;\n  }\n  .min-h-sm-5px {\n    min-height: 5px !important;\n  }\n  .min-h-sm-6px {\n    min-height: 6px !important;\n  }\n  .min-h-sm-7px {\n    min-height: 7px !important;\n  }\n  .min-h-sm-8px {\n    min-height: 8px !important;\n  }\n  .min-h-sm-9px {\n    min-height: 9px !important;\n  }\n  .min-h-sm-10px {\n    min-height: 10px !important;\n  }\n  .min-h-sm-15px {\n    min-height: 15px !important;\n  }\n  .min-h-sm-20px {\n    min-height: 20px !important;\n  }\n  .min-h-sm-25px {\n    min-height: 25px !important;\n  }\n  .min-h-sm-30px {\n    min-height: 30px !important;\n  }\n  .min-h-sm-35px {\n    min-height: 35px !important;\n  }\n  .min-h-sm-40px {\n    min-height: 40px !important;\n  }\n  .min-h-sm-45px {\n    min-height: 45px !important;\n  }\n  .min-h-sm-50px {\n    min-height: 50px !important;\n  }\n  .min-h-sm-55px {\n    min-height: 55px !important;\n  }\n  .min-h-sm-60px {\n    min-height: 60px !important;\n  }\n  .min-h-sm-65px {\n    min-height: 65px !important;\n  }\n  .min-h-sm-70px {\n    min-height: 70px !important;\n  }\n  .min-h-sm-75px {\n    min-height: 75px !important;\n  }\n  .min-h-sm-80px {\n    min-height: 80px !important;\n  }\n  .min-h-sm-85px {\n    min-height: 85px !important;\n  }\n  .min-h-sm-90px {\n    min-height: 90px !important;\n  }\n  .min-h-sm-95px {\n    min-height: 95px !important;\n  }\n  .min-h-sm-100px {\n    min-height: 100px !important;\n  }\n  .min-h-sm-125px {\n    min-height: 125px !important;\n  }\n  .min-h-sm-150px {\n    min-height: 150px !important;\n  }\n  .min-h-sm-175px {\n    min-height: 175px !important;\n  }\n  .min-h-sm-200px {\n    min-height: 200px !important;\n  }\n  .min-h-sm-225px {\n    min-height: 225px !important;\n  }\n  .min-h-sm-250px {\n    min-height: 250px !important;\n  }\n  .min-h-sm-275px {\n    min-height: 275px !important;\n  }\n  .min-h-sm-300px {\n    min-height: 300px !important;\n  }\n  .min-h-sm-325px {\n    min-height: 325px !important;\n  }\n  .min-h-sm-350px {\n    min-height: 350px !important;\n  }\n  .min-h-sm-375px {\n    min-height: 375px !important;\n  }\n  .min-h-sm-400px {\n    min-height: 400px !important;\n  }\n  .min-h-sm-425px {\n    min-height: 425px !important;\n  }\n  .min-h-sm-450px {\n    min-height: 450px !important;\n  }\n  .min-h-sm-475px {\n    min-height: 475px !important;\n  }\n  .min-h-sm-500px {\n    min-height: 500px !important;\n  }\n  .min-h-sm-550px {\n    min-height: 550px !important;\n  }\n  .min-h-sm-600px {\n    min-height: 600px !important;\n  }\n  .min-h-sm-650px {\n    min-height: 650px !important;\n  }\n  .min-h-sm-700px {\n    min-height: 700px !important;\n  }\n  .min-h-sm-750px {\n    min-height: 750px !important;\n  }\n  .min-h-sm-800px {\n    min-height: 800px !important;\n  }\n  .min-h-sm-850px {\n    min-height: 850px !important;\n  }\n  .min-h-sm-900px {\n    min-height: 900px !important;\n  }\n  .min-h-sm-950px {\n    min-height: 950px !important;\n  }\n  .min-h-sm-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n  .float-md-end {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n  .object-fit-md-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-md-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-md-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-md-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-md-none {\n    object-fit: none !important;\n  }\n  .overflow-md-auto {\n    overflow: auto !important;\n  }\n  .overflow-md-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-md-visible {\n    overflow: visible !important;\n  }\n  .overflow-md-scroll {\n    overflow: scroll !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-grid {\n    display: grid !important;\n  }\n  .d-md-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-md-none {\n    display: none !important;\n  }\n  .position-md-static {\n    position: static !important;\n  }\n  .position-md-relative {\n    position: relative !important;\n  }\n  .position-md-absolute {\n    position: absolute !important;\n  }\n  .position-md-fixed {\n    position: fixed !important;\n  }\n  .position-md-sticky {\n    position: sticky !important;\n  }\n  .w-md-unset {\n    width: unset !important;\n  }\n  .w-md-25 {\n    width: 25% !important;\n  }\n  .w-md-50 {\n    width: 50% !important;\n  }\n  .w-md-75 {\n    width: 75% !important;\n  }\n  .w-md-100 {\n    width: 100% !important;\n  }\n  .w-md-auto {\n    width: auto !important;\n  }\n  .w-md-1px {\n    width: 1px !important;\n  }\n  .w-md-2px {\n    width: 2px !important;\n  }\n  .w-md-3px {\n    width: 3px !important;\n  }\n  .w-md-4px {\n    width: 4px !important;\n  }\n  .w-md-5px {\n    width: 5px !important;\n  }\n  .w-md-6px {\n    width: 6px !important;\n  }\n  .w-md-7px {\n    width: 7px !important;\n  }\n  .w-md-8px {\n    width: 8px !important;\n  }\n  .w-md-9px {\n    width: 9px !important;\n  }\n  .w-md-10px {\n    width: 10px !important;\n  }\n  .w-md-15px {\n    width: 15px !important;\n  }\n  .w-md-20px {\n    width: 20px !important;\n  }\n  .w-md-25px {\n    width: 25px !important;\n  }\n  .w-md-30px {\n    width: 30px !important;\n  }\n  .w-md-35px {\n    width: 35px !important;\n  }\n  .w-md-40px {\n    width: 40px !important;\n  }\n  .w-md-45px {\n    width: 45px !important;\n  }\n  .w-md-50px {\n    width: 50px !important;\n  }\n  .w-md-55px {\n    width: 55px !important;\n  }\n  .w-md-60px {\n    width: 60px !important;\n  }\n  .w-md-65px {\n    width: 65px !important;\n  }\n  .w-md-70px {\n    width: 70px !important;\n  }\n  .w-md-75px {\n    width: 75px !important;\n  }\n  .w-md-80px {\n    width: 80px !important;\n  }\n  .w-md-85px {\n    width: 85px !important;\n  }\n  .w-md-90px {\n    width: 90px !important;\n  }\n  .w-md-95px {\n    width: 95px !important;\n  }\n  .w-md-100px {\n    width: 100px !important;\n  }\n  .w-md-125px {\n    width: 125px !important;\n  }\n  .w-md-150px {\n    width: 150px !important;\n  }\n  .w-md-175px {\n    width: 175px !important;\n  }\n  .w-md-200px {\n    width: 200px !important;\n  }\n  .w-md-225px {\n    width: 225px !important;\n  }\n  .w-md-250px {\n    width: 250px !important;\n  }\n  .w-md-275px {\n    width: 275px !important;\n  }\n  .w-md-300px {\n    width: 300px !important;\n  }\n  .w-md-325px {\n    width: 325px !important;\n  }\n  .w-md-350px {\n    width: 350px !important;\n  }\n  .w-md-375px {\n    width: 375px !important;\n  }\n  .w-md-400px {\n    width: 400px !important;\n  }\n  .w-md-425px {\n    width: 425px !important;\n  }\n  .w-md-450px {\n    width: 450px !important;\n  }\n  .w-md-475px {\n    width: 475px !important;\n  }\n  .w-md-500px {\n    width: 500px !important;\n  }\n  .w-md-550px {\n    width: 550px !important;\n  }\n  .w-md-600px {\n    width: 600px !important;\n  }\n  .w-md-650px {\n    width: 650px !important;\n  }\n  .w-md-700px {\n    width: 700px !important;\n  }\n  .w-md-750px {\n    width: 750px !important;\n  }\n  .w-md-800px {\n    width: 800px !important;\n  }\n  .w-md-850px {\n    width: 850px !important;\n  }\n  .w-md-900px {\n    width: 900px !important;\n  }\n  .w-md-950px {\n    width: 950px !important;\n  }\n  .w-md-1000px {\n    width: 1000px !important;\n  }\n  .mw-md-unset {\n    max-width: unset !important;\n  }\n  .mw-md-25 {\n    max-width: 25% !important;\n  }\n  .mw-md-50 {\n    max-width: 50% !important;\n  }\n  .mw-md-75 {\n    max-width: 75% !important;\n  }\n  .mw-md-100 {\n    max-width: 100% !important;\n  }\n  .mw-md-auto {\n    max-width: auto !important;\n  }\n  .mw-md-1px {\n    max-width: 1px !important;\n  }\n  .mw-md-2px {\n    max-width: 2px !important;\n  }\n  .mw-md-3px {\n    max-width: 3px !important;\n  }\n  .mw-md-4px {\n    max-width: 4px !important;\n  }\n  .mw-md-5px {\n    max-width: 5px !important;\n  }\n  .mw-md-6px {\n    max-width: 6px !important;\n  }\n  .mw-md-7px {\n    max-width: 7px !important;\n  }\n  .mw-md-8px {\n    max-width: 8px !important;\n  }\n  .mw-md-9px {\n    max-width: 9px !important;\n  }\n  .mw-md-10px {\n    max-width: 10px !important;\n  }\n  .mw-md-15px {\n    max-width: 15px !important;\n  }\n  .mw-md-20px {\n    max-width: 20px !important;\n  }\n  .mw-md-25px {\n    max-width: 25px !important;\n  }\n  .mw-md-30px {\n    max-width: 30px !important;\n  }\n  .mw-md-35px {\n    max-width: 35px !important;\n  }\n  .mw-md-40px {\n    max-width: 40px !important;\n  }\n  .mw-md-45px {\n    max-width: 45px !important;\n  }\n  .mw-md-50px {\n    max-width: 50px !important;\n  }\n  .mw-md-55px {\n    max-width: 55px !important;\n  }\n  .mw-md-60px {\n    max-width: 60px !important;\n  }\n  .mw-md-65px {\n    max-width: 65px !important;\n  }\n  .mw-md-70px {\n    max-width: 70px !important;\n  }\n  .mw-md-75px {\n    max-width: 75px !important;\n  }\n  .mw-md-80px {\n    max-width: 80px !important;\n  }\n  .mw-md-85px {\n    max-width: 85px !important;\n  }\n  .mw-md-90px {\n    max-width: 90px !important;\n  }\n  .mw-md-95px {\n    max-width: 95px !important;\n  }\n  .mw-md-100px {\n    max-width: 100px !important;\n  }\n  .mw-md-125px {\n    max-width: 125px !important;\n  }\n  .mw-md-150px {\n    max-width: 150px !important;\n  }\n  .mw-md-175px {\n    max-width: 175px !important;\n  }\n  .mw-md-200px {\n    max-width: 200px !important;\n  }\n  .mw-md-225px {\n    max-width: 225px !important;\n  }\n  .mw-md-250px {\n    max-width: 250px !important;\n  }\n  .mw-md-275px {\n    max-width: 275px !important;\n  }\n  .mw-md-300px {\n    max-width: 300px !important;\n  }\n  .mw-md-325px {\n    max-width: 325px !important;\n  }\n  .mw-md-350px {\n    max-width: 350px !important;\n  }\n  .mw-md-375px {\n    max-width: 375px !important;\n  }\n  .mw-md-400px {\n    max-width: 400px !important;\n  }\n  .mw-md-425px {\n    max-width: 425px !important;\n  }\n  .mw-md-450px {\n    max-width: 450px !important;\n  }\n  .mw-md-475px {\n    max-width: 475px !important;\n  }\n  .mw-md-500px {\n    max-width: 500px !important;\n  }\n  .mw-md-550px {\n    max-width: 550px !important;\n  }\n  .mw-md-600px {\n    max-width: 600px !important;\n  }\n  .mw-md-650px {\n    max-width: 650px !important;\n  }\n  .mw-md-700px {\n    max-width: 700px !important;\n  }\n  .mw-md-750px {\n    max-width: 750px !important;\n  }\n  .mw-md-800px {\n    max-width: 800px !important;\n  }\n  .mw-md-850px {\n    max-width: 850px !important;\n  }\n  .mw-md-900px {\n    max-width: 900px !important;\n  }\n  .mw-md-950px {\n    max-width: 950px !important;\n  }\n  .mw-md-1000px {\n    max-width: 1000px !important;\n  }\n  .h-md-unset {\n    height: unset !important;\n  }\n  .h-md-25 {\n    height: 25% !important;\n  }\n  .h-md-50 {\n    height: 50% !important;\n  }\n  .h-md-75 {\n    height: 75% !important;\n  }\n  .h-md-100 {\n    height: 100% !important;\n  }\n  .h-md-auto {\n    height: auto !important;\n  }\n  .h-md-1px {\n    height: 1px !important;\n  }\n  .h-md-2px {\n    height: 2px !important;\n  }\n  .h-md-3px {\n    height: 3px !important;\n  }\n  .h-md-4px {\n    height: 4px !important;\n  }\n  .h-md-5px {\n    height: 5px !important;\n  }\n  .h-md-6px {\n    height: 6px !important;\n  }\n  .h-md-7px {\n    height: 7px !important;\n  }\n  .h-md-8px {\n    height: 8px !important;\n  }\n  .h-md-9px {\n    height: 9px !important;\n  }\n  .h-md-10px {\n    height: 10px !important;\n  }\n  .h-md-15px {\n    height: 15px !important;\n  }\n  .h-md-20px {\n    height: 20px !important;\n  }\n  .h-md-25px {\n    height: 25px !important;\n  }\n  .h-md-30px {\n    height: 30px !important;\n  }\n  .h-md-35px {\n    height: 35px !important;\n  }\n  .h-md-40px {\n    height: 40px !important;\n  }\n  .h-md-45px {\n    height: 45px !important;\n  }\n  .h-md-50px {\n    height: 50px !important;\n  }\n  .h-md-55px {\n    height: 55px !important;\n  }\n  .h-md-60px {\n    height: 60px !important;\n  }\n  .h-md-65px {\n    height: 65px !important;\n  }\n  .h-md-70px {\n    height: 70px !important;\n  }\n  .h-md-75px {\n    height: 75px !important;\n  }\n  .h-md-80px {\n    height: 80px !important;\n  }\n  .h-md-85px {\n    height: 85px !important;\n  }\n  .h-md-90px {\n    height: 90px !important;\n  }\n  .h-md-95px {\n    height: 95px !important;\n  }\n  .h-md-100px {\n    height: 100px !important;\n  }\n  .h-md-125px {\n    height: 125px !important;\n  }\n  .h-md-150px {\n    height: 150px !important;\n  }\n  .h-md-175px {\n    height: 175px !important;\n  }\n  .h-md-200px {\n    height: 200px !important;\n  }\n  .h-md-225px {\n    height: 225px !important;\n  }\n  .h-md-250px {\n    height: 250px !important;\n  }\n  .h-md-275px {\n    height: 275px !important;\n  }\n  .h-md-300px {\n    height: 300px !important;\n  }\n  .h-md-325px {\n    height: 325px !important;\n  }\n  .h-md-350px {\n    height: 350px !important;\n  }\n  .h-md-375px {\n    height: 375px !important;\n  }\n  .h-md-400px {\n    height: 400px !important;\n  }\n  .h-md-425px {\n    height: 425px !important;\n  }\n  .h-md-450px {\n    height: 450px !important;\n  }\n  .h-md-475px {\n    height: 475px !important;\n  }\n  .h-md-500px {\n    height: 500px !important;\n  }\n  .h-md-550px {\n    height: 550px !important;\n  }\n  .h-md-600px {\n    height: 600px !important;\n  }\n  .h-md-650px {\n    height: 650px !important;\n  }\n  .h-md-700px {\n    height: 700px !important;\n  }\n  .h-md-750px {\n    height: 750px !important;\n  }\n  .h-md-800px {\n    height: 800px !important;\n  }\n  .h-md-850px {\n    height: 850px !important;\n  }\n  .h-md-900px {\n    height: 900px !important;\n  }\n  .h-md-950px {\n    height: 950px !important;\n  }\n  .h-md-1000px {\n    height: 1000px !important;\n  }\n  .mh-md-unset {\n    max-height: unset !important;\n  }\n  .mh-md-25 {\n    max-height: 25% !important;\n  }\n  .mh-md-50 {\n    max-height: 50% !important;\n  }\n  .mh-md-75 {\n    max-height: 75% !important;\n  }\n  .mh-md-100 {\n    max-height: 100% !important;\n  }\n  .mh-md-auto {\n    max-height: auto !important;\n  }\n  .mh-md-1px {\n    max-height: 1px !important;\n  }\n  .mh-md-2px {\n    max-height: 2px !important;\n  }\n  .mh-md-3px {\n    max-height: 3px !important;\n  }\n  .mh-md-4px {\n    max-height: 4px !important;\n  }\n  .mh-md-5px {\n    max-height: 5px !important;\n  }\n  .mh-md-6px {\n    max-height: 6px !important;\n  }\n  .mh-md-7px {\n    max-height: 7px !important;\n  }\n  .mh-md-8px {\n    max-height: 8px !important;\n  }\n  .mh-md-9px {\n    max-height: 9px !important;\n  }\n  .mh-md-10px {\n    max-height: 10px !important;\n  }\n  .mh-md-15px {\n    max-height: 15px !important;\n  }\n  .mh-md-20px {\n    max-height: 20px !important;\n  }\n  .mh-md-25px {\n    max-height: 25px !important;\n  }\n  .mh-md-30px {\n    max-height: 30px !important;\n  }\n  .mh-md-35px {\n    max-height: 35px !important;\n  }\n  .mh-md-40px {\n    max-height: 40px !important;\n  }\n  .mh-md-45px {\n    max-height: 45px !important;\n  }\n  .mh-md-50px {\n    max-height: 50px !important;\n  }\n  .mh-md-55px {\n    max-height: 55px !important;\n  }\n  .mh-md-60px {\n    max-height: 60px !important;\n  }\n  .mh-md-65px {\n    max-height: 65px !important;\n  }\n  .mh-md-70px {\n    max-height: 70px !important;\n  }\n  .mh-md-75px {\n    max-height: 75px !important;\n  }\n  .mh-md-80px {\n    max-height: 80px !important;\n  }\n  .mh-md-85px {\n    max-height: 85px !important;\n  }\n  .mh-md-90px {\n    max-height: 90px !important;\n  }\n  .mh-md-95px {\n    max-height: 95px !important;\n  }\n  .mh-md-100px {\n    max-height: 100px !important;\n  }\n  .mh-md-125px {\n    max-height: 125px !important;\n  }\n  .mh-md-150px {\n    max-height: 150px !important;\n  }\n  .mh-md-175px {\n    max-height: 175px !important;\n  }\n  .mh-md-200px {\n    max-height: 200px !important;\n  }\n  .mh-md-225px {\n    max-height: 225px !important;\n  }\n  .mh-md-250px {\n    max-height: 250px !important;\n  }\n  .mh-md-275px {\n    max-height: 275px !important;\n  }\n  .mh-md-300px {\n    max-height: 300px !important;\n  }\n  .mh-md-325px {\n    max-height: 325px !important;\n  }\n  .mh-md-350px {\n    max-height: 350px !important;\n  }\n  .mh-md-375px {\n    max-height: 375px !important;\n  }\n  .mh-md-400px {\n    max-height: 400px !important;\n  }\n  .mh-md-425px {\n    max-height: 425px !important;\n  }\n  .mh-md-450px {\n    max-height: 450px !important;\n  }\n  .mh-md-475px {\n    max-height: 475px !important;\n  }\n  .mh-md-500px {\n    max-height: 500px !important;\n  }\n  .mh-md-550px {\n    max-height: 550px !important;\n  }\n  .mh-md-600px {\n    max-height: 600px !important;\n  }\n  .mh-md-650px {\n    max-height: 650px !important;\n  }\n  .mh-md-700px {\n    max-height: 700px !important;\n  }\n  .mh-md-750px {\n    max-height: 750px !important;\n  }\n  .mh-md-800px {\n    max-height: 800px !important;\n  }\n  .mh-md-850px {\n    max-height: 850px !important;\n  }\n  .mh-md-900px {\n    max-height: 900px !important;\n  }\n  .mh-md-950px {\n    max-height: 950px !important;\n  }\n  .mh-md-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n  .order-md-first {\n    order: -1 !important;\n  }\n  .order-md-0 {\n    order: 0 !important;\n  }\n  .order-md-1 {\n    order: 1 !important;\n  }\n  .order-md-2 {\n    order: 2 !important;\n  }\n  .order-md-3 {\n    order: 3 !important;\n  }\n  .order-md-4 {\n    order: 4 !important;\n  }\n  .order-md-5 {\n    order: 5 !important;\n  }\n  .order-md-last {\n    order: 6 !important;\n  }\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 0.75rem !important;\n  }\n  .m-md-4 {\n    margin: 1rem !important;\n  }\n  .m-md-5 {\n    margin: 1.25rem !important;\n  }\n  .m-md-6 {\n    margin: 1.5rem !important;\n  }\n  .m-md-7 {\n    margin: 1.75rem !important;\n  }\n  .m-md-8 {\n    margin: 2rem !important;\n  }\n  .m-md-9 {\n    margin: 2.25rem !important;\n  }\n  .m-md-10 {\n    margin: 2.5rem !important;\n  }\n  .m-md-11 {\n    margin: 2.75rem !important;\n  }\n  .m-md-12 {\n    margin: 3rem !important;\n  }\n  .m-md-13 {\n    margin: 3.25rem !important;\n  }\n  .m-md-14 {\n    margin: 3.5rem !important;\n  }\n  .m-md-15 {\n    margin: 3.75rem !important;\n  }\n  .m-md-16 {\n    margin: 4rem !important;\n  }\n  .m-md-17 {\n    margin: 4.25rem !important;\n  }\n  .m-md-18 {\n    margin: 4.5rem !important;\n  }\n  .m-md-19 {\n    margin: 4.75rem !important;\n  }\n  .m-md-20 {\n    margin: 5rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-md-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-md-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-md-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-md-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-md-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-md-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-md-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-md-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-md-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-md-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-md-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-md-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-md-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-md-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-md-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-md-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-md-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-md-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-md-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-md-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-md-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-md-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-md-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-md-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-md-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-md-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-md-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-md-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-md-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-md-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-md-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-md-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-md-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-md-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-md-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-md-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-md-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-md-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-md-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-md-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-md-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-md-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-md-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-md-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-md-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-md-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-md-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-md-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-md-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-md-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-md-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-md-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-md-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-md-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-md-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-md-4 {\n    margin-right: 1rem !important;\n  }\n  .me-md-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-md-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-md-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-md-8 {\n    margin-right: 2rem !important;\n  }\n  .me-md-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-md-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-md-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-md-12 {\n    margin-right: 3rem !important;\n  }\n  .me-md-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-md-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-md-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-md-16 {\n    margin-right: 4rem !important;\n  }\n  .me-md-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-md-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-md-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-md-20 {\n    margin-right: 5rem !important;\n  }\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-md-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-md-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-md-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-md-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-md-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-md-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-md-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-md-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-md-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-md-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-md-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-md-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-md-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-md-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-md-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-md-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-md-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-md-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-md-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-md-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-md-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-md-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-md-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-md-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-md-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-md-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-md-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-md-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-md-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-md-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-md-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-md-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-md-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-md-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-md-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-md-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-md-n4 {\n    margin: -1rem !important;\n  }\n  .m-md-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-md-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-md-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-md-n8 {\n    margin: -2rem !important;\n  }\n  .m-md-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-md-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-md-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-md-n12 {\n    margin: -3rem !important;\n  }\n  .m-md-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-md-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-md-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-md-n16 {\n    margin: -4rem !important;\n  }\n  .m-md-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-md-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-md-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-md-n20 {\n    margin: -5rem !important;\n  }\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-md-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-md-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-md-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-md-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-md-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-md-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-md-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-md-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-md-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-md-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-md-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-md-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-md-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-md-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-md-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-md-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-md-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-md-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-md-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-md-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-md-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-md-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-md-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-md-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-md-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-md-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-md-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-md-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-md-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-md-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-md-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-md-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-md-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-md-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-md-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-md-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-md-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-md-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-md-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-md-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-md-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-md-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-md-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-md-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-md-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-md-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-md-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-md-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-md-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-md-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-md-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-md-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-md-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-md-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-md-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-md-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-md-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-md-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-md-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-md-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-md-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-md-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-md-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-md-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-md-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-md-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-md-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-md-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-md-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-md-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-md-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-md-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-md-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-md-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-md-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-md-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-md-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-md-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-md-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-md-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-md-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-md-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-md-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-md-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-md-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-md-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-md-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-md-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-md-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-md-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-md-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-md-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-md-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-md-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-md-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-md-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-md-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-md-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-md-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-md-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-md-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-md-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-md-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-md-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-md-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-md-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-md-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-md-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 0.75rem !important;\n  }\n  .p-md-4 {\n    padding: 1rem !important;\n  }\n  .p-md-5 {\n    padding: 1.25rem !important;\n  }\n  .p-md-6 {\n    padding: 1.5rem !important;\n  }\n  .p-md-7 {\n    padding: 1.75rem !important;\n  }\n  .p-md-8 {\n    padding: 2rem !important;\n  }\n  .p-md-9 {\n    padding: 2.25rem !important;\n  }\n  .p-md-10 {\n    padding: 2.5rem !important;\n  }\n  .p-md-11 {\n    padding: 2.75rem !important;\n  }\n  .p-md-12 {\n    padding: 3rem !important;\n  }\n  .p-md-13 {\n    padding: 3.25rem !important;\n  }\n  .p-md-14 {\n    padding: 3.5rem !important;\n  }\n  .p-md-15 {\n    padding: 3.75rem !important;\n  }\n  .p-md-16 {\n    padding: 4rem !important;\n  }\n  .p-md-17 {\n    padding: 4.25rem !important;\n  }\n  .p-md-18 {\n    padding: 4.5rem !important;\n  }\n  .p-md-19 {\n    padding: 4.75rem !important;\n  }\n  .p-md-20 {\n    padding: 5rem !important;\n  }\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-md-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-md-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-md-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-md-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-md-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-md-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-md-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-md-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-md-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-md-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-md-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-md-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-md-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-md-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-md-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-md-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-md-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-md-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-md-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-md-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-md-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-md-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-md-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-md-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-md-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-md-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-md-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-md-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-md-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-md-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-md-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-md-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-md-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-md-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-md-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-md-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-md-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-md-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-md-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-md-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-md-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-md-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-md-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-md-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-md-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-md-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-md-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-md-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-md-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-md-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-md-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-md-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-md-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-md-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-md-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-md-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-md-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-md-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-md-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-md-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-md-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-md-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-md-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-md-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-md-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-md-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-md-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-md-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-md-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-md-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-md-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-md-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-md-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-md-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-md-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-md-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-md-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-md-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-md-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-md-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-md-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-md-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-md-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-md-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-md-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-md-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-md-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-md-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-md-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-md-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-md-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-md-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-md-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-md-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-md-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-md-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-md-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-md-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-md-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-md-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-md-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-md-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-md-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-md-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-md-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-md-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-md-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-md-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-md-4 {\n    gap: 1rem !important;\n  }\n  .gap-md-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-md-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-md-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-md-8 {\n    gap: 2rem !important;\n  }\n  .gap-md-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-md-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-md-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-md-12 {\n    gap: 3rem !important;\n  }\n  .gap-md-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-md-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-md-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-md-16 {\n    gap: 4rem !important;\n  }\n  .gap-md-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-md-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-md-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-md-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-md-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-md-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-md-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-md-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-md-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-md-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-md-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-md-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-md-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-md-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-md-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-md-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-md-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-md-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-md-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-md-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-md-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-md-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-md-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-md-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-md-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-md-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-md-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-md-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-md-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-md-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-md-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-md-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-md-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-md-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-md-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-md-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-md-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-md-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-md-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-md-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-md-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-md-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-md-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-md-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-md-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-md-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-md-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-md-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-md-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-md-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-md-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-md-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-md-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-md-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-md-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-md-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-md-sm {\n    font-size: 0.95rem !important;\n  }\n  .fs-md-base {\n    font-size: 1rem !important;\n  }\n  .fs-md-lg {\n    font-size: 1.075rem !important;\n  }\n  .fs-md-xl {\n    font-size: 1.21rem !important;\n  }\n  .fs-md-fluid {\n    font-size: 100% !important;\n  }\n  .fs-md-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-md-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-md-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-md-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-md-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-md-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-md-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-md-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-md-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-md-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-md-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-md-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-md-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-md-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-md-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-md-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-md-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-md-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-md-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-md-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-md-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-md-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-md-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-md-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-md-start {\n    text-align: left !important;\n  }\n  .text-md-end {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n  .min-w-md-unset {\n    min-width: unset !important;\n  }\n  .min-w-md-25 {\n    min-width: 25% !important;\n  }\n  .min-w-md-50 {\n    min-width: 50% !important;\n  }\n  .min-w-md-75 {\n    min-width: 75% !important;\n  }\n  .min-w-md-100 {\n    min-width: 100% !important;\n  }\n  .min-w-md-auto {\n    min-width: auto !important;\n  }\n  .min-w-md-1px {\n    min-width: 1px !important;\n  }\n  .min-w-md-2px {\n    min-width: 2px !important;\n  }\n  .min-w-md-3px {\n    min-width: 3px !important;\n  }\n  .min-w-md-4px {\n    min-width: 4px !important;\n  }\n  .min-w-md-5px {\n    min-width: 5px !important;\n  }\n  .min-w-md-6px {\n    min-width: 6px !important;\n  }\n  .min-w-md-7px {\n    min-width: 7px !important;\n  }\n  .min-w-md-8px {\n    min-width: 8px !important;\n  }\n  .min-w-md-9px {\n    min-width: 9px !important;\n  }\n  .min-w-md-10px {\n    min-width: 10px !important;\n  }\n  .min-w-md-15px {\n    min-width: 15px !important;\n  }\n  .min-w-md-20px {\n    min-width: 20px !important;\n  }\n  .min-w-md-25px {\n    min-width: 25px !important;\n  }\n  .min-w-md-30px {\n    min-width: 30px !important;\n  }\n  .min-w-md-35px {\n    min-width: 35px !important;\n  }\n  .min-w-md-40px {\n    min-width: 40px !important;\n  }\n  .min-w-md-45px {\n    min-width: 45px !important;\n  }\n  .min-w-md-50px {\n    min-width: 50px !important;\n  }\n  .min-w-md-55px {\n    min-width: 55px !important;\n  }\n  .min-w-md-60px {\n    min-width: 60px !important;\n  }\n  .min-w-md-65px {\n    min-width: 65px !important;\n  }\n  .min-w-md-70px {\n    min-width: 70px !important;\n  }\n  .min-w-md-75px {\n    min-width: 75px !important;\n  }\n  .min-w-md-80px {\n    min-width: 80px !important;\n  }\n  .min-w-md-85px {\n    min-width: 85px !important;\n  }\n  .min-w-md-90px {\n    min-width: 90px !important;\n  }\n  .min-w-md-95px {\n    min-width: 95px !important;\n  }\n  .min-w-md-100px {\n    min-width: 100px !important;\n  }\n  .min-w-md-125px {\n    min-width: 125px !important;\n  }\n  .min-w-md-150px {\n    min-width: 150px !important;\n  }\n  .min-w-md-175px {\n    min-width: 175px !important;\n  }\n  .min-w-md-200px {\n    min-width: 200px !important;\n  }\n  .min-w-md-225px {\n    min-width: 225px !important;\n  }\n  .min-w-md-250px {\n    min-width: 250px !important;\n  }\n  .min-w-md-275px {\n    min-width: 275px !important;\n  }\n  .min-w-md-300px {\n    min-width: 300px !important;\n  }\n  .min-w-md-325px {\n    min-width: 325px !important;\n  }\n  .min-w-md-350px {\n    min-width: 350px !important;\n  }\n  .min-w-md-375px {\n    min-width: 375px !important;\n  }\n  .min-w-md-400px {\n    min-width: 400px !important;\n  }\n  .min-w-md-425px {\n    min-width: 425px !important;\n  }\n  .min-w-md-450px {\n    min-width: 450px !important;\n  }\n  .min-w-md-475px {\n    min-width: 475px !important;\n  }\n  .min-w-md-500px {\n    min-width: 500px !important;\n  }\n  .min-w-md-550px {\n    min-width: 550px !important;\n  }\n  .min-w-md-600px {\n    min-width: 600px !important;\n  }\n  .min-w-md-650px {\n    min-width: 650px !important;\n  }\n  .min-w-md-700px {\n    min-width: 700px !important;\n  }\n  .min-w-md-750px {\n    min-width: 750px !important;\n  }\n  .min-w-md-800px {\n    min-width: 800px !important;\n  }\n  .min-w-md-850px {\n    min-width: 850px !important;\n  }\n  .min-w-md-900px {\n    min-width: 900px !important;\n  }\n  .min-w-md-950px {\n    min-width: 950px !important;\n  }\n  .min-w-md-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-md-unset {\n    min-height: unset !important;\n  }\n  .min-h-md-25 {\n    min-height: 25% !important;\n  }\n  .min-h-md-50 {\n    min-height: 50% !important;\n  }\n  .min-h-md-75 {\n    min-height: 75% !important;\n  }\n  .min-h-md-100 {\n    min-height: 100% !important;\n  }\n  .min-h-md-auto {\n    min-height: auto !important;\n  }\n  .min-h-md-1px {\n    min-height: 1px !important;\n  }\n  .min-h-md-2px {\n    min-height: 2px !important;\n  }\n  .min-h-md-3px {\n    min-height: 3px !important;\n  }\n  .min-h-md-4px {\n    min-height: 4px !important;\n  }\n  .min-h-md-5px {\n    min-height: 5px !important;\n  }\n  .min-h-md-6px {\n    min-height: 6px !important;\n  }\n  .min-h-md-7px {\n    min-height: 7px !important;\n  }\n  .min-h-md-8px {\n    min-height: 8px !important;\n  }\n  .min-h-md-9px {\n    min-height: 9px !important;\n  }\n  .min-h-md-10px {\n    min-height: 10px !important;\n  }\n  .min-h-md-15px {\n    min-height: 15px !important;\n  }\n  .min-h-md-20px {\n    min-height: 20px !important;\n  }\n  .min-h-md-25px {\n    min-height: 25px !important;\n  }\n  .min-h-md-30px {\n    min-height: 30px !important;\n  }\n  .min-h-md-35px {\n    min-height: 35px !important;\n  }\n  .min-h-md-40px {\n    min-height: 40px !important;\n  }\n  .min-h-md-45px {\n    min-height: 45px !important;\n  }\n  .min-h-md-50px {\n    min-height: 50px !important;\n  }\n  .min-h-md-55px {\n    min-height: 55px !important;\n  }\n  .min-h-md-60px {\n    min-height: 60px !important;\n  }\n  .min-h-md-65px {\n    min-height: 65px !important;\n  }\n  .min-h-md-70px {\n    min-height: 70px !important;\n  }\n  .min-h-md-75px {\n    min-height: 75px !important;\n  }\n  .min-h-md-80px {\n    min-height: 80px !important;\n  }\n  .min-h-md-85px {\n    min-height: 85px !important;\n  }\n  .min-h-md-90px {\n    min-height: 90px !important;\n  }\n  .min-h-md-95px {\n    min-height: 95px !important;\n  }\n  .min-h-md-100px {\n    min-height: 100px !important;\n  }\n  .min-h-md-125px {\n    min-height: 125px !important;\n  }\n  .min-h-md-150px {\n    min-height: 150px !important;\n  }\n  .min-h-md-175px {\n    min-height: 175px !important;\n  }\n  .min-h-md-200px {\n    min-height: 200px !important;\n  }\n  .min-h-md-225px {\n    min-height: 225px !important;\n  }\n  .min-h-md-250px {\n    min-height: 250px !important;\n  }\n  .min-h-md-275px {\n    min-height: 275px !important;\n  }\n  .min-h-md-300px {\n    min-height: 300px !important;\n  }\n  .min-h-md-325px {\n    min-height: 325px !important;\n  }\n  .min-h-md-350px {\n    min-height: 350px !important;\n  }\n  .min-h-md-375px {\n    min-height: 375px !important;\n  }\n  .min-h-md-400px {\n    min-height: 400px !important;\n  }\n  .min-h-md-425px {\n    min-height: 425px !important;\n  }\n  .min-h-md-450px {\n    min-height: 450px !important;\n  }\n  .min-h-md-475px {\n    min-height: 475px !important;\n  }\n  .min-h-md-500px {\n    min-height: 500px !important;\n  }\n  .min-h-md-550px {\n    min-height: 550px !important;\n  }\n  .min-h-md-600px {\n    min-height: 600px !important;\n  }\n  .min-h-md-650px {\n    min-height: 650px !important;\n  }\n  .min-h-md-700px {\n    min-height: 700px !important;\n  }\n  .min-h-md-750px {\n    min-height: 750px !important;\n  }\n  .min-h-md-800px {\n    min-height: 800px !important;\n  }\n  .min-h-md-850px {\n    min-height: 850px !important;\n  }\n  .min-h-md-900px {\n    min-height: 900px !important;\n  }\n  .min-h-md-950px {\n    min-height: 950px !important;\n  }\n  .min-h-md-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n  .float-lg-end {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n  .object-fit-lg-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-lg-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-lg-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-lg-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-lg-none {\n    object-fit: none !important;\n  }\n  .overflow-lg-auto {\n    overflow: auto !important;\n  }\n  .overflow-lg-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-lg-visible {\n    overflow: visible !important;\n  }\n  .overflow-lg-scroll {\n    overflow: scroll !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-grid {\n    display: grid !important;\n  }\n  .d-lg-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-lg-none {\n    display: none !important;\n  }\n  .position-lg-static {\n    position: static !important;\n  }\n  .position-lg-relative {\n    position: relative !important;\n  }\n  .position-lg-absolute {\n    position: absolute !important;\n  }\n  .position-lg-fixed {\n    position: fixed !important;\n  }\n  .position-lg-sticky {\n    position: sticky !important;\n  }\n  .w-lg-unset {\n    width: unset !important;\n  }\n  .w-lg-25 {\n    width: 25% !important;\n  }\n  .w-lg-50 {\n    width: 50% !important;\n  }\n  .w-lg-75 {\n    width: 75% !important;\n  }\n  .w-lg-100 {\n    width: 100% !important;\n  }\n  .w-lg-auto {\n    width: auto !important;\n  }\n  .w-lg-1px {\n    width: 1px !important;\n  }\n  .w-lg-2px {\n    width: 2px !important;\n  }\n  .w-lg-3px {\n    width: 3px !important;\n  }\n  .w-lg-4px {\n    width: 4px !important;\n  }\n  .w-lg-5px {\n    width: 5px !important;\n  }\n  .w-lg-6px {\n    width: 6px !important;\n  }\n  .w-lg-7px {\n    width: 7px !important;\n  }\n  .w-lg-8px {\n    width: 8px !important;\n  }\n  .w-lg-9px {\n    width: 9px !important;\n  }\n  .w-lg-10px {\n    width: 10px !important;\n  }\n  .w-lg-15px {\n    width: 15px !important;\n  }\n  .w-lg-20px {\n    width: 20px !important;\n  }\n  .w-lg-25px {\n    width: 25px !important;\n  }\n  .w-lg-30px {\n    width: 30px !important;\n  }\n  .w-lg-35px {\n    width: 35px !important;\n  }\n  .w-lg-40px {\n    width: 40px !important;\n  }\n  .w-lg-45px {\n    width: 45px !important;\n  }\n  .w-lg-50px {\n    width: 50px !important;\n  }\n  .w-lg-55px {\n    width: 55px !important;\n  }\n  .w-lg-60px {\n    width: 60px !important;\n  }\n  .w-lg-65px {\n    width: 65px !important;\n  }\n  .w-lg-70px {\n    width: 70px !important;\n  }\n  .w-lg-75px {\n    width: 75px !important;\n  }\n  .w-lg-80px {\n    width: 80px !important;\n  }\n  .w-lg-85px {\n    width: 85px !important;\n  }\n  .w-lg-90px {\n    width: 90px !important;\n  }\n  .w-lg-95px {\n    width: 95px !important;\n  }\n  .w-lg-100px {\n    width: 100px !important;\n  }\n  .w-lg-125px {\n    width: 125px !important;\n  }\n  .w-lg-150px {\n    width: 150px !important;\n  }\n  .w-lg-175px {\n    width: 175px !important;\n  }\n  .w-lg-200px {\n    width: 200px !important;\n  }\n  .w-lg-225px {\n    width: 225px !important;\n  }\n  .w-lg-250px {\n    width: 250px !important;\n  }\n  .w-lg-275px {\n    width: 275px !important;\n  }\n  .w-lg-300px {\n    width: 300px !important;\n  }\n  .w-lg-325px {\n    width: 325px !important;\n  }\n  .w-lg-350px {\n    width: 350px !important;\n  }\n  .w-lg-375px {\n    width: 375px !important;\n  }\n  .w-lg-400px {\n    width: 400px !important;\n  }\n  .w-lg-425px {\n    width: 425px !important;\n  }\n  .w-lg-450px {\n    width: 450px !important;\n  }\n  .w-lg-475px {\n    width: 475px !important;\n  }\n  .w-lg-500px {\n    width: 500px !important;\n  }\n  .w-lg-550px {\n    width: 550px !important;\n  }\n  .w-lg-600px {\n    width: 600px !important;\n  }\n  .w-lg-650px {\n    width: 650px !important;\n  }\n  .w-lg-700px {\n    width: 700px !important;\n  }\n  .w-lg-750px {\n    width: 750px !important;\n  }\n  .w-lg-800px {\n    width: 800px !important;\n  }\n  .w-lg-850px {\n    width: 850px !important;\n  }\n  .w-lg-900px {\n    width: 900px !important;\n  }\n  .w-lg-950px {\n    width: 950px !important;\n  }\n  .w-lg-1000px {\n    width: 1000px !important;\n  }\n  .mw-lg-unset {\n    max-width: unset !important;\n  }\n  .mw-lg-25 {\n    max-width: 25% !important;\n  }\n  .mw-lg-50 {\n    max-width: 50% !important;\n  }\n  .mw-lg-75 {\n    max-width: 75% !important;\n  }\n  .mw-lg-100 {\n    max-width: 100% !important;\n  }\n  .mw-lg-auto {\n    max-width: auto !important;\n  }\n  .mw-lg-1px {\n    max-width: 1px !important;\n  }\n  .mw-lg-2px {\n    max-width: 2px !important;\n  }\n  .mw-lg-3px {\n    max-width: 3px !important;\n  }\n  .mw-lg-4px {\n    max-width: 4px !important;\n  }\n  .mw-lg-5px {\n    max-width: 5px !important;\n  }\n  .mw-lg-6px {\n    max-width: 6px !important;\n  }\n  .mw-lg-7px {\n    max-width: 7px !important;\n  }\n  .mw-lg-8px {\n    max-width: 8px !important;\n  }\n  .mw-lg-9px {\n    max-width: 9px !important;\n  }\n  .mw-lg-10px {\n    max-width: 10px !important;\n  }\n  .mw-lg-15px {\n    max-width: 15px !important;\n  }\n  .mw-lg-20px {\n    max-width: 20px !important;\n  }\n  .mw-lg-25px {\n    max-width: 25px !important;\n  }\n  .mw-lg-30px {\n    max-width: 30px !important;\n  }\n  .mw-lg-35px {\n    max-width: 35px !important;\n  }\n  .mw-lg-40px {\n    max-width: 40px !important;\n  }\n  .mw-lg-45px {\n    max-width: 45px !important;\n  }\n  .mw-lg-50px {\n    max-width: 50px !important;\n  }\n  .mw-lg-55px {\n    max-width: 55px !important;\n  }\n  .mw-lg-60px {\n    max-width: 60px !important;\n  }\n  .mw-lg-65px {\n    max-width: 65px !important;\n  }\n  .mw-lg-70px {\n    max-width: 70px !important;\n  }\n  .mw-lg-75px {\n    max-width: 75px !important;\n  }\n  .mw-lg-80px {\n    max-width: 80px !important;\n  }\n  .mw-lg-85px {\n    max-width: 85px !important;\n  }\n  .mw-lg-90px {\n    max-width: 90px !important;\n  }\n  .mw-lg-95px {\n    max-width: 95px !important;\n  }\n  .mw-lg-100px {\n    max-width: 100px !important;\n  }\n  .mw-lg-125px {\n    max-width: 125px !important;\n  }\n  .mw-lg-150px {\n    max-width: 150px !important;\n  }\n  .mw-lg-175px {\n    max-width: 175px !important;\n  }\n  .mw-lg-200px {\n    max-width: 200px !important;\n  }\n  .mw-lg-225px {\n    max-width: 225px !important;\n  }\n  .mw-lg-250px {\n    max-width: 250px !important;\n  }\n  .mw-lg-275px {\n    max-width: 275px !important;\n  }\n  .mw-lg-300px {\n    max-width: 300px !important;\n  }\n  .mw-lg-325px {\n    max-width: 325px !important;\n  }\n  .mw-lg-350px {\n    max-width: 350px !important;\n  }\n  .mw-lg-375px {\n    max-width: 375px !important;\n  }\n  .mw-lg-400px {\n    max-width: 400px !important;\n  }\n  .mw-lg-425px {\n    max-width: 425px !important;\n  }\n  .mw-lg-450px {\n    max-width: 450px !important;\n  }\n  .mw-lg-475px {\n    max-width: 475px !important;\n  }\n  .mw-lg-500px {\n    max-width: 500px !important;\n  }\n  .mw-lg-550px {\n    max-width: 550px !important;\n  }\n  .mw-lg-600px {\n    max-width: 600px !important;\n  }\n  .mw-lg-650px {\n    max-width: 650px !important;\n  }\n  .mw-lg-700px {\n    max-width: 700px !important;\n  }\n  .mw-lg-750px {\n    max-width: 750px !important;\n  }\n  .mw-lg-800px {\n    max-width: 800px !important;\n  }\n  .mw-lg-850px {\n    max-width: 850px !important;\n  }\n  .mw-lg-900px {\n    max-width: 900px !important;\n  }\n  .mw-lg-950px {\n    max-width: 950px !important;\n  }\n  .mw-lg-1000px {\n    max-width: 1000px !important;\n  }\n  .h-lg-unset {\n    height: unset !important;\n  }\n  .h-lg-25 {\n    height: 25% !important;\n  }\n  .h-lg-50 {\n    height: 50% !important;\n  }\n  .h-lg-75 {\n    height: 75% !important;\n  }\n  .h-lg-100 {\n    height: 100% !important;\n  }\n  .h-lg-auto {\n    height: auto !important;\n  }\n  .h-lg-1px {\n    height: 1px !important;\n  }\n  .h-lg-2px {\n    height: 2px !important;\n  }\n  .h-lg-3px {\n    height: 3px !important;\n  }\n  .h-lg-4px {\n    height: 4px !important;\n  }\n  .h-lg-5px {\n    height: 5px !important;\n  }\n  .h-lg-6px {\n    height: 6px !important;\n  }\n  .h-lg-7px {\n    height: 7px !important;\n  }\n  .h-lg-8px {\n    height: 8px !important;\n  }\n  .h-lg-9px {\n    height: 9px !important;\n  }\n  .h-lg-10px {\n    height: 10px !important;\n  }\n  .h-lg-15px {\n    height: 15px !important;\n  }\n  .h-lg-20px {\n    height: 20px !important;\n  }\n  .h-lg-25px {\n    height: 25px !important;\n  }\n  .h-lg-30px {\n    height: 30px !important;\n  }\n  .h-lg-35px {\n    height: 35px !important;\n  }\n  .h-lg-40px {\n    height: 40px !important;\n  }\n  .h-lg-45px {\n    height: 45px !important;\n  }\n  .h-lg-50px {\n    height: 50px !important;\n  }\n  .h-lg-55px {\n    height: 55px !important;\n  }\n  .h-lg-60px {\n    height: 60px !important;\n  }\n  .h-lg-65px {\n    height: 65px !important;\n  }\n  .h-lg-70px {\n    height: 70px !important;\n  }\n  .h-lg-75px {\n    height: 75px !important;\n  }\n  .h-lg-80px {\n    height: 80px !important;\n  }\n  .h-lg-85px {\n    height: 85px !important;\n  }\n  .h-lg-90px {\n    height: 90px !important;\n  }\n  .h-lg-95px {\n    height: 95px !important;\n  }\n  .h-lg-100px {\n    height: 100px !important;\n  }\n  .h-lg-125px {\n    height: 125px !important;\n  }\n  .h-lg-150px {\n    height: 150px !important;\n  }\n  .h-lg-175px {\n    height: 175px !important;\n  }\n  .h-lg-200px {\n    height: 200px !important;\n  }\n  .h-lg-225px {\n    height: 225px !important;\n  }\n  .h-lg-250px {\n    height: 250px !important;\n  }\n  .h-lg-275px {\n    height: 275px !important;\n  }\n  .h-lg-300px {\n    height: 300px !important;\n  }\n  .h-lg-325px {\n    height: 325px !important;\n  }\n  .h-lg-350px {\n    height: 350px !important;\n  }\n  .h-lg-375px {\n    height: 375px !important;\n  }\n  .h-lg-400px {\n    height: 400px !important;\n  }\n  .h-lg-425px {\n    height: 425px !important;\n  }\n  .h-lg-450px {\n    height: 450px !important;\n  }\n  .h-lg-475px {\n    height: 475px !important;\n  }\n  .h-lg-500px {\n    height: 500px !important;\n  }\n  .h-lg-550px {\n    height: 550px !important;\n  }\n  .h-lg-600px {\n    height: 600px !important;\n  }\n  .h-lg-650px {\n    height: 650px !important;\n  }\n  .h-lg-700px {\n    height: 700px !important;\n  }\n  .h-lg-750px {\n    height: 750px !important;\n  }\n  .h-lg-800px {\n    height: 800px !important;\n  }\n  .h-lg-850px {\n    height: 850px !important;\n  }\n  .h-lg-900px {\n    height: 900px !important;\n  }\n  .h-lg-950px {\n    height: 950px !important;\n  }\n  .h-lg-1000px {\n    height: 1000px !important;\n  }\n  .mh-lg-unset {\n    max-height: unset !important;\n  }\n  .mh-lg-25 {\n    max-height: 25% !important;\n  }\n  .mh-lg-50 {\n    max-height: 50% !important;\n  }\n  .mh-lg-75 {\n    max-height: 75% !important;\n  }\n  .mh-lg-100 {\n    max-height: 100% !important;\n  }\n  .mh-lg-auto {\n    max-height: auto !important;\n  }\n  .mh-lg-1px {\n    max-height: 1px !important;\n  }\n  .mh-lg-2px {\n    max-height: 2px !important;\n  }\n  .mh-lg-3px {\n    max-height: 3px !important;\n  }\n  .mh-lg-4px {\n    max-height: 4px !important;\n  }\n  .mh-lg-5px {\n    max-height: 5px !important;\n  }\n  .mh-lg-6px {\n    max-height: 6px !important;\n  }\n  .mh-lg-7px {\n    max-height: 7px !important;\n  }\n  .mh-lg-8px {\n    max-height: 8px !important;\n  }\n  .mh-lg-9px {\n    max-height: 9px !important;\n  }\n  .mh-lg-10px {\n    max-height: 10px !important;\n  }\n  .mh-lg-15px {\n    max-height: 15px !important;\n  }\n  .mh-lg-20px {\n    max-height: 20px !important;\n  }\n  .mh-lg-25px {\n    max-height: 25px !important;\n  }\n  .mh-lg-30px {\n    max-height: 30px !important;\n  }\n  .mh-lg-35px {\n    max-height: 35px !important;\n  }\n  .mh-lg-40px {\n    max-height: 40px !important;\n  }\n  .mh-lg-45px {\n    max-height: 45px !important;\n  }\n  .mh-lg-50px {\n    max-height: 50px !important;\n  }\n  .mh-lg-55px {\n    max-height: 55px !important;\n  }\n  .mh-lg-60px {\n    max-height: 60px !important;\n  }\n  .mh-lg-65px {\n    max-height: 65px !important;\n  }\n  .mh-lg-70px {\n    max-height: 70px !important;\n  }\n  .mh-lg-75px {\n    max-height: 75px !important;\n  }\n  .mh-lg-80px {\n    max-height: 80px !important;\n  }\n  .mh-lg-85px {\n    max-height: 85px !important;\n  }\n  .mh-lg-90px {\n    max-height: 90px !important;\n  }\n  .mh-lg-95px {\n    max-height: 95px !important;\n  }\n  .mh-lg-100px {\n    max-height: 100px !important;\n  }\n  .mh-lg-125px {\n    max-height: 125px !important;\n  }\n  .mh-lg-150px {\n    max-height: 150px !important;\n  }\n  .mh-lg-175px {\n    max-height: 175px !important;\n  }\n  .mh-lg-200px {\n    max-height: 200px !important;\n  }\n  .mh-lg-225px {\n    max-height: 225px !important;\n  }\n  .mh-lg-250px {\n    max-height: 250px !important;\n  }\n  .mh-lg-275px {\n    max-height: 275px !important;\n  }\n  .mh-lg-300px {\n    max-height: 300px !important;\n  }\n  .mh-lg-325px {\n    max-height: 325px !important;\n  }\n  .mh-lg-350px {\n    max-height: 350px !important;\n  }\n  .mh-lg-375px {\n    max-height: 375px !important;\n  }\n  .mh-lg-400px {\n    max-height: 400px !important;\n  }\n  .mh-lg-425px {\n    max-height: 425px !important;\n  }\n  .mh-lg-450px {\n    max-height: 450px !important;\n  }\n  .mh-lg-475px {\n    max-height: 475px !important;\n  }\n  .mh-lg-500px {\n    max-height: 500px !important;\n  }\n  .mh-lg-550px {\n    max-height: 550px !important;\n  }\n  .mh-lg-600px {\n    max-height: 600px !important;\n  }\n  .mh-lg-650px {\n    max-height: 650px !important;\n  }\n  .mh-lg-700px {\n    max-height: 700px !important;\n  }\n  .mh-lg-750px {\n    max-height: 750px !important;\n  }\n  .mh-lg-800px {\n    max-height: 800px !important;\n  }\n  .mh-lg-850px {\n    max-height: 850px !important;\n  }\n  .mh-lg-900px {\n    max-height: 900px !important;\n  }\n  .mh-lg-950px {\n    max-height: 950px !important;\n  }\n  .mh-lg-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n  .order-lg-first {\n    order: -1 !important;\n  }\n  .order-lg-0 {\n    order: 0 !important;\n  }\n  .order-lg-1 {\n    order: 1 !important;\n  }\n  .order-lg-2 {\n    order: 2 !important;\n  }\n  .order-lg-3 {\n    order: 3 !important;\n  }\n  .order-lg-4 {\n    order: 4 !important;\n  }\n  .order-lg-5 {\n    order: 5 !important;\n  }\n  .order-lg-last {\n    order: 6 !important;\n  }\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 0.75rem !important;\n  }\n  .m-lg-4 {\n    margin: 1rem !important;\n  }\n  .m-lg-5 {\n    margin: 1.25rem !important;\n  }\n  .m-lg-6 {\n    margin: 1.5rem !important;\n  }\n  .m-lg-7 {\n    margin: 1.75rem !important;\n  }\n  .m-lg-8 {\n    margin: 2rem !important;\n  }\n  .m-lg-9 {\n    margin: 2.25rem !important;\n  }\n  .m-lg-10 {\n    margin: 2.5rem !important;\n  }\n  .m-lg-11 {\n    margin: 2.75rem !important;\n  }\n  .m-lg-12 {\n    margin: 3rem !important;\n  }\n  .m-lg-13 {\n    margin: 3.25rem !important;\n  }\n  .m-lg-14 {\n    margin: 3.5rem !important;\n  }\n  .m-lg-15 {\n    margin: 3.75rem !important;\n  }\n  .m-lg-16 {\n    margin: 4rem !important;\n  }\n  .m-lg-17 {\n    margin: 4.25rem !important;\n  }\n  .m-lg-18 {\n    margin: 4.5rem !important;\n  }\n  .m-lg-19 {\n    margin: 4.75rem !important;\n  }\n  .m-lg-20 {\n    margin: 5rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-lg-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-lg-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-lg-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-lg-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-lg-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-lg-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-lg-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-lg-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-lg-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-lg-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-lg-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-lg-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-lg-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-lg-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-lg-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-lg-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-lg-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-lg-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-lg-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-lg-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-lg-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-lg-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-lg-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-lg-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-lg-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-lg-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-lg-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-lg-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-lg-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-lg-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-lg-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-lg-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-lg-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-lg-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-lg-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-lg-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-lg-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-lg-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-lg-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-lg-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-lg-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-lg-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-lg-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-lg-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-lg-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-lg-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-lg-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-lg-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-lg-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-lg-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-lg-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-lg-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-lg-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-lg-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-lg-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-lg-4 {\n    margin-right: 1rem !important;\n  }\n  .me-lg-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-lg-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-lg-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-lg-8 {\n    margin-right: 2rem !important;\n  }\n  .me-lg-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-lg-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-lg-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-lg-12 {\n    margin-right: 3rem !important;\n  }\n  .me-lg-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-lg-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-lg-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-lg-16 {\n    margin-right: 4rem !important;\n  }\n  .me-lg-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-lg-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-lg-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-lg-20 {\n    margin-right: 5rem !important;\n  }\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-lg-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-lg-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-lg-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-lg-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-lg-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-lg-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-lg-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-lg-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-lg-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-lg-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-lg-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-lg-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-lg-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-lg-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-lg-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-lg-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-lg-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-lg-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-lg-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-lg-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-lg-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-lg-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-lg-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-lg-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-lg-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-lg-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-lg-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-lg-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-lg-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-lg-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-lg-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-lg-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-lg-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-lg-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-lg-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-lg-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1rem !important;\n  }\n  .m-lg-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-lg-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-lg-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-lg-n8 {\n    margin: -2rem !important;\n  }\n  .m-lg-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-lg-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-lg-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-lg-n12 {\n    margin: -3rem !important;\n  }\n  .m-lg-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-lg-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-lg-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-lg-n16 {\n    margin: -4rem !important;\n  }\n  .m-lg-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-lg-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-lg-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-lg-n20 {\n    margin: -5rem !important;\n  }\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-lg-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-lg-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-lg-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-lg-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-lg-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-lg-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-lg-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-lg-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-lg-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-lg-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-lg-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-lg-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-lg-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-lg-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-lg-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-lg-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-lg-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-lg-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-lg-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-lg-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-lg-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-lg-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-lg-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-lg-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-lg-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-lg-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-lg-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-lg-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-lg-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-lg-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-lg-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-lg-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-lg-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-lg-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-lg-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-lg-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-lg-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-lg-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-lg-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-lg-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-lg-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-lg-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-lg-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-lg-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-lg-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-lg-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-lg-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-lg-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-lg-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-lg-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-lg-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-lg-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-lg-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-lg-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-lg-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-lg-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-lg-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-lg-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-lg-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-lg-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-lg-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-lg-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-lg-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-lg-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-lg-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-lg-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-lg-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-lg-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-lg-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-lg-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-lg-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-lg-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-lg-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-lg-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-lg-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-lg-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-lg-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-lg-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-lg-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-lg-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-lg-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-lg-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-lg-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-lg-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-lg-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-lg-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-lg-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-lg-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-lg-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-lg-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-lg-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-lg-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-lg-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-lg-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-lg-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-lg-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-lg-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-lg-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-lg-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-lg-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-lg-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-lg-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-lg-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-lg-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-lg-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-lg-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-lg-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-lg-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 0.75rem !important;\n  }\n  .p-lg-4 {\n    padding: 1rem !important;\n  }\n  .p-lg-5 {\n    padding: 1.25rem !important;\n  }\n  .p-lg-6 {\n    padding: 1.5rem !important;\n  }\n  .p-lg-7 {\n    padding: 1.75rem !important;\n  }\n  .p-lg-8 {\n    padding: 2rem !important;\n  }\n  .p-lg-9 {\n    padding: 2.25rem !important;\n  }\n  .p-lg-10 {\n    padding: 2.5rem !important;\n  }\n  .p-lg-11 {\n    padding: 2.75rem !important;\n  }\n  .p-lg-12 {\n    padding: 3rem !important;\n  }\n  .p-lg-13 {\n    padding: 3.25rem !important;\n  }\n  .p-lg-14 {\n    padding: 3.5rem !important;\n  }\n  .p-lg-15 {\n    padding: 3.75rem !important;\n  }\n  .p-lg-16 {\n    padding: 4rem !important;\n  }\n  .p-lg-17 {\n    padding: 4.25rem !important;\n  }\n  .p-lg-18 {\n    padding: 4.5rem !important;\n  }\n  .p-lg-19 {\n    padding: 4.75rem !important;\n  }\n  .p-lg-20 {\n    padding: 5rem !important;\n  }\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-lg-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-lg-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-lg-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-lg-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-lg-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-lg-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-lg-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-lg-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-lg-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-lg-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-lg-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-lg-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-lg-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-lg-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-lg-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-lg-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-lg-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-lg-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-lg-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-lg-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-lg-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-lg-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-lg-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-lg-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-lg-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-lg-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-lg-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-lg-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-lg-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-lg-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-lg-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-lg-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-lg-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-lg-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-lg-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-lg-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-lg-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-lg-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-lg-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-lg-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-lg-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-lg-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-lg-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-lg-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-lg-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-lg-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-lg-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-lg-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-lg-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-lg-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-lg-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-lg-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-lg-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-lg-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-lg-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-lg-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-lg-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-lg-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-lg-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-lg-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-lg-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-lg-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-lg-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-lg-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-lg-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-lg-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-lg-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-lg-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-lg-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-lg-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-lg-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-lg-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-lg-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-lg-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-lg-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-lg-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-lg-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-lg-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-lg-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-lg-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-lg-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-lg-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-lg-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-lg-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-lg-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-lg-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-lg-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-lg-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-lg-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-lg-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-lg-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-lg-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-lg-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-lg-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-lg-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-lg-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-lg-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-lg-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-lg-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-lg-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-lg-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-lg-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-lg-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-lg-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-lg-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-lg-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-lg-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-lg-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-lg-4 {\n    gap: 1rem !important;\n  }\n  .gap-lg-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-lg-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-lg-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-lg-8 {\n    gap: 2rem !important;\n  }\n  .gap-lg-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-lg-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-lg-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-lg-12 {\n    gap: 3rem !important;\n  }\n  .gap-lg-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-lg-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-lg-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-lg-16 {\n    gap: 4rem !important;\n  }\n  .gap-lg-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-lg-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-lg-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-lg-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-lg-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-lg-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-lg-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-lg-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-lg-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-lg-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-lg-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-lg-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-lg-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-lg-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-lg-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-lg-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-lg-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-lg-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-lg-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-lg-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-lg-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-lg-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-lg-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-lg-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-lg-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-lg-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-lg-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-lg-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-lg-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-lg-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-lg-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-lg-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-lg-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-lg-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-lg-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-lg-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-lg-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-lg-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-lg-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-lg-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-lg-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-lg-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-lg-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-lg-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-lg-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-lg-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-lg-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-lg-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-lg-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-lg-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-lg-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-lg-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-lg-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-lg-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-lg-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-lg-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-lg-sm {\n    font-size: 0.95rem !important;\n  }\n  .fs-lg-base {\n    font-size: 1rem !important;\n  }\n  .fs-lg-lg {\n    font-size: 1.075rem !important;\n  }\n  .fs-lg-xl {\n    font-size: 1.21rem !important;\n  }\n  .fs-lg-fluid {\n    font-size: 100% !important;\n  }\n  .fs-lg-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-lg-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-lg-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-lg-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-lg-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-lg-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-lg-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-lg-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-lg-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-lg-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-lg-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-lg-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-lg-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-lg-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-lg-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-lg-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-lg-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-lg-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-lg-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-lg-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-lg-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-lg-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-lg-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-lg-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-lg-start {\n    text-align: left !important;\n  }\n  .text-lg-end {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n  .min-w-lg-unset {\n    min-width: unset !important;\n  }\n  .min-w-lg-25 {\n    min-width: 25% !important;\n  }\n  .min-w-lg-50 {\n    min-width: 50% !important;\n  }\n  .min-w-lg-75 {\n    min-width: 75% !important;\n  }\n  .min-w-lg-100 {\n    min-width: 100% !important;\n  }\n  .min-w-lg-auto {\n    min-width: auto !important;\n  }\n  .min-w-lg-1px {\n    min-width: 1px !important;\n  }\n  .min-w-lg-2px {\n    min-width: 2px !important;\n  }\n  .min-w-lg-3px {\n    min-width: 3px !important;\n  }\n  .min-w-lg-4px {\n    min-width: 4px !important;\n  }\n  .min-w-lg-5px {\n    min-width: 5px !important;\n  }\n  .min-w-lg-6px {\n    min-width: 6px !important;\n  }\n  .min-w-lg-7px {\n    min-width: 7px !important;\n  }\n  .min-w-lg-8px {\n    min-width: 8px !important;\n  }\n  .min-w-lg-9px {\n    min-width: 9px !important;\n  }\n  .min-w-lg-10px {\n    min-width: 10px !important;\n  }\n  .min-w-lg-15px {\n    min-width: 15px !important;\n  }\n  .min-w-lg-20px {\n    min-width: 20px !important;\n  }\n  .min-w-lg-25px {\n    min-width: 25px !important;\n  }\n  .min-w-lg-30px {\n    min-width: 30px !important;\n  }\n  .min-w-lg-35px {\n    min-width: 35px !important;\n  }\n  .min-w-lg-40px {\n    min-width: 40px !important;\n  }\n  .min-w-lg-45px {\n    min-width: 45px !important;\n  }\n  .min-w-lg-50px {\n    min-width: 50px !important;\n  }\n  .min-w-lg-55px {\n    min-width: 55px !important;\n  }\n  .min-w-lg-60px {\n    min-width: 60px !important;\n  }\n  .min-w-lg-65px {\n    min-width: 65px !important;\n  }\n  .min-w-lg-70px {\n    min-width: 70px !important;\n  }\n  .min-w-lg-75px {\n    min-width: 75px !important;\n  }\n  .min-w-lg-80px {\n    min-width: 80px !important;\n  }\n  .min-w-lg-85px {\n    min-width: 85px !important;\n  }\n  .min-w-lg-90px {\n    min-width: 90px !important;\n  }\n  .min-w-lg-95px {\n    min-width: 95px !important;\n  }\n  .min-w-lg-100px {\n    min-width: 100px !important;\n  }\n  .min-w-lg-125px {\n    min-width: 125px !important;\n  }\n  .min-w-lg-150px {\n    min-width: 150px !important;\n  }\n  .min-w-lg-175px {\n    min-width: 175px !important;\n  }\n  .min-w-lg-200px {\n    min-width: 200px !important;\n  }\n  .min-w-lg-225px {\n    min-width: 225px !important;\n  }\n  .min-w-lg-250px {\n    min-width: 250px !important;\n  }\n  .min-w-lg-275px {\n    min-width: 275px !important;\n  }\n  .min-w-lg-300px {\n    min-width: 300px !important;\n  }\n  .min-w-lg-325px {\n    min-width: 325px !important;\n  }\n  .min-w-lg-350px {\n    min-width: 350px !important;\n  }\n  .min-w-lg-375px {\n    min-width: 375px !important;\n  }\n  .min-w-lg-400px {\n    min-width: 400px !important;\n  }\n  .min-w-lg-425px {\n    min-width: 425px !important;\n  }\n  .min-w-lg-450px {\n    min-width: 450px !important;\n  }\n  .min-w-lg-475px {\n    min-width: 475px !important;\n  }\n  .min-w-lg-500px {\n    min-width: 500px !important;\n  }\n  .min-w-lg-550px {\n    min-width: 550px !important;\n  }\n  .min-w-lg-600px {\n    min-width: 600px !important;\n  }\n  .min-w-lg-650px {\n    min-width: 650px !important;\n  }\n  .min-w-lg-700px {\n    min-width: 700px !important;\n  }\n  .min-w-lg-750px {\n    min-width: 750px !important;\n  }\n  .min-w-lg-800px {\n    min-width: 800px !important;\n  }\n  .min-w-lg-850px {\n    min-width: 850px !important;\n  }\n  .min-w-lg-900px {\n    min-width: 900px !important;\n  }\n  .min-w-lg-950px {\n    min-width: 950px !important;\n  }\n  .min-w-lg-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-lg-unset {\n    min-height: unset !important;\n  }\n  .min-h-lg-25 {\n    min-height: 25% !important;\n  }\n  .min-h-lg-50 {\n    min-height: 50% !important;\n  }\n  .min-h-lg-75 {\n    min-height: 75% !important;\n  }\n  .min-h-lg-100 {\n    min-height: 100% !important;\n  }\n  .min-h-lg-auto {\n    min-height: auto !important;\n  }\n  .min-h-lg-1px {\n    min-height: 1px !important;\n  }\n  .min-h-lg-2px {\n    min-height: 2px !important;\n  }\n  .min-h-lg-3px {\n    min-height: 3px !important;\n  }\n  .min-h-lg-4px {\n    min-height: 4px !important;\n  }\n  .min-h-lg-5px {\n    min-height: 5px !important;\n  }\n  .min-h-lg-6px {\n    min-height: 6px !important;\n  }\n  .min-h-lg-7px {\n    min-height: 7px !important;\n  }\n  .min-h-lg-8px {\n    min-height: 8px !important;\n  }\n  .min-h-lg-9px {\n    min-height: 9px !important;\n  }\n  .min-h-lg-10px {\n    min-height: 10px !important;\n  }\n  .min-h-lg-15px {\n    min-height: 15px !important;\n  }\n  .min-h-lg-20px {\n    min-height: 20px !important;\n  }\n  .min-h-lg-25px {\n    min-height: 25px !important;\n  }\n  .min-h-lg-30px {\n    min-height: 30px !important;\n  }\n  .min-h-lg-35px {\n    min-height: 35px !important;\n  }\n  .min-h-lg-40px {\n    min-height: 40px !important;\n  }\n  .min-h-lg-45px {\n    min-height: 45px !important;\n  }\n  .min-h-lg-50px {\n    min-height: 50px !important;\n  }\n  .min-h-lg-55px {\n    min-height: 55px !important;\n  }\n  .min-h-lg-60px {\n    min-height: 60px !important;\n  }\n  .min-h-lg-65px {\n    min-height: 65px !important;\n  }\n  .min-h-lg-70px {\n    min-height: 70px !important;\n  }\n  .min-h-lg-75px {\n    min-height: 75px !important;\n  }\n  .min-h-lg-80px {\n    min-height: 80px !important;\n  }\n  .min-h-lg-85px {\n    min-height: 85px !important;\n  }\n  .min-h-lg-90px {\n    min-height: 90px !important;\n  }\n  .min-h-lg-95px {\n    min-height: 95px !important;\n  }\n  .min-h-lg-100px {\n    min-height: 100px !important;\n  }\n  .min-h-lg-125px {\n    min-height: 125px !important;\n  }\n  .min-h-lg-150px {\n    min-height: 150px !important;\n  }\n  .min-h-lg-175px {\n    min-height: 175px !important;\n  }\n  .min-h-lg-200px {\n    min-height: 200px !important;\n  }\n  .min-h-lg-225px {\n    min-height: 225px !important;\n  }\n  .min-h-lg-250px {\n    min-height: 250px !important;\n  }\n  .min-h-lg-275px {\n    min-height: 275px !important;\n  }\n  .min-h-lg-300px {\n    min-height: 300px !important;\n  }\n  .min-h-lg-325px {\n    min-height: 325px !important;\n  }\n  .min-h-lg-350px {\n    min-height: 350px !important;\n  }\n  .min-h-lg-375px {\n    min-height: 375px !important;\n  }\n  .min-h-lg-400px {\n    min-height: 400px !important;\n  }\n  .min-h-lg-425px {\n    min-height: 425px !important;\n  }\n  .min-h-lg-450px {\n    min-height: 450px !important;\n  }\n  .min-h-lg-475px {\n    min-height: 475px !important;\n  }\n  .min-h-lg-500px {\n    min-height: 500px !important;\n  }\n  .min-h-lg-550px {\n    min-height: 550px !important;\n  }\n  .min-h-lg-600px {\n    min-height: 600px !important;\n  }\n  .min-h-lg-650px {\n    min-height: 650px !important;\n  }\n  .min-h-lg-700px {\n    min-height: 700px !important;\n  }\n  .min-h-lg-750px {\n    min-height: 750px !important;\n  }\n  .min-h-lg-800px {\n    min-height: 800px !important;\n  }\n  .min-h-lg-850px {\n    min-height: 850px !important;\n  }\n  .min-h-lg-900px {\n    min-height: 900px !important;\n  }\n  .min-h-lg-950px {\n    min-height: 950px !important;\n  }\n  .min-h-lg-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n  .float-xl-end {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n  .object-fit-xl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xl-none {\n    object-fit: none !important;\n  }\n  .overflow-xl-auto {\n    overflow: auto !important;\n  }\n  .overflow-xl-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-xl-visible {\n    overflow: visible !important;\n  }\n  .overflow-xl-scroll {\n    overflow: scroll !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-grid {\n    display: grid !important;\n  }\n  .d-xl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xl-none {\n    display: none !important;\n  }\n  .position-xl-static {\n    position: static !important;\n  }\n  .position-xl-relative {\n    position: relative !important;\n  }\n  .position-xl-absolute {\n    position: absolute !important;\n  }\n  .position-xl-fixed {\n    position: fixed !important;\n  }\n  .position-xl-sticky {\n    position: sticky !important;\n  }\n  .w-xl-unset {\n    width: unset !important;\n  }\n  .w-xl-25 {\n    width: 25% !important;\n  }\n  .w-xl-50 {\n    width: 50% !important;\n  }\n  .w-xl-75 {\n    width: 75% !important;\n  }\n  .w-xl-100 {\n    width: 100% !important;\n  }\n  .w-xl-auto {\n    width: auto !important;\n  }\n  .w-xl-1px {\n    width: 1px !important;\n  }\n  .w-xl-2px {\n    width: 2px !important;\n  }\n  .w-xl-3px {\n    width: 3px !important;\n  }\n  .w-xl-4px {\n    width: 4px !important;\n  }\n  .w-xl-5px {\n    width: 5px !important;\n  }\n  .w-xl-6px {\n    width: 6px !important;\n  }\n  .w-xl-7px {\n    width: 7px !important;\n  }\n  .w-xl-8px {\n    width: 8px !important;\n  }\n  .w-xl-9px {\n    width: 9px !important;\n  }\n  .w-xl-10px {\n    width: 10px !important;\n  }\n  .w-xl-15px {\n    width: 15px !important;\n  }\n  .w-xl-20px {\n    width: 20px !important;\n  }\n  .w-xl-25px {\n    width: 25px !important;\n  }\n  .w-xl-30px {\n    width: 30px !important;\n  }\n  .w-xl-35px {\n    width: 35px !important;\n  }\n  .w-xl-40px {\n    width: 40px !important;\n  }\n  .w-xl-45px {\n    width: 45px !important;\n  }\n  .w-xl-50px {\n    width: 50px !important;\n  }\n  .w-xl-55px {\n    width: 55px !important;\n  }\n  .w-xl-60px {\n    width: 60px !important;\n  }\n  .w-xl-65px {\n    width: 65px !important;\n  }\n  .w-xl-70px {\n    width: 70px !important;\n  }\n  .w-xl-75px {\n    width: 75px !important;\n  }\n  .w-xl-80px {\n    width: 80px !important;\n  }\n  .w-xl-85px {\n    width: 85px !important;\n  }\n  .w-xl-90px {\n    width: 90px !important;\n  }\n  .w-xl-95px {\n    width: 95px !important;\n  }\n  .w-xl-100px {\n    width: 100px !important;\n  }\n  .w-xl-125px {\n    width: 125px !important;\n  }\n  .w-xl-150px {\n    width: 150px !important;\n  }\n  .w-xl-175px {\n    width: 175px !important;\n  }\n  .w-xl-200px {\n    width: 200px !important;\n  }\n  .w-xl-225px {\n    width: 225px !important;\n  }\n  .w-xl-250px {\n    width: 250px !important;\n  }\n  .w-xl-275px {\n    width: 275px !important;\n  }\n  .w-xl-300px {\n    width: 300px !important;\n  }\n  .w-xl-325px {\n    width: 325px !important;\n  }\n  .w-xl-350px {\n    width: 350px !important;\n  }\n  .w-xl-375px {\n    width: 375px !important;\n  }\n  .w-xl-400px {\n    width: 400px !important;\n  }\n  .w-xl-425px {\n    width: 425px !important;\n  }\n  .w-xl-450px {\n    width: 450px !important;\n  }\n  .w-xl-475px {\n    width: 475px !important;\n  }\n  .w-xl-500px {\n    width: 500px !important;\n  }\n  .w-xl-550px {\n    width: 550px !important;\n  }\n  .w-xl-600px {\n    width: 600px !important;\n  }\n  .w-xl-650px {\n    width: 650px !important;\n  }\n  .w-xl-700px {\n    width: 700px !important;\n  }\n  .w-xl-750px {\n    width: 750px !important;\n  }\n  .w-xl-800px {\n    width: 800px !important;\n  }\n  .w-xl-850px {\n    width: 850px !important;\n  }\n  .w-xl-900px {\n    width: 900px !important;\n  }\n  .w-xl-950px {\n    width: 950px !important;\n  }\n  .w-xl-1000px {\n    width: 1000px !important;\n  }\n  .mw-xl-unset {\n    max-width: unset !important;\n  }\n  .mw-xl-25 {\n    max-width: 25% !important;\n  }\n  .mw-xl-50 {\n    max-width: 50% !important;\n  }\n  .mw-xl-75 {\n    max-width: 75% !important;\n  }\n  .mw-xl-100 {\n    max-width: 100% !important;\n  }\n  .mw-xl-auto {\n    max-width: auto !important;\n  }\n  .mw-xl-1px {\n    max-width: 1px !important;\n  }\n  .mw-xl-2px {\n    max-width: 2px !important;\n  }\n  .mw-xl-3px {\n    max-width: 3px !important;\n  }\n  .mw-xl-4px {\n    max-width: 4px !important;\n  }\n  .mw-xl-5px {\n    max-width: 5px !important;\n  }\n  .mw-xl-6px {\n    max-width: 6px !important;\n  }\n  .mw-xl-7px {\n    max-width: 7px !important;\n  }\n  .mw-xl-8px {\n    max-width: 8px !important;\n  }\n  .mw-xl-9px {\n    max-width: 9px !important;\n  }\n  .mw-xl-10px {\n    max-width: 10px !important;\n  }\n  .mw-xl-15px {\n    max-width: 15px !important;\n  }\n  .mw-xl-20px {\n    max-width: 20px !important;\n  }\n  .mw-xl-25px {\n    max-width: 25px !important;\n  }\n  .mw-xl-30px {\n    max-width: 30px !important;\n  }\n  .mw-xl-35px {\n    max-width: 35px !important;\n  }\n  .mw-xl-40px {\n    max-width: 40px !important;\n  }\n  .mw-xl-45px {\n    max-width: 45px !important;\n  }\n  .mw-xl-50px {\n    max-width: 50px !important;\n  }\n  .mw-xl-55px {\n    max-width: 55px !important;\n  }\n  .mw-xl-60px {\n    max-width: 60px !important;\n  }\n  .mw-xl-65px {\n    max-width: 65px !important;\n  }\n  .mw-xl-70px {\n    max-width: 70px !important;\n  }\n  .mw-xl-75px {\n    max-width: 75px !important;\n  }\n  .mw-xl-80px {\n    max-width: 80px !important;\n  }\n  .mw-xl-85px {\n    max-width: 85px !important;\n  }\n  .mw-xl-90px {\n    max-width: 90px !important;\n  }\n  .mw-xl-95px {\n    max-width: 95px !important;\n  }\n  .mw-xl-100px {\n    max-width: 100px !important;\n  }\n  .mw-xl-125px {\n    max-width: 125px !important;\n  }\n  .mw-xl-150px {\n    max-width: 150px !important;\n  }\n  .mw-xl-175px {\n    max-width: 175px !important;\n  }\n  .mw-xl-200px {\n    max-width: 200px !important;\n  }\n  .mw-xl-225px {\n    max-width: 225px !important;\n  }\n  .mw-xl-250px {\n    max-width: 250px !important;\n  }\n  .mw-xl-275px {\n    max-width: 275px !important;\n  }\n  .mw-xl-300px {\n    max-width: 300px !important;\n  }\n  .mw-xl-325px {\n    max-width: 325px !important;\n  }\n  .mw-xl-350px {\n    max-width: 350px !important;\n  }\n  .mw-xl-375px {\n    max-width: 375px !important;\n  }\n  .mw-xl-400px {\n    max-width: 400px !important;\n  }\n  .mw-xl-425px {\n    max-width: 425px !important;\n  }\n  .mw-xl-450px {\n    max-width: 450px !important;\n  }\n  .mw-xl-475px {\n    max-width: 475px !important;\n  }\n  .mw-xl-500px {\n    max-width: 500px !important;\n  }\n  .mw-xl-550px {\n    max-width: 550px !important;\n  }\n  .mw-xl-600px {\n    max-width: 600px !important;\n  }\n  .mw-xl-650px {\n    max-width: 650px !important;\n  }\n  .mw-xl-700px {\n    max-width: 700px !important;\n  }\n  .mw-xl-750px {\n    max-width: 750px !important;\n  }\n  .mw-xl-800px {\n    max-width: 800px !important;\n  }\n  .mw-xl-850px {\n    max-width: 850px !important;\n  }\n  .mw-xl-900px {\n    max-width: 900px !important;\n  }\n  .mw-xl-950px {\n    max-width: 950px !important;\n  }\n  .mw-xl-1000px {\n    max-width: 1000px !important;\n  }\n  .h-xl-unset {\n    height: unset !important;\n  }\n  .h-xl-25 {\n    height: 25% !important;\n  }\n  .h-xl-50 {\n    height: 50% !important;\n  }\n  .h-xl-75 {\n    height: 75% !important;\n  }\n  .h-xl-100 {\n    height: 100% !important;\n  }\n  .h-xl-auto {\n    height: auto !important;\n  }\n  .h-xl-1px {\n    height: 1px !important;\n  }\n  .h-xl-2px {\n    height: 2px !important;\n  }\n  .h-xl-3px {\n    height: 3px !important;\n  }\n  .h-xl-4px {\n    height: 4px !important;\n  }\n  .h-xl-5px {\n    height: 5px !important;\n  }\n  .h-xl-6px {\n    height: 6px !important;\n  }\n  .h-xl-7px {\n    height: 7px !important;\n  }\n  .h-xl-8px {\n    height: 8px !important;\n  }\n  .h-xl-9px {\n    height: 9px !important;\n  }\n  .h-xl-10px {\n    height: 10px !important;\n  }\n  .h-xl-15px {\n    height: 15px !important;\n  }\n  .h-xl-20px {\n    height: 20px !important;\n  }\n  .h-xl-25px {\n    height: 25px !important;\n  }\n  .h-xl-30px {\n    height: 30px !important;\n  }\n  .h-xl-35px {\n    height: 35px !important;\n  }\n  .h-xl-40px {\n    height: 40px !important;\n  }\n  .h-xl-45px {\n    height: 45px !important;\n  }\n  .h-xl-50px {\n    height: 50px !important;\n  }\n  .h-xl-55px {\n    height: 55px !important;\n  }\n  .h-xl-60px {\n    height: 60px !important;\n  }\n  .h-xl-65px {\n    height: 65px !important;\n  }\n  .h-xl-70px {\n    height: 70px !important;\n  }\n  .h-xl-75px {\n    height: 75px !important;\n  }\n  .h-xl-80px {\n    height: 80px !important;\n  }\n  .h-xl-85px {\n    height: 85px !important;\n  }\n  .h-xl-90px {\n    height: 90px !important;\n  }\n  .h-xl-95px {\n    height: 95px !important;\n  }\n  .h-xl-100px {\n    height: 100px !important;\n  }\n  .h-xl-125px {\n    height: 125px !important;\n  }\n  .h-xl-150px {\n    height: 150px !important;\n  }\n  .h-xl-175px {\n    height: 175px !important;\n  }\n  .h-xl-200px {\n    height: 200px !important;\n  }\n  .h-xl-225px {\n    height: 225px !important;\n  }\n  .h-xl-250px {\n    height: 250px !important;\n  }\n  .h-xl-275px {\n    height: 275px !important;\n  }\n  .h-xl-300px {\n    height: 300px !important;\n  }\n  .h-xl-325px {\n    height: 325px !important;\n  }\n  .h-xl-350px {\n    height: 350px !important;\n  }\n  .h-xl-375px {\n    height: 375px !important;\n  }\n  .h-xl-400px {\n    height: 400px !important;\n  }\n  .h-xl-425px {\n    height: 425px !important;\n  }\n  .h-xl-450px {\n    height: 450px !important;\n  }\n  .h-xl-475px {\n    height: 475px !important;\n  }\n  .h-xl-500px {\n    height: 500px !important;\n  }\n  .h-xl-550px {\n    height: 550px !important;\n  }\n  .h-xl-600px {\n    height: 600px !important;\n  }\n  .h-xl-650px {\n    height: 650px !important;\n  }\n  .h-xl-700px {\n    height: 700px !important;\n  }\n  .h-xl-750px {\n    height: 750px !important;\n  }\n  .h-xl-800px {\n    height: 800px !important;\n  }\n  .h-xl-850px {\n    height: 850px !important;\n  }\n  .h-xl-900px {\n    height: 900px !important;\n  }\n  .h-xl-950px {\n    height: 950px !important;\n  }\n  .h-xl-1000px {\n    height: 1000px !important;\n  }\n  .mh-xl-unset {\n    max-height: unset !important;\n  }\n  .mh-xl-25 {\n    max-height: 25% !important;\n  }\n  .mh-xl-50 {\n    max-height: 50% !important;\n  }\n  .mh-xl-75 {\n    max-height: 75% !important;\n  }\n  .mh-xl-100 {\n    max-height: 100% !important;\n  }\n  .mh-xl-auto {\n    max-height: auto !important;\n  }\n  .mh-xl-1px {\n    max-height: 1px !important;\n  }\n  .mh-xl-2px {\n    max-height: 2px !important;\n  }\n  .mh-xl-3px {\n    max-height: 3px !important;\n  }\n  .mh-xl-4px {\n    max-height: 4px !important;\n  }\n  .mh-xl-5px {\n    max-height: 5px !important;\n  }\n  .mh-xl-6px {\n    max-height: 6px !important;\n  }\n  .mh-xl-7px {\n    max-height: 7px !important;\n  }\n  .mh-xl-8px {\n    max-height: 8px !important;\n  }\n  .mh-xl-9px {\n    max-height: 9px !important;\n  }\n  .mh-xl-10px {\n    max-height: 10px !important;\n  }\n  .mh-xl-15px {\n    max-height: 15px !important;\n  }\n  .mh-xl-20px {\n    max-height: 20px !important;\n  }\n  .mh-xl-25px {\n    max-height: 25px !important;\n  }\n  .mh-xl-30px {\n    max-height: 30px !important;\n  }\n  .mh-xl-35px {\n    max-height: 35px !important;\n  }\n  .mh-xl-40px {\n    max-height: 40px !important;\n  }\n  .mh-xl-45px {\n    max-height: 45px !important;\n  }\n  .mh-xl-50px {\n    max-height: 50px !important;\n  }\n  .mh-xl-55px {\n    max-height: 55px !important;\n  }\n  .mh-xl-60px {\n    max-height: 60px !important;\n  }\n  .mh-xl-65px {\n    max-height: 65px !important;\n  }\n  .mh-xl-70px {\n    max-height: 70px !important;\n  }\n  .mh-xl-75px {\n    max-height: 75px !important;\n  }\n  .mh-xl-80px {\n    max-height: 80px !important;\n  }\n  .mh-xl-85px {\n    max-height: 85px !important;\n  }\n  .mh-xl-90px {\n    max-height: 90px !important;\n  }\n  .mh-xl-95px {\n    max-height: 95px !important;\n  }\n  .mh-xl-100px {\n    max-height: 100px !important;\n  }\n  .mh-xl-125px {\n    max-height: 125px !important;\n  }\n  .mh-xl-150px {\n    max-height: 150px !important;\n  }\n  .mh-xl-175px {\n    max-height: 175px !important;\n  }\n  .mh-xl-200px {\n    max-height: 200px !important;\n  }\n  .mh-xl-225px {\n    max-height: 225px !important;\n  }\n  .mh-xl-250px {\n    max-height: 250px !important;\n  }\n  .mh-xl-275px {\n    max-height: 275px !important;\n  }\n  .mh-xl-300px {\n    max-height: 300px !important;\n  }\n  .mh-xl-325px {\n    max-height: 325px !important;\n  }\n  .mh-xl-350px {\n    max-height: 350px !important;\n  }\n  .mh-xl-375px {\n    max-height: 375px !important;\n  }\n  .mh-xl-400px {\n    max-height: 400px !important;\n  }\n  .mh-xl-425px {\n    max-height: 425px !important;\n  }\n  .mh-xl-450px {\n    max-height: 450px !important;\n  }\n  .mh-xl-475px {\n    max-height: 475px !important;\n  }\n  .mh-xl-500px {\n    max-height: 500px !important;\n  }\n  .mh-xl-550px {\n    max-height: 550px !important;\n  }\n  .mh-xl-600px {\n    max-height: 600px !important;\n  }\n  .mh-xl-650px {\n    max-height: 650px !important;\n  }\n  .mh-xl-700px {\n    max-height: 700px !important;\n  }\n  .mh-xl-750px {\n    max-height: 750px !important;\n  }\n  .mh-xl-800px {\n    max-height: 800px !important;\n  }\n  .mh-xl-850px {\n    max-height: 850px !important;\n  }\n  .mh-xl-900px {\n    max-height: 900px !important;\n  }\n  .mh-xl-950px {\n    max-height: 950px !important;\n  }\n  .mh-xl-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xl-first {\n    order: -1 !important;\n  }\n  .order-xl-0 {\n    order: 0 !important;\n  }\n  .order-xl-1 {\n    order: 1 !important;\n  }\n  .order-xl-2 {\n    order: 2 !important;\n  }\n  .order-xl-3 {\n    order: 3 !important;\n  }\n  .order-xl-4 {\n    order: 4 !important;\n  }\n  .order-xl-5 {\n    order: 5 !important;\n  }\n  .order-xl-last {\n    order: 6 !important;\n  }\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 0.75rem !important;\n  }\n  .m-xl-4 {\n    margin: 1rem !important;\n  }\n  .m-xl-5 {\n    margin: 1.25rem !important;\n  }\n  .m-xl-6 {\n    margin: 1.5rem !important;\n  }\n  .m-xl-7 {\n    margin: 1.75rem !important;\n  }\n  .m-xl-8 {\n    margin: 2rem !important;\n  }\n  .m-xl-9 {\n    margin: 2.25rem !important;\n  }\n  .m-xl-10 {\n    margin: 2.5rem !important;\n  }\n  .m-xl-11 {\n    margin: 2.75rem !important;\n  }\n  .m-xl-12 {\n    margin: 3rem !important;\n  }\n  .m-xl-13 {\n    margin: 3.25rem !important;\n  }\n  .m-xl-14 {\n    margin: 3.5rem !important;\n  }\n  .m-xl-15 {\n    margin: 3.75rem !important;\n  }\n  .m-xl-16 {\n    margin: 4rem !important;\n  }\n  .m-xl-17 {\n    margin: 4.25rem !important;\n  }\n  .m-xl-18 {\n    margin: 4.5rem !important;\n  }\n  .m-xl-19 {\n    margin: 4.75rem !important;\n  }\n  .m-xl-20 {\n    margin: 5rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-xl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-xl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-xl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-xl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-xl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-xl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-xl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-xl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-xl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-xl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-xl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-xl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-xl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-xl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-xl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-xl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-xl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-xl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-xl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-xl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-xl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-xl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xl-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xl-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-xl-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-xl-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xl-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-xl-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-xl-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xl-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-xl-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-xl-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-xl-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-xl-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-xl-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-xl-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-xl-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-xl-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xl-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-xl-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xl-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xl-4 {\n    margin-right: 1rem !important;\n  }\n  .me-xl-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-xl-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xl-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-xl-8 {\n    margin-right: 2rem !important;\n  }\n  .me-xl-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xl-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-xl-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-xl-12 {\n    margin-right: 3rem !important;\n  }\n  .me-xl-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-xl-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-xl-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-xl-16 {\n    margin-right: 4rem !important;\n  }\n  .me-xl-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-xl-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xl-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-xl-20 {\n    margin-right: 5rem !important;\n  }\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xl-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-xl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-xl-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-xl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-xl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-xl-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-xl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-xl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-xl-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-xl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-xl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-xl-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xl-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xl-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-xl-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-xl-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xl-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-xl-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-xl-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xl-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-xl-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-xl-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-xl-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-xl-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-xl-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-xl-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-xl-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-xl-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xl-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-xl-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-xl-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1rem !important;\n  }\n  .m-xl-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-xl-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-xl-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-xl-n8 {\n    margin: -2rem !important;\n  }\n  .m-xl-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-xl-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-xl-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-xl-n12 {\n    margin: -3rem !important;\n  }\n  .m-xl-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-xl-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-xl-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-xl-n16 {\n    margin: -4rem !important;\n  }\n  .m-xl-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-xl-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-xl-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-xl-n20 {\n    margin: -5rem !important;\n  }\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-xl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-xl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-xl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-xl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-xl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-xl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-xl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-xl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-xl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-xl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-xl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-xl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-xl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-xl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-xl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-xl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-xl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-xl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-xl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-xl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-xl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-xl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-xl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-xl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-xl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-xl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xl-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xl-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-xl-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-xl-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xl-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-xl-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-xl-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xl-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-xl-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-xl-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-xl-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-xl-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-xl-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-xl-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-xl-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-xl-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-xl-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-xl-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xl-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xl-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-xl-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-xl-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xl-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-xl-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-xl-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xl-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-xl-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-xl-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-xl-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-xl-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-xl-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-xl-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-xl-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-xl-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-xl-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-xl-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xl-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-xl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-xl-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-xl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-xl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-xl-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-xl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-xl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-xl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-xl-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-xl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-xl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-xl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-xl-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xl-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xl-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-xl-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-xl-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xl-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-xl-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-xl-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xl-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-xl-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-xl-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-xl-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-xl-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-xl-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-xl-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-xl-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-xl-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-xl-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-xl-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 0.75rem !important;\n  }\n  .p-xl-4 {\n    padding: 1rem !important;\n  }\n  .p-xl-5 {\n    padding: 1.25rem !important;\n  }\n  .p-xl-6 {\n    padding: 1.5rem !important;\n  }\n  .p-xl-7 {\n    padding: 1.75rem !important;\n  }\n  .p-xl-8 {\n    padding: 2rem !important;\n  }\n  .p-xl-9 {\n    padding: 2.25rem !important;\n  }\n  .p-xl-10 {\n    padding: 2.5rem !important;\n  }\n  .p-xl-11 {\n    padding: 2.75rem !important;\n  }\n  .p-xl-12 {\n    padding: 3rem !important;\n  }\n  .p-xl-13 {\n    padding: 3.25rem !important;\n  }\n  .p-xl-14 {\n    padding: 3.5rem !important;\n  }\n  .p-xl-15 {\n    padding: 3.75rem !important;\n  }\n  .p-xl-16 {\n    padding: 4rem !important;\n  }\n  .p-xl-17 {\n    padding: 4.25rem !important;\n  }\n  .p-xl-18 {\n    padding: 4.5rem !important;\n  }\n  .p-xl-19 {\n    padding: 4.75rem !important;\n  }\n  .p-xl-20 {\n    padding: 5rem !important;\n  }\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-xl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-xl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-xl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-xl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-xl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-xl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-xl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-xl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-xl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-xl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-xl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-xl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-xl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-xl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-xl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-xl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-xl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-xl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-xl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-xl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-xl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-xl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-xl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-xl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-xl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-xl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xl-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xl-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-xl-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-xl-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xl-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-xl-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-xl-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xl-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-xl-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-xl-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-xl-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-xl-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-xl-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-xl-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-xl-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-xl-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-xl-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-xl-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xl-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xl-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-xl-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-xl-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xl-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-xl-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-xl-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xl-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-xl-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-xl-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-xl-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-xl-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-xl-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-xl-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-xl-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-xl-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-xl-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-xl-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xl-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-xl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-xl-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-xl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-xl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-xl-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-xl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-xl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-xl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-xl-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-xl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-xl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-xl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-xl-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xl-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xl-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-xl-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-xl-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xl-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-xl-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-xl-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xl-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-xl-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-xl-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-xl-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-xl-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-xl-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-xl-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-xl-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-xl-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-xl-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-xl-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xl-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-xl-4 {\n    gap: 1rem !important;\n  }\n  .gap-xl-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-xl-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-xl-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-xl-8 {\n    gap: 2rem !important;\n  }\n  .gap-xl-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-xl-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-xl-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-xl-12 {\n    gap: 3rem !important;\n  }\n  .gap-xl-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-xl-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-xl-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-xl-16 {\n    gap: 4rem !important;\n  }\n  .gap-xl-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-xl-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-xl-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-xl-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-xl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xl-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xl-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xl-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-xl-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xl-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-xl-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-xl-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-xl-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-xl-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-xl-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-xl-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-xl-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-xl-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-xl-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-xl-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-xl-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-xl-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-xl-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-xl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xl-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xl-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xl-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-xl-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xl-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-xl-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-xl-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-xl-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-xl-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-xl-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-xl-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-xl-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-xl-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-xl-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-xl-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-xl-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-xl-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-xl-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-xl-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-xl-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-xl-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-xl-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-xl-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-xl-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-xl-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-xl-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-xl-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-xl-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-xl-sm {\n    font-size: 0.95rem !important;\n  }\n  .fs-xl-base {\n    font-size: 1rem !important;\n  }\n  .fs-xl-lg {\n    font-size: 1.075rem !important;\n  }\n  .fs-xl-xl {\n    font-size: 1.21rem !important;\n  }\n  .fs-xl-fluid {\n    font-size: 100% !important;\n  }\n  .fs-xl-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-xl-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-xl-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-xl-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-xl-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-xl-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-xl-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-xl-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-xl-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-xl-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-xl-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-xl-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-xl-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-xl-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-xl-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-xl-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-xl-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-xl-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-xl-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-xl-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-xl-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-xl-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-xl-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-xl-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-xl-start {\n    text-align: left !important;\n  }\n  .text-xl-end {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n  .min-w-xl-unset {\n    min-width: unset !important;\n  }\n  .min-w-xl-25 {\n    min-width: 25% !important;\n  }\n  .min-w-xl-50 {\n    min-width: 50% !important;\n  }\n  .min-w-xl-75 {\n    min-width: 75% !important;\n  }\n  .min-w-xl-100 {\n    min-width: 100% !important;\n  }\n  .min-w-xl-auto {\n    min-width: auto !important;\n  }\n  .min-w-xl-1px {\n    min-width: 1px !important;\n  }\n  .min-w-xl-2px {\n    min-width: 2px !important;\n  }\n  .min-w-xl-3px {\n    min-width: 3px !important;\n  }\n  .min-w-xl-4px {\n    min-width: 4px !important;\n  }\n  .min-w-xl-5px {\n    min-width: 5px !important;\n  }\n  .min-w-xl-6px {\n    min-width: 6px !important;\n  }\n  .min-w-xl-7px {\n    min-width: 7px !important;\n  }\n  .min-w-xl-8px {\n    min-width: 8px !important;\n  }\n  .min-w-xl-9px {\n    min-width: 9px !important;\n  }\n  .min-w-xl-10px {\n    min-width: 10px !important;\n  }\n  .min-w-xl-15px {\n    min-width: 15px !important;\n  }\n  .min-w-xl-20px {\n    min-width: 20px !important;\n  }\n  .min-w-xl-25px {\n    min-width: 25px !important;\n  }\n  .min-w-xl-30px {\n    min-width: 30px !important;\n  }\n  .min-w-xl-35px {\n    min-width: 35px !important;\n  }\n  .min-w-xl-40px {\n    min-width: 40px !important;\n  }\n  .min-w-xl-45px {\n    min-width: 45px !important;\n  }\n  .min-w-xl-50px {\n    min-width: 50px !important;\n  }\n  .min-w-xl-55px {\n    min-width: 55px !important;\n  }\n  .min-w-xl-60px {\n    min-width: 60px !important;\n  }\n  .min-w-xl-65px {\n    min-width: 65px !important;\n  }\n  .min-w-xl-70px {\n    min-width: 70px !important;\n  }\n  .min-w-xl-75px {\n    min-width: 75px !important;\n  }\n  .min-w-xl-80px {\n    min-width: 80px !important;\n  }\n  .min-w-xl-85px {\n    min-width: 85px !important;\n  }\n  .min-w-xl-90px {\n    min-width: 90px !important;\n  }\n  .min-w-xl-95px {\n    min-width: 95px !important;\n  }\n  .min-w-xl-100px {\n    min-width: 100px !important;\n  }\n  .min-w-xl-125px {\n    min-width: 125px !important;\n  }\n  .min-w-xl-150px {\n    min-width: 150px !important;\n  }\n  .min-w-xl-175px {\n    min-width: 175px !important;\n  }\n  .min-w-xl-200px {\n    min-width: 200px !important;\n  }\n  .min-w-xl-225px {\n    min-width: 225px !important;\n  }\n  .min-w-xl-250px {\n    min-width: 250px !important;\n  }\n  .min-w-xl-275px {\n    min-width: 275px !important;\n  }\n  .min-w-xl-300px {\n    min-width: 300px !important;\n  }\n  .min-w-xl-325px {\n    min-width: 325px !important;\n  }\n  .min-w-xl-350px {\n    min-width: 350px !important;\n  }\n  .min-w-xl-375px {\n    min-width: 375px !important;\n  }\n  .min-w-xl-400px {\n    min-width: 400px !important;\n  }\n  .min-w-xl-425px {\n    min-width: 425px !important;\n  }\n  .min-w-xl-450px {\n    min-width: 450px !important;\n  }\n  .min-w-xl-475px {\n    min-width: 475px !important;\n  }\n  .min-w-xl-500px {\n    min-width: 500px !important;\n  }\n  .min-w-xl-550px {\n    min-width: 550px !important;\n  }\n  .min-w-xl-600px {\n    min-width: 600px !important;\n  }\n  .min-w-xl-650px {\n    min-width: 650px !important;\n  }\n  .min-w-xl-700px {\n    min-width: 700px !important;\n  }\n  .min-w-xl-750px {\n    min-width: 750px !important;\n  }\n  .min-w-xl-800px {\n    min-width: 800px !important;\n  }\n  .min-w-xl-850px {\n    min-width: 850px !important;\n  }\n  .min-w-xl-900px {\n    min-width: 900px !important;\n  }\n  .min-w-xl-950px {\n    min-width: 950px !important;\n  }\n  .min-w-xl-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-xl-unset {\n    min-height: unset !important;\n  }\n  .min-h-xl-25 {\n    min-height: 25% !important;\n  }\n  .min-h-xl-50 {\n    min-height: 50% !important;\n  }\n  .min-h-xl-75 {\n    min-height: 75% !important;\n  }\n  .min-h-xl-100 {\n    min-height: 100% !important;\n  }\n  .min-h-xl-auto {\n    min-height: auto !important;\n  }\n  .min-h-xl-1px {\n    min-height: 1px !important;\n  }\n  .min-h-xl-2px {\n    min-height: 2px !important;\n  }\n  .min-h-xl-3px {\n    min-height: 3px !important;\n  }\n  .min-h-xl-4px {\n    min-height: 4px !important;\n  }\n  .min-h-xl-5px {\n    min-height: 5px !important;\n  }\n  .min-h-xl-6px {\n    min-height: 6px !important;\n  }\n  .min-h-xl-7px {\n    min-height: 7px !important;\n  }\n  .min-h-xl-8px {\n    min-height: 8px !important;\n  }\n  .min-h-xl-9px {\n    min-height: 9px !important;\n  }\n  .min-h-xl-10px {\n    min-height: 10px !important;\n  }\n  .min-h-xl-15px {\n    min-height: 15px !important;\n  }\n  .min-h-xl-20px {\n    min-height: 20px !important;\n  }\n  .min-h-xl-25px {\n    min-height: 25px !important;\n  }\n  .min-h-xl-30px {\n    min-height: 30px !important;\n  }\n  .min-h-xl-35px {\n    min-height: 35px !important;\n  }\n  .min-h-xl-40px {\n    min-height: 40px !important;\n  }\n  .min-h-xl-45px {\n    min-height: 45px !important;\n  }\n  .min-h-xl-50px {\n    min-height: 50px !important;\n  }\n  .min-h-xl-55px {\n    min-height: 55px !important;\n  }\n  .min-h-xl-60px {\n    min-height: 60px !important;\n  }\n  .min-h-xl-65px {\n    min-height: 65px !important;\n  }\n  .min-h-xl-70px {\n    min-height: 70px !important;\n  }\n  .min-h-xl-75px {\n    min-height: 75px !important;\n  }\n  .min-h-xl-80px {\n    min-height: 80px !important;\n  }\n  .min-h-xl-85px {\n    min-height: 85px !important;\n  }\n  .min-h-xl-90px {\n    min-height: 90px !important;\n  }\n  .min-h-xl-95px {\n    min-height: 95px !important;\n  }\n  .min-h-xl-100px {\n    min-height: 100px !important;\n  }\n  .min-h-xl-125px {\n    min-height: 125px !important;\n  }\n  .min-h-xl-150px {\n    min-height: 150px !important;\n  }\n  .min-h-xl-175px {\n    min-height: 175px !important;\n  }\n  .min-h-xl-200px {\n    min-height: 200px !important;\n  }\n  .min-h-xl-225px {\n    min-height: 225px !important;\n  }\n  .min-h-xl-250px {\n    min-height: 250px !important;\n  }\n  .min-h-xl-275px {\n    min-height: 275px !important;\n  }\n  .min-h-xl-300px {\n    min-height: 300px !important;\n  }\n  .min-h-xl-325px {\n    min-height: 325px !important;\n  }\n  .min-h-xl-350px {\n    min-height: 350px !important;\n  }\n  .min-h-xl-375px {\n    min-height: 375px !important;\n  }\n  .min-h-xl-400px {\n    min-height: 400px !important;\n  }\n  .min-h-xl-425px {\n    min-height: 425px !important;\n  }\n  .min-h-xl-450px {\n    min-height: 450px !important;\n  }\n  .min-h-xl-475px {\n    min-height: 475px !important;\n  }\n  .min-h-xl-500px {\n    min-height: 500px !important;\n  }\n  .min-h-xl-550px {\n    min-height: 550px !important;\n  }\n  .min-h-xl-600px {\n    min-height: 600px !important;\n  }\n  .min-h-xl-650px {\n    min-height: 650px !important;\n  }\n  .min-h-xl-700px {\n    min-height: 700px !important;\n  }\n  .min-h-xl-750px {\n    min-height: 750px !important;\n  }\n  .min-h-xl-800px {\n    min-height: 800px !important;\n  }\n  .min-h-xl-850px {\n    min-height: 850px !important;\n  }\n  .min-h-xl-900px {\n    min-height: 900px !important;\n  }\n  .min-h-xl-950px {\n    min-height: 950px !important;\n  }\n  .min-h-xl-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n  .float-xxl-end {\n    float: right !important;\n  }\n  .float-xxl-none {\n    float: none !important;\n  }\n  .object-fit-xxl-contain {\n    object-fit: contain !important;\n  }\n  .object-fit-xxl-cover {\n    object-fit: cover !important;\n  }\n  .object-fit-xxl-fill {\n    object-fit: fill !important;\n  }\n  .object-fit-xxl-scale {\n    object-fit: scale-down !important;\n  }\n  .object-fit-xxl-none {\n    object-fit: none !important;\n  }\n  .overflow-xxl-auto {\n    overflow: auto !important;\n  }\n  .overflow-xxl-hidden {\n    overflow: hidden !important;\n  }\n  .overflow-xxl-visible {\n    overflow: visible !important;\n  }\n  .overflow-xxl-scroll {\n    overflow: scroll !important;\n  }\n  .d-xxl-inline {\n    display: inline !important;\n  }\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xxl-block {\n    display: block !important;\n  }\n  .d-xxl-grid {\n    display: grid !important;\n  }\n  .d-xxl-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-xxl-table {\n    display: table !important;\n  }\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xxl-flex {\n    display: flex !important;\n  }\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-xxl-none {\n    display: none !important;\n  }\n  .position-xxl-static {\n    position: static !important;\n  }\n  .position-xxl-relative {\n    position: relative !important;\n  }\n  .position-xxl-absolute {\n    position: absolute !important;\n  }\n  .position-xxl-fixed {\n    position: fixed !important;\n  }\n  .position-xxl-sticky {\n    position: sticky !important;\n  }\n  .w-xxl-unset {\n    width: unset !important;\n  }\n  .w-xxl-25 {\n    width: 25% !important;\n  }\n  .w-xxl-50 {\n    width: 50% !important;\n  }\n  .w-xxl-75 {\n    width: 75% !important;\n  }\n  .w-xxl-100 {\n    width: 100% !important;\n  }\n  .w-xxl-auto {\n    width: auto !important;\n  }\n  .w-xxl-1px {\n    width: 1px !important;\n  }\n  .w-xxl-2px {\n    width: 2px !important;\n  }\n  .w-xxl-3px {\n    width: 3px !important;\n  }\n  .w-xxl-4px {\n    width: 4px !important;\n  }\n  .w-xxl-5px {\n    width: 5px !important;\n  }\n  .w-xxl-6px {\n    width: 6px !important;\n  }\n  .w-xxl-7px {\n    width: 7px !important;\n  }\n  .w-xxl-8px {\n    width: 8px !important;\n  }\n  .w-xxl-9px {\n    width: 9px !important;\n  }\n  .w-xxl-10px {\n    width: 10px !important;\n  }\n  .w-xxl-15px {\n    width: 15px !important;\n  }\n  .w-xxl-20px {\n    width: 20px !important;\n  }\n  .w-xxl-25px {\n    width: 25px !important;\n  }\n  .w-xxl-30px {\n    width: 30px !important;\n  }\n  .w-xxl-35px {\n    width: 35px !important;\n  }\n  .w-xxl-40px {\n    width: 40px !important;\n  }\n  .w-xxl-45px {\n    width: 45px !important;\n  }\n  .w-xxl-50px {\n    width: 50px !important;\n  }\n  .w-xxl-55px {\n    width: 55px !important;\n  }\n  .w-xxl-60px {\n    width: 60px !important;\n  }\n  .w-xxl-65px {\n    width: 65px !important;\n  }\n  .w-xxl-70px {\n    width: 70px !important;\n  }\n  .w-xxl-75px {\n    width: 75px !important;\n  }\n  .w-xxl-80px {\n    width: 80px !important;\n  }\n  .w-xxl-85px {\n    width: 85px !important;\n  }\n  .w-xxl-90px {\n    width: 90px !important;\n  }\n  .w-xxl-95px {\n    width: 95px !important;\n  }\n  .w-xxl-100px {\n    width: 100px !important;\n  }\n  .w-xxl-125px {\n    width: 125px !important;\n  }\n  .w-xxl-150px {\n    width: 150px !important;\n  }\n  .w-xxl-175px {\n    width: 175px !important;\n  }\n  .w-xxl-200px {\n    width: 200px !important;\n  }\n  .w-xxl-225px {\n    width: 225px !important;\n  }\n  .w-xxl-250px {\n    width: 250px !important;\n  }\n  .w-xxl-275px {\n    width: 275px !important;\n  }\n  .w-xxl-300px {\n    width: 300px !important;\n  }\n  .w-xxl-325px {\n    width: 325px !important;\n  }\n  .w-xxl-350px {\n    width: 350px !important;\n  }\n  .w-xxl-375px {\n    width: 375px !important;\n  }\n  .w-xxl-400px {\n    width: 400px !important;\n  }\n  .w-xxl-425px {\n    width: 425px !important;\n  }\n  .w-xxl-450px {\n    width: 450px !important;\n  }\n  .w-xxl-475px {\n    width: 475px !important;\n  }\n  .w-xxl-500px {\n    width: 500px !important;\n  }\n  .w-xxl-550px {\n    width: 550px !important;\n  }\n  .w-xxl-600px {\n    width: 600px !important;\n  }\n  .w-xxl-650px {\n    width: 650px !important;\n  }\n  .w-xxl-700px {\n    width: 700px !important;\n  }\n  .w-xxl-750px {\n    width: 750px !important;\n  }\n  .w-xxl-800px {\n    width: 800px !important;\n  }\n  .w-xxl-850px {\n    width: 850px !important;\n  }\n  .w-xxl-900px {\n    width: 900px !important;\n  }\n  .w-xxl-950px {\n    width: 950px !important;\n  }\n  .w-xxl-1000px {\n    width: 1000px !important;\n  }\n  .mw-xxl-unset {\n    max-width: unset !important;\n  }\n  .mw-xxl-25 {\n    max-width: 25% !important;\n  }\n  .mw-xxl-50 {\n    max-width: 50% !important;\n  }\n  .mw-xxl-75 {\n    max-width: 75% !important;\n  }\n  .mw-xxl-100 {\n    max-width: 100% !important;\n  }\n  .mw-xxl-auto {\n    max-width: auto !important;\n  }\n  .mw-xxl-1px {\n    max-width: 1px !important;\n  }\n  .mw-xxl-2px {\n    max-width: 2px !important;\n  }\n  .mw-xxl-3px {\n    max-width: 3px !important;\n  }\n  .mw-xxl-4px {\n    max-width: 4px !important;\n  }\n  .mw-xxl-5px {\n    max-width: 5px !important;\n  }\n  .mw-xxl-6px {\n    max-width: 6px !important;\n  }\n  .mw-xxl-7px {\n    max-width: 7px !important;\n  }\n  .mw-xxl-8px {\n    max-width: 8px !important;\n  }\n  .mw-xxl-9px {\n    max-width: 9px !important;\n  }\n  .mw-xxl-10px {\n    max-width: 10px !important;\n  }\n  .mw-xxl-15px {\n    max-width: 15px !important;\n  }\n  .mw-xxl-20px {\n    max-width: 20px !important;\n  }\n  .mw-xxl-25px {\n    max-width: 25px !important;\n  }\n  .mw-xxl-30px {\n    max-width: 30px !important;\n  }\n  .mw-xxl-35px {\n    max-width: 35px !important;\n  }\n  .mw-xxl-40px {\n    max-width: 40px !important;\n  }\n  .mw-xxl-45px {\n    max-width: 45px !important;\n  }\n  .mw-xxl-50px {\n    max-width: 50px !important;\n  }\n  .mw-xxl-55px {\n    max-width: 55px !important;\n  }\n  .mw-xxl-60px {\n    max-width: 60px !important;\n  }\n  .mw-xxl-65px {\n    max-width: 65px !important;\n  }\n  .mw-xxl-70px {\n    max-width: 70px !important;\n  }\n  .mw-xxl-75px {\n    max-width: 75px !important;\n  }\n  .mw-xxl-80px {\n    max-width: 80px !important;\n  }\n  .mw-xxl-85px {\n    max-width: 85px !important;\n  }\n  .mw-xxl-90px {\n    max-width: 90px !important;\n  }\n  .mw-xxl-95px {\n    max-width: 95px !important;\n  }\n  .mw-xxl-100px {\n    max-width: 100px !important;\n  }\n  .mw-xxl-125px {\n    max-width: 125px !important;\n  }\n  .mw-xxl-150px {\n    max-width: 150px !important;\n  }\n  .mw-xxl-175px {\n    max-width: 175px !important;\n  }\n  .mw-xxl-200px {\n    max-width: 200px !important;\n  }\n  .mw-xxl-225px {\n    max-width: 225px !important;\n  }\n  .mw-xxl-250px {\n    max-width: 250px !important;\n  }\n  .mw-xxl-275px {\n    max-width: 275px !important;\n  }\n  .mw-xxl-300px {\n    max-width: 300px !important;\n  }\n  .mw-xxl-325px {\n    max-width: 325px !important;\n  }\n  .mw-xxl-350px {\n    max-width: 350px !important;\n  }\n  .mw-xxl-375px {\n    max-width: 375px !important;\n  }\n  .mw-xxl-400px {\n    max-width: 400px !important;\n  }\n  .mw-xxl-425px {\n    max-width: 425px !important;\n  }\n  .mw-xxl-450px {\n    max-width: 450px !important;\n  }\n  .mw-xxl-475px {\n    max-width: 475px !important;\n  }\n  .mw-xxl-500px {\n    max-width: 500px !important;\n  }\n  .mw-xxl-550px {\n    max-width: 550px !important;\n  }\n  .mw-xxl-600px {\n    max-width: 600px !important;\n  }\n  .mw-xxl-650px {\n    max-width: 650px !important;\n  }\n  .mw-xxl-700px {\n    max-width: 700px !important;\n  }\n  .mw-xxl-750px {\n    max-width: 750px !important;\n  }\n  .mw-xxl-800px {\n    max-width: 800px !important;\n  }\n  .mw-xxl-850px {\n    max-width: 850px !important;\n  }\n  .mw-xxl-900px {\n    max-width: 900px !important;\n  }\n  .mw-xxl-950px {\n    max-width: 950px !important;\n  }\n  .mw-xxl-1000px {\n    max-width: 1000px !important;\n  }\n  .h-xxl-unset {\n    height: unset !important;\n  }\n  .h-xxl-25 {\n    height: 25% !important;\n  }\n  .h-xxl-50 {\n    height: 50% !important;\n  }\n  .h-xxl-75 {\n    height: 75% !important;\n  }\n  .h-xxl-100 {\n    height: 100% !important;\n  }\n  .h-xxl-auto {\n    height: auto !important;\n  }\n  .h-xxl-1px {\n    height: 1px !important;\n  }\n  .h-xxl-2px {\n    height: 2px !important;\n  }\n  .h-xxl-3px {\n    height: 3px !important;\n  }\n  .h-xxl-4px {\n    height: 4px !important;\n  }\n  .h-xxl-5px {\n    height: 5px !important;\n  }\n  .h-xxl-6px {\n    height: 6px !important;\n  }\n  .h-xxl-7px {\n    height: 7px !important;\n  }\n  .h-xxl-8px {\n    height: 8px !important;\n  }\n  .h-xxl-9px {\n    height: 9px !important;\n  }\n  .h-xxl-10px {\n    height: 10px !important;\n  }\n  .h-xxl-15px {\n    height: 15px !important;\n  }\n  .h-xxl-20px {\n    height: 20px !important;\n  }\n  .h-xxl-25px {\n    height: 25px !important;\n  }\n  .h-xxl-30px {\n    height: 30px !important;\n  }\n  .h-xxl-35px {\n    height: 35px !important;\n  }\n  .h-xxl-40px {\n    height: 40px !important;\n  }\n  .h-xxl-45px {\n    height: 45px !important;\n  }\n  .h-xxl-50px {\n    height: 50px !important;\n  }\n  .h-xxl-55px {\n    height: 55px !important;\n  }\n  .h-xxl-60px {\n    height: 60px !important;\n  }\n  .h-xxl-65px {\n    height: 65px !important;\n  }\n  .h-xxl-70px {\n    height: 70px !important;\n  }\n  .h-xxl-75px {\n    height: 75px !important;\n  }\n  .h-xxl-80px {\n    height: 80px !important;\n  }\n  .h-xxl-85px {\n    height: 85px !important;\n  }\n  .h-xxl-90px {\n    height: 90px !important;\n  }\n  .h-xxl-95px {\n    height: 95px !important;\n  }\n  .h-xxl-100px {\n    height: 100px !important;\n  }\n  .h-xxl-125px {\n    height: 125px !important;\n  }\n  .h-xxl-150px {\n    height: 150px !important;\n  }\n  .h-xxl-175px {\n    height: 175px !important;\n  }\n  .h-xxl-200px {\n    height: 200px !important;\n  }\n  .h-xxl-225px {\n    height: 225px !important;\n  }\n  .h-xxl-250px {\n    height: 250px !important;\n  }\n  .h-xxl-275px {\n    height: 275px !important;\n  }\n  .h-xxl-300px {\n    height: 300px !important;\n  }\n  .h-xxl-325px {\n    height: 325px !important;\n  }\n  .h-xxl-350px {\n    height: 350px !important;\n  }\n  .h-xxl-375px {\n    height: 375px !important;\n  }\n  .h-xxl-400px {\n    height: 400px !important;\n  }\n  .h-xxl-425px {\n    height: 425px !important;\n  }\n  .h-xxl-450px {\n    height: 450px !important;\n  }\n  .h-xxl-475px {\n    height: 475px !important;\n  }\n  .h-xxl-500px {\n    height: 500px !important;\n  }\n  .h-xxl-550px {\n    height: 550px !important;\n  }\n  .h-xxl-600px {\n    height: 600px !important;\n  }\n  .h-xxl-650px {\n    height: 650px !important;\n  }\n  .h-xxl-700px {\n    height: 700px !important;\n  }\n  .h-xxl-750px {\n    height: 750px !important;\n  }\n  .h-xxl-800px {\n    height: 800px !important;\n  }\n  .h-xxl-850px {\n    height: 850px !important;\n  }\n  .h-xxl-900px {\n    height: 900px !important;\n  }\n  .h-xxl-950px {\n    height: 950px !important;\n  }\n  .h-xxl-1000px {\n    height: 1000px !important;\n  }\n  .mh-xxl-unset {\n    max-height: unset !important;\n  }\n  .mh-xxl-25 {\n    max-height: 25% !important;\n  }\n  .mh-xxl-50 {\n    max-height: 50% !important;\n  }\n  .mh-xxl-75 {\n    max-height: 75% !important;\n  }\n  .mh-xxl-100 {\n    max-height: 100% !important;\n  }\n  .mh-xxl-auto {\n    max-height: auto !important;\n  }\n  .mh-xxl-1px {\n    max-height: 1px !important;\n  }\n  .mh-xxl-2px {\n    max-height: 2px !important;\n  }\n  .mh-xxl-3px {\n    max-height: 3px !important;\n  }\n  .mh-xxl-4px {\n    max-height: 4px !important;\n  }\n  .mh-xxl-5px {\n    max-height: 5px !important;\n  }\n  .mh-xxl-6px {\n    max-height: 6px !important;\n  }\n  .mh-xxl-7px {\n    max-height: 7px !important;\n  }\n  .mh-xxl-8px {\n    max-height: 8px !important;\n  }\n  .mh-xxl-9px {\n    max-height: 9px !important;\n  }\n  .mh-xxl-10px {\n    max-height: 10px !important;\n  }\n  .mh-xxl-15px {\n    max-height: 15px !important;\n  }\n  .mh-xxl-20px {\n    max-height: 20px !important;\n  }\n  .mh-xxl-25px {\n    max-height: 25px !important;\n  }\n  .mh-xxl-30px {\n    max-height: 30px !important;\n  }\n  .mh-xxl-35px {\n    max-height: 35px !important;\n  }\n  .mh-xxl-40px {\n    max-height: 40px !important;\n  }\n  .mh-xxl-45px {\n    max-height: 45px !important;\n  }\n  .mh-xxl-50px {\n    max-height: 50px !important;\n  }\n  .mh-xxl-55px {\n    max-height: 55px !important;\n  }\n  .mh-xxl-60px {\n    max-height: 60px !important;\n  }\n  .mh-xxl-65px {\n    max-height: 65px !important;\n  }\n  .mh-xxl-70px {\n    max-height: 70px !important;\n  }\n  .mh-xxl-75px {\n    max-height: 75px !important;\n  }\n  .mh-xxl-80px {\n    max-height: 80px !important;\n  }\n  .mh-xxl-85px {\n    max-height: 85px !important;\n  }\n  .mh-xxl-90px {\n    max-height: 90px !important;\n  }\n  .mh-xxl-95px {\n    max-height: 95px !important;\n  }\n  .mh-xxl-100px {\n    max-height: 100px !important;\n  }\n  .mh-xxl-125px {\n    max-height: 125px !important;\n  }\n  .mh-xxl-150px {\n    max-height: 150px !important;\n  }\n  .mh-xxl-175px {\n    max-height: 175px !important;\n  }\n  .mh-xxl-200px {\n    max-height: 200px !important;\n  }\n  .mh-xxl-225px {\n    max-height: 225px !important;\n  }\n  .mh-xxl-250px {\n    max-height: 250px !important;\n  }\n  .mh-xxl-275px {\n    max-height: 275px !important;\n  }\n  .mh-xxl-300px {\n    max-height: 300px !important;\n  }\n  .mh-xxl-325px {\n    max-height: 325px !important;\n  }\n  .mh-xxl-350px {\n    max-height: 350px !important;\n  }\n  .mh-xxl-375px {\n    max-height: 375px !important;\n  }\n  .mh-xxl-400px {\n    max-height: 400px !important;\n  }\n  .mh-xxl-425px {\n    max-height: 425px !important;\n  }\n  .mh-xxl-450px {\n    max-height: 450px !important;\n  }\n  .mh-xxl-475px {\n    max-height: 475px !important;\n  }\n  .mh-xxl-500px {\n    max-height: 500px !important;\n  }\n  .mh-xxl-550px {\n    max-height: 550px !important;\n  }\n  .mh-xxl-600px {\n    max-height: 600px !important;\n  }\n  .mh-xxl-650px {\n    max-height: 650px !important;\n  }\n  .mh-xxl-700px {\n    max-height: 700px !important;\n  }\n  .mh-xxl-750px {\n    max-height: 750px !important;\n  }\n  .mh-xxl-800px {\n    max-height: 800px !important;\n  }\n  .mh-xxl-850px {\n    max-height: 850px !important;\n  }\n  .mh-xxl-900px {\n    max-height: 900px !important;\n  }\n  .mh-xxl-950px {\n    max-height: 950px !important;\n  }\n  .mh-xxl-1000px {\n    max-height: 1000px !important;\n  }\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n  .order-xxl-first {\n    order: -1 !important;\n  }\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n  .order-xxl-last {\n    order: 6 !important;\n  }\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n  .m-xxl-3 {\n    margin: 0.75rem !important;\n  }\n  .m-xxl-4 {\n    margin: 1rem !important;\n  }\n  .m-xxl-5 {\n    margin: 1.25rem !important;\n  }\n  .m-xxl-6 {\n    margin: 1.5rem !important;\n  }\n  .m-xxl-7 {\n    margin: 1.75rem !important;\n  }\n  .m-xxl-8 {\n    margin: 2rem !important;\n  }\n  .m-xxl-9 {\n    margin: 2.25rem !important;\n  }\n  .m-xxl-10 {\n    margin: 2.5rem !important;\n  }\n  .m-xxl-11 {\n    margin: 2.75rem !important;\n  }\n  .m-xxl-12 {\n    margin: 3rem !important;\n  }\n  .m-xxl-13 {\n    margin: 3.25rem !important;\n  }\n  .m-xxl-14 {\n    margin: 3.5rem !important;\n  }\n  .m-xxl-15 {\n    margin: 3.75rem !important;\n  }\n  .m-xxl-16 {\n    margin: 4rem !important;\n  }\n  .m-xxl-17 {\n    margin: 4.25rem !important;\n  }\n  .m-xxl-18 {\n    margin: 4.5rem !important;\n  }\n  .m-xxl-19 {\n    margin: 4.75rem !important;\n  }\n  .m-xxl-20 {\n    margin: 5rem !important;\n  }\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n  .mx-xxl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n  .mx-xxl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n  .mx-xxl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n  .mx-xxl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n  .mx-xxl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n  .mx-xxl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n  .mx-xxl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n  .mx-xxl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n  .mx-xxl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n  .mx-xxl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n  .mx-xxl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n  .mx-xxl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n  .mx-xxl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n  .mx-xxl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n  .mx-xxl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n  .mx-xxl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n  .mx-xxl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n  .mx-xxl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n  .my-xxl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n  .my-xxl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n  .my-xxl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n  .my-xxl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n  .my-xxl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n  .my-xxl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n  .my-xxl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n  .my-xxl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n  .my-xxl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n  .my-xxl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n  .my-xxl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n  .my-xxl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n  .my-xxl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n  .my-xxl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n  .my-xxl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n  .my-xxl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n  .my-xxl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n  .my-xxl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mt-xxl-3 {\n    margin-top: 0.75rem !important;\n  }\n  .mt-xxl-4 {\n    margin-top: 1rem !important;\n  }\n  .mt-xxl-5 {\n    margin-top: 1.25rem !important;\n  }\n  .mt-xxl-6 {\n    margin-top: 1.5rem !important;\n  }\n  .mt-xxl-7 {\n    margin-top: 1.75rem !important;\n  }\n  .mt-xxl-8 {\n    margin-top: 2rem !important;\n  }\n  .mt-xxl-9 {\n    margin-top: 2.25rem !important;\n  }\n  .mt-xxl-10 {\n    margin-top: 2.5rem !important;\n  }\n  .mt-xxl-11 {\n    margin-top: 2.75rem !important;\n  }\n  .mt-xxl-12 {\n    margin-top: 3rem !important;\n  }\n  .mt-xxl-13 {\n    margin-top: 3.25rem !important;\n  }\n  .mt-xxl-14 {\n    margin-top: 3.5rem !important;\n  }\n  .mt-xxl-15 {\n    margin-top: 3.75rem !important;\n  }\n  .mt-xxl-16 {\n    margin-top: 4rem !important;\n  }\n  .mt-xxl-17 {\n    margin-top: 4.25rem !important;\n  }\n  .mt-xxl-18 {\n    margin-top: 4.5rem !important;\n  }\n  .mt-xxl-19 {\n    margin-top: 4.75rem !important;\n  }\n  .mt-xxl-20 {\n    margin-top: 5rem !important;\n  }\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .me-xxl-3 {\n    margin-right: 0.75rem !important;\n  }\n  .me-xxl-4 {\n    margin-right: 1rem !important;\n  }\n  .me-xxl-5 {\n    margin-right: 1.25rem !important;\n  }\n  .me-xxl-6 {\n    margin-right: 1.5rem !important;\n  }\n  .me-xxl-7 {\n    margin-right: 1.75rem !important;\n  }\n  .me-xxl-8 {\n    margin-right: 2rem !important;\n  }\n  .me-xxl-9 {\n    margin-right: 2.25rem !important;\n  }\n  .me-xxl-10 {\n    margin-right: 2.5rem !important;\n  }\n  .me-xxl-11 {\n    margin-right: 2.75rem !important;\n  }\n  .me-xxl-12 {\n    margin-right: 3rem !important;\n  }\n  .me-xxl-13 {\n    margin-right: 3.25rem !important;\n  }\n  .me-xxl-14 {\n    margin-right: 3.5rem !important;\n  }\n  .me-xxl-15 {\n    margin-right: 3.75rem !important;\n  }\n  .me-xxl-16 {\n    margin-right: 4rem !important;\n  }\n  .me-xxl-17 {\n    margin-right: 4.25rem !important;\n  }\n  .me-xxl-18 {\n    margin-right: 4.5rem !important;\n  }\n  .me-xxl-19 {\n    margin-right: 4.75rem !important;\n  }\n  .me-xxl-20 {\n    margin-right: 5rem !important;\n  }\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .mb-xxl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n  .mb-xxl-4 {\n    margin-bottom: 1rem !important;\n  }\n  .mb-xxl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n  .mb-xxl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n  .mb-xxl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n  .mb-xxl-8 {\n    margin-bottom: 2rem !important;\n  }\n  .mb-xxl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n  .mb-xxl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n  .mb-xxl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n  .mb-xxl-12 {\n    margin-bottom: 3rem !important;\n  }\n  .mb-xxl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n  .mb-xxl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n  .mb-xxl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n  .mb-xxl-16 {\n    margin-bottom: 4rem !important;\n  }\n  .mb-xxl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n  .mb-xxl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n  .mb-xxl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n  .mb-xxl-20 {\n    margin-bottom: 5rem !important;\n  }\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .ms-xxl-3 {\n    margin-left: 0.75rem !important;\n  }\n  .ms-xxl-4 {\n    margin-left: 1rem !important;\n  }\n  .ms-xxl-5 {\n    margin-left: 1.25rem !important;\n  }\n  .ms-xxl-6 {\n    margin-left: 1.5rem !important;\n  }\n  .ms-xxl-7 {\n    margin-left: 1.75rem !important;\n  }\n  .ms-xxl-8 {\n    margin-left: 2rem !important;\n  }\n  .ms-xxl-9 {\n    margin-left: 2.25rem !important;\n  }\n  .ms-xxl-10 {\n    margin-left: 2.5rem !important;\n  }\n  .ms-xxl-11 {\n    margin-left: 2.75rem !important;\n  }\n  .ms-xxl-12 {\n    margin-left: 3rem !important;\n  }\n  .ms-xxl-13 {\n    margin-left: 3.25rem !important;\n  }\n  .ms-xxl-14 {\n    margin-left: 3.5rem !important;\n  }\n  .ms-xxl-15 {\n    margin-left: 3.75rem !important;\n  }\n  .ms-xxl-16 {\n    margin-left: 4rem !important;\n  }\n  .ms-xxl-17 {\n    margin-left: 4.25rem !important;\n  }\n  .ms-xxl-18 {\n    margin-left: 4.5rem !important;\n  }\n  .ms-xxl-19 {\n    margin-left: 4.75rem !important;\n  }\n  .ms-xxl-20 {\n    margin-left: 5rem !important;\n  }\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n  .m-xxl-n1 {\n    margin: -0.25rem !important;\n  }\n  .m-xxl-n2 {\n    margin: -0.5rem !important;\n  }\n  .m-xxl-n3 {\n    margin: -0.75rem !important;\n  }\n  .m-xxl-n4 {\n    margin: -1rem !important;\n  }\n  .m-xxl-n5 {\n    margin: -1.25rem !important;\n  }\n  .m-xxl-n6 {\n    margin: -1.5rem !important;\n  }\n  .m-xxl-n7 {\n    margin: -1.75rem !important;\n  }\n  .m-xxl-n8 {\n    margin: -2rem !important;\n  }\n  .m-xxl-n9 {\n    margin: -2.25rem !important;\n  }\n  .m-xxl-n10 {\n    margin: -2.5rem !important;\n  }\n  .m-xxl-n11 {\n    margin: -2.75rem !important;\n  }\n  .m-xxl-n12 {\n    margin: -3rem !important;\n  }\n  .m-xxl-n13 {\n    margin: -3.25rem !important;\n  }\n  .m-xxl-n14 {\n    margin: -3.5rem !important;\n  }\n  .m-xxl-n15 {\n    margin: -3.75rem !important;\n  }\n  .m-xxl-n16 {\n    margin: -4rem !important;\n  }\n  .m-xxl-n17 {\n    margin: -4.25rem !important;\n  }\n  .m-xxl-n18 {\n    margin: -4.5rem !important;\n  }\n  .m-xxl-n19 {\n    margin: -4.75rem !important;\n  }\n  .m-xxl-n20 {\n    margin: -5rem !important;\n  }\n  .mx-xxl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n  .mx-xxl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n  .mx-xxl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n  .mx-xxl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n  .mx-xxl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n  .mx-xxl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n  .mx-xxl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n  .mx-xxl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n  .mx-xxl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n  .mx-xxl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n  .mx-xxl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n  .mx-xxl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n  .mx-xxl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n  .mx-xxl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n  .mx-xxl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n  .mx-xxl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n  .mx-xxl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n  .mx-xxl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n  .mx-xxl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n  .mx-xxl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n  .my-xxl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n  .my-xxl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n  .my-xxl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n  .my-xxl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n  .my-xxl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n  .my-xxl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n  .my-xxl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n  .my-xxl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n  .my-xxl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n  .my-xxl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n  .my-xxl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n  .my-xxl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n  .my-xxl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n  .my-xxl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n  .my-xxl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n  .my-xxl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n  .my-xxl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n  .my-xxl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n  .my-xxl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n  .my-xxl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n  .mt-xxl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mt-xxl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mt-xxl-n3 {\n    margin-top: -0.75rem !important;\n  }\n  .mt-xxl-n4 {\n    margin-top: -1rem !important;\n  }\n  .mt-xxl-n5 {\n    margin-top: -1.25rem !important;\n  }\n  .mt-xxl-n6 {\n    margin-top: -1.5rem !important;\n  }\n  .mt-xxl-n7 {\n    margin-top: -1.75rem !important;\n  }\n  .mt-xxl-n8 {\n    margin-top: -2rem !important;\n  }\n  .mt-xxl-n9 {\n    margin-top: -2.25rem !important;\n  }\n  .mt-xxl-n10 {\n    margin-top: -2.5rem !important;\n  }\n  .mt-xxl-n11 {\n    margin-top: -2.75rem !important;\n  }\n  .mt-xxl-n12 {\n    margin-top: -3rem !important;\n  }\n  .mt-xxl-n13 {\n    margin-top: -3.25rem !important;\n  }\n  .mt-xxl-n14 {\n    margin-top: -3.5rem !important;\n  }\n  .mt-xxl-n15 {\n    margin-top: -3.75rem !important;\n  }\n  .mt-xxl-n16 {\n    margin-top: -4rem !important;\n  }\n  .mt-xxl-n17 {\n    margin-top: -4.25rem !important;\n  }\n  .mt-xxl-n18 {\n    margin-top: -4.5rem !important;\n  }\n  .mt-xxl-n19 {\n    margin-top: -4.75rem !important;\n  }\n  .mt-xxl-n20 {\n    margin-top: -5rem !important;\n  }\n  .me-xxl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .me-xxl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .me-xxl-n3 {\n    margin-right: -0.75rem !important;\n  }\n  .me-xxl-n4 {\n    margin-right: -1rem !important;\n  }\n  .me-xxl-n5 {\n    margin-right: -1.25rem !important;\n  }\n  .me-xxl-n6 {\n    margin-right: -1.5rem !important;\n  }\n  .me-xxl-n7 {\n    margin-right: -1.75rem !important;\n  }\n  .me-xxl-n8 {\n    margin-right: -2rem !important;\n  }\n  .me-xxl-n9 {\n    margin-right: -2.25rem !important;\n  }\n  .me-xxl-n10 {\n    margin-right: -2.5rem !important;\n  }\n  .me-xxl-n11 {\n    margin-right: -2.75rem !important;\n  }\n  .me-xxl-n12 {\n    margin-right: -3rem !important;\n  }\n  .me-xxl-n13 {\n    margin-right: -3.25rem !important;\n  }\n  .me-xxl-n14 {\n    margin-right: -3.5rem !important;\n  }\n  .me-xxl-n15 {\n    margin-right: -3.75rem !important;\n  }\n  .me-xxl-n16 {\n    margin-right: -4rem !important;\n  }\n  .me-xxl-n17 {\n    margin-right: -4.25rem !important;\n  }\n  .me-xxl-n18 {\n    margin-right: -4.5rem !important;\n  }\n  .me-xxl-n19 {\n    margin-right: -4.75rem !important;\n  }\n  .me-xxl-n20 {\n    margin-right: -5rem !important;\n  }\n  .mb-xxl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .mb-xxl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .mb-xxl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n  .mb-xxl-n4 {\n    margin-bottom: -1rem !important;\n  }\n  .mb-xxl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n  .mb-xxl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n  .mb-xxl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n  .mb-xxl-n8 {\n    margin-bottom: -2rem !important;\n  }\n  .mb-xxl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n  .mb-xxl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n  .mb-xxl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n  .mb-xxl-n12 {\n    margin-bottom: -3rem !important;\n  }\n  .mb-xxl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n  .mb-xxl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n  .mb-xxl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n  .mb-xxl-n16 {\n    margin-bottom: -4rem !important;\n  }\n  .mb-xxl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n  .mb-xxl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n  .mb-xxl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n  .mb-xxl-n20 {\n    margin-bottom: -5rem !important;\n  }\n  .ms-xxl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .ms-xxl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .ms-xxl-n3 {\n    margin-left: -0.75rem !important;\n  }\n  .ms-xxl-n4 {\n    margin-left: -1rem !important;\n  }\n  .ms-xxl-n5 {\n    margin-left: -1.25rem !important;\n  }\n  .ms-xxl-n6 {\n    margin-left: -1.5rem !important;\n  }\n  .ms-xxl-n7 {\n    margin-left: -1.75rem !important;\n  }\n  .ms-xxl-n8 {\n    margin-left: -2rem !important;\n  }\n  .ms-xxl-n9 {\n    margin-left: -2.25rem !important;\n  }\n  .ms-xxl-n10 {\n    margin-left: -2.5rem !important;\n  }\n  .ms-xxl-n11 {\n    margin-left: -2.75rem !important;\n  }\n  .ms-xxl-n12 {\n    margin-left: -3rem !important;\n  }\n  .ms-xxl-n13 {\n    margin-left: -3.25rem !important;\n  }\n  .ms-xxl-n14 {\n    margin-left: -3.5rem !important;\n  }\n  .ms-xxl-n15 {\n    margin-left: -3.75rem !important;\n  }\n  .ms-xxl-n16 {\n    margin-left: -4rem !important;\n  }\n  .ms-xxl-n17 {\n    margin-left: -4.25rem !important;\n  }\n  .ms-xxl-n18 {\n    margin-left: -4.5rem !important;\n  }\n  .ms-xxl-n19 {\n    margin-left: -4.75rem !important;\n  }\n  .ms-xxl-n20 {\n    margin-left: -5rem !important;\n  }\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n  .p-xxl-3 {\n    padding: 0.75rem !important;\n  }\n  .p-xxl-4 {\n    padding: 1rem !important;\n  }\n  .p-xxl-5 {\n    padding: 1.25rem !important;\n  }\n  .p-xxl-6 {\n    padding: 1.5rem !important;\n  }\n  .p-xxl-7 {\n    padding: 1.75rem !important;\n  }\n  .p-xxl-8 {\n    padding: 2rem !important;\n  }\n  .p-xxl-9 {\n    padding: 2.25rem !important;\n  }\n  .p-xxl-10 {\n    padding: 2.5rem !important;\n  }\n  .p-xxl-11 {\n    padding: 2.75rem !important;\n  }\n  .p-xxl-12 {\n    padding: 3rem !important;\n  }\n  .p-xxl-13 {\n    padding: 3.25rem !important;\n  }\n  .p-xxl-14 {\n    padding: 3.5rem !important;\n  }\n  .p-xxl-15 {\n    padding: 3.75rem !important;\n  }\n  .p-xxl-16 {\n    padding: 4rem !important;\n  }\n  .p-xxl-17 {\n    padding: 4.25rem !important;\n  }\n  .p-xxl-18 {\n    padding: 4.5rem !important;\n  }\n  .p-xxl-19 {\n    padding: 4.75rem !important;\n  }\n  .p-xxl-20 {\n    padding: 5rem !important;\n  }\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n  .px-xxl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n  .px-xxl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n  .px-xxl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n  .px-xxl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n  .px-xxl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n  .px-xxl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n  .px-xxl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n  .px-xxl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n  .px-xxl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n  .px-xxl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n  .px-xxl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n  .px-xxl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n  .px-xxl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n  .px-xxl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n  .px-xxl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n  .px-xxl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n  .px-xxl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n  .px-xxl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n  .py-xxl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n  .py-xxl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n  .py-xxl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n  .py-xxl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n  .py-xxl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n  .py-xxl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n  .py-xxl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n  .py-xxl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n  .py-xxl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n  .py-xxl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n  .py-xxl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n  .py-xxl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n  .py-xxl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n  .py-xxl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n  .py-xxl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n  .py-xxl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n  .py-xxl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n  .py-xxl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pt-xxl-3 {\n    padding-top: 0.75rem !important;\n  }\n  .pt-xxl-4 {\n    padding-top: 1rem !important;\n  }\n  .pt-xxl-5 {\n    padding-top: 1.25rem !important;\n  }\n  .pt-xxl-6 {\n    padding-top: 1.5rem !important;\n  }\n  .pt-xxl-7 {\n    padding-top: 1.75rem !important;\n  }\n  .pt-xxl-8 {\n    padding-top: 2rem !important;\n  }\n  .pt-xxl-9 {\n    padding-top: 2.25rem !important;\n  }\n  .pt-xxl-10 {\n    padding-top: 2.5rem !important;\n  }\n  .pt-xxl-11 {\n    padding-top: 2.75rem !important;\n  }\n  .pt-xxl-12 {\n    padding-top: 3rem !important;\n  }\n  .pt-xxl-13 {\n    padding-top: 3.25rem !important;\n  }\n  .pt-xxl-14 {\n    padding-top: 3.5rem !important;\n  }\n  .pt-xxl-15 {\n    padding-top: 3.75rem !important;\n  }\n  .pt-xxl-16 {\n    padding-top: 4rem !important;\n  }\n  .pt-xxl-17 {\n    padding-top: 4.25rem !important;\n  }\n  .pt-xxl-18 {\n    padding-top: 4.5rem !important;\n  }\n  .pt-xxl-19 {\n    padding-top: 4.75rem !important;\n  }\n  .pt-xxl-20 {\n    padding-top: 5rem !important;\n  }\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pe-xxl-3 {\n    padding-right: 0.75rem !important;\n  }\n  .pe-xxl-4 {\n    padding-right: 1rem !important;\n  }\n  .pe-xxl-5 {\n    padding-right: 1.25rem !important;\n  }\n  .pe-xxl-6 {\n    padding-right: 1.5rem !important;\n  }\n  .pe-xxl-7 {\n    padding-right: 1.75rem !important;\n  }\n  .pe-xxl-8 {\n    padding-right: 2rem !important;\n  }\n  .pe-xxl-9 {\n    padding-right: 2.25rem !important;\n  }\n  .pe-xxl-10 {\n    padding-right: 2.5rem !important;\n  }\n  .pe-xxl-11 {\n    padding-right: 2.75rem !important;\n  }\n  .pe-xxl-12 {\n    padding-right: 3rem !important;\n  }\n  .pe-xxl-13 {\n    padding-right: 3.25rem !important;\n  }\n  .pe-xxl-14 {\n    padding-right: 3.5rem !important;\n  }\n  .pe-xxl-15 {\n    padding-right: 3.75rem !important;\n  }\n  .pe-xxl-16 {\n    padding-right: 4rem !important;\n  }\n  .pe-xxl-17 {\n    padding-right: 4.25rem !important;\n  }\n  .pe-xxl-18 {\n    padding-right: 4.5rem !important;\n  }\n  .pe-xxl-19 {\n    padding-right: 4.75rem !important;\n  }\n  .pe-xxl-20 {\n    padding-right: 5rem !important;\n  }\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pb-xxl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n  .pb-xxl-4 {\n    padding-bottom: 1rem !important;\n  }\n  .pb-xxl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n  .pb-xxl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pb-xxl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n  .pb-xxl-8 {\n    padding-bottom: 2rem !important;\n  }\n  .pb-xxl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n  .pb-xxl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pb-xxl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n  .pb-xxl-12 {\n    padding-bottom: 3rem !important;\n  }\n  .pb-xxl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n  .pb-xxl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pb-xxl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n  .pb-xxl-16 {\n    padding-bottom: 4rem !important;\n  }\n  .pb-xxl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n  .pb-xxl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pb-xxl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n  .pb-xxl-20 {\n    padding-bottom: 5rem !important;\n  }\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .ps-xxl-3 {\n    padding-left: 0.75rem !important;\n  }\n  .ps-xxl-4 {\n    padding-left: 1rem !important;\n  }\n  .ps-xxl-5 {\n    padding-left: 1.25rem !important;\n  }\n  .ps-xxl-6 {\n    padding-left: 1.5rem !important;\n  }\n  .ps-xxl-7 {\n    padding-left: 1.75rem !important;\n  }\n  .ps-xxl-8 {\n    padding-left: 2rem !important;\n  }\n  .ps-xxl-9 {\n    padding-left: 2.25rem !important;\n  }\n  .ps-xxl-10 {\n    padding-left: 2.5rem !important;\n  }\n  .ps-xxl-11 {\n    padding-left: 2.75rem !important;\n  }\n  .ps-xxl-12 {\n    padding-left: 3rem !important;\n  }\n  .ps-xxl-13 {\n    padding-left: 3.25rem !important;\n  }\n  .ps-xxl-14 {\n    padding-left: 3.5rem !important;\n  }\n  .ps-xxl-15 {\n    padding-left: 3.75rem !important;\n  }\n  .ps-xxl-16 {\n    padding-left: 4rem !important;\n  }\n  .ps-xxl-17 {\n    padding-left: 4.25rem !important;\n  }\n  .ps-xxl-18 {\n    padding-left: 4.5rem !important;\n  }\n  .ps-xxl-19 {\n    padding-left: 4.75rem !important;\n  }\n  .ps-xxl-20 {\n    padding-left: 5rem !important;\n  }\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n  .gap-xxl-3 {\n    gap: 0.75rem !important;\n  }\n  .gap-xxl-4 {\n    gap: 1rem !important;\n  }\n  .gap-xxl-5 {\n    gap: 1.25rem !important;\n  }\n  .gap-xxl-6 {\n    gap: 1.5rem !important;\n  }\n  .gap-xxl-7 {\n    gap: 1.75rem !important;\n  }\n  .gap-xxl-8 {\n    gap: 2rem !important;\n  }\n  .gap-xxl-9 {\n    gap: 2.25rem !important;\n  }\n  .gap-xxl-10 {\n    gap: 2.5rem !important;\n  }\n  .gap-xxl-11 {\n    gap: 2.75rem !important;\n  }\n  .gap-xxl-12 {\n    gap: 3rem !important;\n  }\n  .gap-xxl-13 {\n    gap: 3.25rem !important;\n  }\n  .gap-xxl-14 {\n    gap: 3.5rem !important;\n  }\n  .gap-xxl-15 {\n    gap: 3.75rem !important;\n  }\n  .gap-xxl-16 {\n    gap: 4rem !important;\n  }\n  .gap-xxl-17 {\n    gap: 4.25rem !important;\n  }\n  .gap-xxl-18 {\n    gap: 4.5rem !important;\n  }\n  .gap-xxl-19 {\n    gap: 4.75rem !important;\n  }\n  .gap-xxl-20 {\n    gap: 5rem !important;\n  }\n  .row-gap-xxl-0 {\n    row-gap: 0 !important;\n  }\n  .row-gap-xxl-1 {\n    row-gap: 0.25rem !important;\n  }\n  .row-gap-xxl-2 {\n    row-gap: 0.5rem !important;\n  }\n  .row-gap-xxl-3 {\n    row-gap: 0.75rem !important;\n  }\n  .row-gap-xxl-4 {\n    row-gap: 1rem !important;\n  }\n  .row-gap-xxl-5 {\n    row-gap: 1.25rem !important;\n  }\n  .row-gap-xxl-6 {\n    row-gap: 1.5rem !important;\n  }\n  .row-gap-xxl-7 {\n    row-gap: 1.75rem !important;\n  }\n  .row-gap-xxl-8 {\n    row-gap: 2rem !important;\n  }\n  .row-gap-xxl-9 {\n    row-gap: 2.25rem !important;\n  }\n  .row-gap-xxl-10 {\n    row-gap: 2.5rem !important;\n  }\n  .row-gap-xxl-11 {\n    row-gap: 2.75rem !important;\n  }\n  .row-gap-xxl-12 {\n    row-gap: 3rem !important;\n  }\n  .row-gap-xxl-13 {\n    row-gap: 3.25rem !important;\n  }\n  .row-gap-xxl-14 {\n    row-gap: 3.5rem !important;\n  }\n  .row-gap-xxl-15 {\n    row-gap: 3.75rem !important;\n  }\n  .row-gap-xxl-16 {\n    row-gap: 4rem !important;\n  }\n  .row-gap-xxl-17 {\n    row-gap: 4.25rem !important;\n  }\n  .row-gap-xxl-18 {\n    row-gap: 4.5rem !important;\n  }\n  .row-gap-xxl-19 {\n    row-gap: 4.75rem !important;\n  }\n  .row-gap-xxl-20 {\n    row-gap: 5rem !important;\n  }\n  .column-gap-xxl-0 {\n    column-gap: 0 !important;\n  }\n  .column-gap-xxl-1 {\n    column-gap: 0.25rem !important;\n  }\n  .column-gap-xxl-2 {\n    column-gap: 0.5rem !important;\n  }\n  .column-gap-xxl-3 {\n    column-gap: 0.75rem !important;\n  }\n  .column-gap-xxl-4 {\n    column-gap: 1rem !important;\n  }\n  .column-gap-xxl-5 {\n    column-gap: 1.25rem !important;\n  }\n  .column-gap-xxl-6 {\n    column-gap: 1.5rem !important;\n  }\n  .column-gap-xxl-7 {\n    column-gap: 1.75rem !important;\n  }\n  .column-gap-xxl-8 {\n    column-gap: 2rem !important;\n  }\n  .column-gap-xxl-9 {\n    column-gap: 2.25rem !important;\n  }\n  .column-gap-xxl-10 {\n    column-gap: 2.5rem !important;\n  }\n  .column-gap-xxl-11 {\n    column-gap: 2.75rem !important;\n  }\n  .column-gap-xxl-12 {\n    column-gap: 3rem !important;\n  }\n  .column-gap-xxl-13 {\n    column-gap: 3.25rem !important;\n  }\n  .column-gap-xxl-14 {\n    column-gap: 3.5rem !important;\n  }\n  .column-gap-xxl-15 {\n    column-gap: 3.75rem !important;\n  }\n  .column-gap-xxl-16 {\n    column-gap: 4rem !important;\n  }\n  .column-gap-xxl-17 {\n    column-gap: 4.25rem !important;\n  }\n  .column-gap-xxl-18 {\n    column-gap: 4.5rem !important;\n  }\n  .column-gap-xxl-19 {\n    column-gap: 4.75rem !important;\n  }\n  .column-gap-xxl-20 {\n    column-gap: 5rem !important;\n  }\n  .fs-xxl-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n  .fs-xxl-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n  .fs-xxl-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n  .fs-xxl-4 {\n    font-size: 1.25rem !important;\n  }\n  .fs-xxl-5 {\n    font-size: 1.15rem !important;\n  }\n  .fs-xxl-6 {\n    font-size: 1.075rem !important;\n  }\n  .fs-xxl-7 {\n    font-size: 0.95rem !important;\n  }\n  .fs-xxl-8 {\n    font-size: 0.85rem !important;\n  }\n  .fs-xxl-9 {\n    font-size: 0.75rem !important;\n  }\n  .fs-xxl-10 {\n    font-size: 0.5rem !important;\n  }\n  .fs-xxl-sm {\n    font-size: 0.95rem !important;\n  }\n  .fs-xxl-base {\n    font-size: 1rem !important;\n  }\n  .fs-xxl-lg {\n    font-size: 1.075rem !important;\n  }\n  .fs-xxl-xl {\n    font-size: 1.21rem !important;\n  }\n  .fs-xxl-fluid {\n    font-size: 100% !important;\n  }\n  .fs-xxl-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n  .fs-xxl-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n  .fs-xxl-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n  .fs-xxl-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n  .fs-xxl-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n  .fs-xxl-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n  .fs-xxl-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n  .fs-xxl-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n  .fs-xxl-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n  .fs-xxl-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n  .fs-xxl-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n  .fs-xxl-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n  .fs-xxl-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n  .fs-xxl-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n  .fs-xxl-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n  .fs-xxl-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n  .fs-xxl-6x {\n    font-size: calc(1.725rem + 5.7vw) !important;\n  }\n  .fs-xxl-6qx {\n    font-size: calc(1.75rem + 6vw) !important;\n  }\n  .fs-xxl-6hx {\n    font-size: calc(1.775rem + 6.3vw) !important;\n  }\n  .fs-xxl-6tx {\n    font-size: calc(1.8rem + 6.6vw) !important;\n  }\n  .fs-xxl-7x {\n    font-size: calc(1.825rem + 6.9vw) !important;\n  }\n  .fs-xxl-7qx {\n    font-size: calc(1.85rem + 7.2vw) !important;\n  }\n  .fs-xxl-7hx {\n    font-size: calc(1.875rem + 7.5vw) !important;\n  }\n  .fs-xxl-7tx {\n    font-size: calc(1.9rem + 7.8vw) !important;\n  }\n  .text-xxl-start {\n    text-align: left !important;\n  }\n  .text-xxl-end {\n    text-align: right !important;\n  }\n  .text-xxl-center {\n    text-align: center !important;\n  }\n  .min-w-xxl-unset {\n    min-width: unset !important;\n  }\n  .min-w-xxl-25 {\n    min-width: 25% !important;\n  }\n  .min-w-xxl-50 {\n    min-width: 50% !important;\n  }\n  .min-w-xxl-75 {\n    min-width: 75% !important;\n  }\n  .min-w-xxl-100 {\n    min-width: 100% !important;\n  }\n  .min-w-xxl-auto {\n    min-width: auto !important;\n  }\n  .min-w-xxl-1px {\n    min-width: 1px !important;\n  }\n  .min-w-xxl-2px {\n    min-width: 2px !important;\n  }\n  .min-w-xxl-3px {\n    min-width: 3px !important;\n  }\n  .min-w-xxl-4px {\n    min-width: 4px !important;\n  }\n  .min-w-xxl-5px {\n    min-width: 5px !important;\n  }\n  .min-w-xxl-6px {\n    min-width: 6px !important;\n  }\n  .min-w-xxl-7px {\n    min-width: 7px !important;\n  }\n  .min-w-xxl-8px {\n    min-width: 8px !important;\n  }\n  .min-w-xxl-9px {\n    min-width: 9px !important;\n  }\n  .min-w-xxl-10px {\n    min-width: 10px !important;\n  }\n  .min-w-xxl-15px {\n    min-width: 15px !important;\n  }\n  .min-w-xxl-20px {\n    min-width: 20px !important;\n  }\n  .min-w-xxl-25px {\n    min-width: 25px !important;\n  }\n  .min-w-xxl-30px {\n    min-width: 30px !important;\n  }\n  .min-w-xxl-35px {\n    min-width: 35px !important;\n  }\n  .min-w-xxl-40px {\n    min-width: 40px !important;\n  }\n  .min-w-xxl-45px {\n    min-width: 45px !important;\n  }\n  .min-w-xxl-50px {\n    min-width: 50px !important;\n  }\n  .min-w-xxl-55px {\n    min-width: 55px !important;\n  }\n  .min-w-xxl-60px {\n    min-width: 60px !important;\n  }\n  .min-w-xxl-65px {\n    min-width: 65px !important;\n  }\n  .min-w-xxl-70px {\n    min-width: 70px !important;\n  }\n  .min-w-xxl-75px {\n    min-width: 75px !important;\n  }\n  .min-w-xxl-80px {\n    min-width: 80px !important;\n  }\n  .min-w-xxl-85px {\n    min-width: 85px !important;\n  }\n  .min-w-xxl-90px {\n    min-width: 90px !important;\n  }\n  .min-w-xxl-95px {\n    min-width: 95px !important;\n  }\n  .min-w-xxl-100px {\n    min-width: 100px !important;\n  }\n  .min-w-xxl-125px {\n    min-width: 125px !important;\n  }\n  .min-w-xxl-150px {\n    min-width: 150px !important;\n  }\n  .min-w-xxl-175px {\n    min-width: 175px !important;\n  }\n  .min-w-xxl-200px {\n    min-width: 200px !important;\n  }\n  .min-w-xxl-225px {\n    min-width: 225px !important;\n  }\n  .min-w-xxl-250px {\n    min-width: 250px !important;\n  }\n  .min-w-xxl-275px {\n    min-width: 275px !important;\n  }\n  .min-w-xxl-300px {\n    min-width: 300px !important;\n  }\n  .min-w-xxl-325px {\n    min-width: 325px !important;\n  }\n  .min-w-xxl-350px {\n    min-width: 350px !important;\n  }\n  .min-w-xxl-375px {\n    min-width: 375px !important;\n  }\n  .min-w-xxl-400px {\n    min-width: 400px !important;\n  }\n  .min-w-xxl-425px {\n    min-width: 425px !important;\n  }\n  .min-w-xxl-450px {\n    min-width: 450px !important;\n  }\n  .min-w-xxl-475px {\n    min-width: 475px !important;\n  }\n  .min-w-xxl-500px {\n    min-width: 500px !important;\n  }\n  .min-w-xxl-550px {\n    min-width: 550px !important;\n  }\n  .min-w-xxl-600px {\n    min-width: 600px !important;\n  }\n  .min-w-xxl-650px {\n    min-width: 650px !important;\n  }\n  .min-w-xxl-700px {\n    min-width: 700px !important;\n  }\n  .min-w-xxl-750px {\n    min-width: 750px !important;\n  }\n  .min-w-xxl-800px {\n    min-width: 800px !important;\n  }\n  .min-w-xxl-850px {\n    min-width: 850px !important;\n  }\n  .min-w-xxl-900px {\n    min-width: 900px !important;\n  }\n  .min-w-xxl-950px {\n    min-width: 950px !important;\n  }\n  .min-w-xxl-1000px {\n    min-width: 1000px !important;\n  }\n  .min-h-xxl-unset {\n    min-height: unset !important;\n  }\n  .min-h-xxl-25 {\n    min-height: 25% !important;\n  }\n  .min-h-xxl-50 {\n    min-height: 50% !important;\n  }\n  .min-h-xxl-75 {\n    min-height: 75% !important;\n  }\n  .min-h-xxl-100 {\n    min-height: 100% !important;\n  }\n  .min-h-xxl-auto {\n    min-height: auto !important;\n  }\n  .min-h-xxl-1px {\n    min-height: 1px !important;\n  }\n  .min-h-xxl-2px {\n    min-height: 2px !important;\n  }\n  .min-h-xxl-3px {\n    min-height: 3px !important;\n  }\n  .min-h-xxl-4px {\n    min-height: 4px !important;\n  }\n  .min-h-xxl-5px {\n    min-height: 5px !important;\n  }\n  .min-h-xxl-6px {\n    min-height: 6px !important;\n  }\n  .min-h-xxl-7px {\n    min-height: 7px !important;\n  }\n  .min-h-xxl-8px {\n    min-height: 8px !important;\n  }\n  .min-h-xxl-9px {\n    min-height: 9px !important;\n  }\n  .min-h-xxl-10px {\n    min-height: 10px !important;\n  }\n  .min-h-xxl-15px {\n    min-height: 15px !important;\n  }\n  .min-h-xxl-20px {\n    min-height: 20px !important;\n  }\n  .min-h-xxl-25px {\n    min-height: 25px !important;\n  }\n  .min-h-xxl-30px {\n    min-height: 30px !important;\n  }\n  .min-h-xxl-35px {\n    min-height: 35px !important;\n  }\n  .min-h-xxl-40px {\n    min-height: 40px !important;\n  }\n  .min-h-xxl-45px {\n    min-height: 45px !important;\n  }\n  .min-h-xxl-50px {\n    min-height: 50px !important;\n  }\n  .min-h-xxl-55px {\n    min-height: 55px !important;\n  }\n  .min-h-xxl-60px {\n    min-height: 60px !important;\n  }\n  .min-h-xxl-65px {\n    min-height: 65px !important;\n  }\n  .min-h-xxl-70px {\n    min-height: 70px !important;\n  }\n  .min-h-xxl-75px {\n    min-height: 75px !important;\n  }\n  .min-h-xxl-80px {\n    min-height: 80px !important;\n  }\n  .min-h-xxl-85px {\n    min-height: 85px !important;\n  }\n  .min-h-xxl-90px {\n    min-height: 90px !important;\n  }\n  .min-h-xxl-95px {\n    min-height: 95px !important;\n  }\n  .min-h-xxl-100px {\n    min-height: 100px !important;\n  }\n  .min-h-xxl-125px {\n    min-height: 125px !important;\n  }\n  .min-h-xxl-150px {\n    min-height: 150px !important;\n  }\n  .min-h-xxl-175px {\n    min-height: 175px !important;\n  }\n  .min-h-xxl-200px {\n    min-height: 200px !important;\n  }\n  .min-h-xxl-225px {\n    min-height: 225px !important;\n  }\n  .min-h-xxl-250px {\n    min-height: 250px !important;\n  }\n  .min-h-xxl-275px {\n    min-height: 275px !important;\n  }\n  .min-h-xxl-300px {\n    min-height: 300px !important;\n  }\n  .min-h-xxl-325px {\n    min-height: 325px !important;\n  }\n  .min-h-xxl-350px {\n    min-height: 350px !important;\n  }\n  .min-h-xxl-375px {\n    min-height: 375px !important;\n  }\n  .min-h-xxl-400px {\n    min-height: 400px !important;\n  }\n  .min-h-xxl-425px {\n    min-height: 425px !important;\n  }\n  .min-h-xxl-450px {\n    min-height: 450px !important;\n  }\n  .min-h-xxl-475px {\n    min-height: 475px !important;\n  }\n  .min-h-xxl-500px {\n    min-height: 500px !important;\n  }\n  .min-h-xxl-550px {\n    min-height: 550px !important;\n  }\n  .min-h-xxl-600px {\n    min-height: 600px !important;\n  }\n  .min-h-xxl-650px {\n    min-height: 650px !important;\n  }\n  .min-h-xxl-700px {\n    min-height: 700px !important;\n  }\n  .min-h-xxl-750px {\n    min-height: 750px !important;\n  }\n  .min-h-xxl-800px {\n    min-height: 800px !important;\n  }\n  .min-h-xxl-850px {\n    min-height: 850px !important;\n  }\n  .min-h-xxl-900px {\n    min-height: 900px !important;\n  }\n  .min-h-xxl-950px {\n    min-height: 950px !important;\n  }\n  .min-h-xxl-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 1.75rem !important;\n  }\n  .fs-2 {\n    font-size: 1.5rem !important;\n  }\n  .fs-3 {\n    font-size: 1.35rem !important;\n  }\n  .fs-2x {\n    font-size: 2rem !important;\n  }\n  .fs-2qx {\n    font-size: 2.25rem !important;\n  }\n  .fs-2hx {\n    font-size: 2.5rem !important;\n  }\n  .fs-2tx {\n    font-size: 2.75rem !important;\n  }\n  .fs-3x {\n    font-size: 3rem !important;\n  }\n  .fs-3qx {\n    font-size: 3.25rem !important;\n  }\n  .fs-3hx {\n    font-size: 3.5rem !important;\n  }\n  .fs-3tx {\n    font-size: 3.75rem !important;\n  }\n  .fs-4x {\n    font-size: 4rem !important;\n  }\n  .fs-4qx {\n    font-size: 4.25rem !important;\n  }\n  .fs-4hx {\n    font-size: 4.5rem !important;\n  }\n  .fs-4tx {\n    font-size: 4.75rem !important;\n  }\n  .fs-5x {\n    font-size: 5rem !important;\n  }\n  .fs-5qx {\n    font-size: 5.25rem !important;\n  }\n  .fs-5hx {\n    font-size: 5.5rem !important;\n  }\n  .fs-5tx {\n    font-size: 5.75rem !important;\n  }\n  .fs-6x {\n    font-size: 6rem !important;\n  }\n  .fs-6qx {\n    font-size: 6.25rem !important;\n  }\n  .fs-6hx {\n    font-size: 6.5rem !important;\n  }\n  .fs-6tx {\n    font-size: 6.75rem !important;\n  }\n  .fs-7x {\n    font-size: 7rem !important;\n  }\n  .fs-7qx {\n    font-size: 7.25rem !important;\n  }\n  .fs-7hx {\n    font-size: 7.5rem !important;\n  }\n  .fs-7tx {\n    font-size: 7.75rem !important;\n  }\n  .fs-sm-1 {\n    font-size: 1.75rem !important;\n  }\n  .fs-sm-2 {\n    font-size: 1.5rem !important;\n  }\n  .fs-sm-3 {\n    font-size: 1.35rem !important;\n  }\n  .fs-sm-2x {\n    font-size: 2rem !important;\n  }\n  .fs-sm-2qx {\n    font-size: 2.25rem !important;\n  }\n  .fs-sm-2hx {\n    font-size: 2.5rem !important;\n  }\n  .fs-sm-2tx {\n    font-size: 2.75rem !important;\n  }\n  .fs-sm-3x {\n    font-size: 3rem !important;\n  }\n  .fs-sm-3qx {\n    font-size: 3.25rem !important;\n  }\n  .fs-sm-3hx {\n    font-size: 3.5rem !important;\n  }\n  .fs-sm-3tx {\n    font-size: 3.75rem !important;\n  }\n  .fs-sm-4x {\n    font-size: 4rem !important;\n  }\n  .fs-sm-4qx {\n    font-size: 4.25rem !important;\n  }\n  .fs-sm-4hx {\n    font-size: 4.5rem !important;\n  }\n  .fs-sm-4tx {\n    font-size: 4.75rem !important;\n  }\n  .fs-sm-5x {\n    font-size: 5rem !important;\n  }\n  .fs-sm-5qx {\n    font-size: 5.25rem !important;\n  }\n  .fs-sm-5hx {\n    font-size: 5.5rem !important;\n  }\n  .fs-sm-5tx {\n    font-size: 5.75rem !important;\n  }\n  .fs-sm-6x {\n    font-size: 6rem !important;\n  }\n  .fs-sm-6qx {\n    font-size: 6.25rem !important;\n  }\n  .fs-sm-6hx {\n    font-size: 6.5rem !important;\n  }\n  .fs-sm-6tx {\n    font-size: 6.75rem !important;\n  }\n  .fs-sm-7x {\n    font-size: 7rem !important;\n  }\n  .fs-sm-7qx {\n    font-size: 7.25rem !important;\n  }\n  .fs-sm-7hx {\n    font-size: 7.5rem !important;\n  }\n  .fs-sm-7tx {\n    font-size: 7.75rem !important;\n  }\n  .fs-md-1 {\n    font-size: 1.75rem !important;\n  }\n  .fs-md-2 {\n    font-size: 1.5rem !important;\n  }\n  .fs-md-3 {\n    font-size: 1.35rem !important;\n  }\n  .fs-md-2x {\n    font-size: 2rem !important;\n  }\n  .fs-md-2qx {\n    font-size: 2.25rem !important;\n  }\n  .fs-md-2hx {\n    font-size: 2.5rem !important;\n  }\n  .fs-md-2tx {\n    font-size: 2.75rem !important;\n  }\n  .fs-md-3x {\n    font-size: 3rem !important;\n  }\n  .fs-md-3qx {\n    font-size: 3.25rem !important;\n  }\n  .fs-md-3hx {\n    font-size: 3.5rem !important;\n  }\n  .fs-md-3tx {\n    font-size: 3.75rem !important;\n  }\n  .fs-md-4x {\n    font-size: 4rem !important;\n  }\n  .fs-md-4qx {\n    font-size: 4.25rem !important;\n  }\n  .fs-md-4hx {\n    font-size: 4.5rem !important;\n  }\n  .fs-md-4tx {\n    font-size: 4.75rem !important;\n  }\n  .fs-md-5x {\n    font-size: 5rem !important;\n  }\n  .fs-md-5qx {\n    font-size: 5.25rem !important;\n  }\n  .fs-md-5hx {\n    font-size: 5.5rem !important;\n  }\n  .fs-md-5tx {\n    font-size: 5.75rem !important;\n  }\n  .fs-md-6x {\n    font-size: 6rem !important;\n  }\n  .fs-md-6qx {\n    font-size: 6.25rem !important;\n  }\n  .fs-md-6hx {\n    font-size: 6.5rem !important;\n  }\n  .fs-md-6tx {\n    font-size: 6.75rem !important;\n  }\n  .fs-md-7x {\n    font-size: 7rem !important;\n  }\n  .fs-md-7qx {\n    font-size: 7.25rem !important;\n  }\n  .fs-md-7hx {\n    font-size: 7.5rem !important;\n  }\n  .fs-md-7tx {\n    font-size: 7.75rem !important;\n  }\n  .fs-lg-1 {\n    font-size: 1.75rem !important;\n  }\n  .fs-lg-2 {\n    font-size: 1.5rem !important;\n  }\n  .fs-lg-3 {\n    font-size: 1.35rem !important;\n  }\n  .fs-lg-2x {\n    font-size: 2rem !important;\n  }\n  .fs-lg-2qx {\n    font-size: 2.25rem !important;\n  }\n  .fs-lg-2hx {\n    font-size: 2.5rem !important;\n  }\n  .fs-lg-2tx {\n    font-size: 2.75rem !important;\n  }\n  .fs-lg-3x {\n    font-size: 3rem !important;\n  }\n  .fs-lg-3qx {\n    font-size: 3.25rem !important;\n  }\n  .fs-lg-3hx {\n    font-size: 3.5rem !important;\n  }\n  .fs-lg-3tx {\n    font-size: 3.75rem !important;\n  }\n  .fs-lg-4x {\n    font-size: 4rem !important;\n  }\n  .fs-lg-4qx {\n    font-size: 4.25rem !important;\n  }\n  .fs-lg-4hx {\n    font-size: 4.5rem !important;\n  }\n  .fs-lg-4tx {\n    font-size: 4.75rem !important;\n  }\n  .fs-lg-5x {\n    font-size: 5rem !important;\n  }\n  .fs-lg-5qx {\n    font-size: 5.25rem !important;\n  }\n  .fs-lg-5hx {\n    font-size: 5.5rem !important;\n  }\n  .fs-lg-5tx {\n    font-size: 5.75rem !important;\n  }\n  .fs-lg-6x {\n    font-size: 6rem !important;\n  }\n  .fs-lg-6qx {\n    font-size: 6.25rem !important;\n  }\n  .fs-lg-6hx {\n    font-size: 6.5rem !important;\n  }\n  .fs-lg-6tx {\n    font-size: 6.75rem !important;\n  }\n  .fs-lg-7x {\n    font-size: 7rem !important;\n  }\n  .fs-lg-7qx {\n    font-size: 7.25rem !important;\n  }\n  .fs-lg-7hx {\n    font-size: 7.5rem !important;\n  }\n  .fs-lg-7tx {\n    font-size: 7.75rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-grid {\n    display: grid !important;\n  }\n  .d-print-inline-grid {\n    display: inline-grid !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n  .d-print-none {\n    display: none !important;\n  }\n}\n:root {\n  --bs-xs:0;\n  --bs-sm:576px;\n  --bs-md:768px;\n  --bs-lg:992px;\n  --bs-xl:1200px;\n  --bs-xxl:1400px;\n  --bs-scrollbar-size: 5px;\n  --bs-scrollbar-overlay-size: 19px;\n  --bs-scrollbar-overlay-space: 7px;\n  --bs-white-bg-rgb: 255, 255, 255;\n  --bs-black-bg-rgb: 0, 0, 0;\n}\n\n[data-bs-theme=light] {\n  --bs-text-muted: #99A1B7;\n  --bs-gray-100: #F9F9F9;\n  --bs-gray-100-rgb: 249, 249, 249;\n  --bs-gray-200: #F1F1F4;\n  --bs-gray-200-rgb: 241, 241, 244;\n  --bs-gray-300: #DBDFE9;\n  --bs-gray-300-rgb: 219, 223, 233;\n  --bs-gray-400: #C4CADA;\n  --bs-gray-400-rgb: 196, 202, 218;\n  --bs-gray-500: #99A1B7;\n  --bs-gray-500-rgb: 153, 161, 183;\n  --bs-gray-600: #78829D;\n  --bs-gray-600-rgb: 120, 130, 157;\n  --bs-gray-700: #4B5675;\n  --bs-gray-700-rgb: 75, 86, 117;\n  --bs-gray-800: #252F4A;\n  --bs-gray-800-rgb: 37, 47, 74;\n  --bs-gray-900: #071437;\n  --bs-gray-900-rgb: 7, 20, 55;\n  --bs-light: #F9F9F9;\n  --bs-primary: #1B84FF;\n  --bs-secondary: #F9F9F9;\n  --bs-success: #17C653;\n  --bs-info: #7239EA;\n  --bs-warning: #F6C000;\n  --bs-danger: #F8285A;\n  --bs-dark: #1E2129;\n  --bs-primary-active: #056EE9;\n  --bs-secondary-active: #DBDFE9;\n  --bs-light-active: #FCFCFC;\n  --bs-success-active: #04B440;\n  --bs-info-active: #5014D0;\n  --bs-warning-active: #DEAD00;\n  --bs-danger-active: #D81A48;\n  --bs-dark-active: #111318;\n  --bs-primary-light: #E9F3FF;\n  --bs-secondary-light: #F9F9F9;\n  --bs-success-light: #DFFFEA;\n  --bs-info-light: #F8F5FF;\n  --bs-warning-light: #FFF8DD;\n  --bs-danger-light: #FFEEF3;\n  --bs-dark-light: #F9F9F9;\n  --bs-light-light: #ffffff;\n  --bs-primary-inverse: #ffffff;\n  --bs-secondary-inverse: #252F4A;\n  --bs-light-inverse: #252F4A;\n  --bs-success-inverse: #ffffff;\n  --bs-info-inverse: #ffffff;\n  --bs-warning-inverse: #ffffff;\n  --bs-danger-inverse: #ffffff;\n  --bs-dark-inverse: #ffffff;\n  --bs-primary-clarity: rgba(27, 132, 255, 0.2);\n  --bs-secondary-clarity: rgba(249, 249, 249, 0.2);\n  --bs-success-clarity: rgba(23, 198, 83, 0.2);\n  --bs-info-clarity: rgba(114, 57, 234, 0.2);\n  --bs-warning-clarity: rgba(246, 192, 0, 0.2);\n  --bs-danger-clarity: rgba(248, 40, 90, 0.2);\n  --bs-dark-clarity: rgba(30, 33, 41, 0.2);\n  --bs-light-clarity: rgba(255, 255, 255, 0.2);\n  --bs-light-rgb: 249, 249, 249;\n  --bs-primary-rgb: 27, 132, 255;\n  --bs-secondary-rgb: 249, 249, 249;\n  --bs-success-rgb: 23, 198, 83;\n  --bs-info-rgb: 114, 57, 234;\n  --bs-warning-rgb: 246, 192, 0;\n  --bs-danger-rgb: 248, 40, 90;\n  --bs-dark-rgb: 30, 33, 41;\n  --bs-text-white: #ffffff;\n  --bs-text-primary: #1B84FF;\n  --bs-text-secondary: #F9F9F9;\n  --bs-text-light: #F9F9F9;\n  --bs-text-success: #17C653;\n  --bs-text-info: #7239EA;\n  --bs-text-warning: #F6C000;\n  --bs-text-danger: #F8285A;\n  --bs-text-dark: #1E2129;\n  --bs-text-muted: #99A1B7;\n  --bs-text-gray-100: #F9F9F9;\n  --bs-text-gray-200: #F1F1F4;\n  --bs-text-gray-300: #DBDFE9;\n  --bs-text-gray-400: #C4CADA;\n  --bs-text-gray-500: #99A1B7;\n  --bs-text-gray-600: #78829D;\n  --bs-text-gray-700: #4B5675;\n  --bs-text-gray-800: #252F4A;\n  --bs-text-gray-900: #071437;\n  --bs-border-color: #F1F1F4;\n  --bs-border-dashed-color: #DBDFE9;\n  --bs-component-active-color: #ffffff;\n  --bs-component-active-bg: #1B84FF;\n  --bs-component-hover-color: #1B84FF;\n  --bs-component-hover-bg: #F9F9F9;\n  --bs-component-checked-color: #ffffff;\n  --bs-component-checked-bg: #1B84FF;\n  --bs-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);\n  --bs-input-bg: var(--bs-body-bg);\n  --bs-input-color: var(--bs-gray-700);\n  --bs-input-solid-color: var(--bs-gray-700);\n  --bs-input-solid-bg: var(--bs-gray-100);\n  --bs-input-solid-bg-focus: var(--bs-gray-200);\n  --bs-input-solid-placeholder-color: var(--bs-gray-500);\n  --bs-root-card-box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.03);\n  --bs-root-card-border-color: #F1F1F4;\n  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n  --bs-table-striped-bg: rgba(var(--bs-gray-100-rgb), 0.75);\n  --bs-table-loading-message-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-dropdown-bg: var(--bs-body-bg);\n  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-code-bg: #f1f3f8;\n  --bs-code-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);\n  --bs-code-border-color: transparent;\n  --bs-code-color: #b93993;\n  --bs-symbol-label-color: var(--bs-gray-800);\n  --bs-symbol-label-bg: var(--bs-gray-100);\n  --bs-symbol-border-color: rgba(var(--bs-body-bg), 0.5);\n  --bs-bullet-bg-color: var(--bs-gray-400);\n  --bs-scrolltop-opacity: 0;\n  --bs-scrolltop-opacity-on: 0.3;\n  --bs-scrolltop-opacity-hover: 1;\n  --bs-scrolltop-box-shadow: var(--bs-box-shadow);\n  --bs-scrolltop-bg-color: var(--bs-primary);\n  --bs-scrolltop-bg-color-hover: var(--bs-primary);\n  --bs-scrolltop-icon-color: var(--bs-primary-inverse);\n  --bs-scrolltop-icon-color-hover: var(--bs-primary-inverse);\n  --bs-drawer-box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);\n  --bs-drawer-bg-color: #ffffff;\n  --bs-drawer-overlay-bg-color: rgba(0, 0, 0, 0.2);\n  --bs-menu-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-menu-dropdown-bg-color: var(--bs-body-bg);\n  --bs-menu-heading-color: #99A1B7;\n  --bs-menu-link-color-hover: #1B84FF;\n  --bs-menu-link-color-show: #1B84FF;\n  --bs-menu-link-color-here: #1B84FF;\n  --bs-menu-link-color-active: #1B84FF;\n  --bs-menu-link-bg-color-hover: #F9F9F9;\n  --bs-menu-link-bg-color-show: #F9F9F9;\n  --bs-menu-link-bg-color-here: #F9F9F9;\n  --bs-menu-link-bg-color-active: #F9F9F9;\n  --bs-scrollbar-color: #F1F1F4;\n  --bs-scrollbar-hover-color: #DBDFE9;\n  --bs-overlay-bg: rgba(0, 0, 0, 0.05);\n  --bs-blockui-overlay-bg: rgba(0, 0, 0, 0.05);\n  --bs-rating-color-default: #C4CADA;\n  --bs-rating-color-active: #FFAD0F;\n  --bs-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(30, 33, 41, 0.1);\n  --bs-ribbon-label-bg: #1B84FF;\n  --bs-ribbon-label-border-color: #0053b4;\n  --bs-ribbon-clip-bg: #1E2129;\n  --bs-engage-btn-bg: #ffffff;\n  --bs-engage-btn-box-shadow: 0px 0px 22px #E0E0E0;\n  --bs-engage-btn-border-color: #E8E8E8;\n  --bs-engage-btn-color: #252F4A;\n  --bs-engage-btn-icon-color: #78829D;\n  --bs-engage-btn-color-active: #252F4A;\n}\n\n[data-bs-theme=dark] {\n  --bs-text-muted: #636674;\n  --bs-gray-100: #1B1C22;\n  --bs-gray-100-rgb: 27, 28, 34;\n  --bs-gray-200: #26272F;\n  --bs-gray-200-rgb: 38, 39, 47;\n  --bs-gray-300: #363843;\n  --bs-gray-300-rgb: 54, 56, 67;\n  --bs-gray-400: #464852;\n  --bs-gray-400-rgb: 70, 72, 82;\n  --bs-gray-500: #636674;\n  --bs-gray-500-rgb: 99, 102, 116;\n  --bs-gray-600: #808290;\n  --bs-gray-600-rgb: 128, 130, 144;\n  --bs-gray-700: #9A9CAE;\n  --bs-gray-700-rgb: 154, 156, 174;\n  --bs-gray-800: #B5B7C8;\n  --bs-gray-800-rgb: 181, 183, 200;\n  --bs-gray-900: #F5F5F5;\n  --bs-gray-900-rgb: 245, 245, 245;\n  --bs-light: #1B1C22;\n  --bs-primary: #006AE6;\n  --bs-secondary: #363843;\n  --bs-success: #00A261;\n  --bs-info: #883FFF;\n  --bs-warning: #C59A00;\n  --bs-danger: #E42855;\n  --bs-dark: #272A34;\n  --bs-primary-active: #107EFF;\n  --bs-secondary-active: #464852;\n  --bs-light-active: #1F212A;\n  --bs-success-active: #01BF73;\n  --bs-info-active: #9E63FF;\n  --bs-warning-active: #D9AA00;\n  --bs-danger-active: #FF3767;\n  --bs-dark-active: #2D2F39;\n  --bs-primary-light: #172331;\n  --bs-secondary-light: #363843;\n  --bs-success-light: #1F212A;\n  --bs-info-light: #272134;\n  --bs-warning-light: #242320;\n  --bs-danger-light: #302024;\n  --bs-dark-light: #1E2027;\n  --bs-light-light: #1F212A;\n  --bs-primary-inverse: #ffffff;\n  --bs-secondary-inverse: #ffffff;\n  --bs-light-inverse: #808290;\n  --bs-success-inverse: #ffffff;\n  --bs-info-inverse: #ffffff;\n  --bs-warning-inverse: #ffffff;\n  --bs-danger-inverse: #ffffff;\n  --bs-dark-inverse: #ffffff;\n  --bs-primary-clarity: rgba(0, 106, 230, 0.2);\n  --bs-secondary-clarity: rgba(54, 56, 67, 0.2);\n  --bs-success-clarity: rgba(0, 162, 97, 0.2);\n  --bs-info-clarity: rgba(136, 63, 255, 0.2);\n  --bs-warning-clarity: rgba(197, 154, 0, 0.2);\n  --bs-danger-clarity: rgba(228, 40, 85, 0.2);\n  --bs-dark-clarity: rgba(39, 42, 52, 0.2);\n  --bs-light-clarity: rgba(31, 33, 42, 0.2);\n  --bs-light-rgb: 27, 28, 34;\n  --bs-primary-rgb: 0, 106, 230;\n  --bs-secondary-rgb: 54, 56, 67;\n  --bs-success-rgb: 0, 162, 97;\n  --bs-info-rgb: 136, 63, 255;\n  --bs-warning-rgb: 197, 154, 0;\n  --bs-danger-rgb: 228, 40, 85;\n  --bs-dark-rgb: 39, 42, 52;\n  --bs-text-white: #ffffff;\n  --bs-text-primary: #006AE6;\n  --bs-text-secondary: #363843;\n  --bs-text-light: #1B1C22;\n  --bs-text-success: #00A261;\n  --bs-text-info: #883FFF;\n  --bs-text-warning: #C59A00;\n  --bs-text-danger: #E42855;\n  --bs-text-dark: #272A34;\n  --bs-text-muted: #636674;\n  --bs-text-gray-100: #1B1C22;\n  --bs-text-gray-200: #26272F;\n  --bs-text-gray-300: #363843;\n  --bs-text-gray-400: #464852;\n  --bs-text-gray-500: #636674;\n  --bs-text-gray-600: #808290;\n  --bs-text-gray-700: #9A9CAE;\n  --bs-text-gray-800: #B5B7C8;\n  --bs-text-gray-900: #F5F5F5;\n  --bs-border-color: #26272F;\n  --bs-border-dashed-color: #363843;\n  --bs-component-active-color: #ffffff;\n  --bs-component-active-bg: #006AE6;\n  --bs-component-hover-color: #006AE6;\n  --bs-component-hover-bg: #1B1C22;\n  --bs-component-checked-color: #ffffff;\n  --bs-component-checked-bg: #006AE6;\n  --bs-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --bs-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);\n  --bs-input-color: var(--bs-gray-700);\n  --bs-input-bg: var(--bs-body-bg);\n  --bs-input-solid-color: var(--bs-gray-700);\n  --bs-input-solid-bg: var(--bs-gray-100);\n  --bs-input-solid-bg-focus: var(--bs-gray-200);\n  --bs-input-solid-placeholder-color: var(--bs-gray-500);\n  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n  --bs-root-card-box-shadow: none;\n  --bs-root-card-border-color: #1E2027;\n  --bs-table-striped-bg: rgba(27, 28, 34, 0.75);\n  --bs-table-loading-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-dropdown-bg: #1C1D22;\n  --bs-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-code-bg: #2b2b40;\n  --bs-code-shadow: rgba(0, 0, 0, 0.08) 0px 3px 9px 0px;\n  --bs-code-border-color: transparent;\n  --bs-code-color: #b93993;\n  --bs-symbol-label-color: #B5B7C8;\n  --bs-symbol-label-bg: #1B1C22;\n  --bs-symbol-border-color: rgba(255, 255, 255, 0.5);\n  --bs-bullet-bg-color: #464852;\n  --bs-scrolltop-opacity: 0;\n  --bs-scrolltop-opacity-on: 0.3;\n  --bs-scrolltop-opacity-hover: 1;\n  --bs-scrolltop-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-scrolltop-bg-color: #1B84FF;\n  --bs-scrolltop-bg-color-hover: #1B84FF;\n  --bs-scrolltop-icon-color: #ffffff;\n  --bs-scrolltop-icon-color-hover: #ffffff;\n  --bs-drawer-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\n  --bs-drawer-bg-color: #1C1D22;\n  --bs-drawer-overlay-bg-color: rgba(0, 0, 0, 0.4);\n  --bs-menu-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-menu-dropdown-bg-color: #1C1D22;\n  --bs-menu-heading-color: #636674;\n  --bs-menu-link-color-hover: #006AE6;\n  --bs-menu-link-color-show: #006AE6;\n  --bs-menu-link-color-here: #006AE6;\n  --bs-menu-link-color-active: #006AE6;\n  --bs-menu-link-bg-color-hover: #1B1C22;\n  --bs-menu-link-bg-color-show: #1B1C22;\n  --bs-menu-link-bg-color-here: #1B1C22;\n  --bs-menu-link-bg-color-active: #1B1C22;\n  --bs-scrollbar-color: #26272F;\n  --bs-scrollbar-hover-color: #363843;\n  --bs-overlay-bg: rgba(255, 255, 255, 0.05);\n  --bs-blockui-overlay-bg: rgba(255, 255, 255, 0.05);\n  --bs-rating-color-default: #464852;\n  --bs-rating-color-active: #FFAD0F;\n  --bs-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(255, 255, 255, 0.1);\n  --bs-ribbon-label-bg: #1B84FF;\n  --bs-ribbon-label-border-color: #0053b4;\n  --bs-ribbon-clip-bg: #F9F9F9;\n  --bs-engage-btn-bg: #26272F;\n  --bs-engage-btn-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-engage-btn-border-color: #26272F;\n  --bs-engage-btn-color: #B5B7C8;\n  --bs-engage-btn-icon-color: #808290;\n  --bs-engage-btn-color-active: #B5B7C8;\n}\n\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n  outline: 0;\n}\n\n.blockquote-footer {\n  color: var(--bs-blockquote-footer-color);\n}\n\n.list-style-none {\n  list-style: none;\n}\n\n[data-kt-theme-mode-switching=true] * {\n  transition: none !important;\n}\n\n[data-bs-theme=light] .theme-dark-show {\n  display: none !important;\n}\n[data-bs-theme=light] .theme-light-bg-transparent {\n  background-color: transparent !important;\n}\n[data-bs-theme=light] .theme-light-bg-body {\n  background-color: var(--bs-body-bg) !important;\n}\n\n[data-bs-theme=dark] .theme-light-show {\n  display: none !important;\n}\n[data-bs-theme=dark] .theme-dark-bg-transparent {\n  background-color: transparent !important;\n}\n[data-bs-theme=dark] .theme-dark-bg-body {\n  background-color: var(--bs-body-bg) !important;\n}\n\n.animation {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n\n@keyframes animationSlideInDown {\n  from {\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.animation-slide-in-down {\n  animation-name: animationSlideInDown;\n}\n\n@keyframes animationSlideInUp {\n  from {\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.animation-slide-in-up {\n  animation-name: animationSlideInUp;\n}\n\n@keyframes animationFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.animation-fade-in {\n  animation-name: animationFadeIn;\n}\n\n@keyframes animationFadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n.animation-fade-out {\n  animation-name: animationFadeOut;\n}\n\n.animation-blink {\n  animation: animationBlink 1s steps(5, start) infinite;\n}\n\n@keyframes animationBlink {\n  to {\n    visibility: hidden;\n  }\n}\n.alert-light {\n  color: var(--bs-light);\n  border-color: var(--bs-light);\n  background-color: var(--bs-light-light);\n}\n.alert-light .alert-link {\n  color: var(--bs-light);\n}\n\n.alert-primary {\n  color: var(--bs-primary);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary-light);\n}\n.alert-primary .alert-link {\n  color: var(--bs-primary);\n}\n\n.alert-secondary {\n  color: var(--bs-secondary);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary-light);\n}\n.alert-secondary .alert-link {\n  color: var(--bs-secondary);\n}\n\n.alert-success {\n  color: var(--bs-success);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success-light);\n}\n.alert-success .alert-link {\n  color: var(--bs-success);\n}\n\n.alert-info {\n  color: var(--bs-info);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info-light);\n}\n.alert-info .alert-link {\n  color: var(--bs-info);\n}\n\n.alert-warning {\n  color: var(--bs-warning);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning-light);\n}\n.alert-warning .alert-link {\n  color: var(--bs-warning);\n}\n\n.alert-danger {\n  color: var(--bs-danger);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger-light);\n}\n.alert-danger .alert-link {\n  color: var(--bs-danger);\n}\n\n.alert-dark {\n  color: var(--bs-dark);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark-light);\n}\n.alert-dark .alert-link {\n  color: var(--bs-dark);\n}\n\n[data-bs-theme=dark] .dropdown-menu {\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n}\n\n.toast .toast-header .btn-close {\n  margin-right: 0;\n}\n\n[data-bs-theme=dark] .toast {\n  --bs-toast-bg: #26272F;\n  --bs-toast-header-bg: #26272F;\n  --bs-toast-header-border-color: #363843;\n}\n\n.nav-pills .nav-item {\n  margin-right: 0.5rem;\n}\n.nav-pills .nav-item:last-child {\n  margin-right: 0;\n}\n\n.nav-stretch {\n  align-items: stretch;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.nav-stretch .nav-item {\n  display: flex;\n  align-items: stretch;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.nav-stretch .nav-link {\n  display: flex;\n  align-items: center;\n}\n\n.nav-group {\n  padding: 0.35rem;\n  border-radius: 0.65rem;\n  background-color: var(--bs-gray-100);\n}\n.nav-group.nav-group-outline {\n  background-color: transparent;\n  border: 1px solid var(--bs-border-color);\n}\n.nav-group.nav-group-fluid {\n  display: flex;\n}\n.nav-group.nav-group-fluid > label,\n.nav-group.nav-group-fluid > .btn {\n  position: relative;\n  flex-shrink: 0;\n  flex-grow: 1;\n  flex-basis: 0;\n}\n.nav-group.nav-group-fluid > label {\n  margin-right: 0.1rem;\n}\n.nav-group.nav-group-fluid > label > .btn {\n  width: 100%;\n}\n.nav-group.nav-group-fluid > label:last-child {\n  margin-right: 0;\n}\n\n.nav-line-tabs {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: var(--bs-border-color);\n}\n.nav-line-tabs .nav-item {\n  margin-bottom: -1px;\n}\n.nav-line-tabs .nav-item .nav-link {\n  color: var(--bs-gray-500);\n  border: 0;\n  border-bottom: 1px solid transparent;\n  transition: color 0.2s ease;\n  padding: 0.5rem 0;\n  margin: 0 1rem;\n}\n.nav-line-tabs .nav-item:first-child .nav-link {\n  margin-left: 0;\n}\n.nav-line-tabs .nav-item:last-child .nav-link {\n  margin-right: 0;\n}\n.nav-line-tabs .nav-item .nav-link.active,\n.nav-line-tabs .nav-item.show .nav-link,\n.nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {\n  background-color: transparent;\n  border: 0;\n  border-bottom: 1px solid var(--bs-primary);\n  transition: color 0.2s ease;\n}\n.nav-line-tabs.nav-line-tabs-2x {\n  border-bottom-width: 2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item {\n  margin-bottom: -2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link {\n  border-bottom-width: 2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active,\n.nav-line-tabs.nav-line-tabs-2x .nav-item.show .nav-link,\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {\n  border-bottom-width: 2px;\n}\n\n.nav.nav-pills.nav-pills-custom .show > .nav-link,\n.nav.nav-pills.nav-pills-custom .nav-link {\n  border: 1px dashed var(--bs-border-dashed-color);\n  border-radius: 0.85rem;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid,\n.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid {\n  border: 3px solid var(--bs-border-dashed-color);\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid.active,\n.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid.active {\n  border: 3px solid var(--bs-primary);\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img {\n  width: 30px;\n  transition: color 0.2s ease;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.default,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.default {\n  display: inline-block;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.active,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.active {\n  display: none;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active,\n.nav.nav-pills.nav-pills-custom .nav-link.active {\n  background-color: transparent;\n  border: 1px solid var(--bs-border-dashed-color);\n  transition-duration: 1ms;\n  position: relative;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active .nav-text,\n.nav.nav-pills.nav-pills-custom .nav-link.active .nav-text {\n  color: var(--bs-gray-800) !important;\n  transition: color 0.2s ease;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active .bullet-custom,\n.nav.nav-pills.nav-pills-custom .nav-link.active .bullet-custom {\n  display: block;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .bullet-custom,\n.nav.nav-pills.nav-pills-custom .nav-link .bullet-custom {\n  display: none;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(1) {\n  color: #B5B5C3;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(2) {\n  color: #3F4254;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(1) {\n  color: #ffffff !important;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(2) {\n  color: #ffffff !important;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(1) {\n  color: #ffffff !important;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(2) {\n  color: #ffffff !important;\n}\n\n.pagination {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 0;\n}\n.pagination.pagination-circle .page-link {\n  border-radius: 50%;\n}\n.pagination.pagination-outline .page-link {\n  border: 1px solid var(--bs-border-color);\n}\n.pagination.pagination-outline .page-item:hover:not(.disabled) .page-link, .pagination.pagination-outline .page-item.active .page-link {\n  border-color: var(--bs-primary-light);\n}\n\n.page-item {\n  margin-right: 0.5rem;\n  /*rtl:end:ignore*/\n}\n.page-item:last-child {\n  margin-right: 0;\n}\n.page-item .page-link {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.65rem;\n  height: 2.5rem;\n  min-width: 2.5rem;\n  font-weight: 500;\n  font-size: 1.075rem;\n  /*rtl:options:{\"autoRename\":false}*/\n  /*rtl:end:ignore*/\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item .page-link i {\n  font-size: 0.85rem;\n}\n.page-item .page-link .previous,\n.page-item .page-link .next {\n  display: block;\n  height: 0.875rem;\n  width: 0.875rem;\n  /*rtl:raw:transform: rotateZ(-180deg);*/\n}\n.page-item .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item:focus .page-link {\n  color: var(--bs-pagination-focus-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item:focus .page-link .svg-icon,\n.page-item:focus .page-link i {\n  color: var(--bs-pagination-focus-color);\n}\n.page-item:focus .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-focus-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-focus-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-focus-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item:focus .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-focus-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-focus-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-focus-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link {\n  color: var(--bs-pagination-hover-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link.page-text {\n  background-color: transparent;\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .svg-icon,\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link i {\n  color: var(--bs-pagination-hover-color);\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-hover-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-hover-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-hover-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-hover-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-hover-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-hover-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item.active .page-link {\n  color: var(--bs-pagination-active-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item.active .page-link.page-text {\n  background-color: transparent;\n}\n.page-item.active .page-link .svg-icon,\n.page-item.active .page-link i {\n  color: var(--bs-pagination-active-color);\n}\n.page-item.active .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-active-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-active-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-active-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item.active .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-active-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-active-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-active-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item.disabled .page-link {\n  color: var(--bs-pagination-disabled-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item.disabled .page-link .svg-icon,\n.page-item.disabled .page-link i {\n  color: var(--bs-pagination-disabled-color);\n}\n.page-item.disabled .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-disabled-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-disabled-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-disabled-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item.disabled .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-pagination-disabled-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-disabled-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-pagination-disabled-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n\n@media (max-width: 991.98px) {\n  .page-item {\n    margin-right: 0.25rem;\n  }\n  .page-item:last-child {\n    margin-right: 0;\n  }\n}\n.separator {\n  display: block;\n  height: 0;\n  border-bottom: 1px solid var(--bs-border-color);\n}\n.separator.separator-dotted {\n  border-bottom-style: dotted;\n  border-bottom-color: var(--bs-border-dashed-color);\n}\n.separator.separator-dashed {\n  border-bottom-style: dashed;\n  border-bottom-color: var(--bs-border-dashed-color);\n}\n.separator.separator-content {\n  display: flex;\n  align-items: center;\n  border-bottom: 0;\n  text-align: center;\n}\n.separator.separator-content::before, .separator.separator-content::after {\n  content: \" \";\n  width: 50%;\n  border-bottom: 1px solid var(--bs-border-color);\n}\n.separator.separator-content::before {\n  margin-right: 1.25rem;\n}\n.separator.separator-content::after {\n  margin-left: 1.25rem;\n}\n.separator.separator-content.separator-dotted::before, .separator.separator-content.separator-dotted::after {\n  border-bottom-style: dotted;\n  border-bottom-color: var(--bs-border-dashed-color);\n}\n.separator.separator-content.separator-dashed::before, .separator.separator-content.separator-dashed::after {\n  border-bottom-style: dashed;\n  border-bottom-color: var(--bs-border-dashed-color);\n}\n.separator.separator-content.border-light::before, .separator.separator-content.border-light::after {\n  border-color: #F9F9F9 !important;\n}\n.separator.separator-content.border-primary::before, .separator.separator-content.border-primary::after {\n  border-color: #1B84FF !important;\n}\n.separator.separator-content.border-secondary::before, .separator.separator-content.border-secondary::after {\n  border-color: #F9F9F9 !important;\n}\n.separator.separator-content.border-success::before, .separator.separator-content.border-success::after {\n  border-color: #17C653 !important;\n}\n.separator.separator-content.border-info::before, .separator.separator-content.border-info::after {\n  border-color: #7239EA !important;\n}\n.separator.separator-content.border-warning::before, .separator.separator-content.border-warning::after {\n  border-color: #F6C000 !important;\n}\n.separator.separator-content.border-danger::before, .separator.separator-content.border-danger::after {\n  border-color: #F8285A !important;\n}\n.separator.separator-content.border-dark::before, .separator.separator-content.border-dark::after {\n  border-color: #1E2129 !important;\n}\n\n.carousel-custom .carousel-indicators {\n  align-items: center;\n  position: static;\n  z-index: auto;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.carousel-custom .carousel-indicators li {\n  transform: none;\n  opacity: 1;\n}\n.carousel-custom .carousel-indicators li.active {\n  transform: none;\n  opacity: 1;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li {\n  border-radius: 0;\n  background-color: transparent !important;\n  height: 13px;\n  width: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li:after {\n  display: inline-block;\n  content: \" \";\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  background-color: var(--bs-gray-200);\n  height: 9px;\n  width: 9px;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li.active {\n  background-color: transparent;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li.active:after {\n  transition: all 0.3s ease;\n  height: 13px;\n  width: 13px;\n  background-color: var(--bs-gray-400);\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li {\n  transition: all 0.3s ease;\n  background-color: transparent !important;\n  border-radius: 6px;\n  height: 6px;\n  width: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li:after {\n  display: inline-block;\n  content: \" \";\n  transition: all 0.3s ease;\n  background-color: var(--bs-gray-400);\n  border-radius: 6px;\n  height: 6px;\n  width: 6px;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active {\n  transition: all 0.3s ease;\n  background-color: transparent;\n  height: 6px;\n  width: 16px;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active:after {\n  transition: all 0.3s ease;\n  height: 6px;\n  width: 16px;\n  background-color: var(--bs-gray-600);\n}\n.carousel-custom .carousel-indicators-active-light li.active:after {\n  background-color: var(--bs-light) !important;\n}\n.carousel-custom .carousel-indicators-active-primary li.active:after {\n  background-color: var(--bs-primary) !important;\n}\n.carousel-custom .carousel-indicators-active-secondary li.active:after {\n  background-color: var(--bs-secondary) !important;\n}\n.carousel-custom .carousel-indicators-active-success li.active:after {\n  background-color: var(--bs-success) !important;\n}\n.carousel-custom .carousel-indicators-active-info li.active:after {\n  background-color: var(--bs-info) !important;\n}\n.carousel-custom .carousel-indicators-active-warning li.active:after {\n  background-color: var(--bs-warning) !important;\n}\n.carousel-custom .carousel-indicators-active-danger li.active:after {\n  background-color: var(--bs-danger) !important;\n}\n.carousel-custom .carousel-indicators-active-dark li.active:after {\n  background-color: var(--bs-dark) !important;\n}\n.carousel-custom.carousel-stretch {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.carousel-custom.carousel-stretch .carousel-inner {\n  flex-grow: 1;\n}\n.carousel-custom.carousel-stretch .carousel-item {\n  height: 100%;\n}\n.carousel-custom.carousel-stretch .carousel-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.menu-group {\n  display: flex;\n}\n\n.menu,\n.menu-wrapper {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.menu-inner {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.menu-sub {\n  display: none;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  flex-direction: column;\n}\n\n.menu-item {\n  display: block;\n  padding: 0.15rem 0;\n}\n.menu-item .menu-link {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  flex: 0 0 100%;\n  padding: 0.65rem 1rem;\n  transition: none;\n  outline: none !important;\n}\n.menu-item .menu-link .menu-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  margin-right: 0.5rem;\n}\n.menu-item .menu-link .menu-icon i,\n.menu-item .menu-link .menu-icon .svg-icon {\n  line-height: 1;\n}\n.menu-item .menu-link .menu-bullet {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.25rem;\n  margin-right: 0.5rem;\n}\n.menu-item .menu-link .menu-title {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n}\n.menu-item .menu-link .menu-badge {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-left: 0.5rem;\n}\n.menu-item .menu-link .menu-arrow {\n  display: flex;\n  align-items: stretch;\n  position: relative;\n  overflow: hidden;\n  flex-shrink: 0;\n  margin-left: 5px;\n  width: 9px;\n  height: 9px;\n}\n.menu-item .menu-link .menu-arrow:after {\n  display: block;\n  width: 100%;\n  content: \" \";\n  will-change: transform;\n  background-size: 100% 100%;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-item .menu-content {\n  padding: 0.65rem 1rem;\n}\n\n.menu-item.show .menu-link .menu-arrow:after {\n  backface-visibility: hidden;\n  transition: transform 0.3s ease;\n}\n\n.menu-nowrap .menu-title,\n.menu-nowrap .menu-link {\n  flex-wrap: nowrap;\n  flex-shrink: 0;\n}\n\n.menu-center {\n  justify-content: center;\n}\n\n.menu-heading {\n  color: var(--bs-menu-heading-color);\n}\n\n.menu-item.menu-accordion .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(-90deg);\n  /*rtl:remove*/\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n.menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(90deg);\n  /*rtl:remove*/\n  transform: rotateZ(-90deg);\n  transition: transform 0.3s ease;\n}\n\n.menu-sub-dropdown {\n  display: none;\n  border-radius: 0.65rem;\n  background-color: var(--bs-menu-dropdown-bg-color);\n  box-shadow: var(--bs-menu-dropdown-box-shadow);\n  z-index: 107;\n}\n.show.menu-dropdown > .menu-sub-dropdown, .menu-sub-dropdown.menu.show, .menu-sub-dropdown.show[data-popper-placement] {\n  display: flex;\n  will-change: transform;\n  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n}\n\n.menu-sub-accordion {\n  display: none;\n}\n.show:not(.menu-dropdown) > .menu-sub-accordion, .menu-sub-accordion.show {\n  display: flex;\n}\n\n.menu-sub-indention .menu-sub:not([data-popper-placement]) {\n  margin-left: 1rem;\n}\n.menu-sub-indention .menu-item .menu-item .menu-link.active {\n  margin-right: 1rem;\n}\n\n.menu-inline {\n  display: flex;\n}\n\n.menu-fit > .menu-item > .menu-content,\n.menu-fit > .menu-item > .menu-link {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.menu-column {\n  flex-direction: column;\n  width: 100%;\n}\n\n.menu-row {\n  flex-direction: row;\n}\n.menu-row > .menu-item {\n  display: flex;\n  align-items: center;\n}\n.menu-row > .menu-item > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(-90deg);\n  /*rtl:remove*/\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n\n.menu-rounded .menu-link {\n  border-radius: 0.65rem;\n}\n\n.menu-pill .menu-link {\n  border-radius: 50px;\n}\n\n.menu-rounded-0 .menu-link {\n  border-radius: 0 !important;\n}\n\n@media (min-width: 576px) {\n  .menu-item.menu-sm-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-sm-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-sm-dropdown, .menu-sub-sm-dropdown.menu.show, .menu-sub-sm-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-sm-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-sm-accordion, .menu-sub-sm-accordion.show {\n    display: flex;\n  }\n  .menu-sub-sm-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-sm-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-sm-inline {\n    display: flex;\n  }\n  .menu-sm-fit > .menu-item > .menu-content,\n  .menu-sm-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-sm-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-sm-row {\n    flex-direction: row;\n  }\n  .menu-sm-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sm-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-sm-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-sm-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 768px) {\n  .menu-item.menu-md-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-md-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-md-dropdown, .menu-sub-md-dropdown.menu.show, .menu-sub-md-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-md-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-md-accordion, .menu-sub-md-accordion.show {\n    display: flex;\n  }\n  .menu-sub-md-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-md-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-md-inline {\n    display: flex;\n  }\n  .menu-md-fit > .menu-item > .menu-content,\n  .menu-md-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-md-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-md-row {\n    flex-direction: row;\n  }\n  .menu-md-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-md-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-md-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-md-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-md-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 992px) {\n  .menu-item.menu-lg-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-lg-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-lg-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-lg-accordion, .menu-sub-lg-accordion.show {\n    display: flex;\n  }\n  .menu-sub-lg-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-lg-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-lg-inline {\n    display: flex;\n  }\n  .menu-lg-fit > .menu-item > .menu-content,\n  .menu-lg-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-lg-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-lg-row {\n    flex-direction: row;\n  }\n  .menu-lg-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-lg-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-lg-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-lg-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 1200px) {\n  .menu-item.menu-xl-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-xl-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xl-dropdown, .menu-sub-xl-dropdown.menu.show, .menu-sub-xl-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-xl-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xl-accordion, .menu-sub-xl-accordion.show {\n    display: flex;\n  }\n  .menu-sub-xl-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xl-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-xl-inline {\n    display: flex;\n  }\n  .menu-xl-fit > .menu-item > .menu-content,\n  .menu-xl-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-xl-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-xl-row {\n    flex-direction: row;\n  }\n  .menu-xl-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-xl-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-xl-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-xl-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 1400px) {\n  .menu-item.menu-xxl-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-xxl-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-dropdown, .menu-sub-xxl-dropdown.menu.show, .menu-sub-xxl-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-xxl-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xxl-accordion, .menu-sub-xxl-accordion.show {\n    display: flex;\n  }\n  .menu-sub-xxl-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xxl-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-xxl-inline {\n    display: flex;\n  }\n  .menu-xxl-fit > .menu-item > .menu-content,\n  .menu-xxl-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-xxl-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-xxl-row {\n    flex-direction: row;\n  }\n  .menu-xxl-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-xxl-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-xxl-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-xxl-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 575.98px) {\n  .menu-item.menu-sm-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-sm-down-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-sm-down-dropdown, .menu-sub-sm-down-dropdown.menu.show, .menu-sub-sm-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-sm-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-sm-down-accordion, .menu-sub-sm-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-sm-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-sm-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-sm-down-inline {\n    display: flex;\n  }\n  .menu-sm-down-fit > .menu-item > .menu-content,\n  .menu-sm-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-sm-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-sm-down-row {\n    flex-direction: row;\n  }\n  .menu-sm-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sm-down-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-sm-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-sm-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 767.98px) {\n  .menu-item.menu-md-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-md-down-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-md-down-dropdown, .menu-sub-md-down-dropdown.menu.show, .menu-sub-md-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-md-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-md-down-accordion, .menu-sub-md-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-md-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-md-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-md-down-inline {\n    display: flex;\n  }\n  .menu-md-down-fit > .menu-item > .menu-content,\n  .menu-md-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-md-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-md-down-row {\n    flex-direction: row;\n  }\n  .menu-md-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-md-down-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-md-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-md-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .menu-item.menu-lg-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-lg-down-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-lg-down-dropdown, .menu-sub-lg-down-dropdown.menu.show, .menu-sub-lg-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-lg-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-lg-down-accordion, .menu-sub-lg-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-lg-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-lg-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-lg-down-inline {\n    display: flex;\n  }\n  .menu-lg-down-fit > .menu-item > .menu-content,\n  .menu-lg-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-lg-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-lg-down-row {\n    flex-direction: row;\n  }\n  .menu-lg-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-lg-down-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-lg-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-lg-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 1199.98px) {\n  .menu-item.menu-xl-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-xl-down-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xl-down-dropdown, .menu-sub-xl-down-dropdown.menu.show, .menu-sub-xl-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-xl-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xl-down-accordion, .menu-sub-xl-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-xl-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xl-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-xl-down-inline {\n    display: flex;\n  }\n  .menu-xl-down-fit > .menu-item > .menu-content,\n  .menu-xl-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-xl-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-xl-down-row {\n    flex-direction: row;\n  }\n  .menu-xl-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-xl-down-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-xl-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-xl-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 1399.98px) {\n  .menu-item.menu-xxl-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-sub-xxl-down-dropdown {\n    display: none;\n    border-radius: 0.65rem;\n    background-color: var(--bs-menu-dropdown-bg-color);\n    box-shadow: var(--bs-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-down-dropdown, .menu-sub-xxl-down-dropdown.menu.show, .menu-sub-xxl-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n  .menu-sub-xxl-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xxl-down-accordion, .menu-sub-xxl-down-accordion.show {\n    display: flex;\n  }\n  .menu-sub-xxl-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xxl-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n  .menu-xxl-down-inline {\n    display: flex;\n  }\n  .menu-xxl-down-fit > .menu-item > .menu-content,\n  .menu-xxl-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  .menu-xxl-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n  .menu-xxl-down-row {\n    flex-direction: row;\n  }\n  .menu-xxl-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-xxl-down-rounded .menu-link {\n    border-radius: 0.65rem;\n  }\n  .menu-xxl-down-pill .menu-link {\n    border-radius: 50px;\n  }\n  .menu-xxl-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n.menu-link-indention .menu-item {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(1rem + 1rem);\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(2rem + 1rem);\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(3rem + 1rem);\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(4rem + 1rem);\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: 1rem;\n  padding-right: 0;\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(2rem);\n  padding-right: 0;\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(3rem);\n  padding-right: 0;\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(4rem);\n  padding-right: 0;\n}\n\n@keyframes menu-sub-dropdown-animation-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes menu-sub-dropdown-animation-move-up {\n  from {\n    margin-top: 0.75rem;\n  }\n  to {\n    margin-top: 0;\n  }\n}\n@keyframes menu-sub-dropdown-animation-move-down {\n  from {\n    margin-bottom: 0.75rem;\n  }\n  to {\n    margin-bottom: 0;\n  }\n}\n.menu-white .menu-item .menu-link {\n  color: var(--bs-white);\n}\n.menu-white .menu-item .menu-link .menu-title {\n  color: var(--bs-white);\n}\n.menu-white .menu-item .menu-link .menu-icon,\n.menu-white .menu-item .menu-link .menu-icon .svg-icon,\n.menu-white .menu-item .menu-link .menu-icon i {\n  color: var(--bs-white);\n}\n.menu-white .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-white);\n}\n.menu-white .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-white .menu-item .menu-link {\n  color: var(--bs-text-white);\n}\n.menu-title-white .menu-item .menu-link .menu-title {\n  color: var(--bs-text-white);\n}\n\n.menu-icon-white .menu-item .menu-link .menu-icon,\n.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-white .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-white);\n}\n\n.menu-bullet-white .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-white);\n}\n\n.menu-arrow-white .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-primary .menu-item .menu-link {\n  color: var(--bs-primary);\n}\n.menu-primary .menu-item .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-primary .menu-item .menu-link .menu-icon,\n.menu-primary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-primary .menu-item .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-primary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-primary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-primary .menu-item .menu-link {\n  color: var(--bs-text-primary);\n}\n.menu-title-primary .menu-item .menu-link .menu-title {\n  color: var(--bs-text-primary);\n}\n\n.menu-icon-primary .menu-item .menu-link .menu-icon,\n.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-primary .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-primary);\n}\n\n.menu-bullet-primary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-primary);\n}\n\n.menu-arrow-primary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-secondary .menu-item .menu-link {\n  color: var(--bs-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-title {\n  color: var(--bs-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-icon,\n.menu-secondary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-secondary .menu-item .menu-link .menu-icon i {\n  color: var(--bs-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-secondary .menu-item .menu-link {\n  color: var(--bs-text-secondary);\n}\n.menu-title-secondary .menu-item .menu-link .menu-title {\n  color: var(--bs-text-secondary);\n}\n\n.menu-icon-secondary .menu-item .menu-link .menu-icon,\n.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-secondary .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-secondary);\n}\n\n.menu-bullet-secondary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-secondary);\n}\n\n.menu-arrow-secondary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-light .menu-item .menu-link {\n  color: var(--bs-light);\n}\n.menu-light .menu-item .menu-link .menu-title {\n  color: var(--bs-light);\n}\n.menu-light .menu-item .menu-link .menu-icon,\n.menu-light .menu-item .menu-link .menu-icon .svg-icon,\n.menu-light .menu-item .menu-link .menu-icon i {\n  color: var(--bs-light);\n}\n.menu-light .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-light);\n}\n.menu-light .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-light .menu-item .menu-link {\n  color: var(--bs-text-light);\n}\n.menu-title-light .menu-item .menu-link .menu-title {\n  color: var(--bs-text-light);\n}\n\n.menu-icon-light .menu-item .menu-link .menu-icon,\n.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-light .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-light);\n}\n\n.menu-bullet-light .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-light);\n}\n\n.menu-arrow-light .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-success .menu-item .menu-link {\n  color: var(--bs-success);\n}\n.menu-success .menu-item .menu-link .menu-title {\n  color: var(--bs-success);\n}\n.menu-success .menu-item .menu-link .menu-icon,\n.menu-success .menu-item .menu-link .menu-icon .svg-icon,\n.menu-success .menu-item .menu-link .menu-icon i {\n  color: var(--bs-success);\n}\n.menu-success .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-success);\n}\n.menu-success .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-success .menu-item .menu-link {\n  color: var(--bs-text-success);\n}\n.menu-title-success .menu-item .menu-link .menu-title {\n  color: var(--bs-text-success);\n}\n\n.menu-icon-success .menu-item .menu-link .menu-icon,\n.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-success .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-success);\n}\n\n.menu-bullet-success .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-success);\n}\n\n.menu-arrow-success .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-info .menu-item .menu-link {\n  color: var(--bs-info);\n}\n.menu-info .menu-item .menu-link .menu-title {\n  color: var(--bs-info);\n}\n.menu-info .menu-item .menu-link .menu-icon,\n.menu-info .menu-item .menu-link .menu-icon .svg-icon,\n.menu-info .menu-item .menu-link .menu-icon i {\n  color: var(--bs-info);\n}\n.menu-info .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-info);\n}\n.menu-info .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-info .menu-item .menu-link {\n  color: var(--bs-text-info);\n}\n.menu-title-info .menu-item .menu-link .menu-title {\n  color: var(--bs-text-info);\n}\n\n.menu-icon-info .menu-item .menu-link .menu-icon,\n.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-info .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-info);\n}\n\n.menu-bullet-info .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-info);\n}\n\n.menu-arrow-info .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-warning .menu-item .menu-link {\n  color: var(--bs-warning);\n}\n.menu-warning .menu-item .menu-link .menu-title {\n  color: var(--bs-warning);\n}\n.menu-warning .menu-item .menu-link .menu-icon,\n.menu-warning .menu-item .menu-link .menu-icon .svg-icon,\n.menu-warning .menu-item .menu-link .menu-icon i {\n  color: var(--bs-warning);\n}\n.menu-warning .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-warning);\n}\n.menu-warning .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-warning .menu-item .menu-link {\n  color: var(--bs-text-warning);\n}\n.menu-title-warning .menu-item .menu-link .menu-title {\n  color: var(--bs-text-warning);\n}\n\n.menu-icon-warning .menu-item .menu-link .menu-icon,\n.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-warning .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-warning);\n}\n\n.menu-bullet-warning .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-warning);\n}\n\n.menu-arrow-warning .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-danger .menu-item .menu-link {\n  color: var(--bs-danger);\n}\n.menu-danger .menu-item .menu-link .menu-title {\n  color: var(--bs-danger);\n}\n.menu-danger .menu-item .menu-link .menu-icon,\n.menu-danger .menu-item .menu-link .menu-icon .svg-icon,\n.menu-danger .menu-item .menu-link .menu-icon i {\n  color: var(--bs-danger);\n}\n.menu-danger .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-danger);\n}\n.menu-danger .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-danger .menu-item .menu-link {\n  color: var(--bs-text-danger);\n}\n.menu-title-danger .menu-item .menu-link .menu-title {\n  color: var(--bs-text-danger);\n}\n\n.menu-icon-danger .menu-item .menu-link .menu-icon,\n.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-danger .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-danger);\n}\n\n.menu-bullet-danger .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-danger);\n}\n\n.menu-arrow-danger .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-dark .menu-item .menu-link {\n  color: var(--bs-dark);\n}\n.menu-dark .menu-item .menu-link .menu-title {\n  color: var(--bs-dark);\n}\n.menu-dark .menu-item .menu-link .menu-icon,\n.menu-dark .menu-item .menu-link .menu-icon .svg-icon,\n.menu-dark .menu-item .menu-link .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-dark .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-dark .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-dark .menu-item .menu-link {\n  color: var(--bs-text-dark);\n}\n.menu-title-dark .menu-item .menu-link .menu-title {\n  color: var(--bs-text-dark);\n}\n\n.menu-icon-dark .menu-item .menu-link .menu-icon,\n.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-dark .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-dark);\n}\n\n.menu-bullet-dark .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-dark);\n}\n\n.menu-arrow-dark .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-muted .menu-item .menu-link {\n  color: var(--bs-muted);\n}\n.menu-muted .menu-item .menu-link .menu-title {\n  color: var(--bs-muted);\n}\n.menu-muted .menu-item .menu-link .menu-icon,\n.menu-muted .menu-item .menu-link .menu-icon .svg-icon,\n.menu-muted .menu-item .menu-link .menu-icon i {\n  color: var(--bs-muted);\n}\n.menu-muted .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-muted);\n}\n.menu-muted .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-muted .menu-item .menu-link {\n  color: var(--bs-text-muted);\n}\n.menu-title-muted .menu-item .menu-link .menu-title {\n  color: var(--bs-text-muted);\n}\n\n.menu-icon-muted .menu-item .menu-link .menu-icon,\n.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-muted .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-muted);\n}\n\n.menu-bullet-muted .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-muted);\n}\n\n.menu-arrow-muted .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-100 .menu-item .menu-link {\n  color: var(--bs-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-icon,\n.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-100 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-100 .menu-item .menu-link {\n  color: var(--bs-text-gray-100);\n}\n.menu-title-gray-100 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-100);\n}\n\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-100);\n}\n\n.menu-bullet-gray-100 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-100);\n}\n\n.menu-arrow-gray-100 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-200 .menu-item .menu-link {\n  color: var(--bs-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-icon,\n.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-200 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-200 .menu-item .menu-link {\n  color: var(--bs-text-gray-200);\n}\n.menu-title-gray-200 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-200);\n}\n\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-200);\n}\n\n.menu-bullet-gray-200 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-200);\n}\n\n.menu-arrow-gray-200 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-300 .menu-item .menu-link {\n  color: var(--bs-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-icon,\n.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-300 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-300 .menu-item .menu-link {\n  color: var(--bs-text-gray-300);\n}\n.menu-title-gray-300 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-300);\n}\n\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-300);\n}\n\n.menu-bullet-gray-300 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-300);\n}\n\n.menu-arrow-gray-300 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-400 .menu-item .menu-link {\n  color: var(--bs-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-icon,\n.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-400 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-400 .menu-item .menu-link {\n  color: var(--bs-text-gray-400);\n}\n.menu-title-gray-400 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-400);\n}\n\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-400);\n}\n\n.menu-bullet-gray-400 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-400);\n}\n\n.menu-arrow-gray-400 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-500 .menu-item .menu-link {\n  color: var(--bs-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-icon,\n.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-500 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-500 .menu-item .menu-link {\n  color: var(--bs-text-gray-500);\n}\n.menu-title-gray-500 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-500);\n}\n\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-500);\n}\n\n.menu-bullet-gray-500 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-500);\n}\n\n.menu-arrow-gray-500 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-600 .menu-item .menu-link {\n  color: var(--bs-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-icon,\n.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-600 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-600 .menu-item .menu-link {\n  color: var(--bs-text-gray-600);\n}\n.menu-title-gray-600 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-600);\n}\n\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-600);\n}\n\n.menu-bullet-gray-600 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-600);\n}\n\n.menu-arrow-gray-600 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-700 .menu-item .menu-link {\n  color: var(--bs-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-icon,\n.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-700 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-700 .menu-item .menu-link {\n  color: var(--bs-text-gray-700);\n}\n.menu-title-gray-700 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-700);\n}\n\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-700);\n}\n\n.menu-bullet-gray-700 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-700);\n}\n\n.menu-arrow-gray-700 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-800 .menu-item .menu-link {\n  color: var(--bs-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-icon,\n.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-800 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-800 .menu-item .menu-link {\n  color: var(--bs-text-gray-800);\n}\n.menu-title-gray-800 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-800);\n}\n\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-800);\n}\n\n.menu-bullet-gray-800 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-800);\n}\n\n.menu-arrow-gray-800 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-900 .menu-item .menu-link {\n  color: var(--bs-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-icon,\n.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-900 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-900 .menu-item .menu-link {\n  color: var(--bs-text-gray-900);\n}\n.menu-title-gray-900 .menu-item .menu-link .menu-title {\n  color: var(--bs-text-gray-900);\n}\n\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon i {\n  color: var(--bs-text-gray-900);\n}\n\n.menu-bullet-gray-900 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-text-gray-900);\n}\n\n.menu-arrow-gray-900 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-hover);\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-here);\n  color: var(--bs-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-icon,\n.menu-here-bg .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-bg .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-root-here-bg > .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-here);\n  color: var(--bs-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon,\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n@media (min-width: 992px) {\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link {\n    transition: color 0.2s ease;\n    background-color: var(--bs-menu-link-bg-color-here);\n    color: var(--bs-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-title {\n    color: var(--bs-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon,\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon .svg-icon,\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon i {\n    color: var(--bs-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-bullet .bullet {\n    background-color: var(--bs-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-menu-link-color-here);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--bs-menu-link-color-here);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n}\n.menu-show-bg .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-show);\n  color: var(--bs-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-icon,\n.menu-show-bg .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-bg .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-active);\n  color: var(--bs-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-title {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-icon,\n.menu-active-bg .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-bg .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-hover);\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-here);\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-icon,\n.menu-state-bg .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-bg .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-show);\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-menu-link-bg-color-active);\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-title {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-icon,\n.menu-state-bg .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-bg .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-color .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-icon,\n.menu-state-color .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-color .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-color .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-icon,\n.menu-state-color .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-color .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-color .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-title {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-icon,\n.menu-state-color .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-color .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary);\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-bg-light-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg-light-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg-light-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg-light-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--bs-primary-light);\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-dark .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-icon,\n.menu-state-dark .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-dark .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-dark .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-icon,\n.menu-state-dark .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-dark .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-dark .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-title {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-icon,\n.menu-state-dark .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-dark .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-gray-900 .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-gray-900 .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.show > .menu-link .menu-icon,\n.menu-state-gray-900 .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-gray-900 .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-gray-900 .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.here > .menu-link .menu-icon,\n.menu-state-gray-900 .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-gray-900 .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-gray-900 .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item .menu-link.active .menu-title {\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item .menu-link.active .menu-icon,\n.menu-state-gray-900 .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-gray-900 .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-gray-900);\n}\n.menu-state-gray-900 .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-here-title-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-here-title-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-show-title-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-show-title-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-active-title-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-active-title-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--bs-primary);\n}\n.menu-state-title-primary .menu-item .menu-link.active .menu-title {\n  color: var(--bs-primary);\n}\n\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-here-icon-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-show-icon-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-active-icon-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-icon-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-icon-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-primary);\n}\n.menu-state-icon-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-primary);\n}\n\n.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-show-bullet-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-show-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-here-bullet-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-here-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-active-bullet-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-active-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bullet-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bullet-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n.menu-state-bullet-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-primary);\n}\n\n.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-arrow-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-here-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-arrow-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-show-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-arrow-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-active-arrow-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.anchor {\n  display: flex;\n  align-items: center;\n}\n.anchor a {\n  position: relative;\n  display: none;\n  align-items: center;\n  justify-content: flex-start;\n  height: 1em;\n  width: 1.25em;\n  margin-left: -1.25em;\n  font-weight: 500;\n  font-size: 0.8em;\n  color: var(--bs-text-muted);\n  transition: all 0.2s ease-in-out;\n}\n.anchor a:before {\n  content: \"#\";\n}\n.anchor:hover a {\n  display: flex;\n}\n.anchor:hover a:hover {\n  color: var(--bs-primary);\n  transition: all 0.2s ease-in-out;\n}\n\n.card {\n  --bs-card-box-shadow: var(--bs-root-card-box-shadow);\n  --bs-card-border-color: var(--bs-root-card-border-color);\n  border: 1px solid var(--bs-card-border-color);\n}\n.card .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  flex-wrap: wrap;\n  min-height: 70px;\n  padding: 0 2.25rem;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: 1px solid var(--bs-card-border-color);\n}\n.card .card-header .card-title {\n  display: flex;\n  align-items: center;\n  margin: 0.5rem;\n  margin-left: 0;\n}\n.card .card-header .card-title.flex-column {\n  align-items: flex-start;\n  justify-content: center;\n}\n.card .card-header .card-title .card-icon {\n  margin-right: 0.75rem;\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon i {\n  font-size: 1.25rem;\n  color: var(--bs-gray-600);\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon i:after, .card .card-header .card-title .card-icon i:before {\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon .svg-icon {\n  color: var(--bs-gray-600);\n}\n.card .card-header .card-title .card-icon .svg-icon svg {\n  height: 24px;\n  width: 24px;\n}\n.card .card-header .card-title,\n.card .card-header .card-title .card-label {\n  font-weight: 500;\n  font-size: 1.275rem;\n  color: var(--bs-text-gray-900);\n}\n.card .card-header .card-title .card-label {\n  margin: 0 0.75rem 0 0;\n  flex-wrap: wrap;\n}\n.card .card-header .card-title small, .card .card-header .card-title .small {\n  color: var(--bs-text-muted);\n  font-size: 1rem;\n}\n.card .card-header .card-title h1, .card .card-header .card-title .h1, .card .card-header .card-title h2, .card .card-header .card-title .h2, .card .card-header .card-title h3, .card .card-header .card-title .h3, .card .card-header .card-title h4, .card .card-header .card-title .h4, .card .card-header .card-title h5, .card .card-header .card-title .h5, .card .card-header .card-title h6, .card .card-header .card-title .h6 {\n  margin-bottom: 0;\n}\n.card .card-header .card-toolbar {\n  display: flex;\n  align-items: center;\n  margin: 0.5rem 0;\n  flex-wrap: wrap;\n}\n.card .card-body {\n  padding: 2rem 2.25rem;\n  color: var(--bs-card-color);\n}\n.card .card-footer {\n  padding: 2rem 2.25rem;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: 1px solid var(--bs-card-border-color);\n}\n.card .card-scroll {\n  position: relative;\n  overflow: auto;\n}\n.card.card-px-0 .card-header,\n.card.card-px-0 .card-body,\n.card.card-px-0 .card-footer {\n  padding-left: 0;\n  padding-right: 0;\n}\n.card.card-py-0 .card-header,\n.card.card-py-0 .card-body,\n.card.card-py-0 .card-footer {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.card.card-p-0 .card-header,\n.card.card-p-0 .card-body,\n.card.card-p-0 .card-footer {\n  padding: 0;\n}\n.card.card-dashed {\n  box-shadow: none;\n  border: 1px dashed var(--bs-border-dashed-color);\n}\n.card.card-dashed > .card-header {\n  border-bottom: 1px dashed var(--bs-border-dashed-color);\n}\n.card.card-dashed > .card-footer {\n  border-top: 1px dashed var(--bs-border-dashed-color);\n}\n.card.card-bordered {\n  box-shadow: none;\n  border: 1px solid #F1F1F4;\n}\n.card.card-flush > .card-header {\n  border-bottom: 0 !important;\n}\n.card.card-flush > .card-footer {\n  border-top: 0 !important;\n}\n.card.card-shadow {\n  box-shadow: var(--bs-card-box-shadow);\n  border: 0;\n}\n.card.card-reset {\n  border: 0 !important;\n  box-shadow: none !important;\n  background-color: transparent !important;\n}\n.card.card-reset > .card-header {\n  border-bottom: 0 !important;\n}\n.card.card-reset > .card-footer {\n  border-top: 0 !important;\n}\n.card.card-borderless {\n  border: 0 !important;\n}\n.card.card-borderless > .card-header {\n  border-bottom: 0 !important;\n}\n.card.card-borderless > .card-footer {\n  border-top: 0 !important;\n}\n.card.card-border-0 {\n  border: 0 !important;\n}\n\n.card.card-stretch {\n  height: calc(100% - var(--bs-gutter-y));\n}\n.card.card-stretch-75 {\n  height: calc(75% - var(--bs-gutter-y));\n}\n.card.card-stretch-50 {\n  height: calc(50% - var(--bs-gutter-y));\n}\n.card.card-stretch-33 {\n  height: calc(33.333% - var(--bs-gutter-y));\n}\n.card.card-stretch-25 {\n  height: calc(25% - var(--bs-gutter-y));\n}\n.card .card-header-stretch {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  align-items: stretch;\n}\n.card .card-header-stretch .card-toolbar {\n  margin: 0;\n  align-items: stretch;\n}\n@media (min-width: 576px) {\n  .card.card-sm-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-sm-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-sm-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 768px) {\n  .card.card-md-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-md-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-md-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 992px) {\n  .card.card-lg-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-lg-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-lg-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 1200px) {\n  .card.card-xl-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-xl-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-xl-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 1400px) {\n  .card.card-xxl-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-xxl-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-xxl-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n\n.card-p {\n  padding: 2rem 2.25rem !important;\n}\n\n.card-px {\n  padding-left: 2.25rem !important;\n  padding-right: 2.25rem !important;\n}\n\n.card-shadow {\n  box-shadow: var(--bs-card-box-shadow);\n}\n\n.card-py {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.card-rounded {\n  border-radius: 0.85rem;\n}\n\n.card-rounded-start {\n  border-top-left-radius: 0.85rem;\n  border-bottom-left-radius: 0.85rem;\n}\n\n.card-rounded-end {\n  border-top-right-radius: 0.85rem;\n  border-bottom-right-radius: 0.85rem;\n}\n\n.card-rounded-top {\n  border-top-left-radius: 0.85rem;\n  border-top-right-radius: 0.85rem;\n}\n\n.card-rounded-bottom {\n  border-bottom-left-radius: 0.85rem;\n  border-bottom-right-radius: 0.85rem;\n}\n\n@media (max-width: 767.98px) {\n  .card > .card-header:not(.flex-nowrap) {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n}\n[data-bs-theme=dark] .card {\n  --bs-card-box-shadow: none;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  padding: 0;\n  margin: 0;\n}\n.breadcrumb .breadcrumb-item {\n  display: flex;\n  align-items: center;\n  padding-left: 0.5rem;\n}\n.breadcrumb .breadcrumb-item:last-child {\n  padding-right: 0;\n}\n.breadcrumb .breadcrumb-item:after {\n  padding-left: 0.5rem;\n  content: \"/\";\n}\n.breadcrumb .breadcrumb-item:before {\n  display: none;\n}\n.breadcrumb .breadcrumb-item:first-child {\n  padding-left: 0;\n}\n.breadcrumb .breadcrumb-item:last-child:after {\n  display: none;\n}\n\n.breadcrumb-line .breadcrumb-item:after {\n  content: \"-\";\n}\n\n.breadcrumb-dot .breadcrumb-item:after {\n  content: \"•\";\n}\n\n.breadcrumb-separatorless .breadcrumb-item:after {\n  display: none;\n}\n\n.btn {\n  --bs-btn-color: var(--bs-body-color);\n  outline: none !important;\n}\n.btn:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg):not(.shadow-xs) {\n  box-shadow: none;\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline) {\n  border: 0;\n  padding: calc(0.775rem + 1px) calc(1.5rem + 1px);\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline).btn-lg, .btn-group-lg > .btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline) {\n  padding: calc(0.825rem + 1px) calc(1.75rem + 1px);\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline).btn-sm, .btn-group-sm > .btn:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline) {\n  padding: calc(0.55rem + 1px) calc(1rem + 1px);\n}\n.btn.btn-link {\n  border: 0;\n  border-radius: 0;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  text-decoration: none;\n  font-weight: 500;\n}\n.btn.btn-outline:not(.btn-outline-dashed) {\n  border: 1px solid var(--bs-gray-300);\n}\n.btn.btn-outline-dashed {\n  border: 1px dashed var(--bs-gray-300);\n}\n.btn.btn-flush {\n  appearance: none;\n  box-shadow: none;\n  border-radius: 0;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none !important;\n  margin: 0;\n  padding: 0;\n}\n.btn.btn-flex {\n  display: inline-flex;\n  align-items: center;\n}\n.btn.btn-trim-start {\n  justify-content: flex-start !important;\n  padding-left: 0 !important;\n}\n.btn.btn-trim-end {\n  justify-content: flex-end !important;\n  padding-right: 0 !important;\n}\n\n.btn-reset {\n  background-color: transparent;\n  border: 0;\n  box-shadow: none;\n  user-select: none;\n  outline: none;\n}\n\n.btn > i {\n  display: inline-flex;\n  font-size: 1rem;\n  padding-right: 0.35rem;\n  vertical-align: middle;\n}\n.btn.btn-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  height: calc(1.5em + 1.55rem + 2px);\n  width: calc(1.5em + 1.55rem + 2px);\n  line-height: 1;\n}\n.btn.btn-icon i {\n  padding-right: 0;\n}\n.btn.btn-icon:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {\n  border: 0;\n}\n.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon {\n  height: calc(1.5em + 1.1rem + 2px);\n  width: calc(1.5em + 1.1rem + 2px);\n}\n.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon {\n  height: calc(1.5em + 1.65rem + 2px);\n  width: calc(1.5em + 1.65rem + 2px);\n}\n.btn.btn-icon.btn-circle {\n  border-radius: 50%;\n}\n\n.btn.btn-outline.btn-outline-dashed {\n  border-width: 1px;\n  border-style: dashed;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dashed, .btn-check:active + .btn.btn-outline.btn-outline-dashed, .btn.btn-outline.btn-outline-dashed:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.active, .btn.btn-outline.btn-outline-dashed.show, .show > .btn.btn-outline.btn-outline-dashed {\n  border-color: var(--bs-primary);\n}\n\n.btn.btn-hover-outline {\n  border-width: 1px;\n  border-style: solid;\n}\n.btn-check:checked + .btn.btn-hover-outline, .btn-check:active + .btn.btn-hover-outline, .btn.btn-hover-outline:focus:not(.btn-active), .btn.btn-hover-outline:hover:not(.btn-active), .btn.btn-hover-outline:active:not(.btn-active), .btn.btn-hover-outline.active, .btn.btn-hover-outline.show, .show > .btn.btn-hover-outline {\n  border-color: var(--bs-gray-300);\n}\n\n.btn.btn-light {\n  color: var(--bs-light-inverse);\n  border-color: var(--bs-light);\n  background-color: var(--bs-light);\n}\n.btn.btn-light i,\n.btn.btn-light .svg-icon {\n  color: var(--bs-light-inverse);\n}\n.btn.btn-light.dropdown-toggle:after {\n  color: var(--bs-light-inverse);\n}\n.btn-check:checked + .btn.btn-light, .btn-check:active + .btn.btn-light, .btn.btn-light:focus:not(.btn-active), .btn.btn-light:hover:not(.btn-active), .btn.btn-light:active:not(.btn-active), .btn.btn-light.active, .btn.btn-light.show, .show > .btn.btn-light {\n  color: var(--bs-light-inverse);\n  border-color: var(--bs-light-active);\n  background-color: var(--bs-light-active) !important;\n}\n.btn-check:checked + .btn.btn-light i,\n.btn-check:checked + .btn.btn-light .svg-icon, .btn-check:active + .btn.btn-light i,\n.btn-check:active + .btn.btn-light .svg-icon, .btn.btn-light:focus:not(.btn-active) i,\n.btn.btn-light:focus:not(.btn-active) .svg-icon, .btn.btn-light:hover:not(.btn-active) i,\n.btn.btn-light:hover:not(.btn-active) .svg-icon, .btn.btn-light:active:not(.btn-active) i,\n.btn.btn-light:active:not(.btn-active) .svg-icon, .btn.btn-light.active i,\n.btn.btn-light.active .svg-icon, .btn.btn-light.show i,\n.btn.btn-light.show .svg-icon, .show > .btn.btn-light i,\n.show > .btn.btn-light .svg-icon {\n  color: var(--bs-light-inverse);\n}\n.btn-check:checked + .btn.btn-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light.dropdown-toggle:after, .btn.btn-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light.active.dropdown-toggle:after, .btn.btn-light.show.dropdown-toggle:after, .show > .btn.btn-light.dropdown-toggle:after {\n  color: var(--bs-light-inverse);\n}\n\n.btn.btn-light-light {\n  color: var(--bs-light);\n  border-color: var(--bs-light-light);\n  background-color: var(--bs-light-light);\n}\n.btn.btn-light-light i,\n.btn.btn-light-light .svg-icon {\n  color: var(--bs-light);\n}\n.btn.btn-light-light.dropdown-toggle:after {\n  color: var(--bs-light);\n}\n.btn-check:checked + .btn.btn-light-light, .btn-check:active + .btn.btn-light-light, .btn.btn-light-light:focus:not(.btn-active), .btn.btn-light-light:hover:not(.btn-active), .btn.btn-light-light:active:not(.btn-active), .btn.btn-light-light.active, .btn.btn-light-light.show, .show > .btn.btn-light-light {\n  color: var(--bs-light-inverse);\n  border-color: var(--bs-light);\n  background-color: var(--bs-light) !important;\n}\n.btn-check:checked + .btn.btn-light-light i,\n.btn-check:checked + .btn.btn-light-light .svg-icon, .btn-check:active + .btn.btn-light-light i,\n.btn-check:active + .btn.btn-light-light .svg-icon, .btn.btn-light-light:focus:not(.btn-active) i,\n.btn.btn-light-light:focus:not(.btn-active) .svg-icon, .btn.btn-light-light:hover:not(.btn-active) i,\n.btn.btn-light-light:hover:not(.btn-active) .svg-icon, .btn.btn-light-light:active:not(.btn-active) i,\n.btn.btn-light-light:active:not(.btn-active) .svg-icon, .btn.btn-light-light.active i,\n.btn.btn-light-light.active .svg-icon, .btn.btn-light-light.show i,\n.btn.btn-light-light.show .svg-icon, .show > .btn.btn-light-light i,\n.show > .btn.btn-light-light .svg-icon {\n  color: var(--bs-light-inverse);\n}\n.btn-check:checked + .btn.btn-light-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light-light.dropdown-toggle:after, .btn.btn-light-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-light.active.dropdown-toggle:after, .btn.btn-light-light.show.dropdown-toggle:after, .show > .btn.btn-light-light.dropdown-toggle:after {\n  color: var(--bs-light-inverse);\n}\n\n.btn.btn-bg-light {\n  border-color: var(--bs-light);\n  background-color: var(--bs-light);\n}\n.btn-check:checked + .btn.btn-active-light, .btn-check:active + .btn.btn-active-light, .btn.btn-active-light:focus:not(.btn-active), .btn.btn-active-light:hover:not(.btn-active), .btn.btn-active-light:active:not(.btn-active), .btn.btn-active-light.active, .btn.btn-active-light.show, .show > .btn.btn-active-light {\n  color: var(--bs-light-inverse);\n  border-color: var(--bs-light);\n  background-color: var(--bs-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light i,\n.btn-check:checked + .btn.btn-active-light .svg-icon, .btn-check:active + .btn.btn-active-light i,\n.btn-check:active + .btn.btn-active-light .svg-icon, .btn.btn-active-light:focus:not(.btn-active) i,\n.btn.btn-active-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-light:hover:not(.btn-active) i,\n.btn.btn-active-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-light:active:not(.btn-active) i,\n.btn.btn-active-light:active:not(.btn-active) .svg-icon, .btn.btn-active-light.active i,\n.btn.btn-active-light.active .svg-icon, .btn.btn-active-light.show i,\n.btn.btn-active-light.show .svg-icon, .show > .btn.btn-active-light i,\n.show > .btn.btn-active-light .svg-icon {\n  color: var(--bs-light-inverse);\n}\n.btn-check:checked + .btn.btn-active-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light.dropdown-toggle:after, .btn.btn-active-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light.active.dropdown-toggle:after, .btn.btn-active-light.show.dropdown-toggle:after, .show > .btn.btn-active-light.dropdown-toggle:after {\n  color: var(--bs-light-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-light, .btn-check:active + .btn.btn-active-light-light, .btn.btn-active-light-light:focus:not(.btn-active), .btn.btn-active-light-light:hover:not(.btn-active), .btn.btn-active-light-light:active:not(.btn-active), .btn.btn-active-light-light.active, .btn.btn-active-light-light.show, .show > .btn.btn-active-light-light {\n  color: var(--bs-light);\n  border-color: var(--bs-light-light);\n  background-color: var(--bs-light-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-light i,\n.btn-check:checked + .btn.btn-active-light-light .svg-icon, .btn-check:active + .btn.btn-active-light-light i,\n.btn-check:active + .btn.btn-active-light-light .svg-icon, .btn.btn-active-light-light:focus:not(.btn-active) i,\n.btn.btn-active-light-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-light:hover:not(.btn-active) i,\n.btn.btn-active-light-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-light:active:not(.btn-active) i,\n.btn.btn-active-light-light:active:not(.btn-active) .svg-icon, .btn.btn-active-light-light.active i,\n.btn.btn-active-light-light.active .svg-icon, .btn.btn-active-light-light.show i,\n.btn.btn-active-light-light.show .svg-icon, .show > .btn.btn-active-light-light i,\n.show > .btn.btn-active-light-light .svg-icon {\n  color: var(--bs-light);\n}\n.btn-check:checked + .btn.btn-active-light-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-light.dropdown-toggle:after, .btn.btn-active-light-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-light.active.dropdown-toggle:after, .btn.btn-active-light-light.show.dropdown-toggle:after, .show > .btn.btn-active-light-light.dropdown-toggle:after {\n  color: var(--bs-light);\n}\n\n.btn.btn-outline.btn-outline-light {\n  color: var(--bs-light);\n  border-color: var(--bs-light);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-light i,\n.btn.btn-outline.btn-outline-light .svg-icon {\n  color: var(--bs-light);\n}\n.btn.btn-outline.btn-outline-light.dropdown-toggle:after {\n  color: var(--bs-light);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-light, .btn-check:active + .btn.btn-outline.btn-outline-light, .btn.btn-outline.btn-outline-light:focus:not(.btn-active), .btn.btn-outline.btn-outline-light:hover:not(.btn-active), .btn.btn-outline.btn-outline-light:active:not(.btn-active), .btn.btn-outline.btn-outline-light.active, .btn.btn-outline.btn-outline-light.show, .show > .btn.btn-outline.btn-outline-light {\n  color: var(--bs-light-active);\n  border-color: var(--bs-light);\n  background-color: var(--bs-light-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-light i,\n.btn-check:checked + .btn.btn-outline.btn-outline-light .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-light i,\n.btn-check:active + .btn.btn-outline.btn-outline-light .svg-icon, .btn.btn-outline.btn-outline-light:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-light:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-light:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-light:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light.active i,\n.btn.btn-outline.btn-outline-light.active .svg-icon, .btn.btn-outline.btn-outline-light.show i,\n.btn.btn-outline.btn-outline-light.show .svg-icon, .show > .btn.btn-outline.btn-outline-light i,\n.show > .btn.btn-outline.btn-outline-light .svg-icon {\n  color: var(--bs-light-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn.btn-outline.btn-outline-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-light.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-light.dropdown-toggle:after {\n  color: var(--bs-light-active);\n}\n\n.btn.btn-primary {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary);\n}\n.btn.btn-primary i,\n.btn.btn-primary .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.btn.btn-primary.dropdown-toggle:after {\n  color: var(--bs-primary-inverse);\n}\n.btn-check:checked + .btn.btn-primary, .btn-check:active + .btn.btn-primary, .btn.btn-primary:focus:not(.btn-active), .btn.btn-primary:hover:not(.btn-active), .btn.btn-primary:active:not(.btn-active), .btn.btn-primary.active, .btn.btn-primary.show, .show > .btn.btn-primary {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary-active);\n  background-color: var(--bs-primary-active) !important;\n}\n.btn-check:checked + .btn.btn-primary i,\n.btn-check:checked + .btn.btn-primary .svg-icon, .btn-check:active + .btn.btn-primary i,\n.btn-check:active + .btn.btn-primary .svg-icon, .btn.btn-primary:focus:not(.btn-active) i,\n.btn.btn-primary:focus:not(.btn-active) .svg-icon, .btn.btn-primary:hover:not(.btn-active) i,\n.btn.btn-primary:hover:not(.btn-active) .svg-icon, .btn.btn-primary:active:not(.btn-active) i,\n.btn.btn-primary:active:not(.btn-active) .svg-icon, .btn.btn-primary.active i,\n.btn.btn-primary.active .svg-icon, .btn.btn-primary.show i,\n.btn.btn-primary.show .svg-icon, .show > .btn.btn-primary i,\n.show > .btn.btn-primary .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.btn-check:checked + .btn.btn-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-primary.dropdown-toggle:after, .btn.btn-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-primary.active.dropdown-toggle:after, .btn.btn-primary.show.dropdown-toggle:after, .show > .btn.btn-primary.dropdown-toggle:after {\n  color: var(--bs-primary-inverse);\n}\n\n.btn.btn-light-primary {\n  color: var(--bs-primary);\n  border-color: var(--bs-primary-light);\n  background-color: var(--bs-primary-light);\n}\n.btn.btn-light-primary i,\n.btn.btn-light-primary .svg-icon {\n  color: var(--bs-primary);\n}\n.btn.btn-light-primary.dropdown-toggle:after {\n  color: var(--bs-primary);\n}\n.btn-check:checked + .btn.btn-light-primary, .btn-check:active + .btn.btn-light-primary, .btn.btn-light-primary:focus:not(.btn-active), .btn.btn-light-primary:hover:not(.btn-active), .btn.btn-light-primary:active:not(.btn-active), .btn.btn-light-primary.active, .btn.btn-light-primary.show, .show > .btn.btn-light-primary {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary) !important;\n}\n.btn-check:checked + .btn.btn-light-primary i,\n.btn-check:checked + .btn.btn-light-primary .svg-icon, .btn-check:active + .btn.btn-light-primary i,\n.btn-check:active + .btn.btn-light-primary .svg-icon, .btn.btn-light-primary:focus:not(.btn-active) i,\n.btn.btn-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-light-primary:hover:not(.btn-active) i,\n.btn.btn-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-light-primary:active:not(.btn-active) i,\n.btn.btn-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-light-primary.active i,\n.btn.btn-light-primary.active .svg-icon, .btn.btn-light-primary.show i,\n.btn.btn-light-primary.show .svg-icon, .show > .btn.btn-light-primary i,\n.show > .btn.btn-light-primary .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.btn-check:checked + .btn.btn-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-primary.dropdown-toggle:after, .btn.btn-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary.active.dropdown-toggle:after, .btn.btn-light-primary.show.dropdown-toggle:after, .show > .btn.btn-light-primary.dropdown-toggle:after {\n  color: var(--bs-primary-inverse);\n}\n\n.btn.btn-bg-primary {\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary);\n}\n.btn-check:checked + .btn.btn-active-primary, .btn-check:active + .btn.btn-active-primary, .btn.btn-active-primary:focus:not(.btn-active), .btn.btn-active-primary:hover:not(.btn-active), .btn.btn-active-primary:active:not(.btn-active), .btn.btn-active-primary.active, .btn.btn-active-primary.show, .show > .btn.btn-active-primary {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary) !important;\n}\n.btn-check:checked + .btn.btn-active-primary i,\n.btn-check:checked + .btn.btn-active-primary .svg-icon, .btn-check:active + .btn.btn-active-primary i,\n.btn-check:active + .btn.btn-active-primary .svg-icon, .btn.btn-active-primary:focus:not(.btn-active) i,\n.btn.btn-active-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-primary:hover:not(.btn-active) i,\n.btn.btn-active-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-primary:active:not(.btn-active) i,\n.btn.btn-active-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-primary.active i,\n.btn.btn-active-primary.active .svg-icon, .btn.btn-active-primary.show i,\n.btn.btn-active-primary.show .svg-icon, .show > .btn.btn-active-primary i,\n.show > .btn.btn-active-primary .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.btn-check:checked + .btn.btn-active-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-primary.dropdown-toggle:after, .btn.btn-active-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary.active.dropdown-toggle:after, .btn.btn-active-primary.show.dropdown-toggle:after, .show > .btn.btn-active-primary.dropdown-toggle:after {\n  color: var(--bs-primary-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-primary, .btn-check:active + .btn.btn-active-light-primary, .btn.btn-active-light-primary:focus:not(.btn-active), .btn.btn-active-light-primary:hover:not(.btn-active), .btn.btn-active-light-primary:active:not(.btn-active), .btn.btn-active-light-primary.active, .btn.btn-active-light-primary.show, .show > .btn.btn-active-light-primary {\n  color: var(--bs-primary);\n  border-color: var(--bs-primary-light);\n  background-color: var(--bs-primary-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-primary i,\n.btn-check:checked + .btn.btn-active-light-primary .svg-icon, .btn-check:active + .btn.btn-active-light-primary i,\n.btn-check:active + .btn.btn-active-light-primary .svg-icon, .btn.btn-active-light-primary:focus:not(.btn-active) i,\n.btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:hover:not(.btn-active) i,\n.btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:active:not(.btn-active) i,\n.btn.btn-active-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-primary.active i,\n.btn.btn-active-light-primary.active .svg-icon, .btn.btn-active-light-primary.show i,\n.btn.btn-active-light-primary.show .svg-icon, .show > .btn.btn-active-light-primary i,\n.show > .btn.btn-active-light-primary .svg-icon {\n  color: var(--bs-primary);\n}\n.btn-check:checked + .btn.btn-active-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-primary.dropdown-toggle:after, .btn.btn-active-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary.active.dropdown-toggle:after, .btn.btn-active-light-primary.show.dropdown-toggle:after, .show > .btn.btn-active-light-primary.dropdown-toggle:after {\n  color: var(--bs-primary);\n}\n\n.btn.btn-outline.btn-outline-primary {\n  color: var(--bs-primary);\n  border-color: var(--bs-primary);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-primary i,\n.btn.btn-outline.btn-outline-primary .svg-icon {\n  color: var(--bs-primary);\n}\n.btn.btn-outline.btn-outline-primary.dropdown-toggle:after {\n  color: var(--bs-primary);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-primary, .btn-check:active + .btn.btn-outline.btn-outline-primary, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active), .btn.btn-outline.btn-outline-primary:hover:not(.btn-active), .btn.btn-outline.btn-outline-primary:active:not(.btn-active), .btn.btn-outline.btn-outline-primary.active, .btn.btn-outline.btn-outline-primary.show, .show > .btn.btn-outline.btn-outline-primary {\n  color: var(--bs-primary-active);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-primary i,\n.btn-check:checked + .btn.btn-outline.btn-outline-primary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-primary i,\n.btn-check:active + .btn.btn-outline.btn-outline-primary .svg-icon, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-primary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-primary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-primary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary.active i,\n.btn.btn-outline.btn-outline-primary.active .svg-icon, .btn.btn-outline.btn-outline-primary.show i,\n.btn.btn-outline.btn-outline-primary.show .svg-icon, .show > .btn.btn-outline.btn-outline-primary i,\n.show > .btn.btn-outline.btn-outline-primary .svg-icon {\n  color: var(--bs-primary-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-primary.dropdown-toggle:after {\n  color: var(--bs-primary-active);\n}\n\n.btn.btn-secondary {\n  color: var(--bs-secondary-inverse);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary);\n}\n.btn.btn-secondary i,\n.btn.btn-secondary .svg-icon {\n  color: var(--bs-secondary-inverse);\n}\n.btn.btn-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-secondary, .btn-check:active + .btn.btn-secondary, .btn.btn-secondary:focus:not(.btn-active), .btn.btn-secondary:hover:not(.btn-active), .btn.btn-secondary:active:not(.btn-active), .btn.btn-secondary.active, .btn.btn-secondary.show, .show > .btn.btn-secondary {\n  color: var(--bs-secondary-inverse);\n  border-color: var(--bs-secondary-active);\n  background-color: var(--bs-secondary-active) !important;\n}\n.btn-check:checked + .btn.btn-secondary i,\n.btn-check:checked + .btn.btn-secondary .svg-icon, .btn-check:active + .btn.btn-secondary i,\n.btn-check:active + .btn.btn-secondary .svg-icon, .btn.btn-secondary:focus:not(.btn-active) i,\n.btn.btn-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-secondary:hover:not(.btn-active) i,\n.btn.btn-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-secondary:active:not(.btn-active) i,\n.btn.btn-secondary:active:not(.btn-active) .svg-icon, .btn.btn-secondary.active i,\n.btn.btn-secondary.active .svg-icon, .btn.btn-secondary.show i,\n.btn.btn-secondary.show .svg-icon, .show > .btn.btn-secondary i,\n.show > .btn.btn-secondary .svg-icon {\n  color: var(--bs-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-secondary.dropdown-toggle:after, .btn.btn-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary.active.dropdown-toggle:after, .btn.btn-secondary.show.dropdown-toggle:after, .show > .btn.btn-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-inverse);\n}\n\n.btn.btn-light-secondary {\n  color: var(--bs-secondary);\n  border-color: var(--bs-secondary-light);\n  background-color: var(--bs-secondary-light);\n}\n.btn.btn-light-secondary i,\n.btn.btn-light-secondary .svg-icon {\n  color: var(--bs-secondary);\n}\n.btn.btn-light-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary);\n}\n.btn-check:checked + .btn.btn-light-secondary, .btn-check:active + .btn.btn-light-secondary, .btn.btn-light-secondary:focus:not(.btn-active), .btn.btn-light-secondary:hover:not(.btn-active), .btn.btn-light-secondary:active:not(.btn-active), .btn.btn-light-secondary.active, .btn.btn-light-secondary.show, .show > .btn.btn-light-secondary {\n  color: var(--bs-secondary-inverse);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary) !important;\n}\n.btn-check:checked + .btn.btn-light-secondary i,\n.btn-check:checked + .btn.btn-light-secondary .svg-icon, .btn-check:active + .btn.btn-light-secondary i,\n.btn-check:active + .btn.btn-light-secondary .svg-icon, .btn.btn-light-secondary:focus:not(.btn-active) i,\n.btn.btn-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-light-secondary:hover:not(.btn-active) i,\n.btn.btn-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-light-secondary:active:not(.btn-active) i,\n.btn.btn-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-light-secondary.active i,\n.btn.btn-light-secondary.active .svg-icon, .btn.btn-light-secondary.show i,\n.btn.btn-light-secondary.show .svg-icon, .show > .btn.btn-light-secondary i,\n.show > .btn.btn-light-secondary .svg-icon {\n  color: var(--bs-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-secondary.dropdown-toggle:after, .btn.btn-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary.active.dropdown-toggle:after, .btn.btn-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-light-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-inverse);\n}\n\n.btn.btn-bg-secondary {\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary);\n}\n.btn-check:checked + .btn.btn-active-secondary, .btn-check:active + .btn.btn-active-secondary, .btn.btn-active-secondary:focus:not(.btn-active), .btn.btn-active-secondary:hover:not(.btn-active), .btn.btn-active-secondary:active:not(.btn-active), .btn.btn-active-secondary.active, .btn.btn-active-secondary.show, .show > .btn.btn-active-secondary {\n  color: var(--bs-secondary-inverse);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary) !important;\n}\n.btn-check:checked + .btn.btn-active-secondary i,\n.btn-check:checked + .btn.btn-active-secondary .svg-icon, .btn-check:active + .btn.btn-active-secondary i,\n.btn-check:active + .btn.btn-active-secondary .svg-icon, .btn.btn-active-secondary:focus:not(.btn-active) i,\n.btn.btn-active-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-secondary:hover:not(.btn-active) i,\n.btn.btn-active-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-secondary:active:not(.btn-active) i,\n.btn.btn-active-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-secondary.active i,\n.btn.btn-active-secondary.active .svg-icon, .btn.btn-active-secondary.show i,\n.btn.btn-active-secondary.show .svg-icon, .show > .btn.btn-active-secondary i,\n.show > .btn.btn-active-secondary .svg-icon {\n  color: var(--bs-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-active-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-secondary.dropdown-toggle:after, .btn.btn-active-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary.active.dropdown-toggle:after, .btn.btn-active-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-secondary, .btn-check:active + .btn.btn-active-light-secondary, .btn.btn-active-light-secondary:focus:not(.btn-active), .btn.btn-active-light-secondary:hover:not(.btn-active), .btn.btn-active-light-secondary:active:not(.btn-active), .btn.btn-active-light-secondary.active, .btn.btn-active-light-secondary.show, .show > .btn.btn-active-light-secondary {\n  color: var(--bs-secondary);\n  border-color: var(--bs-secondary-light);\n  background-color: var(--bs-secondary-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-secondary i,\n.btn-check:checked + .btn.btn-active-light-secondary .svg-icon, .btn-check:active + .btn.btn-active-light-secondary i,\n.btn-check:active + .btn.btn-active-light-secondary .svg-icon, .btn.btn-active-light-secondary:focus:not(.btn-active) i,\n.btn.btn-active-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:hover:not(.btn-active) i,\n.btn.btn-active-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:active:not(.btn-active) i,\n.btn.btn-active-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary.active i,\n.btn.btn-active-light-secondary.active .svg-icon, .btn.btn-active-light-secondary.show i,\n.btn.btn-active-light-secondary.show .svg-icon, .show > .btn.btn-active-light-secondary i,\n.show > .btn.btn-active-light-secondary .svg-icon {\n  color: var(--bs-secondary);\n}\n.btn-check:checked + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn.btn-active-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary.active.dropdown-toggle:after, .btn.btn-active-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-light-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary);\n}\n\n.btn.btn-outline.btn-outline-secondary {\n  color: var(--bs-secondary);\n  border-color: var(--bs-secondary);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-secondary i,\n.btn.btn-outline.btn-outline-secondary .svg-icon {\n  color: var(--bs-secondary);\n}\n.btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary, .btn-check:active + .btn.btn-outline.btn-outline-secondary, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active), .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active), .btn.btn-outline.btn-outline-secondary:active:not(.btn-active), .btn.btn-outline.btn-outline-secondary.active, .btn.btn-outline.btn-outline-secondary.show, .show > .btn.btn-outline.btn-outline-secondary {\n  color: var(--bs-secondary-active);\n  border-color: var(--bs-secondary);\n  background-color: var(--bs-secondary-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary i,\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-secondary i,\n.btn-check:active + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-secondary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary.active i,\n.btn.btn-outline.btn-outline-secondary.active .svg-icon, .btn.btn-outline.btn-outline-secondary.show i,\n.btn.btn-outline.btn-outline-secondary.show .svg-icon, .show > .btn.btn-outline.btn-outline-secondary i,\n.show > .btn.btn-outline.btn-outline-secondary .svg-icon {\n  color: var(--bs-secondary-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {\n  color: var(--bs-secondary-active);\n}\n\n.btn.btn-success {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success);\n}\n.btn.btn-success i,\n.btn.btn-success .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.btn.btn-success.dropdown-toggle:after {\n  color: var(--bs-success-inverse);\n}\n.btn-check:checked + .btn.btn-success, .btn-check:active + .btn.btn-success, .btn.btn-success:focus:not(.btn-active), .btn.btn-success:hover:not(.btn-active), .btn.btn-success:active:not(.btn-active), .btn.btn-success.active, .btn.btn-success.show, .show > .btn.btn-success {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success-active);\n  background-color: var(--bs-success-active) !important;\n}\n.btn-check:checked + .btn.btn-success i,\n.btn-check:checked + .btn.btn-success .svg-icon, .btn-check:active + .btn.btn-success i,\n.btn-check:active + .btn.btn-success .svg-icon, .btn.btn-success:focus:not(.btn-active) i,\n.btn.btn-success:focus:not(.btn-active) .svg-icon, .btn.btn-success:hover:not(.btn-active) i,\n.btn.btn-success:hover:not(.btn-active) .svg-icon, .btn.btn-success:active:not(.btn-active) i,\n.btn.btn-success:active:not(.btn-active) .svg-icon, .btn.btn-success.active i,\n.btn.btn-success.active .svg-icon, .btn.btn-success.show i,\n.btn.btn-success.show .svg-icon, .show > .btn.btn-success i,\n.show > .btn.btn-success .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.btn-check:checked + .btn.btn-success.dropdown-toggle:after, .btn-check:active + .btn.btn-success.dropdown-toggle:after, .btn.btn-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-success.active.dropdown-toggle:after, .btn.btn-success.show.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle:after {\n  color: var(--bs-success-inverse);\n}\n\n.btn.btn-light-success {\n  color: var(--bs-success);\n  border-color: var(--bs-success-light);\n  background-color: var(--bs-success-light);\n}\n.btn.btn-light-success i,\n.btn.btn-light-success .svg-icon {\n  color: var(--bs-success);\n}\n.btn.btn-light-success.dropdown-toggle:after {\n  color: var(--bs-success);\n}\n.btn-check:checked + .btn.btn-light-success, .btn-check:active + .btn.btn-light-success, .btn.btn-light-success:focus:not(.btn-active), .btn.btn-light-success:hover:not(.btn-active), .btn.btn-light-success:active:not(.btn-active), .btn.btn-light-success.active, .btn.btn-light-success.show, .show > .btn.btn-light-success {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success) !important;\n}\n.btn-check:checked + .btn.btn-light-success i,\n.btn-check:checked + .btn.btn-light-success .svg-icon, .btn-check:active + .btn.btn-light-success i,\n.btn-check:active + .btn.btn-light-success .svg-icon, .btn.btn-light-success:focus:not(.btn-active) i,\n.btn.btn-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-light-success:hover:not(.btn-active) i,\n.btn.btn-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-light-success:active:not(.btn-active) i,\n.btn.btn-light-success:active:not(.btn-active) .svg-icon, .btn.btn-light-success.active i,\n.btn.btn-light-success.active .svg-icon, .btn.btn-light-success.show i,\n.btn.btn-light-success.show .svg-icon, .show > .btn.btn-light-success i,\n.show > .btn.btn-light-success .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.btn-check:checked + .btn.btn-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-light-success.dropdown-toggle:after, .btn.btn-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success.active.dropdown-toggle:after, .btn.btn-light-success.show.dropdown-toggle:after, .show > .btn.btn-light-success.dropdown-toggle:after {\n  color: var(--bs-success-inverse);\n}\n\n.btn.btn-bg-success {\n  border-color: var(--bs-success);\n  background-color: var(--bs-success);\n}\n.btn-check:checked + .btn.btn-active-success, .btn-check:active + .btn.btn-active-success, .btn.btn-active-success:focus:not(.btn-active), .btn.btn-active-success:hover:not(.btn-active), .btn.btn-active-success:active:not(.btn-active), .btn.btn-active-success.active, .btn.btn-active-success.show, .show > .btn.btn-active-success {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success) !important;\n}\n.btn-check:checked + .btn.btn-active-success i,\n.btn-check:checked + .btn.btn-active-success .svg-icon, .btn-check:active + .btn.btn-active-success i,\n.btn-check:active + .btn.btn-active-success .svg-icon, .btn.btn-active-success:focus:not(.btn-active) i,\n.btn.btn-active-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-success:hover:not(.btn-active) i,\n.btn.btn-active-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-success:active:not(.btn-active) i,\n.btn.btn-active-success:active:not(.btn-active) .svg-icon, .btn.btn-active-success.active i,\n.btn.btn-active-success.active .svg-icon, .btn.btn-active-success.show i,\n.btn.btn-active-success.show .svg-icon, .show > .btn.btn-active-success i,\n.show > .btn.btn-active-success .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.btn-check:checked + .btn.btn-active-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-success.dropdown-toggle:after, .btn.btn-active-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success.active.dropdown-toggle:after, .btn.btn-active-success.show.dropdown-toggle:after, .show > .btn.btn-active-success.dropdown-toggle:after {\n  color: var(--bs-success-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-success, .btn-check:active + .btn.btn-active-light-success, .btn.btn-active-light-success:focus:not(.btn-active), .btn.btn-active-light-success:hover:not(.btn-active), .btn.btn-active-light-success:active:not(.btn-active), .btn.btn-active-light-success.active, .btn.btn-active-light-success.show, .show > .btn.btn-active-light-success {\n  color: var(--bs-success);\n  border-color: var(--bs-success-light);\n  background-color: var(--bs-success-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-success i,\n.btn-check:checked + .btn.btn-active-light-success .svg-icon, .btn-check:active + .btn.btn-active-light-success i,\n.btn-check:active + .btn.btn-active-light-success .svg-icon, .btn.btn-active-light-success:focus:not(.btn-active) i,\n.btn.btn-active-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-success:hover:not(.btn-active) i,\n.btn.btn-active-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-success:active:not(.btn-active) i,\n.btn.btn-active-light-success:active:not(.btn-active) .svg-icon, .btn.btn-active-light-success.active i,\n.btn.btn-active-light-success.active .svg-icon, .btn.btn-active-light-success.show i,\n.btn.btn-active-light-success.show .svg-icon, .show > .btn.btn-active-light-success i,\n.show > .btn.btn-active-light-success .svg-icon {\n  color: var(--bs-success);\n}\n.btn-check:checked + .btn.btn-active-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-success.dropdown-toggle:after, .btn.btn-active-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success.active.dropdown-toggle:after, .btn.btn-active-light-success.show.dropdown-toggle:after, .show > .btn.btn-active-light-success.dropdown-toggle:after {\n  color: var(--bs-success);\n}\n\n.btn.btn-outline.btn-outline-success {\n  color: var(--bs-success);\n  border-color: var(--bs-success);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-success i,\n.btn.btn-outline.btn-outline-success .svg-icon {\n  color: var(--bs-success);\n}\n.btn.btn-outline.btn-outline-success.dropdown-toggle:after {\n  color: var(--bs-success);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-success, .btn-check:active + .btn.btn-outline.btn-outline-success, .btn.btn-outline.btn-outline-success:focus:not(.btn-active), .btn.btn-outline.btn-outline-success:hover:not(.btn-active), .btn.btn-outline.btn-outline-success:active:not(.btn-active), .btn.btn-outline.btn-outline-success.active, .btn.btn-outline.btn-outline-success.show, .show > .btn.btn-outline.btn-outline-success {\n  color: var(--bs-success-active);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-success i,\n.btn-check:checked + .btn.btn-outline.btn-outline-success .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-success i,\n.btn-check:active + .btn.btn-outline.btn-outline-success .svg-icon, .btn.btn-outline.btn-outline-success:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-success:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-success:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-success:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success.active i,\n.btn.btn-outline.btn-outline-success.active .svg-icon, .btn.btn-outline.btn-outline-success.show i,\n.btn.btn-outline.btn-outline-success.show .svg-icon, .show > .btn.btn-outline.btn-outline-success i,\n.show > .btn.btn-outline.btn-outline-success .svg-icon {\n  color: var(--bs-success-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn.btn-outline.btn-outline-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-success.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-success.dropdown-toggle:after {\n  color: var(--bs-success-active);\n}\n\n.btn.btn-info {\n  color: var(--bs-info-inverse);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info);\n}\n.btn.btn-info i,\n.btn.btn-info .svg-icon {\n  color: var(--bs-info-inverse);\n}\n.btn.btn-info.dropdown-toggle:after {\n  color: var(--bs-info-inverse);\n}\n.btn-check:checked + .btn.btn-info, .btn-check:active + .btn.btn-info, .btn.btn-info:focus:not(.btn-active), .btn.btn-info:hover:not(.btn-active), .btn.btn-info:active:not(.btn-active), .btn.btn-info.active, .btn.btn-info.show, .show > .btn.btn-info {\n  color: var(--bs-info-inverse);\n  border-color: var(--bs-info-active);\n  background-color: var(--bs-info-active) !important;\n}\n.btn-check:checked + .btn.btn-info i,\n.btn-check:checked + .btn.btn-info .svg-icon, .btn-check:active + .btn.btn-info i,\n.btn-check:active + .btn.btn-info .svg-icon, .btn.btn-info:focus:not(.btn-active) i,\n.btn.btn-info:focus:not(.btn-active) .svg-icon, .btn.btn-info:hover:not(.btn-active) i,\n.btn.btn-info:hover:not(.btn-active) .svg-icon, .btn.btn-info:active:not(.btn-active) i,\n.btn.btn-info:active:not(.btn-active) .svg-icon, .btn.btn-info.active i,\n.btn.btn-info.active .svg-icon, .btn.btn-info.show i,\n.btn.btn-info.show .svg-icon, .show > .btn.btn-info i,\n.show > .btn.btn-info .svg-icon {\n  color: var(--bs-info-inverse);\n}\n.btn-check:checked + .btn.btn-info.dropdown-toggle:after, .btn-check:active + .btn.btn-info.dropdown-toggle:after, .btn.btn-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-info.active.dropdown-toggle:after, .btn.btn-info.show.dropdown-toggle:after, .show > .btn.btn-info.dropdown-toggle:after {\n  color: var(--bs-info-inverse);\n}\n\n.btn.btn-light-info {\n  color: var(--bs-info);\n  border-color: var(--bs-info-light);\n  background-color: var(--bs-info-light);\n}\n.btn.btn-light-info i,\n.btn.btn-light-info .svg-icon {\n  color: var(--bs-info);\n}\n.btn.btn-light-info.dropdown-toggle:after {\n  color: var(--bs-info);\n}\n.btn-check:checked + .btn.btn-light-info, .btn-check:active + .btn.btn-light-info, .btn.btn-light-info:focus:not(.btn-active), .btn.btn-light-info:hover:not(.btn-active), .btn.btn-light-info:active:not(.btn-active), .btn.btn-light-info.active, .btn.btn-light-info.show, .show > .btn.btn-light-info {\n  color: var(--bs-info-inverse);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info) !important;\n}\n.btn-check:checked + .btn.btn-light-info i,\n.btn-check:checked + .btn.btn-light-info .svg-icon, .btn-check:active + .btn.btn-light-info i,\n.btn-check:active + .btn.btn-light-info .svg-icon, .btn.btn-light-info:focus:not(.btn-active) i,\n.btn.btn-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-light-info:hover:not(.btn-active) i,\n.btn.btn-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-light-info:active:not(.btn-active) i,\n.btn.btn-light-info:active:not(.btn-active) .svg-icon, .btn.btn-light-info.active i,\n.btn.btn-light-info.active .svg-icon, .btn.btn-light-info.show i,\n.btn.btn-light-info.show .svg-icon, .show > .btn.btn-light-info i,\n.show > .btn.btn-light-info .svg-icon {\n  color: var(--bs-info-inverse);\n}\n.btn-check:checked + .btn.btn-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-light-info.dropdown-toggle:after, .btn.btn-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info.active.dropdown-toggle:after, .btn.btn-light-info.show.dropdown-toggle:after, .show > .btn.btn-light-info.dropdown-toggle:after {\n  color: var(--bs-info-inverse);\n}\n\n.btn.btn-bg-info {\n  border-color: var(--bs-info);\n  background-color: var(--bs-info);\n}\n.btn-check:checked + .btn.btn-active-info, .btn-check:active + .btn.btn-active-info, .btn.btn-active-info:focus:not(.btn-active), .btn.btn-active-info:hover:not(.btn-active), .btn.btn-active-info:active:not(.btn-active), .btn.btn-active-info.active, .btn.btn-active-info.show, .show > .btn.btn-active-info {\n  color: var(--bs-info-inverse);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info) !important;\n}\n.btn-check:checked + .btn.btn-active-info i,\n.btn-check:checked + .btn.btn-active-info .svg-icon, .btn-check:active + .btn.btn-active-info i,\n.btn-check:active + .btn.btn-active-info .svg-icon, .btn.btn-active-info:focus:not(.btn-active) i,\n.btn.btn-active-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-info:hover:not(.btn-active) i,\n.btn.btn-active-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-info:active:not(.btn-active) i,\n.btn.btn-active-info:active:not(.btn-active) .svg-icon, .btn.btn-active-info.active i,\n.btn.btn-active-info.active .svg-icon, .btn.btn-active-info.show i,\n.btn.btn-active-info.show .svg-icon, .show > .btn.btn-active-info i,\n.show > .btn.btn-active-info .svg-icon {\n  color: var(--bs-info-inverse);\n}\n.btn-check:checked + .btn.btn-active-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-info.dropdown-toggle:after, .btn.btn-active-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info.active.dropdown-toggle:after, .btn.btn-active-info.show.dropdown-toggle:after, .show > .btn.btn-active-info.dropdown-toggle:after {\n  color: var(--bs-info-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-info, .btn-check:active + .btn.btn-active-light-info, .btn.btn-active-light-info:focus:not(.btn-active), .btn.btn-active-light-info:hover:not(.btn-active), .btn.btn-active-light-info:active:not(.btn-active), .btn.btn-active-light-info.active, .btn.btn-active-light-info.show, .show > .btn.btn-active-light-info {\n  color: var(--bs-info);\n  border-color: var(--bs-info-light);\n  background-color: var(--bs-info-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-info i,\n.btn-check:checked + .btn.btn-active-light-info .svg-icon, .btn-check:active + .btn.btn-active-light-info i,\n.btn-check:active + .btn.btn-active-light-info .svg-icon, .btn.btn-active-light-info:focus:not(.btn-active) i,\n.btn.btn-active-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-info:hover:not(.btn-active) i,\n.btn.btn-active-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-info:active:not(.btn-active) i,\n.btn.btn-active-light-info:active:not(.btn-active) .svg-icon, .btn.btn-active-light-info.active i,\n.btn.btn-active-light-info.active .svg-icon, .btn.btn-active-light-info.show i,\n.btn.btn-active-light-info.show .svg-icon, .show > .btn.btn-active-light-info i,\n.show > .btn.btn-active-light-info .svg-icon {\n  color: var(--bs-info);\n}\n.btn-check:checked + .btn.btn-active-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-info.dropdown-toggle:after, .btn.btn-active-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info.active.dropdown-toggle:after, .btn.btn-active-light-info.show.dropdown-toggle:after, .show > .btn.btn-active-light-info.dropdown-toggle:after {\n  color: var(--bs-info);\n}\n\n.btn.btn-outline.btn-outline-info {\n  color: var(--bs-info);\n  border-color: var(--bs-info);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-info i,\n.btn.btn-outline.btn-outline-info .svg-icon {\n  color: var(--bs-info);\n}\n.btn.btn-outline.btn-outline-info.dropdown-toggle:after {\n  color: var(--bs-info);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-info, .btn-check:active + .btn.btn-outline.btn-outline-info, .btn.btn-outline.btn-outline-info:focus:not(.btn-active), .btn.btn-outline.btn-outline-info:hover:not(.btn-active), .btn.btn-outline.btn-outline-info:active:not(.btn-active), .btn.btn-outline.btn-outline-info.active, .btn.btn-outline.btn-outline-info.show, .show > .btn.btn-outline.btn-outline-info {\n  color: var(--bs-info-active);\n  border-color: var(--bs-info);\n  background-color: var(--bs-info-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-info i,\n.btn-check:checked + .btn.btn-outline.btn-outline-info .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-info i,\n.btn-check:active + .btn.btn-outline.btn-outline-info .svg-icon, .btn.btn-outline.btn-outline-info:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-info:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-info:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-info:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info.active i,\n.btn.btn-outline.btn-outline-info.active .svg-icon, .btn.btn-outline.btn-outline-info.show i,\n.btn.btn-outline.btn-outline-info.show .svg-icon, .show > .btn.btn-outline.btn-outline-info i,\n.show > .btn.btn-outline.btn-outline-info .svg-icon {\n  color: var(--bs-info-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn.btn-outline.btn-outline-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-info.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-info.dropdown-toggle:after {\n  color: var(--bs-info-active);\n}\n\n.btn.btn-warning {\n  color: var(--bs-warning-inverse);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning);\n}\n.btn.btn-warning i,\n.btn.btn-warning .svg-icon {\n  color: var(--bs-warning-inverse);\n}\n.btn.btn-warning.dropdown-toggle:after {\n  color: var(--bs-warning-inverse);\n}\n.btn-check:checked + .btn.btn-warning, .btn-check:active + .btn.btn-warning, .btn.btn-warning:focus:not(.btn-active), .btn.btn-warning:hover:not(.btn-active), .btn.btn-warning:active:not(.btn-active), .btn.btn-warning.active, .btn.btn-warning.show, .show > .btn.btn-warning {\n  color: var(--bs-warning-inverse);\n  border-color: var(--bs-warning-active);\n  background-color: var(--bs-warning-active) !important;\n}\n.btn-check:checked + .btn.btn-warning i,\n.btn-check:checked + .btn.btn-warning .svg-icon, .btn-check:active + .btn.btn-warning i,\n.btn-check:active + .btn.btn-warning .svg-icon, .btn.btn-warning:focus:not(.btn-active) i,\n.btn.btn-warning:focus:not(.btn-active) .svg-icon, .btn.btn-warning:hover:not(.btn-active) i,\n.btn.btn-warning:hover:not(.btn-active) .svg-icon, .btn.btn-warning:active:not(.btn-active) i,\n.btn.btn-warning:active:not(.btn-active) .svg-icon, .btn.btn-warning.active i,\n.btn.btn-warning.active .svg-icon, .btn.btn-warning.show i,\n.btn.btn-warning.show .svg-icon, .show > .btn.btn-warning i,\n.show > .btn.btn-warning .svg-icon {\n  color: var(--bs-warning-inverse);\n}\n.btn-check:checked + .btn.btn-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-warning.dropdown-toggle:after, .btn.btn-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-warning.active.dropdown-toggle:after, .btn.btn-warning.show.dropdown-toggle:after, .show > .btn.btn-warning.dropdown-toggle:after {\n  color: var(--bs-warning-inverse);\n}\n\n.btn.btn-light-warning {\n  color: var(--bs-warning);\n  border-color: var(--bs-warning-light);\n  background-color: var(--bs-warning-light);\n}\n.btn.btn-light-warning i,\n.btn.btn-light-warning .svg-icon {\n  color: var(--bs-warning);\n}\n.btn.btn-light-warning.dropdown-toggle:after {\n  color: var(--bs-warning);\n}\n.btn-check:checked + .btn.btn-light-warning, .btn-check:active + .btn.btn-light-warning, .btn.btn-light-warning:focus:not(.btn-active), .btn.btn-light-warning:hover:not(.btn-active), .btn.btn-light-warning:active:not(.btn-active), .btn.btn-light-warning.active, .btn.btn-light-warning.show, .show > .btn.btn-light-warning {\n  color: var(--bs-warning-inverse);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning) !important;\n}\n.btn-check:checked + .btn.btn-light-warning i,\n.btn-check:checked + .btn.btn-light-warning .svg-icon, .btn-check:active + .btn.btn-light-warning i,\n.btn-check:active + .btn.btn-light-warning .svg-icon, .btn.btn-light-warning:focus:not(.btn-active) i,\n.btn.btn-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-light-warning:hover:not(.btn-active) i,\n.btn.btn-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-light-warning:active:not(.btn-active) i,\n.btn.btn-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-light-warning.active i,\n.btn.btn-light-warning.active .svg-icon, .btn.btn-light-warning.show i,\n.btn.btn-light-warning.show .svg-icon, .show > .btn.btn-light-warning i,\n.show > .btn.btn-light-warning .svg-icon {\n  color: var(--bs-warning-inverse);\n}\n.btn-check:checked + .btn.btn-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-light-warning.dropdown-toggle:after, .btn.btn-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning.active.dropdown-toggle:after, .btn.btn-light-warning.show.dropdown-toggle:after, .show > .btn.btn-light-warning.dropdown-toggle:after {\n  color: var(--bs-warning-inverse);\n}\n\n.btn.btn-bg-warning {\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning);\n}\n.btn-check:checked + .btn.btn-active-warning, .btn-check:active + .btn.btn-active-warning, .btn.btn-active-warning:focus:not(.btn-active), .btn.btn-active-warning:hover:not(.btn-active), .btn.btn-active-warning:active:not(.btn-active), .btn.btn-active-warning.active, .btn.btn-active-warning.show, .show > .btn.btn-active-warning {\n  color: var(--bs-warning-inverse);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning) !important;\n}\n.btn-check:checked + .btn.btn-active-warning i,\n.btn-check:checked + .btn.btn-active-warning .svg-icon, .btn-check:active + .btn.btn-active-warning i,\n.btn-check:active + .btn.btn-active-warning .svg-icon, .btn.btn-active-warning:focus:not(.btn-active) i,\n.btn.btn-active-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-warning:hover:not(.btn-active) i,\n.btn.btn-active-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-warning:active:not(.btn-active) i,\n.btn.btn-active-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-warning.active i,\n.btn.btn-active-warning.active .svg-icon, .btn.btn-active-warning.show i,\n.btn.btn-active-warning.show .svg-icon, .show > .btn.btn-active-warning i,\n.show > .btn.btn-active-warning .svg-icon {\n  color: var(--bs-warning-inverse);\n}\n.btn-check:checked + .btn.btn-active-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-warning.dropdown-toggle:after, .btn.btn-active-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning.active.dropdown-toggle:after, .btn.btn-active-warning.show.dropdown-toggle:after, .show > .btn.btn-active-warning.dropdown-toggle:after {\n  color: var(--bs-warning-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-warning, .btn-check:active + .btn.btn-active-light-warning, .btn.btn-active-light-warning:focus:not(.btn-active), .btn.btn-active-light-warning:hover:not(.btn-active), .btn.btn-active-light-warning:active:not(.btn-active), .btn.btn-active-light-warning.active, .btn.btn-active-light-warning.show, .show > .btn.btn-active-light-warning {\n  color: var(--bs-warning);\n  border-color: var(--bs-warning-light);\n  background-color: var(--bs-warning-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-warning i,\n.btn-check:checked + .btn.btn-active-light-warning .svg-icon, .btn-check:active + .btn.btn-active-light-warning i,\n.btn-check:active + .btn.btn-active-light-warning .svg-icon, .btn.btn-active-light-warning:focus:not(.btn-active) i,\n.btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:hover:not(.btn-active) i,\n.btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:active:not(.btn-active) i,\n.btn.btn-active-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-light-warning.active i,\n.btn.btn-active-light-warning.active .svg-icon, .btn.btn-active-light-warning.show i,\n.btn.btn-active-light-warning.show .svg-icon, .show > .btn.btn-active-light-warning i,\n.show > .btn.btn-active-light-warning .svg-icon {\n  color: var(--bs-warning);\n}\n.btn-check:checked + .btn.btn-active-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-warning.dropdown-toggle:after, .btn.btn-active-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning.active.dropdown-toggle:after, .btn.btn-active-light-warning.show.dropdown-toggle:after, .show > .btn.btn-active-light-warning.dropdown-toggle:after {\n  color: var(--bs-warning);\n}\n\n.btn.btn-outline.btn-outline-warning {\n  color: var(--bs-warning);\n  border-color: var(--bs-warning);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-warning i,\n.btn.btn-outline.btn-outline-warning .svg-icon {\n  color: var(--bs-warning);\n}\n.btn.btn-outline.btn-outline-warning.dropdown-toggle:after {\n  color: var(--bs-warning);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-warning, .btn-check:active + .btn.btn-outline.btn-outline-warning, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active), .btn.btn-outline.btn-outline-warning:hover:not(.btn-active), .btn.btn-outline.btn-outline-warning:active:not(.btn-active), .btn.btn-outline.btn-outline-warning.active, .btn.btn-outline.btn-outline-warning.show, .show > .btn.btn-outline.btn-outline-warning {\n  color: var(--bs-warning-active);\n  border-color: var(--bs-warning);\n  background-color: var(--bs-warning-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-warning i,\n.btn-check:checked + .btn.btn-outline.btn-outline-warning .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-warning i,\n.btn-check:active + .btn.btn-outline.btn-outline-warning .svg-icon, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-warning:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-warning:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-warning:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning.active i,\n.btn.btn-outline.btn-outline-warning.active .svg-icon, .btn.btn-outline.btn-outline-warning.show i,\n.btn.btn-outline.btn-outline-warning.show .svg-icon, .show > .btn.btn-outline.btn-outline-warning i,\n.show > .btn.btn-outline.btn-outline-warning .svg-icon {\n  color: var(--bs-warning-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-warning.dropdown-toggle:after {\n  color: var(--bs-warning-active);\n}\n\n.btn.btn-danger {\n  color: var(--bs-danger-inverse);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger);\n}\n.btn.btn-danger i,\n.btn.btn-danger .svg-icon {\n  color: var(--bs-danger-inverse);\n}\n.btn.btn-danger.dropdown-toggle:after {\n  color: var(--bs-danger-inverse);\n}\n.btn-check:checked + .btn.btn-danger, .btn-check:active + .btn.btn-danger, .btn.btn-danger:focus:not(.btn-active), .btn.btn-danger:hover:not(.btn-active), .btn.btn-danger:active:not(.btn-active), .btn.btn-danger.active, .btn.btn-danger.show, .show > .btn.btn-danger {\n  color: var(--bs-danger-inverse);\n  border-color: var(--bs-danger-active);\n  background-color: var(--bs-danger-active) !important;\n}\n.btn-check:checked + .btn.btn-danger i,\n.btn-check:checked + .btn.btn-danger .svg-icon, .btn-check:active + .btn.btn-danger i,\n.btn-check:active + .btn.btn-danger .svg-icon, .btn.btn-danger:focus:not(.btn-active) i,\n.btn.btn-danger:focus:not(.btn-active) .svg-icon, .btn.btn-danger:hover:not(.btn-active) i,\n.btn.btn-danger:hover:not(.btn-active) .svg-icon, .btn.btn-danger:active:not(.btn-active) i,\n.btn.btn-danger:active:not(.btn-active) .svg-icon, .btn.btn-danger.active i,\n.btn.btn-danger.active .svg-icon, .btn.btn-danger.show i,\n.btn.btn-danger.show .svg-icon, .show > .btn.btn-danger i,\n.show > .btn.btn-danger .svg-icon {\n  color: var(--bs-danger-inverse);\n}\n.btn-check:checked + .btn.btn-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-danger.dropdown-toggle:after, .btn.btn-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-danger.active.dropdown-toggle:after, .btn.btn-danger.show.dropdown-toggle:after, .show > .btn.btn-danger.dropdown-toggle:after {\n  color: var(--bs-danger-inverse);\n}\n\n.btn.btn-light-danger {\n  color: var(--bs-danger);\n  border-color: var(--bs-danger-light);\n  background-color: var(--bs-danger-light);\n}\n.btn.btn-light-danger i,\n.btn.btn-light-danger .svg-icon {\n  color: var(--bs-danger);\n}\n.btn.btn-light-danger.dropdown-toggle:after {\n  color: var(--bs-danger);\n}\n.btn-check:checked + .btn.btn-light-danger, .btn-check:active + .btn.btn-light-danger, .btn.btn-light-danger:focus:not(.btn-active), .btn.btn-light-danger:hover:not(.btn-active), .btn.btn-light-danger:active:not(.btn-active), .btn.btn-light-danger.active, .btn.btn-light-danger.show, .show > .btn.btn-light-danger {\n  color: var(--bs-danger-inverse);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger) !important;\n}\n.btn-check:checked + .btn.btn-light-danger i,\n.btn-check:checked + .btn.btn-light-danger .svg-icon, .btn-check:active + .btn.btn-light-danger i,\n.btn-check:active + .btn.btn-light-danger .svg-icon, .btn.btn-light-danger:focus:not(.btn-active) i,\n.btn.btn-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-light-danger:hover:not(.btn-active) i,\n.btn.btn-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-light-danger:active:not(.btn-active) i,\n.btn.btn-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-light-danger.active i,\n.btn.btn-light-danger.active .svg-icon, .btn.btn-light-danger.show i,\n.btn.btn-light-danger.show .svg-icon, .show > .btn.btn-light-danger i,\n.show > .btn.btn-light-danger .svg-icon {\n  color: var(--bs-danger-inverse);\n}\n.btn-check:checked + .btn.btn-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-light-danger.dropdown-toggle:after, .btn.btn-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger.active.dropdown-toggle:after, .btn.btn-light-danger.show.dropdown-toggle:after, .show > .btn.btn-light-danger.dropdown-toggle:after {\n  color: var(--bs-danger-inverse);\n}\n\n.btn.btn-bg-danger {\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger);\n}\n.btn-check:checked + .btn.btn-active-danger, .btn-check:active + .btn.btn-active-danger, .btn.btn-active-danger:focus:not(.btn-active), .btn.btn-active-danger:hover:not(.btn-active), .btn.btn-active-danger:active:not(.btn-active), .btn.btn-active-danger.active, .btn.btn-active-danger.show, .show > .btn.btn-active-danger {\n  color: var(--bs-danger-inverse);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger) !important;\n}\n.btn-check:checked + .btn.btn-active-danger i,\n.btn-check:checked + .btn.btn-active-danger .svg-icon, .btn-check:active + .btn.btn-active-danger i,\n.btn-check:active + .btn.btn-active-danger .svg-icon, .btn.btn-active-danger:focus:not(.btn-active) i,\n.btn.btn-active-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-danger:hover:not(.btn-active) i,\n.btn.btn-active-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-danger:active:not(.btn-active) i,\n.btn.btn-active-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-danger.active i,\n.btn.btn-active-danger.active .svg-icon, .btn.btn-active-danger.show i,\n.btn.btn-active-danger.show .svg-icon, .show > .btn.btn-active-danger i,\n.show > .btn.btn-active-danger .svg-icon {\n  color: var(--bs-danger-inverse);\n}\n.btn-check:checked + .btn.btn-active-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-danger.dropdown-toggle:after, .btn.btn-active-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger.active.dropdown-toggle:after, .btn.btn-active-danger.show.dropdown-toggle:after, .show > .btn.btn-active-danger.dropdown-toggle:after {\n  color: var(--bs-danger-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-danger, .btn-check:active + .btn.btn-active-light-danger, .btn.btn-active-light-danger:focus:not(.btn-active), .btn.btn-active-light-danger:hover:not(.btn-active), .btn.btn-active-light-danger:active:not(.btn-active), .btn.btn-active-light-danger.active, .btn.btn-active-light-danger.show, .show > .btn.btn-active-light-danger {\n  color: var(--bs-danger);\n  border-color: var(--bs-danger-light);\n  background-color: var(--bs-danger-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-danger i,\n.btn-check:checked + .btn.btn-active-light-danger .svg-icon, .btn-check:active + .btn.btn-active-light-danger i,\n.btn-check:active + .btn.btn-active-light-danger .svg-icon, .btn.btn-active-light-danger:focus:not(.btn-active) i,\n.btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:hover:not(.btn-active) i,\n.btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:active:not(.btn-active) i,\n.btn.btn-active-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-light-danger.active i,\n.btn.btn-active-light-danger.active .svg-icon, .btn.btn-active-light-danger.show i,\n.btn.btn-active-light-danger.show .svg-icon, .show > .btn.btn-active-light-danger i,\n.show > .btn.btn-active-light-danger .svg-icon {\n  color: var(--bs-danger);\n}\n.btn-check:checked + .btn.btn-active-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-danger.dropdown-toggle:after, .btn.btn-active-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger.active.dropdown-toggle:after, .btn.btn-active-light-danger.show.dropdown-toggle:after, .show > .btn.btn-active-light-danger.dropdown-toggle:after {\n  color: var(--bs-danger);\n}\n\n.btn.btn-outline.btn-outline-danger {\n  color: var(--bs-danger);\n  border-color: var(--bs-danger);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-danger i,\n.btn.btn-outline.btn-outline-danger .svg-icon {\n  color: var(--bs-danger);\n}\n.btn.btn-outline.btn-outline-danger.dropdown-toggle:after {\n  color: var(--bs-danger);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-danger, .btn-check:active + .btn.btn-outline.btn-outline-danger, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active), .btn.btn-outline.btn-outline-danger:hover:not(.btn-active), .btn.btn-outline.btn-outline-danger:active:not(.btn-active), .btn.btn-outline.btn-outline-danger.active, .btn.btn-outline.btn-outline-danger.show, .show > .btn.btn-outline.btn-outline-danger {\n  color: var(--bs-danger-active);\n  border-color: var(--bs-danger);\n  background-color: var(--bs-danger-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-danger i,\n.btn-check:checked + .btn.btn-outline.btn-outline-danger .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-danger i,\n.btn-check:active + .btn.btn-outline.btn-outline-danger .svg-icon, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-danger:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-danger:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-danger:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger.active i,\n.btn.btn-outline.btn-outline-danger.active .svg-icon, .btn.btn-outline.btn-outline-danger.show i,\n.btn.btn-outline.btn-outline-danger.show .svg-icon, .show > .btn.btn-outline.btn-outline-danger i,\n.show > .btn.btn-outline.btn-outline-danger .svg-icon {\n  color: var(--bs-danger-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-danger.dropdown-toggle:after {\n  color: var(--bs-danger-active);\n}\n\n.btn.btn-dark {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark);\n}\n.btn.btn-dark i,\n.btn.btn-dark .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.btn.btn-dark.dropdown-toggle:after {\n  color: var(--bs-dark-inverse);\n}\n.btn-check:checked + .btn.btn-dark, .btn-check:active + .btn.btn-dark, .btn.btn-dark:focus:not(.btn-active), .btn.btn-dark:hover:not(.btn-active), .btn.btn-dark:active:not(.btn-active), .btn.btn-dark.active, .btn.btn-dark.show, .show > .btn.btn-dark {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark-active);\n  background-color: var(--bs-dark-active) !important;\n}\n.btn-check:checked + .btn.btn-dark i,\n.btn-check:checked + .btn.btn-dark .svg-icon, .btn-check:active + .btn.btn-dark i,\n.btn-check:active + .btn.btn-dark .svg-icon, .btn.btn-dark:focus:not(.btn-active) i,\n.btn.btn-dark:focus:not(.btn-active) .svg-icon, .btn.btn-dark:hover:not(.btn-active) i,\n.btn.btn-dark:hover:not(.btn-active) .svg-icon, .btn.btn-dark:active:not(.btn-active) i,\n.btn.btn-dark:active:not(.btn-active) .svg-icon, .btn.btn-dark.active i,\n.btn.btn-dark.active .svg-icon, .btn.btn-dark.show i,\n.btn.btn-dark.show .svg-icon, .show > .btn.btn-dark i,\n.show > .btn.btn-dark .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.btn-check:checked + .btn.btn-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-dark.dropdown-toggle:after, .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-dark.active.dropdown-toggle:after, .btn.btn-dark.show.dropdown-toggle:after, .show > .btn.btn-dark.dropdown-toggle:after {\n  color: var(--bs-dark-inverse);\n}\n\n.btn.btn-light-dark {\n  color: var(--bs-dark);\n  border-color: var(--bs-dark-light);\n  background-color: var(--bs-dark-light);\n}\n.btn.btn-light-dark i,\n.btn.btn-light-dark .svg-icon {\n  color: var(--bs-dark);\n}\n.btn.btn-light-dark.dropdown-toggle:after {\n  color: var(--bs-dark);\n}\n.btn-check:checked + .btn.btn-light-dark, .btn-check:active + .btn.btn-light-dark, .btn.btn-light-dark:focus:not(.btn-active), .btn.btn-light-dark:hover:not(.btn-active), .btn.btn-light-dark:active:not(.btn-active), .btn.btn-light-dark.active, .btn.btn-light-dark.show, .show > .btn.btn-light-dark {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark) !important;\n}\n.btn-check:checked + .btn.btn-light-dark i,\n.btn-check:checked + .btn.btn-light-dark .svg-icon, .btn-check:active + .btn.btn-light-dark i,\n.btn-check:active + .btn.btn-light-dark .svg-icon, .btn.btn-light-dark:focus:not(.btn-active) i,\n.btn.btn-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-light-dark:hover:not(.btn-active) i,\n.btn.btn-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-light-dark:active:not(.btn-active) i,\n.btn.btn-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-light-dark.active i,\n.btn.btn-light-dark.active .svg-icon, .btn.btn-light-dark.show i,\n.btn.btn-light-dark.show .svg-icon, .show > .btn.btn-light-dark i,\n.show > .btn.btn-light-dark .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.btn-check:checked + .btn.btn-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-light-dark.dropdown-toggle:after, .btn.btn-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark.active.dropdown-toggle:after, .btn.btn-light-dark.show.dropdown-toggle:after, .show > .btn.btn-light-dark.dropdown-toggle:after {\n  color: var(--bs-dark-inverse);\n}\n\n.btn.btn-bg-dark {\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark);\n}\n.btn-check:checked + .btn.btn-active-dark, .btn-check:active + .btn.btn-active-dark, .btn.btn-active-dark:focus:not(.btn-active), .btn.btn-active-dark:hover:not(.btn-active), .btn.btn-active-dark:active:not(.btn-active), .btn.btn-active-dark.active, .btn.btn-active-dark.show, .show > .btn.btn-active-dark {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark) !important;\n}\n.btn-check:checked + .btn.btn-active-dark i,\n.btn-check:checked + .btn.btn-active-dark .svg-icon, .btn-check:active + .btn.btn-active-dark i,\n.btn-check:active + .btn.btn-active-dark .svg-icon, .btn.btn-active-dark:focus:not(.btn-active) i,\n.btn.btn-active-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-dark:hover:not(.btn-active) i,\n.btn.btn-active-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-dark:active:not(.btn-active) i,\n.btn.btn-active-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-dark.active i,\n.btn.btn-active-dark.active .svg-icon, .btn.btn-active-dark.show i,\n.btn.btn-active-dark.show .svg-icon, .show > .btn.btn-active-dark i,\n.show > .btn.btn-active-dark .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.btn-check:checked + .btn.btn-active-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-dark.dropdown-toggle:after, .btn.btn-active-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark.active.dropdown-toggle:after, .btn.btn-active-dark.show.dropdown-toggle:after, .show > .btn.btn-active-dark.dropdown-toggle:after {\n  color: var(--bs-dark-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-dark, .btn-check:active + .btn.btn-active-light-dark, .btn.btn-active-light-dark:focus:not(.btn-active), .btn.btn-active-light-dark:hover:not(.btn-active), .btn.btn-active-light-dark:active:not(.btn-active), .btn.btn-active-light-dark.active, .btn.btn-active-light-dark.show, .show > .btn.btn-active-light-dark {\n  color: var(--bs-dark);\n  border-color: var(--bs-dark-light);\n  background-color: var(--bs-dark-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-dark i,\n.btn-check:checked + .btn.btn-active-light-dark .svg-icon, .btn-check:active + .btn.btn-active-light-dark i,\n.btn-check:active + .btn.btn-active-light-dark .svg-icon, .btn.btn-active-light-dark:focus:not(.btn-active) i,\n.btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:hover:not(.btn-active) i,\n.btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:active:not(.btn-active) i,\n.btn.btn-active-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-light-dark.active i,\n.btn.btn-active-light-dark.active .svg-icon, .btn.btn-active-light-dark.show i,\n.btn.btn-active-light-dark.show .svg-icon, .show > .btn.btn-active-light-dark i,\n.show > .btn.btn-active-light-dark .svg-icon {\n  color: var(--bs-dark);\n}\n.btn-check:checked + .btn.btn-active-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-dark.dropdown-toggle:after, .btn.btn-active-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark.active.dropdown-toggle:after, .btn.btn-active-light-dark.show.dropdown-toggle:after, .show > .btn.btn-active-light-dark.dropdown-toggle:after {\n  color: var(--bs-dark);\n}\n\n.btn.btn-outline.btn-outline-dark {\n  color: var(--bs-dark);\n  border-color: var(--bs-dark);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-dark i,\n.btn.btn-outline.btn-outline-dark .svg-icon {\n  color: var(--bs-dark);\n}\n.btn.btn-outline.btn-outline-dark.dropdown-toggle:after {\n  color: var(--bs-dark);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dark, .btn-check:active + .btn.btn-outline.btn-outline-dark, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active), .btn.btn-outline.btn-outline-dark:hover:not(.btn-active), .btn.btn-outline.btn-outline-dark:active:not(.btn-active), .btn.btn-outline.btn-outline-dark.active, .btn.btn-outline.btn-outline-dark.show, .show > .btn.btn-outline.btn-outline-dark {\n  color: var(--bs-dark-active);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dark i,\n.btn-check:checked + .btn.btn-outline.btn-outline-dark .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-dark i,\n.btn-check:active + .btn.btn-outline.btn-outline-dark .svg-icon, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-dark:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-dark:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-dark:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark.active i,\n.btn.btn-outline.btn-outline-dark.active .svg-icon, .btn.btn-outline.btn-outline-dark.show i,\n.btn.btn-outline.btn-outline-dark.show .svg-icon, .show > .btn.btn-outline.btn-outline-dark i,\n.show > .btn.btn-outline.btn-outline-dark .svg-icon {\n  color: var(--bs-dark-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-dark.dropdown-toggle:after {\n  color: var(--bs-dark-active);\n}\n\n.btn.btn-color-white {\n  color: var(--bs-text-white);\n}\n.btn.btn-color-white i,\n.btn.btn-color-white .svg-icon {\n  color: var(--bs-text-white);\n}\n.btn.btn-color-white.dropdown-toggle:after {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-color-white, .btn-check:active + .btn.btn-active-color-white, .btn.btn-active-color-white:focus:not(.btn-active), .btn.btn-active-color-white:hover:not(.btn-active), .btn.btn-active-color-white:active:not(.btn-active), .btn.btn-active-color-white.active, .btn.btn-active-color-white.show, .show > .btn.btn-active-color-white {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-color-white i,\n.btn-check:checked + .btn.btn-active-color-white .svg-icon, .btn-check:active + .btn.btn-active-color-white i,\n.btn-check:active + .btn.btn-active-color-white .svg-icon, .btn.btn-active-color-white:focus:not(.btn-active) i,\n.btn.btn-active-color-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-white:hover:not(.btn-active) i,\n.btn.btn-active-color-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-white:active:not(.btn-active) i,\n.btn.btn-active-color-white:active:not(.btn-active) .svg-icon, .btn.btn-active-color-white.active i,\n.btn.btn-active-color-white.active .svg-icon, .btn.btn-active-color-white.show i,\n.btn.btn-active-color-white.show .svg-icon, .show > .btn.btn-active-color-white i,\n.show > .btn.btn-active-color-white .svg-icon {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-color-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-white.dropdown-toggle:after, .btn.btn-active-color-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white.active.dropdown-toggle:after, .btn.btn-active-color-white.show.dropdown-toggle:after, .show > .btn.btn-active-color-white.dropdown-toggle:after {\n  color: var(--bs-text-white);\n}\n\n.btn.btn-icon-white i,\n.btn.btn-icon-white .svg-icon {\n  color: var(--bs-text-white);\n}\n.btn.btn-icon-white.dropdown-toggle:after {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-icon-white i,\n.btn-check:checked + .btn.btn-active-icon-white .svg-icon, .btn-check:active + .btn.btn-active-icon-white i,\n.btn-check:active + .btn.btn-active-icon-white .svg-icon, .btn.btn-active-icon-white:focus:not(.btn-active) i,\n.btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:hover:not(.btn-active) i,\n.btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:active:not(.btn-active) i,\n.btn.btn-active-icon-white:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-white.active i,\n.btn.btn-active-icon-white.active .svg-icon, .btn.btn-active-icon-white.show i,\n.btn.btn-active-icon-white.show .svg-icon, .show > .btn.btn-active-icon-white i,\n.show > .btn.btn-active-icon-white .svg-icon {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-icon-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-white.dropdown-toggle:after, .btn.btn-active-icon-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white.active.dropdown-toggle:after, .btn.btn-active-icon-white.show.dropdown-toggle:after, .show > .btn.btn-active-icon-white.dropdown-toggle:after {\n  color: var(--bs-text-white);\n}\n\n.btn.btn-text-white {\n  color: var(--bs-text-white);\n}\n.btn-check:checked + .btn.btn-active-text-white, .btn-check:active + .btn.btn-active-text-white, .btn.btn-active-text-white:focus:not(.btn-active), .btn.btn-active-text-white:hover:not(.btn-active), .btn.btn-active-text-white:active:not(.btn-active), .btn.btn-active-text-white.active, .btn.btn-active-text-white.show, .show > .btn.btn-active-text-white {\n  color: var(--bs-text-white);\n}\n\n.btn.btn-color-primary {\n  color: var(--bs-text-primary);\n}\n.btn.btn-color-primary i,\n.btn.btn-color-primary .svg-icon {\n  color: var(--bs-text-primary);\n}\n.btn.btn-color-primary.dropdown-toggle:after {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-color-primary, .btn-check:active + .btn.btn-active-color-primary, .btn.btn-active-color-primary:focus:not(.btn-active), .btn.btn-active-color-primary:hover:not(.btn-active), .btn.btn-active-color-primary:active:not(.btn-active), .btn.btn-active-color-primary.active, .btn.btn-active-color-primary.show, .show > .btn.btn-active-color-primary {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-color-primary i,\n.btn-check:checked + .btn.btn-active-color-primary .svg-icon, .btn-check:active + .btn.btn-active-color-primary i,\n.btn-check:active + .btn.btn-active-color-primary .svg-icon, .btn.btn-active-color-primary:focus:not(.btn-active) i,\n.btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:hover:not(.btn-active) i,\n.btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:active:not(.btn-active) i,\n.btn.btn-active-color-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-primary.active i,\n.btn.btn-active-color-primary.active .svg-icon, .btn.btn-active-color-primary.show i,\n.btn.btn-active-color-primary.show .svg-icon, .show > .btn.btn-active-color-primary i,\n.show > .btn.btn-active-color-primary .svg-icon {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-color-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-primary.dropdown-toggle:after, .btn.btn-active-color-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary.active.dropdown-toggle:after, .btn.btn-active-color-primary.show.dropdown-toggle:after, .show > .btn.btn-active-color-primary.dropdown-toggle:after {\n  color: var(--bs-text-primary);\n}\n\n.btn.btn-icon-primary i,\n.btn.btn-icon-primary .svg-icon {\n  color: var(--bs-text-primary);\n}\n.btn.btn-icon-primary.dropdown-toggle:after {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-icon-primary i,\n.btn-check:checked + .btn.btn-active-icon-primary .svg-icon, .btn-check:active + .btn.btn-active-icon-primary i,\n.btn-check:active + .btn.btn-active-icon-primary .svg-icon, .btn.btn-active-icon-primary:focus:not(.btn-active) i,\n.btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:hover:not(.btn-active) i,\n.btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:active:not(.btn-active) i,\n.btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary.active i,\n.btn.btn-active-icon-primary.active .svg-icon, .btn.btn-active-icon-primary.show i,\n.btn.btn-active-icon-primary.show .svg-icon, .show > .btn.btn-active-icon-primary i,\n.show > .btn.btn-active-icon-primary .svg-icon {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn.btn-active-icon-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary.active.dropdown-toggle:after, .btn.btn-active-icon-primary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-primary.dropdown-toggle:after {\n  color: var(--bs-text-primary);\n}\n\n.btn.btn-text-primary {\n  color: var(--bs-text-primary);\n}\n.btn-check:checked + .btn.btn-active-text-primary, .btn-check:active + .btn.btn-active-text-primary, .btn.btn-active-text-primary:focus:not(.btn-active), .btn.btn-active-text-primary:hover:not(.btn-active), .btn.btn-active-text-primary:active:not(.btn-active), .btn.btn-active-text-primary.active, .btn.btn-active-text-primary.show, .show > .btn.btn-active-text-primary {\n  color: var(--bs-text-primary);\n}\n\n.btn.btn-color-secondary {\n  color: var(--bs-text-secondary);\n}\n.btn.btn-color-secondary i,\n.btn.btn-color-secondary .svg-icon {\n  color: var(--bs-text-secondary);\n}\n.btn.btn-color-secondary.dropdown-toggle:after {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-color-secondary, .btn-check:active + .btn.btn-active-color-secondary, .btn.btn-active-color-secondary:focus:not(.btn-active), .btn.btn-active-color-secondary:hover:not(.btn-active), .btn.btn-active-color-secondary:active:not(.btn-active), .btn.btn-active-color-secondary.active, .btn.btn-active-color-secondary.show, .show > .btn.btn-active-color-secondary {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-color-secondary i,\n.btn-check:checked + .btn.btn-active-color-secondary .svg-icon, .btn-check:active + .btn.btn-active-color-secondary i,\n.btn-check:active + .btn.btn-active-color-secondary .svg-icon, .btn.btn-active-color-secondary:focus:not(.btn-active) i,\n.btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:hover:not(.btn-active) i,\n.btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:active:not(.btn-active) i,\n.btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary.active i,\n.btn.btn-active-color-secondary.active .svg-icon, .btn.btn-active-color-secondary.show i,\n.btn.btn-active-color-secondary.show .svg-icon, .show > .btn.btn-active-color-secondary i,\n.show > .btn.btn-active-color-secondary .svg-icon {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn.btn-active-color-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary.active.dropdown-toggle:after, .btn.btn-active-color-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-color-secondary.dropdown-toggle:after {\n  color: var(--bs-text-secondary);\n}\n\n.btn.btn-icon-secondary i,\n.btn.btn-icon-secondary .svg-icon {\n  color: var(--bs-text-secondary);\n}\n.btn.btn-icon-secondary.dropdown-toggle:after {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-icon-secondary i,\n.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon, .btn-check:active + .btn.btn-active-icon-secondary i,\n.btn-check:active + .btn.btn-active-icon-secondary .svg-icon, .btn.btn-active-icon-secondary:focus:not(.btn-active) i,\n.btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:hover:not(.btn-active) i,\n.btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:active:not(.btn-active) i,\n.btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary.active i,\n.btn.btn-active-icon-secondary.active .svg-icon, .btn.btn-active-icon-secondary.show i,\n.btn.btn-active-icon-secondary.show .svg-icon, .show > .btn.btn-active-icon-secondary i,\n.show > .btn.btn-active-icon-secondary .svg-icon {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn.btn-active-icon-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary.active.dropdown-toggle:after, .btn.btn-active-icon-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-secondary.dropdown-toggle:after {\n  color: var(--bs-text-secondary);\n}\n\n.btn.btn-text-secondary {\n  color: var(--bs-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-text-secondary, .btn-check:active + .btn.btn-active-text-secondary, .btn.btn-active-text-secondary:focus:not(.btn-active), .btn.btn-active-text-secondary:hover:not(.btn-active), .btn.btn-active-text-secondary:active:not(.btn-active), .btn.btn-active-text-secondary.active, .btn.btn-active-text-secondary.show, .show > .btn.btn-active-text-secondary {\n  color: var(--bs-text-secondary);\n}\n\n.btn.btn-color-light {\n  color: var(--bs-text-light);\n}\n.btn.btn-color-light i,\n.btn.btn-color-light .svg-icon {\n  color: var(--bs-text-light);\n}\n.btn.btn-color-light.dropdown-toggle:after {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-color-light, .btn-check:active + .btn.btn-active-color-light, .btn.btn-active-color-light:focus:not(.btn-active), .btn.btn-active-color-light:hover:not(.btn-active), .btn.btn-active-color-light:active:not(.btn-active), .btn.btn-active-color-light.active, .btn.btn-active-color-light.show, .show > .btn.btn-active-color-light {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-color-light i,\n.btn-check:checked + .btn.btn-active-color-light .svg-icon, .btn-check:active + .btn.btn-active-color-light i,\n.btn-check:active + .btn.btn-active-color-light .svg-icon, .btn.btn-active-color-light:focus:not(.btn-active) i,\n.btn.btn-active-color-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-light:hover:not(.btn-active) i,\n.btn.btn-active-color-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-light:active:not(.btn-active) i,\n.btn.btn-active-color-light:active:not(.btn-active) .svg-icon, .btn.btn-active-color-light.active i,\n.btn.btn-active-color-light.active .svg-icon, .btn.btn-active-color-light.show i,\n.btn.btn-active-color-light.show .svg-icon, .show > .btn.btn-active-color-light i,\n.show > .btn.btn-active-color-light .svg-icon {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-color-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-light.dropdown-toggle:after, .btn.btn-active-color-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light.active.dropdown-toggle:after, .btn.btn-active-color-light.show.dropdown-toggle:after, .show > .btn.btn-active-color-light.dropdown-toggle:after {\n  color: var(--bs-text-light);\n}\n\n.btn.btn-icon-light i,\n.btn.btn-icon-light .svg-icon {\n  color: var(--bs-text-light);\n}\n.btn.btn-icon-light.dropdown-toggle:after {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-icon-light i,\n.btn-check:checked + .btn.btn-active-icon-light .svg-icon, .btn-check:active + .btn.btn-active-icon-light i,\n.btn-check:active + .btn.btn-active-icon-light .svg-icon, .btn.btn-active-icon-light:focus:not(.btn-active) i,\n.btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:hover:not(.btn-active) i,\n.btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:active:not(.btn-active) i,\n.btn.btn-active-icon-light:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-light.active i,\n.btn.btn-active-icon-light.active .svg-icon, .btn.btn-active-icon-light.show i,\n.btn.btn-active-icon-light.show .svg-icon, .show > .btn.btn-active-icon-light i,\n.show > .btn.btn-active-icon-light .svg-icon {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-icon-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-light.dropdown-toggle:after, .btn.btn-active-icon-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light.active.dropdown-toggle:after, .btn.btn-active-icon-light.show.dropdown-toggle:after, .show > .btn.btn-active-icon-light.dropdown-toggle:after {\n  color: var(--bs-text-light);\n}\n\n.btn.btn-text-light {\n  color: var(--bs-text-light);\n}\n.btn-check:checked + .btn.btn-active-text-light, .btn-check:active + .btn.btn-active-text-light, .btn.btn-active-text-light:focus:not(.btn-active), .btn.btn-active-text-light:hover:not(.btn-active), .btn.btn-active-text-light:active:not(.btn-active), .btn.btn-active-text-light.active, .btn.btn-active-text-light.show, .show > .btn.btn-active-text-light {\n  color: var(--bs-text-light);\n}\n\n.btn.btn-color-success {\n  color: var(--bs-text-success);\n}\n.btn.btn-color-success i,\n.btn.btn-color-success .svg-icon {\n  color: var(--bs-text-success);\n}\n.btn.btn-color-success.dropdown-toggle:after {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-color-success, .btn-check:active + .btn.btn-active-color-success, .btn.btn-active-color-success:focus:not(.btn-active), .btn.btn-active-color-success:hover:not(.btn-active), .btn.btn-active-color-success:active:not(.btn-active), .btn.btn-active-color-success.active, .btn.btn-active-color-success.show, .show > .btn.btn-active-color-success {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-color-success i,\n.btn-check:checked + .btn.btn-active-color-success .svg-icon, .btn-check:active + .btn.btn-active-color-success i,\n.btn-check:active + .btn.btn-active-color-success .svg-icon, .btn.btn-active-color-success:focus:not(.btn-active) i,\n.btn.btn-active-color-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-success:hover:not(.btn-active) i,\n.btn.btn-active-color-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-success:active:not(.btn-active) i,\n.btn.btn-active-color-success:active:not(.btn-active) .svg-icon, .btn.btn-active-color-success.active i,\n.btn.btn-active-color-success.active .svg-icon, .btn.btn-active-color-success.show i,\n.btn.btn-active-color-success.show .svg-icon, .show > .btn.btn-active-color-success i,\n.show > .btn.btn-active-color-success .svg-icon {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-color-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-success.dropdown-toggle:after, .btn.btn-active-color-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success.active.dropdown-toggle:after, .btn.btn-active-color-success.show.dropdown-toggle:after, .show > .btn.btn-active-color-success.dropdown-toggle:after {\n  color: var(--bs-text-success);\n}\n\n.btn.btn-icon-success i,\n.btn.btn-icon-success .svg-icon {\n  color: var(--bs-text-success);\n}\n.btn.btn-icon-success.dropdown-toggle:after {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-icon-success i,\n.btn-check:checked + .btn.btn-active-icon-success .svg-icon, .btn-check:active + .btn.btn-active-icon-success i,\n.btn-check:active + .btn.btn-active-icon-success .svg-icon, .btn.btn-active-icon-success:focus:not(.btn-active) i,\n.btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:hover:not(.btn-active) i,\n.btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:active:not(.btn-active) i,\n.btn.btn-active-icon-success:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-success.active i,\n.btn.btn-active-icon-success.active .svg-icon, .btn.btn-active-icon-success.show i,\n.btn.btn-active-icon-success.show .svg-icon, .show > .btn.btn-active-icon-success i,\n.show > .btn.btn-active-icon-success .svg-icon {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-icon-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-success.dropdown-toggle:after, .btn.btn-active-icon-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success.active.dropdown-toggle:after, .btn.btn-active-icon-success.show.dropdown-toggle:after, .show > .btn.btn-active-icon-success.dropdown-toggle:after {\n  color: var(--bs-text-success);\n}\n\n.btn.btn-text-success {\n  color: var(--bs-text-success);\n}\n.btn-check:checked + .btn.btn-active-text-success, .btn-check:active + .btn.btn-active-text-success, .btn.btn-active-text-success:focus:not(.btn-active), .btn.btn-active-text-success:hover:not(.btn-active), .btn.btn-active-text-success:active:not(.btn-active), .btn.btn-active-text-success.active, .btn.btn-active-text-success.show, .show > .btn.btn-active-text-success {\n  color: var(--bs-text-success);\n}\n\n.btn.btn-color-info {\n  color: var(--bs-text-info);\n}\n.btn.btn-color-info i,\n.btn.btn-color-info .svg-icon {\n  color: var(--bs-text-info);\n}\n.btn.btn-color-info.dropdown-toggle:after {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-color-info, .btn-check:active + .btn.btn-active-color-info, .btn.btn-active-color-info:focus:not(.btn-active), .btn.btn-active-color-info:hover:not(.btn-active), .btn.btn-active-color-info:active:not(.btn-active), .btn.btn-active-color-info.active, .btn.btn-active-color-info.show, .show > .btn.btn-active-color-info {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-color-info i,\n.btn-check:checked + .btn.btn-active-color-info .svg-icon, .btn-check:active + .btn.btn-active-color-info i,\n.btn-check:active + .btn.btn-active-color-info .svg-icon, .btn.btn-active-color-info:focus:not(.btn-active) i,\n.btn.btn-active-color-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-info:hover:not(.btn-active) i,\n.btn.btn-active-color-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-info:active:not(.btn-active) i,\n.btn.btn-active-color-info:active:not(.btn-active) .svg-icon, .btn.btn-active-color-info.active i,\n.btn.btn-active-color-info.active .svg-icon, .btn.btn-active-color-info.show i,\n.btn.btn-active-color-info.show .svg-icon, .show > .btn.btn-active-color-info i,\n.show > .btn.btn-active-color-info .svg-icon {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-color-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-info.dropdown-toggle:after, .btn.btn-active-color-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info.active.dropdown-toggle:after, .btn.btn-active-color-info.show.dropdown-toggle:after, .show > .btn.btn-active-color-info.dropdown-toggle:after {\n  color: var(--bs-text-info);\n}\n\n.btn.btn-icon-info i,\n.btn.btn-icon-info .svg-icon {\n  color: var(--bs-text-info);\n}\n.btn.btn-icon-info.dropdown-toggle:after {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-icon-info i,\n.btn-check:checked + .btn.btn-active-icon-info .svg-icon, .btn-check:active + .btn.btn-active-icon-info i,\n.btn-check:active + .btn.btn-active-icon-info .svg-icon, .btn.btn-active-icon-info:focus:not(.btn-active) i,\n.btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:hover:not(.btn-active) i,\n.btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:active:not(.btn-active) i,\n.btn.btn-active-icon-info:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-info.active i,\n.btn.btn-active-icon-info.active .svg-icon, .btn.btn-active-icon-info.show i,\n.btn.btn-active-icon-info.show .svg-icon, .show > .btn.btn-active-icon-info i,\n.show > .btn.btn-active-icon-info .svg-icon {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-icon-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-info.dropdown-toggle:after, .btn.btn-active-icon-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info.active.dropdown-toggle:after, .btn.btn-active-icon-info.show.dropdown-toggle:after, .show > .btn.btn-active-icon-info.dropdown-toggle:after {\n  color: var(--bs-text-info);\n}\n\n.btn.btn-text-info {\n  color: var(--bs-text-info);\n}\n.btn-check:checked + .btn.btn-active-text-info, .btn-check:active + .btn.btn-active-text-info, .btn.btn-active-text-info:focus:not(.btn-active), .btn.btn-active-text-info:hover:not(.btn-active), .btn.btn-active-text-info:active:not(.btn-active), .btn.btn-active-text-info.active, .btn.btn-active-text-info.show, .show > .btn.btn-active-text-info {\n  color: var(--bs-text-info);\n}\n\n.btn.btn-color-warning {\n  color: var(--bs-text-warning);\n}\n.btn.btn-color-warning i,\n.btn.btn-color-warning .svg-icon {\n  color: var(--bs-text-warning);\n}\n.btn.btn-color-warning.dropdown-toggle:after {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-color-warning, .btn-check:active + .btn.btn-active-color-warning, .btn.btn-active-color-warning:focus:not(.btn-active), .btn.btn-active-color-warning:hover:not(.btn-active), .btn.btn-active-color-warning:active:not(.btn-active), .btn.btn-active-color-warning.active, .btn.btn-active-color-warning.show, .show > .btn.btn-active-color-warning {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-color-warning i,\n.btn-check:checked + .btn.btn-active-color-warning .svg-icon, .btn-check:active + .btn.btn-active-color-warning i,\n.btn-check:active + .btn.btn-active-color-warning .svg-icon, .btn.btn-active-color-warning:focus:not(.btn-active) i,\n.btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:hover:not(.btn-active) i,\n.btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:active:not(.btn-active) i,\n.btn.btn-active-color-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-color-warning.active i,\n.btn.btn-active-color-warning.active .svg-icon, .btn.btn-active-color-warning.show i,\n.btn.btn-active-color-warning.show .svg-icon, .show > .btn.btn-active-color-warning i,\n.show > .btn.btn-active-color-warning .svg-icon {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-color-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-warning.dropdown-toggle:after, .btn.btn-active-color-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning.active.dropdown-toggle:after, .btn.btn-active-color-warning.show.dropdown-toggle:after, .show > .btn.btn-active-color-warning.dropdown-toggle:after {\n  color: var(--bs-text-warning);\n}\n\n.btn.btn-icon-warning i,\n.btn.btn-icon-warning .svg-icon {\n  color: var(--bs-text-warning);\n}\n.btn.btn-icon-warning.dropdown-toggle:after {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-icon-warning i,\n.btn-check:checked + .btn.btn-active-icon-warning .svg-icon, .btn-check:active + .btn.btn-active-icon-warning i,\n.btn-check:active + .btn.btn-active-icon-warning .svg-icon, .btn.btn-active-icon-warning:focus:not(.btn-active) i,\n.btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:hover:not(.btn-active) i,\n.btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:active:not(.btn-active) i,\n.btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning.active i,\n.btn.btn-active-icon-warning.active .svg-icon, .btn.btn-active-icon-warning.show i,\n.btn.btn-active-icon-warning.show .svg-icon, .show > .btn.btn-active-icon-warning i,\n.show > .btn.btn-active-icon-warning .svg-icon {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn.btn-active-icon-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning.active.dropdown-toggle:after, .btn.btn-active-icon-warning.show.dropdown-toggle:after, .show > .btn.btn-active-icon-warning.dropdown-toggle:after {\n  color: var(--bs-text-warning);\n}\n\n.btn.btn-text-warning {\n  color: var(--bs-text-warning);\n}\n.btn-check:checked + .btn.btn-active-text-warning, .btn-check:active + .btn.btn-active-text-warning, .btn.btn-active-text-warning:focus:not(.btn-active), .btn.btn-active-text-warning:hover:not(.btn-active), .btn.btn-active-text-warning:active:not(.btn-active), .btn.btn-active-text-warning.active, .btn.btn-active-text-warning.show, .show > .btn.btn-active-text-warning {\n  color: var(--bs-text-warning);\n}\n\n.btn.btn-color-danger {\n  color: var(--bs-text-danger);\n}\n.btn.btn-color-danger i,\n.btn.btn-color-danger .svg-icon {\n  color: var(--bs-text-danger);\n}\n.btn.btn-color-danger.dropdown-toggle:after {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-color-danger, .btn-check:active + .btn.btn-active-color-danger, .btn.btn-active-color-danger:focus:not(.btn-active), .btn.btn-active-color-danger:hover:not(.btn-active), .btn.btn-active-color-danger:active:not(.btn-active), .btn.btn-active-color-danger.active, .btn.btn-active-color-danger.show, .show > .btn.btn-active-color-danger {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-color-danger i,\n.btn-check:checked + .btn.btn-active-color-danger .svg-icon, .btn-check:active + .btn.btn-active-color-danger i,\n.btn-check:active + .btn.btn-active-color-danger .svg-icon, .btn.btn-active-color-danger:focus:not(.btn-active) i,\n.btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:hover:not(.btn-active) i,\n.btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:active:not(.btn-active) i,\n.btn.btn-active-color-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-color-danger.active i,\n.btn.btn-active-color-danger.active .svg-icon, .btn.btn-active-color-danger.show i,\n.btn.btn-active-color-danger.show .svg-icon, .show > .btn.btn-active-color-danger i,\n.show > .btn.btn-active-color-danger .svg-icon {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-color-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-danger.dropdown-toggle:after, .btn.btn-active-color-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger.active.dropdown-toggle:after, .btn.btn-active-color-danger.show.dropdown-toggle:after, .show > .btn.btn-active-color-danger.dropdown-toggle:after {\n  color: var(--bs-text-danger);\n}\n\n.btn.btn-icon-danger i,\n.btn.btn-icon-danger .svg-icon {\n  color: var(--bs-text-danger);\n}\n.btn.btn-icon-danger.dropdown-toggle:after {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-icon-danger i,\n.btn-check:checked + .btn.btn-active-icon-danger .svg-icon, .btn-check:active + .btn.btn-active-icon-danger i,\n.btn-check:active + .btn.btn-active-icon-danger .svg-icon, .btn.btn-active-icon-danger:focus:not(.btn-active) i,\n.btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:hover:not(.btn-active) i,\n.btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:active:not(.btn-active) i,\n.btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger.active i,\n.btn.btn-active-icon-danger.active .svg-icon, .btn.btn-active-icon-danger.show i,\n.btn.btn-active-icon-danger.show .svg-icon, .show > .btn.btn-active-icon-danger i,\n.show > .btn.btn-active-icon-danger .svg-icon {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn.btn-active-icon-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger.active.dropdown-toggle:after, .btn.btn-active-icon-danger.show.dropdown-toggle:after, .show > .btn.btn-active-icon-danger.dropdown-toggle:after {\n  color: var(--bs-text-danger);\n}\n\n.btn.btn-text-danger {\n  color: var(--bs-text-danger);\n}\n.btn-check:checked + .btn.btn-active-text-danger, .btn-check:active + .btn.btn-active-text-danger, .btn.btn-active-text-danger:focus:not(.btn-active), .btn.btn-active-text-danger:hover:not(.btn-active), .btn.btn-active-text-danger:active:not(.btn-active), .btn.btn-active-text-danger.active, .btn.btn-active-text-danger.show, .show > .btn.btn-active-text-danger {\n  color: var(--bs-text-danger);\n}\n\n.btn.btn-color-dark {\n  color: var(--bs-text-dark);\n}\n.btn.btn-color-dark i,\n.btn.btn-color-dark .svg-icon {\n  color: var(--bs-text-dark);\n}\n.btn.btn-color-dark.dropdown-toggle:after {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-color-dark, .btn-check:active + .btn.btn-active-color-dark, .btn.btn-active-color-dark:focus:not(.btn-active), .btn.btn-active-color-dark:hover:not(.btn-active), .btn.btn-active-color-dark:active:not(.btn-active), .btn.btn-active-color-dark.active, .btn.btn-active-color-dark.show, .show > .btn.btn-active-color-dark {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-color-dark i,\n.btn-check:checked + .btn.btn-active-color-dark .svg-icon, .btn-check:active + .btn.btn-active-color-dark i,\n.btn-check:active + .btn.btn-active-color-dark .svg-icon, .btn.btn-active-color-dark:focus:not(.btn-active) i,\n.btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:hover:not(.btn-active) i,\n.btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:active:not(.btn-active) i,\n.btn.btn-active-color-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-color-dark.active i,\n.btn.btn-active-color-dark.active .svg-icon, .btn.btn-active-color-dark.show i,\n.btn.btn-active-color-dark.show .svg-icon, .show > .btn.btn-active-color-dark i,\n.show > .btn.btn-active-color-dark .svg-icon {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-color-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-dark.dropdown-toggle:after, .btn.btn-active-color-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark.active.dropdown-toggle:after, .btn.btn-active-color-dark.show.dropdown-toggle:after, .show > .btn.btn-active-color-dark.dropdown-toggle:after {\n  color: var(--bs-text-dark);\n}\n\n.btn.btn-icon-dark i,\n.btn.btn-icon-dark .svg-icon {\n  color: var(--bs-text-dark);\n}\n.btn.btn-icon-dark.dropdown-toggle:after {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-icon-dark i,\n.btn-check:checked + .btn.btn-active-icon-dark .svg-icon, .btn-check:active + .btn.btn-active-icon-dark i,\n.btn-check:active + .btn.btn-active-icon-dark .svg-icon, .btn.btn-active-icon-dark:focus:not(.btn-active) i,\n.btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:hover:not(.btn-active) i,\n.btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:active:not(.btn-active) i,\n.btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark.active i,\n.btn.btn-active-icon-dark.active .svg-icon, .btn.btn-active-icon-dark.show i,\n.btn.btn-active-icon-dark.show .svg-icon, .show > .btn.btn-active-icon-dark i,\n.show > .btn.btn-active-icon-dark .svg-icon {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn.btn-active-icon-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark.active.dropdown-toggle:after, .btn.btn-active-icon-dark.show.dropdown-toggle:after, .show > .btn.btn-active-icon-dark.dropdown-toggle:after {\n  color: var(--bs-text-dark);\n}\n\n.btn.btn-text-dark {\n  color: var(--bs-text-dark);\n}\n.btn-check:checked + .btn.btn-active-text-dark, .btn-check:active + .btn.btn-active-text-dark, .btn.btn-active-text-dark:focus:not(.btn-active), .btn.btn-active-text-dark:hover:not(.btn-active), .btn.btn-active-text-dark:active:not(.btn-active), .btn.btn-active-text-dark.active, .btn.btn-active-text-dark.show, .show > .btn.btn-active-text-dark {\n  color: var(--bs-text-dark);\n}\n\n.btn.btn-color-muted {\n  color: var(--bs-text-muted);\n}\n.btn.btn-color-muted i,\n.btn.btn-color-muted .svg-icon {\n  color: var(--bs-text-muted);\n}\n.btn.btn-color-muted.dropdown-toggle:after {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-color-muted, .btn-check:active + .btn.btn-active-color-muted, .btn.btn-active-color-muted:focus:not(.btn-active), .btn.btn-active-color-muted:hover:not(.btn-active), .btn.btn-active-color-muted:active:not(.btn-active), .btn.btn-active-color-muted.active, .btn.btn-active-color-muted.show, .show > .btn.btn-active-color-muted {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-color-muted i,\n.btn-check:checked + .btn.btn-active-color-muted .svg-icon, .btn-check:active + .btn.btn-active-color-muted i,\n.btn-check:active + .btn.btn-active-color-muted .svg-icon, .btn.btn-active-color-muted:focus:not(.btn-active) i,\n.btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:hover:not(.btn-active) i,\n.btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:active:not(.btn-active) i,\n.btn.btn-active-color-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-color-muted.active i,\n.btn.btn-active-color-muted.active .svg-icon, .btn.btn-active-color-muted.show i,\n.btn.btn-active-color-muted.show .svg-icon, .show > .btn.btn-active-color-muted i,\n.show > .btn.btn-active-color-muted .svg-icon {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-color-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-muted.dropdown-toggle:after, .btn.btn-active-color-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted.active.dropdown-toggle:after, .btn.btn-active-color-muted.show.dropdown-toggle:after, .show > .btn.btn-active-color-muted.dropdown-toggle:after {\n  color: var(--bs-text-muted);\n}\n\n.btn.btn-icon-muted i,\n.btn.btn-icon-muted .svg-icon {\n  color: var(--bs-text-muted);\n}\n.btn.btn-icon-muted.dropdown-toggle:after {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-icon-muted i,\n.btn-check:checked + .btn.btn-active-icon-muted .svg-icon, .btn-check:active + .btn.btn-active-icon-muted i,\n.btn-check:active + .btn.btn-active-icon-muted .svg-icon, .btn.btn-active-icon-muted:focus:not(.btn-active) i,\n.btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:hover:not(.btn-active) i,\n.btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:active:not(.btn-active) i,\n.btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted.active i,\n.btn.btn-active-icon-muted.active .svg-icon, .btn.btn-active-icon-muted.show i,\n.btn.btn-active-icon-muted.show .svg-icon, .show > .btn.btn-active-icon-muted i,\n.show > .btn.btn-active-icon-muted .svg-icon {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn.btn-active-icon-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted.active.dropdown-toggle:after, .btn.btn-active-icon-muted.show.dropdown-toggle:after, .show > .btn.btn-active-icon-muted.dropdown-toggle:after {\n  color: var(--bs-text-muted);\n}\n\n.btn.btn-text-muted {\n  color: var(--bs-text-muted);\n}\n.btn-check:checked + .btn.btn-active-text-muted, .btn-check:active + .btn.btn-active-text-muted, .btn.btn-active-text-muted:focus:not(.btn-active), .btn.btn-active-text-muted:hover:not(.btn-active), .btn.btn-active-text-muted:active:not(.btn-active), .btn.btn-active-text-muted.active, .btn.btn-active-text-muted.show, .show > .btn.btn-active-text-muted {\n  color: var(--bs-text-muted);\n}\n\n.btn.btn-color-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n.btn.btn-color-gray-100 i,\n.btn.btn-color-gray-100 .svg-icon {\n  color: var(--bs-text-gray-100);\n}\n.btn.btn-color-gray-100.dropdown-toggle:after {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-color-gray-100, .btn-check:active + .btn.btn-active-color-gray-100, .btn.btn-active-color-gray-100:focus:not(.btn-active), .btn.btn-active-color-gray-100:hover:not(.btn-active), .btn.btn-active-color-gray-100:active:not(.btn-active), .btn.btn-active-color-gray-100.active, .btn.btn-active-color-gray-100.show, .show > .btn.btn-active-color-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-color-gray-100 i,\n.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-100 i,\n.btn-check:active + .btn.btn-active-color-gray-100 .svg-icon, .btn.btn-active-color-gray-100:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:active:not(.btn-active) i,\n.btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100.active i,\n.btn.btn-active-color-gray-100.active .svg-icon, .btn.btn-active-color-gray-100.show i,\n.btn.btn-active-color-gray-100.show .svg-icon, .show > .btn.btn-active-color-gray-100 i,\n.show > .btn.btn-active-color-gray-100 .svg-icon {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn.btn-active-color-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100.active.dropdown-toggle:after, .btn.btn-active-color-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-100.dropdown-toggle:after {\n  color: var(--bs-text-gray-100);\n}\n\n.btn.btn-icon-gray-100 i,\n.btn.btn-icon-gray-100 .svg-icon {\n  color: var(--bs-text-gray-100);\n}\n.btn.btn-icon-gray-100.dropdown-toggle:after {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100 i,\n.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-100 i,\n.btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon, .btn.btn-active-icon-gray-100:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100.active i,\n.btn.btn-active-icon-gray-100.active .svg-icon, .btn.btn-active-icon-gray-100.show i,\n.btn.btn-active-icon-gray-100.show .svg-icon, .show > .btn.btn-active-icon-gray-100 i,\n.show > .btn.btn-active-icon-gray-100 .svg-icon {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn.btn-active-icon-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100.active.dropdown-toggle:after, .btn.btn-active-icon-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-100.dropdown-toggle:after {\n  color: var(--bs-text-gray-100);\n}\n\n.btn.btn-text-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-text-gray-100, .btn-check:active + .btn.btn-active-text-gray-100, .btn.btn-active-text-gray-100:focus:not(.btn-active), .btn.btn-active-text-gray-100:hover:not(.btn-active), .btn.btn-active-text-gray-100:active:not(.btn-active), .btn.btn-active-text-gray-100.active, .btn.btn-active-text-gray-100.show, .show > .btn.btn-active-text-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n\n.btn.btn-color-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n.btn.btn-color-gray-200 i,\n.btn.btn-color-gray-200 .svg-icon {\n  color: var(--bs-text-gray-200);\n}\n.btn.btn-color-gray-200.dropdown-toggle:after {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-color-gray-200, .btn-check:active + .btn.btn-active-color-gray-200, .btn.btn-active-color-gray-200:focus:not(.btn-active), .btn.btn-active-color-gray-200:hover:not(.btn-active), .btn.btn-active-color-gray-200:active:not(.btn-active), .btn.btn-active-color-gray-200.active, .btn.btn-active-color-gray-200.show, .show > .btn.btn-active-color-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-color-gray-200 i,\n.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-200 i,\n.btn-check:active + .btn.btn-active-color-gray-200 .svg-icon, .btn.btn-active-color-gray-200:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:active:not(.btn-active) i,\n.btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200.active i,\n.btn.btn-active-color-gray-200.active .svg-icon, .btn.btn-active-color-gray-200.show i,\n.btn.btn-active-color-gray-200.show .svg-icon, .show > .btn.btn-active-color-gray-200 i,\n.show > .btn.btn-active-color-gray-200 .svg-icon {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn.btn-active-color-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200.active.dropdown-toggle:after, .btn.btn-active-color-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-200.dropdown-toggle:after {\n  color: var(--bs-text-gray-200);\n}\n\n.btn.btn-icon-gray-200 i,\n.btn.btn-icon-gray-200 .svg-icon {\n  color: var(--bs-text-gray-200);\n}\n.btn.btn-icon-gray-200.dropdown-toggle:after {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200 i,\n.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-200 i,\n.btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon, .btn.btn-active-icon-gray-200:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200.active i,\n.btn.btn-active-icon-gray-200.active .svg-icon, .btn.btn-active-icon-gray-200.show i,\n.btn.btn-active-icon-gray-200.show .svg-icon, .show > .btn.btn-active-icon-gray-200 i,\n.show > .btn.btn-active-icon-gray-200 .svg-icon {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn.btn-active-icon-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200.active.dropdown-toggle:after, .btn.btn-active-icon-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-200.dropdown-toggle:after {\n  color: var(--bs-text-gray-200);\n}\n\n.btn.btn-text-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-text-gray-200, .btn-check:active + .btn.btn-active-text-gray-200, .btn.btn-active-text-gray-200:focus:not(.btn-active), .btn.btn-active-text-gray-200:hover:not(.btn-active), .btn.btn-active-text-gray-200:active:not(.btn-active), .btn.btn-active-text-gray-200.active, .btn.btn-active-text-gray-200.show, .show > .btn.btn-active-text-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n\n.btn.btn-color-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n.btn.btn-color-gray-300 i,\n.btn.btn-color-gray-300 .svg-icon {\n  color: var(--bs-text-gray-300);\n}\n.btn.btn-color-gray-300.dropdown-toggle:after {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-color-gray-300, .btn-check:active + .btn.btn-active-color-gray-300, .btn.btn-active-color-gray-300:focus:not(.btn-active), .btn.btn-active-color-gray-300:hover:not(.btn-active), .btn.btn-active-color-gray-300:active:not(.btn-active), .btn.btn-active-color-gray-300.active, .btn.btn-active-color-gray-300.show, .show > .btn.btn-active-color-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-color-gray-300 i,\n.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-300 i,\n.btn-check:active + .btn.btn-active-color-gray-300 .svg-icon, .btn.btn-active-color-gray-300:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:active:not(.btn-active) i,\n.btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300.active i,\n.btn.btn-active-color-gray-300.active .svg-icon, .btn.btn-active-color-gray-300.show i,\n.btn.btn-active-color-gray-300.show .svg-icon, .show > .btn.btn-active-color-gray-300 i,\n.show > .btn.btn-active-color-gray-300 .svg-icon {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn.btn-active-color-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300.active.dropdown-toggle:after, .btn.btn-active-color-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-300.dropdown-toggle:after {\n  color: var(--bs-text-gray-300);\n}\n\n.btn.btn-icon-gray-300 i,\n.btn.btn-icon-gray-300 .svg-icon {\n  color: var(--bs-text-gray-300);\n}\n.btn.btn-icon-gray-300.dropdown-toggle:after {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300 i,\n.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-300 i,\n.btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon, .btn.btn-active-icon-gray-300:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300.active i,\n.btn.btn-active-icon-gray-300.active .svg-icon, .btn.btn-active-icon-gray-300.show i,\n.btn.btn-active-icon-gray-300.show .svg-icon, .show > .btn.btn-active-icon-gray-300 i,\n.show > .btn.btn-active-icon-gray-300 .svg-icon {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn.btn-active-icon-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300.active.dropdown-toggle:after, .btn.btn-active-icon-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-300.dropdown-toggle:after {\n  color: var(--bs-text-gray-300);\n}\n\n.btn.btn-text-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-text-gray-300, .btn-check:active + .btn.btn-active-text-gray-300, .btn.btn-active-text-gray-300:focus:not(.btn-active), .btn.btn-active-text-gray-300:hover:not(.btn-active), .btn.btn-active-text-gray-300:active:not(.btn-active), .btn.btn-active-text-gray-300.active, .btn.btn-active-text-gray-300.show, .show > .btn.btn-active-text-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n\n.btn.btn-color-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n.btn.btn-color-gray-400 i,\n.btn.btn-color-gray-400 .svg-icon {\n  color: var(--bs-text-gray-400);\n}\n.btn.btn-color-gray-400.dropdown-toggle:after {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-color-gray-400, .btn-check:active + .btn.btn-active-color-gray-400, .btn.btn-active-color-gray-400:focus:not(.btn-active), .btn.btn-active-color-gray-400:hover:not(.btn-active), .btn.btn-active-color-gray-400:active:not(.btn-active), .btn.btn-active-color-gray-400.active, .btn.btn-active-color-gray-400.show, .show > .btn.btn-active-color-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-color-gray-400 i,\n.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-400 i,\n.btn-check:active + .btn.btn-active-color-gray-400 .svg-icon, .btn.btn-active-color-gray-400:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:active:not(.btn-active) i,\n.btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400.active i,\n.btn.btn-active-color-gray-400.active .svg-icon, .btn.btn-active-color-gray-400.show i,\n.btn.btn-active-color-gray-400.show .svg-icon, .show > .btn.btn-active-color-gray-400 i,\n.show > .btn.btn-active-color-gray-400 .svg-icon {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn.btn-active-color-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400.active.dropdown-toggle:after, .btn.btn-active-color-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-400.dropdown-toggle:after {\n  color: var(--bs-text-gray-400);\n}\n\n.btn.btn-icon-gray-400 i,\n.btn.btn-icon-gray-400 .svg-icon {\n  color: var(--bs-text-gray-400);\n}\n.btn.btn-icon-gray-400.dropdown-toggle:after {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400 i,\n.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-400 i,\n.btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon, .btn.btn-active-icon-gray-400:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400.active i,\n.btn.btn-active-icon-gray-400.active .svg-icon, .btn.btn-active-icon-gray-400.show i,\n.btn.btn-active-icon-gray-400.show .svg-icon, .show > .btn.btn-active-icon-gray-400 i,\n.show > .btn.btn-active-icon-gray-400 .svg-icon {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn.btn-active-icon-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400.active.dropdown-toggle:after, .btn.btn-active-icon-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-400.dropdown-toggle:after {\n  color: var(--bs-text-gray-400);\n}\n\n.btn.btn-text-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-text-gray-400, .btn-check:active + .btn.btn-active-text-gray-400, .btn.btn-active-text-gray-400:focus:not(.btn-active), .btn.btn-active-text-gray-400:hover:not(.btn-active), .btn.btn-active-text-gray-400:active:not(.btn-active), .btn.btn-active-text-gray-400.active, .btn.btn-active-text-gray-400.show, .show > .btn.btn-active-text-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n\n.btn.btn-color-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n.btn.btn-color-gray-500 i,\n.btn.btn-color-gray-500 .svg-icon {\n  color: var(--bs-text-gray-500);\n}\n.btn.btn-color-gray-500.dropdown-toggle:after {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-color-gray-500, .btn-check:active + .btn.btn-active-color-gray-500, .btn.btn-active-color-gray-500:focus:not(.btn-active), .btn.btn-active-color-gray-500:hover:not(.btn-active), .btn.btn-active-color-gray-500:active:not(.btn-active), .btn.btn-active-color-gray-500.active, .btn.btn-active-color-gray-500.show, .show > .btn.btn-active-color-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-color-gray-500 i,\n.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-500 i,\n.btn-check:active + .btn.btn-active-color-gray-500 .svg-icon, .btn.btn-active-color-gray-500:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:active:not(.btn-active) i,\n.btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500.active i,\n.btn.btn-active-color-gray-500.active .svg-icon, .btn.btn-active-color-gray-500.show i,\n.btn.btn-active-color-gray-500.show .svg-icon, .show > .btn.btn-active-color-gray-500 i,\n.show > .btn.btn-active-color-gray-500 .svg-icon {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn.btn-active-color-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500.active.dropdown-toggle:after, .btn.btn-active-color-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-500.dropdown-toggle:after {\n  color: var(--bs-text-gray-500);\n}\n\n.btn.btn-icon-gray-500 i,\n.btn.btn-icon-gray-500 .svg-icon {\n  color: var(--bs-text-gray-500);\n}\n.btn.btn-icon-gray-500.dropdown-toggle:after {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500 i,\n.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-500 i,\n.btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon, .btn.btn-active-icon-gray-500:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500.active i,\n.btn.btn-active-icon-gray-500.active .svg-icon, .btn.btn-active-icon-gray-500.show i,\n.btn.btn-active-icon-gray-500.show .svg-icon, .show > .btn.btn-active-icon-gray-500 i,\n.show > .btn.btn-active-icon-gray-500 .svg-icon {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn.btn-active-icon-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500.active.dropdown-toggle:after, .btn.btn-active-icon-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-500.dropdown-toggle:after {\n  color: var(--bs-text-gray-500);\n}\n\n.btn.btn-text-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-text-gray-500, .btn-check:active + .btn.btn-active-text-gray-500, .btn.btn-active-text-gray-500:focus:not(.btn-active), .btn.btn-active-text-gray-500:hover:not(.btn-active), .btn.btn-active-text-gray-500:active:not(.btn-active), .btn.btn-active-text-gray-500.active, .btn.btn-active-text-gray-500.show, .show > .btn.btn-active-text-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n\n.btn.btn-color-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n.btn.btn-color-gray-600 i,\n.btn.btn-color-gray-600 .svg-icon {\n  color: var(--bs-text-gray-600);\n}\n.btn.btn-color-gray-600.dropdown-toggle:after {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-color-gray-600, .btn-check:active + .btn.btn-active-color-gray-600, .btn.btn-active-color-gray-600:focus:not(.btn-active), .btn.btn-active-color-gray-600:hover:not(.btn-active), .btn.btn-active-color-gray-600:active:not(.btn-active), .btn.btn-active-color-gray-600.active, .btn.btn-active-color-gray-600.show, .show > .btn.btn-active-color-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-color-gray-600 i,\n.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-600 i,\n.btn-check:active + .btn.btn-active-color-gray-600 .svg-icon, .btn.btn-active-color-gray-600:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:active:not(.btn-active) i,\n.btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600.active i,\n.btn.btn-active-color-gray-600.active .svg-icon, .btn.btn-active-color-gray-600.show i,\n.btn.btn-active-color-gray-600.show .svg-icon, .show > .btn.btn-active-color-gray-600 i,\n.show > .btn.btn-active-color-gray-600 .svg-icon {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn.btn-active-color-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600.active.dropdown-toggle:after, .btn.btn-active-color-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-600.dropdown-toggle:after {\n  color: var(--bs-text-gray-600);\n}\n\n.btn.btn-icon-gray-600 i,\n.btn.btn-icon-gray-600 .svg-icon {\n  color: var(--bs-text-gray-600);\n}\n.btn.btn-icon-gray-600.dropdown-toggle:after {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600 i,\n.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-600 i,\n.btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon, .btn.btn-active-icon-gray-600:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600.active i,\n.btn.btn-active-icon-gray-600.active .svg-icon, .btn.btn-active-icon-gray-600.show i,\n.btn.btn-active-icon-gray-600.show .svg-icon, .show > .btn.btn-active-icon-gray-600 i,\n.show > .btn.btn-active-icon-gray-600 .svg-icon {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn.btn-active-icon-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600.active.dropdown-toggle:after, .btn.btn-active-icon-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-600.dropdown-toggle:after {\n  color: var(--bs-text-gray-600);\n}\n\n.btn.btn-text-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-text-gray-600, .btn-check:active + .btn.btn-active-text-gray-600, .btn.btn-active-text-gray-600:focus:not(.btn-active), .btn.btn-active-text-gray-600:hover:not(.btn-active), .btn.btn-active-text-gray-600:active:not(.btn-active), .btn.btn-active-text-gray-600.active, .btn.btn-active-text-gray-600.show, .show > .btn.btn-active-text-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n\n.btn.btn-color-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n.btn.btn-color-gray-700 i,\n.btn.btn-color-gray-700 .svg-icon {\n  color: var(--bs-text-gray-700);\n}\n.btn.btn-color-gray-700.dropdown-toggle:after {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-color-gray-700, .btn-check:active + .btn.btn-active-color-gray-700, .btn.btn-active-color-gray-700:focus:not(.btn-active), .btn.btn-active-color-gray-700:hover:not(.btn-active), .btn.btn-active-color-gray-700:active:not(.btn-active), .btn.btn-active-color-gray-700.active, .btn.btn-active-color-gray-700.show, .show > .btn.btn-active-color-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-color-gray-700 i,\n.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-700 i,\n.btn-check:active + .btn.btn-active-color-gray-700 .svg-icon, .btn.btn-active-color-gray-700:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:active:not(.btn-active) i,\n.btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700.active i,\n.btn.btn-active-color-gray-700.active .svg-icon, .btn.btn-active-color-gray-700.show i,\n.btn.btn-active-color-gray-700.show .svg-icon, .show > .btn.btn-active-color-gray-700 i,\n.show > .btn.btn-active-color-gray-700 .svg-icon {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn.btn-active-color-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700.active.dropdown-toggle:after, .btn.btn-active-color-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-700.dropdown-toggle:after {\n  color: var(--bs-text-gray-700);\n}\n\n.btn.btn-icon-gray-700 i,\n.btn.btn-icon-gray-700 .svg-icon {\n  color: var(--bs-text-gray-700);\n}\n.btn.btn-icon-gray-700.dropdown-toggle:after {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700 i,\n.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-700 i,\n.btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon, .btn.btn-active-icon-gray-700:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700.active i,\n.btn.btn-active-icon-gray-700.active .svg-icon, .btn.btn-active-icon-gray-700.show i,\n.btn.btn-active-icon-gray-700.show .svg-icon, .show > .btn.btn-active-icon-gray-700 i,\n.show > .btn.btn-active-icon-gray-700 .svg-icon {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn.btn-active-icon-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700.active.dropdown-toggle:after, .btn.btn-active-icon-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-700.dropdown-toggle:after {\n  color: var(--bs-text-gray-700);\n}\n\n.btn.btn-text-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-text-gray-700, .btn-check:active + .btn.btn-active-text-gray-700, .btn.btn-active-text-gray-700:focus:not(.btn-active), .btn.btn-active-text-gray-700:hover:not(.btn-active), .btn.btn-active-text-gray-700:active:not(.btn-active), .btn.btn-active-text-gray-700.active, .btn.btn-active-text-gray-700.show, .show > .btn.btn-active-text-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n\n.btn.btn-color-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n.btn.btn-color-gray-800 i,\n.btn.btn-color-gray-800 .svg-icon {\n  color: var(--bs-text-gray-800);\n}\n.btn.btn-color-gray-800.dropdown-toggle:after {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-color-gray-800, .btn-check:active + .btn.btn-active-color-gray-800, .btn.btn-active-color-gray-800:focus:not(.btn-active), .btn.btn-active-color-gray-800:hover:not(.btn-active), .btn.btn-active-color-gray-800:active:not(.btn-active), .btn.btn-active-color-gray-800.active, .btn.btn-active-color-gray-800.show, .show > .btn.btn-active-color-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-color-gray-800 i,\n.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-800 i,\n.btn-check:active + .btn.btn-active-color-gray-800 .svg-icon, .btn.btn-active-color-gray-800:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:active:not(.btn-active) i,\n.btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800.active i,\n.btn.btn-active-color-gray-800.active .svg-icon, .btn.btn-active-color-gray-800.show i,\n.btn.btn-active-color-gray-800.show .svg-icon, .show > .btn.btn-active-color-gray-800 i,\n.show > .btn.btn-active-color-gray-800 .svg-icon {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn.btn-active-color-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800.active.dropdown-toggle:after, .btn.btn-active-color-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-800.dropdown-toggle:after {\n  color: var(--bs-text-gray-800);\n}\n\n.btn.btn-icon-gray-800 i,\n.btn.btn-icon-gray-800 .svg-icon {\n  color: var(--bs-text-gray-800);\n}\n.btn.btn-icon-gray-800.dropdown-toggle:after {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800 i,\n.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-800 i,\n.btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon, .btn.btn-active-icon-gray-800:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800.active i,\n.btn.btn-active-icon-gray-800.active .svg-icon, .btn.btn-active-icon-gray-800.show i,\n.btn.btn-active-icon-gray-800.show .svg-icon, .show > .btn.btn-active-icon-gray-800 i,\n.show > .btn.btn-active-icon-gray-800 .svg-icon {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn.btn-active-icon-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800.active.dropdown-toggle:after, .btn.btn-active-icon-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-800.dropdown-toggle:after {\n  color: var(--bs-text-gray-800);\n}\n\n.btn.btn-text-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-text-gray-800, .btn-check:active + .btn.btn-active-text-gray-800, .btn.btn-active-text-gray-800:focus:not(.btn-active), .btn.btn-active-text-gray-800:hover:not(.btn-active), .btn.btn-active-text-gray-800:active:not(.btn-active), .btn.btn-active-text-gray-800.active, .btn.btn-active-text-gray-800.show, .show > .btn.btn-active-text-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n\n.btn.btn-color-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n.btn.btn-color-gray-900 i,\n.btn.btn-color-gray-900 .svg-icon {\n  color: var(--bs-text-gray-900);\n}\n.btn.btn-color-gray-900.dropdown-toggle:after {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-color-gray-900, .btn-check:active + .btn.btn-active-color-gray-900, .btn.btn-active-color-gray-900:focus:not(.btn-active), .btn.btn-active-color-gray-900:hover:not(.btn-active), .btn.btn-active-color-gray-900:active:not(.btn-active), .btn.btn-active-color-gray-900.active, .btn.btn-active-color-gray-900.show, .show > .btn.btn-active-color-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-color-gray-900 i,\n.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-900 i,\n.btn-check:active + .btn.btn-active-color-gray-900 .svg-icon, .btn.btn-active-color-gray-900:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:active:not(.btn-active) i,\n.btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900.active i,\n.btn.btn-active-color-gray-900.active .svg-icon, .btn.btn-active-color-gray-900.show i,\n.btn.btn-active-color-gray-900.show .svg-icon, .show > .btn.btn-active-color-gray-900 i,\n.show > .btn.btn-active-color-gray-900 .svg-icon {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn.btn-active-color-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900.active.dropdown-toggle:after, .btn.btn-active-color-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-900.dropdown-toggle:after {\n  color: var(--bs-text-gray-900);\n}\n\n.btn.btn-icon-gray-900 i,\n.btn.btn-icon-gray-900 .svg-icon {\n  color: var(--bs-text-gray-900);\n}\n.btn.btn-icon-gray-900.dropdown-toggle:after {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900 i,\n.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-900 i,\n.btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon, .btn.btn-active-icon-gray-900:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900.active i,\n.btn.btn-active-icon-gray-900.active .svg-icon, .btn.btn-active-icon-gray-900.show i,\n.btn.btn-active-icon-gray-900.show .svg-icon, .show > .btn.btn-active-icon-gray-900 i,\n.show > .btn.btn-active-icon-gray-900 .svg-icon {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn.btn-active-icon-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900.active.dropdown-toggle:after, .btn.btn-active-icon-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-900.dropdown-toggle:after {\n  color: var(--bs-text-gray-900);\n}\n\n.btn.btn-text-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-text-gray-900, .btn-check:active + .btn.btn-active-text-gray-900, .btn.btn-active-text-gray-900:focus:not(.btn-active), .btn.btn-active-text-gray-900:hover:not(.btn-active), .btn.btn-active-text-gray-900:active:not(.btn-active), .btn.btn-active-text-gray-900.active, .btn.btn-active-text-gray-900.show, .show > .btn.btn-active-text-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n\n.btn.btn-facebook {\n  color: #ffffff;\n  border-color: #3b5998;\n  background-color: #3b5998;\n}\n.btn.btn-facebook i,\n.btn.btn-facebook .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-facebook.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-facebook, .btn-check:active + .btn.btn-facebook, .btn.btn-facebook:focus:not(.btn-active), .btn.btn-facebook:hover:not(.btn-active), .btn.btn-facebook:active:not(.btn-active), .btn.btn-facebook.active, .btn.btn-facebook.show, .show > .btn.btn-facebook {\n  border-color: #30497c;\n  background-color: #30497c !important;\n}\n\n.btn.btn-light-facebook {\n  color: #3b5998;\n  border-color: rgba(59, 89, 152, 0.1);\n  background-color: rgba(59, 89, 152, 0.1);\n}\n.btn.btn-light-facebook i,\n.btn.btn-light-facebook .svg-icon {\n  color: #3b5998;\n}\n.btn.btn-light-facebook.dropdown-toggle:after {\n  color: #3b5998;\n}\n.btn-check:checked + .btn.btn-light-facebook, .btn-check:active + .btn.btn-light-facebook, .btn.btn-light-facebook:focus:not(.btn-active), .btn.btn-light-facebook:hover:not(.btn-active), .btn.btn-light-facebook:active:not(.btn-active), .btn.btn-light-facebook.active, .btn.btn-light-facebook.show, .show > .btn.btn-light-facebook {\n  color: #ffffff;\n  border-color: #3b5998;\n  background-color: #3b5998 !important;\n}\n.btn-check:checked + .btn.btn-light-facebook i,\n.btn-check:checked + .btn.btn-light-facebook .svg-icon, .btn-check:active + .btn.btn-light-facebook i,\n.btn-check:active + .btn.btn-light-facebook .svg-icon, .btn.btn-light-facebook:focus:not(.btn-active) i,\n.btn.btn-light-facebook:focus:not(.btn-active) .svg-icon, .btn.btn-light-facebook:hover:not(.btn-active) i,\n.btn.btn-light-facebook:hover:not(.btn-active) .svg-icon, .btn.btn-light-facebook:active:not(.btn-active) i,\n.btn.btn-light-facebook:active:not(.btn-active) .svg-icon, .btn.btn-light-facebook.active i,\n.btn.btn-light-facebook.active .svg-icon, .btn.btn-light-facebook.show i,\n.btn.btn-light-facebook.show .svg-icon, .show > .btn.btn-light-facebook i,\n.show > .btn.btn-light-facebook .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-facebook.dropdown-toggle:after, .btn-check:active + .btn.btn-light-facebook.dropdown-toggle:after, .btn.btn-light-facebook:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook.active.dropdown-toggle:after, .btn.btn-light-facebook.show.dropdown-toggle:after, .show > .btn.btn-light-facebook.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-google {\n  color: #ffffff;\n  border-color: #dd4b39;\n  background-color: #dd4b39;\n}\n.btn.btn-google i,\n.btn.btn-google .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-google.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-google, .btn-check:active + .btn.btn-google, .btn.btn-google:focus:not(.btn-active), .btn.btn-google:hover:not(.btn-active), .btn.btn-google:active:not(.btn-active), .btn.btn-google.active, .btn.btn-google.show, .show > .btn.btn-google {\n  border-color: #cd3623;\n  background-color: #cd3623 !important;\n}\n\n.btn.btn-light-google {\n  color: #dd4b39;\n  border-color: rgba(221, 75, 57, 0.1);\n  background-color: rgba(221, 75, 57, 0.1);\n}\n.btn.btn-light-google i,\n.btn.btn-light-google .svg-icon {\n  color: #dd4b39;\n}\n.btn.btn-light-google.dropdown-toggle:after {\n  color: #dd4b39;\n}\n.btn-check:checked + .btn.btn-light-google, .btn-check:active + .btn.btn-light-google, .btn.btn-light-google:focus:not(.btn-active), .btn.btn-light-google:hover:not(.btn-active), .btn.btn-light-google:active:not(.btn-active), .btn.btn-light-google.active, .btn.btn-light-google.show, .show > .btn.btn-light-google {\n  color: #ffffff;\n  border-color: #dd4b39;\n  background-color: #dd4b39 !important;\n}\n.btn-check:checked + .btn.btn-light-google i,\n.btn-check:checked + .btn.btn-light-google .svg-icon, .btn-check:active + .btn.btn-light-google i,\n.btn-check:active + .btn.btn-light-google .svg-icon, .btn.btn-light-google:focus:not(.btn-active) i,\n.btn.btn-light-google:focus:not(.btn-active) .svg-icon, .btn.btn-light-google:hover:not(.btn-active) i,\n.btn.btn-light-google:hover:not(.btn-active) .svg-icon, .btn.btn-light-google:active:not(.btn-active) i,\n.btn.btn-light-google:active:not(.btn-active) .svg-icon, .btn.btn-light-google.active i,\n.btn.btn-light-google.active .svg-icon, .btn.btn-light-google.show i,\n.btn.btn-light-google.show .svg-icon, .show > .btn.btn-light-google i,\n.show > .btn.btn-light-google .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-google.dropdown-toggle:after, .btn-check:active + .btn.btn-light-google.dropdown-toggle:after, .btn.btn-light-google:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google.active.dropdown-toggle:after, .btn.btn-light-google.show.dropdown-toggle:after, .show > .btn.btn-light-google.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-twitter {\n  color: #ffffff;\n  border-color: #1da1f2;\n  background-color: #1da1f2;\n}\n.btn.btn-twitter i,\n.btn.btn-twitter .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-twitter.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-twitter, .btn-check:active + .btn.btn-twitter, .btn.btn-twitter:focus:not(.btn-active), .btn.btn-twitter:hover:not(.btn-active), .btn.btn-twitter:active:not(.btn-active), .btn.btn-twitter.active, .btn.btn-twitter.show, .show > .btn.btn-twitter {\n  border-color: #0d8ddc;\n  background-color: #0d8ddc !important;\n}\n\n.btn.btn-light-twitter {\n  color: #1da1f2;\n  border-color: rgba(29, 161, 242, 0.1);\n  background-color: rgba(29, 161, 242, 0.1);\n}\n.btn.btn-light-twitter i,\n.btn.btn-light-twitter .svg-icon {\n  color: #1da1f2;\n}\n.btn.btn-light-twitter.dropdown-toggle:after {\n  color: #1da1f2;\n}\n.btn-check:checked + .btn.btn-light-twitter, .btn-check:active + .btn.btn-light-twitter, .btn.btn-light-twitter:focus:not(.btn-active), .btn.btn-light-twitter:hover:not(.btn-active), .btn.btn-light-twitter:active:not(.btn-active), .btn.btn-light-twitter.active, .btn.btn-light-twitter.show, .show > .btn.btn-light-twitter {\n  color: #ffffff;\n  border-color: #1da1f2;\n  background-color: #1da1f2 !important;\n}\n.btn-check:checked + .btn.btn-light-twitter i,\n.btn-check:checked + .btn.btn-light-twitter .svg-icon, .btn-check:active + .btn.btn-light-twitter i,\n.btn-check:active + .btn.btn-light-twitter .svg-icon, .btn.btn-light-twitter:focus:not(.btn-active) i,\n.btn.btn-light-twitter:focus:not(.btn-active) .svg-icon, .btn.btn-light-twitter:hover:not(.btn-active) i,\n.btn.btn-light-twitter:hover:not(.btn-active) .svg-icon, .btn.btn-light-twitter:active:not(.btn-active) i,\n.btn.btn-light-twitter:active:not(.btn-active) .svg-icon, .btn.btn-light-twitter.active i,\n.btn.btn-light-twitter.active .svg-icon, .btn.btn-light-twitter.show i,\n.btn.btn-light-twitter.show .svg-icon, .show > .btn.btn-light-twitter i,\n.show > .btn.btn-light-twitter .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-twitter.dropdown-toggle:after, .btn-check:active + .btn.btn-light-twitter.dropdown-toggle:after, .btn.btn-light-twitter:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter.active.dropdown-toggle:after, .btn.btn-light-twitter.show.dropdown-toggle:after, .show > .btn.btn-light-twitter.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-instagram {\n  color: #ffffff;\n  border-color: #e1306c;\n  background-color: #e1306c;\n}\n.btn.btn-instagram i,\n.btn.btn-instagram .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-instagram.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-instagram, .btn-check:active + .btn.btn-instagram, .btn.btn-instagram:focus:not(.btn-active), .btn.btn-instagram:hover:not(.btn-active), .btn.btn-instagram:active:not(.btn-active), .btn.btn-instagram.active, .btn.btn-instagram.show, .show > .btn.btn-instagram {\n  border-color: #cd1e59;\n  background-color: #cd1e59 !important;\n}\n\n.btn.btn-light-instagram {\n  color: #e1306c;\n  border-color: rgba(225, 48, 108, 0.1);\n  background-color: rgba(225, 48, 108, 0.1);\n}\n.btn.btn-light-instagram i,\n.btn.btn-light-instagram .svg-icon {\n  color: #e1306c;\n}\n.btn.btn-light-instagram.dropdown-toggle:after {\n  color: #e1306c;\n}\n.btn-check:checked + .btn.btn-light-instagram, .btn-check:active + .btn.btn-light-instagram, .btn.btn-light-instagram:focus:not(.btn-active), .btn.btn-light-instagram:hover:not(.btn-active), .btn.btn-light-instagram:active:not(.btn-active), .btn.btn-light-instagram.active, .btn.btn-light-instagram.show, .show > .btn.btn-light-instagram {\n  color: #ffffff;\n  border-color: #e1306c;\n  background-color: #e1306c !important;\n}\n.btn-check:checked + .btn.btn-light-instagram i,\n.btn-check:checked + .btn.btn-light-instagram .svg-icon, .btn-check:active + .btn.btn-light-instagram i,\n.btn-check:active + .btn.btn-light-instagram .svg-icon, .btn.btn-light-instagram:focus:not(.btn-active) i,\n.btn.btn-light-instagram:focus:not(.btn-active) .svg-icon, .btn.btn-light-instagram:hover:not(.btn-active) i,\n.btn.btn-light-instagram:hover:not(.btn-active) .svg-icon, .btn.btn-light-instagram:active:not(.btn-active) i,\n.btn.btn-light-instagram:active:not(.btn-active) .svg-icon, .btn.btn-light-instagram.active i,\n.btn.btn-light-instagram.active .svg-icon, .btn.btn-light-instagram.show i,\n.btn.btn-light-instagram.show .svg-icon, .show > .btn.btn-light-instagram i,\n.show > .btn.btn-light-instagram .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-instagram.dropdown-toggle:after, .btn-check:active + .btn.btn-light-instagram.dropdown-toggle:after, .btn.btn-light-instagram:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram.active.dropdown-toggle:after, .btn.btn-light-instagram.show.dropdown-toggle:after, .show > .btn.btn-light-instagram.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-youtube {\n  color: #ffffff;\n  border-color: #ff0000;\n  background-color: #ff0000;\n}\n.btn.btn-youtube i,\n.btn.btn-youtube .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-youtube.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-youtube, .btn-check:active + .btn.btn-youtube, .btn.btn-youtube:focus:not(.btn-active), .btn.btn-youtube:hover:not(.btn-active), .btn.btn-youtube:active:not(.btn-active), .btn.btn-youtube.active, .btn.btn-youtube.show, .show > .btn.btn-youtube {\n  border-color: #d90000;\n  background-color: #d90000 !important;\n}\n\n.btn.btn-light-youtube {\n  color: #ff0000;\n  border-color: rgba(255, 0, 0, 0.1);\n  background-color: rgba(255, 0, 0, 0.1);\n}\n.btn.btn-light-youtube i,\n.btn.btn-light-youtube .svg-icon {\n  color: #ff0000;\n}\n.btn.btn-light-youtube.dropdown-toggle:after {\n  color: #ff0000;\n}\n.btn-check:checked + .btn.btn-light-youtube, .btn-check:active + .btn.btn-light-youtube, .btn.btn-light-youtube:focus:not(.btn-active), .btn.btn-light-youtube:hover:not(.btn-active), .btn.btn-light-youtube:active:not(.btn-active), .btn.btn-light-youtube.active, .btn.btn-light-youtube.show, .show > .btn.btn-light-youtube {\n  color: #ffffff;\n  border-color: #ff0000;\n  background-color: #ff0000 !important;\n}\n.btn-check:checked + .btn.btn-light-youtube i,\n.btn-check:checked + .btn.btn-light-youtube .svg-icon, .btn-check:active + .btn.btn-light-youtube i,\n.btn-check:active + .btn.btn-light-youtube .svg-icon, .btn.btn-light-youtube:focus:not(.btn-active) i,\n.btn.btn-light-youtube:focus:not(.btn-active) .svg-icon, .btn.btn-light-youtube:hover:not(.btn-active) i,\n.btn.btn-light-youtube:hover:not(.btn-active) .svg-icon, .btn.btn-light-youtube:active:not(.btn-active) i,\n.btn.btn-light-youtube:active:not(.btn-active) .svg-icon, .btn.btn-light-youtube.active i,\n.btn.btn-light-youtube.active .svg-icon, .btn.btn-light-youtube.show i,\n.btn.btn-light-youtube.show .svg-icon, .show > .btn.btn-light-youtube i,\n.show > .btn.btn-light-youtube .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-youtube.dropdown-toggle:after, .btn-check:active + .btn.btn-light-youtube.dropdown-toggle:after, .btn.btn-light-youtube:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube.active.dropdown-toggle:after, .btn.btn-light-youtube.show.dropdown-toggle:after, .show > .btn.btn-light-youtube.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-linkedin {\n  color: #ffffff;\n  border-color: #0077b5;\n  background-color: #0077b5;\n}\n.btn.btn-linkedin i,\n.btn.btn-linkedin .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-linkedin.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-linkedin, .btn-check:active + .btn.btn-linkedin, .btn.btn-linkedin:focus:not(.btn-active), .btn.btn-linkedin:hover:not(.btn-active), .btn.btn-linkedin:active:not(.btn-active), .btn.btn-linkedin.active, .btn.btn-linkedin.show, .show > .btn.btn-linkedin {\n  border-color: #005e8f;\n  background-color: #005e8f !important;\n}\n\n.btn.btn-light-linkedin {\n  color: #0077b5;\n  border-color: rgba(0, 119, 181, 0.1);\n  background-color: rgba(0, 119, 181, 0.1);\n}\n.btn.btn-light-linkedin i,\n.btn.btn-light-linkedin .svg-icon {\n  color: #0077b5;\n}\n.btn.btn-light-linkedin.dropdown-toggle:after {\n  color: #0077b5;\n}\n.btn-check:checked + .btn.btn-light-linkedin, .btn-check:active + .btn.btn-light-linkedin, .btn.btn-light-linkedin:focus:not(.btn-active), .btn.btn-light-linkedin:hover:not(.btn-active), .btn.btn-light-linkedin:active:not(.btn-active), .btn.btn-light-linkedin.active, .btn.btn-light-linkedin.show, .show > .btn.btn-light-linkedin {\n  color: #ffffff;\n  border-color: #0077b5;\n  background-color: #0077b5 !important;\n}\n.btn-check:checked + .btn.btn-light-linkedin i,\n.btn-check:checked + .btn.btn-light-linkedin .svg-icon, .btn-check:active + .btn.btn-light-linkedin i,\n.btn-check:active + .btn.btn-light-linkedin .svg-icon, .btn.btn-light-linkedin:focus:not(.btn-active) i,\n.btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:hover:not(.btn-active) i,\n.btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:active:not(.btn-active) i,\n.btn.btn-light-linkedin:active:not(.btn-active) .svg-icon, .btn.btn-light-linkedin.active i,\n.btn.btn-light-linkedin.active .svg-icon, .btn.btn-light-linkedin.show i,\n.btn.btn-light-linkedin.show .svg-icon, .show > .btn.btn-light-linkedin i,\n.show > .btn.btn-light-linkedin .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-linkedin.dropdown-toggle:after, .btn-check:active + .btn.btn-light-linkedin.dropdown-toggle:after, .btn.btn-light-linkedin:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin.active.dropdown-toggle:after, .btn.btn-light-linkedin.show.dropdown-toggle:after, .show > .btn.btn-light-linkedin.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n[data-bs-theme=dark] .btn.btn-dark {\n  color: #B5B7C8;\n  background-color: #464852;\n}\n[data-bs-theme=dark] .btn.btn-dark i,\n[data-bs-theme=dark] .btn.btn-dark .svg-icon {\n  color: #B5B7C8;\n}\n[data-bs-theme=dark] .btn.btn-dark.dropdown-toggle:after {\n  color: #B5B7C8;\n}\n.btn-check:checked + [data-bs-theme=dark] .btn.btn-dark, .btn-check:active + [data-bs-theme=dark] .btn.btn-dark, [data-bs-theme=dark] .btn.btn-dark:focus:not(.btn-active), [data-bs-theme=dark] .btn.btn-dark:hover:not(.btn-active), [data-bs-theme=dark] .btn.btn-dark:active:not(.btn-active), [data-bs-theme=dark] .btn.btn-dark.active, [data-bs-theme=dark] .btn.btn-dark.show, .show > [data-bs-theme=dark] .btn.btn-dark {\n  color: #bec0cf;\n  background-color: #4d4f5a !important;\n}\n.btn-check:checked + [data-bs-theme=dark] .btn.btn-dark i,\n.btn-check:checked + [data-bs-theme=dark] .btn.btn-dark .svg-icon, .btn-check:active + [data-bs-theme=dark] .btn.btn-dark i,\n.btn-check:active + [data-bs-theme=dark] .btn.btn-dark .svg-icon, [data-bs-theme=dark] .btn.btn-dark:focus:not(.btn-active) i,\n[data-bs-theme=dark] .btn.btn-dark:focus:not(.btn-active) .svg-icon, [data-bs-theme=dark] .btn.btn-dark:hover:not(.btn-active) i,\n[data-bs-theme=dark] .btn.btn-dark:hover:not(.btn-active) .svg-icon, [data-bs-theme=dark] .btn.btn-dark:active:not(.btn-active) i,\n[data-bs-theme=dark] .btn.btn-dark:active:not(.btn-active) .svg-icon, [data-bs-theme=dark] .btn.btn-dark.active i,\n[data-bs-theme=dark] .btn.btn-dark.active .svg-icon, [data-bs-theme=dark] .btn.btn-dark.show i,\n[data-bs-theme=dark] .btn.btn-dark.show .svg-icon, .show > [data-bs-theme=dark] .btn.btn-dark i,\n.show > [data-bs-theme=dark] .btn.btn-dark .svg-icon {\n  color: #bec0cf;\n}\n.btn-check:checked + [data-bs-theme=dark] .btn.btn-dark.dropdown-toggle:after, .btn-check:active + [data-bs-theme=dark] .btn.btn-dark.dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark.active.dropdown-toggle:after, [data-bs-theme=dark] .btn.btn-dark.show.dropdown-toggle:after, .show > [data-bs-theme=dark] .btn.btn-dark.dropdown-toggle:after {\n  color: #bec0cf;\n}\n\n.modal-rounded {\n  border-radius: 0.65rem !important;\n}\n\ncode:not([class*=language-]) {\n  font-weight: 400;\n  color: var(--bs-code-color);\n  border: 1px solid var(--bs-code-border-color);\n  background-color: var(--bs-code-bg);\n  border-radius: 0.3rem;\n  line-height: inherit;\n  font-size: 1rem;\n  padding: 0.1rem 0.4rem;\n  margin: 0 0.5rem;\n  box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);\n}\ncode:not([class*=language-]).code-light {\n  color: var(--bs-light);\n  background-color: var(--bs-light-light);\n  border: 1px solid var(--bs-light);\n}\ncode:not([class*=language-]).code-primary {\n  color: var(--bs-primary);\n  background-color: var(--bs-primary-light);\n  border: 1px solid var(--bs-primary);\n}\ncode:not([class*=language-]).code-secondary {\n  color: var(--bs-secondary);\n  background-color: var(--bs-secondary-light);\n  border: 1px solid var(--bs-secondary);\n}\ncode:not([class*=language-]).code-success {\n  color: var(--bs-success);\n  background-color: var(--bs-success-light);\n  border: 1px solid var(--bs-success);\n}\ncode:not([class*=language-]).code-info {\n  color: var(--bs-info);\n  background-color: var(--bs-info-light);\n  border: 1px solid var(--bs-info);\n}\ncode:not([class*=language-]).code-warning {\n  color: var(--bs-warning);\n  background-color: var(--bs-warning-light);\n  border: 1px solid var(--bs-warning);\n}\ncode:not([class*=language-]).code-danger {\n  color: var(--bs-danger);\n  background-color: var(--bs-danger-light);\n  border: 1px solid var(--bs-danger);\n}\ncode:not([class*=language-]).code-dark {\n  color: var(--bs-dark);\n  background-color: var(--bs-dark-light);\n  border: 1px solid var(--bs-dark);\n}\n\n.col-form-label {\n  font-size: 1.05rem;\n}\n\n.form-control.form-control-transparent {\n  background-color: transparent;\n  border-color: transparent;\n}\n.dropdown.show > .form-control.form-control-transparent, .form-control.form-control-transparent:active, .form-control.form-control-transparent.active, .form-control.form-control-transparent:focus, .form-control.form-control-transparent.focus {\n  background-color: transparent;\n  border-color: transparent;\n}\n.form-control.form-control-flush {\n  border: 0;\n  background-color: transparent;\n  outline: none !important;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.form-control.form-control-solid {\n  background-color: var(--bs-gray-100);\n  border-color: var(--bs-gray-100);\n  color: var(--bs-gray-700);\n  transition: color 0.2s ease;\n}\n.form-control.form-control-solid::placeholder {\n  color: var(--bs-gray-500);\n}\n.form-control.form-control-solid::-moz-placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n.dropdown.show > .form-control.form-control-solid, .form-control.form-control-solid:active, .form-control.form-control-solid.active, .form-control.form-control-solid:focus, .form-control.form-control-solid.focus {\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-200);\n  color: var(--bs-gray-700);\n  transition: color 0.2s ease;\n}\n\n.form-control-solid-bg {\n  background-color: var(--bs-gray-100);\n}\n\n.form-control-plaintext {\n  color: var(--bs-gray-700);\n}\n\n.placeholder-gray-500::placeholder {\n  color: var(--bs-gray-500);\n}\n.placeholder-gray-500::-moz-placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n\n.placeholder-white::placeholder {\n  color: #ffffff;\n}\n.placeholder-white::-moz-placeholder {\n  color: #ffffff;\n  opacity: 1;\n}\n\n.resize-none {\n  resize: none;\n}\n\n.form-floating .form-control.form-control-solid::placeholder {\n  color: transparent;\n}\n.form-floating.form-control-solid-bg label::after,\n.form-floating > :disabled ~ label::after,\n.form-floating > :focus ~ label::after {\n  background-color: transparent !important;\n}\n\n.form-select {\n  appearance: none;\n}\n.form-select:focus {\n  border-color: var(--bs-gray-400);\n  box-shadow: false, 0 0 0 0.25rem rgba(var(--bs-component-active-bg), 0.25);\n}\n.form-select:disabled {\n  color: var(--bs-gray-500);\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-300);\n}\n.form-select:-moz-focusring {\n  text-shadow: 0 0 0 var(--bs-gray-700);\n}\n.form-select.form-select-solid {\n  background-color: var(--bs-gray-100);\n  border-color: var(--bs-gray-100);\n  color: var(--bs-gray-700);\n  transition: color 0.2s ease;\n}\n.form-select.form-select-solid::placeholder {\n  color: var(--bs-gray-500);\n}\n.form-select.form-select-solid::-moz-placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n.dropdown.show > .form-select.form-select-solid, .form-select.form-select-solid:active, .form-select.form-select-solid.active, .form-select.form-select-solid:focus, .form-select.form-select-solid.focus {\n  background-color: var(--bs-gray-200);\n  border-color: var(--bs-gray-200) !important;\n  color: var(--bs-gray-700);\n  transition: color 0.2s ease;\n}\n.form-select.form-select-transparent {\n  background-color: transparent;\n  border-color: transparent;\n  color: var(--bs-gray-700);\n}\n.form-select.form-select-transparent::placeholder {\n  color: var(--bs-gray-500);\n}\n.form-select.form-select-transparent::-moz-placeholder {\n  color: var(--bs-gray-500);\n  opacity: 1;\n}\n.dropdown.show > .form-select.form-select-transparent, .form-select.form-select-transparent:active, .form-select.form-select-transparent.active, .form-select.form-select-transparent:focus, .form-select.form-select-transparent.focus {\n  background-color: transparent;\n  border-color: transparent !important;\n  color: var(--bs-gray-700);\n}\n\n.form-check:not(.form-switch) .form-check-input[type=checkbox] {\n  background-size: 60% 60%;\n}\n.form-check.form-check-sm .form-check-input {\n  height: 1.55rem;\n  width: 1.55rem;\n}\n.form-check.form-check-lg .form-check-input {\n  height: 2.25rem;\n  width: 2.25rem;\n}\n.form-check.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n.form-check.form-check-solid .form-check-input {\n  border: 0;\n}\n.form-check.form-check-solid .form-check-input:not(:checked) {\n  background-color: var(--bs-gray-200);\n}\n.form-check.form-check-solid .form-check-input[type=checkbox]:indeterminate {\n  background-color: #1B84FF;\n}\n.form-check.form-check-success .form-check-input:checked {\n  background-color: var(--bs-success);\n}\n.form-check.form-check-danger .form-check-input:checked {\n  background-color: var(--bs-danger);\n}\n.form-check.form-check-warning .form-check-input:checked {\n  background-color: var(--bs-warning);\n}\n\n.form-check-custom {\n  display: flex;\n  align-items: center;\n  padding-left: 0;\n  margin: 0;\n}\n.form-check-custom .form-check-input {\n  margin: 0;\n  float: none;\n  flex-shrink: 0;\n}\n.form-check-custom .form-check-label {\n  margin-left: 0.55rem;\n}\n\n.form-switch.form-check-custom .form-check-input {\n  height: 2.25rem;\n}\n.form-switch.form-check-custom.form-switch-sm .form-check-input {\n  height: 1.5rem;\n  width: 2.5rem;\n}\n.form-switch.form-check-custom.form-switch-lg .form-check-input {\n  height: 2.75rem;\n  width: 3.75rem;\n}\n.form-switch.form-check-solid .form-check-input {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-solid .form-check-input:not(:checked) {\n  background-color: var(--bs-gray-200);\n}\n\n[data-bs-theme=dark] .form-switch .form-check-input:focus:not(:checked) {\n  --bs-form-switch-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n}\n\n.form-check-image {\n  position: relative;\n  overflow: hidden;\n}\n.form-check-image img {\n  max-width: 100%;\n}\n.form-check-image .form-check-wrapper {\n  border-radius: 0.85rem;\n  border: 2px solid transparent;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  overflow: hidden;\n  margin-bottom: 0.75rem;\n}\n.form-check-image .form-check-rounded {\n  border-radius: 0.85rem;\n}\n.form-check-image .form-check-label {\n  font-weight: 600;\n  margin-left: 0.5rem;\n}\n.form-check-image.active:not(.form-check-success):not(.form-check-danger) .form-check-wrapper {\n  border-color: var(--bs-primary) !important;\n}\n.form-check-image.form-check-success.active .form-check-wrapper {\n  border-color: var(--bs-success) !important;\n}\n.form-check-image.form-check-danger.active .form-check-wrapper {\n  border-color: var(--bs-danger) !important;\n}\n.form-check-image.disabled {\n  opacity: 0.65;\n}\n\n.input-group.input-group-solid {\n  border-radius: 0.65rem;\n}\n.input-group.input-group-solid.input-group-sm {\n  border-radius: 0.3rem;\n}\n.input-group.input-group-solid.input-group-lg {\n  border-radius: 0.85rem;\n}\n.input-group.input-group-solid .input-group-text {\n  background-color: var(--bs-gray-100);\n  border-color: var(--bs-gray-100);\n}\n.input-group.input-group-solid .input-group-text + .form-control {\n  border-left-color: var(--bs-gray-300);\n}\n.input-group.input-group-solid .form-control {\n  background-color: var(--bs-gray-100);\n  border-color: var(--bs-gray-100);\n}\n.input-group.input-group-solid .form-control + .input-group-text {\n  border-left-color: var(--bs-gray-300);\n}\n\n.form-floating .form-control.form-control-solid::placeholder {\n  color: transparent;\n}\n.form-floating.form-control-solid-bg label::after,\n.form-floating > :disabled ~ label::after,\n.form-floating > :focus ~ label::after {\n  background-color: transparent !important;\n}\n\n.required:after {\n  content: \"*\";\n  position: relative;\n  font-size: inherit;\n  color: var(--bs-danger);\n  padding-left: 0.25rem;\n  font-weight: 600;\n}\n\n.progress-vertical {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n}\n.progress-vertical .progress {\n  height: 100%;\n  border-radius: 0.65rem;\n  display: flex;\n  align-items: flex-end;\n  margin-right: 1rem;\n}\n.progress-vertical .progress:last-child {\n  margin-right: 0;\n}\n.progress-vertical .progress .progress-bar {\n  width: 8px;\n  border-radius: 0.65rem;\n}\n\n.table:not(.table-bordered) > :not(:first-child) {\n  border-color: transparent;\n  border-width: 0;\n  border-style: none;\n}\n.table:not(.table-bordered) > :not(:last-child) > :last-child > * {\n  border-bottom-color: inherit;\n}\n.table:not(.table-bordered) tr, .table:not(.table-bordered) th, .table:not(.table-bordered) td {\n  border-color: inherit;\n  border-width: inherit;\n  border-style: inherit;\n  text-transform: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  color: inherit;\n  height: inherit;\n  min-height: inherit;\n}\n.table:not(.table-bordered) tr:first-child, .table:not(.table-bordered) th:first-child, .table:not(.table-bordered) td:first-child {\n  padding-left: 0;\n}\n.table:not(.table-bordered) tr:last-child, .table:not(.table-bordered) th:last-child, .table:not(.table-bordered) td:last-child {\n  padding-right: 0;\n}\n.table:not(.table-bordered) tfoot tr:last-child,\n.table:not(.table-bordered) tbody tr:last-child {\n  border-bottom: 0 !important;\n}\n.table:not(.table-bordered) tfoot tr:last-child th, .table:not(.table-bordered) tfoot tr:last-child td,\n.table:not(.table-bordered) tbody tr:last-child th,\n.table:not(.table-bordered) tbody tr:last-child td {\n  border-bottom: 0 !important;\n}\n.table:not(.table-bordered) tfoot th, .table:not(.table-bordered) tfoot td {\n  border-top: inherit;\n}\n.table:not(.table-bordered).table-rounded {\n  border-radius: 0.65rem;\n  border-spacing: 0;\n  border-collapse: separate;\n}\n.table:not(.table-bordered).table-rows-rounded th:first-child, .table:not(.table-bordered).table-rows-rounded td:first-child {\n  border-top-left-radius: 6px;\n  border-bottom-left-radius: 6px;\n}\n.table:not(.table-bordered).table-rows-rounded th:last-child, .table:not(.table-bordered).table-rows-rounded td:last-child {\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n.table:not(.table-bordered).table-flush tr, .table:not(.table-bordered).table-flush th, .table:not(.table-bordered).table-flush td {\n  padding: inherit;\n}\n.table:not(.table-bordered).table-row-bordered tr {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: var(--bs-border-color);\n}\n.table:not(.table-bordered).table-row-bordered tfoot th, .table:not(.table-bordered).table-row-bordered tfoot td {\n  border-top-width: 1px !important;\n}\n.table:not(.table-bordered).table-row-dashed tr {\n  border-bottom-width: 1px;\n  border-bottom-style: dashed;\n  border-bottom-color: var(--bs-border-color);\n}\n.table:not(.table-bordered).table-row-dashed tfoot th, .table:not(.table-bordered).table-row-dashed tfoot td {\n  border-top-width: 1px !important;\n}\n.table:not(.table-bordered).table-row-gray-100 tr {\n  border-bottom-color: var(--bs-gray-100);\n}\n.table:not(.table-bordered).table-row-gray-200 tr {\n  border-bottom-color: var(--bs-gray-200);\n}\n.table:not(.table-bordered).table-row-gray-300 tr {\n  border-bottom-color: var(--bs-gray-300);\n}\n.table:not(.table-bordered).table-row-gray-400 tr {\n  border-bottom-color: var(--bs-gray-400);\n}\n.table:not(.table-bordered).table-row-gray-500 tr {\n  border-bottom-color: var(--bs-gray-500);\n}\n.table:not(.table-bordered).table-row-gray-600 tr {\n  border-bottom-color: var(--bs-gray-600);\n}\n.table:not(.table-bordered).table-row-gray-700 tr {\n  border-bottom-color: var(--bs-gray-700);\n}\n.table:not(.table-bordered).table-row-gray-800 tr {\n  border-bottom-color: var(--bs-gray-800);\n}\n.table:not(.table-bordered).table-row-gray-900 tr {\n  border-bottom-color: var(--bs-gray-900);\n}\n\n.table-layout-fixed {\n  table-layout: fixed;\n}\n\n.table-sort:after {\n  opacity: 0;\n}\n\n.table-sort,\n.table-sort-asc,\n.table-sort-desc {\n  vertical-align: middle;\n}\n.table-sort:after,\n.table-sort-asc:after,\n.table-sort-desc:after {\n  position: relative;\n  display: inline-block;\n  width: 0.75rem;\n  height: 0.75rem;\n  content: \" \";\n  bottom: auto;\n  right: auto;\n  left: auto;\n  margin-left: 0.5rem;\n}\n\n.table-sort-asc:after {\n  opacity: 1;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z'/%3e%3c/svg%3e\");\n}\n\n.table-sort-desc:after {\n  opacity: 1;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-text-muted%29'%3e%3cpath d='M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z'/%3e%3c/svg%3e\");\n}\n\n.table-loading-message {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  border-radius: 0.65rem;\n  box-shadow: var(--bs-table-loading-message-box-shadow);\n  background-color: var(--bs-body-bg);\n  color: var(--bs-gray-700);\n  font-weight: 600;\n  margin: 0 !important;\n  width: auto;\n  padding: 0.85rem 2rem !important;\n  transform: translateX(-50%) translateY(-50%);\n}\n\n.table-loading {\n  position: relative;\n}\n.table-loading .table-loading-message {\n  display: block;\n}\n\n.table.g-0 th, .table.g-0 td {\n  padding: 0rem;\n}\n.table.g-0 th.dtr-control, .table.g-0 td.dtr-control {\n  padding-left: 0rem !important;\n}\n\n.table.gy-0 th, .table.gy-0 td {\n  padding-top: 0rem;\n  padding-bottom: 0rem;\n}\n\n.table.gx-0 th, .table.gx-0 td {\n  padding-left: 0rem;\n  padding-right: 0rem;\n}\n.table.gx-0 th.dtr-control, .table.gx-0 td.dtr-control {\n  padding-left: 0rem !important;\n}\n\n.table.gs-0 th:first-child, .table.gs-0 td:first-child {\n  padding-left: 0rem;\n}\n.table.gs-0 th:last-child, .table.gs-0 td:last-child {\n  padding-right: 0rem;\n}\n.table.gs-0 th.dtr-control:first-child, .table.gs-0 td.dtr-control:first-child {\n  padding-left: 0rem !important;\n}\n\n.table.g-1 th, .table.g-1 td {\n  padding: 0.25rem;\n}\n.table.g-1 th.dtr-control, .table.g-1 td.dtr-control {\n  padding-left: 0.25rem !important;\n}\n\n.table.gy-1 th, .table.gy-1 td {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.table.gx-1 th, .table.gx-1 td {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.table.gx-1 th.dtr-control, .table.gx-1 td.dtr-control {\n  padding-left: 0.25rem !important;\n}\n\n.table.gs-1 th:first-child, .table.gs-1 td:first-child {\n  padding-left: 0.25rem;\n}\n.table.gs-1 th:last-child, .table.gs-1 td:last-child {\n  padding-right: 0.25rem;\n}\n.table.gs-1 th.dtr-control:first-child, .table.gs-1 td.dtr-control:first-child {\n  padding-left: 0.25rem !important;\n}\n\n.table.g-2 th, .table.g-2 td {\n  padding: 0.5rem;\n}\n.table.g-2 th.dtr-control, .table.g-2 td.dtr-control {\n  padding-left: 0.5rem !important;\n}\n\n.table.gy-2 th, .table.gy-2 td {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.table.gx-2 th, .table.gx-2 td {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.table.gx-2 th.dtr-control, .table.gx-2 td.dtr-control {\n  padding-left: 0.5rem !important;\n}\n\n.table.gs-2 th:first-child, .table.gs-2 td:first-child {\n  padding-left: 0.5rem;\n}\n.table.gs-2 th:last-child, .table.gs-2 td:last-child {\n  padding-right: 0.5rem;\n}\n.table.gs-2 th.dtr-control:first-child, .table.gs-2 td.dtr-control:first-child {\n  padding-left: 0.5rem !important;\n}\n\n.table.g-3 th, .table.g-3 td {\n  padding: 0.75rem;\n}\n.table.g-3 th.dtr-control, .table.g-3 td.dtr-control {\n  padding-left: 0.75rem !important;\n}\n\n.table.gy-3 th, .table.gy-3 td {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.table.gx-3 th, .table.gx-3 td {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n.table.gx-3 th.dtr-control, .table.gx-3 td.dtr-control {\n  padding-left: 0.75rem !important;\n}\n\n.table.gs-3 th:first-child, .table.gs-3 td:first-child {\n  padding-left: 0.75rem;\n}\n.table.gs-3 th:last-child, .table.gs-3 td:last-child {\n  padding-right: 0.75rem;\n}\n.table.gs-3 th.dtr-control:first-child, .table.gs-3 td.dtr-control:first-child {\n  padding-left: 0.75rem !important;\n}\n\n.table.g-4 th, .table.g-4 td {\n  padding: 1rem;\n}\n.table.g-4 th.dtr-control, .table.g-4 td.dtr-control {\n  padding-left: 1rem !important;\n}\n\n.table.gy-4 th, .table.gy-4 td {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.table.gx-4 th, .table.gx-4 td {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.table.gx-4 th.dtr-control, .table.gx-4 td.dtr-control {\n  padding-left: 1rem !important;\n}\n\n.table.gs-4 th:first-child, .table.gs-4 td:first-child {\n  padding-left: 1rem;\n}\n.table.gs-4 th:last-child, .table.gs-4 td:last-child {\n  padding-right: 1rem;\n}\n.table.gs-4 th.dtr-control:first-child, .table.gs-4 td.dtr-control:first-child {\n  padding-left: 1rem !important;\n}\n\n.table.g-5 th, .table.g-5 td {\n  padding: 1.25rem;\n}\n.table.g-5 th.dtr-control, .table.g-5 td.dtr-control {\n  padding-left: 1.25rem !important;\n}\n\n.table.gy-5 th, .table.gy-5 td {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.table.gx-5 th, .table.gx-5 td {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n.table.gx-5 th.dtr-control, .table.gx-5 td.dtr-control {\n  padding-left: 1.25rem !important;\n}\n\n.table.gs-5 th:first-child, .table.gs-5 td:first-child {\n  padding-left: 1.25rem;\n}\n.table.gs-5 th:last-child, .table.gs-5 td:last-child {\n  padding-right: 1.25rem;\n}\n.table.gs-5 th.dtr-control:first-child, .table.gs-5 td.dtr-control:first-child {\n  padding-left: 1.25rem !important;\n}\n\n.table.g-6 th, .table.g-6 td {\n  padding: 1.5rem;\n}\n.table.g-6 th.dtr-control, .table.g-6 td.dtr-control {\n  padding-left: 1.5rem !important;\n}\n\n.table.gy-6 th, .table.gy-6 td {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.table.gx-6 th, .table.gx-6 td {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.table.gx-6 th.dtr-control, .table.gx-6 td.dtr-control {\n  padding-left: 1.5rem !important;\n}\n\n.table.gs-6 th:first-child, .table.gs-6 td:first-child {\n  padding-left: 1.5rem;\n}\n.table.gs-6 th:last-child, .table.gs-6 td:last-child {\n  padding-right: 1.5rem;\n}\n.table.gs-6 th.dtr-control:first-child, .table.gs-6 td.dtr-control:first-child {\n  padding-left: 1.5rem !important;\n}\n\n.table.g-7 th, .table.g-7 td {\n  padding: 1.75rem;\n}\n.table.g-7 th.dtr-control, .table.g-7 td.dtr-control {\n  padding-left: 1.75rem !important;\n}\n\n.table.gy-7 th, .table.gy-7 td {\n  padding-top: 1.75rem;\n  padding-bottom: 1.75rem;\n}\n\n.table.gx-7 th, .table.gx-7 td {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n.table.gx-7 th.dtr-control, .table.gx-7 td.dtr-control {\n  padding-left: 1.75rem !important;\n}\n\n.table.gs-7 th:first-child, .table.gs-7 td:first-child {\n  padding-left: 1.75rem;\n}\n.table.gs-7 th:last-child, .table.gs-7 td:last-child {\n  padding-right: 1.75rem;\n}\n.table.gs-7 th.dtr-control:first-child, .table.gs-7 td.dtr-control:first-child {\n  padding-left: 1.75rem !important;\n}\n\n.table.g-8 th, .table.g-8 td {\n  padding: 2rem;\n}\n.table.g-8 th.dtr-control, .table.g-8 td.dtr-control {\n  padding-left: 2rem !important;\n}\n\n.table.gy-8 th, .table.gy-8 td {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.table.gx-8 th, .table.gx-8 td {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n.table.gx-8 th.dtr-control, .table.gx-8 td.dtr-control {\n  padding-left: 2rem !important;\n}\n\n.table.gs-8 th:first-child, .table.gs-8 td:first-child {\n  padding-left: 2rem;\n}\n.table.gs-8 th:last-child, .table.gs-8 td:last-child {\n  padding-right: 2rem;\n}\n.table.gs-8 th.dtr-control:first-child, .table.gs-8 td.dtr-control:first-child {\n  padding-left: 2rem !important;\n}\n\n.table.g-9 th, .table.g-9 td {\n  padding: 2.25rem;\n}\n.table.g-9 th.dtr-control, .table.g-9 td.dtr-control {\n  padding-left: 2.25rem !important;\n}\n\n.table.gy-9 th, .table.gy-9 td {\n  padding-top: 2.25rem;\n  padding-bottom: 2.25rem;\n}\n\n.table.gx-9 th, .table.gx-9 td {\n  padding-left: 2.25rem;\n  padding-right: 2.25rem;\n}\n.table.gx-9 th.dtr-control, .table.gx-9 td.dtr-control {\n  padding-left: 2.25rem !important;\n}\n\n.table.gs-9 th:first-child, .table.gs-9 td:first-child {\n  padding-left: 2.25rem;\n}\n.table.gs-9 th:last-child, .table.gs-9 td:last-child {\n  padding-right: 2.25rem;\n}\n.table.gs-9 th.dtr-control:first-child, .table.gs-9 td.dtr-control:first-child {\n  padding-left: 2.25rem !important;\n}\n\n.table.g-10 th, .table.g-10 td {\n  padding: 2.5rem;\n}\n.table.g-10 th.dtr-control, .table.g-10 td.dtr-control {\n  padding-left: 2.5rem !important;\n}\n\n.table.gy-10 th, .table.gy-10 td {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n\n.table.gx-10 th, .table.gx-10 td {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n.table.gx-10 th.dtr-control, .table.gx-10 td.dtr-control {\n  padding-left: 2.5rem !important;\n}\n\n.table.gs-10 th:first-child, .table.gs-10 td:first-child {\n  padding-left: 2.5rem;\n}\n.table.gs-10 th:last-child, .table.gs-10 td:last-child {\n  padding-right: 2.5rem;\n}\n.table.gs-10 th.dtr-control:first-child, .table.gs-10 td.dtr-control:first-child {\n  padding-left: 2.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .table.g-sm-0 th, .table.g-sm-0 td {\n    padding: 0rem;\n  }\n  .table.g-sm-0 th.dtr-control, .table.g-sm-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-sm-0 th, .table.gy-sm-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-sm-0 th, .table.gx-sm-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-sm-0 th.dtr-control, .table.gx-sm-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-sm-0 th:first-child, .table.gs-sm-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-sm-0 th:last-child, .table.gs-sm-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-sm-0 th.dtr-control:first-child, .table.gs-sm-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-sm-1 th, .table.g-sm-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-sm-1 th.dtr-control, .table.g-sm-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-sm-1 th, .table.gy-sm-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-sm-1 th, .table.gx-sm-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-sm-1 th.dtr-control, .table.gx-sm-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-sm-1 th:first-child, .table.gs-sm-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-sm-1 th:last-child, .table.gs-sm-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-sm-1 th.dtr-control:first-child, .table.gs-sm-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-sm-2 th, .table.g-sm-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-sm-2 th.dtr-control, .table.g-sm-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-sm-2 th, .table.gy-sm-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-sm-2 th, .table.gx-sm-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-sm-2 th.dtr-control, .table.gx-sm-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-sm-2 th:first-child, .table.gs-sm-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-sm-2 th:last-child, .table.gs-sm-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-sm-2 th.dtr-control:first-child, .table.gs-sm-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-sm-3 th, .table.g-sm-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-sm-3 th.dtr-control, .table.g-sm-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-sm-3 th, .table.gy-sm-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-sm-3 th, .table.gx-sm-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-sm-3 th.dtr-control, .table.gx-sm-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-sm-3 th:first-child, .table.gs-sm-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-sm-3 th:last-child, .table.gs-sm-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-sm-3 th.dtr-control:first-child, .table.gs-sm-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-sm-4 th, .table.g-sm-4 td {\n    padding: 1rem;\n  }\n  .table.g-sm-4 th.dtr-control, .table.g-sm-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-sm-4 th, .table.gy-sm-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-sm-4 th, .table.gx-sm-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-sm-4 th.dtr-control, .table.gx-sm-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-sm-4 th:first-child, .table.gs-sm-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-sm-4 th:last-child, .table.gs-sm-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-sm-4 th.dtr-control:first-child, .table.gs-sm-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-sm-5 th, .table.g-sm-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-sm-5 th.dtr-control, .table.g-sm-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-sm-5 th, .table.gy-sm-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-sm-5 th, .table.gx-sm-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-sm-5 th.dtr-control, .table.gx-sm-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-sm-5 th:first-child, .table.gs-sm-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-sm-5 th:last-child, .table.gs-sm-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-sm-5 th.dtr-control:first-child, .table.gs-sm-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-sm-6 th, .table.g-sm-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-sm-6 th.dtr-control, .table.g-sm-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-sm-6 th, .table.gy-sm-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-sm-6 th, .table.gx-sm-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-sm-6 th.dtr-control, .table.gx-sm-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-sm-6 th:first-child, .table.gs-sm-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-sm-6 th:last-child, .table.gs-sm-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-sm-6 th.dtr-control:first-child, .table.gs-sm-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-sm-7 th, .table.g-sm-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-sm-7 th.dtr-control, .table.g-sm-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-sm-7 th, .table.gy-sm-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-sm-7 th, .table.gx-sm-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-sm-7 th.dtr-control, .table.gx-sm-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-sm-7 th:first-child, .table.gs-sm-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-sm-7 th:last-child, .table.gs-sm-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-sm-7 th.dtr-control:first-child, .table.gs-sm-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-sm-8 th, .table.g-sm-8 td {\n    padding: 2rem;\n  }\n  .table.g-sm-8 th.dtr-control, .table.g-sm-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-sm-8 th, .table.gy-sm-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-sm-8 th, .table.gx-sm-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-sm-8 th.dtr-control, .table.gx-sm-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-sm-8 th:first-child, .table.gs-sm-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-sm-8 th:last-child, .table.gs-sm-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-sm-8 th.dtr-control:first-child, .table.gs-sm-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-sm-9 th, .table.g-sm-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-sm-9 th.dtr-control, .table.g-sm-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-sm-9 th, .table.gy-sm-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-sm-9 th, .table.gx-sm-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-sm-9 th.dtr-control, .table.gx-sm-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-sm-9 th:first-child, .table.gs-sm-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-sm-9 th:last-child, .table.gs-sm-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-sm-9 th.dtr-control:first-child, .table.gs-sm-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-sm-10 th, .table.g-sm-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-sm-10 th.dtr-control, .table.g-sm-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-sm-10 th, .table.gy-sm-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-sm-10 th, .table.gx-sm-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-sm-10 th.dtr-control, .table.gx-sm-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-sm-10 th:first-child, .table.gs-sm-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-sm-10 th:last-child, .table.gs-sm-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-sm-10 th.dtr-control:first-child, .table.gs-sm-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .table.g-md-0 th, .table.g-md-0 td {\n    padding: 0rem;\n  }\n  .table.g-md-0 th.dtr-control, .table.g-md-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-md-0 th, .table.gy-md-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-md-0 th, .table.gx-md-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-md-0 th.dtr-control, .table.gx-md-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-md-0 th:first-child, .table.gs-md-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-md-0 th:last-child, .table.gs-md-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-md-0 th.dtr-control:first-child, .table.gs-md-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-md-1 th, .table.g-md-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-md-1 th.dtr-control, .table.g-md-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-md-1 th, .table.gy-md-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-md-1 th, .table.gx-md-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-md-1 th.dtr-control, .table.gx-md-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-md-1 th:first-child, .table.gs-md-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-md-1 th:last-child, .table.gs-md-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-md-1 th.dtr-control:first-child, .table.gs-md-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-md-2 th, .table.g-md-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-md-2 th.dtr-control, .table.g-md-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-md-2 th, .table.gy-md-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-md-2 th, .table.gx-md-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-md-2 th.dtr-control, .table.gx-md-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-md-2 th:first-child, .table.gs-md-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-md-2 th:last-child, .table.gs-md-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-md-2 th.dtr-control:first-child, .table.gs-md-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-md-3 th, .table.g-md-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-md-3 th.dtr-control, .table.g-md-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-md-3 th, .table.gy-md-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-md-3 th, .table.gx-md-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-md-3 th.dtr-control, .table.gx-md-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-md-3 th:first-child, .table.gs-md-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-md-3 th:last-child, .table.gs-md-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-md-3 th.dtr-control:first-child, .table.gs-md-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-md-4 th, .table.g-md-4 td {\n    padding: 1rem;\n  }\n  .table.g-md-4 th.dtr-control, .table.g-md-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-md-4 th, .table.gy-md-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-md-4 th, .table.gx-md-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-md-4 th.dtr-control, .table.gx-md-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-md-4 th:first-child, .table.gs-md-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-md-4 th:last-child, .table.gs-md-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-md-4 th.dtr-control:first-child, .table.gs-md-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-md-5 th, .table.g-md-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-md-5 th.dtr-control, .table.g-md-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-md-5 th, .table.gy-md-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-md-5 th, .table.gx-md-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-md-5 th.dtr-control, .table.gx-md-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-md-5 th:first-child, .table.gs-md-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-md-5 th:last-child, .table.gs-md-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-md-5 th.dtr-control:first-child, .table.gs-md-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-md-6 th, .table.g-md-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-md-6 th.dtr-control, .table.g-md-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-md-6 th, .table.gy-md-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-md-6 th, .table.gx-md-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-md-6 th.dtr-control, .table.gx-md-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-md-6 th:first-child, .table.gs-md-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-md-6 th:last-child, .table.gs-md-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-md-6 th.dtr-control:first-child, .table.gs-md-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-md-7 th, .table.g-md-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-md-7 th.dtr-control, .table.g-md-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-md-7 th, .table.gy-md-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-md-7 th, .table.gx-md-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-md-7 th.dtr-control, .table.gx-md-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-md-7 th:first-child, .table.gs-md-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-md-7 th:last-child, .table.gs-md-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-md-7 th.dtr-control:first-child, .table.gs-md-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-md-8 th, .table.g-md-8 td {\n    padding: 2rem;\n  }\n  .table.g-md-8 th.dtr-control, .table.g-md-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-md-8 th, .table.gy-md-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-md-8 th, .table.gx-md-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-md-8 th.dtr-control, .table.gx-md-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-md-8 th:first-child, .table.gs-md-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-md-8 th:last-child, .table.gs-md-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-md-8 th.dtr-control:first-child, .table.gs-md-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-md-9 th, .table.g-md-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-md-9 th.dtr-control, .table.g-md-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-md-9 th, .table.gy-md-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-md-9 th, .table.gx-md-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-md-9 th.dtr-control, .table.gx-md-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-md-9 th:first-child, .table.gs-md-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-md-9 th:last-child, .table.gs-md-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-md-9 th.dtr-control:first-child, .table.gs-md-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-md-10 th, .table.g-md-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-md-10 th.dtr-control, .table.g-md-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-md-10 th, .table.gy-md-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-md-10 th, .table.gx-md-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-md-10 th.dtr-control, .table.gx-md-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-md-10 th:first-child, .table.gs-md-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-md-10 th:last-child, .table.gs-md-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-md-10 th.dtr-control:first-child, .table.gs-md-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .table.g-lg-0 th, .table.g-lg-0 td {\n    padding: 0rem;\n  }\n  .table.g-lg-0 th.dtr-control, .table.g-lg-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-lg-0 th, .table.gy-lg-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-lg-0 th, .table.gx-lg-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-lg-0 th.dtr-control, .table.gx-lg-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-lg-0 th:first-child, .table.gs-lg-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-lg-0 th:last-child, .table.gs-lg-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-lg-0 th.dtr-control:first-child, .table.gs-lg-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-lg-1 th, .table.g-lg-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-lg-1 th.dtr-control, .table.g-lg-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-lg-1 th, .table.gy-lg-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-lg-1 th, .table.gx-lg-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-lg-1 th.dtr-control, .table.gx-lg-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-lg-1 th:first-child, .table.gs-lg-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-lg-1 th:last-child, .table.gs-lg-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-lg-1 th.dtr-control:first-child, .table.gs-lg-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-lg-2 th, .table.g-lg-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-lg-2 th.dtr-control, .table.g-lg-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-lg-2 th, .table.gy-lg-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-lg-2 th, .table.gx-lg-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-lg-2 th.dtr-control, .table.gx-lg-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-lg-2 th:first-child, .table.gs-lg-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-lg-2 th:last-child, .table.gs-lg-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-lg-2 th.dtr-control:first-child, .table.gs-lg-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-lg-3 th, .table.g-lg-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-lg-3 th.dtr-control, .table.g-lg-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-lg-3 th, .table.gy-lg-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-lg-3 th, .table.gx-lg-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-lg-3 th.dtr-control, .table.gx-lg-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-lg-3 th:first-child, .table.gs-lg-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-lg-3 th:last-child, .table.gs-lg-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-lg-3 th.dtr-control:first-child, .table.gs-lg-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-lg-4 th, .table.g-lg-4 td {\n    padding: 1rem;\n  }\n  .table.g-lg-4 th.dtr-control, .table.g-lg-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-lg-4 th, .table.gy-lg-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-lg-4 th, .table.gx-lg-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-lg-4 th.dtr-control, .table.gx-lg-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-lg-4 th:first-child, .table.gs-lg-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-lg-4 th:last-child, .table.gs-lg-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-lg-4 th.dtr-control:first-child, .table.gs-lg-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-lg-5 th, .table.g-lg-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-lg-5 th.dtr-control, .table.g-lg-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-lg-5 th, .table.gy-lg-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-lg-5 th, .table.gx-lg-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-lg-5 th.dtr-control, .table.gx-lg-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-lg-5 th:first-child, .table.gs-lg-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-lg-5 th:last-child, .table.gs-lg-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-lg-5 th.dtr-control:first-child, .table.gs-lg-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-lg-6 th, .table.g-lg-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-lg-6 th.dtr-control, .table.g-lg-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-lg-6 th, .table.gy-lg-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-lg-6 th, .table.gx-lg-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-lg-6 th.dtr-control, .table.gx-lg-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-lg-6 th:first-child, .table.gs-lg-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-lg-6 th:last-child, .table.gs-lg-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-lg-6 th.dtr-control:first-child, .table.gs-lg-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-lg-7 th, .table.g-lg-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-lg-7 th.dtr-control, .table.g-lg-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-lg-7 th, .table.gy-lg-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-lg-7 th, .table.gx-lg-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-lg-7 th.dtr-control, .table.gx-lg-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-lg-7 th:first-child, .table.gs-lg-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-lg-7 th:last-child, .table.gs-lg-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-lg-7 th.dtr-control:first-child, .table.gs-lg-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-lg-8 th, .table.g-lg-8 td {\n    padding: 2rem;\n  }\n  .table.g-lg-8 th.dtr-control, .table.g-lg-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-lg-8 th, .table.gy-lg-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-lg-8 th, .table.gx-lg-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-lg-8 th.dtr-control, .table.gx-lg-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-lg-8 th:first-child, .table.gs-lg-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-lg-8 th:last-child, .table.gs-lg-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-lg-8 th.dtr-control:first-child, .table.gs-lg-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-lg-9 th, .table.g-lg-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-lg-9 th.dtr-control, .table.g-lg-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-lg-9 th, .table.gy-lg-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-lg-9 th, .table.gx-lg-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-lg-9 th.dtr-control, .table.gx-lg-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-lg-9 th:first-child, .table.gs-lg-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-lg-9 th:last-child, .table.gs-lg-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-lg-9 th.dtr-control:first-child, .table.gs-lg-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-lg-10 th, .table.g-lg-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-lg-10 th.dtr-control, .table.g-lg-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-lg-10 th, .table.gy-lg-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-lg-10 th, .table.gx-lg-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-lg-10 th.dtr-control, .table.gx-lg-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-lg-10 th:first-child, .table.gs-lg-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-lg-10 th:last-child, .table.gs-lg-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-lg-10 th.dtr-control:first-child, .table.gs-lg-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .table.g-xl-0 th, .table.g-xl-0 td {\n    padding: 0rem;\n  }\n  .table.g-xl-0 th.dtr-control, .table.g-xl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-xl-0 th, .table.gy-xl-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-xl-0 th, .table.gx-xl-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-xl-0 th.dtr-control, .table.gx-xl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-xl-0 th:first-child, .table.gs-xl-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-xl-0 th:last-child, .table.gs-xl-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-xl-0 th.dtr-control:first-child, .table.gs-xl-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-xl-1 th, .table.g-xl-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-xl-1 th.dtr-control, .table.g-xl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-xl-1 th, .table.gy-xl-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-xl-1 th, .table.gx-xl-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-xl-1 th.dtr-control, .table.gx-xl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-xl-1 th:first-child, .table.gs-xl-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-xl-1 th:last-child, .table.gs-xl-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-xl-1 th.dtr-control:first-child, .table.gs-xl-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-xl-2 th, .table.g-xl-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-xl-2 th.dtr-control, .table.g-xl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-xl-2 th, .table.gy-xl-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-xl-2 th, .table.gx-xl-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-xl-2 th.dtr-control, .table.gx-xl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-xl-2 th:first-child, .table.gs-xl-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-xl-2 th:last-child, .table.gs-xl-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-xl-2 th.dtr-control:first-child, .table.gs-xl-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-xl-3 th, .table.g-xl-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-xl-3 th.dtr-control, .table.g-xl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-xl-3 th, .table.gy-xl-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-xl-3 th, .table.gx-xl-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-xl-3 th.dtr-control, .table.gx-xl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-xl-3 th:first-child, .table.gs-xl-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-xl-3 th:last-child, .table.gs-xl-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-xl-3 th.dtr-control:first-child, .table.gs-xl-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-xl-4 th, .table.g-xl-4 td {\n    padding: 1rem;\n  }\n  .table.g-xl-4 th.dtr-control, .table.g-xl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-xl-4 th, .table.gy-xl-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-xl-4 th, .table.gx-xl-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-xl-4 th.dtr-control, .table.gx-xl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-xl-4 th:first-child, .table.gs-xl-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-xl-4 th:last-child, .table.gs-xl-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-xl-4 th.dtr-control:first-child, .table.gs-xl-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-xl-5 th, .table.g-xl-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-xl-5 th.dtr-control, .table.g-xl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-xl-5 th, .table.gy-xl-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-xl-5 th, .table.gx-xl-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-xl-5 th.dtr-control, .table.gx-xl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-xl-5 th:first-child, .table.gs-xl-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-xl-5 th:last-child, .table.gs-xl-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-xl-5 th.dtr-control:first-child, .table.gs-xl-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-xl-6 th, .table.g-xl-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-xl-6 th.dtr-control, .table.g-xl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-xl-6 th, .table.gy-xl-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-xl-6 th, .table.gx-xl-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-xl-6 th.dtr-control, .table.gx-xl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-xl-6 th:first-child, .table.gs-xl-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-xl-6 th:last-child, .table.gs-xl-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-xl-6 th.dtr-control:first-child, .table.gs-xl-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-xl-7 th, .table.g-xl-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-xl-7 th.dtr-control, .table.g-xl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-xl-7 th, .table.gy-xl-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-xl-7 th, .table.gx-xl-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-xl-7 th.dtr-control, .table.gx-xl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-xl-7 th:first-child, .table.gs-xl-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-xl-7 th:last-child, .table.gs-xl-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-xl-7 th.dtr-control:first-child, .table.gs-xl-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-xl-8 th, .table.g-xl-8 td {\n    padding: 2rem;\n  }\n  .table.g-xl-8 th.dtr-control, .table.g-xl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-xl-8 th, .table.gy-xl-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-xl-8 th, .table.gx-xl-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-xl-8 th.dtr-control, .table.gx-xl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-xl-8 th:first-child, .table.gs-xl-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-xl-8 th:last-child, .table.gs-xl-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-xl-8 th.dtr-control:first-child, .table.gs-xl-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-xl-9 th, .table.g-xl-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-xl-9 th.dtr-control, .table.g-xl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-xl-9 th, .table.gy-xl-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-xl-9 th, .table.gx-xl-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-xl-9 th.dtr-control, .table.gx-xl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-xl-9 th:first-child, .table.gs-xl-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-xl-9 th:last-child, .table.gs-xl-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-xl-9 th.dtr-control:first-child, .table.gs-xl-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-xl-10 th, .table.g-xl-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-xl-10 th.dtr-control, .table.g-xl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-xl-10 th, .table.gy-xl-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-xl-10 th, .table.gx-xl-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-xl-10 th.dtr-control, .table.gx-xl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-xl-10 th:first-child, .table.gs-xl-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-xl-10 th:last-child, .table.gs-xl-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-xl-10 th.dtr-control:first-child, .table.gs-xl-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .table.g-xxl-0 th, .table.g-xxl-0 td {\n    padding: 0rem;\n  }\n  .table.g-xxl-0 th.dtr-control, .table.g-xxl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gy-xxl-0 th, .table.gy-xxl-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n  .table.gx-xxl-0 th, .table.gx-xxl-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-xxl-0 th.dtr-control, .table.gx-xxl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n  .table.gs-xxl-0 th:first-child, .table.gs-xxl-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-xxl-0 th:last-child, .table.gs-xxl-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-xxl-0 th.dtr-control:first-child, .table.gs-xxl-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n  .table.g-xxl-1 th, .table.g-xxl-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-xxl-1 th.dtr-control, .table.g-xxl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gy-xxl-1 th, .table.gy-xxl-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n  .table.gx-xxl-1 th, .table.gx-xxl-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-xxl-1 th.dtr-control, .table.gx-xxl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n  .table.gs-xxl-1 th:first-child, .table.gs-xxl-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-xxl-1 th:last-child, .table.gs-xxl-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-xxl-1 th.dtr-control:first-child, .table.gs-xxl-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n  .table.g-xxl-2 th, .table.g-xxl-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-xxl-2 th.dtr-control, .table.g-xxl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gy-xxl-2 th, .table.gy-xxl-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .table.gx-xxl-2 th, .table.gx-xxl-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-xxl-2 th.dtr-control, .table.gx-xxl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n  .table.gs-xxl-2 th:first-child, .table.gs-xxl-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-xxl-2 th:last-child, .table.gs-xxl-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-xxl-2 th.dtr-control:first-child, .table.gs-xxl-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n  .table.g-xxl-3 th, .table.g-xxl-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-xxl-3 th.dtr-control, .table.g-xxl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gy-xxl-3 th, .table.gy-xxl-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .table.gx-xxl-3 th, .table.gx-xxl-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-xxl-3 th.dtr-control, .table.gx-xxl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n  .table.gs-xxl-3 th:first-child, .table.gs-xxl-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-xxl-3 th:last-child, .table.gs-xxl-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-xxl-3 th.dtr-control:first-child, .table.gs-xxl-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n  .table.g-xxl-4 th, .table.g-xxl-4 td {\n    padding: 1rem;\n  }\n  .table.g-xxl-4 th.dtr-control, .table.g-xxl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gy-xxl-4 th, .table.gy-xxl-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n  .table.gx-xxl-4 th, .table.gx-xxl-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-xxl-4 th.dtr-control, .table.gx-xxl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n  .table.gs-xxl-4 th:first-child, .table.gs-xxl-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-xxl-4 th:last-child, .table.gs-xxl-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-xxl-4 th.dtr-control:first-child, .table.gs-xxl-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n  .table.g-xxl-5 th, .table.g-xxl-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-xxl-5 th.dtr-control, .table.g-xxl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gy-xxl-5 th, .table.gy-xxl-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n  .table.gx-xxl-5 th, .table.gx-xxl-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-xxl-5 th.dtr-control, .table.gx-xxl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n  .table.gs-xxl-5 th:first-child, .table.gs-xxl-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-xxl-5 th:last-child, .table.gs-xxl-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-xxl-5 th.dtr-control:first-child, .table.gs-xxl-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n  .table.g-xxl-6 th, .table.g-xxl-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-xxl-6 th.dtr-control, .table.g-xxl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gy-xxl-6 th, .table.gy-xxl-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .table.gx-xxl-6 th, .table.gx-xxl-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-xxl-6 th.dtr-control, .table.gx-xxl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n  .table.gs-xxl-6 th:first-child, .table.gs-xxl-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-xxl-6 th:last-child, .table.gs-xxl-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-xxl-6 th.dtr-control:first-child, .table.gs-xxl-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n  .table.g-xxl-7 th, .table.g-xxl-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-xxl-7 th.dtr-control, .table.g-xxl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gy-xxl-7 th, .table.gy-xxl-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n  .table.gx-xxl-7 th, .table.gx-xxl-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-xxl-7 th.dtr-control, .table.gx-xxl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n  .table.gs-xxl-7 th:first-child, .table.gs-xxl-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-xxl-7 th:last-child, .table.gs-xxl-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-xxl-7 th.dtr-control:first-child, .table.gs-xxl-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n  .table.g-xxl-8 th, .table.g-xxl-8 td {\n    padding: 2rem;\n  }\n  .table.g-xxl-8 th.dtr-control, .table.g-xxl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gy-xxl-8 th, .table.gy-xxl-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .table.gx-xxl-8 th, .table.gx-xxl-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-xxl-8 th.dtr-control, .table.gx-xxl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n  .table.gs-xxl-8 th:first-child, .table.gs-xxl-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-xxl-8 th:last-child, .table.gs-xxl-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-xxl-8 th.dtr-control:first-child, .table.gs-xxl-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n  .table.g-xxl-9 th, .table.g-xxl-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-xxl-9 th.dtr-control, .table.g-xxl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gy-xxl-9 th, .table.gy-xxl-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n  .table.gx-xxl-9 th, .table.gx-xxl-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-xxl-9 th.dtr-control, .table.gx-xxl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n  .table.gs-xxl-9 th:first-child, .table.gs-xxl-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-xxl-9 th:last-child, .table.gs-xxl-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-xxl-9 th.dtr-control:first-child, .table.gs-xxl-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n  .table.g-xxl-10 th, .table.g-xxl-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-xxl-10 th.dtr-control, .table.g-xxl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gy-xxl-10 th, .table.gy-xxl-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n  .table.gx-xxl-10 th, .table.gx-xxl-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-xxl-10 th.dtr-control, .table.gx-xxl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n  .table.gs-xxl-10 th:first-child, .table.gs-xxl-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-xxl-10 th:last-child, .table.gs-xxl-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-xxl-10 th.dtr-control:first-child, .table.gs-xxl-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n.popover {\n  --bs-popover-header-border-color: #F1F1F4;\n}\n.popover .popover-header {\n  font-size: 1rem;\n  font-weight: 500;\n  border-bottom: 1px solid var(--bs-popover-header-border-color);\n}\n.popover .popover-dismiss {\n  position: absolute;\n  top: 0.85rem;\n  right: 0.85rem;\n  height: 1.25rem;\n  width: 1.25rem;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--bs-gray-500%29'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--bs-gray-500%29'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\");\n  mask-size: 50%;\n  -webkit-mask-size: 50%;\n}\n.popover .popover-dismiss:hover {\n  background-color: var(--bs-primary);\n}\n.popover .popover-dismiss + .popover-header {\n  padding-right: 2.5rem;\n}\n\n.popover-inverse {\n  --bs-popover-bg: var(--bs-gray-900);\n  --bs-popover-border-color: var(--bs-gray-900);\n  --bs-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-popover-header-color: var(--bs-gray-200);\n  --bs-popover-header-bg: var(--bs-gray-900);\n  --bs-popover-body-color: var(--bs-gray-400);\n  --bs-popover-arrow-border: transparent;\n  --bs-popover-header-border-color: var(--bs-gray-800);\n}\n\n[data-bs-theme=dark] .popover:not(.popover-inverse) {\n  --bs-popover-bg: #26272F;\n  --bs-popover-border-color: #26272F;\n  --bs-popover-header-bg: #26272F;\n  --bs-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --bs-popover-header-border-color: #363843;\n}\n\n.tooltip .tooltip-inner {\n  box-shadow: var(--bs-tooltip-box-shadow);\n}\n.tooltip.tooltop-auto-width .tooltip-inner {\n  white-space: nowrap;\n  max-width: none;\n}\n.tooltip.tooltip-inverse {\n  --bs-tooltip-color: var(--bs-dark-inverse);\n  --bs-tooltip-bg: var(--bs-dark);\n}\n\n[data-bs-theme=dark] .tooltip:not(.tooltip-inverse) {\n  --bs-tooltip-bg: #26272F;\n  --bs-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n}\n\n.accordion .accordion-header {\n  cursor: pointer;\n}\n.accordion.accordion-icon-toggle .accordion-icon {\n  display: flex;\n  flex-shrink: 0;\n  transition: all 0.2s ease-in-out;\n  transform: rotate(90deg);\n  align-items: center;\n  justify-content: center;\n}\n.accordion.accordion-icon-toggle .accordion-icon i,\n.accordion.accordion-icon-toggle .accordion-icon .svg-icon {\n  color: var(--bs-primary);\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon {\n  transition: all 0.2s ease-in-out;\n  transform: rotate(0);\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon i,\n.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon {\n  color: var(--bs-text-muted);\n}\n.accordion.accordion-icon-collapse .accordion-icon {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease-in-out;\n}\n.accordion.accordion-icon-collapse .accordion-icon .accordion-icon-on {\n  display: inline-flex;\n}\n.accordion.accordion-icon-collapse .accordion-icon .accordion-icon-off {\n  display: none;\n}\n.accordion.accordion-icon-collapse .accordion-icon i,\n.accordion.accordion-icon-collapse .accordion-icon .svg-icon {\n  color: var(--bs-primary);\n}\n.accordion.accordion-icon-collapse .collapsed .accordion-icon {\n  transition: all 0.2s ease-in-out;\n}\n.accordion.accordion-icon-collapse .collapsed .accordion-icon .accordion-icon-on {\n  display: none;\n}\n.accordion.accordion-icon-collapse .collapsed .accordion-icon .accordion-icon-off {\n  display: inline-flex;\n}\n.accordion.accordion-icon-collapse .collapsed .accordion-icon i,\n.accordion.accordion-icon-collapse .collapsed .accordion-icon .svg-icon {\n  color: var(--bs-text-muted);\n}\n.accordion.accordion-borderless .accordion-item {\n  border: 0;\n}\n.accordion.accordion-flush .accordion-item {\n  background-color: transparent;\n  border: 0;\n  border-radius: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.image-input {\n  position: relative;\n  display: inline-block;\n  border-radius: 0.65rem;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.image-input:not(.image-input-empty) {\n  background-image: none !important;\n}\n.image-input .image-input-wrapper {\n  width: 120px;\n  height: 120px;\n  border-radius: 0.65rem;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.image-input [data-kt-image-input-action] {\n  cursor: pointer;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n.image-input [data-kt-image-input-action=change] {\n  left: 100%;\n  top: 0;\n}\n.image-input [data-kt-image-input-action=change] input {\n  width: 0 !important;\n  height: 0 !important;\n  overflow: hidden;\n  opacity: 0;\n}\n.image-input [data-kt-image-input-action=cancel],\n.image-input [data-kt-image-input-action=remove] {\n  position: absolute;\n  left: 100%;\n  top: 100%;\n}\n.image-input [data-kt-image-input-action=cancel] {\n  display: none;\n}\n.image-input.image-input-changed [data-kt-image-input-action=cancel] {\n  display: flex;\n}\n.image-input.image-input-changed [data-kt-image-input-action=remove] {\n  display: none;\n}\n.image-input.image-input-empty [data-kt-image-input-action=remove],\n.image-input.image-input-empty [data-kt-image-input-action=cancel] {\n  display: none;\n}\n.image-input.image-input-circle {\n  border-radius: 50%;\n}\n.image-input.image-input-circle .image-input-wrapper {\n  border-radius: 50%;\n}\n.image-input.image-input-circle [data-kt-image-input-action=change] {\n  left: 100%;\n  top: 0;\n  transform: translate(-100%, 0%);\n}\n.image-input.image-input-circle [data-kt-image-input-action=cancel],\n.image-input.image-input-circle [data-kt-image-input-action=remove] {\n  left: 100%;\n  top: 100%;\n  transform: translate(-100%, -100%);\n}\n.image-input.image-input-outline .image-input-wrapper {\n  border: 3px solid var(--bs-body-bg);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.symbol {\n  display: inline-block;\n  flex-shrink: 0;\n  position: relative;\n  border-radius: 0.65rem;\n}\n.symbol .symbol-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  color: var(--bs-symbol-label-color);\n  background-color: var(--bs-symbol-label-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  border-radius: 0.65rem;\n}\n.symbol .symbol-label:after {\n  border-radius: 0.65rem;\n}\n.symbol .symbol-badge {\n  position: absolute;\n  border-radius: 100%;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%) !important;\n}\n.symbol > img {\n  width: 100%;\n  flex-shrink: 0;\n  display: inline-block;\n  border-radius: 0.65rem;\n}\n.symbol.symbol-square,\n.symbol.symbol-square > img,\n.symbol.symbol-square .symbol-label {\n  border-radius: 0 !important;\n}\n.symbol.symbol-circle,\n.symbol.symbol-circle > img,\n.symbol.symbol-circle .symbol-label {\n  border-radius: 50%;\n}\n.symbol.symbol-circle:after,\n.symbol.symbol-circle > img:after,\n.symbol.symbol-circle .symbol-label:after {\n  border-radius: 50%;\n}\n.symbol > img {\n  width: 50px;\n  height: 50px;\n}\n.symbol .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-fixed .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-fixed > img {\n  width: 50px;\n  height: 50px;\n  max-width: none;\n}\n.symbol.symbol-2by3 .symbol-label {\n  height: 50px;\n  width: 75px;\n}\n.symbol.symbol-2by3 > img {\n  height: 50px;\n  width: 75px;\n  max-width: none;\n}\n.symbol.symbol-20px > img {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px .symbol-label {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px.symbol-fixed .symbol-label {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px.symbol-fixed > img {\n  width: 20px;\n  height: 20px;\n  max-width: none;\n}\n.symbol.symbol-20px.symbol-2by3 .symbol-label {\n  height: 20px;\n  width: 30px;\n}\n.symbol.symbol-20px.symbol-2by3 > img {\n  height: 20px;\n  width: 30px;\n  max-width: none;\n}\n.symbol.symbol-25px > img {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px .symbol-label {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px.symbol-fixed .symbol-label {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px.symbol-fixed > img {\n  width: 25px;\n  height: 25px;\n  max-width: none;\n}\n.symbol.symbol-25px.symbol-2by3 .symbol-label {\n  height: 25px;\n  width: 37.5px;\n}\n.symbol.symbol-25px.symbol-2by3 > img {\n  height: 25px;\n  width: 37.5px;\n  max-width: none;\n}\n.symbol.symbol-30px > img {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px .symbol-label {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px.symbol-fixed .symbol-label {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px.symbol-fixed > img {\n  width: 30px;\n  height: 30px;\n  max-width: none;\n}\n.symbol.symbol-30px.symbol-2by3 .symbol-label {\n  height: 30px;\n  width: 45px;\n}\n.symbol.symbol-30px.symbol-2by3 > img {\n  height: 30px;\n  width: 45px;\n  max-width: none;\n}\n.symbol.symbol-35px > img {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px .symbol-label {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px.symbol-fixed .symbol-label {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px.symbol-fixed > img {\n  width: 35px;\n  height: 35px;\n  max-width: none;\n}\n.symbol.symbol-35px.symbol-2by3 .symbol-label {\n  height: 35px;\n  width: 52.5px;\n}\n.symbol.symbol-35px.symbol-2by3 > img {\n  height: 35px;\n  width: 52.5px;\n  max-width: none;\n}\n.symbol.symbol-40px > img {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px .symbol-label {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px.symbol-fixed .symbol-label {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px.symbol-fixed > img {\n  width: 40px;\n  height: 40px;\n  max-width: none;\n}\n.symbol.symbol-40px.symbol-2by3 .symbol-label {\n  height: 40px;\n  width: 60px;\n}\n.symbol.symbol-40px.symbol-2by3 > img {\n  height: 40px;\n  width: 60px;\n  max-width: none;\n}\n.symbol.symbol-45px > img {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px .symbol-label {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px.symbol-fixed .symbol-label {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px.symbol-fixed > img {\n  width: 45px;\n  height: 45px;\n  max-width: none;\n}\n.symbol.symbol-45px.symbol-2by3 .symbol-label {\n  height: 45px;\n  width: 67.5px;\n}\n.symbol.symbol-45px.symbol-2by3 > img {\n  height: 45px;\n  width: 67.5px;\n  max-width: none;\n}\n.symbol.symbol-50px > img {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px.symbol-fixed .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px.symbol-fixed > img {\n  width: 50px;\n  height: 50px;\n  max-width: none;\n}\n.symbol.symbol-50px.symbol-2by3 .symbol-label {\n  height: 50px;\n  width: 75px;\n}\n.symbol.symbol-50px.symbol-2by3 > img {\n  height: 50px;\n  width: 75px;\n  max-width: none;\n}\n.symbol.symbol-55px > img {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px .symbol-label {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px.symbol-fixed .symbol-label {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px.symbol-fixed > img {\n  width: 55px;\n  height: 55px;\n  max-width: none;\n}\n.symbol.symbol-55px.symbol-2by3 .symbol-label {\n  height: 55px;\n  width: 82.5px;\n}\n.symbol.symbol-55px.symbol-2by3 > img {\n  height: 55px;\n  width: 82.5px;\n  max-width: none;\n}\n.symbol.symbol-60px > img {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px .symbol-label {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px.symbol-fixed .symbol-label {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px.symbol-fixed > img {\n  width: 60px;\n  height: 60px;\n  max-width: none;\n}\n.symbol.symbol-60px.symbol-2by3 .symbol-label {\n  height: 60px;\n  width: 90px;\n}\n.symbol.symbol-60px.symbol-2by3 > img {\n  height: 60px;\n  width: 90px;\n  max-width: none;\n}\n.symbol.symbol-65px > img {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px .symbol-label {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px.symbol-fixed .symbol-label {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px.symbol-fixed > img {\n  width: 65px;\n  height: 65px;\n  max-width: none;\n}\n.symbol.symbol-65px.symbol-2by3 .symbol-label {\n  height: 65px;\n  width: 97.5px;\n}\n.symbol.symbol-65px.symbol-2by3 > img {\n  height: 65px;\n  width: 97.5px;\n  max-width: none;\n}\n.symbol.symbol-70px > img {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px .symbol-label {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px.symbol-fixed .symbol-label {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px.symbol-fixed > img {\n  width: 70px;\n  height: 70px;\n  max-width: none;\n}\n.symbol.symbol-70px.symbol-2by3 .symbol-label {\n  height: 70px;\n  width: 105px;\n}\n.symbol.symbol-70px.symbol-2by3 > img {\n  height: 70px;\n  width: 105px;\n  max-width: none;\n}\n.symbol.symbol-75px > img {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px .symbol-label {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px.symbol-fixed .symbol-label {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px.symbol-fixed > img {\n  width: 75px;\n  height: 75px;\n  max-width: none;\n}\n.symbol.symbol-75px.symbol-2by3 .symbol-label {\n  height: 75px;\n  width: 112.5px;\n}\n.symbol.symbol-75px.symbol-2by3 > img {\n  height: 75px;\n  width: 112.5px;\n  max-width: none;\n}\n.symbol.symbol-90px > img {\n  width: 90px;\n  height: 90px;\n}\n.symbol.symbol-90px .symbol-label {\n  width: 90px;\n  height: 90px;\n}\n.symbol.symbol-90px.symbol-fixed .symbol-label {\n  width: 90px;\n  height: 90px;\n}\n.symbol.symbol-90px.symbol-fixed > img {\n  width: 90px;\n  height: 90px;\n  max-width: none;\n}\n.symbol.symbol-90px.symbol-2by3 .symbol-label {\n  height: 90px;\n  width: 135px;\n}\n.symbol.symbol-90px.symbol-2by3 > img {\n  height: 90px;\n  width: 135px;\n  max-width: none;\n}\n.symbol.symbol-100px > img {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px .symbol-label {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px.symbol-fixed .symbol-label {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px.symbol-fixed > img {\n  width: 100px;\n  height: 100px;\n  max-width: none;\n}\n.symbol.symbol-100px.symbol-2by3 .symbol-label {\n  height: 100px;\n  width: 150px;\n}\n.symbol.symbol-100px.symbol-2by3 > img {\n  height: 100px;\n  width: 150px;\n  max-width: none;\n}\n.symbol.symbol-125px > img {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px .symbol-label {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px.symbol-fixed .symbol-label {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px.symbol-fixed > img {\n  width: 125px;\n  height: 125px;\n  max-width: none;\n}\n.symbol.symbol-125px.symbol-2by3 .symbol-label {\n  height: 125px;\n  width: 187.5px;\n}\n.symbol.symbol-125px.symbol-2by3 > img {\n  height: 125px;\n  width: 187.5px;\n  max-width: none;\n}\n.symbol.symbol-150px > img {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px .symbol-label {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px.symbol-fixed .symbol-label {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px.symbol-fixed > img {\n  width: 150px;\n  height: 150px;\n  max-width: none;\n}\n.symbol.symbol-150px.symbol-2by3 .symbol-label {\n  height: 150px;\n  width: 225px;\n}\n.symbol.symbol-150px.symbol-2by3 > img {\n  height: 150px;\n  width: 225px;\n  max-width: none;\n}\n.symbol.symbol-160px > img {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px .symbol-label {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px.symbol-fixed .symbol-label {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px.symbol-fixed > img {\n  width: 160px;\n  height: 160px;\n  max-width: none;\n}\n.symbol.symbol-160px.symbol-2by3 .symbol-label {\n  height: 160px;\n  width: 240px;\n}\n.symbol.symbol-160px.symbol-2by3 > img {\n  height: 160px;\n  width: 240px;\n  max-width: none;\n}\n.symbol.symbol-175px > img {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px .symbol-label {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px.symbol-fixed .symbol-label {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px.symbol-fixed > img {\n  width: 175px;\n  height: 175px;\n  max-width: none;\n}\n.symbol.symbol-175px.symbol-2by3 .symbol-label {\n  height: 175px;\n  width: 262.5px;\n}\n.symbol.symbol-175px.symbol-2by3 > img {\n  height: 175px;\n  width: 262.5px;\n  max-width: none;\n}\n.symbol.symbol-200px > img {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px .symbol-label {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px.symbol-fixed .symbol-label {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px.symbol-fixed > img {\n  width: 200px;\n  height: 200px;\n  max-width: none;\n}\n.symbol.symbol-200px.symbol-2by3 .symbol-label {\n  height: 200px;\n  width: 300px;\n}\n.symbol.symbol-200px.symbol-2by3 > img {\n  height: 200px;\n  width: 300px;\n  max-width: none;\n}\n@media (min-width: 576px) {\n  .symbol.symbol-sm-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-sm-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-sm-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-sm-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-sm-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-sm-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-sm-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-sm-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-sm-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-sm-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-sm-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-sm-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-sm-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-sm-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-sm-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-sm-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-sm-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-sm-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-sm-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-sm-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-sm-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-sm-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-sm-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 768px) {\n  .symbol.symbol-md-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-md-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-md-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-md-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-md-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-md-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-md-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-md-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-md-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-md-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-md-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-md-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-md-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-md-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-md-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-md-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-md-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-md-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-md-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-md-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-md-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-md-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-md-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-md-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-md-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-md-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-md-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-md-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-md-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-md-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-md-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-md-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-md-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-md-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-md-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-md-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-md-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-md-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-md-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-md-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-md-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-md-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-md-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-md-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-md-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-md-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-md-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-md-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-md-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-md-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-md-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-md-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 992px) {\n  .symbol.symbol-lg-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-lg-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-lg-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-lg-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-lg-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-lg-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-lg-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-lg-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-lg-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-lg-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-lg-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-lg-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-lg-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-lg-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-lg-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-lg-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-lg-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-lg-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-lg-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-lg-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-lg-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-lg-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-lg-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 1200px) {\n  .symbol.symbol-xl-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-xl-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-xl-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-xl-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-xl-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-xl-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-xl-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-xl-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-xl-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-xl-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-xl-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-xl-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-xl-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xl-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xl-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xl-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-xl-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-xl-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-xl-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-xl-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-xl-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-xl-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-xl-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 1400px) {\n  .symbol.symbol-xxl-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-xxl-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-xxl-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-xxl-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-xxl-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-xxl-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-xxl-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-xxl-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-xxl-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-xxl-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-xxl-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-xxl-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-xxl-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xxl-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xxl-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xxl-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-xxl-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-xxl-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-xxl-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-xxl-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-xxl-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-xxl-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-xxl-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n\n.symbol-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-left: 10px;\n}\n.symbol-group .symbol {\n  position: relative;\n  z-index: 0;\n  margin-left: -10px;\n  transition: all 0.3s ease;\n}\n.symbol-group .symbol:hover {\n  transition: all 0.3s ease;\n  z-index: 1;\n}\n.symbol-group .symbol-badge {\n  border: 2px solid var(--bs-body-bg);\n}\n.symbol-group .symbol-label {\n  position: relative;\n}\n.symbol-group .symbol-label:after {\n  display: block;\n  content: \" \";\n  border-radius: inherit;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  border: 2px solid var(--bs-symbol-border-color);\n  -webkit-background-clip: padding-box; /* for Safari */\n  background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */\n}\n.symbol-group.symbol-hover .symbol {\n  cursor: pointer;\n}\n\n.pulse {\n  position: relative;\n}\n.pulse.pulse-light .pulse-ring {\n  border-color: var(--bs-light);\n}\n.pulse.pulse-primary .pulse-ring {\n  border-color: var(--bs-primary);\n}\n.pulse.pulse-secondary .pulse-ring {\n  border-color: var(--bs-secondary);\n}\n.pulse.pulse-success .pulse-ring {\n  border-color: var(--bs-success);\n}\n.pulse.pulse-info .pulse-ring {\n  border-color: var(--bs-info);\n}\n.pulse.pulse-warning .pulse-ring {\n  border-color: var(--bs-warning);\n}\n.pulse.pulse-danger .pulse-ring {\n  border-color: var(--bs-danger);\n}\n.pulse.pulse-dark .pulse-ring {\n  border-color: var(--bs-dark);\n}\n\n.pulse-ring {\n  display: block;\n  border-radius: 40px;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  animation: animation-pulse 3.5s ease-out;\n  animation-iteration-count: infinite;\n  opacity: 0;\n  border-width: 3px;\n  border-style: solid;\n  border-color: var(--bs-gray-500);\n}\n\n@keyframes animation-pulse {\n  0% {\n    -webkit-transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  60% {\n    -webkit-transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  65% {\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(1.2, 1.2);\n    opacity: 0;\n  }\n}\n[data-kt-app-page-loading=on] *,\n.page-loading * {\n  transition: none !important;\n}\n\n.page-loader {\n  background-color: var(--bs-body-bg);\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  display: none;\n}\n[data-kt-app-page-loading=on] .page-loader, .page-loading .page-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.scrolltop {\n  position: fixed;\n  display: none;\n  cursor: pointer;\n  z-index: 105;\n  justify-content: center;\n  align-items: center;\n  width: 36px;\n  height: 36px;\n  bottom: 40px;\n  right: 20px;\n  background-color: var(--bs-scrolltop-bg-color);\n  box-shadow: var(--bs-scrolltop-box-shadow);\n  opacity: 0;\n  transition: color 0.2s ease;\n  border-radius: 0.65rem;\n}\n.scrolltop .svg-icon {\n  color: var(--bs-scrolltop-icon-color);\n}\n.scrolltop .svg-icon svg {\n  height: 24px;\n  width: 24px;\n}\n.scrolltop > i {\n  font-size: 1.3rem;\n  color: var(--bs-scrolltop-icon-color);\n}\n.scrolltop:hover {\n  background-color: var(--bs-scrolltop-bg-color-hover);\n}\n.scrolltop:hover .svg-icon,\n.scrolltop:hover i {\n  color: var(--bs-scrolltop-icon-color-hover);\n}\n[data-kt-scrolltop=on] .scrolltop {\n  opacity: var(--bs-scrolltop-opacity-on);\n  animation: animation-scrolltop 0.4s ease-out 1;\n  display: flex;\n}\n[data-kt-scrolltop=on] .scrolltop:hover {\n  transition: color 0.2s ease;\n  opacity: var(--bs-scrolltop-opacity-hover);\n}\n\n@media (max-width: 991.98px) {\n  .scrolltop {\n    bottom: 30px;\n    right: 15px;\n    width: 30px;\n    height: 30px;\n  }\n}\n@keyframes animation-scrolltop {\n  from {\n    margin-bottom: -15px;\n  }\n  to {\n    margin-bottom: 0;\n  }\n}\n.svg-icon {\n  line-height: 1;\n  color: var(--bs-text-muted);\n}\n.svg-icon svg {\n  height: 1.15rem;\n  width: 1.15rem;\n}\n.svg-icon.svg-icon-white {\n  color: var(--bs-text-white);\n}\n.svg-icon.svg-icon-primary {\n  color: var(--bs-text-primary);\n}\n.svg-icon.svg-icon-secondary {\n  color: var(--bs-text-secondary);\n}\n.svg-icon.svg-icon-light {\n  color: var(--bs-text-light);\n}\n.svg-icon.svg-icon-success {\n  color: var(--bs-text-success);\n}\n.svg-icon.svg-icon-info {\n  color: var(--bs-text-info);\n}\n.svg-icon.svg-icon-warning {\n  color: var(--bs-text-warning);\n}\n.svg-icon.svg-icon-danger {\n  color: var(--bs-text-danger);\n}\n.svg-icon.svg-icon-dark {\n  color: var(--bs-text-dark);\n}\n.svg-icon.svg-icon-muted {\n  color: var(--bs-text-muted);\n}\n.svg-icon.svg-icon-gray-100 {\n  color: var(--bs-text-gray-100);\n}\n.svg-icon.svg-icon-gray-200 {\n  color: var(--bs-text-gray-200);\n}\n.svg-icon.svg-icon-gray-300 {\n  color: var(--bs-text-gray-300);\n}\n.svg-icon.svg-icon-gray-400 {\n  color: var(--bs-text-gray-400);\n}\n.svg-icon.svg-icon-gray-500 {\n  color: var(--bs-text-gray-500);\n}\n.svg-icon.svg-icon-gray-600 {\n  color: var(--bs-text-gray-600);\n}\n.svg-icon.svg-icon-gray-700 {\n  color: var(--bs-text-gray-700);\n}\n.svg-icon.svg-icon-gray-800 {\n  color: var(--bs-text-gray-800);\n}\n.svg-icon.svg-icon-gray-900 {\n  color: var(--bs-text-gray-900);\n}\n.svg-icon.svg-icon-1 svg {\n  height: 1.75rem !important;\n  width: 1.75rem !important;\n}\n.svg-icon.svg-icon-2 svg {\n  height: 1.5rem !important;\n  width: 1.5rem !important;\n}\n.svg-icon.svg-icon-3 svg {\n  height: 1.35rem !important;\n  width: 1.35rem !important;\n}\n.svg-icon.svg-icon-4 svg {\n  height: 1.25rem !important;\n  width: 1.25rem !important;\n}\n.svg-icon.svg-icon-5 svg {\n  height: 1.15rem !important;\n  width: 1.15rem !important;\n}\n.svg-icon.svg-icon-6 svg {\n  height: 1.075rem !important;\n  width: 1.075rem !important;\n}\n.svg-icon.svg-icon-7 svg {\n  height: 0.95rem !important;\n  width: 0.95rem !important;\n}\n.svg-icon.svg-icon-8 svg {\n  height: 0.85rem !important;\n  width: 0.85rem !important;\n}\n.svg-icon.svg-icon-9 svg {\n  height: 0.75rem !important;\n  width: 0.75rem !important;\n}\n.svg-icon.svg-icon-10 svg {\n  height: 0.5rem !important;\n  width: 0.5rem !important;\n}\n.svg-icon.svg-icon-sm svg {\n  height: 0.95rem !important;\n  width: 0.95rem !important;\n}\n.svg-icon.svg-icon-base svg {\n  height: 1rem !important;\n  width: 1rem !important;\n}\n.svg-icon.svg-icon-lg svg {\n  height: 1.075rem !important;\n  width: 1.075rem !important;\n}\n.svg-icon.svg-icon-xl svg {\n  height: 1.21rem !important;\n  width: 1.21rem !important;\n}\n.svg-icon.svg-icon-fluid svg {\n  height: 100% !important;\n  width: 100% !important;\n}\n.svg-icon.svg-icon-2x svg {\n  height: 2rem !important;\n  width: 2rem !important;\n}\n.svg-icon.svg-icon-2qx svg {\n  height: 2.25rem !important;\n  width: 2.25rem !important;\n}\n.svg-icon.svg-icon-2hx svg {\n  height: 2.5rem !important;\n  width: 2.5rem !important;\n}\n.svg-icon.svg-icon-2tx svg {\n  height: 2.75rem !important;\n  width: 2.75rem !important;\n}\n.svg-icon.svg-icon-3x svg {\n  height: 3rem !important;\n  width: 3rem !important;\n}\n.svg-icon.svg-icon-3qx svg {\n  height: 3.25rem !important;\n  width: 3.25rem !important;\n}\n.svg-icon.svg-icon-3hx svg {\n  height: 3.5rem !important;\n  width: 3.5rem !important;\n}\n.svg-icon.svg-icon-3tx svg {\n  height: 3.75rem !important;\n  width: 3.75rem !important;\n}\n.svg-icon.svg-icon-4x svg {\n  height: 4rem !important;\n  width: 4rem !important;\n}\n.svg-icon.svg-icon-4qx svg {\n  height: 4.25rem !important;\n  width: 4.25rem !important;\n}\n.svg-icon.svg-icon-4hx svg {\n  height: 4.5rem !important;\n  width: 4.5rem !important;\n}\n.svg-icon.svg-icon-4tx svg {\n  height: 4.75rem !important;\n  width: 4.75rem !important;\n}\n.svg-icon.svg-icon-5x svg {\n  height: 5rem !important;\n  width: 5rem !important;\n}\n.svg-icon.svg-icon-5qx svg {\n  height: 5.25rem !important;\n  width: 5.25rem !important;\n}\n.svg-icon.svg-icon-5hx svg {\n  height: 5.5rem !important;\n  width: 5.5rem !important;\n}\n.svg-icon.svg-icon-5tx svg {\n  height: 5.75rem !important;\n  width: 5.75rem !important;\n}\n.svg-icon.svg-icon-6x svg {\n  height: 6rem !important;\n  width: 6rem !important;\n}\n.svg-icon.svg-icon-6qx svg {\n  height: 6.25rem !important;\n  width: 6.25rem !important;\n}\n.svg-icon.svg-icon-6hx svg {\n  height: 6.5rem !important;\n  width: 6.5rem !important;\n}\n.svg-icon.svg-icon-6tx svg {\n  height: 6.75rem !important;\n  width: 6.75rem !important;\n}\n.svg-icon.svg-icon-7x svg {\n  height: 7rem !important;\n  width: 7rem !important;\n}\n.svg-icon.svg-icon-7qx svg {\n  height: 7.25rem !important;\n  width: 7.25rem !important;\n}\n.svg-icon.svg-icon-7hx svg {\n  height: 7.5rem !important;\n  width: 7.5rem !important;\n}\n.svg-icon.svg-icon-7tx svg {\n  height: 7.75rem !important;\n  width: 7.75rem !important;\n}\n@media (min-width: 576px) {\n  .svg-icon.svg-icon-sm-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-sm-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-sm-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-sm-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-sm-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-sm-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-sm svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-sm-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-sm-lg svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-sm-xl svg {\n    height: 1.21rem !important;\n    width: 1.21rem !important;\n  }\n  .svg-icon.svg-icon-sm-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-sm-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-sm-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-sm-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-sm-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-sm-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-sm-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-sm-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .svg-icon.svg-icon-md-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-md-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-md-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-md-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-md-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-md-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-md-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-md-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-md-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-md-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-md-sm svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-md-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-md-lg svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-md-xl svg {\n    height: 1.21rem !important;\n    width: 1.21rem !important;\n  }\n  .svg-icon.svg-icon-md-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-md-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-md-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-md-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-md-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-md-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-md-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-md-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-md-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-md-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-md-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-md-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-md-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-md-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-md-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-md-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-md-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-md-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-md-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-md-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-md-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-md-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-md-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-md-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-md-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .svg-icon.svg-icon-lg-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-lg-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-lg-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-lg-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-lg-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-lg-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-sm svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-lg-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-lg-lg svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-lg-xl svg {\n    height: 1.21rem !important;\n    width: 1.21rem !important;\n  }\n  .svg-icon.svg-icon-lg-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-lg-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-lg-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-lg-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-lg-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-lg-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-lg-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-lg-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .svg-icon.svg-icon-xl-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-xl-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-xl-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xl-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xl-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-xl-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-sm svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xl-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-xl-lg svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xl-xl svg {\n    height: 1.21rem !important;\n    width: 1.21rem !important;\n  }\n  .svg-icon.svg-icon-xl-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-xl-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-xl-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-xl-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-xl-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-xl-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-xl-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-xl-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .svg-icon.svg-icon-xxl-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xxl-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-xxl-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-sm svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xxl-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-xxl-lg svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xxl-xl svg {\n    height: 1.21rem !important;\n    width: 1.21rem !important;\n  }\n  .svg-icon.svg-icon-xxl-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-xxl-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6x svg {\n    height: 6rem !important;\n    width: 6rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6qx svg {\n    height: 6.25rem !important;\n    width: 6.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6hx svg {\n    height: 6.5rem !important;\n    width: 6.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6tx svg {\n    height: 6.75rem !important;\n    width: 6.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7x svg {\n    height: 7rem !important;\n    width: 7rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7qx svg {\n    height: 7.25rem !important;\n    width: 7.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7hx svg {\n    height: 7.5rem !important;\n    width: 7.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7tx svg {\n    height: 7.75rem !important;\n    width: 7.75rem !important;\n  }\n}\n\n.fixed-top {\n  position: fixed;\n  z-index: 101;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n@media (min-width: 576px) {\n  .fixed-top-sm {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 768px) {\n  .fixed-top-md {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 992px) {\n  .fixed-top-lg {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .fixed-top-xl {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 1400px) {\n  .fixed-top-xxl {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n.timeline {\n  --bs-timeline-icon-size: 38px;\n  --bs-timeline-icon-space: 0.35rem;\n}\n.timeline .timeline-item {\n  position: relative;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: flex-start;\n}\n.timeline .timeline-item:last-child .timeline-line {\n  bottom: 100%;\n}\n.timeline .timeline-line {\n  display: block;\n  content: \" \";\n  justify-content: center;\n  position: absolute;\n  z-index: 0;\n  left: 0;\n  top: var(--bs-timeline-icon-size);\n  bottom: 0;\n  transform: translate(50%);\n  border-left-width: 1px;\n  border-left-style: solid;\n  border-left-color: var(--bs-gray-300);\n  width: var(--bs-timeline-icon-size);\n  margin-top: var(--bs-timeline-icon-space);\n  margin-bottom: var(--bs-timeline-icon-space);\n}\n.timeline .timeline-icon {\n  z-index: 1;\n  flex-shrink: 0;\n  margin-right: 1rem;\n  width: var(--bs-timeline-icon-size);\n  height: var(--bs-timeline-icon-size);\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--bs-gray-300);\n  border-radius: 50%;\n}\n.timeline .timeline-content {\n  width: 100%;\n  overflow: auto;\n  margin-bottom: 1.5rem;\n}\n.timeline.timeline-center .timeline-item {\n  align-items: center;\n}\n.timeline.timeline-center .timeline-item:first-child .timeline-line {\n  top: 50%;\n}\n.timeline.timeline-center .timeline-item:last-child .timeline-line {\n  bottom: 50%;\n}\n.timeline.timeline-border-dashed .timeline-line {\n  border-left-style: dashed !important;\n}\n.timeline.timeline-border-dashed .timeline-icon {\n  border-style: dashed !important;\n}\n\n.timeline-label {\n  position: relative;\n}\n.timeline-label:before {\n  content: \"\";\n  position: absolute;\n  left: 51px;\n  width: 3px;\n  top: 0;\n  bottom: 0;\n  background-color: var(--bs-gray-200);\n}\n.timeline-label .timeline-item {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n  margin-bottom: 1.7rem;\n}\n.timeline-label .timeline-item:last-child {\n  margin-bottom: 0;\n}\n.timeline-label .timeline-label {\n  width: 50px;\n  flex-shrink: 0;\n  position: relative;\n  color: var(--bs-gray-800);\n}\n.timeline-label .timeline-badge {\n  flex-shrink: 0;\n  background-color: var(--bs-body-bg);\n  width: 1rem;\n  height: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  position: relative;\n  margin-top: 1px;\n  margin-left: -0.5rem;\n  padding: 3px !important;\n  border: 6px solid var(--bs-body-bg) !important;\n}\n.timeline-label .timeline-content {\n  flex-grow: 1;\n}\n\n.overlay {\n  position: relative;\n}\n.overlay .overlay-layer {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--bs-overlay-bg);\n  transition: all 0.3s ease;\n  opacity: 0;\n}\n.overlay.overlay-show .overlay-layer, .overlay.overlay-block .overlay-layer, .overlay:hover .overlay-layer {\n  transition: all 0.3s ease;\n  opacity: 1;\n}\n.overlay.overlay-block {\n  cursor: wait;\n}\n\n.bullet {\n  display: inline-block;\n  background-color: var(--bs-bullet-bg-color);\n  border-radius: 6px;\n  width: 8px;\n  height: 4px;\n  flex-shrink: 0;\n}\n\n.bullet-dot {\n  width: 4px;\n  height: 4px;\n  border-radius: 100% !important;\n}\n\n.bullet-vertical {\n  width: 4px;\n  height: 8px;\n}\n\n.bullet-line {\n  width: 5px;\n  height: 1px;\n  border-radius: 0;\n}\n\n.drawer {\n  display: flex !important;\n  overflow: auto;\n  z-index: 110;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  background-color: var(--bs-drawer-bg-color);\n  transition: transform 0.3s ease-in-out !important;\n}\n.drawer.drawer-start {\n  left: 0;\n  transform: translateX(-100%);\n}\n.drawer.drawer-end {\n  right: 0;\n  transform: translateX(100%);\n}\n.drawer.drawer-bottom {\n  bottom: 0;\n  top: auto;\n  left: 0;\n  right: 0;\n  transform: translateY(100%);\n}\n.drawer.drawer-top {\n  top: 0;\n  bottom: auto;\n  left: 0;\n  right: 0;\n  transform: translateY(-100%);\n}\n.drawer.drawer-on {\n  transform: none;\n  box-shadow: var(--bs-drawer-box-shadow);\n  transition: transform 0.3s ease-in-out !important;\n}\n\n.drawer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  overflow: hidden;\n  z-index: 109;\n  background-color: var(--bs-drawer-overlay-bg-color);\n  animation: animation-drawer-fade-in 0.3s ease-in-out 1;\n}\n\n[data-kt-drawer=true] {\n  display: none;\n}\n\n@keyframes animation-drawer-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@media (max-width: 991.98px) {\n  body[data-kt-drawer=on] {\n    overflow: hidden;\n  }\n}\n.badge {\n  display: inline-flex;\n  align-items: center;\n}\n.badge.badge-circle, .badge.badge-square {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.75rem;\n  min-width: 1.75rem;\n  padding: 0 0.1rem;\n  line-height: 0;\n}\n.badge.badge-circle {\n  border-radius: 50%;\n  padding: 0;\n  min-width: unset;\n  width: 1.75rem;\n}\n.badge.badge-sm {\n  min-width: 1.5rem;\n  font-size: 0.8rem;\n}\n.badge.badge-sm.badge-square {\n  height: 1.5rem;\n}\n.badge.badge-sm.badge-circle {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.badge.badge-lg {\n  min-width: 2rem;\n  font-size: 1rem;\n}\n.badge.badge-lg.badge-square {\n  height: 2rem;\n}\n.badge.badge-lg.badge-circle {\n  width: 2rem;\n  height: 2rem;\n}\n\n.badge-light {\n  color: var(--bs-light-inverse);\n  background-color: var(--bs-light);\n}\n.badge-light.badge-outline {\n  border: 1px solid var(--bs-light);\n  color: var(--bs-light);\n  background-color: transparent;\n}\n\n.badge-light-light {\n  color: var(--bs-light);\n  background-color: var(--bs-light-light);\n}\n\n.badge-primary {\n  color: var(--bs-primary-inverse);\n  background-color: var(--bs-primary);\n}\n.badge-primary.badge-outline {\n  border: 1px solid var(--bs-primary);\n  color: var(--bs-primary);\n  background-color: transparent;\n}\n\n.badge-light-primary {\n  color: var(--bs-primary);\n  background-color: var(--bs-primary-light);\n}\n\n.badge-secondary {\n  color: var(--bs-secondary-inverse);\n  background-color: var(--bs-secondary);\n}\n.badge-secondary.badge-outline {\n  border: 1px solid var(--bs-secondary);\n  color: var(--bs-secondary);\n  background-color: transparent;\n}\n\n.badge-light-secondary {\n  color: var(--bs-secondary);\n  background-color: var(--bs-secondary-light);\n}\n\n.badge-success {\n  color: var(--bs-success-inverse);\n  background-color: var(--bs-success);\n}\n.badge-success.badge-outline {\n  border: 1px solid var(--bs-success);\n  color: var(--bs-success);\n  background-color: transparent;\n}\n\n.badge-light-success {\n  color: var(--bs-success);\n  background-color: var(--bs-success-light);\n}\n\n.badge-info {\n  color: var(--bs-info-inverse);\n  background-color: var(--bs-info);\n}\n.badge-info.badge-outline {\n  border: 1px solid var(--bs-info);\n  color: var(--bs-info);\n  background-color: transparent;\n}\n\n.badge-light-info {\n  color: var(--bs-info);\n  background-color: var(--bs-info-light);\n}\n\n.badge-warning {\n  color: var(--bs-warning-inverse);\n  background-color: var(--bs-warning);\n}\n.badge-warning.badge-outline {\n  border: 1px solid var(--bs-warning);\n  color: var(--bs-warning);\n  background-color: transparent;\n}\n\n.badge-light-warning {\n  color: var(--bs-warning);\n  background-color: var(--bs-warning-light);\n}\n\n.badge-danger {\n  color: var(--bs-danger-inverse);\n  background-color: var(--bs-danger);\n}\n.badge-danger.badge-outline {\n  border: 1px solid var(--bs-danger);\n  color: var(--bs-danger);\n  background-color: transparent;\n}\n\n.badge-light-danger {\n  color: var(--bs-danger);\n  background-color: var(--bs-danger-light);\n}\n\n.badge-dark {\n  color: var(--bs-dark-inverse);\n  background-color: var(--bs-dark);\n}\n.badge-dark.badge-outline {\n  border: 1px solid var(--bs-dark);\n  color: var(--bs-dark);\n  background-color: transparent;\n}\n\n.badge-light-dark {\n  color: var(--bs-dark);\n  background-color: var(--bs-dark-light);\n}\n\n.indicator-progress {\n  display: none;\n}\n[data-kt-indicator=on] > .indicator-progress {\n  display: inline-block;\n}\n\n[data-kt-indicator=on] > .indicator-label {\n  display: none;\n}\n\n.hover-elevate-up {\n  transition: transform 0.3s ease;\n}\n.hover-elevate-up:hover {\n  transform: translateY(-2.5%);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.hover-elevate-down {\n  transition: transform 0.3s ease;\n}\n.hover-elevate-down:hover {\n  transform: translateY(2.5%);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.hover-scale {\n  transition: transform 0.3s ease;\n}\n.hover-scale:hover {\n  transform: scale(1.1);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.hover-rotate-end {\n  transition: transform 0.3s ease;\n}\n.hover-rotate-end:hover {\n  transform: rotate(4deg);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.hover-rotate-start {\n  transition: transform 0.3s ease;\n}\n.hover-rotate-start:hover {\n  transform: rotate(-4deg);\n  transition: transform 0.3s ease;\n  will-change: transform;\n}\n\n.rotate {\n  display: inline-flex;\n  align-items: center;\n}\n\n.rotate-90 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-90, .show > .rotate-90, .active > .rotate-90 {\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-90, [direction=rtl] .show > .rotate-90, [direction=rtl] .active > .rotate-90 {\n  transform: rotateZ(-90deg);\n}\n\n.rotate-n90 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-n90, .show > .rotate-n90, .active > .rotate-n90 {\n  transform: rotateZ(-90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n90, [direction=rtl] .show > .rotate-n90, [direction=rtl] .active > .rotate-n90 {\n  transform: rotateZ(90deg);\n}\n\n.rotate-180 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-180, .show > .rotate-180, .active > .rotate-180 {\n  transform: rotateZ(180deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-180, [direction=rtl] .show > .rotate-180, [direction=rtl] .active > .rotate-180 {\n  transform: rotateZ(-180deg);\n}\n\n.rotate-n180 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-n180, .show > .rotate-n180, .active > .rotate-n180 {\n  transform: rotateZ(-180deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n180, [direction=rtl] .show > .rotate-n180, [direction=rtl] .active > .rotate-n180 {\n  transform: rotateZ(180deg);\n}\n\n.rotate-270 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-270, .show > .rotate-270, .active > .rotate-270 {\n  transform: rotateZ(270deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-270, [direction=rtl] .show > .rotate-270, [direction=rtl] .active > .rotate-270 {\n  transform: rotateZ(-270deg);\n}\n\n.rotate-n270 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-n270, .show > .rotate-n270, .active > .rotate-n270 {\n  transform: rotateZ(-270deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n270, [direction=rtl] .show > .rotate-n270, [direction=rtl] .active > .rotate-n270 {\n  transform: rotateZ(270deg);\n}\n\n@media (min-width: 992px) {\n  main,\n  span,\n  ol,\n  ul,\n  pre,\n  div {\n    scrollbar-width: thin;\n    scrollbar-color: var(--bs-scrollbar-color) transparent;\n  }\n  main::-webkit-scrollbar,\n  span::-webkit-scrollbar,\n  ol::-webkit-scrollbar,\n  ul::-webkit-scrollbar,\n  pre::-webkit-scrollbar,\n  div::-webkit-scrollbar {\n    width: var(--bs-scrollbar-size);\n    height: var(--bs-scrollbar-size);\n  }\n  main ::-webkit-scrollbar-track,\n  span ::-webkit-scrollbar-track,\n  ol ::-webkit-scrollbar-track,\n  ul ::-webkit-scrollbar-track,\n  pre ::-webkit-scrollbar-track,\n  div ::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n  main ::-webkit-scrollbar-thumb,\n  span ::-webkit-scrollbar-thumb,\n  ol ::-webkit-scrollbar-thumb,\n  ul ::-webkit-scrollbar-thumb,\n  pre ::-webkit-scrollbar-thumb,\n  div ::-webkit-scrollbar-thumb {\n    border-radius: var(--bs-scrollbar-size);\n  }\n  main::-webkit-scrollbar-thumb,\n  span::-webkit-scrollbar-thumb,\n  ol::-webkit-scrollbar-thumb,\n  ul::-webkit-scrollbar-thumb,\n  pre::-webkit-scrollbar-thumb,\n  div::-webkit-scrollbar-thumb {\n    background-color: var(--bs-scrollbar-color);\n  }\n  main::-webkit-scrollbar-corner,\n  span::-webkit-scrollbar-corner,\n  ol::-webkit-scrollbar-corner,\n  ul::-webkit-scrollbar-corner,\n  pre::-webkit-scrollbar-corner,\n  div::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n  main:hover,\n  span:hover,\n  ol:hover,\n  ul:hover,\n  pre:hover,\n  div:hover {\n    scrollbar-color: var(--bs-scrollbar-hover-color) transparent;\n  }\n  main:hover::-webkit-scrollbar-thumb,\n  span:hover::-webkit-scrollbar-thumb,\n  ol:hover::-webkit-scrollbar-thumb,\n  ul:hover::-webkit-scrollbar-thumb,\n  pre:hover::-webkit-scrollbar-thumb,\n  div:hover::-webkit-scrollbar-thumb {\n    background-color: var(--bs-scrollbar-hover-color);\n  }\n  main:hover::-webkit-scrollbar-corner,\n  span:hover::-webkit-scrollbar-corner,\n  ol:hover::-webkit-scrollbar-corner,\n  ul:hover::-webkit-scrollbar-corner,\n  pre:hover::-webkit-scrollbar-corner,\n  div:hover::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n}\n.scroll,\n.hover-scroll,\n.hover-scroll-overlay {\n  overflow: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll,\n  .hover-scroll,\n  .hover-scroll-overlay {\n    overflow: auto;\n  }\n}\n\n.scroll-x,\n.hover-scroll-x,\n.hover-scroll-overlay-x {\n  overflow-x: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll-x,\n  .hover-scroll-x,\n  .hover-scroll-overlay-x {\n    overflow-x: auto;\n  }\n}\n\n.scroll-y,\n.hover-scroll-y,\n.hover-scroll-overlay-y {\n  overflow-y: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll-y,\n  .hover-scroll-y,\n  .hover-scroll-overlay-y {\n    overflow-y: auto;\n  }\n}\n\n.hover-scroll,\n.hover-scroll-overlay,\n.hover-scroll-x,\n.hover-scroll-overlay-x,\n.hover-scroll-y,\n.hover-scroll-overlay-y {\n  scrollbar-color: transparent transparent;\n}\n.hover-scroll::-webkit-scrollbar-thumb,\n.hover-scroll-overlay::-webkit-scrollbar-thumb,\n.hover-scroll-x::-webkit-scrollbar-thumb,\n.hover-scroll-overlay-x::-webkit-scrollbar-thumb,\n.hover-scroll-y::-webkit-scrollbar-thumb,\n.hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n  background-color: transparent;\n}\n.hover-scroll::-webkit-scrollbar-corner,\n.hover-scroll-overlay::-webkit-scrollbar-corner,\n.hover-scroll-x::-webkit-scrollbar-corner,\n.hover-scroll-overlay-x::-webkit-scrollbar-corner,\n.hover-scroll-y::-webkit-scrollbar-corner,\n.hover-scroll-overlay-y::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n.hover-scroll:hover,\n.hover-scroll-overlay:hover,\n.hover-scroll-x:hover,\n.hover-scroll-overlay-x:hover,\n.hover-scroll-y:hover,\n.hover-scroll-overlay-y:hover {\n  scrollbar-color: var(--bs-scrollbar-color) transparent;\n}\n.hover-scroll:hover::-webkit-scrollbar-thumb,\n.hover-scroll-overlay:hover::-webkit-scrollbar-thumb,\n.hover-scroll-x:hover::-webkit-scrollbar-thumb,\n.hover-scroll-overlay-x:hover::-webkit-scrollbar-thumb,\n.hover-scroll-y:hover::-webkit-scrollbar-thumb,\n.hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {\n  background-color: var(--bs-scrollbar-color);\n}\n.hover-scroll:hover::-webkit-scrollbar-corner,\n.hover-scroll-overlay:hover::-webkit-scrollbar-corner,\n.hover-scroll-x:hover::-webkit-scrollbar-corner,\n.hover-scroll-overlay-x:hover::-webkit-scrollbar-corner,\n.hover-scroll-y:hover::-webkit-scrollbar-corner,\n.hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n\n.scroll-ps {\n  padding-left: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-ms {\n  margin-left: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-mb {\n  margin-bottom: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-pe {\n  padding-right: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-me {\n  margin-right: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-px {\n  padding-left: var(--bs-scrollbar-size) !important;\n  padding-right: var(--bs-scrollbar-size) !important;\n}\n\n.scroll-mx {\n  margin-left: var(--bs-scrollbar-size) !important;\n  margin-right: var(--bs-scrollbar-size) !important;\n}\n\n@media (min-width: 576px) {\n  .scroll-sm-ps {\n    padding-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-sm-ms {\n    margin-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-sm-mb {\n    margin-bottom: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-sm-pe {\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-sm-me {\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-sm-px {\n    padding-left: var(--bs-scrollbar-size) !important;\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-sm-mx {\n    margin-left: var(--bs-scrollbar-size) !important;\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n}\n@media (min-width: 768px) {\n  .scroll-md-ps {\n    padding-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-md-ms {\n    margin-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-md-mb {\n    margin-bottom: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-md-pe {\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-md-me {\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-md-px {\n    padding-left: var(--bs-scrollbar-size) !important;\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-md-mx {\n    margin-left: var(--bs-scrollbar-size) !important;\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n}\n@media (min-width: 992px) {\n  .scroll-lg-ps {\n    padding-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-lg-ms {\n    margin-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-lg-mb {\n    margin-bottom: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-lg-pe {\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-lg-me {\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-lg-px {\n    padding-left: var(--bs-scrollbar-size) !important;\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-lg-mx {\n    margin-left: var(--bs-scrollbar-size) !important;\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n}\n@media (min-width: 1200px) {\n  .scroll-xl-ps {\n    padding-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xl-ms {\n    margin-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xl-mb {\n    margin-bottom: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xl-pe {\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xl-me {\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xl-px {\n    padding-left: var(--bs-scrollbar-size) !important;\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xl-mx {\n    margin-left: var(--bs-scrollbar-size) !important;\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n}\n@media (min-width: 1400px) {\n  .scroll-xxl-ps {\n    padding-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xxl-ms {\n    margin-left: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xxl-mb {\n    margin-bottom: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xxl-pe {\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xxl-me {\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xxl-px {\n    padding-left: var(--bs-scrollbar-size) !important;\n    padding-right: var(--bs-scrollbar-size) !important;\n  }\n  .scroll-xxl-mx {\n    margin-left: var(--bs-scrollbar-size) !important;\n    margin-right: var(--bs-scrollbar-size) !important;\n  }\n}\n.rating {\n  display: flex;\n  align-items: center;\n}\n\n.rating-input {\n  position: absolute !important;\n  left: -9999px !important;\n}\n.rating-input[disabled] {\n  display: none;\n}\n\n.rating-label {\n  padding: 0;\n  margin: 0;\n}\n.rating-label > i, .rating-label > .svg-icon {\n  line-height: 1;\n  color: var(--bs-rating-color-default);\n}\n\nlabel.rating-label {\n  cursor: pointer;\n}\n\ndiv.rating-label.checked > i, div.rating-label.checked > .svg-icon,\nlabel.rating-label > i,\nlabel.rating-label > .svg-icon {\n  color: var(--bs-rating-color-active);\n}\n\n.rating-input:checked ~ .rating-label > i, .rating-input:checked ~ .rating-label > .svg-icon {\n  color: var(--bs-rating-color-default);\n}\n\n.rating:hover label.rating-label > i, .rating:hover label.rating-label > .svg-icon {\n  color: var(--bs-rating-color-active);\n}\n\nlabel.rating-label:hover ~ .rating-label {\n  color: var(--bs-rating-color-default);\n}\nlabel.rating-label:hover ~ .rating-label > i, label.rating-label:hover ~ .rating-label > .svg-icon {\n  color: var(--bs-rating-color-default);\n}\n\n.stepper [data-kt-stepper-element=info],\n.stepper [data-kt-stepper-element=content] {\n  display: none;\n}\n.stepper [data-kt-stepper-element=info].current,\n.stepper [data-kt-stepper-element=content].current {\n  display: flex;\n}\n.stepper .stepper-item[data-kt-stepper-action=step] {\n  cursor: pointer;\n}\n.stepper [data-kt-stepper-action=final] {\n  display: none;\n}\n.stepper [data-kt-stepper-action=previous] {\n  display: none;\n}\n.stepper [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.first [data-kt-stepper-action=previous] {\n  display: none;\n}\n.stepper.first [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper.first [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.between [data-kt-stepper-action=previous] {\n  display: inline-block;\n}\n.stepper.between [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper.between [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.last [data-kt-stepper-action=final] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=final].btn-flex {\n  display: flex;\n}\n.stepper.last [data-kt-stepper-action=previous] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=previous].btn-flex {\n  display: flex;\n}\n.stepper.last [data-kt-stepper-action=previous][data-kt-stepper-state=hide-on-last-step] {\n  display: none !important;\n}\n.stepper.last [data-kt-stepper-action=next] {\n  display: none;\n}\n.stepper.last [data-kt-stepper-action=next].btn-flex {\n  display: flex;\n}\n.stepper.last [data-kt-stepper-action=submit] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=submit].btn-flex {\n  display: flex;\n}\n\n.stepper.stepper-pills {\n  --bs-stepper-pills-size: 40px;\n  --bs-stepper-icon-border-radius: 9px;\n  --bs-stepper-icon-check-size: 1rem;\n  --bs-stepper-icon-bg-color: var(--bs-primary-light);\n  --bs-stepper-icon-bg-color-current: var(--bs-primary);\n  --bs-stepper-icon-bg-color-completed: var(--bs-primary-light);\n  --bs-stepper-icon-border: 0;\n  --bs-stepper-icon-border-current: 0;\n  --bs-stepper-icon-border-completed: 0;\n  --bs-stepper-icon-number-color: var(--bs-primary);\n  --bs-stepper-icon-number-color-current: var(--bs-white);\n  --bs-stepper-icon-check-color-completed: var(--bs-primary);\n  --bs-stepper-label-title-opacity: 1;\n  --bs-stepper-label-title-opacity-current: 1;\n  --bs-stepper-label-title-opacity-completed: 1;\n  --bs-stepper-label-title-color: var(--bs-gray-800);\n  --bs-stepper-label-title-color-current: var(--bs-gray-600);\n  --bs-stepper-label-title-color-completed: var(--bs-text-muted);\n  --bs-stepper-label-desc-opacity: 1;\n  --bs-stepper-label-desc-opacity-current: 1;\n  --bs-stepper-label-desc-opacity-completed: 1;\n  --bs-stepper-label-desc-color: var(--bs-text-muted);\n  --bs-stepper-label-desc-color-current: var(--bs-gray-500);\n  --bs-stepper-label-desc-color-completed: var(--bs-gray-500);\n  --bs-stepper-line-border: 1px dashed var(--bs-gray-300);\n}\n.stepper.stepper-pills .stepper-nav {\n  display: flex;\n}\n.stepper.stepper-pills .stepper-item {\n  display: flex;\n  align-items: center;\n  transition: color 0.2s ease;\n}\n.stepper.stepper-pills .stepper-item .stepper-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: color 0.2s ease;\n  width: var(--bs-stepper-pills-size);\n  height: var(--bs-stepper-pills-size);\n  border-radius: var(--bs-stepper-icon-border-radius);\n  background-color: var(--bs-stepper-icon-bg-color);\n  border: var(--bs-stepper-icon-border);\n  margin-right: 1.5rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-icon .stepper-check {\n  display: none;\n  font-size: var(--bs-stepper-icon-check-size);\n}\n.stepper.stepper-pills .stepper-item .stepper-icon .stepper-number {\n  font-weight: 600;\n  color: var(--bs-stepper-icon-number-color);\n  font-size: 1.25rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-label {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.stepper.stepper-pills .stepper-item .stepper-label .stepper-title {\n  color: var(--bs-stepper-label-title-color);\n  opacity: var(--bs-stepper-label-title-opacity);\n  font-weight: 600;\n  font-size: 1.25rem;\n  margin-bottom: 0.3rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-label .stepper-desc {\n  opacity: var(--bs-stepper-label-desc-opacity);\n  color: var(--bs-stepper-label-desc-color);\n}\n.stepper.stepper-pills .stepper-item.current {\n  transition: color 0.2s ease;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon {\n  transition: color 0.2s ease;\n  background-color: var(--bs-stepper-icon-bg-color-current);\n  border: var(--bs-stepper-icon-border-current);\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-check {\n  display: none;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-number {\n  color: var(--bs-stepper-icon-number-color-current);\n  font-size: 1.35rem;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-title {\n  opacity: var(--bs-stepper-label-title-opacity-current);\n  color: var(--bs-stepper-label-title-color-current);\n}\n.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-desc {\n  opacity: var(--bs-stepper-label-desc-opacity-current);\n  color: var(--bs-stepper-label-desc-color-current);\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon, .stepper.stepper-pills .stepper-item.completed .stepper-icon {\n  transition: color 0.2s ease;\n  background-color: var(--bs-stepper-icon-bg-color-completed);\n  border: var(--bs-stepper-icon-border-completed);\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-check, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-check {\n  color: var(--bs-stepper-icon-check-color-completed);\n  display: inline-block;\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-number, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-number {\n  display: none;\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-title, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-title {\n  opacity: var(--bs-stepper-label-title-opacity-completed);\n  color: var(--bs-stepper-label-title-color-completed);\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-desc, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-desc {\n  opacity: var(--bs-stepper-label-desc-opacity-completed);\n  color: var(--bs-stepper-label-desc-color-completed);\n}\n.stepper.stepper-pills.stepper-column .stepper-nav {\n  flex-direction: column;\n  align-items: start;\n}\n.stepper.stepper-pills.stepper-column .stepper-item {\n  flex-direction: column;\n  justify-content: start;\n  align-items: stretch;\n  padding: 0;\n  margin: 0;\n}\n.stepper.stepper-pills.stepper-column .stepper-wrapper {\n  display: flex;\n  align-items: center;\n}\n.stepper.stepper-pills.stepper-column .stepper-icon {\n  z-index: 1;\n}\n.stepper.stepper-pills.stepper-column .stepper-line {\n  display: block;\n  flex-grow: 1;\n  margin-left: calc(var(--bs-stepper-pills-size) / 2);\n  border-left: var(--bs-stepper-line-border);\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n.stepper.stepper-links .stepper-nav {\n  display: flex;\n  margin: 0 auto;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.stepper.stepper-links .stepper-nav .stepper-item {\n  position: relative;\n  flex-shrink: 0;\n  margin: 1rem 1.5rem;\n}\n.stepper.stepper-links .stepper-nav .stepper-item:after {\n  content: \" \";\n  position: absolute;\n  top: 2.3rem;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: transparent;\n  transition: color 0.2s ease;\n}\n.stepper.stepper-links .stepper-nav .stepper-item .stepper-title {\n  color: var(--bs-gray-900);\n  font-weight: 600;\n  font-size: 1.25rem;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current {\n  transition: color 0.2s ease;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current .stepper-title {\n  color: var(--bs-primary);\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current:after {\n  background-color: var(--bs-primary);\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current.mark-completed:last-child .stepper-title, .stepper.stepper-links .stepper-nav .stepper-item.completed .stepper-title {\n  color: var(--bs-gray-500);\n}\n\n.toggle.collapsible:not(.collapsed) .toggle-off, .toggle.active .toggle-off {\n  display: none;\n}\n.toggle.collapsible.collapsed .toggle-on, .toggle:not(.collapsible):not(.active) .toggle-on {\n  display: none;\n}\n\n.xehagon {\n  clip-path: polygon(45% 1.3397459622%, 46.5797985667% 0.6030737921%, 48.2635182233% 0.1519224699%, 50% 0%, 51.7364817767% 0.1519224699%, 53.4202014333% 0.6030737921%, 55% 1.3397459622%, 89.6410161514% 21.3397459622%, 91.0688922482% 22.3395555688%, 92.3014605826% 23.5721239031%, 93.3012701892% 25%, 94.0379423592% 26.5797985667%, 94.4890936815% 28.2635182233%, 94.6410161514% 30%, 94.6410161514% 70%, 94.4890936815% 71.7364817767%, 94.0379423592% 73.4202014333%, 93.3012701892% 75%, 92.3014605826% 76.4278760969%, 91.0688922482% 77.6604444312%, 89.6410161514% 78.6602540378%, 55% 98.6602540378%, 53.4202014333% 99.3969262079%, 51.7364817767% 99.8480775301%, 50% 100%, 48.2635182233% 99.8480775301%, 46.5797985667% 99.3969262079%, 45% 98.6602540378%, 10.3589838486% 78.6602540378%, 8.9311077518% 77.6604444312%, 7.6985394174% 76.4278760969%, 6.6987298108% 75%, 5.9620576408% 73.4202014333%, 5.5109063185% 71.7364817767%, 5.3589838486% 70%, 5.3589838486% 30%, 5.5109063185% 28.2635182233%, 5.9620576408% 26.5797985667%, 6.6987298108% 25%, 7.6985394174% 23.5721239031%, 8.9311077518% 22.3395555688%, 10.3589838486% 21.3397459622%);\n}\n\n.octagon {\n  clip-path: polygon(46.1731656763% 0.7612046749%, 47.411809549% 0.3407417371%, 48.6947380778% 0.0855513863%, 50% 0%, 51.3052619222% 0.0855513863%, 52.588190451% 0.3407417371%, 53.8268343237% 0.7612046749%, 82.1111055711% 12.4769334274%, 83.2842712475% 13.0554747147%, 84.3718855375% 13.7821953496%, 85.3553390593% 14.6446609407%, 86.2178046504% 15.6281144625%, 86.9445252853% 16.7157287525%, 87.5230665726% 17.8888944289%, 99.2387953251% 46.1731656763%, 99.6592582629% 47.411809549%, 99.9144486137% 48.6947380778%, 100% 50%, 99.9144486137% 51.3052619222%, 99.6592582629% 52.588190451%, 99.2387953251% 53.8268343237%, 87.5230665726% 82.1111055711%, 86.9445252853% 83.2842712475%, 86.2178046504% 84.3718855375%, 85.3553390593% 85.3553390593%, 84.3718855375% 86.2178046504%, 83.2842712475% 86.9445252853%, 82.1111055711% 87.5230665726%, 53.8268343237% 99.2387953251%, 52.588190451% 99.6592582629%, 51.3052619222% 99.9144486137%, 50% 100%, 48.6947380778% 99.9144486137%, 47.411809549% 99.6592582629%, 46.1731656763% 99.2387953251%, 17.8888944289% 87.5230665726%, 16.7157287525% 86.9445252853%, 15.6281144625% 86.2178046504%, 14.6446609407% 85.3553390593%, 13.7821953496% 84.3718855375%, 13.0554747147% 83.2842712475%, 12.4769334274% 82.1111055711%, 0.7612046749% 53.8268343237%, 0.3407417371% 52.588190451%, 0.0855513863% 51.3052619222%, 0% 50%, 0.0855513863% 48.6947380778%, 0.3407417371% 47.411809549%, 0.7612046749% 46.1731656763%, 12.4769334274% 17.8888944289%, 13.0554747147% 16.7157287525%, 13.7821953496% 15.6281144625%, 14.6446609407% 14.6446609407%, 15.6281144625% 13.7821953496%, 16.7157287525% 13.0554747147%, 17.8888944289% 12.4769334274%);\n}\n\n.ribbon {\n  position: relative;\n}\n.ribbon .ribbon-label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 10px;\n  position: absolute;\n  z-index: 1;\n  background-color: var(--bs-ribbon-label-bg);\n  box-shadow: var(--bs-ribbon-label-box-shadow);\n  color: var(--bs-primary-inverse);\n  top: 50%;\n  right: 0;\n  transform: translateX(5px) translateY(-50%);\n}\n.ribbon .ribbon-label > .ribbon-inner {\n  z-index: -1;\n  position: absolute;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.ribbon .ribbon-label:after {\n  border-color: var(--bs-ribbon-label-border-color);\n}\n.ribbon-vertical .ribbon-label {\n  padding: 5px 10px;\n  min-width: 36px;\n  min-height: 46px;\n  text-align: center;\n}\n.ribbon.ribbon-top .ribbon-label {\n  top: 0;\n  transform: translateX(-15px) translateY(-4px);\n  border-bottom-right-radius: 0.65rem;\n  border-bottom-left-radius: 0.65rem;\n}\n.ribbon.ribbon-bottom .ribbon-label {\n  border-top-right-radius: 0.65rem;\n  border-top-left-radius: 0.65rem;\n}\n.ribbon.ribbon-start .ribbon-label {\n  top: 50%;\n  left: 0;\n  right: auto;\n  transform: translateX(-5px) translateY(-50%);\n  border-top-right-radius: 0.65rem;\n  border-bottom-right-radius: 0.65rem;\n}\n.ribbon.ribbon-end .ribbon-label {\n  border-top-left-radius: 0.65rem;\n  border-bottom-left-radius: 0.65rem;\n}\n\n.ribbon.ribbon-clip.ribbon-start .ribbon-label {\n  left: -5px;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner {\n  border-top-right-radius: 0.65rem;\n  border-bottom-right-radius: 0.65rem;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:after {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-color: transparent !important;\n  bottom: -10px;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before {\n  border-width: 0 10px 10px 0;\n  border-right-color: var(--bs-ribbon-clip-bg) !important;\n  left: 0;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label {\n  right: -5px;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner {\n  border-top-left-radius: 0.65rem;\n  border-bottom-left-radius: 0.65rem;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:after {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-color: transparent !important;\n  bottom: -10px;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before {\n  border-width: 0 0 10px 10px;\n  border-left-color: var(--bs-ribbon-clip-bg) !important;\n  right: 0;\n}\n\n.ribbon.ribbon-triangle {\n  position: absolute;\n  z-index: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.ribbon.ribbon-triangle.ribbon-top-start {\n  top: 0;\n  left: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent !important;\n  border-left: solid 2rem transparent;\n  border-right: solid 2rem transparent !important;\n  border-top: solid 2rem transparent;\n}\n.ribbon.ribbon-triangle.ribbon-top-end {\n  top: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent !important;\n  border-left: solid 2rem transparent !important;\n  border-right: solid 2rem transparent;\n  border-top: solid 2rem transparent;\n}\n.ribbon.ribbon-triangle.ribbon-bottom-start {\n  bottom: 0;\n  left: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent;\n  border-left: solid 2rem transparent;\n  border-right: solid 2rem transparent !important;\n  border-top: solid 2rem transparent !important;\n}\n.ribbon.ribbon-triangle.ribbon-bottom-end {\n  bottom: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent;\n  border-right: solid 2rem transparent;\n  border-left: solid 2rem transparent !important;\n  border-top: solid 2rem transparent !important;\n}\n\n.blockui {\n  position: relative;\n}\n.blockui .blockui-overlay {\n  transition: all 0.3s ease;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--bs-blockui-overlay-bg);\n}\n.blockui .blockui-overlay .spinner-border {\n  height: 1.35rem;\n  width: 1.35rem;\n}\n.blockui .blockui-message {\n  display: flex;\n  align-items: center;\n  border-radius: 0.65rem;\n  box-shadow: var(--bs-blockui-message-box-shadow);\n  background-color: var(--bs-blockui-message-bg);\n  color: var(--bs-gray-700);\n  font-weight: 600;\n  margin: 0 !important;\n  width: auto;\n  padding: 0.85rem 1.75rem !important;\n}\n.blockui .blockui-message .spinner-border {\n  margin-right: 0.65rem;\n}\n\n[data-bs-theme=dark] .blockui {\n  --bs-blockui-overlay-bg: rgba(255, 255, 255, 0.05);\n  --bs-blockui-message-bg: #26272F;\n  --bs-blockui-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.15);\n}\n\n.explore-btn-toggle {\n  color: var(--bs-gray-600);\n  background-color: #ffffff;\n}\n.explore-btn-toggle:hover, .explore-btn-toggle:focus, .explore-btn-toggle:active {\n  color: #ffffff;\n  background-color: #00B2FF;\n}\n\n.explore-btn-dismiss {\n  border: 0;\n}\n.explore-btn-dismiss:hover i,\n.explore-btn-dismiss:hover .svg-icon {\n  color: #00B2FF;\n}\n\n.explore-btn-primary {\n  border: 0;\n  color: #ffffff;\n  background-color: #00B2FF;\n}\n.explore-btn-primary:hover {\n  color: #ffffff;\n  background-color: #0098DA;\n}\n\n.explore-btn-secondary {\n  border: 0;\n  color: var(--bs-gray-600);\n  background-color: var(--bs-gray-100);\n}\n.explore-btn-secondary:hover {\n  color: var(--bs-gray-800);\n  background-color: var(--bs-gray-200);\n}\n\n.explore-btn-outline {\n  border: 1px dashed var(--bs-gray-300) !important;\n}\n.explore-btn-outline:hover, .explore-btn-outline.active {\n  border: 1px dashed #50CD89 !important;\n  background-color: #E8FFF3;\n}\n\n.explore-link {\n  color: #00B2FF;\n}\n.explore-link:hover {\n  color: #0098DA;\n}\n\n.explore-link-hover:hover {\n  color: #00B2FF !important;\n}\n\n.explore-icon-success {\n  color: #50CD89;\n}\n\n.explore-icon-danger {\n  color: #F1416C;\n}\n\n.explore-label-free {\n  color: #ffffff;\n  background-color: #FFC700;\n}\n\n.explore-label-pro {\n  color: #ffffff;\n  background-color: #50CD89;\n}\n\n.app-engage {\n  position: fixed;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  z-index: 5;\n  padding-right: 12px;\n}\n.app-engage .app-engage-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  box-shadow: var(--bs-engage-btn-box-shadow);\n  border-width: 1px;\n  border-style: solid;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 8px;\n  border-radius: 6px;\n  width: 66px;\n  height: 70px;\n  color: var(--bs-engage-btn-color);\n  border-color: var(--bs-engage-btn-border-color);\n  background-color: var(--bs-engage-btn-bg);\n}\n.app-engage .app-engage-btn i,\n.app-engage .app-engage-btn .svg-icon {\n  color: var(--bs-engage-btn-icon-color);\n}\n.app-engage .app-engage-btn.dropdown-toggle:after {\n  color: var(--bs-engage-btn-icon-color);\n}\n.app-engage .app-engage-btn.hover-dark:hover {\n  color: var(--bs-dark-inverse);\n  border-color: var(--bs-dark);\n  background-color: var(--bs-dark);\n}\n.app-engage .app-engage-btn.hover-dark:hover i,\n.app-engage .app-engage-btn.hover-dark:hover .svg-icon {\n  color: var(--bs-dark-inverse);\n}\n.app-engage .app-engage-btn.hover-primary:hover {\n  color: var(--bs-primary-inverse);\n  border-color: var(--bs-primary);\n  background-color: var(--bs-primary);\n}\n.app-engage .app-engage-btn.hover-primary:hover i,\n.app-engage .app-engage-btn.hover-primary:hover .svg-icon {\n  color: var(--bs-primary-inverse);\n}\n.app-engage .app-engage-btn.hover-success:hover {\n  color: var(--bs-success-inverse);\n  border-color: var(--bs-success);\n  background-color: var(--bs-success);\n}\n.app-engage .app-engage-btn.hover-success:hover i,\n.app-engage .app-engage-btn.hover-success:hover .svg-icon {\n  color: var(--bs-success-inverse);\n}\n.app-engage .app-engage-btn.app-engage-btn-toggle-off {\n  width: 35px;\n  height: 35px;\n}\n.app-engage .app-engage-btn.app-engage-btn-toggle-on {\n  width: 35px;\n  height: 35px;\n  display: none;\n}\n.app-engage.app-engage-hide .app-engage-btn {\n  visibility: hidden;\n}\n.app-engage.app-engage-hide .app-engage-btn.app-engage-btn-toggle-off {\n  display: none;\n}\n.app-engage.app-engage-hide .app-engage-btn.app-engage-btn-toggle-on {\n  visibility: visible;\n  display: flex;\n}\n\n.engage-btn {\n  display: flex;\n  align-items: center;\n  height: 35px !important;\n  color: var(--bs-engage-btn-color);\n  border-color: var(--bs-engage-btn-bg);\n  background-color: var(--bs-engage-btn-bg);\n}\n.engage-btn i,\n.engage-btn .svg-icon {\n  color: var(--bs-engage-btn-color);\n}\n.engage-btn.dropdown-toggle:after {\n  color: var(--bs-engage-btn-color);\n}\n.btn-check:checked + .engage-btn, .btn-check:active + .engage-btn, .engage-btn:focus:not(.btn-active), .engage-btn:hover:not(.btn-active), .engage-btn:active:not(.btn-active), .engage-btn.active, .engage-btn.show, .show > .engage-btn {\n  color: var(--bs-engage-btn-color-active);\n  border-color: var(--bs-engage-btn-bg);\n  background-color: var(--bs-engage-btn-bg) !important;\n}\n.btn-check:checked + .engage-btn i,\n.btn-check:checked + .engage-btn .svg-icon, .btn-check:active + .engage-btn i,\n.btn-check:active + .engage-btn .svg-icon, .engage-btn:focus:not(.btn-active) i,\n.engage-btn:focus:not(.btn-active) .svg-icon, .engage-btn:hover:not(.btn-active) i,\n.engage-btn:hover:not(.btn-active) .svg-icon, .engage-btn:active:not(.btn-active) i,\n.engage-btn:active:not(.btn-active) .svg-icon, .engage-btn.active i,\n.engage-btn.active .svg-icon, .engage-btn.show i,\n.engage-btn.show .svg-icon, .show > .engage-btn i,\n.show > .engage-btn .svg-icon {\n  color: var(--bs-engage-btn-color-active);\n}\n.btn-check:checked + .engage-btn.dropdown-toggle:after, .btn-check:active + .engage-btn.dropdown-toggle:after, .engage-btn:focus:not(.btn-active).dropdown-toggle:after, .engage-btn:hover:not(.btn-active).dropdown-toggle:after, .engage-btn:active:not(.btn-active).dropdown-toggle:after, .engage-btn.active.dropdown-toggle:after, .engage-btn.show.dropdown-toggle:after, .show > .engage-btn.dropdown-toggle:after {\n  color: var(--bs-engage-btn-color-active);\n}\n\n.cookiealert {\n  background: inherit;\n  color: inherit;\n}\n\n@media print {\n  .print-content-only {\n    padding: 0 !important;\n    background: none !important;\n  }\n  .print-content-only .wrapper,\n  .print-content-only .page,\n  .print-content-only .page-title .content,\n  .print-content-only .container,\n  .print-content-only .container-xxl,\n  .print-content-only .container-fluid,\n  .print-content-only .container-sm,\n  .print-content-only .container-md,\n  .print-content-only .container-lg,\n  .print-content-only .container-xl {\n    background: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  .print-content-only .aside,\n  .print-content-only .sidebar,\n  .print-content-only .scrolltop,\n  .print-content-only .header,\n  .print-content-only .footer,\n  .print-content-only .toolbar,\n  .print-content-only .drawer,\n  .print-content-only .btn {\n    display: none !important;\n  }\n}\n.bg-white {\n  --bs-bg-rgb-color: var(--bs-white-bg-rgb);\n  background-color: #ffffff !important;\n}\n\n.bg-black {\n  --bs-bg-rgb-color: var(--bs-black-bg-rgb);\n  background-color: #000000 !important;\n}\n\n.bg-body {\n  --bs-bg-rgb-color: var(--bs-body-bg-rgb);\n  background-color: var(--bs-body-bg) !important;\n}\n\n.bg-hover-body {\n  cursor: pointer;\n}\n.bg-hover-body:hover {\n  background-color: var(--bs-body-bg) !important;\n}\n\n.bg-active-body.active {\n  background-color: var(--bs-body-bg) !important;\n}\n\n.bg-state-body {\n  cursor: pointer;\n}\n.bg-state-body.active, .bg-state-body:hover {\n  background-color: var(--bs-body-bg) !important;\n}\n\n.bg-hover-white {\n  cursor: pointer;\n}\n.bg-hover-white:hover {\n  --bs-bg-rgb-color: var(--bs-white-bg-rgb);\n  background-color: #ffffff !important;\n}\n\n.bg-active-white.active {\n  --bs-bg-rgb-color: var(--bs-white-bg-rgb);\n  background-color: #ffffff !important;\n}\n\n.bg-state-white {\n  cursor: pointer;\n}\n.bg-state-white.active, .bg-state-white:hover {\n  --bs-bg-rgb-color: var(--bs-white-bg-rgb);\n  background-color: #ffffff !important;\n}\n\n.bg-light-light {\n  background-color: var(--bs-light-light) !important;\n}\n\n.bg-light {\n  --bs-bg-rgb-color: var(--bs-light-rgb);\n  background-color: var(--bs-light) !important;\n}\n\n.bg-light-active {\n  --bs-bg-rgb-color: var(--bs-light-active-rgb);\n  background-color: var(--bs-light-active) !important;\n}\n\n.bg-hover-light-light {\n  cursor: pointer;\n}\n.bg-hover-light-light:hover {\n  background-color: var(--bs-light-light) !important;\n}\n\n.bg-state-light-light {\n  cursor: pointer;\n}\n.bg-state-light-light.active, .bg-state-light-light:hover {\n  background-color: var(--bs-light-light) !important;\n}\n\n.bg-hover-light {\n  cursor: pointer;\n}\n.bg-hover-light:hover {\n  background-color: var(--bs-light) !important;\n}\n\n.bg-active-light.active {\n  background-color: var(--bs-light) !important;\n}\n\n.bg-state-light {\n  cursor: pointer;\n}\n.bg-state-light.active, .bg-state-light:hover {\n  background-color: var(--bs-light) !important;\n}\n\n.bg-light-primary {\n  background-color: var(--bs-primary-light) !important;\n}\n\n.bg-primary {\n  --bs-bg-rgb-color: var(--bs-primary-rgb);\n  background-color: var(--bs-primary) !important;\n}\n\n.bg-primary-active {\n  --bs-bg-rgb-color: var(--bs-primary-active-rgb);\n  background-color: var(--bs-primary-active) !important;\n}\n\n.bg-hover-light-primary {\n  cursor: pointer;\n}\n.bg-hover-light-primary:hover {\n  background-color: var(--bs-primary-light) !important;\n}\n\n.bg-state-light-primary {\n  cursor: pointer;\n}\n.bg-state-light-primary.active, .bg-state-light-primary:hover {\n  background-color: var(--bs-primary-light) !important;\n}\n\n.bg-hover-primary {\n  cursor: pointer;\n}\n.bg-hover-primary:hover {\n  background-color: var(--bs-primary) !important;\n}\n\n.bg-active-primary.active {\n  background-color: var(--bs-primary) !important;\n}\n\n.bg-state-primary {\n  cursor: pointer;\n}\n.bg-state-primary.active, .bg-state-primary:hover {\n  background-color: var(--bs-primary) !important;\n}\n\n.bg-light-secondary {\n  background-color: var(--bs-secondary-light) !important;\n}\n\n.bg-secondary {\n  --bs-bg-rgb-color: var(--bs-secondary-rgb);\n  background-color: var(--bs-secondary) !important;\n}\n\n.bg-secondary-active {\n  --bs-bg-rgb-color: var(--bs-secondary-active-rgb);\n  background-color: var(--bs-secondary-active) !important;\n}\n\n.bg-hover-light-secondary {\n  cursor: pointer;\n}\n.bg-hover-light-secondary:hover {\n  background-color: var(--bs-secondary-light) !important;\n}\n\n.bg-state-light-secondary {\n  cursor: pointer;\n}\n.bg-state-light-secondary.active, .bg-state-light-secondary:hover {\n  background-color: var(--bs-secondary-light) !important;\n}\n\n.bg-hover-secondary {\n  cursor: pointer;\n}\n.bg-hover-secondary:hover {\n  background-color: var(--bs-secondary) !important;\n}\n\n.bg-active-secondary.active {\n  background-color: var(--bs-secondary) !important;\n}\n\n.bg-state-secondary {\n  cursor: pointer;\n}\n.bg-state-secondary.active, .bg-state-secondary:hover {\n  background-color: var(--bs-secondary) !important;\n}\n\n.bg-light-success {\n  background-color: var(--bs-success-light) !important;\n}\n\n.bg-success {\n  --bs-bg-rgb-color: var(--bs-success-rgb);\n  background-color: var(--bs-success) !important;\n}\n\n.bg-success-active {\n  --bs-bg-rgb-color: var(--bs-success-active-rgb);\n  background-color: var(--bs-success-active) !important;\n}\n\n.bg-hover-light-success {\n  cursor: pointer;\n}\n.bg-hover-light-success:hover {\n  background-color: var(--bs-success-light) !important;\n}\n\n.bg-state-light-success {\n  cursor: pointer;\n}\n.bg-state-light-success.active, .bg-state-light-success:hover {\n  background-color: var(--bs-success-light) !important;\n}\n\n.bg-hover-success {\n  cursor: pointer;\n}\n.bg-hover-success:hover {\n  background-color: var(--bs-success) !important;\n}\n\n.bg-active-success.active {\n  background-color: var(--bs-success) !important;\n}\n\n.bg-state-success {\n  cursor: pointer;\n}\n.bg-state-success.active, .bg-state-success:hover {\n  background-color: var(--bs-success) !important;\n}\n\n.bg-light-info {\n  background-color: var(--bs-info-light) !important;\n}\n\n.bg-info {\n  --bs-bg-rgb-color: var(--bs-info-rgb);\n  background-color: var(--bs-info) !important;\n}\n\n.bg-info-active {\n  --bs-bg-rgb-color: var(--bs-info-active-rgb);\n  background-color: var(--bs-info-active) !important;\n}\n\n.bg-hover-light-info {\n  cursor: pointer;\n}\n.bg-hover-light-info:hover {\n  background-color: var(--bs-info-light) !important;\n}\n\n.bg-state-light-info {\n  cursor: pointer;\n}\n.bg-state-light-info.active, .bg-state-light-info:hover {\n  background-color: var(--bs-info-light) !important;\n}\n\n.bg-hover-info {\n  cursor: pointer;\n}\n.bg-hover-info:hover {\n  background-color: var(--bs-info) !important;\n}\n\n.bg-active-info.active {\n  background-color: var(--bs-info) !important;\n}\n\n.bg-state-info {\n  cursor: pointer;\n}\n.bg-state-info.active, .bg-state-info:hover {\n  background-color: var(--bs-info) !important;\n}\n\n.bg-light-warning {\n  background-color: var(--bs-warning-light) !important;\n}\n\n.bg-warning {\n  --bs-bg-rgb-color: var(--bs-warning-rgb);\n  background-color: var(--bs-warning) !important;\n}\n\n.bg-warning-active {\n  --bs-bg-rgb-color: var(--bs-warning-active-rgb);\n  background-color: var(--bs-warning-active) !important;\n}\n\n.bg-hover-light-warning {\n  cursor: pointer;\n}\n.bg-hover-light-warning:hover {\n  background-color: var(--bs-warning-light) !important;\n}\n\n.bg-state-light-warning {\n  cursor: pointer;\n}\n.bg-state-light-warning.active, .bg-state-light-warning:hover {\n  background-color: var(--bs-warning-light) !important;\n}\n\n.bg-hover-warning {\n  cursor: pointer;\n}\n.bg-hover-warning:hover {\n  background-color: var(--bs-warning) !important;\n}\n\n.bg-active-warning.active {\n  background-color: var(--bs-warning) !important;\n}\n\n.bg-state-warning {\n  cursor: pointer;\n}\n.bg-state-warning.active, .bg-state-warning:hover {\n  background-color: var(--bs-warning) !important;\n}\n\n.bg-light-danger {\n  background-color: var(--bs-danger-light) !important;\n}\n\n.bg-danger {\n  --bs-bg-rgb-color: var(--bs-danger-rgb);\n  background-color: var(--bs-danger) !important;\n}\n\n.bg-danger-active {\n  --bs-bg-rgb-color: var(--bs-danger-active-rgb);\n  background-color: var(--bs-danger-active) !important;\n}\n\n.bg-hover-light-danger {\n  cursor: pointer;\n}\n.bg-hover-light-danger:hover {\n  background-color: var(--bs-danger-light) !important;\n}\n\n.bg-state-light-danger {\n  cursor: pointer;\n}\n.bg-state-light-danger.active, .bg-state-light-danger:hover {\n  background-color: var(--bs-danger-light) !important;\n}\n\n.bg-hover-danger {\n  cursor: pointer;\n}\n.bg-hover-danger:hover {\n  background-color: var(--bs-danger) !important;\n}\n\n.bg-active-danger.active {\n  background-color: var(--bs-danger) !important;\n}\n\n.bg-state-danger {\n  cursor: pointer;\n}\n.bg-state-danger.active, .bg-state-danger:hover {\n  background-color: var(--bs-danger) !important;\n}\n\n.bg-light-dark {\n  background-color: var(--bs-dark-light) !important;\n}\n\n.bg-dark {\n  --bs-bg-rgb-color: var(--bs-dark-rgb);\n  background-color: var(--bs-dark) !important;\n}\n\n.bg-dark-active {\n  --bs-bg-rgb-color: var(--bs-dark-active-rgb);\n  background-color: var(--bs-dark-active) !important;\n}\n\n.bg-hover-light-dark {\n  cursor: pointer;\n}\n.bg-hover-light-dark:hover {\n  background-color: var(--bs-dark-light) !important;\n}\n\n.bg-state-light-dark {\n  cursor: pointer;\n}\n.bg-state-light-dark.active, .bg-state-light-dark:hover {\n  background-color: var(--bs-dark-light) !important;\n}\n\n.bg-hover-dark {\n  cursor: pointer;\n}\n.bg-hover-dark:hover {\n  background-color: var(--bs-dark) !important;\n}\n\n.bg-active-dark.active {\n  background-color: var(--bs-dark) !important;\n}\n\n.bg-state-dark {\n  cursor: pointer;\n}\n.bg-state-dark.active, .bg-state-dark:hover {\n  background-color: var(--bs-dark) !important;\n}\n\n.bg-gray-100 {\n  --bs-bg-rgb-color: var(--bs-gray-100-rgb);\n  background-color: var(--bs-gray-100);\n}\n\n.bg-hover-gray-100:hover {\n  --bs-bg-rgb-color: var(--bs-gray-100-rgb);\n  background-color: var(--bs-gray-100);\n}\n\n.bg-gray-100i {\n  --bs-bg-rgb-color: var(--bs-gray-100-rgb);\n  background-color: var(--bs-gray-100) !important;\n}\n\n.bg-gray-200 {\n  --bs-bg-rgb-color: var(--bs-gray-200-rgb);\n  background-color: var(--bs-gray-200);\n}\n\n.bg-hover-gray-200:hover {\n  --bs-bg-rgb-color: var(--bs-gray-200-rgb);\n  background-color: var(--bs-gray-200);\n}\n\n.bg-gray-200i {\n  --bs-bg-rgb-color: var(--bs-gray-200-rgb);\n  background-color: var(--bs-gray-200) !important;\n}\n\n.bg-gray-300 {\n  --bs-bg-rgb-color: var(--bs-gray-300-rgb);\n  background-color: var(--bs-gray-300);\n}\n\n.bg-hover-gray-300:hover {\n  --bs-bg-rgb-color: var(--bs-gray-300-rgb);\n  background-color: var(--bs-gray-300);\n}\n\n.bg-gray-300i {\n  --bs-bg-rgb-color: var(--bs-gray-300-rgb);\n  background-color: var(--bs-gray-300) !important;\n}\n\n.bg-gray-400 {\n  --bs-bg-rgb-color: var(--bs-gray-400-rgb);\n  background-color: var(--bs-gray-400);\n}\n\n.bg-hover-gray-400:hover {\n  --bs-bg-rgb-color: var(--bs-gray-400-rgb);\n  background-color: var(--bs-gray-400);\n}\n\n.bg-gray-400i {\n  --bs-bg-rgb-color: var(--bs-gray-400-rgb);\n  background-color: var(--bs-gray-400) !important;\n}\n\n.bg-gray-500 {\n  --bs-bg-rgb-color: var(--bs-gray-500-rgb);\n  background-color: var(--bs-gray-500);\n}\n\n.bg-hover-gray-500:hover {\n  --bs-bg-rgb-color: var(--bs-gray-500-rgb);\n  background-color: var(--bs-gray-500);\n}\n\n.bg-gray-500i {\n  --bs-bg-rgb-color: var(--bs-gray-500-rgb);\n  background-color: var(--bs-gray-500) !important;\n}\n\n.bg-gray-600 {\n  --bs-bg-rgb-color: var(--bs-gray-600-rgb);\n  background-color: var(--bs-gray-600);\n}\n\n.bg-hover-gray-600:hover {\n  --bs-bg-rgb-color: var(--bs-gray-600-rgb);\n  background-color: var(--bs-gray-600);\n}\n\n.bg-gray-600i {\n  --bs-bg-rgb-color: var(--bs-gray-600-rgb);\n  background-color: var(--bs-gray-600) !important;\n}\n\n.bg-gray-700 {\n  --bs-bg-rgb-color: var(--bs-gray-700-rgb);\n  background-color: var(--bs-gray-700);\n}\n\n.bg-hover-gray-700:hover {\n  --bs-bg-rgb-color: var(--bs-gray-700-rgb);\n  background-color: var(--bs-gray-700);\n}\n\n.bg-gray-700i {\n  --bs-bg-rgb-color: var(--bs-gray-700-rgb);\n  background-color: var(--bs-gray-700) !important;\n}\n\n.bg-gray-800 {\n  --bs-bg-rgb-color: var(--bs-gray-800-rgb);\n  background-color: var(--bs-gray-800);\n}\n\n.bg-hover-gray-800:hover {\n  --bs-bg-rgb-color: var(--bs-gray-800-rgb);\n  background-color: var(--bs-gray-800);\n}\n\n.bg-gray-800i {\n  --bs-bg-rgb-color: var(--bs-gray-800-rgb);\n  background-color: var(--bs-gray-800) !important;\n}\n\n.bg-gray-900 {\n  --bs-bg-rgb-color: var(--bs-gray-900-rgb);\n  background-color: var(--bs-gray-900);\n}\n\n.bg-hover-gray-900:hover {\n  --bs-bg-rgb-color: var(--bs-gray-900-rgb);\n  background-color: var(--bs-gray-900);\n}\n\n.bg-gray-900i {\n  --bs-bg-rgb-color: var(--bs-gray-900-rgb);\n  background-color: var(--bs-gray-900) !important;\n}\n\n.bg-opacity-0 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;\n}\n\n.bg-hover-opacity-0:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;\n}\n\n.bg-active-opacity-0.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;\n}\n\n.bg-state-opacity-0 .active, .bg-state-opacity-0:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0) !important;\n}\n\n.bg-opacity-5 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;\n}\n\n.bg-hover-opacity-5:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;\n}\n\n.bg-active-opacity-5.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;\n}\n\n.bg-state-opacity-5 .active, .bg-state-opacity-5:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.05) !important;\n}\n\n.bg-opacity-10 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;\n}\n\n.bg-hover-opacity-10:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;\n}\n\n.bg-active-opacity-10.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;\n}\n\n.bg-state-opacity-10 .active, .bg-state-opacity-10:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.1) !important;\n}\n\n.bg-opacity-15 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;\n}\n\n.bg-hover-opacity-15:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;\n}\n\n.bg-active-opacity-15.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;\n}\n\n.bg-state-opacity-15 .active, .bg-state-opacity-15:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.15) !important;\n}\n\n.bg-opacity-20 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;\n}\n\n.bg-hover-opacity-20:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;\n}\n\n.bg-active-opacity-20.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;\n}\n\n.bg-state-opacity-20 .active, .bg-state-opacity-20:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.2) !important;\n}\n\n.bg-opacity-25 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;\n}\n\n.bg-hover-opacity-25:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;\n}\n\n.bg-active-opacity-25.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;\n}\n\n.bg-state-opacity-25 .active, .bg-state-opacity-25:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.25) !important;\n}\n\n.bg-opacity-50 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;\n}\n\n.bg-hover-opacity-50:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;\n}\n\n.bg-active-opacity-50.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;\n}\n\n.bg-state-opacity-50 .active, .bg-state-opacity-50:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.5) !important;\n}\n\n.bg-opacity-75 {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;\n}\n\n.bg-hover-opacity-75:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;\n}\n\n.bg-active-opacity-75.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;\n}\n\n.bg-state-opacity-75 .active, .bg-state-opacity-75:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 0.75) !important;\n}\n\n.bg-opacity-100 {\n  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;\n}\n\n.bg-hover-opacity-100:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;\n}\n\n.bg-active-opacity-100.active {\n  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;\n}\n\n.bg-state-opacity-100 .active, .bg-state-opacity-100:hover {\n  background-color: rgba(var(--bs-bg-rgb-color), 1) !important;\n}\n\n.bgi-no-repeat {\n  background-repeat: no-repeat;\n}\n\n.bgi-position-y-top {\n  background-position-y: top;\n}\n\n.bgi-position-y-bottom {\n  background-position-y: bottom;\n}\n\n.bgi-position-y-center {\n  background-position-y: center;\n}\n\n.bgi-position-x-start {\n  background-position-x: left;\n}\n\n.bgi-position-x-end {\n  background-position-x: right;\n}\n\n.bgi-position-x-center {\n  background-position-x: center;\n}\n\n.bgi-position-top {\n  background-position: 0 top;\n}\n\n.bgi-position-bottom {\n  background-position: 0 bottom;\n}\n\n.bgi-position-center {\n  background-position: center;\n}\n\n.bgi-size-auto {\n  background-size: auto;\n}\n\n.bgi-size-cover {\n  background-size: cover;\n}\n\n.bgi-size-contain {\n  background-size: contain;\n}\n\n.bgi-attachment-fixed {\n  background-attachment: fixed;\n}\n\n.bgi-attachment-scroll {\n  background-attachment: scroll;\n}\n\n@media (min-width: 576px) {\n  .bgi-size-sm-auto {\n    background-size: auto;\n  }\n  .bgi-size-sm-cover {\n    background-size: cover;\n  }\n  .bgi-size-sm-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-sm-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-sm-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 768px) {\n  .bgi-size-md-auto {\n    background-size: auto;\n  }\n  .bgi-size-md-cover {\n    background-size: cover;\n  }\n  .bgi-size-md-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-md-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-md-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 992px) {\n  .bgi-size-lg-auto {\n    background-size: auto;\n  }\n  .bgi-size-lg-cover {\n    background-size: cover;\n  }\n  .bgi-size-lg-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-lg-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-lg-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 1200px) {\n  .bgi-size-xl-auto {\n    background-size: auto;\n  }\n  .bgi-size-xl-cover {\n    background-size: cover;\n  }\n  .bgi-size-xl-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-xl-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-xl-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 1400px) {\n  .bgi-size-xxl-auto {\n    background-size: auto;\n  }\n  .bgi-size-xxl-cover {\n    background-size: cover;\n  }\n  .bgi-size-xxl-contain {\n    background-size: contain;\n  }\n  .bgi-attachment-xxl-fixed {\n    background-attachment: fixed;\n  }\n  .bgi-attachment-xxl-scroll {\n    background-attachment: scroll;\n  }\n}\n.border-active:not(.active):not(:active):not(:hover):not(:focus) {\n  border-color: transparent !important;\n}\n\n.border-hover:not(:hover):not(:focus):not(.active):not(:active) {\n  cursor: pointer;\n  border-color: transparent !important;\n}\n\n.border-gray-100 {\n  border-color: var(--bs-gray-100) !important;\n}\n\n.border-gray-200 {\n  border-color: var(--bs-gray-200) !important;\n}\n\n.border-gray-300 {\n  border-color: var(--bs-gray-300) !important;\n}\n\n.border-gray-400 {\n  border-color: var(--bs-gray-400) !important;\n}\n\n.border-gray-500 {\n  border-color: var(--bs-gray-500) !important;\n}\n\n.border-gray-600 {\n  border-color: var(--bs-gray-600) !important;\n}\n\n.border-gray-700 {\n  border-color: var(--bs-gray-700) !important;\n}\n\n.border-gray-800 {\n  border-color: var(--bs-gray-800) !important;\n}\n\n.border-gray-900 {\n  border-color: var(--bs-gray-900) !important;\n}\n\n.border-hover-light:hover {\n  border-color: var(--bs-light) !important;\n}\n\n.border-active-light.active {\n  border-color: var(--bs-light) !important;\n}\n\n.border-hover-primary:hover {\n  border-color: var(--bs-primary) !important;\n}\n\n.border-active-primary.active {\n  border-color: var(--bs-primary) !important;\n}\n\n.border-hover-secondary:hover {\n  border-color: var(--bs-secondary) !important;\n}\n\n.border-active-secondary.active {\n  border-color: var(--bs-secondary) !important;\n}\n\n.border-hover-success:hover {\n  border-color: var(--bs-success) !important;\n}\n\n.border-active-success.active {\n  border-color: var(--bs-success) !important;\n}\n\n.border-hover-info:hover {\n  border-color: var(--bs-info) !important;\n}\n\n.border-active-info.active {\n  border-color: var(--bs-info) !important;\n}\n\n.border-hover-warning:hover {\n  border-color: var(--bs-warning) !important;\n}\n\n.border-active-warning.active {\n  border-color: var(--bs-warning) !important;\n}\n\n.border-hover-danger:hover {\n  border-color: var(--bs-danger) !important;\n}\n\n.border-active-danger.active {\n  border-color: var(--bs-danger) !important;\n}\n\n.border-hover-dark:hover {\n  border-color: var(--bs-dark) !important;\n}\n\n.border-active-dark.active {\n  border-color: var(--bs-dark) !important;\n}\n\n.border-hover-transparent:hover {\n  border-color: transparent !important;\n}\n\n.border-dashed {\n  border-style: dashed !important;\n  border-color: var(--bs-border-dashed-color);\n}\n\n.border-top-dashed {\n  border-top-style: dashed !important;\n}\n\n.border-bottom-dashed {\n  border-bottom-style: dashed !important;\n}\n\n.border-start-dashed {\n  border-left-style: dashed !important;\n}\n\n.border-end-dashed {\n  border-right-style: dashed !important;\n}\n\n.border-dotted {\n  border-style: dotted !important;\n}\n\n.border-top-dotted {\n  border-top-style: dotted !important;\n}\n\n.border-bottom-dotted {\n  border-bottom-style: dotted !important;\n}\n\n.border-start-dotted {\n  border-left-style: dotted !important;\n}\n\n.border-end-dotted {\n  border-right-style: dotted !important;\n}\n\n.border-transparent {\n  border-color: transparent !important;\n}\n\n.border-body {\n  border-color: var(--bs-body-bg) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-start-0 {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.flex-root {\n  flex: 1;\n}\n\n.flex-column-auto {\n  flex: none;\n}\n\n.flex-column-fluid {\n  flex: 1 0 auto;\n}\n\n.flex-row-auto {\n  flex: 0 0 auto;\n}\n\n.flex-row-fluid {\n  flex: 1 auto;\n  min-width: 0;\n}\n\n.flex-center {\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-start {\n  justify-content: start;\n  align-items: start;\n}\n\n.flex-end {\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n.flex-stack {\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-root {\n    flex: 1;\n  }\n  .flex-sm-column-auto {\n    flex: none;\n  }\n  .flex-sm-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-sm-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-sm-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-sm-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-sm-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-sm-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-sm-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-root {\n    flex: 1;\n  }\n  .flex-md-column-auto {\n    flex: none;\n  }\n  .flex-md-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-md-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-md-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-md-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-md-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-md-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-md-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-root {\n    flex: 1;\n  }\n  .flex-lg-column-auto {\n    flex: none;\n  }\n  .flex-lg-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-lg-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-lg-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-lg-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-lg-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-lg-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-lg-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-root {\n    flex: 1;\n  }\n  .flex-xl-column-auto {\n    flex: none;\n  }\n  .flex-xl-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-xl-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-xl-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-xl-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-xl-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-xl-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-xl-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 1400px) {\n  .flex-xxl-root {\n    flex: 1;\n  }\n  .flex-xxl-column-auto {\n    flex: none;\n  }\n  .flex-xxl-column-fluid {\n    flex: 1 0 auto;\n  }\n  .flex-xxl-row-auto {\n    flex: 0 0 auto;\n  }\n  .flex-xxl-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n  .flex-xxl-center {\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-xxl-start {\n    justify-content: start;\n    align-items: start;\n  }\n  .flex-xxl-end {\n    justify-content: flex-end;\n    align-items: flex-end;\n  }\n  .flex-xxl-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n.flex-equal {\n  flex-grow: 1;\n  flex-basis: 0;\n  flex-shrink: 0;\n}\n\n.shadow-xs {\n  box-shadow: var(--bs-box-shadow-xs);\n}\n\n.shadow-sm {\n  box-shadow: var(--bs-box-shadow-sm);\n}\n\n.shadow {\n  box-shadow: var(--bs-box-shadow);\n}\n\n.shadow-lg {\n  box-shadow: var(--bs-box-shadow-lg);\n}\n\n.text-white {\n  color: var(--bs-text-white) !important;\n}\n\n.text-hover-white {\n  transition: color 0.2s ease;\n}\n.text-hover-white i {\n  transition: color 0.2s ease;\n}\n.text-hover-white:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.text-hover-white:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.text-hover-white:hover .svg-icon {\n  color: var(--bs-text-white) !important;\n}\n\n.text-active-white {\n  transition: color 0.2s ease;\n}\n.text-active-white i {\n  transition: color 0.2s ease;\n}\n.text-active-white.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.text-active-white.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.text-active-white.active .svg-icon {\n  color: var(--bs-text-white) !important;\n}\n\n.text-primary {\n  color: var(--bs-text-primary) !important;\n}\n\n.text-inverse-primary {\n  color: var(--bs-primary-inverse) !important;\n}\n\n.text-light-primary {\n  color: var(--bs-primary-light) !important;\n}\n\n.text-hover-primary {\n  transition: color 0.2s ease;\n}\n.text-hover-primary i {\n  transition: color 0.2s ease;\n}\n.text-hover-primary:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.text-hover-primary:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.text-hover-primary:hover .svg-icon {\n  color: var(--bs-text-primary) !important;\n}\n\n.text-active-primary {\n  transition: color 0.2s ease;\n}\n.text-active-primary i {\n  transition: color 0.2s ease;\n}\n.text-active-primary.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.text-active-primary.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.text-active-primary.active .svg-icon {\n  color: var(--bs-text-primary) !important;\n}\n\n.text-secondary {\n  color: var(--bs-text-secondary) !important;\n}\n\n.text-inverse-secondary {\n  color: var(--bs-secondary-inverse) !important;\n}\n\n.text-light-secondary {\n  color: var(--bs-secondary-light) !important;\n}\n\n.text-hover-secondary {\n  transition: color 0.2s ease;\n}\n.text-hover-secondary i {\n  transition: color 0.2s ease;\n}\n.text-hover-secondary:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.text-hover-secondary:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.text-hover-secondary:hover .svg-icon {\n  color: var(--bs-text-secondary) !important;\n}\n\n.text-active-secondary {\n  transition: color 0.2s ease;\n}\n.text-active-secondary i {\n  transition: color 0.2s ease;\n}\n.text-active-secondary.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.text-active-secondary.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.text-active-secondary.active .svg-icon {\n  color: var(--bs-text-secondary) !important;\n}\n\n.text-light {\n  color: var(--bs-text-light) !important;\n}\n\n.text-inverse-light {\n  color: var(--bs-light-inverse) !important;\n}\n\n.text-light-light {\n  color: var(--bs-light-light) !important;\n}\n\n.text-hover-light {\n  transition: color 0.2s ease;\n}\n.text-hover-light i {\n  transition: color 0.2s ease;\n}\n.text-hover-light:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.text-hover-light:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.text-hover-light:hover .svg-icon {\n  color: var(--bs-text-light) !important;\n}\n\n.text-active-light {\n  transition: color 0.2s ease;\n}\n.text-active-light i {\n  transition: color 0.2s ease;\n}\n.text-active-light.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.text-active-light.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.text-active-light.active .svg-icon {\n  color: var(--bs-text-light) !important;\n}\n\n.text-success {\n  color: var(--bs-text-success) !important;\n}\n\n.text-inverse-success {\n  color: var(--bs-success-inverse) !important;\n}\n\n.text-light-success {\n  color: var(--bs-success-light) !important;\n}\n\n.text-hover-success {\n  transition: color 0.2s ease;\n}\n.text-hover-success i {\n  transition: color 0.2s ease;\n}\n.text-hover-success:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.text-hover-success:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.text-hover-success:hover .svg-icon {\n  color: var(--bs-text-success) !important;\n}\n\n.text-active-success {\n  transition: color 0.2s ease;\n}\n.text-active-success i {\n  transition: color 0.2s ease;\n}\n.text-active-success.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.text-active-success.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.text-active-success.active .svg-icon {\n  color: var(--bs-text-success) !important;\n}\n\n.text-info {\n  color: var(--bs-text-info) !important;\n}\n\n.text-inverse-info {\n  color: var(--bs-info-inverse) !important;\n}\n\n.text-light-info {\n  color: var(--bs-info-light) !important;\n}\n\n.text-hover-info {\n  transition: color 0.2s ease;\n}\n.text-hover-info i {\n  transition: color 0.2s ease;\n}\n.text-hover-info:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.text-hover-info:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.text-hover-info:hover .svg-icon {\n  color: var(--bs-text-info) !important;\n}\n\n.text-active-info {\n  transition: color 0.2s ease;\n}\n.text-active-info i {\n  transition: color 0.2s ease;\n}\n.text-active-info.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.text-active-info.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.text-active-info.active .svg-icon {\n  color: var(--bs-text-info) !important;\n}\n\n.text-warning {\n  color: var(--bs-text-warning) !important;\n}\n\n.text-inverse-warning {\n  color: var(--bs-warning-inverse) !important;\n}\n\n.text-light-warning {\n  color: var(--bs-warning-light) !important;\n}\n\n.text-hover-warning {\n  transition: color 0.2s ease;\n}\n.text-hover-warning i {\n  transition: color 0.2s ease;\n}\n.text-hover-warning:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.text-hover-warning:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.text-hover-warning:hover .svg-icon {\n  color: var(--bs-text-warning) !important;\n}\n\n.text-active-warning {\n  transition: color 0.2s ease;\n}\n.text-active-warning i {\n  transition: color 0.2s ease;\n}\n.text-active-warning.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.text-active-warning.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.text-active-warning.active .svg-icon {\n  color: var(--bs-text-warning) !important;\n}\n\n.text-danger {\n  color: var(--bs-text-danger) !important;\n}\n\n.text-inverse-danger {\n  color: var(--bs-danger-inverse) !important;\n}\n\n.text-light-danger {\n  color: var(--bs-danger-light) !important;\n}\n\n.text-hover-danger {\n  transition: color 0.2s ease;\n}\n.text-hover-danger i {\n  transition: color 0.2s ease;\n}\n.text-hover-danger:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.text-hover-danger:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.text-hover-danger:hover .svg-icon {\n  color: var(--bs-text-danger) !important;\n}\n\n.text-active-danger {\n  transition: color 0.2s ease;\n}\n.text-active-danger i {\n  transition: color 0.2s ease;\n}\n.text-active-danger.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.text-active-danger.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.text-active-danger.active .svg-icon {\n  color: var(--bs-text-danger) !important;\n}\n\n.text-dark {\n  color: var(--bs-text-dark) !important;\n}\n\n.text-inverse-dark {\n  color: var(--bs-dark-inverse) !important;\n}\n\n.text-light-dark {\n  color: var(--bs-dark-light) !important;\n}\n\n.text-hover-dark {\n  transition: color 0.2s ease;\n}\n.text-hover-dark i {\n  transition: color 0.2s ease;\n}\n.text-hover-dark:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.text-hover-dark:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.text-hover-dark:hover .svg-icon {\n  color: var(--bs-text-dark) !important;\n}\n\n.text-active-dark {\n  transition: color 0.2s ease;\n}\n.text-active-dark i {\n  transition: color 0.2s ease;\n}\n.text-active-dark.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.text-active-dark.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.text-active-dark.active .svg-icon {\n  color: var(--bs-text-dark) !important;\n}\n\n.text-muted {\n  color: var(--bs-text-muted) !important;\n}\n\n.text-hover-muted {\n  transition: color 0.2s ease;\n}\n.text-hover-muted i {\n  transition: color 0.2s ease;\n}\n.text-hover-muted:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.text-hover-muted:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.text-hover-muted:hover .svg-icon {\n  color: var(--bs-text-muted) !important;\n}\n\n.text-active-muted {\n  transition: color 0.2s ease;\n}\n.text-active-muted i {\n  transition: color 0.2s ease;\n}\n.text-active-muted.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.text-active-muted.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.text-active-muted.active .svg-icon {\n  color: var(--bs-text-muted) !important;\n}\n\n.text-gray-100 {\n  color: var(--bs-text-gray-100) !important;\n}\n\n.text-hover-gray-100 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-100 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-100:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.text-hover-gray-100:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.text-hover-gray-100:hover .svg-icon {\n  color: var(--bs-text-gray-100) !important;\n}\n\n.text-active-gray-100 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-100 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-100.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.text-active-gray-100.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.text-active-gray-100.active .svg-icon {\n  color: var(--bs-text-gray-100) !important;\n}\n\n.text-gray-200 {\n  color: var(--bs-text-gray-200) !important;\n}\n\n.text-hover-gray-200 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-200 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-200:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.text-hover-gray-200:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.text-hover-gray-200:hover .svg-icon {\n  color: var(--bs-text-gray-200) !important;\n}\n\n.text-active-gray-200 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-200 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-200.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.text-active-gray-200.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.text-active-gray-200.active .svg-icon {\n  color: var(--bs-text-gray-200) !important;\n}\n\n.text-gray-300 {\n  color: var(--bs-text-gray-300) !important;\n}\n\n.text-hover-gray-300 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-300 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-300:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.text-hover-gray-300:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.text-hover-gray-300:hover .svg-icon {\n  color: var(--bs-text-gray-300) !important;\n}\n\n.text-active-gray-300 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-300 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-300.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.text-active-gray-300.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.text-active-gray-300.active .svg-icon {\n  color: var(--bs-text-gray-300) !important;\n}\n\n.text-gray-400 {\n  color: var(--bs-text-gray-400) !important;\n}\n\n.text-hover-gray-400 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-400 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-400:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.text-hover-gray-400:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.text-hover-gray-400:hover .svg-icon {\n  color: var(--bs-text-gray-400) !important;\n}\n\n.text-active-gray-400 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-400 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-400.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.text-active-gray-400.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.text-active-gray-400.active .svg-icon {\n  color: var(--bs-text-gray-400) !important;\n}\n\n.text-gray-500 {\n  color: var(--bs-text-gray-500) !important;\n}\n\n.text-hover-gray-500 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-500 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-500:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.text-hover-gray-500:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.text-hover-gray-500:hover .svg-icon {\n  color: var(--bs-text-gray-500) !important;\n}\n\n.text-active-gray-500 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-500 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-500.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.text-active-gray-500.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.text-active-gray-500.active .svg-icon {\n  color: var(--bs-text-gray-500) !important;\n}\n\n.text-gray-600 {\n  color: var(--bs-text-gray-600) !important;\n}\n\n.text-hover-gray-600 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-600 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-600:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.text-hover-gray-600:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.text-hover-gray-600:hover .svg-icon {\n  color: var(--bs-text-gray-600) !important;\n}\n\n.text-active-gray-600 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-600 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-600.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.text-active-gray-600.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.text-active-gray-600.active .svg-icon {\n  color: var(--bs-text-gray-600) !important;\n}\n\n.text-gray-700 {\n  color: var(--bs-text-gray-700) !important;\n}\n\n.text-hover-gray-700 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-700 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-700:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.text-hover-gray-700:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.text-hover-gray-700:hover .svg-icon {\n  color: var(--bs-text-gray-700) !important;\n}\n\n.text-active-gray-700 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-700 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-700.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.text-active-gray-700.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.text-active-gray-700.active .svg-icon {\n  color: var(--bs-text-gray-700) !important;\n}\n\n.text-gray-800 {\n  color: var(--bs-text-gray-800) !important;\n}\n\n.text-hover-gray-800 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-800 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-800:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.text-hover-gray-800:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.text-hover-gray-800:hover .svg-icon {\n  color: var(--bs-text-gray-800) !important;\n}\n\n.text-active-gray-800 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-800 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-800.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.text-active-gray-800.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.text-active-gray-800.active .svg-icon {\n  color: var(--bs-text-gray-800) !important;\n}\n\n.text-gray-900 {\n  color: var(--bs-text-gray-900) !important;\n}\n\n.text-hover-gray-900 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-900 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-900:hover {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n.text-hover-gray-900:hover i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n.text-hover-gray-900:hover .svg-icon {\n  color: var(--bs-text-gray-900) !important;\n}\n\n.text-active-gray-900 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-900 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-900.active {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n.text-active-gray-900.active i {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n.text-active-gray-900.active .svg-icon {\n  color: var(--bs-text-gray-900) !important;\n}\n\n.parent-hover .parent-hover-white {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-white {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.parent-hover .parent-hover-primary {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-primary {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.parent-hover .parent-hover-secondary {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-secondary {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.parent-hover .parent-hover-light {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-light {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.parent-hover .parent-hover-success {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-success {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.parent-hover .parent-hover-info {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-info {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.parent-hover .parent-hover-warning {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-warning {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.parent-hover .parent-hover-danger {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-danger {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.parent-hover .parent-hover-dark {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-dark {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.parent-hover .parent-hover-muted {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-muted {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.parent-hover .parent-hover-gray-100 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-100 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.parent-hover .parent-hover-gray-200 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-200 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.parent-hover .parent-hover-gray-300 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-300 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.parent-hover .parent-hover-gray-400 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-400 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.parent-hover .parent-hover-gray-500 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-500 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.parent-hover .parent-hover-gray-600 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-600 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.parent-hover .parent-hover-gray-700 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-700 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.parent-hover .parent-hover-gray-800 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-800 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.parent-hover .parent-hover-gray-900 {\n  transition: color 0.2s ease;\n}\n.parent-hover:hover .parent-hover-gray-900 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n\n.parent-active .parent-active-white {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-white {\n  transition: color 0.2s ease;\n  color: var(--bs-text-white) !important;\n}\n.parent-active .parent-active-primary {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-primary {\n  transition: color 0.2s ease;\n  color: var(--bs-text-primary) !important;\n}\n.parent-active .parent-active-secondary {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-secondary {\n  transition: color 0.2s ease;\n  color: var(--bs-text-secondary) !important;\n}\n.parent-active .parent-active-light {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-light {\n  transition: color 0.2s ease;\n  color: var(--bs-text-light) !important;\n}\n.parent-active .parent-active-success {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-success {\n  transition: color 0.2s ease;\n  color: var(--bs-text-success) !important;\n}\n.parent-active .parent-active-info {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-info {\n  transition: color 0.2s ease;\n  color: var(--bs-text-info) !important;\n}\n.parent-active .parent-active-warning {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-warning {\n  transition: color 0.2s ease;\n  color: var(--bs-text-warning) !important;\n}\n.parent-active .parent-active-danger {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-danger {\n  transition: color 0.2s ease;\n  color: var(--bs-text-danger) !important;\n}\n.parent-active .parent-active-dark {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-dark {\n  transition: color 0.2s ease;\n  color: var(--bs-text-dark) !important;\n}\n.parent-active .parent-active-muted {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-muted {\n  transition: color 0.2s ease;\n  color: var(--bs-text-muted) !important;\n}\n.parent-active .parent-active-gray-100 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-100 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-100) !important;\n}\n.parent-active .parent-active-gray-200 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-200 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-200) !important;\n}\n.parent-active .parent-active-gray-300 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-300 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-300) !important;\n}\n.parent-active .parent-active-gray-400 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-400 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-400) !important;\n}\n.parent-active .parent-active-gray-500 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-500 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-500) !important;\n}\n.parent-active .parent-active-gray-600 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-600 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-600) !important;\n}\n.parent-active .parent-active-gray-700 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-700 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-700) !important;\n}\n.parent-active .parent-active-gray-800 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-800 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-800) !important;\n}\n.parent-active .parent-active-gray-900 {\n  transition: color 0.2s ease;\n}\n.parent-active.active .parent-active-gray-900 {\n  transition: color 0.2s ease;\n  color: var(--bs-text-gray-900) !important;\n}\n\n.text-transparent {\n  color: transparent;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\ni.bi, i[class^=fonticon-], i[class*=\" fonticon-\"], i[class^=fa-], i[class*=\" fa-\"], i[class^=la-], i[class*=\" la-\"] {\n  line-height: 1;\n  font-size: 1rem;\n  color: var(--bs-text-muted);\n}\n\na {\n  transition: color 0.2s ease;\n}\na:hover {\n  transition: color 0.2s ease;\n}\n\n.opacity-active-0.active {\n  opacity: 0 !important;\n}\n\n.opacity-state-0:hover, .opacity-state-0.active {\n  opacity: 0 !important;\n}\n\n.opacity-active-5.active {\n  opacity: 0.05 !important;\n}\n\n.opacity-state-5:hover, .opacity-state-5.active {\n  opacity: 0.05 !important;\n}\n\n.opacity-active-10.active {\n  opacity: 0.1 !important;\n}\n\n.opacity-state-10:hover, .opacity-state-10.active {\n  opacity: 0.1 !important;\n}\n\n.opacity-active-15.active {\n  opacity: 0.15 !important;\n}\n\n.opacity-state-15:hover, .opacity-state-15.active {\n  opacity: 0.15 !important;\n}\n\n.opacity-active-20.active {\n  opacity: 0.2 !important;\n}\n\n.opacity-state-20:hover, .opacity-state-20.active {\n  opacity: 0.2 !important;\n}\n\n.opacity-active-25.active {\n  opacity: 0.25 !important;\n}\n\n.opacity-state-25:hover, .opacity-state-25.active {\n  opacity: 0.25 !important;\n}\n\n.opacity-active-50.active {\n  opacity: 0.5 !important;\n}\n\n.opacity-state-50:hover, .opacity-state-50.active {\n  opacity: 0.5 !important;\n}\n\n.opacity-active-75.active {\n  opacity: 0.75 !important;\n}\n\n.opacity-state-75:hover, .opacity-state-75.active {\n  opacity: 0.75 !important;\n}\n\n.opacity-active-100.active {\n  opacity: 1 !important;\n}\n\n.opacity-state-100:hover, .opacity-state-100.active {\n  opacity: 1 !important;\n}\n\n.transform-90 {\n  transform: rotate(90deg);\n  transform-origin: right top;\n}\n\n.tree {\n  --bs-tree-icon-size: 16px;\n  --bs-tree-icon-gap: 14px;\n  --bs-tree-icon-color-open: var(--bs-success);\n  --bs-tree-icon-color-default: var(--bs-gray-500);\n  --bs-tree-icon-color-close: var(--bs-gray-500);\n  --bs-tree-line-color: var(--bs-gray-200);\n}\n.tree .tree-node {\n  padding-left: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n}\n.tree .tree-sub {\n  padding: 0.35rem 0;\n}\n.tree .tree-content {\n  display: flex;\n  align-items: center;\n  padding: 0.35rem 0;\n}\n.tree .tree-wrapper {\n  padding-left: calc(var(--bs-tree-icon-size) + var(--bs-tree-icon-size));\n}\n.tree .tree-section {\n  display: flex;\n  align-items: baseline;\n  padding-left: var(--bs-tree-icon-gap);\n}\n.tree .tree-toggle {\n  display: flex;\n  align-items: center;\n  width: var(--bs-tree-icon-size);\n}\n.tree .tree-toggle .tree-icon-default {\n  font-size: 1.5rem;\n  color: var(--bs-tree-icon-color-default);\n}\n.tree .tree-toggle .tree-icon-open {\n  font-size: 1.5rem;\n  color: var(--bs-tree-icon-color-open);\n}\n.tree .tree-toggle .tree-icon-close {\n  font-size: 1.5rem;\n  color: var(--bs-tree-icon-color-close);\n}\n.tree .tree-toggle.collapsed .tree-icon-close {\n  display: flex;\n}\n.tree .tree-toggle.collapsed .tree-icon-open {\n  display: none;\n}\n.tree .tree-toggle:not(.collapsed) .tree-icon-close {\n  display: none;\n}\n.tree .tree-toggle:not(.collapsed) .tree-icon-open {\n  display: flex;\n}\n.tree > .tree-node {\n  padding-left: 0 !important;\n}\n.tree.tree-line .tree-sub {\n  border-left: 1px solid var(--bs-tree-line-color);\n  margin-left: calc(var(--bs-tree-icon-size) / 2);\n}\n\n@media (min-width: 992px) {\n  .testimonials-slider-highlight {\n    transition: all ease 0.3;\n  }\n  .testimonials-slider-highlight .testimonials-photo,\n  .testimonials-slider-highlight .testimonials-title,\n  .testimonials-slider-highlight .testimonials-body,\n  .testimonials-slider-highlight .testimonials-author,\n  .testimonials-slider-highlight .testimonials-positon {\n    transition: all ease 0.3s;\n  }\n  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-photo {\n    height: 200px;\n    width: 200px;\n    transition: all ease 0.3s;\n  }\n  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-title {\n    color: var(--bs-gray-900) !important;\n    font-size: 1.54rem !important;\n    transition: all ease 0.3s;\n    margin-bottom: 1.3rem !important;\n  }\n  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-description {\n    color: var(--bs-gray-700) !important;\n    font-size: 1.38rem !important;\n    transition: all ease 0.3s;\n    margin-bottom: 1.7rem !important;\n  }\n  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-author {\n    color: var(--bs-primary) !important;\n    font-size: 1.1rem !important;\n    transition: all ease 0.3s;\n  }\n  .testimonials-slider-highlight .tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active .testimonials-positon {\n    color: var(--bs-gray-500) !important;\n    font-size: 0.9rem !important;\n    transition: all ease 0.3s;\n  }\n}\n.testimonials-slider-quote .testimonials-quote {\n  opacity: 0.2;\n}\n.testimonials-slider-quote .tns-item:not(.tns-slide-active) + .tns-slide-active + .tns-slide-active .testimonials-quote {\n  opacity: 0.5;\n  color: var(--bs-primary) !important;\n}\n\n.stepper.stepper-pills.stepper-multistep {\n  --bs-stepper-pills-size: 46px;\n  --bs-stepper-icon-border-radius: 9px;\n  --bs-stepper-icon-check-size: 1.25rem;\n  --bs-stepper-icon-bg-color: rgba(255, 255, 255, 0.03);\n  --bs-stepper-icon-bg-color-current: var(--bs-success);\n  --bs-stepper-icon-bg-color-completed: rgba(255, 255, 255, 0.03);\n  --bs-stepper-icon-border: 1px dashed rgba(255, 255, 255, 0.3);\n  --bs-stepper-icon-border-current: 0;\n  --bs-stepper-icon-border-completed: 1px dashed rgba(255, 255, 255, 0.3);\n  --bs-stepper-icon-number-color: var(--bs-white);\n  --bs-stepper-icon-number-color-current: var(--bs-white);\n  --bs-stepper-icon-number-color-completed: var(--bs-white);\n  --bs-stepper-icon-check-color-completed: var(--bs-success);\n  --bs-stepper-label-title-opacity: 0.7;\n  --bs-stepper-label-title-opacity-current: 1;\n  --bs-stepper-label-title-opacity-completed: 1;\n  --bs-stepper-label-title-color: var(--bs-white);\n  --bs-stepper-label-title-color-current: var(--bs-white);\n  --bs-stepper-label-title-color-completed: var(--bs-white);\n  --bs-stepper-label-desc-opacity: 0.7;\n  --bs-stepper-label-desc-opacity-current: 0.7;\n  --bs-stepper-label-desc-opacity-completed: 0.7;\n  --bs-stepper-label-desc-color: var(--bs-white);\n  --bs-stepper-label-desc-color-current: var(--bs-white);\n  --bs-stepper-label-desc-color-completed: var(--bs-white);\n  --bs-stepper-line-border: 1px dashed rgba(255, 255, 255, 0.3);\n}\n\n.landing-dark-bg {\n  background-color: #13263C;\n}\n\n.landing-dark-color {\n  color: #13263C;\n}\n\n.landing-dark-border {\n  border: 1px dashed #2C3F5B;\n}\n\n.landing-dark-separator {\n  border-top: 1px dashed #2C3F5B;\n}\n\n.landing-curve {\n  position: relative;\n}\n.landing-curve svg {\n  position: relative;\n  top: 0;\n  display: block;\n}\n\n.landing-header {\n  display: flex;\n  align-items: center;\n  height: 100px;\n}\n.landing-header .logo-default {\n  display: block;\n}\n.landing-header .logo-sticky {\n  display: none;\n}\n.landing-header .menu .menu-link.active {\n  color: #ffffff;\n}\n[data-kt-sticky-landing-header=on] .landing-header .menu .menu-link.active {\n  color: #1B84FF;\n  background-color: rgba(239, 242, 245, 0.4);\n}\n[data-kt-sticky-landing-header=on] .landing-header {\n  padding: 0;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  background-color: #ffffff;\n  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  height: 70px;\n}\n[data-kt-sticky-landing-header=on] .landing-header .logo-sticky {\n  display: block;\n}\n[data-kt-sticky-landing-header=on] .landing-header .logo-default {\n  display: none;\n}\n\nbody[data-kt-sticky-landing-header=on] {\n  padding-top: 100px;\n}\n\n@media (max-width: 991.98px) {\n  .landing-header {\n    height: 70px;\n  }\n  .landing-header .landing-menu-wrapper {\n    position: relative;\n    overflow: auto;\n  }\n  [data-kt-sticky-landing-header=on] .landing-header {\n    height: 70px;\n  }\n  .landing-header .menu .menu-link.active {\n    color: #1B84FF;\n    background-color: rgba(239, 242, 245, 0.4);\n  }\n  body[data-kt-sticky-landing-header=on] {\n    padding-top: 70px;\n  }\n}\n[data-bs-theme=light] {\n  --bs-page-bg: #F9F9F9;\n  --bs-app-blank-bg: #ffffff;\n  --bs-header-desktop-fixed-bg-color: #ffffff;\n  --bs-header-desktop-fixed-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);\n  --bs-header-desktop-fixed-bg-color: #ffffff;\n  --bs-header-desktop-fixed-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);\n  --bs-aside-bg-color: #F1F1F4;\n  --bs-sidebar-bg-color: #192440;\n  --bs-sidebar-tabs-link-bg-color-default: #0e172e;\n  --bs-sidebar-tabs-link-bg-color-active: #07122d;\n  --bs-sidebar-tabs-link-icon-color-default: #5e6278;\n  --bs-sidebar-tabs-link-icon-color-active: #ffffff;\n  --bs-sidebar-dashed-border-color: #3e4a69;\n  --bs-sidebar-muted-color: #546182;\n  --bs-sidebar-muted-bg-color: #0e172e;\n}\n\n[data-bs-theme=dark] {\n  --bs-page-bg: #0F1014;\n  --bs-app-blank-bg: #0F1014;\n  --bs-header-desktop-fixed-bg-color: #0F1014;\n  --bs-header-desktop-fixed-box-shadow: none;\n  --bs-header-desktop-fixed-bg-color: #15171C;\n  --bs-header-desktop-fixed-box-shadow: none;\n  --bs-aside-bg-color: #0D0E12;\n  --bs-sidebar-bg-color: #1e1e2d;\n  --bs-sidebar-tabs-link-bg-color-default: #161621;\n  --bs-sidebar-tabs-link-bg-color-active: #12121b;\n  --bs-sidebar-tabs-link-icon-color-default: #5e6278;\n  --bs-sidebar-tabs-link-icon-color-active: #ffffff;\n  --bs-sidebar-dashed-border-color: #26272F;\n  --bs-sidebar-muted-color: #636674;\n  --bs-sidebar-muted-bg-color: #1a1a27;\n}\n\nhtml {\n  font-family: sans-serif;\n  text-size-adjust: 100%;\n}\n\nhtml,\nbody {\n  height: 100%;\n  margin: 0px;\n  padding: 0px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 14px !important;\n  font-weight: 400;\n  font-family: Inter, Helvetica, \"sans-serif\";\n}\n@media (max-width: 991.98px) {\n  html,\n  body {\n    font-size: 14px !important;\n  }\n}\n@media (max-width: 767.98px) {\n  html,\n  body {\n    font-size: 13px !important;\n  }\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n}\nbody a:hover,\nbody a:active,\nbody a:focus {\n  text-decoration: none !important;\n}\n\ncanvas {\n  user-select: none;\n}\n\nrouter-outlet {\n  display: none;\n}\n\n@media print {\n  .print-content-only {\n    padding: 0 !important;\n    background: none !important;\n  }\n  .print-content-only .wrapper,\n  .print-content-only .page,\n  .print-content-only .page-title,\n  .print-content-only .content,\n  .print-content-only .container,\n  .print-content-only .container-xxl,\n  .print-content-only .container-fluid,\n  .print-content-only .container-sm,\n  .print-content-only .container-md,\n  .print-content-only .container-lg,\n  .print-content-only .container-xl {\n    background: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  .print-content-only .aside,\n  .print-content-only .sidebar,\n  .print-content-only .scrolltop,\n  .print-content-only .header,\n  .print-content-only .footer,\n  .print-content-only .toolbar,\n  .print-content-only .drawer,\n  .print-content-only .btn {\n    display: none !important;\n  }\n}\nbody {\n  background-color: var(--bs-page-bg);\n}\n\n.text-page-bg {\n  color: #F9F9F9;\n}\n\n.app-blank {\n  background-color: var(--bs-app-blank-bg) !important;\n}\n\n@media (min-width: 1400px) {\n  .sidebar-enabled .engage-toolbar {\n    right: 400px !important;\n  }\n  .sidebar-enabled .scrolltop {\n    right: 405px !important;\n  }\n}\n@media (min-width: 992px) {\n  .container,\n  .container-xxl,\n  .container-fluid,\n  .container-sm,\n  .container-md,\n  .container-lg,\n  .container-xl {\n    padding: 0 50px !important;\n  }\n  .wrapper {\n    padding-top: 50px;\n    padding-left: 350px;\n  }\n  .header-fixed[data-kt-sticky-header=on] .wrapper {\n    padding-top: 130px;\n  }\n}\n@media (max-width: 991.98px) {\n  .container,\n  .container-xxl,\n  .container-fluid,\n  .container-sm,\n  .container-md,\n  .container-lg,\n  .container-xl {\n    max-width: none;\n    padding: 0 20px !important;\n  }\n  .header-tablet-and-mobile-fixed[data-kt-sticky-header=on] .wrapper {\n    padding-top: 55px;\n  }\n}\n@media (min-width: 1400px) {\n  .sidebar-enabled[data-kt-sticky-header=on] .header {\n    right: 400px !important;\n  }\n}\n@media (min-width: 992px) {\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 80px;\n  }\n  .header-fixed[data-kt-sticky-header=on] .header {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 350px;\n    z-index: 97;\n    background-color: var(--bs-header-desktop-fixed-bg-color);\n    box-shadow: var(--bs-header-desktop-fixed-box-shadow);\n    height: 65px;\n    padding: 0;\n    border-bottom-right-radius: 0.65rem;\n    border-bottom-left-radius: 0.65rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 60px;\n  }\n  .header-tablet-and-mobile-fixed[data-kt-sticky-header=on] .header {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 97;\n    height: 55px;\n    min-height: 55px;\n    background-color: var(--bs-header-tablet-and-mobile-fixed-bg-color);\n    box-shadow: var(--bs-header-tablet-and-mobile-fixed-box-shadow);\n    border-bottom-right-radius: 0.65rem;\n    border-bottom-left-radius: 0.65rem;\n  }\n  .header .page-title {\n    display: none !important;\n  }\n}\n.aside {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bs-aside-bg-color);\n  padding: 0;\n}\n.aside .aside-menu {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.aside .aside-menu .menu > .menu-item > .menu-link .menu-title {\n  font-size: 1.1rem;\n}\n.aside .aside-menu .menu > .menu-item.menu-accordion.show > .menu-link > .menu-icon i,\n.aside .aside-menu .menu > .menu-item.menu-accordion.show > .menu-link > .menu-icon .svg-icon, .aside .aside-menu .menu > .menu-item.menu-accordion.showing > .menu-link > .menu-icon i,\n.aside .aside-menu .menu > .menu-item.menu-accordion.showing > .menu-link > .menu-icon .svg-icon {\n  /*rtl:ignore*/\n  transform: rotateZ(-90deg);\n  /*rtl:remove*/\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n.aside .aside-menu .menu > .menu-item.menu-accordion.hiding > .menu-link > .menu-icon i,\n.aside .aside-menu .menu > .menu-item.menu-accordion.hiding > .menu-link > .menu-icon .svg-icon {\n  /*rtl:ignore*/\n  transform: rotateZ(0);\n  /*rtl:remove*/\n  transform: rotateZ(0);\n  transition: transform 0.3s ease;\n}\n.aside .aside-menu .menu .menu-item .menu-link {\n  background-color: transparent;\n  color: var(--bs-gray-700);\n}\n.aside .aside-menu .menu .menu-item .menu-link .menu-title {\n  color: var(--bs-gray-700);\n}\n.aside .aside-menu .menu .menu-item .menu-link .menu-icon,\n.aside .aside-menu .menu .menu-item .menu-link .menu-icon .svg-icon,\n.aside .aside-menu .menu .menu-item .menu-link .menu-icon i {\n  color: var(--bs-gray-600);\n}\n.aside .aside-menu .menu .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-400);\n}\n.aside .aside-menu .menu .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--bs-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--bs-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.aside .aside-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .aside .aside-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: transparent;\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .aside .aside-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: transparent;\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item.here > .menu-link .menu-title {\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: transparent;\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item.show > .menu-link .menu-title {\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item.show > .menu-link .menu-icon,\n.aside .aside-menu .menu .menu-item.show > .menu-link .menu-icon .svg-icon,\n.aside .aside-menu .menu .menu-item.show > .menu-link .menu-icon i {\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: transparent;\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item .menu-link.active .menu-title {\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item .menu-link.active .menu-icon,\n.aside .aside-menu .menu .menu-item .menu-link.active .menu-icon .svg-icon,\n.aside .aside-menu .menu .menu-item .menu-link.active .menu-icon i {\n  color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--bs-gray-900);\n}\n.aside .aside-menu .menu .menu-item > .menu-link.active .menu-title {\n  font-weight: 600;\n}\n\n@media (min-width: 992px) {\n  .aside {\n    position: fixed;\n    top: 50px;\n    bottom: 50px;\n    left: 50px;\n    z-index: 100;\n    overflow: hidden;\n    width: 300px;\n    border-radius: 2rem;\n  }\n  .aside .scroll-y,\n  .aside .hover-scroll-overlay-y {\n    scrollbar-color: var(--bs-gray-300) transparent;\n  }\n  .aside .scroll-y::-webkit-scrollbar-thumb,\n  .aside .hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n    background-color: var(--bs-gray-300);\n  }\n  .aside .scroll-y::-webkit-scrollbar-corner,\n  .aside .hover-scroll-overlay-y::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n  .aside .scroll-y:hover,\n  .aside .hover-scroll-overlay-y:hover {\n    scrollbar-color: var(--bs-gray-400) transparent;\n  }\n  .aside .scroll-y:hover::-webkit-scrollbar-thumb,\n  .aside .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {\n    background-color: var(--bs-gray-400);\n  }\n  .aside .scroll-y:hover::-webkit-scrollbar-corner,\n  .aside .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n  .aside .aside-logo {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (max-width: 991.98px) {\n  .aside {\n    display: none;\n  }\n  .aside .aside-logo {\n    display: none;\n  }\n}\n[data-bs-theme=dark] .aside {\n  border: 1px solid #15171C;\n}\n\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bs-sidebar-bg-color);\n  padding: 0;\n}\n.sidebar .sidebar-nav {\n  flex-wrap: nowrap;\n  padding: 0;\n  margin: 9;\n  width: 100%;\n  border: 0;\n  justify-content: space-between;\n  align-items: center;\n}\n.sidebar .sidebar-nav .nav-item {\n  padding: 0;\n  margin: 0;\n  height: 85px;\n  width: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.sidebar .sidebar-nav .nav-link {\n  padding: 0;\n  margin: 0;\n  height: 75px;\n  width: 60px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bs-sidebar-tabs-link-bg-color-default);\n  border: 0;\n  border-radius: 0.65rem;\n}\n.sidebar .sidebar-nav .nav-link i {\n  transition: all 0.3s ease;\n  font-size: 2.25rem;\n  color: var(--bs-sidebar-tabs-link-icon-color-default);\n}\n.sidebar .sidebar-nav .nav-link.active {\n  height: 85px;\n  width: 70px;\n  padding: 0;\n  transition: all 0.3s ease;\n  background-color: var(--bs-sidebar-tabs-link-bg-color-active);\n}\n.sidebar .sidebar-nav .nav-link.active i {\n  font-size: 2.75rem;\n  color: var(--bs-sidebar-tabs-link-icon-color-active);\n}\n.sidebar .sidebar-border-dashed {\n  border: 1px dashed var(--bs-sidebar-dashed-border-color);\n}\n.sidebar .sidebar-text-muted {\n  color: var(--bs-sidebar-muted-color);\n}\n.sidebar .sidebar-bg-muted {\n  background-color: var(--bs-sidebar-muted-bg-color);\n}\n\n@media (min-width: 1400px) {\n  .sidebar {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 101;\n    width: 400px;\n    overflow: hidden;\n  }\n  .sidebar-enabled .app-engage {\n    right: 400px;\n  }\n}\n@media (max-width: 1399.98px) {\n  .sidebar {\n    display: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .sidebar {\n    display: none;\n  }\n  .sidebar .sidebar-nav .nav-item {\n    height: 65px;\n    width: 50px;\n  }\n  .sidebar .sidebar-nav .nav-link {\n    height: 45px;\n    width: 40px;\n  }\n  .sidebar .sidebar-nav .nav-link .svg-icon svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .sidebar .sidebar-nav .nav-link.active {\n    height: 65px;\n    width: 50px;\n  }\n  .sidebar .sidebar-nav .nav-link.active .svg-icon svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .content {\n    padding: 25px 0 0 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .content {\n    padding: 20px 0 0 0;\n  }\n}","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","//\n// Bootstrap & Custom Variables\n// Safely override any variable in _variables.custom.scss\n//\n\n// Prefix for :root CSS variables\n$prefix: bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n\n// Custom coal colors\n$coal-100:  #15171C !default;\n$coal-200:  #13141A !default;\n$coal-300:  #111217 !default;\n$coal-400:  #0F1014 !default;\n$coal-500:  #0D0E12 !default;\n$coal-600:  #0B0C10 !default;\n$coal-black: #000000 !default;\n$coal-clarity:  rgba(#18191F, 50) !default;\n\n\n// Bootstrap color system\n$white: #ffffff !default;\n$black:#000000 !default;\n\n// Bootstrap grey colors\n$gray-100: #F9F9F9 !default;\n$gray-200: #F1F1F4 !default;\n$gray-300: #DBDFE9 !default;\n$gray-400: #C4CADA !default;\n$gray-500: #99A1B7 !default;\n$gray-600: #78829D !default;\n$gray-700: #4B5675 !default;\n$gray-800: #252F4A !default;\n$gray-900: #071437 !default;\n \n// Bootstrap muted color\n$text-muted: $gray-500 !default;\n\n// Bootstrap gray colors map\n$grays: (\n\t\"100\": $gray-100,\n\t\"200\": $gray-200,\n\t\"300\": $gray-300,\n\t\"400\": $gray-400,\n\t\"500\": $gray-500,\n\t\"600\": $gray-600,\n\t\"700\": $gray-700,\n\t\"800\": $gray-800,\n\t\"900\": $gray-900\n) !default; \n\n// Bootstrap contextual colors\n// Primary colors\n$primary:\t\t\t\t\t\t#1B84FF !default;\n$primary-active:\t\t\t\t#056EE9 !default;\n$primary-light: \t\t\t\t#E9F3FF !default;\n$primary-clarity: \t\t\t\trgba(#1B84FF, 0.2) !default;\n$primary-inverse: \t\t\t\t$white !default; \n\n// Secondary colors\n$secondary: \t\t\t\t\t#F9F9F9 !default;\n$secondary-active: \t\t\t\t$gray-300 !default;\n$secondary-light: \t\t\t\t#F9F9F9 !default;\n$secondary-clarity:\t\t\t\trgba(#F9F9F9, 0.2) !default; \n$secondary-inverse:\t\t\t\t$gray-800 !default; \n\n// Light colors\n$light: \t\t\t\t\t\t$gray-100 !default;\n$light-active: \t\t\t\t\t#FCFCFC !default;\n$light-light: \t\t\t\t\t#ffffff !default;\n$light-clarity: \t\t\t\trgba($white, 0.2) !default;\n$light-inverse:\t\t\t\t\t$gray-800 !default;\n\n// Success colors\n$success: \t\t\t\t\t\t#17C653 !default; \n$success-active: \t\t\t\t#04B440 !default;\n$success-light: \t\t\t\t#DFFFEA !default;\n$success-clarity: \t\t\t\trgba(#17C653, 0.2) !default;\n$success-inverse: \t\t\t\t$white !default;\n\n// Info colors\n$info: \t\t\t\t\t\t\t#7239EA !default; \n$info-active: \t\t\t\t\t#5014D0 !default;\n$info-light: \t\t\t\t\t#F8F5FF !default;\n$info-clarity: \t\t\t\t\trgba(#7239EA, 0.2) !default;\n$info-inverse: \t\t\t\t\t$white !default;\n\n// Warning colors\n$warning: \t\t\t\t\t\t#F6C000 !default; \n$warning-active: \t\t\t\t#DEAD00 !default;\n$warning-light: \t\t\t\t#FFF8DD !default;\n$warning-clarity: \t\t\t\trgba(#F6C000, 0.2) !default;\n$warning-inverse: \t\t\t\t$white !default;\n\n// Danger colors\n$danger: \t\t\t\t\t\t#F8285A !default; \n$danger-active: \t\t\t\t#D81A48 !default;\n$danger-light: \t\t\t\t\t#FFEEF3 !default;\n$danger-clarity: \t\t\t\trgba(#F8285A, 0.2) !default;\n$danger-inverse: \t\t\t\t$white !default;\n\n// Dark colors\n$dark: \t\t\t\t\t\t\t#1E2129 !default;\n$dark-active: \t\t\t\t\t#111318 !default;\n$dark-light: \t\t\t\t\t#F9F9F9 !default; \n$dark-clarity: \t\t\t\t\trgba(#1E2129, 0.2) !default;\n$dark-inverse: \t\t\t\t\t$white !default;\n\n// Contextual colors\n$theme-colors: (\n\t\"light\": $light,\n\t\"primary\": $primary,\n\t\"secondary\": $secondary,\n\t\"success\": $success,\n\t\"info\": $info,\n\t\"warning\": $warning,\n\t\"danger\": $danger,\n\t\"dark\": $dark\n) !default;\n\t\n// Contextual active state colors\n$theme-active-colors: (\n\t\"primary\": $primary-active,\n\t\"secondary\":  $secondary-active,\n\t\"light\":   $light-active,\n\t\"success\": $success-active,\n\t\"info\":    $info-active,\n\t\"warning\": $warning-active,\n\t\"danger\":  $danger-active,\n\t\"dark\":    $dark-active\n) !default; \n\n// Contextual inverse state colors\n$theme-inverse-colors: (\n\t\"primary\": $primary-inverse,\n\t\"secondary\":  $secondary-inverse,\n\t\"light\":   $light-inverse,\n\t\"success\": $success-inverse,\n\t\"info\":    $info-inverse,\n\t\"warning\": $warning-inverse,\n\t\"danger\":  $danger-inverse,\n\t\"dark\":    $dark-inverse\n) !default; \n\n// Contextual light state colors\n$theme-light-colors: (\n\t\"primary\": $primary-light,\n\t\"secondary\": $secondary-light,\n\t\"success\": $success-light,\n\t\"info\":    $info-light,\n\t\"warning\": $warning-light,\n\t\"danger\":  $danger-light,\n\t\"dark\":    $dark-light,\n\t\"light\":   $light-light\n) !default; \n\n// Contextual light state colors\n$theme-clarity-colors: (\n\t\"primary\": $primary-clarity,\n\t\"secondary\": $secondary-clarity,\n\t\"success\": $success-clarity,\n\t\"info\":    $info-clarity,\n\t\"warning\": $warning-clarity,\n\t\"danger\":  $danger-clarity,\n\t\"dark\":    $dark-clarity,\n\t\"light\":   $light-clarity,\n) !default; \n\n// Text colors\n$theme-text-colors: (\n\t\"white\":   $white,\n\t\"primary\": $primary,\n\t\"secondary\":  $secondary,\n\t\"light\":   $light,\n\t\"success\": $success,\n\t\"info\":    $info,\n\t\"warning\": $warning,\n\t\"danger\":  $danger,\n\t\"dark\":    $dark,\n\t\"muted\":   $text-muted,\n\t\"gray-100\":   $gray-100,\n\t\"gray-200\":   $gray-200,\n\t\"gray-300\":   $gray-300,\n\t\"gray-400\":   $gray-400,\n\t\"gray-500\":   $gray-500,\n\t\"gray-600\":   $gray-600,\n\t\"gray-700\":   $gray-700,\n\t\"gray-800\":   $gray-800,\n\t\"gray-900\":   $gray-900\n) !default; \n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n$enable-rounded: true !default;\n$enable-shadows: true !default;\n$enable-negative-margins: true !default;\n$enable-smooth-scroll: false !default;\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n$spacer: 1rem !default;\n\n$spacers: (\n\t0: 0,\n\t1: ($spacer * .25), // 3.5px\n\t2: ($spacer * .5), // 7px;\n\t3: ($spacer * .75), // 10.5px\n\t4: ($spacer * 1), // 14px\n\t5: ($spacer * 1.25), // 17.5px\n\t6: ($spacer * 1.5),  // 21px\n\t7: ($spacer * 1.75), // 24.5px\n\t8: ($spacer * 2), // 28px\n\t9: ($spacer * 2.25), // 31.5px\n\t10: ($spacer * 2.5), // 35px\n\t11: ($spacer * 2.75), // 38.5px\n\t12: ($spacer * 3),   \t// 42px\n\t13: ($spacer * 3.25),\t// 45.5px\n\t14: ($spacer * 3.5), \t// 49px\n\t15: ($spacer * 3.75), \t// 52.5px\n\t16: ($spacer * 4), \t\t// 55px\n\t17: ($spacer * 4.25), \t// 58.5px\n\t18: ($spacer * 4.5), \t// 62px\n\t19: ($spacer * 4.75), \t// 65.5px\n\t20: ($spacer * 5), \t\t// 69px\n);\n\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n$position-values: (\n\t0: 0,\n\t25: 25%,\n\t50: 50%,\n\t75: 75%,\n\t100: 100%\n) !default;\n\n\n// Body\n//\n// Settings for the `<body>` element.\n$body-bg:                   $white !default;\n$body-bg-rgb:               to-rgb($body-bg) !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n\n// Links\n//\n// Style anchor elements.\n$link-color:                $primary !default;\n$link-decoration:           none !default;\n$link-shade-percentage:     20% !default;\n$link-hover-color:          $primary-active !default;\n$link-hover-decoration:     none !default;\n\n\n// Paragraphs\n//\n// Style p element.\n$paragraph-margin-bottom:         1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n\txs: 0,\n\tsm: 576px,\n\tmd: 768px,\n\tlg: 992px,\n\txl: 1200px,\n\txxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n$container-max-widths: (\n\tsm: 540px,\n\tmd: 720px,\n\tlg: 960px,\n\txl: 1140px,\n\txxl: 1320px\n) !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n$border-width:                  1px !default;\n$border-color:                  $gray-200 !default;\n$border-dashed-color:           $gray-300 !default;\n\n$border-widths: (\n\t0: 0,\n\t1: 1px,\n\t2: 2px,\n\t3: 3px,\n\t4: 4px,\n\t5: 5px\n) !default;\n\n// Border Radiues\n$border-radius:                 .475rem !default;\n$border-radius-sm:              .425rem !default;\n$border-radius-lg:              .625rem !default;\n$border-radius-xl:              1rem !default;\n$border-radius-2xl:             2rem !default;\n$border-radius-pill:            50rem !default;\n\n// Keenthemes hover states\n$component-hover-color: \t\t$primary !default;\n$component-hover-bg: \t\t\t$gray-100 !default;\n\n// Keenthemes active states\n$component-active-color:        $primary-inverse !default;\n$component-active-bg:           $primary !default;\n\n// Keenthemes checked states\n$component-checked-color:        $primary-inverse !default;\n$component-checked-bg:           $primary !default;\n\n// Keenthemes custom transition settings\n$transition-link: color .2s ease !default; \n$transition-input: color .2s ease !default; \n\n// Box shadow\n// Shadows\n$box-shadow-xs: \t\t\t\t0 .1rem 0.75rem 0.25rem rgba($black, 0.05) !default;\n$box-shadow-sm: \t\t\t\t0 .1rem 1rem 0.25rem rgba($black, .05) !default;\n$box-shadow: \t\t\t\t\t0 .5rem 1.5rem 0.5rem rgba($black, .075) !default;\n$box-shadow-lg: \t\t\t\t0 1rem 2rem 1rem rgba($black, .1) !default;\n$box-shadow-inset: \t\t\t\tinset 0 1px 2px rgba($black, .075) !default;\n\n// Keenthemes custom gutter sizes\n$gutters: (\n\t0: 0rem,\n\t1: ($spacer * .25),  \t// 3.5px\n\t2: ($spacer * .5),   \t// 7px;\n\t3: ($spacer * .75),  \t// 10.5px\n\t4: ($spacer * 1), \t// 14px\n\t5: ($spacer * 1.25), \t// 17.5px\n\t6: ($spacer * 1.5),  \t// 21px\n\t7: ($spacer * 1.75), \t// 24.5px\n\t8: ($spacer * 2), \t// 28px\n\t9: ($spacer * 2.25), \t// 31.5px\n\t10: ($spacer * 2.5), \t// 35px\n) !default;\n\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n// Font family\n$font-family-sans-serif: Inter, Helvetica, \"sans-serif\" !default;\n\n$font-size-base: 1rem !default; // Assumes the browser default, typically `13px`\n$font-size-lg: $font-size-base * 1.075 !default;   // 14.04px\n$font-size-xl: $font-size-base * 1.21 !default;   // 16.04px\n$font-size-sm: $font-size-base * .95 !default;   // 12.025px\n\n$font-weight-lighter: lighter !default;\n$font-weight-light: 300 !default;\n$font-weight-normal: 400 !default;\n$font-weight-semibold: 500 !default;\n$font-weight-bold: 600 !default;\n$font-weight-bolder: 700 !default;\n\n$font-weight-base: $font-weight-normal !default;\n\n// Line heights\n$line-height-base: 1.5 !default;\n$line-height-sm: 1.25 !default;\n$line-height-lg: 1.75 !default;\n\n// Keenthemes custom line heights\n$line-height-xl: 2 !default;\n$line-height-xxl: 2.25 !default;\n\n// Heading sizes\n$h1-font-size:  $font-size-base * 1.75 !default; // 22.75px\n$h2-font-size:  $font-size-base * 1.5 !default; // 19.50px\n$h3-font-size:  $font-size-base * 1.35 !default; // 17.55px\n$h4-font-size:  $font-size-base * 1.25 !default; // 16.25px\n$h5-font-size:  $font-size-base * 1.15 !default; // 14.95px\n$h6-font-size:  $font-size-base * 1.075 !default; // 13.97px\n\n// Font Sizes\n$font-sizes: (\n\t1: $h1-font-size,   // 22.75px\n\t2: $h2-font-size,   // 19.50px\n\t3: $h3-font-size,   // 17.55px\n\t4: $h4-font-size,   // 16.25px\n\t5: $h5-font-size,   // 14.95px\n\t6: $h6-font-size,   // 13.95px\n\n\t7: $font-size-base * 0.95,  // 12.35px\n\t8: $font-size-base * 0.85,  // 11.05px\n\t9: $font-size-base * 0.75,  // 9.75px\n\t10: $font-size-base * 0.5,  // 6.50px\n\n\tsm: $font-size-sm,\n\tbase: $font-size-base, // 13px\n\tlg: $font-size-lg,\n\txl: $font-size-xl,\n\t\n\tfluid: 100%, // 100%\n\n\t2x: $font-size-base * 2,  // 26px\n\t2qx: $font-size-base * 2.25, // 29.25px\n\t2hx: $font-size-base * 2.5,  // 32.5px\n\t2tx: $font-size-base * 2.75, // 35.75px\n\n\t3x: $font-size-base * 3,  // 39px\n\t3qx: $font-size-base * 3.25, // 42.25px\n\t3hx: $font-size-base * 3.5,  // 45.5px\n\t3tx: $font-size-base * 3.75, // 48.75px\n\n\t4x: $font-size-base * 4,  // 52px\n\t4qx: $font-size-base * 4.25, // 55.25px\n\t4hx: $font-size-base * 4.5,  // 58.5px\n\t4tx: $font-size-base * 4.75, // 61.75px\n\t\n\t5x: $font-size-base * 5,  // 65px\n\t5qx: $font-size-base * 5.25, // 68.25px\n\t5hx: $font-size-base * 5.5,  // 71.5px\n\t5tx: $font-size-base * 5.75,  // 74.75px\n\n\t6x: $font-size-base * 6,  // 75px\n\t6qx: $font-size-base * 6.25, // 78.25px\n\t6hx: $font-size-base * 6.5,  // 81.5px\n\t6tx: $font-size-base * 6.75,  // 84.75px\n\n\t7x: $font-size-base * 7,  // 85px\n\t7qx: $font-size-base * 7.25, // 88.25px\n\t7hx: $font-size-base * 7.5,  // 91.5px\n\t7tx: $font-size-base * 7.75  // 94.75px\n) !default;\n\n$headings-font-weight: \t\t\t600 !default;\n$headings-color: \t\t\t\t$gray-900 !default;\n$headings-line-height:        \t1.2 !default;\n\n$display-font-sizes: (\n 1: 5rem,\n 2: 4.5rem,\n 3: 4rem,\n 4: 3.5rem,\n 5: 3rem,\n 6: 2.5rem\n) !default;\n\n$display-font-weight:  $font-weight-bolder !default;\n$display-line-height:  $headings-line-height !default;\n\n$blockquote-footer-color:     $gray-600 !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n$table-cell-padding-y:                      .75rem !default;\n$table-cell-padding-x:                      .75rem !default;\n$table-cell-padding-y-sm:                   .5rem !default;\n$table-cell-padding-x-sm:                   .5rem !default;\n\n$table-color:                               var(--#{$prefix}body-color) !default;\n$table-bg:                                  transparent !default;\n$table-accent-bg:                           transparent !default;\n$table-striped-color:                       $table-color !default;\n$table-striped-bg:                          rgba(var(--#{$prefix}gray-100-rgb), 0.75) !default;\n\n$table-active-color:                        $table-color !default;\n$table-active-bg:                           var(--#{$prefix}gray-100) !default;\n\n$table-hover-color:                         $table-color !default;\n$table-hover-bg:                            var(--#{$prefix}gray-100) !default;\n\n$table-border-factor:                       .1 !default;\n$table-border-width:                        $border-width !default;\n$table-border-color:                        var(--#{$prefix}border-color) !default;\n\n$table-caption-color:                       $text-muted !default;\n\n$table-loading-message-box-shadow:          0px 0px 50px 0px rgba(82,63,105, 0.15) !default;\n$table-loading-message-bg:                  var(--#{$prefix}body-bg) !default;\n$table-loading-message-color:               var(--#{$prefix}gray-700) !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n$input-btn-padding-y:                       .775rem !default;\n$input-btn-padding-x:                       1rem !default;\n$input-btn-font-family:                     null !default;\n$input-btn-font-size:                       $font-size-base * 1.1 !default;\n$input-btn-line-height:                     $line-height-base !default;\n\n$input-btn-focus-width:                     .25rem !default;\n$input-btn-focus-color-opacity:             .25 !default;\n$input-btn-focus-color:                     rgba(var(--#{$prefix}component-active-bg), $input-btn-focus-color-opacity) !default;\n$input-btn-focus-box-shadow:                null !default;\n\n\n$input-btn-padding-y-sm:                    .55rem !default;\n$input-btn-padding-x-sm:                    .75rem !default;\n$input-btn-font-size-sm:                    $font-size-sm !default;\n\n$input-btn-padding-y-lg:                    .825rem !default;\n$input-btn-padding-x-lg:                    1.5rem !default;\n$input-btn-font-size-lg:                    $font-size-base * 1.15 !default;\n\n$input-btn-border-width:                    $border-width !default;\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n$btn-padding-y:                             $input-btn-padding-y !default;\n$btn-padding-x:                             1.5rem !default;\n$btn-font-family:                           $input-btn-font-family !default;\n$btn-font-size:                             $input-btn-font-size !default;\n$btn-line-height:                           $input-btn-line-height !default;\n$btn-white-space:                           null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:                          $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:                          1rem !default;\n$btn-font-size-sm:                          $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:                          $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:                          1.75rem !default;\n$btn-font-size-lg:                          $input-btn-font-size-lg !default;\n\n$btn-border-width:                          $input-btn-border-width !default;\n\n$btn-font-weight:                           $font-weight-semibold !default;\n$btn-box-shadow:                            none !default;\n$btn-focus-width:                           $input-btn-focus-width !default;\n$btn-focus-box-shadow:                      none !default;\n$btn-disabled-opacity:                      .65 !default;\n$btn-active-box-shadow:                     none !default;\n\n$btn-link-color:                            var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:                      var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:                   var(--#{$prefix}gray-600) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:                         $border-radius !default;\n$btn-border-radius-sm:                      $border-radius-sm !default;\n$btn-border-radius-lg:                      $border-radius-lg !default;\n\n\n// Forms\n$form-text-margin-top:                      .5rem !default;\n$form-text-font-size:                       $font-size-sm !default;\n$form-text-color:                           var(--#{$prefix}text-muted) !default;\n\n$form-label-margin-bottom:                  .5rem !default;\n$form-label-font-size:                      1.05rem !default;\n$form-label-font-weight:                    500 !default;\n$form-label-color:                          var(--#{$prefix}gray-800) !default;\n\n$input-padding-y:                           $input-btn-padding-y !default;\n$input-padding-x:                           $input-btn-padding-x !default;\n$input-font-family:                         $input-btn-font-family !default;\n$input-font-size:                           $input-btn-font-size !default;\n$input-font-weight:                         $font-weight-semibold !default;\n$input-line-height:                         $input-btn-line-height !default;\n\n$input-bg:                                  var(--#{$prefix}body-bg) !default;\n\n$input-border-width:                    \t$input-btn-border-width !default;\n$input-color:                               var(--#{$prefix}gray-700) !default;\n$input-border-color:                        var(--#{$prefix}gray-300) !default;\n$input-box-shadow:\t\t\t\t\t\t\tfalse !default;\n$input-border-radius:                       $btn-border-radius !default;\n$input-border-radius-sm:                    $btn-border-radius-sm !default;\n$input-border-radius-lg:                    $btn-border-radius-lg !default;\n\n$input-focus-bg:                            $input-bg !default;\n$input-focus-border-color:                  var(--#{$prefix}gray-400) !default;\n$input-btn-focus-width:         \t\t\t.25rem !default;\n$input-focus-color:                         $input-color !default;\n$input-focus-width:                     \t$input-btn-focus-width !default;\n\n$input-disabled-color:                      var(--#{$prefix}gray-500) !default;\n$input-disabled-bg:                         var(--#{$prefix}gray-200) !default;\n$input-disabled-border-color:               $input-border-color !default;\n\n$input-placeholder-color:                   var(--#{$prefix}gray-500) !default;\n$input-plaintext-color:                     var(--#{$prefix}gray-700) !default;\n\n$inpur-autifill-bg-color:\t\t\t\t\tvar(--#{$prefix}gray-100) !default;\n\n// Keenthemes solid input style\n$input-solid-color:         \t            var(--#{$prefix}gray-700) !default;\n$input-solid-bg:                            var(--#{$prefix}gray-100) !default;\n$input-solid-bg-focus:                      var(--#{$prefix}gray-200) !default;\n$input-solid-placeholder-color:             var(--#{$prefix}gray-500) !default; \n\n\n// Form checks\n$form-check-input-width:                    1.75rem !default;\n$form-check-input-width-sm:                 1.55rem !default;\n$form-check-input-width-lg:                 2.25rem !default;\n$form-check-input-bg-size:                  60% 60% !default;\n$form-check-min-height:                     $font-size-base * $line-height-base !default;\n$form-check-padding-start:                  $form-check-input-width + .5rem !default;\n$form-check-padding-left:                   $form-check-input-width + .5rem !default;\n$form-check-margin-bottom:                  .125rem !default;\n$form-check-label-color:                    var(--#{$prefix}gray-500) !default;\n$form-check-label-color-checked:            var(--#{$prefix}gray-700) !default;\n$form-check-label-cursor:                   null !default;\n$form-check-transition:                     null !default;\n$form-check-inline-margin-right:            1rem !default;\n\n$form-check-input-active-filter:            brightness(90%) !default;\n\n$form-check-input-bg:                       transparent !default;\n$form-check-input-bg-solid:                 var(--#{$prefix}gray-200) !default;\n$form-check-input-border:                   1px solid $input-border-color !default;\n$form-check-input-border-radius:            .45em !default;\n$form-check-radio-border-radius:            50% !default;\n$form-check-input-focus-border:             $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:         none !default;\n\n$form-check-input-checked-color:                    $component-checked-color !default;\n$form-check-input-checked-bg-color:                 $component-checked-bg !default;\n$form-check-input-checked-border-color:             $component-checked-bg !default;\n$form-check-input-checked-bg-image:                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'><path d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n$form-check-radio-checked-bg-image:                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-checked-bg-color-solid:           $component-checked-bg !default;\n$form-check-input-focus-bg-color-solid:           \t$component-checked-bg !default;\n\n$form-check-input-indeterminate-color:              $component-checked-color  !default;\n$form-check-input-indeterminate-bg-color:           $component-checked-bg !default;\n$form-check-input-indeterminate-border-color:       $component-checked-bg !default;\n$form-check-input-indeterminate-bg-image:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:                 .5 !default;\n$form-check-label-disabled-opacity:                 $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:             $btn-disabled-opacity !default;\n\n$form-switch-color:                                 rgba($black, .25) !default;\n$form-switch-color-solid:                           $white !default;\n$form-switch-width:                                 3.25rem !default;\n$form-switch-height:                                2.25rem !default;\n$form-switch-width-sm:                              2.5rem !default;\n$form-switch-height-sm:                             1.5rem !default;\n$form-switch-width-lg:                              3.75rem !default;\n$form-switch-height-lg:                             2.75rem !default;\n\n$form-switch-padding-start:                         $form-switch-width + .5rem !default;\n$form-switch-padding-left:                          $form-switch-width + .5rem !default;\n$form-switch-bg-image:                              url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-bg-image-solid:                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-solid}'/></svg>\") !default;\n$form-switch-border-radius:                         $form-switch-width !default;\n\n$form-switch-focus-color:                          \t$form-switch-color !default;\n$form-switch-focus-bg-image:                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:                         $component-checked-color !default;\n$form-switch-checked-bg-image:                      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position:                   right center !default;\n\n\t\n// Input groups\n$input-group-addon-bg:                              var(--#{$prefix}gray-100) !default;\n$input-group-addon-color:                           var(--#{$prefix}gray-700) !default;\n$input-group-addon-border-color:                    $input-border-color !default;\n\n\n// Form select\n$form-select-color:                                 $input-color !default;\n$form-select-bg:                                    $input-bg !default;\n$form-select-disabled-color:                        $input-disabled-color !default;\n$form-select-disabled-bg:                           var(--#{$prefix}gray-200) !default;\n$form-select-disabled-border-color:                 $input-disabled-border-color !default;\n$form-select-indicator-color:                       $gray-600 !default;\n$form-select-indicator:                             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n$form-select-border-color:                          $input-border-color !default;\n$form-select-box-shadow:                            false !default;\n$form-select-focus-border-color:                    $input-focus-border-color !default;\n$form-select-focus-width:         \t\t\t\t\t$input-focus-width !default;\n$form-select-focus-box-shadow:                      0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n\n// Form range\n$form-range-track-border-radius:                    $border-radius !default;\n$form-range-track-bg:                               var(--#{$prefix}gray-300) !default;\n$form-range-thumb-disabled-bg:                      var(--#{$prefix}gray-500) !default;\n\n\n// Form file button\n$form-file-button-color:                            $input-color !default;\n$form-file-button-bg:                               $input-group-addon-bg !default;\n$form-file-button-hover-bg:                         shade-color($form-file-button-bg, 5%) !default;\n\n\n// Form floating\n$input-height-border:                   \t\t\t$input-border-width * 2 !default;\n$form-floating-height:            \t\t\t\t\tcalc(3.75rem + #{$input-height-border}) !default;\n$form-floating-input-padding-t:                     1.85rem !default;\n\n\n// Navs\n$nav-link-transition:               \t\t\t\tcolor .15s ease-in-out !default;\n$nav-tabs-border-color:                             var(--#{$prefix}border-color) !default;\n\n\n// Dropdowns\n// Dropdown menu container and contents.\n$dropdown-color:                                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                                       var(--#{$prefix}body-bg) !default;\n$dropdown-divider-bg:                               var(--#{$prefix}gray-100) !default;\n$dropdown-box-shadow:\t\t\t\t\t\t\t\t0px 0px 50px 0px rgba(82,63,105, 0.15) !default;\n$dropdown-border-radius:                            $border-radius !default;\n$dropdown-border-width:                             0rem !default;\n$dropdown-link-color:                               var(--#{$prefix}gray-900) !default;\n$dropdown-link-active-color:                        var(--#{$prefix}component-hover-color) !default;\n$dropdown-link-active-bg:                           var(--#{$prefix}component-hover-bg) !default;\n$dropdown-link-active-color:                        var(--#{$prefix}component-active-color) !default;\n$dropdown-link-active-bg:                           var(--#{$prefix}component-active-bg) !default;\n$dropdown-link-disabled-color:                      var(--#{$prefix}gray-500) !default;\n$dropdown-header-color:                             var(--#{$prefix}gray-600) !default;\n$dropdown-item-padding-y:           \t\t\t\t0.65rem !default;\n$dropdown-item-padding-x:           \t\t\t\t0.85rem !default;\n\n\n// Pagination\n$pagination-item-height:                            2.5rem !default;\n$pagination-item-bg:                                var(--#{$prefix}body-bg) !default;\n$pagination-item-space:                             0.5rem !default;\n$pagination-item-space-tablet-and-mobile:           0.25rem !default;\n$pagination-font-weight:                            $font-weight-semibold !default;\n$pagination-font-size:                              $font-size-lg !default;\n$pagination-icon-font-size:                         0.85rem !default;\n$pagination-icon-height:                            $pagination-item-height * 0.35 !default;\n\n$pagination-padding-y:                              .375rem !default;\n$pagination-padding-x:                              .75rem !default;\n$pagination-padding-y-sm:                           .25rem !default;\n$pagination-padding-x-sm:                           .5rem !default;\n$pagination-padding-y-lg:                           .75rem !default;\n$pagination-padding-x-lg:                           1.5rem !default;\n\n$pagination-color:                                  var(--#{$prefix}gray-700) !default;\n$pagination-bg:                                     transparent !default;\n$pagination-border-width:                           0 !default;\n$pagination-border-radius:                          $btn-border-radius !default;\n$pagination-margin-left:                            0 !default;\n$pagination-border-color:                           transparent !default;\n\n$pagination-focus-color:                            var(--#{$prefix}component-hover-color) !default;\n$pagination-focus-bg:                               var(--#{$prefix}component-hover-bg) !default;\n$pagination-focus-box-shadow:                       none !default;\n$pagination-focus-outline:                          0 !default;\n\n$pagination-hover-color:                            var(--#{$prefix}component-hover-color) !default;\n$pagination-hover-bg:                               var(--#{$prefix}component-hover-bg) !default;\n$pagination-hover-border-color:                     transparent !default;\n\n$pagination-active-color:                           var(--#{$prefix}component-active-color) !default;\n$pagination-active-bg:                              var(--#{$prefix}component-active-bg) !default;\n$pagination-active-border-color:                    transparent !default;\n\n$pagination-disabled-color:                         var(--#{$prefix}gray-400) !default;\n$pagination-disabled-bg:                            transparent !default;\n$pagination-disabled-border-color:                  transparent !default;\n\n// Card\n$card-box-shadow:                   \t\t\t\t0px 0px 20px 0px rgba(76,87,125,0.02) !default;\n$card-border-color:     \t\t\t\t\t\t\t$border-color !default;\n$card-border-width:                 \t\t\t\t1px !default;\n$card-border-style:                 \t\t\t\tsolid !default;\n$card-border-dashed-color:     \t\t\t\t\t\tvar(--#{$prefix}border-dashed-color) !default;\n$card-color:\t\t\t\t\t\t\t\t\t\tnull !default;\n$card-cap-bg:        \t\t\t\t\t\t\t\ttransparent !default;\n$card-py:      \t\t\t\t        \t\t\t\t2rem !default;\n$card-px:     \t\t\t\t\t    \t\t\t\t2.25rem !default;\n$card-border-radius:    \t\t\t\t\t\t\t$border-radius-lg !default;\n$card-header-py:                   \t\t\t\t\t0.5rem !default;\n$card-header-height: \t\t\t\t\t\t\t\t70px !default;\n$card-border-enabled:               \t\t\t\tfalse !default;\n$card-title-color:\t\t\t\t\t\t\t\t\tvar(--#{$prefix}gray-900) !default;\n \n// Accordion\n$accordion-color:                               var(--#{$prefix}body-color) !default;\n$accordion-bg:                                  var(--#{$prefix}body-bg) !default;\n$accordion-padding-y:                           1.5rem !default;\n$accordion-padding-x:                           1.5rem !default;\n$accordion-border-color:                        var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                       $border-radius !default;\n$accordion-button-color:                  \t\t$accordion-color !default;\n$accordion-button-bg:                           $accordion-bg !default;\n$accordion-button-active-bg:                    var(--#{$prefix}gray-100) !default;\n$accordion-button-active-color:                 var(--#{$prefix}primary) !default;\n$accordion-button-focus-border-color:           var(--#{$prefix}border-color)  !default;\n$accordion-button-focus-box-shadow:             none !default;\n\n$accordion-icon-width:                          1.15rem !default;\n$accordion-icon-color:                          $body-color !default;\n$accordion-icon-active-color:                   $primary !default;\n$accordion-button-icon:                         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:                  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n\n// Tooltips\n$tooltip-font-size:     \t\t\t\t1rem !default;\n$tooltip-max-width:     \t\t\t\t200px !default;\n$tooltip-color:      \t\t\t\t    var(--#{$prefix}gray-800) !default;\n$tooltip-bg:      \t\t\t\t        var(--#{$prefix}body-bg) !default;\n$tooltip-border-radius:    \t\t\t\t$btn-border-radius !default;\n$tooltip-opacity:       \t\t\t\t1 !default;\n$tooltip-box-shadow:    \t\t\t\t0px 0px 50px 0px rgba(82,63,105, 0.075) !default;\n$tooltip-padding-y:     \t\t\t\t.75rem !default;\n$tooltip-padding-x:     \t\t\t\t1rem !default;\n$tooltip-margin:     \t\t\t\t    0 !default;\n\n\n// Popovers\n$popover-bg:                            $body-bg !default;\n$popover-font-size:     \t\t\t\t$font-size-base !default;\n$popover-border-color:     \t\t\t\t$popover-bg !default;\n$popover-border-radius:    \t\t\t\t$border-radius !default;\n$popover-inner-border-radius:\t\t\t$border-radius !default;\n$popover-box-shadow:    \t\t\t\t$dropdown-box-shadow !default;\n$popover-header-bg:     \t\t\t\t$popover-bg !default;\n$popover-header-color:     \t\t\t\tvar(--#{$prefix}gray-800) !default;\n$popover-header-font-weight:     \t\t500 !default; \n$popover-header-font-size:    \t\t\t1rem !default; \n$popover-header-padding-y:    \t\t\t1rem !default;\n$popover-header-padding-x:    \t\t\t1.25rem !default;\n$popover-header-border-color:           $border-color !default; \n$popover-body-color:    \t\t\t\tvar(--#{$prefix}gray-800) !default;\n$popover-body-padding-y:                1.25rem !default;\n$popover-body-padding-x:                1.25rem !default;\n$popover-dissmis-btn-size:            \t1.25rem !default; \n$popover-dissmis-btn-top:               0.85rem !default; \n$popover-dissmis-btn-end:               0.85rem !default; \n\n\n// Toasts\n$toast-color:                           var(--#{$prefix}gray-700) !default;\n$toast-background-color:                var(--#{$prefix}body-bg) !default;\n$toast-box-shadow:                      var(--#{$prefix}box-shadow) !default;\n$toast-header-color:                    var(--#{$prefix}gray-700) !default;\n$toast-header-background-color:         var(--#{$prefix}body-bg) !default;\n$toast-header-border-color:             var(--#{$prefix}border-color) !default;\n$toast-border-color:                \ttransparent !default;\n\n\n// Badges\n$badge-font-size:               0.85rem !default;\n$badge-font-size-sm:            0.8rem !default;\n$badge-font-size-lg:            1rem !default;\n$badge-font-weight:             $font-weight-bold !default;\n$badge-color:                   var(--#{$prefix}body-color) !default;\n$badge-padding-y:               .325rem !default;\n$badge-padding-x:               .5rem !default;\n$badge-border-radius:           $border-radius-sm !default;\n$badge-size:                    1.75rem !default;\n$badge-size-sm:                 1.5rem !default;\n$badge-size-lg:                 2rem !default;\n\n// Modals\n// Padding applied to the modal body\n$modal-inner-padding:     \t\t\t\t\t    1.75rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:    \t\t\t\t.5rem !default;\n\n$modal-dialog-margin:      \t\t\t\t        .5rem !default;\n$modal-dialog-margin-y-sm-up:    \t\t\t\t1.75rem !default;\n\n$modal-content-color:      \t\t\t\t        null !default;\n$modal-content-bg:      \t\t\t\t        var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:  \t\t\t\t    null !default;\n$modal-content-border-width:  \t\t\t\t    0 !default;\n$modal-content-border-radius:    \t\t\t\t$border-radius !default;\n$modal-content-inner-border-radius: \t\t\t$border-radius !default;\n$modal-content-box-shadow:    \t\t\t\t    0 .25rem .5rem rgba($black, .05) !default;\n$modal-content-box-shadow-xs:    \t\t\t\t0 .25rem .5rem rgba($black, .1) !default;\n$modal-content-box-shadow-sm-up:   \t\t\t\t0 .5rem 1rem rgba($black, .1) !default;\n\n$modal-backdrop-bg:    \t\t \t\t\t        $black !default;\n$modal-backdrop-opacity:   \t\t\t\t        0.4 !default;\n\n$modal-header-border-color:                     var(--#{$prefix}border-color) !default;\n$modal-footer-border-color:                     $modal-header-border-color !default;\n$modal-header-border-width:                     1px !default;\n\n\n// Progress bars\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}gray-100) !default;\n$progress-border-radius:            6px !default;\n$progress-box-shadow:               none !default;\n\n\n// List group\n$list-group-color:                          var(--#{$prefix}gray-900) !default;\n$list-group-bg:                             $white !default;\n$list-group-border-color:                   rgba($black, .125) !default;\n\n$list-group-hover-bg:                       var(--#{$prefix}gray-100) !default;\n$list-group-active-color:                   var(--#{$prefix}component-active-color) !default;\n$list-group-active-bg:                      var(--#{$prefix}component-active-bg) !default;\n$list-group-active-border-color:            $list-group-active-bg !default;\n\n$list-group-disabled-color:                 var(--#{$prefix}gray-600) !default;\n$list-group-disabled-bg:                    $list-group-bg !default;\n\n$list-group-action-color:                   var(--#{$prefix}gray-700) !default;\n$list-group-action-hover-color:             $list-group-action-color !default;\n\n$list-group-action-active-color:            var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:               var(--#{$prefix}gray-200) !default;\n\n// Image thumbnails\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n\n\n// Figures\n$figure-caption-color:              var(--#{$prefix}gray-600) !default;\n\n\n// Breadcrumbs\n$breadcrumb-bg:                         null !default;\n$breadcrumb-divider-color:              var(--#{$prefix}gray-600) !default;\n$breadcrumb-active-color:               var(--#{$prefix}primary) !default;\n$breadcrumb-item-padding-x:             .5rem !default;\n\n\n// Carousel\n$carousel-custom-indicator-transition-speed:                    0.3s !default;\n$carousel-custom-indicator-default-bg-color:                    var(--#{$prefix}gray-200) !default;\n$carousel-custom-indicator-active-bg-color:                     var(--#{$prefix}gray-400) !default;\n\n$carousel-custom-dots-indicator-default-size:                   9px !default;\n$carousel-custom-dots-indicator-active-size:                    13px !default;\n\n$carousel-custom-bullet-indicator-default-size:                 6px !default;\n$carousel-custom-bullet-indicator-active-width:                 16px !default;\n$carousel-custom-bullet-indicator-default-bg-color:             var(--#{$prefix}gray-400) !default;\n$carousel-custom-bullet-indicator-active-bg-color:              var(--#{$prefix}gray-600) !default;\n\n// Spinners\n$spinner-border-width:   \t\t\t\t\t.185rem !default;\n$spinner-animation-speed:   \t\t\t\t.65s !default;\n$spinner-border-width-sm:   \t\t\t\t.145em !default;\n\n\n// Close\n$btn-close-width:            \t\t\t\t0.75rem !default;\n$btn-close-height:           \t\t\t\t$btn-close-width !default;\n$btn-close-color:            \t\t\t\t$black !default;\n$btn-close-bg:               \t\t\t\turl(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:\t\t\t\t\tnone !default;\n\n// Code\n$code-bg:                   #f1f3f8 !default;\n$code-shadow:\t\t\t\t0px 3px 9px rgba(0,0,0,.08);\n$code-color:                #b93993 !default;\n$code-border-color:         transparent !default;\n$code-padding:              0.1rem 0.4rem !default;\n$code-margin:               0 0.5rem !default;\n$code-font-size: \t\t\t1rem !default;\n$code-font-weight:          400 !default;\n$code-border-radius:        0.3rem !default; \n$code-space:                0.25rem !default;\n\n// Opacity\n$opacity-values: (\n\t0: 0,\n\t5: .05,\n\t10: .1,\n\t15: .15,\n\t20: .20,\n\t25: .25,\n\t50: .5,\n\t75: .75,\n\t100: 1,\n ) !default;\n\n// Zindex\n$zindex-values: (\n\tn1: -1,\n\tn2: -2,\n\t0: 0,\n\t1: 1,\n\t2: 2,\n\t3: 3\n) !default;\n\n// Letter spacing\n$letter-spacing-values: (\n\t1: 0.1rem,\n\t2: 0.115rem,\n\t3: 0.125rem,\n\t4: 0.25rem,\n\t5: 0.5rem,\n\tn1: -0.1rem,\n\tn2: -0.115rem,\n\tn3: -0.125rem,\n\tn4: -0.25rem,\n\tn5: -0.5rem,\n) !default;\n\n// Keenthemes hight and width sizes\n$custom-sizes: (\n\tunset: unset,\n\t25: 25%,\n\t50: 50%,\n\t75: 75%,\n\t100: 100%,\n\tauto: auto,\n\t1px: 1px,\n\t2px: 2px,\n\t3px: 3px,\n\t4px: 4px,\n\t5px: 5px,\n\t6px: 6px,\n\t7px: 7px,\n\t8px: 8px,\n\t9px: 9px,\n\t10px: 10px,\n\t15px: 15px,\n\t20px: 20px,\n\t25px: 25px,\n\t30px: 30px,\n\t35px: 35px,\n\t40px: 40px,\n\t45px: 45px,\n\t50px: 50px,\n\t55px: 55px,\n\t60px: 60px,\n\t65px: 65px,\n\t70px: 70px,\n\t75px: 75px,\n\t80px: 80px,\n\t85px: 85px,\n\t90px: 90px,\n\t95px: 95px,\n\t100px: 100px,\n\t125px: 125px,\n\t150px: 150px,\n\t175px: 175px,\n\t200px: 200px,\n\t225px: 225px,\n\t250px: 250px,\n\t275px: 275px,\n\t300px: 300px,\n\t325px: 325px,\n\t350px: 350px,\n\t375px: 375px,\n\t400px: 400px,\n\t425px: 425px,\n\t450px: 450px,\n\t475px: 475px,\n\t500px: 500px,\n\t550px: 550px,\n\t600px: 600px,\n\t650px: 650px,\n\t700px: 700px,\n\t750px: 750px,\n\t800px: 800px,\n\t850px: 850px,\n\t900px: 900px,\n\t950px: 950px,\n\t1000px: 1000px\n) !default;\n\n\n// Keenthemes symbol component\n$symbol-sizes: (\n\t20px: 20px,\n\t25px: 25px,\n\t30px: 30px,\n\t35px: 35px,\n\t40px: 40px,\n\t45px: 45px,\n\tdefault: 50px,\n\t50px: 50px,\n\t55px: 55px,\n\t60px: 60px,\n\t65px: 65px,\n\t70px: 70px,\n\t75px: 75px,\n\t90px: 90px,\n\t100px:100px,\n\t125px:125px,\n\t150px:150px,\n\t160px:160px,\n\t175px:175px,\n\t200px:200px\n) !default;\n\n$symbol-border-color: rgba(var(--#{$prefix}body-bg), 0.5);\n$symbol-label-color: var(--#{$prefix}gray-800);\n$symbol-label-bg: var(--#{$prefix}gray-100);\n\n// Keenthemes timeline component\n$timeline-icon-size: 38px;\n$timeline-icon-space: 0.35rem;\n\n\n// Keenthemes bullet component\n$bullet-bg-color: var(--#{$prefix}gray-400) !default;\n$bullet-dot-size: 4px !default;\n$bullet-bar-height: 4px !default;\n$bullet-bar-width: 8px !default;\n$bullet-bar-border-radius: 6px !default;\n$bullet-line-height: 1px !default;\n$bullet-line-width: 5px !default;\n\n\n// Keenthemes scrolltop component\n$scrolltop-z-index: 105 !default;\n$scrolltop-opacity: 0 !default;\n$scrolltop-opacity-on: 0.3 !default;\n$scrolltop-opacity-hover: 1 !default;\n$scrolltop-bottom: 40px !default;\n$scrolltop-bottom-mobile: 30px !default;\n$scrolltop-end: 20px !default;\n$scrolltop-end-mobile: 15px !default;\n$scrolltop-size: 36px !default;\n$scrolltop-size-mobile: 30px !default;\n$scrolltop-box-shadow: var(--#{$prefix}box-shadow) !default;\n$scrolltop-bg-color: var(--#{$prefix}primary) !default;\n$scrolltop-bg-color-hover: var(--#{$prefix}primary) !default;\n$scrolltop-icon-color: var(--#{$prefix}primary-inverse) !default;\n$scrolltop-icon-color-hover: var(--#{$prefix}primary-inverse) !default;\n\n// Keenthemes sticky toolbar component\n$sticky-toolbar-z-index: 95 !default;\n\n\n// Keenthemes drawer component\n$drawer-z-index: 110 !default;\n$drawer-box-shadow: 0px 1px 9px -3px rgba(0,0,0, 0.05) !default;\n$drawer-bg-color: $body-bg !default;\n$drawer-transition-speed: 0.3s !default;\n$drawer-overlay-bg-color: rgba($black, 0.2) !default;\n$drawer-overlay-animation-speed: 0.3s !default;\n\n// Keenthemes menu component   \n$menu-dropdown-box-shadow: $dropdown-box-shadow !default;\n$menu-dropdown-z-index: 107 !default;\n$menu-dropdown-bg-color: $dropdown-bg !default;\n$menu-dropdown-border-radius: $dropdown-border-radius !default;\n$menu-dropdown-animation: true !default;\n$menu-dropdown-animation-speed: 0.3s !default;\n$menu-dropdown-animation-move-offset: 0.75rem !default;\n$menu-accordion-indention: 1rem !default;\n$menu-accordion-arrow-transition: transform 0.3s ease !default;\n$menu-item-padding-y: 0.15rem !default;\n$menu-item-padding-x: 0 !default;\n$menu-link-padding-y: 0.65rem !default;\n$menu-link-padding-x: 1rem !default;\n$menu-link-border-radius: $border-radius !default;\n$menu-link-color-hover: $component-hover-color !default;\n$menu-link-color-show: $component-hover-color !default;\n$menu-link-color-here: $component-hover-color !default;\n$menu-link-color-active: $component-hover-color !default;\n$menu-link-bg-color-hover: $component-hover-bg !default;\n$menu-link-bg-color-show: $component-hover-bg !default;\n$menu-link-bg-color-here: $component-hover-bg !default;\n$menu-link-bg-color-active: $component-hover-bg !default;\n$menu-icon-size: 2rem !default;\n$menu-icon-space: 0.5rem !default;\n$menu-bullet-size: 1.25rem !default;\n$menu-bullet-space: 0.5rem !default;\n$menu-badge-space: 0.5rem !default;\n$menu-arrow-size: 9px !default;\n$menu-arrow-space: 5px !default;\n$menu-heading-color: $text-muted !default;\n\n// Keenthemes tree component\n$tree-icon-size: 16px !default;\n$tree-icon-gap: 14px !default;\n$tree-node-padding-y: 0.35rem !default;\n$tree-node-padding-x: 1.25rem !default;\n\n\n// Keenthemes scrollbar component \n$scrollbar-size: 5px !default;\n$scrollbar-overlay-size: 19px !default;\n$scrollbar-overlay-space: 7px !default;\n$scrollbar-color: $gray-200 !default;\n$scrollbar-hover-color: $gray-300 !default;\n$body-scrollbar-width: 15px !default;\n\n// Keenthemes overlay component \n$overlay-bg: rgba($black, 0.05)  !default;\n\n// Keenthemes blockui component \n$blockui-overlay-bg: rgba($black, 0.05) !default;\n$blockui-message-bg: $tooltip-bg !default;\n$blockui-message-box-shadow: $tooltip-box-shadow !default;\n\n// Keenthemes rating component \n$rating-color-default: $gray-400 !default;\n$rating-color-active: #FFAD0F !default;\n\n// Keenthemes ribbon component \n$ribbon-label-box-shadow: 0px -1px 5px 0px rgba($dark, 0.1) !default;\n$ribbon-label-bg: $primary !default;\n$ribbon-label-border-color: darken($primary, 20%) !default;\n$ribbon-clip-bg: $dark !default;\n\n// Keenthemes fixed component \n$fixed-z-index: 101 !default;\n\n// Engage panel\n$engage-btn-bg: $body-bg;\n$engage-btn-box-shadow: 0px 0px 22px #E0E0E0;\n$engage-btn-border-color: #E8E8E8;\n$engage-btn-color: $gray-800;\n$engage-btn-icon-color: $gray-600;\n$engage-btn-color-active: $gray-800;\n$engage-z-index: 5;\n\n// Social Network Colors Used With Boostrap Buttons(see: https://brandcolors.net)\n$social-colors: (\n\tfacebook: (\n\t\tbase: #3b5998,\n\t\tinverse: #ffffff,\n\t\tlight: rgba(#3b5998, 0.1),\n\t\tactive: darken(#3b5998, 7.5%)\n\t),\n\tgoogle: (\n\t\tbase: #dd4b39,\n\t\tinverse: #ffffff,\n\t\tlight: rgba(#dd4b39, 0.1),\n\t\tactive: darken(#dd4b39, 7.5%)\n\t),\n\ttwitter: (\n\t\tbase: #1da1f2,\n\t\tinverse: #ffffff,\n\t\tlight: rgba(#1da1f2, 0.1),\n\t\tactive: darken(#1da1f2, 7.5%)\n\t),\n\tinstagram: (\n\t\tbase: #e1306c,\n\t\tinverse: #ffffff,\n\t\tlight: rgba(#e1306c, 0.1),\n\t\tactive: darken(#e1306c, 7.5%)\n\t),\n\tyoutube: (\n\t\tbase: #ff0000,\n\t\tinverse: #ffffff,\n\t\tlight: rgba(#ff0000, 0.1),\n\t\tactive: darken(#ff0000, 7.5%)\n\t),\n\tlinkedin: (\n\t\tbase: #0077b5,\n\t\tinverse: #ffffff,\n\t\tlight: rgba(#0077b5, 0.1),\n\t\tactive: darken(#0077b5, 7.5%)\n\t)\n) !default;","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n\n    @each $value in $shadow {\n      @if $value != null {\n        $result: append($result, $value, \"comma\");\n      }\n      @if $value == none and length($shadow) > 1 {\n        @warn \"The keyword 'none' must be used as a single argument.\";\n      }\n    }\n\n    @if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","//\n// CSS Variables\n//\n\n:root {\n    // Breakpoints\n    @each $breakpoint, $value in $grid-breakpoints {\n        --#{$prefix}#{$breakpoint}:#{$value};\n    }\n\n    // Keenthemes scrollbar component \n    --#{$prefix}scrollbar-size: #{$scrollbar-size};\n    --#{$prefix}scrollbar-overlay-size: #{$scrollbar-overlay-size};\n    --#{$prefix}scrollbar-overlay-space: #{$scrollbar-overlay-space};\n\n    // Bootstrap general    \n    --#{$prefix}white-bg-rgb: #{to-rgb($white)};\n    --#{$prefix}black-bg-rgb: #{to-rgb($black)};\n}\n\n@include color-mode(light) {\n    // Bootstrap muted color\n    --#{$prefix}text-muted: #{$text-muted};\n\n    // Grey colors\n    @each $name, $value in $grays {\n        --#{$prefix}gray-#{$name}: #{$value};\n        --#{$prefix}gray-#{$name}-rgb: #{to-rgb($value)};\n    }\n\n    // Contextual colors\n    @each $name, $value in $theme-colors {\n        --#{$prefix}#{$name}: #{$value};\n    }\n\n    // Contextual active state colors\n    @each $name, $value in $theme-active-colors {\n        --#{$prefix}#{$name}-active: #{$value};\n    }\n\n    // Contextual light state colors\n    @each $name, $value in $theme-light-colors {\n        --#{$prefix}#{$name}-light: #{$value};\n    }\n\n    // Contextual inverse state colors\n    @each $name, $value in $theme-inverse-colors {\n        --#{$prefix}#{$name}-inverse: #{$value};\n    }\n\n    // Contextual clarity state colors\n    @each $name, $value in $theme-clarity-colors {\n        --#{$prefix}#{$name}-clarity: #{$value};\n    }\n\n    // Contextual rbg colors\n    @each $name, $value in $theme-colors {\n        --#{$prefix}#{$name}-rgb: #{to-rgb($value)};\n    }\n\n    // Text colors\n    @each $name, $value in $theme-text-colors {\n        --#{$prefix}text-#{$name}: #{$value};\n    }\n\n    // Components\n    --#{$prefix}border-color: #{$border-color};\n    --#{$prefix}border-dashed-color: #{$border-dashed-color};\n\n    --#{$prefix}component-active-color: #{$component-active-color};\n    --#{$prefix}component-active-bg: #{$component-active-bg};\n    --#{$prefix}component-hover-color: #{$component-hover-color};\n    --#{$prefix}component-hover-bg: #{$component-hover-bg};\n    --#{$prefix}component-checked-color: #{$component-checked-color};\n    --#{$prefix}component-checked-bg: #{$component-checked-bg};\n\n    // Box shadow\n    --#{$prefix}box-shadow-xs: #{$box-shadow-xs};\n    --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n    --#{$prefix}box-shadow: #{$box-shadow};\n    --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n\n    // Forms\n    --#{$prefix}input-bg: #{$input-bg};\n    --#{$prefix}input-color: #{$input-color};\n    --#{$prefix}input-solid-color: #{$input-solid-color};\n    --#{$prefix}input-solid-bg: #{$input-solid-bg};\n    --#{$prefix}input-solid-bg-focus: #{$input-solid-bg-focus};\n    --#{$prefix}input-solid-placeholder-color: #{$input-solid-placeholder-color};\n\n    // Card\n    --#{$prefix}root-card-box-shadow: #{$card-box-shadow};\n    --#{$prefix}root-card-border-color: #{$card-border-color};\n\n    // Tooltip\n    --#{$prefix}tooltip-box-shadow: #{$tooltip-box-shadow-dark};\n\n    // Table\n    --#{$prefix}table-striped-bg: #{$table-striped-bg};\n    --#{$prefix}table-loading-message-box-shadow: #{$table-loading-message-box-shadow};\n\n    // Dropdowns\n    --#{$prefix}dropdown-bg: #{$dropdown-bg};\n    --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n\n    // Code\n    --#{$prefix}code-bg: #{$code-bg};\n    --#{$prefix}code-shadow: #{$code-shadow};\n    --#{$prefix}code-border-color: #{$code-border-color};\n    --#{$prefix}code-color: #{$code-color};  \n\n    // Symbol\n    --#{$prefix}symbol-label-color: #{$symbol-label-color};\n    --#{$prefix}symbol-label-bg: #{$symbol-label-bg};\n    --#{$prefix}symbol-border-color: #{$symbol-border-color};   \n\n    // Bullet\n    --#{$prefix}bullet-bg-color: #{$bullet-bg-color};\n\n    // Scrolltop\n    --#{$prefix}scrolltop-opacity: #{$scrolltop-opacity};\n    --#{$prefix}scrolltop-opacity-on: #{$scrolltop-opacity-on};\n    --#{$prefix}scrolltop-opacity-hover: #{$scrolltop-opacity-hover};\n    --#{$prefix}scrolltop-box-shadow: #{$scrolltop-box-shadow};\n    --#{$prefix}scrolltop-bg-color: #{$scrolltop-bg-color};\n    --#{$prefix}scrolltop-bg-color-hover: #{$scrolltop-bg-color-hover};\n    --#{$prefix}scrolltop-icon-color: #{$scrolltop-icon-color};\n    --#{$prefix}scrolltop-icon-color-hover: #{$scrolltop-icon-color-hover};\n\n    // Keenthemes drawer component\n    --#{$prefix}drawer-box-shadow: #{$drawer-box-shadow};\n    --#{$prefix}drawer-bg-color: #{$drawer-bg-color};\n    --#{$prefix}drawer-overlay-bg-color: #{$drawer-overlay-bg-color};\n\n    // Keenthemes menu component\n    --#{$prefix}menu-dropdown-box-shadow: #{$menu-dropdown-box-shadow};\n    --#{$prefix}menu-dropdown-bg-color: #{$menu-dropdown-bg-color};\n    --#{$prefix}menu-heading-color: #{$menu-heading-color};\n    --#{$prefix}menu-link-color-hover: #{$menu-link-color-hover};\n    --#{$prefix}menu-link-color-show: #{$menu-link-color-show};\n    --#{$prefix}menu-link-color-here: #{$menu-link-color-here};\n    --#{$prefix}menu-link-color-active: #{$menu-link-color-active};\n    --#{$prefix}menu-link-bg-color-hover: #{$menu-link-bg-color-hover};\n    --#{$prefix}menu-link-bg-color-show: #{$menu-link-bg-color-show};\n    --#{$prefix}menu-link-bg-color-here: #{$menu-link-bg-color-here};\n    --#{$prefix}menu-link-bg-color-active: #{$menu-link-bg-color-active};    \n\n    // Keenthemes scrollbar component \n    --#{$prefix}scrollbar-color: #{$scrollbar-color};\n    --#{$prefix}scrollbar-hover-color: #{$scrollbar-hover-color};\n\n    // Keenthemes overlay component \n    --#{$prefix}overlay-bg: #{$overlay-bg};\n\n    // Keenthemes blockui component\n    --#{$prefix}blockui-overlay-bg: #{$blockui-overlay-bg};\n\n    // Keenthemes rating component\n    --#{$prefix}rating-color-default: #{$rating-color-default};\n    --#{$prefix}rating-color-active: #{$rating-color-active};\n\n    // Keenthemes ribbon component \n    --#{$prefix}ribbon-label-box-shadow: #{$ribbon-label-box-shadow};\n    --#{$prefix}ribbon-label-bg: #{$ribbon-label-bg};\n    --#{$prefix}ribbon-label-border-color: #{$ribbon-label-border-color};\n    --#{$prefix}ribbon-clip-bg: #{$ribbon-clip-bg}; \n\n    // Engage panel\n    --#{$prefix}engage-btn-bg: #{$engage-btn-bg};\n    --#{$prefix}engage-btn-box-shadow: #{$engage-btn-box-shadow};\n    --#{$prefix}engage-btn-border-color: #{$engage-btn-border-color};\n    --#{$prefix}engage-btn-color: #{$engage-btn-color};\n    --#{$prefix}engage-btn-icon-color: #{$engage-btn-icon-color};\n    --#{$prefix}engage-btn-color-active: #{$engage-btn-color-active};\n}\n\n@include color-mode(dark) {\n    // Bootstrap muted color\n    --#{$prefix}text-muted: #{$text-muted-dark};\n\n    // Grey colors\n    @each $name, $value in $grays-dark {\n        --#{$prefix}gray-#{$name}: #{$value};\n        --#{$prefix}gray-#{$name}-rgb: #{to-rgb($value)};\n    }\n\n    // Contextual colors\n    @each $name, $value in $theme-colors-dark {\n        --#{$prefix}#{$name}: #{$value};\n    }\n\n    // Contextual active state colors\n    @each $name, $value in $theme-active-colors-dark {\n        --#{$prefix}#{$name}-active: #{$value};\n    }\n\n    // Contextual light state colors\n    @each $name, $value in $theme-light-colors-dark {\n        --#{$prefix}#{$name}-light: #{$value};\n    }\n\n    // Contextual inverse state colors\n    @each $name, $value in $theme-inverse-colors-dark {\n        --#{$prefix}#{$name}-inverse: #{$value};\n    }\n\n    // Contextual clarity state colors\n    @each $name, $value in $theme-clarity-colors-dark {\n        --#{$prefix}#{$name}-clarity: #{$value};\n    }\n\n    // Contextual rbg colors\n    @each $name, $value in $theme-colors-dark {\n        --#{$prefix}#{$name}-rgb: #{to-rgb($value)};\n    }\n\n    // Text colors\n    @each $name, $value in $theme-text-colors-dark {\n        --#{$prefix}text-#{$name}: #{$value};\n    }\n    \n    // Components\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-dashed-color: #{$border-dashed-color-dark};\n\n    --#{$prefix}component-active-color: #{$component-active-color-dark};\n    --#{$prefix}component-active-bg: #{$component-active-bg-dark};\n    --#{$prefix}component-hover-color: #{$component-hover-color-dark};\n    --#{$prefix}component-hover-bg: #{$component-hover-bg-dark};\n    --#{$prefix}component-checked-color: #{$component-checked-color-dark};\n    --#{$prefix}component-checked-bg: #{$component-checked-bg-dark};\n\n    // Box shadow\n    --#{$prefix}box-shadow-xs: #{$box-shadow-xs-dark};\n    --#{$prefix}box-shadow-sm: #{$box-shadow-sm-dark};\n    --#{$prefix}box-shadow: #{$box-shadow-dark};\n    --#{$prefix}box-shadow-lg: #{$box-shadow-lg-dark};\n\n    // Forms\n    --#{$prefix}input-color: #{$input-color};\n    --#{$prefix}input-bg: #{$input-bg};\n    --#{$prefix}input-solid-color: #{$input-solid-color};\n    --#{$prefix}input-solid-bg: #{$input-solid-bg};\n    --#{$prefix}input-solid-bg-focus: #{$input-solid-bg-focus};\n    --#{$prefix}input-solid-placeholder-color: #{$input-solid-placeholder-color};\n\n    // Tooltip\n    --#{$prefix}tooltip-box-shadow: #{$tooltip-box-shadow-dark};\n\n    // Card\n    --#{$prefix}root-card-box-shadow: #{$card-box-shadow-dark};\n    --#{$prefix}root-card-border-color: #{$card-border-color-dark};\n\n    // Table\n    --#{$prefix}table-striped-bg: #{$table-striped-bg-dark};\n    --#{$prefix}table-loading-message-box-shadow: #{$table-loading-message-box-shadow-dark};\n\n    // Dropdowns\n    --#{$prefix}dropdown-bg: #{$dropdown-bg-dark};\n    --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow-dark};\n\n    // Code\n    --#{$prefix}code-bg: #{$code-bg-dark};\n    --#{$prefix}code-shadow: #{$code-shadow-dark};\n    --#{$prefix}code-border-color: #{$code-border-color-dark};\n    --#{$prefix}code-color: #{$code-color-dark};  \n\n    // Symbol\n    --#{$prefix}symbol-label-color: #{$symbol-label-color-dark};\n    --#{$prefix}symbol-label-bg: #{$symbol-label-bg-dark};\n    --#{$prefix}symbol-border-color: #{$symbol-border-color-dark};   \n\n    // Bullet\n    --#{$prefix}bullet-bg-color: #{$bullet-bg-color-dark};\n\n    // Scrolltop\n    --#{$prefix}scrolltop-opacity: #{$scrolltop-opacity-dark};\n    --#{$prefix}scrolltop-opacity-on: #{$scrolltop-opacity-on-dark};\n    --#{$prefix}scrolltop-opacity-hover: #{$scrolltop-opacity-hover-dark};\n    --#{$prefix}scrolltop-box-shadow: #{$scrolltop-box-shadow-dark};\n    --#{$prefix}scrolltop-bg-color: #{$scrolltop-bg-color-dark};\n    --#{$prefix}scrolltop-bg-color-hover: #{$scrolltop-bg-color-hover-dark};\n    --#{$prefix}scrolltop-icon-color: #{$scrolltop-icon-color-dark};\n    --#{$prefix}scrolltop-icon-color-hover: #{$scrolltop-icon-color-hover-dark};\n\n    // Keenthemes drawer component\n    --#{$prefix}drawer-box-shadow: #{$drawer-box-shadow-dark};\n    --#{$prefix}drawer-bg-color: #{$drawer-bg-color-dark};\n    --#{$prefix}drawer-overlay-bg-color: #{$drawer-overlay-bg-color-dark};\n\n    // Keenthemes menu component\n    --#{$prefix}menu-dropdown-box-shadow: #{$menu-dropdown-box-shadow-dark};\n    --#{$prefix}menu-dropdown-bg-color: #{$menu-dropdown-bg-color-dark};\n    --#{$prefix}menu-heading-color: #{$menu-heading-color-dark};\n    \n    --#{$prefix}menu-link-color-hover: #{$menu-link-color-hover-dark};\n    --#{$prefix}menu-link-color-show: #{$menu-link-color-show-dark};\n    --#{$prefix}menu-link-color-here: #{$menu-link-color-here-dark};\n    --#{$prefix}menu-link-color-active: #{$menu-link-color-active-dark};\n    --#{$prefix}menu-link-bg-color-hover: #{$menu-link-bg-color-hover-dark};\n    --#{$prefix}menu-link-bg-color-show: #{$menu-link-bg-color-show-dark};\n    --#{$prefix}menu-link-bg-color-here: #{$menu-link-bg-color-here-dark};\n    --#{$prefix}menu-link-bg-color-active: #{$menu-link-bg-color-active-dark};\n    \n    // Keenthemes scrollbar component \n    --#{$prefix}scrollbar-color: #{$scrollbar-color-dark};\n    --#{$prefix}scrollbar-hover-color: #{$scrollbar-hover-color-dark};\n\n    // Keenthemes overlay component \n    --#{$prefix}overlay-bg: #{$overlay-bg-dark};\n\n    // Keenthemes blockui component\n    --#{$prefix}blockui-overlay-bg: #{$blockui-overlay-bg-dark};\n\n    // Keenthemes rating component\n    --#{$prefix}rating-color-default: #{$rating-color-default-dark};\n    --#{$prefix}rating-color-active: #{$rating-color-active-dark};\n\n    // Keenthemes ribbon component \n    --#{$prefix}ribbon-label-box-shadow: #{$ribbon-label-box-shadow-dark};\n    --#{$prefix}ribbon-label-bg: #{$ribbon-label-bg-dark};\n    --#{$prefix}ribbon-label-border-color: #{$ribbon-label-border-color-dark};\n    --#{$prefix}ribbon-clip-bg: #{$ribbon-clip-bg-dark};  \n\n    // Engage panel\n    --#{$prefix}engage-btn-bg: #{$engage-btn-bg-dark};\n    --#{$prefix}engage-btn-box-shadow: #{$engage-btn-box-shadow-dark};\n    --#{$prefix}engage-btn-border-color: #{$engage-btn-border-color-dark};\n    --#{$prefix}engage-btn-color: #{$engage-btn-color-dark};\n    --#{$prefix}engage-btn-icon-color: #{$engage-btn-icon-color-dark};\n    --#{$prefix}engage-btn-color-active: #{$engage-btn-color-active-dark};\n}","//\n// Reboot\n//\n\nh1, h2, h3, h4, h5, h6 {\n\toutline: 0;\n}\n","\n\n.blockquote-footer {\n\tcolor: var(--#{$prefix}blockquote-footer-color);\n}\n\n.list-style-none {\n\tlist-style: none;\n}","//\n// Theme Modes\n//\n\n// Used for theme mode switching via JS\n[data-kt-theme-mode-switching=\"true\"] * {\n    transition: none !important;\n}\n\n// Light mode\n@include color-mode(light) {\n\t.theme-dark-show {\n\t\tdisplay: none !important;\t\t\n\t}\n\n\t.theme-light-bg-transparent {\n\t\tbackground-color: transparent !important;\t\n\t}\n\n\t.theme-light-bg-body {\n\t\tbackground-color: var(--#{$prefix}body-bg) !important;\t\n\t}\n}\n\n// Dark mode\n@include color-mode(dark) {\n\t.theme-light-show {\n\t\tdisplay: none !important;\t\t\n\t}\n\n\t.theme-dark-bg-transparent {\n\t\tbackground-color: transparent !important;\t\n\t}\n\n\t.theme-dark-bg-body {\n\t\tbackground-color: var(--#{$prefix}body-bg) !important;\t\n\t}\n}","//\n// Animation\n//\n\n// Base\n.animation {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n\n// Slide In Down\n@keyframes animationSlideInDown {\n    from {\n        transform: translate3d(0, -100%, 0);\n        visibility: visible;\n    }\n\n    to {\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n.animation-slide-in-down {\n    animation-name: animationSlideInDown;\n}\n\n// Slide In Up\n@keyframes animationSlideInUp {\n    from {\n        transform: translate3d(0, 100%, 0);\n        visibility: visible;\n    }\n\n    to {\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n.animation-slide-in-up {\n    animation-name: animationSlideInUp;\n}\n\n// Fade In\n@keyframes animationFadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.animation-fade-in {\n    animation-name: animationFadeIn;\n}\n\n// Fade Out\n@keyframes animationFadeOut {\n    from {\n        opacity: 1;\n    }\n\n    to {\n        opacity: 0;\n    }\n}\n.animation-fade-out {\n    animation-name: animationFadeOut;\n}\n\n// Blink\n.animation-blink {\n    animation: animationBlink 1s steps(5, start) infinite;\n}\n\n@keyframes animationBlink {\n    to {\n        visibility: hidden;\n    }\n}","//\n// Alert\n//\n\t\n@each $name, $value in $theme-colors {\n\t.alert-#{$name} {\n\t\tcolor: var(--#{$prefix}#{$name});\n\t\tborder-color: var(--#{$prefix}#{$name});\n\t\tbackground-color: var(--#{$prefix}#{$name}-light);\n\n\t\t.alert-link {\n    \t\tcolor: var(--#{$prefix}#{$name});\n  \t\t}\n\t}\n}\n","\n//\n// Dropdown\n//\n\n@if $enable-dark-mode {\n    @include color-mode(dark) {\n        .dropdown-menu {\n            @include box-shadow($dropdown-box-shadow-dark);\n        }\n    }\n}",".toast {\n\t.toast-header {\n\t\t.btn-close {\n\t\t\tmargin-right: 0;\t\n\t\t}\t\n\t}\n}\n\n@if $enable-dark-mode {\n    @include color-mode(dark) {\n        .toast {\n\t\t\t--#{$prefix}toast-bg: #{$toast-background-color-dark};\n\t\t\t--#{$prefix}toast-header-bg: #{$toast-header-background-color-dark};\n\t\t\t--#{$prefix}toast-header-border-color: #{$toast-header-border-color-dark};\n        }\n    }\n}","//\n// Nav\n//\n\n// Nav pills\n.nav-pills {\n\t.nav-item {\n\t\tmargin-right: 0.5rem;\n\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n}\n\n// Stretch items\n.nav-stretch {\n\talign-items: stretch;\n\tpadding-top: 0 !important;\n\tpadding-bottom: 0 !important;\n\n\t.nav-item {\n\t\tdisplay: flex;\n\t\talign-items: stretch;\n\t\tpadding-top: 0 !important;\n\t\tpadding-bottom: 0 !important;\n\t}\n\n\t.nav-link {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n}\n\n// Nav group\n.nav-group {\n\tpadding: 0.35rem;\n\t@include border-radius($border-radius);\n\tbackground-color: var(--#{$prefix}gray-100);\n\n\t// Outline nav group\n\t&.nav-group-outline {\t\n\t\tbackground-color: transparent;\n\t\tborder: 1px solid var(--#{$prefix}border-color);\t\n\t}\n\n\t// Fluid option\n\t&.nav-group-fluid {\n\t\tdisplay: flex;\n\n\t\t> label,\n\t\t> .btn {\n\t\t\tposition: relative;\n\t\t\tflex-shrink: 0;\n\t\t\tflex-grow: 1;\n\t\t\tflex-basis: 0;\n\t\t}\n\n\t\t> label {\n\t\t\tmargin-right: 0.1rem;\n\n\t\t\t> .btn {\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n}","//\n// Nav\n//\n\n// Line tabs\n.nav-line-tabs {\n\tborder-bottom-width: 1px;\n\tborder-bottom-style: solid;\n\tborder-bottom-color: var(--#{$prefix}border-color);\n\n\t.nav-item {\n\t\tmargin-bottom: -1px;\n\n\t\t// Base link\n\t\t.nav-link {\n\t\t\tcolor: var(--#{$prefix}gray-500);\n\t\t\tborder: 0;\n\t\t\tborder-bottom: 1px solid transparent;\n\t\t\ttransition: $transition-link;\n\t\t\tpadding: 0.5rem 0;\n\t\t\tmargin: 0 1rem;\n\t\t}\n\n\t\t// First Item\n\t\t&:first-child {\n\t\t\t.nav-link {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\n\t\t// Last Item\n\t\t&:last-child {\n\t\t\t.nav-link {\n\t\t\t\tmargin-right: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t// Active & Hover States\n\t.nav-item .nav-link.active,\n  \t.nav-item.show .nav-link,\n\t.nav-item .nav-link:hover:not(.disabled) {\n\t\tbackground-color: transparent;\n\t\tborder: 0;\n\t\tborder-bottom: 1px solid var(--#{$prefix}primary);\n\t\ttransition: $transition-link;\n  \t}\n\n\t// 2x Line\n\t&.nav-line-tabs-2x {\n\t\tborder-bottom-width: 2px;\n\n\t\t.nav-item {\n\t\t\tmargin-bottom: -2px;\n\n\t\t\t.nav-link {\n\t\t\t\tborder-bottom-width: 2px;\n\t\t\t}\n\t\t}\n\n\t\t// Active & Hover States\n\t\t.nav-item .nav-link.active,\n\t  \t.nav-item.show .nav-link,\n\t\t.nav-item .nav-link:hover:not(.disabled) {\n\t\t\tborder-bottom-width: 2px;\n\t\t}\n\t}\n}","//\n// Custom Nav Pills\n//\n\n.nav.nav-pills.nav-pills-custom {\n\t// States\n\t.show > .nav-link,\n\t.nav-link{\t\t\n\t\tborder: 1px dashed var(--#{$prefix}border-dashed-color);\n\t\t@include border-radius($border-radius-lg);\n\t\t\n\t\t&.nav-link-border-solid {\n\t\t\tborder: 3px solid var(--#{$prefix}border-dashed-color);\n\n\t\t\t&.active {\t\t\t\t\t \t\t\n\t\t\t\tborder: 3px solid var(--#{$prefix}primary);\t \n\t\t\t}\n\t\t}\n\t\t\n        .nav-icon {\n            img {\n                width: 30px;\n                transition: $transition-link;\n\n                &.default {\n                    display: inline-block;\n                }\n\n                &.active {\n                    display: none;\n                }\n            }\n        }\n\n        &.active {\t\n\t\t\tbackground-color: transparent;\t\t\n\t\t\tborder: 1px solid var(--#{$prefix}border-dashed-color);\n\t\t\ttransition-duration: 1ms;\t\t\t\n\t\t\tposition: relative;\n\n\t\t\t.nav-text {\n\t\t\t\tcolor: var(--#{$prefix}gray-800) !important;\n\t\t\t\ttransition: $transition-link;\n\t\t\t}\n\t\t\t\n\t\t\t.bullet-custom {\n\t\t\t\tdisplay: block;\t\t\t  \t\n\t\t\t}\n\t\t}\n\n\t\t.bullet-custom {\n\t\t\tdisplay: none;\t\t\t  \t\n\t\t}\n\t}\n\n\t&.nav-pills-active-custom {\n\t\t.nav-item {\t\t\t\t \n\t\t\t.nav-link {\n\t\t\t\t&:not(:active) {\t\t\t\t \n\t\t\t\t\tspan:nth-child(1) {\n\t\t\t\t\t\tcolor: #B5B5C3;\n\t\t\t\t\t}\n\t\n\t\t\t\t\tspan:nth-child(2) {\n\t\t\t\t\t\tcolor: #3F4254;\n\t\t\t\t\t}\t\t\t\t\t\t \t \n\t\t\t\t}\t\t\n\n\t\t\t\t&:hover {\t\t\t\t \n\t\t\t\t\tspan:nth-child(1) {\n\t\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t}\n\t\n\t\t\t\t\tspan:nth-child(2) {\n\t\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t}\t\t\t\t\t\t \t \n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t&.active {\t\t\t\t \n\t\t\t\t\tspan:nth-child(1) {\n\t\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t}\n\t\n\t\t\t\t\tspan:nth-child(2) {\n\t\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t}\t\t\t\t\t\t \t \n\t\t\t\t}\t\n\t\t\t}\t\t\t\t \t\t \n\t\t}\t\t \n\t}\n}\n","//\n// Pagination\n//\n\n.pagination {\n\tdisplay:flex;\n\tflex-wrap: wrap;\n\tjustify-content: center;\n\tmargin: 0;\n\n\t// Pagination circle\n\t&.pagination-circle {\n\t\t.page-link {\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n\n\t// Pagination outline\n\t&.pagination-outline {\n\t\t.page-link {\n\t\t\tborder: 1px solid var(--#{$prefix}border-color);\n\t\t}\n\n\t\t.page-item {\n\t\t\t&:hover:not(.disabled),\n\t\t    &.active {\n\t\t\t    .page-link {\n\t\t\t        border-color: var(--#{$prefix}primary-light);\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n\t}\t\t\n}\n\n.page-item {\n    margin-right: $pagination-item-space;\n\n\t&:last-child {\n        margin-right: 0;\n    }\n\n\t.page-link {\n\t\tdisplay:flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tborder-radius: $btn-border-radius;\n\t\theight: $pagination-item-height;\n\t\tmin-width: $pagination-item-height;\n\t\tfont-weight: $pagination-font-weight;\n\t\tfont-size: $pagination-font-size;\n\n\t\ti {\n\t\t\tfont-size: $pagination-icon-font-size;\n\t\t}\n\n\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t.previous,\n\t\t.next {\n\t\t\tdisplay: block;\n\t\t\theight: $pagination-icon-height;\n\t\t\twidth: $pagination-icon-height;\n\n\t\t\t/*rtl:raw:transform: rotateZ(-180deg);*/\n\t\t}\n\t\t/*rtl:end:ignore*/\n\n\t\t.previous {\n\t\t\t@include svg-bg-icon(arrow-start, $pagination-color);\n\t\t}\n\n\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t.next {\n\t\t\t@include svg-bg-icon(arrow-end, $pagination-color);\n\t\t}\n\t}\n\n\t&:focus {\n\t\t.page-link {\n\t\t\tcolor: var(--#{$prefix}pagination-focus-color);\n\n\t\t\t.svg-icon,\n\t\t\ti {\n\t\t\t\tcolor: var(--#{$prefix}pagination-focus-color);\n\t\t\t}\n\n\t\t\t.previous {\n\t\t\t\t@include svg-bg-icon(arrow-start, var(--#{$prefix}pagination-focus-color));\n\t\t\t}\n\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t\t.next {\n\t\t\t\t@include svg-bg-icon(arrow-end, var(--#{$prefix}pagination-focus-color));\n\t\t\t}\n\t\t}\n\t}\n\n\t&:hover:not(.active):not(.offset):not(.disabled) {\n\t\t.page-link {\n\t\t\tcolor: var(--#{$prefix}pagination-hover-color);\n\t\t\t\n\t\t\t&.page-text {\n\t\t\t\tbackground-color: transparent;\t\n\t\t\t}\n\n\t\t\t.svg-icon,\n\t\t\ti {\n\t\t\t\tcolor: var(--#{$prefix}pagination-hover-color);\n\t\t\t}\n\n\t\t\t.previous {\n\t\t\t\t@include svg-bg-icon(arrow-start, var(--#{$prefix}pagination-hover-color));\n\t\t\t}\n\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t\t.next {\n\t\t\t\t@include svg-bg-icon(arrow-end, var(--#{$prefix}pagination-hover-color));\n\t\t\t}\n\t\t}\n\t}\n\n\t&.active {\n\t\t.page-link {\n\t\t\tcolor: var(--#{$prefix}pagination-active-color);\n\n\t\t\t&.page-text {\n\t\t\t\tbackground-color: transparent;\t\n\t\t\t}\n\n\t\t\t.svg-icon,\n\t\t\ti {\n\t\t\t\tcolor: var(--#{$prefix}pagination-active-color);;\n\t\t\t}\n\t\t\t\t\n\t\t\t.previous {\n\t\t\t\t@include svg-bg-icon(arrow-start, var(--#{$prefix}pagination-active-color));\n\t\t\t}\n\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t\t.next {\n\t\t\t\t@include svg-bg-icon(arrow-end, var(--#{$prefix}pagination-active-color));\n\t\t\t}\n\t\t}\n\t}\n\n\t&.disabled {\n\t\t.page-link {\n\t\t\tcolor: var(--#{$prefix}pagination-disabled-color);\n\n\t\t\t.svg-icon,\n\t\t\ti {\n\t\t\t\tcolor: var(--#{$prefix}pagination-disabled-color);\n\t\t\t}\n\n\t\t\t.previous {\n\t\t\t\t@include svg-bg-icon(arrow-start, var(--#{$prefix}pagination-disabled-color));\n\t\t\t}\n\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\n\t\t\t.next {\n\t\t\t\t@include svg-bg-icon(arrow-end, var(--#{$prefix}pagination-disabled-color));\n\t\t\t}\n\t\t}\n\t}\n\t/*rtl:end:ignore*/\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.page-item {\n\t\tmargin-right: $pagination-item-space-tablet-and-mobile;\n\n\t\t&:last-child {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n}","//\n// To make future updates easier consider overriding the global variables from _variables.bootstrap.scss and _variables.custom.scss for current demo in this file.\n// Note that this file is included first and variables defined in _variables.bootstrap.scss and _variables.custom.scss\n// are not accessible in this file but you can override any global variable as shown below:\n//\n\n// Border Radiues\n$border-radius-sm:            \t\t\t\t\t\t.3rem;\n$border-radius:               \t\t\t\t\t\t.65rem;\n$border-radius-lg:            \t\t\t\t\t\t.85rem;\n$border-radius-xl:                                  1.25rem;\n\n","//\n// SVG Bg Icons\n//\n\n@mixin svg-bg-icon($type, $color: none, $update: false) {\n    $bg-image: '';\n\n    // Icon type;\n    @if ($type == close) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n    }\n\n    @if ($type == check) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'><path fill='#{$color}' d='M4.89557 6.49823L2.79487 4.26513C2.26967 3.70683 1.38251 3.70683 0.857309 4.26513C0.375593 4.77721 0.375593 5.57574 0.857309 6.08781L4.74989 10.2257C5.14476 10.6455 5.81176 10.6455 6.20663 10.2257L13.1427 2.85252C13.6244 2.34044 13.6244 1.54191 13.1427 1.02984C12.6175 0.471537 11.7303 0.471536 11.2051 1.02984L6.06096 6.49823C5.74506 6.83403 5.21146 6.83403 4.89557 6.49823Z'/></svg>\");\n    }\n\n    @if ($type == arrow-top) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='#{$color}'><path d='M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z'/></svg>\");\n    }\n\n    @if ($type == arrow-bottom) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='#{$color}'><path d='M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z'/></svg>\");\n    }\n\n    @if ($type == arrow-start) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='#{$color}'><path d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/></svg>\");\n    }\n\n    @if ($type == arrow-end) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='#{$color}'><path d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/></svg>\");\n    }\n\n    @if ($type == sort) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/></svg>\");\n    }\n\n    @if ($type == sort-asc) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/></svg>\");\n    }\n\n    @if ($type == sort-desc) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/></svg>\");\n    }\n\n    @if ($type == expand) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><rect opacity='0.3' x='2' y='2' width='20' height='20' rx='5' fill='#{$color}'/><rect x='10.8891' y='17.8033' width='12' height='2' rx='1' transform='rotate(-90 10.8891 17.8033)' fill='#{$color}'/><rect x='6.01041' y='10.9247' width='12' height='2' rx='1' fill='#{$color}'/></svg>\");\n    }\n\n    @if ($type == collapse) {\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><rect opacity='0.3' x='2' y='2' width='20' height='20' rx='5' fill='#{$color}'/><rect x='6.0104' y='10.9247' width='12' height='2' rx='1' fill='#{$color}'/></svg>\");\n    } \n\n    // Icon style\n    @if $update == false {\n        mask-repeat: no-repeat;\n        mask-position: center;\n        -webkit-mask-repeat: no-repeat;\n        -webkit-mask-position: center;\n    }   \n        \n    @if $color != none {\n        background-color: $color;\n    }\n\n    -webkit-mask-image: escape-svg($bg-image);\n    mask-image: escape-svg($bg-image);\n}\n\n","//\n// Separator\n//\n\n.separator {\n    display: block;\n    height: 0;\n    border-bottom: 1px solid var(--#{$prefix}border-color);\n\n    &.separator-dotted {\n        border-bottom-style: dotted;\n        border-bottom-color: var(--#{$prefix}border-dashed-color);\n    }\n\n    &.separator-dashed {\n        border-bottom-style: dashed;\n        border-bottom-color: var(--#{$prefix}border-dashed-color);\n    }\n\n    &.separator-content {\n        display: flex;\n        align-items: center;\n        border-bottom: 0;\n        text-align: center;\n\n        &::before,\n        &::after {\n            content: \" \";\n            width: 50%;\n            border-bottom: 1px solid var(--#{$prefix}border-color);\n        }\n\n        &::before{\n            margin-right: 1.25rem;\n        }\n\n        &::after{\n            margin-left: 1.25rem;\n        }\n\n        &.separator-dotted {\n            &::before,\n            &::after {\n                border-bottom-style: dotted;\n                border-bottom-color: var(--#{$prefix}border-dashed-color);\n            }\n        }\n\n        &.separator-dashed {\n            &::before,\n            &::after {\n                border-bottom-style: dashed;\n                border-bottom-color: var(--#{$prefix}border-dashed-color);\n            }\n        }\n\n        @each $color, $value in $theme-colors {\n            &.border-#{$color}{\n                &::before,\n                &::after {\n                    border-color: $value !important; \n                }\n            }\n        }\n    }\n}\n","//\n// Carousel\n//\n\n\n.carousel-custom {\n    // Indicators\n    .carousel-indicators {\n        align-items: center;\n        position: static;\n        z-index: auto;\n        margin: 0;\n        padding: 0;\n        list-style: none;\n\n        li {\n            transform: none;\n            opacity: 1;\n\n            &.active {\n                transform: none;\n                opacity: 1;\n            }\n        }\n\n        // Dots style\n        &.carousel-indicators-dots {\n            li {\n                border-radius: 0;\n                background-color: transparent !important;\n                height: $carousel-custom-dots-indicator-active-size;\n                width: $carousel-custom-dots-indicator-active-size;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                text-align: center;\n\n                &:after {\n                    display: inline-block;\n                    content: \" \";\n                    @include border-radius(50%);\n                    transition: all $carousel-custom-indicator-transition-speed ease;\n                    background-color: $carousel-custom-indicator-default-bg-color;\n                    height: $carousel-custom-dots-indicator-default-size;\n                    width: $carousel-custom-dots-indicator-default-size;\n                }\n\n                &.active {\n                    background-color: transparent;\n\n                    &:after {\n                        transition: all $carousel-custom-indicator-transition-speed ease;\n                        height: $carousel-custom-dots-indicator-active-size;\n                        width: $carousel-custom-dots-indicator-active-size;\n                        background-color: $carousel-custom-indicator-active-bg-color;\n                    }\n                }\n            }\n        }\n\n        // Bullet style\n        &.carousel-indicators-bullet {\n            li {\n                transition: all $carousel-custom-indicator-transition-speed ease;\n                background-color: transparent !important;\n                border-radius: $carousel-custom-bullet-indicator-default-size;\n                height: $carousel-custom-bullet-indicator-default-size;\n                width: $carousel-custom-bullet-indicator-default-size;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                text-align: center;\n\n                &:after {\n                    display: inline-block;\n                    content: \" \";\n                    transition: all $carousel-custom-indicator-transition-speed ease;\n                    background-color: $carousel-custom-bullet-indicator-default-bg-color;\n                    border-radius: $carousel-custom-bullet-indicator-default-size;\n                    height: $carousel-custom-bullet-indicator-default-size;\n                    width: $carousel-custom-bullet-indicator-default-size;\n                }\n\n                &.active {\n                    transition: all $carousel-custom-indicator-transition-speed ease;\n                    background-color: transparent;\n                    height: $carousel-custom-bullet-indicator-default-size;\n                    width: $carousel-custom-bullet-indicator-active-width;\n\n                    &:after {\n                        transition: all $carousel-custom-indicator-transition-speed ease;\n                        height: $carousel-custom-bullet-indicator-default-size;\n                        width: $carousel-custom-bullet-indicator-active-width;\n                        background-color: $carousel-custom-bullet-indicator-active-bg-color;\n                    }\n                }\n            }\n        }\n    }\n\n    // Theme colors\n    @each $name, $value in $theme-colors {\n        .carousel-indicators-active-#{$name} {\n            li.active:after {\n                background-color: var(--#{$prefix}#{$name}) !important;\n            }\n        }\n    }\n\n    // Stretch mode\n    &.carousel-stretch {\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n\n        .carousel-inner {\n            flex-grow: 1;\n        }\n\n        .carousel-item {\n            height: 100%;\n        }\n\n        .carousel-wrapper {\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n        }\n    }   \n}\n","//\n// Menu Base\n//\n\n// Menu group\n.menu-group {\n    display: flex;\n}\n\n// Menu & wrapper\n.menu,\n.menu-wrapper {\n    display: flex;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n// Sub inner\n.menu-inner {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n// Sub menu\n.menu-sub {\n    display: none;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n    flex-direction: column;\n}\n\n// Menu item\n.menu-item {\n    display: block;\n    padding: $menu-item-padding-y $menu-item-padding-x;\n\n    // Menu Link\n    .menu-link {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        padding: 0;\n        flex: 0 0 100%;\n        padding: $menu-link-padding-y $menu-link-padding-x;\n        transition: none;\n        outline: none !important;\n\n        .menu-icon {\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: $menu-icon-size;\n            margin-right: $menu-icon-space;\n\n            i,\n            .svg-icon {\n                line-height: 1;\n            }\n        }\n\n        .menu-bullet {\n            flex-shrink: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: $menu-bullet-size;\n            margin-right: $menu-bullet-space;\n        }\n\n        .menu-title {\n            display: flex;\n            align-items: center;\n            flex-grow: 1;\n        }\n\n        .menu-badge {\n            display: flex;\n            align-items: center;\n            flex-shrink: 0;\n            margin-left: $menu-badge-space;\n        }\n\n        .menu-arrow {\n            display: flex;\n            align-items: stretch;\n            position: relative;\n            overflow: hidden;\n            flex-shrink: 0;\n            margin-left: $menu-arrow-space;\n            width: $menu-arrow-size;\n            height: $menu-arrow-size;\n\n            &:after {\n                display: block;\n                width: 100%;\n                content: \" \";\n                will-change: transform;\n                background-size: 100% 100%;\n                @include svg-bg-icon(arrow-start, var(--#{$prefix}text-muted));\n                /*rtl:begin:remove*/\n                @include svg-bg-icon(arrow-end, var(--#{$prefix}text-muted));\n                /*rtl:end:remove*/\n            }\n        }\n    }\n\n    // Menu Content\n    .menu-content {\n        padding: $menu-link-padding-y $menu-link-padding-x;\n    }\n}\n\n// Accordion arrows\n.menu-item {    \n    &.show {\n        .menu-link {\n            .menu-arrow:after {                \n                backface-visibility: hidden;\n                transition: $menu-accordion-arrow-transition;\n            }\n        }\n    }\n}\n\n// No wrap\n.menu-nowrap {\n    .menu-title,\n    .menu-link {\n        flex-wrap: nowrap;    \n        flex-shrink: 0;\n    }\n}\n\n// Center alignment\n.menu-center {\n    justify-content: center;\n}\n\n// Heading\n.menu-heading {\n    color: var(--#{$prefix}menu-heading-color);    \n}\n\n// Responsive \n@each $direction in (up, down) {\n    @each $breakpoint in map-keys($grid-breakpoints) {\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n        @if $infix and $direction == down {\n            $infix: $infix + \"-\" + $direction;\n        }\n\n        @include media-breakpoint-direction($direction, $breakpoint) {\n            // Accordion arrow\n            .menu-item.menu#{$infix}-accordion {\n                .menu-arrow:after {\n                    @include menu-link-arrow-rotate(90deg, -90deg);\n                }\n\n                &.showing:not(.menu-dropdown),\n                &.show:not(.hiding):not(.menu-dropdown) {\n                    > .menu-link {\n                        .menu-arrow:after {\n                            @include menu-link-arrow-rotate(-90deg, 90deg);\n                        }\n                    }\n                }\n            }\n\n            // Sub dropdown\n            .menu-sub#{$infix}-dropdown {\n                display: none;\n                border-radius: $menu-dropdown-border-radius;\n                background-color: var(--#{$prefix}menu-dropdown-bg-color);\n                box-shadow: var(--#{$prefix}menu-dropdown-box-shadow);\n                z-index: $menu-dropdown-z-index;\n\n                // Dropdown show\n                .show.menu-dropdown > &,\n                &.menu.show,\n                &.show[data-popper-placement] {\n                    display: flex;\n                    will-change: transform;\n                    \n                    // Animation\n                    @if ($menu-dropdown-animation == true) {\n                        // Move up\n                        animation: menu-sub-dropdown-animation-fade-in #{$menu-dropdown-animation-speed} ease 1, menu-sub-dropdown-animation-move-up #{$menu-dropdown-animation-speed} ease 1;\n                    }                    \n                }\n            }\n\n            // Sub accordion\n            .menu-sub#{$infix}-accordion {\n                display: none;\n\n                .show:not(.menu-dropdown) > &,\n                &.show {\n                    display: flex;\n                }\n            }\n\n            // Sub indention\n            .menu-sub#{$infix}-indention {\n                @include menu-sub-indention($menu-accordion-indention);\n\n                // Active link\n                .menu-item .menu-item .menu-link.active {\n                    margin-right: $menu-link-padding-x;\n                }\n            }\n\n            // Inline\n            .menu#{$infix}-inline {\n                display: flex;\n            }\n\n            // Reset link left & right paddings of level 1 menu links\n            .menu#{$infix}-fit {\n                > .menu-item {\n                    > .menu-content,\n                    > .menu-link {\n                        padding-left: 0 !important;\n                        padding-right: 0 !important;\n                    }\n                }\n            }\n\n            .menu#{$infix}-column {\n                flex-direction: column;\n                width: 100%;\n            }\n\n            .menu#{$infix}-row {\n                flex-direction: row;\n\n                > .menu-item {\n                    display: flex;\n                    align-items: center;\n\n                    > .menu-link {\n                        .menu-arrow:after {\n                            @include menu-link-arrow-rotate(90deg, -90deg);\n                        }\n                    }\n                }\n            }\n\n            // Border radiuses\n            .menu#{$infix}-rounded {\n                .menu-link {\n                    @include border-radius($menu-link-border-radius);\n                }\n            }\n\n            // Border radiuses\n            .menu#{$infix}-pill {\n                .menu-link {\n                    border-radius: 50px;\n                }\n            }\n\n            // Reset border radiuses\n            .menu#{$infix}-rounded-0 {\n                .menu-link {\n                    border-radius: 0 !important;\n                }\n            }\n        }\n    }\n}\n\n// Link indention\n.menu-link-indention {\n    .menu-item {\n        padding-top: 0;    \n        padding-bottom: 0;    \n    }\n        \n    @include menu-link-indention($menu-accordion-indention, $menu-link-padding-x);\n}\n\n// Menu animations\n@keyframes menu-sub-dropdown-animation-fade-in {\n    from   { \n        opacity: 0; \n    }\n\n    to { \n        opacity: 1; \n    }\n}\n\n@keyframes menu-sub-dropdown-animation-move-up {\n    from   { \n        margin-top: #{$menu-dropdown-animation-move-offset};\n    }\n    \n    to { \n        margin-top: 0;\n    }\n}\n\n@keyframes menu-sub-dropdown-animation-move-down {\n    from   { \n        margin-bottom: #{$menu-dropdown-animation-move-offset};\n    }\n\n    to { \n        margin-bottom: 0;\n    }\n}","//\n// Label\n//\n\n// Set arrow direction\n@mixin menu-link-arrow-rotate($angle, $angleRtl) {\n\t/*rtl:ignore*/\n\ttransform: rotateZ($angleRtl);\n\t/*rtl:remove*/\n\ttransform: rotateZ($angle);\n\ttransition: $menu-accordion-arrow-transition;\n}\n\n// Set menu link padding x\n@mixin menu-link-padding-x($value) {\n\t// Menu item\n\t.menu-item {\n\t\t.menu-link,\n\t\t.menu-content {\n\t\t\tpadding-left: $value;\n\t\t\tpadding-right: $value;\n\t\t}\n\t}\n}\n\n// Set menu link padding y\n@mixin menu-link-padding-y($value) {\n\t// Menu item\n\t.menu-item {\n\t\t.menu-link,\n\t\t.menu-content {\n\t\t\tpadding-top: $value;\n\t\t\tpadding-bottom: $value;\n\t\t}\n\t}\n}\n\t\n// Set link indention\n@mixin menu-link-indention($value, $offset) {\n\t.menu-sub:not([data-popper-placement]) {\n\t\t> .menu-item,\n\t\t> .menu-inner > .menu-item {\n\t\t\t> .menu-content,\n\t\t\t> .menu-link {\n\t\t\t\tpadding-left: calc(#{1 * $value} + #{$offset});\n\t\t\t}\n\n\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t> .menu-item,\n\t\t\t\t> .menu-inner > .menu-item {\n\t\t\t\t\t> .menu-content,\n\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\tpadding-left: calc(#{2 * $value} + #{$offset});\n\t\t\t\t\t}\n\n\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t\t> .menu-item,\n\t\t\t\t\t\t> .menu-inner > .menu-item {\n\t\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t\tpadding-left: calc(#{3 * $value} + #{$offset});\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t\t\t\t> .menu-item,\n\t\t\t\t\t\t\t\t> .menu-inner > .menu-item {\n\t\t\t\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t\t\t\tpadding-left: calc(#{4 * $value} + #{$offset});\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&.menu-fit {\n\t\t.menu-sub:not([data-popper-placement]) {\n\t\t\t> .menu-item,\n\t\t\t> .menu-inner > .menu-item {\n\t\t\t\t> .menu-content,\n\t\t\t\t> .menu-link {\n\t\t\t\t\tpadding-left: #{$value};\n\t\t\t\t\tpadding-right: 0;\n\t\t\t\t}\n\t\t\n\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t> .menu-item,\n\t\t\t\t\t> .menu-inner > .menu-item {\n\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\tpadding-left: calc(#{2 * $value});\n\t\t\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\t\t}\n\t\t\n\t\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t\t\t> .menu-item,\n\t\t\t\t\t\t\t> .menu-inner > .menu-item {\n\t\t\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t\t\tpadding-left: calc(#{3 * $value});\n\t\t\t\t\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\t\t\t\t}\n\t\t\n\t\t\t\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\n\t\t\t\t\t\t\t\t\t> .menu-item,\n\t\t\t\t\t\t\t\t\t> .menu-inner > .menu-item {\n\t\t\t\t\t\t\t\t\t\t> .menu-content,\n\t\t\t\t\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t\t\t\t\tpadding-left: calc(#{4 * $value});\n\t\t\t\t\t\t\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Set sub indention\n@mixin menu-sub-indention($value) {\n\t.menu-sub:not([data-popper-placement]) {\n\t\tmargin-left: $value;\n\t}\n}\n\n// Set menu link theme\n@mixin menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null) {\n\t@if ( $bg-color != null ) {\n\t\tbackground-color: $bg-color;\n\t}\n\n\t@if ( $title-color != null ) {\n\t\tcolor: $title-color;\n\n\t\t.menu-title {\n\t\t\tcolor: $title-color;\n\t\t}\n\t}\n\n\t@if ( $icon-color != null ) {\n\t\t.menu-icon {\n\t\t\t&,\n\t\t\t.svg-icon,\n\t\t\ti {\n\t\t\t\tcolor: $icon-color;\n\t\t\t}\n\t\t}\n\t}\n\n\t@if ( $bullet-color != null ) {\n\t\t.menu-bullet {\n\t\t\t.bullet {\n\t\t\t\tbackground-color: $bullet-color;\n\t\t\t}\n\t\t}\n\t}\n\n\t@if ( $arrow-color != null ) {\n\t\t// Arrow\n\t\t.menu-arrow:after {\n\t\t\t@include svg-bg-icon(arrow-start, $arrow-color);\n\t\t\t/*rtl:begin:remove*/\n\t\t\t@include svg-bg-icon(arrow-end, $arrow-color);\n\t\t\t/*rtl:end:remove*/\n\t\t}\n\t}\n}\n\n// Set menu link default state\n@mixin menu-link-default-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t$sel: '';\n\n\t@if ($all-links == false) {\n\t\t$sel: '& > ';\n\t}\n\n\t#{$sel}.menu-link {\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n\n// Set menu link hover state\n@mixin menu-link-hover-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t$sel: '&:not(.here) ';\n\n\t@if ($all-links == false) {\n\t\t$sel: '&:not(.here) > ';\n\t}\n\n\t&.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here),\n\t#{$sel}.menu-link:hover:not(.disabled):not(.active):not(.here) {\n\t\ttransition: $transition-link;\n\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n\n// Set menu link active state\n@mixin menu-link-active-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t$sel: '';\n\n\t@if ($all-links == false) {\n\t\t$sel: '& > ';\n\t}\n\n\t#{$sel}.menu-link.active {\n\t\ttransition: $transition-link;\n\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n\n// Set menu link show state\n@mixin menu-link-show-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t//&.here > .menu-link,\n\t&.show > .menu-link {\n\t\ttransition: $transition-link;\n\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n\n// Set menu link here state\n@mixin menu-link-here-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\n\t&.here > .menu-link {\n\t\ttransition: $transition-link;\n\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\n\t}\n}\n\n// Set menu link default\n@mixin menu-link-default($all-links: true) {\n\t$sel: '';\n\n\t@if ($all-links == false) {\n\t\t$sel: '& > ';\n\t}\n\n\t#{$sel}.menu-link {\n\t\t@content;\n\t}\n}\n\n// Set menu link hover\n@mixin menu-link-hover($all-links: true) {\n\t$sel: '&:not(.here) ';\n\n\t@if ($all-links == false) {\n\t\t$sel: '&:not(.here) > ';\n\t}\n\n\t&.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here),\n\t#{$sel}.menu-link:hover:not(.disabled):not(.active):not(.here) {\n\t\ttransition: $transition-link;\n\n\t\t@content;\n\t}\n}\n\n// Set menu link active\n@mixin menu-link-active($all-links: true) {\n\t$sel: '';\n\n\t@if ($all-links == false) {\n\t\t$sel: '& > ';\n\t}\n\n\t#{$sel}.menu-link.active {\n\t\ttransition: $transition-link;\n\n\t\t@content;\n\t}\n}\n\n// Set menu link show\n@mixin menu-link-show($all-links: true) {\n\t//&.here > .menu-link,\n\t&.show > .menu-link {\n\t\ttransition: $transition-link;\n\n\t\t@content;\n\t}\n}\n\n// Set menu link here\n@mixin menu-link-here($all-links: true) {\n\t&.here > .menu-link {\n\t\ttransition: $transition-link;\n\n\t\t@content;\n\t}\n}\n","// Media of at most the maximum and minimum breakpoint widths. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint.\n\n@mixin media-breakpoint-direction($direction, $name, $breakpoints: $grid-breakpoints) {\n    @if $direction == up {\n        $min: breakpoint-min($name, $breakpoints);\n\n        @if $min {\n            @media (min-width: $min) {\n                @content;\n            }\n        } @else {\n            @content;\n        }\n\n    } @else if $direction == down {\n        $max: breakpoint-max($name, $breakpoints);\n\n        @if $max {\n            @media (max-width: $max) {\n                @content;\n            }\n        }\n    }\n}","//\n// Menu Theme\n//\n\n// Theme text colors\n@each $name, $color in $theme-text-colors {\n    .menu-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( var(--#{$prefix}#{$name}), var(--#{$prefix}#{$name}), var(--#{$prefix}#{$name}), var(--#{$prefix}#{$name}), null );\n        }\n    }\n\n    .menu-title-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( var(--#{$prefix}text-#{$name}), null, null, null, null );\n        }\n    }\n\n    .menu-icon-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( null, var(--#{$prefix}text-#{$name}), null, null, null );\n        }\n    }\n\n    .menu-bullet-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( null, null, var(--#{$prefix}text-#{$name}), null, null );\n        }\n    }\n\n    .menu-arrow-#{$name} {\n        .menu-item {\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n            @include menu-link-default-state( null, null, null, var(--#{$prefix}text-#{$name}), null );\n        }\n    }\n}\n\n// Default background states\n.menu-hover-bg {\n    .menu-item {\n        @include menu-link-hover-state( \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-bg-color-hover) \n        );\n    }\n}\n\n.menu-here-bg {\n    .menu-item {\n        @include menu-link-here-state( \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-bg-color-here) \n        );\n    }\n}\n\n.menu-root-here-bg {\n    > .menu-item {\n        @include menu-link-here-state( \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-bg-color-here) \n        );\n    }\n}\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n    .menu-root-here-bg-desktop {\n        > .menu-item {\n            @include menu-link-here-state( \n                var(--#{$prefix}menu-link-color-here), \n                var(--#{$prefix}menu-link-color-here), \n                var(--#{$prefix}menu-link-color-here), \n                var(--#{$prefix}menu-link-color-here), \n                var(--#{$prefix}menu-link-bg-color-here) \n            );\n        }\n    }\n}\n\n.menu-show-bg {\n    .menu-item {\n        @include menu-link-show-state( \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-bg-color-show) \n        );\n    }\n}\n\n.menu-active-bg {\n    .menu-item {\n        @include menu-link-active-state( \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-bg-color-active) \n        );\n    }\n}\n\n.menu-state-bg {\n    .menu-item {\n        @include menu-link-hover-state( \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-bg-color-hover) \n        );\n\n        @include menu-link-here-state( \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-bg-color-here) \n        );\n\n        @include menu-link-show-state( \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-bg-color-show) \n        );\n\n        @include menu-link-active-state( \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-bg-color-active) \n        );\n    }\n}\n\n.menu-state-color {\n    .menu-item {\n        @include menu-link-hover-state( \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-color-hover), \n            var(--#{$prefix}menu-link-color-hover), \n            null\n        );\n\n        @include menu-link-here-state( \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            var(--#{$prefix}menu-link-color-here), \n            null\n        );\n\n        @include menu-link-show-state( \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-color-show), \n            var(--#{$prefix}menu-link-color-show), \n            null\n        );\n\n        @include menu-link-active-state( \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-color-active), \n            var(--#{$prefix}menu-link-color-active), \n            null\n        );\n    }\n}\n\n// Primary background states\n.menu-hover-bg-primary {\n    .menu-item {\n        @include menu-link-hover-state( \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary) \n        );\n    }\n}\n\n.menu-show-bg-primary {\n    .menu-item {\n        @include menu-link-show-state( \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary) \n        );\n    }\n}\n\n.menu-here-bg-primary {\n    .menu-item {\n        @include menu-link-here-state( \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary)\n        );\n    }\n}\n\n.menu-active-bg-primary {\n    .menu-item {\n        @include menu-link-active-state( \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary)\n        );\n    }\n}\n\n.menu-state-bg-primary {\n    .menu-item {\n        @include menu-link-hover-state( \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary) \n        );\n\n        @include menu-link-show-state( \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary) \n        );\n\n        @include menu-link-here-state( \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary)\n        );\n\n        @include menu-link-active-state( \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary)\n        );\n\n        @include menu-link-show-state( \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary-inverse), \n            var(--#{$prefix}primary) \n        );\n    }\n}\n\n// Light primary background states\n.menu-show-bg-light-primary {\n    .menu-item {\n        @include menu-link-show-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary-light) );\n    }\n}\n\n.menu-here-bg-light-primary {\n    .menu-item {\n        @include menu-link-here-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary-light) );\n    }\n}\n\n.menu-hover-bg-light-primary {\n    .menu-item {\n        @include menu-link-hover-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary-light) );\n    }\n}\n\n.menu-active-bg-light-primary {\n    .menu-item {\n        @include menu-link-active-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary-light) );\n    }\n}\n\n.menu-state-bg-light-primary {\n    .menu-item {\n        @include menu-link-show-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary-light) );\n        @include menu-link-here-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary-light) );\n        @include menu-link-hover-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary-light) );\n        @include menu-link-active-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary-light) );\n    }\n}\n\n// Primary color states\n.menu-hover-primary {\n    .menu-item {\n        @include menu-link-hover-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), null );\n    }\n}\n\n.menu-show-primary {\n    .menu-item {\n        @include menu-link-show-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), null );\n    }\n}\n\n.menu-here-primary {\n    .menu-item {\n        @include menu-link-here-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), null );\n    }\n}\n\n.menu-active-primary {\n    .menu-item {\n        @include menu-link-active-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), null );\n    }\n}\n\n.menu-state-primary {\n    .menu-item {\n        @include menu-link-hover-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), null );\n        @include menu-link-show-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), null );\n        @include menu-link-here-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), null );\n        @include menu-link-active-state( var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), var(--#{$prefix}primary), null );\n    }\n}\n\n.menu-state-dark {\n    .menu-item {\n        @include menu-link-hover-state( var(--#{$prefix}dark), var(--#{$prefix}dark), var(--#{$prefix}dark), var(--#{$prefix}dark), null );\n        @include menu-link-show-state( var(--#{$prefix}dark), var(--#{$prefix}dark), var(--#{$prefix}dark), var(--#{$prefix}dark), null );\n        @include menu-link-here-state( var(--#{$prefix}dark), var(--#{$prefix}dark), var(--#{$prefix}dark), var(--#{$prefix}dark), null );\n        @include menu-link-active-state( var(--#{$prefix}dark), var(--#{$prefix}dark), var(--#{$prefix}dark), var(--#{$prefix}dark), null );\n    }\n}\n\n.menu-state-gray-900 {\n    .menu-item {\n        @include menu-link-hover-state( var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), null );\n        @include menu-link-show-state( var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), null );\n        @include menu-link-here-state( var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), null );\n        @include menu-link-active-state( var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), var(--#{$prefix}gray-900), null );\n    }\n}\n\n// Primary title color states\n.menu-hover-title-primary {\n    .menu-item {\n        @include menu-link-hover-state( var(--#{$prefix}primary), null, null, null, null );\n    }\n}\n\n.menu-here-title-primary {\n    .menu-item {\n        @include menu-link-here-state( var(--#{$prefix}primary), null, null, null, null );\n    }\n}\n\n.menu-show-title-primary {\n    .menu-item {\n        @include menu-link-show-state( var(--#{$prefix}primary), null, null, null, null );\n    }\n}\n\n.menu-active-title-primary {\n    .menu-item {\n        @include menu-link-active-state( var(--#{$prefix}primary), null, null, null, null );\n    }\n}\n\n.menu-state-title-primary {\n    .menu-item {\n        @include menu-link-hover-state( var(--#{$prefix}primary), null, null, null, null );\n        @include menu-link-here-state( var(--#{$prefix}primary), null, null, null, null );\n        @include menu-link-show-state( var(--#{$prefix}primary), null, null, null, null );\n        @include menu-link-active-state( var(--#{$prefix}primary), null, null, null, null );\n    }\n}\n\n// Primary icon color states\n.menu-hover-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, var(--#{$prefix}primary), null, null, null );\n    }\n}\n\n.menu-here-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-here-state( null, var(--#{$prefix}primary), null, null, null );\n    }\n}\n\n.menu-show-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-show-state( null, var(--#{$prefix}primary), null, null, null );\n    }\n}\n\n.menu-active-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-active-state( null, var(--#{$prefix}primary), null, null, null );\n    }\n}\n\n.menu-state-icon-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, var(--#{$prefix}primary), null, null, null );\n        @include menu-link-here-state( null, var(--#{$prefix}primary), null, null, null );\n        @include menu-link-show-state( null, var(--#{$prefix}primary), null, null, null );\n        @include menu-link-active-state( null, var(--#{$prefix}primary), null, null, null );\n    }\n}\n\n// Primary bullet color states\n.menu-hover-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, null, var(--#{$prefix}primary), null, null );\n    }\n}\n\n.menu-show-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-show-state( null, null, var(--#{$prefix}primary), null, null );\n    }\n}\n\n.menu-here-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-here-state( null, null, var(--#{$prefix}primary), null, null );\n    }\n}\n\n.menu-active-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-active-state( null, null, var(--#{$prefix}primary), null, null );\n    }\n}\n\n.menu-state-bullet-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, null, var(--#{$prefix}primary), null, null );\n        @include menu-link-here-state( null, null, var(--#{$prefix}primary), null, null );\n        @include menu-link-show-state( null, null, var(--#{$prefix}primary), null, null );\n        @include menu-link-active-state( null, null, var(--#{$prefix}primary), null, null );\n    }\n}\n\n// Primary arrow color states\n.menu-hover-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, null, null, var(--#{$prefix}primary), null );\n    }\n}\n\n.menu-here-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-here-state( null, null, null, var(--#{$prefix}primary), null );\n    }\n}\n\n.menu-show-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-show-state( null, null, null, var(--#{$prefix}primary), null );\n    }\n}\n\n.menu-active-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-active-state( null, null, null, var(--#{$prefix}primary), null );\n    }\n}\n\n.menu-state-arrow-primary {\n    .menu-item {\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\n        @include menu-link-hover-state( null, null, null, var(--#{$prefix}primary), null );\n        @include menu-link-here-state( null, null, null, var(--#{$prefix}primary), null );\n        @include menu-link-show-state( null, null, null, var(--#{$prefix}primary), null );\n        @include menu-link-active-state( null, null, null, var(--#{$prefix}primary), null );\n    }\n}\n","//\n// Anchor\n//\n\n.anchor {\n    display: flex;\n    align-items: center;\n\n    a {\n        position: relative;\n        display: none;\n        align-items: center;\n        justify-content:flex-start;\n        height: 1em;\n        width: 1.25em;\n        margin-left: -1.25em;\n        font-weight: 500;\n        font-size: 0.8em;\n        color: var(--#{$prefix}text-muted);\n        transition: $transition-base;\n\n        &:before {\n            content: '#';\n        }\n    }\n\n    &:hover {\n        a {\n            display: flex;\n\n            &:hover {\n                color: var(--#{$prefix}primary);\n                transition: $transition-base;\n            }\n        }\n    }\n}\n","//\n// Card\n//\n\n// Base\n.card {    \n    --#{$prefix}card-box-shadow: var(--#{$prefix}root-card-box-shadow);\n    --#{$prefix}card-border-color: var(--#{$prefix}root-card-border-color);\n\n    @if ($card-border-enabled)  {\n        border: $card-border-width $card-border-style var(--#{$prefix}card-border-color);\n    } @else {\n        border: 0;\n    }  \n\n    // Header\n    .card-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: stretch;\n        flex-wrap: wrap;\n        min-height: $card-header-height;\n        padding: 0 $card-px;\n        color: var(--#{$prefix}card-cap-color);\n        background-color: var(--#{$prefix}card-cap-bg);\n        border-bottom: $card-border-width $card-border-style var(--#{$prefix}card-border-color);\n\n        // Title\n        .card-title {\n            display: flex;\n            align-items: center;\n            margin: $card-header-py;\n            margin-left: 0;\n\n            &.flex-column {\n                align-items: flex-start;\n                justify-content: center;\n            }\n\n            .card-icon {\n                margin-right: 0.75rem;\n                line-height: 0;\n\n                i {\n                    font-size: 1.25rem;\n                    color: var(--#{$prefix}gray-600);\n                    line-height: 0;\n\n                    &:after,\n                    &:before {\n                        line-height: 0;\n                    }\n                }\n\n                .svg-icon {\n                    color: var(--#{$prefix}gray-600);\n                    @include svg-icon-size(24px);\n                }\n            }\n\n            &,\n            .card-label {\n                font-weight: 500;\n                font-size: 1.275rem;\n                color: var(--#{$prefix}text-gray-900);\n            }\n\n            .card-label {\n                margin: 0 0.75rem 0 0;\n                flex-wrap: wrap;\n            }\n\n            // Description\n            small {\n                color: var(--#{$prefix}text-muted);\n                font-size: 1rem;\n            }\n\n            // Headings\n            h1, h2, h3, h4, h5, h6 {\n                margin-bottom: 0;\n            }\n        }\n\n        // Toolbar\n        .card-toolbar {\n            display: flex;\n            align-items: center;\n            margin: $card-header-py 0;\n            flex-wrap: wrap;\n        }\n    }\n\n    // Body\n    .card-body {\n        padding: $card-py $card-px;\n        color: var(--#{$prefix}card-color);\n    }\n\n    // Footer\n    .card-footer {\n        padding: $card-py $card-px;\n        color: var(--#{$prefix}card-cap-color);\n        background-color: var(--#{$prefix}card-cap-bg);\n        border-top: $card-border-width $card-border-style var(--#{$prefix}card-border-color);\n    }\n\n    // Scroll\n    .card-scroll {\n        position: relative;\n        overflow: auto;\n    }\n\n    // Reset padding x\n    &.card-px-0 {\n        .card-header,\n        .card-body,\n        .card-footer {\n            padding-left: 0;\n            padding-right: 0;\n        }\n    }\n\n    &.card-py-0 {\n        .card-header,\n        .card-body,\n        .card-footer {\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n    }\n\n    &.card-p-0 {\n        .card-header,\n        .card-body,\n        .card-footer {\n            padding: 0;\n        }\n    }\n\n    // Dashed style\n    &.card-dashed {\n        box-shadow: none;\n        border: $card-border-width dashed $card-border-dashed-color;\n\n        > .card-header {\n            border-bottom: 1px dashed $card-border-dashed-color;\n        }\n\n        > .card-footer {\n            border-top: 1px dashed $card-border-dashed-color;\n        }\n    }\n\n    // Bordered style\n    &.card-bordered {\n        box-shadow: none;\n        border: $card-border-width $card-border-style $card-border-color;\n    }\n\n    // Flush header and footer borders\n    &.card-flush {\n        > .card-header {\n            border-bottom: 0 !important;\n        }\n\n        > .card-footer {\n            border-top: 0 !important;\n        }\n    }\n    \n    // Enable shadow\n    &.card-shadow {\n        box-shadow: var(--#{$prefix}card-box-shadow);\n        border: 0;\n    }\n\n    // Reset styles\n    &.card-reset {\n        border: 0 !important;\n        box-shadow: none !important;\n        background-color: transparent !important;\n\n        > .card-header {\n            border-bottom: 0 !important;\n        }\n\n        > .card-footer {\n            border-top: 0 !important;\n        }\n    }\n\n    // Reset borders\n    &.card-borderless {\n        border: 0 !important;\n\n        > .card-header {\n            border-bottom: 0 !important;\n        }\n\n        > .card-footer {\n            border-top: 0 !important;\n        }\n    }\n\n    // Reset borders\n    &.card-border-0 {\n        border: 0 !important;\n    }\n}\n\n// Responsive stretch heights\n.card {\n    @each $breakpoint in map-keys($grid-breakpoints) {\n    \t@include media-breakpoint-up($breakpoint) {\n    \t\t$infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n            // Stretch\n            &.card#{$infix}-stretch {\n                height: calc(100% - var(--#{$prefix}gutter-y));\n            }\n\n            // Stretch 75\n            &.card#{$infix}-stretch-75 {\n                height: calc(75% - var(--#{$prefix}gutter-y));\n            }\n\n            // Stretch 50\n            &.card#{$infix}-stretch-50 {\n                height: calc(50% - var(--#{$prefix}gutter-y));\n            }\n\n             // Stretch 33\n            &.card#{$infix}-stretch-33 {\n                height: calc(33.333% - var(--#{$prefix}gutter-y));\n            }\n\n            // Stretch 25\n            &.card#{$infix}-stretch-25 {\n                height: calc(25% - var(--#{$prefix}gutter-y));\n            }\n\n            // Header stretch\n            .card-header#{$infix}-stretch {\n                padding-top: 0 !important;\n                padding-bottom: 0 !important;\n                align-items: stretch;\n    \n                .card-toolbar {\n                    margin: 0;\n                    align-items: stretch;\n                }\n            }\n        }\n    }\n}\n\n// Utilities\n.card-p {\n    padding: $card-py $card-px !important;\n}\n\n.card-px {\n    padding-left: $card-px !important;\n    padding-right: $card-px !important;\n}\n\n.card-shadow {\n    box-shadow: var(--#{$prefix}card-box-shadow);\n}\n\n.card-py {\n    padding-top: $card-py !important;\n    padding-bottom: $card-py !important;\n}\n\n.card-rounded {\n    border-radius: $card-border-radius;\n}\n\n.card-rounded-start {\n    border-top-left-radius: $card-border-radius;\n    border-bottom-left-radius: $card-border-radius;\n}\n\n.card-rounded-end {\n    border-top-right-radius: $card-border-radius;\n    border-bottom-right-radius: $card-border-radius;\n}\n\n.card-rounded-top {\n    border-top-left-radius: $card-border-radius;\n    border-top-right-radius: $card-border-radius;\n}\n\n.card-rounded-bottom {\n    border-bottom-left-radius: $card-border-radius;\n    border-bottom-right-radius: $card-border-radius;\n}\n\n// Mobile mode\n@include media-breakpoint-down(md) {\n    .card {\n        > .card-header:not(.flex-nowrap) {\n            padding-top: $card-header-py;\n            padding-bottom: $card-header-py;\n        }\n    }\n}\n\n@if $enable-dark-mode {\n    @include color-mode(dark) {\n        .card {\n            --#{$prefix}card-box-shadow: #{$card-box-shadow-dark};\n        }\n    }\n}","//\n// SVG Icon\n//\n\n\n@mixin svg-icon-size($size, $important: false) {\n    svg {\n        height: $size valueif($important, !important, null);\n        width: $size valueif($important, !important, null);\n    }\n}\n","//\n// Breadcrumb\n//\n\n// Breadcrumb\n.breadcrumb {\n    display: flex;\n    align-items: center;\n    background-color: transparent;\n    padding: 0;\n    margin: 0;    \n\n    // Item breadcrumb\n    .breadcrumb-item {\n        display: flex;\n        align-items: center;\n        padding-left: $breadcrumb-item-padding-x;\n\n        &:last-child {\n            padding-right: 0;\n        }\n\n        &:after {\n            padding-left: $breadcrumb-item-padding-x;\n            content: \"/\";\n        }\n\n        &:before {\n            display: none;\n        }\n\n        &:first-child {\n            padding-left: 0;\n        }\n\n        &:last-child {\n            &:after {\n                display: none;\n            }\n        }\n    }\n}\n\n// Breadcrumb line style\n.breadcrumb-line {\n    .breadcrumb-item {\n        &:after {\n            content: \"-\";\n        }\n    }\n}\n\n// Breadcrumb dot style\n.breadcrumb-dot {\n    .breadcrumb-item {\n        &:after {            \n            content: \"\\2022\";\n        }\n    }\n}\n\n// Breadcrumb separatorless style\n.breadcrumb-separatorless {\n    .breadcrumb-item {\n        &:after {\n            display:none;\n        }\n    }\n}","//\n// Buttons Base\n//\n\n// Button\n.btn {\n\t--#{$prefix}btn-color: var(--#{$prefix}body-color);\n\n\t// Reset outline\n\toutline: none !important;\t\n\n\t// Reset focus shadow\n\t&:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg):not(.shadow-xs) {\n\t\tbox-shadow: none;\n\t}\n\n\t// Remove border\n\t&:not(.btn-outline):not(.btn-dashed):not(.btn-bordered):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon):not(.btn-hover-outline) {\n\t\tborder: 0;\n\t\tpadding: calc(#{$btn-padding-y} + #{$btn-border-width}) calc(#{$btn-padding-x} + #{$btn-border-width});\n\n\t\t&.btn-lg {\n\t\t\tpadding: calc(#{$btn-padding-y-lg} + #{$btn-border-width}) calc(#{$btn-padding-x-lg} + #{$btn-border-width});\n\t\t}\n\n\t\t&.btn-sm {\n\t\t\tpadding: calc(#{$btn-padding-y-sm} + #{$btn-border-width}) calc(#{$btn-padding-x-sm} + #{$btn-border-width});\n\t\t}\n\t}\n\n\t// Link\n\t&.btn-link {\n\t\tborder: 0;\n\t\tborder-radius: 0;\n\t\tpadding-left: 0 !important;\n\t\tpadding-right: 0 !important;\n\t\ttext-decoration: none;\n\t\tfont-weight: $btn-font-weight;\n\t}\n \n\t// Outline\n\t&.btn-outline:not(.btn-outline-dashed) {\n\t\tborder: 1px solid $input-border-color;\n\t}\n\n\t// Outline dashed\n\t&.btn-outline-dashed {\n\t\tborder: 1px dashed $input-border-color;\n\t}\n\n\t// Flush\n\t&.btn-flush {\n\t\t@include button-reset();\n\t}\n\n\t// Flex\n\t&.btn-flex {\t\t\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t}\n\n\t// Align start\n\t&.btn-trim-start {\n\t\tjustify-content: flex-start !important;\n\t\tpadding-left: 0 !important;\t\t\n\t}\n\n\t// Align start\n\t&.btn-trim-end {\n\t\tjustify-content: flex-end !important;\n\t\tpadding-right: 0 !important;\t\n\t} \n}\n\n// Reset\n.btn-reset {\n\tbackground-color: transparent;\n\tborder: 0;\n\tbox-shadow: none;\n\tuser-select: none;\n\toutline: none;\n}\n\n// Icons\n.btn {\n\t// Font icon\n\t> i {\n\t\tdisplay: inline-flex;\n\t\tfont-size: $font-size-base;\n\t\tpadding-right: 0.35rem;\n\t\tvertical-align: middle;\n\t}\n\n\t// Icon only button\n\t&.btn-icon {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding: 0;\n\t\theight: $input-height;\n\t\twidth: $input-height;\n\t\tline-height: 1;\n\n\t\ti {\n\t\t\tpadding-right: 0;\t\n\t\t}\n\n\t\t// Remove border\n\t\t&:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {\n\t\t\tborder: 0;\n\t\t}\n\n\t\t// Sizes\n\t\t&.btn-sm {\n\t\t\theight: $input-height-sm;\n\t\t\twidth: $input-height-sm;\n\t\t\t \n\t\t}\n\n\t\t&.btn-lg {\n\t\t\theight: $input-height-lg;\n\t\t\twidth: $input-height-lg;\n\t\t}\n\n\t\t&.btn-circle {\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n}","//\n// Reset\n//\n\n@mixin button-reset() {\n    appearance: none;\n    box-shadow: none;\n    border-radius: 0;\n    border: none;\n    cursor: pointer;\n    background-color: transparent;\n    outline: none  !important;\n    margin: 0;\n    padding: 0;\n}\n\n@mixin input-reset() {\n\tborder: 0;\n\tbackground-color: transparent;\n    outline: none !important;\n\tbox-shadow: none;\n    border-radius: 0;\n}\n","//\n// Buttons Theme\n//\n\n// Outline dashed basic style\n.btn.btn-outline.btn-outline-dashed {\n\tborder-width: 1px;\n\tborder-style: dashed;\t\n\t\n\t$color: null;\n\t$icon-color: null;\n\t$border-color: null;\n\t$bg-color: null;;\n\n\t$color-active: null;\n\t$icon-color-active: null;\n\t$border-color-active: var(--#{$prefix}primary);\n\t$bg-color-active: null;\n\n\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n}\n\n// Outline hover basic style\n.btn.btn-hover-outline {\n\tborder-width: 1px;\n\tborder-style: solid;\t\n\t\n\t$color: null;\n\t$icon-color: null;\n\t$border-color: null;\n\t$bg-color: null;\n\n\t$color-active: null;\n\t$icon-color-active: null;\n\t$border-color-active: $input-border-color;\n\t$bg-color-active: null;\n\n\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n}\n\n// Theme colors\n@each $name, $value in $theme-colors {\n\t// Base\n\t.btn.btn-#{$name} {\n\t\t$color: var(--#{$prefix}#{$name}-inverse);\n\t\t$icon-color: var(--#{$prefix}#{$name}-inverse);\n\t\t$border-color: var(--#{$prefix}#{$name});\n\t\t$bg-color: var(--#{$prefix}#{$name});\n\n\t\t$color-active: var(--#{$prefix}#{$name}-inverse);\n\t\t$icon-color-active: var(--#{$prefix}#{$name}-inverse);\n\t\t$border-color-active: var(--#{$prefix}#{$name}-active);\n\t\t$bg-color-active: var(--#{$prefix}#{$name}-active);\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Light\n\t@if ( theme-light-color($name) ) {\n\t\t.btn.btn-light-#{$name} {\n\t\t\t$color: var(--#{$prefix}#{$name});\n\t\t\t$icon-color: var(--#{$prefix}#{$name});\n\t\t\t$border-color: var(--#{$prefix}#{$name}-light);\n\t\t\t$bg-color: var(--#{$prefix}#{$name}-light);\n\t\n\t\t\t$color-active: var(--#{$prefix}#{$name}-inverse);\n\t\t\t$icon-color-active: var(--#{$prefix}#{$name}-inverse);\n\t\t\t$border-color-active: var(--#{$prefix}#{$name});\n\t\t\t$bg-color-active: var(--#{$prefix}#{$name});\n\t\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\t}\t\n\n\t// Background\n\t.btn.btn-bg-#{$name} {\n\t\t$color: null;\n\t\t$icon-color: null;\n\t\t$border-color: var(--#{$prefix}#{$name});\n\t\t$bg-color: var(--#{$prefix}#{$name});\t\t\n\n\t\t$color-active: null;\n\t\t$icon-color-active: null;\n\t\t$border-color-active: null;\n\t\t$bg-color-active: null;\t\t\t\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\t\n\t// Active\n\t.btn.btn-active-#{$name} {\n\t\t$color: null;\n\t\t$icon-color: null;\n\t\t$border-color: null;\n\t\t$bg-color: null;\n\n\t\t$color-active: var(--#{$prefix}#{$name}-inverse);\n\t\t$icon-color-active: var(--#{$prefix}#{$name}-inverse);\n\t\t$border-color-active: var(--#{$prefix}#{$name});\n\t\t$bg-color-active: var(--#{$prefix}#{$name});\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Light\n\t@if ( theme-light-color($name) ) {\n\t\t.btn.btn-active-light-#{$name} {\n\t\t\t$color: null;\n\t\t\t$icon-color: null;\n\t\t\t$border-color: null;\n\t\t\t$bg-color: null;\n\n\t\t\t$color-active: var(--#{$prefix}#{$name});\n\t\t\t$icon-color-active: var(--#{$prefix}#{$name});\n\t\t\t$border-color-active: var(--#{$prefix}#{$name}-light);\n\t\t\t$bg-color-active: var(--#{$prefix}#{$name}-light);\n\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t\t}\n\t}\n\n\t// Outline\n\t.btn.btn-outline.btn-outline-#{$name} {\n\t\t$color: var(--#{$prefix}#{$name});\n\t\t$icon-color: var(--#{$prefix}#{$name});\n\t\t$border-color: var(--#{$prefix}#{$name});\n\t\t$bg-color: transparent;\n\n\t\t$color-active: var(--#{$prefix}#{$name}-active);\n\t\t$icon-color-active: var(--#{$prefix}#{$name}-active);\n\t\t$border-color-active: var(--#{$prefix}#{$name});\n\t\t$bg-color-active: var(--#{$prefix}#{$name}-light);\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n}\n\n// Theme text colors\n@each $name, $value in $theme-text-colors {\n\t// Text and icon colors\n\t.btn.btn-color-#{$name} {\n\t\t$color: var(--#{$prefix}text-#{$name});\n\t\t$icon-color: var(--#{$prefix}text-#{$name});\n\t\t$bg-color: null;\n\t\t$border-color: null;\n\n\t\t$color-active: null;\n\t\t$icon-color-active: null;\n\t\t$border-color-active: null;\n\t\t$bg-color-active: null;\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Text and icon colors active state\n\t.btn.btn-active-color-#{$name} {\n\t\t$color: null;\n\t\t$icon-color: null;\n\t\t$border-color: null;\n\t\t$bg-color: null;\n\n\t\t$color-active: var(--#{$prefix}text-#{$name});\n\t\t$icon-color-active: var(--#{$prefix}text-#{$name});\n\t\t$border-color-active: null;\n\t\t$bg-color-active: null;\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Icon colors \n\t.btn.btn-icon-#{$name} {\n\t\t$color: null;\n\t\t$icon-color: var(--#{$prefix}text-#{$name});\n\t\t$bg-color: null;\n\t\t$border-color: null;\n\n\t\t$color-active: null;\n\t\t$icon-color-active: null;\n\t\t$border-color-active: null;\n\t\t$bg-color-active: null;\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Icon colors active state\n\t.btn.btn-active-icon-#{$name} {\n\t\t$color: null;\n\t\t$icon-color: null;\n\t\t$bg-color: null;\n\t\t$border-color: null;\n\n\t\t$color-active: null;\n\t\t$icon-color-active: var(--#{$prefix}text-#{$name});\n\t\t$border-color-active: null;\n\t\t$bg-color-active: null;\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Text colors\n\t.btn.btn-text-#{$name} {\n\t\t$color: var(--#{$prefix}text-#{$name});\n\t\t$icon-color: null;\n\t\t$bg-color: null;\n\t\t$border-color: null;\n\n\t\t$color-active: null;\n\t\t$icon-color-active: null;\n\t\t$border-color-active: null;\n\t\t$bg-color-active: null;\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Text colors active state\n\t.btn.btn-active-text-#{$name} {\n\t\t$color: null;\n\t\t$icon-color: null;\n\t\t$bg-color: null;\n\t\t$border-color: null;\n\n\t\t$color-active: var(--#{$prefix}text-#{$name});\n\t\t$icon-color-active: null;\n\t\t$border-color-active: null;\n\t\t$bg-color-active: null;\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\t\n}\n\n// Social colors\n@each $name, $value in $social-colors {\n\t// Base\n\t.btn.btn-#{$name} {\n\t\t$color: get($value, inverse);\n\t\t$icon-color: get($value, inverse);\n\t\t$border-color: get($value, base);\n\t\t$bg-color: get($value, base);\n\n\t\t$color-active: null;\n\t\t$icon-color-active: null;\n\t\t$border-color-active: get($value, active);\n\t\t$bg-color-active: get($value, active);\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n\n\t// Light\n\t.btn.btn-light-#{$name} {\n\t\t$color: get($value, base);\n\t\t$icon-color: get($value, base);\n\t\t$bg-color: get($value, light);\n\t\t$border-color: get($value, light);\n\n\t\t$color-active: get($value, inverse);\n\t\t$icon-color-active: get($value, inverse);\n\t\t$bg-color-active: get($value, base);\n\t\t$border-color-active: get($value, base);\n\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\n\t}\n}\n\n@include color-mode(dark) {\n\t.btn.btn-dark {\n\t\t@include button-custom-variant(\n\t\t\t$color: $gray-800-dark, \n\t\t\t$icon-color: $gray-800-dark, \n\t\t\t$border-color: null, \n\t\t\t$bg-color: $gray-400-dark,\n\t\t\t$color-active: lighten($gray-800-dark, 3%), \n\t\t\t$icon-color-active: lighten($gray-800-dark, 3%), \n\t\t\t$border-color-active: null, \n\t\t\t$bg-color-active: lighten($gray-400-dark, 3%),\n\t\t);\n\t}\n}","//\n// Button Mixins\n//\n\n// Custom variant\n@mixin button-custom-variant(\n    $color,\n    $icon-color,\n    $border-color,\n    $bg-color,\n    $color-active,\n    $icon-color-active,\n    $border-color-active,\n    $bg-color-active\n) {\n\n    @if ( $color != null ) {\n        color: $color;\n    }\n\n    @if ( $icon-color != null ) {\n        i,\n        .svg-icon {\n    \t\tcolor: $icon-color;\n    \t}\n\n        &.dropdown-toggle:after {\n            color: $icon-color;\n        }\n    }\n\n    @if ( $border-color != null ) {\n        border-color: $border-color;\n    }\n\n    @if ( $bg-color != null ) {\n        background-color: $bg-color;\n    }\n\n    .btn-check:checked + &,\n    .btn-check:active + &,\n    &:focus:not(.btn-active),\n    &:hover:not(.btn-active),\n    &:active:not(.btn-active),\n    &.active,\n    &.show,\n    .show > & {\n        @if ( $color-active != null ) {\n            color: $color-active;\n        }\n\n        @if ( $icon-color-active != null ) {\n            i,\n            .svg-icon {\n        \t\tcolor: $icon-color-active;\n        \t}\n\n            &.dropdown-toggle:after {\n                color: $icon-color-active;\n            }\n        }\n\n        @if ( $border-color-active != null ) {\n            border-color: $border-color-active;\n        }\n\n        @if ( $bg-color-active != null ) {\n            background-color: $bg-color-active !important;\n        }\n    }\n}\n\n@mixin button-active-state() {    \n    .btn-check:checked + &,\n    .btn-check:active + &,\n    &:focus:not(.btn-active),\n    &:hover:not(.btn-active),\n    &:active:not(.btn-active),\n    &.active,\n    &.show,\n    .show > & {\n        @content;\n    }\n}\n","// Bootstrap color system\n\n//\n// Bootstrap & Custom Variables\n// Safely override any variable in _variables.custom.scss\n//\n\n$gray-100-dark:  #1B1C22 !default;\n$gray-200-dark:  #26272F !default;\n$gray-300-dark:  #363843 !default;\n$gray-400-dark:  #464852 !default;\n$gray-500-dark:  #636674 !default;\n$gray-600-dark:  #808290 !default;\n$gray-700-dark:  #9A9CAE !default;\n$gray-800-dark:  #B5B7C8 !default;\n$gray-900-dark:  #F5F5F5 !default;\n\n$grays-dark: (\n\t\"100\": $gray-100-dark,\n\t\"200\": $gray-200-dark,\n\t\"300\": $gray-300-dark,\n\t\"400\": $gray-400-dark,\n\t\"500\": $gray-500-dark,\n\t\"600\": $gray-600-dark,\n\t\"700\": $gray-700-dark,\n\t\"800\": $gray-800-dark,\n\t\"900\": $gray-900-dark\n) !default;\n\n// Bootstrap muted color\n$text-muted-dark: $gray-500-dark !default;\n\n// Bootstrap contextual colors\n// Primary colors\n$primary-dark:\t\t\t\t\t\t#006AE6 !default;\n$primary-active-dark:\t\t\t\t#107EFF !default;\n$primary-light-dark: \t\t\t\t#172331 !default;\n$primary-clarity-dark: \t\t\t\trgba(#006AE6, 0.2) !default;\n$primary-inverse-dark: \t\t\t\t$white !default;\n\n// Secondary colors\n$secondary-dark: \t\t\t\t\t$gray-300-dark !default;\n$secondary-active-dark: \t\t\t$gray-400-dark !default;\n$secondary-light-dark: \t\t\t\t$gray-300-dark !default;\n$secondary-clarity-dark:\t\t\trgba($gray-300-dark, 0.2) !default; \n$secondary-inverse-dark:\t\t\t$white !default; \n\n// Light colors\n$light-dark: \t\t\t\t\t\t$gray-100-dark !default;\n$light-active-dark: \t\t\t\t#1F212A !default;\n$light-light-dark: \t\t\t\t\t#1F212A !default;\n$light-clarity-dark: \t\t\t\trgba(31, 33, 42, 0.20) !default;\n$light-inverse-dark:\t\t\t\t$gray-600-dark !default;\n\n// Success colors\n$success-dark: \t\t\t\t\t\t#00A261 !default; \n$success-active-dark: \t\t\t\t#01BF73 !default;\n$success-light-dark: \t\t\t\t#1F212A !default;\n$success-clarity-dark: \t\t\t\trgba(#00A261, 0.2) !default;\n$success-inverse-dark: \t\t\t\t$white !default;\n\n// Info colors\n$info-dark: \t\t\t\t\t\t#883FFF !default; \n$info-active-dark: \t\t\t\t\t#9E63FF !default;\n$info-light-dark: \t\t\t\t\t#272134 !default;\n$info-clarity-dark: \t\t\t\trgba(#883FFF, 0.2) !default;\n$info-inverse-dark: \t\t\t\t$white !default;\n\n// Warning colors\n$warning-dark: \t\t\t\t\t\t#C59A00 !default; \n$warning-active-dark: \t\t\t\t#D9AA00 !default;\n$warning-light-dark: \t\t\t\t#242320 !default;\n$warning-clarity-dark: \t\t\t\trgba(#C59A00, 0.2) !default;\n$warning-inverse-dark: \t\t\t\t$white !default;\n\n// Danger colors\n$danger-dark: \t\t\t\t\t\t#E42855 !default; \n$danger-active-dark: \t\t\t\t#FF3767 !default;\n$danger-light-dark: \t\t\t\t#302024 !default;\n$danger-clarity-dark: \t\t\t\trgba(#E42855, 0.2) !default;\n$danger-inverse-dark: \t\t\t\t$white !default;\n\n// Dark colors\n$dark-dark: \t\t\t\t\t\t#272A34 !default;\n$dark-active-dark: \t\t\t\t\t#2D2F39 !default;\n$dark-light-dark: \t\t\t\t\t#1E2027 !default;\n$dark-clarity-dark: \t\t\t\trgba(#272A34, 0.2) !default;\n$dark-inverse-dark: \t\t\t\t$white !default;\n\n// Contextual colors\n$theme-colors-dark: (\n\t\"light\": $light-dark,\n\t\"primary\": $primary-dark,\n\t\"secondary\": $secondary-dark,\n\t\"success\": $success-dark,\n\t\"info\": $info-dark,\n\t\"warning\": $warning-dark,\n\t\"danger\": $danger-dark,\n\t\"dark\": $dark-dark\n) !default;\n\t\n// Contextual active state colors\n$theme-active-colors-dark: (\n\t\"primary\": $primary-active-dark,\n\t\"secondary\":  $secondary-active-dark,\n\t\"light\":   $light-active-dark,\n\t\"success\": $success-active-dark,\n\t\"info\":    $info-active-dark,\n\t\"warning\": $warning-active-dark,\n\t\"danger\":  $danger-active-dark,\n\t\"dark\":    $dark-active-dark\n) !default; \n\n// Contextual inverse state colors\n$theme-inverse-colors-dark: (\n\t\"primary\": $primary-inverse-dark,\n\t\"secondary\":  $secondary-inverse-dark,\n\t\"light\":   $light-inverse-dark,\n\t\"success\": $success-inverse-dark,\n\t\"info\":    $info-inverse-dark,\n\t\"warning\": $warning-inverse-dark,\n\t\"danger\":  $danger-inverse-dark,\n\t\"dark\":    $dark-inverse-dark\n) !default; \n\n// Contextual light state colors\n$theme-light-colors-dark: (\n\t\"primary\": $primary-light-dark,\n\t\"secondary\": $secondary-light-dark,\n\t\"success\": $success-light-dark,\n\t\"info\":    $info-light-dark,\n\t\"warning\": $warning-light-dark,\n\t\"danger\":  $danger-light-dark,\n\t\"dark\":    $dark-light-dark,\n\t\"light\":   $light-light-dark\n) !default; \n\n// Contextual light state colors\n$theme-clarity-colors-dark: (\n\t\"primary\": $primary-clarity-dark,\n\t\"secondary\": $secondary-clarity-dark,\n\t\"success\": $success-clarity-dark,\n\t\"info\":    $info-clarity-dark,\n\t\"warning\": $warning-clarity-dark,\n\t\"danger\":  $danger-clarity-dark,\n\t\"dark\":    $dark-clarity-dark,\n\t\"light\":   $light-clarity-dark,\n) !default; \n\n// Text colors\n$theme-text-colors-dark: (\n\t\"white\":   $white,\n\t\"primary\": $primary-dark,\n\t\"secondary\":  $secondary-dark,\n\t\"light\":   $light-dark,\n\t\"success\": $success-dark,\n\t\"info\":    $info-dark,\n\t\"warning\": $warning-dark,\n\t\"danger\":  $danger-dark,\n\t\"dark\":    $dark-dark,\n\t\"muted\":   $text-muted-dark,\n\t\"gray-100\":   $gray-100-dark,\n\t\"gray-200\":   $gray-200-dark,\n\t\"gray-300\":   $gray-300-dark,\n\t\"gray-400\":   $gray-400-dark,\n\t\"gray-500\":   $gray-500-dark,\n\t\"gray-600\":   $gray-600-dark,\n\t\"gray-700\":   $gray-700-dark,\n\t\"gray-800\":   $gray-800-dark,\n\t\"gray-900\":   $gray-900-dark\n) !default; \n\n\n// Body\n//\n// Settings for the `<body>` element.\n$body-bg-dark:              #1C1D22 !default;\n$body-bg-rgb-dark:          to-rgb($body-bg-dark) !default;\n$body-color-dark:           $gray-900-dark !default;\n\n\n// Links\n//\n// Style anchor elements.\n$link-color-dark:           $primary-dark !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n$border-color-dark:             $gray-200-dark !default;\n$border-dashed-color-dark:      $gray-300-dark !default; \n\n// Keenthemes hover states\n$component-hover-color-dark: \t$primary-dark !default;\n$component-hover-bg-dark: \t\t$gray-100-dark !default;\n\n// Keenthemes active states\n$component-active-color-dark:   $primary-inverse !default;\n$component-active-bg-dark:      $primary-dark !default;\n\n// Keenthemes checked states\n$component-checked-color-dark:   $primary-inverse !default;\n$component-checked-bg-dark:      $primary-dark !default;\n\n$headings-color-dark: \t\t\t $gray-900-dark !default;\n$blockquote-footer-color-dark:   $gray-600-dark !default;\n\n\n// Box shadow\n$box-shadow-xs-dark: \t\t\t0 .1rem 0.75rem 0.25rem rgba($black, 0.05) !default;\n$box-shadow-sm-dark: \t\t\t0 .1rem 1rem 0.25rem rgba($black, .05) !default;\n$box-shadow-dark: \t\t\t\t0 .5rem 1.5rem 0.5rem rgba($black, .075) !default;\n$box-shadow-lg-dark: \t\t\t0 1rem 2rem 1rem rgba($black, .1) !default;\n$box-shadow-inset-dark: \t\tinset 0 1px 2px rgba($black, .075) !default;\n\n\n// Card\n$card-box-shadow-dark:                   \t\t\tnull !default;\n$card-border-color-dark:     \t\t\t\t\t\t$border-color-dark !default;\n\n// Tables\n$table-striped-bg-dark:         \t\t\t\t\trgba($gray-100-dark, 0.75) !default;\n$table-loading-message-box-shadow-dark:        \t\t0px 0px 30px rgba(0, 0, 0, 0.3) !default;\n\t\n// Forms\n$form-select-indicator-color-dark:                  $gray-600-dark !default;\n$form-select-indicator-dark:                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n$form-switch-color-dark:                            rgba($white, .25) !default;\n$form-switch-color-solid-dark:                      $gray-500-dark !default;\n$form-switch-bg-image-dark:                         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-dark}'/></svg>\") !default;\n$form-switch-bg-image-solid-dark:                   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-solid-dark}'/></svg>\") !default;\n\n\n// Accordion\n$accordion-icon-color-dark:                         $body-color-dark!default;\n$accordion-icon-active-color-dark:                  $primary-dark !default;\n$accordion-button-icon-dark:         \t\t\t\turl(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon-dark:  \t\t\t\turl(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n\n// Dropdowns\n$dropdown-bg-dark:                                  $body-bg-dark !default;\n$dropdown-box-shadow-dark:\t\t\t\t\t\t\t0px 0px 30px rgba(0, 0, 0, 0.3) !default;\n\n// Popover\n$popover-bg-dark:                            \t\t$gray-200-dark !default;\n$popover-border-color-dark:                         $gray-200-dark !default;\n$popover-box-shadow-dark:    \t\t\t\t\t\t$dropdown-box-shadow-dark !default;\n$popover-header-border-color-dark:           \t\t$gray-300-dark !default;\n\n// Toasts\n$toast-background-color-dark:                \t\t$gray-200-dark !default;\n$toast-header-background-color-dark:         \t\t$gray-200-dark !default;\n$toast-header-border-color-dark:             \t\t$gray-300-dark !default;\n\n// Tooltip\n$tooltip-bg-dark:                            \t\t$gray-200-dark !default;\n$tooltip-box-shadow-dark:    \t\t\t\t\t\t0px 0px 30px rgba(0, 0, 0, 0.15) !default;\n\n// Code\n$code-bg-dark:                   #2b2b40 !default;\n$code-shadow-dark:               rgba(0, 0, 0, 0.08) 0px 3px 9px 0px !default;\n$code-color-dark:                #b93993 !default;\n$code-border-color-dark:         transparent  !default;\n\n// Symbol\n$symbol-border-color-dark: rgba($body-bg, 0.5);\n$symbol-label-color-dark: $gray-800-dark;\n$symbol-label-bg-dark: $gray-100-dark;\n\n\n// Keenthemes bullet component\n$bullet-bg-color-dark: $gray-400-dark !default;\n\n// Keenthemes scrolltop component\n$scrolltop-opacity-dark: 0 !default;\n$scrolltop-opacity-on-dark: 0.3 !default;\n$scrolltop-opacity-hover-dark: 1 !default;\n$scrolltop-box-shadow-dark: $box-shadow !default;\n$scrolltop-bg-color-dark: $primary !default;\n$scrolltop-bg-color-hover-dark: $primary !default;\n$scrolltop-icon-color-dark: $primary-inverse !default;\n$scrolltop-icon-color-hover-dark: $primary-inverse !default;\n\n\n// Keenthemes drawer component\n$drawer-box-shadow-dark: 0px 0px 30px rgba(0, 0, 0, 0.1) !default;\n$drawer-bg-color-dark: $body-bg-dark !default;\n$drawer-overlay-bg-color-dark: rgba($black, 0.4) !default;\n\n// Keenthemes menu component   \n$menu-dropdown-box-shadow-dark: $dropdown-box-shadow-dark !default;\n$menu-dropdown-bg-color-dark: $dropdown-bg-dark !default;\n$menu-link-color-hover-dark: $component-hover-color-dark !default;\n$menu-link-color-show-dark: $component-hover-color-dark !default;\n$menu-link-color-here-dark: $component-hover-color-dark !default;\n$menu-link-color-active-dark: $component-hover-color-dark !default;\n$menu-link-bg-color-hover-dark: $component-hover-bg-dark !default;\n$menu-link-bg-color-show-dark: $component-hover-bg-dark !default;\n$menu-link-bg-color-here-dark: $component-hover-bg-dark !default;\n$menu-link-bg-color-active-dark: $component-hover-bg-dark !default;\n$menu-heading-color-dark: $text-muted-dark !default;\n\t\n// Keenthemes scrollbar component \n$scrollbar-color-dark: $gray-200-dark !default;\n$scrollbar-hover-color-dark: $gray-300-dark !default;\n\n// Keenthemes overlay component \n$overlay-bg-dark: rgba($white, 0.05) !default;\n\n// Keenthemes blockui component \n$blockui-overlay-bg-dark: rgba($white, 0.05) !default;\n$blockui-message-bg-dark: $tooltip-bg-dark !default;\n$blockui-message-box-shadow-dark: $tooltip-box-shadow-dark !default;\n\n// Keenthemes rating component \n$rating-color-default-dark: $gray-400-dark !default;\n$rating-color-active-dark: #FFAD0F !default;\n\n// Keenthemes ribbon component \n$ribbon-label-box-shadow-dark: 0px -1px 5px 0px rgba($white, 0.1) !default;\n$ribbon-label-bg-dark: $primary !default;\n$ribbon-label-border-color-dark: darken($primary, 20%) !default;\n$ribbon-clip-bg-dark: $light !default;\n\n// Engage panel\n$engage-btn-bg-dark: $gray-200-dark;\n$engage-btn-box-shadow-dark: 0px 0px 30px rgba(0, 0, 0, 0.3);\n$engage-btn-border-color-dark: $border-color-dark;\n$engage-btn-color-dark: $gray-800-dark;\n$engage-btn-icon-color-dark: $gray-600-dark;\n$engage-btn-color-active-dark: $gray-800-dark;","//\n// Modal\n//\n\n.modal-rounded {\n\tborder-radius: $modal-content-border-radius !important;\t\n}","//\n// Code\n//\n\ncode:not([class*=\"language-\"]) {\n    font-weight: $code-font-weight;\n    color: var(--#{$prefix}code-color);\n    border: 1px solid var(--#{$prefix}code-border-color);\n    background-color: var(--#{$prefix}code-bg);\n    @include border-radius($code-border-radius);\n    line-height: inherit;\n    font-size: $code-font-size;\n    padding: $code-padding;\n    margin: $code-margin;        \n    box-shadow: $code-shadow;\n\n    @each $name, $value in $theme-colors {\n        &.code-#{$name} {\n            color: var(--#{$prefix}#{$name});\n            background-color: var(--#{$prefix}#{$name}-light);\n            border: 1px solid var(--#{$prefix}#{$name});\n        }\n    }\n}\n","\n//\n// Col form label\n//\n\n.col-form-label {\n\t@include font-size($form-label-font-size);\n}","//\n// Form controls\n//\n\n// Customization\n.form-control {\n\t// Transparent style\n\t&.form-control-transparent {\n\t\tbackground-color: transparent;\n\t\tborder-color: transparent;\n\n\t\t.dropdown.show > &,\n\t\t&:active,\n\t\t&.active,\n\t\t&:focus,\n\t\t&.focus {\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: transparent;\n\t\t}\n\t}\n\n\t// Flush\n\t&.form-control-flush {\n\t\t@include input-reset();\n\t}\n}\n\n// Solid style\n.form-control.form-control-solid {\n\tbackground-color: $input-solid-bg;\n\tborder-color: $input-solid-bg;\n\tcolor: $input-solid-color;\n\t@include placeholder($input-solid-placeholder-color);\n\ttransition: $transition-input;\n\n\t.dropdown.show > &,\n\t&:active,\n\t&.active,\n\t&:focus,\n\t&.focus {\n\t\tbackground-color: $input-solid-bg-focus;\n\t\tborder-color: $input-solid-bg-focus;\n\t\tcolor: $input-solid-color;\n\t\ttransition: $transition-input;\n\t}\n}\n\n// Form control solid bg\n.form-control-solid-bg {\n\tbackground-color: $input-solid-bg;\n}\n\n// Readonly controls as plain text\n.form-control-plaintext {\n  \tcolor: $input-plaintext-color\n}\n\n// Placeholder colors\n.placeholder-gray-500 {\n\t@include placeholder(var(--#{$prefix}gray-500));\n}\n\n.placeholder-white {\n\t@include placeholder($white);\n}\n\n// Textarea reset resize\n.resize-none {\n\tresize: none;\n}","//\n// Input placeholder color\n//\n\n@mixin placeholder($color) {\n    // Chrome, Firefox, Opera, Safari 10.1+\n    &::placeholder { \n        color: $color;\n    }\n    \n    // Firefox\n    &::-moz-placeholder {\n        color: $color;\n        opacity: 1;\n    }\n}\n","//\n// Floating label\n//\n\n.form-floating {\n    .form-control.form-control-solid {\n        &::placeholder {\n            color: transparent;    \n        }\n    }\n\n    &.form-control-solid-bg label,\n    > :disabled ~ label,\n    > :focus ~ label {\n        &::after {\n            background-color: transparent !important;\n        }\n    }\n}\n     ","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n\tappearance: none;\n\t//box-shadow: none !important;\n\n\t&:focus {\n\t\tborder-color: $form-select-focus-border-color;\n\t\t@if $enable-shadows {\n\t\t\t@include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n\t\t} @else {\n\t\t\t// Avoid using mixin so we can pass custom focus shadow properly\n\t\t\tbox-shadow: $form-select-focus-box-shadow;\n\t\t}\n\t}\n\n\t&:disabled {\n\t\tcolor: $form-select-disabled-color;\n\t\tbackground-color: $form-select-disabled-bg;\n\t\tborder-color: $form-select-disabled-border-color;\n\t}\n\n\t// Remove outline from select box in FF\n\t&:-moz-focusring {\n\t\ttext-shadow: 0 0 0 $form-select-color;\n\t}\n\n\t// Solid style\n\t&.form-select-solid {\n\t\t@include placeholder($input-solid-placeholder-color);\n\t\tbackground-color: $input-solid-bg;\n\t\tborder-color: $input-solid-bg;\n\t\tcolor: $input-solid-color;\n\t\ttransition: $transition-input;\n\t\t\n\t\t.dropdown.show > &,\n\t\t&:active,\n\t\t&.active,\n\t\t&:focus,\n\t\t&.focus {\n\t\t\tbackground-color: $input-solid-bg-focus;\n\t\t\tborder-color: $input-solid-bg-focus !important;\n\t\t\tcolor: $input-solid-color;\n\t\t\ttransition: $transition-input;\n\t\t}\n\t}\n\n\t// Transparent style\n\t&.form-select-transparent {\n\t\t@include placeholder($input-placeholder-color);\n\t\tbackground-color: transparent;\n\t\tborder-color: transparent;\n\t\tcolor: $input-color;\n\n\t\t.dropdown.show > &,\n\t\t&:active,\n\t\t&.active,\n\t\t&:focus,\n\t\t&.focus {\n\t\t\tbackground-color: transparent;\n\t\t\tborder-color: transparent !important;\n\t\t\tcolor: $input-color;\n\t\t}\n\t}\n}","//\n// Form Check\n//\n\n// Customization\n.form-check {\n    // Input \n    &:not(.form-switch) {\n        .form-check-input {\n            &[type=\"checkbox\"] {\n                background-size: $form-check-input-bg-size;\n            }\n        }\n    }\n    \n    // Sizing\n    &.form-check-sm {\n        .form-check-input {\n            height: $form-check-input-width-sm;\n            width: $form-check-input-width-sm;\n        }\n    }\n\n    &.form-check-lg {\n        .form-check-input {\n            height: $form-check-input-width-lg;\n            width: $form-check-input-width-lg;\n        }\n    }\n\n    // Inline\n    &.form-check-inline {\n        display: inline-block;\n        margin-right: $form-check-inline-margin-end;\n    }\n\n    // Solid\n    &.form-check-solid {\n        .form-check-input {\n            border: 0;\n\n            &:not(:checked) {\n                background-color: $form-check-input-bg-solid;\n            }            \n\n            &[type=checkbox]:indeterminate {\n                background-color: $form-check-input-checked-bg-color;\n            }\n        }\n    }\n\n    // States\n    // Success state\n    &.form-check-success {\n        .form-check-input {\n            &:checked {\n                background-color: var(--#{$prefix}success);\n            }\n        }\n    }\n\n    // Danger state\n    &.form-check-danger {\n        .form-check-input {\n            &:checked {\n                background-color: var(--#{$prefix}danger);\n            }\n        }\n    }\n\n    // Warning state\n    &.form-check-warning {\n        .form-check-input {\n            &:checked {\n                background-color: var(--#{$prefix}warning);\n            }\n        }\n    }\n}\n\n// Custom checkbox and radio\n.form-check-custom {\n    display: flex;\n    align-items: center;\n    padding-left: 0;\n    margin: 0;\n\n    // Input\n    .form-check-input {\n        margin: 0;\n        float: none;\n        flex-shrink: 0;\n    }\n\n    // Label\n    .form-check-label {\n        margin-left: 0.55rem;\n    }\n}\n\n// Switch\n.form-switch {   \n    &.form-check-custom {\n        .form-check-input {\n            height: $form-switch-height;\n        }\n\n        &.form-switch-sm {\n            .form-check-input {\n                height: $form-switch-height-sm;\n                width: $form-switch-width-sm;\n            }\n        }\n\n        &.form-switch-lg {\n            .form-check-input {\n                height: $form-switch-height-lg;\n                width: $form-switch-width-lg;\n            }\n        }\n    }\n\n    // Solid\n    &.form-check-solid {\n        .form-check-input {\n            --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-solid)};\n\n            &:not(:checked) {\n                background-color: $form-check-input-bg-solid;\n            } \n        }\n    }    \n}\n\n@if $enable-dark-mode {\n    @include color-mode(dark) {\n        .form-switch .form-check-input {\n            &:focus:not(:checked) {\n                --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n            }\n        }\n    }\n}\n\n// Image \n.form-check-image {\n    position: relative;\n    overflow: hidden;\n\n    img {\n        max-width: 100%;    \n    }\n\n    .form-check-wrapper {        \n        @include border-radius($border-radius-lg);        \n        border: 2px solid transparent;    \n        transition: $transition-base;\n        cursor: pointer;\n        overflow: hidden;\n        margin-bottom: 0.75rem;\n    }\n\n    .form-check-rounded {\n        @include border-radius($border-radius-lg);        \n    }        \n\n    .form-check-label {\n        font-weight: $font-weight-bold;    \n        margin-left: 0.5rem;\n    }\n\n    &.active:not(.form-check-success):not(.form-check-danger) {\n        .form-check-wrapper {\n            border-color: var(--#{$prefix}primary) !important;\n        }    \n    }\n\n    &.form-check-success.active {\n        .form-check-wrapper {\n            border-color: var(--#{$prefix}success) !important;\n        } \n    }\n\n    &.form-check-danger.active {\n        .form-check-wrapper {\n            border-color: var(--#{$prefix}danger) !important;\n        } \n    }\n\n    &.disabled {\n        opacity: $form-check-btn-check-disabled-opacity;\n    }\n}","//\n// Input Group\n//\n\n// Form control\n.input-group {\n    &.input-group-solid {\n        @include border-radius($input-border-radius);\n\n        &.input-group-sm {\n            @include border-radius($input-border-radius-sm);\n        }\n\n        &.input-group-lg {\n            @include border-radius($input-border-radius-lg);\n        }\n\n        .input-group-text {\n            background-color: $input-solid-bg;\n\t\t    border-color: $input-solid-bg;\n\n            & + .form-control {\n                border-left-color: $input-border-color;\n            }\n        }\n\n        .form-control {\n            background-color: $input-solid-bg;\n    \t\tborder-color: $input-solid-bg;\n\n            & + .input-group-text {\n                border-left-color: $input-border-color;\n            }\n        }\n    }\n}\n","//\n// Required Label\n//\n\n.required {\n    &:after {\n        content: \"*\";\n        position: relative;\n        font-size: inherit;\n        color: var(--#{$prefix}danger);\n        padding-left: 0.25rem;\n        font-weight: $font-weight-bold;\n    }\n}","//\n// Progress\n//\n\n// Vertical Position\n.progress-vertical {\n    display: flex;\n    align-items: stretch;\n    justify-content: space-between;\n\n    .progress {\n        height: 100%;\n        @include border-radius($border-radius);\n        display: flex;\n        align-items: flex-end;\n        margin-right: 1rem;\n\n        &:last-child {\n            margin-right: 0;\n        }\n\n        .progress-bar {\n            width: 8px;\n            @include border-radius($border-radius);\n        }\n    }\n}\n","//\n// Table\n//\n\n// Table\n.table:not(.table-bordered) {\n\t// Fix for BS 5.1.2 update\n\t& > :not(:first-child) {\n    \tborder-color: transparent;\n\t\tborder-width: 0;\n\t\tborder-style: none;\n\t}\n\t\n\t>:not(:last-child)>:last-child>* {\n\t\tborder-bottom-color: inherit;\n\t}\n\n\ttr, th, td {\n\t\tborder-color: inherit;\n\t\tborder-width: inherit;\n\t\tborder-style: inherit;\n\t\ttext-transform: inherit;\n\t\tfont-weight: inherit;\n\t\tfont-size: inherit;\n\t\tcolor: inherit;\n\t\theight: inherit;\n\t\tmin-height: inherit;\n\n\t\t&:first-child {\n\t\t\tpadding-left: 0;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n\n\ttfoot,\n\ttbody {\n\t\ttr:last-child {\n\t\t\tborder-bottom: 0 !important;\n\n\t\t\tth, td {\n\t\t\t\tborder-bottom: 0 !important;\n\t\t\t}\n\t\t}\n\t}\n\n\ttfoot {\n\t\tth, td {\n\t\t\tborder-top: inherit;\n\t\t}\n\t}\n\n\t// Rounded\n\t&.table-rounded {\n\t\tborder-radius: $border-radius;\n\t\tborder-spacing: 0;\n\t\tborder-collapse: separate;\n\t}\n\n\t// Row Rounded\n\t&.table-rows-rounded {\n\t\tth,td {\n\t\t\t&:first-child {\n\t\t\t\tborder-top-left-radius: 6px;\n\t\t\t\tborder-bottom-left-radius: 6px;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\tborder-top-right-radius: 6px;\n\t\t\t\tborder-bottom-right-radius: 6px;\n\t\t\t}\n\t\t}\n\n\t}\n\n\t// Flush\n\t&.table-flush {\n\t\ttr, th, td {\n\t\t\tpadding: inherit;\n\t\t}\n\t}\n\n\t// Row bordered\n\t&.table-row-bordered {\n\t\ttr {\n\t\t\tborder-bottom-width: 1px;\n\t\t\tborder-bottom-style: solid;\n\t\t\tborder-bottom-color: var(--#{$prefix}border-color);\n\t\t}\n\n\t\ttfoot {\n\t\t\tth, td {\n\t\t\t\tborder-top-width: 1px !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t// Row dashed\n\t&.table-row-dashed {\n\t\ttr {\n\t\t\tborder-bottom-width: 1px;\n\t\t\tborder-bottom-style: dashed;\n\t\t\tborder-bottom-color: var(--#{$prefix}border-color);\n\t\t}\n\n\t\ttfoot {\n\t\t\tth, td {\n\t\t\t\tborder-top-width: 1px !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t// Row border colors\n\t@each $name, $value in $grays {\n\t\t&.table-row-gray-#{$name} {\n\t\t\ttr { \n\t\t\t\tborder-bottom-color: var(--#{$prefix}gray-#{$name});\n\t\t\t}\n\t\t}\n\t}\t\n}\n\n// Layout fixed\n.table-layout-fixed {\n\ttable-layout: fixed;\n}\n\n// Sorting\n.table-sort {\n\t&:after {\n\t\topacity: 0;\n\t}\n}\n\n.table-sort,\n.table-sort-asc,\n.table-sort-desc {\n\tvertical-align: middle;\n\n\t&:after {\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\twidth: 0.75rem;\n\t\theight: 0.75rem;\n\t\tcontent: \" \";\n\t\tbottom: auto;\n\t\tright: auto;\n\t\tleft: auto;\n\t\tmargin-left: 0.5rem;\n\t}\t\t\n}\n\n.table-sort-asc {\n\t&:after {\n\t\topacity: 1;\n\t\t@include svg-bg-icon(arrow-top, var(--#{$prefix}text-muted));\n\t}\n}\n\n.table-sort-desc {\n\t&:after {\n\t\topacity: 1;\n\t\t@include svg-bg-icon(arrow-bottom, var(--#{$prefix}text-muted));\n\t}\n}\n\n// Loading\n.table-loading-message {\n\tdisplay: none;\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\t@include border-radius($border-radius);\n\tbox-shadow: var(--#{$prefix}table-loading-message-box-shadow);\n\tbackground-color: $table-loading-message-bg;\n\tcolor: $table-loading-message-color;\n\tfont-weight: $font-weight-bold;\n\tmargin: 0 !important;\n\twidth: auto;\n\tpadding: 0.85rem 2rem !important;\n\ttransform: translateX(-50%) translateY(-50%);\n}\n\n.table-loading {\n\tposition: relative;\n\n\t.table-loading-message {\n\t\tdisplay: block;\n\t}\t\n}\n\n// Cell gutters\n@each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n        @each $name, $value in $gutters {\n\t\t\t.table.g#{$infix}-#{$name} {\n\t\t\t\tth, td {\n\t\t\t\t\tpadding: $value;\n\n\t\t\t\t\t// Datatables responsive mode fix\n\t\t\t\t\t&.dtr-control {\n\t\t\t\t\t\tpadding-left: $value !important;\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n\n            .table.gy#{$infix}-#{$name} {\n\t\t\t\tth, td {\n\t\t\t\t\tpadding-top: $value;\n\t\t\t\t\tpadding-bottom: $value;\n\t\t\t\t}\n            }\n\n\t\t\t.table.gx#{$infix}-#{$name} {\n\t\t\t\tth, td {\n\t\t\t\t\tpadding-left: $value;\n\t\t\t\t\tpadding-right: $value;\n\n\t\t\t\t\t// Datatables responsive mode fix\n\t\t\t\t\t&.dtr-control {\n\t\t\t\t\t\tpadding-left: $value !important;\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n\n\t\t\t.table.gs#{$infix}-#{$name} {\n\t\t\t\t th, td {\n\t\t\t\t\t&:first-child {\n\t   \t\t\t\t\tpadding-left: $value;\n\t\t\t\t\t}\n\n\t\t\t\t\t&:last-child {\n\t   \t\t\t\t\tpadding-right: $value;\n\t\t\t\t\t}\n\n\t\t\t\t\t// Datatables responsive mode fix\n\t\t\t\t\t&.dtr-control:first-child {\n\t\t\t\t\t\tpadding-left: $value !important;\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n        }\n    }\n}\n","//\n// Popover\n//\n\n\n// Base\n.popover {\n    --#{$prefix}popover-header-border-color: #{$popover-header-border-color};\n\n    .popover-header {\n        font-size: $popover-header-font-size;\n        font-weight: $popover-header-font-weight;\n        border-bottom: 1px solid var(--#{$prefix}popover-header-border-color);\n    }\n\n    .popover-dismiss {\n        position: absolute;\n        top: $popover-dissmis-btn-top;\n        right: $popover-dissmis-btn-end;\n        height: $popover-dissmis-btn-size;\n        width: $popover-dissmis-btn-size;\n        @include svg-bg-icon(close, var(--#{$prefix}gray-500)); // todo: revise\n        mask-size: 50%;\n        -webkit-mask-size: 50%;\n\n        &:hover {\n            background-color: var(--#{$prefix}primary);\n        }\n\n        & + .popover-header {\n            padding-right: $popover-body-padding-x + $popover-dissmis-btn-size;\n        }\n    }\n}\n\n// Inverse\n.popover-inverse {\n    --#{$prefix}popover-bg: var(--#{$prefix}gray-900);\n    --#{$prefix}popover-border-color: var(--#{$prefix}gray-900);\n    --#{$prefix}popover-box-shadow: #{$popover-box-shadow-dark};\n    --#{$prefix}popover-header-color: var(--#{$prefix}gray-200);\n    --#{$prefix}popover-header-bg: var(--#{$prefix}gray-900);\n    --#{$prefix}popover-body-color: var(--#{$prefix}gray-400);\n    --#{$prefix}popover-arrow-border: transparent;\n    --#{$prefix}popover-header-border-color: var(--#{$prefix}gray-800);\n}\n\n@if $enable-dark-mode {\n    @include color-mode(dark) {\n        .popover:not(.popover-inverse) {\n            --#{$prefix}popover-bg: #{$popover-bg-dark};\n            --#{$prefix}popover-border-color: #{$popover-border-color-dark};\n            --#{$prefix}popover-header-bg: #{$popover-bg-dark};\n            --#{$prefix}popover-box-shadow: #{$popover-box-shadow-dark};\n            --#{$prefix}popover-header-border-color: #{$popover-header-border-color-dark};\n        }\n    }\n}","//\n//  Tooltip\n//\n\n\n// Base\n.tooltip {\n    .tooltip-inner {\n        box-shadow: var(--#{$prefix}tooltip-box-shadow);\n    }\n\n    &.tooltop-auto-width {\n       \t.tooltip-inner {\n       \t\twhite-space: nowrap;\n  \t\t\tmax-width: none;\n        }\n    }\n\n    &.tooltip-inverse {\n        --#{$prefix}tooltip-color: var(--#{$prefix}dark-inverse);\n        --#{$prefix}tooltip-bg: var(--#{$prefix}dark);\n    }\n}\n\n@if $enable-dark-mode {\n    @include color-mode(dark) {\n        .tooltip:not(.tooltip-inverse) {\n            --#{$prefix}tooltip-bg: #{$tooltip-bg-dark};\n            --#{$prefix}tooltip-box-shadow: #{$tooltip-box-shadow-dark};\n        }\n    }\n}\n","//\n// Accordion\n//\n\n// Base\n.accordion {\n\t// According heading\n\t.accordion-header {\n\t\tcursor: pointer;\n\t}\n\n\t// Icon toggle mode\n\t&.accordion-icon-toggle {\n\t\t// Accordion icon expaned mode\n\t\t.accordion-icon {\n\t\t\tdisplay: flex;\n\t\t\tflex-shrink: 0;\n\t\t\ttransition: $transition-base;\n\t\t\ttransform: rotate(90deg);\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\ti,\n\t\t\t.svg-icon {\n\t    \t\tcolor: var(--#{$prefix}primary);\n\t    \t}\n\t\t}\n\n\t\t// Accordion icon collapsed mode\n\t\t.collapsed {\n\t\t\t.accordion-icon {\n\t\t\t\ttransition: $transition-base;\n\t\t\t\ttransform: rotate(0);\n\n\t\t\t\ti,\n\t\t\t\t.svg-icon {\n\t\t    \t\tcolor: var(--#{$prefix}text-muted);\n\t\t    \t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Icon collapse mode\n\t&.accordion-icon-collapse {\n\t\t// Accordion icon expaned mode\n\t\t.accordion-icon {\n\t\t\tdisplay: flex;\n\t\t\tflex-shrink: 0;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\ttransition: $transition-base;\n\n\t\t\t.accordion-icon-on {\n\t\t\t\tdisplay: inline-flex;\t\n\t\t\t}\n\n\t\t\t.accordion-icon-off {\n\t\t\t\tdisplay: none;\t\n\t\t\t}\n\n\t\t\ti,\n\t\t\t.svg-icon {\n\t    \t\tcolor: var(--#{$prefix}primary);\n\t    \t}\n\t\t}\n\n\t\t// Accordion icon collapsed mode\n\t\t.collapsed {\n\t\t\t.accordion-icon {\n\t\t\t\ttransition: $transition-base;\n\t\t\t\t\n\t\t\t\t.accordion-icon-on {\n\t\t\t\t\tdisplay: none;\t\n\t\t\t\t}\n\n\t\t\t\t.accordion-icon-off {\n\t\t\t\t\tdisplay: inline-flex;\t\n\t\t\t\t}\n\n\t\t\t\ti,\n\t\t\t\t.svg-icon {\n\t\t    \t\tcolor: var(--#{$prefix}text-muted);\n\t\t    \t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Reset accordion item border\n\t&.accordion-borderless {\n\t\t// According item\n\t\t.accordion-item {\n\t\t\tborder: 0;\n\t\t}\n\t}\n\n\t// Reset accordion item border, border radiues and background color\n\t&.accordion-flush {\n\t\t// According item\n\t\t.accordion-item {\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 0;\n\t\t\tborder-radius: 0;\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\t\n}\n","//\n// Avatar\n//\n\n\n// Base\n.image-input {\n\tposition: relative;\n\tdisplay: inline-block;\n\t@include border-radius($border-radius);\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\n\t// Empty state\n\t&:not(.image-input-empty) {\n\t\tbackground-image: none !important;\n\t}\n\n\t// Wrapper\n\t.image-input-wrapper {\n\t\twidth: 120px;\n\t\theight: 120px;\n\t\t@include border-radius($border-radius);\n\t\tbackground-repeat: no-repeat;\n\t\tbackground-size: cover;\n\t}\n\n\t// Actions\n\t[data-kt-image-input-action] {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttransform: translate(-50%,-50%);\n\t}\n\n\t// Change Button\n\t[data-kt-image-input-action=\"change\"] {\n\t\tleft: 100%;\n\t\ttop: 0;\n\n\t\tinput {\n\t\t\twidth: 0 !important;\n\t\t\theight: 0 !important;\n\t\t\toverflow: hidden;\n\t\t\topacity: 0;\n\t\t}\n\t}\n\n\t// Cancel & Remove Buttons\n\t[data-kt-image-input-action=\"cancel\"],\n\t[data-kt-image-input-action=\"remove\"] {\n\t\tposition: absolute;\n\t\tleft: 100%;\n\t\ttop: 100%;\n\t}\n\n\t[data-kt-image-input-action=\"cancel\"] {\n\t\tdisplay: none;\n\t}\n\n\t// Input Changed State\n\t&.image-input-changed {\n\t\t[data-kt-image-input-action=\"cancel\"] {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t[data-kt-image-input-action=\"remove\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t// Input Empty State\n\t&.image-input-empty {\n\t\t[data-kt-image-input-action=\"remove\"],\n\t\t[data-kt-image-input-action=\"cancel\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t// Circle style\n\t&.image-input-circle {\n\t\tborder-radius: 50%;\n\n\t\t// Wrapper\n\t\t.image-input-wrapper {\n\t\t\tborder-radius: 50%;\n\t\t}\n\n\t\t// Change Control\n\t\t[data-kt-image-input-action=\"change\"] {\n\t\t\tleft: 100%;\n\t\t\ttop: 0;\n\t\t\ttransform: translate(-100%, 0%);\n\t\t}\n\n\t\t// Cancel & Remove Buttons\n\t\t[data-kt-image-input-action=\"cancel\"],\n\t\t[data-kt-image-input-action=\"remove\"] {\n\t\t\tleft: 100%;\n\t\t\ttop: 100%;\n\t\t\ttransform: translate(-100%,-100%);\n\t\t}\n\t}\n\n\t// Bordered style\n\t&.image-input-outline {\n\t\t.image-input-wrapper {\n\t\t\tborder: 3px solid var(--#{$prefix}body-bg);\n\t\t\tbox-shadow: var(--#{$prefix}box-shadow);\n\t\t}\n\t}\n}\n","//\n// symbol\n//\n\n// Base\n.symbol {\n    display: inline-block;;\n    flex-shrink: 0;\n    position: relative;\n    @include border-radius($border-radius);\n\n    // Label\n    .symbol-label {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-weight: 500;\n        color: var(--#{$prefix}symbol-label-color);\n        background-color: var(--#{$prefix}symbol-label-bg);\n        background-repeat: no-repeat;\n        background-position: center center;\n        background-size: cover;\n        @include border-radius($border-radius);\n\n        &:after {\n            @include border-radius($border-radius);\n        }\n    }\n\n    // Badge\n    .symbol-badge {\n        position: absolute;\n        border-radius: 100%;\n        top: 0;\n        left: 50%;\n        transform: translateX(-50%) translateY(-50%) !important;\n    }\n\n    // Image\n    > img {\n        width: 100%;\n        flex-shrink: 0;\n        display: inline-block;\n        @include border-radius($border-radius);\n    }\n\n    // Square\n    &.symbol-square {\n        &,\n        > img,\n        .symbol-label {\n            border-radius: 0 !important;\n        }\n    }\n\n    // Circle\n    &.symbol-circle {\n        &,\n        > img,\n        .symbol-label {\n            border-radius: 50%;\n\n            &:after {\n                border-radius: 50%;\n            }\n        }\n    }\n\n    // Sizes\n    @include symbol-size(get($symbol-sizes, default));\n\n    @each $breakpoint in map-keys($grid-breakpoints) {\n        @include media-breakpoint-up($breakpoint) {\n            $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n            @each $name, $value in $symbol-sizes {\n                @if ($name != 'default') {\n                    &.symbol#{$infix}-#{$name} {\n                        @include symbol-size($value);\n                    }\n                }\n            }\n        }\n    }\n}\n\n// Group\n.symbol-group {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    margin-left: 10px;\n\n    .symbol {\n        position: relative;\n        z-index: 0;\n        margin-left: -10px;\n        transition: all 0.3s ease;\n\n        &:hover {\n            transition: all 0.3s ease;\n            z-index: 1;\n        }\n    }\n\n    .symbol-badge {\n        border: 2px solid var(--#{$prefix}body-bg);\n    }\n\n    .symbol-label {\n        position: relative;\n\n        &:after {\n            display: block;\n            content: \" \";\n            border-radius: inherit;\n            position: absolute;\n            top: 0;\n            right: 0;\n            left: 0;\n            bottom: 0;\n            border: 2px solid var(--#{$prefix}symbol-border-color);\n            -webkit-background-clip: padding-box; /* for Safari */\n            background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */    \n        }       \n    }\n\n    &.symbol-hover {\n        .symbol {\n            cursor: pointer;\n        }\n    }\n}\n","//\n// Symbol\n//\n\n@mixin symbol-size($size) {\n    > img {\n        width: $size;\n        height: $size;\n    }\n\n    .symbol-label {\n        width: $size;\n        height: $size;\n    }\n\n    &.symbol-fixed {\n        .symbol-label {\n            width: $size;\n            height: $size;\n        }\n\n        > img {\n            width: $size;\n            height: $size;\n            max-width: none;\n        }\n    }\n\n    // Ratios\n    &.symbol-2by3 {\n        .symbol-label {\n            height: $size;\n            width:  $size * divide(3, 2);\n        }\n\n        > img {\n            height: $size;\n            width:  $size * divide(3, 2);\n            max-width: none;\n        }\n    }\n}\n","//\n// Pulse\n//\n\n\n// Base\n.pulse {\n    position: relative;\n\n    // Theme Colors\n    @each $name, $color in $theme-colors {\n        &.pulse-#{$name} {\n            .pulse-ring {\n                border-color: var(--#{$prefix}#{$name});\n            }\n        }\n    }\n}\n\n.pulse-ring {\n    display: block;\n    border-radius: 40px;\n    height: 40px;\n    width: 40px;\n    position: absolute;\n    animation: animation-pulse 3.5s ease-out;\n    animation-iteration-count: infinite;\n    opacity: 0;\n    border-width: 3px;\n    border-style: solid;\n    border-color: var(--#{$prefix}gray-500);\t\n}\n\n@keyframes animation-pulse {\n    0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}\n    60% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}\n    65% {opacity: 1;}\n    100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}\n}\n","//\n// Page loader(used by the previous layout system)\n//\n\n// CSS3 Transitions only after page load(.page-loading class added to body tag and remove with JS on page load)\n[data-kt-app-page-loading=\"on\"] *,\n.page-loading * {\n    transition: none !important;\n}\n\n// Base\n.page-loader {\n\tbackground-color: var(--#{$prefix}body-bg);\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tz-index: 10000;\n   \tdisplay: none;\n\n\t[data-kt-app-page-loading=\"on\"] &,\n   \t.page-loading & {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n   \t\talign-items: center;\n\t}\n}\n","//\n// Scrolltop\n//\n\n.scrolltop {    \n    position: fixed;\n    display: none;\n    cursor: pointer;\n    z-index: $scrolltop-z-index;\n    justify-content: center;\n    align-items: center;\n    width: $scrolltop-size;\n    height: $scrolltop-size;\n    bottom: $scrolltop-bottom;\n    right: $scrolltop-end;    \n    background-color: var(--#{$prefix}scrolltop-bg-color);\n    box-shadow: var(--#{$prefix}scrolltop-box-shadow);\n    opacity: $scrolltop-opacity;\n    transition: $transition-link;\n    @include border-radius($border-radius);\n\n    .svg-icon {\n        @include svg-icon-size(24px);\n        color: var(--#{$prefix}scrolltop-icon-color);\n    }\n\n    > i {\n        font-size: 1.3rem;\n        color: var(--#{$prefix}scrolltop-icon-color);\n    }\n\n    &:hover {\n        background-color: var(--#{$prefix}scrolltop-bg-color-hover);\n\n        .svg-icon,\n        i {\n            color: var(--#{$prefix}scrolltop-icon-color-hover);\n        }\n    }\n\n    [data-kt-scrolltop=\"on\"] & {\n        opacity: var(--#{$prefix}scrolltop-opacity-on);\n        animation: animation-scrolltop .4s ease-out 1;\n        display: flex;\n\n        &:hover {\n            transition: $transition-link;\n            opacity: var(--#{$prefix}scrolltop-opacity-hover);\n        }\n    }\n\n    \n}\n\n// Tablet & Mobile Modess\n@include media-breakpoint-down(lg) {\n    .scrolltop { \n        bottom: $scrolltop-bottom-mobile;\n        right: $scrolltop-end-mobile;    \n        width: $scrolltop-size-mobile;\n        height: $scrolltop-size-mobile;\n    }\n}\n\n// Animations\n@keyframes animation-scrolltop {\n    from   { margin-bottom: -15px; }\n    to {  margin-bottom: 0; }\n}\n","//\n// SVG Icon\n//\n\n.svg-icon {\n    line-height: 1;\n    color: var(--#{$prefix}text-muted);\n    @include svg-icon-size(get($font-sizes, 5));\n\n    // Theme colors\n    @each $name, $color in $theme-text-colors {\n        &.svg-icon-#{$name} {\n            color: var(--#{$prefix}text-#{$name});\n        }\n    }\n\n    // Responsive icon sizes\n    @each $breakpoint in map-keys($grid-breakpoints) {\n        @include media-breakpoint-up($breakpoint) {\n            $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n            // Sizes\n            @each $name, $value in $font-sizes {\n                &.svg-icon#{$infix}-#{$name} {\n                    @include svg-icon-size($value, true);\n                }\n            }\n        }\n    }\n}\n","//\n// Fixed\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n        .fixed-top#{$infix} {\n            position: fixed;\n            z-index: $fixed-z-index;\n            top: 0;\n            left: 0;\n            right: 0;    \n        }\n    }\n}\n\n","//\n// Timeline\n//\n\n// Base\n.timeline {\n\t// Variables\n\t--#{$prefix}timeline-icon-size: #{$timeline-icon-size};\n\t--#{$prefix}timeline-icon-space: #{$timeline-icon-space};\n\n\t// Item\n\t.timeline-item {\n\t\tposition: relative;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\n\t\t&:last-child {\n\t\t\t.timeline-line {\n\t\t\t\tbottom: 100%;\n\t\t\t}\n\t\t}\n\t}        \n\n\t// Line\n\t.timeline-line {\n\t\tdisplay: block;\n\t\tcontent: \" \";\n\t\tjustify-content: center;     \n\t\tposition: absolute;\n\t\tz-index: 0;\n\t\tleft: 0;\n\t\ttop: var(--#{$prefix}timeline-icon-size);\n\t\tbottom: 0;\n\t\ttransform: translate(50%);\n\t\tborder-left-width: 1px;\n\t\tborder-left-style: solid;\n\t\tborder-left-color: var(--#{$prefix}gray-300); \n\t\twidth: var(--#{$prefix}timeline-icon-size);\n\t\tmargin-top: var(--#{$prefix}timeline-icon-space);\n\t\tmargin-bottom: var(--#{$prefix}timeline-icon-space);\n\t}\n\n\t// Icon\n\t.timeline-icon {\n\t\tz-index: 1;\n\t\tflex-shrink: 0;\n\t\tmargin-right: 1rem;\n\t\twidth: var(--#{$prefix}timeline-icon-size); \n\t\theight: var(--#{$prefix}timeline-icon-size); \n\t\tdisplay: flex;\n\t\ttext-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder: 1px solid var(--#{$prefix}gray-300); \n\t\tborder-radius: 50%;\n\t}\n\n\t// Content\n\t.timeline-content {\n\t\twidth: 100%;\n\t\toverflow: auto;\n\t\tmargin-bottom: 1.5rem;\n\t}\n\n\t// Vertical center \n\t&.timeline-center {\n\t\t.timeline-item {\n\t\t\talign-items: center;\n\n\t\t\t&:first-child {\n                .timeline-line {\n                    top: 50%;\n                }\n            }\n\n            &:last-child {\n                .timeline-line {\n                    bottom: 50%;\n                }\n            }\n\t\t}\n\t}\n\n\t// Line solid\n\t&.timeline-border-dashed {\t\t\t\t\n\t\t.timeline-line {\n\t\t\tborder-left-style: dashed !important;\t\t\t\t\n\t\t}\n\n\t\t.timeline-icon {\n\t\t\tborder-style: dashed !important;\t\n\t\t}\n\t}\n}\n","//\n// Timeline Label\n//\n\n\n.timeline-label {\n\tposition: relative;\n\n    $label-width: 50px;\n\n\t&:before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\tleft: $label-width + 1px;\n\t\twidth: 3px;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tbackground-color: var(--#{$prefix}gray-200);\n\t}\n\n\t// \n\t.timeline-item {\n\t\tdisplay: flex;\n        align-items: flex-start;\n\t\tposition: relative;\n\t\tmargin-bottom: 1.7rem;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\t}\n\n\t.timeline-label {\n\t\twidth: $label-width;\n\t\tflex-shrink: 0;\n\t\tposition: relative;\n\t\tcolor: var(--#{$prefix}gray-800);\n\t}\n\n\t.timeline-badge {\n\t\tflex-shrink: 0;\n\t\tbackground-color: var(--#{$prefix}body-bg);\n\t\twidth: 1rem;\n\t\theight: 1rem;\t\t\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tz-index: 1;\n\t\tposition: relative;\n\t\tmargin-top: 1px;\n\t\tmargin-left: -0.5rem;\n\t\tpadding: 3px !important;\n\t\tborder: 6px solid var(--#{$prefix}body-bg) !important;\t\t \n\t}\n\n\t.timeline-content {\n\t\tflex-grow: 1;\n\t}\n}\n","//\n// Demo\n//\n\n\n.overlay  {\n    position: relative;\n\n    .overlay-layer {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: var(--#{$prefix}overlay-bg);\n        transition: all 0.3s ease;\n        opacity: 0;\n    }\n\n    &.overlay-show,\n    &.overlay-block,\n    &:hover {\n        .overlay-layer {\n            transition: all 0.3s ease;\n            opacity: 1;\n        }\n    }\n\n    &.overlay-block {\n        cursor: wait;\n    }\n}\n","//\n// Bullet\n//\n\n// Base\n.bullet {\n    display: inline-block;\n    background-color: var(--#{$prefix}bullet-bg-color); \n    @include border-radius($bullet-bar-border-radius);\n    width: $bullet-bar-width;\n    height: $bullet-bar-height;\n    flex-shrink: 0;\n}\n\n// Dot bullet\n.bullet-dot {\n    width: $bullet-dot-size;\n    height: $bullet-dot-size;\n    border-radius: 100% !important;\n}\n\n// Vertical bullet\n.bullet-vertical {\n    width: $bullet-bar-height;\n    height: $bullet-bar-width;\n}\n\n// Vertical line\n.bullet-line {\n    width: $bullet-line-width;\n    height: $bullet-line-height;\n    border-radius: 0;\n}","//\n// Drawer\n//\n\n// Drawer\n.drawer {\n\tdisplay: flex !important;\n\toverflow: auto;\n\tz-index: $drawer-z-index;\n\tposition: fixed;\n\ttop: 0;\n\tbottom: 0;\n\tbackground-color: var(--#{$prefix}drawer-bg-color);\n\ttransition: transform $drawer-transition-speed ease-in-out !important;\n\n\t&.drawer-start {\n\t\tleft: 0;\n\t\ttransform: translateX(-100%);\n\t}\n\n\t&.drawer-end {\n\t\tright: 0;\n\t\ttransform: translateX(100%);\n\t}\n\n\t&.drawer-bottom {\n\t\tbottom: 0;\n\t\ttop: auto;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttransform: translateY(100%);\n\t}\n\n\t&.drawer-top {\n\t\ttop: 0;\n\t\tbottom: auto;\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttransform: translateY(-100%);\n\t}\n\n\t&.drawer-on {\n\t\ttransform: none;\n\t\tbox-shadow: var(--#{$prefix}drawer-box-shadow);\n\t\ttransition: transform $drawer-transition-speed ease-in-out !important;\n\t}\n}\n\n// Drawer Overlay\n.drawer-overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\toverflow: hidden;\n\tz-index: $drawer-z-index - 1;\n\tbackground-color: var(--#{$prefix}drawer-overlay-bg-color);\n\tanimation: animation-drawer-fade-in $drawer-overlay-animation-speed ease-in-out 1;\n}\n\n// Initial state\n[data-kt-drawer=\"true\"] {\n\tdisplay: none;\n}\n\n// Animation\n@keyframes animation-drawer-fade-in {\n\tfrom   { opacity: 0; }\n\tto { opacity: 1; }\n}\n\n// Tablet & Mobile Modes\n@include media-breakpoint-down(lg) {\n\tbody[data-kt-drawer=\"on\"] {\n\t\toverflow: hidden;\n\t}\n}\n","//\n// Badge\n//\n\n.badge {\n    display: inline-flex;\n    align-items: center;\n    \n    // Fixed size\n    &.badge-circle,\n    &.badge-square {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        height: $badge-size;\n        min-width: $badge-size;\n        padding: 0 0.1rem;\n        line-height: 0;\n    }\n\n    // Circle\n    &.badge-circle {\n        border-radius: 50%;\n        padding: 0;\n        min-width: unset;\n        width: $badge-size;\n    }\n\n    // Sizes\n    &.badge-sm {\n        min-width: $badge-size-sm;\n        font-size: $badge-font-size-sm;\n\n        &.badge-square {\n            height: $badge-size-sm;\n        }\n\n        &.badge-circle {\n            width: $badge-size-sm;\n            height: $badge-size-sm;\n        }\n    }\n\n    &.badge-lg {\n        min-width: $badge-size-lg;\n        font-size: $badge-font-size-lg;\n\n        &.badge-square {\n            height: $badge-size-lg;\n        }\n\n        &.badge-circle {\n            width: $badge-size-lg;\n            height: $badge-size-lg;\n        }\n    }\n}\n\n@each $name, $value in $theme-colors {\n    .badge-#{$name} {\n        color: var(--#{$prefix}#{$name}-inverse);\n        background-color: var(--#{$prefix}#{$name});\n\n        &.badge-outline {\n            border: 1px solid var(--#{$prefix}#{$name});\n            color: var(--#{$prefix}#{$name});\n            background-color: transparent;\n        }\n    }\n\n    .badge-light-#{$name} {\n        color: var(--#{$prefix}#{$name});\n        background-color: var(--#{$prefix}#{$name}-light);\n    }    \n}\n","//\n// Indicator\n//\n\n.indicator-progress {\n    display: none;\n\n    [data-kt-indicator=\"on\"] > & {\n        display: inline-block;\n    }\n}\n\n.indicator-label {\n    [data-kt-indicator=\"on\"] > & {\n        display: none;\n    }\n}","//\n// Hover effects\n//\n\n.hover-elevate-up {\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: translateY(-2.5%);\n\t\ttransition: transform 0.3s ease;\n\t\twill-change: transform;\n\t}\n}\n\n.hover-elevate-down {\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: translateY(2.5%);\n\t\ttransition: transform 0.3s ease;\n\t\twill-change: transform;\n\t}\n}\n\n.hover-scale {\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: scale(1.1);\n\t\ttransition: transform 0.3s ease;\n\t\twill-change: transform;\n\t}\n}\n\n.hover-rotate-end {\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: rotate(4deg);\n\t\ttransition: transform 0.3s ease;\n\t\twill-change: transform;\n\t}\n}\n\n.hover-rotate-start {\n\ttransition: transform 0.3s ease;\n\n\t&:hover {\n\t\ttransform: rotate(-4deg);\n\t\ttransition: transform 0.3s ease;\n\t\twill-change: transform;\n\t}\n}","//\n// Rotate\n// \n\n\n$rotate-transition: transform 0.3s ease;\n\n.rotate {\n    display: inline-flex;\n    align-items: center;\n}\n\n@each $value in (90, 180, 270) {\n    .rotate-#{$value} {\n        transition: $rotate-transition;\n        backface-visibility: hidden;\n        will-change: transform;\n\n        .collapsible:not(.collapsed)> & ,\n        .show > &,\n        .active > & {\n            transform: rotateZ(#{$value}deg);\n            transition: $rotate-transition;\n\n            [direction=\"rtl\"] & {\n                transform: rotateZ(-#{$value}deg);\n            }\n        }\n    }\n\n    .rotate-n#{$value} {\n        transition: $rotate-transition;\n        backface-visibility: hidden;\n        will-change: transform;\n\n        .collapsible:not(.collapsed)> &,\n        .show > &,\n        .active > & {\n            transform: rotateZ(-#{$value}deg);\n            transition: $rotate-transition;\n\n            [direction=\"rtl\"] & {\n                transform: rotateZ(#{$value}deg);\n            }\n        }\n    }\n}","//\n// Scroll\n//\n\n\n// Customize native scrollbars only for desktop mode\n@include media-breakpoint-up(lg) {\n    main,\n    span,\n    ol,\n    ul,\n    pre,\n    div {\n        // Firefox\n        scrollbar-width: thin;\n\n        // Webkit\n        &::-webkit-scrollbar {            \n            width: var(--#{$prefix}scrollbar-size);\n            height: var(--#{$prefix}scrollbar-size);\n        }\n\n        ::-webkit-scrollbar-track {\n           background-color: transparent;\n        }\n\n        ::-webkit-scrollbar-thumb {\n            @include border-radius(var(--#{$prefix}scrollbar-size));\n        }\n\n        // Default color\n        @include scrollbar-color(var(--#{$prefix}scrollbar-color), var(--#{$prefix}scrollbar-hover-color));\n    }\n}\n\n// Scroll\n.scroll,\n.hover-scroll,\n.hover-scroll-overlay {\n    overflow: scroll;\n    position: relative;\n\n    // Tablet & mobile modes\n    @include media-breakpoint-down(lg) {\n        overflow: auto;\n    }\n}\n\n.scroll-x,\n.hover-scroll-x,\n.hover-scroll-overlay-x {\n    overflow-x: scroll;\n    position: relative;\n\n    // Tablet & mobile modes\n    @include media-breakpoint-down(lg) {\n        overflow-x: auto;\n    }\n}\n\n.scroll-y,\n.hover-scroll-y,\n.hover-scroll-overlay-y {\n    overflow-y: scroll;\n    position: relative;\n\n    // Tablet & mobile modes\n    @include media-breakpoint-down(lg) {\n        overflow-y: auto;\n    }\n}\n\n.hover-scroll,\n.hover-scroll-overlay,\n.hover-scroll-x,\n.hover-scroll-overlay-x,\n.hover-scroll-y,\n.hover-scroll-overlay-y {\n    @include scrollbar-color(transparent, var(--#{$prefix}scrollbar-color));\n}\n\n// Utilities\n@each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n        .scroll#{$infix}-ps {\n            padding-left: var(--#{$prefix}scrollbar-size) !important;\n        }\n\n        .scroll#{$infix}-ms {\n            margin-left: var(--#{$prefix}scrollbar-size) !important;\n        }\n\n        .scroll#{$infix}-mb {\n            margin-bottom: var(--#{$prefix}scrollbar-size) !important;\n        }\n\n        .scroll#{$infix}-pe {\n            padding-right: var(--#{$prefix}scrollbar-size) !important;\n        }\n\n        .scroll#{$infix}-me {\n            margin-right: var(--#{$prefix}scrollbar-size) !important;\n        }\n\n        .scroll#{$infix}-px {\n            padding-left: var(--#{$prefix}scrollbar-size) !important;\n            padding-right: var(--#{$prefix}scrollbar-size) !important;\n        }\n\n        .scroll#{$infix}-mx {\n            margin-left: var(--#{$prefix}scrollbar-size) !important;\n            margin-right: var(--#{$prefix}scrollbar-size) !important;\n        }\n    }\n}\n\n  \n","//\n// Scroll mixins\n//\n\n@mixin scrollbar-color($color, $hover-color: null) {\n    // Firefox\n    scrollbar-color: $color transparent;\n    \n    // Webkit\n    &::-webkit-scrollbar-thumb {\n        background-color: $color;\n    }\n\n    &::-webkit-scrollbar-corner {\n        background-color: transparent;\n    }\n\n    @if ($hover-color != null) {\n        // Hover state\n        &:hover {\n            // Firefox\n            scrollbar-color: $hover-color transparent;\n\n            // Webkit\n            &::-webkit-scrollbar-thumb {\n                background-color: $hover-color;\n            }\n\n            &::-webkit-scrollbar-corner {\n                background-color: transparent;\n            }\n        }\n    }\n}\n","//\n// Rating\n//\n\n.rating {\n    display: flex;\n    align-items: center;\n}\n\n.rating-input {\n    position: absolute !important;\n    left: -9999px !important;\n\n    &[disabled] {\n        display: none;\n    }\n}\n\n.rating-label {\n    padding: 0;\n    margin: 0;\n\n    & > i,\n    & > .svg-icon {\n        line-height: 1;\n        color: var(--#{$prefix}rating-color-default);\n    }\n}\n\nlabel.rating-label {\n    cursor: pointer;\n}\n\ndiv.rating-label.checked,\nlabel.rating-label {\n    & > i,\n    & > .svg-icon {\n        color: var(--#{$prefix}rating-color-active);\n    }\n}\n\n.rating-input:checked ~ .rating-label {\n    & > i,\n    & > .svg-icon {\n        color: var(--#{$prefix}rating-color-default);\n    }\n}\n\n.rating:hover label.rating-label {\n    & > i,\n    & > .svg-icon {\n        color: var(--#{$prefix}rating-color-active);\n    }\n}\n\nlabel.rating-label:hover ~ .rating-label {\n    & > i,\n    & > .svg-icon {\n        color: var(--#{$prefix}rating-color-default);\n    }\n    color: var(--#{$prefix}rating-color-default);\n}\n","//\n// Stepper\n//\n\n// Base\n.stepper {\n\t// Content\n\t[data-kt-stepper-element=\"info\"],\n\t[data-kt-stepper-element=\"content\"] {\n\t\tdisplay: none;\n\n\t\t&.current {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n\n\t// Enable cursor pointer on clickable steppers\n\t.stepper-item[data-kt-stepper-action=\"step\"] {\n\t\tcursor: pointer;\n\t}\n\n\t// States\n\t& {\n\t\t[data-kt-stepper-action=\"final\"] {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"previous\"] {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"next\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.first {\n\t\t[data-kt-stepper-action=\"previous\"] {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"next\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.between {\n\t\t[data-kt-stepper-action=\"previous\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"next\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"] {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.last {\n\t\t[data-kt-stepper-action=\"final\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"final\"].btn-flex {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"previous\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"previous\"].btn-flex {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"previous\"][data-kt-stepper-state=\"hide-on-last-step\"] {\n\t\t\tdisplay: none !important;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"next\"] {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"next\"].btn-flex {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"] {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t[data-kt-stepper-action=\"submit\"].btn-flex {\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n}","//\n// Stepper Pills\n//\n\n// Base\n.stepper.stepper-pills {\n    --#{$prefix}stepper-pills-size: 40px;\n    --#{$prefix}stepper-icon-border-radius: 9px;\n    --#{$prefix}stepper-icon-check-size: 1rem;\n\n    --#{$prefix}stepper-icon-bg-color: var(--#{$prefix}primary-light);    \n    --#{$prefix}stepper-icon-bg-color-current: var(--#{$prefix}primary);\n    --#{$prefix}stepper-icon-bg-color-completed: var(--#{$prefix}primary-light);\n\n    --#{$prefix}stepper-icon-border: 0;\n    --#{$prefix}stepper-icon-border-current: 0;\n    --#{$prefix}stepper-icon-border-completed: 0;\n\n    --#{$prefix}stepper-icon-number-color: var(--#{$prefix}primary);\n    --#{$prefix}stepper-icon-number-color-current: var(--#{$prefix}white);\n\n    --#{$prefix}stepper-icon-check-color-completed: var(--#{$prefix}primary);\n\n    --#{$prefix}stepper-label-title-opacity: 1;\n    --#{$prefix}stepper-label-title-opacity-current: 1;\n    --#{$prefix}stepper-label-title-opacity-completed: 1;\n\n    --#{$prefix}stepper-label-title-color: var(--#{$prefix}gray-800);\n    --#{$prefix}stepper-label-title-color-current: var(--#{$prefix}gray-600);\n    --#{$prefix}stepper-label-title-color-completed: var(--#{$prefix}text-muted);\n\n    --#{$prefix}stepper-label-desc-opacity: 1;\n    --#{$prefix}stepper-label-desc-opacity-current: 1;\n    --#{$prefix}stepper-label-desc-opacity-completed: 1;\n    \n    --#{$prefix}stepper-label-desc-color: var(--#{$prefix}text-muted);     \n    --#{$prefix}stepper-label-desc-color-current: var(--#{$prefix}gray-500);\n    --#{$prefix}stepper-label-desc-color-completed: var(--#{$prefix}gray-500);\n\n    --#{$prefix}stepper-line-border: 1px dashed var(--#{$prefix}gray-300);\n    \n    // Nav\n    .stepper-nav {\n        display: flex;\n    }\n\n    // Item\n    .stepper-item {\n        display: flex;\n        align-items: center;\n        transition: $transition-link;            \n\n        // Icon\n        .stepper-icon {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-shrink: 0;\n            transition: $transition-link;\n            width: var(--#{$prefix}stepper-pills-size);\n            height: var(--#{$prefix}stepper-pills-size);\n            border-radius: var(--#{$prefix}stepper-icon-border-radius);\n            background-color: var(--#{$prefix}stepper-icon-bg-color);\n            border: var(--#{$prefix}stepper-icon-border);\n            margin-right: 1.5rem;\n\n            .stepper-check {\n                display: none;\n                font-size: var(--#{$prefix}stepper-icon-check-size);\n            }\n\n            .stepper-number {\n                font-weight: $font-weight-bold;\n                color: var(--#{$prefix}stepper-icon-number-color);\n                font-size: 1.25rem;\n            }\n        }\n\n        // Label\n        .stepper-label {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n\n            .stepper-title {\n                color: var(--#{$prefix}stepper-label-title-color);\n                opacity: var(--#{$prefix}stepper-label-title-opacity);\n                font-weight: 600;\n                font-size: 1.25rem;\n                margin-bottom: .3rem;\n            }\n\n            .stepper-desc {\n                opacity: var(--#{$prefix}stepper-label-desc-opacity);\n                color: var(--#{$prefix}stepper-label-desc-color);\n            }\n        }\n\n        // Current\n        &.current {\n            transition: $transition-link;\n\n            .stepper-icon {\n                transition: $transition-link;\n                background-color: var(--#{$prefix}stepper-icon-bg-color-current);\n                border: var(--#{$prefix}stepper-icon-border-current);\n\n                .stepper-check {\n                    display: none;\n                }\n\n                .stepper-number {\n                    color: var(--#{$prefix}stepper-icon-number-color-current);\n                    font-size: 1.35rem;\n                }\n            }\n\n            .stepper-label {\n                .stepper-title {\n                    opacity: var(--#{$prefix}stepper-label-title-opacity-current);\n                    color: var(--#{$prefix}stepper-label-title-color-current);\n                }\n\n                .stepper-desc {\n                    opacity: var(--#{$prefix}stepper-label-desc-opacity-current);\n                    color: var(--#{$prefix}stepper-label-desc-color-current);\n                }\n            }\n        }\n\n        // Completed\n        &.current.mark-completed:last-child,\n        &.completed {\n            .stepper-icon {\n                transition: $transition-link;\n                background-color: var(--#{$prefix}stepper-icon-bg-color-completed);\n                border: var(--#{$prefix}stepper-icon-border-completed);\n\n                .stepper-check {\n                    color: var(--#{$prefix}stepper-icon-check-color-completed);\n                    display: inline-block;\n                }\n\n                .stepper-number {\n                    display: none;\n                }\n            }\n\n            .stepper-label {\n                .stepper-title {\n                    opacity: var(--#{$prefix}stepper-label-title-opacity-completed);\n                    color: var(--#{$prefix}stepper-label-title-color-completed);\n                }\n\n                .stepper-desc {\n                    opacity: var(--#{$prefix}stepper-label-desc-opacity-completed);\n                    color: var(--#{$prefix}stepper-label-desc-color-completed);\n                }\n            }\n        }\n    }\n\n    // Column\n    &.stepper-column {\n        // Nav\n        .stepper-nav {\n            flex-direction: column;\n            align-items: start;\n        }\n\n        // Item\n        .stepper-item {\n            flex-direction: column;\n            justify-content: start;\n            align-items: stretch;\n            padding: 0;\n\t\t    margin: 0;\n        }\n\n        // Wrapper \n        .stepper-wrapper {\n            display: flex;\n            align-items: center;\n        }\n\n        // Icon\n        .stepper-icon {\n            z-index: 1;\n        }\n\n        // Line\n        .stepper-line {\n            display: block;\n            flex-grow: 1;\n            margin-left: calc(var(--#{$prefix}stepper-pills-size) / 2);\n            border-left: var(--#{$prefix}stepper-line-border); \n            margin-top: 2px;\n            margin-bottom: 2px;\n        }\n    }    \n}","//\n// Stepper Links\n//\n\n// Base\n.stepper.stepper-links {\n    .stepper-nav {\n\t\tdisplay: flex;\n\t\tmargin: 0 auto;\n\t\tjustify-content: center;\n\t\talign-items: center;\t\n\t\tflex-wrap: wrap;\n\n        .stepper-item {\n\t\t\tposition: relative;\n\t\t\tflex-shrink: 0;\n\t\t\tmargin: 1rem 1.5rem;\n\n\t\t\t&:after {\n\t\t\t\tcontent: \" \";\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 2.3rem;\n\t\t\t\tleft: 0;\n\t\t\t\theight: 2px;\n\t\t\t\twidth: 100%;\n\t\t\t\tbackground-color: transparent;\n\t\t\t\ttransition: $transition-link;\n\t\t\t}           \n\n            .stepper-title {\n                color: var(--#{$prefix}gray-900);\t\t\n                font-weight: 600;\n                font-size: 1.25rem; \n            }             \n\n            // Current\n            &.current {\n\t\t\t\ttransition: $transition-link;\n\t\t\t\t\n\t\t\t\t.stepper-title {\n\t\t\t\t\tcolor: var(--#{$prefix}primary);\t\t\t\t\t \n\t\t\t\t}               \n                \n\t\t\t\t&:after {\t\t\t\t\t\n\t\t\t\t\tbackground-color: var(--#{$prefix}primary);\n\t\t\t\t}\t\t\t\t                              \n\t\t\t} \n\t\t\t\n\t\t\t&.current.mark-completed:last-child,\n\t\t\t&.completed {\n\t\t\t\t.stepper-title {\n\t\t\t\t\tcolor: var(--#{$prefix}gray-500);\n\t\t\t\t}  \t\t\t\n\t\t\t}\n        }\n    }     \n}","//\n// Toggle\n//\n\n.toggle {\n    &.collapsible:not(.collapsed), // Integration with Bootstrap Collapse\n    &.active {\n        .toggle-off {\n            display: none;\n        }\n    }\n\n    &.collapsible.collapsed, // Integration with Bootstrap Collapse\n    &:not(.collapsible):not(.active) {\n        .toggle-on {\n            display: none;\n        }\n    }\n}","//\n// Shape\n// \n\n.xehagon {\n    //$edges-number: 6, $main-radius: 30%, $rounding-radius: 10%, $rotated: true, $precision: 20\n    @include shape(6);\n}\n\n.octagon {\n    //$edges-number: 6, $main-radius: 30%, $rounding-radius: 10%, $rotated: true, $precision: 20\n    @include shape(8);\n}","\n@use 'sass:math';\n\n@mixin shape($edges-number: 6, $main-radius: 30%, $rounding-radius: 10%, $rotated: true, $precision: 20) {\n\t$central-angle: divide(360deg, $edges-number);\n\t$angle: ($edges-number - 2) * divide(180deg, $edges-number);\n\t$max-var-angle: 2 * (90deg - divide($angle, 2));\n\t$precision: 6;\n\t$unit-var-angle: divide($max-var-angle, $precision);\t\n\t$r-diff: $main-radius + $rounding-radius;\n\n\t$points: ();\n\n\t@for $i from 0 to $edges-number {\n\t\t$vertex-angle: $i * $central-angle + if($rotated, -90deg, 0deg);\n\t\t$vertex-x: 50% + $r-diff * math.cos($vertex-angle);\n\t\t$vertex-y: 50% + $r-diff * math.sin($vertex-angle);\n\n\t\t@for $j from 0 through $precision {\n\t\t\t$curr-angle: $vertex-angle + ($j - 0.5 * $precision) * $unit-var-angle;\n\t\t\t$x: $vertex-x + $rounding-radius * math.cos($curr-angle);\n\t\t\t$y: $vertex-y + $rounding-radius * math.sin($curr-angle);\n\n\t\t\t$points: $points, $x $y;\n\t\t}\n\t}\n\t\n\tclip-path: polygon($points);\n}","//\n// Ribbon\n//\n\n// Base\n.ribbon {\n\tposition: relative;\n\n\t// Ribbon target\n\t.ribbon-label {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tpadding: 5px 10px;\n\t\tposition: absolute;\n\t\tz-index: 1;\n\t\tbackground-color: var(--#{$prefix}ribbon-label-bg);\n\t\tbox-shadow: var(--#{$prefix}ribbon-label-box-shadow);\n\t\tcolor: var(--#{$prefix}primary-inverse);\n\t\ttop: 50%;\n\t\tright: 0;\n\t\ttransform: translateX(5px) translateY(-50%);\n\n\t\t> .ribbon-inner {\n\t\t\tz-index: -1;\n\t\t\tposition: absolute;\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t}\n\n\t\t&:after {\n\t\t\tborder-color: var(--#{$prefix}ribbon-label-border-color);\n\t\t}\n\t}\n\n\t// Vertical aligment\n\t&-vertical {\n\t\t.ribbon-label {\n\t\t\tpadding: 5px 10px;\n\t\t\tmin-width: 36px;\n\t\t\tmin-height: 46px;\n\t\t\ttext-align: center;\n\t\t}\n\t}\n\n\t&.ribbon-top {\n\t\t.ribbon-label {\n\t\t\ttop: 0;\n\t\t\ttransform: translateX(-15px) translateY(-4px);\n\t\t\tborder-bottom-right-radius: $border-radius;\n\t\t\tborder-bottom-left-radius: $border-radius;\n\t\t}\n\t}\n\n\t&.ribbon-bottom {\n\t\t.ribbon-label {\n\t\t\tborder-top-right-radius: $border-radius;\n\t\t\tborder-top-left-radius: $border-radius;\n\t\t}\n\t}\n\n\t&.ribbon-start {\n\t\t.ribbon-label {\n\t\t\ttop: 50%;\n\t\t\tleft: 0;\n\t\t\tright: auto;\n\t\t\ttransform: translateX(-5px) translateY(-50%);\n\t\t\tborder-top-right-radius: $border-radius;\n\t\t\tborder-bottom-right-radius: $border-radius;\n\t\t}\n\t}\n\n\t&.ribbon-end {\n\t\t.ribbon-label {\n\t\t\tborder-top-left-radius: $border-radius;\n\t\t\tborder-bottom-left-radius: $border-radius;\n\t\t}\n\t}\n}\n\n// Clip style\n.ribbon.ribbon-clip {\n\t&.ribbon-start {\n\t\t.ribbon-label {\n\t\t\tleft: -5px;\n\n\t\t\t.ribbon-inner {\n\t\t\t\tborder-top-right-radius: $border-radius;\n\t\t\t\tborder-bottom-right-radius: $border-radius;\n\n\t\t\t\t&:before,\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-color: transparent !important;\n\t\t\t\t\tbottom: -10px;\n\t\t\t\t}\n\n\t\t\t\t&:before {\n\t\t\t\t\tborder-width: 0 10px 10px 0;\n\t\t\t\t\tborder-right-color: var(--#{$prefix}ribbon-clip-bg) !important;\n\t\t\t\t\tleft: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ribbon-end {\n\t\t.ribbon-label {\n\t\t\tright: -5px;\n\n\t\t\t.ribbon-inner {\n\t\t\t\tborder-top-left-radius: $border-radius;\n\t\t\t\tborder-bottom-left-radius: $border-radius;\n\n\t\t\t\t&:before,\n\t\t\t\t&:after {\n\t\t\t\t\tcontent: \"\";\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-color: transparent !important;\n\t\t\t\t\tbottom: -10px;\n\t\t\t\t}\n\n\t\t\t\t&:before {\n\t\t\t\t\tborder-width: 0 0 10px 10px;\n\t\t\t\t\tborder-left-color: var(--#{$prefix}ribbon-clip-bg) !important;\n\t\t\t\t\tright: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Triangle style\n.ribbon.ribbon-triangle {\n\tposition: absolute;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\n\t// Top start position\n\t&.ribbon-top-start {\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-bottom: solid 2rem transparent !important;\n\t\tborder-left: solid 2rem transparent;\n\t\tborder-right: solid 2rem transparent !important;\n\t\tborder-top: solid 2rem transparent;\t \n\t}\n\n\t// Top end position\n\t&.ribbon-top-end {\n\t\ttop: 0;\n\t\tright: 0;\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-bottom: solid 2rem transparent !important;\n\t\tborder-left: solid 2rem transparent !important;\n\t\tborder-right: solid 2rem transparent;\n\t\tborder-top: solid 2rem transparent;\t\t \n\t}\n\n\t// Botton start position\n\t&.ribbon-bottom-start {\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-bottom: solid 2rem transparent;\n\t\tborder-left: solid 2rem transparent;\n\t\tborder-right: solid 2rem transparent !important;\n\t\tborder-top: solid 2rem transparent !important;\t\n\t}\t\n\t\n\t// Botton end position\n\t&.ribbon-bottom-end {\n\t\tbottom: 0;\n\t\tright: 0;\n\t\twidth: 4rem;\n\t\theight: 4rem;\n\t\tborder-bottom: solid 2rem transparent;\n\t\tborder-right: solid 2rem transparent;\n\t\tborder-left: solid 2rem transparent !important;\n\t\tborder-top: solid 2rem transparent !important;\t\t\t \n\t}\t\t \n}\n\n","//\n// BlockUI\n//\n\n\n.blockui  {\n    position: relative;\n\n    .blockui-overlay {\n        transition: all 0.3s ease;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background-color: var(--#{$prefix}blockui-overlay-bg);\n\n        .spinner-border {\n            height: 1.35rem;\n            width: 1.35rem;\n        }\n    }\n\n    .blockui-message {\n        display: flex;\n        align-items: center;\n        @include border-radius($border-radius);\n        box-shadow: var(--#{$prefix}blockui-message-box-shadow);\n        background-color: var(--#{$prefix}blockui-message-bg);\n        color: var(--#{$prefix}gray-700);\n        font-weight: $font-weight-bold;\n        margin: 0 !important;\n        width: auto;\n        padding: 0.85rem 1.75rem !important;\n\n        .spinner-border {\n            margin-right: 0.65rem;\n        }\n    }\n}\n\n@if $enable-dark-mode {\n    @include color-mode(dark) {\n        .blockui {\n            --#{$prefix}blockui-overlay-bg: #{$blockui-overlay-bg-dark};\n            --#{$prefix}blockui-message-bg: #{$blockui-message-bg-dark};\n            --#{$prefix}blockui-message-box-shadow: #{$blockui-message-box-shadow-dark};\n        }\n    }\n}\n","//\n// Explore(used for demo product demo)\n//\n\n$explore-primary: #00B2FF;\n$explore-primary-light: #F1FAFF;\n$explore-primary-active: #0098DA;\n$explore-primary-inverse: $white;\n\n$explore-success: #50CD89;\n$explore-success-light: #E8FFF3;\n$explore-success-active: #47BE7D;\n$explore-success-inverse: $white;\n\n$explore-warning: #FFC700;\n$explore-warning-inverse: $white;\n\n$explore-danger: #F1416C;\n$explore-warning-inverse: $white;\n\n.explore-btn-toggle {\n    color: var(--#{$prefix}gray-600);\n    background-color: $white;\n\n    &:hover,\n    &:focus,\n    &:active {\n        color: $explore-primary-inverse;\n        background-color: $explore-primary;\n    }\n}\n\n.explore-btn-dismiss {\t\n    border: 0;\n\n    &:hover {\n        i,\n        .svg-icon {\n            color: $explore-primary;\n        }\n    }\n}\n\n.explore-btn-primary {\t\n\tborder: 0;\n    color: $explore-primary-inverse;\n    background-color: $explore-primary;\n\n    &:hover {\n        color: $explore-primary-inverse;\n        background-color: $explore-primary-active;\n    }\n}\n\n.explore-btn-secondary {\t\n\tborder: 0;\n    color: var(--#{$prefix}gray-600);\n    background-color: var(--#{$prefix}gray-100);\n\n    &:hover {\n        color: var(--#{$prefix}gray-800);\n        background-color: var(--#{$prefix}gray-200);\n    }\n}\n\n.explore-btn-outline {\n    border: 1px dashed var(--#{$prefix}gray-300) !important;\n\n    &:hover,\n    &.active {\n        border: 1px dashed $explore-success !important;\n        background-color: $explore-success-light;\n    }\n}\n\n.explore-link {\t\n    color: $explore-primary;\n\n    &:hover {\n        color: $explore-primary-active;\n    }\n}\n\n.explore-link-hover:hover {\t\n    color: $explore-primary !important;\n}\n\n.explore-icon-success {\t\n    color: $explore-success;\n}\n\n.explore-icon-danger {\t\n    color: $explore-danger;\n}\n\n.explore-label-free {\n    color: $explore-warning-inverse;\n    background-color: $explore-warning;\n}\n\n.explore-label-pro {\n    color: $explore-success-inverse;\n    background-color: $explore-success;\n}","//\n// Engage panel(used for demo product demo)\n//\n\n.app-engage {\n\tposition: fixed;\n\tright: 0;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-end;\n\tz-index: $engage-z-index;\n\tpadding-right: 12px;\n\n\t.app-engage-btn {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tflex-direction: column;\n\t\tbox-shadow: var(--#{$prefix}engage-btn-box-shadow);\n\t\tborder-width: 1px;\n\t\tborder-style: solid;\n\t\tfont-size: 12px;\n\t\tfont-weight: $font-weight-bold;\n\t\tmargin-bottom: 8px;\n\t\t@include border-radius(6px);\n\t\twidth: 66px;\n\t\theight: 70px;\n\n\t\t@include button-custom-variant(\n\t\t\t$color: var(--#{$prefix}engage-btn-color), \n\t\t\t$icon-color: var(--#{$prefix}engage-btn-icon-color), \n\t\t\t$border-color: var(--#{$prefix}engage-btn-border-color), \n\t\t\t$bg-color: var(--#{$prefix}engage-btn-bg), \n\t\t\t$color-active: null, \n\t\t\t$icon-color-active: null, \n\t\t\t$border-color-active: null,\n\t\t\t$bg-color-active: null\n\t\t);\n\n\t\t&.hover-dark:hover {\n\t\t\tcolor: var(--#{$prefix}dark-inverse);\n\t\t\tborder-color: var(--#{$prefix}dark);\n\t\t\tbackground-color: var(--#{$prefix}dark);\n\n\t\t\ti,\n\t\t\t.svg-icon {\n\t\t\t\tcolor: var(--#{$prefix}dark-inverse);\n\t\t\t}\n\t\t}\n\n\t\t&.hover-primary:hover {\n\t\t\tcolor: var(--#{$prefix}primary-inverse);\n\t\t\tborder-color: var(--#{$prefix}primary);\n\t\t\tbackground-color: var(--#{$prefix}primary);\n\n\t\t\ti,\n\t\t\t.svg-icon {\n\t\t\t\tcolor: var(--#{$prefix}primary-inverse);\n\t\t\t}\n\t\t}\n\n\t\t&.hover-success:hover {\n\t\t\tcolor: var(--#{$prefix}success-inverse);\n\t\t\tborder-color: var(--#{$prefix}success);\n\t\t\tbackground-color: var(--#{$prefix}success);\n\n\t\t\ti,\n\t\t\t.svg-icon {\n\t\t\t\tcolor: var(--#{$prefix}success-inverse);\n\t\t\t}\n\t\t}\n\n\t\t&.app-engage-btn-toggle-off {\n\t\t\twidth: 35px;\n\t\t\theight: 35px;\n\t\t}\n\n\t\t&.app-engage-btn-toggle-on {\n\t\t\twidth: 35px;\n\t\t\theight: 35px;\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.app-engage-hide {\n\t\t.app-engage-btn {\n\t\t\tvisibility: hidden;\n\n\t\t\t&.app-engage-btn-toggle-off {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t&.app-engage-btn-toggle-on {\n\t\t\t\tvisibility: visible;\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t}\t\t\n\t}\n}\n\n.engage-btn {\n\tdisplay: flex;\n\talign-items: center;\n\theight: 35px !important;\n\n\t@include button-custom-variant(\n\t\t$color: var(--#{$prefix}engage-btn-color), \n\t\t$icon-color: var(--#{$prefix}engage-btn-color), \n\t\t$border-color: var(--#{$prefix}engage-btn-bg), \n\t\t$bg-color: var(--#{$prefix}engage-btn-bg), \n\t\t$color-active: var(--#{$prefix}engage-btn-color-active), \n\t\t$icon-color-active: var(--#{$prefix}engage-btn-color-active), \n\t\t$border-color-active: var(--#{$prefix}engage-btn-bg),\n\t\t$bg-color-active: var(--#{$prefix}engage-btn-bg)\n\t);\n}","//\n// Cookie Alert\n//\n\n.cookiealert{\n    background: inherit;\n    color: inherit;\n}","//\n// Print Mode\n//\n\n// Add .print-content-only class to body element in order to allow printing only the content area\n@media print {\n    .print-content-only {\n        padding: 0 !important;\n        background: none !important;\n\n        .wrapper,\n        .page,\n        .page-title\n        .content,\n        .container,\n        .container-xxl,\n        .container-fluid {\n            background: none !important;\n            padding: 0 !important;\n            margin: 0 !important;\n        }\n\n        .aside,\n        .sidebar,\n        .scrolltop,\n        .header,\n        .footer,\n        .toolbar,\n        .drawer,\n        .btn {\n            display: none !important;\n        }\n    }\n}\n","//\n// Custom background helpers\n//\n\n// Background white color\n.bg-white {\n\t--#{$prefix}bg-rgb-color: var(--#{$prefix}white-bg-rgb);\n\tbackground-color: $white !important;\n}\n\n// Background black color\n.bg-black {\n\t--#{$prefix}bg-rgb-color: var(--#{$prefix}black-bg-rgb);\n\tbackground-color: $black !important;\n}\n\n// Background body color\n.bg-body {\n\t--#{$prefix}bg-rgb-color: var(--#{$prefix}body-bg-rgb);\n\tbackground-color: var(--#{$prefix}body-bg) !important;\n}\n\n.bg-hover-body {\n\tcursor: pointer;\n\n\t&:hover {\n\t\tbackground-color: var(--#{$prefix}body-bg) !important;\n\t}\n}\n\n.bg-active-body {\n\t&.active {\n\t\tbackground-color: var(--#{$prefix}body-bg) !important;\n\t}\n}\n\n.bg-state-body {\n\tcursor: pointer;\n\n\t&.active,\n\t&:hover {\t\t\t\t\n\t\tbackground-color: var(--#{$prefix}body-bg) !important;\n\t}\n}\n\n.bg-hover-white {\n\tcursor: pointer;\n\n\t&:hover {\n\t\t--#{$prefix}bg-rgb-color: var(--#{$prefix}white-bg-rgb);\n\t\tbackground-color: $white !important;\n\t}\n}\n\n.bg-active-white {\n\t&.active {\n\t\t--#{$prefix}bg-rgb-color: var(--#{$prefix}white-bg-rgb);\n\t\tbackground-color: $white !important;\n\t}\n}\n\n.bg-state-white {\n\tcursor: pointer;\n\n\t&.active,\n\t&:hover {\t\t\t\t\n\t\t--#{$prefix}bg-rgb-color: var(--#{$prefix}white-bg-rgb);\n\t\tbackground-color: $white !important;\n\t}\n}\n\n// Background theme light colors\n@each $name, $value in $theme-colors {\n\t@if (theme-light-color($name)) {\n\t\t.bg-light-#{$name} {\n\t\t\tbackground-color: var(--#{$prefix}#{$name}-light) !important;\n\t\t}\n\t}\n\n\t.bg-#{$name} {\n\t\t--#{$prefix}bg-rgb-color: var(--#{$prefix}#{$name}-rgb);\n\t\tbackground-color: var(--#{$prefix}#{$name}) !important;\n\t}\n\n\t.bg-#{$name}-active {\n\t\t--#{$prefix}bg-rgb-color: var(--#{$prefix}#{$name}-active-rgb);\n\t\tbackground-color: var(--#{$prefix}#{$name}-active) !important;\n\t}\n\n\t@if (theme-light-color($name)) {\n\t\t.bg-hover-light-#{$name} {\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--#{$prefix}#{$name}-light) !important;\n\t\t\t}\n\t\t}\n\n\t\t.bg-state-light-#{$name} {\n\t\t\tcursor: pointer;\n\n\t\t\t&.active,\n\t\t\t&:hover {\t\t\t\t\n\t\t\t\tbackground-color: var(--#{$prefix}#{$name}-light) !important;\n\t\t\t}\n\t\t}\n\t}\n\n\t.bg-hover-#{$name} {\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--#{$prefix}#{$name}) !important;\n\t\t}\n\t}\n\n\t.bg-active-#{$name} {\n\t\t&.active {\n\t\t\tbackground-color: var(--#{$prefix}#{$name}) !important;\n\t\t}\n\t}\n\n\t.bg-state-#{$name} {\n\t\tcursor: pointer;\n\n\t\t&.active,\n\t\t&:hover {\t\t\t\t\n\t\t\tbackground-color: var(--#{$prefix}#{$name}) !important;\n\t\t}\n\t}\n}\n\n// Background gray colors\n@each $name, $value in $grays {\n    .bg-gray-#{$name} {\n\t\t--#{$prefix}bg-rgb-color: var(--#{$prefix}gray-#{$name}-rgb);\n\t\tbackground-color: var(--#{$prefix}gray-#{$name});\n\t}\n\n\t.bg-hover-gray-#{$name} {\n\t\t&:hover {\n\t\t\t--#{$prefix}bg-rgb-color: var(--#{$prefix}gray-#{$name}-rgb);\n\t\t\tbackground-color: var(--#{$prefix}gray-#{$name});\t\n\t\t}\t\t\n\t}\n\n\t.bg-gray-#{$name}i {\n\t\t--#{$prefix}bg-rgb-color: var(--#{$prefix}gray-#{$name}-rgb);\n\t\tbackground-color: var(--#{$prefix}gray-#{$name}) !important;\n\t}\n}\n\n// Opacity\n@each $name, $value in $opacity-values {\n\t.bg-opacity-#{$name} {\n\t\tbackground-color: rgba(var(--#{$prefix}bg-rgb-color), #{$value}) !important;\n\t}\n\n\t.bg-hover-opacity-#{$name}:hover {\n\t\tbackground-color: rgba(var(--#{$prefix}bg-rgb-color), #{$value}) !important;\n\t}\n\n\t.bg-active-opacity-#{$name}.active {\n\t\tbackground-color: rgba(var(--#{$prefix}bg-rgb-color), #{$value}) !important;\n\t}\n\n\t.bg-state-opacity-#{$name} {\n\t\t.active,\n\t\t&:hover {\n\t\t\tbackground-color: rgba(var(--#{$prefix}bg-rgb-color), #{$value}) !important;\n\t\t}\t\t\n\t}\n}\n\n// Background image helpers\n// Background repeat\n.bgi-no-repeat {\n\tbackground-repeat: no-repeat;\n}\n\n// Background positions\n.bgi-position-y-top {\n\tbackground-position-y: top;\n}\n\n.bgi-position-y-bottom {\n\tbackground-position-y: bottom;\n}\n\n.bgi-position-y-center {\n\tbackground-position-y: center;\n}\n\n.bgi-position-x-start {\n\tbackground-position-x: left;\n}\n\n.bgi-position-x-end {\n\tbackground-position-x: right;\n}\n\n.bgi-position-x-center {\n\tbackground-position-x: center;\n}\n\n.bgi-position-top {\n\tbackground-position: 0 top;\n}\n\n.bgi-position-bottom {\n\tbackground-position: 0 bottom;\n}\n\n.bgi-position-center {\n\tbackground-position: center;\n}\n\n// Responsive helpers\n@each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n\t\t$infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\t\t\n\t\t// Background sizes\n\t\t.bgi-size#{$infix}-auto {\n\t\t\tbackground-size: auto;\n\t\t}\n\n\t\t.bgi-size#{$infix}-cover {\n\t\t\tbackground-size: cover;\n\t\t}\n\n\t\t.bgi-size#{$infix}-contain {\n\t\t\tbackground-size: contain;\n\t\t}\t\n\n\t\t// Background attachment\n\t\t.bgi-attachment#{$infix}-fixed {\n\t\t\tbackground-attachment: fixed;\n\t\t}\n\n\t\t.bgi-attachment#{$infix}-scroll {\n\t\t\tbackground-attachment: scroll;\n\t\t}\n\t}\n}\n\n\n\n","//\n// Border\n//\n\n.border-active:not(.active):not(:active):not(:hover):not(:focus) {\n    border-color: transparent !important;\n}\n\n.border-hover:not(:hover):not(:focus):not(.active):not(:active) {\n    cursor: pointer;\n    border-color: transparent !important;\n}\n\n// Gray border colors\n@each $name, $value in $grays {\n\t// Initial\n\t.border-gray-#{$name} {\n\t\tborder-color: var(--#{$prefix}gray-#{$name}) !important;\n\t}\n}\n\n// Hover border colors\n@each $name, $value in $theme-colors {\n    .border-hover-#{$name}:hover {\n        border-color: var(--#{$prefix}#{$name}) !important;\n    }\n\n    .border-active-#{$name}.active {\n        border-color: var(--#{$prefix}#{$name}) !important;\n    }   \n}\n\n// Hover transparent\n.border-hover-transparent:hover {\n    border-color: transparent !important;\n}\n\n// Dashed style\n.border-dashed {\n    border-style: dashed !important;\n    border-color: var(--#{$prefix}border-dashed-color);\n}\n\n.border-top-dashed {\n    border-top-style: dashed !important;\n}\n\n.border-bottom-dashed {\n    border-bottom-style: dashed !important;\n}\n\n.border-start-dashed {\n    border-left-style: dashed !important;\n}\n\n.border-end-dashed {\n    border-right-style: dashed !important;\n}\n\n// Dotted style\n.border-dotted {\n    border-style: dotted !important;\n}\n\n.border-top-dotted {\n    border-top-style: dotted !important;\n}\n\n.border-bottom-dotted {\n    border-bottom-style: dotted !important;\n}\n\n.border-start-dotted {\n    border-left-style: dotted !important;\n}\n\n.border-end-dotted {\n    border-right-style: dotted !important;\n}\n\n// Border transparent\n.border-transparent {\n    border-color: transparent !important;\n}\n\n// Border body\n.border-body {\n    border-color: var(--#{$prefix}body-bg) !important;\n}\n\n// Border radiuses\n.rounded-top-0 {\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.rounded-bottom-0 {\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.rounded-start-0 {\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n}\n\n.rounded-end-0 {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.rounded-circle {\n    border-radius: 50% !important;\n}\n","//\n// Flex Utilities\n//\n\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n    @include media-breakpoint-up($breakpoint) {\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n        .flex#{$infix}-root {\n\t\t\tflex: 1;\n\t\t}\n\n        .flex#{$infix}-column-auto {\n            flex: none;\n        }\n\n        .flex#{$infix}-column-fluid {\n            flex: 1 0 auto;\n        }\n\n        .flex#{$infix}-row-auto {\n            flex: 0 0 auto;\n        }\n\n        .flex#{$infix}-row-fluid {\n            flex: 1 auto;\n            min-width: 0;\n        }\n\n    \t.flex#{$infix}-center {\n    \t\tjustify-content: center;\n    \t\talign-items: center;\n    \t}\n\n        .flex#{$infix}-start {\n    \t\tjustify-content: start;\n    \t\talign-items: start;\n    \t}\n\n        .flex#{$infix}-end {\n    \t\tjustify-content: flex-end;\n    \t\talign-items: flex-end;\n    \t}\n\n        .flex#{$infix}-stack {\n\t\t\tjustify-content: space-between;\n    \t\talign-items: center;\n\t\t}\n    }\n}\n\n.flex-equal {\n    flex-grow: 1;\n    flex-basis: 0;\n    flex-shrink: 0;\n}\n","//\n// Shadow\n//\n\n.shadow-xs {\n    box-shadow: var(--#{$prefix}box-shadow-xs);\n}\n\n.shadow-sm {\n    box-shadow: var(--#{$prefix}box-shadow-sm);\n}\n\n.shadow {\n    box-shadow: var(--#{$prefix}box-shadow);\n}\n\n.shadow-lg {\n    box-shadow: var(--#{$prefix}box-shadow-lg);\n}","//\n// Text\n//\n\n// Text colors\n@each $name, $color in $theme-text-colors {\n    // Base color\n    .text-#{$name} {\n        color: var(--#{$prefix}text-#{$name}) !important;\n    }\n\n    // Inverse color\n    @if (theme-inverse-color($name)) {\n        .text-inverse-#{$name} {\n            color: var(--#{$prefix}#{$name}-inverse) !important;\n        }\n    }\n\n    @if (theme-light-color($name)) {\n        // Light colors\n        .text-light-#{$name} {\n            color: var(--#{$prefix}#{$name}-light) !important;\n        }\n    }\n\n    // Hover\n    .text-hover-#{$name} {\n        transition: $transition-link;\n\n        i {\n            transition: $transition-link;\n        }\n\n        &:hover {\n            transition: $transition-link;\n            color: var(--#{$prefix}text-#{$name}) !important;\n\n            i {\n                transition: $transition-link;\n\t\t\t\tcolor: var(--#{$prefix}text-#{$name}) !important;\n\t\t\t}\n\n\t\t\t.svg-icon {\n\t\t\t\tcolor: var(--#{$prefix}text-#{$name}) !important;\n\t\t\t}\n        }\n    }\n\n    // Active\n    .text-active-#{$name} {\n        transition: $transition-link;        \n\n        i {\n            transition: $transition-link;\n        }\n\n        &.active {\n            transition: $transition-link;\n            color: var(--#{$prefix}text-#{$name}) !important;\n            \n            i {\n                transition: $transition-link;\n                color: var(--#{$prefix}text-#{$name}) !important;\n            }\n    \n            .svg-icon {\n                color: var(--#{$prefix}text-#{$name}) !important;\n            }\n        }\n    }\n}\n\n// Parent hover\n.parent-hover {\n    @each $name, $color in $theme-text-colors {\n        .parent-hover-#{$name} {\n            transition: $transition-link;\n        }\n\n        &:hover {\n            .parent-hover-#{$name} {\n                transition: $transition-link;\n                color: var(--#{$prefix}text-#{$name}) !important;\n            }\n        }    \n    }\n}\n\n// Parent active\n.parent-active {\n    @each $name, $color in $theme-text-colors {\n        .parent-active-#{$name} {\n            transition: $transition-link;\n        }\n\n        &.active {\n            .parent-active-#{$name} {\n                transition: $transition-link;\n                color: var(--#{$prefix}text-#{$name}) !important;\n            }\n        }    \n    }\n}\n\n// Text transparent\n.text-transparent {\n    color: transparent;\n}\n\n// Cursor pointer\n.cursor-pointer {\n    cursor: pointer;\n}\n\n// Cursor default\n.cursor-default {\n    cursor: default;\n}\n// Cursor move\n.cursor-move {\n    cursor: move;\n}\n\n// Icons\ni {\n    &.bi,\n    &[class^=\"fonticon-\"],\n    &[class*=\" fonticon-\"],\n    &[class^=\"fa-\"],\n    &[class*=\" fa-\"],\n    &[class^=\"la-\"],\n    &[class*=\" la-\"] {\n        line-height: 1;\n        font-size: 1rem;\n        color: var(--#{$prefix}text-muted);        \n    }   \n}\n\n// Link transition\na {\n    transition: $transition-link;\n\n    &:hover {\n        transition:$transition-link;\n    }\n}\n","//\n// Opacity\n//\n\n@each $name, $value in $opacity-values {\n\t// Active state\n\t.opacity-active-#{$name}.active {\n\t\topacity: #{$value} !important;\n\t}\n\n\t// Active and hover states\n\t.opacity-state-#{$name} {\n\t\t&:hover,\n\t\t&.active {\n\t\t\topacity: #{$value} !important;\n\t\t}\n\t}\n}","//\n// Transform\n//\n\n.transform-90 {\n    transform: rotate(90deg);\n    transform-origin: right top;\n}","//\n//  Tree\n//\n\n.tree {\n\t// Css variables\n\t--#{$prefix}tree-icon-size: #{$tree-icon-size};\n\t--#{$prefix}tree-icon-gap: #{$tree-icon-gap};\n\t--#{$prefix}tree-icon-color-open: var(--#{$prefix}success);\n\t--#{$prefix}tree-icon-color-default: var(--#{$prefix}gray-500);\n\t--#{$prefix}tree-icon-color-close: var(--#{$prefix}gray-500);\t \t\n\t--#{$prefix}tree-line-color: var(--#{$prefix}gray-200);\t\n\n\t.tree-node {\n\t\tpadding-left: $tree-node-padding-x;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: start;\n\t}\n\n\t.tree-sub {\n\t\tpadding: $tree-node-padding-y 0;\t\t \t \n\t}\n\n\t.tree-content {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: $tree-node-padding-y 0;\n\t}\n\n\t.tree-wrapper {\n\t\tpadding-left: calc(var(--#{$prefix}tree-icon-size) + var(--#{$prefix}tree-icon-size));\n\t}\n\n\t.tree-section {\n\t\tdisplay: flex;\n\t\talign-items: baseline;\n\t\tpadding-left: var(--#{$prefix}tree-icon-gap);\n\t}\n\n\t.tree-toggle {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\twidth: var(--#{$prefix}tree-icon-size);\n\t\t\n\t\t.tree-icon-default {\n\t\t\tfont-size: 1.5rem;\n\t\t\tcolor: var(--#{$prefix}tree-icon-color-default);\t\n\t\t}\n\n\t\t.tree-icon-open {\n\t\t\tfont-size: 1.5rem;\t\t\t \n\t\t\tcolor: var(--#{$prefix}tree-icon-color-open);\t\n\t\t}\t\n\n\t\t.tree-icon-close {\n\t\t\tfont-size: 1.5rem;\n\t\t\tcolor: var(--#{$prefix}tree-icon-color-close);\t\t\t \n\t\t}\n\t\t\n\t\t&.collapsed {\n\t\t\t.tree-icon-close {\n\t\t\t\tdisplay: flex;\n\t\t\t}\t\n\t\n\t\t\t.tree-icon-open {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\t\t\t\n\n\t\t&:not(.collapsed) {\n\t\t\t.tree-icon-close {\n\t\t\t\tdisplay: none;\n\t\t\t}\t\n\t\n\t\t\t.tree-icon-open {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t} \t\t\n\t}\t\n\n\t& > .tree-node {\n\t\tpadding-left: 0 !important;\n\t} \n\n\t&.tree-line {\n\t\t.tree-sub {\t\n\t\t\tborder-left: 1px solid var(--#{$prefix}tree-line-color);\t\n\t\t\tmargin-left: calc(var(--#{$prefix}tree-icon-size) / 2);\t\n\t\t}\n\t}\n} ","//\n// Testimonials slider\n//\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n\t.testimonials-slider-highlight {\n\t\ttransition: all ease 0.3;\n\t\n\t\t.testimonials-photo,\n\t\t.testimonials-title, \n\t\t.testimonials-body,\n\t\t.testimonials-author,\n\t\t.testimonials-positon {\n\t\t\ttransition: all ease 0.3s;\n\t\t}\n\t\n\t\t.tns-item:not(.tns-slide-active) + .tns-item.tns-slide-active {\t\t\t\n\t\t\t.testimonials-photo {\n\t\t\t\theight: 200px;\n\t\t\t\twidth: 200px;\n\t\t\t\ttransition: all ease 0.3s;\n\t\t\t}\n\t\n\t\t\t.testimonials-title {\n\t\t\t\tcolor: var(--#{$prefix}gray-900) !important;\n\t\t\t\tfont-size: 1.54rem !important;\n\t\t\t\ttransition: all ease 0.3s;\n\t\t\t\tmargin-bottom: 1.3rem !important;\n\t\t\t}\n\t\n\t\t\t.testimonials-description {\n\t\t\t\tcolor: var(--#{$prefix}gray-700) !important;\n\t\t\t\tfont-size: 1.38rem !important;\n\t\t\t\ttransition: all ease 0.3s;\n\t\t\t\tmargin-bottom: 1.7rem !important;\n\t\t\t}\n\t\n\t\t\t.testimonials-author {\n\t\t\t\tcolor: var(--#{$prefix}primary) !important;\n\t\t\t\tfont-size: 1.1rem !important;\n\t\t\t\ttransition: all ease 0.3s;\n\t\t\t}\n\t\n\t\t\t.testimonials-positon {\n\t\t\t\tcolor: var(--#{$prefix}gray-500) !important;\n\t\t\t\tfont-size: 0.9rem !important;\n\t\t\t\ttransition: all ease 0.3s;\n\t\t\t}\n\t\t}\t\n\t} \t\n}\n\n.testimonials-slider-quote {\n\t.testimonials-quote {\n\t\topacity: 0.2;\n\t}\n\n\t.tns-item:not(.tns-slide-active) + .tns-slide-active + .tns-slide-active {\n\t\t.testimonials-quote {\n\t\t\topacity: 0.5;\n\t\t\tcolor: var(--#{$prefix}primary) !important;\n\t\t}\n\t}\t\n} ","//\n// Multistep stepper\n//\n\n// Custom\n.stepper.stepper-pills.stepper-multistep {\n    --#{$prefix}stepper-pills-size: 46px;\n    --#{$prefix}stepper-icon-border-radius: 9px;\n    --#{$prefix}stepper-icon-check-size: 1.25rem;\n\n    --#{$prefix}stepper-icon-bg-color: rgba(255, 255, 255, 0.03);\n    --#{$prefix}stepper-icon-bg-color-current: var(--#{$prefix}success);\n    --#{$prefix}stepper-icon-bg-color-completed: rgba(255, 255, 255, 0.03);\n\n    --#{$prefix}stepper-icon-border: 1px dashed rgba(255, 255, 255, 0.3);\n    --#{$prefix}stepper-icon-border-current: 0;\n    --#{$prefix}stepper-icon-border-completed: 1px dashed rgba(255, 255, 255, 0.3);\n\n    --#{$prefix}stepper-icon-number-color: var(--#{$prefix}white);\n    --#{$prefix}stepper-icon-number-color-current: var(--#{$prefix}white);\n    --#{$prefix}stepper-icon-number-color-completed: var(--#{$prefix}white);\n    \n    --#{$prefix}stepper-icon-check-color-completed: var(--#{$prefix}success);\n\n    --#{$prefix}stepper-label-title-opacity: 0.7;\n    --#{$prefix}stepper-label-title-opacity-current: 1;\n    --#{$prefix}stepper-label-title-opacity-completed: 1;\n\n    --#{$prefix}stepper-label-title-color: var(--#{$prefix}white);\n    --#{$prefix}stepper-label-title-color-current: var(--#{$prefix}white);\n    --#{$prefix}stepper-label-title-color-completed: var(--#{$prefix}white);\n    \n    --#{$prefix}stepper-label-desc-opacity: 0.7;\n    --#{$prefix}stepper-label-desc-opacity-current: 0.7;\n    --#{$prefix}stepper-label-desc-opacity-completed: 0.7;\n\n    --#{$prefix}stepper-label-desc-color: var(--#{$prefix}white); \n    --#{$prefix}stepper-label-desc-color-current: var(--#{$prefix}white);\n    --#{$prefix}stepper-label-desc-color-completed: var(--#{$prefix}white);\n\n    --#{$prefix}stepper-line-border: 1px dashed rgba(255, 255, 255, 0.3);\n}\n","//\n// Landing elements\n//\n\n// Variables\n$landing-dark-color: #13263C;\n$landing-header-height: 100px;\n$landing-header-height-tablet-and-mobile: 70px;\n$landing-header-sticky-height: 70px;\n$landing-header-sticky-height-tablet-and-mobile: 70px;\n\n// Utility classes\n.landing-dark-bg {\n    background-color: $landing-dark-color;\n}\n\n.landing-dark-color {\n    color: $landing-dark-color;\n}\n\n.landing-dark-border {\n    border:1px dashed #2C3F5B;\n}\n\n.landing-dark-separator {\n    border-top:1px dashed #2C3F5B;\n}\n\n.landing-curve  {\n    position: relative;\n\n    svg {\n        position: relative;\n        top: 0;  \n        display: block;\n    }\n}\n\n// Landing header\n.landing-header {\n    display: flex;\n    align-items: center;    \n    height: $landing-header-height;\n\n    // Logos\n    .logo-default {\n        display: block;\n    }\n\n    .logo-sticky {\n        display: none;\n    }\n\n    // Menu\n    .menu {\n        // Menu link\n        .menu-link {\n            &.active {\n                color: $white;\n            }\n        }\n\n        // Header menu sticky mode\n        [data-kt-sticky-landing-header=\"on\"] & {\n            // Menu link\n            .menu-link {\n                &.active {\n                    color: $primary;\n                    background-color: rgba(#EFF2F5, 0.4);\n                }\n            }\n        }\n    }\n\n    // Sticky header modes\n    [data-kt-sticky-landing-header=\"on\"] & {        \n        padding: 0;\n        position: fixed;\n        top: 0;\n        right: 0;\n        left: 0;\n        z-index: 100;\n        background-color: $white;\n        box-shadow: 0px 10px 30px 0px rgba(82,63,105,0.05);\n        height: $landing-header-sticky-height;\n        \n        // Logos\n        .logo-sticky {\n            display: block;\n        }\n\n        .logo-default {\n            display: none;\n        }\n    }\n}\n\n// Fix body padding top when Landing sticky header is on\nbody[data-kt-sticky-landing-header=\"on\"] {\n    padding-top: $landing-header-height;\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n    // Landing header\n    .landing-header {\n        height: $landing-header-height-tablet-and-mobile;\n\n        // Menu wrapper\n        .landing-menu-wrapper {\n            position: relative;\n            overflow: auto;\n        }\n\n        // Sticky header modes\n        [data-kt-sticky-landing-header=\"on\"] & { \n            height: $landing-header-sticky-height-tablet-and-mobile;\n        }\n\n        // Menu\n        .menu {\n            // Menu link\n            .menu-link {\n                &.active {\n                    color: $primary;\n                    background-color: rgba(#EFF2F5, 0.4);\n                }\n            }\n        }\n    }\n\n    // Fix body padding top when Landing sticky header is on\n    body[data-kt-sticky-landing-header=\"on\"] {\n        padding-top: $landing-header-height-tablet-and-mobile;\n    }\n}","//\n// Root\n//\n\n// Light mode\n@include color-mode(light) {\n    // Page bg\n    --#{$prefix}page-bg: #{$page-bg};\n\n    // App blank bg color\n    --#{$prefix}app-blank-bg: #{$app-blank-bg-color};\n\n    // Header\n    --#{$prefix}header-desktop-fixed-bg-color: #{get($header-config, desktop, fixed, bg-color)};\n    --#{$prefix}header-desktop-fixed-box-shadow: #{get($header-config, desktop, fixed, box-shadow)};\n\n    --#{$prefix}header-desktop-fixed-bg-color: #{get($header-config, tablet-and-mobile, fixed, bg-color)};\n    --#{$prefix}header-desktop-fixed-box-shadow: #{get($header-config, tablet-and-mobile, fixed, box-shadow)};\n\n    // Aside\n    --#{$prefix}aside-bg-color: #{get($aside-config, bg-color)};\n\n    // Sidebar\n    --#{$prefix}sidebar-bg-color: #{get($sidebar-config, bg-color)};\n    --#{$prefix}sidebar-tabs-link-bg-color-default: #{get($sidebar-config, tabs, link-bg-color, default)};\n    --#{$prefix}sidebar-tabs-link-bg-color-active: #{get($sidebar-config, tabs, link-bg-color, active)};\n    --#{$prefix}sidebar-tabs-link-icon-color-default: #{get($sidebar-config, tabs, link-icon-color, default)};\n    --#{$prefix}sidebar-tabs-link-icon-color-active: #{get($sidebar-config, tabs, link-icon-color, active)};\n    --#{$prefix}sidebar-dashed-border-color: #{get($sidebar-config, dashed-border-color)};\n    --#{$prefix}sidebar-muted-color: #{get($sidebar-config, muted-color)};\n    --#{$prefix}sidebar-muted-bg-color: #{get($sidebar-config, muted-bg-color)};\n}\n\n// Dark mode\n@include color-mode(dark) {\n    // Page bg\n    --#{$prefix}page-bg: #{$page-bg-dark};\n\n    // App blank bg color\n    --#{$prefix}app-blank-bg: #{$app-blank-bg-color-dark};\n\n    // Header\n    --#{$prefix}header-desktop-fixed-bg-color: #{get($header-config, desktop, fixed, bg-color-dark)};\n    --#{$prefix}header-desktop-fixed-box-shadow: #{get($header-config, desktop, fixed, box-shadow-dark)};\n\n    --#{$prefix}header-desktop-fixed-bg-color: #{get($header-config, tablet-and-mobile, fixed, bg-color-dark)};\n    --#{$prefix}header-desktop-fixed-box-shadow: #{get($header-config, tablet-and-mobile, fixed, box-shadow-dark)};\n\n    // Aside\n    --#{$prefix}aside-bg-color: #{get($aside-config, bg-color-dark)};\n\n    // Sidebar\n    --#{$prefix}sidebar-bg-color: #{get($sidebar-config, bg-color-dark)};\n    --#{$prefix}sidebar-tabs-link-bg-color-default: #{get($sidebar-config, tabs, link-bg-color, default-dark)};\n    --#{$prefix}sidebar-tabs-link-bg-color-active: #{get($sidebar-config, tabs, link-bg-color, active-dark)};\n    --#{$prefix}sidebar-tabs-link-icon-color-default: #{get($sidebar-config, tabs, link-icon-color, default-dark)};\n    --#{$prefix}sidebar-tabs-link-icon-color-active: #{get($sidebar-config, tabs, link-icon-color, active-dark)};\n    --#{$prefix}sidebar-dashed-border-color: #{get($sidebar-config, dashed-border-color-dark)};\n    --#{$prefix}sidebar-muted-color: #{get($sidebar-config, muted-color-dark)};\n    --#{$prefix}sidebar-muted-bg-color: #{get($sidebar-config, muted-bg-color-dark)};\n}\n","//\n// Root\n//\n\nhtml {\n  font-family: sans-serif;\n  text-size-adjust: 100%;\n}\n\nhtml,\nbody {\n    height: 100%;\n    margin: 0px;\n    padding: 0px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-size: $root-font-size !important;\n    font-weight: $font-weight-base;\n    font-family: $font-family-sans-serif;\n\n    // Tablet mode\n    @include media-breakpoint-down(lg) {\n        font-size: $root-font-size-lg !important;\n    }\n\n    // Mobile mode\n    @include media-breakpoint-down(md) {\n        font-size: $root-font-size-md !important;\n    }    \n}\n\nbody {\n    display: flex;\n    flex-direction: column;\n\n    a:hover,\n    a:active,\n    a:focus {\n        text-decoration: none !important;\n    }\n}\n\ncanvas {\n    user-select: none;\n}\n\n// Angular integration\nrouter-outlet {\n    display: none;\n}","//\n// Print Mode\n//\n\n// Add .print-content-only class to body element in order to allow printing only the content area\n@media print {\n    .print-content-only {\n        padding: 0 !important;\n        background: none !important;\n\n        .wrapper,\n        .page,\n        .page-title,\n        .content,\n        .container,\n        .container-xxl,\n        .container-fluid {\n            background: none !important;\n            padding: 0 !important;\n            margin: 0 !important;\n        }\n        \n        .aside,\n        .sidebar,\n        .scrolltop,\n        .header,\n        .footer,\n        .toolbar,\n        .drawer,\n        .btn {\n            display: none !important;\n        }\n    }\n}\n","//\n// Main\n//\n\n\nbody {\n\tbackground-color: var(--#{$prefix}page-bg);\n}\n\n// Font color from Content background color\n.text-page-bg {\n\tcolor: $page-bg;\n}\n\n.app-blank {\n\tbackground-color: var(--#{$prefix}app-blank-bg) !important;\n}\n\n// Above Xxl\n@include media-breakpoint-up(xxl) {\n\t// Wrapper\n\t.wrapper {\n\t\t// Sidebar enabled mode\n\t\t.sidebar-enabled & {\n\t\t\t//padding-right: get($sidebar-config, width);\n\t\t}\n\t}\n\n\t// Engage toolbar\n\t.sidebar-enabled .engage-toolbar {\n\t\tright: get($sidebar-config, width) !important;\n\t}\n\n\t// Engage toolbar\n\t.sidebar-enabled .scrolltop {\n\t\tright: get($sidebar-config, width) + 5px !important;\n\t}\n}\n\n// Desktop Mode\n@include media-breakpoint-up(lg) {\n\t// Containers\n\t.container,\n\t.container-xxl,\n\t.container-fluid {\n\t\tpadding: 0 get($content-spacing, desktop) !important;\n\t}\n\n\t// Wrapper\n\t.wrapper {\n\t\tpadding-top: get($content-spacing, desktop);\n\t\tpadding-left: get($aside-config, width) + get($content-spacing, desktop);\n\n\t\t// Fixed header mode\n\t\t.header-fixed[data-kt-sticky-header=\"on\"] & {\n\t\t\tpadding-top: get($content-spacing, desktop) + get($header-config, desktop, default, height);\n\t\t}\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t// Containers\n\t.container,\n\t.container-xxl,\n\t.container-fluid {\n\t\tmax-width: none;\n\t\tpadding: 0 get($content-spacing, tablet-and-mobile) !important;\n\t}\n\n\t// Wrapper\n\t.wrapper {\n\t\t// Fixed header mode\n\t\t.header-tablet-and-mobile-fixed[data-kt-sticky-header=\"on\"] & {\n\t\t\tpadding-top: get($header-config, tablet-and-mobile, fixed, height);\n\t\t}\n\t}\n}","//\n// Header\n//\n\n// Above Xxl\n@include media-breakpoint-up(xxl) {\n\t.header {\n\t\t// Sidebar enabled and header sticky modes\n\t\t.sidebar-enabled[data-kt-sticky-header=\"on\"] & {\n\t\t\tright: get($sidebar-config, width) !important;\n\t\t}\n\t}\n}\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n\t.header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\theight: get($header-config, desktop, default, height);\n\n\t\t// Fixed header & sticky header modes\n\t\t.header-fixed[data-kt-sticky-header=\"on\"] & {\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tleft: get($aside-config, width) + get($content-spacing, desktop);\n\t\t\tz-index: get($header-config, desktop, fixed, z-index);\n\t\t\tbackground-color: var(--#{$prefix}header-desktop-fixed-bg-color);\n\t\t\tbox-shadow: var(--#{$prefix}header-desktop-fixed-box-shadow);\n\t\t\theight: get($header-config, desktop, fixed, height);\n\t\t\tpadding: 0;\n\t\t\t@include border-bottom-radius($border-radius);\n\t\t}\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.header {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\theight: get($header-config, tablet-and-mobile, default, height);\n\n\t\t// Fixed header and header sticky modes\n\t\t.header-tablet-and-mobile-fixed[data-kt-sticky-header=\"on\"] & {\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tright: 0;\n\t\t\tleft: 0;\n\t\t\tz-index: get($header-config, tablet-and-mobile, fixed, z-index);\n\t\t\theight: get($header-config, tablet-and-mobile, fixed, height);\n\t\t\tmin-height: get($header-config, tablet-and-mobile, fixed, height);\n\t\t\tbackground-color: var(--#{$prefix}header-tablet-and-mobile-fixed-bg-color);\n\t\t\tbox-shadow: var(--#{$prefix}header-tablet-and-mobile-fixed-box-shadow);\n\t\t\t@include border-bottom-radius($border-radius);\n\t\t}\n\n\t\t// Page title\n\t\t.page-title {\n\t\t\tdisplay: none !important;\n\t\t}\n\t}\n}","//\n// Aside\n//\n\n// General mode(all devices)\n.aside {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: var(--#{$prefix}aside-bg-color);\n\tpadding: 0;\n\n\t// Aside menu\n\t.aside-menu {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\twidth: 100%;\n\n\t\t.menu {\t\t\t\n\t\t\t// Menu item\n\t\t\t> .menu-item {\n\t\t\t\t> .menu-link {\n\t\t\t\t\t.menu-title {\n\t\t\t\t\t\tfont-size: 1.1rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\n\t\t\t\t&.menu-accordion {\n\t\t\t\t\t&.show,\n\t\t\t\t\t&.showing {\n\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t> .menu-icon {\n\t\t\t\t\t\t\t\ti,\n\t\t\t\t\t\t\t\t.svg-icon {\n\t\t\t\t\t\t\t\t\t@include menu-link-arrow-rotate(90deg, -90deg);\n\t\t\t\t\t\t\t\t}\t\t\t\t\t\t\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t&.hiding {\n\t\t\t\t\t\t> .menu-link {\n\t\t\t\t\t\t\t> .menu-icon {\n\t\t\t\t\t\t\t\ti,\n\t\t\t\t\t\t\t\t.svg-icon {\n\t\t\t\t\t\t\t\t\t@include menu-link-arrow-rotate(0, 0);\n\t\t\t\t\t\t\t\t}\t\t\t\t\t\t\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\t\n\t\t\t\t}\t\t\t\n\t\t\t}\n\n\t\t\t// Link colors\n\t\t\t.menu-item {\n\t\t\t\t@include menu-link-default-state( $title-color: var(--#{$prefix}gray-700), $icon-color: var(--#{$prefix}gray-600), $bullet-color: var(--#{$prefix}gray-400), $arrow-color: var(--#{$prefix}gray-400), $bg-color: transparent );\n\t\t\t\t@include menu-link-hover-state( $title-color: var(--#{$prefix}gray-900), $icon-color: null, $bullet-color: null, $arrow-color: null, $bg-color: transparent );\n\t\t\t\t@include menu-link-here-state( $title-color: var(--#{$prefix}gray-900), $icon-color: null, $bullet-color: null, $arrow-color: null, $bg-color: transparent );\n\t\t\t\t@include menu-link-show-state( $title-color: var(--#{$prefix}gray-900), $icon-color: var(--#{$prefix}gray-900), $bullet-color: var(--#{$prefix}gray-900), $arrow-color: null, $bg-color: transparent );\n\t\t\t\t@include menu-link-active-state( $title-color: var(--#{$prefix}gray-900), $icon-color: var(--#{$prefix}gray-900), $bullet-color: var(--#{$prefix}gray-900), $arrow-color: null, $bg-color: transparent );\n\n\t\t\t\t> .menu-link.active {\n\t\t\t\t\t.menu-title {\n\t\t\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n\t.aside {\n\t\tposition: fixed;\n\t\ttop: get($content-spacing, desktop);\n\t\tbottom: get($content-spacing, desktop);\n\t\tleft: get($content-spacing, desktop);\n\t\tz-index: get($aside-config, z-index);\n\t\toverflow: hidden;\n\t\twidth: get($aside-config, width);\n\t\t@include border-radius(get($aside-config, border-radius));\n\n\t\t.scroll-y,\n        .hover-scroll-overlay-y {        \n            @include scrollbar-color(var(--#{$prefix}gray-300), var(--#{$prefix}gray-400));\n        }\n\n\t\t// Logo\n\t\t.aside-logo {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t}\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.aside {\n\t\tdisplay: none;\n\n\t\t// Logo\n\t\t.aside-logo {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n@include color-mode(dark) {\n\t.aside {\n\t\tborder: 1px solid $coal-100;\n\t}\n}","//\n// Sidebar\n//\n\n// General mode(all devices)\n.sidebar {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: var(--#{$prefix}sidebar-bg-color);\n\tpadding: 0;\n\n\t// Navs\n\t.sidebar-nav {\n\t\t$nav-btn-height: 85px;\n\t\t$nav-btn-width: 70px;\n\t\t$nav-btn-height-sm: 75px;\n\t\t$nav-btn-width-sm: 60px;\n\t\t$nav-btn-transition: all 0.3s ease;\n\n\t\tflex-wrap: nowrap;\n\t\tpadding: 0;\n\t\tmargin: 9;\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t.nav-item {\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\theight: $nav-btn-height;\n\t\t\twidth: $nav-btn-width;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\t.nav-link {\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\theight: $nav-btn-height-sm;\n\t\t\twidth: $nav-btn-width-sm;\n\t\t\ttransition: $nav-btn-transition;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tbackground-color: var(--#{$prefix}sidebar-tabs-link-bg-color-default);\n\t\t\tborder: 0;\n\t\t\t@include border-radius($border-radius);\n\n\t\t\ti {\n\t\t\t\ttransition: $nav-btn-transition;\n\t\t\t\tfont-size: 2.25rem;\n\t\t\t\tcolor: var(--#{$prefix}sidebar-tabs-link-icon-color-default);\n\t\t\t}\n\n\t\t\t&.active {\n\t\t\t\theight: $nav-btn-height;\n\t\t\t\twidth: $nav-btn-width;\n\t\t\t\tpadding: 0;\n\t\t\t\ttransition: $nav-btn-transition;\n\t\t\t\tbackground-color: var(--#{$prefix}sidebar-tabs-link-bg-color-active);\n\n\t\t\t\ti {\t\t\t\n\t\t\t\t\tfont-size: 2.75rem;\t\t\t\t\t\t\t \n\t\t\t\t\tcolor: var(--#{$prefix}sidebar-tabs-link-icon-color-active);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Border\n\t.sidebar-border-dashed {\n\t\tborder: 1px dashed var(--#{$prefix}sidebar-dashed-border-color);\n\t}\n\n\t// Border\n\t.sidebar-text-muted {\n\t\tcolor: var(--#{$prefix}sidebar-muted-color);\n\t}\n\n\t.sidebar-bg-muted {\n\t\tbackground-color: var(--#{$prefix}sidebar-muted-bg-color);\n\t}\n}\n\n// Desktop mode\n@include media-breakpoint-up(xxl) {\n\t.sidebar {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tright: 0;\n\t\tz-index: get($sidebar-config, z-index);\n\t\twidth: get($sidebar-config, width);\t\t\n\t\toverflow: hidden;\n\t}\n\n\t.sidebar-enabled {\n\t\t.app-engage {\n\t\t\tright: get($sidebar-config, width);\n\t\t}\n\t}\n}\n\n// Below Xxl\n@include media-breakpoint-down(xxl) {\n\t.sidebar {\n\t\tdisplay: none;\n\t}\n}\n\n// Tablet and mobile modes\n@include media-breakpoint-down(lg) {\n\t.sidebar {\n\t\tdisplay: none;\n\n\t\t// Navs\n\t\t.sidebar-nav {\n\t\t\t$nav-btn-height: 65px;\n\t\t\t$nav-btn-width: 50px;\n\t\t\t$nav-btn-height-sm: 45px;\n\t\t\t$nav-btn-width-sm: 40px;\n\n\t\t\t.nav-item {\n\t\t\t\theight: $nav-btn-height;\n\t\t\t\twidth: $nav-btn-width;\n\t\t\t}\n\n\t\t\t.nav-link {\n\t\t\t\theight: $nav-btn-height-sm;\n\t\t\t\twidth: $nav-btn-width-sm;\n\n\t\t\t\t.svg-icon {\n\t\t\t\t\t@include svg-icon-size(1.75rem, true);\n\t\t\t\t}\n\n\t\t\t\t&.active {\n\t\t\t\t\theight: $nav-btn-height;\n\t\t\t\t\twidth: $nav-btn-width;\n\t\t\t\t\t.svg-icon {\t\t\t\t\t\n\t\t\t\t\t\t@include svg-icon-size(2.25rem, true);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","//\n// Content\n//\n\n// Desktop mode\n@include media-breakpoint-up(lg) {\n\t.content {\n\t\tpadding: divide(get($content-spacing, desktop), 2) 0 0 0;\t\n\t}\n}\n\n// Tablet & mobile modes\n@include media-breakpoint-down(lg) {\n\t.content {\n\t\tpadding: get($content-spacing, tablet-and-mobile) 0 0 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
